/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
 (function () {
  'use strict';

  angular.module('JPTC.pages', [
    'ui.router',
    'JPTC.pages.services',
    'JPTC.pages.config',
    'JPTC.pages.main',
    //'JPTC.pages.dashboard',
    // 'JPTC.pages.ui',
    // 'JPTC.pages.components',
    // 'JPTC.pages.form',
    // 'JPTC.pages.tables',
    // 'JPTC.pages.charts',
    // 'JPTC.pages.maps',
    // 'JPTC.pages.profile',
    'JPTC.pages.authSignIn',
    'JPTC.pages.homePage',
    'JPTC.pages.forgotPassword',
    'JPTC.pages.authSignUp',
    'JPTC.pages.serviceContract',
    'JPTC.pages.permissionDenied',
    'JPTC.pages.deviceRequest',
    'JPTC.pages.deviceLinkage',
    // 'JPTC.pages.contract',
    'JPTC.pages.salesSettlements',
    'JPTC.pages.application',
    'JPTC.pages.comingSoon',
    'JPTC.pages.serviceManagement',
    'JPTC.pages.deviceManagement',
    'JPTC.pages.partner',
    'JPTC.pages.inOfficeService',
    'JPTC.pages.notifications',
    'JPTC.pages.systemManagement',
    'JPTC.pages.other',
  ])
    .config(routeConfig)
    .run(function ($rootScope, $location, AuthService) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            var login =  AuthService.isLoggedInLocally();
            if (toState.authenticate && !login) {
                $rootScope.returnToState = toState.name;
                $rootScope.returnToStateParams = toParams.Id;
            }
        });
    });

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider, localStorageServiceProvider, $translateProvider) {
    localStorageServiceProvider.setPrefix('cov');

    $translateProvider.translations('en', {

      "common.components": {

        "title.error": "Error",
        "title.error.withCount": " Error(s) found.",
        "title.success": "Success",
        "title.warning": "Warning",
        "title.info": "Information",
        "title.delete": "Delete?",
        "title.cancel": "Cancel?",
        "coming.soon": "Coming Soon",
        "permission.denied": "Permission Denied",
        "permission.denied.msg": "Error! You do not have permission to use this feature.",
        "500.denied": "500 Error",
        "404.denied": "404 Error",
        "500.msg.part1": "An Unknown Error has occurred! Please go to",
        "500.msg.part2": "page and retry.",
        "404.msg.part1": "We cannot find the item you are looking for. Please go to",
        "404.msg.part2": "page and retry.",
        "msg.success": "Process completed successfully.",
        "msg.error.same.oldPassword": "New password can not be same as old password, please enter another password.",
        "msg.error.password.noMatch": "New password and confirm password does not match.",
        "msg.error.in.form": "An error has occurred. Please confirm the information you have entered.",
        "msg.error.in.form.withCount": "Please confirm the highlighted fields and rectify the fields where data is not provided or data is in incorrect format.",
        "msg.error.in.device.owner": "This operation cannot be completed. The target device owner contains linked device requests or running devices. Please cancel / delete the device requests and Suspend-HW the running devices before proceeding. If the problem persists, please contact e-MOSS Support center.",
        "msg.error.response": "An error has occurred while performing this operation. Please try again.",
        "msg.confirm": "Uploaded information will be lost. To save the information press “Save” or “Submit” button.",
        "msg.changePassword": "Entered new password does not match with confirm password. please enter the password again",
        "msg.token.expired": "The Password reset link (URL) has expired. Please generate a new password reset link (URL) through \"Forgot Password\" or contact the administrator. ",
        "msg.csv.format":"This file type is not supported. Please upload an excel (*.xlsx) file to proceed.",
        "msg.csv.max.size.10":"The maximum size of the file can be 10 MB",
        "msg.csv.max.size.5":"The maximum size of the file can be 5 MB",
        "msg.service.contract.organisation":"The merchant organization already exists, do you want to map another service contract against it?",
        "msg.continue":"Continue",
        "btn.yes":"Yes",
        "btn.cancel":"Cancel",
        "btn.delete": "Delete",
        "btn.confirm":"Confirm",
        "required":"*",
        "org.type.err.msg":"Cannot create Admin Organisation with other organisation type.",
        "processing":"Processing ... Please wait.",
        "data.not.available":"Data Not Available",
        "points.to.note":"Points to Note:",
        "select.all":"Select All",

        "random": {
          "add.new": "Add New",
          "required": "Required",
          "no.results.found": "No Results Found",
          "valid.required":"Valid Input Required",
          "half.width.valid.required":"Valid Half-width Input Required"
        },

        "address": {
          "title": "Street Address",
          "zip": "Zip Code",
          "prefecture": "Prefecture",
          "city.town": "City / Town Area",
          "street": "Street Address",
          "street.kana": "Street Address (Kana)",
          "building": "Building Name",
          "building.kana": "Building Name (Kana)"
        },

        "contact": {
          "title": "Contact",
          "email": "E-mail ID",
          "email_error_msg": "Valid email required",
          "availability": "Contact Availability",
          "type": "Contact Type",
          "phone": "Contact Phone",
          "phone_error_msg": "Valid phone required"
        },

        "service.fee": {
          "e.money": "E Money",
          "qr.money": "QR Money",
          "credit.money": "Credit Card",
        },
        "errorMessages": {
          "fillRequiredFields": "Please fill required field(s)",
          "error": "Error"
        },
      },

      "home.page": {
        "title": "e-MOSS",
        "title2": " Plus",
        "home": "Home",
        "message": "Welcome to e-MOSS Plus Service",
        "html.page.title.admin": "Admin",
        "html.page.title.device.owner": "Device Owner",
        "html.page.title.merchant": "Merchant"
      },

      "merchant.number":{
        "registration":"Merchant Number Registration",
        "isRegistered":"Merchant Number is Registered.",
        "notRegistered":"Merchant Number is not Registered.",
        "information":"Merchant Number Information",
        "msg.success":"Merchant Number Registration : Succesful",
        "msg.error":"Merchant Number Registration : Unsuccesfull. Please try again or contact e-MOSS Support",
        "not.registered":"Not Registered",
        "form.submit":"Submit",
        "form.cancel":"Cancel",
        "form.apply.all":"Apply all",
        "form.confirm":"Once registered, the Merchant Number cannot be updated.",
        "update.confirm":"You are about to update the Service Contract. It may impact the Sales Aggregation or Settlement/Invoice Records.",
        "empty.error":"Merchant Number cannot be blank. Please input the correct merchant number.",
        "apply.all.error":"The input value in 'Odakyu(PASMO), Rakuten Edy, WAON, iD, nanaco' is either empty or invalid. Please enter a 16 digit value and try again."
      },

      "session.timeout":{
        "caution":"Caution!",
        "message.pre":"Your session is about to expire in ",
        "message.post":" minutes. Please click 'Renew Session' button to avoid loosing any unsaved data and to continue working in this session.",
        "renew":"Renew Session",
        "expireText":"Your previous session was expired. Please login again."
      },

      "service.contract.create": {
        "version":"Contract Version",
        "confirm":"A new service contract will be registered in the system. Please confirm to proceed.",
        "service.contract": {
          "title": "Service Contract Information",
          "title_detail": "Detail - eMPP Application",
          "title_edit": "Edit - eMPP Application",
          "date": "Date",
          "contractName": "Contract Name",
          "description": "Description",
          "remarks": "CLX Service Operator Remarks",
          "terms": "I here by agree to the eMPP Terms & Conditions",
          "cancel": "Cancel",
          "save": "Save Contract",
          "submit": "Submit Contract"
        },
        "applicant.information": {
          "title": "e-MOSS Plus Application",
          "company.information": "Company Information",
          "create.new": "Create New",
          "company.type": "Type",
          "name1":"Name",
          "nameRep":"Name*",
          "name.kana": "Name (Kana Reading)",
          "name": "Company Name Kanji",
          "company.name": "Name",
          "company.url": "Organisation URL",
          "company.code": "Company Code",
          "company.code1": "",
          "company.business": "Business Type",
          "company.products": "Products Handled",
          "company.contact": "Company's Contact",
          "company.representative": {
            "title": "Company Representative's Information",
            "name.kana": "Name (Kana reading)",
            "name": "Name (Kanji name)",
            "name.label": "Name",
            "dateOfBirh": "Date of Birth",
            "addressTitle": "Home Address"
          },
          "incharge.department": "Incharge Department",
          "branch": {
            "title": "Branch / Sales Office Information",
            "create.new": "Create New Branch / Sales Office",
            "subTitle": "Branch / Sales Office Information",
            "code": "Branch / Sales Office Code",
            "name": "Name of Branch / Sales Dept",
            "personInChargeTitle": "Information of Person(s) In-Charge"
          }
        },
        "deviceOwner": {
          "title": "Link Device Owners",
          "subTitle": "Device Owner Information",
          "code": "Device Owner Code",
          "name": "Device Owner Organisation Name",
          "address": "Street Address",
          "inCharge": "In Charge Details",
          "device.purchase": "Device Purchase*",
          "self": "Self",
          "rented": "Rented",
          "self.rented": "Self + Rented",
          "warning.msg" : "The Device Owner is already added."
        },
        "serviceDetails": {
          "title": "Service Details",
          "subTitle.a": "(A) Settlement fee - ME-10 (1) Built-in modem type & (2) External modem type",
          "subTitle.a1": "Terminal model ME-10-1, ME-10-2",
          "subTitle.emoney": "Settlement fee per e-money",
          "subTitle.a.ME.20.1": "(A) Settlement fee - ME-20 (1) Built-in modem",
          "subTitle.a1.ME.20.1": "Terminal model ME-20-1",
          "subTitle.a.ME.20.2": "(A) Settlement fee - ME-20 (2) External modem type",
          "subTitle.a1.ME.20.2": "Terminal model ME-20-2",
          "subTitle.qr": "Per QR Money Brand",
          "subTitle.creditCard": "Credit Card",
          "transaction": "Transaction",
          "yen": "JPY",
          "percent": "%",
          "subTitle.b1": "(B) (1) Service Fee - Built-in Modem Type",
          "applicable.device": "Applicable Device Types",
          "init.charges.title": "Initial Charges (One-time charges)",
          "init.charges.sub": "HW Initial Registration Charge (unit) including E-Money & Internet fee",
          "monthly.charges.title": "Monthly Charges (Recurring charges) ",
          "monthly.charges.sub": "HW Usage Fee (Units / Month)",
          "subTitle.b2": "(B) (2) Service Fee - External Modem Type",
          "includeSettlement":"Include in Settlement",
          "nonTaxable":"Non Taxable",
          "in.office.pay":"In-office pay *",
          "0.emoney":"0 E-Money",
          "emoney.registrationFee": "Registration fee",
          "emoney.systemUsageFee": "System usage fee",
          "subTitle.b3": "(B) (3) Service Cost - ME-20 (1) Built-in Modem Type",
          "subTitle.b4": "(B) (4) Service Cost - ME-20 (2) External Modem Type",
          "subTitle.a.ME.5.1": "(A) Settlement fee - ME-5 (1) Built-in modem type",
          "subTitle.a1.ME.5.1": "Terminal model ME-5-1",
          "subTitle.b5": "(B) Service fee - (1) Built-in modem type",
        },
        "settlementConditions": {
          "title": "Settlement Conditions",
          "method.title": "Settlement Method",
          "method.group": "Settlement Group",
          "method.sub": "Payment Date",
          "closing.title": "Closing Date",
          "closing.sub": "Select Closing Date",
          "paymentMethod.title": "Payment Method of Expenses (B) and (C)",
          "paymentMethod.sub": "Payment Method*",
          "paymentMethod.sub1": "",
          "createInvoice":"Create Invoice*"
        },
        "settlementInformation": {
          "title": "Settlement Branch Information",
          "offsetting": "(Companies which allow Offsetting)",
          "no.offsetting": "(Companies which do not allow Offsetting)",
          "bank.transfer.title": "Bank Transfer / Invoice Method",
          "bank.transfer.sub": "Method of Transfer / Invoice",
          "charge.monthlyFee.from": "Charge Monthly Fee From",
          "details.by.deviceOwner":"Device Owner wise Details Required/Not Required",
          "initialOperation": "Initial Operation",
          "initialPayment": "Initial Payment",
          "emailInvoice": "Email Invoice",
          "telemetryAccess": "Access Telemetry service for beverage vending machines",
          "bankAccount": {
            "title": "Bank Account Information (for Bank Transfer Order)",
            "branchName": "Branch Name",
            "branchCode": "Branch/Center Code",
            "bankCode": "FI Code",
            "bankName": "Bank Name",
            "bankBranchCode": "Branch Code",
            "bankBranchName": "Branch Office Name",
            "accountNo": "Account No.",
            "accountName": "Account Holder Name(Kanji name)",
            "accountName.kana": "Account Holder Name(Kana reading)",
            "bank.type": "Bank Type",
            "account.holder": "Account Holder",
            "type.of.account": "Type of Account",
            "invoiceId": "Invoice Destination Id"
          },
          "settlement.send.location": {
            "name": "Name",
            "title": "Destination to send Itemized details (Invoice will be sent by post)",
            "inChargeName": "In-Charge Name (Kanji name)",
            "inChargeName.kana": "In-Charge Name (Kana name)",
            "remarks": "Remarks"
          }
        },

        "address": {
          "title": "Street Address",
          "zip": "Zip Code",
          "prefecture": "Prefecture",
          "city.town": "City / Town Area",
          "street": "Street Address",
          "street.kana": "Street Address (Kana)",
          "building": "Building Name",
          "building.kana": "Building Name (Kana)"
        },

        "contact": {
          "title": "Contact",
          "email": "E-mail ID",
          "availability": "Contact Availability",
          "type": "Contact Type",
          "phone": "Contact Phone"
        },

        "inCharge": {
          "title": "In-Charge Person",
          "name.kana": "Name (Kana reading)",
          "name": "Name (Kanji name)"
        },

        "other": {
          "title": "Other expenses",
          "cancellation.charge": "Cancellation Charge"
        },

        "service.usage.remarks": "Service Usage Remarks",

        "bool1": "Owner can apply for device",
        "bool2": "Owner must approve device request",
        "bool3": "Merchant can apply for device",
        "acquirer": {
            "title":"Acquirer related Information",
            "jmups":"J-Mups Template",
            "jmups.select":"Select J-Mups Template",
         },
        "cir":{
          "title":"Credit Information Registration",
          "terminalId":"Terminal identification number(TID)",
          "senderId":"Sender Id",
          "receipientId":"Receipient Id",
          "merchantId":"Merchant Id",
          "2merchantId":"2nd Merchant Id",
          "merchantCategoryCode":"Merchant Category Code",
         }
      },

      "service.contract.list": {
        "upload.excel.btn": "Upload Service Contract Excel",
        "download.excel.btn": "Download Service Contract Info",
        "service.contract.id": "Service Contract ID",
        "contract.id": "Contract Id",
        "merchant.id": "Merchant Id",
        "merchant.name": "Merchant Name",
        "owner.id": "Owner Id",
        "owner.name": "Owner Name",
        "doc": "Date Of Contract",
        "organization.type": "Organisation Type",
        "device.owner.id": "Device Owner ID",
        "merchant.address": "Merchant Address",
        "view": "View",
        "merchant.information":"Merchant Information",
        "download":"Download",
        "upload":"Upload",
        "maroon.application":"MARON Application Initial Value Registration",
        "maroon.application.register":"Register",
        "maroon.application.register.title":"Confirmation of registration details",
        "maroon.application.register.message":"Save the registration details."
      },

      "users.create.update.view": {

        "on.page.details": {
          "title": "Create/Update/View User"
        },
        "info.msg":"NOTE : Cannot search those PARTNER organisations where the user login is not allowed.",

        "common.information": {
          "title": "Common Information",
          "userName": "User Name",
          "userId": "User Id",
          "userEmail": "User Email",
          "userDescription": "User Description",
          "contactNumber": "Contact Number",
          "orgError": "Organisation does not exist"
        },

        "organization.information": {
          "title": "Organisation Information",
          "organizationName": "Organisation Name",
          "organizationCode": "Organisation Code",
          "userType": "User Type"
        },

        "user.information": {
          "title": "User Information",
          "dob": "Date of Birth",
          "age": "Age",
          "gender": "Gender"
        },

        "address": {
          "title": "Street Address※",
          "zip": "Zip Code",
          "prefecture": "Prefecture",
          "city.town": "City / Town Area",
          "street": "Street Address",
          "street.kana": "Street Address (Kana)",
          "building": "Building Name",
          "building.kana": "Building Name (Kana)"
        },
        "contact": {
          "title": "Contact",
          "email": "E-mail",
          "availability": "Contact Availability",
          "type": "Contact Type",
          "phone": "Contact Phone"
        },

        "permission": {
          "title": "Permissions",
          "allowedOperations": "Allowed Operations",
        },

        "service.contract": {
          "title": "Service Contract Information",
          "date": "Date",
          "contractName": "Contract Name",
          "description": "Description",
          "remarks": "CLX Service Operator Remarks",
          "terms": "I here by agree to the eMPP Terms & Conditions",
          "cancel": "Cancel",
          "save": "Save Contract",
          "submit": "Submit Contract"
        },
        "applicant.information": {
          "title": "eMPP Application",
          "company.information": "Company Information",
          "create.new": "Create New",
          "company.type": "Type",
          "name1": "Name*",
          "name.kana": "Name (Kana Reading)",
          "name": "Company Name Kanji",
          "company.url": "Organisation URL",
          "company.code": "Company Code*",
          "company.business": "Business Type",
          "company.products": "Products Handled",
          "company.contact": "Company's Contact",
          "company.representative": {
            "title": "Company Representative's Information",
            "name.kana": "Name (Kana reading)",
            "name": "Name (Kanji name)",
            "dateOfBirh": "Date of Birth",
            "addressTitle": "Home Address"
          },
          "branch": {
            "title": "Branch / Sales Office Information",
            "create.new": "Create New Branch / Sales Office",
            "subTitle": "Branch / Sales Office Information",
            "code": "Branch / Sales Office Code",
            "name": "Name of Branch / Sales Dept",
            "personInChargeTitle": "Information of Person(s) In-Charge"
          }
        },
        "deviceOwner": {
          "title": "Link Device Owners",
          "subTitle": "Device Owner Information",
          "code": "Device Owner Code",
          "name": "Device Owner Organisation Name",
          "address": "Street Address",
          "inCharge": "In Charge Details"
        },
        "serviceDetails": {
          "title": "Service Details",
          "subTitle.a": "(A) Payment Handling Fee",
          "subTitle.emoney": "Per E-Money Brand",
          "subTitle.qr": "Per QR Money Brand",
          "subTitle.creditCard": "Credit Card",
          "transaction": "Transaction",
          "yen": "JPY",
          "percent": "%",
          "subTitle.b1": "(B) (1) Service Fee - Built-in Modem Type",
          "applicable.device": "Applicable Device Types",
          "init.charges.title": "Initial Charges (One-time charges)",
          "init.charges.sub": "HW Initial Registration Charge (unit) including E-Money & Internet fee",
          "monthly.charges.title": "Monthly Charges (Recurring charges) ",
          "monthly.charges.sub": "HW Usage Fee (Units / Month)",
          "subTitle.b2": "(B) (2) Service Fee - External Modem Type"
        },
        "settlementConditions": {
          "title": "Settlement Conditions",
          "method.title": "Settlement Method",
          "method.group": "Settlement Group",
          "method.sub": "Payment Date",
          "closing.title": "Closing Date",
          "closing.sub": "Select Closing Date",
          "paymentMethod.title": "Payment Method of Expenses (B) and (C)",
          "paymentMethod.sub": "Payment Date"
        },
        "settlementInformation": {
          "title": "Settlement Branch Information",
          "offsetting": "(Companies which allow Offsetting)",
          "no.offsetting": "(Companies which do not allow Offsetting)",
          "bank.transfer.title": "Bank Transfer / Invoice Method",
          "bank.transfer.sub": "Method of Transfer / Invoice",
          "charge.monthlyFee.from": "Charge Monthly Fee From",
          "initialOperation": "Initial Operation",
          "initialPayment": "Initial Payment",
          "bankAccount": {
            "title": "Bank Account Information (for Bank Transfer Order)",
            "branchName": "Branch Name",
            "branchCode": "Branch/Center Code",
            "bankCode": "FI Code",
            "bankName": "Bank Name",
            "bankBranchCode": "Branch Code",
            "bankBranchName": "Branch Office Name",
            "accountNo": "Account No.",
            "accountName": "Account Holder Name(Kanji name)",
            "accountName.kana": "Account Holder Name(Kana reading)"
          },
          "settlement.send.location": {
            "title": "Destination to send Itemized details (Invoice will be sent by post)",
            "inChargeName": "In-Charge Name (Kanji name)",
            "inChargeName.kana": "In-Charge Name (Kana name)",
            "remarks": "Remarks"
          }
        },
        "inCharge": {
          "title": "In-Charge Person",
          "name.kana": "Name (Kana reading)",
          "name": "Name (Kanji name)"
        }
      },


      "org":{
          "detail.title":"Organisation Details",
          "list":{
              "org.code":"Org Code (eMPP)",
              "org.id":"Organisation Id",
              "org.id.info":"Based upon the organisation type, \nthis column displays the respective \nOrganisation Id such as the Merchant Id or \nDevice Owner Id or Partner Id or Office Id.",
              "org.type":"Org Type",
              "org.name":"Org Name",
              "org.address":"Org Address",
              "org.representative":"Representative Info",
              "action":"Action",
              "view.edit":"View / Edit",
              "view":"View",
              "pass":"Password Management",
              "enable":"Enable",
              "disable":"Disable",
              "delete":"Delete",
              "msg.enable":"Are you sure you want to enable this organisation?",
              "msg.enable.status":"Organisation status: enabled",
              "msg.disable":"Are you sure you want to disable this organisation?",
              "msg.disable.status":"Organisation status: disabled",
              "msg.delete":"Are you sure you want to delete this organisation?",
              "msg.delete.status":"The Organisation is successfully deleted. The users belonging to this organization has also been deleted."
          },

          "create":{
              "common.information":"Common Information",
              "org.type":"Organisation Type",
              "org.name":"Organisation Name",
              "organisation.information":"Organisation Information",
              "url":"Organisation URL",
              "products.handled":"Products Handled",
              "name":"Name",
              "submit.data":"Submit Organisation Data"

          },
          "view":{
              "EDIT":"Edit",
              "title_view":"View Organisation",
              "title_update":"Update Organisation",
              "save":"Save Organisation Data",
              "incharge.delete.error1":"The In Charge user cannot be deleted from the system since this user is the last remaining In Charge of Service Contract ID ",
              "incharge.delete.error2":". Before deleting this user, please create a new In-Charge user of the Service Contract ID ",
              "incharge.delete.error3":" [OR] set another user of the same organisation as 'In Charge' of Service Contract ID ",
              "incharge.delete.error4":"  using [User => Detail Page].",
          }
      },

      "user":{
        "service.contract":"In-Charge of Service Contract ID",
        "service.contract.in-charge":"Make In-Charge of Service Contract ID",
        "text.placeholder.for.sc.id":"To make In-Charge of a Service Contract, please select user type as ADMIN",
        "list.placeholder.for.sc.id":"Click here or Start typing the Service Contract ID",
        "none":"None",

        "detail.title":"User Account Details",
        "list":{
          "merchant.id":"Merchant Id",
          "owner.id":"Device Owner Id",
          "msg.enable":"Are you sure you want to enable this user?",
          "msg.enable.status":"User status: enabled",
          "msg.disable":"Are you sure you want to disable this user?",
          "msg.disable.status":"User status: disabled",
          "msg.delete":"Are you sure you want to delete this user?",
          "msg.delete.status":"The User is successfully deleted.",
          "msg.user.description":"This is a mandatory field and upto 250 characters are allowed."
        },
        "password.management": {
          "operation": "Operation Type",
          "generatePass": "Generate Password",
          "resetPass": "Reset Password",
          "changePass": "Change Password",
          "oldPassword": "Current Password",
          "newPassword": "New Password",
          "confirmPassword": "Confirm Password",
        },
        "view":{
          "submit.data":"Submit User Data",
          "save":"Save User Data"
        }
      },

      "partner":{
        "details":"Partner Details",
        "link":"Link Partner",
        "name":"Partner Name",
        "code":"Partner Code",
        "conditions":"Partner Condition",
        "warning.msg":"The Partner is already added.",
        "allow":{
            "login":"Login by PARTNER Organisation's user",
            "deviceRequest":"Allow to view [Device Requests] menu & pages",
            "sales":"Allow to view [Sales] menu & pages",
            "settlementInvoice":"Allow to view [Settlement/Invoice] menu & pages",
            "serviceManagement":"Allow to view [Service Management] menu & pages"
        },
        "org.msg":{
            "changes":"You are about to save the following changes in permission for <NAME> organization:",
            "login":"The system will allow to create new user-accounts for this organization. The newly created user-accounts will be able to use the features which are allowed to them. with login instructions.The “In-Charge” user will receive an email notification with login instructions.",
            "no.login":"The system will remove all existing user-accounts of this organization (including the In-Charge users also) and these user-accounts cannot be recovered again if “Login” operation is “Allowed” in future . The users will not be able to login or use the system after the details are saved.",
            "access": {
                "grant.deviceRequest":"<b>Grant</b> access privilege to <b>[Device Requests]</b>",
                "revoke.deviceRequest":"<b>Revoke</b> access privilege to <b>[Device Requests]</b>",
                "grant.sales":"<b>Grant</b> access privilege to <b>[Sales]</b>",
                "revoke.sales":"<b>Revoke</b> access privilege to <b>[Sales]</b>",
                "grant.settlementInvoice":"<b>Grant</b> access privilege to <b>[Settlement & Invoice]</b>",
                "revoke.settlementInvoice":"<b>Revoke</b> access privilege to <b>[Settlement & Invoice]</b>",
                "grant.serviceManagement":"<b>Grant</b> access privilege to <b>[Service Management]</b>",
                "revoke.serviceManagement":"<b>Revoke</b> access privilege to <b>[Service Management]</b>",
            }
        }
      },

      "login": {
        "title": "Sign In",
        "email": "Email",
        "password": "Password",
        "forgotPass":"Forgot Password",
        "changePass":"Change Password",
        "submit":"Submit",
        "sign.out":"Sign Out"

      },

      "device.management": {
        "status": "Status",
        "running": "Running",
        "stopped": "Stopped",
        "error": "Error",
        "removed": "Removed",
        "applied": "Applied",
        "device.serial": "Device Serial",
        "owner.merchant": "Owner/Merchant",
        "sales.center": "Sales Center",
        "first": "第一",
        "second": "第二",
        "third": "第三",
        "loc.id": "Loc ID",
        "loc.name": "Loc Name",
        "money.types": "Money Types",
        "transport": "Transport",
        "waon": "WAON",
        "edy": "Edy",
        "id": "iD",
        "qp": "QUICPay+",
        "nanaco": "nanaco",
        "signal": "Signal",
        "last.communication.date": "Last Communication Date",
        "last.sales.date": "Last Sales Date",
        "last.modified.date":"Last Modified Date",
        "operation.start.date": "Operation Start Date",
        "operation.start.date.info": "Start Date (Install date)\nStart Date - This is the date when first communication is recieved from terminal.\nInstall Date - This date either arrived from terminal or is calculated based upon Delivery date.",
        "csv.info": "Money Types\nRegistered & Available  - 3\nUnregistered & Available - 2\nRegistered & Unavailable - 1\nUnregistered & Unavailable - 0",
        "others": "Others",
        "search": "Show Data",
        "msg":"(!) NOTE: The search result displays status of all those devices for which the selected organisation is either an Owner or a Merchant.",
        "device.delivery.date":"Device Delivery Date",
        "installation.code":"Installation Code",
        "remarks":"Remarks",
      },
      "device.replacement": {
        "device.information" :{ 
          "title": "Device Information",
          "device.serial":"Device Serial Number",
          "before.device.serial.placeholder": "Enter the serial # only",
          "after.device.serial.placeholder": "Enter the serial # only",
          "status":"Status",
          "notes.title":"* Important Points to Note :",
          "notes.1": 'The Replacement Date must be at-least 1 min more than the maximum value among "Last Communication Date", "Last Sales Date", "Removal Date", "Portal Detachment Date". Also, the replacement date-time must be less than the NOW time. Please note that the Replacement Date is used to separate the Sales Transactions between the Now and To-Be merchant.',
          "notes.2": 'The "Last Communication Date" and "Last Sales Date" fields displays the latest data.',
          "notes.3": 'Except "Last Communication Date", "Last Sales Date", "Removal Date", "Portal Detachment Date", all other data displayed under the To-Be Device is copied from the Now Device.',
          "notes.4": 'If the To-Be device has already sent Transactions having Date greater than the Replacement Date, then the To-Be Device will be automatically moved to "Installed" or "Running" state for the new Merchant/Branch.',
          "error.replacement.date":'The Replacement Date must be at-least 1 min more than the maximum value among "Last Communication Date", "Last Sales Date", "Removal Date", "Portal Detachment Date". Please note that the Replacement Date is used to separate the Sales Transactions between the Now and To-Be merchant. Please correct the input and try again.',
          "error.replacement.date.one.sec":'The Replacement Date must be at-least 1 second more than the maximum value among "Last Communication Date", "Last Sales Date", "Removal Date", "Portal Detachment Date". Please note that the Replacement Date is used to separate the Sales Transactions between the Now and To-Be merchant. Please correct the input and try again.',
          "error.replacement.date.invalid": "The replacement date-time must be less than the NOW time. Please enter another date-time and try again.",
          "error.delivery.date": '"Expected Date of Delivery" must be greater than or equal to "Replacement Date". Please enter another date-time and try again.',
          "merchant":"Merchant (Merchant code)",
          "device.owner":"Device Owner (Device Owner code)",
          "contract.id":"Service Contract ID",
          "company.id":"Company ID",
          "application.number":"Device Application Number",
          "branch.code":"Branch Code",
          "branch.name":"Branch Name",
          "installation.store.name": "Installation Store Name",
          "vending.machine.type":"Vending Machine Type",
          "replacement.date": "Replacement Date *",
          "expected.delivery.date": "Expected Delivery Date",
          "removal.date": "Removal Date",
          "portalDetached.date": "Portal Detached Date",
          "last.communication.date": "Last Communication Date",
          "last.communication.date.star": "Last Communication Date *",
          "last.sales.date": "Last Sales Date",
          "last.sales.date.star": "Last Sales Date *",
          "installation.charges":"Installation Charges",
          "monthly.charges":"Monthly Charges",
          "monthly.fee":"Monthly Fee",
          "initial.fee":"Initial Fee",
          "charge.monthly.fee":"Charge Monthly Fee ?",
          "charge.initial.fee":"Charge Initial Fee ?",
          "status.title": "List of valid statuses :",
          "status.removed": "Removed",
          "status.portalDetached": "Portal_Detached",
          "status.removed.settled": "Removed_And_Settled",
          "status.portalDetached.settled": "Portal_Detached_And_Settled",
          "status.fresh": "Fresh Device",
          "status.or": "OR",
          "na": "NA"
        },
        "warning.msg.replacementDate": "NOTE : The replacement date-time must be less than the NOW time.",
        "confirm.tobe.device": "Confirm To-be Device ?",
        "confirm.title": "Note",
        "confirm.msg": "Once submitted the device serial number cannot be changed. Please check before saving it.",
        "success.msg": "Process has been completed successfully ",
        "provide.serialNumber.msg": "NOW and TO-BE Device Serial Number cannot be same. Please provide a different serial number to replace.",
        "provide.valid.serialNumber": "Please provide a valid Device Serial Number",
        "fresh.device.msg":"Not Available (Fresh Device)",
        "getData": "Get Data",
        "now.title": "Now",
        "tobe.title": "To-be",
        "apply": "Apply",
        "next": "Next",
        "submit":"Submit"
      },

      "salesSettlements": {
        "notes01":"*To display the results after changing the filter criteria, please click on (Show Data) button.",
        "notes02":"*It may take up to about 30 mins for the latest One-Item Details to reflect on this screen.",
        "monthly": {
          "list": {
            "search": {
              "title": "Search Filter Criteria",
              "oneItemTitle": "Search Filter Criteria",
              "organization": "Select Merchant",
              "deviceOwner":"Select Device Owner",
              "selectMerchantError":"Please Select Any merchant",
              "organizationPlaceholder": "<Select Organisation>",
              "granularity": "Result Granularity: Group and display results by -",
              "aggregatedSalesBy": "Display Aggregated Sales by: ",
              "month": "Select Month",
              "date": "Select Date",
              "showData": "Show Data",
              "downloadCsv": "DOWNLOAD CSV",
              "totalMerchants": "Total Merchants",
              "salesOffice": 'Branch / Sales office',
              "deviceSerial": 'Device serial',
              "applicationSerial": 'Application serial number',
              "installationLocation": 'Installation location',
              "remarks": 'Remarks',
              "remarksOrVmNumber": 'Remarks or VM Number',
              "displayUnit": 'Display unit',
              "moneyType": 'Money type',
              "unitPrice": 'Unit Price',
              "option":"Option",
              "option.unitprice":"Aggregation by unit price",
              "productName": 'Product Name',
              "displayData": 'Display Data',
              "addClosingInformation": "Add Closing Information",
              "toggleClosingInformation": "Activate/Deactivate Closing Information",   
              "err.msg.required.field": "{{param}} in Row {{row}} is a Required Field.",
              "err.msg.wrong.value.entered" : "{{param}} in Row {{row}} should have a value only from dropdown.",
              "err.msg.wrong.time.entered" : "Please enter correct {{param}} in the format 'HH:mm:ss'",
              "msg.server.error": "Please confirm the below errors and please rectify the rows/fields containing the error (errors such as data is not provided, data is duplicate, data is in incorrect format etc).",
              "warning.msg.dont.refresh": "NOTE: Please do not refresh the browser (or do not hit the keyboard's F5 key).",
              "btn_cancel": "Cancel",
              "btn.submit": "Submit",
              "downloadExcel": "Create CSV",
              "downloadReports": "Download Reports",
            },
            "searchResult": {
              "title": "Search Result",
              "previousYear": "Previous Year",
              "previousMonth": "Previous Month",
              "nextYear": "Next Year",
              "nextMonth": "Next Month",
              "display": "Displaying Results from:",
              "branchSalesCenter": "Branch/Sales Center",
              "deviceCount": "Device Count",
              "deviceSerialNo": "Device Serial No",
              "transportationCard": "Transportation Card",
              "rakutenEdy": "Rakuten Edy",
              "naNaCo": 'nanaco',
              'waon': 'WAON',
              'id': 'iD',
              'QUICPay+': 'QUICpay+',
              'linePay': 'Line Pay',
              'weChatPay': 'WeChat Pay',
              'aliPay': 'AliPay',
              'rakutenPay': 'RakutenPay',
              'viewDetails': 'View Details',
              'noResults': 'No result found',
              'dailyDetails': 'Daily Sales Details',
              'monthlyDetails': 'Monthly Sales Details',
              'details': 'Details for one item',
              'total': 'Total',
              'number': '(Number)',
              'amount': '(Amount)'
            },
            "settlement": {
              'settlement': 'Settlement',
              'settlementMonth': 'Settlement month',
              'settlementDepartment': 'Settlement Department',
              'search': 'Search',
              'merchantName': 'Merchant name',
              'bankTransferAmount': 'Bank transfer amount',
              'bankTransferDate': 'Bank transfer date',
              'invoice': 'Invoice ID',
              'financialIstitition': 'Financial Istitition',
              'branch': 'Branch',
              'type': 'Type',
              'accountNumber': 'Account Number',
              'ePaymentAmount': 'E-payment transaction amount',
              'charges': 'Charges',
              'mothlyCharges': 'Monthly Charges',
              'noOfDevices': 'Number of devices',
              'settlementTiming': 'Settlement timing',
              'brandName': 'Brand Name',
              'noOfPaymentItems': 'Number Of Payment Items',
              'paymentAmount': 'Payment Amount',
              'chargesRate': 'Charges Rate'
            },
            "warning.modal": {
              'message1': 'Processing takes time because detailed data needs to be processed to create the report. Please click the “Create CSV” button to create the data in the background.',
              'message2': 'The output report can be viewed on the “Report Download” screen.',
            },
            "table": {
              'requestDate' : 'Request Date',
              'merchantId' : 'Merchant ID',
              'branchName': 'Branch / Sales office',
              'date': 'Year/Month',
              'aggregatedSalesBy': 'Display Aggregated Sales',
              'granularity': 'Result Granularity',
              'unitPrice': 'Aggregation by unit price',
              'status': 'Situation',
              'completionDate': 'Completion Date',
              'downloadCSV': 'Download',
              'supplementary.information' : 'Supplementary Information',
              'downloadBtn' : 'Download',
              'sourcePage' : 'Report Type',
              'refresh' : 'Refresh',
              'back' : 'Switch to Monthly Sales Display'
            },
          },
        },

        "daily": {
          "title": "Search Filter Criteria"
        },
        "deviceSerialNumber": "Device Serial Number",
        "after.replacement": "After Replacement",
        "before.replacement": "Before Replacement",
        "devices.count": "Count of devices:",
        "initial.fee":"Initial Fee =",
        "monthly.fee": "Monthly Fee =",
        "replacement": "Replacement =",
        "total.count": "Total Count =",
        "settlementCSVbyBranch":"_Settlement_DetailsByBranch",
        "settlementCSVbyDevice":"_Settlement_DetailsByDevice",
        "invoiceCSVbyBranch":"_Invoice_DetailsByBranch",
        "invoiceCSVbyDevice":"_Invoice_DetailsByDevice",
        "closing.date.info":"For those Terminal(s) which is/are removed in this \nmonth, this column displays the latest date amongst \n{Closing Date, Removal Date, Portal Detached Date}."
      },

      "settlementsAndInvoices": {
        "invoice.not.settlement.created": "A Settlement is created instead of an Invoice.",
        "settlement.not.invoice.created":"An Invoice is created instead of a Settlement",
        "list": {
          "title": "Settlement / Invoice",
          "noData": "No results found.",
          "form": {
            "date": "Target month for settlement",
            "showData": "Show Data",
          },
          "card": {
            "settlement": {
              "title": "Settlement",
              "table": {
                "contractId": "Contract ID",
                "merchantName": "Merchant name",
                "branchName": "Branch name",
                "branchCode":"Branch Code",
                "expenses": "Expenses",
                "settlementDestination": "Settlement Destination",
                "otherFee": "Other Fee (taxable)",
                "otherFee2": "Other Fee (non-taxable)",
                "remarks": "Remarks (taxable)",
                "remarks2": "Remarks(non-taxable)",
                "adjustedAmount" : "Adjusted Amount Details",
                "submit": "Submit",
                "revert": "Revert",
                "recalculate": "Re-calculate",
                "notapplicable":"Not Applicable",
            "save.invoiceAdjusted":"The Invoice has been successfully adjusted",
            "revert.invoiceAdjusted":"The invoice adjustment has been reverted successfully.",    
		        "submit.msg": "This action will make the Settlement in submitted state. The respective Merchant will be able to view the Settlement once submitted. Do you wish to proceed?",
		        "revert.msg": "This action will make the Settlement in non-submitted state. The respective Merchant will not be able to view the Settlement after reverting and it must be Submitted again. Do you want to proceed?",
		        "recalculate.msg": "This action will re-calculate and update the Settlement document. After the Settlement document is updated, it cannot be reversed. Are you sure you want to proceed with this action?",
              },
              "action": {
                "display": "Display Settlement",
                "download": "Download Settlement (PDF)"
              },
              "modal":{
                "header":"Confirmation Required",
                "submit.btn":"Submit",
                "confirm":{
                  "msg1":"You are about to adjust the invoice amount of",
                  "msg2":"with the current settlement. Please press Submit to confirm, else press X to discard.",
                },
               "revertInvoice":{
                  "header":"Confirmation Required",
                  "submit.btn":"Revert",
                  "confirm":{
                    "msg1":"You are about to revert the invoice adjustment of",
                    "msg2":"with the current settlement. Please press Submit to confirm, else press X to discard."
                  }
               }, 
              },
            },
            "invoice": {
              "title": "Invoice",
              "table": {
                "contractId": "Contract ID",
                "merchantName": "Merchant name",
                "branchName": "Branch name",
                "branchCode":"Branch Code",
                "expenses": "Expenses",
                "settlementDestination": "Settlement Destination",
                "otherFee": "Other Fee (taxable)",
                "otherFee2": "Other Fee (non-taxable)",
                "remarks": "Remarks (taxable)",
                "remarks2": "Remarks(non-taxable)",
                "reason": "Reason",
                "submit": "Submit",
                "revert": "Revert",
                "recalculate": "Re-calculate",
                "paymentMethod": "Separate",
                "sendingStatus": "Sending Status",
		        "submit.msg": "This action will make the Invoice in submitted state. The respective Merchant will be able to view the Invoice once submitted. Do you wish to proceed?",
		        "revert.msg": "This action will make the Invoice in non-submitted state. The respective Merchant will not be able to view the Invoice after reverting and it must be Submitted again. Do you want to proceed?",
		        "recalculate.msg": "This action will re-calculate and update the Invoice document. After the Invoice document is updated, it cannot be reversed. Are you sure you want to proceed with this action?",
              },
              "action": {
                "display": "Display Invoice",
                "download": "Download Invoice (PDF)",
                "emailInvoice": "Email Invoice",
              }
            }
          },
        },
        "detail": {
          "title": "Settlement / Invoice",
          "form": {
            "date": "Target month for settlement",
            "merchantName": "Merchant name",
            "contractId": "Contract ID",
            "showData": "Show Data"
          },
          "card": {
            "settlement": {
              "title": "Settlement",
              "action": {
                "display": "Display Settlement",
                "download": "Download Settlement (PDF)",
                "displayBranch": "Display details by branch",
                "downloadCSV": "Download details by branch (CSV)",
                downloadDetailsByDeviceOwnerByDevice : "Download Details by device owner - by device"
              },
              "branchDetail": {
                "title": "Details of Settlement",
                "download": "Download Settlement (PDF)"
              }
            },
            "invoice": {
              "title": "Invoice",
              "action": {
                "display": "Display Invoice",
                "download": "Download Invoice (PDF)",
                "displayBranch": "Display details by branch",
                "displayDevice": "Display details by device",
                "downloadCSV": "Download details by branch (CSV)",
                "downloadByDeviceCSV": "Download details by device (CSV)"
              },
              "branchDetail": {
                "title": "Details of Invoice",
                "download": "Download Invoice (PDF)"
              },
              "note": {
                "closingDate": "※ The closing button was pressed and the Settlement Amount is lower than monthly fee.",
                "calenderMonth": "※ The Settlement Amount is lower than monthly fee.",
              }
            }
          },
        }
      },

      "left.nav": {
        "ParentMenu": {
          "item1": "Service Contract",
          "item2": "Device Requests",
          "item3": "Device Management",
          "item4": "Sales & Settlement",
          "item5": "Notifications",
          "item6": "Service Management",
          "item7": "System Management",
          "item8": "In-office Service",
          "item9": "Partner",
          "item10": "Device Linking",
          "item11": "Other",
        },
        "ChildMenu": {
          "item1": "List / Browse",
          "item2": "Create / Update",
          "item3": "List / Browse Device Requests",
          "item4": "New Device Installation",
          "item5": "Device Preparation Status",
          "item6": "List / Browse Device Status",
          "item7": "View Device Details",
          "item8": "Daily Sales",
          "item9": "Monthly Sales",
          "item9.1": "Details for one item",
          "item10": "Settlement",
          "item10.1": "Settlement / Invoice ",
          "item11": "Invoice",
          "item12": "View Notification Details",
          "item13": "Configure Notifications",
          "item14": "Organisation",
          "item15": "User Account",
          "item16": "Permissions",
          "item17": "Device Terminals",
          "item18": "Schedules",
          "item19": "Monitor / View System Status",
          "item20": "Device Replacement",
          "item21": "Department",
          "item22": "Usage Rules",
          "item23": "Device Linkage",
          "item24": "Usage Details",
          "item25": "QR Code Management",
          "item26": "Employee",
          "item27": "Terminal Operations",
          "item28": "Change Device Request",
          "item29": "Application for Device Linking",
          "item30": "Inventory Device Management",
          "item31": "Download Reports",
        },
        "ChildSubMenu": {
          "item1": "List / Browse",
          "item2": "View One Record",
          "item3": "View Settlement Summary",
          "item4": "Create / Update Invoice",
          "item5": "Create/ Update",
          "item6": "Generate/Reset/Change Password",
          "item7": "Update/View Device Information",
          "item8": "Password Management",
          "item9": "By Device",
          "item10": "By Employee",
          "item11": "Create",
          "item12": "Display by Month/Day",
          "item13": "One Item Details",
          "item14": "Update",
          "item15": "Account Management",
          "item16": "Transmission History",
          "item17": "Register New",
          "item18": "Add Closing",
          "item19": "Activate/Deactivate Closing",
        }
      },

      "device.request": {
        "history": {
          "suspend.title":"Suspend / Resume History",
          "suspend.note": 'NOTE: The most recent history is always displayed on the top and the "Initial Fee" and "Monthly Fee" is calculated based on the Yes/No displayed on the top row.',
          "msg": "Click here to view replacement history",
          "title":"Device Replacement History",
          "operation.start.date": "Operation Start Date",
          "removal.date": "Removal Date",
          "replacement.date": "Replacement Date",
          "deviceSerialNumber": "Device Serial Number",
          "merchant.id": "Merchant ID",
          "contract.id":"Service Contract ID",
          "status": "Status",
          "fromDateTime": "From Date-time",
          "toDateTime": "To Date-time",
          "branchName": "Branch Name",
          "branchCode": "Branch Code",
          "charge.monthly.fee":"Charge Monthly Fee ?",
          "charge.initial.fee":"Charge Initial Fee ?",
          "yes": "Yes",
          "no": "No"
        },
        "create": {
          "title": "New Device Request",
          "btn_create": "Create",
          "btn_cancel": "Cancel",
          "sc.id.missing": "Please enter service contract id"
        },
        "list": {
          "service.contract.id": "Service Contract ID",
          "partner": "Partner",
          "partner.table.column": "P",
          "merchant.name": "Merchant Name",
          "device.application.number": "Device Application Number",
          "date.of.application": "Date of Application",
          "device.productName": "Product Name",
          "device.serial": "Device Serial",
          "device.serial.tooltip": "Comma or space separated half-width alphanumeric values up to 200 chars.",
          "device.owner": "Device Owner",
          "desired.delivery.date": "Desired Delivery Date",
          "expected.delivery.date": "Expected Delivery Date",
          "jesca.application": "JESCA Application",
          "jesca.application.date": "JESCA Application Date",
          "jesca.reflection.date": "JESCA Reflection Date",
          "ins.store.name": "Installation Store Name",
          "inv.branch.name": "Invoice Destination Branch Name",
          "status": "Status",
          "view": "View",
          "device": "Device",
          "version": "Version",
          "upload.device": "Upload Device Request Excel",
          "upload.device.changes": "Device Application Change Upload",
          "upload.device.jesca": "JESCA Upload Device Request Excel",
          "upload.device.progress": "Upload Shipment Report Excel",
          "edit.device": "Edit Device Request",
          "edit.device.progress": "Edit Device Progress",
          "edit.device.changes":"Edit Device Application Changes",
          "download.shipment.template": "Download Shipment Report",
          "download.jmups.excel": "Download JMups Excel",
          "download.jmups.excel.confirm.msg1": "The below Service Contracts of the selected Device Requests does not contain the Merchant Numbers",
          "download.jmups.excel.confirm.msg2": "Therefore, the Merchant numbers will be downloaded as blank. Do you want to continue?",
          "download.shipment.tms.excel.btn": "Shipping Info CSV (TMS)",
          "download.request.tms.excel.btn": "Installation Info CSV (TMS)",
          "download.device.request.excel.btn": "Download e-MOSS Plus Terminal Application",
          "msg.confirm.cancel": "Are you sure you want to cancel this Device Request?",
          "msg.confirm.delete": "Are you sure you want to delete this Device Request?",
          "msg.success.cancel": "Device Request Cancelled Successfully",
          "msg.success.delete": "Device Request Deleted Successfully",
          "msg.error": "Error occurred while submitting the form. Please try again later.",
          "btn.cancel": "Cancel",
          "btn.delete": "Delete",
          "last.modified": "Last Modified",
          "supplementary.information":"Supplementary Information",
          "created.by":"Created By：",
          "filter.by.status":"Filter by Status",
          "btn.show.data":"Show",
          "btn.clear":"Clear",
          "terminal.remove":"Remove Terminal",
          "detach.suspend.dropdown.btn": "Detach / Suspend",
          "detach.terminal.btn":"Detach Terminal(s)",
          "detach.terminal.title":"Portal Detachment of Terminal(s)",
          "detach.terminal.point1":"The “Detached Date” field can be set to ① any value between “Removal Date (31/32)” and “Current Month-end Date”. ②If the “Removal Date (31/32)” is not available, then the “Detached Date” field can be set to any value between “Last Communication Date” and “Current Month-end Date”.③If the “Last Communication Date” is not available, then the “Detached Date” field can be set to any value between  “Operation Start Date” and “Current Month-end Date” ④If the “Operation Start Date” is not available, then the “Detached Date” field can be set to any value between  “Installation Date”  and “Current Month-end Date”",
          "detach.terminal.point2":"After detachment,  it cannot be reverted back. ",
          "detach.terminal.point3":"If the “Detached Date” falls in previous month’s Settlement duration (if it’s Settlement/Invoice was already created), then please be sure to “Re-Calculate” the Settlement / Invoice documents, when required. Please note that the Terminals will be moved to “Portal Detached And Settled” state either by “Re-Calculate” operation or by the Settlement batch executed on “Next Batch Run Date”.",
          "detach.terminal.point4":"The Terminal Removal application can be modified until the “Current Month-end Date” (the application becomes un-editable after the “Current Month-end Date” is passed).",
          "terminal.remove.confirm.msg":"This will register a Terminal Removal application with the system and the Terminal will be moved to a Detached State in few minutes. Also, the Terminal will be Settled/Invoiced on the 'Next Batch Run Date', then the Terminal can be re-attached to the e-MPP system.",
          "show.replacement.devices": "Show Replacement Devices",
          "reservation.date.time": "Reservation Date time",
        },
        "detail": {
          "title.detail": "Detail",
          "title.device.detail": "Device Detail",
          "btn_update": "Update"
        },
        "confirm.title": "Note",
        "edit": {
          "err.msg.cannot.allow.state.transition": "Device Installation Status for Application ID: '{{id}}' is not allowed to update from '{{from}}' to '{{to}}' in row {{row}}.",

          "err.msg.required.field": "{{param}} in Row {{row}} is a Required Field.",
          "err.msg.date.or.non.empty.field": "{{param}} in Row {{row}} should contain date in valid format YYYY年MM月DD日 only.",
          "err.msg.empty.field.with.width.n.or.empty": "{{param}} in Row {{row}} should contain a maximum of {{n}} characters.",
          "err.msg.non.alphanumeric": "{{param}} in Row {{row}} is not in proper format. It can contain alphabets and digits only.",
          "err.msg.non.space.alphanumeric": "{{param}} in Row {{row}} is not in proper format. It can contain alphabets,space and digits only.",
          "err.msg.numeric.field": "{{param}} in Row {{row}} is not  in proper format.It can contain digits only.",
          "err.msg.stringLengthFullHalf": "{{param}} in Row {{row}} should contain a maximum of {{n}} bytes.",
          "err.msg.numericOneToFive.field": "{{param}} in Row {{row}} is not  in proper format.It can contain digits between 1-5 only.",
          "err.msg.numericZeroToOne.field": "{{param}} in Row {{row}} is not  in proper format.It can contain digits between 0-1 only.",
          "err.msg.numericOneToTwo.field": "{{param}} in Row {{row}} is not  in proper format.It can contain digits between 1-2 only.",
          "err.msg.numericOneToThree.field": "{{param}} in Row {{row}} is not  in proper format.It can contain digits between 1-3 only.",
          "err.msg.fullwidth.field": "{{param}} in Row {{row}} should have Full Width Characters Only.",
          "err.msg.halfwidth.field": "{{param}} in Row {{row}} should have half Width Characters Only.",
          "err.msg.phone.invalid": "{{param}} in Row {{row}} should have a valid phone number.",
          "err.msg.email.invalid": "{{param}} in Row {{row}} should have a valid email.",
          "err.msg.zip.code.invalid": "{{param}} in Row {{row}} should have a valid zip code.",

          "err.msg.numeric.or.empty.field": "{{param}} in Row {{row}} should contain numbers only or leave it empty.",
          "err.msg.numeric.or.non.empty.field": "{{param}} in Row {{row}} should contain numbers only.",
          "err.msg.numeric.or.non.empty.field.with.width.6": "{{param}} in Row {{row}} should contain only numbers with maximum 6 digits.",
          "err.msg.branch.code": "{{param}} in Row {{row}} is either empty or not in proper format. It should contain alphabets and digits upto 6 characters.",
          "err.msg.date.or.empty.field": "{{param}} in Row {{row}} should contain date in valid format YYYY年MM月DD日 only or leave it empty.",
          "err.msg.date.remove.device": "{{param}} is invalid in Row {{row}}, please enter a valid date in format yyyy/MM/dd hh:mm:ss",
          "err.msg.device.serial": "{{param}} in Row {{row}} is not in proper format. The system allows to input any combination of alphabets, digits, '-' and '_' , please correct the input and retry.",
          "err.msg.device.owner": "{{param}} is invalid in Row {{row}}, please select from the dropdown options.",
          "err.msg.empty.field.with.width.n.and.non.empty": "{{param}} in Row {{row}} should not be empty or contain more than {{n}} characters.",
          "err.msg.format.invalid": "{{param}} in Row {{row}} is not in proper format.",
          "warning.msg.dont.refresh": "NOTE: Please do not refresh the browser (or do not hit the keyboard's F5 key).",
          "btn.save.as.draft": "Save As Draft",
          "btn.submit": "Apply",
          "btn.cancel": "Cancel",
          "running.state.edit.message": "Editing Device Request(s) which are in Installed or Running State may immediately impact the Sales Aggregation and Device Management pages. It may also impact the past Settlement/Invoice Records when they are “Re-Calculated” and shall impact the future Settlement/Invoice Records. <span class='text-danger-imp'>In case a Terminal was installed in recent 30 mins, these changes will also affect the Sales Aggregation and Device Management for such Terminals(s).</span> Are you sure you want to continue?"
        },
        "suspend": {
          "confirm.msg": '<div>This will register new Suspend/Resume request(s) for the selected device(s). </div>  <div class="m-t-10">Please note that: </div> <div> <ol>  <li>Once a Suspend/Resume request is registered in the system, then this request cannot be cancelled or reverted. </li>  <li>The system may take upto one hour to process a Suspend/Resume request. A new Suspend/Resume request for the same device can only be applied after the previous Suspend/Resume request was already processed successfully. </li>  <li> Once a device is moved to "Processing Suspension" or "Suspended" states, the device is NOT automatically moved to "Installed" or "Running" states even if there are any new transaction arrives. Please register a Resume request to move the system to "Installed" or "Running" states. </li> </ol> </div> <div> Please click on the confirm button to proceed. </div> ',
          "btn": "Suspend / Resume",
          "err.msg.required.field": '{{param}} is invalid in Row {{row}}, please select the "Operation" drop-down to populate this value.',
          "err.msg.invalid.date":'The input "Operation Effective From" date-time is invalid. Please input a date-time from Today (from 0000 JST) to Future date up-to end of sixth-month excluding the current month. Please input such a date-time and try again.',
          "err.msg.invalid.status": "For Device [{{deviceSerial}}, {{applicationNumber}}], the operation {{operation}} cannot be selected since the device is in {{nowStatus}} state. Instead, please select operation {{validOperation}} to proceed.",
          "title": "Suspend / Resume Terminal(s)",
          "terminal.point1": 'Please note that once a "Processing Suspension" request is registered in the system, then the request cannot be cancelled. The Device must be "Suspended" and then "Resumed" if it is required to use the Device again. At present, there is no concept of Cancellation of a Suspend/Resume request, therefore, please be sure before registering a Suspend/Resume request.',
          "terminal.point2": 'The "Operation Effective From" date-time can be selected as Today (from 0000 JST) or Future date. The "Operation Effective From" for a Future date can be set only up-to end of sixth-month excluding the current/running month.',
          "terminal.point3": 'It may take upto 1 hour for the TO-BE states to become visible in the Device Request and Device Management pages. Until the TO-BE states are visible, the same device cannot be moved to next operation/state using the "Suspend/Resume Terminal(s)" page.',
          "terminal.point4": 'Once a device is moved to "Processing Suspension" or "Suspended" states, then the system does NOT automatically move those devices back to "Installed" or "Running" states (even if any transaction arrives from the device). However, the "Monthly Sales", "Daily Sales" and "Details for one item" page displays the latest transaction. Also, the "Last Communication Date" and "Last Sales Date" displays the latest transaction dates.'
        },
        "jesca":{
            "edit.title":"Edit JESCA Application",
            "upload.excel":"Upload JESCA DR Excel (Draft)",
            "upload.csv":"Upload JESCA CSV",
            "download":"JESCA Application Download",
            "download.result":"JESCA Application Result Download",
            "download.activation.csv":"JESCA Activation Info CSV Download",
            "apply":"Apply For JESCA to MARON via SFTP",
            "apply.title":"Confirmation of application details",
            "apply.message":"Save the changes and apply to JESCA",
            "apply.btn.text":"Apply",
            "reset.btn.text":"Reset",
            "reset.title":"Confirmation of reset",
            "reset.message":"Reset the application.",
        },
        "change":{
          "upload.excel":"Upload Device Request Change",
          "edit.title":"Edit Device Request Change",
          "receipt.number":"Receipt Number",
          "item.name":"Item Name",
          "serial.number":"S.No",
          "service.contractId":"Service Contract Id",
          "device.merchant":"Merchant",
          "device.owner":"Device Owner",
          "device.application.number":"Device Application Number",
          "device.serial":"Device Serial",
          "installation.store.name":"Installation Store Name",
          "reservation.date.time":"Reservation Date Time",
          "status":"Status",
          "btn.reserve":"Reserve Change",
          "btn.download":"Download",
          "btn.save":"Save",
          "btn.cancel":"Cancel",
          "btn.cancelApplication":"Cancel Application",
      },
      "reserve.modal":{
        "immediate":"Immediately",
        "today":"Today",
        "month.end":"Month End",
        "start.next.month":"Start of Next Month",
        "specify.date.time":"Specify Date Time",
        "cancel.reservation":"Cancel reservation",
        "title":"Reserve Change",
        "title2":"Reservation Change",
        "message1":"The following terminals have already been settled (activated):",
        "message2":"Execute immediately. Are you sure?",
        "btnText":"Execute",
      },
      "upload.error.modal":{
        "message1":"Please make reservations separately for terminals that have already been settled (activated) and those that have not yet been settled (activated).",
        "message2":"Terminals that have already been settled (activated):",
        "btnText":"OK",
      }
    },
    "device.linking":{
      "modal.msg":{
        "title":"Confirm Application Cancellation",
        "message":"Are you sure you want to cancel the application?",
        "btn.text":"Yes"
      }
    },

      "jmups.mapping":{
        "title":"J-Mups Area-Operator Mapping",
        "money.type":"Money Type",
        "area":"Area",
        "area.specific":"Specific Area",
        "current.operator":"Current Operator",
        "change.operator":"Operator After Change ",
        "save":"Save Changes",
        "inuse.money.operator":"Show In-use Operators only",
        "confirm":"You are about to update the J-Mups Area-Operator Mapping. It may impact the J-Mups Application form."
      },

      "iosl":{
        "office.attributes":"Office Attributes",
        "service.type":"Service Type",
        "service.sub.type":"Service Sub Type",
        "related.merchants":"Related Merchants",
        "merchant.name":"Merchant Name",
        "merchant.code":"Merchant Code",
        "warning.msg":"The Merchant is already added.",
        "last.modified":"Last Modified",
        "msg.server.error": "Please confirm the below errors and please rectify the rows/fields containing the error (errors such as data is not provided, data is duplicate, data is in incorrect format etc).",
        "empty.excel.file.msg": "The uploaded excel file was empty. Please check the excel file and try again.",
        "department": {
          "create.update.view.on.page.title": "Create Department",
          "upload.info":"Upload Department/Employee Info",
          "err.msg.required.field": "{{param}} in Row {{row}} is a Required Field.",
          "err.msg.valid.required.field":"{{param}} in Row {{row}} should not contain special character(s).",
          "msg.delete.status": "Deleted Successfully",
          "delete.warning.msg": "Select atleast one row to delete",
          "office.id": "Office ID",
          "id":"Department ID",
          "employee":"Employee",
          "office.name":"Office Name",
          "name": "Department Name",
          "remarks": "Department Remarks",
          "operation": "Operation",
          "edit":"Edit Department Info",
          "upload":"Upload Department/Employee Info",
          "download":"Download Department Info",
          "delete":"Delete",
          "delete.msg":"Are you sure you want to delete ?",
          "submit":"Submit"
        },

        "employee": {
          "create.update.view.on.page.title": "Create Employee",
          "select.office.name.msg": "Office name must be selected before selecting Department Name",
          "expiration.date.msg": "'Expiration Date' must be greater than  'Start Date'. Please enter another date-time and try again.",
          "upload.info":"Upload Department/Employee Info",
          "msg.delete.status": "Deleted Successfully",
          "office.id": "Office ID",
          "office.name": "Office Name",
          "department":"Department",
          "department.id":"Department ID",
          "department.name":"Department Name",
          "department.remarks":"Department Remarks",
          "id":"Employee ID",
          "name": "Employee Name",
          "expiryDate":"Expiration Date",
          "startDate":"Start Date",
          "enabled":"Enabled",
          "issueCount":"Issue Count",
          "remarks": "Employee Remarks",
          "expiration.date": "Expiration Date",
          "operation": "Operation",
          "edit":"Edit Employee Info",
          "upload":"Upload Department/Employee Info",
          "download":"Download Employee Info",
          "delete":"Delete",
          "delete.msg":"Are you sure you want to delete ?",
          "action": "Action",
          "submit":"Submit",
          "qrcode.download": "Download Employee QrCode",
          "qrcode.info": "Employee QR Code Information",
          "qrcode.detail.msg": "Click here to view QR Code Details",
          "qrcode.data" :"QR Code data",
          "qrcode" :"QR Code",
          "setting.value":"Setting Value",
          "remainder.from.result":"Remainder from result",
          "feliCaIdm":"Card Number (IDM)",
        },
        "usage.rules":{
            "create":"Create Usage Rules",
            "upload":"Upload usage rules information",
            "edit":"Edit Usage Rules",
            "download":"Download usage rules",
            "one.time.amount":"One-time Amount",
            "total.number.per.day":"Total number of times/day",
            "total.number.per.month":"Total number of times/month",
            "cumulated.amount.per.day":"Cumulated amount/day",
            "cumulated.amount.per.month":"Cumulated amount/month",
            "cumulated.numberoftimes.allowed":"Cumulated Number of times",
            "cumulated.amount":"Cumulated Amount",
            "column.code":"Column Number",
            "time.slot.available":"Time range",
            "week.days.allowed":"Days of the week",
            "cumulative.no.of.times.per.week.allowed":"Cumulative count/week",
            "cumulative.amount.per.week.allowed":"Cumulative amount/week",
            "not.empty.error.msg": "All the rules cannot be empty, atleast one rule must be filled. Please check and try again."
        },
        "device.linkage":{
            "create":"Create Device Link",
            "edit":"Edit Device Link Info",
            "upload":"Upload Device Link Info",
            "download":"Download Device Link Info",
            "application.number":"Application Number",
            "merchant":"Merchant",
            "device.owner":"Device Owner",
            "device.serial":"Device Serial",
            "installation.location":"Installation Location",
            "installation.store.name": "Installation Store Name",
            "linking.date":"Linking Date",
            "customer.control.number":"Customer Control Number",
        },
        "usage.details": {
          "display.granularity": "Display Granularity",
          "target.month":"Target Month",
          "target.day":"Target Day",
          "time.period":"Time Period",
          "daily":"Daily",
          "remark": "Remark",
          "installation.store.name": "Installation Store Name",
          "office":"Office",
          "department":"Department",
          "total.usage":"Total Usage",
          "operator":"Operator",
          "operatorId":"Operator ID",
          "device.serial":"Device Serial",
          "installation.location":"Installation Location",
          "employee":"Employee",
          "settlement.time":"Settlement Time",
          "settlement.amount":"Settlement Amount",
          "processing.result":"Processing Result",
          "error.id":"Error",
          "column.id":"Column ID"
        },
        "transmission.history":{
          "device.number":"Device Number",
          "transmission.received.date":"Transmission Received Date time",
          "sequence.number":"Sequence Number",
          "transmission.type":"Transmission Type",
          "number.of.retry":"Number of Retry",
          "processing.result":"Processing Result",
          "error.code":"Error Code",
          "error.result":"Error Result",
          "delete":"Delete",
          "error.type":"Error Type",
          "duration":"Duration",
          "update":"Update",
        },
        "account.management":{
          "register.new":"Register New",
          "office.id":"Office ID",
          "auth.id":"Authentication ID",
          "auth.id.name":"Authentication ID Name",
          "new.password":"New Password",
          "password":"Password",
          "delete":"Delete",
          "delete.msg":"Are you sure you want to delete ?",
          "msg.delete.status":"The Account is successfully deleted.",
          "enable":"Enable",
          "disable":"Disable",
          "msg.enable":"Are you sure you want to enable this account?",
          "msg.enable.status":"Account status: enabled",
          "msg.disable":"Are you sure you want to disable this account?",
          "msg.disable.status":"Account status: disabled",
        }
      },

      "other":{
        "header":'Access Telemetry service for beverage vending machines',
        "link":'Click Here',
      }

    });

    $translateProvider.translations('jp', {
      "common.components": {

        "title.error": "エラー",
        "title.error.withCount": "つのエラーが見つかりました。",
        "title.success": "成功",
        "title.warning": "警告",
        "title.info": "情報",
        "title.delete": "削除？",
        "title.cancel": "キャンセル？",
        "coming.soon": "準備中",
        "permission.denied": "アクセス権限がありません。",
        "permission.denied.msg": "エラー! 本機能を使用する許可がありません。",
        "500.denied": "500エラー",
        "404.denied": "404エラー",
        "500.msg.part1": "不明なエラーが発生しました。",
        "500.msg.part2": "から再試行してください。",
        "404.msg.part1": "お探しのページは見つかりませんでした。",
        "404.msg.part2": "から再試行してください。",

        "msg.success": "処理が成功に完了しました。",
        "msg.error.same.oldPassword": "新パスワードを現パスワードと同じにすることはできません。別のパスワードを入力してください。",
        "msg.error.password.noMatch": "新しいパスワードと確認パスワードが一致しません。",
        "msg.error.in.form": "エラーが発生しました。入力した情報を確認してください。",
        "msg.error.in.form.withCount": "強調表示されたフィールドを確認して、データが提供されていないか、データの形式が正しくないフィールドを修正してください。",
        "msg.error.in.device.owner": "本操作は完了できません。ターゲット借用元にはリンクされた端末申請または実行中の端末が含まれています。先に進む前に端末申請を取消または削除し、実行中の端末を中断してください。問題が解決しない場合は、e-MOSSサポートセンターに連絡してください。",
        "msg.error.response": "この操作の実行中にエラーが発生しました。 もう一度やり直してください。",
        "msg.confirm": "アップロードした情報が失われます。情報を保存するために「保存」ボタンをクリックしてください。",
        "msg.changePassword": "入力した新規パスワードが「パスワードに確認」のパスワードと一致していません。",
        "msg.token.expired": "パスワードリセットリンク(URL)の期限が切りました。「パスワードを忘れた」オプションで新規パスワードリセットリンク(URL)を作成するか管理者まで問い合わせお願いします。",
        "msg.csv.format":"このファイル形式はサポートされていません。エクセルファイル（*.xlsx)をアップロードしてください。",
        "msg.csv.max.size.10":"ファイルの最大サイズは10 MBです。",
        "msg.csv.max.size.5":"ファイルの最大サイズは5 MBです。",
        "msg.service.contract.organisation":"加盟店の会社は既に存在します。別の契約を作成しますか？",
        "msg.continue":"確定",
        "btn.yes":"確定",
        "btn.cancel":"キャンセル",
        "btn.delete": "削除",
        "btn.confirm":"確認",
        "required":"※",
        "org.type.err.msg":"管理者の組織は他の組織区分で作成することはできません。",
        "processing":"処理中...しばらくお待ちください。",
        "data.not.available":"該当データなし",
        "points.to.note":"注意点：",
        "select.all":"全選択",

        "random": {
          "add.new": "追加",
          "required": "必須",
          "no.results.found": "結果が見つかりませんでした。",
          "valid.required":"有効な入力が必要です。",
          "half.width.valid.required":"有効な半角入力が必要です。"
        },

        "address": {
          "title": "所在地",
          "zip": "〒",
          "prefecture": "都道府県",
          "city.town": "市区町村丁目",
          "street": "番地",
          "street.kana": "フリガナ",
          "building": "マンション名等",
          "building.kana": "フリガナ"
        },

        "contact": {
          "title": "ご連絡先",
          "email": "メールアドレス",
          "email_error_msg": "有効なメールアドレスが必要です。",
          "availability": "営業時間内外",
          "type": "事務所・自宅",
          "phone": "電話番号",
          "phone_error_msg": "有効な電話番号が必要です。"
        },

        "service.fee": {
          "e.money": "電子マネー数",
          "qr.money": "QRマネー数",
          "credit.money": "Credit Card",
        },
        "errorMessages": {
          "fillRequiredFields": "必須項目に情報を入力してください。",
          "error": "エラー"
        },
      },

      "home.page": {
        "title": "e-MOSS",
        "title2": " Plus",
        "home": "ホーム",
        "message": "e-MOSS Plus サービスへようこそ",
        "html.page.title.admin": "管理者",
        "html.page.title.device.owner": "端末所有者",
        "html.page.title.merchant": "加盟店"
      },

      "merchant.number":{
        "registration":"加盟店番号登録",
        "isRegistered":"加盟店番号が登録されています。",
        "notRegistered":"加盟店番号が登録されていません。",
        "information":"加盟店番号情報",
        "msg.success":"加盟店番号が成功に登録しました。",
        "msg.error":"加盟店番号登録が失敗しました。もう一度やり直すか、e-MOSS Plusサポートに連絡してください。",
        "not.registered":"未登録",
        "form.submit":"提出",
        "form.cancel":"キャンセル",
        "form.apply.all":"すべて適用",
        "form.confirm":"一度登録すると、加盟店番号は更新できません。",
        "update.confirm":"e-MOSS Plusお申込み内容を更新しますか。継続する場合、売上・資金精算へ影響する可能があります。",
        "empty.error":"加盟店番号は空白にできません。正しい加盟店番号を入力してください。",
        "apply.all.error":"小田急(PASMO), 楽天Edy, WAON, iD, nanaco の入力値が空か無効です。16桁の値を入力して、再度お試しください。"
      },

      "session.timeout":{
        "caution":"注意!",
        "message.pre":"このセッションは、",
        "message.post":"分で期限切れになります。保存されていないデータが失われないようにし、作業を続けるには、[セッションの更新] ボタンをクリックしてください。",
        "renew":"セッションの更新",
        "expireText":"前回のセッションは期限切れです。ログインし直してください。"
      },

      "service.contract.create": {
        "version":"お申込書バージョン",
        "confirm":"新しい契約がシステムに登録されます。 続行するには、確認してください。",
        "service.contract": {
          "title": "お申込情報",
          "title_detail": "e-MOSS Plus申込内容の確認",
          "title_edit": "編集 - e-MOSS Plus申込",
          "date": "申込年月日",
          "contractName": "契約名",
          "description": "契約概要",
          "remarks": "コンラックス担当者備考",
          "terms": "当社は「e-MOSS Plus加盟店規約」を承認の上、サービスを申込ます。本契約書の書類は貴社に譲渡し返却を求めません。",
          "cancel": "キャンセル",
          "save": "保存",
          "submit": "提出"
        },
        "applicant.information": {
          "title": "e-MOSS Plus お申込み",
          "create.new": "新規作成",
          "company.information": "企業情報",
          "company.type": "法人/個人区分",
          "name1":"氏名",
          "nameRep":"氏名※",
          "name.kana": "フリガナ※",
          "name": "氏名※",
          "company.name":"会社名※",
          "company.url": "ホームページ",
          "company.code": "法人コード",
          "company.code1": "（※法人の場合必須）",
          "company.business": "業種業務区分",
          "company.products": "取扱商品",
          "company.contact": "企業連絡先",
          "company.representative": {
            "title": "代表者様情報",
            "name.kana": "フリガナ※",
            "name": "氏名※",
            "name.label": "会社名※",
            "dateOfBirh": "生年月日",
            "addressTitle": "代表者自宅住所（※個人の場合必須）"
          },
          "incharge.department": "担当部署名",
          "branch": {
            "title": "支店/営業所情報",
            "create.new": "新規",
            "subTitle": "支店/営業所情報",
            "code": "支店/営業所コード",
            "name": "支店名/営業所名",
            "personInChargeTitle": "支店/営業所担当者情報(連絡先情報)"
          }
        },

        "deviceOwner": {
          "title": "端末借用元情報",
          "subTitle": "端末所有者情報",
          "code": "所有者コード",
          "name": "端末所有者の会社名",
          "address": "住所",
          "inCharge": "担当者",
          "device.purchase": "端末購入※",
          "self": "自社",
          "rented": "借用",
          "self.rented": "自社+借用",
          "warning.msg": "端末所有者はすでに追加されています 。"
        },

        "serviceDetails": {
          "title": "ご利用サービスの明細",
          "subTitle.a": "(A) 決済手数料 - ME-10 (1) モデム内蔵タイプ & (2)外部モデムタイプ",
          "subTitle.a1": "端末機種 ME-10-1, ME-10-2",
          "subTitle.emoney": "電子マネー毎の決済手数料",
          "subTitle.a.ME.20.1": "(A) 決済手数料 - ME-20  (1) モデム内蔵タイプ",
          "subTitle.a1.ME.20.1": "端末機種 ME-20-1",
          "subTitle.a.ME.20.2": "(A) 決済手数料 - ME-20 (2) 外付けモデムタイプ",
          "subTitle.a1.ME.20.2": "端末機種 ME-20-2",
          "subTitle.qr": "QRマネー毎の決済手数料",
          "subTitle.creditCard": "Credit Card",
          "transaction": "取引",
          "yen": "円",
          "percent": "%",
          "subTitle.b1": "(B) サービス費用 -（1）モデム内蔵タイプ",
          "applicable.device": "端末機種",
          "init.charges.title": "初期費用 (一回払い)",
          "init.charges.sub": "端末初期登録費用(台)",
          "monthly.charges.title": "月額費用 (再発コスト)",
          "monthly.charges.sub": "端末月額利用費用（台/月）",
          "subTitle.b2": "(B) サービス費用 - (2) 外部モデムタイプ",
          "includeSettlement":"精算書に含める",
          "nonTaxable":"非課税",
          "in.office.pay":"オフィス決済 ※",
          "0.emoney":"0電子マネー",
          "emoney.registrationFee": "登録料",
          "emoney.systemUsageFee": "システム利用料",
          "subTitle.b3": "(B) (3) サービス費用 - ME-20 (1) モデム内蔵タイプ",
          "subTitle.b4": "(B) (4) サービス費用 - ME-20 (2) 外部モデムタイプ",
          "subTitle.a.ME.5.1": "(A) 決済手数料 - ME-5 (1) モデム内蔵タイプ",
          "subTitle.a1.ME.5.1": "端末機種 ME-5-1",
          "subTitle.b5": "(B)サービス費用- (1) モデム内蔵タイプ",
        },

        "settlementConditions": {
          "title": "ご精算条件",
          "method.title": "精算方法",
          "method.group": "精算グループ",
          "method.sub": "支払日",
          "closing.title": "締め日",
          "closing.sub": "決済端末締め日",
          "paymentMethod.title": "(B)及び(C)のお支払い方法",
          "paymentMethod.sub": "諸費用 (B) (C)の※",
          "paymentMethod.sub1": "お支払い方法",
          "createInvoice":"請求書作成※"
        },

        "settlementInformation": {
          "title": "ご精算情報",
          "offsetting": "（相殺する法人様）",
          "no.offsetting": "(相殺しない法人様)",
          "bank.transfer.title": "お振込/ご請求方法について",
          "bank.transfer.sub": "精算先",
          "charge.monthlyFee.from": "月額費用の課金開始タイミング",
          "details.by.deviceOwner":"端末所有者別明細　要/不要",
          "initialOperation": "初回起動",
          "initialPayment": "初回決済",
          "emailInvoice": "請求書送付する／しない",
          "telemetryAccess": "飲料自販機向け検量サービスにアクセス",
          "bankAccount": {
            "title": "お振込口座",
            "branchName": "支店営業所名",
            "branchCode": "支店営業所コード",
            "bankCode": "金融機関コード",
            "bankName": "金融機関名",
            "bankBranchCode": "支店コード",
            "bankBranchName": "支店名",
            "serviceDetails": "口座番号",
            "accountName": "口座名義",
            "accountName.kana": "フリガナ",
            "bank.type": "金融機関",
            "account.holder": "口座名義",
            "accountNo": "口座番号",
            "type.of.account": "普通/当座",
            "invoiceId": "請求先ID"
          },
          "settlement.send.location": {
            "name": "会社名",
            "title": "明細送付先（ご請求書の場合郵送いたします）",
            "inChargeName": "会社/部署/担当者名※",
            "inChargeName.kana": "フリガナ※",
            "remarks": "備考"
          }
        },

        "address": {
          "title": "住所※",
          "zip": "〒",
          "prefecture": "都道府県",
          "city.town": "市区町村丁目",
          "street": "番地",
          "street.kana": "フリガナ",
          "building": "マンション名等",
          "building.kana": "フリガナ"
        },

        "contact": {
          "title": "ご連絡先※",
          "email": "メールアドレス",
          "availability": "営業時間内外",
          "type": "事務所・自宅",
          "phone": "電話番号"
        },

        "inCharge": {
          "title": "担当者情報",
          "name.kana": "フリガナ※",
          "name": "担当者名※"
        },

        "other": {
          "title": "その他費用",
          "cancellation.charge": "解約費用"
        },

        "service.usage.remarks": "サービス利用の備考",

        "bool1": "借用元による端末申請が可能",
        "bool2": "借用元による端末申請承認が必要",
        "bool3": "加盟店による端末申請が可能",
        "acquirer": {
            "title":"アクワイアラ関係詳細",
            "jmups":"J-Mupsテンプレート",
            "jmups.select":"J-Mupsテンプレートを選択"

         },
         "cir":{
          "title":"クレジット情報登録",
          "terminalId":"端末識別番号(TID)",
          "senderId":"仕向会社ID",
          "receipientId":"被仕向会社ID",
          "merchantId":"加盟店ID",
          "2merchantId":"第2加盟店ID",
          "merchantCategoryCode":"加盟店カテゴリーコード",
         }
      },

      "service.contract.list": {
        "upload.excel.btn": "申込書アップロード",
        "download.excel.btn": "申込書一覧ダウンロード",
        "service.contract.id": "契約先ID",
        "contract.id": "契約先ID",
        "merchant.id": "加盟店ID",
        "merchant.name": "加盟店",
        "owner.id": "所有者ID",
        "owner.name": "所有者名",
        "doc": "申込年月日",
        "organization.type": "申込区分",
        "device.owner.id": "借用元ID",
        "merchant.address": "所在地",
        "view": "表示",
        "merchant.information":"会社情報",
        "download":"ダウンロード",
        "upload":"アップロード",
        "maroon.application":"MARONアプリケーション初期値登録",
        "maroon.application.register":"登録",
        "maroon.application.register.title":"登録内容の確認",
        "maroon.application.register.message":"登録内容を保存します。"
      },

      "users.create.update.view": {

        "on.page.details": {
          "title": "ユーザーの作成/更新/表示"
        },
        "info.msg":"注：ユーザーログインが許可されていないパートナー組織は検索できません。",

        "common.information": {
          "title": "共通情報",
          "userName": "ユーザー名",
          "userId": "ユーザーID",
          "userEmail": "ユーザーメールアドレス",
          "userDescription": "ユーザー情報",
          "contactNumber": "連絡先",
          "orgError": "法人コードが存在していません。"
        },
        "organization.information": {
          "title": "企業情報",
          "organizationName": "法人名",
          "organizationCode": "法人コード",
          "userType": "ユーザー区分"
        },
        "user.information": {
          "title": "ユーザー情報",
          "dob": "生年月日",
          "age": "年齢",
          "gender": "性別"
        },
        "address": {
          "title": "住所※",
          "zip": "〒",
          "prefecture": "都道府県",
          "city.town": "市区町村丁目",
          "street": "番地",
          "street.kana": "フリガナ",
          "building": "マンション名等",
          "building.kana": "フリガナ"
        },
        "contact": {
          "title": "ご連絡先",
          "email": "メールアドレス",
          "availability": "営業時間内外",
          "type": "事務所・自宅",
          "phone": "電話番号"
        },
        "permission": {
          "title": "許可",
          "allowedOperations": "利用可能な操作",
        },
        "service.contract": {
          "title": "サービス契約情報",
          "date": "年月日",
          "contractName": "契約名",
          "description": "契約概要",
          "remarks": "CLXサービス担当者備考/",
          "terms": "eMPPの条件に同意する",
          "cancel": "キャンセル",
          "save": "契約を保存する",
          "submit": "契約を提出する"
        },

        "applicant.information": {
          "title": "eMPPアプリケーション",
          "company.information": "企業情報",
          "create.new": "新規",
          "company.type": "法人・個人区分",
          "name1": "会社名※",
          "name.kana": "フリガナ",
          "name": "会社名※",
          "company.url": "ホームページ",
          "company.code": "法人コード※",
          "company.business": "業種業務内容",
          "company.products": "取扱商品",
          "company.contact": "担当者名"
        },
        "company.representative": {
          "title": "代表者様情報",
          "name.kana": "フリガナ",
          "name": "氏名",
          "dateOfBirh": "生年月日",
          "addressTitle": "自宅所"
        },
        "branch": {
          "title": "支店/営業所情報",
          "create.new": "新規",
          "subTitle": "支店/営業所情報",
          "code": "支店/営業所コード",
          "name": "支店/営業所名",
          "personInChargeTitle": "支店/営業所担当者情報"
        },


        "deviceOwner": {
          "title": "既存端末所有者へ連携",
          "subTitle": "端末所有者情報",
          "code": "所有者コード",
          "name": "借用元",
          "address": "住所",
          "inCharge": "担当者"
        },

        "serviceDetails": {
          "title": "ご利用サービス",
          "subTitle.a": "(A) 決済手数料",
          "subTitle.emoney": "電子マネー別決済手数料",
          "subTitle.qr": "QRマネー別決済手数料",
          "subTitle.creditCard": "Credit Card",
          "transaction": "取引",
          "yen": "円",
          "percent": "%",
          "subTitle.b1": "(B)（1）サービス月額費用 - 内載モデムタイプ",
          "applicable.device": "端末機種",
          "init.charges.title": "初期費用",
          "init.charges.sub": "端末初期登録費用(台)（電子マネーセンター登録及び回線開通事務を含む）",
          "monthly.charges.title": "月額費用",
          "monthly.charges.sub": "端末月額利用量（台/月）",
          "subTitle.b2": "(B) サービス月額費用 -（2）外部モデムタイプ"
        },

        "settlementConditions": {
          "title": "ご精算条件",
          "method.title": "精算方法",
          "method.group": "精算グループ",
          "method.sub": "支払日",
          "closing.title": "締め日計算",
          "closing.sub": "締め日",
          "paymentMethod.title": "（B）（C）のお支払い方法",
          "paymentMethod.sub": "支払日"
        },

        "settlementInformation": {
          "title": "ご精算先情報",
          "offsetting": "（相殺する法人様）",
          "no.offsetting": "(相殺しない法人様)",
          "bank.transfer.title": "お振込/ご請求方法について",
          "bank.transfer.sub": "お振込/ご請求方法",
          "charge.monthlyFee.from": "月額費用の課金開始タイミング",
          "initialOperation": "初回起動",
          "initialPayment": "初回決済",
          "bankAccount": {
            "title": "お振込講座",
            "branchName": "加盟店の支店営業所名",
            "branchCode": "加盟店の支店営業所コード",
            "bankCode": "金融機関コード",
            "bankName": "金融機関",
            "bankBranchCode": "支店コード",
            "bankBranchName": "支店名",
            "accountNo": "口座番号",
            "accountName": "口座名義",
            "accountName.kana": "フリガナ"
          },

          "settlement.send.location": {
            "title": "明細送付先（ご請求書の場合郵送いたします）",
            "inChargeName": "会社/部署/担当者名",
            "inChargeName.kana": "フリガナ",
            "remarks": "備考"
          }
        },

        "inCharge": {
          "title": "ご連絡先",
          "name.kana": "フリガナ",
          "name": "担当者名"
        },
      },

      "home": {
        "title": "ホーム"
      },

      "org":{
              "detail.title":"組織の詳細",
              "list":{
                  "org.code":"法人コード (e-MOSS Plus)",
                  "org.id":"組織 ID",
                  "org.id.info":"組織の種類に応じて、加盟店ID、\n端末所有者ID、パートナーID、オフィスID\nなどの組織IDが表示されます。",
                  "org.type":"区分",
                  "org.name":"会社名",
                  "org.address":"所在地",
                  "org.representative":"代表者情報",
                  "action":"各種操作",
                  "view.edit":"表示/編集",
                  "view":"表示",
                  "pass":"パスワード管理",
                  "enable":"有効",
                  "disable":"無効",
                  "delete":"削除",
                  "msg.enable":"この会社を有効にしますが、よろしいですか？",
                  "msg.enable.status":"会社状況: 有効",
                  "msg.disable":"この会社を無効にしますが、よろしいですか？",
                  "msg.disable.status":"会社状況: 無効",
                  "msg.delete":"この会社を削除しますが、よろしいですか？ ",
                  "msg.delete.status":"会社を正常に削除しました。本会社に所属するユーザーも削除しました。"
              },
              "create":{
                   "common.information":"共通情報",
                  "org.type":"区分",
                  "org.name":"会社名",
                  "organisation.information":"企業情報",
                  "url":"ホームページ",
                  "products.handled":"取扱商品",
                  "name":"氏名",
                  "submit.data":"確定"
              },
              "view":{
                  "EDIT":"編集",
                  "title_view":"企業情報",
                  "title_update":"組織を更新",
                  "save":"確定",
                  "incharge.delete.error1":"このユーザーは契約ID ",
                  "incharge.delete.error2":"の最後の担当者であるため、担当者ユーザーはシステムから削除できません。 このユーザーを削除する前に、契約ID ",
                  "incharge.delete.error3":"の新規担当者ユーザーを作成するかあるいは、「ユーザー=>詳細ページ」を使用して同じ組織の別のユーザーを契約ID ",
                  "incharge.delete.error4":"の '担当者'に設定してください。",
              }
          },

      "user":{
            "service.contract":"契約IDの担当者",
            "service.contract.in-charge":"契約IDの担当者にする",
            "text.placeholder.for.sc.id":"契約の担当者を作成するには、ユーザー区分を管理者として選択してください。",
            "list.placeholder.for.sc.id":"こちらをクリックするか、契約IDを入力してください",
            "none":"なし",

            "detail.title":"ユーザーアカウントの詳細",
            "list":{
                  "merchant.id":"加盟店ID",
                  "owner.id":"所有者ID",
                  "msg.enable":"このユーザーを有効にしますが、よろしいですか？",
                  "msg.enable.status":"ユーザー状況: 有効",
                  "msg.disable":"このユーザーを無効にしますが、よろしいですか？",
                  "msg.disable.status":"ユーザー状況: 無効",
                  "msg.delete":"このユーザー削除しますが、よろしいですか？",
                  "msg.delete.status":"ユーザーを正常に削除しました。",
                  "msg.user.description":"これは必須フィールドで、最大250文字まで入力できます。"
              },
            "password.management": {
                  "operation": "操作タイプ",
                  "generatePass":"パスワード生成",
                  "resetPass":"パスワードリセット",
                  "changePass":"パスワード変更",
                  "oldPassword": "現パスワード入力",
                  "newPassword": "新パスワード入力",
                  "confirmPassword":"確認用）パスワード入力"
              },
            "view":{
                "submit.data":"確定",
                "save":"確定"
            }
      },

      "partner":{
        "details":"パートナー詳細",
        "link":"パートナー追加",
        "name":"パートナー名",
        "code":"パートナーコード",
        "conditions":"パートナー条件",
        "warning.msg":"パートナーはすでに追加されています 。",
        "allow":{
            "login":"ログインを許可する",
            "deviceRequest":"［端末申請］［端末稼働管理］メニュー・機能参照を許可する",
            "sales":"［売上・資金精算］メニュー・機能参照を許可する",
            "settlementInvoice":"［精算書・請求書］メニュー・機能参照を許可する",
            "serviceManagement":"［サービス管理］メニュー・機能参照を許可する"
        },
        "org.msg":{
            "changes":"<NAME>組織の権限の変更を次のように保存しようとしています：",
            "login":"システムはこの組織の新しいユーザーアカウントの作成を許可します。新しく作成されたユーザーアカウントは、ログイン手順で許可されている機能を使用できます。「担当」のユーザーには、ログイン手順が記載されたメール通知が送信されます。",
            "no.login":"システムはこの組織のすべての既存のユーザーアカウント（担当ユーザーも含む）を削除し、今後「ログイン」操作が「許可」された場合、これらのユーザーアカウントを再び復元することはできません。 情報が保存されると、ユーザーはログインしたり、システムを使用したりすることができなくなります。",
            "access": {
                "grant.deviceRequest":"<b>「端末申請」</b>へのアクセスを<b>「許可する」</b>",
                "revoke.deviceRequest":"<b>「端末申請]</b>へのアクセスを<b>「許可しない」</b>",
                "grant.sales":"<b>「売上・資金精算」</b>へのアクセスを<b>「許可する」</b>",
                "revoke.sales":"<b>「売上・資金精算]</b>へのアクセスを<b>「許可しない」</b>",
                "grant.settlementInvoice":"<b>「精算書・請求書」</b>へのアクセスを<b>「許可する」</b>",
                "revoke.settlementInvoice":"<b>「精算書・請求書」</b>へのアクセスを<b>「許可しない」</b>",
                "grant.serviceManagement":"<b>「サービス管理」</b>へのアクセスを<b>「許可する」</b>",
                "revoke.serviceManagement":"<b>「サービス管理]</b>へのアクセスを<b>「許可しない」</b>",
            }
        }
      },

      "login":{
        "title":"ログイン",
        "email": "メールアドレス",
        "password": "パスワード入力",
        "forgotPass":"パスワードを忘れた場合",
        "changePass":"パスワード変更",
        "submit":"提出",
        "sign.out":"ログアウト"

      },

      "device.management": {
        "status": "状況",
        "running": "稼働中",
        "stopped": "停止中",
        "error": "エラー有り",
        "removed": "撤去済み",
        "applied": "申請中",
        "device.serial": "端末シリアル",
        "owner.merchant": "所有者/加盟店",
        "sales.center": "支店・営業所",
        "first": "第一",
        "second": "第二",
        "third": "第三",
        "loc.id": "ロケID",
        "loc.name": "設置場所名",
        "money.types": "マネー種",
        "transport": "交通系",
        "waon": "WAON",
        "edy": "楽天Edy",
        "id": "iD",
        "qp": "QUICPay+",
        "nanaco": "nanaco",
        "signal": "電波",
        "last.communication.date": "最終通信日",
        "last.sales.date": "最終売上日",
        "last.modified.date":"情報更新日時",
        "operation.start.date": "稼働開始日",
        "operation.start.date.info": "稼働開始日時（設置日時）\n稼働開始日時は、最初の通信が端末から受信された日付です。\n設置日時は、設置されてから端末から受信された日付、または納品に基づいて計算された日付です。",
        "csv.info": "マネー種\n登録済・利用可  - 3\n未登録・利用可 - 2\n登録済・利用不可 - 1\n未登録・利用不可 - 0",
        "others": "その他",
        "search": "表示",
        "msg":"※ 検索結果には、選択した組織が所有者または加盟店のいずれかであるすべての端末状況が表示されます。",
        "device.delivery.date":"端末納品日",
        "installation.code":"設置先コード",
        "remarks":"備考",
      },

      "device.replacement": {
        "device.information" :{ 
          "title": "端末情報",
          "device.serial":"端末シリアル",
          "before.device.serial.placeholder": "端末シリアルのみを入力してください。",
          "after.device.serial.placeholder": "端末シリアルのみを入力してください。",
          "status":"状況",
          "notes.title":"* 重要な注意点 :",
          "notes.1": '交換日は、「最終通信日」、「最終売上日」、「撤去日」、「ポータルから締め・撤去日」のうち、最大値よりも1分以上長い値を指定してください。また、交換の時刻は現在の時刻以下である必要があります。交換日は、現在と次加盟店間の売上取引を切り離す際に使用されます。',
          "notes.2": '「最終通信日」と「最終売上日」の欄には、最新のデータが表示されます。',
          "notes.3": '「最終通信日」、「最終売上日」、「撤去日」、「ポータルから締め・撤去日」以外の次端末に表示されているデータは、すべて現在端末のデータと同じです。',
          "notes.4": '次端末が、既に交換日より後の日付を持つ取引を送信している場合は、自動的に「設置済み」または「稼働中」の状態に移行されます。',
          "error.replacement.date":"交換日は、「最終通信日」、「最終売上日」、「撤去日」、「ポータルから締め・撤去日」のうち、最大値よりも1分以上長い値を指定してください。交換日は、現在加盟店と次加盟店の間で売上取引を分離するために使用されますのでご注意ください。入力を修正して再度お試しください。",
          "error.replacement.date.one.sec":"交換日は、「最終通信日」、「最終販売日」、「削除日」、または「ポータル閉鎖/削除日」の最大値よりも少なくとも1秒長くなければなりません。交換日は、現在の加盟店と次の加盟店との間の売上取引を区切るために使用されることにご注意ください。入力内容を修正して再度お試しください。",
          "error.replacement.date.invalid": "注意: 置換日時は、現在時刻より前でなければなりません。別の日時を入力して再度お試しください。",
          "error.delivery.date":"納品予定日は「交換日」以上である必要があります。別の日時を入力して再度お試しください。",
          "merchant":"加盟店（加盟店コード）",
          "device.owner":"端末所有者（端末所有者コード）",
          "contract.id":"契約先ID",
          "company.id":"会社ID",
          "application.number":"申込通番",
          "branch.code":"支店コード",
          "branch.name":"支店名",
          "installation.store.name": "設置店舗名",
          "vending.machine.type":"自販機機種類",
          "replacement.date": "交換日 *",
          "expected.delivery.date": "納品予定日",
          "removal.date": "撤去日",
          "portalDetached.date": "ポータルから締め・撤去日",
          "last.communication.date": "最終通信日",
          "last.communication.date.star": "最終通信日 *",
          "last.sales.date": "最終売上日",
          "last.sales.date.star": "最終売上日 *",
          "installation.charges":"設置料金",
          "monthly.charges":"月額利用料",
          "monthly.fee":"月額費用",
          "initial.fee":"初期費用",
          "charge.monthly.fee":"月額費用を請求しますか？",
          "charge.initial.fee":"初期費用を請求しますか？",
          "status.title": "入力可能な状態",
          "status.removed": "撤去済み",
          "status.portalDetached": "ポータルから締め・撤去",
          "status.removed.settled": "撤去及び精算済み",
          "status.portalDetached.settled": "ポータルから締め・撤去及び精算済み",
          "status.fresh": "新端末",
          "status.or": "又は",
          "na": "NA"
        },
        "warning.msg.replacementDate":"注意: 置換日時は、現在時刻より前でなければなりません。",
        "confirm.tobe.device": "端末交換？",
        "confirm.title": "注:",
        "confirm.msg": "一度提出された端末シリアルは変更できません。ご確認の上、保存してください。",
        "success.msg": "プロセスは正常に完了しました",
        "provide.serialNumber.msg": "既存の端末と新端末の端末シリアルが同じになることはありません。別の端末シリアルを入力してください。",
        "provide.valid.serialNumber": "有効な端末シリアルを入力してください。",
        "fresh.device.msg":"存在していない端末（新端末）",
        "getData": "表示",
        "now.title": "既存の端末",
        "tobe.title": "新端末（交換後の端末）",
        "apply": "申請",
        "next": "次",
        "submit":"提出",
      },



      "salesSettlements": {
        "notes01":"*フィルター条件を変更した後に結果を表示するには、「表示」ボタンをクリックしてください。",
        "notes02":"*この画面に最新の一件明細が反映されるまでに30分程度かかる場合があります。",
        "monthly": {
          "list": {
            "search": {
              "title": "検索条件",
              "oneItemTitle": "一件明細",
              "organization": "加盟店",
              "deviceOwner":"端末所有者",
              "selectMerchantError":"加盟店を選択してください",
              "organizationPlaceholder": "<加盟店>",
              "granularity": "表示粒度 ",
              "aggregatedSalesBy": "合計基準 ",
              "month": "対象月",
              "date": "対象日",
              "showData": "表示",
              "downloadCsv": "DOWNLOAD CSV",
              "totalMerchants": "加盟店合計",
              "salesOffice": '支店/営業所',
              "deviceSerial": '端末シリアル',
              "applicationSerial": '申込通番',
              "installationLocation": '設置場所',
              "remarks": '備考',
              "remarksOrVmNumber": '備考 or 自販機機番',
              "displayUnit": '表示単位',
              "moneyType": 'マネー種',
              "unitPrice": '単価',
              "option":"オプション",
              "option.unitprice":"単価別集計",
              "productName": '品名',
              "displayData": '表示データ/',
              "addClosingInformation": "締め情報　追加",
              "toggleClosingInformation": "締め情報　有効・無効", 
              "err.msg.required.field": "行{{row}}の{{param}}は必須項目です。",
              "err.msg.wrong.value.entered" : "行{{row}}の{{param}}はドロップダウンからのみ値を持つべきです。",
              "err.msg.wrong.time.entered" : "HH:mm:ss'形式で正しい{{param}}を入力してください。",
              "msg.server.error": "以下のエラー（データが入力されていない、データが重複している、データの形式が間違っているなど）をご確認の上、入力欄の内容を修正してください。",
              "warning.msg.dont.refresh": "注意：ブラウザを更新しないでください（または、キーボードのF5キーを押さないでください）。",
              "btn_cancel": "キャンセル",
              "btn.submit": "確定",
              "downloadExcel": "CSV作成",
              "downloadReports": "レポートダウンロード画面へ",
            },
            "searchResult": {
              "title": "検索結果",
              "previousYear": "Previous Year",
              "previousMonth": "Previous Month",
              "nextYear": "Next Year",
              "nextMonth": "Next Month",
              "display": "Displaying Results from:",
              "branchSalesCenter": "支店・営業所毎",
              "deviceCount": "端末数",
              "deviceSerialNo": "端末シリアル",
              "transportationCard": "交通系",
              "rakutenEdy": "楽天Edy",
              "naNaCo": 'nanaco',
              'waon': 'WAON',
              'id': 'iD',
              'quicPay': 'QUICPay+',
              'linePay': 'Line Pay',
              'weChatPay': 'WeChat Pay',
              'aliPay': 'AliPay',
              'rakutenPay': '楽天Pay',
              'viewDetails': '詳細',
              'noResults': '結果が見つかりませんでした。',
              'dailyDetails': '日別売上詳細',
              'monthlyDetails': '月別売上詳細',
              'details': '一件明細',
              'total': '合計',
              'number': '(件数)',
              'amount': '(金額)'
            },
            "settlement": {
              'settlement': '精算書',
              'settlementMonth': '精算対象月',
              'settlementDepartment': '精算先',
              'search': '照会',
              'merchantName': '加盟店',
              'bankTransferAmount': '振込予定額',
              'bankTransferDate': '振込予定日',
              'invoice': '請求先ID',
              'financialIstitition': '金融機関',
              'branch': '支店',
              'type': '普通/当座',
              'accountNumber': '口座番号',
              'ePaymentAmount': '電子決済取引総額',
              'charges': '手数料',
              'mothlyCharges': '月額利用料',
              'noOfDevices': '端末台数',
              'settlementTiming': '決済端末締め日',
              'brandName': 'ブランド名',
              'noOfPaymentItems': '決済件数',
              'paymentAmount': '決済総額',
              'chargesRate': '手数料率'
            },
            "warning.modal": {
              'message1': 'レポートを作成するために詳細なデータ処理が必要なため処理に時間がかかります。バックヤードでデータ作成しますので「CSV作成」ボタンを押下してください。',
              'message2': '出力レポートは、「レポートダウンロード」画面で確認ができます。',
            },
            "table": {
              'requestDate' : 'リクエスト日',
              'merchantId' : '加盟店ID',
              'branchName': '支店・営業所',
              'date': '年／月',
              'aggregatedSalesBy': '合計基準',
              'granularity': '表示粒度',
              'unitPrice': '単価別集計',
              'status': '状況',
              'completionDate': '完成日',
              'downloadCSV': 'ダウンロード',
              'supplementary.information' : '補足情報',
              'downloadBtn' : 'ダウンロード',
              'sourcePage' : 'レポートタイプ',
              'refresh' : 'リフレッシュ',
              'back' : '売上状況（月別）一覧画面へ',
            },
          },
        },

        "daily": {
          "title": "日別売上状況"
        },
        "deviceSerialNumber": "端末シリアル",
        "after.replacement": "交換後",
        "before.replacement": "交換前",
        "devices.count": "端末数 :",
        "initial.fee":"初期費用 =",
        "monthly.fee": "月額費用 =",
        "replacement": "交換 = ",
        "total.count": "合計 = ",
        "settlementCSVbyBranch":"_精算書_支店別明細",
        "settlementCSVbyDevice":"_精算書_端末別明細",
        "invoiceCSVbyBranch":"_請求書_支店別明細",
        "invoiceCSVbyDevice":"_請求書_端末別明細",
        "closing.date.info":"今月中に撤去された端末の場合、この列には、\n{締め時刻、撤去日、ポータルからの締め・撤去日} \nの中で最新の日付が表示されます。 "
      },

      "settlementsAndInvoices": {
        "invoice.not.settlement.created": "請求書の代わりに決済が作成されます。",
        "settlement.not.invoice.created":"決済の代わりに請求書が作成されます。",
        "list": {
          "title": "精算書/請求書",
          "noData": "結果が見つかりませんでした。",
          "form": {
            "date": "精算対象月",
            "showData": "表示"
          },
          "card": {
            "settlement": {
              "title": "精算書",
              "table": {
                "contractId": "契約先ID",
                "merchantName": "加盟店名",
                "branchName": "支店名",
                "branchCode":"支店コード",
                "expenses": "諸費用",
                "settlementDestination": "精算先",
                "otherFee": "その他費用(課税)",
                "otherFee2": "その他振込(非課税)",
                "remarks": "備考(課税)",
                "remarks2": "備考(非課税)",
                "adjustedAmount" : "調整内容",
                "submit": "確定",
                "revert": "元に戻す",
                "recalculate": "更新",
                "notapplicable":"該当しない",
            "save.invoiceAdjusted":"インボイスは正常に調整されました",
            "revert.invoiceAdjusted":"請求書の調整は正常に元に戻されました。",    
		        "submit.msg": "この操作により、精算書は提出済み状態になります。各加盟店は、提出される精算書を見ることができます。続行しますか？",
		        "revert.msg": "この操作により、精算書は未提出状態になります。各加盟店は、元に戻した後に精算書を見ることができなくなり、再度提出する必要があります。続行しますか？",
		        "recalculate.msg": "この操作は、精算書を再計算して更新します。精算書が更新された後、元に戻すことはできません。この操作を続行してもよろしいですか？",
              },
              "action": {
                "display": "精算書表示",
                "download": "精算書ダウンロード(PDF)"
              },
              "modal":{
                "header":"確認が必要",
                "submit.btn":"提出",
                "confirm":{
                  "msg1":"請求金額",
                  "msg2":"を現在の決済で調整しようとしています。確定する場合はSubmitを、破棄する場合はXを押してください。",
                },
              "revertInvoice":{
                "header":"確認が必要",
                  "submit.btn":"復帰",
                  "confirm":{
                    "msg1":"請求書調整額",
                    "msg2":"を現在の決済に戻します。確定する場合はSubmitを、破棄する場合はXを押してください。"
                  }
             },
            },
            },
            "invoice": {
              "title": "請求書",
              "table": {
                "contractId": "契約先ID",
                "merchantName": "加盟店名",
                "branchName": "支店名",
                "branchCode":"支店コード",
                "expenses": "諸費用",
                "settlementDestination": "精算先",
                "otherFee": "その他費用(課税)",
                "otherFee2": "その他振込(非課税)",
                "remarks": "備考(課税)",
                "remarks2": "備考(非課税)",
                "reason": "理由",
                "submit": "確定",
                "revert": "元に戻す",
                "recalculate": "再計算",
                "paymentMethod": "別途",
                "sendingStatus": "送付状況",
		        "submit.msg": "この操作により、請求書は提出済み状態になります。各加盟店は、提出される請求書を見ることができます。続行しますか？",
		        "revert.msg": "この操作により、請求書は未提出状態になります。各加盟店は、元に戻した後に請求書を見ることができなくなり、再度提出する必要があります。続行しますか？",
		        "recalculate.msg": "この操作は、請求書を再計算して更新します。請求書が更新された後、元に戻すことはできません。この操作を続行してもよろしいですか？",
              },
              "action": {
                "display": "請求書表示",
                "download": "請求書ダウンロード(PDF)",
                "emailInvoice": "メール送信",
              }
            }
          },
        },
        "detail": {
          "title": "精算書/請求書",
          "form": {
            "date": "精算対象月",
            "merchantName": "加盟店名",
            "contractId": "契約先ID",
            "showData": "表示"
          },
          "card": {
            "settlement": {
              "title": "精算書",
              "action": {
                "display": "精算書表示",
                "download": "精算書ダウンロード(PDF)",
                "displayBranch": "支店別明細表示",
                "downloadCSV": "支店別明細ダウンロード(CSV)",
                downloadDetailsByDeviceOwnerByDevice : "所有者別 - 端末別明細ダウンロード"
              },
              "branchDetail": {
                "title": "精算書明細",
                "download": "精算書ダウンロード(PDF)"
              }
            },
            "invoice": {
              "title": "請求書",
              "action": {
                "display": "請求書表示",
                "download": "請求書ダウンロード(PDF)",
                "displayBranch": "支店別明細表示",
                "displayDevice": "端末別明細表示",
                "downloadCSV": "支店別明細ダウンロード(CSV)",
                "downloadByDeviceCSV": "端末別明細ダウンロード(CSV)",
              },
              "branchDetail": {
                "title": "請求書明細",
                "download": "請求書ダウンロード(PDF)"
              },
              "note": {
                "closingDate": "※締めボタンが押され、ご利用合計値がe-MOSS利用料合計値より小さいです。",
                "calenderMonth": "※ご利用合計値がe-MOSS利用料合計値より小さいです。",
              }
            }
          },
        }
      },

      "left.nav": {
        "ParentMenu": {
          "item1": "e-MOSS Plus お申込み",
          "item2": "端末申請",
          "item3": "端末稼働管理",
          "item4": "売上・資金精算",
          "item5": "通知",
          "item6": "サービス管理",
          "item7": "システムマネジメント",
          "item8": "オフィス内サービス",
          "item9": "パートナー",
          "item10": "端末紐付け",
          "item11": "その他",
        },
        "ChildMenu": {
          "item1": "一覧 / 閲覧",
          "item2": "新規 / 編集",
          "item3": "端末申請一覧",
          "item4": "新規端末設置",
          "item5": "端末手配状況",
          "item6": "端末状況一覧/閲覧",
          "item7": "端末詳細閲覧",
          "item8": "売上状況（日別）",
          "item9": "売上状況（月別）",
          "item9.1": "一件明細",
          "item10": "資金精算",
          "item10.1": "精算書・請求書",
          "item11": "請求書",
          "item12": "詳細閲覧",
          "item13": "通知設定",
          "item14": "組織",
          "item15": "ユーザーアカウント",
          "item16": "権限",
          "item17": "端末",
          "item18": "スケジュール",
          "item19": "システム状態監視・閲覧",
          "item20": "端末交換",
          "item21": "部署",
          "item22": "利用ルール",
          "item23": "端末紐付け",
          "item24": "利用詳細",
          "item25": "QRコード管理",
          "item26": "従業員",
          "item27": "端末操作",
          "item28": "端末申請変更",
          "item29": "端末紐付け申請",
          "item30": "在庫端末管理",
          "item31": "レポートダウンロード",
        },

        "ChildSubMenu": {
          "item1": "一覧・閲覧",
          "item2": "1レコード確認",
          "item3": "精算書の閲覧",
          "item4": "新規作成 / 編集",
          "item5": "新規作成 / 編集",
          "item6": "パスワードの生成・リセット・変更",
          "item7": "端末情報の編集/閲覧",
          "item8": "パスワード管理",
          "item9": "端末毎",
          "item10": "従業員毎",
          "item11":"作成",
          "item12": "月別・日別表示",
          "item13": "一件明細",
          "item14": "更新",
          "item15": "アカウント管理",
          "item16": "送信履歴",
          "item17": "新規登録する",
          "item18": "締め情報　追加",
          "item19": "締め情報　有効・無効",
        }
      },

      "device.request": {
        "history": {
          "suspend.title":"休止中・再開履歴",
          "suspend.note": '注意：最新の履歴が上段に表示され、はい/いいえに基づいて「初期費用」と「月額費用」が計算されます。',
          "msg": "ここをクリックして交換履歴をご確認ください。",
          "title":"端末交換履歴",
          "deviceSerialNumber": "端末シリアル",
          "operation.start.date": "稼働開始日",
          "removal.date": "撤去日",
          "replacement.date": "交換日",
          "merchant.id": "契約先ID",
          "contract.id":"契約先ID",
          "status": "状況",
          "fromDateTime": "開始日",
          "toDateTime": "終了日",
          "branchName": "支店名",
          "branchCode": "支店コード",
          "charge.monthly.fee":"月額費用を請求しますか？",
          "charge.initial.fee":"初期費用を請求しますか？",
          "yes": "はい",
          "no": "いいえ"
        },
        "create": {
          "title": "新規端末申請",
          "btn_create": "作成",
          "btn_cancel": "キャンセル",
          "sc.id.missing": "契約先IDを入力してください。"
        },
        "confirm.title": "注:",
        "list": {
          "service.contract.id": "契約先ID",
          "partner": "パートナー",
          "partner.table.column": "P",
          "merchant.name": "加盟店",
          "device.application.number": "申込通番",
          "date.of.application": "申込年月日",
          "device.productName": "品名",
          "device.serial": "端末シリアル",
          "device.serial.tooltip": "カンマ又は空白スペース区切り、最大200半角英数字。",
          "device.owner": "端末所有者",
          "desired.delivery.date": "設置希望日",
          "expected.delivery.date": "納品(予定)日",
          "jesca.application": "JESCA申請",
          "jesca.application.date": "JESCA申請日",
          "jesca.reflection.date": "JESCA反映日",
          "ins.store.name": "設置店舗名",
          "inv.branch.name": "請求先支店名",
          "status": "状況",
          "view": "表示",
          "device": "手配状況",
          "version": "ファイルフォーマット",
          "upload.device.progress": "端末手配状況アップロード",
          "upload.device": "端末申請アップロード",
          "upload.device.changes": "端末申請変更アップロード",
          "upload.device.jesca": "JESCA端末申請アップロード",
          "edit.device.progress": "端末手配状況編集",
          "edit.device.changes":"端末申請変更編集",
          "edit.device": "端末申請編集",
          "download.shipment.template": "端末手配状況ダウンロード",
          "download.jmups.excel": "JMups エクセルをダウンロード",
          "download.jmups.excel.confirm.msg1": "下記選択された端末申請のサービス契約には、加盟店番号が含まれていません。",
          "download.jmups.excel.confirm.msg2": "そのため、加盟店番号は空欄としてダウンロードされます。続けますか？",
          "download.shipment.tms.excel.btn": "出荷先情報CSVダウンロード",
          "download.request.tms.excel.btn": "設置先情報CSVダウンロード",
          "download.device.request.excel.btn": "e-MOSSplus端末申請書ダウンロード",
          "msg.confirm.cancel": "端末申請をキャンセルしますが、よろしいですか？",
          "msg.confirm.delete": "端末申請を削除しますが、よろしいですか？",
          "msg.success.cancel": "端末申請を成功にキャンセルしました。",
          "msg.success.delete": "端末申請を成功に削除しました。",
          "msg.error": "情報をサブミットする時、エラーが発生しました。",
          "btn.cancel": "取消",
          "btn.delete": "削除",
          "last.modified": "最終更新日時",
          "supplementary.information":"補足情報",
          "created.by":"作成者：",
          "filter.by.status":"状況で絞る",
          "btn.show.data":"表示",
          "btn.clear":"クリア",
          "terminal.remove":"端末を撤去",
          "detach.suspend.dropdown.btn": "ポータルから撤去・休止",
          "detach.terminal.btn":"ポータルから端末を撤去",
          "detach.terminal.title":"ポータルから端末を撤去",
          "detach.terminal.point1":"「締め・撤去日を入力」は、①「撤去日 (31/32)」と今月末日の間の日時が入力できます。②「撤去日 (31/32)」が該当データなしの場合、「最終通信日」と今月末日の間の日時が入力できます。<br>③「最終通信日」が該当なしの場合は「稼働開始日」から、④「稼働開始日」が該当なしの場合は「設置日」から、⑤「設置日」が該当なしの場合は今月1日から、今月末日の間の日時が入力できます。",
          "detach.terminal.point2":"「締め・撤去」された後は、元の状態に戻すことができません。",
          "detach.terminal.point3":"「締め・撤去日を入力」が過去月の精算期間にある場合（精算書・請求書がすでに発行されている場合）、精算書・請求書を「更新」・「再計算」してください。<br> \n 「更新」・「再計算」操作または「次のバッチ実行日」に実行された精算バッチのいずれかによって「ポータルから締め・撤去及び精算済み」状態に移行します。",
          "detach.terminal.point4":"「今月の最終日」まで変更できます。「今月の最終日」が過ぎると変更できません。",

          "terminal.remove.confirm.msg":"端末は数分で「締め・撤去」された状態に移行します。<br>「締め・撤去」された後は、元の状態に戻すことができません。",
          "show.replacement.devices": "交換端末表示",
          "reservation.date.time": "更新実行予定日時での検索",
        },
        "detail": {
          "title.detail": "詳細",
          "title.device.detail": "詳細",
          "btn_update": "登録"
        },
        "edit": {
          "err.msg.cannot.allow.state.transition": "申請ID:{{id}}の端末申請状況は、行{{row}}で{{from}}から{{to}}に更新することはできません。",

          "err.msg.required.field": "行{{row}}の{{param}}は必須項目です。",
          "err.msg.date.or.non.empty.field": "行{{row}}の{{param}}には、YYYY年MM月DD日のみの有効な形式の日付を含める必要があります。",
          "err.msg.empty.field.with.width.n.or.empty": "行{{row}}の{{param}}には、最大{{n}}文字の入力が必要です。",
          "err.msg.non.alphanumeric": "行{{row}}の{{param}}は形式が正しくありません。 英字と数字のみの組合わせを含める必要があります。",
          "err.msg.non.space.alphanumeric": "行{{row}}の{{param}}は形式が正しくありません。アルファベット、スペース、数字のみの組み合わせで構成されている必要があります。",
          "err.msg.numeric.field": "行{{row}}の{{param}}は形式が正しくありません。 数字だけが入っていること",
          "err.msg.stringLengthFullHalf": "行{{row}}の{{param}}には、最大で{{n}}バイトの入力が必要です。",
          "err.msg.numericOneToFive.field": "行{{row}}の{{param}}は形式が正しくありません。 1から5までの数字のみが含まれている必要があります。",
          "err.msg.numericZeroToOne.field": "行{{row}}の{{param}}は形式が正しくありません。 0から1までの数字のみが含まれている必要があります。",
          "err.msg.numericOneToTwo.field": "行{{row}}の{{param}}は形式が正しくありません。 1から2までの数字だけが含まれている必要があります。",
          "err.msg.numericOneToThree.field": "行{{row}}の{{param}}は形式が正しくありません。 1から3までの数字だけが含まれている必要があります。",
          "err.msg.fullwidth.field": "行{{row}}の{{param}}には、全角数字で入力が必要です。",
          "err.msg.halfwidth.field": "行{{row}}の{{parameter}}には、半角数字または半角カタカナで入力が必要です。",
          "err.msg.phone.invalid": "行{{row}}の{{param}}には、有効な電話番号が必要です。",
          "err.msg.email.invalid": "行{{row}}の{{param}}には、有効なメールアドレスが必要です。",
          "err.msg.zip.code.invalid": "行{{row}}の{{Param}}には、有効な郵便番号が必要です。",

          "err.msg.numeric.or.empty.field": "行{{row}}の{{param}}には数字のみを含めるか、空のままにしてください。",
          "err.msg.numeric.or.non.empty.field": "行{{row}}の{{param}}には、数字で入力が必要です。",
          "err.msg.numeric.or.non.empty.field.with.width.6": "行{{row}}の{{param}}には、最大６桁の数字で入力が必要です。",
          "err.msg.branch.code": "行{{row}}の{{param}}が空であるか、正しい形式ではありません。６文字までの英字、数字、または両方の組合せを含める必要があります。",
          "err.msg.date.or.empty.field": "行{{row}}の{{param}}には、YYYY年MM月DD日のみの有効な形式の日付を含めるか、空のままにしてください。",
          "err.msg.date.remove.device": "行{{row}}の{{param}}は無効です。有効な日付を yyyy/MM/dd hh:mm:ss の形式で入力してください。",
          "err.msg.device.serial": "行{{row}}の{{param}}の形式が正しくありません。英字、数字、「 - 」および「_ 」の任意の組合せを入力できます。入力を修正してやり直してください。",
          "err.msg.device.owner": "行{{row}}の{{param}}は無効です。ドロップダウンオプションから選択してください。",
          "err.msg.empty.field.with.width.n.and.non.empty": "行{{row}}の{{param}}が空であるか、{{n}}文字を超えています。",
          "err.msg.format.invalid": "行{{row}}の{{param}}の形式が正しくありません。",
          "warning.msg.dont.refresh": "注意：ブラウザを更新しないでください（または、キーボードのF5キーを押さないでください）。",
          "btn.save.as.draft": "一時保存",
          "btn.submit": "申請",
          "btn.cancel": "キャンセル",
          "running.state.edit.message": "設置済みまたは実行中の状態にある端末申請を編集すると、すぐに売上・資金精算と端末稼働管理に影響する場合があります。また、過去の精算書・請求書を「再計算」されると、将来の精算書・請求書に影響を与える可能性があります。<span class='text-danger-imp'>端末が最近の30分に設置された場合、こちらの変更は、その端末の売上・資金精算と端末稼働管理に影響します。</span>継続してよろしいですか？"
        },
        "suspend": {
          "confirm.msg": '<div>選択された端末の新規休止中・再開状況を申請します。 </div>  <div class="m-t-10">以下の点にご注意ください。 </div> <div> <ol>  <li>一度休止中・再開状況を申請されたら、キャンセルや元に戻すことはできません。 </li>  <li>休止中・再開申請の処理には、最大1時間かかる場合があります。同じ端末に対する新しい休止中/再開申請は、前の申請が正常に処理された後にのみ適用することができます。 </li>  <li> 一度「休止処理中」または「休止中」状態に移行した端末は、新規取引が到着しても自動的に「設置済み」または「稼働中」状態には移行されません。「設置済み」または「稼働中」状態に移動させるためには、「再開」状況の申請をしてください。 </li> </ol> </div> <div> 確認ボタンをクリックしてお進みください。 </div> ',
          "btn": "ポータルから休止・再開",
          "err.msg.required.field": '行{{row}}の{{param}}が無効なので、「操作」ドロップダウンを選択してこの値を入力してください。',
          "err.msg.invalid.date":"入力された「適用日時」が無効です。本日(日本時間の0000)から当月を除いた6ヶ月後までの将来の日時を入力して、再度お試しください。",
          "err.msg.invalid.status":"端末[{{deviceSerial}},{{applicationNumber}}]の場合、端末が{{nowStatus}}の状態になっているため、{{operation}}操作を選択することができません。代わりに{{validOperation}}操作を選択して進めてください。",
          "title": "ポータルから端末を休止・再開",
          "terminal.point1": '一度登録された「休止処理中」の申請はキャンセルできませんのでご注意ください。端末を再度使用する場合は、「休止中」した後に「再開」する必要があります。現在、休止中・再開の申請をキャンセルすることができませんので、休止中・再開を申請する前に必ずご確認ください。',
          "terminal.point2": '「適用日時」は、本日(日本時間の0000から)か将来の日時に設定できます。将来の「稼働開始日」は、当月を除く6ヶ月目の月末まで設定できます。',
          "terminal.point3": '次の状態が「端末申請」と「端末管理」ページで表示されるまでに1時間程度かかる場合があります。次の状態が表示されるまでは、「休止中・再開端末」ページで同じ端末を次の状態に移動することはできません。',
          "terminal.point4": '一度「休止処理中」や「休止中」に移行した端末は、（端末から取引が到着しても）自動的に「設置済み」や「稼働中」の状態には戻りません。一度「休止処理中」や「休止中」に移行した端末は、（端末から取引が到着しても）自動的に「設置済み」や「稼働中」の状態には戻りません。ただし、売上状況（月別）、売上状況（日別）、「一件明細」ページには、最新の取引が表示されます。また、「最終通信日」「最終売上日」には、最新の取引日が表示されます。'
        },
        "jesca":{
          "edit.title":"JESCA申請編集",
          "upload.excel":"JESCA端末申請(準備中)",
          "upload.csv":"JESCA申請書アップロード",
          "download":"JESCA申請書ダウンロード",
          "download.result":"JESCA申請結果ダウンロード",
          "download.activation.csv":"アクティベート情報CSVダウンロード",
          "apply":"申請",
          "apply.title":"申請内容の確認 ",
          "apply.message":"変更内容を保存して、JESCAへ申請します。",
          "apply.btn.text":"申請",
          "reset.btn.text":"リセット",
          "reset.title":"リセットの確認",
          "reset.message":"申請書をリセットします。",
        },
        "change":{
          "upload.excel":"端末申請変更アップロード",
          "edit.title":"端末申請変更編集",
          "receipt.number":"受付番号",
          "item.name":"項目名",
          "serial.number":"通番",
          "service.contractId":"契約先ID",
          "device.merchant":"加盟店",
          "device.owner":"端末所有者",
          "device.application.number":"申込通番",
          "device.serial":"端末シリアル",
          "installation.store.name":"設置先店舗名",
          "reservation.date.time":"更新予約日時",
          "status":"状況",
          "btn.reserve":"変更予約",
          "btn.download":"ダウンロード",
          "btn.save":"保存",
          "btn.cancel":"キャンセル",
          "btn.cancelApplication":"申し込みの取り消し",
      },
      "reserve.modal":{
        "immediate":"即時",
        "today":"当日",
        "month.end":"当月末",
        "start.next.month":"翌月初",
        "specify.date.time":"日時指定",
        "cancel.reservation":"予約取り消し",
        "title":"変更予約",
        "title2":"予約変更",
        "message1":"以下の端末は既に決済（起動）が行われています。",
        "message2":"即時に実行します。よろしいですか。",
        "btnText":"実行",
      },
      "upload.error.modal":{
        "message1":"決済（起動）が既に行われている端末と未決済（未起動）の端末が混在しているため別々で予約を行ってください",
        "message2":"決済（起動）が既に行われている端末",
        "btnText":"OK",
      }
    },

    "device.linking":{
      "modal.msg":{
        "title":"申込キャンセルの確認",
        "message":"本当にキャンセルしますか？",
        "btn.text":"はい"
      }
    },

      "jmups.mapping":{
         "title":"J-Mups エリア・事業者マッピング",
         "money.type":"電子マネー種類",
         "area":"エリア",
         "area.specific":"特定エリア",
         "current.operator":"現在の事業者",
         "change.operator":"変更後の事業者",
         "save":"保存",
         "inuse.money.operator":"使用中の事業者のみ表示",
         "confirm":"J-Mupsエリア・事業者マッピングを更新しますか。継続する場合、J-Mups申請書へ影響する可能があります。"
      },

      "iosl":{
        "office.attributes":"オフィス属性",
        "service.type":"サービスタイプ",
        "service.sub.type":"サービスサブタイプ",
        "related.merchants":"関連加盟店",
        "merchant.name":"加盟店",
        "merchant.code":"加盟店コード",
        "warning.msg":"加盟店はすでに追加されています。",
        "last.modified":"最終更新日",
        "msg.server.error": "以下のエラー（データが入力されていない、データが重複している、データの形式が間違っているなど）をご確認の上、入力欄の内容を修正してください。",
        "empty.excel.file.msg": "アップロードされたエクセルファイルが空です。ご確認の上、再度お試しください。",
        "department": {
          "create.update.view.on.page.title": "部署の作成",
          "upload.info":"部署/従業員情報アップロード",
          "err.msg.required.field": "行{{row}}の{{param}}は必須項目です。",
          "err.msg.valid.required.field":"行{{row}}内の{{param}}は、特殊文字を含んではいけません。",
          "msg.delete.status": "正常に削除されました。",
          "employee": "従業員",
          "office.id": "オフィスID",
          "id":"部署ID",
          "office.name":"オフィス名",
          "name": "部署名",
          "remarks": "部署備考",
          "operation": "操作",
          "edit":"部署情報の編集",
          "upload":"部署/従業員情報アップロード",
          "download":"部署情報ダウンロード",
          "delete":"削除",
          "delete.msg":"削除してもよろしいですか？",
          "submit":"申請"
        },
        "employee": {
          "create.update.view.on.page.title": "従業員の作成",
          "select.office.name.msg": "部署名を選択する前に、オフィス名を選択する必要があります。",
          "expiration.date.msg": "有効期限は開始日よりもあとでなければなりません。別の日付を入力して、もう一度試してみてください。",
          "upload.info":"部署/従業員情報アップロード",
          "msg.delete.status": "正常に削除されました。",
          "office.id": "オフィスID",
          "office.name": "オフィス名",
          "department":"部署名",
          "department.id":"部署ID",
          "department.name":"部署名",
          "department.remarks":"部署備考",
          "id":"従業員ID",
          "name": "従業員名",
          "expiryDate":"有効期限",
          "startDate":"開始日",
          "enabled":"有効済み",
          "issueCount":"発行回数",
          "remarks": "従業員備考",
          "operation": "操作",
          "edit":"従業員情報の編集",
          "upload":"部署/従業員情報アップロード",
          "download":"従業員情報ダウンロード",
          "delete":"削除",
          "delete.msg":"削除してもよろしいですか？",
          "submit":"申請",
          "qrcode.download": "従業員QRコードダウンロード",
          "qrcode.info": "従業員QRコード情報",
          "qrcode.detail.msg": "QRコード詳細はこちら",
          "qrcode.data" :"QRコードデータ",
          "qrcode" :"QRコード",
          "setting.value":"設定値",
          "remainder.from.result":"実績からの残り",
          "feliCaIdm":"カード番号(IDM)",
        },
        "usage.rules":{
          "create":"利用ルールの作成",
          "upload":"利用ルール情報アップロード",
          "edit":"利用ルール変更",
          "download":"利用ルール情報 ダウンロード",
          "one.time.amount":"一回金額",
          "total.number.per.day":"累積回数/日",
          "total.number.per.month":"累積回数/月",
          "cumulated.amount.per.day":"累積金額/日",
          "cumulated.amount.per.month":"累積金額/月",
          "cumulated.numberoftimes.allowed":"累積回数",
          "cumulated.amount":"累積金額",
          "column.code":"コラム番号",
          "time.slot.available":"時間範囲",
          "week.days.allowed":"曜日",
          "cumulative.no.of.times.per.week.allowed":"累積回数/週",
          "cumulative.amount.per.week.allowed":"累積金額/週",
          "not.empty.error.msg": "すべてのルールを空にすることができません。最低1つのルールを入力する必要があります。ご確認の上、再度お試しください。"
        },
        "device.linkage":{
            "create":"端末紐付けの作成",
            "edit":"端末紐付け情報編集",
            "upload":"端末紐付け情報アップロード",
            "download":"端末紐付け情報ダウンロード",
            "application.number":"申込通番",
            "merchant":"加盟店",
            "device.owner":"端末所有者 ",
            "device.serial":"端末シリアル",
            "installation.location":"設置場所",
            "installation.store.name": "設置店舗名",
            "linking.date":"紐付け実施日",
            "customer.control.number":"お客様管理番号",
        },
        "usage.details": {
          "display.granularity": "表示粒度",
          "target.month":"対象月",
          "target.day":"対象日",
          "time.period":"期間",
          "daily":"日毎",
          "remark": "備考",
          "office":"オフィス",
          "department":"部署",
          "total.usage":"利用合計",
          "operator":"オペレータ",
          "operatorId":"オペレータ ID",
          "device.serial":"端末シリアル",
          "installation.location":"設置場所",
          "installation.store.name": "設置店舗名",
          "employee":"従業員",
          "settlement.time":"決済時刻",
          "settlement.amount":"決済金額",
          "processing.result":"処理結果",
          "error.id":"エラー",
          "column.id":"コラムID"
        },
        "transmission.history":{
          "device.number":"端末番号",
          "transmission.received.date":"受信日時",
          "sequence.number":"シーケンス番号",
          "transmission.type":"通信種別",
          "number.of.retry":"リトライ回数",
          "processing.result":"処理結果",
          "error.code":"エラーコード",
          "error.result":"エラー結果",
          "delete":"削除",
          "error.type":"エラー種類",
          "duration":"期間",
          "update":"更新情報",
        },
        "account.management":{
          "register.new":"新規登録はこちら",
          "office.id":"オフィスID",
          "auth.id":"認証ID",
          "auth.id.name":"認証ID名",
          "new.password":"新しいパスワード",
          "password":"パスワード",
          "delete":"削除",
          "delete.msg":"削除してもよろしいですか？",
          "msg.delete.status":"アカウントは正常に削除されました。",
          "enable":"有効",
          "disable":"無効",
          "msg.enable":"本当にこのアカウントを有効にしますか？",
          "msg.enable.status":"アカウントの状態: 有効",
          "msg.disable":"本当にこのアカウントを無効にしますか？",
          "msg.disable.status":"アカウントの状態: 無効",
        }
      },

      "other":{
        "header":'飲料自販機向け検量サービスにアクセス',
        "link":'ここをクリックしてください',
      }

    });
    var lang = 'jp';
    try {
      lang = JSON.parse(window.localStorage.getItem('cov.lang'));
    } catch (err) { }
    if (lang != 'en' && lang != 'jp') {
      lang = 'jp';
    }
    $translateProvider.preferredLanguage(lang);


    $urlRouterProvider.otherwise(function($injector, $location, toState) {
        var state = $injector.get('$state');
        var absUrl = $location.absUrl();
        var str = absUrl.split('#');
        if(str[1] != null && str[1].length > 1)
            return '/main/404';


        return '/main/dashboard';
    });

    // baSidebarServiceProvider.addStaticItem({
    //   title: '端末申請',
    //   icon: 'fa fa-file-text',
    //   subMenu: [{
    //     title: '申請一覧',
    //     icon: 'fa fa-list',
    //   }, {
    //     title: '新規申請',
    //     icon: 'ion-add',
    //   }]
    // });

    /*
   try {
     var pp = JSON.parse(window.localStorage.getItem('cov.loginResponse'));
       console.log(pp.permissionsMap);
       console.log('gggggggg');
   } catch(err) {
       console.log(err);
   }
   */

    /*baSidebarServiceProvider.addStaticItem({
      title: 'left.nav.ParentMenu.item3',
      icon: 'fa fa-edit',
      subMenu: [{
        title: 'left.nav.ChildMenu.item6',
        url:'/main/page/comingSoon',
        icon: 'ion-document',
      }, {
        title: 'left.nav.ChildMenu.item7',
        url:'/main/page/comingSoon',
        icon: 'fa-list',
      }]
    });
*/

    /*
        baSidebarServiceProvider.addStaticItem({
          title: 'left.nav.ParentMenu.item4',
          icon: 'fa fa-money',
          subMenu: [{
            title: 'left.nav.ChildMenu.item8',
            url:'/main/page/comingSoon',
            icon: 'ion-document',
              subMenu:[{
                  title:'left.nav.ChildSubMenu.item1',
                  url:'/main/page/comingSoon',
                  icon: 'ion-document',
              },
            {
              title:'left.nav.ChildSubMenu.item2',
              url:'/main/page/comingSoon',
              icon: 'ion-document',
            }]

          },
          {
            title: 'left.nav.ChildMenu.item9',
            url:'/main/sales/monthly',
            icon: 'ion-document',
              subMenu:[{
                  title:'left.nav.ChildSubMenu.item1',
                  url:'/main/sales/monthly/list',
                  icon: 'ion-document',
              },
            {
              title:'left.nav.ChildSubMenu.item2',
              url:'/main/page/comingSoon',
              icon: 'ion-document',
            }],

          },

          {
            title: 'left.nav.ChildMenu.item10',
            url:'/main/page/comingSoon',
            icon: 'ion-document',
              subMenu:[{
                  title:'left.nav.ChildSubMenu.item1',
                  url:'/main/page/comingSoon',
                  icon: 'ion-document',
              },
            {
              title:'left.nav.ChildSubMenu.item3',
              url:'/main/page/comingSoon',
              icon: 'ion-document',
            }],

          },
          {
            title: 'left.nav.ChildMenu.item11',
            url:'/main/page/comingSoon',
            icon: 'ion-document',
              subMenu:[{
                  title:'left.nav.ChildSubMenu.item1',
                  url:'/main/page/comingSoon',
                  icon: 'ion-document',
              },
            {
              title:'left.nav.ChildSubMenu.item4',
              url:'/main/page/comingSoon',
              icon: 'ion-document',
            }],

          }
        ]
        });


        baSidebarServiceProvider.addStaticItem({
          title: 'left.nav.ParentMenu.item5',
          icon: 'fa fa-bell',
          subMenu: [{
            title: 'left.nav.ChildMenu.item1',
            icon: 'ion-document',
          }, {
            title: 'left.nav.ChildMenu.item12',
            icon: 'fa-list',
          }, {
            title: 'left.nav.ChildMenu.item13',
            icon: 'ion-document',
          }]
        });*/
    /*
        baSidebarServiceProvider.addStaticItem({
          title: 'left.nav.ParentMenu.item6',
          icon: 'fa fa-edit',
          subMenu: [{
            title: 'left.nav.ChildMenu.item14',
            url:'/main/page/comingSoon',
            icon: 'ion-document',
              subMenu:[{
                  title:'left.nav.ChildSubMenu.item1',
                  url:'/main/page/comingSoon',
                  icon: 'ion-document',
              },
            {
              title:'left.nav.ChildSubMenu.item5',
              url:'/main/page/comingSoon',
              icon: 'ion-document',
            }]

          },
          {
            title: 'left.nav.ChildMenu.item15',
            url:'/main/page/comingSoon',
            icon: 'ion-document',
              subMenu:[{
                  title:'left.nav.ChildSubMenu.item1',
                  url:'/main/page/comingSoon',
                  icon: 'ion-document',
              },
            {
              title:'left.nav.ChildSubMenu.item5',
              url:'/main/page/comingSoon',
              icon: 'ion-document',
            },
            {
              title:'left.nav.ChildSubMenu.item6',
              url:'/main/page/comingSoon',
              icon: 'ion-document',
            }],

          },

          {
            title: 'left.nav.ChildMenu.item16',
            url:'/main/page/comingSoon',
            icon: 'ion-document',
          },
          {
            title: 'left.nav.ChildMenu.item17',
            url:'/main/page/comingSoon',
            icon: 'ion-document',
              subMenu:[{
                  title:'left.nav.ChildSubMenu.item1',
                  url:'/main/page/comingSoon',
                  icon: 'ion-document',
              },
            {
              title:'left.nav.ChildSubMenu.item7',
              url:'/main/page/comingSoon',
              icon: 'ion-document',
            }],

          }
        ]
        });

        */
    /*
  baSidebarServiceProvider.addStaticItem({
    title: 'left.nav.ParentMenu.item7',
    icon: 'fa fa-wrench',
    subMenu: [{
      title: 'left.nav.ChildMenu.item18',
      icon: 'ion-document',
    }, {
      title: 'left.nav.ChildMenu.item19',
      icon: 'fa-list',
    }]
  });*/

  }

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'JPTC.theme.components',
      'JPTC.theme.inputs'
  ]);

})();

(function() {
    'use strict';

    angular.module('JPTC.pages.application', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        // $stateProvider
        //     .state('main.application', {
        //         url: '/application',
        //         template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        //         abstract: true,
        //         title: 'Application',
        //         sidebarMeta: {
        //             icon: 'ion-compose',
        //             order: 250,
        //         },
        //         authenticate: true
        //     })
        //     .state('main.application.info', {
        //         url: '/info',
        //         templateUrl: 'app/pages/application/views/info.html',
        //         controller: 'ApplicationInfoCtrl',
        //         controllerAs: 'vm',
        //         title: 'Application',
        //         sidebarMeta: {
        //             order: 0,
        //         },
        //         resolve: {
        //         },
        //         authenticate: true
        //     })
    }

})();
(function() {
  'use strict';

  angular.module('JPTC.pages.authSignIn', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignIn', {
        url: '/authSignIn',
        templateUrl: 'app/pages/authSignIn/authSignIn.html',
        title: 'Login',
        controller: 'authSignInCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
(function() {
  'use strict';

  angular.module('JPTC.pages.authSignUp', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignUp', {
        url: '/authSignUp',
        templateUrl: 'app/pages/authSignUp/authSignUp.html',
        title: 'My Page',
        controller: 'authSignUpCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.charts', [
      'JPTC.pages.charts.amCharts',
      'JPTC.pages.charts.chartJs',
      'JPTC.pages.charts.chartist',
      'JPTC.pages.charts.morris'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts', {
        url: '/charts',
        abstract: true,
        template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
        title: 'Charts',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 150,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
  
    angular.module('JPTC.pages.comingSoon', ['ui.select', 'ngSanitize'])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
        
      $stateProvider
      .state('main.comingSoon', {
        url: '/page',
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'サービス契約',
        authenticate: true
    })
        .state('main.comingSoon.coming', {
          url: '/comingSoon',
          templateUrl: 'app/pages/comingSoon/comingSoon.html',
          title: '近日公開',                   
          authenticate: true
        });
    }
  
  })();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.components', [
      'JPTC.pages.components.mail',
      'JPTC.pages.components.timeline',
      'JPTC.pages.components.tree',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components', {
        url: '/components',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Components',
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 100,
        },
        authenticate: true
      });
  }

})();
(function() {
  'use strict';

  angular.module('JPTC.pages.config', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
(function() {
    'use strict';

    angular.module('JPTC.pages.contract', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.contract', {
                url: '/contract',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: '契約状況',
                sidebarMeta: {
                    icon: 'ion-compose',
                    order: 250,
                },
                authenticate: true
            })
            .state('main.contract.devicePurchase', {
                url: '/dp',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: '端末売買契約',
                sidebarMeta: {
                    order: 200,
                },
                authenticate: true
            })
            .state('main.contract.devicePurchase.list', {
                url: '/list',
                templateUrl: 'app/pages/contract/devicePurchase/list.html',
                controller: 'ListDevicePurchaseCtrl',
                controllerAs: 'vm',
                title: '契約閲覧・修正',
                sidebarMeta: {
                    order: 0,
                },
                resolve: {
                    dpListPromise: function (ContractService) {
                        return ContractService.search();
                    }
                },
                authenticate: true
            })
            .state('main.contract.devicePurchase.new', {
                url: '/new',
                templateUrl: 'app/pages/contract/devicePurchase/new.html',
                controller: 'NewDevicePurchaseCtrl',
                controllerAs: 'vm',
                title: '新規契約登録',
                sidebarMeta: {
                    order: 0,
                },
                authenticate: true
            })

            // .state('main.contract.service', {
            //     url: '/service',
            //     template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
            //     abstract: true,
            //     title: 'サービス契約',
            //     sidebarMeta: {
            //         order: 200,
            //     },
            //     authenticate: true
            // });
        // .state('form.layouts', {
        //     url: '/layouts',
        //     templateUrl: 'app/pages/form/layouts/layouts.html',
        //     title: 'Form Layouts',
        //     sidebarMeta: {
        //         order: 100,
        //     },
        // })
        // .state('form.wizard',
        //     {
        //         url: '/wizard',
        //         templateUrl: 'app/pages/form/wizard/wizard.html',
        //         controller: 'WizardCtrl',
        //         controllerAs: 'vm',
        //         title: 'Form Wizard',
        //         sidebarMeta: {
        //             order: 200,
        //         },
        //     });
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        title: 'ホーム',
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0,
        },
        authenticate: true
      });
  }

})();
(function() {
    'use strict';

    angular.module('JPTC.pages.deviceLinkage', ['ui.select', 'ngSanitize', 'JPTC.pages.form'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.deviceLinkage', {
                url: '/device-linkage',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ParentMenu.item10',
                sidebarMeta: {
                    icon: 'fa fa-tasks',
                    order: 250,
                    permission: {
                        DEVICE_LINKING: ['READ']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_LINKING','READ');
                    },
                },
                authenticate: true
            })
            .state('main.deviceLinkage.list', {
                url: '/list/:query',
                templateUrl: 'app/pages/device-linkage/views/device-linkage.html',
                controller: 'DeviceLinkageCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item29',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        ADL_DEVICE_LINKING: ['READ']
                    }
                },
                resolve: {
                        hasPermission: function(AuthService) {
                            return AuthService.hasPermission('ADL_DEVICE_LINKING','WRITE');
                        },
                        types: function (ServiceContractService) {
                            return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                        },
                        deviceOwnerIds : function (DeviceLinkageService){
                            return DeviceLinkageService.getAllDeviceOwners();
                        }
                },
                authenticate: true
            })
            .state('main.deviceLinkage.inventoryManagement', {
                url: '/inventoryManagement',
                templateUrl: 'app/pages/device-linkage/views/inventory-device-management.html',
                controller: 'InventoryManagementCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item30',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        IDM_DEVICE_LINKING: ['READ']
                    }
                },
                resolve: {
                        hasPermission: function(AuthService) {
                            return AuthService.hasPermission('IDM_DEVICE_LINKING','READ');
                        },
                        types: function (ServiceContractService) {
                            return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                        },
                        requests: function (DeviceLinkageService, localStorageService) {
                            var pageSize = localStorageService.get('pageSize');
                            return DeviceLinkageService.getAllInventoryDeviceManagement({
                                pageSize: pageSize.DEVICE_INSTALLATION.defaultValue
                            });
                        },
                        filterOptions: function (DeviceRequestService) {
                            return DeviceRequestService.getDeviceInstallationFilterOptions();
                        }
                },
                authenticate: true
            })
            .state('main.deviceLinkage.editDeviceApplicationChange', {
                url: '/edit-application-change',
                templateUrl: 'app/pages/device-linkage/views/edit-device-application-change.html',
                controller: 'EditDeviceApplicationChangeCtrl',
                controllerAs: 'vm',
                title: 'device.request.list.upload.device',
                params : { deviceRequest: null, isJescaUpload: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('IDM_DEVICE_LINKING','WRITE');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    }
                },
                authenticate: true
            });

    }

})();
(function() {
    'use strict';

    angular.module('JPTC.pages.deviceManagement', ['ui.select', 'ngSanitize'])
        .constant('DEFAULT_DEVICE_RUNNING_STATUS_KEYS', [
            'INVENTORY',
            'DELIVERED',
            'INSTALLED',
            'RUNNING',
            'PROCESSING_SUSPENSION',
            'SUSPENDED',
            'PROCESSING_CANCELLATION',
            'REMOVED'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, DEFAULT_DEVICE_RUNNING_STATUS_KEYS) {
        $stateProvider
            .state('main.deviceManagement', {
                url: '/device-management',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ParentMenu.item3',
                sidebarMeta: {
                    icon: 'fa fa-tablet',
                    order: 250,
                    permission: {
                        DEVICE_MGMT: ['STATUS']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_MGMT', 'STATUS');
                    },
                },
                authenticate: true
            })
            .state('main.deviceManagement.list', {
                url: '/list/:query',
                templateUrl: 'app/pages/device-management/views/list-deviceManagement.html',
                controller: 'DeviceManagementListCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item6',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        DEVICE_MGMT: ['STATUS']
                    }
                }, 
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_MGMT', 'STATUS');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('PAYMENT');
                    },
                    filterOptions: function (DeviceManagementService) {
                        return DeviceManagementService.getDeviceManagementFilterOptions({});
                    },
                    deviceList: function (DeviceManagementService, localStorageService) {
                        var pageSize = localStorageService.get('pageSize');
                        return DeviceManagementService.fetchDeviceMonitoringRecords({
                            runningStatuses: DEFAULT_DEVICE_RUNNING_STATUS_KEYS,
                            pageSize: pageSize.DEVICE_MANAGEMENT.defaultValue
                        });
                    },
                },
                authenticate: true
            })
            .state('main.deviceManagement.details', {
                url: '/device-details',
                templateUrl: 'app/pages/comingSoon/comingSoon.html',
                /* controller: 'RequestDetailCtrl',
                controllerAs: 'vm',*/
                title: 'left.nav.ChildMenu.item7',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        DEVICE_MGMT: ['DETAILS']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_MGMT', 'DETAILS');
                    },

                },
                authenticate: true
            })
    }

})();
(function() {
    'use strict';

    angular.module('JPTC.pages.deviceRequest', ['ui.select', 'ngSanitize', 'JPTC.pages.form'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.deviceRequest', {
                url: '/device-request',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ParentMenu.item2',
                sidebarMeta: {
                    icon: 'fa fa-tasks',
                    order: 250,
                    permission: {
                        DEVICE_REQUEST: ['READ']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','READ');
                    },
                },
                authenticate: true
            })
            .state('main.deviceRequest.list', {
                url: '/list',
                templateUrl: 'app/pages/device-request/views/request-list.html',
                controller: 'RequestListCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item3',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        DEVICE_REQUEST: ['READ']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','READ');
                    },
                    requests: function (DeviceRequestService, localStorageService) {
                        var pageSize = localStorageService.get('pageSize');
                        return DeviceRequestService.getAllDeviceInstallation({
                            pageSize: pageSize.DEVICE_INSTALLATION.defaultValue
                        });
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    },
                    filterOptions: function (DeviceRequestService) {
                        return DeviceRequestService.getDeviceInstallationFilterOptions();
                    }
                },
                authenticate: true
            })
            .state('main.deviceRequest.change', {
                url: '/change',
                templateUrl: 'app/pages/device-request/views/change-device-request.html',
                controller: 'ChangeRequestListCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item28',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        DEVICE_REQUEST: ['READ']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','READ');
                    },
                    requests: function (DeviceRequestService, localStorageService) {
                        var pageSize = localStorageService.get('pageSize');
                        return DeviceRequestService.getAllChangeDeviceRequest({
                            pageSize: pageSize.DEVICE_INSTALLATION.defaultValue
                        });
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    },
                    filterOptions: function (DeviceRequestService) {
                        return DeviceRequestService.getDeviceInstallationFilterOptions();
                    }
                },
                authenticate: true
            })
            .state('main.deviceRequest.create', {
                url: '/create',
                templateUrl: 'app/pages/device-request/views/new-request.html',
                controller: 'NewRequestCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item4',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        DEVICE_REQUEST: ['WRITE']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','WRITE');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    },
                    KeyMap: function (DeviceRequestService) {
                        return DeviceRequestService.getKeyMap();
                    },
                },
                authenticate: true
            })
            .state('main.deviceRequest.createMultiple', {
                url: '/create-multiple',
                templateUrl: 'app/pages/device-request/views/multiple-request.html',
                controller: 'MultiNewRequestCtrl',
                controllerAs: 'vm',
                title: 'device.request.list.upload.device',
                params : { deviceRequest: null, isJescaUpload: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','WRITE');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    }
                },
                authenticate: true
            })
            .state('main.deviceRequest.detail', {
                url: '/detail/',
                templateUrl: 'app/pages/device-request/views/request-detail.html',
                controller: 'RequestDetailCtrl',
                controllerAs: 'vm',
                title: 'device.request.list.edit.device',
                params : { deviceInstallation: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','READ');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    },
                    KeyMap: function (DeviceRequestService) {
                        return DeviceRequestService.getKeyMap();
                    }
                },
                authenticate: true
            })
            .state('main.deviceRequest.jesca', {
                url: '/jesca/',
                templateUrl: 'app/pages/device-request/views/jesca-detail.html',
                controller: 'JescaDetailCtrl',
                controllerAs: 'vm',
                title: 'device.request.jesca.edit.title',
                params : { deviceInstallation: null,resetButtonStatus: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','READ');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    },
                    KeyMap: function (DeviceRequestService) {
                        return DeviceRequestService.getJescaKeyMap();
                    }
                },
                authenticate: true
            })
            .state('main.deviceRequest.removeTerminal', {
                url: '/remove-terminal/',
                templateUrl: 'app/pages/device-request/views/remove-device.html',
                controller: 'RemoveDeviceCtrl',
                controllerAs: 'vm',
                title: 'device.request.list.detach.terminal.title',
                params : { removeDeviceMap: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','MGMNT_WRITE');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    },
                },
                authenticate: true
            })
            .state('main.deviceRequest.deviceDetail', {
                url: '/device-detail/',
                templateUrl: 'app/pages/device-request/views/device-detail.html',
                controller: 'DeviceDetailCtrl',
                controllerAs: 'vm',
                title: 'device.request.list.edit.device.progress',
                params : { deviceDetailList: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','MGMNT_READ');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE');
                    },
                    KeyMap: function (DeviceRequestService) {
                        return DeviceRequestService.getDeviceKeys();
                    },
                    isNewUpload: function () {
                        return false;
                    },
                },
                authenticate: true
            })
            .state('main.deviceRequest.parseDeviceDetail', {
                url: '/upload-device-detail',
                templateUrl: 'app/pages/device-request/views/device-detail.html',
                controller: 'DeviceDetailCtrl',
                controllerAs: 'vm',
                title: 'device.request.list.upload.device.progress',
                params : { deviceDetailList: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','MGMNT_WRITE');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE');
                    },
                    KeyMap: function (DeviceRequestService) {
                        return DeviceRequestService.getDeviceKeys();
                    },
                    deviceList: function () {
                        return null
                    },
                    isNewUpload: function () {
                        return true;
                    },
                },
                authenticate: true
            })
            .state('main.deviceRequest.replace', {
                url: '/device-replacement',
                templateUrl: 'app/pages/device-request/views/device-replacement.html',
                controller: 'DeviceReplacementCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item20',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        DEVICE_REPLACEMENT: ['SUBMIT']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REPLACEMENT', 'SUBMIT');
                    },
                    filterOptions: function (DeviceRequestService) {
                        return DeviceRequestService.getDeviceInstallationFilterOptions();
                    }

                },
                authenticate: true
            })
            .state('main.deviceRequest.deviceSuspend', {
                url: '/suspend-remove-device/',
                templateUrl: 'app/pages/device-request/views/suspend-device.html',
                controller: 'SuspendDeviceCtrl',
                controllerAs: 'vm',
                title: 'device.request.suspend.title',
                params : { suspendDeviceMap: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','MGMNT_WRITE');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    },
                },
                authenticate: true
            })
            .state('main.deviceRequest.changeMultiple', {
                url: '/change-multiple',
                templateUrl: 'app/pages/device-request/views/change-multiple-request.html',
                controller: 'MultiNewChangeRequestCtrl',
                controllerAs: 'vm',
                title: 'device.request.list.upload.device',
                params : { deviceRequest: null, isJescaUpload: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','WRITE');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    }
                },
                authenticate: true
            })
            .state('main.deviceRequest.editDeviceRequestChange', {
                url: '/edit-change',
                templateUrl: 'app/pages/device-request/views/edit-device-request-change.html',
                controller: 'EditChangeRequestCtrl',
                controllerAs: 'vm',
                title: 'device.request.list.upload.device',
                params : { deviceRequest: null, isJescaUpload: null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('DEVICE_REQUEST','READ');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    }
                },
                authenticate: true
            });

    }

})();
(function() {
    'use strict';
  
    angular.module('JPTC.pages.forgotPassword', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('forgotPassword', {
          url: '/forgotPassword',
          templateUrl: 'app/pages/forgotPassword/forgotPassword.html',
          title: 'ForgotPassword',
          controller: 'forgotPasswordCtrl',
          controllerAs: 'vm',
          authenticate: false
        })
        
        .state('changePassword', {
          url: '/changePassword/:tokenId',
          templateUrl: 'app/pages/forgotPassword/changePassword.html',
          title: 'ChangePassword',
          controller: 'changePasswordCtrl',
          controllerAs: 'vm',
          resolve: {
            getDetail: function (AuthService, $stateParams) {
              return AuthService.validateToken($stateParams.tokenId);
                            
          }
          },
          authenticate: false
        });
    }
  
  })();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.form', ['ui.select', 'ngSanitize'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.form', {
        url: '/form',
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Form Elements',
        sidebarMeta: {
          icon: 'ion-compose',
          order: 250,
        },
        authenticate: true
      })
      .state('main.form.inputs', {
        url: '/inputs',
        templateUrl: 'app/pages/form/inputs/inputs.html',
        title: 'Form Inputs',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      })
      .state('main.form.layouts', {
        url: '/layouts',
        templateUrl: 'app/pages/form/layouts/layouts.html',
        title: 'Form Layouts',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      })
      .state('main.form.wizard', {
        url: '/wizard',
        templateUrl: 'app/pages/form/wizard/wizard.html',
        controller: 'WizardCtrl',
        controllerAs: 'vm',
        title: 'Form Wizard',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
 (function() {
  'use strict';

  angular.module('JPTC.pages.homePage', ['ui.select', 'ngSanitize'])
  .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider
    .state('main.homePage', {
      url: '',
      template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
      abstract: true,
      title: 'eMPP',
      authenticate: true
    })
    .state('main.homePage.home', {
      url: '/dashboard',
      controller: 'HomePageCtrl',
      templateUrl: 'app/pages/homePage/homePage.html',
      title: '',
      sidebarMeta: {
        icon: 'ion-android-home',
        order: 0,
      },
      authenticate: true
    });

  }
})();
(function () {
      'use strict';

      angular.module('JPTC.pages.inOfficeService', ['ui.select', 'ngSanitize'])
            .config(routeConfig);

      /** @ngInject */
      function routeConfig($stateProvider) {

            $stateProvider
                  .state('main.iosl', {
                        url: '/iosl',
                        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                        abstract: true,
                        title: 'left.nav.ParentMenu.item8',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    OFFICE_USAGE_DETAILS: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_DETAILS', 'READ');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.department', {
                        url: '/department',
                        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                        abstract: true,
                        title: 'left.nav.ChildMenu.item21',
                        sidebarMeta: {
                              icon: 'ion-compose',
                              order: 250,
                              permission: {
                                    OFFICE_DEPARTMENT: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEPARTMENT', 'READ');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.department.list', {
                        url: '/list',
                        cache: false,
                        templateUrl: 'app/pages/in-office-service/department/views/list-department.html',
                        controller: 'DepartmentListCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item1',
                        sidebarMeta: {
                              order: 0,
                              permission: {
                                    OFFICE_DEPARTMENT: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEPARTMENT', 'READ');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.department.preview', {
                        url: '/preview',
                        cache: false,
                        templateUrl: 'app/pages/in-office-service/department/views/list-preview.html',
                        controller: 'ListPreviewCtrl',
                        controllerAs: 'vm',
                        title: 'iosl.department.upload.info',
                        params: { data: null },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEPARTMENT', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.department.create', {
                        url: '/create',
                        templateUrl: 'app/pages/in-office-service/department/views/new-department.html',
                        controller: 'NewDepartmentCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item11',
                        sidebarMeta: {
                              order: 0,
                              permission: {
                                    OFFICE_DEPARTMENT: ['SUBMIT']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEPARTMENT', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.department.update', {
                        url: '/update',
                        templateUrl: 'app/pages/in-office-service/department/views/edit-department.html',
                        controller: 'EditDepartmentCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item14',
                        params: { departments: null },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEPARTMENT', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.employee', {
                        url: '/employee',
                        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                        abstract: true,
                        title: 'left.nav.ChildMenu.item26',
                        sidebarMeta: {
                              icon: 'ion-compose',
                              order: 250,
                              permission: {
                                    OFFICE_EMPLOYEE: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_EMPLOYEE', 'READ');
                              },
                        },
                        authenticate: true
                  }).state('main.iosl.employee.list', {
                        url: '/list',
                        cache: false,
                        templateUrl: 'app/pages/in-office-service/employee/views/list-employee.html',
                        controller: 'EmployeeListCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item1',
                        sidebarMeta: {
                              order: 0,
                              permission: {
                                    OFFICE_EMPLOYEE: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_EMPLOYEE', 'READ');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.employee.preview', {
                        url: '/preview',
                        cache: false,
                        templateUrl: 'app/pages/in-office-service/employee/views/list-preview.html',
                        controller: 'EmployeeListPreviewCtrl',
                        controllerAs: 'vm',
                        title: 'iosl.employee.upload.info',
                        params: { data: null },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_EMPLOYEE', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.employee.create', {
                        url: '/create',
                        templateUrl: 'app/pages/in-office-service/employee/views/new-employee.html',
                        controller: 'NewEmployeeCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item11',
                        sidebarMeta: {
                              order: 0,
                              permission: {
                                    OFFICE_EMPLOYEE: ['SUBMIT']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_EMPLOYEE', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.employee.update', {
                        url: '/update',
                        templateUrl: 'app/pages/in-office-service/employee/views/edit-employee.html',
                        controller: 'EditEmployeeCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item14',
                        params: { employees: null },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_EMPLOYEE', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.employee.detail', {
                        url: '/detail/:id',
                        templateUrl: 'app/pages/in-office-service/employee/views/detail.html',
                        controller: 'EmployeeDetailCtrl',
                        controllerAs: 'vm',
                        title: 'iosl.employee.qrcode',
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_QR_CODES', 'READ');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.usageRules', {
                        url: '/usage-rules',
                        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                        abstract: true,
                        title: 'left.nav.ChildMenu.item22',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    OFFICE_USAGE_RULES: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_RULES', 'READ');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.usageRules.list', {
                        url: '/list',
                        templateUrl: 'app/pages/in-office-service/usageRules/views/list-usage-rules.html',
                        controller: 'UsageRulesListCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item1',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    OFFICE_USAGE_RULES: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_RULES', 'READ');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.usageRules.preview', {
                        url: '/preview',
                        cache: false,
                        templateUrl: 'app/pages/in-office-service/usageRules/views/preview-usage-rules.html',
                        controller: 'UsageRulePreviewCtrl',
                        controllerAs: 'vm',
                        title: 'iosl.usage.rules.upload',
                        params: { usageRules: null },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_RULES', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.usageRules.create', {
                        url: '/create',
                        templateUrl: 'app/pages/in-office-service/usageRules/views/create-rule.html',
                        controller: 'CreateRuleCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item11',
                        sidebarMeta: {
                              order: 250,
                              permission: {
                                    OFFICE_USAGE_RULES: ['SUBMIT']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_RULES', 'READ');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.usageRules.update', {
                        url: '/update',
                        templateUrl: 'app/pages/in-office-service/usageRules/views/preview-usage-rules.html',
                        controller: 'UsageRulePreviewCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item11',
                        params: { usageRules: null, isUpdate: true },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_RULES', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })


                  .state('main.iosl.deviceLinkage', {
                        url: '/device-linkage',
                        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                        abstract: true,
                        title: 'left.nav.ChildMenu.item23',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    OFFICE_DEVICE_LINKAGE: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEVICE_LINKAGE', 'READ');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.deviceLinkage.list', {
                        url: '/list',
                        templateUrl: 'app/pages/in-office-service/deviceLinkage/views/list-device-link.html',
                        controller: 'DeviceLinkListCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item1',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    OFFICE_DEVICE_LINKAGE: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEVICE_LINKAGE', 'READ');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.deviceLinkage.preview', {
                        url: '/preview',
                        cache: false,
                        templateUrl: 'app/pages/in-office-service/deviceLinkage/views/preview-device-link.html',
                        controller: 'DeviceLinkPreviewCtrl',
                        controllerAs: 'vm',
                        title: 'iosl.device.linkage.upload',
                        params: { deviceLink: null },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEVICE_LINKAGE', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.deviceLinkage.create', {
                        url: '/create',
                        templateUrl: 'app/pages/in-office-service/deviceLinkage/views/create-device-link.html',
                        controller: 'CreateDeviceLinkCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item11',
                        sidebarMeta: {
                              order: 250,
                              permission: {
                                    OFFICE_DEVICE_LINKAGE: ['SUBMIT']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEVICE_LINKAGE', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })

                  .state('main.iosl.deviceLinkage.update', {
                        url: '/update',
                        templateUrl: 'app/pages/in-office-service/deviceLinkage/views/preview-device-link.html',
                        controller: 'DeviceLinkPreviewCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item14',
                        params: { deviceLink: null, isUpdate: true },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_DEVICE_LINKAGE', 'SUBMIT');
                              },
                        },
                        authenticate: true
                  })


                  .state('main.iosl.usageDetails', {
                        url: '/usage-details',
                        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                        abstract: true,
                        title: 'left.nav.ChildMenu.item24',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    OFFICE_USAGE_DETAILS: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_DETAILS', 'READ');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.usageDetails.monthlyOrDaily', {
                        url: '/monthly-daily',
                        templateUrl: 'app/pages/in-office-service/usageDetails/views/monthly-usage.html',
                        controller: 'MonthlyUsageCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item12',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    OFFICE_USAGE_DETAILS: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_DETAILS', 'READ');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.usageDetails.oneItem', {
                        url: '/one-item',
                        templateUrl: 'app/pages/in-office-service/usageDetails/views/one-item-usage.html',
                        controller: 'OneItemUsageCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item13',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    OFFICE_USAGE_DETAILS: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('OFFICE_USAGE_DETAILS', 'READ');
                              },
                        },
                        authenticate: true
                  })

                  //for terminal operation

                  .state('main.iosl.terminalOperation', {
                        url: '/terminal-operation',
                        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                        abstract: true,
                        title: 'left.nav.ChildMenu.item27',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    IOSLTERMINALOPS: ['MENU']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('IOSLTERMINALOPS', 'MENU');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.terminalOperation.accountManagement', {
                        url: '/account-management',
                        templateUrl: 'app/pages/in-office-service/terminalOperations/views/account-management.html',
                        controller: 'accountManagementCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item15',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    IOSLTERMINALOPS_ACCOUNT: ['ALL']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('IOSLTERMINALOPS_ACCOUNT', 'ALL');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.terminalOperation.register', {
                        url: '/register',
                        cache: false,
                        templateUrl: 'app/pages/in-office-service/terminalOperations/views/register-new-account.html',
                        controller: 'registerNewCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item17',
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('IOSLTERMINALOPS_ACCOUNT', 'ALL');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.terminalOperation.edit', {
                        url: '/edit',
                        cache: false,
                        templateUrl: 'app/pages/in-office-service/terminalOperations/views/edit-account.html',
                        controller: 'editAccountNewCtrl',
                        controllerAs: 'vm',
                        params: { accountDetails: null },
                        title: 'left.nav.ChildSubMenu.item17',
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('IOSLTERMINALOPS_ACCOUNT', 'ALL');
                              },
                        },
                        authenticate: true
                  })
                  .state('main.iosl.terminalOperation.transmissionHistory', {
                        url: '/transmission-history',
                        templateUrl: 'app/pages/in-office-service/terminalOperations/views/transmission-history.html',
                        controller: 'transmissionHistoryCtrl',
                        controllerAs: 'vm',
                        title: 'left.nav.ChildSubMenu.item16',
                        sidebarMeta: {
                              icon: 'fa fa-laptop',
                              order: 250,
                              permission: {
                                    IOSLTERMINALOPS_TRANSMISSIONHIS: ['READ']
                              }
                        },
                        resolve: {
                              hasPermission: function (AuthService) {
                                    return AuthService.hasPermission('IOSLTERMINALOPS_TRANSMISSIONHIS', 'READ');
                              },
                              filterOptions: function (inOfficeServices) {
                                    return inOfficeServices.filterOptions();
                              }
                        },
                        authenticate: true
                  })

      }
})();
/**
 * @author l.azevedo
 * created on 29.07.2017
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.main', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/pages/main/main.html',
        redirectTo: 'main.dashboard',
        authenticate: true,
        resolve: {
            allTypes: function (ServiceManagementService) {
                return ServiceManagementService.getAllTypes();
            }
        }
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.maps', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.maps', {
        url: '/maps',
        templateUrl: 'app/pages/maps/maps.html',
        abstract: true,
        title: 'Maps',
        sidebarMeta: {
          icon: 'ion-ios-location-outline',
          order: 500,
        },
        authenticate: true
      })
      .state('main.maps.gmap', {
        url: '/gmap',
        templateUrl: 'app/pages/maps/google-maps/google-maps.html',
        controller: 'GmapPageCtrl',
        title: 'Google Maps',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      })
      .state('main.maps.leaflet', {
        url: '/leaflet',
        templateUrl: 'app/pages/maps/leaflet/leaflet.html',
        controller: 'LeafletPageCtrl',
        title: 'Leaflet Maps',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      })
      .state('main.maps.bubble', {
        url: '/bubble',
        templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
        controller: 'MapBubblePageCtrl',
        title: 'Bubble Maps',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      })
      .state('main.maps.line', {
        url: '/line',
        templateUrl: 'app/pages/maps/map-lines/map-lines.html',
        controller: 'MapLinesPageCtrl',
        title: 'Line Maps',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();
(function() {
    'use strict';

    angular.module('JPTC.pages.notifications', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {     
        
        $stateProvider
            .state('main.notifications', {
                url: '/notifications',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ParentMenu.item5',
                sidebarMeta: {
                    icon: 'fa fa-bell',
                    order: 250,
                    permission: {
                        NOTIFICATIONS: ['ALL']
                    }
                }, 
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('NOTIFICATIONS', 'ALL');
                    },

                },
                authenticate: true
            })
            .state('main.notifications.list', {
                url: '/list',
                templateUrl: 'app/pages/comingSoon/comingSoon.html',
                /*  controller: 'RequestListCtrl',
                controllerAs: 'vm',*/
                title: 'left.nav.ChildMenu.item1',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        NOTIFICATIONS: ['ALL']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('NOTIFICATIONS', 'ALL');
                    },

                },
                authenticate: true
            })
            .state('main.notifications.details', {
                url: '/details',
                templateUrl: 'app/pages/comingSoon/comingSoon.html',
                /* controller: 'RequestDetailCtrl',
                controllerAs: 'vm',*/
                title: 'left.nav.ChildMenu.item12',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        NOTIFICATIONS: ['ALL']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('NOTIFICATIONS', 'ALL');
                    },

                },
                authenticate: true
            })
            .state('main.notifications.configure', {
                url: '/configure',
                templateUrl: 'app/pages/comingSoon/comingSoon.html',
                /* controller: 'RequestDetailCtrl',
                controllerAs: 'vm',*/
                title: 'left.nav.ChildMenu.item13',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        NOTIFICATIONS: ['ALL']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('NOTIFICATIONS', 'ALL');
                    },

                },
                authenticate: true
            })
    }

})();
(function() {
    'use strict';
  
    angular.module('JPTC.pages.other', ['ui.select', 'ngSanitize'])
    .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
     
      $stateProvider.state('main.other', {
        url: '/other',
        templateUrl: 'app/pages/other/views/other.html',
        title: 'left.nav.ParentMenu.item11',
        controller: 'OtherCtrl',
        controllerAs: 'vm',  
        sidebarMeta: {
            icon: 'fa fa-ellipsis-h',
            order: 250,
            permission: {
                  TELEMETRY_OPTION: ['ALL']
            }
        },
        resolve: {
            hasPermission: function(AuthService) {
                return AuthService.hasPermission('TELEMETRY_OPTION', 'ALL');
            },
           
            telemetryEnabled: function(OtherService) {
                return OtherService.isTelemetryEnabled();
            }
        },
        authenticate: true
      });
    }
  })();
 (function() {
  'use strict';

  angular.module('JPTC.pages.partner', ['ui.select', 'ngSanitize'])
  .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider
    .state('main.partner', {
          url: '/partner',
          templateUrl: 'app/pages/comingSoon/comingSoon.html',
          title: 'left.nav.ParentMenu.item9',
          sidebarMeta: {
                icon: 'fa fa-users',
                order: 250,
                permission: {
                   NOTIFICATIONS: ['ALL']
                }
          },
          resolve:{
                hasPermission: function(AuthService) {
                    return AuthService.hasPermission('NOTIFICATIONS', 'ALL');
                },
          },
      authenticate: true
    });

  }
})();
(function() {
    'use strict';

    angular.module('JPTC.pages.permissionDenied', ['ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.permissionDenied', {
                url: '/permissionDenied',
                templateUrl: 'app/pages/permissionDenied/permissionDenied.html',
                controller: function() {},
                title: 'common.components.permission.denied',
                authenticate: true
            })
            .state('main.500error', {
                url: '/500',
                templateUrl: 'app/pages/permissionDenied/500.html',
                controller: function() {},
                title: 'common.components.500.denied',
                authenticate: true
            })
            .state('main.404error', {
                url: '/404',
                templateUrl: 'app/pages/permissionDenied/404.html',
                controller: function() {},
                title: 'common.components.404.denied',
                authenticate: true
            })
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.profile', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.profile', {
        url: '/profile',
        title: 'Profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfilePageCtrl',
        authenticate: true
      });
  }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $translateProvider) {


        $stateProvider
            .state('main.salesSettlements', {
                url: '/sales',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ParentMenu.item4',
                sidebarMeta: {
                    icon: 'fa fa-yen',
                    order: 250,
                    permission: {
                        SALES: ['ALL'],
                        SETINV: ['ALL']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        var multiplePermission = {
                            'SALES': 'ALL',
                            'SETINV': 'ALL'
                        };
                        return AuthService.hasMultiplePermission(multiplePermission);
                    },

                },
                authenticate: true
            })
            .state('main.salesSettlements.monthly', {
                url: '/monthly',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                authenticate: true,
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SALES: ['ALL']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },

                },
                title: 'left.nav.ChildMenu.item9'
            })
            .state('main.salesSettlements.monthly.list', {
                url: '/list/:query',
                templateUrl: 'app/pages/sales-settlements/views/sales-list.html',
                controller: 'SalesListCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item1',
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SALES: ['ALL']
                    }
                },
                params: { interval: 'MONTHLY' },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('PAYMENT');
                    },
                    salesList: function (SalesSettlementsService, baUtil, $stateParams, localStorageService) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        var pageSize = localStorageService.get('pageSize');
                        if (!query.pageSize) {
                            query.pageSize = pageSize.SALES.defaultValue;
                        }
                        if (query.unitPrice) {
                            return SalesSettlementsService.fetchMonthlyUnitPriceResult(baUtil.makeQueryString(query))
                        }
                        else {
                            return SalesSettlementsService.fetchMonthlyResult(baUtil.makeQueryString(query))
                        }
                    },
                    salesStats:  function (SalesSettlementsService, baUtil, $stateParams) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query);
                        return  SalesSettlementsService.getSalesStats(query.organisationId, query.date, query.branchCode, query.interval)
                    },
                    aggregationDates: function (SalesSettlementsService, baUtil, $stateParams) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        return  SalesSettlementsService.getAggregationDates(query.organisationId)
                    },
                    allMerchants: function (SalesSettlementsService) {
                        return  SalesSettlementsService.getAllOrganisation()
                    },
                    salesBranch: function (SalesSettlementsService, $stateParams, baUtil) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        return SalesSettlementsService.getSettlementBranches(query.organisationId)
                    },
                    salesPropertyMap : function (SalesSettlementsService){
                        return SalesSettlementsService.fetchSalesPropertyMap();
                    },
                    isDownloadReportsEnabled: function(SalesSettlementsService){
                        return SalesSettlementsService.isDownloadReportsEnabled();
                    }
                },
                authenticate: true
            })
            .state('main.salesSettlements.daily', {
                url: '/daily',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                authenticate: true,
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SALES: ['ALL']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },
                },
                title: 'left.nav.ChildMenu.item8'
            })
            .state('main.salesSettlements.daily.list', {
                url: '/list/:query',
                templateUrl: 'app/pages/sales-settlements/views/sales-list.html',
                controller: 'SalesListCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item1',
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SALES: ['ALL']
                    }
                },
                params: { interval: 'DAILY' },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('PAYMENT');
                    },
                    salesList: function (SalesSettlementsService, baUtil, $stateParams, localStorageService) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        var pageSize = localStorageService.get('pageSize');
                        if (!query.pageSize) {
                            query.pageSize = pageSize.SALES.defaultValue;
                        }
                        if (query.unitPrice) {
                            return SalesSettlementsService.fetchMonthlyUnitPriceResult(baUtil.makeQueryString(query))
                        }
                        else {
                            return SalesSettlementsService.fetchMonthlyResult(baUtil.makeQueryString(query))
                        }
                    },
                    salesStats:  function (SalesSettlementsService, baUtil, $stateParams) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query);
                        return  SalesSettlementsService.getSalesStats(query.organisationId, query.date, query.branchCode, query.interval)
                    },
                    aggregationDates: function (SalesSettlementsService, baUtil, $stateParams) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        return  SalesSettlementsService.getAggregationDates(query.organisationId)
                    },
                    allMerchants: function (SalesSettlementsService) {
                        return  SalesSettlementsService.getAllOrganisation()
                    },
                    salesBranch: function (SalesSettlementsService, $stateParams, baUtil) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        return SalesSettlementsService.getSettlementBranches(query.organisationId)
                    },
                    salesPropertyMap : function (SalesSettlementsService){
                        return SalesSettlementsService.fetchSalesPropertyMap();
                    },
                    isDownloadReportsEnabled: function(SalesSettlementsService){
                        return SalesSettlementsService.isDownloadReportsEnabled();
                    }
                },
                authenticate: true
            })
            .state('main.salesSettlements.oneItem', {
                url: '/one-item',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                authenticate: true,
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SALES: ['ALL']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },
                },
                title: 'left.nav.ChildMenu.item9.1'
            })
            .state('main.salesSettlements.oneItem.detail', {
                url: '/detail/:query',
                templateUrl: 'app/pages/sales-settlements/views/sales-detail.html',
                controller: 'SalesDetailCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item1',
                params: { interval: 'MONTHLY' },
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SALES: ['ALL']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },
                    paymentDetail: function (SalesSettlementsService, $stateParams, baUtil, localStorageService) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        var pageSize = localStorageService.get('pageSize');
                        if (!query.pageSize) {
                            query.pageSize = pageSize.PAYMENT_TRANSACTION.defaultValue;
                        }

                        if( baUtil.isUndefinedOrNullOrEmptyObject(query.units) )
                            delete query.units;
                        return SalesSettlementsService.fetchMonthlyTransaction(baUtil.makeQueryString(query),query);
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('PAYMENT');
                    },
                    navigationDates: function (SalesSettlementsService, $stateParams, baUtil) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        return SalesSettlementsService.getAggregationDates(query.organisationId)
                    },
                    allMerchants: function (SalesSettlementsService) {
                        return  SalesSettlementsService.getAllOrganisation()
                    },
                    salesBranch: function (SalesSettlementsService, $stateParams, baUtil) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        return SalesSettlementsService.getSettlementBranches(query.organisationId)
                    },
                    unitPrices: function (SalesSettlementsService, $stateParams, baUtil) {
                        return []
                    //     if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                    //         return [];
                    //     }
                    //     var query = JSON.parse($stateParams.query);
                    //     return SalesSettlementsService.getOneItemPricesForOrganisation(query.organisationId)
                    }
                },
                authenticate: true
            })
            .state('main.salesSettlements.oneItem.addClosing', {
                url: '/addClosing',
                templateUrl: 'app/pages/sales-settlements/views/preview-sales-detail.html',
                controller: 'PreviewSalesDetailCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item18',
                params: { query : null, headers : null, rows : null, enums : null, addClosingInfoDate : null },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },
                },
                authenticate: true
            })
            .state('main.salesSettlements.oneItem.toggleClosing', {
                url: '/toggleClosing',
                templateUrl: 'app/pages/sales-settlements/views/preview-sales-detail-toggle-closing.html',
                controller: 'PreviewSalesDetailToggleClosingCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item19',
                params: { query : null, headers : null, rows : null, enums : null},
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },
                },
                authenticate: true
            })
            // .state('main.salesSettlements.settlement', {
            //     url: '/settlement',
            //     templateUrl: 'app/pages/sales-settlements/views/settlement-list.html',
            //     controller: 'SettlementListCtrl',
            //     controllerAs: 'vm',
            //     title: 'salesSettlements.monthly.list.settlement.settlement',
            //     sidebarMeta: {
            //         order: 0,
            //         permission: {
            //             SALES: ['ALL']
            //         }
            //     },
            //     resolve: {
            //         hasPermission: function(AuthService) {
            //             return AuthService.hasPermission('SALES', 'ALL');
            //         },
            //         settlementList: function (SalesSettlementsService) {
            //             return SalesSettlementsService.getSettlementList()
            //         },
            //     },
            //     authenticate: true
            // }).state('main.salesSettlements.settlementDetail', {
            //     url: '/settlement-detail/:query',
            //     templateUrl: 'app/pages/sales-settlements/views/settlement.html',
            //     controller: 'SettlementCtrl',
            //     controllerAs: 'vm',
            //     title: 'salesSettlements.monthly.list.settlement.settlement',
            //     resolve: {
            //         hasPermission: function(AuthService) {
            //             return AuthService.hasPermission('SALES', 'ALL');
            //         },
            //         settlementData: function (SalesSettlementsService, $stateParams, baUtil) {
            //             var query = JSON.parse($stateParams.query)
            //             if (query && query.branchCode && query.date) {
            //                 return SalesSettlementsService.getSettlementDetail(baUtil.makeQueryString(query))
            //             }
            //             return null
            //         },
            //         settlementBranches: function (SalesSettlementsService, $stateParams) {
            //             var query = JSON.parse($stateParams.query)
            //             return SalesSettlementsService.getSettlementBranches(query.organisationId)
            //         },
            //     },
            //     authenticate: true
            // })
            .state('main.salesSettlements.settlementList', {
                url: '/settlement-list/:query',
                templateUrl: 'app/pages/sales-settlements/views/settlement-list.html',
                controller: 'SettlementListCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item10.1',
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SETINV: ['ALL']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SETINV', 'ALL');
                    },
                    serviceContractDetail: function (baUtil, SalesSettlementsService, $stateParams) {
                        var isMerchant = baUtil.isMerchantOrMerchantAndDeviceOwner();
                        if (!isMerchant) {
                            return null
                        }
                        var account = baUtil.getAccountDto();
                        return SalesSettlementsService.getServiceContractByMerchant(account.organisation.organisationId)
                    },
                    settlementData: function (SalesSettlementsService, $stateParams, baUtil, localStorageService) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        var pageSize = localStorageService.get('pageSize');
                        if (!query.pageSize) {
                            query.pageSize = pageSize.SETTLEMENT.defaultValue;
                        }
                        return SalesSettlementsService.getSettlementList(baUtil.makeQueryString(query))
                    },
                    invoiceData: function (SalesSettlementsService, $stateParams, baUtil, localStorageService) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        var pageSize = localStorageService.get('pageSize');
                        if (!query.pageSize) {
                            query.pageSize = pageSize.SETTLEMENT.defaultValue;
                        }
                        return SalesSettlementsService.getInvoiceList(query.date, baUtil.makeQueryString(query))
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('PAYMENT');
                    },
                    allTypes: function (ServiceContractService) {
                        return ServiceContractService.getAllTypes();
                    },
                },
                authenticate: true
            })
            .state('main.salesSettlements.settlementDetail', {
                url: '/settlement-detail/:merchantId/:query',
                templateUrl: 'app/pages/sales-settlements/views/settlement-detail.html',
                controller: 'SettlementDetailCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item10.1',
                // sidebarMeta: {
                //     order: 0,
                //     permission: {
                //         SALES: ['ALL']
                //     }
                // },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SETINV', 'ALL');
                    },
                    settlementDetailData: function (SalesSettlementsService, $stateParams, baUtil, localStorageService) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        var pageSize = localStorageService.get("pageSize");
                        if (!query.pageSize) {
                          query.pageSize = pageSize.SETTLEMENT.defaultValue;
                        }
                        query.pageNumber = 0;
            
                        return SalesSettlementsService.getSettlementDetailData($stateParams.merchantId, query.date, query.contractId, query.pageNumber, query.pageSize)
                    },
                    invoiceDetailData: function (SalesSettlementsService, $stateParams, baUtil, localStorageService) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        var pageSize = localStorageService.get("pageSize");
                        if (!query.pageSize) {
                          query.pageSize = pageSize.SETTLEMENT.defaultValue;
                        }
                        query.pageNumber = 0;
                        return SalesSettlementsService.getInvoiceDetailData($stateParams.merchantId, query.date, query.contractId, query.pageNumber, query.pageSize)
                    },
                    settlementData: function (SalesSettlementsService, $stateParams, baUtil) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        return SalesSettlementsService.getSettlementListForMerchant(query.date, $stateParams.merchantId)
                    },
                    invoiceData: function (SalesSettlementsService, $stateParams, baUtil) {
                        if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                            return null
                        }
                        var query = JSON.parse($stateParams.query)
                        return SalesSettlementsService.getInvoiceListForMerchant(query.date, $stateParams.merchantId)
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('PAYMENT');
                    },
                },
                authenticate: true
            })
            .state('main.salesSettlements.reports', {
                url: '/download-reports',
                templateUrl: 'app/pages/sales-settlements/views/monthly-sales-request.html',
                controller: 'MonthlySalesRequest',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item31',
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SALES', 'ALL');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('PAYMENT');
                    },
                    sourcePageEnum : function (ServiceContractService){
                        return ServiceContractService.getTypeByEntity('SOURCE_PAGE');
                    },
                },
                authenticate: true
            });
    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.serviceContract', {
                url: '/service-contract',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ParentMenu.item1',
                sidebarMeta: {
                    icon: 'fa fa-file-text',
                    order: 250,
                    permission: {
                        SERVICE_CONTRACT: ['LIST']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_CONTRACT', 'LIST');
                    },
                },
                authenticate: true
            })
            .state('main.serviceContract.list', {
                url: '/list',
                cache: false,
                templateUrl: 'app/pages/service-contact/views/list.html',
                controller: 'ListContractCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item1',
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SERVICE_CONTRACT: ['LIST']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_CONTRACT', 'LIST');
                    },
                    scListPromise: function (ServiceContractService, localStorageService) {
                        var pageSize = localStorageService.get('pageSize');
                        return ServiceContractService.search("pageSize="+pageSize.SERVICE_CONTRACT.defaultValue);
                    },
                    allTypes: function (ServiceContractService) {
                        return ServiceContractService.getAllTypes();
                    }
                },
                authenticate: true
            })
            .state('main.serviceContract.create', {
                url: '/create',
                templateUrl: 'app/pages/service-contact/views/create-new.html',
                controller: 'NewContractCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildMenu.item2',
                params : {contractInfo :null },
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SERVICE_CONTRACT: ['WRITE']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_CONTRACT', 'WRITE');
                    },
                    allTypes: function (ServiceContractService) {
                        return ServiceContractService.getAllTypes();
                    },
                    branchProperty: function (ServiceContractService) {
                        return ServiceContractService.getBranchProperty();
                    },
                    emvProperty: function (ServiceContractService) {
                        return ServiceContractService.getEMVProperty();
                    }
                },
                authenticate: true
            })
            .state('main.serviceContract.detail', {
                url: '/detail/:contractId',
                templateUrl: 'app/pages/service-contact/views/detail.html',
                controller: 'DetailContractCtrl',
                controllerAs: 'vm',
                title: 'service.contract.create.service.contract.title_detail',
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_CONTRACT', 'READ');
                    },
                    getDetail: function ($stateParams, ServiceContractService) {
                        return ServiceContractService.getDetailFromId($stateParams.contractId);
                    },
                    allTypes: function (ServiceContractService) {
                        return ServiceContractService.getAllTypes();
                    },
                    maronBtnStatus: function ($stateParams,ServiceContractService) {
                        return ServiceContractService.getMaronBtnStatus($stateParams.contractId);
                    },
                    branchProperty: function (ServiceContractService) {
                        return ServiceContractService.getBranchProperty();
                    }
                },
                authenticate: true
            })
            .state('main.serviceContract.jescamaroon', {
                url: '/jesca-maron-application',
                templateUrl: 'app/pages/service-contact/views/jesca-maroon.html',
                controller: 'JescaMaroonCtrl',
                controllerAs: 'vm',
                title: 'service.contract.list.maroon.application',
                params : { maroonData: null, serviceContractId : null },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_CONTRACT', 'READ');
                    },
                    types: function (ServiceContractService) {
                        return ServiceContractService.getTypeByEntity('DEVICE_INSTALLATION');
                    },
                },
                authenticate: true
            })
    }
})();
(function() {
    'use strict';

    angular.module('JPTC.pages.serviceManagement', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {

        $stateProvider
            .state('main.serviceManagement', {
                url: '/service-management',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ParentMenu.item6',
                sidebarMeta: {
                    icon: 'fa fa-th',
                    order: 250,
                    permission: {
                        SERVICE_MGMT: ['READ']
                    }
                },
               /* resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'READ');
                    },
                },*/
                authenticate: true
            })

            .state('main.serviceManagement.organisation', {
                url: '/organisation',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ChildMenu.item14',
                sidebarMeta: {
                    icon: 'ion-compose',
                    order: 250,
                    permission: {
                        SERVICE_MGMT: ['READ']
                    }
                },/*
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'READ');
                    },                    
                },*/
                authenticate: true
            })

            .state('main.serviceManagement.organisation.list', {
                url: '/list',
                cache:false,
                templateUrl: 'app/pages/service-management/organization/views/list-Org.html',
                controller: 'ListOrgCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item1',
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SERVICE_MGMT: ['READ']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'READ');
                    },
                    scListPromise: function (ServiceManagementService, localStorageService) {
                        var pageSize = localStorageService.get('pageSize');
                        return ServiceManagementService.searchOrg("pageSize=" + pageSize.ORGANISATION.defaultValue);
                    },
                    types: function(ServiceManagementService){
                        return ServiceManagementService.getAllTypes();
                    }
                },

                authenticate: true
            })
            .state('main.serviceManagement.organisation.create', {
                url: '/create-update',
                templateUrl: 'app/pages/service-management/organization/views/create-new.html',
                controller: 'NewOrganizationCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item5',
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SERVICE_MGMT: ['ORG_WRITE']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'ORG_WRITE');
                    },
                    allTypes: function (ServiceManagementService) {
                        return ServiceManagementService.getAllTypes();
                    }
                },

                authenticate: true
            })



            /*.state('main.serviceManagement.organisation.link', {
                url: '/link-connect',
                templateUrl: 'app/pages/service-management/organization/views/link.html',
               // controller: 'NewOrganizationCtrl',
                controllerAs: 'vm',
                title: 'Link / Connect',
                params : {contractInfo :null },
                sidebarMeta: {
                    order: 0,
                },

                authenticate: true
            })*/

        .state('main.serviceManagement.organisation.detail', {
                url: '/detail/:orgId',
                templateUrl: 'app/pages/service-management/organization/views/org-detail.html',
                controller: 'DetailOrgCtrl',
                controllerAs: 'vm',
                title: 'org.detail.title',
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'READ');
                    },
                    allTypes: function (ServiceManagementService) {
                        return ServiceManagementService.getAllTypes();
                    },
                    getDetail: function (ServiceManagementService, $stateParams) {
                        return ServiceManagementService.getOrgDetailFromId($stateParams.orgId);
                    }
                },
                authenticate: true
            })
            .state('main.serviceManagement.users', {
                url: '/users',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ChildMenu.item15',
                sidebarMeta: {
                    icon: 'fa fa-th',
                    order: 250,
                    permission: {
                        SERVICE_MGMT: ['READ']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'READ');
                    },
                },
                authenticate: true
            })
            .state('main.serviceManagement.users.list', {
                url: '/list',
                cache:false,
                templateUrl: 'app/pages/service-management/users/views/list.html',
                controller: 'ListUsersCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item1',
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SERVICE_MGMT: ['READ']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'READ');
                    },
                    scListPromise: function (ServiceManagementService, localStorageService) {
                        var pageSize = localStorageService.get('pageSize');
                        return ServiceManagementService.search("pageSize=" + pageSize.ACCOUNT.defaultValue);
                    },
                    types: function(ServiceManagementService){
                        return ServiceManagementService.getAllTypes();
                    }
                },
                authenticate: true
            })
            .state('main.serviceManagement.users.detail', {
                url: '/detail/:userId',
                templateUrl: 'app/pages/service-management/users/views/detail-user.html',
                controller: 'DetailUserCtrl',
                controllerAs: 'vm',
                title: 'user.detail.title',
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'READ');
                    },
                    allTypes: function (ServiceManagementService) {
                        return ServiceManagementService.getAllTypes();
                    },
                    getDetail: function (ServiceManagementService, $stateParams) {
                        return ServiceManagementService.getUserDetailFromId($stateParams.userId);
                    }
                },
                authenticate: true
            })

            .state('main.serviceManagement.users.create', {
                url: '/create-update',
                templateUrl: 'app/pages/service-management/users/views/create-user.html',
                controller: 'NewUsersCtrl',
                controllerAs: 'vm',
                title: 'left.nav.ChildSubMenu.item5',
              //  params : {contractInfo :null },
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SERVICE_MGMT: ['USER_WRITE']
                    }
                },
                resolve: {
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SERVICE_MGMT', 'USER_WRITE');
                    },
                    allTypes: function (ServiceManagementService) {
                        return ServiceManagementService.getAllTypes();
                    },
                    generateUserId: function (ServiceManagementService) {
                        return ServiceManagementService.generateUserId();
                    }
                },

                authenticate: true
            })

            .state('main.serviceManagement.users.passwordManagement',{
                url:'/passwordManagement/:userId',
                templateUrl: 'app/pages/service-management/users/views/passwordManagement.html',
                controller:'PassManageCtrl',
                controllerAs:'vm',
                title: 'left.nav.ChildSubMenu.item8',
                resolve: {
                    hasPermission: function(AuthService, $stateParams, localStorageService) {
                        if (localStorageService.get('loginResponse').accountDto.accountId===$stateParams.userId)
                            return
                        return AuthService.hasPermission('SERVICE_MGMT', 'USER_WRITE');
                    },
                    allTypes: function (ServiceManagementService) {
                         return ServiceManagementService.getAllTypes();
                    },
                    getDetail: function (ServiceManagementService, $stateParams) {
                        return ServiceManagementService.getUserDetailFromId($stateParams.userId);
                    }
                },
                authenticate: true
            })

    }

})();
(function() {
  'use strict';

  angular.module('JPTC.pages.services', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
(function() {
    'use strict';

    angular.module('JPTC.pages.systemManagement', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        
        $stateProvider
            .state('main.systemManagement', {
                url: '/system-management',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'left.nav.ParentMenu.item7',
                sidebarMeta: {
                    icon: 'fa fa-cogs',
                    order: 250,
                    permission: {
                        SYSTEM_MGMT: ['ALL']
                    }
                },
                resolve:{
                     hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SYSTEM_MGMT', 'ALL');
                    },
                },
                authenticate: true
            })
            .state('main.systemManagement.jmups', {
                url: '/jmups-mapping',
                templateUrl: 'app/pages/system-management/views/jmups-mapping.html',
                controller: 'JmupsMappingCtrl',
                controllerAs: 'vm',
                title: 'jmups.mapping.title',
                sidebarMeta: {
                    order: 0,
                    permission: {
                        SYSTEM_MGMT: ['ALL']
                    }
                },
                resolve:{
                    hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SYSTEM_MGMT', 'ALL');
                    },
                    jmupsMap : function(systemManagementService) {
                        return systemManagementService.getJmupsMapping();
                    }
                },
                authenticate: true
            })
            .state('main.systemManagement.schedules', {
                url: '/schedules',
                templateUrl: 'app/pages/comingSoon/comingSoon.html',
                /*  controller: 'RequestListCtrl',
                controllerAs: 'vm',*/
                title: 'left.nav.ChildMenu.item18',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        SYSTEM_MGMT: ['ALL']
                    }
                },
                resolve:{
                     hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SYSTEM_MGMT', 'ALL');
                    },
                },
                authenticate: true
            })
            .state('main.systemManagement.status', {
                url: '/status',
                templateUrl: 'app/pages/comingSoon/comingSoon.html',
                /* controller: 'RequestDetailCtrl',
                controllerAs: 'vm',*/
                title: 'left.nav.ChildMenu.item19',
                sidebarMeta: {
                    order: 1,
                    permission: {
                        SYSTEM_MGMT: ['ALL']
                    }
                },
                resolve:{
                     hasPermission: function(AuthService) {
                        return AuthService.hasPermission('SYSTEM_MGMT', 'ALL');
                    },
                },
                authenticate: true
            })
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.tables', {
        url: '/tables',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        controller: 'TablesPageCtrl',
        title: 'Tables',
        sidebarMeta: {
          icon: 'ion-grid',
          order: 300,
        },
        authenticate: true
      }).state('main.tables.basic', {
        url: '/basic',
        templateUrl: 'app/pages/tables/basic/tables.html',
        title: 'Basic Tables',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.tables.smart', {
        url: '/smart',
        templateUrl: 'app/pages/tables/smart/tables.html',
        title: 'Smart Tables',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
    $urlRouterProvider.when('/main/tables', '/main/tables/basic');
  }

})();
/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui', [
      'JPTC.pages.ui.typography',
      'JPTC.pages.ui.buttons',
      'JPTC.pages.ui.icons',
      'JPTC.pages.ui.modals',
      'JPTC.pages.ui.grid',
      'JPTC.pages.ui.alerts',
      'JPTC.pages.ui.progressBars',
      'JPTC.pages.ui.notifications',
      'JPTC.pages.ui.tabs',
      'JPTC.pages.ui.slider',
      'JPTC.pages.ui.panels',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui', {
        url: '/ui',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'UI Features',
        sidebarMeta: {
          icon: 'ion-android-laptop',
          order: 200,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.charts.amCharts', [])
    .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.amCharts', {
        url: '/amCharts',
        templateUrl: 'app/pages/charts/amCharts/charts.html',
        title: 'amCharts',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.charts.chartJs', [])
    .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartJs', {
        url: '/chartJs',
        templateUrl: 'app/pages/charts/chartJs/chartJs.html',
        title: 'Chart.js',
        sidebarMeta: {
          order: 200
        },
        authenticate: true
      });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    // Configure all charts
    ChartJsProvider.setOptions({
      chartColors: [
        layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight
      ],
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 2500
      },
      scale: {
        gridLines: {
          color: layoutColors.border
        },
        scaleLabel: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          fontColor: layoutColors.defaultText,
          showLabelBackdrop: false
        }
      }
    });
    // Configure all line charts
    ChartJsProvider.setOptions('Line', {
      datasetFill: false
    });
    // Configure all radar charts
    ChartJsProvider.setOptions('radar', {
      scale: {
        pointLabels: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          maxTicksLimit: 5,
          display: false
        }
      }
    });
    // Configure all bar charts
    ChartJsProvider.setOptions('bar', {
      tooltips: {
        enabled: false
      }
    });
  }

})();
/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartist', {
        url: '/chartist',
        templateUrl: 'app/pages/charts/chartist/chartist.html',
        title: 'Chartist',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();
/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider) {
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.morris', {
        url: '/morris',
        templateUrl: 'app/pages/charts/morris/morris.html',
        title: 'Morris',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.components.mail', {
        url: '/mail',
        abstract: true,
        templateUrl: 'app/pages/components/mail/mail.html',
        controller: "MailTabCtrl",
        controllerAs: "tabCtrl",
        title: 'Mail',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.components.mail.label', {
        url: '/:label',
        templateUrl: 'app/pages/components/mail/list/mailList.html',
        title: 'Mail',
        controller: "MailListCtrl",
        controllerAs: "listCtrl",
        authenticate: true
      }).state('main.components.mail.detail', {
        url: '/:label/:id',
        templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
        title: 'Mail',
        controller: "MailDetailCtrl",
        controllerAs: "detailCtrl",
        authenticate: true
      });
    $urlRouterProvider.when('/main/components/mail', '/main/components/mail/inbox');
  }

})();
/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
        title: 'Timeline',
        sidebarMeta: {
          icon: 'ion-ios-pulse',
          order: 100,
        },
        authenticate: true
      });
  }
})();
/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.components.tree', [])
    .config(routeConfig)
    .config(function() {
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components.tree', {
        url: '/tree',
        templateUrl: 'app/pages/components/tree/tree.html',
        title: 'Tree View',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.alerts', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.alerts', {
        url: '/alerts',
        templateUrl: 'app/pages/ui/alerts/alerts.html',
        title: 'Alerts',
        sidebarMeta: {
          order: 500,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.buttons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.buttons', {
        url: '/buttons',
        templateUrl: 'app/pages/ui/buttons/buttons.html',
        controller: 'ButtonPageCtrl',
        title: 'Buttons',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.grid', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.grid', {
        url: '/grid',
        templateUrl: 'app/pages/ui/grid/grid.html',
        title: 'Grid',
        sidebarMeta: {
          order: 400,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.icons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.icons', {
        url: '/icons',
        templateUrl: 'app/pages/ui/icons/icons.html',
        controller: 'IconsPageCtrl',
        title: 'Icons',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.modals', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.modals', {
        url: '/modals',
        templateUrl: 'app/pages/ui/modals/modals.html',
        controller: 'ModalsPageCtrl',
        title: 'Modals',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.notifications', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.notifications', {
        url: '/notifications',
        templateUrl: 'app/pages/ui/notifications/notifications.html',
        controller: 'NotificationsPageCtrl',
        title: 'Notifications',
        sidebarMeta: {
          order: 700,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.panels', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.panels', {
        url: '/panels',
        templateUrl: 'app/pages/ui/panels/panels.html',
        controller: 'NotificationsPageCtrl',
        title: 'Panels',
        sidebarMeta: {
          order: 1100,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.progressBars', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.progressBars', {
        url: '/progressBars',
        templateUrl: 'app/pages/ui/progressBars/progressBars.html',
        title: 'Progress Bars',
        sidebarMeta: {
          order: 600,
        },
        authenticate: true
      });
  }

})();
/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.slider', {
        url: '/slider',
        templateUrl: 'app/pages/ui/slider/slider.html',
        title: 'Sliders',
        sidebarMeta: {
          order: 1000,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.tabs', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.tabs', {
        url: '/tabs',
        templateUrl: 'app/pages/ui/tabs/tabs.html',
        title: 'Tabs & Accordions',
        sidebarMeta: {
          order: 800,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('JPTC.pages.ui.typography', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.typography', {
        url: '/typography',
        templateUrl: 'app/pages/ui/typography/typography.html',
        title: 'Typography',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

})();
'use strict';

var serverUrl = '${serverUrl}';
var paymentServerUrl = '${paymentServerUrl}';
var ioslServerUrl = '${ioslServerUrl}';
var localServerUrl = 'http://localhost:8454'
var paymentLocalServerUrl = 'http://localhost:8455'
var ioslLocalServerUrl = 'http://localhost:8456/iosl/'

angular.module('JPTC', [
  'ngAnimate',
  'ngCookies',
  'ngFileUpload',
  'ngFileSaver',
  'LocalStorageModule',
  'pascalprecht.translate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'ngIdle',
  'smart-table',
  'xeditable',
  'ui.slimscroll',
  'ngJsTree',
  'ngMask',
  'ae-datetimepicker',
  'pathgather.popeye',
  'angular-progress-button-styles',
  'JPTC.theme',
  'JPTC.pages'
])
.config(function(IdleProvider, KeepaliveProvider) {
        // configure Idle settings
        IdleProvider.idle(2700); // in seconds
        IdleProvider.timeout(900); // in seconds
        KeepaliveProvider.interval(1800); // in seconds
    })
.constant('API_CONFIG', {
  // url: 'https://jptokyo.co',
  // url: 'https://demo.jptokyo.co',
  // url: 'http://localhost:8454',
  url: function() {
    return (serverUrl.indexOf('{serverUrl}') >= 0) ? localServerUrl : serverUrl;
  }(),
  paymentUrl: function () {
    return (paymentServerUrl.indexOf('{paymentServerUrl}') >= 0) ? paymentLocalServerUrl : paymentServerUrl;
  } (),
  ioslUrl: function() {
    return (ioslServerUrl.indexOf('{ioslServerUrl}') >= 0) ? ioslLocalServerUrl : ioslServerUrl;
  }(),
  env: function () {
    var finalUrl = (serverUrl.indexOf('{serverUrl}') >= 0)
        ? localServerUrl
        : serverUrl;

    finalUrl = finalUrl.toLowerCase();

    if (finalUrl.indexOf('localhost') >= 0) return 'localhost';
    if (finalUrl.indexOf('dev1.') >= 0) return 'dev1';
    if (finalUrl.indexOf('qa.') >= 0) return 'qa';
    if (finalUrl.indexOf('test.') >= 0) return 'stg';
    if (finalUrl.indexOf('uat.')>= 0) return 'uat';

    return 'prod';
  }(),
  telemetryBaseUrls: {
    dev1: 'https://dev1.telemetry.jptc.link/sso',
    qa: 'https://qa.telemetry.jptc.link/sso',
    stg: 'https://emp.telemetry.test.cpi-cgw.com/sso',
    uat: 'https://uat.telemetry.jptccloud.com/sso',
    prod: 'https://emp.telemetry.cpi-cgw.com/sso',
    localhost: 'http://localhost:3000'
  }
});

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('JPTC.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('JPTC.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('JPTC.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('JPTC.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
  'use strict';

  angular.module('JPTC.pages.authSignIn')
    .controller('authSignInCtrl', authSignInCtrl)
    .run(function(Idle){
                Idle.unwatch();
    });

  /** @ngInject */
  function authSignInCtrl($scope, AuthService, $state, $timeout, toastr, baUtil, $translate, localStorageService, $filter, $rootScope, $location, $window, Idle) {
    var vm = this;
    init();
    vm.loginFormData = {
    }
    vm.login = login;
    vm.changeLanguage = changeLanguage;
    vm.localTranslator = $filter('translate');
    vm.sealUrl = sealUrl;



    function init() {
        AuthService.clearLogin();
        Idle.unwatch();
        sealUrl();
    }

    var isSessionExpired =  localStorageService.get('sessionExpired');
    if (!baUtil.isUndefinedOrNullOrEmpty(isSessionExpired)) {
        vm.expireSessionText = true;
        localStorageService.remove('sessionExpired');
//        console.log(localStorageService.get('sessionExpired'));
    }
    else {
        vm.expireSessionText = false;
    }


    function changeLanguage(lang) {
        $translate.use(lang);
        localStorageService.set('lang', lang);
        $scope.$broadcast('LANG_CHANGE');
    }

    function sealUrl() {
        var host = $location.host();
//        console.log(host);
        if (host == 'emp.cpi-cgw.com') {
            vm.originalSeal = true;
        }
        else {
            vm.originalSeal = false;
        }

    }


    function login() {
         if (vm.loginForm.$invalid) {
          /*  toastr.error(vm.localTranslator("common.components.errorMessages.fillRequiredFields"),
                    vm.localTranslator("common.components.errorMessages.error"),
                    baUtil.toastOptions()
           );*/
            return;
         }
          AuthService.login(vm.loginFormData,
            function success() {
              Idle.watch();
              $timeout(function() {
                if(!baUtil.isUndefinedOrNullOrEmptyObject($rootScope.returnToState) && !baUtil.isUndefinedOrNullOrEmptyObject(localStorageService.get('rdUrl'))) {
                   var rd = localStorageService.get('rdUrl');
//                      console.log(rd);
                      $window.location.href = rd;
                 } else {
                      $state.go('main.homePage.home');
                 }
                   localStorageService.remove('rdUrl');
              }, 10);
            }, function err(err) {
              //show notification
               toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
               );

            });
    }


  }

})();
(function() {
  'use strict';

  angular.module('JPTC.pages.authSignUp')
    .controller('authSignUpCtrl', authSignUpCtrl);

  /** @ngInject */
  function authSignUpCtrl($scope) {
    var vm = this;

  }

})();
(function () {
  'use strict';

  angular.module('JPTC.pages.config')
    .run(stateChangeStart);

  /** @ngInject */
  function stateChangeStart($rootScope, $state, AuthService, baUtil, $location) {
    $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
      if (toState.authenticate && !AuthService.isLoggedInLocally()) {
        // User isn’t authenticated
        AuthService.saveRD($location.absUrl());
        $state.transitionTo("authSignIn");
        event.preventDefault();
      }
    });
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      console.log('$stateChangeError happened', toState, toParams, fromState, fromParams, error);
      // this is required if you want to prevent the $UrlRouter reverting the URL to the previous valid location
      if (error === 'PERMISSION_DENIED') {
        return $state.go('main.permissionDenied');
      }
      if (error && error.status && !isNaN(error.status)) {
        event.preventDefault();
        switch (parseInt(error.status)) {
          case 403: {
            return $state.go('main.permissionDenied');
          }
          case 401: {
            return $state.go('authSignIn', { extras: { msg: 'Login token expired please re-login.' } });
          }
          default: {
            if (error.status >= 500 && error.status <= 599) {
              return $state.go('main.500error');
            }
            return $state.go('main.404error');
          }
        }
      }

      // }


    });
  }

})();
(function () {
    'use strict';
  
    angular.module('JPTC.pages.forgotPassword')
      .controller('changePasswordCtrl', changePasswordCtrl);
  
    /** @ngInject */
    function changePasswordCtrl($scope, AuthService, $state, $translate, $stateParams, $timeout , toastr, baUtil, getDetail, localStorageService, $filter) {
      var vm = this;
    //  vm.changePassForm = {}
     // vm.validate - validate
     vm.tokeninfo = {}

     vm.submit = submit
     vm.submita = submita
            
    vm.changeLanguage = changeLanguage;
    vm.localTranslator = $filter('translate');

  
    if (getDetail.status >= 200 && getDetail.status <= 299) {
        vm.userDetails = getDetail.data.data;
    }

    if (!baUtil.isUndefinedOrNull(vm.userDetails)) {
        vm.tokeninfo = vm.userDetails
    }

    
    function changeLanguage(lang) {
        $translate.use(lang);
        localStorageService.set('lang', lang);
        $scope.$broadcast('LANG_CHANGE');
    }


    var tokenid = $stateParams.tokenId;

    if (vm.tokeninfo.status != true) {
      toastr.error(vm.localTranslator("common.components.msg.token.expired"), vm.localTranslator("common.components.title.error"), baUtil.toastOptions())
        $state.go('forgotPassword');
     }

     

    function submit() {
        
          if(vm.changePassForm.$invalid) {
            return;
           }

          if (vm.changePass == vm.changePassConfirm) { 
                
            AuthService.changePassword(tokenid, vm.changePass,
             function success(response) {
              toastr.success(
                response.data.message || vm.localTranslator("common.components.msg.success"),
                vm.localTranslator("common.components.title.success"),
                baUtil.toastOptions()
              );
             $state.go('authSignIn');
                  //  $state.reload()
           }, function err(err) {
              toastr.error(           
                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
           }); 
           
           }
       else {
           
            toastr.error(vm.localTranslator("common.components.msg.changePassword"), vm.localTranslator("common.components.title.error"), baUtil.toastOptions())
            
       }

      }

      function submita() {
        AuthService.changePassword(vm.userName,
            function success(response) {
              toastr.success('Password reset link has been sent Email Id', 'Success', baUtil.toastOptions())
                   $state.reload()
          }, function err(err) {
              toastr.error(baUtil.getErrorMessageOrDefault(err, 'Error submitting form'), 'Error', baUtil.toastOptions())
          });
      }

    
  
    }
  
  })();
(function () {
  'use strict';

  angular.module('JPTC.pages.forgotPassword')
    .controller('forgotPasswordCtrl', forgotPasswordCtrl);

  /** @ngInject */
  function forgotPasswordCtrl($scope, AuthService, $state, $timeout , toastr, baUtil, $translate, localStorageService, $filter) {
    var vm = this;
    vm.forgotPassForm = {}
    vm.submit = submit
    vm.changeLanguage = changeLanguage;
    vm.localTranslator = $filter('translate');

    function submit() {
        
          if(vm.forgotPass.$invalid) {
            return;
          }
        
          AuthService.forgotPassword(vm.userName,
              function success(response) {
                toastr.success(
                  response.data.message || vm.localTranslator("common.components.msg.success"),
                  vm.localTranslator("common.components.title.success"),
                  baUtil.toastOptions()
              );
                     $state.reload()
            }, function err(err) {
                toastr.error(           
                  baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                  vm.localTranslator("common.components.title.error"),
                  baUtil.toastOptions()
              );
            });
    }

      
      
    function changeLanguage(lang) {
        $translate.use(lang);
        localStorageService.set('lang', lang);
        $scope.$broadcast('LANG_CHANGE');
    }
      
      
    function change() {
      AuthService.changePassword(vm.forgotPassForm,
        function success() {
          $timeout(function() {
            // Enter code for success
          });
        }, function error() {
          //show notification
        });
    }

  }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.homePage')
        .controller('HomePageCtrl', HomePageCtrl);

    /** @ngInject */
    function HomePageCtrl($translate) {
        var vm = this;

        vm.getLang = getLang;

        function getLang() {
            return $translate.use();
        }

    }

})();
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal) {
    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

(function () {
    'use strict';

    angular.module('JPTC.pages.services')
        .factory('AuthService', AuthService);

    /** @ngInject */
    function AuthService(baUtil, $http, $state, $translate, $q, $filter, localStorageService, API_CONFIG) {
        var service = {};
        service.isLoggedInLocally = isLoggedInLocally;
        service.clearLogin = clearLogin;
        service.logout = logout;
        service.login = login;
        service.search = search;
        service.getToken = getToken;
        service.getPermissions = getPermissions;
        service.getPageSize = getPageSize;
        service.isAdmin = isAdmin;
        service.getOrgId = getOrgId;
        service.getDeviceOwnerCode = getDeviceOwnerCode;
        service.forgotPassword = forgotPassword;
        service.validateToken = validateToken;
        service.changePassword = changePassword;
        service.hasPermission = hasPermission;
        service.hasMultiplePermission = hasMultiplePermission;
        service.saveRD = saveRD;
        service.renewToken = renewToken;
        service.expireToken = expireToken;

        return service;
        function saveRD(url) {
            localStorageService.remove('rdUrl');
            localStorageService.set('rdUrl', url);
        }
        function isLoggedInLocally() {
            return !baUtil.isUndefinedOrNullOrEmptyObject(localStorageService.get('loginResponse'));
        }
        function clearLogin() {
            localStorageService.remove('loginResponse');
        }

        function logout() {
             var vm = this;
             this.expireToken();
             localStorageService.remove('loginResponse');
             $state.go('authSignIn');
        }

        function search(query) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/search?query='+query,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;

            });
        }

        function getPageSize() {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/pageSize',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                var pageSize = response.data.data;
                localStorageService.set('pageSize', pageSize);

            });
        }
        function isAdmin() {
            var loginResponse = localStorageService.get('loginResponse');
            if (baUtil.isUndefinedOrNullOrEmptyObject(localStorageService.get('loginResponse'))) {
                return false;
            }
            if (baUtil.isUndefinedOrNullOrEmptyObject(loginResponse.accountDto)) {
                return false;
            }
            if (baUtil.isUndefinedOrNullOrEmptyList(loginResponse.accountDto.accountTypes)) {
                return false;
            }
            return loginResponse.accountDto.accountTypes.indexOf('ADMIN') > -1;
        }
        function getOrgId() {
            var loginResponse = localStorageService.get('loginResponse');
            if (baUtil.isUndefinedOrNullOrEmptyObject(localStorageService.get('loginResponse'))) {
                return false;
            }
            if (baUtil.isUndefinedOrNullOrEmptyObject(loginResponse.accountDto)) {
                return false;
            }
            if (baUtil.isUndefinedOrNullOrEmptyObject(loginResponse.accountDto.organisation)) {
                return false;
            }
            return loginResponse.accountDto.organisation.organisationId;
        }
        function getDeviceOwnerCode(){
            var loginResponse = localStorageService.get('loginResponse');
            if (baUtil.isUndefinedOrNullOrEmptyObject(localStorageService.get('loginResponse'))) {
                return false;
            }
            if (baUtil.isUndefinedOrNullOrEmptyObject(loginResponse.accountDto)) {
                return false;
            }
            if (baUtil.isUndefinedOrNullOrEmptyObject(loginResponse.accountDto.organisation)) {
                return false;
            }
            return loginResponse.accountDto.organisation.deviceOwnerCode;
        }
        function getToken() {
            var loginResponse = localStorageService.get('loginResponse');
            if (!baUtil.isUndefinedOrNullOrEmptyObject(localStorageService.get('loginResponse'))) {
                return loginResponse.token;
            }
        }
        function getPermissions() {
            var loginResponse = localStorageService.get('loginResponse');
            if (!baUtil.isUndefinedOrNullOrEmptyObject(loginResponse)) {
                return loginResponse.permissionsMap;
            }
        }
        function hasPermission(module, permissionName) {
            var permissions = getPermissions();
            return $q(function(resolve, reject) {
                if (baUtil.isUndefinedOrNullOrEmptyObject(permissions)
                    || baUtil.isUndefinedOrNullOrEmptyObject(permissions[module])
                    || baUtil.isUndefinedOrNull(permissions[module][permissionName])) {
                        return reject('PERMISSION_DENIED');
                    } else if (permissions[module][permissionName] == true) {
                        return resolve('ok')
                    }
            });
        }
        function hasMultiplePermission(value) {
            var permissions = getPermissions();
            var grant = false;
            var hasAccess = [];
            angular.forEach(value, function(permissionName, module) {
                if (baUtil.isUndefinedOrNullOrEmptyObject(permissions)
                    || baUtil.isUndefinedOrNullOrEmptyObject(permissions[module])
                    || baUtil.isUndefinedOrNull(permissions[module][permissionName])) {
                    grant = false;
                } else if (permissions[module][permissionName] == true) {
                    grant = true
                    hasAccess.push(true);
                }
            });
            return $q(function(resolve, reject) {
                if(hasAccess.length > 0) {
                    return resolve('ok')
                }
                else {
                    return reject('PERMISSION_DENIED');
                }
            });
        }
        function login(loginDto, successCallback, errorCallback) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/login',
                method: 'post',
                data: loginDto,
                headers: {
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            }).
                success(function (response) {
                    successCallback(response);
                    localStorageService.set('loginResponse', response.data);
                }).
                error(function (response) {
                    errorCallback(response);
                });
        };

        function forgotPassword(userName, successCallback, errorCallback) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/forgot/password/initiate',
                method: 'post',
                data: {
                    "userName":userName},
                headers: {
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            }).
                success(function(response) {
                    successCallback(response);
                }).
                error(function(response){
                    errorCallback(response);
                });
        };


        function validateToken(pass_token) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/forgot/password/check',
                method: 'post',
                data: { "token":pass_token},
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            })

        };

        function changePassword(tokenid, newPass, successCallback, errorCallback) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/forgot/password/change',
                method: 'post',
                data: {
                    "token":tokenid,
                    "password": newPass
                },
                headers: {
                    'X-COV-TOKEN': getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).
                success(function(response) {
                    successCallback(response);
                }).
                error(function(response){
                    errorCallback(response);
                });
        };

        function renewToken() {
             return $http({
                url: API_CONFIG.url + '/api/v1/account/session/renew',
                method: 'post',
                headers: {
                    'X-COV-TOKEN': getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
             })
        };

        function expireToken() {
             return $http({
                url: API_CONFIG.url + '/api/v1/account/logout',
                method: 'post',
                headers: {
                    'X-COV-TOKEN': getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
              })
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('JPTC.pages.services')
        .factory('httpInterceptor', HttpInterceptor);

    function HttpInterceptor($q, baUtil, localStorageService, $cookies) {

        return {
            // do something on success
            'request': function (config) {
                if (baUtil.isUndefinedOrNullOrEmpty(config.headers['X-OFB-TOKEN'])) {
                    // Look for token in the cookie
                    if (!baUtil.isUndefinedOrNullOrEmpty($cookies.get('auth-token'))) {
                        config.headers['X-COV-TOKEN'] = $cookies.get('auth-token');
                    }
                }
                return config;
            },

            // do something on error
            'requestError': function (rejection) {
                //   if (canRecover(rejection)) {
                //     return responseOrNewPromise
                //   }
                return $q.reject(rejection);
            },

            // do something on success
            'response': function (response) {
                return response;
            },

            // do something on error
            'responseError': function (rejection) {
                //   if (canRecover(rejection)) {
                //     return responseOrNewPromise
                //   }

                if (rejection.status === 401) {
                    localStorageService.clearAll();
                }
                return $q.reject(rejection);
            }
        };
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 10000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 3,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
(function () {
    'use strict';
  
    angular.module('JPTC.theme')
        .directive('ngConfirmClick', ngConfirmClick);
  
    /** @ngInject */
    function ngConfirmClick() {
      return {
          
        link: function (scope, element, attr) {
            var msg = attr.ngConfirmClick || "Are you sure?";
            var clickAction = attr.confirmedClick;
            element.bind('click',function (event) {
                if ( window.confirm(msg) ) {
                    scope.$eval(clickAction)
                }
            });
        }
      }
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          // elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('JPTC.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function() {
  "use strict";

  angular.module("JPTC.theme").service("baUtil", baUtil);

  /** @ngInject */
  function baUtil($uibModal, localStorageService, $translate, $sce) {
    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt(hex.slice(1, 3), 16);
      var g = parseInt(hex.slice(3, 5), 16);
      var b = parseInt(hex.slice(5, 7), 16);
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    };

    this.hasAttr = function(elem, attrName) {
      var attr = $(elem).attr(attrName);
      return typeof attr !== typeof undefined && attr !== false;
    };
    this.toastOptions = function() {
      return {
          "autoDismiss": false,
          "positionClass": "toast-top-right",
          "type": "success",
          "timeOut": "10000",
          "extendedTimeOut": "2000",
          "allowHtml": false,
          "closeButton": true,
          "tapToDismiss": true,
          "progressBar": false,
          "newestOnTop": true,
          "maxOpened": 0,
          "preventDuplicates": false,
          "preventOpenDuplicates": false
      };
    }
    this.toastOptionsWithExtendedTimeout = function() {
      return {
          "autoDismiss": false,
          "positionClass": "toast-top-right",
          "type": "success",
          "timeOut": "20000",
          "extendedTimeOut": "2000",
          "allowHtml": false,
          "closeButton": true,
          "tapToDismiss": true,
          "progressBar": false,
          "newestOnTop": true,
          "maxOpened": 0,
          "preventDuplicates": false,
          "preventOpenDuplicates": false
      };
    }
    this.toastOptionsWithCount = function() {
      return {
          "autoDismiss": false,
          "positionClass": "toast-top-full-width",
          "type": "success",
          "timeOut": "500000",
          "extendedTimeOut": "2000",
          "allowHtml": true,
          "closeButton": true,
          "tapToDismiss": false,
          "progressBar": false,
          "newestOnTop": true,
          "maxOpened": 0,
          "preventDuplicates": false,
          "preventOpenDuplicates": false
      };
    }
    this.toastOptionsWithHTML = function() {
      return {
          "autoDismiss": false,
          "positionClass": "toast-top-right",
          "type": "success",
          "timeOut": "10000",
          "extendedTimeOut": "2000",
          "allowHtml": true,
          "closeButton": true,
          "tapToDismiss": true,
          "progressBar": false,
          "newestOnTop": true,
          "maxOpened": 0,
          "preventDuplicates": false,
          "preventOpenDuplicates": false
      };
    }
    this.isStringAndNotEmpty = function(obj) {
      return typeof obj === "string" && obj !== "";
    };

    this.isStringAndEmpty = function(obj) {
      return typeof obj === "string" && obj === "";
    };
    this.isEmptyObject = function(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }

      return true;
    };
    this.isNull = function(obj) {
      return obj === null;
    };
    this.isUndefined = function(obj) {
      return typeof obj === "undefined";
    };
    this.isUndefinedOrNull = function(obj) {
      return typeof obj === "undefined" || obj === null;
    };
    this.isUndefinedOrNullOrEmpty = function(obj) {
      return typeof obj === "undefined" || obj === null || obj === "";
    };
    this.isUndefinedOrNullOrEmptyObject = function(obj) {
      return (
        typeof obj === "undefined" ||
        obj === null ||
        obj === "" ||
        _isEmptyObject(obj)
      );
    };
    this.isUndefinedOrNullOrEmptyList = function(obj) {
      return (
        typeof obj === "undefined" ||
        obj === null ||
        typeof obj.length === "undefined" ||
        obj.length == 0
      );
    };
    this.isEmptyObject = _isEmptyObject;
    this.getNestedValueOfObject = function(obj, keyString) {
      if (
        obj !== Object(obj) ||
        typeof keyString === "undefined" ||
        keyString === null ||
        keyString === ""
      ) {
        return;
      }
      keyString = keyString.split(".");
      var currObj = obj[keyString.shift()];
      while (currObj && keyString.length) currObj = currObj[keyString.shift()];
      return currObj;
    };

    this.getErrorMessageOrDefault = function(error, defaultMessage) {
      if (error && error.errorMessage) {
          return error.errorMessage;
      } else if (error && error.data && error.data.errorMessage) {
          return error.data.errorMessage;
      } else {
          return defaultMessage;
      }
    };

    this.showConfirm = function(title, message, btnText, showCancelButton) {
          var lang = $translate.use();
          return $uibModal.open({
              animation: true,
              controller: function confirmCtrl($uibModalInstance) {
                  var confirmVm = this;
                  confirmVm.showCancelButton  = showCancelButton;
                  confirmVm.title = title || (lang == "jp" ? "保存内容の確認" : 'Are you sure?');
                  confirmVm.message = $sce.trustAsHtml( message || (lang == "jp" ? "変更内容を保存します。" : 'This will save all the changes made by you.'));
                  confirmVm.btnText = btnText || (lang == "jp" ? "保存" : 'Save Changes');
                  confirmVm.cancelbtnText = (lang == "jp" ? "キャンセル" : "Cancel");
                  confirmVm.ok = function () {
                      $uibModalInstance.close();
                  };
                  confirmVm.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
              },
              templateUrl: 'app/pages/components/confirm/confirm.modal.html',
              controllerAs:'confirmVm'
              }).result;

      };

    function _isEmptyObject(obj) {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            return false;
          }
        }

        return true;
    }

    this.makeQueryString = function(params) {
      var query = [];
      Object.keys(params).forEach(function(index) {
          if (params[index] && (typeof params[index] === 'object')) {
              var filters = params[index];
              Object.keys(filters).forEach(function(key) {
                  if (filters[key] instanceof Array) {
                      query.push("".concat(index, "=").concat(key, ":").concat(filters[key].join('|')));
                  }
              })
          } else {
              query.push("".concat(index, "=").concat(params[index]));
          }
      })
      return query.join('&');
    }

    this.getStartOfNextMonth = function(long) {
      var now = new Date(long);
      return new Date(now.getFullYear(), now.getMonth() + 1, 1).getTime();
    }

    this.getStartOfPrevMonth = function(long) {
      var now = new Date(long);
      return new Date(now.getFullYear(), now.getMonth() - 1, 1).getTime();
    }

    this.getStartOfNextDay = function(long) {
      var now = new Date(long);
      now.setHours(0,0,0,0);
      return now.setDate(now.getDate()+1);
    }

    this.getStartOfPrevDay = function(long) {
      var now = new Date(long);
      now.setHours(0,0,0,0);
      return now.setDate(now.getDate()-1);
    }

    this.getStartDateOfMonth = function(long) {
      var now = new Date();
      if (long) {
        now = new Date(long);
      }
      now.setFullYear(now.getFullYear(), now.getMonth(), 1);
      now.setHours(0,0,0,0);
      return now;
    }

    this.getStartOfDay = function(long) {
      var now = new Date();
      if (long) {
        now = new Date(long);
      }
      now.setHours(0,0,0,0);
      return now;
    }

    this.getAccountDto = function () {
      return localStorageService.get('loginResponse').accountDto;
    }




    this.isNormalSystemUser = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.accountTypes[0] == 'NORMAL' &&
        accountDto.organisation.organisationTypes[0] == 'ADMIN'
      ) {
        return true
      }
      return false;
    }



    this.isSystemUser = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("ADMIN") >= 0
      ) {
        return true
      }
      return false;
    }

    this.isSystemAdmin = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.accountTypes[0] == 'ADMIN' &&
        accountDto.organisation.organisationTypes[0] == 'ADMIN'
      ) {
        return true
      }
      return false;
    }

    this.isMerchant = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("MERCHANT") >= 0
      ) {
        return true
      }
      return false;
    }

    this.isMerchantAndDeviceOwner = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        (accountDto &&
        accountDto.organisation) &&
        (accountDto.organisation.organisationTypes.indexOf("MERCHANT") >= 0 &&
        accountDto.organisation.organisationTypes.indexOf("DEVICE_OWNER") >= 0)
      ) {
        return true
      }
      return false;
    }

    this.isMerchantOrMerchantAndDeviceOwner = function () {
      if (this.isMerchant() || this.isMerchantAndDeviceOwner()) {
        return true
      }
      return false;
    }

    this.isDeviceOwner = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("DEVICE_OWNER") >= 0
      ) {
        return true
      }
      return false;
    }

    this.isDeviceOwnerAdmin = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("DEVICE_OWNER") >= 0 &&
        accountDto.accountTypes &&
        accountDto.accountTypes.length &&
        accountDto.accountTypes.indexOf("ADMIN") >= 0
      ) {
        return true
      }
      return false;
    }

    this.isMerchantOrDeviceOwner = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("MERCHANT") >= 0 ||
        accountDto.organisation.organisationTypes.indexOf("DEVICE_OWNER") >= 0
      ) {
        return true
      }
      return false;
    }

    this.isMerchantAdmin = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("MERCHANT") >= 0 &&
        accountDto.accountTypes &&
        accountDto.accountTypes.length &&
        accountDto.accountTypes.indexOf("ADMIN") >= 0
      ) {
        return true
      }
      return false;
    }

    this.isPartnerUser = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("PARTNER") >= 0
      ) {
        return true
      }
      return false;
    }


    this.isNormalOfficeUser = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.accountTypes[0] == 'NORMAL' &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("OFFICE") >= 0
      ) {
        return true
      }
      return false;
    }

    this.isOfficeUser = function () {
      var accountDto = localStorageService.get('loginResponse').accountDto;
      if (
        accountDto &&
        accountDto.organisation &&
        accountDto.organisation.organisationTypes.indexOf("OFFICE") >= 0
      ) {
        return true
      }
      return false;
    }

    this.exportToCsv = function (filename, rows) {
      var processRow = function (row) {
          var finalVal = '';
          for (var j = 0; j < row.length; j++) {
              var innerValue = row[j] === null ? '' : row[j].toString();
              if (row[j] instanceof Date) {
                  innerValue = row[j].toLocaleString();
              };
              var result = innerValue.replace(/"/g, '""');
              if (result.search(/("|,|\n)/g) >= 0)
                  result = '"' + result + '"';
              if (j > 0)
                  finalVal += ',';
              finalVal += result;
          }
          return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
          csvFile += processRow(rows[i]);
      }

      var strArray = Encoding.stringToCode(csvFile);
      var sjisArray = Encoding.convert(strArray, "SJIS", "UNICODE");
      var uint8Array = new Uint8Array(sjisArray);

      var blob = new Blob([uint8Array], { type: "text/csv;" });

      // var blobUtf8 = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
      // var blob = window.Encoding.convert(blobUtf8, 'SJIS', 'UTF8')
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, filename);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", filename);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
  }

  // convert 2019年05月20日 to timestamp of 20/5/2019
  this.convertJpDateToTimestamp = function(dateString) {
    if(!dateString) return null;
    var date_arr = dateString.match(/\d+/g).map(Number);
    if(date_arr.length !== 3) return null;
    else {
      return new Date( date_arr[1] + "/" + date_arr[2] + "/" + date_arr[0] ).getTime()
    }
  }


  this.isValueWithoutSpecialCharacter = function(value) {
    if( this.isUndefinedOrNullOrEmpty(value) ) {
      return false;
    }
    else if( typeof value === "string" || typeof value === "number") {
      var regex = /^.*[-.,~!@#$%^&*;:=_+\\/'"?<>\(\)\{\}\[\]]{1,}/;
      if(value.match(regex) === null)
        return true;
      else
        return false;
    }
    else {
      return true;
    }
  }

  this.isValidDeviceSerial = function(deviceSerial) {
    if( this.isUndefinedOrNullOrEmpty(deviceSerial) ) {
      return false;
    }
    else if( typeof deviceSerial === "string" || typeof deviceSerial === "number" ) {
      var validatedStr = deviceSerial.replace( /[^a-zA-Z0-9_-]*/g, '');
      if( validatedStr == deviceSerial && validatedStr.length > 0 )
        return true;
      else
        return false;
    }
    else {
      return true;
    }
  }

  this.geti18nDateForJP = function () {
    return {
        previousMonth : '前月',
        nextMonth     : '来月',
        months        : ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
        weekdays      : ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
        weekdaysShort : ["日", "月", "火", "水", "木", "金", "土"]
    };
  }

  this.getPageSize = function () {
    var perPage = localStorageService.get('perPage');
    if(!this.isUndefinedOrNullOrEmpty(perPage) && !isNaN(perPage)) {
      return Number(perPage);
    }
    this.setPageSize(10);
    return 10;
  }

  this.getDefaultPageSize = function (moduleName) {
    var defaultSize = localStorageService.get('pageSize')[moduleName].defaultValue;
    if(!this.isUndefinedOrNullOrEmpty(defaultSize) && !isNaN(defaultSize)) {
      return Number(defaultSize);
    }
  }

  this.setPageSize = function (perPage) {
    if(!this.isUndefinedOrNullOrEmpty(perPage) && !isNaN(perPage)) {
      localStorageService.set('perPage', perPage);
    }
  }

  // https://stackoverflow.com/questions/847185/convert-a-unix-timestamp-to-time-in-javascript
  this.timeConverter = function(t) {
    var a = new Date(t);
    var today = new Date();
    var yesterday = new Date(Date.now() - 86400000);

    if($translate.use() === "jp") {
      var year = a.getFullYear();
      var month = ('0' + (a.getMonth()+1)).slice(-2);
      var date = a.getDate();
      var hour = a.getHours();
      var min = ('0' + a.getMinutes()).slice(-2);
      if (a.setHours(0,0,0,0) == today.setHours(0,0,0,0))
        return '今日 ' + hour + ':' + min;
      else if (a.setHours(0,0,0,0) == yesterday.setHours(0,0,0,0))
        return '昨日 ' + hour + ':' + min;
      else {
        // return year + '年' + month + '月' + date + '日 ' + hour + ':' + min;
        return year + '/' + month + '/' + date + ' ' + hour + ':' + min;
      }
    }
    else {
      // var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      // var month = months[a.getMonth()];
      var year = a.getFullYear();
      var month = ('0' + (a.getMonth()+1)).slice(-2);
      var date = a.getDate();
      var hour = a.getHours();
      var min = ('0' + a.getMinutes()).slice(-2);
      if (a.setHours(0,0,0,0) == today.setHours(0,0,0,0))
        return 'Today, ' + hour + ':' + min;
      else if (a.setHours(0,0,0,0) == yesterday.setHours(0,0,0,0))
        return 'Yesterday, ' + hour + ':' + min;
      // else if (year == today.getFullYear())
      //   return date + ' ' + month + ', ' + hour + ':' + min;
      else
        return year + '/' + month + '/' + date + ' ' + hour + ':' + min;
    }
  }

  this.formatPinCode = function(value, pattern) {
    var
      i = 0,
      v = value.toString();
    return pattern.replace(/#/g, function (_) {
      return v[i++];
    });
  }

  this.convertArrayBufferToBase64 = function(arrayBuffer) {
    var base64    = ''
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

    var bytes         = new Uint8Array(arrayBuffer)
    var byteLength    = bytes.byteLength
    var byteRemainder = byteLength % 3
    var mainLength    = byteLength - byteRemainder

    var a, b, c, d
    var chunk

    // Main loop deals with bytes in chunks of 3
    for (var i = 0; i < mainLength; i = i + 3) {
      // Combine the three bytes into a single integer
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

      // Use bitmasks to extract 6-bit segments from the triplet
      a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
      b = (chunk & 258048)   >> 12 // 258048   = (2^6 - 1) << 12
      c = (chunk & 4032)     >>  6 // 4032     = (2^6 - 1) << 6
      d = chunk & 63               // 63       = 2^6 - 1

      // Convert the raw binary segments to the appropriate ASCII encoding
      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
      chunk = bytes[mainLength]

      a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

      // Set the 4 least significant bits to zero
      b = (chunk & 3)   << 4 // 3   = 2^2 - 1

      base64 += encodings[a] + encodings[b] + '=='
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

      a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
      b = (chunk & 1008)  >>  4 // 1008  = (2^6 - 1) << 4

      // Set the 2 least significant bits to zero
      c = (chunk & 15)    <<  2 // 15    = 2^4 - 1

      base64 += encodings[a] + encodings[b] + encodings[c] + '='
    }

    return base64
  }

  this.checkForInvalidExtension = function(fileName, allowedExtensions) {
    var extensionNotFound = true;
    for (var i = 0; i < allowedExtensions.length; i++) {
      if(fileName.endsWith(allowedExtensions[i])) {
        extensionNotFound = false;
      }
    }
    return extensionNotFound;
  }

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
(function () {
    'use strict';

    angular
        .module('JPTC.theme')
        .factory('FormUtils', FormUtils);

    function FormUtils(baUtil, $log, $rootScope) {
        var service = {};
        service.resolve = resolve;
        service.formHasErrors = formHasErrors;
        service.submitForm = submitForm;

        service.allForms = {}; 
        service.setForms = setForms;
        service.getForms = getForms;

        service.setTouchedToTrue = setTouchedToTrue;

        return service;

        function formHasErrors(form) {
            if (baUtil.isUndefinedOrNull(form)) {
                return false;
            }

            return form.$invalid;
        }


        function setForms(forms) {
            service.allForms = angular.copy(forms, service.allForms);
        }

        function getForms() {
            return service.allForms || {};
        }

        function setTouchedToTrue(form) {
            if (form.$invalid) {
                angular.forEach(form.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        if (errorField.$setTouched) {
                            errorField.$setTouched();
                        }
                    });
                });
            }
        }

        function submitForm(form) {
            if (baUtil.isUndefinedOrNull(form)) {
                return;
            }

            if (form.$setSubmitted) {
                form.$setSubmitted();
                $rootScope.$broadcast('formSubmitted', form);
            }
        }

        function resolve(errorMapping, form, callback) {
            var defCallback = function (message, formElementName, errorType) {
                $log.error(formElementName + ' has a error=' + message);
            };

            var func = callback || defCallback;
            if (baUtil.isUndefinedOrNullOrEmptyObject(errorMapping)) {
                $log.error('error mapping not defined');
                return;
            }

            var errors = form.$error;
            if (baUtil.isUndefinedOrNull(form) || baUtil.isUndefinedOrNullOrEmptyObject(errors)) {
                return;
            }

            // errorType is required , min, max, pattern
            for (var errorType in errors) {
                if (!errors.hasOwnProperty(errorType)) {
                    continue;
                }

                var fieldsWithError = errors[errorType];
                if (baUtil.isUndefinedOrNullOrEmptyList(fieldsWithError)) {
                    continue;
                }

                // Always show first error. If error still persistent, they will be shown next time the submit button is pressed
                var fieldError = fieldsWithError[0];
                var formElementName = fieldError.$name;

                if (!errorMapping.hasOwnProperty(formElementName)) {
                    $log.error('Form element ' + formElementName + ' has errors but error string for this form element is not defined');
                    return;
                }

                var formElementErrors = errorMapping[formElementName];
                if (!formElementErrors.hasOwnProperty(errorType)) {
                    $log.error('Form element ' + formElementName + ' has errors for type ' + errorType + ' . Could not find mapping string for this error');
                    return;
                }

                // Only show one error at a time
                var errorToShow = formElementErrors[errorType];
                func(errorToShow, formElementName, errorType);
            }
        }
    }
})();

/**
 * @author m.Sehgal
 * created on 11.06.2019
 */
 (function () {
  "use strict";

  angular.module("JPTC.theme").service("hotUtil", hotUtil);

  /** @ngInject */
  function hotUtil(baUtil, DeviceRequestUtilService, $translate) {
    // utility functions

    // read more http://php.net/manual/en/function.mb-strwidth.php
    function mbCharWidth(input) {
      var len = 0;
      var code = input.charCodeAt(0);
      if (
        (code >= 0x0020 && code <= 0x1fff) ||
        (code >= 0xff61 && code <= 0xff9f)
      ) {
        len = 1; // half width
      } else if ((code >= 0x2000 && code <= 0xff60) || code >= 0xffa0) {
        len = 2; // full width
      }
      return len;
    }

    function isInteger(value) {
      return (
        !isNaN(value) &&
        (function (x) {
          return (x | 0) === x;
        })(parseFloat(value))
      );
    }

    // make sure every function
    //   returns true if not satisfied else false
    var validatorList = {
      required: function (query) {
        return (
          baUtil.isUndefinedOrNullOrEmpty(query) ||
          (typeof query == "string" && query.trim() == "")
        );
      },

      stringLength: function (query, len) {
        if (typeof query === "string" || typeof query === "number") {
          return (query + "").length > len;
        } else {
          return false;
        }
      },

      stringAlphanumeric: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          query = query + "";
          return query.replace(/[^a-zA-Z0-9]*/g, "") != query;
        } else {
          return false;
        }
      },

      stringAlphanumericContainsSpace: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          query = query + "";
          return query.replace(/[^a-zA-Z0-9\s]*/g, "") != query;
        } else {
          return false;
        }
      },

      stringDate: function (query) {
        if (
          baUtil.isUndefinedOrNullOrEmpty(query) ||
          (typeof query == "string" && query.trim() == "")
        ) {
          return false;
        }
        var pattern = new RegExp(
          /^(\d{4})\/(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])$/
        );
        var match = pattern.exec(query);
        if (match == null) {
          return true;
        } else {
          var year = match[1];
          var month = match[2] * 1;
          var day = match[3] * 1;
          var date = new Date(year, month - 1, day); // because months starts from 0.
          if (
            date.getFullYear() == year &&
            date.getMonth() == month - 1 &&
            date.getDate() == day
          ) {
            return false;
          } else {
            return true;
          }
        }
      },

      stringFullWidth: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          var fullWidthOnly = true;
          for (var i = 0, l = query.length; i < l; i++) {
            if (mbCharWidth(query[i]) !== 2) {
              fullWidthOnly = false;
              break;
            }
          }

          return !fullWidthOnly;
        } else {
          return false;
        }
      },
      // numeric code
      numeric: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          query = query + "";
          return query.replace(/[^0-9]*/g, "") != query;
        } else {
          return false;
        }
      },

      // numericOneToFive code
      numericOneToFive: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          query = query + "";
          return query.replace(/[^1-5]*/g, "") != query;
        } else {
          return false;
        }
      },

      // numericZeroToOne code
      numericZeroToOne: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          query = query + "";
          return query.replace(/[^0-1]*/g, "") != query;
        } else {
          return false;
        }
      },

      // numericOneToTwo code
      numericOneToTwo: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          query = query + "";
          return query.replace(/[^1-2]*/g, "") != query;
        } else {
          return false;
        }
      },

      // numericOneToThree code
      numericOneToThree: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          query = query + "";
          return query.replace(/[^1-3]*/g, "") != query;
        } else {
          return false;
        }
      },

      stringHalfWidth: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          var halfWidthOnly = true;
          for (var i = 0, l = query.length; i < l; i++) {
            if (mbCharWidth(query[i]) !== 1) {
              halfWidthOnly = false;
              break;
            }
          }

          return !halfWidthOnly;
        } else {
          return false;
        }
      },

      stringPhone: function (query, callback) {
        if (
          baUtil.isUndefinedOrNullOrEmpty(query) ||
          (typeof query == "string" && query.trim() == "")
        ) {
          return false;
        } else if (typeof query === "string" || typeof query === "number") {
          var pattern = new RegExp(/(?=^\d{1,}-?\d{1,}-?\d{1,}$).{11,13}/);
          return pattern.exec(query) == null || query.length > 13
            ? true
            : false;
        } else {
          return false;
        }
      },

      stringEmail: function (query, callback) {
        if (
          baUtil.isUndefinedOrNullOrEmpty(query) ||
          (typeof query == "string" && query.trim() == "")
        ) {
          return false;
        } else if (typeof query === "string" || typeof query === "number") {
          var pattern = new RegExp(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
          return pattern.exec(query) == null || query.length > 240
            ? true
            : false;
        } else {
          return false;
        }
      },

      stringPincode: function (query) {
        if (typeof query === "string" || typeof query === "number") {
          var pattern = new RegExp(/^\d{3}-?\d{4}$/g);
          return pattern.exec(query) == null ? true : false;
        } else {
          return false;
        }
      },
      // the function stringLengthFullHalf has been created specially for edit jesca applicaiton page for field number id: 17 installationCompanyName please dont change anything in case if required create a copy.
      stringLengthFullHalf: function (query, len) {
        if (typeof query === "string" || typeof query === "number") {
          var lengthFullHalf = 0;
          for (var i = 0, l = query.length; i < l; i++) {
            if (mbCharWidth(query[i]) == 2) {
              lengthFullHalf = lengthFullHalf + 2;
            } else {
              lengthFullHalf++;
            }
          }
          /* 
           we need to display error if the total bytes in a string having both full-width and half-width characters passed to the function exceeds the length passed to the function.
          
           */
          if (lengthFullHalf <= len) {
            return false; //validator is not displaying error if we return false
          } else {
            return true; //validator is displaying error if we return true
          }
        }
      },
    };

    var validatorToErrMsgMapping = {
      numericOneToFive: "device.request.edit.err.msg.numericOneToFive.field",
      numericZeroToOne: "device.request.edit.err.msg.numericZeroToOne.field",
      numericOneToTwo: "device.request.edit.err.msg.numericOneToTwo.field",
      numericOneToThree: "device.request.edit.err.msg.numericOneToThree.field",
      numeric: "device.request.edit.err.msg.numeric.field",
      required: "device.request.edit.err.msg.required.field",
      stringLength:
        "device.request.edit.err.msg.empty.field.with.width.n.or.empty",
        stringLengthFullHalf:
        "device.request.edit.err.msg.stringLengthFullHalf",
      stringAlphanumeric: "device.request.edit.err.msg.non.alphanumeric",
      stringAlphanumericContainsSpace: "device.request.edit.err.msg.non.space.alphanumeric",
      stringDate: "device.request.edit.err.msg.date.or.non.empty.field",
      stringFullWidth: "device.request.edit.err.msg.fullwidth.field",
      stringHalfWidth: "device.request.edit.err.msg.halfwidth.field",
      stringPhone: "device.request.edit.err.msg.phone.invalid",
      stringEmail: "device.request.edit.err.msg.email.invalid",
      stringPincode: "device.request.edit.err.msg.zip.code.invalid",
    };

    // function to aggregate validators
    // and returns the message if not satisfied else false
    this.aggregatedValidator = function (validators, value, row, paramName) {
      if (!validators || !validators.length) return "";
      for (var i = 0; i < validators.length; i++) {
        var d = validators[i];
        if (validatorList[d.split("_")[0]](value, d.split("_")[1])) {
          return $translate.instant(validatorToErrMsgMapping[d.split("_")[0]], {
            row: Number(row) + 1,
            param: paramName,
            n: d.split("_")[1],
          });
        }
      }
      return "";
    };

    // old validators
    this.validatorRequired = function (query, callback) {
      if (baUtil.isUndefinedOrNullOrEmpty(query)) callback(false);
      else callback(true);
    };

    // NOTE: doesn't include required validation
    this.validatorHalfWidthOrEmpty = function (query, callback) {
      if (typeof query === "string" && query !== "") {
        var halfWidthOnly = true;
        for (var i = 0, l = query.length; i < l; i++) {
          if (mbCharWidth(query[i]) !== 1) {
            halfWidthOnly = false;
            break;
          }
        }

        callback(halfWidthOnly);
      } else {
        callback(true);
      }
    };

    // includes required validation
    this.validatorHalfWidthOrNonEmpty = function (query, callback) {
      if (typeof query === "string" && query !== "") {
        var halfWidthOnly = true;
        for (var i = 0, l = query.length; i < l; i++) {
          if (mbCharWidth(query[i]) !== 1) {
            halfWidthOnly = false;
            break;
          }
        }

        callback(halfWidthOnly);
      } else {
        callback(false);
      }
    };

    // NOTE: doesn't include required validation
    this.validatorFullWidthOrEmpty = function (query, callback) {
      if (typeof query === "string" && query !== "") {
        var fullWidthOnly = true;
        for (var i = 0, l = query.length; i < l; i++) {
          if (mbCharWidth(query[i]) !== 2) {
            fullWidthOnly = false;
            break;
          }
        }

        callback(fullWidthOnly);
      } else {
        callback(true);
      }
    };

    // includes required validation with numeric with width
    this.validatorNumericOrNonEmptyWithWidth = function (query, callback) {
      if (isInteger(query) && (query + "").length < 7) {
        callback(true);
      } else {
        callback(false);
      }
    };

    // includes required validation
    this.validatorFullWidthOrNonEmpty = function (query, callback) {
      if (typeof query === "string" && query !== "") {
        var fullWidthOnly = true;
        for (var i = 0, l = query.length; i < l; i++) {
          if (mbCharWidth(query[i]) !== 2) {
            fullWidthOnly = false;
            break;
          }
        }
        callback(fullWidthOnly);
      } else {
        callback(false);
      }
    };

    // NOTE: doesn't include required validation
    this.validatorNumericOrEmpty = function (query, callback) {
      if (baUtil.isUndefinedOrNullOrEmpty(query)) {
        callback(true);
      } else if (typeof query === "string" || typeof query === "number") {
        if (isInteger(query)) {
          callback(true);
        } else {
          callback(false);
        }
      } else {
        callback(false);
      }
    };

    // NOTE: doesn't include required validation
    this.validatorNumericOrNonEmpty = function (query, callback) {
      if (isInteger(query)) {
        callback(true);
      } else {
        callback(false);
      }
    };

    // Check if date is valid by leap year in format 2019年06月12日
    this.validatorDateOrNonEmpty = function (query, callback) {
      var pattern = new RegExp(
        /^(\d{4})年(0?[1-9]|1[012])月(0?[1-9]|[12][0-9]|3[01])日$/
      );
      var match = pattern.exec(query);
      if (match == null) {
        callback(false);
      } else {
        var year = match[1];
        var month = match[2] * 1;
        var day = match[3] * 1;
        var date = new Date(year, month - 1, day); // because months starts from 0.
        if (
          date.getFullYear() == year &&
          date.getMonth() == month - 1 &&
          date.getDate() == day
        ) {
          callback(true);
        } else {
          callback(false);
        }
      }
    };

    // Check if date is valid by leap year in format 2019年06月12日
    this.validatorDateOrEmpty = function (query, callback) {
      if (baUtil.isUndefinedOrNullOrEmpty(query)) {
        callback(true);
      } else {
        var pattern = new RegExp(
          /^(\d{4})年(0?[1-9]|1[012])月(0?[1-9]|[12][0-9]|3[01])日$/
        );
        var match = pattern.exec(query);
        if (match == null) {
          callback(false);
        } else {
          var year = match[1];
          var month = match[2] * 1;
          var day = match[3] * 1;
          var date = new Date(year, month - 1, day); // because months starts from 0.
          if (
            date.getFullYear() == year &&
            date.getMonth() == month - 1 &&
            date.getDate() == day
          ) {
            callback(true);
          } else {
            callback(false);
          }
        }
      }
    };

    // custom validation for branch code
    this.customBranchCode = function (query, callback) {
      if (baUtil.isUndefinedOrNullOrEmpty(query)) {
        callback(false);
      } else if (typeof query === "string" || typeof query === "number") {
        var validatedStr = query.replace(/[^a-zA-Z0-9]*/g, "");
        if (
          validatedStr == query &&
          validatedStr.length < 7 &&
          validatedStr.length > 0
        )
          callback(true);
        else callback(false);
      } else {
        callback(false);
      }
    };

    // custom validation for device serial (non mandatory)
    this.customDeviceSerial = function (query, callback) {
      if (baUtil.isUndefinedOrNullOrEmpty(query)) {
        callback(true);
      } else if (typeof query === "string" || typeof query === "number") {
        var validatedStr = query.replace(/[^a-zA-Z0-9_-]*/g, "");
        if (validatedStr == query && validatedStr.length > 0) callback(true);
        else callback(false);
      } else {
        callback(true);
      }
    };

    // Check if phone number is valid if not empty
    this.validatorPhoneOrEmpty = function (query, callback) {
      if (baUtil.isUndefinedOrNullOrEmpty(query)) {
        callback(true);
      } else if (typeof query === "string" || typeof query === "number") {
        var pattern = new RegExp(/(?=^\d{1,}-?\d{1,}-?\d{1,}$).{11,13}/);
        var match = pattern.exec(query);
        if (match == null) {
          callback(false);
        } else {
          callback(true);
        }
      } else {
        callback(false);
      }
    };

    // Check if email is valid if not empty
    this.validatorEmailOrEmpty = function (query, callback) {
      if (baUtil.isUndefinedOrNullOrEmpty(query)) {
        callback(true);
      } else if (typeof query === "string" || typeof query === "number") {
        var pattern = new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        var match = pattern.exec(query);
        if (match == null) {
          callback(false);
        } else {
          callback(true);
        }
      } else {
        callback(false);
      }
    };
  }
})();

/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.application')
        .controller('ApplicationInfoCtrl', ApplicationInfoCtrl);

    /** @ngInject */
    function ApplicationInfoCtrl() {
        var vm = this;

        vm.EMoneyTypes = ['Transport', 'nanaco', 'WAON', 'Edy', 'QUICPay＋', 'iD' ]
        vm.QRMoneyTypes = [ 'LINEPay', 'WeChatPay', 'Alipay', 'RakutenPay' ]
        vm.chargesBuiltinInitialTypes = [ '1~3 money', '4~5 money', '6 money', 'QR money registration fee']
        vm.chargesBuiltinMonthlyTypes = [ '1~3 money', '4~5 money', '6 money', '+QR money' ]
        vm.chargesExternalInitialTypes = [ '1~3 money', '4~5 money', '6 money', 'QR money registration fee']
        vm.chargesExternalMonthlyTypes = [ '1~3 money', '4~5 money', '6 money', '+QR money' ]
    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.application')
        .factory('ApplicationService', ApplicationService);

    /** @ngInject */
    function ApplicationService(baUtil, $http, API_CONFIG, AuthService) {
        var service = {};
        return service;
        
        
    }
})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('address', address);

	/** @ngInject */
	function address($timeout) {
		return {
			restrict: 'E',
			templateUrl: 'app/pages/components/address/address.html',
			controller: addressCtrl,
			controllerAs: 'vm',
			scope: {
				label: '@',
				address: '=',
				required: '=',
				streetAddressRequired: '=',
				form: '=',
				formKey: '=',
				isEdit: '=',
			},
			link: function(scope, element, attrs, controller) {
                scope.$watch('required', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue);
                    }
				});
				scope.$watch('address', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'address');
                    }
                }, true);
            }
		}
	}

	function addressCtrl($scope, ServiceContractService, baUtil) {
		var vm = this;
		vm.address = $scope.address;
		vm.onPinCodeChange = onPinCodeChange;
		vm.onZipSelected = onZipSelected;
		vm.required = $scope.required;
		vm.streetAddressRequired = $scope.streetAddressRequired;
		vm.addressForm = $scope.form;
		vm.formKey = $scope.formKey;
		vm.isEdit =  baUtil.isUndefinedOrNull($scope.isEdit) ? true : $scope.isEdit;
		vm.init = init;
		$scope.baUtil = baUtil;

		if (vm.address) {
			vm.address.city = (vm.address.city || '') + ' ' + (vm.address.town || '');
		 }
        

		vm.label = $scope.label || 'Address'

		function onPinCodeChange(pincode) {
			if(!baUtil.isUndefinedOrNullOrEmpty(pincode)) {
				pincode = pincode.replace("-", "");
			}
			return ServiceContractService.getDataFromPinCode(pincode)
		}

		function onZipSelected(data) {
			vm.address.pin = baUtil.formatPinCode(data.pin, '###-####');
			vm.address.prefecture = data.prefecture;
			vm.address.city = data.city + ' ' + data.town;
		}

		function init(val, key) {
			vm[key] = val;
		}

	}

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('contact', contact);

	/** @ngInject */
	function contact($timeout) {
		return {
			restrict: 'E',
			templateUrl: 'app/pages/components/contact/contact.html',
			controller: contactCtrl,
			controllerAs: 'vm',
			scope: {
				label: '@',
				contact: '=',
				contactHours: '=',
				contactType: '=',
				multiple: '=',
				required: '=',
				displayEmail: '=',
				emailRequired: '=',
				form: '=',
				formKey: '=',
				getLabel: '=',
				isEdit: '=',
				contactEntity: '=',
			},
			link: function(scope, element, attrs, controller) {
                scope.$watch('required', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'required');
                    }
				});
				scope.$watch('contact', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'contact');
                    }
                }, true);
            }
		}
	}

	function contactCtrl($scope, ServiceContractService, baUtil, $translate) {
		var vm = this;
		vm.contact = $scope.contact;
		vm.contactHours = $scope.contactHours;
		vm.contactType = $scope.contactType;
		vm.required = $scope.required;
		vm.displayEmail = $scope.displayEmail;
		vm.emailRequired = $scope.emailRequired;
		vm.contactForm = $scope.form;
		vm.formKey = $scope.formKey;
		vm.getLabel = $scope.getLabel;
		vm.contactEntity = $scope.contactEntity;
		vm.isEdit =   baUtil.isUndefinedOrNull($scope.isEdit) ? true : $scope.isEdit;
		vm.isMultiple = $scope.multiple || false;
		vm.addNewRow = addNewRow;
		vm.getLang = getLang;
		vm.translate = translate;
		vm.removeRow = removeRow;
		vm.init = init;
		$scope.baUtil = baUtil;

		if (baUtil.isUndefinedOrNull(vm.contact)) {
			vm.contact = [{}]
		}

		if (baUtil.isUndefinedOrNullOrEmptyList(vm.contact)) {
			vm.contact.push({})
		}

		vm.label = $scope.label || 'Contact'

		function getLang() {
			return $translate.use();
		}

		function translate(key) {
			return $translate.instant(key);
		}

		function addNewRow() {
            vm.contact.push({});
		}

		function removeRow(index) {
            vm.contact.splice(index, 1);
		}

		function init(val, key) {
			vm[key] = val;
		}


	}

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('datepicker', datepicker);

	/** @ngInject */
	function datepicker($timeout) {
		return {
			restrict: 'E',
			templateUrl: 'app/pages/components/datepicker/datepicker.html',
			controller: datepickerCtrl,
			controllerAs: 'vm',
			scope: {
				date: '=',
				required: '=',
				format: '=',
				form: '=',
				options: '=',
			},
			link: function(scope, element, attrs, controller) {
                scope.$watch('required', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'required');
                    }
				});
				scope.$watch('date', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'date');
                    }
				}, true);
				// element.on('change', function() {
				// 	$timeout(function() {
				// 		scope.date = 'hello';
				// 	});
				// });
            }
		}
	}

	function datepickerCtrl($scope, baUtil) {
		var vm = this;
		vm.required = $scope.required;
		vm.dateFrom = $scope.form;
		vm.open = open;
        vm.opened = false;
        vm.format = $scope.format || 'yyyy/MM/dd';
		vm.types = {};
		vm.init = init;

		vm.baUtil = baUtil;

		vm.options = $scope.options || {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date(1901,0,1),
            maxDate : new Date(2100,0,1)
		};
		
		function open() {
            vm.opened = true;
		}
		
		function init(val, key) {
			vm[key] = val;
		}

	}

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('deviceFields', deviceFields);

	/** @ngInject */
	function deviceFields($timeout) {
		return {
			restrict: 'E',
			templateUrl: 'app/pages/components/device-fields/device-fields.html',
			controller: deviceFieldsCtrl,
			controllerAs: 'vm',
			scope: {
				type: '=',
				model: '=',
				source: '=',
				readOnly: "="
			},
			link: function(scope, element, attrs, controller) {
				scope.$watch('model', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'model');
                    }
                }, true);
            }
		}
	}

	function deviceFieldsCtrl($scope) {
		var vm = this;
		vm.type = $scope.type;
		vm.dropdownOptions = $scope.source || [];
		vm.readOnly = $scope.readOnly || false;
		vm.init = init;

		function init(val, key) {
			vm[key] = val;
		}

	}

})();
/**
 * Half Width Character validation on form elements
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('halfWidthLimit', halfWidthLimit);

	/** @ngInject */
	function halfWidthLimit($timeout, baUtil, hotUtil) {
		return {
			restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {

                ngModel.$validators.halfWidthLimit = function (modelValue) {
                    if (modelValue == null || modelValue == 'undefined' || modelValue.length === 0) {
                        return true;
                    }

                    var input = modelValue;
                    var code = input.charCodeAt(0);
                    if ((code >= 0x0020 && code <= 0x1FFF) || (code >= 0xFF61 && code <= 0xFF9F)) {
                        return true; // half width
                    } else if ((code >= 0x2000 && code <= 0xFF60) || (code >= 0xFFA0)) {
                        return false; // full width
                    }
                };
            }
		}
	}

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('mobileNumber', mobileNumber);

	/** @ngInject */
	function mobileNumber($timeout, baUtil) {
		return {
			restrict: 'A',
            require: 'ngModel',
            scope: {
                regexToMatch: '='
            },
            link: function (scope, element, attrs, ngModel) {

                ngModel.$validators.mobilenumber = function (modelValue) {
                    if (modelValue == null || modelValue == 'undefined' || modelValue.length === 0) {
                        return true;
                    }
                    
                    //default pattern to use if no pattern is passed
                    var regex = /^.{7,}$/;

                    if (!baUtil.isUndefinedOrNullOrEmpty(scope.regexToMatch)) {
                        regex = new RegExp(scope.regexToMatch);   
                    }
                    var res = modelValue.match(regex) === null ? false : true;
                    return res;
                };
            }
		}
	}

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('ngCompile', ngCompile);

	/** @ngInject */
	function ngCompile($compile) {
		return function(scope, element, attrs) {
            scope.$watch(
                function(scope) {
                    // watch the 'compile' expression for changes
                    return scope.$eval(attrs.ngCompile);
                },
                function(value) {
                    // when the 'compile' expression changes
                    // assign it into the current DOM
                    element.html(value);
    
                    // compile the new DOM and link it to the current
                    // scope.
                    // NOTE: we only compile .childNodes so that
                    // we don't get into infinite loop compiling ourselves
                    $compile(element.contents())(scope);
                }
            );
      };
	}
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('numbersOnly', numbersOnly);

	/** @ngInject */
	function numbersOnly($timeout, baUtil) {
		return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(/[^0-9-]/g, '');
    
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return undefined;
                }            
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
	}

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('pagination', pagination);

	/** @ngInject */
	function pagination($timeout, $translate, baUtil, localStorageService, $state) {
		return {
			restrict: 'E',
			templateUrl: 'app/pages/components/pagination/pagination.html',
			scope: {
				query: '=',
                pageable: '=',
                totalPages: '=',
				totalElements: '=',
				paginateCallback: '='
			},
			link: function(scope, element, attrs, controller) {
				init();
				scope.$watch('query', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.query = newValue;
						init()
					}
                }, true);
				scope.$watch('pageable', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.pageable = newValue;
						init()
					}
                }, true);
				scope.$watch('totalPages', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.totalPages = newValue;
						init()
					}
                }, true);
				scope.$watch('totalElements', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.totalElements = newValue;
						init()
					}
				}, true);

				scope.getLang = function () {
		            return $translate.use();
		        };

				function init() {
					scope.query = scope.query;
					scope.pageable = scope.pageable;
					scope.totalPages = scope.totalPages;
					scope.totalElements = scope.totalElements;
					scope.displayData = {}

					var vm = this;

					var pageSizeValue = localStorageService.get('pageSize');

					if ($state.current.name == 'main.serviceContract.list') {
					    scope.pageSizeList = pageSizeValue.SERVICE_CONTRACT.pageSizes;
					}
					if ($state.current.name == 'main.deviceRequest.list') {
					    scope.pageSizeList = pageSizeValue.DEVICE_INSTALLATION.pageSizes;
					}
					if ($state.current.name == 'main.salesSettlements.monthly.list') {
					    scope.pageSizeList = pageSizeValue.SALES.pageSizes;
					}
					if ($state.current.name == 'main.salesSettlements.reports'){
						scope.pageSizeList = pageSizeValue.SALES.pageSizes;
					}
					if ($state.current.name == 'main.salesSettlements.daily.list') {
					    scope.pageSizeList = pageSizeValue.SALES.pageSizes;
					}
					if ($state.current.name == 'main.salesSettlements.oneItem.detail') {
					    scope.pageSizeList = pageSizeValue.PAYMENT_TRANSACTION.pageSizes;
					}
					if ($state.current.name == 'main.salesSettlements.settlementList') {
					    scope.pageSizeList = pageSizeValue.SETTLEMENT.pageSizes;
					}
					if ($state.current.name == 'main.salesSettlements.settlementDetail') {
						scope.pageSizeList = pageSizeValue.SETTLEMENT.pageSizes;
					}
					if ($state.current.name == 'main.serviceManagement.organisation.list') {
					    scope.pageSizeList = pageSizeValue.ORGANISATION.pageSizes;
					}
					if ($state.current.name == 'main.serviceManagement.users.list') {
					    scope.pageSizeList = pageSizeValue.ACCOUNT.pageSizes;
					}
					if ($state.current.name == 'main.deviceManagement.list') {
					    scope.pageSizeList = pageSizeValue.DEVICE_MANAGEMENT.pageSizes;
					}

					if ($state.current.name == 'main.deviceRequest.change') {
					    scope.pageSizeList = pageSizeValue.DEVICE_INSTALLATION.pageSizes;
					}

					if (scope.pageable.pageNumber === null) {
						return;
					}
					if (isNaN(scope.pageable.pageNumber)) {
						scope.pageable.pageNumber = 0;
					}
					else {
						var pageNumber = parseInt(scope.pageable.pageNumber);
						if (pageNumber < 0) {
							scope.pageable.pageNumber = 0;
						}
					}

					if (pageNumber > scope.totalPages) {
						scope.pageable.pageNumber = scope.totalPages;
					}

					scope.displayData.pageNumber = scope.pageable.pageNumber + 1
					scope.pageItemsEn = "Showing " + (((scope.displayData.pageNumber - 1) * scope.pageable.pageSize) + 1) + " - " + (scope.displayData.pageNumber * scope.pageable.pageSize > scope.totalElements ? scope.totalElements : scope.displayData.pageNumber * scope.pageable.pageSize) + " of " + scope.totalElements;

					scope.pageItemsJp = "" + scope.totalElements + " 件の中 " + (((scope.displayData.pageNumber - 1) * scope.pageable.pageSize) + 1) + " 件から " + (scope.displayData.pageNumber * scope.pageable.pageSize > scope.totalElements ? scope.totalElements : scope.displayData.pageNumber * scope.pageable.pageSize) + " 件までを表示";
				}

				scope.updateQuery = function(pageSize, pageType, displayPageNumber) {
					switch (pageType) {
						case 'SIZE':
							scope.query.pageNumber = 0
							break;
						case 'FIRST':
							scope.query.pageNumber = 0
							break;
						case 'LAST':
							scope.query.pageNumber = scope.totalPages - 1
							break;
						case 'NEXT':
							scope.query.pageNumber = scope.pageable.pageNumber + 1;
                            if (scope.query.pageNumber >= scope.totalPages) {
                                    scope.query.pageNumber = scope.totalPages - 1
                            }
							break;
						case 'PREV':
							scope.query.pageNumber = scope.pageable.pageNumber - 1
							break;
						case 'PAGE':
							scope.query.pageNumber = displayPageNumber - 1
							break;
						default:
							scope.query.pageNumber = scope.pageable.pageNumber
							break;
					}


					if (scope.displayData.pageNumber <= 0) {
							scope.query.pageNumber = 0
					}

					if (scope.displayData.pageNumber > scope.totalPages) {
							scope.query.pageNumber = scope.totalPages - 1
					}

					scope.query.pageSize = pageSize
					// update pageSize in localStorage to sustain it across page refresh
					baUtil.setPageSize(pageSize);
					scope.paginateCallback(scope.query)
				}

            }
		}
	}

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('paginationv2', pagination);

	/** @ngInject */
	function pagination($translate, baUtil, localStorageService, $state) {
		return {
			restrict: 'E',
			templateUrl: 'app/pages/components/pagination-v2/pagination.html',
			scope: {
				query: '=',
				currentPage: '=',
				currentPageSize:'=',
                totalPages: '=',
				totalElements: '=',
				paginateCallback: '='
			},
			link: function(scope, element, attrs, controller) {
				init();
				scope.$watch('query', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.query = newValue;
						init()
					}
                }, true);
				scope.$watch('currentPage', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.currentPage = newValue;
						init()
					}
				}, true);
				scope.$watch('currentPageSize', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.currentPageSize = newValue;
						init()
					}
                }, true);
				scope.$watch('totalPages', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.totalPages = newValue;
						init()
					}
                }, true);
				scope.$watch('totalElements', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
						scope.totalElements = newValue;
						init()
					}
				}, true);

				scope.getLang = function () {
		            return $translate.use();
		        };

				function init() {
					scope.query = scope.query;
					scope.currentPage = scope.currentPage;
					scope.currentPageSize = scope.currentPageSize;
					scope.totalPages = scope.totalPages;
					scope.totalElements = scope.totalElements;
					scope.displayData = {}

					var vm = this;

					var pageSizeValue = localStorageService.get('pageSize');


					if ($state.current.name == 'main.iosl.department.list') {
						scope.pageSizeList = pageSizeValue.OFFICE.pageSizes;
					}
					if ($state.current.name == 'main.iosl.employee.list') {
						scope.pageSizeList = pageSizeValue.OFFICE.pageSizes;
					}
					if ($state.current.name == 'main.iosl.usageRules.list') {
						scope.pageSizeList = pageSizeValue.OFFICE.pageSizes;
					}
					if ($state.current.name == 'main.iosl.deviceLinkage.list') {
						scope.pageSizeList = pageSizeValue.OFFICE.pageSizes;
					}
					if ($state.current.name == 'main.iosl.usageDetails.monthlyOrDaily') {
						scope.pageSizeList = pageSizeValue.OFFICE.pageSizes;
					}
					if ($state.current.name == 'main.iosl.usageDetails.oneItem') {
						scope.pageSizeList = pageSizeValue.OFFICE.pageSizes;
					}
					if ($state.current.name == 'main.iosl.terminalOperation.accountManagement'){
						scope.pageSizeList = pageSizeValue.OFFICE.pageSizes;
					}
					if ($state.current.name == 'main.iosl.terminalOperation.transmissionHistory'){
						scope.pageSizeList = pageSizeValue.OFFICE.pageSizes;
					}

					if (scope.currentPageSize < baUtil.getPageSize()) {
						scope.currentPageSize = baUtil.getPageSize();
					}

					if (scope.currentPage === null) {
						return;
					}
					if (isNaN(scope.currentPage)) {
						scope.currentPage = 0;
					}
					else {
						var pageNumber = parseInt(scope.currentPage);
						if (pageNumber < 0) {
							scope.currentPage = 0;
						}
					}

					if (pageNumber > scope.totalPages) {
						scope.currentPage = scope.totalPages;
					}

					scope.displayData.pageNumber = scope.currentPage + 1
					scope.pageItemsEn = "Showing " + (((scope.displayData.pageNumber - 1) * scope.currentPageSize) + 1) + " - " + (scope.displayData.pageNumber * scope.currentPageSize > scope.totalElements ? scope.totalElements : scope.displayData.pageNumber * scope.currentPageSize) + " of " + scope.totalElements;

					scope.pageItemsJp = "" + scope.totalElements + " 件の中 " + (((scope.displayData.pageNumber - 1) * scope.currentPageSize) + 1) + " 件から " + (scope.displayData.pageNumber * scope.currentPageSize > scope.totalElements ? scope.totalElements : scope.displayData.pageNumber * scope.currentPageSize) + " 件までを表示";
				}

				scope.updateQuery = function(pageSize, pageType, displayPageNumber) {
					switch (pageType) {
						case 'SIZE':
							scope.query.pageNumber = 0
							break;
						case 'FIRST':
							scope.query.pageNumber = 0
							break;
						case 'LAST':
							scope.query.pageNumber = scope.totalPages - 1
							break;
						case 'NEXT':
							scope.query.pageNumber = scope.currentPage + 1;
                            if (scope.query.pageNumber >= scope.totalPages) {
                                    scope.query.pageNumber = scope.totalPages - 1
                            }
							break;
						case 'PREV':
							scope.query.pageNumber = scope.currentPage - 1
							break;
						case 'PAGE':
							scope.query.pageNumber = displayPageNumber - 1
							break;
						default:
							scope.query.pageNumber = scope.currentPage
							break;
					}


					if (scope.displayData.pageNumber <= 0) {
							scope.query.pageNumber = 0
					}

					if (scope.displayData.pageNumber > scope.totalPages) {
							scope.query.pageNumber = scope.totalPages - 1
					}

					scope.query.pageSize = pageSize
					// update pageSize in localStorage to sustain it across page refresh
					baUtil.setPageSize(pageSize);
					scope.paginateCallback(scope.query)
				}

            }
		}
	}

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('positiveNumbersOnly', positiveNumbersOnly);

	/** @ngInject */
	function positiveNumbersOnly($timeout, baUtil) {
		return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(/[^0-9]/g, '');
    
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return undefined;
                }            
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
	}

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('serviceFee', serviceFee);

	/** @ngInject */
	function serviceFee() {
		return {
			restrict: 'E',
			templateUrl: 'app/pages/components/service-fee/serviceFee.html',
			controller: serviceFeeCtrl,
			controllerAs: 'vm',
			scope: {
				otherFeeModel: '=',
				qrOtherFeeModel: '=',
				baseFeeModel: '=',
				creditCardFeeModel: '=',
				model: '=',
				title: '@',
				subTitle: '@',
				paymentHandlingOption: '=',
				paymentDeductionOption: '=',
				deviceType: '=',
				modemType: '=',
				getLabel: '=',
				serviceFeeFrequency: '=',
				serviceFeeEdit: '=',
				isEdit: '=',
				form: '=',
				formKey: '=',
			},
			link: function(scope, element, attrs, controller) {
                scope.$watch('deviceType', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue);
                    }
                });
				scope.$watch('model', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'model');
                    }
                }, true);
				scope.$watch('otherFeeModel', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'otherFeeModel');
                    }
                }, true);
				scope.$watch('qrOtherFeeModel', function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'qrOtherFeeModel');
                    }
                }, true);
				scope.$watch('baseFeeModel',function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'baseFeeModel');
                    }
                }, true);
				scope.$watch('creditCardFeeModel',function(newValue, oldValue) {
                    if(!angular.equals(newValue, oldValue)) {
                        controller.init(newValue, 'creditCardFeeModel');
                    }
                }, true);
            }
		}
	}

	function serviceFeeCtrl($scope, $translate, baUtil) {
		var vm = this;
		vm.serviceFeeForm = $scope.form;
		vm.formKey = $scope.formKey;
		vm.model = $scope.model;
		vm.otherFeeModel =  $scope.otherFeeModel;
		vm.qrOtherFeeModel = $scope.qrOtherFeeModel;
		vm.baseFeeModel = $scope.baseFeeModel;
		vm.creditCardFeeModel = $scope.creditCardFeeModel;
		vm.title = $scope.title;
		vm.subTitle = $scope.subTitle;
		vm.paymentHandlingOption = $scope.paymentHandlingOption;
		vm.paymentDeductionOption = $scope.paymentDeductionOption;
		vm.deviceType = $scope.deviceType;
		vm.modemType = $scope.modemType;
		vm.getLabel = $scope.getLabel;
		vm.serviceFeeEdit = $scope.serviceFeeEdit;
		vm.isEdit =  baUtil.isUndefinedOrNull($scope.isEdit) ? true : $scope.isEdit;
		vm.serviceFeeFrequency = $scope.serviceFeeFrequency;
		vm.getLang = getLang;
		vm.appendRow = appendRow;
		vm.greaterThan = greaterThan;
		vm.init = init;
		

		




        var eMoneyOption = [];
        var qrMoneyOption = [];

		angular.forEach(vm.paymentHandlingOption.E_MONEY.key, function(value,key) {
            if( !vm.paymentHandlingOption.E_MONEY["inUse"][key] ) return;
            eMoneyOption.push(value);
        });

		angular.forEach(vm.paymentHandlingOption.QR_MONEY.key, function(value,key) {
            if( !vm.paymentHandlingOption.QR_MONEY["inUse"][key] ) return;
            qrMoneyOption.push(value);
        });

		vm.eMoneyOptionKey = eMoneyOption.map(function(key, index) {
			return index;
		})

		vm.qrMoneyOptionKey = qrMoneyOption.map(function(key, index) {
			return index;
		})

		function getLang() {
			return $translate.use();
		}

		function translate(key) {
			return $translate.instant(key);
		}

		function init(val, key) {
			vm[key] = val;
		}

		function greaterThan(rangeStart) {
			return function(item){
				return item >= rangeStart;
			  }
		}

		function appendRow(index, list, options, repeatIndex, type) {
			if(index > 5 && type === 'eMoney') {
				options.length = repeatIndex + 1
				return;
			}
			if(index > 13 && type === 'qrMoney') {
				options.length = repeatIndex + 1
				return;
			}
			if (index !== list.length) {
				if (baUtil.isUndefinedOrNull(options[repeatIndex + 1])) {
					options[repeatIndex + 1] = { rangeStart: index + 1 }
					return
				}
				options[repeatIndex + 1].rangeStart = index + 1
			}

			if (index === list.length) {
				options.length = repeatIndex + 1
			}
		}

	}

})();
/**
 * Number validation on service fee
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('serviceFeeNumberValidation', serviceFeeNumberValidation);

	/** @ngInject */
	function serviceFeeNumberValidation($timeout, baUtil) {
		return {
			restrict: 'A',
            require: 'ngModel',
            scope: {
                regexToMatch: '='
            },
            link: function (scope, element, attrs, ngModel) {

                ngModel.$validators.serviceFeeNumberValidation = function (modelValue) {
                    if (modelValue == null || modelValue == 'undefined' || modelValue.length === 0) {
                        return true;
                    }

                    //default pattern to use if no pattern is passed
                    var regex = /^\d+(\.\d{1,2})?$/;

                    if (!baUtil.isUndefinedOrNullOrEmpty(scope.regexToMatch)) {
                        regex = new RegExp(scope.regexToMatch);
                    }
                    var res = modelValue.match(regex) === null ? false : true;
                    return res;
                };
            }
		}
	}

})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('session', session)
		.filter('getMinutes', function() {
            return function(countdown) {

                    var hours = Math.floor(countdown / 3600),
                        minutes = Math.floor((countdown % 3600) / 60),
                        seconds = Math.floor(countdown % 60);

                    return minutes +1;
                };
		});

	/** @ngInject */
	function session($timeout) {
		return {
			restrict: 'E',
			controller: sessionCtrl,
			controllerAs: 'vm',
			scope: {
				session: '=',
			}
		}
	}

	function sessionCtrl($scope, localStorageService, AuthService, $state, baUtil,$uibModalStack, $uibModal, $interval, $rootScope) {

            $scope.events = [];

            closeModals();

            function closeModals() {
//                console.log("close");
                if ($scope.timedout) {
                    $scope.timedout.close();
                    $scope.timedout = null;
                }
            }

            var vm = this;
            vm.renewSession = renewSession;

            function renewSession() {
                closeModals();
                AuthService.renewToken();
//                console.log("Token renewed by button");
            }

            
            $scope.$on('IdleStart', function() {
                closeModals();
                $uibModalStack.dismissAll();
                $scope.timedout = $uibModal.open({
                  templateUrl: 'app/pages/components/session/start.html',
                  windowClass: 'modal-danger'
                });
            });


            $scope.$on('IdleWarn', function(e, countdown) {

                var mm = Math.floor(countdown/60);
                if (mm >= 60) {
                    $scope.minRemaining = mm;
                }
                else {
                    $scope.minRemaining = mm + 1;
                }

                localStorageService.set('minRemaining',$scope.minRemaining);
//                console.log($scope.minRemaining);

                // follows after the IdleStart event, but includes a countdown until the user is considered timed out
                // the countdown arg is the number of seconds remaining until then.
                // you can change the title or display a warning dialog from here.
                // you can let them resume their session by calling Idle.watch()
//                console.log('countdown start');
            });

            $scope.$on('IdleTimeout', function() {
                closeModals();
                localStorageService.set('sessionExpired',true);
                AuthService.logout();
            });

            $scope.$on('IdleEnd', function() {
//                closeModals();
//                $scope.timedout = $uibModal.open({
//                  templateUrl: 'app/pages/components/session/start.html',
//                  windowClass: 'modal-danger'
//                });
            });

            $scope.$on('Keepalive', function() {
                AuthService.renewToken();
//                console.log("Token renewed by ng-idle");
            });

            vm.reminMinutes = $scope.minRemaining;

            /* $interval(renewToken, 180000);

            function renewToken(){
               AuthService.renewToken();
               console.log("Token renewed");
            }*/



	}

})();

angular.module('ngIdle.title', [])
  .provider('Title', function() {
    var options = {
      enabled: true
    };

    var setEnabled = this.enabled = function(enabled) {
      options.enabled = enabled === true;
    };

    function padLeft(nr, n, str){
      return new Array(n-String(nr).length+1).join(str||'0')+nr;
    }

    this.$get = ['$document', '$interpolate', function($document, $interpolate) {
      var state = {
        original: null,
        idle: 'e-MOSS Plus',
        timedout: 'e-MOSS Plus'
      };

      return {
        setEnabled: setEnabled,
        isEnabled: function() {
          return options.enabled;
        },
        original: function(val) {
          if (angular.isUndefined(val)) return state.original;

          state.original = val;
        },
        store: function(overwrite) {
          if (overwrite || !state.original) state.original = this.value();
        },
        value: function(val) {
          if (angular.isUndefined(val)) return $document[0].title;

          $document[0].title = val;
        },
        idleMessage: function(val) {
          if (angular.isUndefined(val)) return state.idle;

          state.idle = val;
        },
        timedOutMessage: function(val) {
          if (angular.isUndefined(val)) return state.timedout;

          state.timedout = val;
        },
        setAsIdle: function(countdown) {
          this.store();

          var remaining = { totalSeconds: countdown };
          remaining.minutes = Math.floor(countdown/60);
          remaining.seconds = padLeft(countdown - remaining.minutes * 60, 2);

          this.value($interpolate(this.idleMessage())(remaining));
        },
        setAsTimedOut: function() {
          this.store();

          this.value(this.timedOutMessage());
        },
        restore: function() {
          if (this.original()) this.value(this.original());
        }
      };
    }];
  });

/**
 * Special Character validation on form elements
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('specialCharacterLimit', specialCharacterLimit);

	/** @ngInject */
	function specialCharacterLimit($timeout, baUtil) {
		return {
			restrict: 'A',
            require: 'ngModel',
            scope: {
                regexToMatch: '='
            },
            link: function (scope, element, attrs, ngModel) {

                ngModel.$validators.specialCharacterLimit = function (modelValue) {
                    if (modelValue == null || modelValue == 'undefined' || modelValue.length === 0) {
                        return true;
                    }

                    //default pattern to use if no pattern is passed
                    var regex = /^.*[-.,~!@#$%^&*;:=_+\\/'"?<>\(\)\{\}\[\]]{3,}/;

                    if (!baUtil.isUndefinedOrNullOrEmpty(scope.regexToMatch)) {
                        regex = new RegExp(scope.regexToMatch);
                    }
                    var res = modelValue.match(regex) === null ? true : false;
                    return res;
                };
            }
		}
	}

})();
/**
 * Special Character validation on form elements
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('specialCharacterLimitV2', specialCharacterLimitV2);

	/** @ngInject */
	function specialCharacterLimitV2($timeout, baUtil) {
		return {
			restrict: 'A',
            require: 'ngModel',
            scope: {
                regexToMatch: '='
            },
            link: function (scope, element, attrs, ngModel) {

                ngModel.$validators.specialCharacterLimit = function (modelValue) {
                    if (modelValue == null || modelValue == 'undefined' || modelValue.length === 0) {
                        return true;
                    }

                    //default pattern to use if no pattern is passed
                    var regex = /^.*[-.,~|!@#$%^&*;:=_+\\/'"?<>\(\)\{\}\[\]]{1,}/;

                    if (!baUtil.isUndefinedOrNullOrEmpty(scope.regexToMatch)) {
                        regex = new RegExp(scope.regexToMatch);
                    }
                    var res = modelValue.match(regex) === null ? true : false;
                    return res;
                };
            }
		}
	}

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('validEmail', validEmail);

	/** @ngInject */
	function validEmail($timeout, baUtil) {
		return {
			restrict: 'A',
            require: 'ngModel',
            scope: {
                regexToMatch: '='
            },
            link: function (scope, element, attrs, ngModel) {

                ngModel.$validators.validEmail = function (modelValue) {
                    if (modelValue == null || modelValue == 'undefined' || modelValue.length === 0) {
                        return true;
                    }
                    
                    //default pattern to use if no pattern is passed
                    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                    if (!baUtil.isUndefinedOrNullOrEmpty(scope.regexToMatch)) {
                        regex = new RegExp(scope.regexToMatch);   
                    }
                    var res = modelValue.match(regex) === null ? false : true;
                    return res;
                };
            }
		}
	}

})();
/**
 * Special Password validation on form elements
 */
 (function () {
	'use strict';

	angular.module('JPTC.theme')
		.directive('validPassword', validPassword);

	/** @ngInject */
	function validPassword($timeout, baUtil) {
		return {
			restrict: 'A',
            require: 'ngModel',
            scope: {
                regexToMatch: '='
            },
            link: function (scope, element, attrs, ngModel) {

                ngModel.$validators.validPassword = function (modelValue) {
                    if (modelValue == null || modelValue == 'undefined' || modelValue.length === 0) {
                        return true;
                    }

                    //default pattern to use if no pattern is passed
                    var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,32}$/;
                    

                    if (!baUtil.isUndefinedOrNullOrEmpty(scope.regexToMatch)) {
                        regex = new RegExp(scope.regexToMatch);
                    }
                    var res = modelValue.match(regex) === null ? false : true;
                    return res;
                };
            }
		}
	}

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.contract')
        .controller('ListDevicePurchaseCtrl', ListDevicePurchaseCtrl);

    /** @ngInject */
    function ListDevicePurchaseCtrl($timeout, toastr, ContractService, dpListPromise, $uibModal) {
        var vm = this;
        vm.init = init;
        vm.searchDp = searchDp;
        vm.openFilterModal = openFilterModal;
        vm.devices = [{label:'MODEL_X', value : 'MODEL_X'}, {label:'MODEL_XL', value : 'MODEL_XL'}];
        init();

        if (dpListPromise.status >= 200 && dpListPromise.status <= 299) {
            vm.dpListResponse = dpListPromise.data.data;
        } else {
            return;
        }

        function init() {
            vm.dpListResponse = {
                content: []
            };
            vm.search = {
                query : ''
            }
        }

        function searchDp() {
            ContractService.search(vm.search.query)
            .then(function s(response) {
                console.log(response)
                vm.dpListResponse = response.data.data;
                console.log(vm.dpListResponse);
            },function err(err) {
            }) 
        }
        function openFilterModal(page, size) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                resolve: {
                    items: function () {
                        return [];
                    }
                }
            });
        }

        
    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.contract')
        .controller('NewDevicePurchaseCtrl', NewDevicePurchaseCtrl);

    /** @ngInject */
    function NewDevicePurchaseCtrl($state, baUtil, toastr, ContractService, AuthService, $scope, FormUtils) {
        var vm = this;
        vm.devices = [{label:'MODEL_X', value : 'MODEL_X'}, {label:'MODEL_XL', value : 'MODEL_XL'}];
        vm.formats = [ 'yyyy/MM/dd', 'dd-MMMM-yyyy', 'dd.MM.yyyy', 'shortDate'];
        vm.init = init;

        vm.init();
        if (!AuthService.isAdmin()) {
            $state.go('main.permissionDenied');
            return ;
        }
        /**
         * Add watches here - start
         */
        $scope.$watch('vm.forNewUser', function(newVal, oldVal) {
            vm.dpFormData.personInChargeEmail = null;
            vm.dpFormData.personInChargeName = null;
        });
        $scope.$watch('vm.selectedDevice', function(newVal, oldVal) {
            if (!baUtil.isUndefinedOrNull(newVal)) {
                vm.dpFormData.deviceModel = newVal.value;
            }
        });

         /**
         * Private Methods
         */

        function init() {
            vm.dpForm = {};
            vm.dpFormData = {
                address : {
                }
            };
            vm.forNewUser = true;
            vm.selectedDevice =  null;
            vm.submitDpForm = submitDpForm;
            vm.personInCharge = {
                onPersonInChargeSelected : onPersonInChargeSelected,
                search : search
            }
            vm.dateChange = dateChange;
            vm.getNewDateOptions = getNewDateOptions;
            vm.datePickerData = {
                contractStartDate: vm.getNewDateOptions(),
                contractEndDate: vm.getNewDateOptions(),
                warrantyStartDate: vm.getNewDateOptions(),
                warrantyEndDate: vm.getNewDateOptions(),
            }
        }

        function dateChange(key, value) {
            vm.dpFormData[key] = value.getTime();
        }
        function search(query) {
            vm.dpFormData.personInChargeEmail = null;
            vm.dpFormData.personInChargeName = null;
            return AuthService.search(query);
        }
        
        function onPersonInChargeSelected(val) {
            vm.dpFormData.personInChargeEmail = val.email;
            vm.dpFormData.personInChargeName = val.name;
        }
        function submitDpForm(form) {
            if (FormUtils.formHasErrors(form)) {
                FormUtils.setTouchedToTrue(form);
                if (form.$setSubmitted) {
                    form.$setSubmitted();
                }
                return;
            }
            ContractService.create(vm.dpFormData)
                .then(function s(response) {
                    toastr.success('New device purchase request created.', 'Success', baUtil.toastOptions());
                    vm.init();
                }, 
                function e(err) {
                    toastr.error(baUtil.getErrorMessageOrDefault(err, 'New device purchase request error.'), 'Error', baUtil.toastOptions());
                })
            console.log(vm.dpFormData);
            
        }

        function getNewDateOptions() {
            return {
                format :vm.formats[0],
                opened : false,
                options : {showWeeks: false},
                open: function () {
                    this.opened = true;
                }
            };
        }
    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.contract')
        .factory('ContractService', ContractService);

    /** @ngInject */
    function ContractService(baUtil, $http, $state, $q, $translate, localStorageService, API_CONFIG, AuthService) {
        var service = {};
        service.search = search;
        service.create = create;
        return service;

        function search(query) {
            if (baUtil.isUndefinedOrNullOrEmpty(query)) {
                query = '';
            }
            return $http({
                url: API_CONFIG.url + '/api/v1/dps?query='+ query,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };
        function create(devicePurchaseCreateDto) {
            return $http({
                url: API_CONFIG.url + '/api/v1/dps',
                method: 'post',
                data: devicePurchaseCreateDto,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'yyyy年MMMM',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'yyyy年MMMM',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();

(function () {
  "use strict";

  angular.module("JPTC.pages.deviceLinkage")
    .controller("DeviceLinkageCtrl", DeviceLinkageCtrl);

  /** @ngInject */
  function DeviceLinkageCtrl(types,$filter, $translate, $scope, AuthService, $stateParams,$state, deviceOwnerIds, DeviceLinkageService , baUtil,toastr,hotUtil,$location) {
    var vm = this;
    vm.deviceOwnerIds = deviceOwnerIds.data.data;
    vm.keyMap = [];
    vm.fetchKirinData = fetchKirinData;
    vm.showData = showData;
    vm.showTable = false;
    vm.showMessage = false;
    vm.cancelCreate = cancelCreate;
    vm.errors = {};
    vm.alerts = [];
    vm.isFormValid = isFormValid;
    vm.isDeviceOwner = baUtil.isDeviceOwner();

    if(vm.isDeviceOwner){
      vm.query = {
        deviceOwnerId : AuthService.getDeviceOwnerCode()
      }
      $state.go($state.current.name, { query : JSON.stringify(vm.query) });
    }

    vm.isMerchantAdmin = baUtil.isMerchantAdmin();
    vm.query = $stateParams.query ? JSON.parse($stateParams.query) : {};
    if (types.status >= 200 && types.status <= 299) {
      vm.types = types.data.data;
    }
    vm.serviceContractIds = [];
    vm.enableSelectMerchant = false;
    vm.saveData = saveData;
    vm.excelColumnNames = [];

    if (!baUtil.isUndefinedOrNullOrEmptyObject(vm.query)) {
            vm.selectedOption = getdeviceOwnerIdFromId(vm.query.deviceOwnerId);
            if(vm.selectedOption){
              fetchKirinData();
            }else {
              vm.showMessage = true;
            }
    }

    function getdeviceOwnerIdFromId(deviceOwnerId) {
      if (baUtil.isUndefinedOrNull(deviceOwnerId)) {
          return null
      }
            return vm.deviceOwnerIds.find(function (item) { return item.deviceOwnerId === deviceOwnerId })
  }


    if(vm.isMerchantAdmin){
      vm.selectedOption = vm.serviceContractIds[0];
      fetchKirinData();
    }


    function showData(){
      if (vm.selectedOption && vm.selectedOption.deviceOwnerId !== undefined) {
        vm.query = {
            deviceOwnerId: vm.selectedOption.deviceOwnerId
        };
        $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
    } 
    }
    
    function fetchKirinData() {
      vm.inProgress = true;
      DeviceLinkageService.getKeyMap(vm.selectedOption.deviceOwnerId)
        .then(function success(response) {
          vm.inProgress = false;
          vm.showTable = true;
          vm.serviceContractIds = response.data.data.serviceContractInfo;
          vm.nestedHeadersLevel = response.data.data.customDeviceInstallationKeys.length - 1;
          vm.enableSelectMerchant = true;
          var arrayTemp = response.data.data.customDeviceInstallationKeys[vm.nestedHeadersLevel];
          arrayTemp.forEach(function(item){
            if (item.excelColumnName !== null) {
                vm.excelColumnNames.push(item.excelColumnName);
            }
          });
          vm.keyMap = response.data.data.customDeviceInstallationKeys;
          vm.updatedKeyMap = vm.keyMap[vm.nestedHeadersLevel];
          vm.updatedKeyMap.forEach(function(item) {
            item.version = "1.0";
          });
          var defaultWidth = 100;

          vm.widthsArray = [];
          vm.updatedKeyMap.forEach(function(item) {
              var width = item.width === 0 ? defaultWidth : item.width;
              vm.widthsArray.push(width);
          });
          
          vm.NewKeyMap = getColumnDetails(vm.updatedKeyMap,"1.0");
          vm.optionKeys = Object.keys(vm.NewKeyMap).sort(function(item){
            return item;
          })
          vm.createInProgress = false;
          init();
        }, function err(err) {
          vm.createInProgress = false;
          vm.inProgress = false;
          toastr.error(
            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
            vm.localTranslator("common.components.title.error"),
            baUtil.toastOptions()
          );
        });
    }



    vm.permissions = AuthService.getPermissions();
    vm.localTranslator = $filter("translate");
    vm.hotTable = null;


    function init() {

      vm.tableSettings = {
        currentRowClassName: 'currentRow',
        currentColClassName: 'currentCol',
        invalidCellClassName: 'cell-has-error',
        columns: [],
        colWidths: vm.widthsArray,
        licenseKey: 'non-commercial-and-evaluation',
        afterRenderer: function (TD, row, col) {
          var isFrozen = vm.tableSettings.columns[col].isFrozen;
          if (isFrozen) {
          // Change the background color of the column if it's frozen
            TD.style.backgroundColor = '#e8dfdf';
          } else {
          // Change the background color of the column if it's not frozen
            TD.style.backgroundColor = 'white'; 
          }
        },
        afterValidate: function (isValid, value, row, prop, source) {
          // common use validator
          if ( !vm.NewKeyMap[prop]["readOnly"] && vm.NewKeyMap[prop]['validators'].length ) {
              var msg = hotUtil.aggregatedValidator(vm.NewKeyMap[prop]['validators'], value, row, vm.NewKeyMap[prop]['excelColumnName']);
              if( msg != "" ) {
                  vm.errors[ row + "_" + prop ] = msg;
                  return false;
              }
              else {
                  delete vm.errors[ row + "_" + prop ];
                  return true;
              }
          }

          if(isValid) {
              delete vm.errors[ row + "_" + prop ];
          }
          else {
              vm.errors[ row + "_" + prop ] = value;
          }
        },
        data: [],
        colHeaders: true,
        rowHeaders: true,
        minSpareRows: 200,
        fixedColumnsLeft:1,
        nestedHeaders: vm.keyMap,
      };

      vm.optionKeys.forEach(function (field) {
        var value = vm.NewKeyMap[field]
        var col = {
            type: getInputType(value.type),
            data: field,
            readOnly: value.readOnly,
            isFrozen: value.isFrozen
        }

        if (getInputType(value.type) === 'dropdown') {
            col.source = getSource(field)
        }

        if (getInputType(value.type) === 'date') {
            col.dateFormat = 'YYYY/MM/DD'
            col.datePickerConfig = {
                showMonthAfterYear: true,
                yearSuffix: "年",
                i18n: baUtil.geti18nDateForJP()
            }
        }

        if ( !vm.NewKeyMap[field]["readOnly"] && vm.NewKeyMap[field]['validators'].length ) {
          col.validator = function(query, callback) {
              callback(true);
          }
      }

        vm.tableSettings.columns.push(col);
      });

      var conditionKey = 'label';
      var conditionValue = 'Empty';
      var replacementValue = null;
      vm.arrayOfArray = vm.keyMap[vm.nestedHeadersLevel];
      vm.keyMap.forEach(function (outerItem) {
        outerItem.forEach(function (innerItem) {
            if (innerItem[conditionKey] === conditionValue) {
                innerItem[conditionKey] = replacementValue;
            }
        });
    });
      vm.alerts = [];
      vm.errors = {};
      var container = document.getElementById("handsontable-device-linkage");
      container.innerHTML = "";
      vm.hotTable = new Handsontable(container, vm.tableSettings);
      vm.hotTable.validateCells();

    }

    function getInputType(type) {
      switch (type) {
          case 'String':
              return 'text'
          case 'Checkbox':
              return 'checkbox'
          case 'Date':
              return 'date'
          case 'Dropdown':
              return 'dropdown'
          default:
              return 'text'
      }
  }

  function getSource(key) {
    switch (key) {
        case 'status':
            return vm.types.CustomDeviceInstallationStatusMaster[$translate.use()]
        case 'type':
            return vm.types.DeviceInstallationType[$translate.use()]
        case 'deviceOwnerId':
            return vm.types.deviceOwner[$translate.use()]
        case 'colhdr_dvcrqst_emoney_transport_card':
            return vm.types.TransportPaymentOptions[$translate.use()]
        default:
            return []
    }
}

    function isFormValid() {
      vm.alerts = [];
      Object.keys(vm.errors).forEach(function(key){
          var row = Number(key.split("_")[0])+1;
          var field = key.split("_")[1];
          if(!field) return;
          vm.alerts.push( vm.errors[key] );
      });
    
      vm.alerts = vm.alerts.reverse();
    
      return vm.alerts.length === 0;
    }

    function saveData(){
      vm.createInProgress = true;
    //   if (vm.deviceLinkageForm.$invalid) {
    //     toastr.error($translate.instant('salesSettlements.monthly.list.search.selectMerchantError'),
    //     $translate.instant('common.components.errorMessages.error'), baUtil.toastOptions())
    //     vm.isLoading = false;
    //     return;
    // }

      if (!vm.isFormValid()) {
        return;
    }

      var data = vm.hotTable.getData();
      var filteredArray = data.filter(function(innerArray) {
        return innerArray.some(function(element) {
            return element !== null;
        });
      });
      var mergedData = [];
        filteredArray.forEach(function(dataSet) {
          mergedData.push(Object.fromEntries(vm.excelColumnNames.map(function(key, index) {
                return [key, dataSet[index]];
            })));
      });

      mergedData.forEach(function(item) {
        for (var key in item) {
            if (item.hasOwnProperty(key) && item[key] !== null && isDate(item[key])) {
                item[key] = baUtil.convertJpDateToTimestamp(item[key]);
            }
        }
      });

      var serviceContractId = null;
      if (vm.selectedMerchant && vm.selectedMerchant.serviceContractId !== undefined) {
         serviceContractId = vm.selectedMerchant.serviceContractId;
      }

    
      DeviceLinkageService.createDeviceApplicationChange(mergedData, vm.selectedOption.deviceOwnerId, serviceContractId)
      .then(function success(response) {
          vm.createInProgress = false;
          toastr.success(
            response.data.data || vm.localTranslator("common.components.msg.success"),
              vm.localTranslator("common.components.title.success"),
              baUtil.toastOptions()
          );
          $state.reload()
      }, function err(err) {
          vm.createInProgress = false;
          toastr.error(
              baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
              vm.localTranslator("common.components.title.error"),
              baUtil.toastOptions()
          );
      });

    }

    function cancelCreate(){
      $location.path('/main/device-linkage/list/')    
    }

    function isDate(dateString) {
      // Check if the date string matches the format "YYYY/MM/DD"
      return /^\d{4}\/\d{2}\/\d{2}$/.test(dateString);
    }


    function getColumnDetails(keys, version) {
			var map = {};
			if(baUtil.isUndefinedOrNullOrEmpty(version)) {
				keys.forEach(function(d){
					if(!d.inUse || d.isDeleted) return;

					if(!map[d.version]) {
						map[d.version] = {};
					}
					map[d.version][d.excelColumnName] = {
						excelColumnName: d["excelColumnName"],
						// jp: d["displayJp"],
						// en: d["displayEn"],
						order: d["order"],
						readOnly: d["readOnly"],
						type: d["type"],
            isFrozen: d["isFrozen"],
						validators: d["validator"],
					};
				});
			}
			else {
				keys.forEach(function(d){
					if(!d.inUse || d.isDeleted || d.version != version) return;
					map[d.excelColumnName] = {
						excelColumnName: d["excelColumnName"],
						// jp: d["displayJp"],
						// en: d["displayEn"],
						order: d["order"],
						readOnly: d["readOnly"],
						type: d["type"],
            isFrozen: d["isFrozen"],
						validators: d["validator"],
					};
				});
			}
			return map;
		};


    $scope.$on('LANG_CHANGE', function (event) {
      // fetchKirinData();
    });

    function getLang() {
      return $translate.use();
    }
  }
})();

(function () {
    'use strict';

    angular.module('JPTC.pages.deviceLinkage')
        .controller('EditDeviceApplicationChangeCtrl', EditDeviceApplicationChangeCtrl);

    /** @ngInject */
    function EditDeviceApplicationChangeCtrl(DeviceLinkageService, types, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, $rootScope, AuthService, $uibModal, hotUtil,
        DeviceRequestUtilService, FileSaver, $sce) {

        if ($stateParams.deviceRequest == null) {
            $state.go("main.deviceLinkage.inventoryManagement");
        }

        if ($stateParams.deviceRequest) {
            $state.current.title = 'device.request.list.edit.device.changes';
        }
        else {
            $state.current.title = 'device.request.list.upload.device';
        }

        var vm = this;
        vm.isJescaUpload = $stateParams.isJescaUpload;
        vm.deviceRequest = $stateParams.deviceRequest.dtos;
        vm.KeyMap = DeviceRequestUtilService.getKeys($stateParams.deviceRequest.keyMap, "1.0");
        vm.getInputType = getInputType;
        vm.reserve = reserve;
        vm.download = download;
        vm.save = save;
        vm.cancelCreate = cancelCreate;
        vm.cancelApplication = cancelApplication;
        vm.serviceContractId = null;
        vm.permissions = AuthService.getPermissions();
        vm.localTranslator = $filter('translate');

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        vm.types.deviceOwner = $stateParams.deviceRequest.deviceOwners;
        vm.types.branchCode = $stateParams.deviceRequest.branchCodeInfo;
        vm.KeyMap.deviceOwnerId.type = "Dropdown";
        vm.autoSelectedDO = ""; // in case of self rent
        vm.isUserDeviceOwnerOfSC = false;
        vm.orgId = AuthService.getOrgId();
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ;
        vm.getDeviceStatusFromKey = getDeviceStatusFromKey;
        vm.getInstallationStatusIndex = getInstallationStatusIndex;
        vm.isDIStateTransitionValid = isDIStateTransitionValid;
        vm.hotTable = null;
        vm.isReserveBtnDisbaled = false;

        vm.getLang = getLang;
        vm.modal = null;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;
        vm.getErrMessageOfStatus = getErrMessageOfStatus;
        vm.getErrMessageDO = getErrMessageDO;

        // if (vm.orgId && vm.orgId != "" && vm.types.deviceOwner.key.indexOf(vm.orgId) != -1 && !baUtil.isMerchant()) {
        //     vm.isUserDeviceOwnerOfSC = true;
        //     vm.autoSelectedDO = vm.orgId;
        // } else if (vm.types.deviceOwner.key.length === 1) {
        //     vm.autoSelectedDO = vm.types.deviceOwner.key[0];
        // }

        if (baUtil.isSystemAdmin()) {
            vm.systemAdmin = true;
        }
        else {
            vm.systemAdmin = false;
        }

        if(baUtil.isMerchant()){
            vm.merchantLogin = true;
        }

        function init() {
            vm.tableData = [];
            vm.tableOptions = {};
            vm.tableSettings = {
                licenseKey: 'non-commercial-and-evaluation',
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                fixedColumnsLeft: 3,
                modifyColWidth: function (width, col) {
                    if(col === 27){
                        return 200;
                    }
                    if (width > 500) return 500;
                },
                afterValidate: function (isValid, value, row, prop, source) {
                    // special validation for device installaiton status
                    // if(prop === "status") {
                    //     var index = vm.types.DeviceInstallationStatus.en.indexOf(value);
                    //     if (index < 0) {
                    //         index = vm.types.DeviceInstallationStatus.jp.indexOf(value);
                    //     }
                    //     var indexValue = index === -1 ? value : vm.types.DeviceInstallationStatus.key[index];

                    //     if(vm.isDIStateTransitionValid(vm.deviceRequest[row]['status'], indexValue)) {
                    //         delete vm.errors[ row + "_" + prop ];
                    //         return true;
                    //     }
                    //     else {
                    //         vm.errors[ row + "_" + prop ] = vm.getErrMessageOfStatus(
                    //             row+1,
                    //             vm.deviceRequest[row]['applicationNumber'],
                    //             vm.deviceRequest[row]['status'],
                    //             indexValue
                    //         );
                    //         return false;
                    //     }
                    // }

                    if (prop === "deviceOwnerId") {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = vm.getErrMessageDO(row + 1, "deviceOwnerId");
                            return false;
                        }
                        // else if (vm.types.deviceOwner[$translate.use()].indexOf(value) === -1) {
                        //     vm.errors[row + "_" + prop] = vm.getErrMessageDO(row + 1, "deviceOwnerId", true);
                        //     return false;
                        // }
                        else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }

                    if (prop === "branchCode") {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = vm.getErrMessageDO(row + 1, "branchCode");
                            return false;
                        }
                        // else if( vm.types.branchCode[ vm.deviceRequest[row]["serviceContractId"] ][$translate.use()].indexOf(value) === -1 ) {
                        //     vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "branchCode", true);
                        //     return false;
                        // }
                        else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }

                    if (prop === "paymentHandlingOption_TRANSPORT") {
                        if (baUtil.isUndefinedOrNullOrEmpty(value) ||
                            vm.types.TransportPaymentOptions[$translate.use()].indexOf(value) === -1) {
                            vm.errors[row + "_" + prop] = vm.getErrMessageDO(row + 1, "paymentHandlingOption_TRANSPORT", true);
                            return false;
                        }
                        else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }

                    if ( !vm.KeyMap[prop]["readOnly"] &&
                        vm.KeyMap[prop]['validators'].length
                    ) {
                        var msg = hotUtil.aggregatedValidator(vm.KeyMap[prop]['validators'], value, row, vm.KeyMap[prop][vm.getLang()]);
                        if( msg != "" ) {
                            vm.errors[ row + "_" + prop ] = msg;
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(isValid) {
                        delete vm.errors[ row + "_" + prop ];
                    }
                    else {
                        vm.errors[ row + "_" + prop ] = value;
                    }
                }
            };
            // disable rows if the device status is not DRAFT or REGISTERED
            //    for users which don't have permissions
            //    when status is cancelled
            vm.tableSettings.cells = function (row, col, prop) {
                var cellMeta = {};
                if(!baUtil.isUndefinedOrNullOrEmpty(vm.tableData[row].productName)) {
                    if(vm.tableData[row].productName.includes('ME-10'))
                    {
                        if(prop === 'paymentHandlingOption_VISA' || prop === 'paymentHandlingOption_MASTERCARD' || prop === 'paymentHandlingOption_AMERICANEXPRESS' || prop === 'paymentHandlingOption_JCB' || prop === 'paymentHandlingOption_DISCOVER' || prop === 'paymentHandlingOption_DINERS'){
                            cellMeta.readOnly = true;
                        }
                    }
                }
                if(!baUtil.isUndefinedOrNullOrEmpty(vm.tableData[row])) {
                    if( vm.tableData[row].readOnly || vm.tableData[row][ prop + "_readOnly" ] ) {
                        cellMeta.readOnly = true;
                    }
                }
                if( prop === "branchCode" ) {
                    cellMeta.source = vm.types.branchCode[ vm.deviceRequest[row]["serviceContractId"] ][$translate.use()];
                }
                return  cellMeta;
            };

            vm.deviceRequest.forEach(function (item, index) {
                    var obj = {};

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.serviceContractId)) {
                        vm.serviceContractId = item.serviceContractId
                    }
                    Object.keys(item).forEach(function (field) {
                        var value = item[field]
                        if (field === 'date' || field === 'preferredDateOfInstallation') {
                            obj[field] = $filter('date')(value, "yyyy/MM/dd");
                            return
                        }

                        obj[field] = value;

                        if (field === 'status') {
                            var index = vm.types.DeviceInstallationStatus.key.indexOf(value);
                            obj[field] = vm.types.DeviceInstallationStatus[$translate.use()][index];
                        }

                        // if (field === 'type') {
                        //     var index = vm.types.DeviceInstallationType.key.indexOf(value);
                        //     obj[field] = vm.types.DeviceInstallationType[$translate.use()][index];
                        // }
                        else if (field === 'deviceOwnerId') {
                            if (baUtil.isUndefinedOrNullOrEmptyObject(value)) {
                                obj['deviceOwnerId'] = "";
                            }
                            else {
                                var index = vm.types.deviceOwner[item.serviceContractId].key.indexOf(value);
                                obj['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId][$translate.use()][index];
                            }
                        }
                        // if(field === 'branchCode'){
                        //     console.log('value', value)
                        //     if (baUtil.isUndefinedOrNullOrEmptyObject(value)) {
                        //         obj['branchCode'] = "";
                        //     }
                        //     else {
                        //         var index = vm.types.branchCode[item.serviceContractId].key.indexOf(value);
                        //         console.log('index', index)
                        //         console.log('vm.types.branchCode[item.serviceContractId][$translate.use()][index]',vm.types.branchCode[item.serviceContractId][$translate.use()][index]);
                        //         obj['branchCode'] = vm.types.branchCode[item.serviceContractId][$translate.use()][index];
                        //     }
                        // }

                        if (field === 'itemName') {
                            var index = vm.types.ItemName.key.indexOf(value);
                            obj[field] = vm.types.ItemName[$translate.use()][index];
                        }

                        if (field === 'vendingMachineModel') {
                            item.paymentHandlingOptions.forEach(function (k, i) {
                                obj['paymentHandlingOption_' + k] = true
                            });
                            obj['paymentHandlingOption_TRANSPORT'] = DeviceRequestUtilService.getTransportPaymentOptionTextFromKey(
                                vm.types.TransportPaymentOptions,
                                item['transportPaymentHandlingOption'],
                                item['paymentHandlingOptions']
                            );
                        }

                    })
                    // vm.tableData.push({...obj,"_s":true});
                    obj._s = true;
                    vm.tableData.push(obj);
                })

            vm.isReserveBtnDisbaled = vm.tableData.some(function (item) {
                if (item.reservationStatus === "COMPLETED" || item.status === "COMPLETED") {
                    return true;
                }
            })

            var keyMap = vm.KeyMap;
                        var optionKeys = Object.keys(keyMap).sort(function (a, b) {
                                return keyMap[a].order - keyMap[b].order;
            });
                        optionKeys.forEach(function (field) {
                var value = keyMap[field]
                                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                // if (
                //     (field == 'status') ||
                //     (field == 'deviceOwnerId' && vm.isUserDeviceOwnerOfSC)
                // ) {
                //     col.readOnly = true;
                // }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = getSource(field)
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                if (!vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'].length) {
                    col.validator = function (query, callback) {
                        callback(true);
                    }
                }
                                vm.tableSettings.columns.push(col);
            })
            var checked = true
            var selectColumnTemplate = { data: "_s", type: "checkbox" };
            vm.tableSettings.columns.unshift(selectColumnTemplate)
            vm.tableSettings.colHeaders.unshift('<input ' + (checked ? 'checked="checked"' : '') + ' class="hot_handsontable_header_chkbox" type="checkbox" />')
            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsontable-edit-change-multiple-request');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            var _settings = options

            container.innerHTML = ''
            vm.hotTable = new Handsontable(container, _settings);
            Handsontable.dom.addEvent(container, 'mousedown', function (event) {
                if (event.target.nodeName == 'INPUT' && event.target.className == 'hot_handsontable_header_chkbox') {
                    event.stopPropagation();
                }
            });
            Handsontable.dom.addEvent(container, 'mouseup', function (event) {
                if (event.target.nodeName == 'INPUT' && event.target.className == 'hot_handsontable_header_chkbox') {
                    event.target.checked = checked
                    vm.tableData = vm.tableData.map(function (item) {
                            item._s = checked
                            return item
                    })
                    vm.tableSettings.colHeaders[0] = '<input ' + (checked ? 'checked="checked"' : '') + ' class="hot_handsontable_header_chkbox" type="checkbox" />'
                    vm.hotTable.render();
                    checked = !checked

                }
            });

            vm.hotTable.render();
            vm.hotTable.validateCells();
        }

        init();

        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        // ask before leaving form
        vm.askBeforeLeaving = true;
        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            if (current.endsWith('device-request/create-multiple') && vm.askBeforeLeaving) {
                processBeforeRedirect(event);
            }
        });

        function processBeforeRedirect(event) {
            toastr.info(
                vm.localTranslator("common.components.msg.confirm"),
                vm.localTranslator("common.components.title.info"),
                baUtil.toastOptions()
            );
            if (event) event.preventDefault();
            vm.askBeforeLeaving = false;
        }

        function cancelCreate() {
            if (baUtil.isSystemAdmin()) {
                if (vm.askBeforeLeaving) {
                    return processBeforeRedirect();
                }
            }
            $state.go("main.deviceLinkage.inventoryManagement");
        }

        function cancelApplication(){
            var title = vm.localTranslator("device.linking.modal.msg.title");
            var message = vm.localTranslator("device.linking.modal.msg.message");
            var btnText = vm.localTranslator("device.linking.modal.msg.btn.text");
            var showCancelButton = true;
            baUtil.showConfirm(title, message, btnText,showCancelButton)
            .then(function() {

            vm.tableData.forEach(function (item) {
                item.reservationStatus = "CANCELLED";
            })
            var data = [];
            vm.cancelApplicationInProgress = true;
            vm.tableData.forEach(function (row) {
                var obj = {
                    paymentHandlingOptions: []
                };
                Object.keys(row).forEach(function (key) {
                    if (key === "paymentHandlingOptions") return;

                    if (key === 'date' || key == 'preferredDateOfInstallation') {
                        var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                        obj[key] = long
                        return
                    }
                    if (key.indexOf("paymentHandlingOption_") >= 0) {
                        if (row[key]) {
                            var optionKey = key.replace('paymentHandlingOption_', '');
                            obj.paymentHandlingOptions.push(optionKey);
                        }
                        return;
                    }

                    obj[key] = row[key]
                });

                obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                    vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d != "TRANSPORT" });
                if (obj['transportPaymentHandlingOption'] !== "-") {
                    obj.paymentHandlingOptions.push("TRANSPORT");
                }

                data.push(obj)
            });

            data.forEach(function (item, i) {
                item = data[i];

                var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                }
                item['status'] = vm.types.DeviceInstallationStatus.key[index];

                var index = vm.types.ItemName.en.indexOf(item.itemName);
                if (index < 0) {
                    index = vm.types.ItemName.jp.indexOf(item.itemName);
                }
                item['itemName'] = vm.types.ItemName.key[index];

                var index = vm.types.deviceOwner[item.serviceContractId].en.indexOf(item.deviceOwnerId);
                if (index < 0) {
                    index = vm.types.deviceOwner[item.serviceContractId].jp.indexOf(item.deviceOwnerId);
                }
                item['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId].key[index];

                var index = vm.types.branchCode[item.serviceContractId].en.indexOf(item.branchCode);
                if (index < 0) {
                    index = vm.types.branchCode[item.serviceContractId].jp.indexOf(item.branchCode);
                }
                item['settlementSendLocationId'] = vm.types.branchCode[item.serviceContractId].key[index];
            })
            var temp_data = data.map(function (d, i) {
                if (d._s) {
                    return { 'id': d.id }
                }
            });

            temp_data = temp_data.filter(function (element) {
                return element !== undefined;
            });
            var new_data = [];

            for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < temp_data.length; j++) {
                    if (data[i].id === temp_data[j].id) {
                        new_data.push(data[i])
}
                    }
            }
            
            var isReservation = false;
            var immediately = false;
                DeviceLinkageService.reserveDeviceApplicationChange(new_data, immediately, isReservation)
                    .then(function success(response) {
                        vm.cancelApplicationInProgress = false;
                        toastr.success(
                            response.data.data || vm.localTranslator("common.components.msg.success"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                    }, function err(err) {
                        vm.cancelApplicationInProgress = false;
                        toastr.error(
                            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                            vm.localTranslator("common.components.title.error"),
                            baUtil.toastOptions()
                        );
                    });
                });
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }

        function getSource(key) {
            switch (key) {
                case 'status':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'type':
                    return vm.types.DeviceInstallationType[$translate.use()]
                case 'deviceOwnerId':
                    return vm.types.deviceOwner[$translate.use()]
                case 'branchCode':
                    return vm.types.branchCode[$translate.use()]    
                case 'paymentHandlingOption_TRANSPORT':
                    return vm.types.TransportPaymentOptions[$translate.use()]
                default:
                    return []
            }
        }

        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field) {
            if (vm.fieldMetaData[field]) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                /// return reqd otherwise
                return $translate.instant(
                    "device.request.edit.err.msg.required.field",
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
        }

        function getErrMessageDO(row, field, isWrongInput) {
            return $translate.instant(
                isWrongInput ? "device.request.edit.err.msg.device.owner" : "device.request.edit.err.msg.required.field",
                { row: row, param: vm.KeyMap[field][vm.getLang()] }
            );
        }

        function getErrMessageOfStatus(row, applicationNumber, from, to) {
            return $translate.instant(
                "device.request.edit.err.msg.cannot.allow.state.transition",
                {
                    row: row,
                    id: applicationNumber,
                    from: vm.getDeviceStatusFromKey(from),
                    to: vm.getDeviceStatusFromKey(to)
                }
            );
        }

        function getInstallationStatusIndex(status) {
            var statusMap = {
                "DRAFT": 0,
                "REGISTERED": 1,
                "ACCEPTED": 2,
                "UNDER_FULFILMENT": 3,
                "COMPLETED": 4,
                "APPLICATION_CANCELLED": 5
            };
            if (Object.keys(statusMap).indexOf(status) === -1) {
                return null;
            }
            return statusMap[status]
        }

        function isDIStateTransitionValid(statusBefore, statusAfter) {

            // no change detected
            if (statusBefore == statusAfter) {
                return true;
            }

            // status shifted backwards
            else if (
                vm.getInstallationStatusIndex(statusBefore) != null &&
                vm.getInstallationStatusIndex(statusAfter) != null &&
                vm.getInstallationStatusIndex(statusBefore) > vm.getInstallationStatusIndex(statusAfter)
            ) {
                if (vm.isSystemUser) {
                    if (
                        (statusBefore == "ACCEPTED" && statusAfter == "REGISTERED") ||
                        (statusBefore == "UNDER_FULFILMENT" && statusAfter == "REGISTERED")
                    ) {
                        return true;
                    }
                }
                return false;
            }

            // status moving forward
            else {
                // for common permissions
                if (
                    (statusBefore == "DRAFT" && statusAfter == "REGISTERED") ||
                    (statusBefore == "REGISTERED" && statusAfter == "APPLICATION_CANCELLED")
                ) {
                    return true;
                }
                // for System User
                else if (vm.isSystemUser) {
                    if (
                        (statusBefore == "REGISTERED" && statusAfter == "ACCEPTED") ||
                        (
                            statusBefore == "ACCEPTED" &&
                            ["UNDER_FULFILMENT", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        ) ||
                        (
                            statusBefore == "UNDER_FULFILMENT" &&
                            ["COMPLETED", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        )
                    ) {
                        return true;
                    }
                }
                // otherwise
                return false;
            }
        }

        function getDeviceStatusFromKey(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);

            if (index === -1) return key;

            return ($translate.use() === "jp" ?
                vm.types.DeviceInstallationStatus.jp[index] :
                vm.types.DeviceInstallationStatus.en[index]);
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function (key) {
                var row = Number(key.split("_")[0]) + 1;
                var field = key.split("_")[1];
                if (!field) return;
                vm.alerts.push(vm.errors[key]);
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function reserve() {
            if (!vm.isFormValid()) {
                return;
            }

            var message = "Message";
            var lang = $translate.use();
            var modalValues = null;
            $uibModal.open({
                animation: false,
                controller: function confirmCtrl($uibModalInstance) {
                    var confirmVm = this;
                    var today = new Date();
                    confirmVm.todayDate = new Date().setHours(23, 59, 59, 999);
                    var tomorrowDate = new Date();
                    tomorrowDate.setDate(today.getDate() + 1)
                    confirmVm.date = tomorrowDate;
                    confirmVm.dateOptions = {
                        showWeeks: false,
                        formatDayTitle: 'yyyy 年 MMMM',
                        formatMonthTitle: 'yyyy 年',
                        minDate: tomorrowDate,
                    }
                    confirmVm.cancelReservation = false;
                    confirmVm.monthEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    confirmVm.nextMonthStartDate = new Date(today.getFullYear(), today.getMonth() + 1, 1)
                    confirmVm.title = (lang == "jp" ? "変更予約" : 'Reserve Change');
                    confirmVm.message = $sce.trustAsHtml(message || (lang == "jp" ? "変更内容を保存します。" : 'This will save all the changes made by you.'));
                    confirmVm.btnText = (lang == "jp" ? "実行" : 'Execute');
                    confirmVm.ok = function () {
                        $uibModalInstance.close();
                        modalValues = confirmVm;
                        vm.createInProgress = true;

                    };
                    confirmVm.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                templateUrl: 'app/pages/device-request/views/reserve-change-modal.html',
                controllerAs: 'confirmVm',
                backdrop: "static"
            }).result.then(function () {

                var immediately = false
                var reservationDateTime = null;
                var reservationStatusValue = "RESERVED";

                if (modalValues.hasOwnProperty('reserveChange') === true) {
                    if (modalValues.reserveChange.reservationDateTime === 'immediate') {
                        reservationDateTime = Date.parse(new Date());
                        immediately = true;
                    } else if (modalValues.reserveChange.reservationDateTime === 'today') {

                        reservationDateTime = modalValues.todayDate;

                    } else if (modalValues.reserveChange.reservationDateTime === 'monthEnd') {

                        reservationDateTime = modalValues.monthEndDate.setHours(23, 59, 59, 999);

                    } else if (modalValues.reserveChange.reservationDateTime === 'startNextMonth') {

                        reservationDateTime = Date.parse(modalValues.nextMonthStartDate);

                    } else if (modalValues.reserveChange.reservationDateTime === 'specificDate') {

                        reservationDateTime = modalValues.date.setHours(0, 0, 0, 0);

                    } else if (modalValues.reserveChange.reservationDateTime === 'cancelReservation') {

                        reservationDateTime = null;
                        reservationStatusValue = "CANCELLED"
                    }
                }
                else {
                    reservationDateTime = modalValues.todayDate;
                }

                vm.tableData.forEach(function (item) {
                    item.reservationStatus = reservationStatusValue || item.status;
                })
                var data = [];

                vm.tableData.forEach(function (item) {
                    item.reservationDateTime = reservationDateTime;
                })

                vm.tableData.forEach(function (row) {
                    var obj = {
                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
                        if (key === "paymentHandlingOptions") return;

                        if (key === 'date' || key == 'preferredDateOfInstallation') {
                            var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                            obj[key] = long
                            return
                        }
                        if (key.indexOf("paymentHandlingOption_") >= 0) {
                            if (row[key]) {
                                var optionKey = key.replace('paymentHandlingOption_', '');
                                obj.paymentHandlingOptions.push(optionKey);
                            }
                            return;
                        }

                        obj[key] = row[key]
                    });

                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                        vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d != "TRANSPORT" });
                    if (obj['transportPaymentHandlingOption'] !== "-") {
                        obj.paymentHandlingOptions.push("TRANSPORT");
                    }

                    data.push(obj)
                });
                
                data.forEach(function (item, i) {
                    item = data[i];

                    var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                    if (index < 0) {
                        index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                    }

                    item['status'] = vm.types.DeviceInstallationStatus.key[index];

                    var index = vm.types.InitialMonthlyBilling.en.indexOf(item.initialBilling);
                    if (index < 0) {
                        index = vm.types.InitialMonthlyBilling.jp.indexOf(item.initialBilling);
                    }
                    item['initialBilling'] = vm.types.InitialMonthlyBilling.key[index];

                    var index = vm.types.InitialMonthlyBilling.en.indexOf(item.monthlyBilling);
                    if (index < 0) {
                        index = vm.types.InitialMonthlyBilling.jp.indexOf(item.monthlyBilling);
                    }
                    item['monthlyBilling'] = vm.types.InitialMonthlyBilling.key[index];

                    var index = vm.types.ItemName.en.indexOf(item.itemName);
                    if (index < 0) {
                        index = vm.types.ItemName.jp.indexOf(item.itemName);
                    }
                    item['itemName'] = vm.types.ItemName.key[index];

                    var index = vm.types.deviceOwner[item.serviceContractId].en.indexOf(item.deviceOwnerId);
                    if (index < 0) {
                        index = vm.types.deviceOwner[item.serviceContractId].jp.indexOf(item.deviceOwnerId);
                    }
                    item['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId].key[index];

                    var index = vm.types.branchCode[item.serviceContractId].en.indexOf(item.branchCode);
                    if (index < 0) {
                        index = vm.types.branchCode[item.serviceContractId].jp.indexOf(item.branchCode);
                    }
                    item['settlementSendLocationId'] = vm.types.branchCode[item.serviceContractId].key[index];
                })

            var data = data.filter(function (d, i) { return d._s });
                var isReservation = true;
                DeviceLinkageService.reserveDeviceApplicationChange(data, immediately, isReservation)
                    .then(function success(response) {
                        vm.createInProgress = false;
                        toastr.success(
                            vm.localTranslator("common.components.msg.success"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                    }, function err(err) {
                        vm.createInProgress = false;
                        toastr.error(
                            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                            vm.localTranslator("common.components.title.error"),
                            baUtil.toastOptions()
                        );
                    });

            });
        }

        function save() {

            var data = [];
            vm.saveInProgress = true;
            vm.tableData.forEach(function (row) {
                var obj = {
                    paymentHandlingOptions: []
                };
                Object.keys(row).forEach(function (key) {
                    if (key === "paymentHandlingOptions") return;

                    if (key === 'date' || key == 'preferredDateOfInstallation') {
                        var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                        obj[key] = long
                        return
                    }
                    if (key.indexOf("paymentHandlingOption_") >= 0) {
                        if (row[key]) {
                            var optionKey = key.replace('paymentHandlingOption_', '');
                            obj.paymentHandlingOptions.push(optionKey);
                        }
                        return;
                    }

                    obj[key] = row[key]
                });

                obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                    vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d != "TRANSPORT" });
                if (obj['transportPaymentHandlingOption'] !== "-") {
                    obj.paymentHandlingOptions.push("TRANSPORT");
                }

                data.push(obj)
            });

            data.forEach(function (item, i) {
                item = data[i];

                var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                }
                item['status'] = vm.types.DeviceInstallationStatus.key[index];

                var index = vm.types.ItemName.en.indexOf(item.itemName);
                if (index < 0) {
                    index = vm.types.ItemName.jp.indexOf(item.itemName);
                }
                item['itemName'] = vm.types.ItemName.key[index];

                var index = vm.types.deviceOwner[item.serviceContractId].en.indexOf(item.deviceOwnerId);
                if (index < 0) {
                    index = vm.types.deviceOwner[item.serviceContractId].jp.indexOf(item.deviceOwnerId);
                }
                item['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId].key[index];

                var index = vm.types.branchCode[item.serviceContractId].en.indexOf(item.branchCode);
                if (index < 0) {
                    index = vm.types.branchCode[item.serviceContractId].jp.indexOf(item.branchCode);
                }
                item['settlementSendLocationId'] = vm.types.branchCode[item.serviceContractId].key[index];
            })
            var temp_data = data.map(function (d, i) {
                if (d._s) {
                    return { 'id': d.id }
                }
            });

            temp_data = temp_data.filter(function (element) {
                return element !== undefined;
            });
            var new_data = [];

            for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < temp_data.length; j++) {
                    if (data[i].id === temp_data[j].id) {
                        new_data.push(data[i])
}
                    }
            }
            
            var isReservation = false;
            var immediately = false;
                DeviceLinkageService.reserveDeviceApplicationChange(new_data, immediately, isReservation)
                    .then(function success(response) {
                        vm.saveInProgress = false;
                        toastr.success(
                            response.data.data || vm.localTranslator("common.components.msg.success"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                    }, function err(err) {
                        vm.saveInProgress = false;
                        toastr.error(
                            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                            vm.localTranslator("common.components.title.error"),
                            baUtil.toastOptions()
                        );
                    });
        }

        function download() {

            var data = [];
            vm.downloadInProgress = true;
            vm.tableData.forEach(function (row) {
                var obj = {
                    paymentHandlingOptions: []
                };
                Object.keys(row).forEach(function (key) {
                    if (key === "paymentHandlingOptions") return;

                    if (key === 'date' || key == 'preferredDateOfInstallation') {
                        var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                        obj[key] = long
                        return
                    }
                    if (key.indexOf("paymentHandlingOption_") >= 0) {
                        if (row[key]) {
                            var optionKey = key.replace('paymentHandlingOption_', '');
                            obj.paymentHandlingOptions.push(optionKey);
                        }
                        return;
                    }

                    obj[key] = row[key]
                });

                obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                    vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d != "TRANSPORT" });
                if (obj['transportPaymentHandlingOption'] !== "-") {
                    obj.paymentHandlingOptions.push("TRANSPORT");
                }

                data.push(obj)
            });

            data.forEach(function (item, i) {
                item = data[i];
                var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                }
                item['status'] = vm.types.DeviceInstallationStatus.key[index];

                var index = vm.types.ItemName.en.indexOf(item.itemName);
                if (index < 0) {
                    index = vm.types.ItemName.jp.indexOf(item.itemName);
                }
                item['itemName'] = vm.types.ItemName.key[index];

                
                var index = vm.types.deviceOwner[item.serviceContractId].en.indexOf(item.deviceOwnerId);
                if (index < 0) {
                    index = vm.types.deviceOwner[item.serviceContractId].jp.indexOf(item.deviceOwnerId);
                }
                item['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId].key[index];

                var index = vm.types.branchCode[item.serviceContractId].en.indexOf(item.branchCode);
                if (index < 0) {
                    index = vm.types.branchCode[item.serviceContractId].jp.indexOf(item.branchCode);
                }
                item['settlementSendLocationId'] = vm.types.branchCode[item.serviceContractId].key[index];
            })

            var temp_data = data.map(function (d, i) {
                if (d._s) {
                    return { 'id': d.id }
                }
            });

            temp_data = temp_data.filter(function (element) {
                return element !== undefined;
            });

            var new_data = [];

            data.forEach(function(dataItem) {
                temp_data.forEach(function(tempItem) {
                    if (dataItem.id === tempItem.id) {
                        new_data.push(dataItem);
                    }
                });
            });

            DeviceLinkageService
                .downloadDeviceApplicationChangeExcel(new_data)
                .then(function (resp) {
                    vm.downloadInProgress = false;
                    var headers = resp.headers();
                    var filename = headers["content-disposition"];
                    filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                    var serverData = new Blob([resp.data], { type: headers['content-type'] });
                    FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
                }, function (err) {
                    vm.downloadInProgress = false;
                    if ("TextDecoder" in window) {
                        try {
                            var enc = new TextDecoder("utf-8");
                            var data = enc.decode(err.data);
                            err = JSON.parse(data);
                        } catch (ignore) { }
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });

        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceLinkage')
        .controller('InventoryManagementCtrl', InventoryManagementCtrl);

    /** @ngInject */
    function InventoryManagementCtrl(requests, $filter, baUtil, types, filterOptions, $state, toastr,$translate, $scope, AuthService, DeviceLinkageService) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();
        vm.localTranslator = $filter('translate');
        vm.showBulkEdit = showBulkEdit;
        vm.onBulkEdit = onBulkEdit;
        vm.isEdit = false;
        vm.selectAll = selectAll;
        vm.getStatus = getStatus;
        vm.getDrRequestTypeStatus = getDrRequestTypeStatus;
        vm.openDeviceDetail = openDeviceDetail;
        vm.selectedRequests = {}
        vm.query = {}
        vm.filters = {}
        vm.paginateCallback = paginateCallback
        vm.isUndefinedOrNullOrEmptyObject = baUtil.isUndefinedOrNullOrEmptyObject
        vm.timeConverter = baUtil.timeConverter
        vm.isBulkDeviceRequestEditDisabled = isBulkDeviceRequestEditDisabled
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ ? true : false;
        vm.writeVisible = vm.permissions.DEVICE_REQUEST.SHOW_WRITE ? true : false;
        vm.isPartner = baUtil.isPartnerUser();
        vm.isMerchantOrMerchantAndDeviceOwner = baUtil.isMerchantOrMerchantAndDeviceOwner();
        vm.isDeviceOwner = baUtil.isDeviceOwner();
        //        vm.isLoading = false;
        vm.applyFilters = applyFilters
        vm.clearFilters = clearFilters
        vm.filterOptions = filterOptions.data.data;
        vm.setFiltersOptionsOfCurrentLanguage = setFiltersOptionsOfCurrentLanguage;


        vm.visibilityPermission = vm.isSystemUser ? {
            "serviceContract": true,
            "partner": true,
            "merchant_name": true,
            "device_owner_name": true,
            "desired_delivery_date": false,
            "storeName": true,
            "branchName": false
        } :
            vm.isPartner ? {
                "serviceContract": true,
                "partner": false,
                "merchant_name": true,
                "device_owner_name": true,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": false
            } :
                vm.isMerchantOrMerchantAndDeviceOwner ? {
                    "serviceContract": false,
                    "partner": false,
                    "merchant_name": false,
                    "device_owner_name": true,
                    "desired_delivery_date": false,
                    "storeName": true,
                    "branchName": true
                } : vm.isDeviceOwner ? {
                    "serviceContract": false,
                    "partner": false,
                    "merchant_name": true,
                    "device_owner_name": false,
                    "desired_delivery_date": false,
                    "storeName": true,
                    "branchName": false
                } : {
                    "serviceContract": false,
                    "partner": false,
                    "merchant_name": true,
                    "device_owner_name": false,
                    "desired_delivery_date": false,
                    "storeName": false,
                    "branchName": false
                };


        if (requests.status >= 200 && requests.status <= 299) {
            vm.requests = requests.data.data;
        }

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        vm.dateOptions = {
            showWeeks: false,
            formatDayTitle: 'yyyy 年 MMMM',
            formatMonthTitle: 'yyyy 年',
            minDate: new Date(1970, 0, 2)
        }
        if (baUtil.isSystemAdmin()) {
            vm.systemAdmin = true;
        }
        else {
            vm.systemAdmin = false;
        }


        vm.changeFirstDateRange = changeFirstDateRange;

        function createdByOrgTitle() {
            vm.createdByOrgTitle = {};
            for (var i = 0; i < vm.requests.content.length; i++) {
                if (vm.requests.content[i].createdByOrg == 'SYSTEM') {
                    vm.createdByOrgTitle[i] = "SYSTEM";
                }
                else {
                    if (baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg;
                    }
                    else if (!baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgMerchantCode + ' / ' + vm.requests.content[i].createdByOrgDeviceOwnerCode + ')';
                    }
                    else if (baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgDeviceOwnerCode + ')';
                    }
                    else if (!baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgMerchantCode + ')';
                    }
                }
            }
        }

        createdByOrgTitle();



        $scope.$on('LANG_CHANGE', function (event) {
            setFiltersOptionsOfCurrentLanguage();
        });

        function setFiltersOptionsOfCurrentLanguage() {

            vm.filterOptions.options = {};
            setFilterOptionsOfKey("CustomDeviceInstallationStatus", "status");
            setFilterOptionsOfKey("DeviceJescaStatus", "jesca_status");
            setFilterOptionsOfKey("ServiceContractId", "serviceContractId");
            setFilterOptionsOfKey("ItemName", "dr_requestType")
            var replacementOptions = { en: 'Show Replacement Devices', jp: '交換端末表示' }
            vm.filterOptions.options["Replacement"] = [{ label: replacementOptions[getLang()], value: true }]

            if (!(vm.isSystemUser || vm.isPartner)) {
                setFilterOptionsOfKey("DeviceInstallationSettlementBranch", "settlementBranch");
            }

            if (vm.isMerchantOrMerchantAndDeviceOwner || vm.isSystemUser || vm.isPartner) {
                setFilterOptionsOfKey("DeviceInstallationDeviceOwner", "deviceOwner");
            }

            if (vm.isDeviceOwner || vm.isSystemUser || vm.isPartner) {
                setFilterOptionsOfKey("DeviceInstallationMerchant", "merchant");
            }

            if (vm.isSystemUser) {
                setFilterOptionsOfKey("DeviceInstallationPartner", "partner");
            }

            vm.filterOptions.options["DateOptions"] = (vm.filterOptions["DateOptions"] || []).map(function (d, i) {
                return { label: d[getLang()], value: d["key"] };
            });

            vm.filterOptions.options["devices"] = (vm.filterOptions["Devices"] || []).map(function (d, i) {
                return { label: d, value: d };
            });


        }

        setFiltersOptionsOfCurrentLanguage();

        function setFilterOptionsOfKey(targetKey, resultKey) {
            try {
                var keys = vm.filterOptions[targetKey]["key"];
                vm.filterOptions.options[resultKey] = vm.filterOptions[targetKey][$translate.use()].map(function (d, i) {
                    return { label: d, value: keys[i] };
                });
            }
            catch (e) {
                vm.filterOptions.options[resultKey] = [];
            }
        }

        function applyFilters() {
            vm.isLoading = true;
            if (vm.filters && vm.filters.DEVICE_REPLACEMENT && vm.filters.DEVICE_REPLACEMENT.length) {
                vm.filters.DEVICE_REPLACEMENT = [{ label: vm.filters.DEVICE_REPLACEMENT[0].label, value: true }];
            } else {
                delete vm.filters.DEVICE_REPLACEMENT;
            }
            if (vm.filters && vm.filters.reservationDateFrom && vm.filters.reservationDateTo) {
                vm.filters.RESERVATION_DATETIME = [{ label: vm.filters.reservationDateFrom, value: new Date(vm.filters.reservationDateFrom).getTime() },
                { label: vm.filters.reservationDateTo, value: new Date(vm.filters.reservationDateTo).getTime() }];
            }

            if (vm.filters && vm.filters.search) {
                if (vm.filters.search.installationLocation) {
                    vm.filters.INSTALLATION_LOCATION = [{ label: vm.filters.search.installationLocation, value: vm.filters.search.installationLocation }];
                } else {
                    delete vm.filters.INSTALLATION_LOCATION;
                }

                if (vm.filters.search.DEVICE_SERIAL) {
                    var deviceSerialString = vm.filters.search.DEVICE_SERIAL;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.DEVICE_SERIAL = [];

                    angular.forEach(deviceSerialArray, function (values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.DEVICE_SERIAL.push({ label: noComma, value: noComma });
                        }

                    });
                }
                else {
                    delete vm.filters.DEVICE_SERIAL;
                }

                if (vm.filters.search.RECEIPT_NUMBER) {
                    var deviceSerialString = vm.filters.search.RECEIPT_NUMBER;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.RECEIPT_NUMBER = [];

                    angular.forEach(deviceSerialArray, function (values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.RECEIPT_NUMBER.push({ label: noComma, value: noComma });
                        }

                    });
                }
                else {
                    delete vm.filters.RECEIPT_NUMBER;
                }

                if (vm.filters.search.DEVICE_APPLICATION_NUMBER) {
                    var deviceSerialString = vm.filters.search.DEVICE_APPLICATION_NUMBER;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.DEVICE_APPLICATION_NUMBER = [];

                    angular.forEach(deviceSerialArray, function (values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.DEVICE_APPLICATION_NUMBER.push({ label: noComma, value: noComma });
                        }

                    });
                }
                else {
                    delete vm.filters.DEVICE_APPLICATION_NUMBER;
                }

                if (vm.filters.search.remarks) {
                    vm.filters.REMARKS = [{ label: vm.filters.search.remarks, value: vm.filters.search.remarks }];
                } else {
                    delete vm.filters.REMARKS;
                }
            }


            if (vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress) return;


            var filterString = Object.keys(vm.filters).map(function (d, i) {
                return vm.filters[d] && vm.filters[d].length ?
                    d + ":" + vm.filters[d].map(function (data) { return data["value"] }).join("|") :
                    "";
            }).filter(function (val) { return val != "" }).join(",");
            vm.query.filters = filterString;
            vm.query.pageNumber = 0;
            vm.dataFetchInProgress = true
            DeviceLinkageService
                .getAllInventoryDeviceManagement(vm.query)
                .then(function (response) {
                    vm.dataFetchInProgress = false;
                    vm.requests = response.data.data;
                    vm.selectedRequests = {};
                    vm.select = false;
                    createdByOrgTitle();
                    vm.isLoading = false;

                }, function err(err) {
                    vm.dataFetchInProgress = false;
                    vm.isLoading = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    )
                });
        }

        function clearFilters() {
            vm.isLoading = true;
            if (vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress) return;
            vm.filters = {};
            delete vm.query.filters;
            delete vm.opFirstSelect;
            vm.query.pageNumber = 0;
            vm.dataFetchInProgressUsingClear = true
            DeviceLinkageService
                .getAllInventoryDeviceManagement(vm.query)
                .then(function (response) {
                    vm.dataFetchInProgressUsingClear = false;
                    vm.requests = response.data.data;
                    vm.selectedRequests = {};
                    vm.select = false;
                    createdByOrgTitle();
                    vm.isLoading = false;
                }, function err(err) {
                    vm.dataFetchInProgressUsingClear = false;
                    vm.isLoading = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    )
                });
        }


        function openDeviceDetail(ev, data) {
            $state.go('main.deviceRequest.deviceDetail', { ids: data.applicationNumber });
        }

        function isBulkDeviceRequestEditDisabled() {
            return Object.keys(vm.selectedRequests)
                .filter(function (id) { return vm.selectedRequests[id] })
                .length === 0;
        }

        var selectedItems = [];
        function onBulkEdit() {
            angular.forEach(vm.selectedRequests, function (isSelected, itemId) {
                if (isSelected) {
                    var selectedItem = vm.requests.content.find(function (item) {
                        return item.id == itemId
                    })
                }

                if (selectedItem) {
                    selectedItems.push(
                        selectedItem.receiptNumber + '-' + selectedItem.serialNumber
                    );
                }

            });
            vm.isBulkEditInProgress = true;
            DeviceLinkageService
                .updateDeviceApplicationChange(selectedItems)
                .then(function success(response) {
                    vm.isBulkEditInProgress = false;
                    $state.go('main.deviceLinkage.editDeviceApplicationChange', { deviceRequest: response.data.data, isJescaUpload: true });
                }, function err(err) {
                    vm.isBulkEditInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    )
                });
        }

        function showBulkEdit() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return false
            }

            return Object.keys(vm.selectedRequests).some(function (item) {
                return vm.selectedRequests[item]
            })
        }

        function selectAll(ev, list) {
            list.forEach(function (item) {
                vm.selectedRequests[item.id] = ev.target.checked
            })
        }

        function getStatus(key) {
            var index = vm.types.CustomDeviceInstallationStatusMaster.key.indexOf(key);
            return vm.types.CustomDeviceInstallationStatusMaster[$translate.use()][index]
        }


        function getDrRequestTypeStatus(key) {
            var index = vm.types.ItemName.key.indexOf(key);
            return vm.types.ItemName[$translate.use()][index]
        }


        function paginateCallback(query) {
            DeviceLinkageService
                .getAllInventoryDeviceManagement(query)
                .then(function (response) {
                    vm.requests = response.data.data;
                    vm.query = query;
                    vm.selectedRequests = {};
                    vm.select = false;
                    createdByOrgTitle();
                });
        }


        function changeFirstDateRange() {
            var dates = getDatePair(vm.filterOptions.DateOptions.filter(function (op) { return op.key === vm.opFirstSelect.value })[0]);
            vm.filters.reservationDateFrom = dates[0];
            vm.filters.reservationDateTo = dates[1];
        }

        function getDatePair(dateOption) {
            var isDay, isWeek, isMonth, isYear;
            isDay = (dateOption.unit == 1);
            isWeek = (dateOption.unit == 2);
            isMonth = (dateOption.unit == 3);
            isYear = (dateOption.unit == 4);

            var fromValue = dateOption.from - 1;
            var toValue = dateOption.to - 1;
            var today = new Date();
            var lastDay = new Date();
            var month = today.getMonth();
            var year = today.getFullYear();

            var fromDate, toDate;

            if (isDay) {
                var startDate = today.getDate() - fromValue;
                var endDate = lastDay.getDate() - toValue;
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(endDate);
            } else if (isWeek) {
                var weekDay = fromValue*7;
                var startDate = today.getDate() - today.getDay() - weekDay + (today.getDay() === 0 ? -6 : 0);
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(lastDay.getDate() - lastDay.getDay() - (toValue*7) + 6);
                if (toDate > new Date().getTime()) {
                    toDate = new Date().getTime();
                }
            } else if (isMonth) {
                var fromMonth = month - fromValue;
                var toMonth = month - toValue + 1;
                fromDate = new Date(year, fromMonth, 1).getTime();
                toDate = new Date(year, toMonth, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            } else if (isYear) {
                var fromYear = year - fromValue;
                var toYear = year - toValue;
                fromDate = new Date(fromYear, 0, 1).getTime();
                toDate = new Date(toYear,12, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            }
            return [fromDate, toDate];
        }

        function getLang() {
            return $translate.use();
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceLinkage')
        .factory('DeviceLinkageService', DeviceLinkageService);

    /** @ngInject */
    function DeviceLinkageService($translate, $http, API_CONFIG, AuthService) {
        var service = {};
        service.getKeyMap = getKeyMap
        service.getAllServiceContractId = getAllServiceContractId;
        service.getAllDeviceOwners = getAllDeviceOwners;
        service.getAllInventoryDeviceManagement = getAllInventoryDeviceManagement;
        service.updateDeviceApplicationChange = updateDeviceApplicationChange;
        service.reserveDeviceApplicationChange = reserveDeviceApplicationChange;
        service.downloadDeviceApplicationChangeExcel = downloadDeviceApplicationChangeExcel;
        service.createDeviceApplicationChange = createDeviceApplicationChange;

        function getKeyMap(deviceOwnerId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/cdi/getAllServiceContractIdInfo?deviceOwnerId='+deviceOwnerId,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getAllServiceContractId(){
            return $http({
                url: API_CONFIG.url + '/api/v1/cdi/getAllServiceContractIdInfo',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getAllDeviceOwners(){
            return $http({
                url: API_CONFIG.url + '/api/v1/cdi/getDeviceOwners',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        } 
        

        function getAllInventoryDeviceManagement(query) {
            var url = API_CONFIG.url + '/api/v1/cdi/inventoryDeviceManagement';
            return $http({
                url: url,
                method: 'post',
                data: query,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'

                },
            });
        }

        function updateDeviceApplicationChange(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/cdi/editMultiple',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function reserveDeviceApplicationChange(data,immediately,isReservation) {
            return $http({
                url: API_CONFIG.url + '/api/v1/cdi/updateMultiple?immediately=' + immediately + '&isReservation=' + isReservation,
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function downloadDeviceApplicationChangeExcel(data) {
            var url = API_CONFIG.url + '/api/v1/cdi/multiple/download';

            return $http({
                url: url,
                method: 'POST',
                data: data,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function createDeviceApplicationChange(data,deviceOwnerId,serviceContractId){
            return $http({
                url: API_CONFIG.url + '/api/v1/cdi/create?deviceOwnerId=' + deviceOwnerId + '&serviceContractId=' + serviceContractId,
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        return service;



    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceManagement')
        .controller('DeviceManagementListCtrl', DeviceManagementListCtrl);

    /** @ngInject */
    function DeviceManagementListCtrl(DeviceManagementService, $filter,$uibModal, types, $translate, $timeout, toastr, baUtil, $state, $scope, $stateParams, filterOptions, deviceList, localStorageService, allTypes, DEFAULT_DEVICE_RUNNING_STATUS_KEYS) {
        var vm = this;
        vm.getLang = getLang;
        vm.getDeviceRunningStatusFromKey = getDeviceRunningStatusFromKey;
        vm.getMoneyTypesFromKeys = getMoneyTypesFromKeys;
        vm.getMoneyTypesColumns = getMoneyTypesColumns;
        vm.baUtil = baUtil;
        vm.getDeviceSerialHtml = getDeviceSerialHtml; 
        vm.showDeviceHistoryModal = showDeviceHistoryModal;
        vm.account = baUtil.getAccountDto();
        vm.filters = $stateParams.filters ? JSON.parse($stateParams.filters) : {};
        vm.paginateCallback = paginateCallback;
        vm.isMerchantOrDeviceOwner = baUtil.isMerchantOrDeviceOwner();
        vm.getDeviceData=getDeviceData;
        vm.downloadCsv=downloadCsv;
        vm.localTranslator = $filter('translate');
        vm.changeFirstDateRange = changeFirstDateRange;
        vm.changeSecondDateRange = changeSecondDateRange;
        vm.changeThirdDateRange = changeThirdDateRange;
        vm.changeFourthDateRange = changeFourthDateRange;
        vm.selectedRequests = {};
        vm.query = {}
        vm.filters = {}
        vm.applyFilters = applyFilters
        vm.clearFilters = clearFilters
        vm.clearDates = clearDates;
        vm.changeFilter = changeFilter;
        vm.options = {};
        vm.refreshflag = null;
//        vm.isLoading = true;
        vm.dateOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date(1970,0,2),
            maxDate : new Date()
         }
		vm.setFiltersOptionsOfCurrentLanguage = setFiltersOptionsOfCurrentLanguage;

        if (deviceList.status >= 200 && deviceList.status <= 299) {
            vm.deviceList = deviceList.data.data;
//            vm.isLoading = false;
        }

        if (filterOptions.status >= 200 && filterOptions.status <= 299) {
            vm.filterOptions = filterOptions.data.data;
        }

        if (baUtil.isSystemAdmin()) {
            vm.systemAdmin = true;
        }
        else {
            vm.systemAdmin = false;
        }

        vm.isSystemUser = baUtil.isSystemUser();

        function getDatePair(dateOption) {
            var isDay, isWeek, isMonth, isYear;
            isDay = (dateOption.unit == 1);
            isWeek = (dateOption.unit == 2);
            isMonth = (dateOption.unit == 3);
            isYear = (dateOption.unit == 4);

            var fromValue = dateOption.from - 1;
            var toValue = dateOption.to - 1;
            var today = new Date();
            var lastDay = new Date();
            var month = today.getMonth();
            var year = today.getFullYear();

            var fromDate, toDate;

            if (isDay) {
                var startDate = today.getDate() - fromValue;
                var endDate = lastDay.getDate() - toValue;
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(endDate);
            } else if (isWeek) {
                var weekDay = fromValue*7;
                var startDate = today.getDate() - today.getDay() - weekDay + (today.getDay() === 0 ? -6 : 0);
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(lastDay.getDate() - lastDay.getDay() - (toValue*7) + 6);
                if (toDate > new Date().getTime()) {
                    toDate = new Date().getTime();
                }
            } else if (isMonth) {
                var fromMonth = month - fromValue;
                var toMonth = month - toValue + 1;
                fromDate = new Date(year, fromMonth, 1).getTime();
                toDate = new Date(year, toMonth, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            } else if (isYear) {
                var fromYear = year - fromValue;
                var toYear = year - toValue;
                fromDate = new Date(fromYear, 0, 1).getTime();
                toDate = new Date(toYear,12, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            }
            return [fromDate, toDate];
        }

        function changeFirstDateRange() {
            var dates = getDatePair(vm.filterOptions.DateOptions.filter(function(op){return op.key===vm.opFirstSelect.value})[0]);
            vm.filters.installDateFrom = dates[0];
            vm.filters.installDateTo = dates[1];
        }

        function changeSecondDateRange() {
            var dates = getDatePair(vm.filterOptions.DateOptions.filter(function(op){return op.key===vm.opSecondSelect.value})[0]);
            vm.filters.communicationDateFrom = dates[0];
            vm.filters.communicationDateTo = dates[1];
        }

        function changeThirdDateRange() {
            var dates = getDatePair(vm.filterOptions.DateOptions.filter(function(op){return op.key===vm.opThirdSelect.value})[0]);
            vm.filters.salesDateFrom = dates[0];
            vm.filters.salesDateTo = dates[1];
        }

        function changeFourthDateRange() {
            var dates = getDatePair(vm.filterOptions.DateOptions.filter(function(op){return op.key===vm.opFourthSelect.value})[0]);
            vm.filters.deviceDeliveryDateFrom = dates[0];
            vm.filters.deviceDeliveryDateTo = dates[1];
        }

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.allTypes = allTypes.data.data;
        }

        vm.tableOptions = {
            'status': {
                'en': 'Status',
                'jp': '状況',
                'column': 'runningStatus'
            },
            'productName': {
                'en': 'Product Name',
                'jp': '品名',
                'column': 'productName'
            },
            'deviceSerial': {
                'en': 'Device Serial',
                'jp': '端末シリアル',
                'column': 'deviceSerialNumber'
            },
            'partnerNames': {
                'en': 'P',
                'jp': 'P',
                'column': 'partnerNames'
            },
            'owner': {
                'en': 'Owner',
                'jp': '所有者',
                'column': 'ownerName'
            },
            'merchant': {
                'en': 'Merchant',
                'jp': '加盟店',
                'column': 'merchantName'
            },
            'salesCenter': {
                'en': 'Sales Center',
                'jp': '支店・営業所',
                'column': 'salesCenter'
            },
            'locationName': {
                'en': 'Location Name',
                'jp': '設置場所名',
                'column': 'storeName'
            },
            'operationStartDate': {
                'en': 'Operation Start Date',
                'jp': '稼働開始日',
                'column': 'startDate'
            },
            'moneyTypes': {
                'en': 'Money Types',
                'jp': 'マネー種',
                'column': 'moneyTypes'
            },
            'signal': {
                'en': 'Signal',
                'jp': '電波',
                'column': 'signal'
            },
            'lastCommunicationDate': {
                'en': 'Last Communication Date',
                'jp': '最終通信日',
                'column': 'lastCommunicationTime'
            },
            'lastSalesDate': {
                'en': 'Last Sales Date',
                'jp': '最終売上日',
                'column': 'lastSalesTime'
            },
            'lastModifiedDate':{
                'en':'Last Modified Date',
                'jp':'情報更新日時',
                'column':'lastModified'
            }
        }

        var csvHeaders = {
            'en': ['#', 'Status', 'Product Name', 'Device Serial', 'P', 'Owner', 'Merchant', 'Sales Center', 'Location Name', 'Start Date', 'Install Date', 'Signal', 'Last Communication Date', 'Last Sales Date'],
            'jp': ['#', '状況', '品名', '端末シリアル', 'P', '所有者', '加盟店', '支店・営業所', '設置場所名', '稼働開始日時', '設置日時', '電波', '最終通信日', '最終売上日']
        }

        var additionalCsvHeaders = {
            'en': ['Last Modified Date','HW Delivery Date','Installation Destination Code',"Remarks 1","Remarks 2","Remarks 3","Remarks 11","Remarks 12","Remarks 32"],
            'jp': ['情報更新日時','HW納品日','設置先コード','備考１','備考２','備考３','備考11','備考12','備考３２']
        }

        vm.moneyTypesInUse = [];
        for (var i=0; i<vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if (vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                vm.moneyTypesInUse.push(vm.types.PaymentHandlingOption.E_MONEY.key[i])
	            csvHeaders['en'].push(vm.types.PaymentHandlingOption.E_MONEY.en[i])
	            csvHeaders['jp'].push(vm.types.PaymentHandlingOption.E_MONEY.jp[i])
            }
        }
        for (var i=0; i<vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if (vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                vm.moneyTypesInUse.push(vm.types.PaymentHandlingOption.QR_MONEY.key[i])
	            csvHeaders['en'].push(vm.types.PaymentHandlingOption.QR_MONEY.en[i])
	            csvHeaders['jp'].push(vm.types.PaymentHandlingOption.QR_MONEY.jp[i])
            }
        }
        for (var i=0; i<vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if (vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                vm.moneyTypesInUse.push(vm.types.PaymentHandlingOption.CREDIT_CARD.key[i])
	            csvHeaders['en'].push(vm.types.PaymentHandlingOption.CREDIT_CARD.en[i])
	            csvHeaders['jp'].push(vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i])
            }
        }
        Object.values(vm.moneyTypesInUse);
        setStaticFilters();
        setFiltersOptionsOfCurrentLanguage();

        function setStaticFilters() {
            var staticOptions = ["Partners","Merchants","DeviceOwners"];
                staticOptions.forEach(function(filter) {
                    vm.options[filter] = vm.filterOptions[filter].map(function(row,i){
                        return { label: row[0].concat(", ", row[1]), value: row[0] };
                    });
                });
                vm.options["Branches"]=vm.filterOptions["Branches"].map(function(row,i){
                   return { label: row[0].concat(", ", row[1], ", ", row[2]), value: [row[0], row[1]] };
                });
                vm.options["Devices"]=vm.filterOptions["Devices"];
                vm.options["Signal"]=vm.filterOptions["Signal"];
        }

        function setFiltersOptionsOfCurrentLanguage() {
            var dynamicOptions = ["Status","MoneyTypes", "ProductNames"];
            dynamicOptions.forEach(function(filter) {
                var keys = vm.filterOptions[filter]["key"];
                vm.options[filter] = vm.filterOptions[filter][getLang()].map(function(d,i){
                    return { label: d, value: keys[i] };
                });
            });
            vm.options["DateOptions"] = vm.filterOptions["DateOptions"].map(function(d,i){
                return { label: d[getLang()], value: d["key"] };
            });
            var replacementOptions = {en: 'Show Replacement Devices', jp:'交換端末表示' }
            vm.options["Replacement"] = [{label: replacementOptions[getLang()], value: true}]
        }

        function getDefaultRunningStatusSelections() {
            return vm.options.Status.filter(function (opt) {
                return DEFAULT_DEVICE_RUNNING_STATUS_KEYS.indexOf(opt.value) !== -1;
            });
        }

        function refreshRunningStatusSelections() {
            if (!vm.filters.runningStatuses || !vm.filters.runningStatuses.length) {
                return;
            }
            var selectedValues = vm.filters.runningStatuses.map(function (m) { return m.value; });
            vm.filters.runningStatuses = vm.options.Status.filter(function (opt) {
                return selectedValues.indexOf(opt.value) !== -1;
            });
        }

        function mapRunningStatusesFilter() {
            return vm.filters.runningStatuses && vm.filters.runningStatuses.map(function (m) { return m.value; });
        }

        function initializeDefaultFilters() {
            vm.filters.runningStatuses = getDefaultRunningStatusSelections();
            vm.query.filters = {
                runningStatuses: mapRunningStatusesFilter(),
                pageNumber: 0,
                pageSize: vm.deviceList && vm.deviceList.pageable && vm.deviceList.pageable.pageSize
            };
        }

        initializeDefaultFilters();

        function prepareTableData(data) {
            if (baUtil.isUndefinedOrNull(data)) {
                return
            }
            if(!vm.isSystemUser) {
                csvHeaders["en"].splice(4,1);
                csvHeaders["jp"].splice(4,1);
                delete vm.tableOptions.partnerNames;
            }
            var tableOptionKeys = Object.keys(vm.tableOptions);
            var tableHeaders = [];
            var columns = [];
            tableOptionKeys.forEach(function (item) {
                tableHeaders.push(vm.tableOptions[item])
                columns.push(vm.tableOptions[item].column)
            })
            vm.tableHeaders = tableHeaders;
            vm.columns = columns;

            $timeout(function () {
                vm.tableData = data;
                vm.showTable = true;
            });

            vm.isLoading = false;
        }
        prepareTableData(vm.deviceList);

        function getDeviceRunningStatusFromKey(item) {
            var resultIndex = vm.types.DeviceRunningStatus.key.indexOf(item);
            return vm.types.DeviceRunningStatus[vm.getLang()][resultIndex];
        }

        function getDeviceSerialHtml(deviceSerial) {
            var title = vm.localTranslator("device.request.history.msg");
            return '<a class="link m-no-error"   title=" ' +   title + ' " ng-click="vm.showDeviceHistoryModal(data[column])"> ' +  deviceSerial + '</a>';
        }

        function getMoneyTypesFromKeys(items) {
            var paymentOptions = [];
	        Object.keys(items).forEach(function(item) {
	            if (vm.moneyTypesInUse.indexOf(item)===-1)
	                return;
	            var eMoneyIndex = vm.types.PaymentHandlingOption.E_MONEY.key.indexOf(item);
                var qrMoneyIndex = vm.types.PaymentHandlingOption.QR_MONEY.key.indexOf(item);
                var creditCardIndex = vm.types.PaymentHandlingOption.CREDIT_CARD.key.indexOf(item);
                var moneyType = "";
	            if (eMoneyIndex !== -1) {
	                moneyType = vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][eMoneyIndex];
	            } else if(qrMoneyIndex !== -1) {
	                moneyType = vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][qrMoneyIndex];
	            }else{
                    moneyType = vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][creditCardIndex];
                }
	            if (items[item] === "UNREGISTERED_AVAILABLE") {
	                paymentOptions.push(moneyType.fontcolor("red"));
                }
	            else if (items[item] === "REGISTERED_UNAVAILABLE") {
                    paymentOptions.push(moneyType.fontcolor("red").strike());
                }
                else {
                    paymentOptions.push(moneyType);
                }
            });
            return paymentOptions.toString();
        }

        function getLang() {
            return $translate.use();
        }

        function paginateCallback(query) {

            vm.isLoading = true;

            if (!baUtil.isUndefinedOrNull(query.filters)) {
                vm.query = query.filters;
                vm.query.pageNumber = query.pageNumber;
                vm.query.pageSize = query.pageSize;
            }
            else {
                vm.query = query;
            }
	        DeviceManagementService
	        .fetchDeviceMonitoringRecords(vm.query)
	            .then(function (response) {
	                vm.deviceList= response.data.data;
	                vm.query =  query;
                    vm.selectedRequests = {};
                    vm.select = false;
	                vm.inProgress = false;
	                vm.isLoading = false;
	            }).catch(function (err) {
	                toastr.error(
	                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
	                    vm.localTranslator("common.components.title.error"),
	                    baUtil.toastOptions()
	                );
	                vm.inProgress = false;
	                vm.isLoading = false;
	            });
        }

        function changeFilter() {
            var newFilterCondition = {
                "partnerNames": vm.filters.partnerNames && vm.filters.partnerNames.map(function(m){return m.value}),
                "merchantNames": vm.filters.merchantNames && vm.filters.merchantNames.map(function(m){return m.value}),
                "deviceOwnerNames": vm.filters.deviceOwnerNames && vm.filters.deviceOwnerNames.map(function(m){return m.value}),
                "merchantCodeBranchNamePairs": vm.filters.merchantCodeBranchNamePairs && vm.filters.merchantCodeBranchNamePairs.map(function(m){return m.value})
            };
            DeviceManagementService.getDeviceManagementFilterOptions(newFilterCondition)
                .then(function (response) {
                    var newOptions = response.data.data;
                    var staticOptions = ["Partners","Merchants","DeviceOwners"];
                    staticOptions.forEach(function(filter) {
                        vm.options[filter] = newOptions[filter].map(function(row,i){
                            return { label: row[0].concat(", ", row[1]), value: row[0] };
                        });
                    });
                    vm.options["Branches"] = newOptions["Branches"].map(function(row,i){
                       return { label: row[0].concat(", ", row[1], ", ", row[2]), value: [row[0], row[1]] };
                    });
                    vm.options["Devices"] = newOptions["Devices"];
                    vm.options["Devices"] = newOptions["ProductName"];
                    vm.refreshflag = new Date().getTime();


                }, function err(err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    )
                });

        }

        $scope.$on('LANG_CHANGE', function (event) {
            setFiltersOptionsOfCurrentLanguage();
            refreshRunningStatusSelections();
        });

        function applyFilters() {
            if(vm.filters) {

                if(vm.filters.DEVICE_SERIAL) {
                    var deviceSerialString = vm.filters.DEVICE_SERIAL;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.deviceSerials = [];

                    angular.forEach(deviceSerialArray, function(values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.deviceSerials.push(noComma);
                        }

                    });
                }
                else {
                    delete vm.filters.deviceSerials;
                }
            }

            vm.isLoading = true;

            if(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress) return;
            if (!angular.isNumber(vm.filters.installDateFrom) && !baUtil.isUndefinedOrNull(vm.filters.installDateFrom )) {
                vm.filters.installDateFrom = vm.filters.installDateFrom.getTime();
            }
            if (!angular.isNumber(vm.filters.installDateTo) && !baUtil.isUndefinedOrNull(vm.filters.installDateTo )) {
                vm.filters.installDateTo = vm.filters.installDateTo.getTime();
            }
            if (!angular.isNumber(vm.filters.communicationDateFrom) && !baUtil.isUndefinedOrNull(vm.filters.communicationDateFrom )) {
                vm.filters.communicationDateFrom = vm.filters.communicationDateFrom.getTime();
            }
            if (!angular.isNumber(vm.filters.communicationDateTo) && !baUtil.isUndefinedOrNull(vm.filters.communicationDateTo )) {
                vm.filters.communicationDateTo = vm.filters.communicationDateTo.getTime();
            }
            if (!angular.isNumber(vm.filters.installDateFrom) && !baUtil.isUndefinedOrNull(vm.filters.installDateFrom )) {
                vm.filters.installDateFrom = vm.filters.installDateFrom.getTime();
            }
            if (!angular.isNumber(vm.filters.salesDateFrom) && !baUtil.isUndefinedOrNull(vm.filters.salesDateFrom )) {
                vm.filters.salesDateFrom = vm.filters.salesDateFrom.getTime();
            }
            if (!angular.isNumber(vm.filters.salesDateTo) && !baUtil.isUndefinedOrNull(vm.filters.salesDateTo )) {
                vm.filters.salesDateTo = vm.filters.salesDateTo.getTime();
            }
            if (!angular.isNumber(vm.filters.deviceDeliveryDateFrom) && !baUtil.isUndefinedOrNull(vm.filters.deviceDeliveryDateFrom )) {
                vm.filters.deviceDeliveryDateFrom = vm.filters.deviceDeliveryDateFrom.getTime();
            }
            if (!angular.isNumber(vm.filters.deviceDeliveryDateTo) && !baUtil.isUndefinedOrNull(vm.filters.deviceDeliveryDateTo )) {
                vm.filters.deviceDeliveryDateTo = vm.filters.deviceDeliveryDateTo.getTime();
            }
            var filterString = {
                "partnerNames": vm.filters.partnerNames && vm.filters.partnerNames.map(function(m){return m.value}),
                "merchantNames": vm.filters.merchantNames && vm.filters.merchantNames.map(function(m){return m.value}),
                "deviceOwnerNames": vm.filters.deviceOwnerNames && vm.filters.deviceOwnerNames.map(function(m){return m.value}),
                "merchantCodeBranchNamePairs": vm.filters.merchantCodeBranchNamePairs && vm.filters.merchantCodeBranchNamePairs.map(function(m){return m.value}),
                "deviceSerials": vm.filters.deviceSerials,
                "runningStatuses": mapRunningStatusesFilter(),
                "signalStrengths": vm.filters.signalStrengths,
                "moneyTypes": vm.filters.moneyTypes && vm.filters.moneyTypes.map(function(m){return m.value}),
                "productNames": vm.filters.productNames && vm.filters.productNames.map(function(m){return m.value}),
                "installDateFrom": vm.filters.installDateFrom,
                "installDateTo": vm.filters.installDateTo,
                "communicationDateFrom": vm.filters.communicationDateFrom,
                "communicationDateTo": vm.filters.communicationDateTo,
                "salesDateFrom": vm.filters.salesDateFrom,
                "salesDateTo": vm.filters.salesDateTo,
                "deviceDeliveryDateFrom": vm.filters.deviceDeliveryDateFrom,
                "deviceDeliveryDateTo": vm.filters.deviceDeliveryDateTo,
                "installationDestinationCode" : vm.filters.installationDestinationCode,
                "remarks": vm.filters.remarks,
                "isReplaced": vm.filters.isReplaced && vm.filters.isReplaced.map(function(m){return m.value})[0],
                "pageNumber":0,
                "pageSize":vm.deviceList.size
            }
            vm.query.filters = filterString;
            vm.dataFetchInProgress = true
            DeviceManagementService.fetchDeviceMonitoringRecords(vm.query.filters)
            .then(function (response) {
                vm.dataFetchInProgress = false;
                vm.deviceList = response.data.data;
                vm.selectedRequests = {};
                vm.select = false;
                vm.isLoading = false;
            }, function err(err) {
                vm.dataFetchInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                vm.isLoading = false;
            });
        }

        function clearFilters() {
            vm.isLoading = true;
            if(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress) return;
            delete vm.query.filters;
            delete vm.opFirstSelect;
            delete vm.opSecondSelect;   
            delete vm.opThirdSelect;
            delete vm.opFourthSelect;
            delete vm.filters;
            vm.filters = {};
            vm.filters.runningStatuses = getDefaultRunningStatusSelections();
            var filterString = {
                "runningStatuses": mapRunningStatusesFilter(),
                "pageNumber":0,
                "pageSize":vm.deviceList.size
            }
            vm.query.filters = filterString;
            vm.dataFetchInProgressUsingClear = true
            DeviceManagementService.fetchDeviceMonitoringRecords(vm.query.filters)
            .then(function (response) {
                vm.dataFetchInProgressUsingClear = false;
                vm.deviceList = response.data.data;
                vm.selectedRequests = {};
                vm.select = false;
                vm.isLoading = false;
            }, function err(err) {
                vm.dataFetchInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                vm.isLoading = false;
            });
            DeviceManagementService.getDeviceManagementFilterOptions({})
                .then(function (response) {
                var newOptions = response.data.data;
                var staticOptions = ["Partners","Merchants","DeviceOwners"];
                staticOptions.forEach(function(filter) {
                    vm.options[filter] = newOptions[filter].map(function(row,i){
                        return { label: row[0].concat(", ", row[1]), value: row[0] };
                    });
                });
                vm.options["Branches"] = newOptions["Branches"].map(function(row,i){
                   return { label: row[0].concat(", ", row[1], ", ", row[2]), value: [row[0], row[1]] };
                });
                vm.options["Devices"] = newOptions["Devices"];
                vm.refreshflag = new Date().getTime();

                vm.isLoading = false;

            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                vm.isLoading = false;
            });
        }

        function clearDates(date) {
            switch (date) {
                case 1:
                    delete vm.opFirstSelect;
                    delete vm.filters.installDateFrom;
                    delete vm.filters.installDateTo;
                    break;

                case 2:
                    delete vm.opSecondSelect;
                    delete vm.filters.communicationDateFrom;
                    delete vm.filters.communicationDateTo;
                    break;

                case 3:
                    delete vm.opThirdSelect;
                    delete vm.filters.salesDateFrom;
                    delete vm.filters.salesDateTo;
                    break;

                case 4:
                    delete vm.opFourthSelect;
                    delete vm.filters.deviceDeliveryDateFrom;
                    delete vm.filters.deviceDeliveryDateTo;
                    break;
    
            }
        }

        function getDeviceData() {
//            vm.filters.organisationName = vm.selectedOrg ? (vm.selectedOrg.name || "") : "";
//            vm.filters.salesCenter = vm.selectedSalesCenter.branchCode;
//            vm.filters.deviceSerial = vm.selectedDevice;
//            vm.filters.pageNumber = 0;
//            getData();
        }

        function downloadCsv() {
            var rows = [
                csvHeaders[getLang()]
            ];
            var new_rows= [
                additionalCsvHeaders[getLang()]
            ]
            rows[0] = rows[0].concat(new_rows[0])
            var query = angular.copy(vm.query.filters);
            if (baUtil.isUndefinedOrNull(query))
                query = {}
            if (!query.runningStatuses) {
                query.runningStatuses = mapRunningStatusesFilter();
            }
            query.pageSize = 0;
            vm.csvInProgress = true;

            DeviceManagementService.fetchDeviceMonitoringRecords(query)
                .then(function (response) {
                    var deviceList= response.data.data.content;
                    var i=1;
                    vm.newColumns = ["lastModified","hwDeliveryDate","installationDestinationCode","remarks1","remarks2","remarks3","remarks11","remarks12","remarks32"];
                    var newKeys =["additionalColumns"]
                    vm.columns = vm.columns.concat(newKeys);
	                deviceList.forEach(function(data) {
	                    var row = [i++];
	                    var moneyTypesRow = [];
                        vm.additionalColumnRow = [];
	                    vm.columns.forEach(function(column) {
	                        var val = null;
	                        if (column === 'runningStatus') {
		                        val = vm.getDeviceRunningStatusFromKey(data[column])
	                        } else if (column === 'salesCenter') {
                                val = data['branchName'] + ' (' + data['branchCode'] + ')'
                            } else if (column === 'startDate') {
	                            val = data['startDate']>0 ? $filter('date')(data[column], 'yyyy/MM/dd HH:mm:ss') : '';
	                            row.push(val)
	                            val = data['installationTime']>0 ? $filter('date')(data['installationTime'], 'yyyy/MM/dd HH:mm:ss') : '';
                            } else if (column === 'lastCommunicationTime' || column === 'lastSalesTime') {
                                val = data[column]>0 ? $filter('date')(data[column], 'yyyy/MM/dd HH:mm:ss') : '';
                            } else if(column === 'lastModified'){
                                return;
                            }
                             else if (column === 'moneyTypes') {
                                vm.moneyTypesInUse.forEach(function(mT) {
                                    if (data[column][mT]==="REGISTERED_AVAILABLE")
                                        moneyTypesRow.push(3)
                                    else if (data[column][mT]==="UNREGISTERED_AVAILABLE")
                                        moneyTypesRow.push(2)
                                    else if (data[column][mT]==="REGISTERED_UNAVAILABLE")
                                        moneyTypesRow.push(1)
                                    else
                                        moneyTypesRow.push(0)
                                })
                                return;
                            } else if (column === 'additionalColumns'){
                                vm.newColumns.forEach(function(item){
                                    if(item === 'lastModified'){
                                        val = data['lastModified']>0 ? $filter('date')(data['lastModified'], 'yyyy/MM/dd HH:mm:ss') : '';
                                        vm.additionalColumnRow.push(val);
                                    }
                                    else if(item === 'hwDeliveryDate'){
                                        val = data['hwDeliveryDate']>0 ? $filter('date')(data['hwDeliveryDate'], 'yyyy/MM/dd HH:mm:ss') : '';
                                        vm.additionalColumnRow.push(val);
                                    }
                                    else if(item === "installationDestinationCode"){
                                        vm.additionalColumnRow.push(data.deviceInstallationDMDto['installationDestinationCode'])
                                    }
                                    else if(item === "remarks1"){
                                        vm.additionalColumnRow.push(data.deviceInstallationDMDto['remarks1'])
                                    }
                                    else if(item === "remarks2"){
                                        vm.additionalColumnRow.push(data.deviceInstallationDMDto['remarks2'])
                                    }
                                    else if(item === "remarks3"){
                                        vm.additionalColumnRow.push(data.deviceInstallationDMDto['remarks3'])
                                    }
                                    else if(item === "remarks11"){
                                        vm.additionalColumnRow.push(data.deviceInstallationDMDto['remarks11'])
                                    }
                                    else if(item === "remarks12"){
                                        vm.additionalColumnRow.push(data.deviceInstallationDMDto['remarks12'])
                                    }
                                    else if(item === "remarks32"){
                                        vm.additionalColumnRow.push(data.deviceInstallationDMDto['remarks32'])
                                    }
                                })
                                return;
                            }
                             else {
                                val = data[column]
                            }
	                        val = baUtil.isUndefinedOrNull(val) ? '' : val.replace(/<\/?[^>]+(>|$)/g, "");
	                        row.push(val);
	                    })
	                    row = row.concat(moneyTypesRow,vm.additionalColumnRow);
	                    rows.push(row);
	                });
	                var fileName = '端末稼働管理_' + $filter('date')(new Date(), 'yyyyMMdd') + '.csv';
	                baUtil.exportToCsv(fileName, rows);
                    vm.columns = vm.columns.filter(function(column) {
                        return !newKeys.includes(column);
                    });
                    
                    vm.csvInProgress = false;
                }).catch(function (err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                    vm.csvInProgress = false;
                });
        }


        function showDeviceHistoryModal(deviceSerial) {
            $uibModal.open({
              animation: false,
              controller: function historyModalCtrl(DeviceManagementService, baUtil, toastr, $filter, deviceSerialNum,types) {
                var vm = this;
                vm.isLoading = false;
                vm.baUtil = baUtil;
                vm.deviceSerial = deviceSerialNum;
                vm.types = types;
                vm.deviceHistory; 
                vm.suspensionHistory;
                vm.localTranslator = $filter('translate');
                vm.getLang = getLang;
                vm.getValueFromTypeKey = getValueFromTypeKey;
                
        
                
                vm.boolOptions = {
                  en: ['Yes', 'No'],
                  jp: ['はい', 'いいえ'],
                  key: [true, false]
                }
            
                function getLang() {
                  return $translate.use();
                }
            
                function getValueFromTypeKey(key, type) {
                  var index = type.key.findIndex(function (item) {
                    return item === key
                  })
            
                  return type[vm.getLang()][index]
                }
            
            
                getDeviceHistory();
                getSuspensionDeviceHistory();
                function getDeviceHistory() {
                  vm.isLoading = true;
                  DeviceManagementService.getDeviceHistory(vm.deviceSerial)
                  .then(function (response) {
                    vm.deviceHistory = response;
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                  }).catch(function (err) {
                    vm.oldDeviceData = {}
                    toastr.error(
                      baUtil.getErrorMessageOrDefault(
                        err,
                        vm.localTranslator('common.components.msg.error.in.form')
                      ),
                      vm.localTranslator('common.components.title.error'),
                      baUtil.toastOptions()
                    )
                  })
                }

                function getSuspensionDeviceHistory() {
                    vm.isLoading = true;
                    DeviceManagementService.getSuspensionHistory(vm.deviceSerial)
                    .then(function (response) {
                      vm.suspensionHistory = response.DeviceSuspensionHistoryDtos;
                      $timeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                    }).catch(function (err) {
                      vm.oldDeviceData = {}
                      toastr.error(
                        baUtil.getErrorMessageOrDefault(
                          err,
                          vm.localTranslator('common.components.msg.error.in.form')
                        ),
                        vm.localTranslator('common.components.title.error'),
                        baUtil.toastOptions()
                      )
                    })
                  }
              },
              templateUrl: 'app/pages/device-request/views/device-history-modal.html',
              controllerAs: 'vm',
              size: "xl",
              resolve: {
                deviceSerialNum: function () {
                  return deviceSerial;
                },
                types:vm.allTypes.DeviceInstallationStatus
              }
            });
          };

        function getMoneyTypesColumns(items) {
            var registeredAvailableMoneyTypes = [];
            var unregisteredAvailableMoneyTypes = [];
            var registeredUnavailableMoneyTypes = [];

	        Object.keys(items).forEach(function(item) {
	            var eMoneyIndex = vm.types.PaymentHandlingOption.E_MONEY.key.indexOf(item);
                var qrMoneyIndex = vm.types.PaymentHandlingOption.QR_MONEY.key.indexOf(item);
                var creditCardIndex = vm.types.PaymentHandlingOption.CREDIT_CARD.key.indexOf(item);
	            var moneyType = "";
	            if (eMoneyIndex !== -1) {
	                moneyType = vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][eMoneyIndex];
	            } else if(qrMoneyIndex !== -1) {
	                moneyType = vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][qrMoneyIndex];
	            }else{
                    moneyType = vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][creditCardIndex];
                }
	            if (items[item] === "UNREGISTERED_AVAILABLE") {
	                unregisteredAvailableMoneyTypes.push(moneyType);
                }
	            else if (items[item] === "REGISTERED_UNAVAILABLE") {
                    registeredUnavailableMoneyTypes.push(moneyType);
                }
                else {
                    registeredAvailableMoneyTypes.push(moneyType);
                }
            });
            var paymentOptions = {
                'registeredAvailableMoneyTypes': registeredAvailableMoneyTypes.toString(),
                'unregisteredAvailableMoneyTypes': unregisteredAvailableMoneyTypes.toString(),
                'registeredUnavailableMoneyTypes': registeredUnavailableMoneyTypes.toString()
            };
            return paymentOptions;
        }
    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceManagement')
        .factory('DeviceManagementService', DeviceManagementService);

    /** @ngInject */
    function DeviceManagementService(baUtil, $translate, $http, API_CONFIG, AuthService) {
        var service = {};
        service.getDeviceManagementFilterOptions = getDeviceManagementFilterOptions;
        service.fetchDeviceMonitoringRecords = fetchDeviceMonitoringRecords;
        service.getDeviceHistory = getDeviceHistory;
        service.getSuspensionHistory = getSuspensionHistory;
        return service;

        function getDeviceManagementFilterOptions(filters) {
            return $http({
                url: API_CONFIG.paymentUrl + '/batch/api/v1/deviceMonitoring/options',
                method: 'post',
                data: filters,
                headers: {
					'X-COV-TOKEN': AuthService.getToken(),
					'Accept-Language': $translate.use(),
					'Pragma': 'no-cache',
					'Cache-Control': 'no-cache'
                },
            });
        }

        function fetchDeviceMonitoringRecords(filters) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/deviceMonitoring/get'),
                method: 'post',
                data: filters,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function getDeviceHistory(deviceSerial) {
            return $http({
                url: API_CONFIG.url + '/api/v1/device/history/' + deviceSerial,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        };


        function getSuspensionHistory(deviceSerial) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/suspension/history/' + deviceSerial,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        };




    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('ChangeRequestListCtrl', ChangeRequestListCtrl);

    /** @ngInject */
    function ChangeRequestListCtrl(requests, $filter, baUtil, types, filterOptions, $state, toastr, $stateParams, $translate, $timeout, $scope, AuthService, DeviceRequestService, $window, FileSaver, Blob, $uibModal, $sce) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.localTranslator = $filter('translate');
        vm.uploadForNewDeviceRequest = uploadForNewDeviceRequest;
        vm.uploadForNewJescaRequest = uploadForNewJescaRequest;
        vm.openDetail = openDetail;
        vm.openSuspendScreen = openSuspendScreen; 
        vm.showBulkEdit = showBulkEdit;
        vm.onBulkEdit = onBulkEdit;
        vm.onBulkJescaEdit = onBulkJescaEdit;
        vm.isEdit = false;
        vm.selectAll = selectAll;
        vm.getStatus = getStatus;
        vm.getJescaStatus = getJescaStatus;
        vm.getDrRequestTypeStatus = getDrRequestTypeStatus;
        vm.bulkDeviceEdit = bulkDeviceEdit;
        vm.openDeviceDetail = openDeviceDetail;
        vm.showDeviceHistoryModal = showDeviceHistoryModal;
        vm.uploadForDeviceDetail = uploadForDeviceDetail;
        vm.downloadShipmentExcel = downloadShipmentExcel;
        vm.downloadDeviceJMupsExcelValidate = downloadDeviceJMupsExcelValidate;
        vm.downloadShipmentTMSExcel = downloadShipmentTMSExcel;
        vm.downloadDRCTMSExcel = downloadDRCTMSExcel;
        vm.jescaActivationCsvDownload = jescaActivationCsvDownload;
        vm.selectedRequests = {}
        vm.query = {}
        vm.filters = {}
        vm.paginateCallback = paginateCallback
        vm.isUndefinedOrNullOrEmptyObject = baUtil.isUndefinedOrNullOrEmptyObject
        vm.isCancelButtonVisible = isCancelButtonVisible
        vm.isDeleteButtonVisible = isDeleteButtonVisible
        vm.isBulkCancelDisabled = isBulkCancelDisabled
        vm.isBulkDeleteDisabled = isBulkDeleteDisabled
        vm.isBulkRemoveDisabled = isBulkRemoveDisabled
        vm.isSuspensionDisabled = isSuspensionDisabled
        vm.isDetachSuspendDropdownDisabled = isDetachSuspendDropdownDisabled
        vm.cancelDeviceRequest = cancelBulkDeviceRequest
        vm.removeTerminal = removeTerminal
        vm.deleteDeviceRequest = deleteBulkDeviceRequest
        vm.cancelBulkDeviceRequest = cancelBulkDeviceRequest
        vm.deleteBulkDeviceRequest = deleteBulkDeviceRequest
        vm.timeConverter = baUtil.timeConverter
        vm.isBulkDeviceRequestEditDisabled = isBulkDeviceRequestEditDisabled
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ ? true : false;
        vm.writeVisible = vm.permissions.DEVICE_REQUEST.SHOW_WRITE ? true : false;
        vm.isPartner = baUtil.isPartnerUser();
        vm.isMerchantOrMerchantAndDeviceOwner = baUtil.isMerchantOrMerchantAndDeviceOwner();
        vm.isDeviceOwner = baUtil.isDeviceOwner();
//        vm.isLoading = false;
        vm.applyFilters = applyFilters
        vm.clearFilters = clearFilters
        vm.filterOptions = filterOptions.data.data;
        vm.setFiltersOptionsOfCurrentLanguage = setFiltersOptionsOfCurrentLanguage;
        var dateFormat = "YYYY/MM/DD";
        vm.setDefaultStatus = setDefaultStatus;
        vm.defaultStatus = ['COMPLETED', 'ERROR', 'RESERVED'];

        vm.visibilityPermission = vm.isSystemUser ? {
                "serviceContract": true,
                "partner": true,
                "merchant_name": true,
                "device_owner_name": true,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": false
            } :
            vm.isPartner ? {
                "serviceContract": true,
                "partner": false,
                "merchant_name": true,
                "device_owner_name": true,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": false
            } :
            vm.isMerchantOrMerchantAndDeviceOwner ? {
                "serviceContract": false,
                "partner": false,
                "merchant_name": false,
                "device_owner_name": true,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": true
            } : vm.isDeviceOwner ? {
                "serviceContract": false,
                "partner": false,
                "merchant_name": true,
                "device_owner_name": false,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": false
            } : {
                "serviceContract": false,
                "partner": false,
                "merchant_name": true,
                "device_owner_name": false,
                "desired_delivery_date": false,
                "storeName": false,
                "branchName": false
            };

        vm.allowedStatusForCancel = vm.isSystemUser ? ["REGISTERED", "ACCEPTED", "UNDER_FULFILMENT"] : ["REGISTERED"];
        vm.allowedStatusForDelete = ["DRAFT"];
        vm.allowedStatusForRemoved = ["COMPLETED","INSTALLED","RUNNING","REMOVED","REMOVED_AND_SETTLED","PORTAL_DETACHED","PORTAL_DETACHED_AND_SETTLED"];
        vm.allowedStatusForSuspension = ["COMPLETED","INSTALLED","RUNNING","PROCESSING_SUSPENSION","SUSPENDED"];
        vm.allowedStatusForDropdown = ["COMPLETED","INSTALLED","RUNNING","PROCESSING_SUSPENSION","SUSPENDED","REMOVED","REMOVED_AND_SETTLED","PORTAL_DETACHED","PORTAL_DETACHED_AND_SETTLED"];

        if (requests.status >= 200 && requests.status <= 299) {
            vm.requests = requests.data.data;
        }

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        vm.dateOptions = {
            format: dateFormat,
            dayViewHeaderFormat:'YYYY[年]  MMMM',
            locale:'ja',
            minDate : new Date(1970,0,2)
         }
         if (baUtil.isSystemAdmin()) {
            vm.systemAdmin = true;
        }
        else {
            vm.systemAdmin = false;
        }


         vm.changeFirstDateRange = changeFirstDateRange;

        function createdByOrgTitle() {
            vm.createdByOrgTitle = {};
            for (var i=0; i < vm.requests.content.length; i++) {
                if (vm.requests.content[i].createdByOrg == 'SYSTEM') {
                    vm.createdByOrgTitle[i] = "SYSTEM";
                }
                else {
                    if (baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg;
                    }
                    else if (!baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgMerchantCode + ' / ' + vm.requests.content[i].createdByOrgDeviceOwnerCode + ')';
                    }
                    else if (baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgDeviceOwnerCode + ')';
                    }
                    else if (!baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgMerchantCode + ')';
                    }
                }
            }
        }

        createdByOrgTitle();


//       Todo: Change the old for loop createdByOrgTitle function with the below angular.forEach after 31-Oct-2019 -------------- Task for Pradeep -------------
//              refactor for race condition by creating this function by calling in view : comment by @mohitSan

//        function createdByOrgTitle() {
//            vm.createdByOrgTitle = {};
//            vm.requests.content.forEach(function (item, key) {
//                if(item.createdByOrg == 'SYSTEM') {
//                    vm.createdByOrgTitle[key] = "SYSTEM";
//                }
//                else {
//                    if(baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgDeviceOwnerCode)) {
//                        vm.createdByOrgTitle[key] = item.createdByOrg;
//                    }
//                    else if(!baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgDeviceOwnerCode)) {
//                        vm.createdByOrgTitle[key] = item.createdByOrg + ' (' + item.createdByOrgMerchantCode + ' / ' + item.createdByOrgDeviceOwnerCode + ')';
//                    }
//                    else if(baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgDeviceOwnerCode)) {
//                        vm.createdByOrgTitle[key] = item.createdByOrg + ' (' + item.createdByOrgDeviceOwnerCode + ')';
//                    }
//                    else if(!baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgDeviceOwnerCode)) {
//                        vm.createdByOrgTitle[key] = item.createdByOrg + ' (' + item.createdByOrgMerchantCode + ')';
//                    }
//                }
//            })
//        }

        $scope.$on('LANG_CHANGE', function (event) {
            setFiltersOptionsOfCurrentLanguage();
        });

        function setFiltersOptionsOfCurrentLanguage() {

            vm.filterOptions.options = {};
            setFilterOptionsOfKey("DeviceRequestChangeStatus", "status");
            setFilterOptionsOfKey("DeviceJescaStatus", "jesca_status");
            setFilterOptionsOfKey("ServiceContractId", "serviceContractId");
            setFilterOptionsOfKey("ItemName","dr_requestType")
            var replacementOptions = {en: 'Show Replacement Devices', jp:'交換端末表示' }
            vm.filterOptions.options["Replacement"] = [{label: replacementOptions[getLang()], value: true}]

            if( !(vm.isSystemUser || vm.isPartner) ) {
                setFilterOptionsOfKey("DeviceInstallationSettlementBranch", "settlementBranch");
            }

            if(vm.isMerchantOrMerchantAndDeviceOwner || vm.isSystemUser || vm.isPartner) {
                setFilterOptionsOfKey("DeviceInstallationDeviceOwner", "deviceOwner");
            }

            if(vm.isDeviceOwner || vm.isSystemUser || vm.isPartner) {
                setFilterOptionsOfKey("DeviceInstallationMerchant", "merchant");
            }

            if(vm.isSystemUser) {
                setFilterOptionsOfKey("DeviceInstallationPartner", "partner");
            }

            vm.filterOptions.options["DateOptions"] = (vm.filterOptions["DateOptions"]||[]).map(function(d,i){
                return { label: d[getLang()], value: d["key"] };
            });

            vm.filterOptions.options["devices"] = (vm.filterOptions["Devices"]||[]).map(function(d,i){
                return { label: d, value: d };
            });

            setDefaultStatus();
        }

        setFiltersOptionsOfCurrentLanguage();

        function setFilterOptionsOfKey(targetKey, resultKey) {
            try {
                var keys = vm.filterOptions[targetKey]["key"];
                vm.filterOptions.options[resultKey] = vm.filterOptions[targetKey][$translate.use()].map(function(d,i){
                    return { label: d, value: keys[i] };
                });
            }
            catch(e) {
                vm.filterOptions.options[resultKey] = [];
            }
        }

        applyFilters();
        function applyFilters() {
            vm.isLoading = true;
            if(vm.filters && vm.filters.DEVICE_REPLACEMENT && vm.filters.DEVICE_REPLACEMENT.length) {
                vm.filters.DEVICE_REPLACEMENT = [{label: vm.filters.DEVICE_REPLACEMENT[0].label, value: true}];
            } else {
                delete vm.filters.DEVICE_REPLACEMENT;
            }

            if(vm.filters && vm.filters.reservationDateFrom && vm.filters.reservationDateTo) {
                vm.filters.reservationDateFrom = new Date(vm.filters.reservationDateFrom);
                vm.filters.reservationDateTo = new Date(vm.filters.reservationDateTo);
                vm.filters.RESERVATION_DATETIME = [{label: vm.filters.reservationDateFrom, value: new Date(vm.filters.reservationDateFrom).getTime()},
                    {label: vm.filters.reservationDateTo, value: new Date(vm.filters.reservationDateTo).getTime()}];
            }

            if(vm.filters && vm.filters.search) {
                if(vm.filters.search.installationLocation) {
                    vm.filters.INSTALLATION_LOCATION = [{label: vm.filters.search.installationLocation, value: vm.filters.search.installationLocation}];
                } else {
                    delete vm.filters.INSTALLATION_LOCATION;
                }

                if(vm.filters.search.DEVICE_SERIAL) {
                    var deviceSerialString = vm.filters.search.DEVICE_SERIAL;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.DEVICE_SERIAL = [];

                    angular.forEach(deviceSerialArray, function(values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.DEVICE_SERIAL.push({label:noComma, value:noComma});
                        }

                    });
                }
                else {
                    delete vm.filters.DEVICE_SERIAL;
                }

                if(vm.filters.search.RECEIPT_NUMBER) {
                    var deviceSerialString = vm.filters.search.RECEIPT_NUMBER;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.RECEIPT_NUMBER = [];

                    angular.forEach(deviceSerialArray, function(values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.RECEIPT_NUMBER.push({label:noComma, value:noComma});
                        }

                    });
                }
                else {
                    delete vm.filters.RECEIPT_NUMBER;
                }

                if(vm.filters.search.DEVICE_APPLICATION_NUMBER) {
                    var deviceSerialString = vm.filters.search.DEVICE_APPLICATION_NUMBER;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.DEVICE_APPLICATION_NUMBER = [];

                    angular.forEach(deviceSerialArray, function(values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.DEVICE_APPLICATION_NUMBER.push({label:noComma, value:noComma});
                        }

                    });
                }
                else {
                    delete vm.filters.DEVICE_APPLICATION_NUMBER;
                }

                if(vm.filters.search.remarks) {
                    vm.filters.REMARKS = [{label: vm.filters.search.remarks, value: vm.filters.search.remarks}];
                } else {
                    delete vm.filters.REMARKS;
                }
            }


            if(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress) return;
             
            
            var filterString = Object.keys(vm.filters).map(function(d,i){
                return vm.filters[d] && vm.filters[d].length ?
                        d +":"+ vm.filters[d].map(function(data){return data["value"]}).join("|") :
                        "";
            }).filter(function (val){return val != ""}).join(",");
            vm.query.filters = filterString;
            vm.query.pageNumber = 0;
            vm.dataFetchInProgress = true
            DeviceRequestService
            .getAllChangeDeviceRequest(vm.query)
            .then(function (response) {
                vm.dataFetchInProgress = false;
                vm.requests = response.data.data;
                vm.selectedRequests = {};
                vm.select = false;
                createdByOrgTitle();
                vm.isLoading = false;

            }, function err(err) {
                vm.dataFetchInProgress = false;
                vm.isLoading = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function clearFilters() {
            vm.isLoading = true;
            if(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress) return;
            vm.filters = {};
            setDefaultStatus();
            delete vm.query.filters;
            vm.query.filters = {};
            vm.query.filters = vm.filters.STATUS && vm.filters.STATUS.length > 0  ? 'STATUS:' + vm.filters.STATUS.map( function(item){ return item.value; } ).join("|") : "";
            delete vm.opFirstSelect;
            vm.query.pageNumber = 0;
            vm.dataFetchInProgressUsingClear = true
            DeviceRequestService
            .getAllChangeDeviceRequest(vm.query)
            .then(function (response) {
                vm.dataFetchInProgressUsingClear = false;
                vm.requests = response.data.data;
                vm.selectedRequests = {};
                vm.select = false;
                createdByOrgTitle();
                vm.isLoading = false;
            }, function err(err) {
                vm.dataFetchInProgressUsingClear = false;
                vm.isLoading = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function uploadForNewDeviceRequest(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name.toLowerCase(), [".xlsx"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.newDeviceInProgress = true;

                DeviceRequestService
                .uploadDeviceRequestChange(file)
                .then(function (response) {
                    vm.newDeviceInProgress = false;
                    $state.go('main.deviceRequest.createMultiple', { deviceRequest: response.data.data, isJescaUpload : false});
                    }, function err(err) {
                    ev.target.value = "";
                    vm.newDeviceInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }
        function uploadForNewJescaRequest(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name.toLowerCase(), [".xlsx"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.isJescaExcelUpload = true;

                DeviceRequestService
                .uploadDeviceRequestChange(file)
                .then(function (response) {
                    vm.isJescaExcelUpload = false;
                    $state.go('main.deviceRequest.changeMultiple', { deviceRequest: response.data.data, isJescaUpload : true});
                    }, function err(err) {
                    ev.target.value = "";
                    vm.isJescaExcelUpload = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }


        function uploadForDeviceDetail(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name, [".xlsx"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.inProgress = true;
                DeviceRequestService
                .uploadDevice(file)
                .then(function (response) {
                    vm.inProgress = false;
                    $state.go('main.deviceRequest.parseDeviceDetail', { deviceDetailList: response.data.data});
                }, function err(err) {
                    ev.target.value = "";
                    vm.inProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }

        function downloadShipmentExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) ||
                vm.isDownloadingExcel == true
            ) {
                return false;
            }
            vm.isDownloadingExcel = true;
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });

            DeviceRequestService
            .downloadDeviceShipmentProgress(keys)
            .then(function(resp){
                vm.isDownloadingExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function downloadDeviceJMupsExcel(keys) {
            DeviceRequestService
                .downloadDeviceJMupsExcel(keys)
                .then(function(resp) {
                    vm.isDownloadingJMupsExcel = false;
                    var headers = resp.headers();
                    var filename = headers["content-disposition"];
                    filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                    var serverData = new Blob([resp.data], {type: headers['content-type']});
                    FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
                },function(err) {
                    vm.isDownloadingJMupsExcel = false;
                    if ("TextDecoder" in window) {
                        try {
                            var enc = new TextDecoder("utf-8");
                            var data = enc.decode(err.data);
                            err = JSON.parse(data);
                        } catch(ignore){ }
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function downloadDeviceJMupsExcelValidate() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) || vm.isDownloadingJMupsExcel == true) {
                return false;
            }
            vm.isDownloadingJMupsExcel = true;
            var keys = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });

            downloadDeviceJMupsExcelValidate(keys);
            DeviceRequestService
                .downloadDeviceJMupsExcelValidate(keys)
                .then(function(resp) {
                    var validation = resp.data.data;
                    if (validation.status === 'success') {
                        downloadDeviceJMupsExcel(keys);
                    }else {
                        baUtil.showConfirm(
                            '',
                            vm.localTranslator("device.request.list.download.jmups.excel.confirm.msg1") + '<br> 「'+ validation.scids + '」 <br>'+
                            vm.localTranslator("device.request.list.download.jmups.excel.confirm.msg2"),
                            vm.localTranslator("common.components.btn.yes")
                        ).then(function() {
                            downloadDeviceJMupsExcel(keys);
                        }).catch(function(error) {
                            vm.isDownloadingJMupsExcel = false;
                        })

                    }
                },function(err) {
                    vm.isDownloadingJMupsExcel = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function downloadShipmentTMSExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) ||
                vm.isDownloadingShipmentTMSExcel == true
            ) {
                return false;
            }
            vm.isDownloadingShipmentTMSExcel = true;
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });

            DeviceRequestService
            .downloadShipmentTMSExcel(keys)
            .then(function(resp) {
                vm.isDownloadingShipmentTMSExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            }, function(err) {
                vm.isDownloadingShipmentTMSExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function downloadDRCTMSExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) ||
                vm.isDownloadingDITMSExcel == true
            ) {
                return false;
            }
            vm.isDownloadingDITMSExcel = true;
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.deviceInstallationId : null;
            }).filter(function(d){ return d; });

            DeviceRequestService
            .downloadDRCTMSExcel(keys)
            .then(function(resp) {
                vm.isDownloadingDITMSExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            }, function(err) {
                vm.isDownloadingDITMSExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function jescaActivationCsvDownload() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) ||
                vm.isDownloadingDITMSExcel == true
            ) {
                return false;
            }
            vm.isDownloadingJescaActivationCsv = true;
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.deviceInstallationId : null;
            }).filter(function(d){ return d; });

            DeviceRequestService
            .downloadJescaActivationCsvForDRC(keys)
            .then(function(resp) {
                vm.isDownloadingJescaActivationCsv = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            }, function(err) {
                vm.isDownloadingJescaActivationCsv = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function openDetail(deviceInstallationId) {
            DeviceRequestService
            .getDeviceInstallationDetailFromList([deviceInstallationId])
            .then(function success(response) {
                $state.go('main.deviceRequest.detail', { deviceInstallation: response });
            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function openDeviceDetail(ev, data) {
            $state.go('main.deviceRequest.deviceDetail', { ids: data.applicationNumber });
        }

        function isBulkDeviceRequestEditDisabled() {
            return Object.keys(vm.selectedRequests)
                         .filter(function (id) {return vm.selectedRequests[id] })
                         .length === 0;
        }

        function onBulkEdit() {
            var keys = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            vm.isBulkEditInProgress = true;
            DeviceRequestService
            .updateDeviceChangeRequest(keys)
            .then(function success(response) {
                vm.isBulkEditInProgress = false;
                $state.go('main.deviceRequest.editDeviceRequestChange', { deviceRequest: response.data.data, isJescaUpload:true });
            }, function err(err) {
                vm.isBulkEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function onBulkJescaEdit() {
        $state.go('main.deviceRequest.change', { });
        if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)){
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });
            
            vm.isBulkEditJescaInProgress = true;
            DeviceRequestService
            .getJescaDetailFromList(keys)
            .then(function success(response) {
                vm.isBulkEditJescaInProgress = false;
                getResetButtonStatus(response,keys);
            }, function err(err) {
                vm.isBulkEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                    )
                });
            }
            else {
                var keys =[{}];
                $state.go('main.deviceRequest.jesca');
            }
        }
        
        function getResetButtonStatus(deviceInstallationresponse,keys){
            DeviceRequestService
            .getResetFlag(keys)
            .then(function success(response) {
                $state.go('main.deviceRequest.jesca', { deviceInstallation: deviceInstallationresponse,resetButtonStatus : response.data.data  });
            }, function err(err) {
                vm.isBulkEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }


        function bulkDeviceEdit() {
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });

            vm.isBulkDeviceEditInProgress = true;
            DeviceRequestService
            .getDeviceList(keys)
            .then(function success(response) {
                vm.isBulkDeviceEditInProgress = false;
                $state.go('main.deviceRequest.deviceDetail', { deviceDetailList: response.data.data });
            }, function err(err) {
                vm.isBulkDeviceEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function showBulkEdit() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return false
            }

            return Object.keys(vm.selectedRequests).some(function (item) {
                return vm.selectedRequests[item]
            })
        }

        function selectAll(ev, list) {
            list.forEach(function (item) {
                vm.selectedRequests[item.deviceInstallationId] = ev.target.checked
            })
        }

        function isCancelButtonVisible(status) {
            if( vm.allowedStatusForCancel.indexOf(status) === -1 )
                    return false;
            return true;
        }
        function isDeleteButtonVisible(status) {
            if( vm.allowedStatusForDelete.indexOf(status) === -1 )
                    return false;
            return true;
        }

        function isBulkCancelDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForCancel.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }

        function isBulkDeleteDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForDelete.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }


        function isBulkRemoveDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.MGMNT_WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForRemoved.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }

        function isDetachSuspendDropdownDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.MGMNT_WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForDropdown.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }

        function isSuspensionDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.MGMNT_WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForSuspension.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }


        function getStatus(key) {
            var index = vm.types.DeviceRequestChangeStatus.key.indexOf(key);
            return vm.types.DeviceRequestChangeStatus[$translate.use()][index]
        }

        function getJescaStatus(key) {
            var index = vm.types.DeviceJescaStatus.key.indexOf(key);
            return vm.types.DeviceJescaStatus[$translate.use()][index]
        }

        function getDrRequestTypeStatus(key) {
            var index = vm.types.ItemName.key.indexOf(key);
            return vm.types.ItemName[$translate.use()][index]
        }


        function paginateCallback(query) {
            DeviceRequestService
            .getAllChangeDeviceRequest(query)
            .then(function (response) {
                vm.requests = response.data.data;
                vm.query = query;
                vm.selectedRequests = {};
                vm.select = false;
                createdByOrgTitle();
            });
        }


        function cancelBulkDeviceRequest(deviceInstallationId) {
            if(deviceInstallationId) {
                var ids = [deviceInstallationId];
            }
            else {
                if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                    return false
                }
                var ids = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            }

            baUtil.showConfirm(
                vm.localTranslator("common.components.title.cancel"),
                vm.localTranslator("device.request.list.msg.confirm.cancel"),
                vm.localTranslator("common.components.btn.yes")
            )
            .then(function() {
                vm.isBulkCancelInProgress = deviceInstallationId ? vm.isBulkCancelInProgress : true;
                DeviceRequestService
                .cancelBulkDeviceRequest(ids)
                .then(function success(response) {
                    vm.isBulkCancelInProgress = deviceInstallationId ? vm.isBulkCancelInProgress : false;
                    toastr.success(
                        vm.localTranslator('device.request.list.msg.success.cancel'),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    )
                    $state.reload()
                }, function err(err) {
                    vm.isBulkCancelInProgress = deviceInstallationId ? vm.isBulkCancelInProgress : false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    )
                });
            });
        }

        function deleteBulkDeviceRequest(deviceInstallationId) {
            if(deviceInstallationId) {
                var ids = [deviceInstallationId];
            }
            else {
                if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                    return false
                }
                var ids = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            }


            baUtil.showConfirm(
                vm.localTranslator("common.components.title.delete"),
                vm.localTranslator("device.request.list.msg.confirm.delete"),
                vm.localTranslator("common.components.btn.yes")
            )
            .then(function() {
                vm.isBulkDeleteInProgress = deviceInstallationId ? vm.isBulkDeleteInProgress : true;
                DeviceRequestService
                .deleteBulkDeviceRequest(ids)
                .then(function success(response) {
                    vm.isBulkDeleteInProgress = deviceInstallationId ? vm.isBulkDeleteInProgress : false;
                    toastr.success(
                        vm.localTranslator('device.request.list.msg.success.delete'),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    )
                    $state.reload()
                }, function err(err) {
                    vm.isBulkDeleteInProgress = deviceInstallationId ? vm.isBulkDeleteInProgress : false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    )
                });
            });
        }


        function removeTerminal() {
            vm.detachTerminalLoader = true;
            var keys = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            var rowKp = [];
            var appNum = [];
            vm.removeTerminalRow = [];

            keys.forEach(function (kkey, ukey) {
                vm.requests.content.filter(function (item) {
                    if (item.deviceInstallationId == kkey) {
                        rowKp.push(item);
                        appNum.push(item.applicationNumber);
                        vm.removeTerminalRow[ukey] = {
                            serviceContractId : item.serviceContractId,
                            companyName : item.companyName,
                            applicationNumber : item.applicationNumber,
                            deviceSerial : item.deviceSerial,
                            status : item.status
                        }
                    }

                })

            })

            DeviceRequestService
            .getTerminalDetails(appNum)
            .then(function success(response) {

                vm.responseRow = response.data.data.DeviceInstallationRemovalDtos;
                vm.default_addMonthlyFee = response.data.data.default_addMonthlyFee;
                vm.default_freeApplicationNumber = response.data.data.default_freeApplicationNumber;
                vm.removalReasons = response.data.data.RemovalReasons;
                vm.errorMessage = response.data.data.errorMessage;
                vm.detachTerminalLoader = false;
                vm.removeTerminalRow.forEach(function (value,key) {
                        vm.responseRow.forEach(function (item) {
                            if (item.applicationNumber == value.applicationNumber) {
                                vm.removeTerminalRow[key].startTime = item.startTime
                                vm.removeTerminalRow[key].lastCommunicationTime = item.lastCommunicationTime
                                vm.removeTerminalRow[key].removalDate = item.removalDate
                                vm.removeTerminalRow[key].nextBatchWillRunOn = item.nextBatchWillRunOn
                                vm.removeTerminalRow[key].operationApplicableTime = item.operationApplicableTime
                                vm.removeTerminalRow[key].lastSalesTime = item.lastSalesTime
    
                                if (value.status == 'PORTAL_DETACHED' || value.status == 'PORTAL_DETACHED_AND_SETTLED' || value.status == 'REMOVED_AND_SETTLED') {
                                    vm.removeTerminalRow[key].addMonthlyFee = item.addMonthlyFee
                                    vm.removeTerminalRow[key].freeApplicationNumber = item.freeApplicationNumber
                                }
                                else{
                                    vm.removeTerminalRow[key].addMonthlyFee = vm.default_addMonthlyFee
                                    vm.removeTerminalRow[key].freeApplicationNumber = vm.default_freeApplicationNumber
                                }
                                vm.removeTerminalRow[key].operationReason = item.operationReason
                                vm.removeTerminalRow[key].operationComment = item.operationComment
                            }
    
                        })
                    })
    
                    var data = [];
                    data[0] = vm.removeTerminalRow;
                    data[1] = vm.removalReasons;
                    data[2] = vm.default_addMonthlyFee;
                    data[3] = vm.default_freeApplicationNumber;
                    $state.go('main.deviceRequest.removeTerminal', { removeDeviceMap: data});
                
            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                vm.detachTerminalLoader = false;
            });

        }

       


        function changeFirstDateRange() {
            var dates = getDatePair(vm.filterOptions.DateOptions.filter(function(op){return op.key===vm.opFirstSelect.value})[0]);
            vm.filters.reservationDateFrom = new Date(dates[0]);
            vm.filters.reservationDateTo = new Date(dates[1]);
        }

        function getDatePair(dateOption) {
            var isDay, isWeek, isMonth, isYear;
            isDay = (dateOption.unit == 1);
            isWeek = (dateOption.unit == 2);
            isMonth = (dateOption.unit == 3);
            isYear = (dateOption.unit == 4);

            var fromValue = dateOption.from - 1;
            var toValue = dateOption.to - 1;
            var today = new Date();
            var lastDay = new Date();
            var month = today.getMonth();
            var year = today.getFullYear();

            var fromDate, toDate;

            if (isDay) {
                var startDate = today.getDate() - fromValue;
                var endDate = lastDay.getDate() - toValue;
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(endDate);
            } else if (isWeek) {
                var weekDay = fromValue*7;
                var startDate = today.getDate() - today.getDay() - weekDay + (today.getDay() === 0 ? -6 : 0);
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(lastDay.getDate() - lastDay.getDay() - (toValue*7) + 6);
                if (toDate > new Date().getTime()) {
                    toDate = new Date().getTime();
                }
            } else if (isMonth) {
                var fromMonth = month - fromValue;
                var toMonth = month - toValue + 1;
                fromDate = new Date(year, fromMonth, 1).getTime();
                toDate = new Date(year, toMonth, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            } else if (isYear) {
                var fromYear = year - fromValue;
                var toYear = year - toValue;
                fromDate = new Date(fromYear, 0, 1).getTime();
                toDate = new Date(toYear,12, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            }
            return [fromDate, toDate];
        }


        function openSuspendScreen() {
            vm.detachTerminalLoader = true;
            var keys = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            var rowKp = [];
            var appNum = [];
            vm.suspensionTerminalRow = [];

            keys.forEach(function (kkey, ukey) {
                vm.requests.content.filter(function (item) {
                    if (item.deviceInstallationId == kkey) {
                        rowKp.push(item);
                        appNum.push(item.applicationNumber);
                        vm.suspensionTerminalRow[ukey] = {
                            serviceContractId : item.serviceContractId,
                            merchantName : item.companyName,
                            applicationNumber : item.applicationNumber,
                            deviceSerial : item.deviceSerial,
                            status : item.status
                        }
                    }

                })

            })

            DeviceRequestService
            .getSuspensionTerminalDetails(appNum)
            .then(function success(response) {
                vm.responseRow = response.data.data.DeviceInstallationSuspensionDtos;
                vm.default_addMonthlyFee = response.data.data.default_addMonthlyFee;
                vm.default_addInitialFee = response.data.data.default_addInitialFee;
                vm.resumeReasons = response.data.data.ResumeReasons;
                vm.suspensionReasons = response.data.data.SuspensionReasons;
                vm.allowedStatus = response.data.data.OperationTypeSuspensionScreen;
                vm.suspensionTerminalRow.forEach(function (value,key) {
                    vm.responseRow.forEach(function (item) {
                        if (item.applicationNumber == value.applicationNumber) {
                            vm.suspensionTerminalRow[key].id = item.id
                            vm.suspensionTerminalRow[key].addMonthlyFee = item.addMonthlyFee
                            vm.suspensionTerminalRow[key].addInitialFee = item.addInitialFee
                            vm.suspensionTerminalRow[key].nextBatchWillRunOn = item.nextBatchWillRunOn
                            vm.suspensionTerminalRow[key].operation = item.operation
                            vm.suspensionTerminalRow[key].applicableDate = item.applicableDate
                            vm.suspensionTerminalRow[key].lastCommunicationTime = item.lastCommunicationTime
                            vm.suspensionTerminalRow[key].operationComment = item.operationComment
                            vm.suspensionTerminalRow[key].operationReason = item.operationReason
                            vm.suspensionTerminalRow[key].operationStartDate = item.operationStartDate
                            vm.suspensionTerminalRow[key].statusFrom = item.statusFrom
                            vm.suspensionTerminalRow[key].toBeStatus = item.toBeStatus
                        }

                    })
                })

                var data = [];
                data[0] = vm.suspensionTerminalRow;
                data[1] = vm.resumeReasons;
                data[2] = vm.suspensionReasons;
                data[3] = vm.default_addMonthlyFee;
                data[4] = vm.default_addInitialFee;
                data[5] = vm.allowedStatus;

                $state.go('main.deviceRequest.deviceSuspend', { suspendDeviceMap: data});

            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                vm.detachTerminalLoader = false;
            });
        }


        function showDeviceHistoryModal(deviceSerial) {
            $uibModal.open({
              animation: false,
              controller: 'DeviceHistoryCtrl',
              templateUrl: 'app/pages/device-request/views/device-history-modal.html',
              controllerAs: 'vm',
              size: "xl",
              resolve: {
                deviceSerialNum: function () {
                  return deviceSerial;
                },
                types:vm.types.DeviceInstallationStatus
              }
            });
          };

          function setDefaultStatus(){
            vm.filters.STATUS = vm.filterOptions.options.status.filter(function(status){
                return vm.defaultStatus.indexOf(status.value) !== -1;
            });
          }

        function getLang() {
            return $translate.use();
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('MultiNewChangeRequestCtrl', MultiNewChangeRequestCtrl);

    /** @ngInject */
    function MultiNewChangeRequestCtrl(DeviceRequestService, types, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, $rootScope, AuthService, $uibModal, hotUtil,
        DeviceRequestUtilService,FileSaver,$sce) {

        if( $stateParams.deviceRequest == null ) {
            $state.go("main.deviceRequest.change");
        }

        if($stateParams.deviceRequest) {
            $state.current.title = 'device.request.list.upload.device.changes';
        }
        else {
            $state.current.title = 'device.request.list.upload.device.changes';
        }

        var vm = this;
        vm.isJescaUpload = $stateParams.isJescaUpload;
        vm.deviceRequest = $stateParams.deviceRequest.dtos;
        vm.transactionData = $stateParams.deviceRequest.transactionData;
        vm.terminalReplacementColorCode = $stateParams.deviceRequest.terminalReplacementColorCode;
        vm.KeyMap = DeviceRequestUtilService.getKeys(
            $stateParams.deviceRequest.keyMap, "1.0"); // always use latest validation
        vm.getInputType = getInputType;
        vm.create = create;
        vm.reserve = reserve;
        vm.download = download;
        vm.cancelCreate = cancelCreate;
        vm.serviceContractId = null;
        vm.permissions = AuthService.getPermissions();
        vm.localTranslator = $filter('translate');

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        vm.types.deviceOwner = $stateParams.deviceRequest.deviceOwner;
        // vm.KeyMap.deviceOwnerId.type = "Dropdown";
        // vm.KeyMap.deviceOwnerId.readOnly = false;
        vm.autoSelectedDO = ""; // in case of self rent
        vm.isUserDeviceOwnerOfSC = false;
        vm.orgId = AuthService.getOrgId();
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ;
        vm.getDeviceStatusFromKey = getDeviceStatusFromKey;
        vm.getInstallationStatusIndex = getInstallationStatusIndex;
        vm.isDIStateTransitionValid = isDIStateTransitionValid;
        vm.hotTable = null;

        vm.getLang = getLang;
        vm.modal = null;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;
        vm.getErrMessageOfStatus = getErrMessageOfStatus;
        vm.getErrMessageDO = getErrMessageDO;

        // if (vm.orgId && vm.orgId != "" && vm.types.deviceOwner.key.indexOf(vm.orgId) != -1 && !baUtil.isMerchant()) {
        //     vm.isUserDeviceOwnerOfSC = true;
        //     vm.autoSelectedDO = vm.orgId;
        // } else if (vm.types.deviceOwner.key.length === 1) {
        //     vm.autoSelectedDO = vm.types.deviceOwner.key[0];
        // }


        function init() {
            vm.tableData = [];
            vm.tableOptions = {};
            vm.tableSettings = {
                licenseKey: 'non-commercial-and-evaluation',
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                fixedColumnsLeft: 5,
                modifyColWidth: function(width, col) {
                    if(width > 500) return 500;
                },
                afterValidate: function (isValid, value, row, prop, source) {
                    // special validation for device installaiton status
                    if(prop === "status") {
                        var index = vm.types.DeviceInstallationStatus.en.indexOf(value);
                        if (index < 0) {
                            index = vm.types.DeviceInstallationStatus.jp.indexOf(value);
                        }
                        var indexValue = index === -1 ? value : vm.types.DeviceInstallationStatus.key[index];

                        if(vm.isDIStateTransitionValid(vm.deviceRequest[row]['status'], indexValue)) {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                        else {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageOfStatus(
                                row+1,
                                vm.deviceRequest[row]['applicationNumber'],
                                vm.deviceRequest[row]['status'],
                                indexValue
                            );
                            return false;
                        }
                    }

                    if(prop === "deviceOwnerId") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId");
                            return false;
                        }
                        else if( vm.types.deviceOwner[$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId", true);
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(prop === "paymentHandlingOption_TRANSPORT") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value) ||
                         vm.types.TransportPaymentOptions[$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "paymentHandlingOption_TRANSPORT", true);
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    // common use validator
                    if ( !vm.KeyMap[prop]["readOnly"] &&
                        vm.KeyMap[prop]['validators'].length
                    ) {
                        var msg = hotUtil.aggregatedValidator(vm.KeyMap[prop]['validators'], value, row, vm.KeyMap[prop][vm.getLang()]);
                        if( msg != "" ) {
                            vm.errors[ row + "_" + prop ] = msg;
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(isValid) {
                        delete vm.errors[ row + "_" + prop ];
                    }
                    else {
                        vm.errors[ row + "_" + prop ] = value;
                    }
                }
            };

            // disable rows if the device status is not DRAFT or REGISTERED
            //    for users which don't have permissions
            //    when status is cancelled
            vm.tableSettings.cells = function (row, col,prop) {
                var cellMeta = {};
                // if( vm.tableData[row].readOnly || vm.tableData[row][ prop + "_readOnly" ] ) {
                //     cellMeta.readOnly = true;
                // }
                var deviceSerial_ = vm.tableData[row].deviceSerial;
                if(!baUtil.isUndefinedOrNullOrEmpty(vm.tableData[row].subCategory)){
                    deviceSerial_ += '-' + vm.tableData[row].subCategory;
                }
                var type_ = vm.tableData[row].type;
                // return vm.tableData[row].isUpdatable === true ? {readOnly : false} : {readOnly : true};
                if(vm.tableData[row].isUpdatable === true){
                                        if(prop.includes('paymentHandlingOption')){
                    var new_prop = prop.replace('paymentHandlingOption_','')
                    if(vm.tableData[row].changedColumns.includes(new_prop)){
                        cellMeta.className = 'changed';
                        cellMeta.readOnly = false;
                    }
                    else if(vm.tableData[row].productName.includes('ME-10')){
                        if(new_prop === 'VISA' || new_prop === 'MASTERCARD' || new_prop === 'AMERICANEXPRESS' || new_prop === 'JCB' || new_prop === 'DISCOVER' || new_prop === 'DINERS'){
                            cellMeta.className = 'even';
                            cellMeta.readOnly = true;
                        }
                    }
                    else{
                        cellMeta.className = 'even';
                        cellMeta.readOnly = false;
                    }
                    }else{

                        if(vm.tableData[row].changedColumns.includes(prop) || prop === 'paymentHandlingOption_PITAPA'){
                            cellMeta.className = 'changed';
                            cellMeta.readOnly = false;
                        }
                        else if(prop === 'receiptNumber' || prop === 'serialNumber' || prop === 'itemName' || prop === 'deviceSerial' ||prop === 'serviceContractId' || prop === 'companyName' || prop === 'applicationNumber' || prop === 'deviceOwnerId'){
                            if((prop === 'receiptNumber' || prop === 'serialNumber') && type_ === 'TERMINAL_REPLACEMENT' && vm.transactionData.hasOwnProperty(deviceSerial_) && vm.transactionData[deviceSerial_].startTime !== 0){
                                var dateDifference = moment(new Date()).diff(vm.transactionData[deviceSerial_].startTime, 'days')
                                if(dateDifference <= Number(vm.terminalReplacementColorCode.drcTerminalRelacementGreen)){
                                    cellMeta.className = 'highlighted_green';
                                }
                                else if(dateDifference <= Number(vm.terminalReplacementColorCode.drcTerminalRelacementYellow)){
                                    cellMeta.className = 'highlighted_yellow';
                                }
                                else 
                                    cellMeta.className = 'highlighted_red';
                            }
                            else 
                                cellMeta.className = 'even';
                            cellMeta.readOnly = true;
                        }else{
                            cellMeta.className = 'even';
                            cellMeta.readOnly = false;
                        }
                    }
                    }
                else{
                    cellMeta.className = 'odd';
                    cellMeta.readOnly = true;
                }
                if (vm.tableData[row] && vm.tableData[row][prop + '_readOnly']) {
                    cellMeta.readOnly = true;
                }
                return cellMeta;
                // return vm.tableData[row] && vm.tableData[row].readOnly ? { readOnly: true } : {};
            };

            vm.deviceRequest.forEach(function (items, indexes) {
                items.forEach(function(item,index){
                    var obj = {};
                    if (baUtil.isUndefinedOrNullOrEmpty(vm.serviceContractId)) {
                    vm.serviceContractId = item.serviceContractId
                }
                
                Object.keys(item).forEach(function (field) {
                    var value = item[field]
                    if (field === 'date' || field == 'preferredDateOfInstallation') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                        return
                    }
                    obj[field] = value;

                    if (field === 'status') {
                        var index = vm.types.DeviceInstallationStatus.key.indexOf(value);
                        obj[field] = vm.types.DeviceInstallationStatus[$translate.use()][index];
                    }
                    
                    if(field === 'initialBilling'){
                        var index = vm.types.InitialMonthlyBilling.key.indexOf(value);
                        obj[field] = vm.types.InitialMonthlyBilling[$translate.use()][index];
                    }

                    if(field === 'monthlyBilling'){
                        var index = vm.types.InitialMonthlyBilling.key.indexOf(value);
                        obj[field] = vm.types.InitialMonthlyBilling[$translate.use()][index];
                    }

                    if(field === 'itemName'){
                        var index = vm.types.ItemName.key.indexOf(value);
                        obj[field] = vm.types.ItemName[$translate.use()][index];
                    }

                    // if (field === 'type') {
                    //     var index = vm.types.DeviceInstallationType.key.indexOf(value);
                    //     obj[field] = vm.types.DeviceInstallationType[$translate.use()][index];
                    // }
                    else if (field === 'deviceOwnerId') {
                        if(baUtil.isUndefinedOrNullOrEmptyObject(value)) {
                            obj['deviceOwnerId'] =  "";
                        }
                        else {
                            var index = vm.types.deviceOwner[item.serviceContractId].key.indexOf(value);
                            obj['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId][$translate.use()][index];
                        }
                     }

                    if (field === 'vendingMachineModel') {
                        item.paymentHandlingOptions.forEach(function (k, i) {
                            obj['paymentHandlingOption_' + k] = true
                        });
                        obj['paymentHandlingOption_TRANSPORT'] = DeviceRequestUtilService.getTransportPaymentOptionTextFromKey(
                            vm.types.TransportPaymentOptions,
                            item['transportPaymentHandlingOption'],
                            item['paymentHandlingOptions']
                            );
                        }
                    
                    if(field === 'deviceSerial'){
                        obj.initialDeviceSerial = value;
                        if(value.includes('-')){
                            obj.subCategory = value.split('-')[1];
                          var new_value = value.slice(0, value.indexOf('-'));

                        }
                        obj[field] = new_value || value ;
                    }
                    if(field === 'applicationNumber'){
                        obj.initialApplicationNumber = value;
                        if(value.includes('-')){
                            obj.subCategoryAppNo = value.split('-')[1];
                           var new_value = value.slice(0, value.indexOf('-'));
                        }
                        obj[field] = new_value || value;                    }    
                        
                    })
                    DeviceRequestUtilService.applyResumeHwBillingReadOnly(item, obj);
                        obj._s=obj.isUpdatable
                        vm.tableData.push(obj);
                })
            })
            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap).sort(function (a, b) {
                return keyMap[a].order - keyMap[b].order;
            });
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (
                    (field == 'status') ||
                    (field == 'deviceOwnerId' && vm.isUserDeviceOwnerOfSC)
                ) {
                    col.readOnly = true;
                }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = getSource(field)
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                if ( !vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'].length ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }
                vm.tableSettings.columns.push(col);
            })
            var checked=true
            var selectColumnTemplate = { data: "_s", type: "checkbox" };
            vm.tableSettings.columns.unshift(selectColumnTemplate)
            vm.tableSettings.colHeaders.unshift('<input '+(checked?'checked="checked"':'')+' class="hot_handsontable_header_chkbox" type="checkbox" />')
            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsontable-change-multiple-request');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            var _settings=options
            
            container.innerHTML=''
            vm.hotTable = new Handsontable(container, _settings);
            container.innerHTML=''
            vm.hotTable = new Handsontable(container, _settings);
            Handsontable.dom.addEvent(container, 'mousedown', function (event) {
                if (event.target.nodeName == 'INPUT' && event.target.className == 'hot_handsontable_header_chkbox') {
                    event.stopPropagation();
                }
            });
            Handsontable.dom.addEvent(container, 'mouseup', function (event) {
                if (event.target.nodeName == 'INPUT' && event.target.className == 'hot_handsontable_header_chkbox') {
                        event.target.checked =checked
                        vm.tableData=vm.tableData.map(function(item){
                            if(item.isUpdatable)
                            {
                                item._s=checked
                            }
                            return item
                        })
                        vm.tableSettings.colHeaders[0]='<input '+(checked?'checked="checked"':'')+' class="hot_handsontable_header_chkbox" type="checkbox" />'
                        vm.hotTable.render();
                        checked=!checked
                    
                }
            });

            vm.hotTable.render();
        }

        init();

        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        // ask before leaving form
        vm.askBeforeLeaving = true;
        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            if (current.endsWith('device-request/create-multiple') && vm.askBeforeLeaving) {
                processBeforeRedirect(event);
            }
        });

        function processBeforeRedirect(event) {
            toastr.info(
                vm.localTranslator("common.components.msg.confirm"),
                vm.localTranslator("common.components.title.info"),
                baUtil.toastOptions()
            );
            if( event ) event.preventDefault();
            vm.askBeforeLeaving = false;
        }

        function cancelCreate() {
            if( vm.askBeforeLeaving ) {
                return processBeforeRedirect();
            }
            $state.go("main.deviceRequest.change");
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }

        function getSource(key) {
            switch (key) {
                case 'status':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'type':
                    return vm.types.DeviceInstallationType[$translate.use()]
                case 'deviceOwnerId':
                    return vm.types.deviceOwner[$translate.use()]
                case 'paymentHandlingOption_TRANSPORT':
                    return vm.types.TransportPaymentOptions[$translate.use()]
                case 'initialBilling':
                    return vm.types.InitialMonthlyBilling[$translate.use()]  
                case 'monthlyBilling':
                    return vm.types.InitialMonthlyBilling[$translate.use()]    
                default:
                    return []
            }
        }

        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field){
            if( vm.fieldMetaData[field] ) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                /// return reqd otherwise
                return $translate.instant(
                    "device.request.edit.err.msg.required.field",
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
        }

        function getErrMessageDO (row, field, isWrongInput) {
            return $translate.instant(
                isWrongInput ? "device.request.edit.err.msg.device.owner" : "device.request.edit.err.msg.required.field",
                { row: row, param: vm.KeyMap[field][vm.getLang()] }
            );
        }

        function getErrMessageOfStatus(row, applicationNumber, from, to){
            return $translate.instant(
                "device.request.edit.err.msg.cannot.allow.state.transition",
                {
                    row: row,
                    id: applicationNumber,
                    from: vm.getDeviceStatusFromKey(from),
                    to: vm.getDeviceStatusFromKey(to)
                }
            );
        }

        function getInstallationStatusIndex(status){
            var statusMap = {
                "DRAFT": 0,
                "REGISTERED": 1,
                "ACCEPTED": 2,
                "UNDER_FULFILMENT": 3,
                "COMPLETED": 4,
                "APPLICATION_CANCELLED": 5
            };
            if(Object.keys(statusMap).indexOf(status) === -1) {
                return null;
            }
            return statusMap[status]
        }

        function isDIStateTransitionValid(statusBefore, statusAfter) {

            // no change detected
            if(statusBefore == statusAfter) {
                return true;
            }

            // status shifted backwards
            else if (
                vm.getInstallationStatusIndex(statusBefore) != null &&
                vm.getInstallationStatusIndex(statusAfter) != null &&
                vm.getInstallationStatusIndex(statusBefore) > vm.getInstallationStatusIndex(statusAfter)
            ) {
                if(vm.isSystemUser) {
                    if(
                        (statusBefore == "ACCEPTED" && statusAfter == "REGISTERED") ||
                        (statusBefore == "UNDER_FULFILMENT" && statusAfter == "REGISTERED")
                    ) {
                        return true;
                    }
                }
                return false;
            }

            // status moving forward
            else {
                // for common permissions
                if(
                    (statusBefore == "DRAFT" && statusAfter == "REGISTERED") ||
                    (statusBefore == "REGISTERED" && statusAfter == "APPLICATION_CANCELLED")
                ) {
                    return true;
                }
                // for System User
                else if(vm.isSystemUser) {
                    if(
                        (statusBefore == "REGISTERED" && statusAfter == "ACCEPTED") ||
                        (
                            statusBefore == "ACCEPTED" &&
                            ["UNDER_FULFILMENT", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        ) ||
                        (
                            statusBefore == "UNDER_FULFILMENT" &&
                            ["COMPLETED", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        )
                    ) {
                        return true;
                    }
                }
                // otherwise
                return false;
            }
        }

        function getDeviceStatusFromKey(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);

            if(index === -1) return key;

            return ($translate.use() === "jp" ?
                    vm.types.DeviceInstallationStatus.jp[index] :
                    vm.types.DeviceInstallationStatus.en[index]);
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function reserve(){
            var emptyStartTime = false, nonEmptyStartTime = false, nonEmptyStartTimeWIthDiffType = false;
            var transactionArray = [];

            vm.tableData.filter(function (d) { 
                return d.isUpdatable && d._s;
            }).forEach(function(d){
                var deviceSerialUpdated = d.deviceSerial;
                if(!baUtil.isUndefinedOrNullOrEmpty(d.subCategory)){
                    deviceSerialUpdated += '-' + d.subCategory;
                }
                if(d.type === "TERMINAL_REPLACEMENT" && vm.transactionData.hasOwnProperty(deviceSerialUpdated) && vm.transactionData[deviceSerialUpdated].startTime !== 0){
                    nonEmptyStartTime = true;
                    var obj = vm.transactionData[deviceSerialUpdated];
                    obj['deviceSerial']=deviceSerialUpdated;
                    transactionArray.push(obj);
                }
                else if(vm.transactionData.hasOwnProperty(deviceSerialUpdated) && vm.transactionData[deviceSerialUpdated].startTime === 0){
                    emptyStartTime = true;
                }
                else if(vm.transactionData.hasOwnProperty(deviceSerialUpdated) && vm.transactionData[deviceSerialUpdated].startTime !== 0){
                    nonEmptyStartTimeWIthDiffType = true;
                }
            });

            if(nonEmptyStartTime && (emptyStartTime || nonEmptyStartTimeWIthDiffType)){
                $uibModal.open({
                    animation: true,
                    controller: function confirmCtrl($uibModalInstance) {
                        var errorVm = this;
                        errorVm.transactionArray = transactionArray;
                        errorVm.ok = function () {
                            $uibModalInstance.close();
                        };
                    },
                    templateUrl: 'app/pages/device-request/views/upload-device-request-change-error-modal.html',
                    controllerAs:'errorVm',
                    backdrop: "static"
                })
                return;
            }

            var modalValues = null;
            $uibModal.open({
                animation: false,
                controller: function confirmCtrl($uibModalInstance) {
                    var confirmVm = this;
                    confirmVm.transactionArray = transactionArray;
                    confirmVm.nonEmptyStartTime = nonEmptyStartTime;
                    var today = new Date();
                    confirmVm.todayDate = new Date().setHours(23,59,59,999);
                    var tomorrowDate = new Date();
                    tomorrowDate.setDate(today.getDate()+1)
                    confirmVm.date = tomorrowDate;
                    confirmVm.dateOptions = {
                        showWeeks: false,
                        formatDayTitle:'yyyy 年 MMMM',
                        formatMonthTitle:'yyyy 年',
                        minDate : tomorrowDate,
                    }
                    confirmVm.cancelReservation = true;
                    confirmVm.monthEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    confirmVm.nextMonthStartDate = new Date(today.getFullYear(), today.getMonth() + 1, 1)
                    confirmVm.ok = function () {
                        $uibModalInstance.close();
                        modalValues = confirmVm;
                        vm.createInProgress = true;
                    };
                    confirmVm.cancel = function(){
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                templateUrl: 'app/pages/device-request/views/reserve-change-modal.html',
                controllerAs: 'confirmVm',
                backdrop: "static"
              }).result.then(function(){

                var immediately = false
                var reservationDateTime = null;
    
            if(nonEmptyStartTime || modalValues.hasOwnProperty('reserveChange') === true){

                if(nonEmptyStartTime || modalValues.reserveChange.reservationDateTime === 'immediate' ){
                    reservationDateTime = Date.parse(new Date());
                    immediately = true;
                }else if(modalValues.reserveChange.reservationDateTime === 'today'){

                    reservationDateTime = modalValues.todayDate;

                }else if(modalValues.reserveChange.reservationDateTime === 'monthEnd'){

                    reservationDateTime = modalValues.monthEndDate.setHours(23,59,59,999);
                    
                }else if(modalValues.reserveChange.reservationDateTime === 'startNextMonth'){

                    reservationDateTime = Date.parse(modalValues.nextMonthStartDate);
                    
                }else if(modalValues.reserveChange.reservationDateTime === 'specificDate'){

                    reservationDateTime = modalValues.date.setHours(0,0,0,0);

                }else if(modalValues.reserveChange.reservationDateTime === 'cancelReservation'){
                    
                    vm.tableData.forEach(function(item){
                        item.drchangeStatus = "CANCELLED";
                    })
                    reservationDateTime = null;
                }
            }else{
                reservationDateTime = modalValues.todayDate;
            }
                
                var data = [];

            vm.tableData.forEach(function(item){
                item.reservationDateTime = reservationDateTime;
            })  

            vm.tableData.forEach(function(item){
                if(item.subCategory && item.initialDeviceSerial.includes('-')){
                    item.deviceSerial = item.deviceSerial + "-" + item.subCategory;
                }
                if(item.subCategoryAppNo && item.initialApplicationNumber.includes('-')){
                    item.applicationNumber = item.applicationNumber + "-" + item.subCategoryAppNo;
                }
            })

            vm.tableData.forEach(function (row) {
                var obj = {
                    paymentHandlingOptions: []
                };
                Object.keys(row).forEach(function (key) {
                    if( key === "paymentHandlingOptions" ) return;

                    if (key === 'date' || key == 'preferredDateOfInstallation') {
                        var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                        obj[key] = long
                        return
                    }
                    if (key.indexOf("paymentHandlingOption_") >= 0){
                        if(row[key]) {
                            var optionKey = key.replace('paymentHandlingOption_', '');
                            obj.paymentHandlingOptions.push(optionKey);
                        }
                        return;
                    }

                    obj[key] = row[key]
                });

                obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                    vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                if(obj['transportPaymentHandlingOption'] !== "-") {
                    obj.paymentHandlingOptions.push("TRANSPORT");
                }

                data.push(obj)
            });

            data.forEach(function (item, i) {
                item = data[i];

                var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                }
                var indexValue = vm.types.DeviceInstallationStatus.key[index];

                if ((indexValue == "REGISTERED" && isDraft) || (indexValue == "DRAFT" && !isDraft))
                    item['status'] = "REGISTERED";
                else if (indexValue == "DRAFT" || indexValue == "REGISTERED")
                    item['status'] = indexValue;
                else
                    item['status'] = vm.isSystemUser ?
                        vm.types.DeviceInstallationStatus.key[index] :
                        vm.deviceRequest[i]['status'];

                var index = vm.types.InitialMonthlyBilling.en.indexOf(item.initialBilling);
                if (index < 0) {
                    index = vm.types.InitialMonthlyBilling.jp.indexOf(item.initialBilling);
                }
                item['initialBilling'] = vm.types.InitialMonthlyBilling.key[index];

                var index = vm.types.InitialMonthlyBilling.en.indexOf(item.monthlyBilling);
                if (index < 0) {
                    index = vm.types.InitialMonthlyBilling.jp.indexOf(item.monthlyBilling);
                }
                item['monthlyBilling'] = vm.types.InitialMonthlyBilling.key[index];

                var index = vm.types.deviceOwner[item.serviceContractId].en.indexOf(item.deviceOwnerId);
                if (index < 0) {
                    index = vm.types.deviceOwner[item.serviceContractId].jp.indexOf(item.deviceOwnerId);
                }
                item['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId].key[index];

                var index = vm.types.ItemName.en.indexOf(item.itemName);
                if (index < 0) {
                    index = vm.types.ItemName.jp.indexOf(item.itemName);
                }
                item['itemName'] = vm.types.ItemName.key[index];
            })
            // data = data.filter(function (d, i) { return d.isUpdatable && d._s });
            var temp_data = data.map(function (d, i) { if(d.isUpdatable && d._s){
                return {'deviceInstallationId':d.deviceInstallationId}
            } });
            temp_data = temp_data.filter(function( element ) {
                return element !== undefined;
            });

             var new_data = [];

             for(var i=0;i<data.length;i++){
                for(var j=0;j<temp_data.length;j++){
                    if(data[i].deviceInstallationId === temp_data[j].deviceInstallationId){
                        new_data.push(data[i])
                        }
                    }
            }
            DeviceRequestService.createDeviceRequestChange(new_data, vm.serviceContractId,immediately)
                .then(function success(response) {
                    vm.createInProgress = false;
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    // $state.go('main.deviceRequest.change');
                }, function err(err) {
                    vm.createInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
                vm.tableData.forEach(function(item){
                    if(item.deviceSerial.includes('-')){
                      item.deviceSerial = item.deviceSerial.slice(0, item.deviceSerial.indexOf('-'));
                    }
                    if(item.applicationNumber.includes('-')){
                      item.applicationNumber = item.applicationNumber.slice(0,item.applicationNumber.indexOf('-'));
                    }
                })
        
            });
        }

        function download(){
            var data = [];
            vm.downloadInProgress = true;
            vm.tableData.forEach(function(item){
                if(item.subCategory && item.initialDeviceSerial.includes('-')){
                    item.deviceSerial = item.deviceSerial + "-" + item.subCategory;
                }
                if(item.subCategoryAppNo && item.initialApplicationNumber.includes('-')){
                    item.applicationNumber = item.applicationNumber + "-" + item.subCategoryAppNo;
                }
            })
            vm.tableData.forEach(function (row) {
                var obj = {
                    paymentHandlingOptions: []
                };
                Object.keys(row).forEach(function (key) {
                    if( key === "paymentHandlingOptions" ) return;

                    if (key === 'date' || key == 'preferredDateOfInstallation') {
                        var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                        obj[key] = long
                        return
                    }
                    if (key.indexOf("paymentHandlingOption_") >= 0){
                        if(row[key]) {
                            var optionKey = key.replace('paymentHandlingOption_', '');
                            obj.paymentHandlingOptions.push(optionKey);
                        }
                        return;
                    }

                    obj[key] = row[key]
                });

                obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                    vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                if(obj['transportPaymentHandlingOption'] !== "-") {
                    obj.paymentHandlingOptions.push("TRANSPORT");
                }

                data.push(obj)
            });

            data.forEach(function (item, i) {
                item = data[i];

                var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                }
                var indexValue = vm.types.DeviceInstallationStatus.key[index];

                if ((indexValue == "REGISTERED" && isDraft) || (indexValue == "DRAFT" && !isDraft))
                    item['status'] = "REGISTERED";
                else if (indexValue == "DRAFT" || indexValue == "REGISTERED")
                    item['status'] = indexValue;
                else
                    item['status'] = vm.isSystemUser ?
                        vm.types.DeviceInstallationStatus.key[index] :
                        vm.deviceRequest[i]['status'];



                var index = vm.types.InitialMonthlyBilling.en.indexOf(item.initialBilling);
                if (index < 0) {
                    index = vm.types.InitialMonthlyBilling.jp.indexOf(item.initialBilling);
                }
                item['initialBilling'] = vm.types.InitialMonthlyBilling.key[index];

                var index = vm.types.InitialMonthlyBilling.en.indexOf(item.monthlyBilling);
                if (index < 0) {
                    index = vm.types.InitialMonthlyBilling.jp.indexOf(item.monthlyBilling);
                }
                item['monthlyBilling'] = vm.types.InitialMonthlyBilling.key[index];

                var index = vm.types.deviceOwner[item.serviceContractId].en.indexOf(item.deviceOwnerId);
                if (index < 0) {
                    index = vm.types.deviceOwner[item.serviceContractId].jp.indexOf(item.deviceOwnerId);
                }
                item['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId].key[index];                             

                var index = vm.types.ItemName.en.indexOf(item.itemName);
                if (index < 0) {
                    index = vm.types.ItemName.jp.indexOf(item.itemName);
                }
                item['itemName'] = vm.types.ItemName.key[index];
            })

            var temp_data = data.map(function (d, i) { if(d.isUpdatable && d._s){
                return {'deviceInstallationId':d.deviceInstallationId}
            } });

            temp_data = temp_data.filter(function( element ) {
                return element !== undefined;
             });


             var new_data = [];

             for(var i=0;i<data.length;i++){
                for(var j=0;j<temp_data.length;j++){
                    if(data[i].deviceInstallationId === temp_data[j].deviceInstallationId){
                        new_data.push(data[i])
                    }
                }
            }

            DeviceRequestService
            .downloadDeviceRequestChangeExcel(new_data)
            .then(function(resp) {
                vm.downloadInProgress = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.downloadInProgress = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });

            vm.tableData.forEach(function(item){
                if(item.deviceSerial.includes('-')){
                    item.deviceSerial = item.deviceSerial.slice(0, item.deviceSerial.indexOf('-'));
                  }
                  if(item.applicationNumber.includes('-')){
                    item.applicationNumber = item.applicationNumber.slice(0,item.applicationNumber.indexOf('-'));
                  }
            })

        }

        function create(isDraft) {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            baUtil.showConfirm()
            .then(function () {

                var data = [];
                vm.tableData.forEach(function (row) {
                    var obj = {
                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
                        if( key === "paymentHandlingOptions" ) return;

                        if (key === 'date' || key == 'preferredDateOfInstallation') {
                            var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                            obj[key] = long
                            return
                        }
                        if (key.indexOf("paymentHandlingOption_") >= 0){
                            if(row[key]) {
                                var optionKey = key.replace('paymentHandlingOption_', '');
                                obj.paymentHandlingOptions.push(optionKey);
                            }
                            return;
                        }

                        obj[key] = row[key]
                    });

                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                        vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                    if(obj['transportPaymentHandlingOption'] !== "-") {
                        obj.paymentHandlingOptions.push("TRANSPORT");
                    }

                    data.push(obj)
                });

                data.forEach(function (item, i) {
                    item = data[i];

                    var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                    if (index < 0) {
                        index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                    }
                    var indexValue = vm.types.DeviceInstallationStatus.key[index];

                    if ((indexValue == "REGISTERED" && isDraft) || (indexValue == "DRAFT" && !isDraft))
                        item['status'] = "REGISTERED";
                    else if (indexValue == "DRAFT" || indexValue == "REGISTERED")
                        item['status'] = indexValue;
                    else
                        item['status'] = vm.isSystemUser ?
                            vm.types.DeviceInstallationStatus.key[index] :
                            vm.deviceRequest[i]['status'];



                    var index = vm.types.DeviceInstallationType.en.indexOf(item.type);
                    if (index < 0) {
                        index = vm.types.DeviceInstallationType.jp.indexOf(item.type);
                    }
                    item['type'] = vm.types.DeviceInstallationType.key[index];

                    var index = vm.types.deviceOwner.en.indexOf(item.deviceOwnerId);
                    if (index < 0) {
                        index = vm.types.deviceOwner.jp.indexOf(item.deviceOwnerId);
                    }
                    item['deviceOwnerId'] = vm.types.deviceOwner.key[index];
                })

                data = data.filter(function (d, i) { return !vm.tableData[i].readOnly });
                if (!data.length) return;

                if(data.length > 9) {
                    vm.modal = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/modalTemplates/loadingModal.html',
                        size: "sm",
                        resolve: {
                          items: function () {
                            return $scope.items;
                        }}
                    });
                }

                if (isDraft) {
                    vm.draftInProgress = true;
                } else {
                    vm.createInProgress = true;
                }


                DeviceRequestService.createDeviceRequest(data, vm.serviceContractId,vm.isJescaUpload)
                .then(function success(response) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    vm.askBeforeLeaving = false;
                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('DeviceDetailCtrl', DeviceDetailCtrl);

    /** @ngInject */
    function DeviceDetailCtrl(AuthService, DeviceRequestService, types, KeyMap, isNewUpload, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, hotUtil) {

        if( $stateParams.deviceDetailList == null ) {
            $state.go("main.deviceRequest.list");
        }

        var vm = this;
        vm.permissions = AuthService.getPermissions();
        vm.deviceRequest = []
        vm.getInputType = getInputType;
        vm.create = create;
        vm.cancelCreate = cancelCreate;
        vm.localTranslator = $filter('translate');
        vm.canEditInRequestStatusArr = [ "REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "INVENTORY"];
        vm.canEditInShippingStatusArr = [ "INITIATED", "SHIPPED" ];
        vm.hotTable = null;

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }

        if (KeyMap.status >= 200 && KeyMap.status <= 299) {
            vm.KeyMap = KeyMap.data.data;
        }

        vm.deviceRequest = $stateParams.deviceDetailList
        vm.getLang = getLang;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;

        vm.fieldMetaData = {
            "serialNumber": {
                "validator": hotUtil.customDeviceSerial,
                "errMsg" : "device.request.edit.err.msg.device.serial"
            }
        }

        if( isNewUpload ) {
            vm.canShowActionBtns = true;
        }
        else {
            vm.canShowActionBtns = false;
        }

        function init() {
            vm.tableData = [];
            vm.tableOptions = {};
            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                columns: [],
                fixedColumnsLeft: 4,
                afterValidate: function (isValid, value, row, prop, source) {
                    if(isValid) {
                        delete vm.errors[ row + "_" + prop ];
                    }
                    else {
                        vm.errors[ row + "_" + prop ] = value;
                    }
                },
            };

            // disable rows if Sys Admin is not the current user
            vm.tableSettings.cells = function (row, col, prop) {
                return (vm.tableData[row].readOnly) ? {readOnly: true} : {};
            };

            vm.deviceRequest.forEach(function (item, index) {
                var obj = {};

                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'dateOfApplication' || field === 'jmupsDeliveryDate' || field === 'carrierDeliveryDate' || field === 'hwPlannedDeliveryDate' || field === 'hwDispatchDate' || field === 'hwDeliveryDate') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                        return
                    }
                    else if (field === "shippingStatus") {
                        var val = baUtil.isStringAndNotEmpty(value) ? value : "INITIATED";
                        var index = vm.types.ShippingStatus.key.indexOf(val);
                        obj['shippingStatus'] = vm.types.ShippingStatus[$translate.use()][index];
                    }
                    else if (field === "deviceInstallationStatus" && baUtil.isStringAndNotEmpty(value)) {
                        var index = vm.types.DeviceInstallationStatus.key.indexOf(value);
                        obj['deviceInstallationStatus'] = vm.types.DeviceInstallationStatus[$translate.use()][index];
                    }
                    else {
                        obj[field] = value;
                    }
                })

                if( !isNewUpload ) {
                    if (
                        !vm.permissions.DEVICE_REQUEST.MGMNT_WRITE ||
                        vm.canEditInRequestStatusArr.indexOf(item['deviceInstallationStatus']) === -1 ||
                        (baUtil.isStringAndNotEmpty(item['shippingStatus']) && vm.canEditInShippingStatusArr.indexOf(item['shippingStatus']) === -1)
                    ) {
                        obj.readOnly = true;
                    }
                    else {
                        vm.canShowActionBtns = true;
                    }
                }

                vm.tableData.push(obj)
            })
            var keyMap = vm.KeyMap
            var optionKeys = Object.keys(keyMap).sort(function (a, b) { return keyMap[a].order - keyMap[b].order });

            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = getSource(field)
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                if( vm.fieldMetaData[field] ) {
                    col.validator = vm.fieldMetaData[field]['validator'];
                }

                vm.tableSettings.columns.push(col);
            })


            var container = document.getElementById('handsontable-device-detail');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }

        init();

        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        function getInputType(type) {
           switch (type) {
               case 'String':
                   return 'text'
               case 'Checkbox':
                   return 'checkbox'
               case 'Date':
                   return 'date'
               case 'Dropdown':
                   return 'dropdown'
               default:
                return 'text'
           }
        }

        function cancelCreate() {
            $state.go("main.deviceRequest.list");
        }

        function getSource(key) {
            switch (key) {
                case 'deviceInstallationStatus':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'shippingStatus':
                    return vm.types.ShippingStatus[$translate.use()]
                default:
                 return []
            }
        }


        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field){
            if( vm.fieldMetaData[field] ) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                return "Error in " + vm.KeyMap[field][vm.getLang()];
            }
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.getErrMessage(row, field) );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function create() {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            baUtil.showConfirm()
            .then(function() {
                vm.updateInProgress = true;

                var data = [];
                vm.tableData.forEach(function (row) {
                    var obj = {};
                    Object.keys(row).forEach(function (key) {
                        if (key === 'dateOfApplication' || key === 'jmupsDeliveryDate' || key === 'carrierDeliveryDate' || key === 'hwPlannedDeliveryDate' || key === 'hwDispatchDate' || key === 'hwDeliveryDate') {
                            var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                            obj[key] = long
                            return
                        }
                        else if (key === "shippingStatus") {
                            var index = vm.types.ShippingStatus.en.indexOf(row[key]);
                            if (index < 0) {
                                index = vm.types.ShippingStatus.jp.indexOf(row[key]);
                            }
                            obj['shippingStatus'] = vm.types.ShippingStatus.key[index];
                        }
                        else if (key === "deviceInstallationStatus") {
                            var index = vm.types.DeviceInstallationStatus.en.indexOf(row[key]);
                            if (index < 0) {
                                index = vm.types.DeviceInstallationStatus.jp.indexOf(row[key]);
                            }
                            obj['deviceInstallationStatus'] = vm.types.DeviceInstallationStatus.key[index];
                        }
                        else {
                            obj[key] = row[key]
                        }
                    })
                    data.push(obj)
                });

                data = data.filter(function(d, i){ return !vm.tableData[i].readOnly });
                if(!data.length) return;

                DeviceRequestService.creteDevice(data).then(function success(response) {
                    vm.updateInProgress = false;
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {
                    vm.updateInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });

        }


    }

})();
(function () {
  'use strict'

  angular
    .module('JPTC.pages.deviceRequest')
    .controller('DeviceHistoryCtrl', DeviceHistoryCtrl)

  /** @ngInject */
  function DeviceHistoryCtrl(
    DeviceRequestService,
    baUtil,
    toastr,
    $filter,
    $translate,
    deviceSerialNum,
    types,
    $timeout
  ) {
    var vm = this;
    vm.isLoading = false;
    vm.baUtil = baUtil;
    vm.deviceSerial = deviceSerialNum;
    vm.deviceHistory; 
    vm.suspensionHistory;
    vm.localTranslator = $filter('translate');
    vm.getLang = getLang;
    vm.getValueFromTypeKey = getValueFromTypeKey;
    vm.translatedNA = vm.localTranslator('device.replacement.device.information.na');
    vm.types = types;
  


    vm.boolOptions = {
      en: ['Yes', 'No'],
      jp: ['はい', 'いいえ'],
      key: [true, false]
    }

    function getLang() {
      return $translate.use();
    }

    function getValueFromTypeKey(key, type) {
      var index = type.key.findIndex(function (item) {
        return item === key
      })

      return type[vm.getLang()][index]
    }

    getDeviceHistory()
    getSuspensionDeviceHistory();

    function getDeviceHistory() {
      vm.isLoading = true;
      DeviceRequestService.getDeviceHistory(vm.deviceSerial)
      .then(function (response) {
        vm.deviceHistory = response;
        $timeout(function() {
          vm.isLoading = false;
      }, 1000);
      }).catch(function (err) {
        vm.oldDeviceData = {}
        toastr.error(
          baUtil.getErrorMessageOrDefault(
            err,
            vm.localTranslator('common.components.msg.error.response')
          ),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
      })
    }

    function getSuspensionDeviceHistory() {
      vm.isLoading = true;
      DeviceRequestService.getSuspensionHistory(vm.deviceSerial)
      .then(function (response) {
        vm.suspensionHistory = response.DeviceSuspensionHistoryDtos;
        $timeout(function() {
          vm.isLoading = false;
      }, 1000);
      }).catch(function (err) {
        vm.oldDeviceData = {}
        toastr.error(
          baUtil.getErrorMessageOrDefault(
            err,
            vm.localTranslator('common.components.msg.error.response')
          ),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
      })
    }

  }
})();

(function () {
  'use strict'

  angular
    .module('JPTC.pages.deviceManagement')
    .controller('DeviceReplacementModalCtrl', DeviceReplacementModalCtrl)

  /** @ngInject */
  function DeviceReplacementModalCtrl(
    DeviceRequestService,
    baUtil,
    toastr,
    $filter,
    $uibModalInstance,
    $translate,
    status,
    isNewDevice,
    data
  ) {
    var vm = this
    vm.getValueFromTypeKey = getValueFromTypeKey
    vm.localTranslator = $filter('translate')
    vm.getLang = getLang
    vm.oldDeviceData = data.oldDeviceData
    vm.newDeviceData = data.newDeviceData
    vm.newDeviceData.status = "UNDER_FULFILMENT"
    vm.applyDeviceReplacement = applyDeviceReplacement
    vm.isNewDevice = isNewDevice;
    vm.deviceReplaceForm
    vm.maxDate = new Date()
    vm.monthlyFeesRequired
    vm.canChargeInitialFee
    vm.canChargeMonthlyFee
    vm.canChargeNowDeviceMonthlyFee
    vm.replacementDate
    vm.deliveryDate
    vm.isLoading = false
    vm.inProgress = false
    vm.isDateGreaterThanNowTime = isDateGreaterThanNowTime;
    var minDate =  vm.oldDeviceData.operationApplicableTime || vm.oldDeviceData.removalDate;
    var dateFormat = "YYYY/MM/DD HH:mm:ss";
    
    
    vm.dateOptions = {
      format: dateFormat,
      date: null,
      locale:'ja',
      dayViewHeaderFormat:'YYYY[年]  MMMM',
      allowInputToggle: true,
      minDate: minDate ? isDateGreaterThanNowTime() ? new Date(): moment(getMaxDate()).toDate() : new Date(1901, 0, 1),
      maxDate: new Date(),
      showClose: true
    }

    var options = angular.copy(vm.dateOptions);
    delete options.maxDate;
    vm.deliveryDateOptions = options;
    
    
    vm.boolOptions = {
      en: ['Yes', 'No'],
      jp: ['はい', 'いいえ'],
      key: [true, false]
    }

    vm.status = status;


    function isDateGreaterThanNowTime() {
      return getMaxDate() > moment().valueOf();
    }


    function getMaxDate() {
      var portalDetachedDate = findMaxDate(vm.newDeviceData.operationApplicableTime, vm.oldDeviceData.operationApplicableTime);
      var removalDate =  findMaxDate(vm.newDeviceData.removalDate, vm.oldDeviceData.removalDate);
      var lastComDate = findMaxDate(vm.newDeviceData.lastCommunicationTime, vm.oldDeviceData.lastCommunicationTime);
      var lastSalesDate =  findMaxDate(vm.newDeviceData.lastSalesTime, vm.oldDeviceData.lastSalesTime);

      var tempDate1 = findMaxDate(portalDetachedDate, removalDate);
      var tempDate2 = findMaxDate(lastComDate, lastSalesDate);
      return findMaxDate(tempDate1, tempDate2);
    }


    function findMaxDate(date1, date2) {
      if(date1){
        if(moment(date2).isSameOrAfter(date1)){
          return date2;
        } else{
          return date1;
        }
      } else {
        return date2;
      }
    }

    function getLang() {
      return $translate.use()
    }


    function applyDeviceReplacement() {
      var replacementDate = moment(vm.replacementDate, dateFormat).valueOf();
      var deliveryDate = moment(vm.deliveryDate, dateFormat).valueOf();
      if (vm.deviceReplaceForm.$invalid) {
        return
      }
      
      if(!moment(replacementDate).isValid() ||  moment(replacementDate).valueOf() > moment().valueOf()){
        toastr.error(
          vm.localTranslator('device.replacement.device.information.error.replacement.date.invalid'),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
        vm.deviceReplaceForm.replacementDate.$invalid = true;
        return;
      }
      
      if(baUtil.isUndefinedOrNullOrEmpty(vm.newDeviceData.removalDate) && 
        baUtil.isUndefinedOrNullOrEmpty(vm.newDeviceData.operationApplicableTime)){
          if(moment(replacementDate).diff(getMaxDate(), 'seconds') < 1){
            toastr.error(
              vm.localTranslator('device.replacement.device.information.error.replacement.date.one.sec'),
              vm.localTranslator('common.components.title.error'),
              baUtil.toastOptions()
            )
            vm.replacementDate = null;
            vm.deviceReplaceForm.replacementDate.$invalid = true;
            return;
          }   
        }
        else{
          if(moment(replacementDate).diff(getMaxDate(), 'minutes') < 1){
            toastr.error(
              vm.localTranslator('device.replacement.device.information.error.replacement.date'),
              vm.localTranslator('common.components.title.error'),
              baUtil.toastOptions()
            )
            vm.replacementDate = null;
            vm.deviceReplaceForm.replacementDate.$invalid = true;
            return;
          } 
      }

      if(replacementDate > deliveryDate) {
        toastr.error(
          vm.localTranslator('device.replacement.device.information.error.delivery.date'),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
        vm.deliveryDate = null;
        vm.deviceReplaceForm.deliveryDate.$invalid = true;
        return;
      }


      baUtil
        .showConfirm(
          vm.localTranslator('device.replacement.confirm.title'),
          vm.localTranslator('device.replacement.confirm.msg'),
          vm.localTranslator('device.replacement.submit')
        )
        .then(
          function () {
            var obj = {
              oldDeviceSerialNum: vm.oldDeviceData.deviceSerial,
              newDeviceSerialNum: vm.newDeviceData.deviceSerial,
              canChargeMonthlyFee: vm.canChargeMonthlyFee,
              canChargeInitialFee: vm.canChargeInitialFee,
              canChargeNowDeviceMonthlyFee: vm.canChargeNowDeviceMonthlyFee,
              newDeviceStatus: vm.newDeviceData.status,
              replacementDate: replacementDate,
              expectedDod: deliveryDate
            }
            vm.inProgress = true;
            DeviceRequestService.replaceDevice(obj)
              .then(function () {
                toastr.success(
                  vm.localTranslator('device.replacement.success.msg'),
                  vm.localTranslator('common.components.title.success'),
                  baUtil.toastOptions()
                )

                vm.inProgress = false;
                $uibModalInstance.close(true)
              })
              .catch(function (err) {
                vm.inProgress = false;
                $uibModalInstance.close(false)
                toastr.error(
                  baUtil.getErrorMessageOrDefault(
                    err,
                    vm.localTranslator('common.components.msg.error.response')
                  ),
                  vm.localTranslator('common.components.title.error'),
                  baUtil.toastOptionsWithExtendedTimeout()
                )
              })
          },
          function err() {}
        )
    }

    function getValueFromTypeKey(key, type) {
      var index = type.key.findIndex(function (item) {
        return item === key
      })

      return type[vm.getLang()][index]
    }
  }
})();

(function () {
  'use strict'

  angular
    .module('JPTC.pages.deviceManagement')
    .controller('DeviceReplacementCtrl', DeviceReplacementCtrl)

  /** @ngInject */
  function DeviceReplacementCtrl(
    DeviceRequestService,
    filterOptions,
    baUtil,
    toastr,
    $filter,
    $translate,
    $uibModal
  ) {
    var vm = this
    vm.isLoading = false
    vm.inProgress = false
    vm.localTranslator = $filter('translate')
    vm.getOldDeviceData = getOldDeviceData
    vm.getNewDeviceData = getNewDeviceData
    vm.showConfirmModal = showConfirmModal
    vm.oldDeviceData
    vm.newDeviceData
    vm.inputDate
    vm.oldDeviceId
    vm.newDeviceId
    vm.isNewDevice = false;
    vm.monthlyFeesRequired
    vm.getLang = getLang;
    vm.getValueFromTypeKey = getValueFromTypeKey;
    vm.changeStatus = changeStatus;
    vm.isNewInput = false;
    vm.translatedNA = vm.localTranslator('device.replacement.device.information.na');
    vm.isModalOpen = false;

    function changeStatus(value) {
      vm.isNewInput = value;
    }


    vm.dateOptions = {
      showWeeks: false,
      formatDayTitle: 'yyyy 年 MMMM',
      formatMonthTitle: 'yyyy 年',
      minDate: new Date(1901, 0, 1),
      maxDate: new Date().getTime()
    }

    if (filterOptions.status >= 200 && filterOptions.status <= 299) {
      vm.status = filterOptions.data.data.DeviceInstallationStatus;
    }

  function getValueFromTypeKey(key, type) {
    var index = type.key.findIndex(function (item) {
      return item === key
    })

    return type[vm.getLang()][index]
  }

  function getLang() {
    return $translate.use();
  }

    function getOldDeviceData() {
      if(!baUtil.isValidDeviceSerial(vm.oldDeviceId)) {
        toastr.error(
          vm.localTranslator('device.replacement.provide.valid.serialNumber'),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
        return;
      }
      DeviceRequestService.getOldDeviceRecord(vm.oldDeviceId)
        .then(function (response) {
          vm.oldDeviceData = response
        })
        .catch(function (err) {
          vm.oldDeviceData = null;
          toastr.error(
            baUtil.getErrorMessageOrDefault(
              err,
              vm.localTranslator('common.components.msg.error.response')
            ),
            vm.localTranslator('common.components.title.error'),
            baUtil.toastOptions()
          )
        })
    }

  
    function getNewDeviceData() {
      if(!baUtil.isValidDeviceSerial(vm.newDeviceId)) {
        toastr.error(
          vm.localTranslator('device.replacement.provide.valid.serialNumber'),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
        return;
      }
   
      DeviceRequestService.getNewDeviceRecord(vm.newDeviceId)
        .then(function (response) {
          vm.newDeviceData = response;
          vm.isNewDevice = false;
          if(!response) {
            vm.isNewDevice = true;
            vm.newDeviceData = {}
            vm.newDeviceData.deviceSerial =  vm.newDeviceId;
          }
        })
        .catch(function (err) {
          vm.newDeviceData = null
          toastr.error(
            baUtil.getErrorMessageOrDefault(
              err,
              vm.localTranslator('common.components.msg.error.response')
            ),
            vm.localTranslator('common.components.title.error'),
            baUtil.toastOptions()
          )
        })
    }




    function showConfirmModal() {
      if (vm.oldDeviceData.deviceSerial === vm.newDeviceData.deviceSerial) {
        vm.newDeviceData = null;
        toastr.error(
          vm.localTranslator('device.replacement.provide.serialNumber.msg'),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
        return
      }
      vm.isModalOpen = true;
      $uibModal.open({
        animation: false,
        controller: 'DeviceReplacementModalCtrl',
        templateUrl: 'app/pages/device-request/views/device-replacement-modal.html',
        controllerAs: 'vm',
        size: "lg",
        backdrop: "static",
        resolve: {
          status: vm.status,
          isNewDevice: angular.copy(vm.isNewDevice),
          data: function () {
            return { oldDeviceData: angular.copy(vm.oldDeviceData), newDeviceData: angular.copy(vm.newDeviceData)};
          }
        }
       
      }).result.then(function (status) {
        vm.isModalOpen = false;
        if(status) {
          vm.newDeviceData = null;
          vm.oldDeviceData = null
          vm.oldDeviceId = null;
          vm.newDeviceId = null;
        }
      }, function() {
        vm.isModalOpen = false;
      });
    }

    
  }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('EditChangeRequestCtrl', EditChangeRequestCtrl);

    /** @ngInject */
    function EditChangeRequestCtrl(DeviceRequestService, types, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, $rootScope, AuthService, $uibModal, hotUtil,
        DeviceRequestUtilService,FileSaver,$sce) {

        if( $stateParams.deviceRequest == null ) {
            $state.go("main.deviceRequest.change");
        }

        if($stateParams.deviceRequest) {
            $state.current.title = 'device.request.list.edit.device.changes';
        }
        else {
            $state.current.title = 'device.request.list.upload.device';
        }

        var vm = this;
        vm.isJescaUpload = $stateParams.isJescaUpload;
        vm.deviceRequest = $stateParams.deviceRequest.dtos;
        vm.KeyMap = DeviceRequestUtilService.getKeys($stateParams.deviceRequest.keyMap, "1.0");
        vm.getInputType = getInputType;
        vm.create = create;
        vm.reserve = reserve;
        vm.download = download;
        vm.cancelCreate = cancelCreate;
        vm.serviceContractId = null;
        vm.permissions = AuthService.getPermissions();
        vm.localTranslator = $filter('translate');

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        vm.types.deviceOwner = $stateParams.deviceRequest.deviceOwners;
        vm.KeyMap.deviceOwnerId.type = "Dropdown";
        vm.KeyMap.deviceOwnerId.readOnly = false;
        vm.autoSelectedDO = ""; // in case of self rent
        vm.isUserDeviceOwnerOfSC = false;
        vm.orgId = AuthService.getOrgId();
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ;
        vm.getDeviceStatusFromKey = getDeviceStatusFromKey;
        vm.getInstallationStatusIndex = getInstallationStatusIndex;
        vm.isDIStateTransitionValid = isDIStateTransitionValid;
        vm.hotTable = null;
        vm.isReserveBtnDisbaled = false;

        vm.getLang = getLang;
        vm.modal = null;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;
        vm.getErrMessageOfStatus = getErrMessageOfStatus;
        vm.getErrMessageDO = getErrMessageDO;

        // if (vm.orgId && vm.orgId != "" && vm.types.deviceOwner.key.indexOf(vm.orgId) != -1 && !baUtil.isMerchant()) {
        //     vm.isUserDeviceOwnerOfSC = true;
        //     vm.autoSelectedDO = vm.orgId;
        // } else if (vm.types.deviceOwner.key.length === 1) {
        //     vm.autoSelectedDO = vm.types.deviceOwner.key[0];
        // }
        
        if (baUtil.isSystemAdmin()) {
            vm.systemAdmin = true;
        }
        else {
            vm.systemAdmin = false;
        }

        function init() {
            vm.tableData = [];
            vm.tableOptions = {};
            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                fixedColumnsLeft: 5,
                modifyColWidth: function(width, col) {
                    if(width > 500) return 500;
                },
                afterValidate: function (isValid, value, row, prop, source) {
                    // special validation for device installaiton status
                    // if(prop === "status") {
                    //     var index = vm.types.DeviceInstallationStatus.en.indexOf(value);
                    //     if (index < 0) {
                    //         index = vm.types.DeviceInstallationStatus.jp.indexOf(value);
                    //     }
                    //     var indexValue = index === -1 ? value : vm.types.DeviceInstallationStatus.key[index];

                    //     if(vm.isDIStateTransitionValid(vm.deviceRequest[row]['status'], indexValue)) {
                    //         delete vm.errors[ row + "_" + prop ];
                    //         return true;
                    //     }
                    //     else {
                    //         vm.errors[ row + "_" + prop ] = vm.getErrMessageOfStatus(
                    //             row+1,
                    //             vm.deviceRequest[row]['applicationNumber'],
                    //             vm.deviceRequest[row]['status'],
                    //             indexValue
                    //         );
                    //         return false;
                    //     }
                    // }

                    if(prop === "deviceOwnerId") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId");
                            return false;
                        }
                        else if( vm.types.deviceOwner[$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId", true);
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(prop === "paymentHandlingOption_TRANSPORT") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value) ||
                         vm.types.TransportPaymentOptions[$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "paymentHandlingOption_TRANSPORT", true);
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    // common use validator
                    // if ( !vm.KeyMap[prop]["readOnly"] &&
                    //     vm.KeyMap[prop]['validators'].length
                    // ) {
                    //     var msg = hotUtil.aggregatedValidator(vm.KeyMap[prop]['validators'], value, row, vm.KeyMap[prop][vm.getLang()]);
                    //     if( msg != "" ) {
                    //         vm.errors[ row + "_" + prop ] = msg;
                    //         return false;
                    //     }
                    //     else {
                    //         delete vm.errors[ row + "_" + prop ];
                    //         return true;
                    //     }
                    // }

                    // if(isValid) {
                    //     delete vm.errors[ row + "_" + prop ];
                    // }
                    // else {
                    //     vm.errors[ row + "_" + prop ] = value;
                    // }
                }
            };
            // disable rows if the device status is not DRAFT or REGISTERED
            //    for users which don't have permissions
            //    when status is cancelled
            vm.tableSettings.cells = function (row, col,prop) {
                var cellMeta = {};
                // return vm.tableData[row].isUpdatable === true ? {readOnly : false} : {readOnly : true};
                if(vm.tableData[row].isUpdatable === true){
                    if(prop.includes('paymentHandlingOption')){
                    var new_prop = prop.replace('paymentHandlingOption_','')
                    if(vm.tableData[row].changedColumns.includes(new_prop)){
                        cellMeta.className = 'changed';
                        cellMeta.readOnly = false;
                    }
                    else if(vm.tableData[row].productName.includes('ME-10')){
                        if(new_prop === 'VISA' || new_prop === 'MASTERCARD' || new_prop === 'AMERICANEXPRESS' || new_prop === 'JCB' || new_prop === 'DISCOVER' || new_prop === 'DINERS'){
                            cellMeta.className = 'even';
                            cellMeta.readOnly = true;
                        }
                    }
                    else{
                        cellMeta.className = 'even';
                        cellMeta.readOnly = false;
                    }
                    }else{

                        if(vm.tableData[row].changedColumns.includes(prop) || prop === 'paymentHandlingOption_PITAPA'){
                            cellMeta.className = 'changed';
                            cellMeta.readOnly = false;
                        }
                        else if(prop === 'receiptNumber' || prop === 'serialNumber' || prop === 'itemName' || prop === 'deviceSerial' ||prop === 'serviceContractId' || prop === 'companyName' || prop === 'applicationNumber' || prop === 'deviceOwnerId'){
                            cellMeta.className = 'even';
                            cellMeta.readOnly = true;
                        }else{
                            cellMeta.className = 'even';
                            cellMeta.readOnly = false;
                        }
                    }
                    }
                else{
                    cellMeta.className = 'odd';
                    cellMeta.readOnly = true;
                }
                if (vm.tableData[row] && vm.tableData[row][prop + '_readOnly']) {
                    cellMeta.readOnly = true;
                }
                return cellMeta;
                // return vm.tableData[row] && vm.tableData[row].readOnly ? { readOnly: true } : {};
            };
            
            vm.deviceRequest.forEach(function (items, indexes) {
                items.forEach(function (item,index) {
                var obj = {};
                if (baUtil.isUndefinedOrNullOrEmpty(vm.serviceContractId)) {
                    vm.serviceContractId = item.serviceContractId
                }
                    Object.keys(item).forEach(function (field) {
                        var value = item[field]
                        if (field === 'date' || field === 'preferredDateOfInstallation') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                        return
                    }

                    obj[field] = value;
                    
                    if (field === 'status') {
                        var index = vm.types.DeviceInstallationStatus.key.indexOf(value);
                        obj[field] = vm.types.DeviceInstallationStatus[$translate.use()][index];
                    }

                    if(field === 'initialBilling'){
                        var index = vm.types.InitialMonthlyBilling.key.indexOf(value);
                        obj[field] = vm.types.InitialMonthlyBilling[$translate.use()][index];
                    }

                    if(field === 'monthlyBilling'){
                        var index = vm.types.InitialMonthlyBilling.key.indexOf(value);
                        obj[field] = vm.types.InitialMonthlyBilling[$translate.use()][index];
                    }
                    
                    // if (field === 'type') {
                    //     var index = vm.types.DeviceInstallationType.key.indexOf(value);
                    //     obj[field] = vm.types.DeviceInstallationType[$translate.use()][index];
                    // }
                    else if (field === 'deviceOwnerId') {
                        if(baUtil.isUndefinedOrNullOrEmptyObject(value)) {
                            obj['deviceOwnerId'] =  "";
                        }
                        else {
                            var index = vm.types.deviceOwner[item.serviceContractId].key.indexOf(value);
                            obj['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId][$translate.use()][index];
                        }
                     }
                    if(field === 'itemName'){
                        var index = vm.types.ItemName.key.indexOf(value);
                        obj[field] = vm.types.ItemName[$translate.use()][index];
                    }
                                
                    if (field === 'vendingMachineModel') {
                        item.paymentHandlingOptions.forEach(function (k, i) {
                            obj['paymentHandlingOption_' + k] = true
                        });
                        obj['paymentHandlingOption_TRANSPORT'] = DeviceRequestUtilService.getTransportPaymentOptionTextFromKey(
                        vm.types.TransportPaymentOptions,
                        item['transportPaymentHandlingOption'],
                        item['paymentHandlingOptions']
                        );
                        }

                        if(field === 'deviceSerial'){
                            obj.initialDeviceSerial = value;
                            if(value.includes('-')){
                                obj.subCategory = value.split('-')[1];
                              var new_value = value.slice(0, value.indexOf('-'));
    
                            }
                            obj[field] = new_value || value ;
                        }
                        if(field === 'applicationNumber'){
                            obj.initialApplicationNumber = value;
                            if(value.includes('-')){
                                obj.subCategoryAppNo = value.split('-')[1];
                               var new_value = value.slice(0, value.indexOf('-'));
                            }
                            obj[field] = new_value || value;                    
                        }    
                    })
                    DeviceRequestUtilService.applyResumeHwBillingReadOnly(item, obj);
                        obj._s=obj.isUpdatable;
                        vm.tableData.push(obj);
                    })
                })
            
            vm.isReserveBtnDisbaled = vm.tableData.some(function(item){
                if(item.drchangeStatus === "COMPLETED" || item.drchangeStatus === "CANCELLED"){
                    return true;
                }
            }  )
                
            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap).sort(function (a, b) {
                return keyMap[a].order - keyMap[b].order;
            });
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                // if (
                //     (field == 'status') ||
                //     (field == 'deviceOwnerId' && vm.isUserDeviceOwnerOfSC)
                // ) {
                //     col.readOnly = true;
                // }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = getSource(field)
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                if ( !vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'].length ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }
                vm.tableSettings.columns.push(col);
            })
            var checked=true
            var selectColumnTemplate = { data: "_s", type: "checkbox" };
            vm.tableSettings.columns.unshift(selectColumnTemplate)
            vm.tableSettings.colHeaders.unshift('<input '+(checked?'checked="checked"':'')+' class="hot_handsontable_header_chkbox" type="checkbox" />')
            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsontable-edit-change-multiple-request');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            var _settings=options
         
            container.innerHTML=''
            vm.hotTable = new Handsontable(container, _settings);
            Handsontable.dom.addEvent(container, 'mousedown', function (event) {
                if (event.target.nodeName == 'INPUT' && event.target.className == 'hot_handsontable_header_chkbox') {
                    event.stopPropagation();
                }
            });
            Handsontable.dom.addEvent(container, 'mouseup', function (event) {
                if (event.target.nodeName == 'INPUT' && event.target.className == 'hot_handsontable_header_chkbox') {
                        event.target.checked =checked
                        vm.tableData=vm.tableData.map(function(item){
                            if(item.isUpdatable)
                            {
                                item._s=checked
                            }
                            return item
                        })
                        vm.tableSettings.colHeaders[0]='<input '+(checked?'checked="checked"':'')+' class="hot_handsontable_header_chkbox" type="checkbox" />'
                        vm.hotTable.render();
                        checked=!checked
                    
                }
            });

            vm.hotTable.render();
            // vm.hotTable.validateCells();
        }

        init();

        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        // ask before leaving form
        vm.askBeforeLeaving = true;
        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            if (current.endsWith('device-request/create-multiple') && vm.askBeforeLeaving) {
                processBeforeRedirect(event);
            }
        });

        function processBeforeRedirect(event) {
            toastr.info(
                vm.localTranslator("common.components.msg.confirm"),
                vm.localTranslator("common.components.title.info"),
                baUtil.toastOptions()
            );
            if( event ) event.preventDefault();
            vm.askBeforeLeaving = false;
        }

        function cancelCreate() {
            if (baUtil.isSystemAdmin()) {
            if( vm.askBeforeLeaving ) {
                return processBeforeRedirect();
            }
        }
            $state.go("main.deviceRequest.change");
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }

        function getSource(key) {
            switch (key) {
                case 'status':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'type':
                    return vm.types.DeviceInstallationType[$translate.use()]
                case 'deviceOwnerId':
                    return vm.types.deviceOwner[$translate.use()]
                case 'paymentHandlingOption_TRANSPORT':
                    return vm.types.TransportPaymentOptions[$translate.use()]
                case 'initialBilling':
                    return vm.types.InitialMonthlyBilling[$translate.use()]  
                case 'monthlyBilling':
                    return vm.types.InitialMonthlyBilling[$translate.use()]  
                default:
                    return []
            }
        }

        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field){
            if( vm.fieldMetaData[field] ) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                /// return reqd otherwise
                return $translate.instant(
                    "device.request.edit.err.msg.required.field",
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
        }

        function getErrMessageDO (row, field, isWrongInput) {
            return $translate.instant(
                isWrongInput ? "device.request.edit.err.msg.device.owner" : "device.request.edit.err.msg.required.field",
                { row: row, param: vm.KeyMap[field][vm.getLang()] }
            );
        }

        function getErrMessageOfStatus(row, applicationNumber, from, to){
            return $translate.instant(
                "device.request.edit.err.msg.cannot.allow.state.transition",
                {
                    row: row,
                    id: applicationNumber,
                    from: vm.getDeviceStatusFromKey(from),
                    to: vm.getDeviceStatusFromKey(to)
                }
            );
        }

        function getInstallationStatusIndex(status){
            var statusMap = {
                "DRAFT": 0,
                "REGISTERED": 1,
                "ACCEPTED": 2,
                "UNDER_FULFILMENT": 3,
                "COMPLETED": 4,
                "APPLICATION_CANCELLED": 5
            };
            if(Object.keys(statusMap).indexOf(status) === -1) {
                return null;
            }
            return statusMap[status]
        }

        function isDIStateTransitionValid(statusBefore, statusAfter) {

            // no change detected
            if(statusBefore == statusAfter) {
                return true;
            }

            // status shifted backwards
            else if (
                vm.getInstallationStatusIndex(statusBefore) != null &&
                vm.getInstallationStatusIndex(statusAfter) != null &&
                vm.getInstallationStatusIndex(statusBefore) > vm.getInstallationStatusIndex(statusAfter)
            ) {
                if(vm.isSystemUser) {
                    if(
                        (statusBefore == "ACCEPTED" && statusAfter == "REGISTERED") ||
                        (statusBefore == "UNDER_FULFILMENT" && statusAfter == "REGISTERED")
                    ) {
                        return true;
                    }
                }
                return false;
            }

            // status moving forward
            else {
                // for common permissions
                if(
                    (statusBefore == "DRAFT" && statusAfter == "REGISTERED") ||
                    (statusBefore == "REGISTERED" && statusAfter == "APPLICATION_CANCELLED")
                ) {
                    return true;
                }
                // for System User
                else if(vm.isSystemUser) {
                    if(
                        (statusBefore == "REGISTERED" && statusAfter == "ACCEPTED") ||
                        (
                            statusBefore == "ACCEPTED" &&
                            ["UNDER_FULFILMENT", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        ) ||
                        (
                            statusBefore == "UNDER_FULFILMENT" &&
                            ["COMPLETED", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        )
                    ) {
                        return true;
                    }
                }
                // otherwise
                return false;
            }
        }

        function getDeviceStatusFromKey(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);

            if(index === -1) return key;

            return ($translate.use() === "jp" ?
                    vm.types.DeviceInstallationStatus.jp[index] :
                    vm.types.DeviceInstallationStatus.en[index]);
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function reserve(){
            var message = "Message";
            var lang = $translate.use();
            var modalValues = null;
            $uibModal.open({
                animation: false,
                controller: function confirmCtrl($uibModalInstance) {
                    var confirmVm = this;
                    var today = new Date();
                    confirmVm.todayDate = new Date().setHours(23,59,59,999);
                    var tomorrowDate = new Date();
                    tomorrowDate.setDate(today.getDate()+1)
                    confirmVm.date = tomorrowDate;
                    confirmVm.dateOptions = {
                        showWeeks: false,
                        formatDayTitle:'yyyy 年 MMMM',
                        formatMonthTitle:'yyyy 年',
                        minDate : tomorrowDate,
                    }
                    confirmVm.cancelReservation = false;
                    confirmVm.monthEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    confirmVm.nextMonthStartDate = new Date(today.getFullYear(), today.getMonth() + 1, 1)
                    confirmVm.title = (lang == "jp" ? "変更予約" : 'Reserve Change');
                    confirmVm.message = $sce.trustAsHtml( message || (lang == "jp" ? "変更内容を保存します。" : 'This will save all the changes made by you.'));
                    confirmVm.btnText = (lang == "jp" ? "実行" : 'Execute');
                    confirmVm.ok = function () {
                        $uibModalInstance.close();
                        modalValues = confirmVm;
                        vm.createInProgress = true;

                    };
                    confirmVm.cancel = function(){
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                templateUrl: 'app/pages/device-request/views/reserve-change-modal.html',
                controllerAs: 'confirmVm',
                backdrop: "static"
              }).result.then(function(){

                var immediately = false
                var reservationDateTime = null;
                var drChangeStatusValue = "RESERVED";

                if(modalValues.hasOwnProperty('reserveChange') === true){
                    if(modalValues.reserveChange.reservationDateTime === 'immediate' ){
                        reservationDateTime = Date.parse(new Date());
                        immediately = true;
                    }else if(modalValues.reserveChange.reservationDateTime === 'today'){
    
                        reservationDateTime = modalValues.todayDate;
    
                    }else if(modalValues.reserveChange.reservationDateTime === 'monthEnd'){
    
                        reservationDateTime = modalValues.monthEndDate.setHours(23,59,59,999);
                        
                    }else if(modalValues.reserveChange.reservationDateTime === 'startNextMonth'){
    
                        reservationDateTime = Date.parse(modalValues.nextMonthStartDate);
                        
                    }else if(modalValues.reserveChange.reservationDateTime === 'specificDate'){
                        
                        reservationDateTime = modalValues.date.setHours(0,0,0,0);
    
                    }else if(modalValues.reserveChange.reservationDateTime === 'cancelReservation'){
                        
                        reservationDateTime = null;
                        drChangeStatusValue = "CANCELLED"
                    }
                }
                else{
                    reservationDateTime = modalValues.todayDate;
                }
                
                vm.tableData.forEach(function(item){
                    item.drchangeStatus = drChangeStatusValue || item.drchangeStatus;
                })
                var data = [];

            vm.tableData.forEach(function(item){
                item.reservationDateTime = reservationDateTime;
            })    

            vm.tableData.forEach(function(item){
                if(item.subCategory && item.initialDeviceSerial.includes('-')){
                    item.deviceSerial = item.deviceSerial + "-" + item.subCategory;
                }
                if(item.subCategoryAppNo && item.initialApplicationNumber.includes('-')){
                    item.applicationNumber = item.applicationNumber + "-" + item.subCategoryAppNo;
                }
            })

            vm.tableData.forEach(function (row) {
                var obj = {
                    paymentHandlingOptions: []
                };
                Object.keys(row).forEach(function (key) {
                    if( key === "paymentHandlingOptions" ) return;

                    if (key === 'date' || key == 'preferredDateOfInstallation') {
                        var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                        obj[key] = long
                        return
                    }
                    if (key.indexOf("paymentHandlingOption_") >= 0){
                        if(row[key]) {
                            var optionKey = key.replace('paymentHandlingOption_', '');
                            obj.paymentHandlingOptions.push(optionKey);
                        }
                        return;
                    }

                    obj[key] = row[key]
                });

                obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                    vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                if(obj['transportPaymentHandlingOption'] !== "-") {
                    obj.paymentHandlingOptions.push("TRANSPORT");
                }

                data.push(obj)
            });

            data.forEach(function (item, i) {
                item = data[i];

                var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                }
                var indexValue = vm.types.DeviceInstallationStatus.key[index];

                if ((indexValue == "REGISTERED" && isDraft) || (indexValue == "DRAFT" && !isDraft))
                    item['status'] = "REGISTERED";
                else if (indexValue == "DRAFT" || indexValue == "REGISTERED")
                    item['status'] = indexValue;
                else
                    item['status'] = vm.isSystemUser ?
                        vm.types.DeviceInstallationStatus.key[index] :
                        vm.deviceRequest[i]['status'];

                var index = vm.types.InitialMonthlyBilling.en.indexOf(item.initialBilling);
                if (index < 0) {
                    index = vm.types.InitialMonthlyBilling.jp.indexOf(item.initialBilling);
                }
                item['initialBilling'] = vm.types.InitialMonthlyBilling.key[index];

                var index = vm.types.InitialMonthlyBilling.en.indexOf(item.monthlyBilling);
                if (index < 0) {
                    index = vm.types.InitialMonthlyBilling.jp.indexOf(item.monthlyBilling);
                }
                item['monthlyBilling'] = vm.types.InitialMonthlyBilling.key[index];

                var index = vm.types.ItemName.en.indexOf(item.itemName);
                if (index < 0) {
                    index = vm.types.ItemName.jp.indexOf(item.itemName);
                }
                item['itemName'] = vm.types.ItemName.key[index];

                // var index = vm.types.DeviceInstallationType.en.indexOf(item.type);
                // if (index < 0) {
                //     index = vm.types.DeviceInstallationType.jp.indexOf(item.type);
                // }
                // item['type'] = vm.types.DeviceInstallationType.key[index];

                var index = vm.types.deviceOwner[item.serviceContractId].en.indexOf(item.deviceOwnerId);
                if (index < 0) {
                    index = vm.types.deviceOwner[item.serviceContractId].jp.indexOf(item.deviceOwnerId);
                }
                item['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId].key[index];
            })

            var data = data.filter(function (d, i) { return d.isUpdatable && d._s });
            
            DeviceRequestService.updateDeviceRequestChange(data,immediately)
                .then(function success(response) {
                    vm.createInProgress = false;
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    // $state.go('main.deviceRequest.change');
                }, function err(err) {
                    vm.createInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });

                vm.tableData.forEach(function(item){
                    if(item.deviceSerial.includes('-')){
                        item.deviceSerial = item.deviceSerial.slice(0, item.deviceSerial.indexOf('-'));
                      }
                      if(item.applicationNumber.includes('-')){
                        item.applicationNumber = item.applicationNumber.slice(0,item.applicationNumber.indexOf('-'));
                      }
                })    
            });
        }

        function download(){
            

                var data = [];
                vm.downloadInProgress = true;
                vm.tableData.forEach(function(item){
                    if(item.subCategory && item.initialDeviceSerial.includes('-')){
                        item.deviceSerial = item.deviceSerial + "-" + item.subCategory;
                    }
                    if(item.subCategoryAppNo && item.initialApplicationNumber.includes('-')){
                        item.applicationNumber = item.applicationNumber + "-" + item.subCategoryAppNo;
                    }
                })
                
                vm.tableData.forEach(function (row) {
                    var obj = {
                          paymentHandlingOptions: []
                        };
                        Object.keys(row).forEach(function (key) {
                            if( key === "paymentHandlingOptions" ) return;
                            
                            if (key === 'date' || key == 'preferredDateOfInstallation') {
                                var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                                obj[key] = long
                                return
                            }
                            if (key.indexOf("paymentHandlingOption_") >= 0){
                                if(row[key]) {
                                    var optionKey = key.replace('paymentHandlingOption_', '');
                                    obj.paymentHandlingOptions.push(optionKey);
                                }
                                return;
                            }
                            
                            obj[key] = row[key]
                        });
                        
                        obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                            vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                            obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                            if(obj['transportPaymentHandlingOption'] !== "-") {
                                obj.paymentHandlingOptions.push("TRANSPORT");
                            }
                            
                            data.push(obj)
                        });
                        
                        data.forEach(function (item, i) {
                            item = data[i];
                            
                            var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                            if (index < 0) {
                                index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                            }
                            var indexValue = vm.types.DeviceInstallationStatus.key[index];
                            
                            if ((indexValue == "REGISTERED" && isDraft) || (indexValue == "DRAFT" && !isDraft))
                            item['status'] = "REGISTERED";
                            else if (indexValue == "DRAFT" || indexValue == "REGISTERED")
                            item['status'] = indexValue;
                            else
                            item['status'] = vm.isSystemUser ?
                            vm.types.DeviceInstallationStatus.key[index] :
                            vm.deviceRequest[i]['status'];
                            
                            var index = vm.types.InitialMonthlyBilling.en.indexOf(item.initialBilling);
                            if (index < 0) {
                                index = vm.types.InitialMonthlyBilling.jp.indexOf(item.initialBilling);
                            }
                            item['initialBilling'] = vm.types.InitialMonthlyBilling.key[index];

                            var index = vm.types.InitialMonthlyBilling.en.indexOf(item.monthlyBilling);
                            if (index < 0) {
                                index = vm.types.InitialMonthlyBilling.jp.indexOf(item.monthlyBilling);
                            }
                            item['monthlyBilling'] = vm.types.InitialMonthlyBilling.key[index];

                            var index = vm.types.ItemName.en.indexOf(item.itemName);
                            if (index < 0) {
                                index = vm.types.ItemName.jp.indexOf(item.itemName);
                            }
                            item['itemName'] = vm.types.ItemName.key[index];
                            
                            // var index = vm.types.DeviceInstallationType.en.indexOf(item.type);
                            // if (index < 0) {
                                //     index = vm.types.DeviceInstallationType.jp.indexOf(item.type);
                                // }
                                // item['type'] = vm.types.DeviceInstallationType.key[index];
                                
                            var index = vm.types.deviceOwner[item.serviceContractId].en.indexOf(item.deviceOwnerId);
                            if (index < 0) {
                                index = vm.types.deviceOwner[item.serviceContractId].jp.indexOf(item.deviceOwnerId);
                            }
                            item['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId].key[index];                             
                            })
                                
                                var temp_data = data.map(function (d, i) { if(d.isUpdatable && d._s){
                                    return {'deviceInstallationId':d.deviceInstallationId}
                                } });

                                temp_data = temp_data.filter(function( element ) {
                                    return element !== undefined;
                                 });


                                 var new_data = [];

                                 for(var i=0;i<data.length;i++){
                                    for(var j=0;j<temp_data.length;j++){
                                        if(data[i].deviceInstallationId === temp_data[j].deviceInstallationId){
                                            new_data.push(data[i])
                                        }
                                    }
                                }
                                
                                DeviceRequestService
                                .downloadDeviceRequestChangeExcel(new_data)
                                .then(function(resp) {
                                    vm.downloadInProgress = false;
                                    var headers = resp.headers();
                                    var filename = headers["content-disposition"];
                                    filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                                    var serverData = new Blob([resp.data], {type: headers['content-type']});
                                    FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
                                },function(err) {
                                    vm.downloadInProgress = false;
                                    if ("TextDecoder" in window) {
                                        try {
                                            var enc = new TextDecoder("utf-8");
                                            var data = enc.decode(err.data);
                                            err = JSON.parse(data);
                                        } catch(ignore){ }
                                    }
                                    toastr.error(
                                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                                        vm.localTranslator("common.components.title.error"),
                                        baUtil.toastOptions()
                                        );
                                    });

                                    vm.tableData.forEach(function(item){
                                        if(item.deviceSerial.includes('-')){
                                            item.deviceSerial = item.deviceSerial.slice(0, item.deviceSerial.indexOf('-'));
                                          }
                                          if(item.applicationNumber.includes('-')){
                                            item.applicationNumber = item.applicationNumber.slice(0,item.applicationNumber.indexOf('-'));
                                          }
                                    })                        

                                }
                                
        function create(isDraft) {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            baUtil.showConfirm()
            .then(function () {

                var data = [];
                vm.tableData.forEach(function (row) {
                    var obj = {
                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
                        if( key === "paymentHandlingOptions" ) return;

                        if (key === 'date' || key == 'preferredDateOfInstallation') {
                            var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                            obj[key] = long
                            return
                        }
                        if (key.indexOf("paymentHandlingOption_") >= 0){
                            if(row[key]) {
                                var optionKey = key.replace('paymentHandlingOption_', '');
                                obj.paymentHandlingOptions.push(optionKey);
                            }
                            return;
                        }

                        obj[key] = row[key]
                    });

                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                        vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                    if(obj['transportPaymentHandlingOption'] !== "-") {
                        obj.paymentHandlingOptions.push("TRANSPORT");
                    }

                    data.push(obj)
                });

                data.forEach(function (item, i) {
                    item = data[i];

                    var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                    if (index < 0) {
                        index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                    }
                    var indexValue = vm.types.DeviceInstallationStatus.key[index];

                    if ((indexValue == "REGISTERED" && isDraft) || (indexValue == "DRAFT" && !isDraft))
                        item['status'] = "REGISTERED";
                    else if (indexValue == "DRAFT" || indexValue == "REGISTERED")
                        item['status'] = indexValue;
                    else
                        item['status'] = vm.isSystemUser ?
                            vm.types.DeviceInstallationStatus.key[index] :
                            vm.deviceRequest[i]['status'];



                    var index = vm.types.DeviceInstallationType.en.indexOf(item.type);
                    if (index < 0) {
                        index = vm.types.DeviceInstallationType.jp.indexOf(item.type);
                    }
                    item['type'] = vm.types.DeviceInstallationType.key[index];

                    var index = vm.types.deviceOwner.en.indexOf(item.deviceOwnerId);
                    if (index < 0) {
                        index = vm.types.deviceOwner.jp.indexOf(item.deviceOwnerId);
                    }
                    item['deviceOwnerId'] = vm.types.deviceOwner.key[index];
                })

                data = data.filter(function (d, i) { return !vm.tableData[i].readOnly });
                if (!data.length) return;

                if(data.length > 9) {
                    vm.modal = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/modalTemplates/loadingModal.html',
                        size: "sm",
                        resolve: {
                          items: function () {
                            return $scope.items;
                        }}
                    });
                }

                if (isDraft) {
                    vm.draftInProgress = true;
                } else {
                    vm.createInProgress = true;
                }


                DeviceRequestService.createDeviceRequest(data, vm.serviceContractId,vm.isJescaUpload)
                .then(function success(response) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    vm.askBeforeLeaving = false;
                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('JescaDetailCtrl', JescaDetailCtrl);

    /** @ngInject */
    function JescaDetailCtrl(DeviceRequestService, types, KeyMap, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, AuthService, $uibModal, hotUtil, DeviceRequestUtilService, FileSaver) {

//        if( $stateParams.deviceInstallation == null ) {
//            $state.go("main.deviceRequest.list");
//        }

        var vm = this;
        vm.deviceRequest = [];
        vm.getInputType = getInputType;
        vm.create = create;
        vm.applyMaroon = applyMaroon;
        vm.cancelCreate = cancelCreate;
        vm.resetRequest = resetRequest;
        vm.permissions = AuthService.getPermissions();
        vm.localTranslator = $filter('translate');
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ;
        vm.getDeviceStatusFromKey = getDeviceStatusFromKey;
        vm.getInstallationStatusIndex = getInstallationStatusIndex;
        vm.isDIStateTransitionValid = isDIStateTransitionValid;
        vm.getLang = getLang;
        vm.modal = null;
        vm.errors = {};
        vm.alerts = [];
        // vm.keyMap = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;
        vm.getErrMessageOfStatus = getErrMessageOfStatus;
        vm.getErrMessageDO = getErrMessageDO;
        vm.hotTable = null;
        vm.disableActionButtons = true;
        vm.disableResetButton = false;
        vm.downloadDeviceRequestExcel = downloadDeviceRequestExcel;
        vm.downloadJescaCsv = downloadJescaCsv;
        vm.downloadJescaCsvResult = downloadJescaCsvResult;
        vm.jescaActivationCsvDownload = jescaActivationCsvDownload;
        vm.uploadJescaCsv = uploadJescaCsv;
        vm.isMerchantAdmin = baUtil.isMerchantAdmin();
        vm.isDeviceOwnerAdmin = baUtil.isDeviceOwnerAdmin();

        // map of {SCId: isUserDeviceOwnerOfSC} to disallow edit of device owner by another device owner
        vm.isUserDeviceOwnerOfSC = {};

        vm.canEditInStatus = vm.isSystemUser ?
                                [ "DRAFT", "REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INVENTORY"] :
                                [ "DRAFT" ];
        vm.merchantAdminCanEditInStatus = ["REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INSTALLED", "RUNNING", "INVENTORY"];

        vm.deviceOwnerCanEditInStatus = ["REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INSTALLED", "RUNNING", "INVENTORY"];

        vm.canPartiallyEditInStatus = vm.isSystemUser ? [ "INSTALLED", "RUNNING", "PROCESSING_SUSPENSION", "SUSPENDED" ] : [ ];
        vm.readOnlyFieldsInPartiallyEditStatus = [ "status", "branchName", "branchCode" ];
        vm.editableFieldsWhenMerchantAdmin = [ "branchDepartment", "branchDesignation", "branchPersonInCharge", "branchPersonInChargePhone",  "branchPersonInChargeEmail", "vendingMachineModel", "remarks1", "remarks2", "remarks3", "remarks4", "remarks5" ];
        vm.editableFieldsWhenDeviceOwner = [  "branchDepartment", "branchDesignation", "branchPersonInCharge", "branchPersonInChargePhone",  "branchPersonInChargeEmail","vendingMachineModel", "remarks1", "remarks2", "remarks3", "remarks4", "remarks5" ];

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }


        vm.abc = {
            "key":[1,2,3],
            "en":[1,2,3],
            "jp":[1,2,3]
        };

//        vm.abc = {
//            "key":["1","2","3"],
//            "en":["1","2","3"],
//            "jp":["1","2","3"]
//        };
        if (!baUtil.isUndefinedOrNullOrEmpty($stateParams.deviceInstallation) && !baUtil.isUndefinedOrNullOrEmptyObject($stateParams.deviceInstallation.data.data) && ($stateParams.deviceInstallation.status >= 200 && $stateParams.deviceInstallation.status <= 299)) {
            vm.deviceRequest = $stateParams.deviceInstallation.data.data;
            vm.disableResetButton = $stateParams.resetButtonStatus;
            vm.disableActionButtons = false
            }
//            .deviceInstallationRequests.sort(function (a, b) { return b.dateCreated - a.dateCreated });
            //vm.KeyMap = DeviceRequestUtilService.getKeys(vm.KeyMap, "2.0");
            //vm.types.deviceOwner = $stateParams.deviceInstallation.data.data.deviceOwners;
            //vm.KeyMap.deviceOwnerId.type = "Dropdown";
            //vm.KeyMap.deviceOwnerId.readOnly = false;
//            vm.orgId = AuthService.getOrgId();
//            if (vm.orgId && vm.orgId != "" && !baUtil.isMerchant()) {
//                Object.keys(vm.types.deviceOwner).forEach(function(d){
//                    if(vm.types.deviceOwner[d].key.indexOf(vm.orgId) != -1 ) {
//                        vm.isUserDeviceOwnerOfSC[d] = true;
//                    }
//                });
//            }
//        }

        function init() {

            vm.KeyMap ={

                ifVersion: {
                              en: "IF Version",
                              jp: "IFバージョン",
                              id: 1,
                              inUse: true,
                              isDeleted: false,
                              name: "ifVersion",
                              order: 1,
                              readOnly: false,
                              type: "String",
                              validators: ["required", "stringLength_5", "stringAlphanumeric"]

                         },
                         schemeType: {
                              en: "Scheme type",
                              jp: "スキーム種別",
                              id: 2,
                              inUse: true,
                              isDeleted: false,
                              name: "schemeType",
                              order: 2,
                              readOnly: false,
                              type: "String",
                              validators: ["required", "stringLength_1", "stringAlphanumeric"]

                         },
                         centerContractCode: {
                              en: "Center Contract Code",
                              jp: "センタ契約者コード",
                              id: 3,
                              inUse: true,
                              isDeleted: false,
                              name: "centerContractCode",
                              order: 3,
                              readOnly: false,
                              type: "String",
                              validators: ["required", "stringLength_3", "stringAlphanumeric"]

                         },
                         allowedValuesProcessingCategory: {
                              en: "Processing Category",
                              jp: "処理区分",
                              id: 4,
                              inUse: true,
                              isDeleted: false,
                              name: "allowedValuesProcessingCategory",
                              order: 4,
                              readOnly: false,
                              type: "Dropdown",
                              validators: []

                         },
                         applicationSerialNumber : {
                              en: "Application Serial Number",
                              jp: "申込通番",
                              id: 5,
                              inUse: true,
                              isDeleted: false,
                              name: "applicationSerialNumber",
                              order: 5,
                              readOnly: true,
                              type: "String",
                              validators: []

                         },
                         uniqueId: {
                              en: "Unique ID",
                              jp: "ユニークID",
                              id: 6,
                              inUse: true,
                              isDeleted: false,
                              name: "uniqueId",
                              order: 6,
                              readOnly: true,
                              type: "String",
                              validators: []

                         },
                         reflectionDate: {
                              en: "Reflection Date",
                              jp: "反映日",
                              id: 7,
                              inUse: true,
                              isDeleted: false,
                              name: "reflectionDate",
                              order: 7,
                              readOnly: false,
                              type: "Date",
                              validators: ["required","stringDate"]

                         },
                         caseCode : {
                              en: "Case code",
                              jp: "案件コード",
                              id: 8,
                              inUse: true,
                              isDeleted: false,
                              name: "caseCode",
                              order: 8,
                              readOnly: false,
                              type: "String",
                              validators: ["required", "stringLength_5", "stringAlphanumeric"]

                         },
                         merchantName : {
                              en: "Merchant Name",
                              jp: "導入先法人名",
                              id: 9,
                              inUse: true,
                              isDeleted: false,
                              name: "merchantName",
                              order: 9,
                              readOnly: false,
                              type: "String",
                              validators: ["required","stringLength_25" ,"stringFullWidth"]

                         },
                         storeZipCode : {
                              en: "Store Zip Code",
                              jp: "店舗郵便番号",
                              id: 10,
                              inUse: true,
                              isDeleted: false,
                              name: "storeZipCode",
                              order: 10,
                              readOnly: false,
                              type: "String",
                              validators: ["required","stringLength_7" ,"numeric"]

                         },
                         storeAddress : {
                              en: "Store address",
                              jp: "店舗住所",
                              id: 11,
                              inUse: true,
                              isDeleted: false,
                              name: "storeAddress",
                              order: 11,
                              readOnly: false,
                              type: "String",
                              validators: ["required" , "stringLength_50" ,"stringFullWidth"]

                         },
                         storeNameKana:  {
                              en: "Store name Kana",
                              jp: "店舗名カナ",
                              id: 12,
                              inUse: true,
                              isDeleted: false,
                              name: "storeNameKana",
                              order: 12,
                              readOnly: false,
                              type: "String",
                              validators: ["required", "stringLength_30" ,"stringHalfWidth"]

                         },
                         storeName : {
                              en: "Store name",
                              jp: "店舗名",
                              id: 13,
                              inUse: true,
                              isDeleted: false,
                              name: "storeName",
                              order: 13,
                              readOnly: false,
                              type: "String",
                              validators: ["required" , "stringLength_25" ,"stringFullWidth"]

                         },
                         storeContactPerson :   {
                              en: "Store Contact Person",
                              jp: "店舗担当者",
                              id: 14,
                              inUse: true,
                              isDeleted: false,
                              name: "storeContactPerson",
                              order: 14,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringFullWidth"]

                         },
                         storeContactPhoneNumber : {
                              en: "Store contact phone number",
                              jp: "店舗連絡先電話番号",
                              id: 15,
                              inUse: true,
                              isDeleted: false,
                              name: "storeContactPhoneNumber",
                              order: 15,
                              readOnly: false,
                              type: "String",
                              validators: ["required","stringLength_11" ,"numeric"]

                         },
                         industryCode:  {
                              en: "Industry Code",
                              jp: "業種コード",
                              id: 16,
                              inUse: true,
                              isDeleted: false,
                              name: "industryCode",
                              order: 16,
                              readOnly: false,
                              type: "String",
                              validators: ["required","stringLength_1" ,"numericOneToFive"]

                         },
                         installationCompanyName :  {
                              en: "Installation company name",
                              jp: "設置会社名",
                              id: 17,
                              inUse: true,
                              isDeleted: false,
                              name: "installationCompanyName",
                              order: 17,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLengthFullHalf_60"]

                         },
                         mainUnitManufacturer : {
                              en: "Main unit manufacturer",
                              jp: "本体メーカー",
                              id: 18,
                              inUse: true,
                              isDeleted: false,
                              name: "mainUnitManufacturer",
                              order: 18,
                              readOnly: false,
                              type: "String",
                              validators: ["required", "stringLength_2", "stringAlphanumeric"]

                         },
                         mainUnitModelNumber : {
                              en: "Main unit model number",
                              jp: "本体型番",
                              id: 19,
                              inUse: true,
                              isDeleted: false,
                              name: "mainUnitModelNumber",
                              order: 19,
                              readOnly: false,
                              type: "String",
                              validators: ["required", "stringLength_2", "stringAlphanumeric"]

                         },
                         mainUnitTerminalNumber :  {
                              en: "Main unit terminal number",
                              jp: "本体端末番号",
                              id: 20,
                              inUse: true,
                              isDeleted: false,
                              name: "mainUnitTerminalNumber",
                              order: 20,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20", "stringAlphanumeric"]

                         },
                         posLinkage : {
                              en: "POS linkage",
                              jp: "POS連動有無",
                              id: 21,
                              inUse: true,
                              isDeleted: false,
                              name: "posLinkage",
                              order: 21,
                              readOnly: false,
                              type: "String",
                              validators: ["required","stringLength_1" ,"numericZeroToOne"]

                         },
                         operationType : {
                              en: "Operation type",
                              jp: "操作タイプ",
                              id: 22,
                              inUse: true,
                              isDeleted: false,
                              name: "operationType",
                              order: 22,
                              readOnly: false,
                              type: "String",
                              validators:["required","stringLength_1" ,"numericZeroToOne"]

                         },
                         activateId : {
                              en: "Activate ID",
                              jp: "アクティベートID",
                              id: 23,
                              inUse: true,
                              isDeleted: false,
                              name: "activateId",
                              order: 23,
                              readOnly: true,
                              type: "String",
                              validators: ["stringLength_20", "stringAlphanumeric"]

                         },
                         activationPassword : {
                              en: "Activation password",
                              jp: "アクティベートパスワード",
                              id: 24,
                              inUse: true,
                              isDeleted: false,
                              name: "activationPassword",
                              order: 24,
                              readOnly: true,
                              type: "String",
                              validators: ["stringLength_10", "stringAlphanumeric"]

                         },
                         enableTrafficIC :  {
                              en: "Traffic IC Yes/No",
                              jp: "交通系IC有無",
                              id: 25,
                              inUse: true,
                              isDeleted: false,
                              name: "enableTrafficIC",
                              order: 25,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         tkid :  {
                              en: "T_KID",
                              jp: "交_KID",
                              id: 26,
                              inUse: true,
                              isDeleted: false,
                              name: "tkid",
                              order: 26,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         talternateSPRWID :  {
                              en: "T_Alternate_SPRWID",
                              jp: "交_SPRWID",
                              id: 27,
                              inUse: true,
                              isDeleted: false,
                              name: "talternateSPRWID",
                              order: 27,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13", "stringAlphanumeric"]

                         },
                         ttid :  {
                              en: "T_TID",
                              jp: "交_TID",
                              id: 28,
                              inUse: true,
                              isDeleted: false,
                              name: "ttid",
                              order: 28,
                              readOnly: false,
                              type: "Number",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         tbusinessCode :  {
                              en: "T_Business Code",
                              jp: "交_事業者コード",
                              id: 29,
                              inUse: true,
                              isDeleted: false,
                              name: "tbusinessCode",
                              order: 29,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_2", "stringAlphanumeric"]

                         },
                         tmerchantNumber :   {
                              en: "T_Merchant Number",
                              jp: "交_加盟店番号",
                              id: 30,
                              inUse: true,
                              isDeleted: false,
                              name: "tmerchantNumber",
                              order: 30,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         tmerchantName :    {
                              en: "T_Merchant Name",
                              jp: "交_加盟店名称",
                              id: 31,
                              inUse: true,
                              isDeleted: false,
                              name: "tmerchantName",
                              order: 31,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         tpayeeCode :   {
                              en: "T_Payee Code",
                              jp: "交_精算先コード",
                              id: 32,
                              inUse: true,
                              isDeleted: false,
                              name: "tpayeeCode",
                              order: 32,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"numeric"]

                         },
                         tdeviceDataPattern : {
                              en: "T_Terminal Data Pattern",
                              jp: "交_端末データパターン",
                              id: 33,
                              inUse: true,
                              isDeleted: false,
                              name: "tdeviceDataPattern",
                              order: 33,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         treturnDataProviderID : {
                              en: "T_Redemption data provider ID",
                              jp: "交_還元データ提供先ID",
                              id: 34,
                              inUse: true,
                              isDeleted: false,
                              name: "treturnDataProviderID",
                              order: 34,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableQUICPay :  {
                              en: "QUICPay Yes/No",
                              jp: "QUICPay有無",
                              id: 35,
                              inUse: true,
                              isDeleted: false,
                              name: "enableQUICPay",
                              order: 35,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         quicPayOptionQKID :   {
                              en: "QUICPay Option",
                              jp: "QUICPayオプション",
                              id: 36,
                              inUse: true,
                              isDeleted: false,
                              name: "quicPayOptionQKID",
                              order: 36,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericOneToTwo"]

                         },
                         qkid :    {
                              en: "Q_KID",
                              jp: "Q_KID",
                              id: 37,
                              inUse: true,
                              isDeleted: false,
                              name: "qkid",
                              order: 37,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         qtid :       {
                              en: "Q_TID",
                              jp: "Q_TID",
                              id: 38,
                              inUse: true,
                              isDeleted: false,
                              name: "qtid",
                              order: 38,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         qmerchantNumber :   {
                              en: "Q_Merchant Number",
                              jp: "Q_加盟店番号",
                              id: 39,
                              inUse: true,
                              isDeleted: false,
                              name: "qmerchantNumber",
                              order: 39,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumeric","stringHalfWidth"]

                         },
                         qmerchantName :  {
                              en: "Q_Merchant Name",
                              jp: "Q_加盟店名称",
                              id: 40,
                              inUse: true,
                              isDeleted: false,
                              name: "qmerchantName",
                              order: 40,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         qmanualCancellationInputAccepted :     {
                              en: "Q_Manual Cancellation Input Accepted",
                              jp: "Q_マニュアル取消入力可否",
                              id: 41,
                              inUse: true,
                              isDeleted: false,
                              name: "qmanualCancellationInputAccepted",
                              order: 41,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         qpartialReturnEntryPermitted :  {
                              en: "Q_Partial Return Entry Permitted",
                              jp: "Q_一部返品入力可否",
                              id: 42,
                              inUse: true,
                              isDeleted: false,
                              name: "qpartialReturnEntryPermitted",
                              order: 42,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         qdeviceDataPattern : {
                              en: "Q_Terminal data pattern",
                              jp: "Q_端末データパターン",
                              id: 43,
                              inUse: true,
                              isDeleted: false,
                              name: "qdeviceDataPattern",
                              order: 43,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         qreturnDataProviderId :  {
                              en: "Q_Return Data Provider ID",
                              jp: "Q_還元データ提供先ID",
                              id: 44,
                              inUse: true,
                              isDeleted: false,
                              name: "qreturnDataProviderId",
                              order: 44,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableId :   {
                              en: "iD Yes/No",
                              jp: "iD有無",
                              id: 45,
                              inUse: true,
                              isDeleted: false,
                              name: "enableId",
                              order: 45,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         ikid :    {
                              en: "I_KID",
                              jp: "I_KID",
                              id: 46,
                              inUse: true,
                              isDeleted: false,
                              name: "ikid",
                              order: 46,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         itid :   {
                              en: "I_TID",
                              jp: "I_TID",
                              id: 47,
                              inUse: true,
                              isDeleted: false,
                              name: "itid",
                              order: 47,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         imerchantNumber :  {
                              en: "I_Merchant Number",
                              jp: "I_加盟店番号",
                              id: 48,
                              inUse: true,
                              isDeleted: false,
                              name: "imerchantNumber",
                              order: 48,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumeric","stringHalfWidth"]

                         },
                         imerchantName :  {
                              en: "I_Merchant Name",
                              jp: "I_加盟店名称",
                              id: 49,
                              inUse: true,
                              isDeleted: false,
                              name: "imerchantName",
                              order: 49,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         iitemCodeRequired :   {
                              en: "I_ItemCodeRequired",
                              jp: "I_商品コード入力要否",
                              id: 50,
                              inUse: true,
                              isDeleted: false,
                              name: "iitemCodeRequired",
                              order: 50,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         imanualRejectRequired :  {
                              en: "I_Manual_Reject_Required",
                              jp: "I_マニュアル取消入力可否",
                              id: 51,
                              inUse: true,
                              isDeleted: false,
                              name: "imanualRejectRequired",
                              order: 51,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         itaxOrOtherInputRequired :  {
                              en: "I_Tax/other input required",
                              jp: "I_税・その他入力要否",
                              id: 52,
                              inUse: true,
                              isDeleted: false,
                              name: "itaxOrOtherInputRequired",
                              order: 52,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         ienquiryRequired :   {
                              en: "I_Enquiry_Required",
                              jp: "I_照会業務入力可否",
                              id: 53,
                              inUse: true,
                              isDeleted: false,
                              name: "ienquiryRequired",
                              order: 53,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         ideviceDataPattern :  {
                              en: "I_terminal data pattern",
                              jp: "I_端末データパターン",
                              id: 54,
                              inUse: true,
                              isDeleted: false,
                              name: "ideviceDataPattern",
                              order: 54,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         ireturnDataProviderId :  {
                              en: "I_reduction data supplier ID",
                              jp: "I_還元データ提供先ID",
                              id: 55,
                              inUse: true,
                              isDeleted: false,
                              name: "ireturnDataProviderId",
                              order: 55,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableEdy :      {
                              en: "Edy Yes/No",
                              jp: "Edy有無",
                              id: 56,
                              inUse: true,
                              isDeleted: false,
                              name: "enableEdy",
                              order: 56,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         ekid : {
                              en: "E_KID",
                              jp: "E_KID",
                              id: 57,
                              inUse: true,
                              isDeleted: false,
                              name: "ekid",
                              order: 57,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         ehigherLevelTerminalId :  {
                              en: "E_Higher level terminal ID",
                              jp: "E_上位端末ID",
                              id: 58,
                              inUse: true,
                              isDeleted: false,
                              name: "ehigherLevelTerminalId",
                              order: 58,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         eemid : {
                              en: "E_EM-ID",
                              jp: "E_EM-ID",
                              id: 59,
                              inUse: true,
                              isDeleted: false,
                              name: "eemid",
                              order: 59,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         ehwidm : {
                              en: "E_HW-idm",
                              jp: "E_HW-idm",
                              id: 60,
                              inUse: true,
                              isDeleted: false,
                              name: "ehwidm",
                              order: 60,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_16", "stringAlphanumeric"]

                         },
                         etid : {
                              en: "E_TID",
                              jp: "E_TID",
                              id: 61,
                              inUse: true,
                              isDeleted: false,
                              name: "etid",
                              order: 61,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         emerchantNumber :  {
                              en: "E_Merchant Number",
                              jp: "E_加盟店番号",
                              id: 62,
                              inUse: true,
                              isDeleted: false,
                              name: "emerchantNumber",
                              order: 62,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         emerchantName : {
                              en: "E_Merchant Name",
                              jp: "E_加盟店名称",
                              id: 63,
                              inUse: true,
                              isDeleted: false,
                              name: "emerchantName",
                              order: 63,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         eedyMerchantId : {
                              en: "E_Edy Merchant ID",
                              jp: "E_Edy加盟店ID",
                              id: 64,
                              inUse: true,
                              isDeleted: false,
                              name: "eedyMerchantId",
                              order: 64,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         e_10JPYRoundingRequired :   {
                              en: "E_10_Yen_Rounding required",
                              jp: "E_10円丸め要否",
                              id: 65,
                              inUse: true,
                              isDeleted: false,
                              name: "e_10JPYRoundingRequired",
                              order: 65,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         eterminalUseClassification :    {
                              en: "E_Terminal use classification",
                              jp: "E_端末用途区分",
                              id: 66,
                              inUse: true,
                              isDeleted: false,
                              name: "eterminalUseClassification",
                              order: 66,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericOneToThree"]

                         },
                         edeviceDataPattern :      {
                              en: "E_terminal data pattern",
                              jp: "E_端末データパターン",
                              id: 67,
                              inUse: true,
                              isDeleted: false,
                              name: "edeviceDataPattern",
                              order: 67,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         ereturnDataProviderId : {
                              en: "E_redemption data provider ID",
                              jp: "E_還元データ提供先ID",
                              id: 68,
                              inUse: true,
                              isDeleted: false,
                              name: "ereturnDataProviderId",
                              order: 68,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableWAON :   {
                              en: "WAON Yes/No",
                              jp: "WAON有無",
                              id: 69,
                              inUse: true,
                              isDeleted: false,
                              name: "enableWAON",
                              order: 69,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         wkid :  {
                              en: "W_KID",
                              jp: "W_KID",
                              id: 70,
                              inUse: true,
                              isDeleted: false,
                              name: "wkid",
                              order: 70,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         wsprwid : {
                              en: "W_SPRWID",
                              jp: "W_SPRWID",
                              id: 71,
                              inUse: true,
                              isDeleted: false,
                              name: "wsprwid",
                              order: 71,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_13", "stringAlphanumeric"]

                         },
                         wmerchantCategoryCode :     {
                              en: "W_Merchant Category Code",
                              jp: "W_加盟店区分コード",
                              id: 72,
                              inUse: true,
                              isDeleted: false,
                              name: "wmerchantCategoryCode",
                              order: 72,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_2", "stringAlphanumeric"]

                         },
                         wcompanyCode :  {
                              en: "W_Company Code",
                              jp: "W_会社コード",
                              id: 73,
                              inUse: true,
                              isDeleted: false,
                              name: "wcompanyCode",
                              order: 73,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_4", "stringAlphanumeric"]

                         },
                         wtid :   {
                              en: "W_TID",
                              jp: "W_TID",
                              id: 74,
                              inUse: true,
                              isDeleted: false,
                              name: "wtid",
                              order: 74,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         wmerchantNumber :    {
                              en: "W_Merchant Number",
                              jp: "W_加盟店番号",
                              id: 75,
                              inUse: true,
                              isDeleted: false,
                              name: "wmerchantNumber",
                              order: 75,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         wmerchantName : {
                              en: "W_Merchant Name",
                              jp: "W_加盟店名称",
                              id: 76,
                              inUse: true,
                              isDeleted: false,
                              name: "wmerchantName",
                              order: 76,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         wwhetherToCancel :   {
                              en: "W_Whether to cancel",
                              jp: "W_取消実施可否",
                              id: 77,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherToCancel",
                              order: 77,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherCashChargeIsAllowed :  {
                              en: "W_Whether cash charge is allowed",
                              jp: "W_現金チャージ実施可否",
                              id: 78,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherCashChargeIsAllowed",
                              order: 78,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherCashChargeCanBeCancelled :  {
                              en: "W_Whether cash charge can be cancelled",
                              jp: "W_現金チャージ取消実施可否",
                              id: 79,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherCashChargeCanBeCancelled",
                              order: 79,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherPointChargeIsAllowed :   {
                              en: "W_Whether point charge is allowed",
                              jp: "W_ポイントチャージ実施可否",
                              id: 80,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherPointChargeIsAllowed",
                              order: 80,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherAutoChargeIsAllowed :   {
                              en: "W_Whether auto charge is allowed",
                              jp: "W_オートチャージ可否",
                              id: 81,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherAutoChargeIsAllowed",
                              order: 81,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherToCancelAnotherTerminal : {
                              en: "W_Whether to cancel another terminal",
                              jp: "W_別端末取消可否",
                              id: 82,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherToCancelAnotherTerminal",
                              order: 82,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wreturnPolicy :   {
                              en: "W_Return policy",
                              jp: "W_返品可否",
                              id: 83,
                              inUse: true,
                              isDeleted: false,
                              name: "wreturnPolicy",
                              order: 83,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wpointAssignmentPattern : {
                              en: "W_Point assignment pattern",
                              jp: "W_ポイント付与パターン",
                              id: 84,
                              inUse: true,
                              isDeleted: false,
                              name: "wpointAssignmentPattern",
                              order: 84,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         wdeviceDataPattern :   {
                              en: "W_Terminal data pattern",
                              jp: "W_端末データパターン",
                              id: 85,
                              inUse: true,
                              isDeleted: false,
                              name: "wdeviceDataPattern",
                              order: 85,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         wreturnDataProviderId :    {
                              en: "W_redemption data provider ID",
                              jp: "W_還元データ提供先ID",
                              id: 86,
                              inUse: true,
                              isDeleted: false,
                              name: "wreturnDataProviderId",
                              order: 86,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableNanaco :   {
                              en: "nanaco Yes/No",
                              jp: "nanaco有無",
                              id: 87,
                              inUse: true,
                              isDeleted: false,
                              name: "enableNanaco",
                              order: 87,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         nkid :    {
                              en: "N_KID",
                              jp: "N_KID",
                              id: 88,
                              inUse: true,
                              isDeleted: false,
                              name: "nkid",
                              order: 88,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         nhigherTerminalId9Digits : {
                              en: "N_Higher terminal ID_9 digits",
                              jp: "N_上位端末ID_9桁",
                              id: 89,
                              inUse: true,
                              isDeleted: false,
                              name: "nhigherTerminalId9Digits",
                              order: 89,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_9", "stringAlphanumeric"]

                         },
                         nhigherLevelTerminalId : {
                              en: "N_Higher level terminal ID",
                              jp: "N_上位端末ID",
                              id: 90,
                              inUse: true,
                              isDeleted: false,
                              name: "nhigherLevelTerminalId",
                              order: 90,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_20", "stringAlphanumeric"]

                         },
                         ntid :  {
                              en: "N_TID",
                              jp: "N_TID",
                              id: 91,
                              inUse: true,
                              isDeleted: false,
                              name: "ntid",
                              order: 91,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         nmerchantNumber :    {
                              en: "N_Merchant Number",
                              jp: "N_加盟店番号",
                              id: 92,
                              inUse: true,
                              isDeleted: false,
                              name: "nmerchantNumber",
                              order: 92,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         nnameOfMerchant :  {
                              en: "N_Merchant Name",
                              jp: "N_加盟店名称",
                              id: 93,
                              inUse: true,
                              isDeleted: false,
                              name: "nnameOfMerchant",
                              order: 93,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         ncashChargeAcceptance :  {
                              en: "N_Cash Charge Acceptance",
                              jp: "N_現金チャージ可否",
                              id: 94,
                              inUse: true,
                              isDeleted: false,
                              name: "ncashChargeAcceptance",
                              order: 94,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         ndeviceDataPattern :  {
                              en: "N_terminal data pattern",
                              jp: "N_端末データパターン",
                              id: 95,
                              inUse: true,
                              isDeleted: false,
                              name: "ndeviceDataPattern",
                              order: 95,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         nreturnDataProviderId :  {
                              en: "N_reduction data provider ID",
                              jp: "N_還元データ提供先ID",
                              id: 96,
                              inUse: true,
                              isDeleted: false,
                              name: "nreturnDataProviderId",
                              order: 96,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enablePiTaPa :  {
                              en: "PiTaPa Yes/No",
                              jp: "PiTaPa有無",
                              id: 97,
                              inUse: true,
                              isDeleted: false,
                              name: "enablePiTaPa",
                              order: 97,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         pkid :    {
                              en: "P_KID",
                              jp: "P_KID",
                              id: 98,
                              inUse: true,
                              isDeleted: false,
                              name: "pkid",
                              order: 98,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         ppiTaPaTID :     {
                              en: "P_PiTaPa-TID",
                              jp: "P_PiTaPa-TID",
                              id: 99,
                              inUse: true,
                              isDeleted: false,
                              name: "ppiTaPaTID",
                              order: 99,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_13", "stringAlphanumeric"]

                         },
                         ptid :   {
                              en: "P_TID",
                              jp: "P_TID",
                              id: 100,
                              inUse: true,
                              isDeleted: false,
                              name: "ptid",
                              order: 100,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         pmerchantNumber :  {
                              en: "P_Merchant Number",
                              jp: "P_加盟店番号",
                              id: 101,
                              inUse: true,
                              isDeleted: false,
                              name: "pmerchantNumber",
                              order: 101,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         pmerchantName : {
                              en: "P_Merchant Name",
                              jp: "P_加盟店名称",
                              id: 102,
                              inUse: true,
                              isDeleted: false,
                              name: "pmerchantName",
                              order: 102,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         preturnBusinessAvailability :   {
                              en: "P_Return business availability",
                              jp: "P_返品業務可否",
                              id: 103,
                              inUse: true,
                              isDeleted: false,
                              name: "preturnBusinessAvailability",
                              order: 103,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         pdeviceDataPattern :   {
                              en: "P_Terminal data pattern",
                              jp: "P_端末データパターン",
                              id: 104,
                              inUse: true,
                              isDeleted: false,
                              name: "pdeviceDataPattern",
                              order: 104,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         preturnDataProviderId : {
                              en: "P_Return Data Provider ID",
                              jp: "P_還元データ提供先ID",
                              id: 105,
                              inUse: true,
                              isDeleted: false,
                              name: "preturnDataProviderId",
                              order: 105,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         }
                        };
            vm.tableData = [];
            vm.tableOptions = {};
            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                fixedColumnsLeft: 6,
                licenseKey: 'non-commercial-and-evaluation',
                modifyColWidth: function(width, col) {
//                return 150;
//                    if(col === 3 || col === 5) {
//                        return 300;
//                    }else if (col === 1 || col === 4){
//                        return 300;
//                    } else if(width > 500) return 500;
                },
                afterValidate: function (isValid, value, row, prop, source) {
                    // custom validation for device installaiton status
                    if(prop === "status") {
                        var index = vm.types.DeviceInstallationStatus.en.indexOf(value);
                        if (index < 0) {
                            index = vm.types.DeviceInstallationStatus.jp.indexOf(value);
                        }
                        var indexValue = index === -1 ? value : vm.types.DeviceInstallationStatus.key[index];

                        if(vm.isDIStateTransitionValid(vm.deviceRequest[row]['status'], indexValue)) {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                        else {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageOfStatus(
                                row+1,
                                vm.deviceRequest[row]['applicationNumber'],
                                vm.deviceRequest[row]['status'],
                                indexValue
                            );
                            return false;
                        }
                    }

                    

                    // custom validation for device owner
//                    if(prop === "deviceOwnerId") {
//                        if(baUtil.isUndefinedOrNullOrEmpty(value)) {
//                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId");
//                            return false;
//                        }
//                        else if( vm.types.deviceOwner[ vm.deviceRequest[row]["serviceContractId"] ][$translate.use()].indexOf(value) === -1 ) {
//                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId", true);
//                            return false;
//                        }
//                        else {
//                            delete vm.errors[ row + "_" + prop ];
//                            return true;
//                        }
//                    }

//                    if(prop === "paymentHandlingOption_TRANSPORT") {
//                        if(baUtil.isUndefinedOrNullOrEmpty(value) ||
//                         vm.types.TransportPaymentOptions[$translate.use()].indexOf(value) === -1 ) {
//                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "paymentHandlingOption_TRANSPORT", true);
//                            return false;
//                        }
//                        else {
//                            delete vm.errors[ row + "_" + prop ];
//                            return true;
//                        }
//                    }

                    // common use validator
                    
                    if(!vm.KeyMap[prop]['validators']) {
                        console.log(vm.KeyMap[prop]);

                    }
                   if ( !vm.KeyMap[prop]["readOnly"] && vm.KeyMap[prop]['validators'].length ) {
                       var msg = hotUtil.aggregatedValidator(vm.KeyMap[prop]['validators'], value, row, vm.KeyMap[prop][vm.getLang()]);

                       if( msg != "" ) {
                           vm.errors[ row + "_" + prop ] = msg;
                           return false;
                       }
                       else {
                           delete vm.errors[ row + "_" + prop ];
                           return true;
                       }
                   }

                   if(isValid) {
                       delete vm.errors[ row + "_" + prop ];
                   }
                   else {
                       vm.errors[ row + "_" + prop ] = value;
                   }

                }
            };

            // disable rows if the device status is not DRAFT or REGISTERED
            //    for users which don't have permissions
            //    when status is cancelled
            //    ALSO >> customise device owners for different SC's DIs
            vm.tableSettings.cells = function (row, col, prop) {
                var cellMeta = {};
//                if(prop === "deviceSerial" || prop === "companyName" || prop === "applicationNumber" || prop === "deviceOwnerId") {
//                    cellMeta.className = 'word-break';
//                }
//                if( prop === "deviceOwnerId" ) {
//                    cellMeta.source = vm.types.deviceOwner[ vm.deviceRequest[row]["serviceContractId"] ][$translate.use()];
//                }
                if(!baUtil.isUndefinedOrNullOrEmpty(vm.tableData[row])) {
                    if( vm.tableData[row].readOnly || vm.tableData[row][ prop + "_readOnly" ] ) {
                        cellMeta.readOnly = true;
                    }
                }
                return  cellMeta;
            };
            vm.deviceRequest.forEach(function (item, index) {
                var obj = {};

                var keys = Object.keys(item).filter(function (k) { return k !== 'paymentHandlingOptions' })
                keys.forEach(function (field) {
                    var value = item[field];
                    obj[field] = value;
                    if (field === 'date' || field == 'reflectionDate') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                    }
//                    else if (field === 'deviceOwnerId') {
//                        if(baUtil.isUndefinedOrNullOrEmptyObject(value)) {
//                            obj['deviceOwnerId'] =  "";
//                        }
//                        else {
//                            var index = vm.types.deviceOwner[item.serviceContractId].key.indexOf(value);
//                            obj['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId][$translate.use()][index];
//                        }
//                    }
//                    else if (field === 'allowedValuesProcessingCategory') {
//                        var index = vm.abc.key.indexOf(value);
//                        obj[field] = vm.abc[$translate.use()][index];
//                    }
//                    else if (field === 'type') {
//                        var index = vm.types.DeviceInstallationType.key.indexOf(value);
//                        obj[field] = vm.types.DeviceInstallationType[$translate.use()][index];
//                    }
//                    else if (field === 'vendingMachineModel') {
//                        item.paymentHandlingOptions.forEach(function (k, i) {
//                            obj['paymentHandlingOption_' + k] = true
//                        });
//
//                        obj['paymentHandlingOption_TRANSPORT'] = DeviceRequestUtilService.getTransportPaymentOptionTextFromKey(
//                            vm.types.TransportPaymentOptions,
//                            item['transportPaymentHandlingOption'],
//                            item['paymentHandlingOptions']
//                        );
//
//                        obj[field] = value;
//                    }
//                    else {
//                        obj[field] = value;
//                    }
//
//
                })
//
//
//                // for merchant admin - allow edit of vending maching model and remarks 1-5
//                if( vm.isMerchantAdmin && vm.merchantAdminCanEditInStatus.indexOf(item['status'] || "") !== -1) {
//                    obj.readOnly = false;
//                    vm.disableActionButtons = false;
//                    Object.keys(obj).forEach(function (field) {
//                        if(vm.editableFieldsWhenMerchantAdmin.indexOf(field)===-1) {
//                            obj[ field + "_readOnly" ] = true;
//                        }
//                    });
//                    vm.types.PaymentHandlingOption.E_MONEY.key.forEach(function (key) {
//                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
//                    });
//                    vm.types.PaymentHandlingOption.QR_MONEY.key.forEach(function (key) {
//                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
//                    });
//                }
//                else if( vm.isDeviceOwnerAdmin && vm.deviceOwnerCanEditInStatus.indexOf(item['status'] || "") !== -1) {
//                    obj.readOnly = false;
//                    vm.disableActionButtons = false;
//                    Object.keys(obj).forEach(function (field) {
//                        if(vm.editableFieldsWhenDeviceOwner.indexOf(field)===-1) {
//                            obj[ field + "_readOnly" ] = true;
//                        }
//                    });
//                    vm.types.PaymentHandlingOption.E_MONEY.key.forEach(function (key) {
//                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
//                    });
//                    vm.types.PaymentHandlingOption.QR_MONEY.key.forEach(function (key) {
//                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
//                    });
//                }
//                else if (
//                    vm.canEditInStatus.indexOf(item.status) !== -1 &&
//                    vm.permissions.DEVICE_REQUEST.WRITE
//                ) {
//                    obj.readOnly = false;
//                    vm.disableActionButtons = false;
//                }
//                else if(
//                    vm.canPartiallyEditInStatus.indexOf(item.status) !== -1 &&
//                    vm.permissions.DEVICE_REQUEST.WRITE
//                ) {
//                    obj.readOnly = false;
//                    vm.disableActionButtons = false;
//                    vm.readOnlyFieldsInPartiallyEditStatus.forEach(function(key){
//                        obj[ key + "_readOnly" ] = true;
//                    });
//                }
//                else {
//                    obj.readOnly = true;
//                }
//
//                if( vm.isUserDeviceOwnerOfSC[item.serviceContractId] ) {
//                    obj["deviceOwnerId_readOnly"] = true;
//                }
//
                if(item.allowedValuesProcessingCategory == 1) {
                    obj["allowedValuesProcessingCategory_readOnly"] = true;
                }

                if( item.changeApplicable == 1 ) {
                    obj.readOnly = true;
                    vm.disableActionButtons = true;
                }
                vm.tableData.push(obj);
            });
            var keyMap = vm.KeyMap
            var optionKeys = Object.keys(keyMap).sort(function (a, b) {
                return keyMap[a].order - keyMap[b].order;
            });

            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: value.name,
                    readOnly: value.readOnly
                }

                if(field == 'status' && !vm.isSystemUser) {
                    col.readOnly = true;
                }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = [2,3]
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

//                if ( !vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'].length ) {
                if ( !vm.KeyMap[field]["readOnly"] ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);

            })


            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsontable-request-detail');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }
        if(!baUtil.isUndefinedOrNullOrEmpty($stateParams.deviceInstallation) && !baUtil.isUndefinedOrNullOrEmptyObject($stateParams.deviceInstallation.data.data)){
            init();
        }
//
        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        function cancelCreate() {
            $state.go("main.deviceRequest.list");
        }

        function resetRequest(){

            var title = vm.localTranslator("device.request.jesca.reset.title");
            var message = vm.localTranslator("device.request.jesca.reset.message");
            var btnText = vm.localTranslator("device.request.jesca.reset.btn.text");

            baUtil.showConfirm(title, message, btnText)
            .then(function() {

            if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest)){
                var keys = vm.deviceRequest.map(function(i){
                    return i.applicationSerialNumber;
                });
            }
            else {
                var keys = [];
            }
            DeviceRequestService
            .getResetJescaRequest(keys)
            .then(function success(response) {
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                  );
                $state.go("main.deviceRequest.list");
            }, function err(err) {
                vm.isBulkEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                $state.go("main.deviceRequest.list");
            });
        } 
        )}

        function getInputType(type) {
           switch (type) {
               case 'String':
                   return 'text'
               case 'Checkbox':
                   return 'checkbox'
               case 'Date':
                   return 'date'
               case 'Dropdown':
                   return 'dropdown'
               default:
                return 'text'
           }
        }


        function getSource(key) {
            switch (key) {
                case 'status':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'type':
                    return vm.types.DeviceInstallationType[$translate.use()]
                case 'deviceOwnerId':
                    return []; // setting this in cells hook
                case 'paymentHandlingOption_TRANSPORT':
                    return vm.types.TransportPaymentOptions[$translate.use()]
                case 'allowedValuesProcessingCategory':
                    return vm.abc[$translate.use()]
                default:
                    return []
            }
        }

        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field){
            if( vm.fieldMetaData[field] ) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                /// return reqd otherwise
                return $translate.instant(
                    "err.msg.required.field",
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
        }

        function getErrMessageOfStatus(row, applicationNumber, from, to){
            return $translate.instant(
                "device.request.edit.err.msg.cannot.allow.state.transition",
                {
                    row: row,
                    id: applicationNumber,
                    from: vm.getDeviceStatusFromKey(from),
                    to: vm.getDeviceStatusFromKey(to)
                }
            );
        }

        function getErrMessageDO (row, field, isWrongInput) {
            return $translate.instant(
                isWrongInput ? "device.request.edit.err.msg.device.owner" : "device.request.edit.err.msg.required.field",
                { row: row, param: vm.KeyMap[field][vm.getLang()] }
            );
        }

        function getInstallationStatusIndex(status){
            var statusMap = {
                "DRAFT": 0,
                "REGISTERED": 1,
                "ACCEPTED": 2,
                "UNDER_FULFILMENT": 3,
                "COMPLETED": 4,
                "APPLICATION_CANCELLED": 5
            };
            if(Object.keys(statusMap).indexOf(status) === -1) {
                return null;
            }
            return statusMap[status]
        }

        function isDIStateTransitionValid(statusBefore, statusAfter) {

            // no change detected
            if(statusBefore == statusAfter) {
                return true;
            }

            // status shifted backwards
            else if (
                vm.getInstallationStatusIndex(statusBefore) != null &&
                vm.getInstallationStatusIndex(statusAfter) != null &&
                vm.getInstallationStatusIndex(statusBefore) > vm.getInstallationStatusIndex(statusAfter)
            ) {
                if(vm.isSystemUser) {
                    if(
                        (statusBefore == "ACCEPTED" && statusAfter == "REGISTERED") ||
                        (statusBefore == "UNDER_FULFILMENT" && statusAfter == "REGISTERED")
                    ) {
                        return true;
                    }
                }
                return false;
            }

            // status moving forward
            else {
                // for common permissions
                if(
                    (statusBefore == "DRAFT" && statusAfter == "REGISTERED") ||
                    (statusBefore == "REGISTERED" && statusAfter == "APPLICATION_CANCELLED")
                ) {
                    return true;
                }
                // for System User
                else if(vm.isSystemUser) {
                    if(
                        (statusBefore == "REGISTERED" && statusAfter == "ACCEPTED") ||
                        (
                            statusBefore == "ACCEPTED" &&
                            ["UNDER_FULFILMENT", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        ) ||
                        (
                            statusBefore == "UNDER_FULFILMENT" &&
                            ["COMPLETED", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        )
                    ) {
                        return true;
                    }
                }
                // otherwise
                return false;
            }
        }

        function getDeviceStatusFromKey(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);

            if(index === -1) return key;

            return ($translate.use() === "jp" ?
                    vm.types.DeviceInstallationStatus.jp[index] :
                    vm.types.DeviceInstallationStatus.en[index]);
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function downloadDeviceRequestExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest) ||
                vm.isDownloadingDIExcel == true
            ) {
                return false;
            }
            vm.isDownloadingDIExcel = true;
            var keys = vm.deviceRequest.map(function(i){
                return i.applicationNumber;
            });

            DeviceRequestService
            .downloadDeviceRequestExcel(keys)
            .then(function(resp) {
                vm.isDownloadingDIExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingDIExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function downloadJescaCsv() {
//            if (
//                baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest) ||
//                vm.isDownloadingDIExcel == true
//            ) {
//                return false;
//            }
            vm.isDownloadingJescaCsv = true;
            if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest)){
                var keys = vm.deviceRequest.map(function(i){
                    return i.applicationSerialNumber;
                });
            }
            else {
                var keys = [];
            }

            DeviceRequestService
            .downloadJescaCsv(keys)
            .then(function(resp) {
                vm.isDownloadingJescaCsv = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingJescaCsv = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }
        function downloadJescaCsvResult() {
//            if (
//                baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest) ||
//                vm.isDownloadingDIExcel == true
//            ) {
//                return false;
//            }
            vm.isDownloadingJescaCsvResult = true;
            if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest)){
                var keys = vm.deviceRequest.map(function(i){
                    return i.applicationSerialNumber;
                });
            }
            else {
                var keys = [];
            }

            DeviceRequestService
            .downloadJescaCsvResult(keys)
            .then(function(resp) {
                vm.isDownloadingJescaCsvResult = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingJescaCsvResult = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }



        function jescaActivationCsvDownload() {

            vm.isDownloadingJescaActivationCsv = true;
            if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest)){
                var keys = vm.deviceRequest.map(function(i){
                    return i.applicationSerialNumber;
                });
            }
            else {
                var keys = [];
            }

            DeviceRequestService
            .downloadJescaActivationCsv(keys, true)
            .then(function(resp) {
                vm.isDownloadingJescaActivationCsv = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            }, function(err) {
                vm.isDownloadingJescaActivationCsv = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function create(isDraft) {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            var message = vm.tableData.find(function(d){
                var index = vm.types.DeviceInstallationStatus.en.indexOf(d.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(d.status);
                }
                var indexValue = vm.types.DeviceInstallationStatus.key[index];

                return (indexValue === "INSTALLED" || indexValue === "RUNNING") && !vm.isMerchantAdmin;
            }) ? vm.localTranslator("device.request.edit.running.state.edit.message") : null;


            baUtil.showConfirm(null, message)
            .then(function() {

                var data = [];
                vm.tableData.forEach(function (row, i) {
                    var obj = {
//                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
//                        if( key === "paymentHandlingOptions" ) return;

                        if (key === 'date' || key == 'preferredDateOfInstallation') {
                            var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                            obj[key] = long;
                        }
                        if (key === 'processingCategory') {
                            obj[key]  = row.allowedValuesProcessingCategory;
                        }
//                        else if (key.indexOf("paymentHandlingOption_") >= 0){
//                            if(row[key]) {
//                                var optionKey = key.replace('paymentHandlingOption_', '');
//                                obj.paymentHandlingOptions.push(optionKey);
//                            }
//                        }
//                        else if( key == "deviceOwnerId" ) {
//                            var index = vm.types.deviceOwner[row.serviceContractId].en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.deviceOwner[row.serviceContractId].jp.indexOf(row[key]);
//                            }
//                            obj['deviceOwnerId'] = vm.types.deviceOwner[row.serviceContractId].key[index];
//                        }
//                        else if( key == "status" ) {
//                            var index = vm.types.DeviceInstallationStatus.en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.DeviceInstallationStatus.jp.indexOf(row[key]);
//                            }
//                            var indexValue = vm.types.DeviceInstallationStatus.key[index];
//
//
//                            if(indexValue == "DRAFT" && !isDraft) {
//                                obj['status'] = "REGISTERED";
//                            }
//                            else
//                                obj['status'] = indexValue;
//
//                        }
//                        else if( key == "type" ) {
//                            var index = vm.types.DeviceInstallationType.en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.DeviceInstallationType.jp.indexOf(row[key]);
//                            }
//                            obj['type'] = vm.types.DeviceInstallationType.key[index];
//                        }
                        else {
                            obj[key] = row[key]
                        }
                    })

//                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
//                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
//                    if(obj['transportPaymentHandlingOption'] !== "-") {
//                        obj.paymentHandlingOptions.push("TRANSPORT");
//                    }
//
//                    if( !(obj['version'] || "1.7").startsWith("2.") ) {
//                        obj['version'] = "2.0";
//                    }

                    var long = baUtil.convertJpDateToTimestamp(obj['reflectionDate'])
                    obj['reflectionDate'] = long;
                    data.push(obj)
                })

                data = data.filter(function(d, i){ return !vm.tableData[i].readOnly });
                if(!data.length) return;

                if(data.length > 9) {
                    vm.modal = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/modalTemplates/loadingModal.html',
                        size: "sm",
                        resolve: {
                          items: function () {
                            return $scope.items;
                        }}
                    });
                }

                if (isDraft) {
                    vm.draftInProgress = true;
                } else {
                    vm.createInProgress = true;
                }
                DeviceRequestService
                .updateJescaDeviceRequest( data )
                .then(function success(response) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }
        function applyMaroon() {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            var message = vm.tableData.find(function(d){
                var index = vm.types.DeviceInstallationStatus.en.indexOf(d.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(d.status);
                }
                var indexValue = vm.types.DeviceInstallationStatus.key[index];

                return (indexValue === "INSTALLED" || indexValue === "RUNNING") && !vm.isMerchantAdmin;
            }) ? vm.localTranslator("device.request.edit.running.state.edit.message") : null;

            var title = vm.localTranslator("device.request.jesca.apply.title");
            var message = vm.localTranslator("device.request.jesca.apply.message");
            var btnText = vm.localTranslator("device.request.jesca.apply.btn.text");


            baUtil.showConfirm(title, message, btnText)
            .then(function() {

                var data = [];
                vm.tableData.forEach(function (row, i) {
                    var obj = {
//                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
                        if (key == 'date' || key == 'reflectionDate') {
                            obj[key] = '';
                            var long = baUtil.convertJpDateToTimestamp(row[key])
                            obj['reflectionDate'] = long;
                        }
                        if (key === 'processingCategory') {
                            obj[key]  = row.allowedValuesProcessingCategory;
                        }
//                        else if (key.indexOf("paymentHandlingOption_") >= 0){
//                            if(row[key]) {
//                                var optionKey = key.replace('paymentHandlingOption_', '');
//                                obj.paymentHandlingOptions.push(optionKey);
//                            }
//                        }
//                        else if( key == "deviceOwnerId" ) {
//                            var index = vm.types.deviceOwner[row.serviceContractId].en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.deviceOwner[row.serviceContractId].jp.indexOf(row[key]);
//                            }
//                            obj['deviceOwnerId'] = vm.types.deviceOwner[row.serviceContractId].key[index];
//                        }
//                        else if( key == "status" ) {
//                            var index = vm.types.DeviceInstallationStatus.en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.DeviceInstallationStatus.jp.indexOf(row[key]);
//                            }
//                            var indexValue = vm.types.DeviceInstallationStatus.key[index];
//
//
//                            if(indexValue == "DRAFT" && !isDraft) {
//                                obj['status'] = "REGISTERED";
//                            }
//                            else
//                                obj['status'] = indexValue;
//
//                        }
//                        else if( key == "type" ) {
//                            var index = vm.types.DeviceInstallationType.en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.DeviceInstallationType.jp.indexOf(row[key]);
//                            }
//                            obj['type'] = vm.types.DeviceInstallationType.key[index];
//                        }
                        else {
                            obj[key] = row[key]
                        }
                    })

//                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
//                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
//                    if(obj['transportPaymentHandlingOption'] !== "-") {
//                        obj.paymentHandlingOptions.push("TRANSPORT");
//                    }
//
//                    if( !(obj['version'] || "1.7").startsWith("2.") ) {
//                        obj['version'] = "2.0";
//                    }
                    var long = baUtil.convertJpDateToTimestamp(obj['reflectionDate'])
                    obj['reflectionDate'] = long;
                    data.push(obj)
                })

                data = data.filter(function(d, i){ return !vm.tableData[i].readOnly });
                if(!data.length) return;

                if(data.length > 9) {
                    vm.modal = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/modalTemplates/loadingModal.html',
                        size: "sm",
                        resolve: {
                          items: function () {
                            return $scope.items;
                        }}
                    });
                }

                vm.createInProgress = true;
                vm.disableActionButtons = true;

                DeviceRequestService
                .applyMarron( data )
                .then(function success(response) {

                    if(vm.modal) {
                        vm.modal.close();
                    }
                    vm.createInProgress = false;
                    vm.disableActionButtons = false;
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {

                    if(vm.modal) {
                        vm.modal.close();
                    }
                    vm.createInProgress = false;
                    vm.disableActionButtons = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }



        function uploadJescaCsv(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name.toLowerCase(), [".csv"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.uploadingJescaCsv = true;

                DeviceRequestService
                .uploadJescaRequest(file)
                .then(function (response) {
                    vm.newDeviceInProgress = false;
                    $state.go('main.deviceRequest.jesca', { deviceInstallation: response });
                    }, function err(err) {
                    ev.target.value = "";
                    vm.uploadingJescaCsv = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('MultiNewRequestCtrl', MultiNewRequestCtrl);

    /** @ngInject */
    function MultiNewRequestCtrl(DeviceRequestService, types, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, $rootScope, AuthService, $uibModal, hotUtil,
        DeviceRequestUtilService) {

        if( $stateParams.deviceRequest == null ) {
            $state.go("main.deviceRequest.list");
        }

        if($stateParams.isJescaUpload) {
            $state.current.title = 'device.request.list.upload.device.jesca';
        }
        else {
            $state.current.title = 'device.request.list.upload.device';
        }

        var vm = this;
        vm.isJescaUpload = $stateParams.isJescaUpload;
        vm.deviceRequest = $stateParams.deviceRequest.dtos;
        vm.KeyMap = DeviceRequestUtilService.getKeys(
            $stateParams.deviceRequest.keyMap, "2.0"); // always use latest validation

        vm.getInputType = getInputType;
        vm.create = create;
        vm.cancelCreate = cancelCreate;
        vm.serviceContractId = null;
        vm.permissions = AuthService.getPermissions();
        vm.localTranslator = $filter('translate');

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }

        vm.types.deviceOwner = $stateParams.deviceRequest.deviceOwner;
        vm.KeyMap.deviceOwnerId.type = "Dropdown";
        vm.KeyMap.deviceOwnerId.readOnly = false;
        vm.autoSelectedDO = ""; // in case of self rent
        vm.isUserDeviceOwnerOfSC = false;
        vm.orgId = AuthService.getOrgId();
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ;
        vm.getDeviceStatusFromKey = getDeviceStatusFromKey;
        vm.getInstallationStatusIndex = getInstallationStatusIndex;
        vm.isDIStateTransitionValid = isDIStateTransitionValid;
        vm.hotTable = null;

        vm.getLang = getLang;
        vm.modal = null;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;
        vm.getErrMessageOfStatus = getErrMessageOfStatus;
        vm.getErrMessageDO = getErrMessageDO;

        if (vm.orgId && vm.orgId != "" && vm.types.deviceOwner.key.indexOf(vm.orgId) != -1 && !baUtil.isMerchant()) {
            vm.isUserDeviceOwnerOfSC = true;
            vm.autoSelectedDO = vm.orgId;
        } else if (vm.types.deviceOwner.key.length === 1) {
            vm.autoSelectedDO = vm.types.deviceOwner.key[0];
        }


        function init() {
            vm.tableData = [];
            vm.tableOptions = {};
            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                fixedColumnsLeft: 5,
                modifyColWidth: function(width, col) {
                    if(width > 500) return 500;
                },
                afterValidate: function (isValid, value, row, prop, source) {
                    // special validation for device installaiton status
                    if(prop === "status") {
                        var index = vm.types.DeviceInstallationStatus.en.indexOf(value);
                        if (index < 0) {
                            index = vm.types.DeviceInstallationStatus.jp.indexOf(value);
                        }
                        var indexValue = index === -1 ? value : vm.types.DeviceInstallationStatus.key[index];

                        if(vm.isDIStateTransitionValid(vm.deviceRequest[row]['status'], indexValue)) {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                        else {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageOfStatus(
                                row+1,
                                vm.deviceRequest[row]['applicationNumber'],
                                vm.deviceRequest[row]['status'],
                                indexValue
                            );
                            return false;
                        }
                    }

                    if(prop === "deviceOwnerId") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId");
                            return false;
                        }
                        else if( vm.types.deviceOwner[$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId", true);
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(prop === "paymentHandlingOption_TRANSPORT") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value) ||
                         vm.types.TransportPaymentOptions[$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "paymentHandlingOption_TRANSPORT", true);
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    // common use validator
                    if ( !vm.KeyMap[prop]["readOnly"] &&
                        vm.KeyMap[prop]['validators'].length
                    ) {
                        var msg = hotUtil.aggregatedValidator(vm.KeyMap[prop]['validators'], value, row, vm.KeyMap[prop][vm.getLang()]);
                        if( msg != "" ) {
                            vm.errors[ row + "_" + prop ] = msg;
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(isValid) {
                        delete vm.errors[ row + "_" + prop ];
                    }
                    else {
                        vm.errors[ row + "_" + prop ] = value;
                    }
                }
            };

            // disable rows if the device status is not DRAFT or REGISTERED
            //    for users which don't have permissions
            //    when status is cancelled
            vm.tableSettings.cells = function (row,col,prop) {
                var cellMeta = {};
                if(vm.tableData[row].productName.includes('ME-10'))
                {
                    if(prop === 'paymentHandlingOption_VISA' || prop === 'paymentHandlingOption_MASTERCARD' || prop === 'paymentHandlingOption_AMERICANEXPRESS' || prop === 'paymentHandlingOption_JCB' || prop === 'paymentHandlingOption_DISCOVER' || prop === 'paymentHandlingOption_DINERS'){
                        cellMeta.readOnly = true;
                    }
                }
                if( vm.tableData[row] && vm.tableData[row].readOnly ) {
                    cellMeta.readOnly = true;
                }
                return cellMeta;
                // return vm.tableData[row] && vm.tableData[row].readOnly ? { readOnly: true } : {};
            };

            vm.deviceRequest.forEach(function (item, index) {
                var obj = {};

                if (baUtil.isUndefinedOrNullOrEmpty(vm.serviceContractId)) {
                    vm.serviceContractId = item.serviceContractId
                }

                Object.keys(item).forEach(function (field) {
                    var value = item[field]
                    if (field === 'date' || field == 'preferredDateOfInstallation') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                        return
                    }
                    obj[field] = value;
                    if (field === 'status') {
                        var index = vm.types.DeviceInstallationStatus.key.indexOf(value);
                        obj[field] = vm.types.DeviceInstallationStatus[$translate.use()][index];
                    }
                    else if (field === 'type') {
                        var index = vm.types.DeviceInstallationType.key.indexOf(value);
                        obj[field] = vm.types.DeviceInstallationType[$translate.use()][index];
                    }
                    else if (field === 'deviceOwnerId') {
                        if (vm.autoSelectedDO !== "") {
                            var index = vm.types.deviceOwner.key.indexOf(vm.autoSelectedDO);
                            obj[field] = vm.types.deviceOwner[$translate.use()][index];
                        }
                        else {
                            var index = vm.types.deviceOwner.key.indexOf(value);
                            obj[field] = vm.types.deviceOwner[$translate.use()][index];
                        }
                    }

                    if (field === 'vendingMachineModel') {
                        item.paymentHandlingOptions.forEach(function (k, i) {
                            obj['paymentHandlingOption_' + k] = true
                        });
                        obj['paymentHandlingOption_TRANSPORT'] = DeviceRequestUtilService.getTransportPaymentOptionTextFromKey(
                            vm.types.TransportPaymentOptions,
                            item['transportPaymentHandlingOption'],
                            item['paymentHandlingOptions']
                        );
                    }
                })

                vm.tableData.push(obj);
            })
            var keyMap = vm.KeyMap;
            
            var optionKeys = Object.keys(keyMap).sort(function (a, b) {
                return keyMap[a].order - keyMap[b].order;
            });

            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (
                    (field == 'status') ||
                    (field == 'deviceOwnerId' && vm.isUserDeviceOwnerOfSC)
                ) {
                    col.readOnly = true;
                }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = getSource(field)
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                if ( !vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'].length ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
            })

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsontable-multiple-request');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }

        init();

        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        // ask before leaving form
        vm.askBeforeLeaving = true;
        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            if (current.endsWith('device-request/create-multiple') && vm.askBeforeLeaving) {
                processBeforeRedirect(event);
            }
        });

        function processBeforeRedirect(event) {
            toastr.info(
                vm.localTranslator("common.components.msg.confirm"),
                vm.localTranslator("common.components.title.info"),
                baUtil.toastOptions()
            );
            if( event ) event.preventDefault();
            vm.askBeforeLeaving = false;
        }

        function cancelCreate() {
            if( vm.askBeforeLeaving ) {
                return processBeforeRedirect();
            }
            $state.go("main.deviceRequest.list");
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }

        function getSource(key) {
            switch (key) {
                case 'status':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'type':
                    return vm.types.DeviceInstallationType[$translate.use()]
                case 'deviceOwnerId':
                    return vm.types.deviceOwner[$translate.use()]
                case 'paymentHandlingOption_TRANSPORT':
                    return vm.types.TransportPaymentOptions[$translate.use()]
                default:
                    return []
            }
        }

        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field){
            if( vm.fieldMetaData[field] ) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                /// return reqd otherwise
                return $translate.instant(
                    "device.request.edit.err.msg.required.field",
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
        }

        function getErrMessageDO (row, field, isWrongInput) {
            return $translate.instant(
                isWrongInput ? "device.request.edit.err.msg.device.owner" : "device.request.edit.err.msg.required.field",
                { row: row, param: vm.KeyMap[field][vm.getLang()] }
            );
        }

        function getErrMessageOfStatus(row, applicationNumber, from, to){
            return $translate.instant(
                "device.request.edit.err.msg.cannot.allow.state.transition",
                {
                    row: row,
                    id: applicationNumber,
                    from: vm.getDeviceStatusFromKey(from),
                    to: vm.getDeviceStatusFromKey(to)
                }
            );
        }

        function getInstallationStatusIndex(status){
            var statusMap = {
                "DRAFT": 0,
                "REGISTERED": 1,
                "ACCEPTED": 2,
                "UNDER_FULFILMENT": 3,
                "COMPLETED": 4,
                "APPLICATION_CANCELLED": 5
            };
            if(Object.keys(statusMap).indexOf(status) === -1) {
                return null;
            }
            return statusMap[status]
        }

        function isDIStateTransitionValid(statusBefore, statusAfter) {

            // no change detected
            if(statusBefore == statusAfter) {
                return true;
            }

            // status shifted backwards
            else if (
                vm.getInstallationStatusIndex(statusBefore) != null &&
                vm.getInstallationStatusIndex(statusAfter) != null &&
                vm.getInstallationStatusIndex(statusBefore) > vm.getInstallationStatusIndex(statusAfter)
            ) {
                if(vm.isSystemUser) {
                    if(
                        (statusBefore == "ACCEPTED" && statusAfter == "REGISTERED") ||
                        (statusBefore == "UNDER_FULFILMENT" && statusAfter == "REGISTERED")
                    ) {
                        return true;
                    }
                }
                return false;
            }

            // status moving forward
            else {
                // for common permissions
                if(
                    (statusBefore == "DRAFT" && statusAfter == "REGISTERED") ||
                    (statusBefore == "REGISTERED" && statusAfter == "APPLICATION_CANCELLED")
                ) {
                    return true;
                }
                // for System User
                else if(vm.isSystemUser) {
                    if(
                        (statusBefore == "REGISTERED" && statusAfter == "ACCEPTED") ||
                        (
                            statusBefore == "ACCEPTED" &&
                            ["UNDER_FULFILMENT", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        ) ||
                        (
                            statusBefore == "UNDER_FULFILMENT" &&
                            ["COMPLETED", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        )
                    ) {
                        return true;
                    }
                }
                // otherwise
                return false;
            }
        }

        function getDeviceStatusFromKey(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);

            if(index === -1) return key;

            return ($translate.use() === "jp" ?
                    vm.types.DeviceInstallationStatus.jp[index] :
                    vm.types.DeviceInstallationStatus.en[index]);
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function create(isDraft) {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            baUtil.showConfirm()
            .then(function () {

                var data = [];
                vm.tableData.forEach(function (row) {
                    var obj = {
                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
                        if( key === "paymentHandlingOptions" ) return;

                        if (key === 'date' || key == 'preferredDateOfInstallation') {
                            var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                            obj[key] = long
                            return
                        }
                        if (key.indexOf("paymentHandlingOption_") >= 0){
                            if(row[key]) {
                                var optionKey = key.replace('paymentHandlingOption_', '');
                                obj.paymentHandlingOptions.push(optionKey);
                            }
                            return;
                        }

                        obj[key] = row[key]
                    });

                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(
                        vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                    if(obj['transportPaymentHandlingOption'] !== "-") {
                        obj.paymentHandlingOptions.push("TRANSPORT");
                    }

                    data.push(obj)
                });

                data.forEach(function (item, i) {
                    item = data[i];

                    var index = vm.types.DeviceInstallationStatus.en.indexOf(item.status);
                    if (index < 0) {
                        index = vm.types.DeviceInstallationStatus.jp.indexOf(item.status);
                    }
                    var indexValue = vm.types.DeviceInstallationStatus.key[index];

                    if ((indexValue == "REGISTERED" && isDraft) || (indexValue == "DRAFT" && !isDraft))
                        item['status'] = "REGISTERED";
                    else if (indexValue == "DRAFT" || indexValue == "REGISTERED")
                        item['status'] = indexValue;
                    else
                        item['status'] = vm.isSystemUser ?
                            vm.types.DeviceInstallationStatus.key[index] :
                            vm.deviceRequest[i]['status'];



                    var index = vm.types.DeviceInstallationType.en.indexOf(item.type);
                    if (index < 0) {
                        index = vm.types.DeviceInstallationType.jp.indexOf(item.type);
                    }
                    item['type'] = vm.types.DeviceInstallationType.key[index];

                    var index = vm.types.deviceOwner.en.indexOf(item.deviceOwnerId);
                    if (index < 0) {
                        index = vm.types.deviceOwner.jp.indexOf(item.deviceOwnerId);
                    }
                    item['deviceOwnerId'] = vm.types.deviceOwner.key[index];
                })

                data = data.filter(function (d, i) { return !vm.tableData[i].readOnly });
                if (!data.length) return;

                if(data.length > 9) {
                    vm.modal = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/modalTemplates/loadingModal.html',
                        size: "sm",
                        resolve: {
                          items: function () {
                            return $scope.items;
                        }}
                    });
                }

                if (isDraft) {
                    vm.draftInProgress = true;
                } else {
                    vm.createInProgress = true;
                }


                DeviceRequestService.createDeviceRequest(data, vm.serviceContractId,vm.isJescaUpload)
                .then(function success(response) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    vm.askBeforeLeaving = false;
                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('NewRequestCtrl', NewRequestCtrl);

    /** @ngInject */
    function NewRequestCtrl(DeviceRequestService, types, KeyMap, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, AuthService, $uibModal, hotUtil, DeviceRequestUtilService) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.deviceRequest = $stateParams.deviceRequest
        vm.getInputType = getInputType;
        vm.create = create;
        vm.cancelCreate = cancelCreate;
        vm.onVersionChange = onVersionChange;
        vm.serviceContractId = null;
        vm.format = 'longDate';
        vm.options = {
            showWeeks: false
        };
        vm.localTranslator = $filter('translate');
        vm.hotTable = null;


        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;

            // remove calcelled status type from DeviceInstallationStatus List
            var index = vm.types.DeviceInstallationStatus.key.indexOf("APPLICATION_CANCELLED");
            vm.types.DeviceInstallationStatus.en.splice(index);
            vm.types.DeviceInstallationStatus.jp.splice(index);
        }

        if (KeyMap.status >= 200 && KeyMap.status <= 299) {
            vm.KeyMapMaster = DeviceRequestUtilService.getKeys(KeyMap.data.data);
            vm.versionOptions = Object.keys(vm.KeyMapMaster);
            vm.version = vm.versionOptions[0];
        }

        vm.getLang = getLang;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;


        function init() {
            vm.tableData = [{}];
            vm.tableOptions = {};

            // replace "Device Owner" param with "Device Owner Id"
            vm.KeyMap = vm.KeyMapMaster[vm.version];
            vm.KeyMap.deviceOwnerId.en = "Device Owner Id";
            vm.KeyMap.serviceContractId.readOnly = false;
            vm.KeyMap.deviceOwnerId.readOnly = false;

            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                modifyColWidth: function(width, col) {
                    if(width > 500) return 500;
                },
                afterValidate: function (isValid, value, row, prop, source) {

                    if(prop === "paymentHandlingOption_TRANSPORT") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value) ||
                         vm.types.TransportPaymentOptions[$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = $translate.instant(
                                "device.request.edit.err.msg.device.owner",
                                {
                                    row: row+1,
                                    param: vm.KeyMap["paymentHandlingOption_TRANSPORT"][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    // common use validator
                    if ( !vm.KeyMap[prop]["readOnly"] && vm.KeyMap[prop]['validators'].length ) {
                        var msg = hotUtil.aggregatedValidator(vm.KeyMap[prop]['validators'], value, row, vm.KeyMap[prop][vm.getLang()]);
                        if( msg != "" ) {
                            vm.errors[ row + "_" + prop ] = msg;
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(isValid) {
                        delete vm.errors[ row + "_" + prop ];
                    }
                    else {
                        vm.errors[ row + "_" + prop ] = value;
                    }
                }
            };

            // disable rows if the device status is not DRAFT or REGISTERED
            //    for users which don't have permissions
            //    when status is cancelled
            vm.tableSettings.cells = function (row, col) {
                return vm.tableData[row].readOnly ? { readOnly: true } : {};
            };

            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap).filter(function (k) { return k !== 'companyName' && k !== 'deviceInstallationId' && k !== 'deviceSerial' && k !== 'applicationNumber' }).sort(function (a, b) { return keyMap[a].order - keyMap[b].order });

            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if ( field == 'status' ) {
                    col.readOnly = true;
                    fieldValue = vm.types.DeviceInstallationStatus[$translate.use()][0];
                }

                if ( field == 'type' ) {
                    col.readOnly = true;
                    fieldValue = vm.types.DeviceInstallationType[$translate.use()][0];
                }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = getSource(field)
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                if (field.indexOf("paymentHandlingOption_") === 0) {
                    fieldValue = false;
                }

                if ( !vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'].length ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;
            });

            if(vm.version === "2.0" ) {
                vm.tableData[0]['paymentHandlingOption_TRANSPORT'] = DeviceRequestUtilService.getTransportPaymentOptionTextFromKey(
                    vm.types.TransportPaymentOptions,
                    vm.tableData[0]['transportPaymentHandlingOption'],
                    vm.tableData[0]['paymentHandlingOptions']
                );
            }

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsontable-request-create');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }

        init();

        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        function onVersionChange(value) {
            vm.version = vm.versionOptions.indexOf(value) != -1 ? value : vm.versionOptions[0];
            init();
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }

        function getSource(key) {
            switch (key) {
                case 'status':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'type':
                    return vm.types.DeviceInstallationType[$translate.use()]
                case 'paymentHandlingOption_TRANSPORT':
                    return vm.types.TransportPaymentOptions[$translate.use()]
                default:
                    return []
            }
        }


        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field){
            if( vm.fieldMetaData[field] ) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                return "Error in " + vm.KeyMap[field][vm.getLang()];
            }
        }

        function cancelCreate() {
            $state.go("main.deviceRequest.list");
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function create(isDraft) {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            baUtil.showConfirm()
            .then(function() {
                if (isDraft) {
                    vm.draftInProgress = true;
                } else {
                    vm.createInProgress = true;
                }


                var data = [];
                vm.serviceContractId = vm.tableData[0].serviceContractId;

                var obj = {
                    paymentHandlingOptions: []
                };
                Object.keys(vm.tableData[0]).forEach(function (key) {
                    if (key === 'date' || key == 'preferredDateOfInstallation') {
                        var long = vm.tableData[0][key] && baUtil.convertJpDateToTimestamp(vm.tableData[0][key])
                        obj[key] = long
                        return
                    }
                    if( key.indexOf("paymentHandlingOption_") >= 0 && vm.tableData[0][key]) {
                        var optionKey = key.replace('paymentHandlingOption_', '');
                        obj.paymentHandlingOptions.push(optionKey);
                        return
                    }
                    obj[key] = vm.tableData[0][key]
                })

                if ( "2.0" === vm.version ) {
                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(vm.types.TransportPaymentOptions, vm.tableData[0]['paymentHandlingOption_TRANSPORT']);
                    if(obj['transportPaymentHandlingOption'] === "-") {
                        obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                    }
                }
                else {
                    obj['transportPaymentHandlingOption'] = null;
                }

                data.push(obj)

                data.forEach(function(item, i) {
                    item = data[i];
                    if (isDraft)
                        item['status'] = "DRAFT";
                    else
                        item['status'] = "REGISTERED";


                    var index = vm.types.DeviceInstallationType.en.indexOf(item.type);
                    if (index < 0) {
                        index = vm.types.DeviceInstallationType.jp.indexOf(item.type);
                    }
                    item['type'] = vm.types.DeviceInstallationType.key[index];

                    item.version = vm.version;
                });

                DeviceRequestService
                .createDeviceRequestSingle(data, vm.serviceContractId)
                .then(function success(response) {
                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {
                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('RemoveDeviceCtrl', RemoveDeviceCtrl);

    /** @ngInject */

    function RemoveDeviceCtrl(types, $filter, baUtil, $state, toastr, $stateParams, $translate, DeviceRequestService, $scope, $uibModal, $sce) {

        if( $stateParams.removeDeviceMap == null ) {
            $state.go("main.deviceRequest.list");
        }

        var vm = this;

        vm.cancel = cancel;
        vm.submit = submit;

        vm.localTranslator = $filter('translate');

        vm.getLang = getLang;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;

        var removeDeviceMap = $stateParams.removeDeviceMap[0];
        vm.removalReasons = $stateParams.removeDeviceMap[1];
        vm.default_addMonthlyFee = $stateParams.removeDeviceMap[2];
        vm.default_freeApplicationNumber = $stateParams.removeDeviceMap[3];

        vm.addMonthlyFee = {
            en:['Yes','No'],
            jp:['はい','いいえ'],
            key:['true','false']
        }
        vm.freeDeviceApnNum = {
            en:['Yes','No'],
            jp:['はい','いいえ'],
            key:['true','false']
        }

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }

        removeDevice(removeDeviceMap);
       


        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }


        

        function removeDevice(rowData) {

                    vm.tableRowData = [];
                    vm.tableData = [{}];
                    vm.tableOptions = {};

                    vm.removeDeviceTableHeader = {
                        serviceContractId: {
                            en: 'Contract ID',
                            jp: '契約先ID',
                            column: 'serviceContractId'
                        },
                        companyName: {
                            en: 'Company Name',
                            jp: '会社名',
                            column: 'companyName'
                        },
                        applicationNumber: {
                            en: 'Application Number',
                            jp: '申込通番',
                            column: 'applicationNumber'
                        },
                        deviceSerial: {
                            en: 'Device Serial',
                            jp: '端末シリアル',
                            column: 'deviceSerial'
                        },
                        status: {
                            en: 'Status',
                            jp: '状況',
                            column: 'status'
                        },
                        startTime: {
                            en: 'Operation Start Date',
                            jp: '稼働開始日',
                            column: 'startTime'
                        },
                        lastCommunicationTime: {
                            en: 'Last Communication Date',
                            jp: '最終通信日',
                            column: 'lastCommunicationTime'
                        },
                        nextBatchWillRunOn: {
                            en: 'Next Batch Run Date',
                            jp: '次のバッチ実行日',
                            column: 'nextBatchWillRunOn'
                        },
                        removalDate: {
                            en: 'Removal Date (31/32)',
                            jp: '撤去日 (31/32)',
                            column: 'removalDate'
                        },
                        operationApplicableTime: {
                            en: 'Enter Detached Date',
                            jp: '締め・撤去日を入力',
                            column: 'operationApplicableTime'
                        },
                        addMonthlyFee: {
                            en: 'Add Monthly Fee?',
                            jp: '月額費用を追加？',
                            column: 'addMonthlyFee'
                        },
                        freeApplicationNumber: {
                            en: 'Free Dvc Apn Num?',
                            jp: '申込通番を解放?',
                            column: 'freeApplicationNumber'
                        },
                        operationReason: {
                            en: 'Reason Of Detachment',
                            jp: '締め・撤去の理由',
                            column: 'operationReason'
                        },
                        operationComment: {
                            en: 'Enter Comment',
                            jp: 'コメントを入力',
                            column: 'operationComment'
                        },
                    }


                    rowData.forEach(function (item, index) {
                        var obj = {};
                        var keys = Object.keys(item)
                        keys.forEach(function (field) {
                            var value = item[field]
                            if (field === 'nextBatchWillRunOn') {
                                obj[field] = $filter('date')(value, "yyyy/MM/dd HH:mm:ss");
                                return
                            }
                            else if (field === 'startTime' || field === 'lastCommunicationTime' || field === 'removalDate'){
                                if (value === 0 || value === null) {
                                    obj[field] = $filter('translate')('common.components.data.not.available');
                                    return
                                }
                                else {
                                    obj[field] = $filter('date')(value, "yyyy/MM/dd HH:mm:ss");
                                    return
                                }
                            }
                            else if (field === 'operationApplicableTime'){
                                if (value === 0) {
                                    obj[field] = $filter('date')(new Date(), "yyyy/MM/dd HH:mm:ss");
                                    return
                                }
                                else {
                                    obj[field] = $filter('date')(value, "yyyy/MM/dd HH:mm:ss");
                                    return
                                }
                            }
                            else if (field === 'addMonthlyFee'){
                                if (value == true) {
                                    obj[field] = monthlyFee(value);
                                    return
                                }
                                else {
                                    obj[field] = monthlyFee(value);
                                    return
                                }
                            }
                            else if (field === 'freeApplicationNumber'){
                                if (value == true) {
                                    obj[field] = freeDeviceApnNum(value);
                                    return
                                }
                                else {
                                    obj[field] = freeDeviceApnNum(value);
                                    return
                                }
                            }
                            else if (field === 'operationReason'){
                                obj[field] = removalReasons(value);
                                return
                            }
                            else if (field === 'status'){
                                obj[field] = getStatus(value);
                                return
                            }
                            else {
                                obj[field] = value;
                            }
                        })
                        vm.tableRowData.push(obj)
                    })

                    vm.KeyMap = vm.removeDeviceTableHeader;
                    vm.KeyMap.serviceContractId.readOnly = true;
                    vm.KeyMap.companyName.readOnly = true;
                    vm.KeyMap.applicationNumber.readOnly = true;
                    vm.KeyMap.deviceSerial.readOnly = true;
                    vm.KeyMap.status.readOnly = true;
                    vm.KeyMap.startTime.readOnly = true;
                    vm.KeyMap.lastCommunicationTime.readOnly = true;
                    vm.KeyMap.nextBatchWillRunOn.readOnly = true;
                    vm.KeyMap.removalDate.readOnly = true;
                    vm.KeyMap.operationApplicableTime.readOnly = false
        //            vm.keyMap.operationApplicableTime.colspan = 3;
                    vm.KeyMap.addMonthlyFee.readOnly = false;
                    vm.KeyMap.freeApplicationNumber.readOnly = false;
                    vm.KeyMap.operationReason.readOnly = false;
                    vm.KeyMap.operationComment.readOnly = false;

                    vm.tableSettings = {
                        colHeaders: [],
                        rowHeaders: true,
                        currentRowClassName: 'currentRow',
                        currentColClassName: 'currentCol',
                        invalidCellClassName: 'cell-has-error',
                        columns: [],
                        cells: function(row, col, prop) {
                          var cellProperties = {};
                          var rowStatus = getStatusKey(vm.tableRowData[row].status);

                          if (rowStatus === 'REMOVED_AND_SETTLED' || rowStatus === 'PORTAL_DETACHED_AND_SETTLED') {
                            cellProperties.readOnly = true;
                          }

                          return cellProperties;

                        },
                        fixedColumnsLeft: 4,
                        modifyColWidth: function(width, col) {
                            if(col === 2 || col === 3) {
                                return 150;
                            }else if (col === 1){
                                return 200;
                            }  else if(width > 500) return 500;
                        },
                        afterValidate: function (isValid, value, row, prop, source) {
                            if(prop === "addMonthlyFee" || prop === "freeApplicationNumber" || prop === "operationReason" ) {
                                if(baUtil.isUndefinedOrNullOrEmpty(value)){
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "device.request.edit.err.msg.device.owner",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;
                                }
                                else {
                                    delete vm.errors[ row + "_" + prop ];
                                    return true;
                                }
                            }

                            if (prop === 'operationApplicableTime') {
                                if(!isValid || baUtil.isUndefinedOrNullOrEmpty(value)) {
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "device.request.edit.err.msg.date.remove.device",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;

                                }
                                else {
                                    delete vm.errors[ row + "_" + prop ];
                                    return true;
                                }
                            }
                        }
                    };

                    vm.tableSettings.cells = function (row, col, prop) {
                        var cellMeta = {};
                        if(prop === "deviceSerial" || prop === "companyName" || prop === "applicationNumber") {
                            cellMeta.className = 'word-break';
                        }
                        return  cellMeta;
                    };
        


                    var keyMap = vm.KeyMap;
                    var optionKeys = Object.keys(keyMap);
                    optionKeys.forEach(function (field) {
                        var value = keyMap[field]
                        var fieldValue = "";
                        vm.tableSettings.colHeaders.push(value[$translate.use()])
                        var col = {
                            type: getInputType(value.type),
                            data: field,
                            readOnly: value.readOnly
                        }


                        if (field == 'operationApplicableTime') {
                            col.type = 'date',
                            col.dateFormat = 'YYYY/MM/DD HH:mm:ss'
                        }
                        if (field == 'addMonthlyFee') {
                            col.type = 'dropdown',
                            col.source = getSource('addMonthlyFee')
                        }
                        if (field == 'freeApplicationNumber') {
                            col.type = 'dropdown',
                            col.source = getSource('freeDeviceApnNum')
                        }
                        if (field == 'operationReason') {
                            col.type = 'dropdown',
                            col.source = getSource('removalReasons'),
                            col.allowEmpty = false
                        }


                        vm.tableSettings.columns.push(col);
                        vm.tableData[0][field] = fieldValue;

                    });

                    var noDetachedRecords = vm.tableRowData.filter(function (key) { return getStatusKey(key.status) !== 'REMOVED_AND_SETTLED' && getStatusKey(key.status) !== 'PORTAL_DETACHED_AND_SETTLED'  })

                    if(noDetachedRecords.length >= 1) {
                        vm.disableApplyBtn = false;
                    }
                    else {
                        vm.disableApplyBtn = true;
                    }

                    vm.alerts = [];
                    vm.errors = {};
                    var container = document.getElementById('handsOnTable-remove-device');
                    container.innerHTML = "";
                    var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
                    vm.hotTable = new Handsontable(container, options);
                    vm.hotTable.validateCells();
                }

        function cancel() {
            $state.go("main.deviceRequest.list");
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submit() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm(
            "",vm.localTranslator("device.request.list.terminal.remove.confirm.msg"),
                vm.localTranslator("common.components.btn.confirm")
            )
                        .then(function() {
                            vm.updateInProgress = true;

                            var data = [];

                            vm.tableRowData.forEach(function (row) {
                                var operationTime = new Date();
                                row.operationTime = operationTime.getTime();
                                var obj = {};
                                Object.keys(row).forEach(function (key) {
                                var value = row[key];
                                    if (key === 'startTime'   || key === 'lastCommunicationTime' || key === 'nextBatchWillRunOn' || key === 'removalDate' || key === 'operationApplicableTime') {
                                        var dateM = new Date(Date.parse(value))
                                        var long = dateM.getTime();
                                        obj[key] = long
                                        return
                                    }
                                    else if (key === 'addMonthlyFee'){
                                        obj[key] = getMonthlyFeeKey(value);
                                        return
                                    }
                                    else if (key === 'freeApplicationNumber'){
                                        obj[key] = getFreeDeviceApnNumKey(value);
                                        return
                                    }
                                    else if (key === 'operationReason'){
                                        obj[key] = getRemovalReasonsKey(value);
                                        return
                                    }
                                    else if (key === 'status'){
                                        obj[key] = getStatusKey(value);
                                        return
                                    }
                                    else {
                                        obj[key] = row[key]
                                    }
                                })
                                data.push(obj)
                            });


                            data = data.filter(function (key) { return key.status !== 'REMOVED_AND_SETTLED' && key.status !== 'PORTAL_DETACHED_AND_SETTLED'  })
                            checkForDeviceSuspension(data);
                        });
        }

        function checkForDeviceSuspension(devices) {
            var newArr = [];
            devices.forEach(function (value) {
                newArr.push(value.applicationNumber);
            })
            DeviceRequestService.validateSuspensionStatus(newArr).then(function success(response) {
                if(response.data.data.error) {
                    $uibModal.open({
                        animation: false,
                        controller: function confirmCtrl($uibModalInstance) {
                          var msgVm = this;
                          msgVm.title = vm.localTranslator("device.request.confirm.title");
                          msgVm.message = $sce.trustAsHtml(response.data.data.message);
                          msgVm.btnText = vm.localTranslator("device.request.btn.okay");
                          msgVm.ok = function () {
                              $uibModalInstance.close();
                          };
                      },
                        templateUrl: 'app/pages/components/msg/msg-modal.html',
                        controllerAs: 'msgVm',
                        backdrop: "static"
                      });
                } else{
                    DeviceRequestService.removeTerminal(devices).then(function success(response) {
                        vm.updateInProgress = false;
                        toastr.success(
                            vm.localTranslator("common.components.msg.success"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                        $state.go("main.deviceRequest.list");
                    }, function err(err) {
                        vm.updateInProgress = false;
                        toastr.error(
                            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                            vm.localTranslator("common.components.title.error"),
                            baUtil.toastOptions()
                        );
                    });
                }
            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function monthlyFee(flag) {
            if(flag) {return vm.addMonthlyFee[$translate.use()][0]}
            if(!flag) {return vm.addMonthlyFee[$translate.use()][1]}
        }

        function getMonthlyFeeKey(flag) {
            if(flag == vm.addMonthlyFee[$translate.use()][0]) {return true}
            if(flag == vm.addMonthlyFee[$translate.use()][1]) {return false}
        }

        function freeDeviceApnNum(flag) {
            if(flag) {return vm.freeDeviceApnNum[$translate.use()][0]}
            if(!flag) {return vm.freeDeviceApnNum[$translate.use()][1]}
        }

        function getFreeDeviceApnNumKey(flag) {
            if(flag == vm.addMonthlyFee[$translate.use()][0]) {return true}
            if(flag == vm.addMonthlyFee[$translate.use()][1]) {return false}
        }

        function removalReasons(flag) {
            vm.removalReasons.key.forEach (function (value, i) {
                if (value == flag) {
                    vm.removalString = vm.removalReasons[$translate.use()][i]
                }
            })
            return vm.removalString;
        }

        function getRemovalReasonsKey(flag) {
            vm.removalReasons[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    vm.removalKey = vm.removalReasons.key[i]
                }
            })
            return vm.removalKey;
        }

        function getSource(key) {
            switch (key) {
                case 'freeDeviceApnNum':
                    return vm.freeDeviceApnNum[$translate.use()]
                case 'addMonthlyFee':
                    return vm.addMonthlyFee[$translate.use()]
                case 'removalReasons':
                    return vm.removalReasons[$translate.use()]
                default:
                 return []
            }
        }


        function getStatus(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);
            return vm.types.DeviceInstallationStatus[$translate.use()][index]
        }

        function getStatusKey(flag) {
            var index = vm.types.DeviceInstallationStatus[$translate.use()].indexOf(flag);
            return vm.types.DeviceInstallationStatus.key[index]
        }

        $scope.$on('LANG_CHANGE', function (event) {
            removeDevice(removeDeviceMap);
        });


        function getLang() {
            return $translate.use();
        }

    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('RequestDetailCtrl', RequestDetailCtrl);

    /** @ngInject */
    function RequestDetailCtrl(DeviceRequestService, types, KeyMap, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, AuthService, $uibModal, hotUtil, DeviceRequestUtilService, FileSaver) {

        if( $stateParams.deviceInstallation == null ) {
            $state.go("main.deviceRequest.list");
        }

        var vm = this;
        vm.deviceRequest = [];
        vm.getInputType = getInputType;
        vm.create = create;
        vm.cancelCreate = cancelCreate;
        vm.permissions = AuthService.getPermissions();
        vm.localTranslator = $filter('translate');
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ;
        vm.getDeviceStatusFromKey = getDeviceStatusFromKey;
        vm.getInstallationStatusIndex = getInstallationStatusIndex;
        vm.isDIStateTransitionValid = isDIStateTransitionValid;
        vm.getLang = getLang;
        vm.modal = null;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;
        vm.getErrMessageOfStatus = getErrMessageOfStatus;
        vm.getErrMessageDO = getErrMessageDO;
        vm.hotTable = null;
        vm.disableActionButtons = true;
        vm.downloadDeviceRequestExcel = downloadDeviceRequestExcel;
        vm.isMerchantAdmin = baUtil.isMerchantAdmin();
        vm.isDeviceOwnerAdmin = baUtil.isDeviceOwnerAdmin();

        // map of {SCId: isUserDeviceOwnerOfSC} to disallow edit of device owner by another device owner
        vm.isUserDeviceOwnerOfSC = {};

        vm.canEditInStatus = vm.isSystemUser ?
                                [ "DRAFT", "REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INVENTORY"] :
                                [ "DRAFT" ];
        vm.merchantAdminCanEditInStatus = ["REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INSTALLED", "RUNNING", "INVENTORY"];

        vm.deviceOwnerCanEditInStatus = ["REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INSTALLED", "RUNNING", "INVENTORY"];

        vm.canPartiallyEditInStatus = vm.isSystemUser ? [ "INSTALLED", "RUNNING", "PROCESSING_SUSPENSION", "SUSPENDED" ] : [ ];
        vm.readOnlyFieldsInPartiallyEditStatus = [ "status", "branchName", "branchCode" ];
        vm.editableFieldsWhenMerchantAdmin = [ "branchDepartment", "branchDesignation", "branchPersonInCharge", "branchPersonInChargePhone",  "branchPersonInChargeEmail", "vendingMachineModel", "remarks1", "remarks2", "remarks3", "remarks4", "remarks5" ];
        vm.editableFieldsWhenDeviceOwner = [  "branchDepartment", "branchDesignation", "branchPersonInCharge", "branchPersonInChargePhone",  "branchPersonInChargeEmail","vendingMachineModel", "remarks1", "remarks2", "remarks3", "remarks4", "remarks5" ];

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }

        if (KeyMap.status >= 200 && KeyMap.status <= 299) {
            vm.KeyMap = KeyMap.data.data;
        }

        if ($stateParams.deviceInstallation.status >= 200 && $stateParams.deviceInstallation.status <= 299) {
            vm.deviceRequest = $stateParams.deviceInstallation.data.data
            .deviceInstallationRequests.sort(function (a, b) { return b.dateCreated - a.dateCreated });
            vm.KeyMap = DeviceRequestUtilService.getKeys(vm.KeyMap, "2.0");
            vm.types.deviceOwner = $stateParams.deviceInstallation.data.data.deviceOwners;
            vm.KeyMap.deviceOwnerId.type = "Dropdown";
            vm.KeyMap.deviceOwnerId.readOnly = false;
            vm.orgId = AuthService.getOrgId();
            if (vm.orgId && vm.orgId != "" && !baUtil.isMerchant()) {
                Object.keys(vm.types.deviceOwner).forEach(function(d){
                    if(vm.types.deviceOwner[d].key.indexOf(vm.orgId) != -1 ) {
                        vm.isUserDeviceOwnerOfSC[d] = true;
                    }
                });
            }
        }

        function init() {
            vm.tableData = [];
            vm.tableOptions = {};
            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                fixedColumnsLeft: 3,
                modifyColWidth: function(width, col) {
                if (col === 1 || col === 2 || col ===3 || col === 5){
                        return 100;
                    }else if(col === 4){
                        return 150;
                    }
                    else if(width > 500) return 500;
                },
                afterValidate: function (isValid, value, row, prop, source) {
                    // custom validation for device installaiton status
                    if(prop === "status") {
                        var index = vm.types.DeviceInstallationStatus.en.indexOf(value);
                        if (index < 0) {
                            index = vm.types.DeviceInstallationStatus.jp.indexOf(value);
                        }
                        var indexValue = index === -1 ? value : vm.types.DeviceInstallationStatus.key[index];

                        if(vm.isDIStateTransitionValid(vm.deviceRequest[row]['status'], indexValue)) {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                        else {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageOfStatus(
                                row+1,
                                vm.deviceRequest[row]['applicationNumber'],
                                vm.deviceRequest[row]['status'],
                                indexValue
                            );
                            return false;
                        }
                    }

                    // custom validation for device owner
                    if(prop === "deviceOwnerId") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId");
                            return false;
                        }
                        else if( vm.types.deviceOwner[ vm.deviceRequest[row]["serviceContractId"] ][$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId", true);
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(prop === "paymentHandlingOption_TRANSPORT") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value) ||
                         vm.types.TransportPaymentOptions[$translate.use()].indexOf(value) === -1 ) {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "paymentHandlingOption_TRANSPORT", true);
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    // common use validator
                    if ( !vm.KeyMap[prop]["readOnly"] && vm.KeyMap[prop]['validators'].length ) {
                        var msg = hotUtil.aggregatedValidator(vm.KeyMap[prop]['validators'], value, row, vm.KeyMap[prop][vm.getLang()]);

                        if( msg != "" ) {
                            vm.errors[ row + "_" + prop ] = msg;
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }

                    if(isValid) {
                        delete vm.errors[ row + "_" + prop ];
                    }
                    else {
                        vm.errors[ row + "_" + prop ] = value;
                    }

                }
            };

            // disable rows if the device status is not DRAFT or REGISTERED
            //    for users which don't have permissions
            //    when status is cancelled
            //    ALSO >> customise device owners for different SC's DIs
            vm.tableSettings.cells = function (row, col, prop) {
                var cellMeta = {};
                if(!baUtil.isUndefinedOrNullOrEmptyList(vm.tableData[row].productName) && vm.tableData[row].productName.includes('ME-10'))
                {
                    if(prop === 'paymentHandlingOption_VISA' || prop === 'paymentHandlingOption_MASTERCARD' || prop === 'paymentHandlingOption_AMERICANEXPRESS' || prop === 'paymentHandlingOption_JCB' || prop === 'paymentHandlingOption_DISCOVER' || prop === 'paymentHandlingOption_DINERS'){
                        cellMeta.readOnly = true;
                    }
                }
                if(prop === "deviceSerial" || prop === "companyName" || prop === "applicationNumber" || prop === "deviceOwnerId") {
                    cellMeta.className = 'word-break';
                }
                if( prop === "deviceOwnerId" ) {
                    cellMeta.source = vm.types.deviceOwner[ vm.deviceRequest[row]["serviceContractId"] ][$translate.use()];
                }
                if( vm.tableData[row].readOnly || vm.tableData[row][ prop + "_readOnly" ] ) {
                    cellMeta.readOnly = true;
                }
                return  cellMeta;
            };

            vm.deviceRequest.forEach(function (item, index) {
                var obj = {};

                var keys = Object.keys(item).filter(function (k) { return k !== 'paymentHandlingOptions' })
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'date' || field == 'preferredDateOfInstallation') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                    }
                    else if (field === 'deviceOwnerId') {
                        if(baUtil.isUndefinedOrNullOrEmptyObject(value)) {
                            obj['deviceOwnerId'] =  "";
                        }
                        else {
                            var index = vm.types.deviceOwner[item.serviceContractId].key.indexOf(value);
                            obj['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId][$translate.use()][index];
                        }
                    }
                    else if (field === 'status') {
                        var index = vm.types.DeviceInstallationStatus.key.indexOf(value);
                        obj[field] = vm.types.DeviceInstallationStatus[$translate.use()][index];
                    }
                    else if (field === 'type') {
                        var index = vm.types.DRExcelRequestTypeName.key.indexOf(value);
                        obj[field] = vm.types.DRExcelRequestTypeName[$translate.use()][index];
                    }
                    else if (field === 'vendingMachineModel') {
                        item.paymentHandlingOptions.forEach(function (k, i) {
                            obj['paymentHandlingOption_' + k] = true
                        });

                        obj['paymentHandlingOption_TRANSPORT'] = DeviceRequestUtilService.getTransportPaymentOptionTextFromKey(
                            vm.types.TransportPaymentOptions,
                            item['transportPaymentHandlingOption'],
                            item['paymentHandlingOptions']
                        );

                        obj[field] = value;
                    }
                    else {
                        obj[field] = value;
                    }


                })


                // for merchant admin - allow edit of vending maching model and remarks 1-5
                if( vm.isMerchantAdmin && vm.merchantAdminCanEditInStatus.indexOf(item['status'] || "") !== -1) {
                    obj.readOnly = false;
                    vm.disableActionButtons = false;
                    Object.keys(obj).forEach(function (field) {
                        if(vm.editableFieldsWhenMerchantAdmin.indexOf(field)===-1) {
                            obj[ field + "_readOnly" ] = true;
                        }
                    });
                    vm.types.PaymentHandlingOption.E_MONEY.key.forEach(function (key) {
                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
                    });
                    vm.types.PaymentHandlingOption.QR_MONEY.key.forEach(function (key) {
                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
                    });
                    vm.types.PaymentHandlingOption.CREDIT_CARD.key.forEach(function (key) {
                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
                    });
                }
                else if( vm.isDeviceOwnerAdmin && vm.deviceOwnerCanEditInStatus.indexOf(item['status'] || "") !== -1) {
                    obj.readOnly = false;
                    vm.disableActionButtons = false;
                    Object.keys(obj).forEach(function (field) {
                        if(vm.editableFieldsWhenDeviceOwner.indexOf(field)===-1) {
                            obj[ field + "_readOnly" ] = true;
                        }
                    });
                    vm.types.PaymentHandlingOption.E_MONEY.key.forEach(function (key) {
                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
                    });
                    vm.types.PaymentHandlingOption.QR_MONEY.key.forEach(function (key) {
                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
                    });
                    vm.types.PaymentHandlingOption.CREDIT_CARD.key.forEach(function (key) {
                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
                    });
                }
                else if (
                    vm.canEditInStatus.indexOf(item.status) !== -1 &&
                    vm.permissions.DEVICE_REQUEST.WRITE
                ) {
                    obj.readOnly = false;
                    vm.disableActionButtons = false;
                }
                else if(
                    vm.canPartiallyEditInStatus.indexOf(item.status) !== -1 &&
                    vm.permissions.DEVICE_REQUEST.WRITE
                ) {
                    obj.readOnly = false;
                    vm.disableActionButtons = false;
                    vm.readOnlyFieldsInPartiallyEditStatus.forEach(function(key){
                        obj[ key + "_readOnly" ] = true;
                    });
                }
                else {
                    obj.readOnly = true;
                }

                if( vm.isUserDeviceOwnerOfSC[item.serviceContractId] ) {
                    obj["deviceOwnerId_readOnly"] = true;
                }

                vm.tableData.push(obj);
            });
            var keyMap = vm.KeyMap
            var optionKeys = Object.keys(keyMap).sort(function (a, b) {
                return keyMap[a].order - keyMap[b].order;
            });

            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if(field == 'status' && !vm.isSystemUser) {
                    col.readOnly = true;
                }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = getSource(field)
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                if ( !vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'].length ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);

            })

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsontable-request-detail');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }

        init();

        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        function cancelCreate() {
            $state.go("main.deviceRequest.list");
        }

        function getInputType(type) {
           switch (type) {
               case 'String':
                   return 'text'
               case 'Checkbox':
                   return 'checkbox'
               case 'Date':
                   return 'date'
               case 'Dropdown':
                   return 'dropdown'
               default:
                return 'text'
           }
        }

        function getSource(key) {
            switch (key) {
                case 'status':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'type':
                    return vm.types.DRExcelRequestTypeName[$translate.use()]
                case 'deviceOwnerId':
                    return []; // setting this in cells hook
                case 'paymentHandlingOption_TRANSPORT':
                    return vm.types.TransportPaymentOptions[$translate.use()]
                default:
                    return []
            }
        }

        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field){
            if( vm.fieldMetaData[field] ) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                /// return reqd otherwise
                return $translate.instant(
                    "err.msg.required.field",
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
        }

        function getErrMessageOfStatus(row, applicationNumber, from, to){
            return $translate.instant(
                "device.request.edit.err.msg.cannot.allow.state.transition",
                {
                    row: row,
                    id: applicationNumber,
                    from: vm.getDeviceStatusFromKey(from),
                    to: vm.getDeviceStatusFromKey(to)
                }
            );
        }

        function getErrMessageDO (row, field, isWrongInput) {
            return $translate.instant(
                isWrongInput ? "device.request.edit.err.msg.device.owner" : "device.request.edit.err.msg.required.field",
                { row: row, param: vm.KeyMap[field][vm.getLang()] }
            );
        }

        function getInstallationStatusIndex(status){
            var statusMap = {
                "DRAFT": 0,
                "REGISTERED": 1,
                "ACCEPTED": 2,
                "UNDER_FULFILMENT": 3,
                "COMPLETED": 4,
                "APPLICATION_CANCELLED": 5
            };
            if(Object.keys(statusMap).indexOf(status) === -1) {
                return null;
            }
            return statusMap[status]
        }

        function isDIStateTransitionValid(statusBefore, statusAfter) {

            // no change detected
            if(statusBefore == statusAfter) {
                return true;
            }

            // status shifted backwards
            else if (
                vm.getInstallationStatusIndex(statusBefore) != null &&
                vm.getInstallationStatusIndex(statusAfter) != null &&
                vm.getInstallationStatusIndex(statusBefore) > vm.getInstallationStatusIndex(statusAfter)
            ) {
                if(vm.isSystemUser) {
                    if(
                        (statusBefore == "ACCEPTED" && statusAfter == "REGISTERED") ||
                        (statusBefore == "UNDER_FULFILMENT" && statusAfter == "REGISTERED")
                    ) {
                        return true;
                    }
                }
                return false;
            }

            // status moving forward
            else {
                // for common permissions
                if(
                    (statusBefore == "DRAFT" && statusAfter == "REGISTERED") ||
                    (statusBefore == "REGISTERED" && statusAfter == "APPLICATION_CANCELLED")
                ) {
                    return true;
                }
                // for System User
                else if(vm.isSystemUser) {
                    if(
                        (statusBefore == "REGISTERED" && statusAfter == "ACCEPTED") ||
                        (
                            statusBefore == "ACCEPTED" &&
                            ["UNDER_FULFILMENT", "APPLICATION_CANCELLED", "INVENTORY"].indexOf(statusAfter) !== -1
                        ) ||
                        (
                            statusBefore == "UNDER_FULFILMENT" &&
                            ["COMPLETED", "APPLICATION_CANCELLED", "INVENTORY"].indexOf(statusAfter) !== -1
                        ) 
                        ||  (statusBefore == "COMPLETED" && statusAfter == "INVENTORY") ||
                        (
                            statusBefore == "INVENTORY" &&
                            ["REMOVED", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        ) 
                    ) {
                        return true;
                    }
                }
                // otherwise
                return false;
            }
        }

        function getDeviceStatusFromKey(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);

            if(index === -1) return key;

            return ($translate.use() === "jp" ?
                    vm.types.DeviceInstallationStatus.jp[index] :
                    vm.types.DeviceInstallationStatus.en[index]);
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function downloadDeviceRequestExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest) ||
                vm.isDownloadingDIExcel == true
            ) {
                return false;
            }
            vm.isDownloadingDIExcel = true;
            var keys = vm.deviceRequest.map(function(i){
                return i.applicationNumber;
            });

            DeviceRequestService
            .downloadDeviceRequestExcel(keys)
            .then(function(resp) {
                vm.isDownloadingDIExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingDIExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function create(isDraft) {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            var message = vm.tableData.find(function(d){
                var index = vm.types.DeviceInstallationStatus.en.indexOf(d.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(d.status);
                }
                var indexValue = vm.types.DeviceInstallationStatus.key[index];

                return (indexValue === "INSTALLED" || indexValue === "RUNNING") && !vm.isMerchantAdmin;
            }) ? vm.localTranslator("device.request.edit.running.state.edit.message") : null;


            baUtil.showConfirm(null, message)
            .then(function() {

                var data = [];
                vm.tableData.forEach(function (row, i) {
                    var obj = {
                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
                        if( key === "paymentHandlingOptions" ) return;

                        if (key === 'date' || key == 'preferredDateOfInstallation') {
                            var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                            obj[key] = long;
                        }
                        else if (key.indexOf("paymentHandlingOption_") >= 0){
                            if(row[key]) {
                                var optionKey = key.replace('paymentHandlingOption_', '');
                                obj.paymentHandlingOptions.push(optionKey);
                            }
                        }
                        else if( key == "deviceOwnerId" ) {
                            var index = vm.types.deviceOwner[row.serviceContractId].en.indexOf(row[key]);
                            if (index < 0) {
                                index = vm.types.deviceOwner[row.serviceContractId].jp.indexOf(row[key]);
                            }
                            obj['deviceOwnerId'] = vm.types.deviceOwner[row.serviceContractId].key[index];
                        }
                        else if( key == "status" ) {
                            var index = vm.types.DeviceInstallationStatus.en.indexOf(row[key]);
                            if (index < 0) {
                                index = vm.types.DeviceInstallationStatus.jp.indexOf(row[key]);
                            }
                            var indexValue = vm.types.DeviceInstallationStatus.key[index];


                            if(indexValue == "DRAFT" && !isDraft) {
                                obj['status'] = "REGISTERED";
                            }
                            else
                                obj['status'] = indexValue;

                        }
                        else if( key == "type" ) {
                            var index = vm.types.DRExcelRequestTypeName.en.indexOf(row[key]);
                            if (index < 0) {
                                index = vm.types.DRExcelRequestTypeName.jp.indexOf(row[key]);
                            }
                            obj['type'] = vm.types.DRExcelRequestTypeName.key[index];
                        }
                        else {
                            obj[key] = row[key]
                        }
                    })

                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
                    if(obj['transportPaymentHandlingOption'] !== "-") {
                        obj.paymentHandlingOptions.push("TRANSPORT");
                    }

                    if( !(obj['version'] || "1.7").startsWith("2.") ) {
                        obj['version'] = "2.0";
                    }

                    data.push(obj)
                })

                data = data.filter(function(d, i){ return !vm.tableData[i].readOnly });
                if(!data.length) return;

                if(data.length > 9) {
                    vm.modal = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/modalTemplates/loadingModal.html',
                        size: "sm",
                        resolve: {
                          items: function () {
                            return $scope.items;
                        }}
                    });
                }

                if (isDraft) {
                    vm.draftInProgress = true;
                } else {
                    vm.createInProgress = true;
                }


                DeviceRequestService
                .updateDeviceRequest( data )
                .then(function success(response) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('RequestListCtrl', RequestListCtrl);

    /** @ngInject */
    function RequestListCtrl(requests, $filter, baUtil, types, filterOptions, $state, toastr, $stateParams, $translate, $timeout, $scope, AuthService, DeviceRequestService, $window, FileSaver, Blob, $uibModal, $sce) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.localTranslator = $filter('translate');
        vm.uploadForNewDeviceRequest = uploadForNewDeviceRequest;
        vm.uploadForNewJescaRequest = uploadForNewJescaRequest;
        vm.openDetail = openDetail;
        vm.openSuspendScreen = openSuspendScreen; 
        vm.showBulkEdit = showBulkEdit;
        vm.onBulkEdit = onBulkEdit;
        vm.onBulkJescaEdit = onBulkJescaEdit;
        vm.isEdit = false;
        vm.selectAll = selectAll;
        vm.getStatus = getStatus;
        vm.getJescaStatus = getJescaStatus;
        vm.bulkDeviceEdit = bulkDeviceEdit;
        vm.openDeviceDetail = openDeviceDetail;
        vm.showDeviceHistoryModal = showDeviceHistoryModal;
        vm.uploadForDeviceDetail = uploadForDeviceDetail;
        vm.downloadShipmentExcel = downloadShipmentExcel;
        vm.downloadDeviceJMupsExcelValidate = downloadDeviceJMupsExcelValidate;
        vm.downloadShipmentTMSExcel = downloadShipmentTMSExcel;
        vm.downloadDITMSExcel = downloadDITMSExcel;
        vm.jescaActivationCsvDownload = jescaActivationCsvDownload;
        vm.selectedRequests = {}
        vm.query = {}
        vm.filters = {}
        vm.paginateCallback = paginateCallback
        vm.isUndefinedOrNullOrEmptyObject = baUtil.isUndefinedOrNullOrEmptyObject
        vm.isCancelButtonVisible = isCancelButtonVisible
        vm.isDeleteButtonVisible = isDeleteButtonVisible
        vm.isBulkCancelDisabled = isBulkCancelDisabled
        vm.isBulkDeleteDisabled = isBulkDeleteDisabled
        vm.isBulkRemoveDisabled = isBulkRemoveDisabled
        vm.isSuspensionDisabled = isSuspensionDisabled
        vm.isDetachSuspendDropdownDisabled = isDetachSuspendDropdownDisabled
        vm.cancelDeviceRequest = cancelBulkDeviceRequest
        vm.removeTerminal = removeTerminal
        vm.deleteDeviceRequest = deleteBulkDeviceRequest
        vm.cancelBulkDeviceRequest = cancelBulkDeviceRequest
        vm.deleteBulkDeviceRequest = deleteBulkDeviceRequest
        vm.timeConverter = baUtil.timeConverter
        vm.isBulkDeviceRequestEditDisabled = isBulkDeviceRequestEditDisabled
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ ? true : false;
        vm.writeVisible = vm.permissions.DEVICE_REQUEST.SHOW_WRITE ? true : false;
        vm.isPartner = baUtil.isPartnerUser();
        vm.isMerchantOrMerchantAndDeviceOwner = baUtil.isMerchantOrMerchantAndDeviceOwner();
        vm.isDeviceOwner = baUtil.isDeviceOwner();
//        vm.isLoading = false;
        vm.applyFilters = applyFilters
        vm.clearFilters = clearFilters
        vm.filterOptions = filterOptions.data.data;
        vm.setFiltersOptionsOfCurrentLanguage = setFiltersOptionsOfCurrentLanguage;
        var dateFormat = "YYYY/MM/DD";

        vm.visibilityPermission = vm.isSystemUser ? {
                "serviceContract": true,
                "partner": true,
                "merchant_name": true,
                "device_owner_name": true,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": false
            } :
            vm.isPartner ? {
                "serviceContract": true,
                "partner": false,
                "merchant_name": true,
                "device_owner_name": true,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": false
            } :
            vm.isMerchantOrMerchantAndDeviceOwner ? {
                "serviceContract": false,
                "partner": false,
                "merchant_name": false,
                "device_owner_name": true,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": true
            } : vm.isDeviceOwner ? {
                "serviceContract": false,
                "partner": false,
                "merchant_name": true,
                "device_owner_name": false,
                "desired_delivery_date": false,
                "storeName": true,
                "branchName": false
            } : {
                "serviceContract": false,
                "partner": false,
                "merchant_name": true,
                "device_owner_name": false,
                "desired_delivery_date": false,
                "storeName": false,
                "branchName": false
            };

        vm.allowedStatusForCancel = vm.isSystemUser ? ["REGISTERED", "ACCEPTED", "UNDER_FULFILMENT"] : ["REGISTERED"];
        vm.allowedStatusForDelete = ["DRAFT"];
        vm.allowedStatusForRemoved = ["COMPLETED","INSTALLED","RUNNING","REMOVED","REMOVED_AND_SETTLED","PORTAL_DETACHED","PORTAL_DETACHED_AND_SETTLED"];
        vm.allowedStatusForSuspension = ["COMPLETED","INSTALLED","RUNNING","PROCESSING_SUSPENSION","SUSPENDED"];
        vm.allowedStatusForDropdown = ["COMPLETED","INSTALLED","RUNNING","PROCESSING_SUSPENSION","SUSPENDED","REMOVED","REMOVED_AND_SETTLED","PORTAL_DETACHED","PORTAL_DETACHED_AND_SETTLED"];

        if (requests.status >= 200 && requests.status <= 299) {
            vm.requests = requests.data.data;
        }

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        vm.dateOptions = {
            format: dateFormat,
            dayViewHeaderFormat:'YYYY[年]  MMMM',
            locale:'ja',
            minDate : new Date(1970,0,2)
         }
         if (baUtil.isSystemAdmin()) {
            vm.systemAdmin = true;
        }
        else {
            vm.systemAdmin = false;
        }


         vm.changeFirstDateRange = changeFirstDateRange;

        function createdByOrgTitle() {
            vm.createdByOrgTitle = {};
            for (var i=0; i < vm.requests.content.length; i++) {

                if (vm.requests.content[i].createdByOrg == 'SYSTEM') {
                    vm.createdByOrgTitle[i] = "SYSTEM";
                }
                else {
                    if (baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg;
                    }
                    else if (!baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgMerchantCode + ' / ' + vm.requests.content[i].createdByOrgDeviceOwnerCode + ')';
                    }
                    else if (baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgDeviceOwnerCode + ')';
                    }
                    else if (!baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(vm.requests.content[i].createdByOrgDeviceOwnerCode)) {
                        vm.createdByOrgTitle[i] = vm.requests.content[i].createdByOrg + ' (' + vm.requests.content[i].createdByOrgMerchantCode + ')';
                    }
                }
            }
        }

        createdByOrgTitle();


//       Todo: Change the old for loop createdByOrgTitle function with the below angular.forEach after 31-Oct-2019 -------------- Task for Pradeep -------------
//              refactor for race condition by creating this function by calling in view : comment by @mohitSan

//        function createdByOrgTitle() {
//            vm.createdByOrgTitle = {};
//            vm.requests.content.forEach(function (item, key) {
//                if(item.createdByOrg == 'SYSTEM') {
//                    vm.createdByOrgTitle[key] = "SYSTEM";
//                }
//                else {
//                    if(baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgDeviceOwnerCode)) {
//                        vm.createdByOrgTitle[key] = item.createdByOrg;
//                    }
//                    else if(!baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgDeviceOwnerCode)) {
//                        vm.createdByOrgTitle[key] = item.createdByOrg + ' (' + item.createdByOrgMerchantCode + ' / ' + item.createdByOrgDeviceOwnerCode + ')';
//                    }
//                    else if(baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgMerchantCode) && !baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgDeviceOwnerCode)) {
//                        vm.createdByOrgTitle[key] = item.createdByOrg + ' (' + item.createdByOrgDeviceOwnerCode + ')';
//                    }
//                    else if(!baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgMerchantCode) && baUtil.isUndefinedOrNullOrEmpty(item.createdByOrgDeviceOwnerCode)) {
//                        vm.createdByOrgTitle[key] = item.createdByOrg + ' (' + item.createdByOrgMerchantCode + ')';
//                    }
//                }
//            })
//        }

        $scope.$on('LANG_CHANGE', function (event) {
            setFiltersOptionsOfCurrentLanguage();
        });

        function setFiltersOptionsOfCurrentLanguage() {

            vm.filterOptions.options = {};
            setFilterOptionsOfKey("ProductName", "productName");
            setFilterOptionsOfKey("DeviceInstallationStatus", "status");
            setFilterOptionsOfKey("DeviceJescaStatus", "jesca_status");
            setFilterOptionsOfKey("ServiceContractId", "serviceContractId");
            var replacementOptions = {en: 'Show Replacement Devices', jp:'交換端末表示' }
            vm.filterOptions.options["Replacement"] = [{label: replacementOptions[getLang()], value: true}]

            if( !(vm.isSystemUser || vm.isPartner) ) {
                setFilterOptionsOfKey("DeviceInstallationSettlementBranch", "settlementBranch");
            }

            if(vm.isMerchantOrMerchantAndDeviceOwner || vm.isSystemUser || vm.isPartner) {
                setFilterOptionsOfKey("DeviceInstallationDeviceOwner", "deviceOwner");
            }

            if(vm.isDeviceOwner || vm.isSystemUser || vm.isPartner) {
                setFilterOptionsOfKey("DeviceInstallationMerchant", "merchant");
            }

            if(vm.isSystemUser) {
                setFilterOptionsOfKey("DeviceInstallationPartner", "partner");
            }

            vm.filterOptions.options["DateOptions"] = (vm.filterOptions["DateOptions"]||[]).map(function(d,i){
                return { label: d[getLang()], value: d["key"] };
            });

            vm.filterOptions.options["productName"] = (vm.filterOptions.options["productName"]||[]).map(function(d,i){
                return { label: d["label"], value: d["label"] };
            });

            vm.filterOptions.options["devices"] = (vm.filterOptions["Devices"]||[]).map(function(d,i){
                return { label: d, value: d };
            });


        }

        setFiltersOptionsOfCurrentLanguage();

        function setFilterOptionsOfKey(targetKey, resultKey) {
            try {
                var keys = vm.filterOptions[targetKey]["key"];
                vm.filterOptions.options[resultKey] = vm.filterOptions[targetKey][$translate.use()].map(function(d,i){
                    return { label: d, value: keys[i] };
                });
            }
            catch(e) {
                vm.filterOptions.options[resultKey] = [];
            }
        }

        function applyFilters() {
            vm.isLoading = true;
            if(vm.filters && vm.filters.DEVICE_REPLACEMENT && vm.filters.DEVICE_REPLACEMENT.length) {
                vm.filters.DEVICE_REPLACEMENT = [{label: vm.filters.DEVICE_REPLACEMENT[0].label, value: true}];
            } else {
                delete vm.filters.DEVICE_REPLACEMENT;
            }

            if(vm.filters && vm.filters.expectedDeliveryDateFrom && vm.filters.expectedDeliveryDateTo) {
                vm.filters.expectedDeliveryDateFrom = new Date(vm.filters.expectedDeliveryDateFrom);
                vm.filters.expectedDeliveryDateTo = new Date(vm.filters.expectedDeliveryDateTo);
                vm.filters.EXPECTED_DELIVERY_DATE = [{label: vm.filters.expectedDeliveryDateFrom, value: new Date(vm.filters.expectedDeliveryDateFrom).getTime()},
                    {label: vm.filters.expectedDeliveryDateTo, value: new Date(vm.filters.expectedDeliveryDateTo).getTime()}];
            }

            if(vm.filters && vm.filters.search) {
                if(vm.filters.search.installationLocation) {
                    vm.filters.INSTALLATION_LOCATION = [{label: vm.filters.search.installationLocation, value: vm.filters.search.installationLocation}];
                } else {
                    delete vm.filters.INSTALLATION_LOCATION;
                }

                if(vm.filters.search.DEVICE_SERIAL) {
                    var deviceSerialString = vm.filters.search.DEVICE_SERIAL;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.DEVICE_SERIAL = [];

                    angular.forEach(deviceSerialArray, function(values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.DEVICE_SERIAL.push({label:noComma, value:noComma});
                        }

                    });
                }
                else {
                    delete vm.filters.DEVICE_SERIAL;
                }

                if(vm.filters.search.DEVICE_APPLICATION_NUMBER) {
                    var deviceSerialString = vm.filters.search.DEVICE_APPLICATION_NUMBER;
                    var deviceSerialArray = deviceSerialString.split(/[ ,]+/);
                    vm.filters.DEVICE_APPLICATION_NUMBER = [];

                    angular.forEach(deviceSerialArray, function(values, item) {
                        var noComma = values.split(',').join("");
                        if (noComma !== '') {
                            vm.filters.DEVICE_APPLICATION_NUMBER.push({label:noComma, value:noComma});
                        }

                    });
                }
                else {
                    delete vm.filters.DEVICE_APPLICATION_NUMBER;
                }

                if(vm.filters.search.remarks) {
                    vm.filters.REMARKS = [{label: vm.filters.search.remarks, value: vm.filters.search.remarks}];
                } else {
                    delete vm.filters.REMARKS;
                }
            }


            if(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress) return;
             
            
            var filterString = Object.keys(vm.filters).map(function(d,i){
                return vm.filters[d] && vm.filters[d].length ?
                        d +":"+ vm.filters[d].map(function(data){return data["value"]}).join("|") :
                        "";
            }).filter(function (val){return val != ""}).join(",");
            vm.query.filters = filterString;
            vm.query.pageNumber = 0;
            vm.dataFetchInProgress = true
            DeviceRequestService
            .getAllDeviceInstallation(vm.query)
            .then(function (response) {
                vm.dataFetchInProgress = false;
                vm.requests = response.data.data;
                vm.selectedRequests = {};
                vm.select = false;
                createdByOrgTitle();
                vm.isLoading = false;

            }, function err(err) {
                vm.dataFetchInProgress = false;
                vm.isLoading = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function clearFilters() {
            vm.isLoading = true;
            if(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress) return;
            vm.filters = {};
            delete vm.query.filters;
            delete vm.opFirstSelect;
            vm.query.pageNumber = 0;
            vm.dataFetchInProgressUsingClear = true
            DeviceRequestService
            .getAllDeviceInstallation(vm.query)
            .then(function (response) {
                vm.dataFetchInProgressUsingClear = false;
                vm.requests = response.data.data;
                vm.selectedRequests = {};
                vm.select = false;
                createdByOrgTitle();
                vm.isLoading = false;
            }, function err(err) {
                vm.dataFetchInProgressUsingClear = false;
                vm.isLoading = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function uploadForNewDeviceRequest(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name.toLowerCase(), [".xlsx"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.newDeviceInProgress = true;

                DeviceRequestService
                .uploadDeviceInstallationRequest(file)
                .then(function (response) {
                    vm.newDeviceInProgress = false;
                    $state.go('main.deviceRequest.createMultiple', { deviceRequest: response.data.data, isJescaUpload : false});
                    }, function err(err) {
                    ev.target.value = "";
                    vm.newDeviceInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }
        function uploadForNewJescaRequest(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name.toLowerCase(), [".xlsx"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.isJescaExcelUpload = true;

                DeviceRequestService
                .uploadDeviceInstallationRequest(file)
                .then(function (response) {
                    vm.isJescaExcelUpload = false;
                    $state.go('main.deviceRequest.createMultiple', { deviceRequest: response.data.data, isJescaUpload : true});
                    }, function err(err) {
                    ev.target.value = "";
                    vm.isJescaExcelUpload = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }


        function uploadForDeviceDetail(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name, [".xlsx"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.inProgress = true;
                DeviceRequestService
                .uploadDevice(file)
                .then(function (response) {
                    vm.inProgress = false;
                    $state.go('main.deviceRequest.parseDeviceDetail', { deviceDetailList: response.data.data});
                }, function err(err) {
                    ev.target.value = "";
                    vm.inProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }

        function downloadShipmentExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) ||
                vm.isDownloadingExcel == true
            ) {
                return false;
            }
            vm.isDownloadingExcel = true;
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });

            DeviceRequestService
            .downloadDeviceShipmentProgress(keys)
            .then(function(resp){
                vm.isDownloadingExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function downloadDeviceJMupsExcel(keys) {
            DeviceRequestService
                .downloadDeviceJMupsExcel(keys)
                .then(function(resp) {
                    vm.isDownloadingJMupsExcel = false;
                    var headers = resp.headers();
                    var filename = headers["content-disposition"];
                    filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                    var serverData = new Blob([resp.data], {type: headers['content-type']});
                    FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
                },function(err) {
                    vm.isDownloadingJMupsExcel = false;
                    if ("TextDecoder" in window) {
                        try {
                            var enc = new TextDecoder("utf-8");
                            var data = enc.decode(err.data);
                            err = JSON.parse(data);
                        } catch(ignore){ }
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function downloadDeviceJMupsExcelValidate() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) || vm.isDownloadingJMupsExcel == true) {
                return false;
            }
            vm.isDownloadingJMupsExcel = true;
            var keys = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });

            downloadDeviceJMupsExcelValidate(keys);
            DeviceRequestService
                .downloadDeviceJMupsExcelValidate(keys)
                .then(function(resp) {
                    var validation = resp.data.data;
                    if (validation.status === 'success') {
                        downloadDeviceJMupsExcel(keys);
                    }else {
                        baUtil.showConfirm(
                            '',
                            vm.localTranslator("device.request.list.download.jmups.excel.confirm.msg1") + '<br> 「'+ validation.scids + '」 <br>'+
                            vm.localTranslator("device.request.list.download.jmups.excel.confirm.msg2"),
                            vm.localTranslator("common.components.btn.yes")
                        ).then(function() {
                            downloadDeviceJMupsExcel(keys);
                        }).catch(function(error) {
                            vm.isDownloadingJMupsExcel = false;
                        })

                    }
                },function(err) {
                    vm.isDownloadingJMupsExcel = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function downloadShipmentTMSExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) ||
                vm.isDownloadingShipmentTMSExcel == true
            ) {
                return false;
            }
            vm.isDownloadingShipmentTMSExcel = true;
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });

            DeviceRequestService
            .downloadShipmentTMSExcel(keys)
            .then(function(resp) {
                vm.isDownloadingShipmentTMSExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            }, function(err) {
                vm.isDownloadingShipmentTMSExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function downloadDITMSExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) ||
                vm.isDownloadingDITMSExcel == true
            ) {
                return false;
            }
            vm.isDownloadingDITMSExcel = true;
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });

            DeviceRequestService
            .downloadDITMSExcel(keys)
            .then(function(resp) {
                vm.isDownloadingDITMSExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            }, function(err) {
                vm.isDownloadingDITMSExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function jescaActivationCsvDownload() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests) ||
                vm.isDownloadingDITMSExcel == true
            ) {
                return false;
            }
            vm.isDownloadingJescaActivationCsv = true;
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });

            DeviceRequestService
            .downloadJescaActivationCsv(keys)
            .then(function(resp) {
                vm.isDownloadingJescaActivationCsv = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            }, function(err) {
                vm.isDownloadingJescaActivationCsv = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function openDetail(deviceInstallationId) {
            DeviceRequestService
            .getDeviceInstallationDetailFromList([deviceInstallationId])
            .then(function success(response) {
                $state.go('main.deviceRequest.detail', { deviceInstallation: response });
            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function openDeviceDetail(ev, data) {
            $state.go('main.deviceRequest.deviceDetail', { ids: data.applicationNumber });
        }

        function isBulkDeviceRequestEditDisabled() {
            return Object.keys(vm.selectedRequests)
                         .filter(function (id) {return vm.selectedRequests[id] })
                         .length === 0;
        }

        function onBulkEdit() {
            var keys = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            vm.isBulkEditInProgress = true;
            DeviceRequestService
            .getDeviceInstallationDetailFromList(keys)
            .then(function success(response) {
                vm.isBulkEditInProgress = false;
                $state.go('main.deviceRequest.detail', { deviceInstallation: response });
            }, function err(err) {
                vm.isBulkEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function onBulkJescaEdit() {
        $state.go('main.deviceRequest.jesca', { });
        if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)){
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });
            
            vm.isBulkEditJescaInProgress = true;
            DeviceRequestService
            .getJescaDetailFromList(keys)
            .then(function success(response) {
                vm.isBulkEditJescaInProgress = false;
                getResetButtonStatus(response,keys);
            }, function err(err) {
                vm.isBulkEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                    )
                });
            }
            else {
                var keys =[{}];
                $state.go('main.deviceRequest.jesca');
            }
        }
        
        function getResetButtonStatus(deviceInstallationresponse,keys){
            DeviceRequestService
            .getResetFlag(keys)
            .then(function success(response) {
                $state.go('main.deviceRequest.jesca', { deviceInstallation: deviceInstallationresponse,resetButtonStatus : response.data.data  });
            }, function err(err) {
                vm.isBulkEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }


        function bulkDeviceEdit() {
            var keys = vm.requests.content.map(function(i){
                return vm.selectedRequests[i.deviceInstallationId] ? i.applicationNumber : null;
            }).filter(function(d){ return d; });

            vm.isBulkDeviceEditInProgress = true;
            DeviceRequestService
            .getDeviceList(keys)
            .then(function success(response) {
                vm.isBulkDeviceEditInProgress = false;
                $state.go('main.deviceRequest.deviceDetail', { deviceDetailList: response.data.data });
            }, function err(err) {
                vm.isBulkDeviceEditInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
            });
        }

        function showBulkEdit() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return false
            }

            return Object.keys(vm.selectedRequests).some(function (item) {
                return vm.selectedRequests[item]
            })
        }

        function selectAll(ev, list) {
            list.forEach(function (item) {
                vm.selectedRequests[item.deviceInstallationId] = ev.target.checked
            })
        }

        function isCancelButtonVisible(status) {
            if( vm.allowedStatusForCancel.indexOf(status) === -1 )
                    return false;
            return true;
        }
        function isDeleteButtonVisible(status) {
            if( vm.allowedStatusForDelete.indexOf(status) === -1 )
                    return false;
            return true;
        }

        function isBulkCancelDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForCancel.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }

        function isBulkDeleteDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForDelete.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }


        function isBulkRemoveDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.MGMNT_WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForRemoved.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }

        function isDetachSuspendDropdownDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.MGMNT_WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForDropdown.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }

        function isSuspensionDisabled() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                return true;
            }
            var flag = false;
            var list = Object.keys(vm.selectedRequests)
                             .filter(function (id) { return vm.selectedRequests[id] });

            if( list.length === 0 || !vm.permissions.DEVICE_REQUEST.MGMNT_WRITE) {
                return true;
            }

            list.forEach(function (item) {
                var device = vm.requests.content.find(function(i){ return i.deviceInstallationId == item });
                if( device && vm.allowedStatusForSuspension.indexOf(device.status) === -1 )
                    flag = true;
            });

            return flag;
        }


        function getStatus(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);
            return vm.types.DeviceInstallationStatus[$translate.use()][index]
        }

        function getJescaStatus(key) {
            var index = vm.types.DeviceJescaStatus.key.indexOf(key);
            return vm.types.DeviceJescaStatus[$translate.use()][index]
        }

        function paginateCallback(query) {
            DeviceRequestService
            .getAllDeviceInstallation(query)
            .then(function (response) {
                vm.requests = response.data.data;
                vm.query = query;
                vm.selectedRequests = {};
                vm.select = false;
                createdByOrgTitle();
            });
        }


        function cancelBulkDeviceRequest(deviceInstallationId) {
            if(deviceInstallationId) {
                var ids = [deviceInstallationId];
            }
            else {
                if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                    return false
                }
                var ids = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            }

            baUtil.showConfirm(
                vm.localTranslator("common.components.title.cancel"),
                vm.localTranslator("device.request.list.msg.confirm.cancel"),
                vm.localTranslator("common.components.btn.yes")
            )
            .then(function() {
                vm.isBulkCancelInProgress = deviceInstallationId ? vm.isBulkCancelInProgress : true;
                DeviceRequestService
                .cancelBulkDeviceRequest(ids)
                .then(function success(response) {
                    vm.isBulkCancelInProgress = deviceInstallationId ? vm.isBulkCancelInProgress : false;
                    toastr.success(
                        vm.localTranslator('device.request.list.msg.success.cancel'),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    )
                    $state.reload()
                }, function err(err) {
                    vm.isBulkCancelInProgress = deviceInstallationId ? vm.isBulkCancelInProgress : false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    )
                });
            });
        }

        function deleteBulkDeviceRequest(deviceInstallationId) {
            if(deviceInstallationId) {
                var ids = [deviceInstallationId];
            }
            else {
                if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedRequests)) {
                    return false
                }
                var ids = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            }


            baUtil.showConfirm(
                vm.localTranslator("common.components.title.delete"),
                vm.localTranslator("device.request.list.msg.confirm.delete"),
                vm.localTranslator("common.components.btn.yes")
            )
            .then(function() {
                vm.isBulkDeleteInProgress = deviceInstallationId ? vm.isBulkDeleteInProgress : true;
                DeviceRequestService
                .deleteBulkDeviceRequest(ids)
                .then(function success(response) {
                    vm.isBulkDeleteInProgress = deviceInstallationId ? vm.isBulkDeleteInProgress : false;
                    toastr.success(
                        vm.localTranslator('device.request.list.msg.success.delete'),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    )
                    $state.reload()
                }, function err(err) {
                    vm.isBulkDeleteInProgress = deviceInstallationId ? vm.isBulkDeleteInProgress : false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    )
                });
            });
        }


        function removeTerminal() {
            vm.detachTerminalLoader = true;
            var keys = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            var rowKp = [];
            var appNum = [];
            vm.removeTerminalRow = [];

            keys.forEach(function (kkey, ukey) {
                vm.requests.content.filter(function (item) {
                    if (item.deviceInstallationId == kkey) {
                        rowKp.push(item);
                        appNum.push(item.applicationNumber);
                        vm.removeTerminalRow[ukey] = {
                            serviceContractId : item.serviceContractId,
                            companyName : item.companyName,
                            applicationNumber : item.applicationNumber,
                            deviceSerial : item.deviceSerial,
                            status : item.status
                        }
                    }

                })

            })

            DeviceRequestService
            .getTerminalDetails(appNum)
            .then(function success(response) {

                vm.responseRow = response.data.data.DeviceInstallationRemovalDtos;
                vm.default_addMonthlyFee = response.data.data.default_addMonthlyFee;
                vm.default_freeApplicationNumber = response.data.data.default_freeApplicationNumber;
                vm.removalReasons = response.data.data.RemovalReasons;
                vm.errorMessage = response.data.data.errorMessage;
                vm.detachTerminalLoader = false;
                vm.removeTerminalRow.forEach(function (value,key) {
                        vm.responseRow.forEach(function (item) {
                            if (item.applicationNumber == value.applicationNumber) {
                                vm.removeTerminalRow[key].startTime = item.startTime
                                vm.removeTerminalRow[key].lastCommunicationTime = item.lastCommunicationTime
                                vm.removeTerminalRow[key].removalDate = item.removalDate
                                vm.removeTerminalRow[key].nextBatchWillRunOn = item.nextBatchWillRunOn
                                vm.removeTerminalRow[key].operationApplicableTime = item.operationApplicableTime
                                vm.removeTerminalRow[key].lastSalesTime = item.lastSalesTime
    
                                if (value.status == 'PORTAL_DETACHED' || value.status == 'PORTAL_DETACHED_AND_SETTLED' || value.status == 'REMOVED_AND_SETTLED') {
                                    vm.removeTerminalRow[key].addMonthlyFee = item.addMonthlyFee
                                    vm.removeTerminalRow[key].freeApplicationNumber = item.freeApplicationNumber
                                }
                                else{
                                    vm.removeTerminalRow[key].addMonthlyFee = vm.default_addMonthlyFee
                                    vm.removeTerminalRow[key].freeApplicationNumber = vm.default_freeApplicationNumber
                                }
                                vm.removeTerminalRow[key].operationReason = item.operationReason
                                vm.removeTerminalRow[key].operationComment = item.operationComment
                            }
    
                        })
                    })
    
                    var data = [];
                    data[0] = vm.removeTerminalRow;
                    data[1] = vm.removalReasons;
                    data[2] = vm.default_addMonthlyFee;
                    data[3] = vm.default_freeApplicationNumber;
                    $state.go('main.deviceRequest.removeTerminal', { removeDeviceMap: data});
                
            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("device.request.list.msg.error")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                vm.detachTerminalLoader = false;
            });

        }

       


        function changeFirstDateRange() {
            var dates = getDatePair(vm.filterOptions.DateOptions.filter(function(op){return op.key===vm.opFirstSelect.value})[0]);
            vm.filters.expectedDeliveryDateFrom = new Date(dates[0]);
            vm.filters.expectedDeliveryDateTo = new Date(dates[1]);
        }

        function getDatePair(dateOption) {
            var isDay, isWeek, isMonth, isYear;
            isDay = (dateOption.unit == 1);
            isWeek = (dateOption.unit == 2);
            isMonth = (dateOption.unit == 3);
            isYear = (dateOption.unit == 4);

            var fromValue = dateOption.from - 1;
            var toValue = dateOption.to - 1;
            var today = new Date();
            var lastDay = new Date();
            var month = today.getMonth();
            var year = today.getFullYear();

            var fromDate, toDate;

            if (isDay) {
                var startDate = today.getDate() - fromValue;
                var endDate = lastDay.getDate() - toValue;
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(endDate);
            } else if (isWeek) {
                var weekDay = fromValue*7;
                var startDate = today.getDate() - today.getDay() - weekDay + (today.getDay() === 0 ? -6 : 0);
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(lastDay.getDate() - lastDay.getDay() - (toValue*7) + 6);
                if (toDate > new Date().getTime()) {
                    toDate = new Date().getTime();
                }
            } else if (isMonth) {
                var fromMonth = month - fromValue;
                var toMonth = month - toValue + 1;
                fromDate = new Date(year, fromMonth, 1).getTime();
                toDate = new Date(year, toMonth, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            } else if (isYear) {
                var fromYear = year - fromValue;
                var toYear = year - toValue;
                fromDate = new Date(fromYear, 0, 1).getTime();
                toDate = new Date(toYear,12, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            }
            return [fromDate, toDate];
        }


        function openSuspendScreen() {
            vm.detachTerminalLoader = true;
            var keys = Object.keys(vm.selectedRequests).filter(function (id) { return vm.selectedRequests[id] });
            var rowKp = [];
            var appNum = [];
            vm.suspensionTerminalRow = [];

            keys.forEach(function (kkey, ukey) {
                vm.requests.content.filter(function (item) {
                    if (item.deviceInstallationId == kkey) {
                        rowKp.push(item);
                        appNum.push(item.applicationNumber);
                        vm.suspensionTerminalRow[ukey] = {
                            serviceContractId : item.serviceContractId,
                            merchantName : item.companyName,
                            applicationNumber : item.applicationNumber,
                            deviceSerial : item.deviceSerial,
                            status : item.status
                        }
                    }

                })

            })

            DeviceRequestService
            .getSuspensionTerminalDetails(appNum)
            .then(function success(response) {
                vm.responseRow = response.data.data.DeviceInstallationSuspensionDtos;
                vm.default_addMonthlyFee = response.data.data.default_addMonthlyFee;
                vm.default_addInitialFee = response.data.data.default_addInitialFee;
                vm.resumeReasons = response.data.data.ResumeReasons;
                vm.suspensionReasons = response.data.data.SuspensionReasons;
                vm.allowedStatus = response.data.data.OperationTypeSuspensionScreen;
                vm.suspensionTerminalRow.forEach(function (value,key) {
                    vm.responseRow.forEach(function (item) {
                        if (item.applicationNumber == value.applicationNumber) {
                            vm.suspensionTerminalRow[key].id = item.id
                            vm.suspensionTerminalRow[key].addMonthlyFee = item.addMonthlyFee
                            vm.suspensionTerminalRow[key].addInitialFee = item.addInitialFee
                            vm.suspensionTerminalRow[key].nextBatchWillRunOn = item.nextBatchWillRunOn
                            vm.suspensionTerminalRow[key].operation = item.operation
                            vm.suspensionTerminalRow[key].applicableDate = item.applicableDate
                            vm.suspensionTerminalRow[key].lastCommunicationTime = item.lastCommunicationTime
                            vm.suspensionTerminalRow[key].operationComment = item.operationComment
                            vm.suspensionTerminalRow[key].operationReason = item.operationReason
                            vm.suspensionTerminalRow[key].operationStartDate = item.operationStartDate
                            vm.suspensionTerminalRow[key].statusFrom = item.statusFrom
                            vm.suspensionTerminalRow[key].toBeStatus = item.toBeStatus
                        }

                    })
                })

                var data = [];
                data[0] = vm.suspensionTerminalRow;
                data[1] = vm.resumeReasons;
                data[2] = vm.suspensionReasons;
                data[3] = vm.default_addMonthlyFee;
                data[4] = vm.default_addInitialFee;
                data[5] = vm.allowedStatus;

                $state.go('main.deviceRequest.deviceSuspend', { suspendDeviceMap: data});

            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                vm.detachTerminalLoader = false;
            });
        }


        function showDeviceHistoryModal(deviceSerial) {
            $uibModal.open({
              animation: false,
              controller: 'DeviceHistoryCtrl',
              templateUrl: 'app/pages/device-request/views/device-history-modal.html',
              controllerAs: 'vm',
              size: "xl",
              resolve: {
                deviceSerialNum: function () {
                  return deviceSerial;
                },
                types:vm.types.DeviceInstallationStatus
              }
            });
          };
      

        function getLang() {
            return $translate.use();
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .controller('SuspendDeviceCtrl', SuspendDeviceCtrl);

    /** @ngInject */
    function SuspendDeviceCtrl(types, $filter, baUtil, $state, toastr, $stateParams, $translate, DeviceRequestService, $scope, $timeout) {

        
        if( $stateParams.suspendDeviceMap == null ) {
            $state.go("main.deviceRequest.list");
        }

        var vm = this;

        vm.cancel = cancel;
        vm.submit = submit;

        vm.localTranslator = $filter('translate');

        vm.getLang = getLang;
        vm.errors = {};
        vm.latestState = null;
        vm.feeObj = null;
        vm.alerts = [];
        vm.isFormValid = isFormValid;
        var feesApiResponse;
        var statusApiResponse;
        var maxAllowedDate = moment().endOf('month').add(6, 'months').endOf('month').toDate();

        var suspendDeviceMap = $stateParams.suspendDeviceMap[0];
        vm.resumeReasons = $stateParams.suspendDeviceMap[1];
        vm.suspensionReasons = $stateParams.suspendDeviceMap[2];
        vm.default_addMonthlyFee = $stateParams.suspendDeviceMap[3];
        vm.default_addInitialFee = $stateParams.suspendDeviceMap[4];
        vm.operationTypes = $stateParams.suspendDeviceMap[5];

        vm.addMonthlyFee = {
            en:['Yes','No'],
            jp:['はい','いいえ'],
            key:['true','false']
        }
        vm.addInitialFee = {
            en:['Yes','No'],
            jp:['はい','いいえ'],
            key:['true','false']
        }
       


        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }

        suspendOrRemoveDevice(suspendDeviceMap);


        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function suspendOrRemoveDevice(rowData) {
                    vm.tableRowData = [];
                    vm.tableData = [{}];
                    vm.tableOptions = {};

                    vm.deviceTableHeader = {
                        serviceContractId: {
                            en: 'Contract ID',
                            jp: '契約先ID',
                            column: 'serviceContractId'
                        },
                        merchantName: {
                            en: 'Merchant Name',
                            jp: '会社名',
                            column: 'merchantName'
                        },
                        applicationNumber: {
                            en: 'Application Number',
                            jp: '申込通番',
                            column: 'applicationNumber'
                        },
                        deviceSerial: {
                            en: 'Device Serial',
                            jp: '端末シリアル',
                            column: 'deviceSerial'
                        },
                        status: {
                            en: 'Current Status',
                            jp: '現在の状況',
                            column: 'status'
                        },
                        statusFrom: {
                            en: 'Current Status From',
                            jp: '現在の状況開始日',
                            column: 'statusFrom'
                        },
                        operation: {
                            en: 'Operation',
                            jp: '操作',
                            column: 'operation'
                        },
                    
                        applicableDate: {
                            en: 'Operation Effective From',
                            jp: '適用日時',
                            column: 'applicableDate'
                        },
                        toBeStatus: {
                            en: 'TO-BE State',
                            jp: '次の状況',
                            column: 'toBeStatus'
                        },
                        operationStartDate: {
                            en: 'Operation Start Date',
                            jp: '稼働開始日',
                            column: 'operationStartDate'
                        },
                        
                        lastCommunicationTime: {
                            en: 'Last Communication Date',
                            jp: '最終通信日',
                            column: 'lastCommunicationTime'
                        },
                        nextBatchWillRunOn: {
                            en: 'Next Batch Run Date',
                            jp: '次のバッチ実行日',
                            column: 'nextBatchWillRunOn'
                        },
                        addInitialFee: {
                            en: 'Charge Initial Fee?',
                            jp: '初期費用を請求？',
                            column: 'addInitialFee'
                        },
                      
                        addMonthlyFee: {
                            en: 'Charge Monthly Fee?',
                            jp: '月額費用を請求？',
                            column: 'addMonthlyFee'
                        },
                        operationReason: {
                            en: 'Reason Of Status Change',
                            jp: '状況を変える理由',
                            column: 'operationReason'
                        },
                        operationComment: {
                            en: 'Enter Comment',
                            jp: 'コメントを入力',
                            column: 'operationComment'
                        },
                    }


                    rowData.forEach(function (item, index) {
                        var obj = {};
                        var keys = Object.keys(item)
                        keys.forEach(function (field) {
                            var value = item[field]
                            if (field === 'nextBatchWillRunOn') {
                                obj[field] = $filter('date')(value, "yyyy/MM/dd HH:mm:ss");
                                return
                            }
                            else if (field === 'statusFrom' || field === 'lastCommunicationTime' || field === 'operationStartDate'){
                                if (value === 0 || value === null) {
                                    obj[field] = $filter('translate')('common.components.data.not.available');
                                    return
                                }
                                else {
                                    obj[field] = $filter('date')(value, "yyyy/MM/dd HH:mm:ss");
                                    return
                                }
                            }
                            else if (field === 'applicableDate'){
                                if (value === null) {
                                    obj[field] = $filter('date')(new Date(), "yyyy/MM/dd HH:mm:ss");
                                    return
                                } else{
                                    obj[field] = $filter('date')(value, "yyyy/MM/dd HH:mm:ss");
                                    return
                                }
                            }
                            else if (field === 'addMonthlyFee'){
                                if (value === true) {
                                    obj[field] = monthlyFee(value);
                                    return
                                }
                                else if(value === false) {
                                    obj[field] = monthlyFee(value);
                                    return
                                }
                            }
                            else if (field === 'addInitialFee'){
                                if (value === true) {
                                    obj[field] = initialFee(value);
                                    return
                                }
                                else if (value === false){
                                    obj[field] = initialFee(value);
                                    return
                                }
                            }
                            
                            else if (field === 'status'){
                                obj[field] = getStatus(value);
                                return
                            }

                            else if (field === 'toBeStatus'){
                                obj[field] = getStatus(value);
                                return
                            }

                            else if (field === 'operationReason'){
                                obj[field] = value === "" ? null : getSuspensionReasons(value) ? getSuspensionReasons(value): getResumeReasons(value);
                                return
                            }
                            else if (field === 'operation'){
                                obj[field] = getOperationType(value);
                                return
                            }
                            else {
                                obj[field] = value;
                            }
                        })
                        vm.tableRowData.push(obj)
                    })

                    vm.KeyMap = vm.deviceTableHeader;
                    vm.KeyMap.serviceContractId.readOnly = true;
                    vm.KeyMap.merchantName.readOnly = true;
                    vm.KeyMap.applicationNumber.readOnly = true;
                    vm.KeyMap.deviceSerial.readOnly = true;
                    vm.KeyMap.status.readOnly = true;
                    vm.KeyMap.statusFrom.readOnly = true;
                    vm.KeyMap.operation.readOnly = false;
                    vm.KeyMap.applicableDate.readOnly = false
                    vm.KeyMap.toBeStatus.readOnly = true;
                    vm.KeyMap.toBeStatus.validators = ['required'];
                    vm.KeyMap.lastCommunicationTime.readOnly = true;
                    vm.KeyMap.operationStartDate.readOnly = true;
                    vm.KeyMap.nextBatchWillRunOn.readOnly = true;
               
        //            vm.keyMap.applicableDate.colspan = 3;
                    vm.KeyMap.addMonthlyFee.readOnly = true;
                    vm.KeyMap.addMonthlyFee.validators = ['required'];

                    vm.KeyMap.addInitialFee.readOnly = true;
                    vm.KeyMap.addInitialFee.validators = ['required'];

                    vm.KeyMap.operationReason.readOnly = false;
                    vm.KeyMap.operationComment.readOnly = false;

                    vm.tableSettings = {
                        colHeaders: [],
                        rowHeaders: true,
                        currentRowClassName: 'currentRow',
                        currentColClassName: 'currentCol',
                        invalidCellClassName: 'cell-has-error',
                        columns: [],
                        fixedColumnsLeft: 4,
                        modifyColWidth: function(width, col) {
                            if(col === 2 || col === 3) {
                                return 150;
                            }else if (col === 1 || col === 6){
                                return 200;
                            }  else if(width > 500) return 500;
                        },
                        beforeChange: function(changes, source){
                            var row = changes[0][0];
                            var prop = changes[0][1];
                            var oldValue = changes[0][2];
                            var newValue = changes[0][3];
                            var context = this;
                            if(prop === 'operation'){
                                if(newValue !== getOperationType('RESUME')) {
                                    this.setDataAtRowProp(row, 'toBeStatus', getStatus(getOperationTypeKey(newValue)), 'edit');
                                    getDeviceFees(this.getDataAtRow(row), row, getOperationTypeKey(newValue));
                                    feesApiResponse && feesApiResponse.then(function(data){
                                        initMonthlyAndInitialFee(context, row, data);
                                    })  
                                } else {
                                    getDeviceLatestStatus(vm.tableRowData[row].deviceSerial);
                                    statusApiResponse.then(function(res){
                                        if(res.data.latestToBeStatusValues){
                                            context.setDataAtRowProp(row, 'toBeStatus', getStatus(res.data.latestToBeStatusValues), 'edit');
                                            getDeviceFees(context.getDataAtRow(row), row, res.data.latestToBeStatusValues);
                                            feesApiResponse && feesApiResponse.then(function(data){
                                                initMonthlyAndInitialFee(context, row, data);
                                            })  
                                        }
                                    }) 
                                     this.setDataAtRowProp(row, 'operationReason', null, 'edit'); 
                                }
                                var sourceArr = newValue === getOperationType('RESUME') ? getSource('resumeReasons'): getSource('suspensionReasons');
                                this.setCellMeta(row, this.propToCol('operationReason'), 'source', sourceArr);
                            }  
                        },
                        afterValidate: function (isValid, value, row, prop, source) {
                            if(prop === "operation" ) {
                                if(baUtil.isUndefinedOrNullOrEmpty(value)){
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "device.request.edit.err.msg.device.owner",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;
                                } 
                                var currentStatus = vm.tableRowData[row].status;
                                if(currentStatus === getStatus('RUNNING') || currentStatus === getStatus('INSTALLED') || currentStatus === getStatus('COMPLETED')) {
                                    if(value !== getStatus('PROCESSING_SUSPENSION')){
                                        vm.errors[ row + "_" + prop ] = $translate.instant(
                                            "device.request.suspend.err.msg.invalid.status",
                                            {
                                                deviceSerial: vm.tableRowData[row].deviceSerial,
                                                applicationNumber: vm.tableRowData[row].applicationNumber,
                                                operation:value,
                                                nowStatus: vm.tableRowData[row].status,
                                                validOperation: getStatus('PROCESSING_SUSPENSION')
                                            }
                                        );
                                        return false;
                                    }
                                }  
                                if(currentStatus === getStatus('PROCESSING_SUSPENSION')) {
                                    if(value !== getOperationType('SUSPENDED')){
                                        vm.errors[ row + "_" + prop ] = $translate.instant(
                                            "device.request.suspend.err.msg.invalid.status",
                                            {
                                                deviceSerial: vm.tableRowData[row].deviceSerial,
                                                applicationNumber: vm.tableRowData[row].applicationNumber,
                                                operation:value,
                                                nowStatus: vm.tableRowData[row].status,
                                                validOperation: getOperationType('SUSPENDED')
                                            }
                                        );
                                        return false;
                                    }
                                }  
                                if(currentStatus === getStatus('SUSPENDED')) {
                                    if(value !== getOperationType('RESUME')){
                                        vm.errors[ row + "_" + prop ] = $translate.instant(
                                            "device.request.suspend.err.msg.invalid.status",
                                            {
                                                deviceSerial: vm.tableRowData[row].deviceSerial,
                                                applicationNumber: vm.tableRowData[row].applicationNumber,
                                                operation:value,
                                                nowStatus: vm.tableRowData[row].status,
                                                validOperation: getOperationType('RESUME')
                                            }
                                        );
                                        return false;
                                    }
                                }  
                                delete vm.errors[ row + "_" + prop ];
                                return true;
                            }

                            if(prop === "operationReason") {
                                if(baUtil.isUndefinedOrNullOrEmpty(value)){
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "device.request.edit.err.msg.device.owner",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;
                                }
                                else {
                                    delete vm.errors[ row + "_" + prop ];
                                    return true;
                                }
                            }
                            if(prop === "toBeStatus" || prop === "addInitialFee"  || prop === "addMonthlyFee") {
                                if(baUtil.isUndefinedOrNullOrEmpty(value)){
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "device.request.suspend.err.msg.required.field",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;
                                }
                                else {
                                    delete vm.errors[ row + "_" + prop ];
                                    return true;
                                }
                            }

                            if (prop === 'applicableDate') {
                                if(!isValid || baUtil.isUndefinedOrNullOrEmpty(value)) {
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "device.request.edit.err.msg.date.remove.device",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;

                                } else   if(moment(value).valueOf() < moment().startOf('day').valueOf() || moment(value).valueOf() > maxAllowedDate.valueOf()) {
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "device.request.suspend.err.msg.invalid.date",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;

                                }
                                else {
                                    delete vm.errors[ row + "_" + prop ];
                                    return true;
                                }
                            }
                        }
                    };

                    vm.tableSettings.cells = function (row, col, prop) {
                        var cellMeta = {};
                        if(prop === "deviceSerial" || prop === "merchantName" || prop === "applicationNumber") {
                            cellMeta.className = 'word-break';
                        }
                        return  cellMeta;
                    };


                    var keyMap = vm.KeyMap;
                    var optionKeys = Object.keys(keyMap);
                    optionKeys.forEach(function (field) {
                        var value = keyMap[field]
                        var fieldValue = "";
                        vm.tableSettings.colHeaders.push(value[$translate.use()])
                        var col = {
                            type: getInputType(value.type),
                            data: field,
                            readOnly: value.readOnly
                        }

                        
                        if (field == 'applicableDate') {
                            col.type = 'date',
                            col.dateFormat = 'YYYY/MM/DD HH:mm:ss'
                            col.datePickerConfig = {
                                minDate: new Date(),
                                maxDate: maxAllowedDate
                             }
                        }
                        if (field == 'operation') {
                            col.type = 'dropdown',
                            col.source = getSource('operation')
                        }
                        if (field == 'operationReason') {
                            col.type = 'dropdown',
                            col.source = getSource('suspensionReasons')
                            col.allowEmpty = true
                        }

                        if ( vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length ) {
                            col.validator = function(query, callback) {
                                callback(true);
                            }
                        }

                        vm.tableSettings.columns.push(col);
                        vm.tableData[0][field] = fieldValue;

                    });

            
                    vm.disableApplyBtn = false;

                    vm.alerts = [];
                    vm.errors = {};
                    var container = document.getElementById('handsOnTable-suspend-device');
                    container.innerHTML = "";
                    var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
                    vm.hotTable = new Handsontable(container, options);
                    vm.hotTable.validateCells();
                }

        function cancel() {
            $state.go("main.deviceRequest.list");
        }


        function initMonthlyAndInitialFee(context, row, data) {
            if(data){
                context.setDataAtRowProp(row, 'addMonthlyFee', monthlyFee(data.data.monthlyFee), 'edit');
                context.setDataAtRowProp(row, 'addInitialFee', initialFee(data.data.initialFee), 'edit');
            }
        }

        function getDeviceLatestStatus(deviceSerial) {
            statusApiResponse = DeviceRequestService.getDeviceLatestStatus(deviceSerial);
        }


        function getDeviceFees(dataArray, row, newToBeStatus) {
            var newDate = dataArray[7];
            var diId = suspendDeviceMap[row].id.toString();
            var deviceSerial = dataArray[3];
            var toBeStatus = newToBeStatus;
            var applicableDate =  moment(newDate).valueOf();
            var nowStatus = getStatusKey(dataArray[4]);
            if(!newDate || !toBeStatus) {
                return;
            }
            feesApiResponse = DeviceRequestService.getDeviceInitialAndMonthlyFees(diId, deviceSerial, applicableDate, nowStatus, toBeStatus);
        }


        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submit() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm(
            "",vm.localTranslator("device.request.suspend.confirm.msg"),
                vm.localTranslator("common.components.btn.confirm")
            )
                        .then(function() {
                            vm.updateInProgress = true;

                            var data = [];

                            vm.tableRowData.forEach(function (row) {
                                var obj = {};
                                Object.keys(row).forEach(function (key) {
                                var value = row[key];
                                    if (key === 'statusFrom'   || key === 'lastCommunicationTime' || key === 'nextBatchWillRunOn'  || key === 'operationStartDate') {
                                        var dateM = new Date(Date.parse(value))
                                        var long = dateM.getTime();
                                        obj[key] = long
                                        return
                                    }
                                    else if (key === 'addMonthlyFee'){
                                        obj[key] = getMonthlyFeeKey(value);
                                          return
                                    }
                                    else if (key === 'addInitialFee'){
                                        obj[key] = getInitialFeeKey(value);
                                        return
                                    }
                                    else if (key === 'applicableDate'){
                                        var dateM = new Date(Date.parse(value))
                                        var long = dateM.getTime();
                                        obj[key] = long
                                        return
                                    }
                                    else if (key === 'operationReason'){
                                        obj[key] = row.operation === getOperationType('RESUME') ? getResumeReasonsKey(value): getSuspensionReasonsKey(value);
                                        return
                                    }
                                    else if (key === 'operation'){
                                        obj[key] = getOperationTypeKey(value);
                                        return
                                    }
                                    else if (key === 'toBeStatus'){
                                        obj[key] = getStatusKey(value);
                                        return
                                    }
                                    else if (key === 'status'){
                                        obj[key] = getStatusKey(value);
                                        return
                                    }
                                    else {
                                        obj[key] = row[key]
                                    }
                                })
                                data.push(obj)
                            });


                            DeviceRequestService.suspendTerminal(data).then(function success(response) {
                                vm.updateInProgress = false;
                                toastr.success(
                                    vm.localTranslator("common.components.msg.success"),
                                    vm.localTranslator("common.components.title.success"),
                                    baUtil.toastOptions()
                                );
                                $state.go("main.deviceRequest.list");
                            }, function err(err) {
                                vm.updateInProgress = false;
                                toastr.error(
                                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                                    vm.localTranslator("common.components.title.error"),
                                    baUtil.toastOptions()
                                );
                            });
                        });


        }

        function monthlyFee(flag) {
            if(flag) {return vm.addMonthlyFee[$translate.use()][0]}
            if(!flag) {return vm.addMonthlyFee[$translate.use()][1]}
        }

        function getMonthlyFeeKey(flag) {
            if(flag == vm.addMonthlyFee[$translate.use()][0]) {return true}
            if(flag == vm.addMonthlyFee[$translate.use()][1]) {return false}
        }

        function initialFee(flag) {
            if(flag) {return vm.addInitialFee[$translate.use()][0]}
            if(!flag) {return vm.addInitialFee[$translate.use()][1]}
        }

        function getInitialFeeKey(flag) {
            if(flag == vm.addInitialFee[$translate.use()][0]) {return true}
            if(flag == vm.addInitialFee[$translate.use()][1]) {return false}
        }

        function getSuspensionReasons(flag) {
            vm.suspensionReasons.key.forEach (function (value, i) {
                if (value == flag) {
                    vm.suspensionString = vm.suspensionReasons[$translate.use()][i]
                }
            })
            return vm.suspensionString;
        }

        function getSuspensionReasonsKey(flag) {
            vm.suspensionReasons[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    vm.suspensionKey = vm.suspensionReasons.key[i]
                }
            })
            return vm.suspensionKey;
        }


        function getResumeReasons(flag) {
            vm.resumeReasons.key.forEach (function (value, i) {
                if (value == flag) {
                    vm.resumeString = vm.resumeReasons[$translate.use()][i]
                }
            })
            return vm.resumeString;
        }

        function getResumeReasonsKey(flag) {
            vm.resumeReasons[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    vm.resumeKey = vm.resumeReasons.key[i]
                }
            })
            return vm.resumeKey;
        }

        function getSource(key) {
            switch (key) {
                case 'addInitialFee':
                    return vm.addInitialFee[$translate.use()]
                case 'addMonthlyFee':
                    return vm.addMonthlyFee[$translate.use()]
                case 'suspensionReasons':
                    return vm.suspensionReasons[$translate.use()]
                case 'resumeReasons':
                    return vm.resumeReasons[$translate.use()]
                case 'operation':
                    return vm.operationTypes[$translate.use()]
                default:
                 return []
            }
        }


        function getStatus(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);
            return vm.types.DeviceInstallationStatus[$translate.use()][index]
        }

        function getStatusKey(flag) {
            var index = vm.types.DeviceInstallationStatus[$translate.use()].indexOf(flag);
            return vm.types.DeviceInstallationStatus.key[index]
        }

        function getOperationType(key) {
            var index = vm.operationTypes.key.indexOf(key);
            return vm.operationTypes[$translate.use()][index]
        }

        function getOperationTypeKey(flag) {
            var index = vm.operationTypes[$translate.use()].indexOf(flag);
            return vm.operationTypes.key[index]
        }

        $scope.$on('LANG_CHANGE', function (event) {
            suspendOrRemoveDevice(suspendDeviceMap);
        });

    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.deviceRequest')
        .factory('DeviceRequestService', DeviceRequestService);

    /** @ngInject */
    function DeviceRequestService(baUtil, $http, API_CONFIG, AuthService, $translate, Upload) {
        var service = {};
        service.createDeviceRequest = createDeviceRequest
        service.createDeviceRequestSingle = createDeviceRequestSingle
        service.getAllDeviceInstallation = getAllDeviceInstallation
        service.getDeviceInstallationDetail = getDeviceInstallationDetail
        service.getDeviceInstallationByServiceContractId = getDeviceInstallationByServiceContractId
        service.updateDeviceRequest = updateDeviceRequest
        service.updateJescaDeviceRequest = updateJescaDeviceRequest
        service.applyMarron = applyMarron
        service.getKeyMap = getKeyMap
        service.getJescaKeyMap = getJescaKeyMap
        service.getDeviceInstallationDetailFromList = getDeviceInstallationDetailFromList
        service.getJescaDetailFromList = getJescaDetailFromList
        service.getResetFlag = getResetFlag
        service.getResetJescaRequest = getResetJescaRequest
        service.creteDevice = creteDevice
        service.getDeviceList = getDeviceList
        service.getDeviceKeys = getDeviceKeys
        service.cancelBulkDeviceRequest = cancelBulkDeviceRequest
        service.deleteBulkDeviceRequest = deleteBulkDeviceRequest
        service.getDeviceInstallationByDeviceSerials = getDeviceInstallationByDeviceSerials
        service.getDeviceInstallationByDeviceSerialsAndDate = getDeviceInstallationByDeviceSerialsAndDate
        service.uploadDevice = uploadDevice
        service.uploadDeviceInstallationRequest = uploadDeviceInstallationRequest
        service.uploadJescaRequest = uploadJescaRequest
        service.downloadDeviceShipmentProgress = downloadDeviceShipmentProgress
        service.downloadDeviceJMupsExcel = downloadDeviceJMupsExcel
        service.downloadDeviceJMupsExcelValidate = downloadDeviceJMupsExcelValidate
        service.downloadShipmentTMSExcel = downloadShipmentTMSExcel
        service.downloadDITMSExcel = downloadDITMSExcel
        service.getDeviceInstallationFilterOptions = getDeviceInstallationFilterOptions
        service.downloadDeviceRequestExcel = downloadDeviceRequestExcel
        service.downloadJescaCsv = downloadJescaCsv
        service.downloadJescaCsvResult  = downloadJescaCsvResult
        service.downloadJescaActivationCsv  = downloadJescaActivationCsv
        service.removeTerminal = removeTerminal
        service.getTerminalDetails = getTerminalDetails
        service.suspendTerminal = suspendTerminal
        service.getSuspensionTerminalDetails =  getSuspensionTerminalDetails
        service.getDeviceLatestStatus = getDeviceLatestStatus
        service.getDeviceInitialAndMonthlyFees = getDeviceInitialAndMonthlyFees
        service.getDeviceHistory = getDeviceHistory;
        service.getSuspensionHistory = getSuspensionHistory;
        service.getOldDeviceRecord = getOldDeviceRecord;
        service.getNewDeviceRecord = getNewDeviceRecord;
        service.replaceDevice = replaceDevice;
        service.getDeviceStatus = getDeviceStatus;
        service.validateSuspensionStatus =  validateSuspensionStatus;
        service.getAllChangeDeviceRequest = getAllChangeDeviceRequest;
        service.uploadDeviceRequestChange = uploadDeviceRequestChange;
        service.updateDeviceChangeRequest = updateDeviceChangeRequest;
        service.createDeviceRequestChange = createDeviceRequestChange;
        service.downloadDeviceRequestChangeExcel = downloadDeviceRequestChangeExcel;
        service.updateDeviceRequestChange = updateDeviceRequestChange;
        service.downloadDRCTMSExcel = downloadDRCTMSExcel;
        service.downloadJescaActivationCsvForDRC = downloadJescaActivationCsvForDRC;
        return service;


        function createDeviceRequest(data, serviceContractId,isJescaUpload) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/multiple/' + serviceContractId + '?isJescaUpload=' + isJescaUpload,
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function createDeviceRequestSingle(data, serviceContractId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/create/' + serviceContractId,
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getTerminalDetails(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/request/detach',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getSuspensionTerminalDetails(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/request/suspension',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        


        function getDeviceHistory(deviceSerial) {
            return $http({
                url: API_CONFIG.url + '/api/v1/device/history/' + deviceSerial,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        };


        function getSuspensionHistory(deviceSerial) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/suspension/history/' + deviceSerial,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        };



        function getDeviceStatus() {
            return $http({
                url: encodeURI(API_CONFIG.url + '/api/v1/device/new/status'),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getOldDeviceRecord(serialNumber) {
            return $http({
                url: encodeURI(API_CONFIG.url + '/api/v1/device/old/' + serialNumber),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }



        function getNewDeviceRecord(serialNumber) {
            return $http({
                url: encodeURI(API_CONFIG.url + '/api/v1/device/new/' + serialNumber),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }


        function replaceDevice(data) {
            return $http({
                url: encodeURI(API_CONFIG.url + '/api/v1/device/replace'),
                method: 'post',
                data:data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }


        function suspendTerminal(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/request/suspension',
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };
        

        function validateSuspensionStatus(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/request/detach/validate',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };
        
        

        

        function getDeviceInitialAndMonthlyFees(diId, deviceSerial, applicableDate, nowStatus, toBeStatus) {
            return $http({
                url: API_CONFIG.paymentUrl + '/batch/api/v1/deviceMonitoring/imFee?diId=' + diId + '&deviceSerial=' + deviceSerial + '&applicableDate=' + applicableDate + '&nowStatus=' + nowStatus + '&toBeStatus=' + toBeStatus,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data;
            })
        };


        function getDeviceLatestStatus(serialNumber) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/operationtype/resume?serialNumber=' + serialNumber,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function (response) {
                return response.data;
            })
        };


        function removeTerminal(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/request/detach',
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function updateDeviceRequest(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/multiple',
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function updateJescaDeviceRequest(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/dji/deviceDtos',
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function applyMarron(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/dji/save-apply',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getDeviceInstallationByDeviceSerials(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/byDeviceSerials',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getDeviceInstallationByDeviceSerialsAndDate(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/byDateAndDeviceSerials',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getAllDeviceInstallation(query) {
            var url = API_CONFIG.url + '/api/v1/di';
            return $http({
                url: url,
                method: 'post',
                data: query,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'

                },
            });
        };

        function getDeviceInstallationDetail(deviceInstallationId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/' + deviceInstallationId,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getDeviceInstallationByServiceContractId(serviceContractId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/' + serviceContractId + '/di',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getKeyMap() {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/getDeviceInstallationKeys',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };
        function getJescaKeyMap() {
        return [
                {
                     displayEn: "Operation Type",
                     displayJp: "項目名",
                     id: 1,
                     inUse: true,
                     isDeleted: false,
                     name: "type",
                     order: 0,
                     readOnly: true,
                     type: "Dropdown",
                     validators: []

                }
            ];
        };

        function getDeviceKeys() {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/getDeviceKeys',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getDeviceInstallationDetailFromList(list) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/multiple',
                method: 'post',
                data: list,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };
        function getJescaDetailFromList(list) {
            return $http({
                url: API_CONFIG.url + '/api/v1/dji/data-di',
                method: 'post',
                data: list,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };
        function getResetFlag(list) {
            return $http({
                url: API_CONFIG.url + '/api/v1/dji/resetFlag',
                method: 'post',
                data: list,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getResetJescaRequest(list) {
            return $http({
                url: API_CONFIG.url + '/api/v1/dji/delete',
                method: 'post',
                data: list,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function creteDevice(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/device/create',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getDeviceList(list) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/multiple/deviceDtos',
                method: 'post',
                data: list,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function cancelBulkDeviceRequest(deviceRequestIds) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/request/cancel',
                method: 'POST',
                data: deviceRequestIds,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function deleteBulkDeviceRequest(deviceRequestIds) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/request/delete',
                method: 'POST',
                data: deviceRequestIds,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getDeviceOwnersOfSC(serviceContractId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/'+serviceContractId+'/do',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function downloadDeviceShipmentProgress(ids) {
            var url = API_CONFIG.url + '/api/v1/di/multiple/deviceDtos/download'

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function downloadDeviceJMupsExcel(ids) {
            var url = API_CONFIG.url + '/api/v1/di/multiple/device/request/jmups/download';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }


        function downloadDeviceJMupsExcelValidate(ids) {
            var url = API_CONFIG.url + '/api/v1/di/multiple/device/request/jmups/download/validate';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function downloadShipmentTMSExcel(ids) {
            var url = API_CONFIG.url + '/api/v1/di/multiple/device/progress/tms/download';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function downloadDITMSExcel (ids) {
            var url = API_CONFIG.url + '/api/v1/di/multiple/device/request/tms/download';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function uploadDevice(file) {
            return Upload.upload({
                url: API_CONFIG.url + '/api/v1/di/multiple/deviceDtos/parse',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function uploadDeviceInstallationRequest(file) {
            return Upload.upload({
                url: API_CONFIG.url + '/api/v1/di/parse',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function uploadJescaRequest(file) {
            return Upload.upload({
                url: API_CONFIG.url + '/api/v1/dji/parse',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }


        function getDeviceInstallationFilterOptions() {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/filter/options',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function downloadDeviceRequestExcel(ids) {
            var url = API_CONFIG.url + '/api/v1/di/multiple/device/request/download';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }
        function downloadJescaCsv(ids) {
            var url = API_CONFIG.url + '/api/v1/dji/multiple/device/download';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }
        function downloadJescaCsvResult(ids) {
            var url = API_CONFIG.url + '/api/v1/dji/multiple/device/download-result';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function downloadJescaActivationCsv (ids, isEditJescaApplication) {
            var url = API_CONFIG.url + '/api/v1/dji/multiple/device/jesca-result';
            if(isEditJescaApplication) url += '/?isEditJescaApplication=true';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        //change device request
        function getAllChangeDeviceRequest(query) {
            var url = API_CONFIG.url + '/api/v1/drc';
            return $http({
                url: url,
                method: 'post',
                data: query,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'

                },
            });
        }

        function uploadDeviceRequestChange(file) {
            return Upload.upload({
                url: API_CONFIG.url + '/api/v1/drc/parse',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        };
        
        function updateDeviceChangeRequest(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/drc/multiple',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function createDeviceRequestChange(data, serviceContractId,immediately) {
            return $http({
                url: API_CONFIG.url + '/api/v1/drc/multiple/' + serviceContractId + '?immediately=' + immediately,
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function downloadDeviceRequestChangeExcel(data) {
            var url = API_CONFIG.url + '/api/v1/drc/multiple/device/request/download';

            return $http({
                url: url,
                method: 'POST',
                data: data,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function updateDeviceRequestChange(data,immediately) {
            return $http({
                url: API_CONFIG.url + '/api/v1/drc/multiple?immediately=' + immediately,
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function downloadDRCTMSExcel (ids) {
            var url = API_CONFIG.url + '/api/v1/drc/multiple/device/request/tms/download';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        };

        function downloadJescaActivationCsvForDRC (ids) {
            var url = API_CONFIG.url + '/api/v1/drc/multiple/device/jesca-result';

            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

    }
})();

(function () {
	'use strict';

	angular.module('JPTC.pages.deviceRequest')
	.factory('DeviceRequestUtilService', DeviceRequestUtilService);

	/** @ngInject */
	function DeviceRequestUtilService(baUtil, $translate) {
		var service = {};

		// depricated
		service.deviceRequestValidators = {

			"deviceOwnerId": {
				"validators": [ "required", "stringLength_20" ]
			},
			"status": {
				"validators": [ "required" ]
			},
			"date": {
				"validators": [ "stringDate", "stringLength_50" ]
			},
			"branchCode": {
				"validators": [ "required", "stringLength_6", "stringAlphanumeric", "stringHalfWidth" ]
			},
			"branchName": {
				"validators": [ "required", "stringLength_50" ]
			},
			"branchDepartment": {
				"validators": [ "stringLength_254" ]
			},
			"branchDesignation": {
				"validators": [ "stringLength_50" ]
			},
			"branchPersonInCharge": {
				"validators": [ "stringLength_50" ]
			},
			"branchPersonInChargePhone": {
				"validators": [ "stringPhone" ]
			},
			"branchPersonInChargeEmail": {
				"validators": [ "stringEmail" ]
			},
			"preferredDateOfInstallation": {
				"validators": [ "stringDate" ]
			},
			"storeName": {
				"validators": [ "required", "stringLength_25", "stringFullWidth" ]
			},
			"storeNameSimple": {
				"validators": [ "stringLength_40", "stringHalfWidth" ]
			},
			"storePin": {
				"validators": [ "required", "stringHalfWidth", "stringPincode" ]
			},
			"storeState": {
				"validators": [ "required", "stringLength_20" ]
			},
			"storeAddress": {
				"validators": [ "required", "stringLength_40", "stringFullWidth" ]
			},
			"storeAddressKana": {
				"validators": [ "stringLength_80" ]
			},
			"storeBuilding": {
				"validators": [ "stringLength_40", "stringFullWidth" ]
			},
			"vendingMachineModel": {
				"validators": [ "stringLength_20", "stringHalfWidth" ]
			},
			"deliveryPin": {
				"validators": [ "required", "stringHalfWidth", "stringPincode" ]
			},
			"deliveryAddress": {
				"validators": [ "required", "stringLength_80" ]
			},
			"deliveryCompanyName": {
				"validators": [ "required", "stringLength_100" ]
			},
			"deliveryDepartment": {
				"validators": [ "stringLength_100" ]
			},
			"deliveryDepartmentDesignation": {
				"validators": [ "stringLength_100" ]
			},
			"deliveryDepartmentPhone": {
				"validators": [ "required", "stringPhone" ]
			},
			"serviceContractId": {
				"validators": [ "required", "stringLength_20" ]
			}
		};

		service.getKeys = function(keys, version) {
			// return version mapped key set
			var map = {};
			if(baUtil.isUndefinedOrNullOrEmpty(version)) {
				keys.forEach(function(d){
					if(!d.inUse || d.isDeleted) return;

					if(!map[d.version]) {
						map[d.version] = {};
					}
					map[d.version][d.name] = {
						excelColumnName: d["excelColumnName"],
						jp: d["displayJp"],
						en: d["displayEn"],
						order: d["order"],
						readOnly: d["readOnly"],
						type: d["type"],
						validators: d["validators"],
					};
				});
			}
			// else return key map of that version
			else {
				keys.forEach(function(d){
					if(!d.inUse || d.isDeleted || d.version != version) return;
					map[d.name] = {
						excelColumnName: d["excelColumnName"],
						jp: d["displayJp"],
						en: d["displayEn"],
						order: d["order"],
						readOnly: d["readOnly"],
						type: d["type"],
						validators: d["validators"],
					};
				});
			}
			return map;
		};

		service.getTransportPaymentOptionTextFromKey = function(keys, keyVal, paymentOptions) {
			var index = keys.key.indexOf(keyVal);
			if( index !== -1 )
				return keys[$translate.use()][index];
			else {
				if(baUtil.isUndefinedOrNullOrEmpty(paymentOptions)) {
					return keys[$translate.use()][ keys.key.indexOf("-") ];
				}
				else {
					if( paymentOptions.length && paymentOptions.indexOf("TRANSPORT") !== -1 ) {
						return keys[$translate.use()][ keys.key.indexOf("○") ];
					}
					else {
						return keys[$translate.use()][ keys.key.indexOf("-") ];
					}
				}
			}
		};

		service.getTransportPaymentOptionKeyFromText = function(keys, textVal) {
			if(baUtil.isUndefinedOrNullOrEmpty(textVal)) {
				return "-";
			}
			var index = keys.en.indexOf(textVal);
			if( index === -1 ) {
				return "-";
			}
			else {
				return keys.key[index];
			}
		};

		service.getKeyFromText = function(keys, textVal) {
			var index = keys.en.indexOf(textVal);
			if (index < 0) {
				index = keys.jp.indexOf(textVal);
			}
			return keys.key[index];
		};

		service.applyResumeHwBillingReadOnly = function(item, obj) {
			if (obj.isUpdatable === true && obj.type === 'CHANGE_MERCHANT_FOR_INVENTROY') {
				if (item.initialBilling == null) {
					obj.initialBilling_readOnly = true;
				}
				if (item.monthlyBilling == null) {
					obj.monthlyBilling_readOnly = true;
				}
			}
		};

		return service;
	}
})();

(function () {
  'use strict';

  angular.module('JPTC.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('DeviceLinkageListCtrl', DeviceLinkageListCtrl);

    /** @ngInject */
    function DeviceLinkageListCtrl($translate, $filter) {
        var vm = this;

    }




})();


(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('qrCodeManagementCtrl', qrCodeManagementCtrl);

    /** @ngInject */
    function qrCodeManagementCtrl($translate, $filter) {
        var vm = this;

    }




})();


(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('UsageDetailsByDeviceCtrl', UsageDetailsByDeviceCtrl);

    /** @ngInject */
    function UsageDetailsByDeviceCtrl($translate, $filter) {
        var vm = this;

    }




})();

(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('UsageDetailsByEmployeeCtrl', UsageDetailsByEmployeeCtrl);

    /** @ngInject */
    function UsageDetailsByEmployeeCtrl($translate, $filter) {
        var vm = this;

    }




})();

(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .factory('inOfficeServices', inOfficeServices);

    /** @ngInject */
    function inOfficeServices($http, API_CONFIG, AuthService, $translate, Upload, baUtil) {
        var service = {};
        service.createDepartment = createDepartment;
        service.uploadDepartmentPreview = uploadDepartmentPreview;
        service.uploadDepartment = uploadDepartment;
        service.exportDepartment = exportDepartment;
        service.searchDepartment = searchDepartment;
        service.getDepartmentColumnValues = getDepartmentColumnValues;
        service.searchOfficeByName = searchOfficeByName;
        service.updateDepartment = updateDepartment;
        service.deleteDepartment = deleteDepartment;

        service.uploadDepartmentAndEmployeePreview = uploadDepartmentAndEmployeePreview;

        service.createEmployee = createEmployee;
        service.uploadEmployeePreview = uploadEmployeePreview;
        service.uploadEmployee = uploadEmployee;
        service.getEmployeeQRCodeDetail = getEmployeeQRCodeDetail;
        service.exportEmployee = exportEmployee;
        service.exportEmployeeQrCode = exportEmployeeQrCode;
        service.searchEmployees = searchEmployees;
        service.searchDepartmentByName = searchDepartmentByName;
        service.searchEmployeeByName = searchEmployeeByName;
        service.getEmployeeColumnValues = getEmployeeColumnValues;
        service.updateEmployee = updateEmployee;
        service.deleteEmployee = deleteEmployee;

        service.createUsageRules = createUsageRules;
        service.searchUsageRules = searchUsageRules;
        service.uploadUsageRules = uploadUsageRules;
        service.uploadUsageRulesPreview = uploadUsageRulesPreview;
        service.downloadUsageRules = downloadUsageRules;
        service.deleteUsageRules = deleteUsageRules;
        service.getUsageRulesColumnValues = getUsageRulesColumnValues;

        service.createDeviceLink = createDeviceLink;
        service.searchDeviceLink = searchDeviceLink;
        service.uploadDeviceLink = uploadDeviceLink;
        service.uploadDeviceLinkPreview = uploadDeviceLinkPreview;
        service.downloadDeviceLink = downloadDeviceLink;
        service.deleteDeviceLink = deleteDeviceLink;
        service.getDeviceColumnValues = getDeviceColumnValues;

        service.getTransactions = getTransactions;
        service.downloadTransactions = downloadTransactions;
        service.getOneItemDetails = getOneItemDetails;
        service.getDeviceUsageColumnValues = getDeviceUsageColumnValues;
        service.downloadUsageDetails = downloadUsageDetails;
        service.getUsageDetailsMinMaxDate = getUsageDetailsMinMaxDate;

        //for terminal Ops
        service.termianlOpsAccountCreate = termianlOpsAccountCreate;
        service.searchTerminalOpsAccounts = searchTerminalOpsAccounts;
        service.searchTerminalOpsHistory = searchTerminalOpsHistory;
        service.updateTerminalOpsAccount = updateTerminalOpsAccount;
        service.deleteTerminalOpsAccounts = deleteTerminalOpsAccounts;
        service.deleteTerminalOpsHistory = deleteTerminalOpsHistory;
        service.enableTerminalOpsAccount = enableTerminalOpsAccount;
        service.disableTerminalOpsAccount = disableTerminalOpsAccount;
        service.filterOptions = filterOptions;
        service.searchOfficeById  = searchOfficeById;

        return service;





        function createDepartment(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/department',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function uploadDepartmentPreview(file) {
            return Upload.upload({
                url: API_CONFIG.ioslUrl + '/api/v1/department/bulk/import/preview',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function uploadDepartment(data) {
            var url = API_CONFIG.ioslUrl + '/api/v1/department/bulk/import';
            return $http({
                url: url,
                method: 'POST',
                data: data,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function exportDepartment(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/department/export';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                responseType: 'arraybuffer',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }




        function searchDepartment(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/department/search';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }



        function getDepartmentColumnValues(columnName, filters) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/department/column/master?column=' + columnName,
                method: 'POST',
                data: filters,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }




        function updateDepartment(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/department',
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function deleteDepartment(ids){
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/department/delete',
                method: 'POST',
                data:ids,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }



        function uploadDepartmentAndEmployeePreview(file) {
            return Upload.upload({
                url: API_CONFIG.ioslUrl + '/api/v1/department/bulk/import/multi/preview',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }


        function exportEmployeeQrCode(ids) {
            var url = API_CONFIG.ioslUrl + '/api/v1/employee/qr-code/export';
            return $http({
                url: url,
                method: 'POST',
                data: ids,
                responseType: 'arraybuffer',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function createEmployee(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/employee',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function getEmployeeQRCodeDetail(id) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/employee/detail/' + id,
                method: 'GET',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function uploadEmployeePreview(file) {
            return Upload.upload({
                url: API_CONFIG.ioslUrl + '/api/v1/employee/bulk/import/preview',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function uploadEmployee(data) {
            var url = API_CONFIG.ioslUrl + '/api/v1/employee/bulk/import';
            return $http({
                url: url,
                method: 'POST',
                data: data,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function exportEmployee(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/employee/export';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                responseType: 'arraybuffer',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function searchEmployees(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/employee/search';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }



        function getEmployeeColumnValues(columnName, filters) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/employee/column/master?column=' + columnName,
                method: 'POST',
                data: filters,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function updateEmployee(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/employee',
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function deleteEmployee(ids){
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/employee/delete',
                method: 'POST',
                data:ids,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function searchOfficeByName(name) {
            var url = API_CONFIG.url + '/api/v1/org/search/office?query=' + name;
            return $http({
                url: url,
                method: 'GET',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            })
            .then(function (response) {
                return response.data.data;
            });
        }

        function searchDepartmentByName(name, id) {
            var url = API_CONFIG.ioslUrl + '/api/v1/department/autocomplete/name?name=' + name + '&officeId=' + id;
            return $http({
                url: url,
                method: 'GET',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            })
            .then(function (response) {
                return response.data.data;
            });
        }

        function searchEmployeeByName(name, id) {
            var url = API_CONFIG.ioslUrl + '/api/v1/employee/autocomplete/name?name=' + name + '&officeId=' + id;
            return $http({
                url: url,
                method: 'GET',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            })
            .then(function (response) {
                return response.data.data;
            });
        }


        function searchUsageRules(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/rule/search';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function createUsageRules(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/rule',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function downloadUsageRules(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/rule/export';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                responseType: 'arraybuffer',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function deleteUsageRules(ids){
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/rule/delete',
                method: 'POST',
                data:ids,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getUsageRulesColumnValues(columnName, filters) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/rule/column/master?column=' + columnName,
                method: 'POST',
                data: filters,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function uploadUsageRulesPreview(file) {
            return Upload.upload({
                url: API_CONFIG.ioslUrl + '/api/v1/rule/bulk/import/preview',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }


        function uploadUsageRules(data) {
            var url = API_CONFIG.ioslUrl + '/api/v1/rule/bulk/import';
            return $http({
                url: url,
                method: 'POST',
                data: data,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }



        function searchDeviceLink(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/device/search';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function createDeviceLink(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/device',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function downloadDeviceLink(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/device/export';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                responseType: 'arraybuffer',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function deleteDeviceLink(ids){
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/device/delete',
                method: 'POST',
                data:ids,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function uploadDeviceLinkPreview(file) {
            return Upload.upload({
                url: API_CONFIG.ioslUrl + '/api/v1/device/bulk/import/preview',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }


        function uploadDeviceLink(data) {
            var url = API_CONFIG.ioslUrl + '/api/v1/device/bulk/import';
            return $http({
                url: url,
                method: 'POST',
                data: data,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function getDeviceColumnValues(columnName, filters) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/device/column/master?column=' + columnName,
                method: 'POST',
                data: filters,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function getTransactions(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/transaction/aggregation';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function downloadTransactions(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/transaction/aggregation/export';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                responseType: 'arraybuffer',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function getDeviceUsageColumnValues(columnName, filters) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/usageDetails/column/master?column=' + columnName,
                method: 'POST',
                data: filters,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }



        function getOneItemDetails(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/usageDetails/search';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function getUsageDetailsMinMaxDate() {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/usageDetails/dates',
                method: 'GET',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function downloadUsageDetails(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/usageDetails/export';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                responseType: 'arraybuffer',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        //for teminal ops
        function termianlOpsAccountCreate(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/terminalops/account/create',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function searchTerminalOpsAccounts(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/terminalops/account/search';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function updateTerminalOpsAccount(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/terminalops/account/update',
                method: 'POST',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function enableTerminalOpsAccount(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/terminalops/account/update',
                method: 'POST',
                data: {id:data.id,authenticationId:data.authenticationId,
                    authenticationIdName:data.authenticationIdName,officeId:data.officeId,isEnabled:"true"},
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function disableTerminalOpsAccount(data) {
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/terminalops/account/update',
                method: 'POST',
                data: {id:data.id,authenticationId:data.authenticationId,
                    authenticationIdName:data.authenticationIdName,officeId:data.officeId,isEnabled:"false"},
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function deleteTerminalOpsAccounts(ids){
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/terminalops/account/delete',
                method: 'POST',
                data:[ids],
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function searchTerminalOpsHistory(filters) {
            var url = API_CONFIG.ioslUrl + '/api/v1/terminalops/history/search';
            return $http({
                url: url,
                method: 'POST',
                data: filters,
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function deleteTerminalOpsHistory(ids){
            return $http({
                url: API_CONFIG.ioslUrl + '/api/v1/terminalops/history/delete',
                method: 'POST',
                data:ids,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function filterOptions() {
            return $http({
                url: API_CONFIG.url + '/api/v1/iosl/filter/options',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function searchOfficeById(id) {
            var url = API_CONFIG.url + '/api/v1/org/search/office?query=' + id;
            return $http({
                url: url,
                method: 'GET',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            })
            .then(function (response) {
                return response.data.data;
            });
        }


    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

(function () {
    'use strict';

    angular.module('JPTC.pages.other')
        .controller('OtherCtrl', OtherCtrl);

    /** @ngInject */
    function OtherCtrl($translate,telemetryEnabled,API_CONFIG,AuthService) {
        var vm = this;
        vm.telemetryEnabled = telemetryEnabled;
        vm.environment = API_CONFIG.env; 
        vm.token = AuthService.getToken();
        vm.getLang = getLang;

        vm.getTelemetryUrl = function () {
            var base = API_CONFIG.telemetryBaseUrls[vm.environment];
            return base + '?token=' + vm.token;
        };

        function getLang() {
            return $translate.use();
        }

    }

})();
(function () {
    'use strict';
  
    angular.module('JPTC.pages.other')
      .factory('OtherService', OtherService);
  
    /** @ngInject */
    function OtherService($translate, $http, API_CONFIG, AuthService) {
      var service = {};   
      service.isTelemetryEnabled = isTelemetryEnabled;
  
      function isTelemetryEnabled() {
        return $http({
          url: API_CONFIG.url + '/api/v1/sc/flagForTelemetryOption',
          method: 'get',
          headers: {
            'X-COV-TOKEN': AuthService.getToken(),
            'Content-Type': 'application/json',
            'Accept-Language': $translate.use(),
            'Pragma': 'no-cache',
            'Cache-Control': 'no-cache'
          }
        }).then(function (response) {
          return !!response.data.data.status;
        });
      }
      return service; 
    }
  
  })();
  
(function () {
  'use strict'

  angular
    .module('JPTC.pages.salesSettlements')
    .controller('HistoryCtrl', HistoryCtrl)

  /** @ngInject */
  function HistoryCtrl(
    DeviceRequestService,
    baUtil,
    toastr,
    $filter,
    $translate,
    deviceSerialNum,
    $timeout,
    types
  ) {
    var vm = this;
    vm.isLoading = false;
    vm.baUtil = baUtil;
    vm.deviceSerial = deviceSerialNum;
    vm.deviceHistory; 
    vm.types = types;
    vm.suspensionHistory;
    vm.localTranslator = $filter('translate');
    vm.getLang = getLang;
    vm.getValueFromTypeKey = getValueFromTypeKey;
    vm.translatedNA = vm.localTranslator('device.replacement.device.information.na');

  


    vm.boolOptions = {
      en: ['Yes', 'No'],
      jp: ['はい', 'いいえ'],
      key: [true, false]
    }

    function getLang() {
      return $translate.use();
    }

    function getValueFromTypeKey(key, type) {
      var index = type.key.findIndex(function (item) {
        return item === key
      })
      return type[vm.getLang()][index]
    }

    getDeviceHistory()
    getSuspensionDeviceHistory();

    function getDeviceHistory() {
      vm.isLoading = true;
      DeviceRequestService.getDeviceHistory(vm.deviceSerial)
      .then(function (response) {
        vm.deviceHistory = response;
        $timeout(function() {
          vm.isLoading = false;
      }, 1000);
      }).catch(function (err) {
        vm.oldDeviceData = {}
        toastr.error(
          baUtil.getErrorMessageOrDefault(
            err,
            vm.localTranslator('common.components.msg.error.response')
          ),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
      })
    }

    function getSuspensionDeviceHistory() {
      vm.isLoading = true;
      DeviceRequestService.getSuspensionHistory(vm.deviceSerial)
      .then(function (response) {
        vm.suspensionHistory = response.DeviceSuspensionHistoryDtos;
        $timeout(function() {
          vm.isLoading = false;
      }, 1000);
      }).catch(function (err) {
        vm.oldDeviceData = {}
        toastr.error(
          baUtil.getErrorMessageOrDefault(
            err,
            vm.localTranslator('common.components.msg.error.response')
          ),
          vm.localTranslator('common.components.title.error'),
          baUtil.toastOptions()
        )
      })
    }

  }
})();

(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements')
        .controller('MonthlySalesRequest', MonthlySalesRequest);

    /** @ngInject */
    function MonthlySalesRequest(SalesSettlementsService, $translate, $scope, $filter, baUtil, $stateParams, toastr, AuthService, FileSaver, types, sourcePageEnum, $window, $state, $rootScope) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        $scope.baUtil = baUtil;
        vm.query = $stateParams.query ? JSON.parse($stateParams.query) : {};
        vm.isLoading = false;
        vm.localTranslator = $filter('translate');
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.paginateCallback = paginateCallback;
        vm.monthlySalesDownloadReport = {};
        vm.getBranch = getBranch;
        vm.getSuppInfoTitle = getSuppInfoTitle;
        vm.downloadMonthlySalesReport = downloadMonthlySalesReport;
        vm.submitMonthlyReportInProgress = {};
        vm.date = new Date().getTime();
        vm.getData = getData;
        vm.goBack = goBack;
        vm.isGoBackLoading = false;

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        if (sourcePageEnum.status >= 200 && sourcePageEnum.status <= 299) {
            vm.sourcePageEnum = sourcePageEnum.data.data;
        }

        vm.aggregationPeriod = {
            "key": ['CLOSING_DATE', 'CALENDAR_MONTH'],
            "en": ['Closing period', 'Calender month period'],
            "jp": ['締め基準', '暦日基準'],
        }

        vm.aggregationByUnitPrice = {
            "key": [true, false],
            "en": ['Yes', 'No'],
            "jp": ['はい', 'いいえ'],
        }

        vm.reportStatus = {
            "key": ['SUBMITTED', 'IN_PROGRESS', 'ERROR', 'COMPLETED'],
            "en": ['Submitted', 'In Progress', 'Error', 'Completed'],
            "jp": ['提出済み', '進行中', 'エラー', '完了'],
        }

        init();
        function init() {
            vm.filter = {
                pageNumber: 0,
                pageSize: baUtil.getDefaultPageSize('SALES'),
            }
            getData();
        }

        function getData() {
            vm.isLoading = true;
            SalesSettlementsService.fetchRequestMonthlyResult(baUtil.makeQueryString(vm.filter))
                .then(function success(response) {
                    vm.isLoading = false;
                    vm.monthlySalesDownloadReport = response;
                }, function err(err) {
                    if(err.status === 401){
                        return $state.go('main.permissionDenied');
                    }

                    vm.isLoading = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                })
        }

        function paginateCallback(query) {
            vm.filter.pageNumber = query.pageNumber;
            vm.filter.pageSize = query.pageSize;  
            getData();
        }

        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, _enum) {
            if(Array.isArray(key)){
                var result = [];
                
                key.forEach(function(item){
                    result.push(getValueFromTypeKey(item, _enum));
                });
                
                return result;
            }

            var index = _enum.key.findIndex(function (item) {
                return item === key
            })
            
            return _enum[vm.getLang()][index]
        }

        function getBranch(branchName, branchCode){
            var result = '', addBranchName = false;

            if(branchName && (branchCode !== 'Total' || vm.getLang() === 'jp')){
                result += branchName;
                addBranchName = true;
            }
            if(branchCode && (branchCode !== 'Total' || vm.getLang() === 'en')){
                if(addBranchName) result += '(';
                result += branchCode;
                if(addBranchName) result += ')';
            }

            return result;
        }

        function getSuppInfoTitle(reportData){
            var result = "";
            
            if(!baUtil.isUndefinedOrNullOrEmpty(reportData.deviceSerial)){
                var deviceSerial = $translate.instant('salesSettlements.monthly.list.search.deviceSerial');
                result += deviceSerial + ' : ';
                result += reportData.deviceSerial;
                result += '\n';
            }
            if(!baUtil.isUndefinedOrNullOrEmpty(reportData.applicationSerial)){
                var applicationSerial = $translate.instant('salesSettlements.monthly.list.search.applicationSerial');
                result += applicationSerial + ' : ';
                result += reportData.applicationSerial;
                result += '\n';
            }
            if(!baUtil.isUndefinedOrNullOrEmpty(reportData.installationLocation)){
                var installationLocation = $translate.instant('salesSettlements.monthly.list.search.installationLocation');
                result += installationLocation + ' : ';
                result += reportData.installationLocation;
                result += '\n';
            }
            if(!baUtil.isUndefinedOrNullOrEmptyList(reportData.productName)){
                var productName = $translate.instant('salesSettlements.monthly.list.search.productName');
                result += productName + ' : ';
                result += getValueFromTypeKey( reportData.productName, vm.types.ProductName ).join(', ').replaceAll('_','-');
                result += '\n';
            }
            if(!baUtil.isUndefinedOrNullOrEmpty(reportData.remarks)){
                var remarks = $translate.instant('salesSettlements.monthly.list.search.remarks');
                result += remarks + ' : ';
                result += reportData.remarks;
            }

            return result;
        }

        function downloadMonthlySalesReport(id, userId){
            vm.submitMonthlyReportInProgress[id] = true;

            SalesSettlementsService.downloadMonthlyResult(id, userId)
                .then(function success(response) {
                    var headers = response.headers();
                    var fileName = headers["content-disposition"];
                    fileName = fileName.substring(fileName.indexOf("filename=") + 9);
                    fileName = decodeURIComponent(fileName);
                    var serverData = new Blob([response.data], {type: headers['content-type']});
                    FileSaver.saveAs(serverData, fileName);  
                vm.submitMonthlyReportInProgress[id] = false;
                
                }, function err(err) {
                    vm.submitMonthlyReportInProgress[id] = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                })
        };

        function goBack(){
             vm.isGoBackLoading = true;
    
            $rootScope.$on('$stateChangeStart', function () {
                vm.isGoBackLoading = true;
            });

            $rootScope.$on('$stateChangeSuccess', function () {
                vm.isGoBackLoading = false;
            });

            $rootScope.$on('$stateChangeError', function () {
                vm.isGoBackLoading = false;
            });

            if ($rootScope.previousState) {
                return $state.go($rootScope.previousState.name, $rootScope.previousParams);
            } else {
                return $state.go("main.salesSettlements.monthly.list");
            }
        }

    }
})();

(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements')
        .controller('PreviewSalesDetailToggleClosingCtrl', PreviewSalesDetailToggleClosingCtrl);

    /** @ngInject */
    function PreviewSalesDetailToggleClosingCtrl($translate, $stateParams, toastr, baUtil, $scope, $state, $filter, SalesSettlementsService) {
        var vm = this;
        vm.getLang = getLang;
        vm.isServerError = false;
        vm.query = {}
        vm.cancel = cancel;
        vm.submit = submit;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.headers = $stateParams.headers;
        vm.enums = $stateParams.enums;

        vm.KeyMap;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;

        vm.closingTypes = {
            en: ['23.締め時', '25.締めボタン押下時'],
            jp: ['23.締め時', '25.締めボタン押下時'],
            key: ['23', '25']
        }

        vm.rows = ($stateParams.rows);
        var rowsCopy=[];

        vm.rows.forEach(function(row){
            var obj = row;

            obj["branchCode/branchName"] = row.branchName + ' (' + row.branchCode + ' )';
            if(obj.dataTiming === '')
                obj['dataTiming'] = '23.締め時';
            obj['statusSelection'] = obj.closingStatus;
            
            if(obj.closingModificationReason != ''){
                obj.closingModificationReason = getTextFromKey(vm.enums.ClosingModificationReason,obj.closingModificationReason);
            }
            rowsCopy.push(obj);
        });
        vm.rows = rowsCopy;
        createTable(vm.rows);

        function cancel() {
            $state.go('main.salesSettlements.oneItem.detail', { query: JSON.stringify($stateParams.query) });            
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function notEmptyValidator(value, callback) {
            callback(true);
        }

        function createTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {};
            vm.headers.forEach(function(item){
                var name = item.name;
                vm.deviceTableHeader[name] = item;
                vm.deviceTableHeader[name].en = item.displayEn;
                vm.deviceTableHeader[name].jp = item.displayJp;
                vm.deviceTableHeader[name].column = item.name;
            });

            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;

            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns : [],
                cells: function (row, col) {
                    var cellProperties = {};
                    if (col === 6) {
                      cellProperties.validator = notEmptyValidator;
                    }
                    return cellProperties;
                },
                className: 'htRight',
                colWidths: [180, 180, 200, 100, 150, 180, 200, 120, 200, 300, 300],

                modifyColWidth: function (width, col) {
                    if (width > 500) return 500;
                },

                afterValidate: function (isValid, value, row, prop, source) {
                    if (prop === "statusSelection" || prop === "closingModificationReason" || prop === 'dataTiming' || prop === 'startTime') {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "salesSettlements.monthly.list.search.err.msg.required.field",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else if((prop === "statusSelection" || prop === "closingModificationReason" || prop === 'dataTiming') && !getSource(prop).includes(value)){
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "salesSettlements.monthly.list.search.err.msg.wrong.value.entered",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else if(prop === 'startTime'){
                            var index = value.indexOf(' ');

                            if(index === -1){
                                vm.errors[row + "_" + prop] = $translate.instant(
                                    "salesSettlements.monthly.list.search.err.msg.wrong.time.entered",
                                    {
                                        param: vm.KeyMap[prop][vm.getLang()]
                                    }
                                );
                                return false;
                            }

                            var index2 = value.indexOf(':');
                            var index3 = value.indexOf(':',index2+1);

                            if(index2 === -1 || index3 === -1){
                                vm.errors[row + "_" + prop] = $translate.instant(
                                    "salesSettlements.monthly.list.search.err.msg.wrong.time.entered",
                                    {
                                        param: vm.KeyMap[prop][vm.getLang()]
                                    }
                                );
                                return false;
                            }

                            var str = value.slice(index+1,index2);
                            var str2 = value.slice(index2+1,index3);
                            var str3 = value.slice(index3+1);

                            if((str.length !== 1 && str.length !== 2) || (str2.length !== 1 && str2.length !== 2) || (str3.length !== 1 && str3.length !== 2) || !(Number(str)>=0 && Number(str)<=23) || !(Number(str2)>=0 && Number(str2)<=59) || !(Number(str3)>=0 && Number(str3)<=59)){
                                vm.errors[row + "_" + prop] = $translate.instant(
                                    "salesSettlements.monthly.list.search.err.msg.wrong.time.entered",
                                    {
                                        param: vm.KeyMap[prop][vm.getLang()]
                                    }
                                );
                                return false;
                            }
                            else{
                                delete vm.errors[row + "_" + prop];
                                return true;    
                            }
                        }
                        else {                
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }
                }
            };

            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field === 'statusSelection' || field === 'closingModificationReason' || field === 'dataTiming') {
                    col.source = getSource(field)
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length) {
                    col.validator = function (query, callback) {
                        callback(true);
                    }
                }

                var minAllowedDate = moment().startOf('month').subtract(1, 'months').toDate();

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD HH:mm:ss'
                    col.datePickerConfig = {
                        minDate: minAllowedDate,
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;
            });


            vm.disableApplyBtn = false;
            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-oneItemDetailToggleClosing');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function (key) {
                var row = Number(key.split("_")[0]) + 1;
                var field = key.split("_")[1];
                if (!field) return;
                vm.alerts.push(vm.errors[key]);
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submit() {
            if (!vm.isFormValid()) {
                return;
            }

            vm.isLoading = true;
            var data = [];
            vm.tableRowData.forEach(function (row) {
                var obj = {};
                Object.keys(row).forEach(function (key) {
                    obj[key] = row[key]
                })

                var ogStatus = getKeyFromText(vm.enums.ClosingStatus,obj.closingStatus);
                var newStatus = getKeyFromText(vm.enums.ClosingStatus,obj.statusSelection);

                obj.closingModificationReason = getKeyFromText(vm.enums.ClosingModificationReason, obj.closingModificationReason);
                obj.statusSelection = getKeyFromText(vm.enums.ClosingStatus, obj.statusSelection);
                obj.dataTiming = getKeyFromText(vm.closingTypes, obj.dataTiming);

                var newStartTime  = new Date(obj.startTime);
                obj.startTime = newStartTime.getTime();

                var newArrivalTime  = new Date(obj.arrivalTime);
                obj.arrivalTime = newArrivalTime.getTime();

                var branchSalesOffice = obj['branchCode/branchName'];
                var indexOfOpeningBracket = branchSalesOffice.indexOf('(');
                var indexOfClosingBracket = branchSalesOffice.indexOf(')');

                obj.branchName = branchSalesOffice.slice(0,indexOfOpeningBracket).trim();
                obj.branchCode = branchSalesOffice.slice(indexOfOpeningBracket + 1, indexOfClosingBracket).trim();

                if(ogStatus === newStatus){
                    obj.statusChanged = 'NOCHANGE';
                }
                else {
                    obj.statusChanged = newStatus;
                }

                delete obj['branchCode/branchName'];
                delete obj.addClosing;
                delete obj.arrivalTime;
                delete obj.closingStatus;
                delete obj.$$hashKey;
                data.push(obj)
            });
            
            SalesSettlementsService.submitAddClosingData(data,  baUtil.makeQueryString({addClosing:false}))
                .then(function success(successMessage) {
                    var formattedMessage = successMessage.replace(/\n/g, "<br/>");
                    vm.isLoading = false;
                    toastr.success(
                        formattedMessage,
                        baUtil.toastOptionsWithHTML()
                    );
                    cancel();
                }, function err(err) {
                    vm.isLoading = false;
                    vm.alerts = err.data.data;
                    vm.isServerError = true;
                });
        }

        function getSource(key) {
            switch (key) {
                case 'statusSelection':
                    return vm.enums.ClosingStatus[$translate.use()]
                case 'closingModificationReason':
                    return vm.enums.ClosingModificationReason[$translate.use()]
                case 'dataTiming':
                    return vm.closingTypes[$translate.use()]
                default:
                    return []
            }
        }

        function getOperationTypes(flag) {
            var operationString;
            vm.operationTypes.key.forEach (function (value, i) {
                if (value == flag) {
                    operationString = vm.operationTypes[$translate.use()][i]
                }
            })
            return operationString;
        }

        function getOperationTypesKey(flag) {
            var operationKey;
            vm.operationTypes[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    operationKey = vm.operationTypes.key[i]
                }
            })
            return operationKey;
        }

        // $scope.$on('LANG_CHANGE', function (event) {
            // suspendOrRemoveDevice(suspendDeviceMap);
        // });

        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

        function getKeyFromText(keys, textVal) {
			var index = keys.en.indexOf(textVal);
			if (index < 0) {
				index = keys.jp.indexOf(textVal);
			}
			return keys.key[index];
		};

        function getTextFromKey(keys, textVal) {
			var index = keys.key.indexOf(textVal);
            return keys[$translate.use()][index];
		};

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements')
        .controller('PreviewSalesDetailCtrl', PreviewSalesDetailCtrl);

    /** @ngInject */
    function PreviewSalesDetailCtrl($translate, $stateParams, toastr, baUtil, $scope, $state, $filter, SalesSettlementsService) {
        var vm = this;
        vm.getLang = getLang;
        vm.isServerError = false;
        vm.query = {}
        vm.cancel = cancel;
        vm.submit = submit;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.headers = $stateParams.headers;
        vm.enums = $stateParams.enums;
        vm.addClosingInfoDate = $stateParams.addClosingInfoDate;

        vm.KeyMap;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;

        vm.closingTypes = {
            en: ['23.締め時', '25.締めボタン押下時'],
            jp: ['23.締め時', '25.締めボタン押下時'],
            key: ['23', '25']
        }

        vm.rows = [];
        vm.rows.push($stateParams.rows);
        var rowsCopy=[];

        vm.rows.forEach(function(row){
            var obj = row;

            obj["branchCode/branchName"] = row.branchName + ' (' + row.branchCode + ' )';
            obj['dataTiming'] = '23.締め時';
            obj['statusSelection'] = getSource('statusSelection')[0];
            obj['startTime'] = vm.addClosingInfoDate;    
            rowsCopy.push(obj);
        });
        vm.rows = rowsCopy;
        createTable(vm.rows);

        function cancel() {
            $state.go('main.salesSettlements.oneItem.detail', { query: JSON.stringify($stateParams.query) });            
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function createTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {};
            vm.headers.forEach(function(item){
                var name = item.name;
                vm.deviceTableHeader[name] = item;
                vm.deviceTableHeader[name].en = item.displayEn;
                vm.deviceTableHeader[name].jp = item.displayJp;
                vm.deviceTableHeader[name].column = item.name;
            });

            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;

            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns : [],
                className: 'htRight',
                colWidths: [180, 180, 200, 100, 150, 180, 200, 120, 200, 300, 300],

                modifyColWidth: function (width, col) {
                    if (width > 500) return 500;
                },

                afterValidate: function (isValid, value, row, prop, source) {
                    if (prop === "statusSelection" || prop === "closingAdditionReason" || prop === 'dataTiming' || prop === 'startTime') {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "salesSettlements.monthly.list.search.err.msg.required.field",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else if((prop === "statusSelection" || prop === "closingAdditionReason" || prop === 'dataTiming') && !getSource(prop).includes(value)){
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "salesSettlements.monthly.list.search.err.msg.wrong.value.entered",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else if(prop === 'startTime'){
                            var index = value.indexOf(' ');

                            if(index === -1){
                                vm.errors[row + "_" + prop] = $translate.instant(
                                    "salesSettlements.monthly.list.search.err.msg.wrong.time.entered",
                                    {
                                        param: vm.KeyMap[prop][vm.getLang()]
                                    }
                                );
                                return false;
                            }

                            var index2 = value.indexOf(':');
                            var index3 = value.indexOf(':',index2+1);

                            if(index2 === -1 || index3 === -1){
                                vm.errors[row + "_" + prop] = $translate.instant(
                                    "salesSettlements.monthly.list.search.err.msg.wrong.time.entered",
                                    {
                                        param: vm.KeyMap[prop][vm.getLang()]
                                    }
                                );
                                return false;
                            }

                            var str = value.slice(index+1,index2);
                            var str2 = value.slice(index2+1,index3);
                            var str3 = value.slice(index3+1);

                            if((str.length !== 1 && str.length !== 2) || (str2.length !== 1 && str2.length !== 2) || (str3.length !== 1 && str3.length !== 2) || !(Number(str)>=0 && Number(str)<=23) || !(Number(str2)>=0 && Number(str2)<=59) || !(Number(str3)>=0 && Number(str3)<=59)){
                                vm.errors[row + "_" + prop] = $translate.instant(
                                    "salesSettlements.monthly.list.search.err.msg.wrong.time.entered",
                                    {
                                        param: vm.KeyMap[prop][vm.getLang()]
                                    }
                                );
                                return false;
                            }
                            else{
                                delete vm.errors[row + "_" + prop];
                                return true;    
                            }
                        }
                        else {                
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }
                }
            };

            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field === 'statusSelection' || field === 'closingAdditionReason' || field === 'dataTiming') {
                    col.source = getSource(field)
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length) {
                    col.validator = function (query, callback) {
                        callback(true);
                    }
                }

                var minAllowedDate = moment().startOf('month').subtract(1, 'months').toDate();

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD HH:mm:ss'
                    col.datePickerConfig = {
                        minDate: minAllowedDate,
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;
            });


            vm.disableApplyBtn = false;
            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-oneItemDetailAddClosing');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function (key) {
                var row = Number(key.split("_")[0]) + 1;
                var field = key.split("_")[1];
                if (!field) return;
                vm.alerts.push(vm.errors[key]);
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submit() {
            if (!vm.isFormValid()) {
                return;
            }

            vm.isLoading = true;
            var data = [];
            vm.tableRowData.forEach(function (row) {
                var obj = {};
                Object.keys(row).forEach(function (key) {
                    obj[key] = row[key]
                })

                obj.closingAdditionReason = getKeyFromText(vm.enums.ClosingAdditionReason, obj.closingAdditionReason);
                obj.statusSelection = getKeyFromText(vm.enums.ClosingStatus, obj.statusSelection);
                obj.dataTiming = getKeyFromText(vm.closingTypes, obj.dataTiming);

                var newDate  = new Date(obj.startTime);
                newDate = newDate.getTime();
                obj.startTime = newDate;

                var branchSalesOffice = obj['branchCode/branchName'];
                var indexOfOpeningBracket = branchSalesOffice.indexOf('(');
                var indexOfClosingBracket = branchSalesOffice.indexOf(')');

                obj.branchName = branchSalesOffice.slice(0,indexOfOpeningBracket).trim();
                obj.branchCode = branchSalesOffice.slice(indexOfOpeningBracket + 1, indexOfClosingBracket).trim();

                delete obj['branchCode/branchName'];
                delete obj.basicInfoId;
                delete obj.statusChanged;
                delete obj.addClosing;
                data.push(obj)
            });

            SalesSettlementsService.submitAddClosingData(data, baUtil.makeQueryString({addClosing:true}))
                .then(function success(successMessage) {
                    vm.isLoading = false;
                    toastr.success(
                        successMessage,
                        baUtil.toastOptions()
                    );
                    cancel();
                }, function err(err) {
                    vm.isLoading = false;
                    toastr.error(
                        err.data.errorMessage,
                        baUtil.toastOptions()
                    );
                    vm.disableApplyBtn = true;
                });
        }

        function getSource(key) {
            switch (key) {
                case 'statusSelection':
                    return vm.enums.ClosingStatus[$translate.use()]
                case 'closingAdditionReason':
                    return vm.enums.ClosingAdditionReason[$translate.use()]
                case 'dataTiming':
                    return vm.closingTypes[$translate.use()]
                default:
                    return []
            }
        }

        function getOperationTypes(flag) {
            var operationString;
            vm.operationTypes.key.forEach (function (value, i) {
                if (value == flag) {
                    operationString = vm.operationTypes[$translate.use()][i]
                }
            })
            return operationString;
        }

        function getOperationTypesKey(flag) {
            var operationKey;
            vm.operationTypes[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    operationKey = vm.operationTypes.key[i]
                }
            })
            return operationKey;
        }

        // $scope.$on('LANG_CHANGE', function (event) {
            // suspendOrRemoveDevice(suspendDeviceMap);
        // });

        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

        function getKeyFromText(keys, textVal) {
			var index = keys.en.indexOf(textVal);
			if (index < 0) {
				index = keys.jp.indexOf(textVal);
			}
			return keys.key[index];
		};

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements')
        .controller('SalesDetailCtrl', SalesDetailCtrl);

    /** @ngInject */
    function SalesDetailCtrl($filter, SalesSettlementsService, $translate, $timeout, $stateParams, types, toastr, baUtil, $scope, $state, paymentDetail, navigationDates, allMerchants, salesBranch, unitPrices, $sce) {
        var vm = this;

        vm.getLang = getLang;
        vm.showData = showData;
        vm.getPaymentLabelFromKey = getPaymentLabelFromKey;
        vm.navigate = navigate;
        vm.search = {};
        vm.salesBranch = {};
        vm.dateFormat = 'yyyy/MM'
        vm.inProgress = false;
        vm.query = $stateParams.query ? JSON.parse($stateParams.query) : {};
        vm.paginateCallback = paginateCallback;
        vm.interval = $stateParams.interval;
        vm.baUtil = baUtil;
        vm.getProcessResultFromKey = getProcessResultFromKey;
        vm.getProcessTypeFromKey = getProcessTypeFromKey;
        vm.updateBranchOffice = updateBranchOffice;
        vm.listMonthlySales = listMonthlySales;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.isUnitPriceDisabled = true;
        // vm.getBranchName = getBranchName;
        vm.getRowStyle = getRowStyle;
        vm.addClosing = false;
        vm.handleDisplayDataChange= handleDisplayDataChange;
        vm.selectedOneItemCheckboxRequests = {}
        vm.selectSingleOneItemCheckbox = selectSingleOneItemCheckbox;
        vm.selectAllOneItemCheckbox = selectAllOneItemCheckbox;
        vm.isOneItemCheckboxSelected = isOneItemCheckboxSelected;
        vm.handleDeviceSerialSearchTextChange = handleDeviceSerialSearchTextChange;
        vm.addClosingInformation = addClosingInformation;
        vm.toggleClosingInformation = toggleClosingInformation;
        vm.getValueFromTypeKey = getValueFromTypeKey;

        vm.account = baUtil.getAccountDto();
        vm.isPartner = baUtil.isPartnerUser();
        vm.isMerchant = baUtil.isMerchantOrMerchantAndDeviceOwner();
        vm.search.date = baUtil.getStartDateOfMonth();
        vm.updateOptionsVisibility = updateOptionsVisibility;

        vm.query.type = 'DEVICE'
        vm.showDownload = false;
        vm.downloadCsv = downloadCsv;
        vm.dateOptions = {
			showWeeks: false,
			datepickerMode: 'month',
            minMode: 'month',
            placeholder: 'yyyy年mm月'
        }

        vm.displayUnit = {
            en: ["Monthly", "Daily"],
            jp: ["月毎", "日毎"],
            key: ['MONTHLY', 'DAILY']
        }

        vm.aggregationPeriod = {
            "key": ['CLOSING_DATE', 'CALENDAR_MONTH'],
            "en": ['Closing period', 'Calender month period'],
            "jp": ['締め基準', '暦日基準'],
        }

        vm.displayData = {
            en: ["Sales Data", "Closing Data"],
            jp: ["売上データ", "締めデータ"],
            key: ['SALES', 'CLOSING']
        }

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }

        vm.moneyTypesOptions = {en:[],jp:[],key:[]};
        vm.productNameOptions = vm.types.ProductName;
        vm.unitPrices = unitPrices;
        vm.search.units = [];
        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.key[i] !== 'Dummy'){
                vm.moneyTypesOptions.en.push(vm.types.PaymentHandlingOption.E_MONEY.en[i]);
                vm.moneyTypesOptions.jp.push(vm.types.PaymentHandlingOption.E_MONEY.jp[i]);
                vm.moneyTypesOptions.key.push(vm.types.PaymentHandlingOption.E_MONEY.key[i]);
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {

            vm.moneyTypesOptions.en.push(vm.types.PaymentHandlingOption.QR_MONEY.en[i]);
            vm.moneyTypesOptions.jp.push(vm.types.PaymentHandlingOption.QR_MONEY.jp[i]);
            vm.moneyTypesOptions.key.push(vm.types.PaymentHandlingOption.QR_MONEY.key[i]);

        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {

            vm.moneyTypesOptions.en.push(vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]);
            vm.moneyTypesOptions.jp.push(vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]);
            vm.moneyTypesOptions.key.push(vm.types.PaymentHandlingOption.CREDIT_CARD.key[i]);

        }

        function updateOptionsVisibility(option){
            if (option === 'CLOSING' && !baUtil.isSystemAdmin()) {
                return true;
            }
            return false;
        }

        if (paymentDetail) {
            vm.paymentDetail = paymentDetail;
        }

        if (navigationDates) {
            vm.navigationDates = navigationDates;
        }

        if (allMerchants) {
            vm.allMerchants = allMerchants;
        }

        if (salesBranch) {
            vm.salesBranch = salesBranch;
        }

        if (vm.isMerchant && !(vm.query && vm.query.organisationId)) {
            vm.orgNameText = vm.account.organisation.name
            vm.search.granularity = 'DEVICE'
            vm.selectedOrg =  getOrganisationFromId(vm.account.organisation.organisationId)
            updateBranchOffice();
            var query = {
                // 'organisationId': vm.search.organisationId,
                'organisationId': vm.selectedOrg.organisationId,
                'organisationName': vm.orgNameText,
                'type': vm.search.granularity,
                'date': vm.search.date.getTime(),
                'interval' : vm.interval,
                'period' : 'CALENDAR_MONTH',
            };

            if (vm.search.period) {
                query.period = vm.search.period
            }
            vm.query = query;
        }

        if (!baUtil.isUndefinedOrNullOrEmptyObject(vm.query)) {
            vm.selectedOrg = getOrganisationFromId(vm.query.organisationId)
            vm.search.date = vm.query.date && new Date(vm.query.date)
            vm.search.period = vm.query.period;
            vm.search.granularity = vm.query.type
            vm.search.interval = vm.query.interval;
            vm.search.displayData = (vm.query.displayData ? vm.query.displayData : 'SALES');
            vm.orgNameText = vm.query.organisationName;
            vm.search.moneyTypes = vm.query.moneyTypes && vm.query.moneyTypes.split(',')
            vm.search.productNames = vm.query.productNames && vm.query.productNames.split(',')
            vm.search.branch = vm.query.branch
            vm.search.applicationSerialNumberText = vm.query.applicationSerialNumberText
            vm.search.deviceSerialSearchText = vm.query.deviceSerialSearchText
            vm.search.installationLocationText = vm.query.installationLocationText
            vm.search.remarksText = vm.query.remarksText
            vm.search.units = baUtil.isUndefinedOrNullOrEmptyObject(vm.query.units) ? [] : vm.query.units.split(',')
        }

        vm.dateOptions = {
			showWeeks: false,
			datepickerMode: 'month',
            minMode: 'month',
            placeholder: 'yyyy年mm月'
        }

        showData(vm.paymentDetail && vm.paymentDetail.content);

        function showData(data) {
            if (baUtil.isUndefinedOrNull(data)) {
                return
            }
            vm.isLoading = true;
            vm.tableHeaders = {
                'en': ['Branch/Sales Center','Product Name', 'Device Serial No.', 'Installation Store Name', 'Transaction date', 'Payment Amount', 'Processing Result', 'Error code', 'Money Type', 'Card ID', 'Processing type', 'Column ID', 'Balance before withdrawal', 'Balance after withdrawal',],
                'jp': [ '支店・営業所','品名', '端末シリアル', '設置店舗名', '決済時刻', '決済金額', '処理結果', 'エラーコード', 'マネー種', 'カード番号', ' 処理種別', 'コラムID', '引去前残高', '引去後残高',]
            }

            vm.columns = [
                'salesCenter',
                'productName',
                'deviceSerialNumber',
                'location',
                'date',
                'deductedAmount',
                'processResult',
                'errorCode',
                'moneyType',
                'cardNumber',
                'processType',
                'columnId',
                'balanceBeforeDeduction',
                'balanceAfterDeduction',
            ];


            if (vm.isMerchant || vm.isPartner) {
                vm.tableHeaders = {
                    'en': [ 'Branch/Sales Center','Product Name', 'Device Serial No.', 'Installation Store Name', 'Transaction date', 'Payment Amount', 'Processing Result', 'Money Type', 'Processing type', 'Column ID',],
                    'jp': [ '支店・営業所','品名', '端末シリアル', '設置店舗名', '決済時刻', '決済金額', '処理結果', 'マネー種', ' 処理種別', 'コラムID',]
                }

                vm.columns = [
                    'salesCenter',
                    'productName',
                    'deviceSerialNumber',
                    'location',
                    'date',
                    'deductedAmount',
                    'processResult',
                    'moneyType',
                    'processType',
                    'columnId',
                ];

                data = data.filter(function(item) { return item.processType === 'DEDUCTION' || item.processType === 'BALANCE_ENQUIRY' })
            }

            if(vm.query.displayData === 'CLOSING'){
                if(!baUtil.isUndefinedOrNull(vm.paymentDetail))
                    vm.addClosing = vm.paymentDetail.addClosing;

                vm.tableHeaders = {
                    'en': [ 'Branch/Sales Center', 'Device Serial No.', 'Installation Store Name', 'Closing Type', 'Closing Time', 'Arrival Time', 'Status'],
                    'jp': [ '支店・営業所', '端末シリアル', '設置店舗名', '締め種類', '締め時刻', '締め反映時刻', '締め状態']
                }

                vm.columns = [
                    'salesCenter',
                    'deviceSerialNumber',
                    'installationStoreName',
                    'dataTiming', 
                    'startTime',
                    'dateCreated',
                    'closingStatus',
                ];

                data.forEach(function(item){
                    if(item.dataTiming === '23'){
                        item.dataTiming = '23.締め時';
                    }
                    else item.dataTiming = '25.締めボタン押下時';        
                })
            }

            var query = angular.copy(vm.query);
            query.pageNumber = 0;
            data.forEach(function (row) {
                row.location = row.storeName;
                query.deviceSerialSearchText = row.deviceSerialNumber;
                row.deviceSerialNumber = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.deviceSerialNumber + '</a>';
                row.salesCenter = row.branchName + '\n(' + row.branchCode + ')';

                var q = angular.copy(query);
                q.installationLocationText = row.location
                row.location = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(q) }) + '">' + row.location + '</a>';

                var q1 = angular.copy(query);
                q1.moneyTypes = row.moneyType
                row.moneyType = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(q1) }) + '">' + vm.getPaymentLabelFromKey(row.moneyType) + '</a>';
            })

            $timeout(function () {
                vm.tableData = data;
                vm.showTable = true;
                vm.showDownload = true;
                vm.isLoading = false;
            });
        }


        function downloadCsv() {
            var rows = [
                vm.tableHeaders[getLang()]
            ];
            var query = angular.copy(vm.query);
            query.pageSize = -1
            query.pageNumber = 0
            SalesSettlementsService.fetchMonthlyTransaction(baUtil.makeQueryString(query),vm.query)
            .then(function (response) {
                var allTransactions = response.content;

                if (vm.isMerchant || vm.isPartner) {
                    allTransactions = allTransactions.filter(function(item) { return item.processType === 'DEDUCTION' || item.processType === 'BALANCE_ENQUIRY' })
                }

                allTransactions.forEach(function(data) {
                    data.salesCenter = data.branchName + ' (' + data.branchCode + ')';
                    data.location = data.storeName;

                    var row = [];
                    vm.columns.forEach(function(col) {
                        var val = null;
                        if (col === 'date' || col === 'startTime' || col === 'dateCreated') {
                            val = $filter('date')(data[col], 'yyyy/MM/dd HH:mm:ss');
                        } else if (col === 'moneyType') {
                            val = vm.getPaymentLabelFromKey(data[col]);
                        }else if (col === 'processType') {
                            val = vm.getProcessTypeFromKey(data[col]);
                        } else if (col === 'processResult') {
                            val = vm.getProcessResultFromKey(data[col]) ;
                        } else if(col === 'closingStatus'){
                            val = (data[col] === 'Valid'? (vm.getLang() === 'en'? 'Active' : '有効') : (vm.getLang() === 'en'?'Inactive': '無効'));
                        } else {
                            val = String(data[col]).replace(/<\/?[^>]+(>|$)/g, "");
                        }
                        val = baUtil.isUndefinedOrNull(val) ? '' : val;
                        row.push(val);
                    })
                    rows.push(row);
                });
                var serviceContractId = (allTransactions.filter(function (item) {
                    return item.serviceContractId;
                })[0] || {}).serviceContractId || '';
                if(vm.search.interval === 'DAILY') {
                    baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-'+ $filter('date')(vm.query.date, 'yyyy-MM-dd') +'.csv', rows);
                } else {
                    baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-'+ $filter('date')(vm.query.date, 'yyyy-MM') +'.csv', rows);
                }
            });
        }

        function getLang() {
            return $translate.use();
        }

        function translate(key) {
            return $translate.instant(key);
        }

        function getPaymentLabelFromKey(key) {
            var eMoneyIndex = vm.types.PaymentHandlingOption.E_MONEY.key.findIndex(function (item) { return item === key })
            if (eMoneyIndex !== -1) {
                return vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][eMoneyIndex]
            }

            var qrMoneyIndex = vm.types.PaymentHandlingOption.QR_MONEY.key.findIndex(function (item) { return item === key })
            if (qrMoneyIndex !== -1) {
                return vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][qrMoneyIndex]
            }
            var creditCardMoneyIndex = vm.types.PaymentHandlingOption.CREDIT_CARD.key.findIndex(function (item) { return item === key })
            if (creditCardMoneyIndex !== -1) {
                return vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][creditCardMoneyIndex]
            }
            return key;
        }

        function getProcessResultFromKey(item) {
            var resultIndex = vm.types.ProcessResult.key.indexOf(item);
            return vm.types.ProcessResult[vm.getLang()][resultIndex];
        }

        function getProcessTypeFromKey(item) {
            var resultIndex = vm.types.ProcessType.key.indexOf(item);
            return vm.types.ProcessType[vm.getLang()][resultIndex];
        }

        function navigate(type) {
            vm.inProgress = true;
            vm.isLoading = true;
            vm.query.pageNumber = '0';
            var query = angular.copy(vm.query);

            if (vm.query.interval === 'DAILY') {
                switch (type) {
                    case 'NEXT':
                        query.date = baUtil.getStartOfNextDay(query.date);
                        break;
                    case 'PREV':
                        query.date = baUtil.getStartOfPrevDay(query.date);
                        break;
                    case 'FIRST':
                        query.date = baUtil.getStartOfDay(vm.navigationDates.from).getTime();
                        break;
                    case 'LAST':
                        query.date = baUtil.getStartOfDay(vm.navigationDates.to).getTime();
                        break;
                    default:
                        return
                }
            } else {
                switch (type) {
                    case 'NEXT':
                        query.date = baUtil.getStartOfNextMonth(query.date);
                        break;
                    case 'PREV':
                        query.date = baUtil.getStartOfPrevMonth(query.date);
                        break;
                    case 'FIRST':
                        query.date = baUtil.getStartDateOfMonth(vm.navigationDates.from).getTime();
                        break;
                    case 'LAST':
                        query.date = baUtil.getStartDateOfMonth(vm.navigationDates.to).getTime();
                        break;
                    default:
                        return
                }
            }

            getData(query)
        }

        function paginateCallback(query) {
            getData(query)
        }

        function getData(query) {
            if (!query.pageSize) {
                query.pageSize = 100;
            }
            SalesSettlementsService.fetchMonthlyTransaction(baUtil.makeQueryString(query),vm.query)
                .then(function (response) {
                    vm.paymentDetail = response;
                    showData(response.content)
                    vm.inProgress = false;
                    vm.query = query;
                });
        }

        function getOrganisationFromId(organisationId) {
            if (baUtil.isUndefinedOrNull(organisationId)) {
                return null
            }
            return vm.allMerchants.find(function (item) { return item.organisationId === organisationId })
        }

        function updateBranchOffice() {
            vm.search.branch = '';
            if (baUtil.isUndefinedOrNull(vm.selectedOrg.organisationId)) {
                return null
            }
            SalesSettlementsService.getSettlementBranches(vm.selectedOrg.organisationId)
                .then(function (response) {
                    vm.salesBranch = response;
                });
            // SalesSettlementsService.getOneItemPricesForOrganisation(vm.selectedOrg.organisationId)
            //     .then(function (response) {
            //         vm.unitPrices = response;
            //         vm.search.units = [];
            //     });
        }

        function listMonthlySales() {
            if (vm.searchForm.$invalid) {
                toastr.error($translate.instant('common.components.errorMessages.fillRequiredFields'),
                                $translate.instant('common.components.errorMessages.error'), baUtil.toastOptions())
                return;
            }

            vm.isLoading = true;
            var search = {
                'organisationId': vm.selectedOrg.organisationId,
                'organisationName': vm.selectedOrg.name,
                'type': vm.search.granularity,
                'date': vm.search.date.getTime(),
                'interval' : vm.search.interval,
                'period' : vm.search.period,
                'applicationSerialNumberText': vm.search.applicationSerialNumberText,
                'moneyTypes': vm.search.moneyTypes && vm.search.moneyTypes.join(','),
                'productNames':vm.search.productNames && vm.search.productNames.join(','),
                'branch': vm.search.branch,
                'branchCode': vm.search.branch && vm.search.branch.key,
                'deviceSerialSearchText': vm.search.deviceSerialSearchText,
                'installationLocationText': vm.search.installationLocationText,
                'remarksText': vm.search.remarksText,
                'units': vm.search.units && vm.search.units.join(','),
                'displayData' : vm.search.displayData
            };

            if (search.branchCode === 'Total') {
                search.branchCode = '';
            }

            if (vm.search.period) {
                search.period = vm.search.period
            }

            vm.showTable = false;
            vm.addClosing = false;
            getData(search)
        }

        function getData(query) {
            vm.inProgress = true;
            $state.go($state.current.name, { query: JSON.stringify(query)}, {reload: true});
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function getRowStyle(data){
            if(data.closingStatus === 'Invalid'){
                return { 'background-color': 'lightgray' }; 
            }
            return { 'background-color': 'white' }; 
        }

        function handleDisplayDataChange(value){
            vm.showTable = false;
            vm.addClosing = false;
            if(value === 'CLOSING'){
                vm.search.period = 'CALENDAR_MONTH';
            }
            else vm.search.period = '';
        }

        function handleDeviceSerialSearchTextChange(value){
            if(!vm.search.deviceSerialSearchText && value === 'CLOSING'){
                vm.search.displayData = 'SALES';
            }
        }

        function isOneItemCheckboxSelected() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedOneItemCheckboxRequests)) {
                return false
            }
            return Object.keys(vm.selectedOneItemCheckboxRequests).some(function (id) { return vm.selectedOneItemCheckboxRequests[id] });
        }

        vm.oneItemCheckboxCount = 0;
        function selectSingleOneItemCheckbox(ev, list) {
            if (ev.target.checked) {
                vm.oneItemCheckboxCount = vm.oneItemCheckboxCount + 1;
            }
            else {
                vm.oneItemCheckboxCount = vm.oneItemCheckboxCount - 1;
            }
        }

        function selectAllOneItemCheckbox(ev, list) {
            list.forEach(function (item) {
                vm.selectedOneItemCheckboxRequests[item.basicInfoId] = ev.target.checked
            })
            if (ev.target.checked) {
                vm.oneItemCheckboxCount = list.length;
            }
            else {
                vm.oneItemCheckboxCount = 0;
            }
        }

        $scope.$on('LANG_CHANGE', function (event) {
            vm.showTable = false;
            vm.addClosing = false;
            var data = vm.paymentDetail && vm.paymentDetail.content
            showData(data);
        });

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

        function addClosingInformation() {
            var queryString = {};
            queryString.organisationId = vm.query.organisationId;
            queryString.branchCode = vm.query.branchCode;
            queryString.deviceSerialSearchText = vm.query.deviceSerialSearchText;
            queryString.type = vm.query.type;
            var date = new Date();
            var addClosingInfoDate = date.getFullYear() + '/'+ ('0'+(date.getMonth()+1)).slice(-2) + '/' + ('0'+date.getDate()).slice(-2) + ' ' + ('0'+date.getHours()).slice(-2) + ':' + ('0'+date.getMinutes()).slice(-2) + ':' + ('0'+date.getSeconds()).slice(-2);

            SalesSettlementsService.getClosingHeaders(baUtil.makeQueryString(queryString))
            .then(function (headers) {
                var filteredHeaders = headers.filter(function(header){
                    return header.version == 2;
                });
                SalesSettlementsService.getAddClosingRows(baUtil.makeQueryString(queryString))
                .then(function (rows) {
                    rows.status = getValueFromTypeKey(rows.status,vm.types.DeviceRunningStatus);
                    SalesSettlementsService.getAddClosingEnums()
                    .then(function (enums) {
                        $state.go('main.salesSettlements.oneItem.addClosing', { query : vm.query, headers : filteredHeaders, rows : rows, enums : enums, addClosingInfoDate : addClosingInfoDate});
                    });
                });                 
            });
           
        }  

        function toggleClosingInformation(){
            var queryString = {};
            queryString.organisationId = vm.query.organisationId;
            queryString.branchCode = vm.query.branchCode;
            queryString.deviceSerialSearchText = vm.query.deviceSerialSearchText;
            queryString.type = vm.query.type;

            var selectedRows = [];
            vm.paymentDetail.content.forEach(function(selectedRow){
                if(selectedRow.basicInfoId in vm.selectedOneItemCheckboxRequests && vm.selectedOneItemCheckboxRequests[selectedRow.basicInfoId] === true){
                    selectedRows.push(JSON.parse(JSON.stringify(selectedRow)));
                }                
            })
            selectedRows.forEach(function(selectedRow){
                delete selectedRow.salesCenter;
                delete selectedRow.location;
                delete selectedRow.moneyType;

                selectedRow.deviceSerialNumber = queryString.deviceSerialSearchText;
                selectedRow.closingStatus = selectedRow.closingStatus === 'Valid' ? (vm.getLang() === 'en'? 'Active' : '有効') : (vm.getLang() === 'en'?'Inactive': '無効') ;

                if(selectedRow.arrivalTime){
                    var unParsedArrivalTime = new Date(selectedRow.arrivalTime);
                    selectedRow.arrivalTime = unParsedArrivalTime.getFullYear() + '/'+ ('0'+(unParsedArrivalTime.getMonth()+1)).slice(-2) + '/' + ('0'+unParsedArrivalTime.getDate()).slice(-2) + ' ' + ('0'+unParsedArrivalTime.getHours()).slice(-2) + ':' + ('0'+unParsedArrivalTime.getMinutes()).slice(-2) + ':' + ('0'+unParsedArrivalTime.getSeconds()).slice(-2);    
                }
                if(selectedRow.startTime){
                    var unParsedStartTime = new Date(selectedRow.startTime);
                    selectedRow.startTime = unParsedStartTime.getFullYear() + '/'+ ('0'+(unParsedStartTime.getMonth()+1)).slice(-2) + '/' + ('0'+unParsedStartTime.getDate()).slice(-2) + ' ' + ('0'+unParsedStartTime.getHours()).slice(-2) + ':' + ('0'+unParsedStartTime.getMinutes()).slice(-2) + ':' + ('0'+unParsedStartTime.getSeconds()).slice(-2);    
                }
                if(selectedRow.status){
                    selectedRow.status = getValueFromTypeKey(selectedRow.status,vm.types.DeviceRunningStatus);
                }
            })

            SalesSettlementsService.getClosingHeaders(baUtil.makeQueryString(queryString))
            .then(function (headers) {
                var filteredHeaders = headers.filter(function(header){
                    return header.version == 1;
                });
                SalesSettlementsService.getAddClosingEnums()
                .then(function (enums) {
                    $state.go('main.salesSettlements.oneItem.toggleClosing', { query : vm.query, headers : filteredHeaders, rows : selectedRows, enums : enums});
                });
            });

        }

    }
})();

(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements')
        .controller('SalesListCtrl', SalesListCtrl);

    /** @ngInject */
    function SalesListCtrl(SalesSettlementsService, $filter, DeviceRequestService, types, $translate, $timeout, toastr, baUtil, $state, $scope, $stateParams, salesList, salesStats, aggregationDates, allMerchants, salesBranch, localStorageService, $uibModal, salesPropertyMap, isDownloadReportsEnabled, $rootScope) {
        var vm = this;

        vm.getOrganisation = getOrganisation;
        vm.getLang = getLang;
        vm.listMonthlySales = listMonthlySales;
        vm.onOrgSelected = onOrgSelected;
        vm.navigate = navigate;
        vm.getBranchData = getBranchData;
        vm.getUnitPriceBranchData = getUnitPriceBranchData;
        vm.interval = $stateParams.interval;
        vm.account = baUtil.getAccountDto();
        vm.dateFormat = 'yyyy/MM'
        vm.search = {};
        vm.salesBranch = {};
        vm.navigationDates = aggregationDates || {};
        vm.baUtil = baUtil;
        vm.query = $stateParams.query ? JSON.parse($stateParams.query) : {};
        vm.branchQuery = $stateParams.query ? JSON.parse($stateParams.query) : {};
        vm.search.date = baUtil.getStartDateOfMonth();
        vm.isMerchant = baUtil.isMerchantOrMerchantAndDeviceOwner();
        vm.isPartner = baUtil.isPartnerUser();
        vm.downloadAggCsv = downloadAggCsv;
        vm.downloadAggCsvUnitPrice = downloadAggCsvUnitPrice;
        vm.downloadAggDetailCsv = downloadAggDetailCsv;
        vm.downloadAggDetailCsvUnitPrice = downloadAggDetailCsvUnitPrice;
        vm.updateBranchOffice = updateBranchOffice;
        vm.showTable = false;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.handleProductNameChange = handleProductNameChange;
        vm.isProductNameSelected = false;
        vm.downloadMonthlySales = downloadMonthlySales;
        vm.validateListMonthlySales = validateListMonthlySales;
        vm.salesPropertyMap = {};
        vm.navigateToDownloadReports = navigateToDownloadReports;
        vm.isDownloadReportsEnabled = false;
      
        if(!baUtil.isUndefinedOrNullOrEmpty(vm.query.productNames)){
            this.isProductNameSelected = true;
        }

        vm.csvDeviceInstallationKeys = {
            "applicationNumber": {
                "en": "Application No",
                "jp": "申込通番"
            },
            "companyName": {
                "en": "Company Name",
                "jp": "会社名"
            },
            "serviceContractId": {
                "en": "Contract ID",
                "jp": "契約先ID"
            },
            "date": {
                "en": "Date of Application",
                "jp": "申込年月日"
            },
            "branchCode": {
                "en": "Invoice Destination Branch Code",
                "jp": "請求先支店コード"
            },
            "branchName": {
                "en": "Invoice Destination Branch Name",
                "jp": "請求先支店名"
            },
            "branchPersonInCharge": {
                "en": "Incharge Name",
                "jp": "担当者名"
            },
            "branchPersonInChargeEmail": {
                "en": "Incharge Email",
                "jp": "担当者連絡先 (Email)"
            },
            "preferredDateOfInstallation": {
                "en": "Preferred Date of Installation",
                "jp": "設置希望日"
            },
            "remarks5": {
                "en": "Installation Destination Code",
                "jp": "設置宛先コード"
            },
            "storeName": {
                "en": "Installation Store Name",
                "jp": "設置店舗名"
            },
            "storeNameSimple": {
                "en": "Installation Store Name(Kana)",
                "jp": "設置店舗名（カナ）"
            },
            "storePin": {
                "en": "Zip Code",
                "jp": "郵便番号"
            },
            "storeState": {
                "en": "State",
                "jp": "都道府県"
            },
            "storeAddress": {
                "en": "City/Town/Street",
                "jp": "市区町村・丁目・番地"
            },
            "storeAddressKana": {
                "en": "City/Town/Street(Kana)",
                "jp": "市区町村・丁目・番地（カナ)"
            },
            "storeBuilding": {
                "en": "Building Name",
                "jp": "ﾋﾞﾙ名"
            },
            "vendingMachineModel": {
                "en": "Vending Machine Model",
                "jp": "自販機機種名"
            },
            "remarks4": {
                "en": "Vending Machine Number",
                "jp": "自動販売機番号"
            },
            "deliveryPin": {
                "en": "HW Delivery Pin",
                "jp": "端末配送先 郵便番号"
            },
            "deliveryAddress": {
                "en": "HW Delivery Address",
                "jp": "端末配送先住所"
            },
            "deliveryCompanyName": {
                "en": "HW Delivery Company Name",
                "jp": "端末配送先会社名"
            },
            "deliveryDepartment": {
                "en": "HW Delivery Destination Department",
                "jp": "端末配送先部署/役職"
            },
            "deliveryDepartmentDesignation": {
                "en": "HW Delivery Destination Designation",
                "jp": "端末配送先指名"
            },
            "deliveryDepartmentPhone": {
                "en": "HW Delivery Destination TEL",
                "jp": "端末配送先TEL"
            },
            "hardwareOption1": {
                "en": "HW Option 1",
                "jp": "ハードウェアオプション１"
            },
            "hardwareOption2": {
                "en": "HW Option 2",
                "jp": "ハードウェアオプション2"
            },
            "hardwareOption3": {
                "en": "HW Option 3",
                "jp": "ハードウェアオプション3"
            },
            "hardwareOption4": {
                "en": "HW Option 4",
                "jp": "ハードウェアオプション4"
            },
            "remarks1": {
                "en": "Remarks 1",
                "jp": "備考１"
            },
            "remarks2": {
                "en": "Remarks 2",
                "jp": "備考2"
            },
            "remarks3": {
                "en": "Remarks 3",
                "jp": "備考3"
            },
            "remarks11": {
                "en": "Remarks 11",
                "jp": "備考11"
            },
            "remarks12": {
                "en": "Remarks 12",
                "jp": "備考12"
            },
            "remarks21": {
                "en": "Remarks 21",
                "jp": "備考21"
            },
            "remarks22": {
                "en": "Remarks 22",
                "jp": "備考22"
            }
        }
        vm.aggregationPeriod = {
            "key": ['CLOSING_DATE', 'CALENDAR_MONTH'],
            "en": ['Closing period', 'Calender month period'],
            "jp": ['締め基準', '暦日基準'],
        }


        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        if (salesPropertyMap.status >= 200 && salesPropertyMap.status <= 299) {
            vm.salesPropertyMap = salesPropertyMap.data.data;
        }
        if (isDownloadReportsEnabled.status >= 200 && isDownloadReportsEnabled.status <= 299) {
            vm.isDownloadReportsEnabled = isDownloadReportsEnabled.data.data;
        }
        vm.productNameOptions = vm.types.ProductName;

        vm.tableOptions = {
                        'branchName': {
                            'en': 'Branch/Sales Center',
                            'jp': '支店・営業所',
                            'column': 'entityName'
                        },
                        'productNameKey': {
                            'en': 'Product Name',
                            'jp': '品名',
                            'column': 'productName'
                        },
                        'deviceSerial': {
                            'en': 'Device Serial No',
                            'jp': '端末シリアル',
                            'column': 'entityId'
                        },
                        'deviceCount': {
                            'en': 'Device Count',
                            'jp': '端末数',
                            'column': 'numberOfDevices'
                        },
                        'installationLocation': {
                            'en': 'Installation Store Name',
                            'jp': '設置店舗名',
                            'column': 'storeName'
                        },
                        'startTime': {
                            'en': 'Closing start time',
                            'jp': '締め時刻',
                            'column': 'startDate'
                        },
                        'endTime': {
                            'en': 'Closing end time',
                            'jp': '締め時刻',
                            'column': 'endDate'
                        },
                        'date': {
                            'en': 'Date',
                            'jp': '日付',
                            'column': 'entityId'
                        },
                        'unit': {
                            'en': 'Unit Price',
                            'jp': '単価',
                            'column': 'unitPrice'
                        },
                        'total': {
                            'en': 'Total',
                            'jp': '合計',
                            'column': 'totalPayment'
                        }
                };


        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.tableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i]] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i],
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i],
                  };
            }
        }


        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.tableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i]] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i],
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.tableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i]] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i],
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i],
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i],
                  };
            }
        }

        vm.dateFormatCSV = '';

        if (vm.interval === 'DAILY') {
            vm.dateFormatCSV = 'yyyy-MM-dd';
        } else {
            vm.dateFormatCSV = 'yyyy-MM';
        }

        if (vm.interval !== 'DAILY') {
            vm.search.period = 'CALENDAR_MONTH'
        }

        if (salesBranch) {
            vm.salesBranch = salesBranch;
        }

        vm.dateOptions = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month'
        }

        if (allMerchants) {
            vm.allMerchants = allMerchants;
        }


        if (vm.interval === 'DAILY') {
            vm.search.date = baUtil.getStartOfDay();
            vm.dateFormat = 'longDate'
            delete vm.dateOptions.datepickerMode
            delete vm.dateOptions.minMode
        }

        if (vm.isMerchant && baUtil.isUndefinedOrNullOrEmptyObject(vm.query)) {
            vm.orgNameText = vm.account.organisation.name
            vm.search.granularity = 'BRANCH'
            // vm.search.organisationId =  vm.account.organisation.organisationId
            vm.selectedOrg = getOrganisationFromId(vm.account.organisation.organisationId)
            updateBranchOffice();

            var query = {
                // 'organisationId': vm.search.organisationId,
                'organisationId': vm.selectedOrg.organisationId,
                'organisationName': vm.orgNameText,
                'type': vm.search.granularity,
                'date': vm.search.date.getTime(),
                'interval': vm.interval,
            };

            if (vm.search.period) {
                query.period = vm.search.period
            }

//            getData(query)
        }

        if (vm.isPartner) {
            vm.search.granularity = 'BRANCH'
        }

        if (!baUtil.isUndefinedOrNullOrEmptyObject(vm.query)) {
            // vm.search.organisationId = vm.query.organisationId
            vm.selectedOrg = getOrganisationFromId(vm.query.organisationId)
            vm.search.date = new Date(vm.query.date)
            vm.search.granularity = vm.query.type
            vm.interval = vm.query.interval;
            vm.search.period = vm.query.period;
            vm.orgNameText = vm.query.organisationName;
            vm.search.branch = vm.query.branch
            vm.search.applicationSerialNumberText = vm.query.applicationSerialNumberText
            vm.search.deviceSerialSearchText = vm.query.deviceSerialSearchText
            vm.search.installationLocationText = vm.query.installationLocationText
            vm.search.remarksText = vm.query.remarksText
            vm.search.productNames = vm.query.productNames && vm.query.productNames.split(',')
            vm.unitPrice = vm.query.unitPrice
            vm.paginateCallback = paginateCallback
            vm.paginateCallbackBranch = paginateCallbackBranch
        }

        if (!baUtil.isUndefinedOrNull(salesList) && !baUtil.isUndefinedOrNull(salesList.content)) {
            prepareTableData(salesList.content);
            vm.salesList = [];
            vm.salesList.pageable = salesList.pageable;
            vm.salesList.totalPages = salesList.totalPages;
            vm.salesList.totalElements = salesList.totalElements;
        }


        $(function() {
           $(".deviceCount").click(function(){
                var branch = $(this).attr('id');
                getUnitPriceBranchData(branch);
           });
        });


        function prepareSalesStats() {
            if(vm.search.granularity === "DEVICE" || vm.unitPriceAggregation || vm.showBranchTable) {
                vm.salesStats = salesStats;
            } 
        }

        function handleProductNameChange(value){
            if(value.length >0){
                vm.search.granularity = "DEVICE"
                vm.isProductNameSelected = true;
            }else{
                vm.isProductNameSelected = false;
            }
        }


        function prepareTableData(data) {
          
            vm.isLoading = true;
//            if(!vm.loadRecords) {
//            }


            if (baUtil.isUndefinedOrNull(data)) {
                return
                vm.isLoading = false;
            }

            var tableOptionKeys = Object.keys(vm.tableOptions);

            if (!vm.unitPrice) {
                tableOptionKeys = tableOptionKeys.filter(function (key) {return key !== 'unit'})
            }

            if (vm.interval === 'DAILY' || vm.search.period === 'CALENDAR_MONTH') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'startTime' && key !== 'endTime' })
            }

            if (vm.search.granularity === 'DEVICE') {
                var tableHeaders = [];
                var columns = [];
                tableOptionKeys.filter(function (key) { return key !== 'deviceCount' && key !== 'date' }).forEach(function (item) {
                    tableHeaders.push(vm.tableOptions[item][vm.getLang()])
                    columns.push(vm.tableOptions[item].column)
                })
                vm.tableHeaders = tableHeaders;
                vm.columns = columns;
            }

            if (vm.search.granularity === 'BRANCH') {
                var tableHeaders = [];
                var columns = [];
                tableOptionKeys.filter(function (key) { return key!== 'productNameKey' && key !== 'deviceSerial' && key !== 'startTime' && key !== 'endTime' && key !== 'installationLocation' && key !== 'date' }).forEach(function (item) {
                    tableHeaders.push(vm.tableOptions[item][vm.getLang()])
                    columns.push(vm.tableOptions[item].column)
                })
                vm.tableHeaders = tableHeaders;
                vm.columns = columns;
            }

            if (vm.search.granularity === 'DAILY') {
                var tableHeaders = [];
                var columns = [];
                tableOptionKeys.filter(function (key) { return key!== 'productNameKey' && key !== 'deviceSerial' && key !== 'startTime' && key !== 'endTime' && key !== 'installationLocation' && key !== 'branchName' && key !== 'deviceCount' }).forEach(function (item) {
                    tableHeaders.push(vm.tableOptions[item][vm.getLang()])
                    columns.push(vm.tableOptions[item].column)
                })
                vm.tableHeaders = tableHeaders;
                vm.columns = columns;
            }

            vm.unitMoney = [];

            angular.forEach(vm.types.PaymentHandlingOption.E_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.E_MONEY["inUse"][key] ) return;
                vm.unitMoney.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.QR_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.QR_MONEY["inUse"][key] ) return;
                vm.unitMoney.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.CREDIT_CARD.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.CREDIT_CARD["inUse"][key] ) return;
                vm.unitMoney.push(value);
            });

            var tableData = [];

            var query = angular.copy(vm.query);

            data.forEach(function (row) {
                var rowData = {};
                rowData.numberOfDevices = row.numberOfDevices;
                var uniqueDevices = row.numberOfDevices - row.numberOfReplacedDevices;
                if (vm.search.granularity === 'BRANCH') {
                    if (row.entityName === 'Total' & row.entityId === 'Total') {
                        rowData.entityName = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                        rowData.numberOfDevices = row.numberOfReplacedDevices ? row.numberOfDevices  + 
                        ' (' + uniqueDevices + ')' : row.numberOfDevices;
                    }
                    else {
                        if (row.entityId !== 'Total') {
                            query.branchCode = row.entityId
                        }
                        query.branch = { "key": row.entityId, "value": row.entityName }
                        rowData.entityName = row.entityName + ' (' + row.entityId + ')';
                    }
                }

                if (vm.search.granularity === 'DEVICE') {
                    if (row.entityName === 'Total') {
                        rowData.entityName = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                    } else {
                        rowData.entityName = row.entityName;
                    }
                }
                
             
                rowData.entityId = row.entityId;

                if (row.entityId !== 'Total' && vm.search.granularity === 'DEVICE') {
                    query.deviceSerialSearchText = row.entityId;
                }

                if (row.entityId === 'Total') {
                    rowData.startDate = '-';
                    rowData.endDate = '-';
                }
                else {
                    rowData.startDate = row.startDate;
                    rowData.endDate = row.endDate;
                }

                if (vm.search.granularity === 'DEVICE' && row.entityId !== 'Total') {
                    query.pageNumber = 0;
                    var isReplaced = checkIfReplaced(row.entityId, row.entityName);
                    rowData.entityId = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';
                    if(isReplaced === 1){
                        rowData.entityId = '<a class="after-replacement" href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';    
                    }
                    if(isReplaced === 2){
                        rowData.entityId = '<a class="before-replacement" href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';    
                    }
                }

                if (row.storeName) {
                    var q = angular.copy(query)
                    q.installationLocationText = row.storeName
                    rowData.storeName = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(q) }) + '">' + row.storeName + '</a>';
                }

                if (row.productName) {
                    rowData.productName = row.productName;
                }
        
                if (row.entityId === 'Total') {
                    rowData.entityId = '-';
                    rowData.storeName = '-';
                    rowData.productName = '-';
                }


                if (vm.unitPrice) {

                    vm.unitPriceAggregation = true;

                    rowData.unitPrice = [];
                    rowData.unitPriceKeys = [];
                    rowData.testRow = [];
                    rowData.dataRow = [];
                    vm.dataRowCSV = [];
                    rowData.dataRowHeader = [];
                        rowData.aa = [];


                    var op = '';

                    for (var u = 0; u < vm.tableHeaders.length; u++) {
                        if (vm.columns[u] === 'endDate') {
                            var msg = $translate.instant('salesSettlements.closing.date.info');
                            op += '<td class="table-th">'+ vm.tableHeaders[u] + '&nbsp; <a class="m-no-error" title="'+ msg +'"><i class="fa fa-info-circle"></i></a></td>';
                        }
                        else {
                            op += '<td class="table-th">'+ vm.tableHeaders[u] + '</td>';
                        }
                    }

                    rowData.dataRowHeader.push('<tr>' + op + '</tr>');

                    angular.forEach(row.items, function (value, key) {
                        angular.forEach(value, function (i,k) {
                            var item = i;
                            var data = item.numItems + ' 件 /' + item.totalCost + ' 円 '
                            var obj = angular.copy(query);
                            obj.moneyTypes = k
                            obj.units = key
                            if (row.entityName === 'Total') {
                                var branchCodeUnitPrice = row.entityName;
                                var branchNameUnitPrice = row.entityName;
                            }
                            else {
                                var aa = row.entityName.split(/(\d+)/);

                                var branchCodeUnitPrice = aa[aa.length - 2];
                                var branchNameUnitPrice = aa[0].split('(')[0];
                            }
                            obj.branchCode = branchCodeUnitPrice;
                            obj.branch = {
                                "key":branchCodeUnitPrice,
                                "value":branchNameUnitPrice
                            }
                            if (vm.search.granularity === 'DAILY') {
                                obj.date = Number(row.entityId)
                                obj.interval = 'DAILY'
                                delete obj.branchCode;
                                delete obj.branch;
                            }
                            if (row.entityName === 'Total') {
                                delete obj.branch;
                            }
                            if (baUtil.isUndefinedOrNullOrEmptyObject(rowData.unitPrice[key])) {
                                rowData.unitPrice[key] = [];
                            }

                            vm.branchCodeUnitPrice = branchCodeUnitPrice;
                            vm.branchNameUnitPrice = branchNameUnitPrice;


                            var combine = 'unitPrice_' + key + '_' + k ;
                            rowData.unitPrice[key][k] = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + data + '</a>';
                            rowData[combine] = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + data + '</a>';

                            var totalPayment = row.items[key].Total.numItems + ' 件 /' + row.items[key].Total.totalCost + ' 円';
                            rowData.totalPayment = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + totalPayment + '</a>';
                            rowData.unitPrice.rowspan = Object.keys(rowData.unitPrice).length - 1;

                        })
                        rowData.unitPriceKeys.push(key);
                    })
                        if (row.entityName === 'Total' & row.entityId === 'Total') {
                             var cName  = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                        }
                        else {
                            var cName = row.entityName;
                        }
                        var nDevices = rowData.numberOfDevices;
                        var entityIdColumn = rowData.entityId;
                        var storeName = rowData.storeName;
                        var productNameColumn = rowData.productName;
                        var closingStartDate = rowData.startDate;
                        var closingEndDate = rowData.endDate;
                        if (vm.search.granularity === 'DEVICE') {

                            if (closingStartDate !== '-') {
                                closingStartDate = $filter('date')(new Date(closingStartDate), 'yyyy/MM/dd HH:mm:ss');
                            }
                            if (closingEndDate !== '-') {
                                closingEndDate = $filter('date')(new Date(closingEndDate), 'yyyy/MM/dd HH:mm:ss');
                            }

                        }

                        var obj = angular.copy(query);
                        if (vm.search.granularity === 'DAILY') {
                            obj.date = Number(row.entityId)
                            obj.interval = 'DAILY'
//                            rowData.entityId = '<a href="' + $state.href('main.salesSettlements.daily.list', { query: getQueryForDetail(obj) }) + '">' + $filter('date')(rowData.entityId, 'yyyy/MM/dd') + '</a>';
                            if(cName !== 'Total') {
                                entityIdColumn = '<a href="' + $state.href('main.salesSettlements.daily.list', { query: getQueryForDetail(obj) }) + '">' + $filter('date')(entityIdColumn, 'yyyy/MM/dd') + '</a>';
//                                entityIdColumn = $filter('date')(new Date(Number(entityIdColumn)), 'yyyy/MM/dd');
                            }
                        }

                        if (vm.search.granularity === 'DAILY') {

                        }

                        Object.keys(row.items).forEach(function (i, k) {
                            vm.uPriceKey = i;

                        })
                        var uPriceKeyLength = rowData.unitPriceKeys.length;
                        for (var m=0; m<uPriceKeyLength; m++) {
                            if (m < 1) {
                                if (vm.search.granularity === 'BRANCH') {
                                    var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ cName +'</td><td rowspan="'+ uPriceKeyLength +'"><span class="deviceCount" id="'+ vm.branchCodeUnitPrice +'">'+ nDevices +'</span></td><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                                    var csvItem1 ='"'+ cName +'""'+ nDevices +'""'+ rowData.unitPriceKeys[m] +'""'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'"';
                                }
                                if (vm.interval === 'DAILY' && vm.query.type === 'DEVICE') {
                                    var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ cName +'</td><td rowspan="'+ uPriceKeyLength +'">'+ productNameColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ entityIdColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ storeName +'</td><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                                }
                                if (vm.search.granularity === 'DEVICE' && vm.search.period === 'CLOSING_DATE') {
                                    var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ cName +'</td><td rowspan="'+ uPriceKeyLength +'">'+ productNameColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ entityIdColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ storeName +'</td><td rowspan="'+ uPriceKeyLength +'">'+ closingStartDate +'</td><td rowspan="'+ uPriceKeyLength +'">'+ closingEndDate +'</td><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                                }
                                if (vm.search.granularity === 'DEVICE' && vm.search.period === 'CALENDAR_MONTH') {
                                    var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ cName +'</td><td rowspan="'+ uPriceKeyLength +'">'+ productNameColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ entityIdColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ storeName +'</td><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                                }
                                if (vm.search.granularity === 'DAILY' && vm.search.period === 'CALENDAR_MONTH') {
//                                    var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ entityIdColumn +'</td><td><a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + rowData.unitPriceKeys[m] + '</a></td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                                    var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ entityIdColumn +'</td><td>' + rowData.unitPriceKeys[m] + '</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                                }

                            var b = '';
                            var csvItem2 ='';

                            for (var u = 0; u < vm.unitMoney.length; u++) {
                                var cellValue = rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_' + vm.unitMoney[u]];
                                if(baUtil.isUndefinedOrNull(cellValue)){cellValue = '0 件 /0 円'};
                                b += '<td>'+ cellValue + '</td>';
                                csvItem2 += '"'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_' + vm.unitMoney[u]] + '"';
                            }

                            var c = '</tr>';

                            rowData.dataRow.push(a + b + c);
                            vm.dataRowCSV.push(csvItem1 + csvItem2);

//                            rowData.aa.push('<td>'+ rowData.unitPrice_90_TRANSPORT +'</td><td>nanco</td><td>waon</td><td>edy</td><td>id</td><td>quickpay</td><td>line</td><td>alipay</td><td>wechat</td><td>rakuten</td><td>other1</td><td>other2</td><td>other3</td></tr>');

                            }
                            else {
                            var a = '<tr><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                            var csvItem1 ='"'+ cName +'""'+ nDevices +'""'+ rowData.unitPriceKeys[m] +'""'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'"';

                            var b = '';
                            var csvItem2 ='';

                            for (var u = 0; u < vm.unitMoney.length; u++) {
                                var cellValue = rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_' + vm.unitMoney[u]];
                                if(baUtil.isUndefinedOrNull(cellValue)){cellValue = '0 件 /0 円'};
                                b += '<td>'+ cellValue + '</td>';
                                csvItem2 += '"'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_' + vm.unitMoney[u]] + '"';
                            }
                            var c = '</tr>';
                            rowData.dataRow.push(a + b + c);
                            }

                        }

                }
                else {

                    vm.unitPriceAggregation = false;

                    Object.keys(row.items).forEach(function (key) {


                        var item = row.items[key];
                        var data = item.numItems + ' 件 /' + item.totalCost + ' 円 '
                        var obj = angular.copy(query);
                        obj.moneyTypes = key
                        if (vm.search.granularity === 'DAILY') {
                            obj.date = Number(row.entityId)
                            obj.interval = 'DAILY'
                        }
                        rowData[key] = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + data + '</a>';
                    })
                    angular.forEach(vm.unitMoney, function(value) {
                        if(!rowData[value]){
                            rowData[value] = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + '0 件 /0 円' + '</a>';
                        }
                    });

                    var obj = angular.copy(query);
                    if (vm.search.granularity === 'DAILY') {
                        obj.date = Number(row.entityId)
                        obj.interval = 'DAILY'
                        rowData.entityId = '<a href="' + $state.href('main.salesSettlements.daily.list', { query: getQueryForDetail(obj) }) + '">' + $filter('date')(rowData.entityId, 'yyyy/MM/dd') + '</a>';
                    }

                    var totalPayment = row.total.numItems + ' 件 /' + row.total.totalCost + ' 円'
                    rowData.totalPayment = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + totalPayment + '</a>';
                }

                tableData.push(rowData);
                prepareSalesStats();

            });

            $timeout(function () {
                vm.tableData = tableData;
                vm.showTable = true;
                vm.isLoading = false;
            });
        }

        function downloadAggCsv() {

            var moneyBrands = [];

            angular.forEach(vm.types.PaymentHandlingOption.E_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.E_MONEY["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.QR_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.QR_MONEY["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.CREDIT_CARD.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.CREDIT_CARD["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            var rows = [];
            var tableOptionKeys = Object.keys(vm.tableOptions);
            var head = [];
            if (vm.interval === 'DAILY' || vm.search.period === 'CALENDAR_MONTH') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'startTime' && key !== 'endTime'});
            }

            if (vm.query.type === 'BRANCH') {
                tableOptionKeys.filter(function (key) { return key!== 'productNameKey' && key !== 'deviceSerial' && key !== 'startTime' && key !== 'endTime' && key !== 'installationLocation' && key !== 'date' && key !== 'unit' }).forEach(function (item) {
                    if (item === 'deviceCount' || item === 'branchName') {
                        head.push(vm.tableOptions[item][vm.getLang()]);
                    } else {
                        if (item !== 'deviceCount' && item !== 'branchName')
                            head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                    }
                })
            }
            if (vm.query.type === 'DEVICE') {
                tableOptionKeys.filter(function (key) { return key !== 'deviceCount' && key !== 'date' && key !== 'unit' }).forEach(function (item) {
                    if (item === 'branchName' || item === 'productNameKey' || item === 'deviceSerial' || item === 'installationLocation' || item === 'startTime' || item === 'endTime') {
                        head.push(vm.tableOptions[item][vm.getLang()]);
                    } else {
                        if (item !== 'deviceCount' && item !== 'branchName')
                            head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                            head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                    }
                })
            }
            if (vm.query.type === 'DAILY') {
                tableOptionKeys.filter(function (key) { return key!== 'productNameKey' && key !== 'deviceSerial' && key !== 'startTime' && key !== 'installationLocation' && key !== 'endTime' && key !== 'branchName' && key !== 'deviceCount' && key !== 'unit' }).forEach(function (item) {
                    if (item === 'date') {
                        head.push(vm.tableOptions[item][vm.getLang()]);
                    }
                    if (item !== 'date') {
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                    }
                })
            }
            rows.push(head);

            var deviceSerials = [];

            var newQuery = angular.copy(vm.query);
            newQuery.pageSize = -1;
            SalesSettlementsService.fetchMonthlyResult(baUtil.makeQueryString(newQuery))
                .then(function (response) {
                    vm.tableDataCSV = response.content;
                    var serviceContractId = (vm.tableDataCSV.filter(function (item) {
                        return item.entityId !== 'Total' && item.serviceContractId;
                    })[0] || {}).serviceContractId || '';

                    vm.tableDataCSV.forEach(function (data) {
                        var row = [];
                        vm.columns.forEach(function (column) {
                            var val = null;
                            if (vm.search.granularity === 'BRANCH') {
                                if (column === 'entityName') {
                                    if(data.entityName === 'Total') {
                                        var branchName = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                                        var uniqueDevices = data.numberOfDevices - data.numberOfReplacedDevices;
                                        data.numberOfDevices = data.numberOfReplacedDevices ? data.numberOfDevices  + 
                                        ' (' + uniqueDevices + ')' : data.numberOfDevices;
                                    }
                                    else {
                                        var branchName = data.entityName + ' (' + data.entityId + ')'
                                    }
                                    row.push(branchName);
                                }
                            }

                            if (vm.search.granularity === 'DEVICE') {

                                if (column === 'entityName') {
                                    if(data.entityName === 'Total') {
                                        var branchName = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                                    }
                                    else {
                                        var branchName = data.entityName;
                                    }
                                    row.push(branchName);
                                }
                                if (column === 'entityId' || column === 'storeName' ||column === 'productName') {
                                    if(data[column] == 'Total' || baUtil.isUndefinedOrNull(data[column])){
                                        data[column] = '-';
                                    }
                                    row.push(data[column]);
                                }

                            }

                            if (vm.search.granularity === 'DAILY') {

                                if (column === 'entityId') {
                                    val = $filter('date')(data[column], 'yyyy/MM/dd');
                                    row.push(val);
                                }

                            }


                            if ((column !== 'numberOfDevices' && vm.query.type === 'BRANCH') || vm.query.type === 'DEVICE' || vm.query.type === 'DAILY') {

                                if (column === 'endDate' || column === 'startDate' || column === 'date') {
                                    if(data.entityName === 'Total') {
                                        val = '-';
                                    }
                                    else {
                                        val = $filter('date')(data[column], 'yyyy/MM/dd HH:mm:ss');
                                    }
                                    row.push(val)
                                }

                            }

                            if (column === 'numberOfDevices' && vm.query.type === 'BRANCH') {
                                val = data[column];
                                row.push(val)
                            }


                            if (vm.query.type === 'DEVICE' && column === 'entityId' && data[column] !== $translate.instant('salesSettlements.monthly.list.searchResult.total')) {
                                deviceSerials.push(String(data[column]).replace(/<\/?[^>]+(>|$)/g, ""));
                            }

                            if (column === 'totalPayment') {
                                row.push(data.total.numItems)
                                row.push(data.total.totalCost)
                            }

                            if (moneyBrands.indexOf(column) >= 0) {
                                var moneyBrandsValue = data.items[column];
                                if (!baUtil.isUndefinedOrNullOrEmptyObject(moneyBrandsValue)) {
                                    row.push(data.items[column].numItems);
                                    row.push(data.items[column].totalCost);
                                }
                                else {
                                    row.push(0);
                                    row.push(0);
                                }
                            }

                        })
                        
                        rows.push(row);
                    });

                    if (vm.query.type === 'DEVICE') {
                        DeviceRequestService.getDeviceInstallationByDeviceSerialsAndDate({
                            deviceSerials: deviceSerials, 
                            interval: vm && vm.interval, 
                            organisationId: vm && vm.query && vm.query.organisationId, 
                            date: vm && vm.query && vm.query.date
                        }).then(function success(response) {
                                var map = response.data.data;
                                var newRows = [];
                                angular.copy(rows).forEach(function (row, rowIndex) {
                                    Object.keys(vm.csvDeviceInstallationKeys).forEach(function (key) {
                                        if (rowIndex == 0) {
                                            //header row
                                            row.push(vm.csvDeviceInstallationKeys[key][$translate.use()]);
                                        } else {
                                            var deviceRequest = map[row[2] + '_' + row[0]];
                                            if (!baUtil.isUndefinedOrNull(deviceRequest)) {
                                                if (key === 'date' || key === 'preferredDateOfInstallation') {
                                                    row.push($filter('date')(deviceRequest[key], 'yyyy/MM/dd'));
                                                } else {
                                                    row.push(deviceRequest[key]);
                                                }
                                            }
                                        }
                                    });
                                    newRows.push(row);
                                })
                                baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', newRows);
                            }, function err(err) {
                                baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', angular.copy(rows));
                            });
                    } else {
                        baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', angular.copy(rows));
                    }

                }, function err(err) {
                    vm.isLoading = false;
                });

        }


        function downloadAggCsvUnitPrice() {

            var moneyBrands = [];

            angular.forEach(vm.types.PaymentHandlingOption.E_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.E_MONEY["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.QR_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.QR_MONEY["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.CREDIT_CARD.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.CREDIT_CARD["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            var rows = [];
            var tableOptionKeys = Object.keys(vm.tableOptions);
            var head = [];
            if (vm.interval === 'DAILY' || vm.search.period === 'CALENDAR_MONTH') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'startTime' && key !== 'endTime'});
            }

            if (vm.query.type === 'BRANCH') {
                tableOptionKeys.filter(function (key) { return key !== 'productNameKey' && key !== 'deviceSerial' && key !== 'startTime' && key !== 'endTime' && key !== 'installationLocation' && key !== 'date' }).forEach(function (item) {
                    if (item === 'deviceCount' || item === 'branchName' || item === 'unit') {
                        head.push(vm.tableOptions[item][vm.getLang()]);
                    } else {
                        if (item !== 'deviceCount' && item !== 'branchName' && item !== 'unit' )
                            head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                    }
                })
            }
            if (vm.query.type === 'DEVICE') {
                tableOptionKeys.filter(function (key) { return key !== 'deviceCount' && key !== 'date' }).forEach(function (item) {
                    if (item === 'branchName' || item === 'productNameKey' || item === 'deviceSerial' || item === 'installationLocation' || item === 'startTime' || item === 'endTime' || item === 'unit') {
                        head.push(vm.tableOptions[item][vm.getLang()]);
                    } else {
                        if (item !== 'deviceCount' && item !== 'branchName' && item !== 'unit')
                            head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                    }
                })
            }
            if (vm.query.type === 'DAILY') {
                tableOptionKeys.filter(function (key) { return key !== 'deviceSerial' && key !== 'startTime' && key !== 'installationLocation' && key !== 'endTime' && key !== 'branchName' && key !== 'deviceCount' }).forEach(function (item) {
                    if (item === 'date'  || item === 'unit') {
                        head.push(vm.tableOptions[item][vm.getLang()]);
                    }
                    if (item !== 'date' && item !== 'unit') {
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                    }
                })
            }

            rows.push(head);

            vm.query.pageSize = -1;
            vm.query.pageNumber = 0;
            SalesSettlementsService.fetchMonthlyUnitPriceResult(baUtil.makeQueryString(vm.query))
                .then(function (response) {
                    vm.unitSalesList = response.content
                    var csvRow = angular.copy(vm.unitSalesList);
                    var serviceContractId = (csvRow.filter(function (item) {
                        return item.entityId !== 'Total' && item.serviceContractId;
                    })[0] || {}).serviceContractId || '';

                    var moneyBrandKeys = ['Total'];
                    angular.forEach(moneyBrands, function(value, key) {
                        moneyBrandKeys.push(value);
                    })

                    var deviceSerials = [];

                    csvRow.forEach(function (row) {

                angular.forEach(row.items, function (value, key) {
                    var m = rows.length;
                    rows.push([]);
                    if (row.entityName === 'Total' & row.entityId === 'Total') {
                         var cName  = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                    }
                    else {
                        var cName = row.entityName;
                    }
                    rows[m].push(cName);

                    if (vm.query.type === 'BRANCH') {
                        rows[m].push(row.numberOfDevices);
                    }
                    if (vm.query.type === 'DEVICE') {
                        deviceSerials.push(row.entityId);
                        if (row.entityName === 'Total' || baUtil.isUndefinedOrNull(row.storeName) ||baUtil.isUndefinedOrNull(row.productName))
                        {
                            rows[m].push('-');
                            rows[m].push('-');
                            rows[m].push('-');
                        }
                        else {
                            rows[m].push(row.productName);
                            rows[m].push(row.entityId);
                            rows[m].push(row.storeName);
                        }
                    }

                    if (vm.search.period === 'CLOSING_DATE' && vm.query.type === 'DEVICE') {
                        if (row.entityId === 'Total') {
                            row.startDate = '-';
                            row.endDate = '-';
                        }
                        var closingStartDate = row.startDate;
                        var closingEndDate = row.endDate;
                        if (closingStartDate !== '-') {
                            closingStartDate = $filter('date')(new Date(closingStartDate), 'yyyy/MM/dd HH:mm:ss');
                        }
                        if (closingEndDate !== '-') {
                            closingEndDate = $filter('date')(new Date(closingEndDate), 'yyyy/MM/dd HH:mm:ss');
                        }

                        rows[m].push(closingStartDate);
                        rows[m].push(closingEndDate);
                    }
                    rows[m].push(key);

                    for (var i=0; i<moneyBrandKeys.length; i++) {
                        var moneyBrandsValue = value[moneyBrandKeys[i]];
                        if (!baUtil.isUndefinedOrNullOrEmptyObject(moneyBrandsValue)) {
                            rows[m].push(value[moneyBrandKeys[i]].numItems);
                            rows[m].push(value[moneyBrandKeys[i]].totalCost);
                        }
                        else {
                            rows[m].push(0);
                            rows[m].push(0);
                        }
                    }

                })
            });

                    if (vm.query.type === 'DEVICE') {
                        DeviceRequestService.getDeviceInstallationByDeviceSerialsAndDate({
                            deviceSerials: deviceSerials, 
                            interval: vm && vm.interval, 
                            organisationId: vm && vm.query && vm.query.organisationId, 
                            date: vm && vm.query && vm.query.date
                        }).then(function success(response) {
                                var map = response.data.data;
                                var newRows = [];
                                angular.copy(rows).forEach(function (row, rowIndex) {
                                    Object.keys(vm.csvDeviceInstallationKeys).forEach(function (key) {
                                        if (rowIndex == 0) {
                                            //header row
                                            row.push(vm.csvDeviceInstallationKeys[key][$translate.use()]);
                                        } else {
                                            var row0item = row[0];
                                            row0item = row0item.split(' ').slice(0, 2).join(' ');
                                            var deviceRequest = map[row[2] + '_' + row0item];
                                            if(!deviceRequest) {
                                                deviceRequest = map[row[2] + '_' + row[0]]
                                            }
                                            if (!baUtil.isUndefinedOrNull(deviceRequest)) {
                                                if (key === 'date' || key === 'preferredDateOfInstallation') {
                                                    row.push($filter('date')(deviceRequest[key], 'yyyy/MM/dd'));
                                                } else {
                                                    row.push(deviceRequest[key]);
                                                }
                                            }
                                        }
                                    });
                                    newRows.push(row);
                                })
                                baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', newRows);
                            }, function err(err) {
                                baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', angular.copy(rows));
                            });
                    }
                    else {
                        baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', angular.copy(rows));
                    }
                });
        }

        function downloadAggDetailCsv() {

            var moneyBrands = [];

            angular.forEach(vm.types.PaymentHandlingOption.E_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.E_MONEY["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.QR_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.QR_MONEY["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.CREDIT_CARD.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.CREDIT_CARD["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            var rows = [];

            var tableOptionKeys = Object.keys(vm.tableOptions);
            var head = [];
            if (vm.search.period === 'CALENDAR_MONTH') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'startTime' && key !== 'endTime'});
            }
            if (vm.interval === 'DAILY') {
            tableOptionKeys.filter(function (key) { return key !== 'deviceCount' && key !== 'date' && key !== 'startTime' && key !== 'endTime' && key !== 'unit' }).forEach(function (item) {
                if (item === 'deviceSerial' ||item === 'productNameKey' || item === 'branchName' || item === 'installationLocation' || item === 'startTime' || item === 'endTime') {
                    head.push(vm.tableOptions[item][vm.getLang()]);
                } else {
                    if (item !== 'deviceSerial' && item !== 'branchName')
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                    head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                }
            })
            rows.push(head);
            }
            if (vm.interval === 'MONTHLY') {
            tableOptionKeys.filter(function (key) { return key !== 'deviceCount' && key !== 'date' && key !== 'unit'}).forEach(function (item) {
                if (item === 'deviceSerial' || item === 'productNameKey' || item === 'branchName' || item === 'installationLocation' || item === 'startTime' || item === 'endTime') {
                    head.push(vm.tableOptions[item][vm.getLang()]);
                } else {
                    if (item !== 'deviceSerial' && item !== 'branchName')
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                    head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                }
            })
            rows.push(head);
            }

            var query = angular.copy(vm.branchQuery);

            query.pageSize = -1;
            query.pageNumber = 0;
            query.branchCode = vm.branchCodeNumber;
            var deviceSerials = [];
            SalesSettlementsService.getAggregationBranchList(baUtil.makeQueryString(query))
                .then(function (response) {
                    var newData = response.content;
                    var serviceContractId = (newData.filter(function (item) {
                        return item.entityId !== 'Total' && item.serviceContractId;
                    })[0] || {}).serviceContractId || '';

                    newData.forEach(function (data) {
                        var row = [];
                        var val = null;
                        vm.branchColumns.forEach(function (column) {

                            if (column === 'entityName') {
                                if(data.entityName === 'Total') {
                                    var branchName = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                                }
                                else {
                                    var branchName = data.entityName + ' (' + data.entityId + ')'
                                }
                                row.push(branchName);
                            }

                            if (column === 'entityId') {
                                deviceSerials.push(data[column]);
                            }
                            if (column === 'entityId' || column === 'storeName' || column === 'productName') {
                                if(data[column] == 'Total' || baUtil.isUndefinedOrNull(data[column])){
                                    data[column] = '-';
                                }
                                row.push(data[column]);
                            }
                            if (column === 'endDate' || column === 'startDate' || column === 'date') {
                                if(data.entityName === 'Total') {
                                    val = '-';
                                }
                                else {
                                    val = $filter('date')(data[column], 'yyyy/MM/dd HH:mm:ss');
                                }
                                row.push(val)
                            }


                            if (column === 'totalPayment') {
                                row.push(data.total.numItems)
                                row.push(data.total.totalCost)
                            }
                            if (moneyBrands.indexOf(column) >= 0) {
                                var moneyBrandsValue = data.items[column];
                                if (!baUtil.isUndefinedOrNullOrEmptyObject(moneyBrandsValue)) {
                                    row.push(data.items[column].numItems);
                                    row.push(data.items[column].totalCost);
                                }
                                else {
                                    row.push(0);
                                    row.push(0);
                                }
                            }

                        })

                        rows.push(row);
                    });

                    DeviceRequestService.getDeviceInstallationByDeviceSerialsAndDate({
                        deviceSerials: deviceSerials, 
                        interval: vm && vm.interval, 
                        organisationId: vm && vm.query && vm.query.organisationId, 
                        date: vm && vm.query && vm.query.date
                    }).then(function success(response) {
                            var map = response.data.data;
                            var newRows = [];
                            angular.copy(rows).forEach(function (row, rowIndex) {
                                Object.keys(vm.csvDeviceInstallationKeys).forEach(function (key) {
                                    if (rowIndex == 0) {
                                        //header row
                                        row.push(vm.csvDeviceInstallationKeys[key][$translate.use()]);
                                    } else {
                                        var row0item = row[0];
                                        row0item = row0item.split(' ').slice(0, 2).join(' ');
                                        var deviceRequest = map[row[2] + '_' + row0item];
                                        if (!baUtil.isUndefinedOrNull(deviceRequest)) {
                                            if (key === 'date' || key === 'preferredDateOfInstallation') {
                                                row.push($filter('date')(deviceRequest[key], 'yyyy/MM/dd'));
                                            } else {
                                                row.push(deviceRequest[key]);
                                            }
                                        }
                                    }
                                });
                                newRows.push(row);
                            })
                            baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', newRows);
                        }, function err(err) {
                            baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', angular.copy(rows));
                        });

                }, function err(err) {
                    vm.isLoading = false;
                });

        }

        function downloadAggDetailCsvUnitPrice() {

            var moneyBrands = [];

            angular.forEach(vm.types.PaymentHandlingOption.E_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.E_MONEY["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.QR_MONEY.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.QR_MONEY["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            angular.forEach(vm.types.PaymentHandlingOption.CREDIT_CARD.key, function(value,key) {
                if( !vm.types.PaymentHandlingOption.CREDIT_CARD["inUse"][key] ) return;
                moneyBrands.push(value);
            });

            var rows = [];

            var tableOptionKeys = Object.keys(vm.tableOptions);
            var head = [];
            if (vm.search.period === 'CALENDAR_MONTH') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'startTime' && key !== 'endTime'});
            }
            if (vm.interval === 'DAILY') {
            tableOptionKeys.filter(function (key) { return key !== 'deviceCount' && key !== 'date' && key !== 'startTime' && key !== 'endTime' }).forEach(function (item) {
                if (item === 'deviceSerial'||item === 'productNameKey' || item === 'branchName' || item === 'installationLocation' || item === 'startTime' || item === 'endTime' || item === 'unit') {
                    head.push(vm.tableOptions[item][vm.getLang()]);
                } else {
                    if (item !== 'deviceSerial' && item !== 'branchName')
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                    head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                }
            })
            rows.push(head);
            }
            if (vm.interval === 'MONTHLY') {
            tableOptionKeys.filter(function (key) { return key !== 'deviceCount' && key !== 'date'}).forEach(function (item) {
                if (item === 'deviceSerial' ||item === 'productNameKey' || item === 'branchName' || item === 'installationLocation' || item === 'startTime' || item === 'endTime' || item === 'unit') {
                    head.push(vm.tableOptions[item][vm.getLang()]);
                } else {
                    if (item !== 'deviceSerial' && item !== 'branchName')
                        head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.number'));
                    head.push(vm.tableOptions[item][vm.getLang()] + $translate.instant('salesSettlements.monthly.list.searchResult.amount'));
                }
            })
            rows.push(head);
            }

            var moneyBrandKeys = ['Total'];
            angular.forEach(moneyBrands, function(value, key) {
                moneyBrandKeys.push(value);
            })



            var query = angular.copy(vm.branchQuery);
            query.type = 'DEVICE';
            query.pageSize = -1;
            query.pageNumber = 0;
            query.branchCode = vm.unitPriceBranchCode;

            SalesSettlementsService.fetchMonthlyUnitPriceResult(baUtil.makeQueryString(query))
                .then(function (response) {
                    var branchTableDataUnitPrice = response.content;
                    var serviceContractId = (branchTableDataUnitPrice.filter(function (item) {
                        return item.entityId !== 'Total' && item.serviceContractId;
                    })[0] || {}).serviceContractId || '';

                    var deviceSerials = [];

                    branchTableDataUnitPrice.forEach(function (row) {
                        angular.forEach(row.items, function (value, key) {
                            var m = rows.length;
                            rows.push([]);
                            if (row.entityName === 'Total' & row.entityId === 'Total') {
                                 var cName  = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                            }
                            else {
                                var cName = row.entityName;
                            }
                            rows[m].push(cName);
                            deviceSerials.push(row.entityId);
                            if (row.entityName === 'Total' || baUtil.isUndefinedOrNull(row.storeName) || baUtil.isUndefinedOrNull(row.productName))
                            {
                                rows[m].push('-');
                                rows[m].push('-');
                                rows[m].push('-');
                            }
                            else {
                                rows[m].push(row.productName);
                                rows[m].push(row.entityId);
                                rows[m].push(row.storeName);
                            }

                            if (vm.search.period === 'CLOSING_DATE') {
                                if (row.entityId === 'Total') {
                                    row.startDate = '-';
                                    row.endDate = '-';
                                }
                                var closingStartDate = row.startDate;
                                var closingEndDate = row.endDate;
                                if (closingStartDate !== '-') {
                                    closingStartDate = $filter('date')(new Date(closingStartDate), 'yyyy/MM/dd HH:mm:ss');
                                }
                                if (closingEndDate !== '-') {
                                    closingEndDate = $filter('date')(new Date(closingEndDate), 'yyyy/MM/dd HH:mm:ss');
                                }

                                rows[m].push(closingStartDate);
                                rows[m].push(closingEndDate);
                            }

                            rows[m].push(key);

                            for (var i=0; i<moneyBrandKeys.length; i++) {
                                var moneyBrandsValue = value[moneyBrandKeys[i]];
                                if (!baUtil.isUndefinedOrNullOrEmptyObject(moneyBrandsValue)) {
                                    rows[m].push(value[moneyBrandKeys[i]].numItems);
                                    rows[m].push(value[moneyBrandKeys[i]].totalCost);
                                }
                                else {
                                    rows[m].push(0);
                                    rows[m].push(0);
                                }
                            }

                        })
                    });

                    DeviceRequestService.getDeviceInstallationByDeviceSerialsAndDate({
                        deviceSerials: deviceSerials, 
                        interval: vm && vm.interval, 
                        organisationId: vm && vm.query && vm.query.organisationId, 
                        date: vm && vm.query && vm.query.date
                    }).then(function success(response) {
                            var map = response.data.data;
                            var newRows = [];
                            angular.copy(rows).forEach(function (row, rowIndex) {
                                Object.keys(vm.csvDeviceInstallationKeys).forEach(function (key) {
                                    if (rowIndex == 0) {
                                        //header row
                                        row.push(vm.csvDeviceInstallationKeys[key][$translate.use()]);
                                    } else {
                                        var row0item = row[0];
                                        row0item = row0item.split(' ').slice(0, 2).join(' ');
                                        var deviceRequest = map[row[2] + '_' + row0item];
                                        if (!baUtil.isUndefinedOrNull(deviceRequest)) {
                                            if (key === 'date' || key === 'preferredDateOfInstallation') {
                                                row.push($filter('date')(deviceRequest[key], 'yyyy/MM/dd'));
                                            } else {
                                                row.push(deviceRequest[key]);
                                            }

                                        }
                                    }
                                });
                                newRows.push(row);
                            })
                            baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', newRows);
                        }, function err(err) {
                            baUtil.exportToCsv(serviceContractId + '-' + vm.query.organisationName + '-' + $filter('date')(vm.query.date, vm.dateFormatCSV) + '.csv', angular.copy(rows));
                        });
                });
        }


        function getFormattedDateAndTime(date, customFormat) {
            var format = customFormat || 'yyyy/MM/dd <br/> HH:mm:ss';
            return $filter('date')(date, format);
        }


        function prepareBranchTableData(data) {
//            vm.isLoading = false;
//            if(!vm.loadBranchRecords) {
//                vm.isBranchLoading = true;
//            }
            if (baUtil.isUndefinedOrNull(data)) {
                return
            }

            var tableOptionKeys = Object.keys(vm.tableOptions);
            tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'date' })

            if (vm.interval === 'DAILY' || vm.search.period === 'CALENDAR_MONTH') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'startTime' && key !== 'endTime' && key !== 'date' })
            }

            if (vm.search.granularity === 'BRANCH') {
                var tableHeaders = [];
                var columns = [];
                tableOptionKeys.filter(function (key) { return key !== 'deviceCount' && key!== 'unit' }).forEach(function (item) {
                    tableHeaders.push(vm.tableOptions[item][vm.getLang()])
                    columns.push(vm.tableOptions[item].column)
                })
                vm.branchTableHeaders = tableHeaders;
                vm.branchColumns = columns;
            }
            else {
//                vm.showBranchTable = false;
                return
            }


            var branchTableData = [];

            var query = angular.copy(vm.query);


            data.forEach(function (row) {
                var rowData = {};

                if (row.entityName === 'Total') {
                    rowData.entityName = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                } else {
                    rowData.entityName = row.entityName;
                }

                rowData.entityId = row.entityId;
                rowData.startDate = getFormattedDateAndTime(row.startDate);
                rowData.endDate = getFormattedDateAndTime(row.endDate);

                if (row.entityId !== 'Total') {
                    query.deviceSerialSearchText = row.entityId;
                    var isReplaced = checkIfReplaced(row.entityId, row.entityName);
                    rowData.entityId = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';
                    if(isReplaced === 1){
                        rowData.entityId = '<a class="after-replacement" href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';    
                    }
                    if(isReplaced === 2){
                        rowData.entityId = '<a class="before-replacement" href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';  
                    }
                }

                if (row.productName) {
                    rowData.productName = row.productName;
                }

                if (row.storeName) {
                    var q = angular.copy(query)
                    q.installationLocationText = row.storeName
                    rowData.storeName = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(q) }) + '">' + row.storeName + '</a>';
                }

                if (row.entityId === 'Total') {
                    rowData.entityId = '-';
                    rowData.productName = '-';
                    rowData.storeName = '-';
                    rowData.startDate = '-';
                    rowData.endDate = '-';
                }

                Object.keys(row.items).forEach(function (key) {
                    var item = row.items[key];
                    var data = item.numItems + ' 件 /' + item.totalCost + ' 円'
                    var obj = angular.copy(query);
                    obj.moneyTypes = key
                    rowData[key] = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + data + '</a>';
                })
                var totalPayment = row.total.numItems + ' 件 /' + row.total.totalCost + ' 円'
                rowData.totalPayment = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(query) }) + '">' + totalPayment + '</a>';
                branchTableData.push(rowData)
                vm.isBranchLoading = false;
            });

            $timeout(function () {
                vm.branchTableData = branchTableData;
                vm.showBranchTable = true;
                prepareSalesStats();
            });
        }

        function prepareUnitPriceBranchTableData(data) {
            if (baUtil.isUndefinedOrNull(data)) {
                return
            }
            vm.branchTableDataUnitPrice = data;

            var tableOptionKeys = Object.keys(vm.tableOptions);
            tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'date' })

            if (vm.interval === 'DAILY' || vm.search.period === 'CALENDAR_MONTH') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'startTime' && key !== 'endTime' && key !== 'date' })
            }

            if (vm.search.granularity === 'BRANCH') {
                var tableHeaders = [];
                var columns = [];
                tableOptionKeys.filter(function (key) { return key !== 'deviceCount' }).forEach(function (item) {
                    tableHeaders.push(vm.tableOptions[item][vm.getLang()])
                    columns.push(vm.tableOptions[item].column)
                })
                vm.branchTableHeaders = tableHeaders;
                vm.branchColumns = columns;
            }
            else {
                vm.showUnitPriceBranchTable = false;
                vm.isBranchLoading = true;
                return
            }


            var branchTableData = [];

            var query = angular.copy(vm.query);

            data.forEach(function (row) {
                var rowData = {};

                if (row.entityName === 'Total') {
                    rowData.entityName = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                } else {
                    rowData.entityName = row.entityName;
                }

                rowData.entityId = row.entityId
                rowData.startDate = row.startDate;
                rowData.endDate = row.endDate;

                if (row.entityId !== 'Total') {
                    query.deviceSerialSearchText = row.entityId;
                    rowData.entityId = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';
                    var isReplaced = checkIfReplaced(row.entityId, row.entityName);
                    if(isReplaced === 1){
                        rowData.entityId = '<a class="after-replacement" href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';    
                    }
                    if(isReplaced === 2){
                        rowData.entityId = '<a class="before-replacement" href="' + $state.href($state.current.name, { query: JSON.stringify(query) }) + '">' + row.entityId + '</a>';  
                    }
                    
                }

                if (row.storeName) {
                    var q = angular.copy(query)
                    q.installationLocationText = row.storeName
                    rowData.storeName = '<a href="' + $state.href($state.current.name, { query: JSON.stringify(q) }) + '">' + row.storeName + '</a>';
                }

                if (row.entityId === 'Total') {
                    rowData.entityId = '-';
                    rowData.productName = '-';
                    rowData.storeName = '-';
                    rowData.startDate = '-';
                    rowData.endDate = '-';
                }



                vm.unitPriceAggregation = true;

                rowData.unitPrice = [];
                rowData.unitPriceKeys = [];
                rowData.testRow = [];
                rowData.dataRow = [];
                vm.dataRowCSV = [];
                rowData.dataRowHeader = [];
                    rowData.aa = [];


                var op = '';
                for (var u = 0; u < vm.branchTableHeaders.length; u++) {
                        if (vm.branchColumns[u] === 'endDate') {
                            var msg = $translate.instant('salesSettlements.closing.date.info');
                            op += '<td class="table-th">'+ vm.branchTableHeaders[u] + '&nbsp; <a class="m-no-error" title="'+ msg +'"><i class="fa fa-info-circle"></i></a></td>';
                        }
                        else {
                            op += '<td class="table-th nope">'+ vm.branchTableHeaders[u] + '</td>';
                        }
//                    op += '<td class="table-th">'+ vm.branchTableHeaders[u] + '</td>';
                }

                rowData.dataRowHeader.push('<tr>' + op + '</tr>');

                angular.forEach(row.items, function (value, key) {
                    angular.forEach(value, function (i,k) {
                        var item = i;
                        var data = item.numItems + ' 件 /' + item.totalCost + ' 円 '
                        var obj = angular.copy(query);
                        obj.moneyTypes = k
                        obj.units = key
                        if (row.entityName === 'Total') {
                            var branchCodeUnitPrice = row.entityName;
                            var branchNameUnitPrice = row.entityName;
                        }
                        else {
                            var aa = row.entityName.split(/(\d+)/);
                            var branchCodeUnitPrice = aa[1];
                            var branchNameUnitPrice = aa[0].split('(')[0];
                        }
                        obj.branchCode = branchCodeUnitPrice;
                        obj.branch = {
                            "key":branchCodeUnitPrice,
                            "value":branchNameUnitPrice
                        }

                        if (row.entityName === 'Total') {
                            delete obj.branch;
                        }

                        if (vm.search.granularity === 'DAILY') {
                            obj.date = Number(row.entityId)
                            obj.interval = 'DAILY'
                        }
                        if (baUtil.isUndefinedOrNullOrEmptyObject(rowData.unitPrice[key])) {
                            rowData.unitPrice[key] = [];
                        }

                        vm.branchCodeUnitPrice = branchCodeUnitPrice;
                        vm.branchNameUnitPrice = branchNameUnitPrice;


                        var combine = 'unitPrice_' + key + '_' + k ;
                        rowData.unitPrice[key][k] = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + data + '</a>';
                        rowData[combine] = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + data + '</a>';

                        var totalPayment = row.items[key].Total.numItems + ' 件 /' + row.items[key].Total.totalCost + ' 円'
                        rowData.totalPayment = '<a href="' + $state.href('main.salesSettlements.oneItem.detail', { query: getQueryForDetail(obj) }) + '">' + totalPayment + '</a>';
                        rowData.unitPrice.rowspan = Object.keys(rowData.unitPrice).length - 1;

                    })
                    rowData.unitPriceKeys.push(key);
                })
                    if (row.entityName === 'Total' & row.entityId === 'Total') {
                         var cName  = $translate.instant('salesSettlements.monthly.list.search.totalMerchants');
                    }
                    else {
                        var cName = row.entityName;
                    }
                    var nDevices = rowData.numberOfDevices;
                    var entityIdColumn = rowData.entityId;
                    var storeName = rowData.storeName;
                    var productNameColumn = rowData.productName;
                    var closingStartDate = rowData.startDate;
                    var closingEndDate = rowData.endDate;
                    if (closingStartDate !== '-') {
                        closingStartDate = $filter('date')(new Date(closingStartDate), 'yyyy/MM/dd HH:mm:ss');
                    }
                    if (closingEndDate !== '-') {
                        closingEndDate = $filter('date')(new Date(closingEndDate), 'yyyy/MM/dd HH:mm:ss');
                    }


                    var obj = angular.copy(query);
                    if (vm.search.granularity === 'DAILY') {
                        obj.date = Number(row.entityId)
                        obj.interval = 'DAILY'
                        if(cName !== 'Total') {
                            entityIdColumn = '<a href="' + $state.href('main.salesSettlements.daily.list', { query: getQueryForDetail(obj) }) + '">' + $filter('date')(entityIdColumn, 'yyyy/MM/dd') + '</a>';
                        }
                    }

                    if (vm.search.granularity === 'DAILY') {

                    }

                    Object.keys(row.items).forEach(function (i, k) {
                        vm.uPriceKey = i;

                    })
                    var uPriceKeyLength = rowData.unitPriceKeys.length;
                    for (var m=0; m<uPriceKeyLength; m++) {
                        if (m < 1) {
                            if (vm.search.period === 'CLOSING_DATE') {
                                var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ cName +'</td><td rowspan="'+ uPriceKeyLength +'">'+ productNameColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ entityIdColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ storeName +'</td><td rowspan="'+ uPriceKeyLength +'">'+ closingStartDate +'</td><td rowspan="'+ uPriceKeyLength +'">'+ closingEndDate +'</td><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                            }
                            else if (vm.search.period === 'CALENDAR_MONTH') {
                                var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ cName +'</td><td rowspan="'+ uPriceKeyLength +'">'+ productNameColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ entityIdColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ storeName +'</td><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                            }
                            else {
                                var a = '<tr><td rowspan="'+ uPriceKeyLength +'">'+ cName +'</td><td rowspan="'+ uPriceKeyLength +'">'+ productNameColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ entityIdColumn +'</td><td rowspan="'+ uPriceKeyLength +'">'+ storeName +'</td><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                              }

                        var b = '';
                        var csvItem2 ='';

                        for (var u = 0; u < vm.unitMoney.length; u++) {
                            var cellValue = rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_' + vm.unitMoney[u]];
                            if(baUtil.isUndefinedOrNull(cellValue)){cellValue = ''};
                            b += '<td>'+ cellValue + '</td>';
                            csvItem2 += '"'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_' + vm.unitMoney[u]] + '"';
                        }

                        var c = '</tr>';

                        rowData.dataRow.push(a + b + c);

                        }
                        else {
                        var a = '<tr><td>'+ rowData.unitPriceKeys[m] +'</td><td>'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'</td>';
                        var csvItem1 ='"'+ cName +'""'+ nDevices +'""'+ rowData.unitPriceKeys[m] +'""'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_Total'] +'"';

                        var b = '';

                        for (var u = 0; u < vm.unitMoney.length; u++) {
                            var cellValue = rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_' + vm.unitMoney[u]];
                            if(baUtil.isUndefinedOrNull(cellValue)){cellValue = ''};
                            b += '<td>'+ cellValue + '</td>';
                            csvItem2 += '"'+ rowData['unitPrice_' + rowData.unitPriceKeys[m] + '_' + vm.unitMoney[u]] + '"';
                        }
                        var c = '</tr>';
                        rowData.dataRow.push(a + b + c);
                        }

                    }

                branchTableData.push(rowData)

            });

            $timeout(function () {
                vm.branchTableData = branchTableData;
                vm.isUnitBranchLoading = false;
                vm.showUnitPriceBranchTable = true;
            });
        }

        function getLang() {
            return $translate.use();
        }

        function translate(key) {
            return $translate.instant(key);
        }

        function getOrganisation(query) {
            return SalesSettlementsService.getOrganisation(query)
        }

        function onOrgSelected(data, index) {
            vm.search.organisationId = data.organisationId;
        }

        function validateListMonthlySales(){
            if (vm.searchForm.$invalid) {
                toastr.error($translate.instant('common.components.errorMessages.fillRequiredFields'),
                $translate.instant('common.components.errorMessages.error'), baUtil.toastOptions())
                vm.isLoading = false;
                return;
            }

            var unitPriceString = baUtil.isUndefinedOrNullOrEmpty(vm.unitPrice)?'FALSE':(vm.unitPrice).toString().toUpperCase();
            var property = 'MONTHLY_SALES_' + vm.search.period + '_' + vm.search.granularity + '_' + unitPriceString;

            if(vm.interval === 'MONTHLY' && baUtil.isUndefinedOrNullOrEmpty(vm.search.deviceSerialSearchText) && baUtil.isUndefinedOrNullOrEmpty(vm.search.applicationSerialNumberText) && (baUtil.isUndefinedOrNullOrEmpty(vm.search.branch) || vm.search.branch.key === 'Total') && vm.salesPropertyMap.hasOwnProperty(property) && vm.salesPropertyMap[property].indexOf(vm.selectedOrg.merchantCode) !== -1){
                $uibModal.open({
                    animation: true,
                    controller: function confirmCtrl($uibModalInstance) {
                        var warningVm = this;
                        warningVm.ok = function () {
                            warningVm.inProgress = true;

                            downloadMonthlySales().then(function (response) {
                                warningVm.inProgress = false;
                                $uibModalInstance.close();
                                if(!vm.isDownloadReportsEnabled){
                                    return $state.go($state.current.name, { query: '' }, { reload: true });
                                }
                            }, function err(err) {
                                warningVm.inProgress = false;
                                $uibModalInstance.close();
                            });
                            vm.showTable=false;
                        };
                    },
                    templateUrl: 'app/pages/sales-settlements/views/monthly-sales-list-display-data-warning-modal.html',
                    controllerAs:'warningVm',
                    backdrop: "static"
                })
                vm.isLoading = false;
                return;
            }
            else {
                listMonthlySales(); 
            }
        }

        function listMonthlySales() {
        
            vm.isLoading = true;
            vm.showBranchTable = false;
            vm.showUnitPriceBranchTable = false

            if(!vm.loadRecords) {
                vm.isLoading = true;
            }

            var search = {
                // 'organisationId': vm.search.organisationId,
                'organisationId': vm.selectedOrg.organisationId,
                'organisationName': vm.selectedOrg.name,
                'type': vm.search.granularity,
                'date': vm.search.date.getTime(),
                'interval': vm.interval,
                'applicationSerialNumberText': vm.search.applicationSerialNumberText,
                'branch': vm.search.branch,
                'branchCode': vm.search.branch && vm.search.branch.key,
                'deviceSerialSearchText': vm.search.deviceSerialSearchText,
                'installationLocationText': vm.search.installationLocationText,
                'remarksText': vm.search.remarksText,
                'productNames':vm.search.productNames && vm.search.productNames.join(','),
                'unitPrice': vm.unitPrice,
            };

            if (search.branchCode === 'Total') {
                search.branchCode = '';
            }

            if (vm.search.period) {
                search.period = vm.search.period
            }

            vm.showTable = false;
            getData(search)
        }

        function navigate(type) {
            vm.inProgress = true;
//            vm.showBranchTable = false;

//            if(!vm.loadRecords) {
//                vm.isLoading = true;
//            }
            var query = vm.query;
            query.pageNumber = 0;

            if (vm.interval === 'DAILY') {
                switch (type) {
                    case 'NEXT':
                        query.date = baUtil.getStartOfNextDay(query.date);
                        break;
                    case 'PREV':
                        query.date = baUtil.getStartOfPrevDay(query.date);
                        break;
                    case 'FIRST':
                        query.date = baUtil.getStartOfDay(vm.navigationDates.from).getTime();
                        break;
                    case 'LAST':
                        query.date = baUtil.getStartOfDay(vm.navigationDates.to).getTime();
                        break;
                    default:
                        return
                }
            } else {
                switch (type) {
                    case 'NEXT':
                        query.date = baUtil.getStartOfNextMonth(query.date);
                        break;
                    case 'PREV':
                        query.date = baUtil.getStartOfPrevMonth(query.date);
                        break;
                    case 'FIRST':
                        query.date = baUtil.getStartDateOfMonth(vm.navigationDates.from).getTime();
                        break;
                    case 'LAST':
                        query.date = baUtil.getStartDateOfMonth(vm.navigationDates.to).getTime();
                        break;
                    default:
                        return
                }
            }

            getData(query)

        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }


        function paginateCallback(query) {
//            vm.loadRecords = true;
            getData(query)
//            vm.loadRecords = false;
        }

        function paginateCallbackBranch(query) {
//            vm.loadBranchRecords = true;
            vm.branchQuery.pageNumber = query.pageNumber;
            vm.branchQuery.pageSize = query.pageSize;
            var noReload = true;

            if (vm.branchData && !vm.unitPrice) {
                getBranchData(vm.newBranchData, noReload);
//                vm.loadBranchRecords = false;
            }
            if (vm.branchData && vm.unitPrice) {
                getUnitPriceBranchData(vm.unitPriceBranchCode, noReload);
//                vm.loadBranchRecords = false;
            }
        }

        function getData(query) {
            if (!query.pageNumber) {
                query.pageNumber = 0;
            }

            vm.inProgress = true;
            $state.go($state.current.name, { query: JSON.stringify(query) }, { reload: true });
        }

        function getBranchData(branch,noReload) {


            var query = angular.copy(vm.branchQuery);

            if (!noReload) {
                vm.isBranchLoading = true;
                vm.showBranchTable = false;
                query.pageNumber = 0;
            }

            vm.newBranchData = branch;

            vm.branchInProgress = true;

            if (vm.newBranchData.entityId === '-' || vm.newBranchData.entityId === 'Total'){
                if (vm.query && vm.query.branchCode) {
                    vm.newBranchData.branchCode = vm.query.branchCode;
                }
                else {
                    vm.newBranchData.branchCode = '';
                    query.branchCode ='';
                }
            }
            else {
                vm.newBranchData.branchCode = vm.newBranchData.entityId;
                query.branchCode = vm.newBranchData.entityId;
            }


//            if (!(query.branchCode && vm.newBranchData.entityId === 'Total')) {
//                query.branchCode = branch.entityId;
//            }
//
//            if (query.branchCode === 'Total' || query.branchCode === '-') {
//                query.branchCode = '';
//            }
//
//            if(!baUtil.isUndefinedOrNull(vm.search.branch) && vm.search.branch.key !== 'Total') {
//                query.branchCode = vm.search.branch.key;
//            }

            if (baUtil.isUndefinedOrNull(query.pageSize)) {
                var getPageSize = localStorageService.get('pageSize');
                query.pageSize = getPageSize.SALES.defaultValue;;
            }
            if (baUtil.isUndefinedOrNull(query.pageNumber)) {
                query.pageNumber = 0;
            }

            vm.branchCodeNumber = query.branchCode;

            SalesSettlementsService.getAggregationBranchList(baUtil.makeQueryString(query))
                .then(function (response) {
                    vm.branchData = response
                    prepareBranchTableData(vm.branchData.content);
                    vm.branchInProgress = false;
                }, function err(err) {
                    vm.isBranchLoading = false;
                });
        }

        function getUnitPriceBranchData(branch,noReload) {
            vm.unitPriceBranchCode = branch;

            var query = angular.copy(vm.branchQuery);

            if (!noReload) {
                vm.isUnitBranchLoading = true;
                vm.showBranchTable = false;
                query.pageNumber = 0;
            }

//            if (query.entityId === '-' || query.entityId === 'Total'){
//                vm.newBranchData.branchCode = '';
//                query.branchCode ='';
//            }
//            else {
//                vm.newBranchData.branchCode = vm.newBranchData.entityId;
//                query.branchCode = vm.newBranchData.entityId;
//            }

//            if (!(query.branchCode && branch.entityId === 'Total')) {
//                query.branchCode = branch;
//            }
//
//            if (query.branchCode === 'Total' || query.branchCode === '-') {
//                query.branchCode = '';
//            }
//
//            if(!baUtil.isUndefinedOrNull(vm.search.branch) && vm.search.branch.key !== 'Total') {
//                query.branchCode = vm.search.branch.key;
//            }
            if (vm.unitPriceBranchCode === 'Total' || vm.unitPriceBranchCode === '') {
                query.branchCode = '';
            }
            else {
                query.branchCode = vm.unitPriceBranchCode;
            }

            query.type = 'DEVICE';

            SalesSettlementsService.fetchMonthlyUnitPriceResult(baUtil.makeQueryString(query))
                .then(function (response) {
                    vm.branchData = response;
                    prepareUnitPriceBranchTableData(vm.branchData.content);
                    vm.branchInProgress = false;
//                    vm.isBranchLoading = true;
                    vm.showUnitPriceBranchTable = false;
                });
        }

        function getOrganisationFromId(organisationId) {
            if (baUtil.isUndefinedOrNull(organisationId)) {
                return null
            }
            return vm.allMerchants.find(function (item) { return item.organisationId === organisationId })
        }

        function updateBranchOffice() {
            vm.search.branch ='';
            if (baUtil.isUndefinedOrNull(vm.selectedOrg.organisationId)) {
                return null
            }
            SalesSettlementsService.getSettlementBranches(vm.selectedOrg.organisationId)
                .then(function (response) {
                    vm.salesBranch = response;
                });
        }

        function getQueryForDetail(query) {
            if (baUtil.isUndefinedOrNull(query)) {
                return query
            }
            var obj = angular.copy(query);
            obj.type = 'DEVICE';

            if (obj.branchCode === 'Total' || obj.branchCode === '-') {
                obj.branchCode = '';
            }

            if (obj.moneyTypes === 'Total')  obj.moneyTypes = '';


            return JSON.stringify(obj)
        }



        function checkIfReplaced(deviceSerial, branchName) {
            var branchCode = branchName.match(/\((.*)\)/)[1];
            var salesStatsData = salesStats;
            if(salesStatsData) {
                var filteredIncomingDevice = salesStatsData.incomingDevices.filter(function (item) {
                    return item.first === deviceSerial  && item.second === branchCode;
                });

                var filteredOutgoingDevice = salesStatsData.outgoingDevices.filter(function (item) {
                    return item.first === deviceSerial  && item.second === branchCode;
                })

                if(filteredIncomingDevice.length) {
                    return 1;
                } if(filteredOutgoingDevice.length) {
                    return 2;
                }
            }
            return null;
        }

        function downloadMonthlySales(){
            if (vm.searchForm.$invalid) {
                toastr.error($translate.instant('common.components.errorMessages.fillRequiredFields'),
                $translate.instant('common.components.errorMessages.error'), baUtil.toastOptions())
                return;
            }

            var search = {
                'organisationId': vm.selectedOrg.organisationId,
                'organisationName': vm.selectedOrg.name,
                'type': vm.search.granularity,
                'date': vm.search.date.getTime(),
                'interval': vm.interval,
                'applicationSerialNumberText': vm.search.applicationSerialNumberText,
                'branchName' : vm.search.branch && vm.search.branch.value,
                'branchCode': vm.search.branch && vm.search.branch.key,
                'deviceSerialSearchText': vm.search.deviceSerialSearchText,
                'installationLocationText': vm.search.installationLocationText,
                'remarksText': vm.search.remarksText,
                'productNames':vm.search.productNames && vm.search.productNames.join(','),
                'unitPrice': vm.unitPrice,
            };
            
            if (vm.search.period) {
                search.period = vm.search.period;
            }

            if (search.branchCode === 'Total') {
                search.branchCode = '';
            }
            
            return SalesSettlementsService.downloadRequestMonthlyResult(baUtil.makeQueryString(JSON.parse(JSON.stringify(search))));
        }

        function navigateToDownloadReports(){
            $rootScope.previousState = null;
            $rootScope.previousParams = null;

            $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                if (fromState && fromState.name) {
                    $rootScope.previousState = fromState;
                    $rootScope.previousParams = fromParams;
                }
            });

            return $state.go("main.salesSettlements.reports");
        }

        $scope.$on('LANG_CHANGE', function (event) {
            vm.showTable = false;
            if(!baUtil.isUndefinedOrNullOrEmptyObject(salesList)){
                prepareTableData(salesList.content);
            }
            if (vm.branchData && !vm.unitPrice) {
                prepareBranchTableData(vm.branchData.content);
            }
            if (vm.branchData && vm.unitPrice) {
                prepareUnitPriceBranchTableData(vm.branchData.content);
            }
        });

    }

})();

(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements')
        .controller('SettlementDetailCtrl', SettlementDetailCtrl);

    /** @ngInject */
    function SettlementDetailCtrl(SalesSettlementsService, $translate,$uibModal, $timeout, $filter, $scope, $sce, baUtil, $state, settlementDetailData, invoiceDetailData, $stateParams, settlementData, invoiceData, localStorageService, toastr, types, allTypes, Popeye) {
        var vm = this;

        $scope.baUtil = baUtil;
        vm.date = baUtil.getStartOfDay();
        vm.localTranslator = $filter('translate');
        vm.getLang = getLang;
        vm.getDeviceSerialHtml = getDeviceSerialHtml;
        vm.showDeviceHistoryModal = showDeviceHistoryModal;
        vm.dateFormat = 'yyyy/MM'
        vm.dateOptions = {
			showWeeks: false,
			datepickerMode: 'month',
			minMode: 'month'
        }
        vm.settlementStats;

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.allTypes = allTypes.data.data;
        }

        vm.settlementTableOptions = {
            merchantName: {
                en: 'Merchant name',
                jp: '加盟店名',
                column: 'merchantName'
            },
            branchName: {
                en: 'Branch name',
                jp: '支店名',
                column: 'branchName'
            },
            branchCode: {
                en: 'Branch Code',
                jp: '支店コード',
                column: 'branchCode'
            },
            deviceTypes:{
                en: 'Product Name',
                jp: '品名',
                column: 'deviceTypes',
            },
            noOfPayments: {
                en: 'No. of payments',
                jp: '決済件数',
                column: 'totalUsageTransactions'
            },
            amountOfPayment: {
                en: 'Amount of Payment',
                jp: '決済金額',
                column: 'totalUsageAmount'
            },
        };

        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(nos)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(件数)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_nos',
                  };
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Amount)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_amount',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (nos)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i] + '(件数)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_nos',
                  };
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Amount)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_amount',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (nos)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i] + '(件数)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_nos',
                  };
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Amount)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_amount',
                  };
            }
        }

        vm.settlementTableOptions.HandlingCharge = {
            en: 'Handling charge',
            jp: '手数料',
            column: 'usageFeeTotal'
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Rate)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(料率)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_rate',
                  };
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_handlingFee',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Rate)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i] + '(料率)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_rate',
                  };
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_handlingFee',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Rate)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i] + '(料率)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_rate',
                  };
                  vm.settlementTableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_handlingFee',
                  };
            }
        }

        vm.settlementTableOptions.initialServiceFee = {
                en: 'Initial service fee',
                jp: 'サービス初期費',
                column: 'initialServiceFee'
        }
        vm.settlementTableOptions.initialServiceFeeNos = {
                en: 'Nos',
                jp: '件数',
                column: 'numberOfInitialDevices'
        }
        vm.settlementTableOptions.monthlyServiceFee = {
                en: 'Monthly service fee',
                jp: 'サービス月額費',
                column: 'monthlyServiceFee'
        }
        vm.settlementTableOptions.monthlyServiceFeeNos = {
                en: 'Nos',
                jp: '件数',
                column: 'numberOfTargetDevices'
        }
        vm.settlementTableOptions.cancellationFee = {
                en: 'Cancellation fee',
                jp: '解約手数料',
                column: 'cancellationServiceFee'
        }
        vm.settlementTableOptions.cancellationFeeNos = {
                en: 'Nos',
                jp: '件数',
                column: 'numberOfCancelledDevices'
        }
        vm.settlementTableOptions.otherFeeTaxable = {
                en: 'Other Fee (taxable)',
                jp: 'その他費用(課税)',
                column: 'otherFeeTaxable'
        }
        vm.settlementTableOptions.otherTransferNonTaxable = {
                en: 'Other Fee (non-taxable)',
                jp: 'その他振込(非課税)',
                column: 'otherTransferNonTaxable'
        }
        vm.settlementTableOptions.totalAmountSpent = {
                en: 'Total amount spent',
                jp: '利用額合計',
                column: 'totalUsageAmount'
        }
        vm.settlementTableOptions.totalUsageFee = {
                en: 'Total usage fee',
                jp: '利用料合計',
                column: 'emossUsageFeeTotal'
        }
        vm.settlementTableOptions.nonTaxPayOptTotalCharges = {
            en: 'Total usage fee (non-taxable)',
            jp: '利用料合計(非課税)',
            column: 'nonTaxPayOptTotalCharges',
        }
        vm.settlementTableOptions.consumptionTaxForUsageFee = {
                en: 'Consumption tax for usage fee',
                jp: '利用料消費税',
                column: 'emossUsageFeeConsumptionTax'
        }
        vm.settlementTableOptions.transferAmount = {
                en: 'Transfer amount',
                jp: '振込総額',
                column: 'totalTransferAmount'
        }

        vm.invoiceTableOptions = {
            merchantName : {
                en: 'Merchant name',
                jp: '加盟店名',
                column: 'merchantName',
                nonEMoney: true,
            },
            branchName : {
                en: 'Branch name',
                jp: '支店名',
                column: 'branchName',
                nonEMoney: true,
            },
            branchCode: {
                en: 'Branch Code',
                jp: '支店コード',
                column: 'branchCode',
                nonEMoney: true,
            },
            deviceTypes:{
                en: 'Product Name',
                jp: '品名',
                column: 'deviceTypes',
                nonEMoney: true,
            },
            noOfPayments: {
                en: 'No. of payments',
                jp: '決済件数',
                column: 'totalUsageTransactions'
            },
            amountOfPayment: {
                en: 'Amount of Payment',
                jp: '決済金額',
                column: 'totalUsageAmount'
            },
        };


        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(nos)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(件数)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_nos',
                  };
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Amount)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_amount',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (nos)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i] + '(件数)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_nos',
                  };
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Amount)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_amount',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (nos)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i] + '(件数)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_nos',
                  };
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Amount)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_amount',
                  };
            }
        }

        vm.invoiceTableOptions.HandlingCharge = {
                en: 'Handling charge',
                jp: '手数料',
                column: 'transactionsUsageFeeTotal'
        }


        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Rate)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(料率)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_rate',
                  };
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_handlingFee',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Rate)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i] + '(料率)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_rate',
                  };
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_handlingFee',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Rate)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i] + '(料率)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_rate',
                  };
                  vm.invoiceTableOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_handlingFee',
                  };
            }
        }

        vm.invoiceTableOptions.initialServiceFee = {
                en: 'Initial service fee',
                jp: 'サービス初期費',
                column: 'initialServiceFee',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.initialServiceFeeNos = {
                en: 'Nos',
                jp: '件数',
                column: 'numberOfInitialDevices',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.monthlyServiceFee = {
                en: 'Monthly service fee',
                jp: 'サービス月額費',
                column: 'monthlyServiceFee',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.monthlyServiceFeeNos = {
                en: 'Nos',
                jp: '件数',
                column: 'numberOfTargetDevices',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.cancellationFee = {
                en: 'Cancellation fee',
                jp: '解約手数料',
                column: 'cancellationFee',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.cancellationFeeNos = {
                en: 'Nos',
                jp: '件数',
                column: 'numberOfCancelledDevices',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.otherFeeTaxable = {
                en: 'Other Fee (taxable)',
                jp: 'その他費用(課税)',
                column: 'otherFeeTaxable',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.otherTransferNonTaxable = {
                en: 'Other Fee (non-taxable)',
                jp: 'その他振込(非課税)',
                column: 'otherTransferNonTaxable',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.totalAmountSpent = {
                en: 'Total amount spent',
                jp: '利用額合計',
                column: 'totalUsageAmount'
        }
        vm.invoiceTableOptions.totalUsageFee = {
                en: 'Total usage fee',
                jp: '利用料合計',
                column: 'usageFeeTotal',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.nonTaxPayOptTotalCharges = {
            en: 'Total usage fee (non-taxable)',
            jp: '利用料合計(非課税)',
            column: 'nonTaxPayOptTotalCharges',
            nonEMoney: true,
        }
        
        vm.invoiceTableOptions.consumptionTaxForUsageFee = {
                en: 'Consumption tax for usage fee',
                jp: '利用料消費税',
                column: 'consumptionTax',
                nonEMoney: true,
        }
        vm.invoiceTableOptions.transferAmount = {
                en: 'Transfer amount',
                jp: '請求総額',
                column: 'billingAmount',
                nonEMoney: true,
        }

        vm.settlementTableOfDeviceOptions = {
            merchantName: {
                en: 'Merchant name',
                jp: '加盟店名',
                column: 'merchantName'
            },
            branchName: {
                en: 'Branch name',
                jp: '支店名',
                column: 'branchName'
            },
            branchCode: {
                en: 'Branch Code',
                jp: '支店コード',
                column: 'branchCode'
            },
            applicationNumber: {
                en: 'Device Application Number',
                jp: '申込通番',
                column: 'applicationNumber',
            },
            deviceTypes:{
                en: 'Product Name',
                jp: '品名',
                column: 'deviceTypes',
            },
            deviceSerial: {
                en: 'Device Serial Number',
                jp: '端末シリアル',
                column: 'deviceSerial'
            },
            installationStoreName: {
                en: 'Installation Store Name',
                jp: '設置先店舗名',
                column: 'installationStoreName'
            },
            noOfPayments: {
                en: 'No. of payments',
                jp: '決済件数',
                column: 'totalUsageTransactions'
            },
            amountOfPayment: {
                en: 'Amount of Payment',
                jp: '決済金額',
                column: 'totalUsageAmount'
            },
        };

        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(nos)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(件数)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_nos',
                  };
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Amount)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_amount',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (nos)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i] + '(件数)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_nos',
                  };
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Amount)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_amount',
                  };
            }
        }
        
        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (nos)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i] + '(件数)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_nos',
                  };
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Amount)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_amount',
                  };
            }
        }



        vm.settlementTableOfDeviceOptions.HandlingCharge = {
            en: 'Handling charge',
            jp: '手数料',
            column: 'usageFeeTotal'
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Rate)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(料率)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_rate',
                  };
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_handlingFee',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Rate)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i] + '(料率)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_rate',
                  };
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_handlingFee',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Rate)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i] + '(料率)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_rate',
                  };
                  vm.settlementTableOfDeviceOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_handlingFee',
                  };
            }
        }

        vm.settlementTableOfDeviceOptions.initialServiceFee = {
            en: 'Initial service fee',
            jp: 'サービス初期費',
            column: 'initialServiceFee'
        }
        vm.settlementTableOfDeviceOptions.monthlyServiceFee = {
            en: 'Monthly service fee',
            jp: 'サービス月額費',
            column: 'monthlyServiceFee'
        }
        vm.settlementTableOfDeviceOptions.cancellationFee = {
            en: 'Cancellation fee',
            jp: '解約手数料',
            column: 'cancellationServiceFee'
        }
        vm.settlementTableOfDeviceOptions.otherFeeTaxable = {
                en: 'Other Fee (taxable)',
                jp: 'その他費用(課税)',
                column: 'otherFeeTaxable'
        }
        vm.settlementTableOfDeviceOptions.otherTransferNonTaxable = {
                en: 'Other Fee (non-taxable)',
                jp: 'その他振込(非課税)',
                column: 'otherTransferNonTaxable'
        }
        vm.settlementTableOfDeviceOptions.totalAmountSpent = {
            en: 'Total amount spent',
            jp: '利用額合計',
            column: 'totalUsageAmount'
        }
        vm.settlementTableOfDeviceOptions.totalUsageFee = {
            en: 'Total usage fee',
            jp: '利用料合計',
            column: 'emossUsageFeeTotal'
        }
        vm.settlementTableOfDeviceOptions.nonTaxPayOptTotalCharges = {
            en: 'Total usage fee (non-taxable)',
            jp: '利用料合計(非課税)',
            column: 'nonTaxPayOptTotalCharges',
        }
        vm.settlementTableOfDeviceOptions.consumptionTaxForUsageFee = {
            en: 'Consumption tax for usage fee',
            jp: '利用料消費税',
            column: 'emossUsageFeeConsumptionTax'
        }
        vm.settlementTableOfDeviceOptions.transferAmount = {
            en: 'Transfer amount',
            jp: '振込総額',
            column: 'totalTransferAmount'
        }

        vm.invoiceTableOfDeviceOptions = {
            merchantName : {
                en: 'Merchant name',
                jp: '加盟店名',
                column: 'merchantName',
                nonEMoney: true,
            },
            branchName : {
                en: 'Branch name',
                jp: '支店名',
                column: 'branchName',
                nonEMoney: true,
            },
            branchCode : {
                en: 'Branch Code',
                jp: '支店コード',
                column: 'branchCode',
                nonEMoney: true,
            },
            applicationNumber : {
                en: 'Device Application Number',
                jp: '申込通番',
                column: 'applicationNumber',
                nonEMoney: true,
            },
            deviceTypes:{
                en: 'Product Name',
                jp: '品名',
                column: 'deviceTypes',
                nonEMoney:true,
            },
            deviceSerial : {
                en: 'Device Serial Number',
                jp: '端末シリアル',
                column: 'deviceSerial',
                nonEMoney: true,
            },
            installationStoreName : {
                en: 'Installation Store Name',
                jp: '設置先店舗名',
                column: 'installationStoreName',
                nonEMoney: true,
            },
            initialServiceFee : {
                en: 'Initial service fee',
                jp: 'サービス初期費',
                column: 'initialServiceFee',
                nonEMoney: true,
            },
            monthlyServiceFee : {
                en: 'Monthly service fee',
                jp: 'サービス月額費',
                column: 'monthlyServiceFee',
                nonEMoney: true,
            },
            cancellationFee : {
                en: 'Cancellation fee',
                jp: '解約手数料',
                column: 'cancellationFee',
                nonEMoney: true,
            },
            noOfPayments: {
                en: 'No. of payments',
                jp: '決済件数',
                column: 'totalUsageTransactions'
            },
            amountOfPayment: {
                en: 'Amount of Payment',
                jp: '決済金額',
                column: 'totalUsageAmount'
            },

        };

        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(nos)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(件数)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_nos',
                  };
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Amount)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_amount',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (nos)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i] + '(件数)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_nos',
                  };
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Amount)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_amount',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_nos'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (nos)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i] + '(件数)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_nos',
                  };
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_amount'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Amount)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]+'(金額)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_amount',
                  };
            }
        }

        vm.invoiceTableOfDeviceOptions.HandlingCharge = {
                en: 'Handling charge',
                jp: '手数料',
                column: 'transactionsUsageFeeTotal'
        }

       

        for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Rate)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(料率)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_rate',
                  };
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.E_MONEY.en[i]+'(Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.E_MONEY.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.E_MONEY.key[i] +'_handlingFee',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
            if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Rate)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i] + '(料率)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_rate',
                  };
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.QR_MONEY.en[i]+' (Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.QR_MONEY.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.QR_MONEY.key[i] +'_handlingFee',
                  };
            }
        }

        for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
            if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_rate'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Rate)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i] + '(料率)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_rate',
                  };
                  vm.invoiceTableOfDeviceOptions[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_handlingFee'] = {
                      en:vm.types.PaymentHandlingOption.CREDIT_CARD.en[i]+' (Handling Fee)',
                      jp:vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i]+'(手数料)',
                      column:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] +'_handlingFee',
                  };
            }
        }

        vm.invoiceTableOfDeviceOptions.otherFeeTaxable = {
                en: 'Other Fee (taxable)',
                jp: 'その他費用(課税)',
                column: 'otherFeeTaxable',
                nonEMoney: true,
        }
        vm.invoiceTableOfDeviceOptions.otherTransferNonTaxable = {
                en: 'Other Fee (non-taxable)',
                jp: 'その他振込(非課税)',
                column: 'otherTransferNonTaxable',
                nonEMoney: true,
        }
        vm.invoiceTableOfDeviceOptions.totalAmountSpent = {
                en: 'Total amount spent',
                jp: '利用額合計',
                column: 'totalUsageAmount'
        }
        vm.invoiceTableOfDeviceOptions.totalUsageFee = {
                en: 'Total usage fee',
                jp: '利用料合計',
                column: 'usageFeeTotal',
                nonEMoney: true,
        }
        vm.invoiceTableOfDeviceOptions.nonTaxPayOptTotalCharges = {
            en: 'Total usage fee (non-taxable)',
            jp: '利用料合計(非課税)',
            column: 'nonTaxPayOptTotalCharges',
            nonEMoney: true,
        }
        vm.invoiceTableOfDeviceOptions.consumptionTaxForUsageFee = {
                en: 'Consumption tax for usage fee',
                jp: '利用料消費税',
                column: 'consumptionTax',
                nonEMoney: true,
        }
        vm.invoiceTableOfDeviceOptions.transferAmount = {
                en: 'Transfer amount',
                jp: '請求総額',
                column: 'billingAmount',
                nonEMoney: true,
        }



        vm.query = $stateParams.query ? JSON.parse($stateParams.query) : {};
        vm.invoiceDataQuery = {};
        vm.settlementDataQuery = {};    
        vm.paginateCallback = paginateCallback;
        vm.merchantId = $stateParams.merchantId
        vm.getData = getData;
        vm.downloadSettlement = downloadSettlement;
        vm.downloadInvoice = downloadInvoice;
        vm.displaySettlementByBranch = displaySettlementByBranch;
        vm.displaySettlementByDevice = displaySettlementByDevice;
        vm.getInvoicebyDevice = getInvoicebyDevice;
        vm.getSettlementByDevice = getSettlementByDevice;
        vm.displayInvoiceByBranch = displayInvoiceByBranch;
        vm.displayInvoiceByDevice = displayInvoiceByDevice;
        vm.showSettlementBranchTable = false;
        vm.showInvoiceBranchTable = false;
        vm.showInvoiceTable = false;
        vm.downloadSettlementCSV = downloadSettlementCSV;
        vm.showInvoiceDeviceTable = false;
        vm.downloadInvoiceCSV = downloadInvoiceCSV;
        vm.isSettlementSelected = isSettlementSelected
        vm.isInvoiceSelected = isInvoiceSelected
        vm.downloadSettlementBranch = downloadSettlementBranch
        vm.downloadInvoiceBranch = downloadInvoiceBranch
        vm.selectAllSettlement = selectAllSettlement
        vm.selectAllInvoice = selectAllInvoice
        vm.reloadInvoiceDetailData = reloadInvoiceDetailData
        vm.hidePdf = hidePdf;
        vm.selectedSettlementRequests = {}
        vm.selectedInvoiceRequests = {}
        vm.downloadByDeviceOwnerByDevice = downloadByDeviceOwnerByDevice;

        if (!baUtil.isUndefinedOrNullOrEmptyObject(vm.query)) {
            vm.date = vm.query.date && new Date(vm.query.date)
        }

        if (settlementDetailData) {
            vm.settlementDetail = settlementDetailData.content;
        }
        
        if (invoiceDetailData) {
            vm.invoiceDetail = invoiceDetailData.content;
            vm.hasEMoney = vm.invoiceDetail.some(function (item) {
                return item.paymentMethod == 'OFFSETTING';
            })
        }

        if (settlementData) {
            vm.settlement = settlementData;
        }

        if (invoiceData) {
            vm.invoice = invoiceData;
        }

        init();

        function getData() {
            var query = angular.copy(vm.query)
            query.date = vm.date.getTime();
            if(query.actualPaymentMethod){
                query.paymentMethod = query.actualPaymentMethod;
            }
            vm.dataInProgress = true;
            vm.isLoading = true;
            $state.go($state.current.name, { query: JSON.stringify(query)}, {reload: true});
        }

        function getLang() {
            return $translate.use();
        }
        
        function downloadSettlement(isDownload) {
            if (baUtil.isUndefinedOrNullOrEmpty(vm.merchantId)) {
                return
            }

            if (isDownload) {
                vm.downloadSettlementInProgress = true;
            } else {
                vm.viewSettlementInProgress = true;
            }

            SalesSettlementsService.downloadSettlementPdfForMerchant(vm.merchantId, vm.date.getTime(), vm.query.contractId)
            .then(function (response) {
                var blob = new Blob([response], {type: 'application/pdf'});
                vm.downloadSettlementInProgress = false;
                vm.viewSettlementInProgress = false;

                var name = 'お振込明細書_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, name);
                    return;
                }

                var url = URL.createObjectURL(blob);
                if (isDownload) {
                    return downloadURL(url, name)
                }
                openBlobInNewTab(response);
            }).catch(function (err) {
                vm.downloadSettlementInProgress = false;
                vm.viewSettlementInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(JSON.parse(new TextDecoder("utf-8").decode(err.data)), vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }
        
        function downloadInvoice(isDownload) {
            if (baUtil.isUndefinedOrNullOrEmpty(vm.merchantId)) {
                return
            }

            if (isDownload) {
                vm.downloadInvoiceInProgress = true;
            } else {
                vm.viewInvoiceInProgress = true;
            }

            SalesSettlementsService.downloadInvoicePdfForMerchant(vm.merchantId, vm.date.getTime(), vm.query.contractId)
            .then(function (response) {
                var blob = new Blob([response], {type: 'application/pdf'});
                vm.downloadInvoiceInProgress = false;
                vm.viewInvoiceInProgress = false;

                var name = '請求書(兼ご利用明細書)_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, name);
                    return;
                }

                var url = URL.createObjectURL(blob);
                if (isDownload) {
                    return downloadURL(url, name)
                }
                openBlobInNewTab(response);
            }).catch(function (err) {
                vm.downloadInvoiceInProgress = false;
                vm.viewInvoiceInProgress = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(JSON.parse(new TextDecoder("utf-8").decode(err.data)), vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function downloadURL(url, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function displaySettlementByBranch() {
            updateSettlementTable();
            vm.showSettlementBranchTable = true;
        }

        function displaySettlementByDevice() {
            vm.isLoading = true;
            getSettlementByDevice();
//            vm.showSettlementBranchTable = true;
            vm.showSettlementDeviceTable = true;
        }
        
        function displayInvoiceByBranch() {
            updateInvoiceTable();
            vm.showInvoiceBranchTable = true;
        }

        function displayInvoiceByDevice() {
            getInvoicebyDevice();
            vm.showInvoiceDeviceTable = true;
        }

        function reloadInvoiceDetailData() {
            if (baUtil.isUndefinedOrNullOrEmpty($stateParams.query)) {
                return null
            }
            var query = JSON.parse($stateParams.query)
            SalesSettlementsService.getInvoiceDetailData($stateParams.merchantId, query.date, query.contractId)
                .then(function (response) {
                    vm.invoiceDetail = response.data;
                }).catch(function (err) {
                    return null;
                });
        }
        
        function init() {
            vm.isLoading = true;
            var query = JSON.parse($stateParams.query);
            SalesSettlementsService.checkDateForInvoiceByDevice(query.date)
                .then(function (response){
                    vm.afterSeptemberEnable = response;
                    vm.isLoading = false;
                })
                .catch (function (err) {
                    vm.afterSeptemberEnable = false;
                    vm.isLoading = false;
                })
            SalesSettlementsService.checkDateForSettlementByDevice(query.date)
                .then(function (response){
                    vm.settlementByDeviceBtnEnable = response;
                    vm.isLoading = false;
                })
                .catch (function (err) {
                    vm.settlementByDeviceBtnEnable = false;
                    vm.isLoading = false;
                })
            SalesSettlementsService.checkMerchantForSettlementByDeviceOwner(query.contractId)
            .then(function (response){
                vm.settlementByDeviceOwnerBtnEnable = response;
                vm.isLoading = false;
            })
            .catch (function (err) {
                vm.settlementByDeviceOwnerBtnEnable = false;
                vm.isLoading = false;
            })
        }

        function updateSettlementTable() {
            vm.isLoading = true;
            var query = JSON.parse($stateParams.query)
            var pageSize = localStorageService.get("pageSize");
            if (!query.pageSize) {
              query.pageSize = pageSize.SETTLEMENT.defaultValue;
            }
            query.pageNumber = 0;

            vm.settlementDataQuery.contractId = query.contractId;
            vm.settlementDataQuery.date = query.date;
            vm.settlementDataQuery.merchantId = $stateParams.merchantId;
            vm.settlementDataQuery.pageSize = query.pageSize;
            vm.settlementDataQuery.pageNumber = query.pageNumber;
            getSettlementStats(query.contractId, query.date, null);
      
            SalesSettlementsService.getSettlementDetailData($stateParams.merchantId, query.date, query.contractId,  query.pageNumber, query.pageSize)
                .then(function (response) {
                    getSettlementByBranchTableDataFromResponse(response);
            })
        }

        function getSettlementByBranchTableDataFromResponse(response) {
            vm.settlementDetail = response.content;
            vm.settlementDetailInfo = response;
            
            if (baUtil.isUndefinedOrNullOrEmptyList(vm.settlementDetail)) {
                vm.showSettlementBranchTable = false;
                vm.settlement = null;
                return
            }
            if (baUtil.isUndefinedOrNullOrEmptyList(vm.settlementDetail)) {
                return;
            }

            var tableHeaders = {
                "en":[],
                "jp":[]
            };
            var columns = [];
            var tableData = [];
            var tableOptionKeys = Object.keys(vm.settlementTableOptions);

            if (vm.query.paymentMethod != 'OFFSETTING') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'initialServiceFee' && key !== 'initialServiceFeeNos' && key !== 'monthlyServiceFee' && key !== 'monthlyServiceFeeNos' && key !== 'cancellationFee' && key !== 'cancellationFeeNos' })
            }

            tableOptionKeys.forEach(function (item, key) {
                tableHeaders.en.push(vm.settlementTableOptions[item].en);
                tableHeaders.jp.push(vm.settlementTableOptions[item].jp);
                columns.push(vm.settlementTableOptions[item].column)
            })

            vm.settlementDetail.forEach(function (item) {
                var rowData = {};
                rowData.merchantName = item.merchantName
                rowData.branchName = item.branchName
                rowData.branchCode = item.branchCode
                rowData.deviceTypes = item.deviceTypes
                rowData.totalUsageTransactions = item.totalUsageTransactions
                rowData.totalUsageAmount = item.totalUsageAmount
                rowData.usageFeeTotal = item.usageFeeTotal
                rowData.otherFeeTaxable = item.otherFeeTaxable
                rowData.otherTransferNonTaxable = item.otherTransferNonTaxable
                rowData.emossUsageFeeTotal = item.emossUsageFeeTotal
                rowData.emossUsageFeeConsumptionTax = item.emossUsageFeeConsumptionTax
                rowData.totalTransferAmount = item.totalTransferAmount
                rowData.nonTaxPayOptTotalCharges = item.nonTaxPayOptTotalCharges


                if (rowData.branchName == 'Total') {
                    rowData.branchName = $translate.instant('salesSettlements.monthly.list.searchResult.total');
                }
                if (rowData.branchCode == 'Total') {
                    rowData.branchCode = '-';
                }

                if (vm.query.paymentMethod == 'OFFSETTING') {
                    rowData.initialServiceFee = item.initialServiceFee
                    rowData.numberOfInitialDevices = item.numberOfInitialDevices
                    rowData.monthlyServiceFee = item.monthlyServiceFee
                    rowData.numberOfTargetDevices = item.numberOfTargetDevices
                    rowData.cancellationServiceFee = item.cancellationServiceFee
                    rowData.numberOfCancelledDevices = item.numberOfCancelledDevices
                }

                Object.keys(item.emoneyPaymentDetailsForDisplay).forEach(function (key) {
                    var eMoney = item.emoneyPaymentDetailsForDisplay[key];
                    rowData[eMoney.paymentOption + '_nos'] = eMoney.numOfPayments;
                    rowData[eMoney.paymentOption + '_amount'] = eMoney.paymentAmount;
                    rowData[eMoney.paymentOption + '_rate'] = eMoney.rateOrAmount + '%';
                    rowData[eMoney.paymentOption + '_handlingFee'] = eMoney.charges;
                })
                tableData.push(rowData);
            })

            vm.settlementTableHeaders = tableHeaders;
            vm.settlementColumns = columns;
            vm.settlementTableData = tableData;
            vm.isLoading = false;
        }


        
        function updateInvoiceTable() {
            vm.isLoading = true;
            var query = JSON.parse($stateParams.query)
            var pageSize = localStorageService.get("pageSize");
            if (!query.pageSize) {
              query.pageSize = pageSize.SETTLEMENT.defaultValue;
            }
            query.pageNumber = 0;

            vm.invoiceDataQuery.contractId = query.contractId;
            vm.invoiceDataQuery.date = query.date;
            vm.invoiceDataQuery.merchantId = $stateParams.merchantId;
            vm.invoiceDataQuery.pageSize = query.pageSize;
            vm.invoiceDataQuery.pageNumber = query.pageNumber;
      
            
            getInvoiceStats(query.contractId, query.date, null);
            SalesSettlementsService.getInvoiceDetailData($stateParams.merchantId, query.date, query.contractId, query.pageNumber, query.pageSize)
                .then(function (response) {
                    getInvoiceByBranchTableDatafromResponse(response);
                }).catch(function (err) {
                    vm.invoiceDetail = null;
                    vm.isLoading = false;
                });
        }


        function getInvoiceByBranchTableDatafromResponse(response) {
            vm.invoiceDetail = response.content;
            vm.invoiceDetailInfo = response;
            if (baUtil.isUndefinedOrNullOrEmptyList(vm.invoiceDetail)) {
                vm.showInvoiceBranchTable = false;
                vm.invoice = null;
                return
            }

            var tableHeaders = {
                "en":[],
                "jp":[]
            };
            
            var columns = [];
            var tableData = [];
            var tableOptionKeys = [];
            if (vm.hasEMoney) {
                tableOptionKeys = Object.keys(vm.invoiceTableOptions);
            } else {
                tableOptionKeys = Object.keys(vm.invoiceTableOptions).filter(function(item) { return vm.invoiceTableOptions[item].nonEMoney })
            }

            tableOptionKeys.filter(function (key) { return key !== '' }).forEach(function (item) {
                tableHeaders.en.push(vm.invoiceTableOptions[item].en);
                tableHeaders.jp.push(vm.invoiceTableOptions[item].jp);
                columns.push(vm.invoiceTableOptions[item].column)
            })

            vm.invoiceDetail.filter(function (key) {return key.entityType == 'BRANCH'}).forEach(function (item) {
                var rowData = item;
                if (rowData.branchName == 'Total') {
                    rowData.branchName = $translate.instant('salesSettlements.monthly.list.searchResult.total');
                }
                if (rowData.branchCode == 'Total') {
                    rowData.branchCode = '-';
                }


                Object.keys(item.emoneyPaymentDetailsForDisplay).forEach(function (key) {
                    var eMoney = item.emoneyPaymentDetailsForDisplay[key];
                    rowData[eMoney.paymentOption + '_nos'] = eMoney.numOfPayments;
                    rowData[eMoney.paymentOption + '_amount'] = eMoney.paymentAmount;
                    rowData[eMoney.paymentOption + '_rate'] = eMoney.rateOrAmount + '%';
                    rowData[eMoney.paymentOption + '_handlingFee'] = eMoney.charges;
                })

                tableData.push(rowData);
            })

            vm.invoiceTableHeaders = tableHeaders;
            vm.invoiceColumns = columns;
            vm.invoiceTableData = tableData;
            vm.isLoading = false;
        }

        function getSettlementByDevice(isDownload) {

            var branchCodes = [];
            var query = JSON.parse($stateParams.query);
            var pageSize = localStorageService.get("pageSize");
            if (!query.pageSize) {
              query.pageSize = isDownload ? -1 : pageSize.SETTLEMENT.defaultValue;
            }
            query.pageNumber = 0;
      
            var id = Object.keys(vm.selectedSettlementRequests).filter(function (id) { return vm.selectedSettlementRequests[id] });
            vm.settlement.forEach (function (item, key) {
                id.forEach (function (i, k) {
                    if (i == item.settlementId) {
                        branchCodes.push(vm.settlement[key].branchCode);
                    }
                })

            })
            if (query.settlementMethod == 'HEADQUARTERS') {
                var ids = '';
            }
            else {
                var ids = branchCodes;
            }

            vm.settlementDataQuery.contractId = query.contractId;
            vm.settlementDataQuery.date = query.date;
            vm.settlementDataQuery.ids = ids;
            vm.settlementDataQuery.pageSize = query.pageSize;
            vm.settlementDataQuery.pageNumber = query.pageNumber;
            getSettlementStats(query.contractId, query.date, ids);

            SalesSettlementsService.getSettlementByDeviceData(query.contractId, query.date, ids, query.pageNumber, query.pageSize)
                .then(function(response){
                    getSettlementByDeviceTableDataFromResponse(isDownload, response);
                })
        }

        function getDeviceSerialHtml(deviceSerial, branchCode, isReplacedOrSuspended) {
            if(vm.settlementStats){
                var filteredIncomingDevice = vm.settlementStats.incomingDevices.filter(function (item) {
                    return item.first === deviceSerial  && item.second === branchCode;
                });
    
                var filteredOutgoingDevice = vm.settlementStats.outgoingDevices.filter(function (item) {
                    return item.first === deviceSerial  && item.second === branchCode;
                })
                var title = vm.localTranslator("device.request.history.msg");
    
                if(filteredIncomingDevice.length) {
                    return '<a class="link m-no-error after-replacement"   title=" ' +   title + ' " ng-click="vm.showDeviceHistoryModal(data[column]); $event.stopPropagation()"> ' +  deviceSerial + '</a>';
                } if(filteredOutgoingDevice.length) {
                    return '<a class="link m-no-error before-replacement"   title=" ' +   title + ' " ng-click="vm.showDeviceHistoryModal(data[column]); $event.stopPropagation()"> ' +  deviceSerial + '</a>';
                } if(isReplacedOrSuspended){
                    return '<a class="link m-no-error"   title=" ' +   title + ' " ng-click="vm.showDeviceHistoryModal(data[column]) ; $event.stopPropagation()"> ' +  deviceSerial + '</a>'; 
                }
            }
            return deviceSerial;
        }

     
        function showDeviceHistoryModal(deviceSerial) {
            var allTypes = vm.allTypes.DeviceInstallationStatus;
            Popeye.openModal({
                templateUrl: "app/pages/sales-settlements/views/device-history-modal.html",
                containerTemplate :' <div class="popeye-modal-container modal-content"> <div class="popeye-modal"> <button  type="button" class="close" ng-click="$close()" aria-label="Close"><em  class="ion-ios-close-empty sn-link-close icon-font"></em></button></div></div>',
                controller: "HistoryCtrl as vm",
                resolve: {
                    deviceSerialNum: function () {
                      return deviceSerial;
                    },
                    types: function () {
                        return allTypes;
                    }
                  }
              });
          };

        function getSettlementByDeviceTableDataFromResponse(isDownload, response) {
            vm.settlementDetail = response.content;
            vm.settlementDetailInfo = response;
            if (baUtil.isUndefinedOrNullOrEmptyList(vm.settlementDetail)) {
                vm.showSettlementDeviceTable = false;
                vm.settlement = null;
                return
            }
            if (baUtil.isUndefinedOrNullOrEmptyList(vm.settlementDetail)) {
                return
            }

            vm.settlementDetail.forEach(function (item, key) {
                var deviceCount = item;
                    vm.showSettlementDeviceBtn = false;
                    if (item.entityType == "DEVICE") {
                        vm.showSettlementDeviceBtn = true;
                    }
            })

            if(isDownload) {
                var tableHeaders = [];
            }
            else {
                var tableHeaders = {
                    "en":[],
                    "jp":[]
                };
            }

            var columns = [];
            var tableData = [];

            var tableOptionKeys = Object.keys(vm.settlementTableOfDeviceOptions);

            if (vm.query.paymentMethod != 'OFFSETTING') {
                tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'initialServiceFee' && key !== 'initialServiceFeeNos' && key !== 'monthlyServiceFee' && key !== 'monthlyServiceFeeNos' && key !== 'cancellationFee' && key !== 'cancellationFeeNos' })
            }


            tableOptionKeys.forEach(function (item) {
                if(isDownload) {
                    tableHeaders.push(vm.settlementTableOfDeviceOptions[item][vm.getLang()]);
                }
                else {
                    tableHeaders.en.push(vm.settlementTableOfDeviceOptions[item].en);
                    tableHeaders.jp.push(vm.settlementTableOfDeviceOptions[item].jp);
                }
                columns.push(vm.settlementTableOfDeviceOptions[item].column)
            })

            vm.settlementDetail.filter(function (key) {return key.entityType == 'DEVICE'}).forEach(function (item){
                var rowData = item;
                    if (rowData.branchCode == 'Total') {
                        rowData.branchCode = '-';
                        rowData.applicationNumber = '-';
                        rowData.deviceSerial = '-';
                        rowData.installationStoreName = '-';
                    }

                    Object.keys(item.emoneyPaymentDetailsForDisplay).forEach(function (key) {
                        var eMoney = item.emoneyPaymentDetailsForDisplay[key];
                        rowData[eMoney.paymentOption + '_nos'] = eMoney.numOfPayments;
                        rowData[eMoney.paymentOption + '_amount'] = eMoney.paymentAmount;
                        rowData[eMoney.paymentOption + '_rate'] = eMoney.rateOrAmount + '%';
                        rowData[eMoney.paymentOption + '_handlingFee'] = eMoney.charges;
                    })

                    tableData.push(rowData);
            })

            vm.settlementTableOfDeviceHeaders = tableHeaders;
            vm.settlementOfDeviceColumns = columns;
            vm.settlementTableOfDeviceData = tableData;
            if(isDownload) {
                var csv = [];
                csv.push(vm.settlementTableOfDeviceHeaders);
                vm.settlementTableOfDeviceData.forEach(function (item) {
                    var row = [];
                    vm.settlementOfDeviceColumns.forEach(function (col) {
                        var val = baUtil.isUndefinedOrNullOrEmpty(item[col]) ? '0' : item[col]
                        row.push(val)
                    })
                    csv.push(row);
                })
                var csvFileName = $translate.instant('salesSettlements.settlementCSVbyDevice');
                baUtil.exportToCsv(vm.query.name +'_'+ vm.query.contractId + csvFileName +'.csv', angular.copy(csv));
            }
            vm.isLoading = false;
        }


        function getInvoicebyDevice(isDownload) {
            vm.isLoading = true;
            var branchCodes = [];
            var query = JSON.parse($stateParams.query);
            var pageSize = localStorageService.get("pageSize");
            if (!query.pageSize) {
              query.pageSize = isDownload ? -1 : pageSize.SETTLEMENT.defaultValue;
            }
            query.pageNumber = 0;
      
            var id = Object.keys(vm.selectedInvoiceRequests).filter(function (id) { return vm.selectedInvoiceRequests[id] });
            vm.invoice.forEach (function (item, key) {
                id.forEach (function (i, k) {
                    if (i == item.invoiceId) {
                        branchCodes.push(vm.invoice[key].branchCode);
                    }
                })

            })
            if (query.invoiceMethod == 'HEADQUARTERS') {
                var ids = '';
            }
            else {
                var ids = branchCodes;
            }

            vm.invoiceDataQuery.contractId = query.contractId;
            vm.invoiceDataQuery.date = query.date;
            vm.invoiceDataQuery.ids = ids;
            vm.invoiceDataQuery.pageSize = query.pageSize;
            vm.invoiceDataQuery.pageNumber = query.pageNumber;
      
            getInvoiceStats(query.contractId, query.date, ids);
            SalesSettlementsService.getInvoiceByDeviceData(query.contractId, query.date, ids, query.pageNumber, query.pageSize)
                .then(function(response){
                    getInvoiceByDeviceTableDatafromResponse(isDownload, response);
                })
        }

        function getInvoiceByDeviceTableDatafromResponse(isDownload, response) {
            vm.invoiceDetail = response.content;
            vm.invoiceDetailInfo = response;
            if (baUtil.isUndefinedOrNullOrEmptyList(vm.invoiceDetail)) {
                vm.showInvoiceDeviceTable = false;
                vm.invoice = null;
                return
            }
            if (baUtil.isUndefinedOrNullOrEmptyList(vm.invoiceDetail)) {
                return
            }

            vm.invoiceDetail.forEach(function (item, key) {
                var deviceCount = item;
                    vm.showInvoiceDeviceBtn = false;
                    if (item.entityType == "DEVICE") {
                        vm.showInvoiceDeviceBtn = true;
                    }
            })

            if(isDownload) {
                var tableHeaders = [];
            }
            else {
                var tableHeaders = {
                    "en":[],
                    "jp":[]
                };
            }

            var columns = [];
            var tableData = [];
            var tableOptionKeys = [];
            if (vm.hasEMoney) {
                tableOptionKeys = Object.keys(vm.invoiceTableOfDeviceOptions);
            } else {
                tableOptionKeys = Object.keys(vm.invoiceTableOfDeviceOptions).filter(function(item) { return vm.invoiceTableOfDeviceOptions[item].nonEMoney })
            }

            tableOptionKeys.filter(function (key) { return key !== ''}).forEach(function (item) {
                if(isDownload) {
                    tableHeaders.push(vm.invoiceTableOfDeviceOptions[item][vm.getLang()]);
                }
                else {
                    tableHeaders.en.push(vm.invoiceTableOfDeviceOptions[item].en);
                    tableHeaders.jp.push(vm.invoiceTableOfDeviceOptions[item].jp);
                }
                columns.push(vm.invoiceTableOfDeviceOptions[item].column)
            })

            vm.invoiceDetail.filter(function (key) {return key.entityType == 'DEVICE'}).forEach(function (item){
                var rowData = item;
                    if (rowData.branchCode == 'Total') {
                        rowData.branchCode = '-';
                        rowData.applicationNumber = '-';
                        rowData.deviceSerial = '-';
                        rowData.installationStoreName = '-';
                    }

                    Object.keys(item.emoneyPaymentDetailsForDisplay).forEach(function (key) {
                        var eMoney = item.emoneyPaymentDetailsForDisplay[key];
                        rowData[eMoney.paymentOption + '_nos'] = eMoney.numOfPayments;
                        rowData[eMoney.paymentOption + '_amount'] = eMoney.paymentAmount;
                        rowData[eMoney.paymentOption + '_rate'] = eMoney.rateOrAmount + '%';
                        rowData[eMoney.paymentOption + '_handlingFee'] = eMoney.charges;
                    })

                    tableData.push(rowData);
            })

            vm.invoiceTableOfDeviceHeaders = tableHeaders;
            vm.invoiceOfDeviceColumns = columns;
            vm.invoiceTableOfDeviceData = tableData;
            if(isDownload) {
                var csv = [];
                csv.push(vm.invoiceTableOfDeviceHeaders);
                vm.invoiceTableOfDeviceData.forEach(function (item) {
                    var row = [];
                    vm.invoiceOfDeviceColumns.forEach(function (col) {
                        var val = baUtil.isUndefinedOrNullOrEmpty(item[col]) ? '0' : item[col]
                        row.push(val)
                    })
                    csv.push(row);
                })
                var csvFileName = $translate.instant('salesSettlements.invoiceCSVbyDevice');
                baUtil.exportToCsv(vm.query.name +'_'+ vm.query.contractId + csvFileName +'.csv', angular.copy(csv));
            }

            vm.isLoading = false;
        }

        function paginateCallback(query) {
            if (vm.showInvoiceBranchTable) {
              SalesSettlementsService.getInvoiceDetailData(
                query.merchantId,
                query.date,
                query.contractId,
                query.pageNumber,
                query.pageSize
              ).then(function (response) {
                getInvoiceByBranchTableDatafromResponse(response);
              });
            } else if (vm.showInvoiceDeviceTable) {
              SalesSettlementsService.getInvoiceByDeviceData(
                query.contractId,
                query.date,
                query.ids,
                query.pageNumber,
                query.pageSize
              ).then(function (response) {
                getInvoiceByDeviceTableDatafromResponse(false, response);
              });
            } else if (vm.showSettlementDeviceTable) {
              SalesSettlementsService.getSettlementByDeviceData(
                query.contractId,
                query.date,
                query.ids,
                query.pageNumber,
                query.pageSize
              ).then(function (response) {
                getSettlementByDeviceTableDataFromResponse(false, response);
              });
            } else if (vm.showSettlementBranchTable) {
              SalesSettlementsService.getSettlementDetailData(
                query.merchantId,
                query.date,
                query.contractId,
                query.pageNumber,
                query.pageSize
              ).then(function (response) {
                getSettlementByBranchTableDataFromResponse(response);
              });
            }
          }
      

        function downloadSettlementCSV() {
            var query = JSON.parse($stateParams.query)
            query.pageNumber = 0;
            query.pageSize = -1;
      
            SalesSettlementsService.getSettlementDetailData($stateParams.merchantId, query.date, query.contractId, query.pageNumber, query.pageSize)
                .then(function (response) {
                    vm.settlementDetail = response.content;
                    if (baUtil.isUndefinedOrNullOrEmptyList(vm.settlementDetail)) {
                        vm.showSettlementBranchTable = false;
                        vm.settlement = null;
                        return
                    }
                if (baUtil.isUndefinedOrNullOrEmptyList(vm.settlementDetail)) {
                    return;
                }

                var tableHeaders = [];
                var columns = [];
                var tableData = [];
                var tableOptionKeys = Object.keys(vm.settlementTableOptions);

                if (vm.query.paymentMethod != 'OFFSETTING') {
                    tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'initialServiceFee' && key !== 'initialServiceFeeNos' && key !== 'monthlyServiceFee' && key !== 'monthlyServiceFeeNos' && key !== 'cancellationFee' && key !== 'cancellationFeeNos' })
                }

               tableOptionKeys.forEach(function (item) {
                    tableHeaders.push(vm.settlementTableOptions[item][vm.getLang()])
                    columns.push(vm.settlementTableOptions[item].column)
                })


               vm.settlementDetail.forEach(function (item) {
                    var rowData = {};
                    rowData.merchantName = item.merchantName
                    rowData.branchName = item.branchName
                    rowData.branchCode = item.branchCode
                    rowData.deviceTypes = item.deviceTypes
                    rowData.totalUsageTransactions = item.totalUsageTransactions
                    rowData.totalUsageAmount = item.totalUsageAmount
                    rowData.usageFeeTotal = item.usageFeeTotal
                    rowData.otherFeeTaxable = item.otherFeeTaxable
                    rowData.otherTransferNonTaxable = item.otherTransferNonTaxable
                    rowData.emossUsageFeeTotal = item.emossUsageFeeTotal
                    rowData.emossUsageFeeConsumptionTax = item.emossUsageFeeConsumptionTax
                    rowData.totalTransferAmount = item.totalTransferAmount
                    rowData.nonTaxPayOptTotalCharges = item.nonTaxPayOptTotalCharges;


                    if (rowData.branchName == 'Total') {
                        rowData.branchName = $translate.instant('salesSettlements.monthly.list.searchResult.total');
                    }
                    if (rowData.branchCode == 'Total') {
                        rowData.branchCode = '-';
                    }

                    if (vm.query.paymentMethod == 'OFFSETTING') {
                        rowData.initialServiceFee = item.initialServiceFee
                        rowData.numberOfInitialDevices = item.numberOfInitialDevices
                        rowData.monthlyServiceFee = item.monthlyServiceFee
                        rowData.numberOfTargetDevices = item.numberOfTargetDevices
                        rowData.cancellationServiceFee = item.cancellationServiceFee
                        rowData.numberOfCancelledDevices = item.numberOfCancelledDevices
                    }

                    Object.keys(item.emoneyPaymentDetailsForDisplay).forEach(function (key) {
                        var eMoney = item.emoneyPaymentDetailsForDisplay[key];
                        rowData[eMoney.paymentOption + '_nos'] = eMoney.numOfPayments;
                        rowData[eMoney.paymentOption + '_amount'] = eMoney.paymentAmount;
                        rowData[eMoney.paymentOption + '_rate'] = eMoney.rateOrAmount + '%';
                        rowData[eMoney.paymentOption + '_handlingFee'] = eMoney.charges;
                    })

                    tableData.push(rowData);
               })

                vm.settlementTableHeaders = tableHeaders;
                vm.settlementColumns = columns;
                vm.settlementTableData = tableData;

                var csv = [];
                csv.push(vm.settlementTableHeaders);

                vm.settlementTableData.forEach(function (item) {
                    var row = [];
                    vm.settlementColumns.forEach(function (col) {
                        var val = baUtil.isUndefinedOrNullOrEmpty(item[col]) ? '0' : item[col]
                        row.push(val)
                    })
                    csv.push(row);
                })
                var csvFileName = $translate.instant('salesSettlements.settlementCSVbyBranch');
                baUtil.exportToCsv(vm.query.name +'_'+ vm.query.contractId + csvFileName + '.csv', angular.copy(csv));

            })
        }
        
        function downloadInvoiceCSV() {
            var query = JSON.parse($stateParams.query)
            query.pageSize = -1;
            query.pageNumber = 0;
      
            SalesSettlementsService.getInvoiceDetailData($stateParams.merchantId, query.date, query.contractId, query.pageNumber, query.pageSize)
                .then(function (response) {
                    vm.invoiceDetail = response.content;
                    if (baUtil.isUndefinedOrNullOrEmptyList(vm.invoiceDetail)) {
                        vm.showInvoiceBranchTable = false;
                        vm.invoice = null;
                        return
                    }

                    var tableHeaders = [];
                    var columns = [];
                    var tableData = [];
                    var tableOptionKeys = [];
                    if (vm.hasEMoney) {
                        tableOptionKeys = Object.keys(vm.invoiceTableOptions);
                    } else {
                        tableOptionKeys = Object.keys(vm.invoiceTableOptions).filter(function(item) { return vm.invoiceTableOptions[item].nonEMoney })
                    }

                    tableOptionKeys.filter(function (key) { return key !== '' }).forEach(function (item) {
                        tableHeaders.push(vm.invoiceTableOptions[item][vm.getLang()])
                        columns.push(vm.invoiceTableOptions[item].column)
                    })

                    vm.invoiceDetail.filter(function (key) {return key.entityType == 'BRANCH'}).forEach(function (item) {
                        var rowData = item;
                        if (rowData.branchName == 'Total') {
                            rowData.branchName = $translate.instant('salesSettlements.monthly.list.searchResult.total');
                        }
                        if (rowData.branchCode == 'Total') {
                            rowData.branchCode = '-';
                        }



                        Object.keys(item.emoneyPaymentDetailsForDisplay).forEach(function (key) {
                            var eMoney = item.emoneyPaymentDetailsForDisplay[key];
                            rowData[eMoney.paymentOption + '_nos'] = eMoney.numOfPayments;
                            rowData[eMoney.paymentOption + '_amount'] = eMoney.paymentAmount;
                            rowData[eMoney.paymentOption + '_rate'] = eMoney.rateOrAmount + '%';
                            rowData[eMoney.paymentOption + '_handlingFee'] = eMoney.charges;
                        })

                        tableData.push(rowData);
                    })

                    vm.invoiceTableHeaders = tableHeaders;
                    vm.invoiceColumns = columns;
                    vm.invoiceTableData = tableData;
                    var csv = [];
                    csv.push(vm.invoiceTableHeaders);

                    vm.invoiceTableData.forEach(function (item) {
                        var row = [];
                        vm.invoiceColumns.forEach(function (col) {
                            var val = baUtil.isUndefinedOrNullOrEmpty(item[col]) ? '0' : item[col]
                            row.push(val)
                        })
                        csv.push(row);
                    })
                    var csvFileName = $translate.instant('salesSettlements.invoiceCSVbyBranch');
                    baUtil.exportToCsv(vm.query.name +'_'+ vm.query.contractId + csvFileName +'.csv', angular.copy(csv));
            })
        }

        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        function selectAllSettlement(ev, list) {
            list.forEach(function (item) {
                vm.selectedSettlementRequests[item.settlementId] = ev.target.checked
            })
        }

        function selectAllInvoice(ev, list) {
            list.forEach(function (item) {
                vm.selectedInvoiceRequests[item.invoiceId] = ev.target.checked
            })
        }

        function isSettlementSelected() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedSettlementRequests)) {
                return false
            }
            return Object.keys(vm.selectedSettlementRequests).some(function (id) { return vm.selectedSettlementRequests[id] });
        }
        
        function isInvoiceSelected() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedInvoiceRequests)) {
                return false
            }
            return Object.keys(vm.selectedInvoiceRequests).some(function (id) { return vm.selectedInvoiceRequests[id] });
        }

        function downloadSettlementBranch(isDownload) {
            var ids = Object.keys(vm.selectedSettlementRequests).filter(function (id) { return vm.selectedSettlementRequests[id] });

            if (baUtil.isUndefinedOrNullOrEmptyList(ids)) {
                return
            }

            if (isDownload) {
                vm.downloadSettlementInProgress = true;
            } else {
                vm.viewSettlementInProgress = true;
            }

            SalesSettlementsService.downloadSettlementPdf(ids)
                .then(function (response) {
                    var blob = new Blob([response], { type: 'application/pdf' });
                    vm.downloadSettlementInProgress = false;
                    vm.viewSettlementInProgress = false;

                    var name = 'settlement.pdf';
                    if (ids.length > 1) {
                        name = 'お振込明細書_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    } else {
                        name = 'お振込明細書_' + getSettlementMerchantNameFromId(ids[0]) + '_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    }

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, name);
                        return;
                    }

                    var url = URL.createObjectURL(blob);
                    if (isDownload) {
                        return downloadURL(url, name)
                    }
                    openBlobInNewTab(response);
                }).catch(function (err) {
                    vm.downloadSettlementInProgress = false;
                    vm.viewSettlementInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(JSON.parse(new TextDecoder("utf-8").decode(err.data)), vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
                vm.isLoading = false;
        }

        function downloadInvoiceBranch(isDownload) {
            var ids = Object.keys(vm.selectedInvoiceRequests).filter(function (id) { return vm.selectedInvoiceRequests[id] });

            if (baUtil.isUndefinedOrNullOrEmptyList(ids)) {
                return
            }

            if (isDownload) {
                vm.downloadInvoiceInProgress = true;
            } else {
                vm.viewInvoiceInProgress = true;
            }

            SalesSettlementsService.downloadInvoicePdf(ids)
                .then(function (response) {
                    var blob = new Blob([response], { type: 'application/pdf' });
                    vm.downloadInvoiceInProgress = false;
                    vm.viewInvoiceInProgress = false;

                    var name = 'invoice.pdf';
                    if (ids.length > 1) {
                        name = '請求書(兼ご利用明細書)_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    } else {
                        name = '請求書(兼ご利用明細書)_' + getInvoiceMerchantNameFromId(ids[0]) + '_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    }

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, name);
                        return;
                    }

                    var url = URL.createObjectURL(blob);
                    if (isDownload) {
                        return downloadURL(url, name)
                    }
                    openBlobInNewTab(response);
                }).catch(function (err) {
                    vm.viewInvoiceInProgress = false;
                    vm.downloadInvoiceInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(JSON.parse(new TextDecoder("utf-8").decode(err.data)), vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function openBlobInNewTab(data) {
            vm.pdfUrl = $sce.trustAsResourceUrl('data:application/pdf;base64,' + baUtil.convertArrayBufferToBase64(data));
            vm.showPdf = true;
            // var link = document.createElement("a");
            // link.target = '_blank';
            // link.href = url;
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
        }

        function hidePdf() {
            vm.showPdf = false;
            vm.pdfUrl = '';
        }

        vm.statsLoading = false;        
        function getSettlementStats(contractId, date, ids) {
            vm.statsLoading = true;
            SalesSettlementsService.getSettlementStats(contractId, date, ids)
            .then(function (response) {
                vm.settlementStats = response;
                vm.statsLoading = false;   
            }).catch(function (err) {
                vm.statsLoading = false;   
            });
        }

        function getInvoiceStats(contractId, date, ids) {
            vm.statsLoading = true;
            SalesSettlementsService.getInvoiceStats(contractId, date, ids)
            .then(function (response) {
                vm.settlementStats = response;
                vm.statsLoading = false;   
            }).catch(function (err) {
                vm.statsLoading = false;   
            });
        }

        function getSettlementMerchantNameFromId(id) {
            var settlement = vm.settlement.find(function (item) {
                return item.settlementId == id
            })
            return settlement.merchantName
        }
        
        function getInvoiceMerchantNameFromId(id) {
            var invoice = vm.invoice.find(function (item) {
                return item.invoiceId == id
            })
            return invoice.merchantName
        }

        function downloadByDeviceOwnerByDevice() {
            vm.isDownloadingDetailsByDeviceOwner = true;
            var branchCodes = [];
            var query = JSON.parse($stateParams.query);
      
            var selectedSettlementRequestIds = Object.keys(vm.selectedSettlementRequests).filter(function (id) { 
                return vm.selectedSettlementRequests[id] 
            });

            vm.settlement.forEach (function (item) {
                    if (selectedSettlementRequestIds.indexOf(item.settlementId) !== -1) {
                        branchCodes.push(item.branchCode);
                    }
            })

            if (query.invoiceMethod == 'HEADQUARTERS') {
                var ids = '';
            }
            else {
                var ids = branchCodes;
                if (baUtil.isUndefinedOrNullOrEmptyList(selectedSettlementRequestIds)) {
                    return;
                }
            }

            vm.settlementDataQuery.contractId = query.contractId;
            vm.settlementDataQuery.date = query.date;
            vm.settlementDataQuery.ids = ids;

            SalesSettlementsService.getSettlementByDeviceOwnerByDevice(query.contractId, query.date, ids)
                .then(function(response){
                    Object.entries(response).forEach(function(items){ 
                        var deviceOwnerName = items[0].substring(items[0].indexOf('-')+1);
                        vm.settlementDetail = items[1];

                        if (baUtil.isUndefinedOrNullOrEmptyList(vm.settlementDetail)) {
                            vm.showSettlementDeviceTable = false;
                            vm.settlement = null;
                            return
                        }
            
                        vm.settlementDetail.forEach(function (item) {
                                vm.showSettlementDeviceBtn = false;
                                if (item.entityType === "DEVICE") {
                                    vm.showSettlementDeviceBtn = true;
                                }
                        })
            
                        var tableHeaders = [];            
                        var columns = [];
                        var tableData = [];
            
                        var tableOptionKeys = Object.keys(vm.settlementTableOfDeviceOptions);
            
                        if (vm.query.paymentMethod != 'OFFSETTING') {
                            tableOptionKeys = tableOptionKeys.filter(function (key) { return key !== 'initialServiceFee' && key !== 'initialServiceFeeNos' && key !== 'monthlyServiceFee' && key !== 'monthlyServiceFeeNos' && key !== 'cancellationFee' && key !== 'cancellationFeeNos' })
                        }
            
            
                        tableOptionKeys.forEach(function (item) {
                            tableHeaders.push(vm.settlementTableOfDeviceOptions[item][vm.getLang()]);
                            columns.push(vm.settlementTableOfDeviceOptions[item].column)
                        })

                        vm.settlementDetail.filter(function (key) {return key.entityType === 'DEVICE'}).forEach(function (item){
                            var rowData = item;
                            if (rowData.branchCode === 'Total') {
                                rowData.branchCode = '-';
                                rowData.applicationNumber = '-';
                                rowData.deviceSerial = '-';
                                rowData.installationStoreName = '-';
                            }
        
                            Object.keys(item.emoneyPaymentDetailsForDisplay).forEach(function (key) {
                                var eMoney = item.emoneyPaymentDetailsForDisplay[key];
                                rowData[eMoney.paymentOption + '_nos'] = eMoney.numOfPayments;
                                rowData[eMoney.paymentOption + '_amount'] = eMoney.paymentAmount;
                                rowData[eMoney.paymentOption + '_rate'] = eMoney.rateOrAmount + '%';
                                rowData[eMoney.paymentOption + '_handlingFee'] = eMoney.charges;
                            })
                            
                            tableData.push(rowData);
                        })
            
                        vm.settlementTableOfDeviceHeaders = tableHeaders;
                        vm.settlementOfDeviceColumns = columns;
                        vm.settlementTableOfDeviceData = tableData;
                        var csv = [];
                        csv.push(vm.settlementTableOfDeviceHeaders);
                        vm.settlementTableOfDeviceData.forEach(function (item) {
                            var row = [];
                            vm.settlementOfDeviceColumns.forEach(function (col) {
                                var val = baUtil.isUndefinedOrNullOrEmpty(item[col]) ? '0' : item[col]
                                row.push(val)
                            })
                            csv.push(row);
                        })

                        baUtil.exportToCsv(vm.query.contractId + '_' + deviceOwnerName + '.csv', angular.copy(csv));    
                    })    
                    vm.isDownloadingDetailsByDeviceOwner = false;
     
                },function(err) {
                    vm.isDownloadingDetailsByDeviceOwner = false;
                    if ("TextDecoder" in window) {
                        try {
                            var enc = new TextDecoder("utf-8");
                            var data = enc.decode(err.data);
                            err = JSON.parse(data);
                        } catch(ignore){ }
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
            });
        }            

        vm.isLoading = false;

    }
})();

(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements')
        .controller('SettlementListCtrl', SettlementListCtrl);

    /** @ngInject */
    function SettlementListCtrl(SalesSettlementsService, $translate, $timeout, $scope, $filter, baUtil, $state, settlementData, invoiceData, $stateParams, toastr, serviceContractDetail, types, $sce, AuthService, allTypes) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        $scope.baUtil = baUtil;
        vm.shoTemplate = false;
        vm.query = $stateParams.query ? JSON.parse($stateParams.query) : {};
        vm.date = baUtil.getStartOfDay();
        vm.account = baUtil.getAccountDto();
        vm.isMerchant = baUtil.isMerchantOrMerchantAndDeviceOwner();
        vm.noServiceContract = false;

        if (vm.isMerchant) {
            if (!baUtil.isUndefinedOrNullOrEmptyList(serviceContractDetail)) {
                var contract = serviceContractDetail[0]
            }
            else {
                vm.noServiceContract = true;
                return;
            }
            $state.go('main.salesSettlements.settlementDetail', {
                query: JSON.stringify(
                    {
                        name: vm.account.organisation.name,
                        contractId: contract.serviceContractId,
                        date: vm.date.getTime(),
                        paymentMethod: baUtil.isUndefinedOrNullOrEmptyList(contract.settlementMethodDto.paymentMethod) ? '' : contract.settlementMethodDto.paymentMethod,
                        invoiceMethod: baUtil.isUndefinedOrNullOrEmptyList(contract.settlementMethodDto.invoiceMethod) ? '' : contract.settlementMethodDto.invoiceMethod,

                    }
                ),
                merchantId: vm.account.organisation.organisationId
            })
            return;
        }
        vm.shoTemplate = true;
        vm.localTranslator = $filter('translate');
        vm.getData = getData;
        vm.submitSettlementDraft = submitSettlementDraft;
        vm.revertPublishedSettlement = revertPublishedSettlement;
        vm.recalculateDraftSettlement = recalculateDraftSettlement;
        vm.downloadSettlement = downloadSettlement;
        vm.downloadSingleSettlement = downloadSingleSettlement;
        vm.submitInvoiceDraft = submitInvoiceDraft;
        vm.revertPublishedInvoice = revertPublishedInvoice;
        vm.recalculateDraftInvoice = recalculateDraftInvoice;
        vm.downloadInvoice = downloadInvoice;
        vm.downloadSingleInvoice = downloadSingleInvoice;
        vm.selectSingleSettlement = selectSingleSettlement;
        vm.selectAllSettlement = selectAllSettlement;
        vm.selectSingleInvoice = selectSingleInvoice;
        vm.selectAllInvoice = selectAllInvoice;
        vm.getUrlForDetail = getUrlForDetail;
        vm.isSettlementSelected = isSettlementSelected;
        vm.isInvoiceSelected = isInvoiceSelected;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.hidePdf = hidePdf;
        vm.paginateCallback = paginateCallback;
        vm.adjustedInvoiceAmountChange = adjustedInvoiceAmountChange;
        vm.revertAdjustedInvoice = revertAdjustedInvoice;
        vm.selectedSettlementRequests = {}
        vm.selectedInvoiceRequests = {}
        vm.submitSettlementInProgress = {}
        vm.recalculateSettlementInProgress = {}
        vm.submitInvoiceInProgress = {}
        vm.recalculateInvoiceInProgress = {}
        vm.enableAdjustedAmount = false;
        vm.enableRevertAdjustmentBtn = false;
        vm.dateFormat = 'yyyy/MM'
        vm.emailInvoice = emailInvoice;
        var makeDate = new Date(vm.query.date);
        var prev = new Date(makeDate.getFullYear(), makeDate.getMonth()-1, makeDate.getMonth());
        vm.emailInvoiceInProgress = false;
        vm.isEmailInvoiceDisabled = isEmailInvoiceDisabled;

        vm.dateOptions = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month',
        }

        vm.dateOptionsForAdjustAmount = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month',
            maxDate: prev
        }

        vm.InvoiceMethod = {
            key: ["HEADQUARTERS", "BRANCH"],
            en: ["By headquarters", "By branch"],
            jp: ["本社一括", "支店別"],
        };
        vm.PaymentMethod = {
            key: ["OFFSETTING", "NON_OFFSETTING"],
            en: ["Offset", "Separate"],
            jp: ["相殺", "別途"],
        };

        if (!baUtil.isUndefinedOrNullOrEmptyObject(vm.query)) {
            vm.date = vm.query.date && new Date(vm.query.date)
        }

        if (settlementData) {
            vm.settlement = settlementData.content;
            
            vm.settlement.forEach(function(item){
                                var tempdate = new Date(item.invoiceAdjustmentDto.adjustedInvoiceDate);
                var new_date = formatDate(tempdate);
                item.invoiceAdjustmentDto.adjustedInvoiceAmountFormatted = item.invoiceAdjustmentDto.adjustedInvoiceAmount ? formartCurrency(item.invoiceAdjustmentDto.adjustedInvoiceAmount) : vm.localTranslator('settlementsAndInvoices.list.card.settlement.table.notapplicable');

                if(item.status === 'PUBLISHED')
                {
                    if(item.invoiceAdjustmentDto.adjustedInvoiceAmount){
                        item.invoiceAdjustmentDto.enableAdjustedAmount = false;
                    }
                    item.invoiceAdjustmentDto.enableRevertAdjustmentBtn = false;   
                }else if(item.invoiceAdjustmentDto.adjustedInvoiceAmount && item.invoiceAdjustmentDto.adjustedInvoiceAmount!= 0){
                    item.invoiceAdjustmentDto.enableAdjustedAmount = false;
                    item.invoiceAdjustmentDto.enableRevertAdjustmentBtn = true;   
                }else{
                    item.invoiceAdjustmentDto.enableAdjustedAmount = true;
                }

                if(item.invoiceAdjustmentDto.invoiceAvailableForAdjustment != null){

                     (item.invoiceAdjustmentDto.invoiceAvailableForAdjustment).forEach(function(items){
                     items.amountPlusdate = formartCurrency(items.invoiceAdjustmentAmount);
                    })
                }
                }
                )
            vm.settlementInfo = settlementData;
        }

        if (invoiceData) {
            vm.invoice = invoiceData.content;
            vm.invoiceInfo = invoiceData;
        }

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }
        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.allTypes = allTypes.data.data;
        }

        function getData(q) {
            vm.isLoading = true;
            var query = angular.copy(vm.query)

            if (!baUtil.isUndefinedOrNullOrEmptyObject(q)) {
                query = angular.copy(q)
            }

            query.date = vm.date.getTime();
            vm.dataInProgress = true;
            $state.go($state.current.name, { query: JSON.stringify(query) }, { reload: true });
        }

        function submitSettlementDraft(settlement) {
            baUtil.showConfirm(vm.localTranslator("settlementsAndInvoices.list.card.settlement.table.submit") + ' ?',
                vm.localTranslator("settlementsAndInvoices.list.card.settlement.table.submit.msg"), vm.localTranslator("common.components.btn.yes")).then
            (function() {
	            var data = { otherFeeTaxable: settlement.otherFeeTaxable, otherRemarks1: settlement.otherRemarks1,
	                            otherTransferNonTaxable: settlement.otherTransferNonTaxable, otherRemarks2: settlement.otherRemarks2 }
	            vm.submitSettlementInProgress[settlement.settlementId] = true;
	            SalesSettlementsService.submitSettlementDraft(settlement.settlementId, data).then
	            (function (response) {
	                toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
                }).catch(function (err) {
                    vm.submitSettlementInProgress[settlement.settlementId] = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
	        });
        }

        function revertPublishedSettlement(settlementId) {
            baUtil.showConfirm(vm.localTranslator("settlementsAndInvoices.list.card.settlement.table.revert") + ' ?',
                vm.localTranslator("settlementsAndInvoices.list.card.settlement.table.revert.msg"), vm.localTranslator("common.components.btn.yes")).then
            (function() {
	            vm.submitSettlementInProgress[settlementId] = true;
	            SalesSettlementsService.revertPublishedSettlement(settlementId).then
	            (function (response) {
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
                }).catch(function (err) {
                    vm.submitSettlementInProgress[settlementId] = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
	        });
        }

        function recalculateDraftSettlement(settlementId) {
            baUtil.showConfirm(vm.localTranslator("settlementsAndInvoices.list.card.settlement.table.recalculate") + ' ?',
                vm.localTranslator("settlementsAndInvoices.list.card.settlement.table.recalculate.msg"), vm.localTranslator("common.components.btn.yes")).then
            (function() {
	            vm.recalculateSettlementInProgress[settlementId] = true;
	            SalesSettlementsService.recalculateDraftSettlement(settlementId).then
	            (function (response) {
                    if(response.status === 205){
                        toastr.success(
                            vm.localTranslator("settlementsAndInvoices.settlement.not.invoice.created"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                    } else{
                        toastr.success(
                            vm.localTranslator("common.components.msg.success"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                    }
                    $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
                }).catch(function (err) {
                    vm.recalculateSettlementInProgress[settlementId] = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
	        });
        }

        function submitInvoiceDraft(invoice) {
            baUtil.showConfirm(vm.localTranslator("settlementsAndInvoices.list.card.invoice.table.submit") + ' ?',
                vm.localTranslator("settlementsAndInvoices.list.card.invoice.table.submit.msg"), vm.localTranslator("common.components.btn.yes")).then
            (function() {
	            var query = angular.copy(vm.query)
	            var data = { otherFeeTaxable: invoice.otherFeeTaxable, otherRemarks1: invoice.otherRemarks1,
                	                            otherTransferNonTaxable: invoice.otherTransferNonTaxable, otherRemarks2: invoice.otherRemarks2 }
	            vm.submitInvoiceInProgress[invoice.invoiceId] = true;
	            SalesSettlementsService.submitInvoiceDraft(invoice.invoiceId, data).then
	            (function (response) {
	                toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go($state.current.name, { query: JSON.stringify(query) }, { reload: true });
                }).catch(function (err) {
                    vm.submitInvoiceInProgress[invoice.invoiceId] = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
	        });
        }

        function revertPublishedInvoice(invoiceId) {
            baUtil.showConfirm(vm.localTranslator("settlementsAndInvoices.list.card.invoice.table.revert") + ' ?',
                vm.localTranslator("settlementsAndInvoices.list.card.invoice.table.revert.msg"), vm.localTranslator("common.components.btn.yes")).then
            (function() {
vm.submitInvoiceInProgress[invoiceId] = true;
	            SalesSettlementsService.revertPublishedInvoice(invoiceId).then
	            (function (response) {
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
                }).catch(function (err) {
vm.submitInvoiceInProgress[invoiceId] = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
	        });
        }

        function recalculateDraftInvoice(invoiceId) {
            baUtil.showConfirm(vm.localTranslator("settlementsAndInvoices.list.card.invoice.table.recalculate") + ' ?',
                vm.localTranslator("settlementsAndInvoices.list.card.invoice.table.recalculate.msg"), vm.localTranslator("common.components.btn.yes")).then
            (function() {
	            vm.recalculateInvoiceInProgress[invoiceId] = true;
	            SalesSettlementsService.recalculateDraftInvoice(invoiceId).then
	            (function (response) {
                    if(response.status === 205){
                        toastr.success(
                            vm.localTranslator("settlementsAndInvoices.invoice.not.settlement.created"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                    } else{
                        toastr.success(
                            vm.localTranslator("common.components.msg.success"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                    }
                    $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
                }).catch(function (err) {
                    vm.recalculateInvoiceInProgress[invoiceId] = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
	        });
        }

        vm.settlementCount = 0;
        function selectSingleSettlement(ev, list) {
            if (ev.target.checked) {
                vm.settlementCount = vm.settlementCount + 1;
            }
            else {
                vm.settlementCount = vm.settlementCount - 1;
            }
            if (vm.settlementCount > 50) {
                vm.settlementLimitFifty = true;
            }
            else {
                vm.settlementLimitFifty = false;
            }
        }
        function selectAllSettlement(ev, list) {
            list.forEach(function (item) {
                vm.selectedSettlementRequests[item.settlementId] = ev.target.checked
            })
            if (ev.target.checked) {
                vm.settlementCount = list.length;
            }
            else {
                vm.settlementCount = 0;
            }
            if (vm.settlementCount > 50) {
                vm.settlementLimitFifty = true;
            }
            else {
                vm.settlementLimitFifty = false;
            }
        }

        vm.invoiceCount = 0;
        function selectSingleInvoice(ev, list) {
            if(ev.target.checked) {
                vm.invoiceCount = vm.invoiceCount + 1;
            }
            else {
                vm.invoiceCount = vm.invoiceCount - 1;
            }
            if (vm.invoiceCount > 50) {
                vm.invoiceLimitFifty = true;
            }
            else {
                vm.invoiceLimitFifty = false;
            }
        }

        function selectAllInvoice(ev, list) {
            list.forEach(function (item) {
                vm.selectedInvoiceRequests[item.invoiceId] = ev.target.checked
            })
            if (ev.target.checked) {
                vm.invoiceCount = list.length
            }
            else {
                vm.invoiceCount = 0;
            }
            if (vm.invoiceCount > 50) {
                vm.invoiceLimitFifty = true;
            }
            else {
                vm.invoiceLimitFifty = false;
            }
        }

        function downloadSettlement(isDownload) {
            var ids = Object.keys(vm.selectedSettlementRequests).filter(function (id) { return vm.selectedSettlementRequests[id] });

            if (baUtil.isUndefinedOrNullOrEmptyList(ids)) {
                return
            }

            if (isDownload) {
                vm.downloadSettlementInProgress = true;
            } else {
                vm.viewSettlementInProgress = true;
            }

            SalesSettlementsService.downloadSettlementPdf(ids)
                .then(function (response) {
                    var blob = new Blob([response], { type: 'application/pdf' });
                    vm.downloadSettlementInProgress = false;
                    vm.viewSettlementInProgress = false;

                    var name = 'settlement.pdf';
                    if (ids.length > 1) {
                        name = 'お振込明細書_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    } else {
                        name = 'お振込明細書_' + getSettlementMerchantNameFromId(ids[0]) + '_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    }

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, name);
                        return;
                    }

                    var url = URL.createObjectURL(blob);
                    if (isDownload) {
                        return downloadURL(url, name)
                    }
                    openBlobInNewTab(response);
                }).catch(function (err) {
                    vm.downloadSettlementInProgress = false;
                    vm.viewSettlementInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(JSON.parse(new TextDecoder("utf-8").decode(err.data)), vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function downloadSingleSettlement(isDownload, id) {
            var ids = [id];

            if (baUtil.isUndefinedOrNullOrEmptyList(ids)) {
                return
            }

            SalesSettlementsService.downloadSettlementPdf(ids)
                .then(function (response) {
                    var blob = new Blob([response], { type: 'application/pdf' });

                    var name = 'settlement.pdf';
                    if (ids.length > 1) {
                        name = 'お振込明細書_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    } else {
                        name = 'お振込明細書_' + getSettlementMerchantNameFromId(ids[0]) + '_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    }

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, name);
                        return;
                    }

                    var url = URL.createObjectURL(blob);
                    if (isDownload) {
                        return downloadURL(url, name)
                    }
                    openBlobInNewTab(response);
                }).catch(function (err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(JSON.parse(new TextDecoder("utf-8").decode(err.data)), vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function downloadInvoice(isDownload) {
            var ids = Object.keys(vm.selectedInvoiceRequests).filter(function (id) { return vm.selectedInvoiceRequests[id] });

            if (baUtil.isUndefinedOrNullOrEmptyList(ids)) {
                return
            }

            if (isDownload) {
                vm.downloadInvoiceInProgress = true;
            } else {
                vm.viewInvoiceInProgress = true;
            }

            SalesSettlementsService.downloadInvoicePdf(ids)
                .then(function (response) {
                    var blob = new Blob([response], { type: 'application/pdf' });
                    vm.downloadInvoiceInProgress = false;
                    vm.viewInvoiceInProgress = false;

                    var name = 'invoice.pdf';
                    if (ids.length > 1) {
                        name = '請求書(兼ご利用明細書)_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    } else {
                        name = '請求書(兼ご利用明細書)_' + getInvoiceMerchantNameFromId(ids[0]) + '_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    }

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, name);
                        return;
                    }

                    var url = URL.createObjectURL(blob);
                    if (isDownload) {
                        return downloadURL(url, name)
                    }
                    openBlobInNewTab(response);
                }).catch(function (err) {
                    vm.viewInvoiceInProgress = false;
                    vm.downloadInvoiceInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(JSON.parse(new TextDecoder("utf-8").decode(err.data)), vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }
        function downloadSingleInvoice(isDownload,id) {
            var ids = [id];

            if (baUtil.isUndefinedOrNullOrEmptyList(ids)) {
                return
            }

            SalesSettlementsService.downloadInvoicePdf(ids)
                .then(function (response) {
                    var blob = new Blob([response], { type: 'application/pdf' });

                    var name = 'invoice.pdf';
                    if (ids.length > 1) {
                        name = '請求書(兼ご利用明細書)_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    } else {
                        name = '請求書(兼ご利用明細書)_' + getInvoiceMerchantNameFromId(ids[0]) + '_' + $filter('date')(vm.date, vm.dateFormat)  + '.pdf'
                    }

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, name);
                        return;
                    }

                    var url = URL.createObjectURL(blob);
                    if (isDownload) {
                        return downloadURL(url, name)
                    }
                    openBlobInNewTab(response);
                }).catch(function (err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(JSON.parse(new TextDecoder("utf-8").decode(err.data)), vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function openBlobInNewTab(data) {
            vm.pdfUrl = $sce.trustAsResourceUrl('data:application/pdf;base64,' + baUtil.convertArrayBufferToBase64(data));
            vm.showPdf = true;
            // var link = document.createElement("a");
            // link.target = '_blank';
            // link.href = url;
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
        }

        function hidePdf() {
            vm.showPdf = false;
            vm.pdfUrl = '';
        }

        function downloadURL(url, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function getUrlForDetail(data, card) {
            if (baUtil.isUndefinedOrNull(data)) {
                return
            }

            var obj = { name: data.merchantName, contractId: data.serviceContractId, date: vm.date.getTime(), paymentMethod: data.paymentMethod, invoiceMethod: data.invoiceMethod,actualPaymentMethod: data.paymentMethod };

            if (card === 'INVOICE') {
                obj.paymentMethod = 'NON_OFFSETTING'
            }

            return $state.href('main.salesSettlements.settlementDetail', { query: JSON.stringify(obj), merchantId: data.merchantId })
        }
        
        function isSettlementSelected() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedSettlementRequests)) {
                return false
            }
            return Object.keys(vm.selectedSettlementRequests).some(function (id) { return vm.selectedSettlementRequests[id] });
        }
        
        function isInvoiceSelected() {
            if (baUtil.isUndefinedOrNullOrEmptyObject(vm.selectedInvoiceRequests)) {
                return false
            }
            return Object.keys(vm.selectedInvoiceRequests).some(function (id) { return vm.selectedInvoiceRequests[id] });
        }

        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function getSettlementMerchantNameFromId(id) {
            var settlement = vm.settlement.find(function (item) {
                return item.settlementId == id
            })
            return settlement.merchantName
        }
        
        function getInvoiceMerchantNameFromId(id) {
            var invoice = vm.invoice.find(function (item) {
                return item.invoiceId == id
            })
            return invoice.merchantName
        }

        function paginateCallback(query) {
            getData(query)
        }

        function adjustedInvoiceAmountChange(date,settlementData){
            var adjustedInvoiceDate = new Date(date).getTime();
            SalesSettlementsService.invoiceData(settlementData.settlementId,adjustedInvoiceDate)
                 .then(function success(response) {
                    var resp = response.invoiceAvailableForAdjustment;
                    var invoiceDataForSave = {
                        settlementIdForAdjustment:response.settlementIdForAdjustment,
                        adjustedInvoiceId:resp.invoiceAdjustmentId
                    }
                    baUtil.showConfirm(
                        vm.localTranslator("settlementsAndInvoices.list.card.settlement.modal.header"),
                        vm.localTranslator('settlementsAndInvoices.list.card.settlement.modal.confirm.msg1') +" " + formartCurrency(resp.invoiceAdjustmentAmount) +" "+ vm.localTranslator('settlementsAndInvoices.list.card.settlement.modal.confirm.msg2'),
                        vm.localTranslator("settlementsAndInvoices.list.card.settlement.modal.submit.btn")
                    )
                    .then(function() {
                        SalesSettlementsService.invoiceAdjustment(invoiceDataForSave)
                        .then(function success(response) {
                            toastr.success(
                                vm.localTranslator('settlementsAndInvoices.list.card.settlement.table.save.invoiceAdjusted'),
                                vm.localTranslator("common.components.title.success"),
                                baUtil.toastOptions()
                            )
                            $state.reload()
                        }, function err(err) {
                            toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("error")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions()
                            );
                        });
                    })
                    .catch(function(){
                        return;
                    });
                 }, function err(err) {
                     toastr.error(
                         baUtil.getErrorMessageOrDefault(err, vm.localTranslator("error")),
                         vm.localTranslator("common.components.title.error"),
                         baUtil.toastOptions()
                     );
                 });
        }

        function revertAdjustedInvoice(settlement) {
            baUtil.showConfirm(vm.localTranslator("settlementsAndInvoices.list.card.settlement.modal.revertInvoice.header"),
                vm.localTranslator("settlementsAndInvoices.list.card.settlement.modal.revertInvoice.confirm.msg1")+ " "+ formartCurrency(settlement.invoiceAdjustmentDto.adjustedInvoiceAmount) +" "+ vm.localTranslator('settlementsAndInvoices.list.card.settlement.modal.revertInvoice.confirm.msg2'),
                vm.localTranslator("settlementsAndInvoices.list.card.settlement.modal.revertInvoice.submit.btn")).then
            (function() {
	            SalesSettlementsService.revertAdjustedInvoice(settlement.settlementId).then
	            (function (response) {
                    toastr.success(
                        vm.localTranslator("settlementsAndInvoices.list.card.settlement.table.revert.invoiceAdjusted"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
                }).catch(function (err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
	        });
        }

        function isEmailInvoiceDisabled(){
            var selectedInvoiceIds = Object.keys(vm.selectedInvoiceRequests).filter(function (id) { return vm.selectedInvoiceRequests[id] });
            var inValidSelection = false;

            var selectedInvoices = vm.invoice.filter(function(item){
                return selectedInvoiceIds.includes(item.invoiceId);
            });

            selectedInvoices.forEach(function(item){
                if(item.emailStatus !== 'NOT_SENT' || item.status !== 'PUBLISHED' ){
                    inValidSelection = true;
                }
            });

            return inValidSelection;
        }

        function emailInvoice(){    
            var selectedInvoiceIds = Object.keys(vm.selectedInvoiceRequests).filter(function (id) { return vm.selectedInvoiceRequests[id] });

            var selectedInvoices = vm.invoice.filter(function(item){
                return selectedInvoiceIds.includes(item.invoiceId);
            });
            var merchantDataList = [], invoiceIdList = [];

            selectedInvoices.forEach(function(item){
                if(item.invoiceMethod === 'BRANCH'){
                    invoiceIdList.push(item.invoiceId);
                }
                else{
                    var obj = {
                        merchantId : item.merchantId,
                        serviceContractId :	item.serviceContractId,
                        invoiceTargetDate : item.targetDate,	
                    };
                    merchantDataList.push(obj);
                }
            });

            var payLoad = {
                merchantDataList : merchantDataList,
                invoiceIdList : invoiceIdList,
            };

            vm.emailInvoiceInProgress = true;

            SalesSettlementsService.emailInvoice(payLoad).then(function (response) {
                vm.emailInvoiceInProgress = false;
                $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
            }, function err(err) {
                vm.emailInvoiceInProgress = false;
                $state.go($state.current.name, { query: JSON.stringify(vm.query) }, { reload: true });
            });
        }

        function formatDate(date) {  
            date = new Date(date);
            var d = date.getUTCDate().toString(),           
                m = (date.getUTCMonth() + 1).toString(),    
                y = date.getUTCFullYear().toString(),       
                formatted = '';
            if (d.length === 1) {                           
                d = '0' + d;
            }
            if (m.length === 1) {                           
                m = '0' + m;
            }
            formatted = y + '/' + m;              
            return formatted;
        }

        function formartCurrency(currency){
            var formartedCurrency = new Intl.NumberFormat('ja-JP', {
                style: 'currency',
                currency: 'JPY',
            });

            var formatted = formartedCurrency.format(currency);
            return formatted;
        } 

    }
})();

(function () {
    'use strict';

    angular.module('JPTC.pages.salesSettlements')
        .factory('SalesSettlementsService', SalesSettlementsService);

    /** @ngInject */
    function SalesSettlementsService(baUtil, $translate, $http, API_CONFIG, AuthService) {
        var service = {};
        service.getOrganisation = getOrganisation;
        service.getAllOrganisation = getAllOrganisation;
        service.fetchMonthlyResult = fetchMonthlyResult;
        service.fetchMonthlyUnitPriceResult = fetchMonthlyUnitPriceResult;
        service.fetchMonthlyResultByEntity = fetchMonthlyResultByEntity;
        service.fetchMonthlyTransaction = fetchMonthlyTransaction;
        service.getAggregationSummary = getAggregationSummary;
        service.getAggregationBranchList = getAggregationBranchList;
        service.getAggregationDates = getAggregationDates;
        service.getSettlementBranches = getSettlementBranches;
        service.getSettlementDetail = getSettlementDetail;
        service.getSettlementListOld = getSettlementListOld;
        service.getSettlementList = getSettlementList;
        service.submitSettlementDraft = submitSettlementDraft;
        service.revertPublishedSettlement = revertPublishedSettlement;
        service.recalculateDraftSettlement = recalculateDraftSettlement;
        service.downloadSettlementPdf = downloadSettlementPdf;
        service.getSettlementDetailData = getSettlementDetailData;
        service.checkDateForInvoiceByDevice = checkDateForInvoiceByDevice;
        service.checkDateForSettlementByDevice = checkDateForSettlementByDevice;
        service.downloadSettlementPdfForMerchant = downloadSettlementPdfForMerchant;
        service.getSettlementListForMerchant = getSettlementListForMerchant;
        service.downloadInvoicePdfForMerchant = downloadInvoicePdfForMerchant;
        service.getInvoiceList = getInvoiceList;
        service.submitInvoiceDraft = submitInvoiceDraft;
        service.revertPublishedInvoice = revertPublishedInvoice;
        service.recalculateDraftInvoice = recalculateDraftInvoice;
        service.downloadInvoicePdf = downloadInvoicePdf;
        service.getInvoiceDetailData = getInvoiceDetailData;
        service.getInvoiceByDeviceData = getInvoiceByDeviceData;
        service.getSettlementByDeviceData = getSettlementByDeviceData;
        service.getInvoiceListForMerchant = getInvoiceListForMerchant;
        service.getServiceContractByMerchant = getServiceContractByMerchant;
        service.getOneItemPricesForOrganisation = getOneItemPricesForOrganisation;
        service.getSettlementStats = getSettlementStats;
        service.getInvoiceStats = getInvoiceStats;
        service.getSalesStats = getSalesStats;
        service.getDeviceHistory = getDeviceHistory;
        service.getSuspensionHistory = getSuspensionHistory;
        service.getClosingHeaders = getClosingHeaders;
        service.getToggleClosingData = getToggleClosingData;
        service.getAddClosingRows = getAddClosingRows;
        service.getAddClosingEnums = getAddClosingEnums;
        service.submitAddClosingData = submitAddClosingData;
        service.invoiceAdjustment = invoiceAdjustment;
        service.invoiceData = invoiceData;
        service.revertAdjustedInvoice = revertAdjustedInvoice;
        service.getSettlementByDeviceOwnerByDevice = getSettlementByDeviceOwnerByDevice;
        service.checkMerchantForSettlementByDeviceOwner = checkMerchantForSettlementByDeviceOwner;
        service.downloadRequestMonthlyResult = downloadRequestMonthlyResult;
        service.fetchRequestMonthlyResult = fetchRequestMonthlyResult;
        service.downloadMonthlyResult = downloadMonthlyResult;
        service.fetchSalesPropertyMap = fetchSalesPropertyMap;
        service.isDownloadReportsEnabled = isDownloadReportsEnabled;
        service.emailInvoice = emailInvoice;

        return service;

        function getOrganisation(query) {
            return $http({
                url: encodeURI(API_CONFIG.url + '/api/v1/org/search/merchant?query=' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data.content;
            });
        }

        function getAllOrganisation() {
            return $http({
                url: encodeURI(API_CONFIG.url + '/api/v1/org/list/merchant?query=""'),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data.content;
            });
        }

        function fetchMonthlyResult(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentAggregation/list?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function fetchMonthlyUnitPriceResult(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentAggregation/unit/list?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function fetchMonthlyResultByEntity(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentAggregation?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function fetchMonthlyTransaction(query,data) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentTransaction?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                if(data.displayData === "CLOSING"){
                    response.data.data.closingInfoDtos.addClosing = response.data.data.addClosing;
                    return response.data.data.closingInfoDtos;
                }else{
                    return response.data.data
                }
            });
        }

        function getAggregationSummary(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentAggregation/summary?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getAggregationBranchList(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentAggregation/list/branchCode?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getAggregationDates(organisationId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentAggregation/dates?organisationId=' + organisationId),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementBranches(merchantId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/branches?merchantId=' + merchantId),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementDetail(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementListOld() {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/list'),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementList(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/list/month?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementListForMerchant(date, merchantId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/merchant/' + merchantId + '/month/' + date),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementDetailData(merchantId, date, serviceContractId,  pageNumber, pageSize) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/merchant/' + merchantId + '/serviceContract/' + serviceContractId + '/month/' + date + '?pageNumber=' + pageNumber + '&pageSize=' + pageSize),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function submitSettlementDraft(settlementId, data) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/' + settlementId),
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function revertPublishedSettlement(settlementId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/revert/' + settlementId),
                method: 'post',
                data: {},
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function recalculateDraftSettlement(settlementId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/recalculate/' + settlementId),
                method: 'post',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response;
            });
        }

        function downloadSettlementPdf(ids) {
//            var settlementIds = ids.join('|')
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/download'),
                method: 'post',
                data: ids,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
                responseType: 'arraybuffer',
            }).then(function(response) {
                return response.data;
            });
        }

        function downloadSettlementPdfForMerchant(merchantId, date, serviceContractId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/merchant/' + merchantId + '/serviceContract/' + serviceContractId + '/month/' + date + '/download'),
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
                responseType: 'arraybuffer',
            }).then(function(response) {
                return response.data;
            });
        }

        function downloadInvoicePdfForMerchant(merchantId, date, serviceContractId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/merchant/' + merchantId + '/serviceContract/' + serviceContractId + '/month/' + date + '/download'),
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
                responseType: 'arraybuffer',
            }).then(function(response) {
                return response.data;
            });
        }

        function getInvoiceList(date, query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/month/' + date + '?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getInvoiceListForMerchant(date, merchantId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/merchant/' + merchantId + '/month/' + date),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function submitInvoiceDraft(invoiceId, data) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/' + invoiceId),
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function revertPublishedInvoice(invoiceId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/revert/' + invoiceId),
                method: 'post',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function recalculateDraftInvoice(invoiceId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/recalculate/' + invoiceId),
                method: 'post',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response;
            });
        }

        function downloadInvoicePdf(ids) {
//            var invoiceIds = ids.join(',')
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/download'),
                method: 'post',
                data: ids,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
                responseType: 'arraybuffer',
            }).then(function(response) {
                return response.data;
            });
        }

        function getInvoiceDetailData(merchantId, date, serviceContractId, pageNumber, pageSize) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/merchant/' + merchantId + '/serviceContract/' + serviceContractId + '/month/' + date + '?pageNumber=' + pageNumber + '&pageSize=' + pageSize),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function checkDateForSettlementByDevice(date) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/device/dateBarrier/' + date),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function checkDateForInvoiceByDevice(date) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/device/dateBarrier/' + date),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function checkMerchantForSettlementByDeviceOwner(contractId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/detailsByDeviceOwner/' + contractId),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getInvoiceByDeviceData(serviceContractId, date, branchCodes, pageNumber, pageSize) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/device?serviceContractId=' + serviceContractId + '&targetDate=' + date + '&branchCodes=' + branchCodes + '&pageNumber=' + pageNumber + '&pageSize=' + pageSize),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementByDeviceData(serviceContractId, date, branchCodes, pageNumber, pageSize) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/device?serviceContractId=' + serviceContractId + '&targetDate=' + date + '&branchCodes=' + branchCodes  + '&pageNumber=' + pageNumber + '&pageSize=' + pageSize),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementByDeviceOwnerByDevice(serviceContractId, date, branchCodes) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/downloadByDeviceOwner?serviceContractId=' + serviceContractId + '&targetDate=' + date + '&branchCodes=' + branchCodes),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data;
            });
        }

        function getServiceContractByMerchant(merchantId) {
            return $http({
                url: encodeURI(API_CONFIG.url + '/api/v1/sc/merchant/' + merchantId),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getOneItemPricesForOrganisation(orgId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentTransaction/unit/price?organisationId=' + orgId),
                method: 'GET',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSettlementStats(serviceContractId, date, branchCodes) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/device-change/settlement/stats?serviceContractId=' + serviceContractId + '&targetDate=' + date + '&branchCodes=' + branchCodes),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getInvoiceStats(serviceContractId, date, branchCodes) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/device-change/invoice/stats?serviceContractId=' + serviceContractId + '&targetDate=' + date + '&branchCodes=' + branchCodes),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getSalesStats(organisationId, date, branchCodes, interval) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/device-change/sales/stats?organisationId=' + organisationId + '&targetDate=' + date + '&branchCodes=' + branchCodes + '&interval=' + interval),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }


        function getDeviceHistory(deviceSerial) {
            return $http({
                url: API_CONFIG.url + '/api/v1/device/history/' + deviceSerial,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        };



        function getSuspensionHistory(deviceSerial) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/suspension/history/' + deviceSerial,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        };

        function getClosingHeaders(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/api/v1/closing/getClosingKeys?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                    return response.data.data
            });
        }

        function getAddClosingRows(query) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentTransaction/getSalesForClosing?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                    return response.data.data
            });
        }

        function getAddClosingEnums() {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/api/v1/master/types?entity=CLOSING'),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                    return response.data.data
            });
        }

        function getToggleClosingData(query){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentTransaction/getSalesForClosing?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                    return response.data.data
            });
        }

        function submitAddClosingData(data, query){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentTransaction/closing/upsert?' + query),
                method: 'POST',
                data : data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                    return response.data.data
            });
        }

        function invoiceAdjustment(data){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/invoiceAdjustment'),
                method: 'POST',
                data : data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                    return response.data.data
            });
        }

        function revertAdjustedInvoice(settlementId) {
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/invoiceAdjustment/revert?settlementId=' + settlementId),
                method: 'post',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function invoiceData(settlementId,date){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/settlement/invoiceData?settlementId=' + settlementId +'&'+ 'date=' + date),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });

        }

        function downloadRequestMonthlyResult(query){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/paymentAggregation/sales/createDownloadable?' + query),
                method: 'post',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function fetchRequestMonthlyResult(query){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/api/v1/sales/get/downloadable?' + query),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function downloadMonthlyResult(id, userId){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/api/v1/sales/download/' + userId + '/' + id ),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
                responseType: 'arraybuffer',
            }).then(function(response) {
                return response;
            }); 
        }

        function fetchSalesPropertyMap(){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/api/v1/org/merchant/list?property=MONTHLY_SALES'),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response;
            }); 
        }

        function isDownloadReportsEnabled(){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/api/v1/sales/flagForDownloadReport'),
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response;
            }); 
        }

        function emailInvoice(data){
            return $http({
                url: encodeURI(API_CONFIG.paymentUrl + '/batch/api/v1/invoice/mailInvoice'),
                method: 'post',
                data : data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }
        
    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('DetailContractCtrl', DetailContractCtrl);

    /** @ngInject */
    function DetailContractCtrl(allTypes, branchProperty, maronBtnStatus, ServiceContractService, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, AuthService, getDetail, $filter, $location, $anchorScroll, $uibModal, hotUtil, $document, FileSaver) {

        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.getDeviceOwner = getDeviceOwner;
        vm.onOrgSelected = onOrgSelected;
        vm.onPartnerSelected = onPartnerSelected;
        vm.onBankSelected = onBankSelected;
        vm.bankCodeChange = bankCodeChange;
        vm.onBankBranchSelected = onBankBranchSelected;
        vm.bankBranchCodeChange = bankBranchCodeChange;
        vm.saveDetail = saveDetail;
        vm.getType = getType;
        vm.addNewRow = addNewRow;
        vm.enableButton = enableButton;
        vm.disableButton = disableButton;
        vm.btnClick = false;
        vm.bankData = {};
        vm.bankBranchData = {};
        vm.getPartner = getPartner;
        vm.localTranslator = $filter('translate');

        vm.paymentHandlingFeeDtos = {
            'ME_10': {
                'E_MONEY':{},
                'QR_MONEY':{},
                'CREDIT_CARD':[{
                        "paymentType": "CREDIT_CARD",
                        "paymentOption": "VISA",
                        "paymentDeductionOption": "PERCENTAGE",
                        "rateOrAmount": 0,
                        "createSettlement": false,
                        "nonTaxable": false,
                        "deviceTypes": "ME-10"
                    },
                    {
                        "paymentType": "CREDIT_CARD",
                        "paymentOption": "MASTERCARD",
                        "paymentDeductionOption": "PERCENTAGE",
                        "rateOrAmount": 0,
                        "createSettlement": false,
                        "nonTaxable": false,
                        "deviceTypes": "ME-10"
                    },
                    {
                        "paymentType": "CREDIT_CARD",
                        "paymentOption": "AMERICANEXPRESS",
                        "paymentDeductionOption": "PERCENTAGE",
                        "rateOrAmount": 0,
                        "createSettlement": false,
                        "nonTaxable": false,
                        "deviceTypes": "ME-10"
                    },
                    {
                        "paymentType": "CREDIT_CARD",
                        "paymentOption": "JCB",
                        "paymentDeductionOption": "PERCENTAGE",
                        "rateOrAmount": 0,
                        "createSettlement": false,
                        "nonTaxable": false,
                        "deviceTypes": "ME-10"
                    },
                    {
                        "paymentType": "CREDIT_CARD",
                        "paymentOption": "DISCOVER",
                        "paymentDeductionOption": "PERCENTAGE",
                        "rateOrAmount": 0,
                        "createSettlement": false,
                        "nonTaxable": false,
                        "deviceTypes": "ME-10"
                    },
                    {
                        "paymentType": "CREDIT_CARD",
                        "paymentOption": "DINERS",
                        "paymentDeductionOption": "PERCENTAGE",
                        "rateOrAmount": 0,
                        "createSettlement": false,
                        "nonTaxable": false,
                        "deviceTypes": "ME-10"
                    }
            ]},
            'ME_20_1': {
                'E_MONEY':{},
                'QR_MONEY':{},
                'CREDIT_CARD':{}
            },
            'ME_20_2': {
                'E_MONEY':{},
                'QR_MONEY':{},
                'CREDIT_CARD':{}
            },
            'ME_5_1': {
                'E_MONEY':{},
                'QR_MONEY':{},
                'CREDIT_CARD':{},
            },
        }

        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.isRepresentativeRequired = isRepresentativeRequired;
        vm.removeRow = removeRow;
        vm.removePartner = removePartner;
        vm.removeDeviceOwnerRow = removeDeviceOwnerRow;
        vm.handlingFeeEmoneyForME_10SelectAll = handlingFeeEmoneyForME_10SelectAll;
        vm.handlingFeeQRmoneyForME_10SelectAll = handlingFeeQRmoneyForME_10SelectAll;
        vm.handlingFeeEmoneyForME_20_1SelectAll = handlingFeeEmoneyForME_20_1SelectAll;
        vm.handlingFeeQRmoneyForME_20_1SelectAll = handlingFeeQRmoneyForME_20_1SelectAll;
        vm.handlingFeeCreditCardForME_20_1SelectAll = handlingFeeCreditCardForME_20_1SelectAll;
        vm.handlingFeeEmoneyForME_20_2SelectAll = handlingFeeEmoneyForME_20_2SelectAll;
        vm.handlingFeeQRmoneyForME_20_2SelectAll = handlingFeeQRmoneyForME_20_2SelectAll;
        vm.handlingFeeCreditCardForME_20_2SelectAll = handlingFeeCreditCardForME_20_2SelectAll;
        vm.handlingFeeQRmoneyForME_5_1SelectAll = handlingFeeQRmoneyForME_5_1SelectAll;
        vm.editDetail = editDetail;
        vm.cancelEdit = cancelEdit;
        vm.isEdit = false;
        vm.detailErrors = false;
        vm.merchantNumber = false;
        vm.submitBtn = false;
        vm.merchantNumberForm = merchantNumberForm;
        vm.submitMerchantForm = submitMerchantForm;
        vm.cancelMerchantForm = cancelMerchantForm;
        vm.applyAllMerchantNumber = applyAllMerchantNumber;
        vm.downloadMaronExcel = downloadMaronExcel;
        vm.uploadJescaMaroonCsv = uploadJescaMaroonCsv;
        vm.contractInfo = {}
        vm.dobOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date(1901,0,1),
            maxDate : new Date()
        }
        vm.isSystemAdmin = baUtil.isSystemAdmin();
        vm.alerts = []
        vm.errors = []

        vm.otherServiceFeeDtos =  {
            builtIn_initial : {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },       
            builtIn_monthly:  
            {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external_initial:  {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn20_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn20_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external20_initial: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external20_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn5_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn5_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
        }

        vm.qrOtherServiceFeeDtos =  {
            builtIn_initial : {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },       
            builtIn_monthly:  
            {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external_initial:  {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn20_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn20_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external20_initial: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external20_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn5_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn5_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
        }

        vm.baseServiceFeeDtos =  {
            builtIn_initial : {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd: 0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            }, 
            builtIn_monthly:  
            {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external_initial:  {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn20_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn20_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external20_initial: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external20_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn5_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn5_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
        }

        vm.serviceFeeDtosCreditCard =  {
            builtIn_initial : {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd: 1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },   
            builtIn_monthly:  
            {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external_initial:  {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd: 1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn20_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn20_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external20_initial: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external20_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn5_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn5_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
        }


        vm.serviceFeeDtos = {
            "builtIn_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "external_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "external_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn20_initial": {
            //     eMoney:[
            //     {       
            //         rangeStart: 1,
            //         serviceFeeFrequency: "INITIAL",
            //         paymentType: "E_MONEY",
            //         deviceTypes: [
            //             "ME_20_1"
            //         ],
            //         modemType: "BUILT_IN_20",
            //         paymentDeductionOption: "FLAT"
            //     }
            // ],
            //     qrMoney: [
            //         {       
            //             rangeStart: 1,
            //             serviceFeeFrequency: "INITIAL",
            //             paymentType: "QR_MONEY",
            //             deviceTypes: [
            //                 "ME_20_1"
            //             ],
            //             modemType: "BUILT_IN_20",
            //             paymentDeductionOption: "FLAT"
            //         }
            //     ],
                eMoney:[],
                qrMoney:[],
                creditCard: [],
            },
            "builtIn20_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "external20_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "external20_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn5_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn5_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
        }

        vm.deviceOwnerDto = [];

        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.types = allTypes.data.data;
        }

        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.types = allTypes.data.data;
        }

        if (maronBtnStatus.status >= 200 && maronBtnStatus.status <= 299) {
            vm.maronBtnStatus = maronBtnStatus.data;
        }

        if (branchProperty.status >= 200 && branchProperty.status <= 299) {
            vm.branchProperty = branchProperty.data.data;
            vm.branchCodeMaxLength = vm.branchProperty.branchCodeLength;
            vm.branchNameMaxLength = vm.branchProperty.branchNameLength;
        }
        else {
            vm.branchCodeMaxLength = 6;
            vm.branchNameMaxLength = 50;
        }

        vm.types.createInvoice  = {
            en:['Yes','No'],
            jp:['はい','いいえ'],
            key:[true,false]
        }

        vm.types.emailInvoice  = {
            en:['Yes','No'],
            jp:['する','しない'],
            key:[true,false]
        }

        if (getDetail.status >= 200 && getDetail.status <= 299) {
            vm.contractDetails = getDetail.data.data;
        }

        if (!baUtil.isUndefinedOrNull(vm.contractDetails)) {
            vm.contractInfo = vm.contractDetails
            if (!baUtil.isUndefinedOrNullOrEmptyList(vm.contractInfo.paymentHandlingFeeDtos)) {
                vm.contractInfo.paymentHandlingFeeDtos.forEach(function (item) {
                    if (item.deviceTypes === "ME-10") {

                        if(item.paymentType === "E_MONEY"){
                            vm.paymentHandlingFeeDtos.ME_10.E_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.E_MONEY.key)] = item
                        }
                        
                        if (item.paymentType === "QR_MONEY") {
                            vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.QR_MONEY.key)] = item
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            vm.paymentHandlingFeeDtos.ME_10.CREDIT_CARD[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.CREDIT_CARD.key)] = item
                        }
                    }
                        
                    if (item.deviceTypes === "ME-20-1") {

                        if(item.paymentType === "E_MONEY"){
                            vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.E_MONEY.key)] = item
                        }

                       if (item.paymentType === "QR_MONEY") {
                            vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.QR_MONEY.key)] = item
                        }
                        
                        if (item.paymentType === "CREDIT_CARD") {
                            vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.CREDIT_CARD.key)] = item
                        }

                    }

                    if(item.deviceTypes === "ME-20-2"){

                        if (item.paymentType === "E_MONEY") {
                            vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.E_MONEY.key)] = item
                        }
    
                        if (item.paymentType === "QR_MONEY") {
                            vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.QR_MONEY.key)] = item
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.CREDIT_CARD.key)] = item
                        }

                    }

                    if (item.deviceTypes === "ME-5-1") {

                        if(item.paymentType === "E_MONEY"){
                            vm.paymentHandlingFeeDtos.ME_5_1.E_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.E_MONEY.key)] = item
                        }

                       if (item.paymentType === "QR_MONEY") {
                            vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.QR_MONEY.key)] = item
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            vm.paymentHandlingFeeDtos.ME_5_1.CREDIT_CARD[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.CREDIT_CARD.key)] = item
                        }
                    }
                })
            }

            if (!baUtil.isUndefinedOrNullOrEmptyList(vm.contractInfo.serviceFeeDtos)) {
                vm.contractInfo.serviceFeeDtos.forEach(function (item, index) {
                    if (item.modemType === "BUILT_IN" && baUtil.isUndefinedOrNull(vm.builtIn_deviceType)) {
                        vm.builtIn_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "EXTERNAL" && baUtil.isUndefinedOrNull(vm.external_deviceType)) {
                        vm.external_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "BUILT_IN_20" && baUtil.isUndefinedOrNull(vm.builtIn20_deviceType)) {
                        vm.builtIn20_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "EXTERNAL_20" && baUtil.isUndefinedOrNull(vm.external20_deviceType)) {
                        vm.external20_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "BUILT_IN_5" && baUtil.isUndefinedOrNull(vm.builtIn5_deviceType)) {
                        vm.builtIn5_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "BUILT_IN" && item.serviceFeeFrequency === "INITIAL") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.builtIn_initial = item;
                            } 
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.builtIn_initial = item;
                            }
                             else{
                                vm.serviceFeeDtos.builtIn_initial.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.builtIn_initial = item;
                            } else{
                                vm.serviceFeeDtos.builtIn_initial.qrMoney.push(item)
                            }
                        }
                        
                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.builtIn_initial = item;
                            } else{
                            vm.serviceFeeDtos.builtIn_initial.creditCard.push(item)

                            }
                        }

                    }

                    if (item.modemType === "BUILT_IN" && item.serviceFeeFrequency === "MONTHLY") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.builtIn_monthly = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.builtIn_monthly = item;
                            }
                             else{
                                vm.serviceFeeDtos.builtIn_monthly.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.builtIn_monthly = item;
                            } else{
                                vm.serviceFeeDtos.builtIn_monthly.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.builtIn_monthly = item;
                            } else{
                            vm.serviceFeeDtos.builtIn_monthly.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "EXTERNAL" && item.serviceFeeFrequency === "INITIAL") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.external_initial = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.external_initial = item;
                            }
                            else {
                                vm.serviceFeeDtos.external_initial.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.external_initial = item;
                            } else{
                                vm.serviceFeeDtos.external_initial.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.external_initial = item;
                            } else{
                            vm.serviceFeeDtos.external_initial.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "EXTERNAL" && item.serviceFeeFrequency === "MONTHLY") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.external_monthly = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.external_monthly = item;
                            }
                             else {
                                vm.serviceFeeDtos.external_monthly.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.external_monthly = item;
                            } else{
                                vm.serviceFeeDtos.external_monthly.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.external_monthly = item;
                            } else{
                            vm.serviceFeeDtos.external_monthly.creditCard.push(item)

                            }
                        }
                    }

                        // NEW IMPLEMENTATION

                        if (item.modemType === "BUILT_IN_20" && item.serviceFeeFrequency === "INITIAL") {
                            if (item.paymentType === "E_MONEY") {
                                if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                    vm.otherServiceFeeDtos.builtIn20_initial = item;
                                }
                                else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                    vm.baseServiceFeeDtos.builtIn20_initial = item;
                                } else{
                                    vm.serviceFeeDtos.builtIn20_initial.eMoney.push(item)
                                }
                            } 
    
                            if (item.paymentType === "QR_MONEY") {
                                if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                    vm.qrOtherServiceFeeDtos.builtIn20_initial = item;
                                } else{
                                vm.serviceFeeDtos.builtIn20_initial.qrMoney.push(item)
    
                                }
                            }

                            if (item.paymentType === "CREDIT_CARD") {
                                if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                    vm.serviceFeeDtosCreditCard.builtIn20_initial = item;
                                } else{
                                vm.serviceFeeDtos.builtIn20_initial.creditCard.push(item)
    
                                }
                            }
                        }
    
                        if (item.modemType === "BUILT_IN_20" && item.serviceFeeFrequency === "MONTHLY") {
                            if (item.paymentType === "E_MONEY") {
                                if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                    vm.otherServiceFeeDtos.builtIn20_monthly = item;
                                }
                                else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                    vm.baseServiceFeeDtos.builtIn20_monthly = item;
                                }
                                 else{
                                    vm.serviceFeeDtos.builtIn20_monthly.eMoney.push(item)
                                }
                            }
    
                            if (item.paymentType === "QR_MONEY") {
                                if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                    vm.qrOtherServiceFeeDtos.builtIn20_monthly = item;
                                } else{
                                vm.serviceFeeDtos.builtIn20_monthly.qrMoney.push(item)
                                }
                            }

                            if (item.paymentType === "CREDIT_CARD") {
                                if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                    vm.serviceFeeDtosCreditCard.builtIn20_monthly = item;
                                } else{
                                vm.serviceFeeDtos.builtIn20_monthly.creditCard.push(item)
    
                                }
                            }
                        }
    
                        if (item.modemType === "EXTERNAL_20" && item.serviceFeeFrequency === "INITIAL") {
                            if (item.paymentType === "E_MONEY") {
                                if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                    vm.otherServiceFeeDtos.external20_initial = item;
                                }
                                else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                    vm.baseServiceFeeDtos.external20_initial = item;
                                } else {
                                    vm.serviceFeeDtos.external20_initial.eMoney.push(item)
                                }
                            }
    
                            if (item.paymentType === "QR_MONEY") {
                                if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                    vm.qrOtherServiceFeeDtos.external20_initial = item;
                                } else {
                                vm.serviceFeeDtos.external20_initial.qrMoney.push(item)
                                }
                            }

                            if (item.paymentType === "CREDIT_CARD") {
                                if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                    vm.serviceFeeDtosCreditCard.external20_initial = item;
                                } else{
                                vm.serviceFeeDtos.external20_initial.creditCard.push(item)
    
                                }
                            }
                        }
    
                        if (item.modemType === "EXTERNAL_20" && item.serviceFeeFrequency === "MONTHLY") {
                            if (item.paymentType === "E_MONEY") {
                                if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                    vm.otherServiceFeeDtos.external20_monthly = item;
                                }
                                else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                    vm.baseServiceFeeDtos.external20_monthly = item;
                                }
                                 else {
                                    vm.serviceFeeDtos.external20_monthly.eMoney.push(item)
                                }
                            }
    
                            if (item.paymentType === "QR_MONEY") {
                                if((item.rangeStart === 15) && (item.rangeEnd === 15)){
                                    vm.qrOtherServiceFeeDtos.external20_monthly = item;
                                }else{
                                vm.serviceFeeDtos.external20_monthly.qrMoney.push(item)
                                }
                            }

                            if (item.paymentType === "CREDIT_CARD") {
                                if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                    vm.serviceFeeDtosCreditCard.external20_monthly = item;
                                } else{
                                vm.serviceFeeDtos.external20_monthly.creditCard.push(item)
    
                                }
                            }
                        }

                        if (item.modemType === "BUILT_IN_5" && item.serviceFeeFrequency === "INITIAL") {
                            if (item.paymentType === "E_MONEY") {
                                if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                    vm.otherServiceFeeDtos.builtIn5_initial = item;
                                }
                                else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                    vm.baseServiceFeeDtos.builtIn5_initial = item;
                                } else{
                                    vm.serviceFeeDtos.builtIn5_initial.eMoney.push(item);
                                }
                            } 
    
                            if (item.paymentType === "QR_MONEY") {
                                if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                    vm.qrOtherServiceFeeDtos.builtIn5_initial = item;
                                } else{
                                    vm.serviceFeeDtos.builtIn5_initial.qrMoney.push(item);
                                }
                            }

                            if (item.paymentType === "CREDIT_CARD") {
                                if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                    vm.serviceFeeDtosCreditCard.builtIn5_initial = item;
                                } else{
                                    vm.serviceFeeDtos.builtIn5_initial.creditCard.push(item);
                                }
                            }
                        }
    
                        if (item.modemType === "BUILT_IN_5" && item.serviceFeeFrequency === "MONTHLY") {
                            if (item.paymentType === "E_MONEY") {
                                if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                    vm.otherServiceFeeDtos.builtIn5_monthly = item;
                                }
                                else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                    vm.baseServiceFeeDtos.builtIn5_monthly = item;
                                }
                                 else{
                                    vm.serviceFeeDtos.builtIn5_monthly.eMoney.push(item);
                                }
                            }
    
                            if (item.paymentType === "QR_MONEY") {
                                if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                    vm.qrOtherServiceFeeDtos.builtIn5_monthly = item;
                                } else{
                                    vm.serviceFeeDtos.builtIn5_monthly.qrMoney.push(item);
                                }
                            }

                            if (item.paymentType === "CREDIT_CARD") {
                                if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                    vm.serviceFeeDtosCreditCard.builtIn5_monthly = item;
                                } else{
                                 vm.serviceFeeDtos.builtIn5_monthly.creditCard.push(item);
                                }
                            }
                        }
                        //END

                })
            }

            vm.contractInfo.deviceOwnerDtos.filter(function (x) { return !!x }).forEach(function (data) {
                vm.deviceOwnerDto.push({
                    code: data.deviceOwnerCode,
                    deviceOrgName: data.name,
                    organisationId: data.organisationId,
                })
            })
        }


        if (baUtil.isUndefinedOrNullOrEmptyList(vm.deviceOwnerDto)) {
            vm.deviceOwnerDto = [{}]
        }

        if (baUtil.isUndefinedOrNullOrEmptyList(vm.contractInfo.partnerDtos)) {
            vm.contractInfo.partnerDtos = [{}]
            vm.emptyPartnerDtos = true;
        }

        function merchantNumberForm() {
            vm.merchantNumber = true;
            $location.hash('merchant');
            $anchorScroll();
            initFirstTable();
            initSecondTable();
        }

        function initFirstTable() {
            if(vm.contractInfo.merchantNumbers.length == 0){
                vm.mNumberFirst = [
                    { type: vm.types.MerchantNumberType.key[0], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[0],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[1], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[1],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[2], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[2],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[3], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[3],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[4], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[4],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[5], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[5],vm.types.MerchantNumberType), number: '' }
                ];
            }
            else {                
                vm.mNumberFirst = [
                    { type: vm.types.MerchantNumberType.key[0], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[0],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[0].number},
                    { type: vm.types.MerchantNumberType.key[1], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[1],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[1].number },
                    { type: vm.types.MerchantNumberType.key[2], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[2],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[2].number },
                    { type: vm.types.MerchantNumberType.key[3], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[3],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[3].number },
                    { type: vm.types.MerchantNumberType.key[4], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[4],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[4].number },
                    { type: vm.types.MerchantNumberType.key[5], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[5],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[5].number }
                ];
            }
            var container,
                tableSettings,
                numberValidator;

            container = document.getElementById('merchant-number');
            container.innerHTML = ""
            tableSettings = {
                colHeaders: false,
                rowHeaders: false,
                columns: [
                    { data: 'name', readOnly: true },
                    {
                        data: 'number',
                        type: 'text',
                        allowEmpty: false,
                        validator: function(query, callback) {
                            if(baUtil.isUndefinedOrNullOrEmpty(query))
                                callback(false);
                            else
                                callback(true);
                        }

                    },
                ],
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                afterValidate: function (isValid, value, row, prop, source) {
                    if (isValid) {
                        vm.blankNumber = false;
                    }
                    else {
                        vm.blankNumber = true;
                    }
                },
                colWidths: [450, 300],
                minSpareRows: 0,
                minSpareCols: 0
            };
            var options = Object.assign({ data: vm.mNumberFirst }, tableSettings);
            var hot = new Handsontable(container, options);
            hot.validateCells();
        }


        function initSecondTable() {
            if(vm.contractInfo.merchantNumbers.length == 0){
                vm.mNumberSecond = [
                    { type: vm.types.MerchantNumberType.key[6], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[6],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[7], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[7],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[8], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[8],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[9], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[9],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[10], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[10],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[11], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[11],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[12], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[12],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[13], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[13],vm.types.MerchantNumberType), number: '' },
                    { type: vm.types.MerchantNumberType.key[14], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[14],vm.types.MerchantNumberType), number: '' }
                ];
            }
            else {

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[6])) {
                        var mn6 = ''
                    }
                    else {
                        var mn6 = vm.contractInfo.merchantNumbers[6].number;
                    }

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[7])) {
                        var mn7 = ''
                    }
                    else {
                        var mn7 = vm.contractInfo.merchantNumbers[7].number;
                    }

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[8])) {
                        var mn8 = ''
                    }
                    else {
                        var mn8 = vm.contractInfo.merchantNumbers[8].number;
                    }

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[9])) {
                        var mn9 = ''
                    }
                    else {
                        var mn9 = vm.contractInfo.merchantNumbers[9].number;
                    }

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[10])) {
                        var mn10 = ''
                    }
                    else {
                        var mn10 = vm.contractInfo.merchantNumbers[10].number;
                    }

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[11])) {
                        var mn11 = ''
                    }
                    else {
                        var mn11 = vm.contractInfo.merchantNumbers[11].number;
                    }

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[12])) {
                        var mn12 = ''
                    }
                    else {
                        var mn12 = vm.contractInfo.merchantNumbers[12].number;
                    }

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[13])) {
                        var mn13 = ''
                    }
                    else {
                        var mn13 = vm.contractInfo.merchantNumbers[13].number;
                    }

                    if (baUtil.isUndefinedOrNullOrEmpty(vm.contractInfo.merchantNumbers[14])) {
                        var mn14 = ''
                    }
                    else {
                        var mn14 = vm.contractInfo.merchantNumbers[14].number;
                    }



                vm.mNumberSecond = [
                    { type: vm.types.MerchantNumberType.key[6], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[6],vm.types.MerchantNumberType), number: mn6 },
                    { type: vm.types.MerchantNumberType.key[7], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[7],vm.types.MerchantNumberType), number: mn7 },
                    { type: vm.types.MerchantNumberType.key[8], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[8],vm.types.MerchantNumberType), number: mn8 },
                    { type: vm.types.MerchantNumberType.key[9], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[9],vm.types.MerchantNumberType), number: mn9 },
                    { type: vm.types.MerchantNumberType.key[10], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[10],vm.types.MerchantNumberType), number: mn10 },
                    { type: vm.types.MerchantNumberType.key[11], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[11],vm.types.MerchantNumberType), number: mn11 },
                    { type: vm.types.MerchantNumberType.key[12], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[12],vm.types.MerchantNumberType), number: mn12 },
                    { type: vm.types.MerchantNumberType.key[13], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[13],vm.types.MerchantNumberType), number: mn13 },
                    { type: vm.types.MerchantNumberType.key[14], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[14],vm.types.MerchantNumberType), number: mn14 }
                ];

                /*todo: will remove after a code refactor*/

               /* vm.mNumberSecond = [
                    { type: vm.types.MerchantNumberType.key[6], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[6],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[6].number },
                    { type: vm.types.MerchantNumberType.key[7], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[7],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[7].number },
                    { type: vm.types.MerchantNumberType.key[8], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[8],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[8].number },
                    { type: vm.types.MerchantNumberType.key[9], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[9],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[9].number },
                    { type: vm.types.MerchantNumberType.key[10], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[10],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[10].number },
                    { type: vm.types.MerchantNumberType.key[11], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[11],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[11].number },
                    { type: vm.types.MerchantNumberType.key[12], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[12],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[12].number },
                    { type: vm.types.MerchantNumberType.key[13], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[13],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[13].number },
                    { type: vm.types.MerchantNumberType.key[14], name: vm.getValueFromTypeKey(vm.types.MerchantNumberType.key[14],vm.types.MerchantNumberType), number: vm.contractInfo.merchantNumbers[14].number }
                ];*/


            }
            var container,
                tableSettings,
                numberValidator;

            container = document.getElementById('merchant-number-second');
            container.innerHTML = ""
            tableSettings = {
                colHeaders: false,
                rowHeaders: false,
                columns: [
                    { data: 'name', readOnly: true },
                    {
                        data: 'number',
                        type: 'text',
                        allowEmpty: false,
                    },
                ],
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                afterValidate: function (isValid, value, row, prop, source) {
                    if (isValid) {
                        vm.blankNumber = false;
                    }
                    else {
                        vm.blankNumber = true;
                    }
                },
                colWidths: [450, 300],
                minSpareRows: 0,
                minSpareCols: 0
            };
            var options = Object.assign({ data: vm.mNumberSecond }, tableSettings);
            var hot = new Handsontable(container, options);
            hot.validateCells();
        }

        function reInitSecondTable() {

            var container,
                tableSettings,
                numberValidator;

            container = document.getElementById('merchant-number-second');
            container.innerHTML = ""
            tableSettings = {
                colHeaders: false,
                rowHeaders: false,
                columns: [
                    { data: 'name', readOnly: true },
                    {
                        data: 'number',
                        type: 'text',
                        allowEmpty: false,

                    },
                ],
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                afterValidate: function (isValid, value, row, prop, source) {
                    if (isValid) {
                        vm.blankNumber = false;
                    }
                    else {
                        vm.blankNumber = true;
                    }
                },
                colWidths: [450, 300],
                minSpareRows: 0,
                minSpareCols: 0
            };
            var options = Object.assign({ data: vm.mNumberSecond }, tableSettings);
            var hot = new Handsontable(container, options);
            hot.validateCells();
        }


        function cancelMerchantForm() {
            $state.reload();
        }

        function applyAllMerchantNumber() {
            if(baUtil.isUndefinedOrNullOrEmpty(vm.mNumberSecond[0].number) || vm.mNumberSecond[0].number.length !== 16){
                toastr.error(
                    vm.localTranslator("merchant.number.apply.all.error"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                return;
            }
            var str = vm.mNumberSecond[0].number;
            str = str.substring(0, str.length - 4);
            vm.mNumberSecond[1].number = str + '0009';
            vm.mNumberSecond[2].number = str + '0010';
            vm.mNumberSecond[3].number = str + '0011';
            vm.mNumberSecond[4].number = str + '0012';
            vm.mNumberSecond[5].number = str + '0013';
            vm.mNumberSecond[6].number = str + '0014';
            vm.mNumberSecond[7].number = str + '0015';
            vm.mNumberSecond[8].number = str + '0016';
            reInitSecondTable();

        }

        vm.handlingFeeSelectAllEmoney = true;
        angular.forEach(vm.paymentHandlingFeeDtos.E_MONEY, function (key) {
            if (key.createSettlement === false) {
                vm.handlingFeeSelectAllEmoney = false;
            }
        });

        vm.handlingFeeSelectAllQRmoney = true;
        angular.forEach(vm.paymentHandlingFeeDtos.QR_MONEY, function (key) {
            if (key.createSettlement === false) {
                vm.handlingFeeSelectAllQRmoney = false;
            }
        });

        function handlingFeeEmoneyForME_10SelectAll() {
            if (vm.handlingFeeME_10SelectAllEmoney){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_10.E_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_10.E_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeQRmoneyForME_10SelectAll() {
            if (vm.handlingFeeME_10SelectAllQRmoney){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_10.QR_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_10.QR_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        
        // ME_20_1
        function handlingFeeEmoneyForME_20_1SelectAll() {
            if (vm.handlingFeeME_20_1SelectAllEmoney){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeQRmoneyForME_20_1SelectAll() {
            if (vm.handlingFeeME_20_1SelectAllQRmoney){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeCreditCardForME_20_1SelectAll() {
            if (vm.handlingFeeME_20_1SelectAllCreditCard){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD,function (item){
                    item.createSettlement = false;
                })
            }
        }
        //End

        // ME_20_2
        function handlingFeeEmoneyForME_20_2SelectAll() {
            if (vm.handlingFeeME_20_2SelectAllEmoney){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeQRmoneyForME_20_2SelectAll() {
            if (vm.handlingFeeME_20_2SelectAllQRmoney){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeCreditCardForME_20_2SelectAll() {
            if (vm.handlingFeeME_20_2SelectAllCreditCard){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD,function (item){
                    item.createSettlement = false;
                })
            }
        }
        //End

        //ME_5_1 START
        function handlingFeeQRmoneyForME_5_1SelectAll() {
            if (vm.handlingFeeME_5_1SelectAllQRmoney){
                angular.forEach(vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        //END

        function submitMerchantForm() {

            if (vm.blankNumber === true) {
                toastr.error(
                    vm.localTranslator("merchant.number.empty.error"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                return;
            }

            vm.mNumber = vm.mNumberFirst.concat(vm.mNumberSecond);

            var scId = vm.contractInfo.serviceContractId;
            ServiceContractService.merchantNumberRegistration(vm.mNumber, scId).then(function success(response) {
                        $state.reload();
                        toastr.success(
                            vm.localTranslator("common.components.msg.success"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        )
                        vm.isEdit = false;
                    }, function err(err) {
                        vm.submitBtn = false;
                        vm.enableButton();
                        toastr.error(
                            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                            vm.localTranslator("common.components.title.error"),
                            baUtil.toastOptions()
                        )
                });
        }

        function getIndexInPaymentDeductionOption(key, list) {
            return list.findIndex(function (item) {
                return item === key
            })
        }
        vm.selfDO = []
        for (var i=0; i < vm.contractInfo.deviceOwnerDtos.length; i++) {
            if (vm.contractInfo.deviceOwnerDtos[i].deviceOwnerCode == vm.contractInfo.organisationDto.deviceOwnerCode) {
                vm.selfDO[i] = true;
            }
            else {
                vm.selfDO[i] = false;
            }
        }
        

        function getLang() {
            return $translate.use();
        }
        function getDeviceOwner(query) {
            return ServiceContractService.getDeviceOwner(query)
        }

        function getPartner(query) {
            return ServiceContractService.getPartner(query)
        }

        function getType(str) {
            return str.replace(/_/g, '-');
        }

        function onOrgSelected(data, index) {
            var ignoreComparison = false;
            var newData = {
                "code":data.deviceOwnerCode,
                "deviceOrgName":data.name,
                "organisationId":data.organisationId
            }
            for(i=0; i <= index; i++) {
                if(vm.deviceOwnerDto[index].code === newData.code) {
                    var ignoreComparison = true;
                }
            }
            var filteredData = $filter('filter')(vm.deviceOwnerDto, newData);
            if(filteredData.length && !ignoreComparison) {
                vm.newContractForm['deviceOwner_' + index].$setViewValue("");
                toastr.error(
                    vm.localTranslator("service.contract.create.deviceOwner.warning.msg"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                return;
            }
            vm.deviceOwnerDto[index].code = data.deviceOwnerCode;
            vm.deviceOwnerDto[index].deviceOrgName = data.name;
            vm.deviceOwnerDto[index].organisationId = data.organisationId;
        }

        function onPartnerSelected(data, index) {
            var ignoreComparison = false;
            for(i=0; i <= index; i++) {
                if(vm.contractDetails.partnerDtos[index].partnerCode === data.partnerCode) {
                    var ignoreComparison = true;
                }
            }

            var filteredData = $filter('filter')(vm.contractInfo.partnerDtos, data);
            if(filteredData.length && !ignoreComparison) {
                vm.newContractForm['partnerSummaries_' + index].$setViewValue("");
                toastr.error(
                    vm.localTranslator("partner.warning.msg"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                return;
            }

            vm.contractInfo.partnerDtos[index].name = data.name;
            vm.contractInfo.partnerDtos[index].partnerCode = data.partnerCode;
            vm.contractInfo.partnerDtos[index].organisationId = data.organisationId;
        }

        function bankCodeChange(bankCode) {
            return ServiceContractService.getDataFromBankCode(bankCode)
        }

        function onBankSelected(data, index) {
            vm.bankData = data
            vm.contractInfo.settlementBranchDtos[index].settlementBankDto.bankName = data.bankName
        }

        function bankBranchCodeChange(branchCode) {
            return ServiceContractService.getDataFromBankBranchCode(vm.bankData.bankCode, branchCode)
        }

        function onBankBranchSelected(data, index) {
            vm.bankBranchData = data
            vm.contractInfo.settlementBranchDtos[index].settlementBankDto.branchName = data.branchName
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }


        vm.accountOrgId = vm.contractInfo.organisationDto.accountDtos[0].organisation.organisationId;

        function addNewRow(list, type) {
            if (baUtil.isUndefinedOrNull(list)) {
                return
            }

            if (type === 'ADD_SETTLEMENT' && vm.contractInfo.settlementMethodDto.paymentMethod === 'OFFSETTING') {
                list.push({
                    "settlementSendLocationDtos": [{
                        "addressDto": {
                            "contactDtos": [{}]
                        },
                        "branchLocationType": "OFFSET_NOTIFICATION"
                    }]
                })
                return
            }
            if (type === 'ADD_SETTLEMENT' && vm.contractInfo.settlementMethodDto.paymentMethod === 'NON_OFFSETTING') {
                list.push({
                    "settlementSendLocationDtos": [{
                        "addressDto": {
                            "contactDtos": [{}]
                        },
                        "branchLocationType": "INVOICE_DESTINATION"
                    },
                    {
                        "addressDto": {
                            "contactDtos": [{}]
                        },
                        "branchLocationType": "CREDIT_NOTIFICATION"
                    }],

                })
                return
            }
            if (type === 'CREATE_ORGANISATION') {
                list.push({
                    "contactDtos": [{}],
                    "orgainsation": {
                        "organisationId": vm.accountOrgId
                    },

                    "serviceContractId": [vm.contractInfo.serviceContractId]


                })
                return
            }
            if (type === 'REPRESENTATIVE') {
                list.push({
                    "addressDtos": [{
                        "contactDtos": [{}]
                    }]
                })
                return
            }
            if (type === 'SETTLEMENT_LOCATION') {
                list.push({
                    "addressDto": {
                        "contactDtos": [{}]
                    }
                })
                return
            }
            list.push({})
        }

        function removeRow(list, index) {
            list.splice(index, 1);
        }

        function removePartner(list, index) {
            list.splice(index, 1);
            if (vm.contractInfo.partnerDtos.length === 0) {
                vm.contractInfo.partnerDtos = [{}];
            }
        }

        function removeDeviceOwnerRow(list, index) {
            var serviceContractId = vm.contractInfo.serviceContractId;
            var orgId = list[index].organisationId;

            ServiceContractService.deleteDeviceOwner(serviceContractId, orgId).then(function (response) {

                if (response.data.data.status == true) {
                    list.splice(index, 1);
                }

                else {
                    toastr.error(vm.localTranslator("common.components.msg.error.in.device.owner"), vm.localTranslator("common.components.title.error"), baUtil.toastOptions())
                }

            });

        }

        function isRepresentativeRequired(type) {
            return type === 'INDIVIDUAL'
        }

        function enableButton () {
            $timeout(function() {
                vm.btnClick = false;
            }, 1000);
        }

        function disableButton () {
            vm.btnClick = true;
            $timeout(function() {
                vm.btnClick = false;
            }, 2000);
        }

        function editDetail() {
            vm.isEdit = true;
            vm.contractInfoCopy = angular.copy(vm.contractInfo);
            vm.paymentHandlingFeeDtosCopy = angular.copy(vm.paymentHandlingFeeDtos);
            vm.serviceFeeDtosCopy = angular.copy(vm.serviceFeeDtos);
            vm.deviceOwnerDtoCopy = angular.copy(vm.deviceOwnerDto);
        }

        function cancelEdit() {
            vm.isEdit = false;
            vm.contractInfo = vm.contractInfoCopy;
            vm.paymentHandlingFeeDtos = vm.paymentHandlingFeeDtosCopy;
            vm.serviceFeeDtos = vm.serviceFeeDtosCopy;
            vm.deviceOwnerDto = vm.deviceOwnerDtoCopy;
            $state.reload();
        }
        function downloadMaronExcel() {
            vm.isDownloadingMaronExcel = true;
            var serviceContractId = vm.contractInfo.serviceContractId;
            ServiceContractService
                .downloadMaronExcel(serviceContractId)
                .then(function(resp) {
                    vm.isDownloadingMaronExcel = false;
                    var headers = resp.headers();
                    var filename = headers["content-disposition"];
                    filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                    var serverData = new Blob([resp.data], {type: headers['content-type']});
                    FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
                },function(err) {
                    vm.isDownloadingMaronExcel = false;
                    if ("TextDecoder" in window) {
                        try {
                            var enc = new TextDecoder("utf-8");
                            var data = enc.decode(err.data);
                            err = JSON.parse(data);
                        } catch(ignore){ }
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });

        }



        function uploadJescaMaroonCsv(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name.toLowerCase(), [".csv"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.uploadingJescaMaroonCsv = true;

                ServiceContractService
                .uploadJescaMaroonRequest(file)
                .then(function (response) {
                    vm.newDeviceInProgress = false;
                    $state.go('main.serviceContract.jescamaroon', { maroonData: response, serviceContractId : vm.contractInfo.serviceContractId });
                    }, function err(err) {
                    ev.target.value = "";
                    vm.uploadingJescaCsv = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }

        function saveDetail() {
            vm.submitBtn = true;

            var form = angular.copy(vm.newContractForm);
            var contractInfo = angular.copy(vm.contractInfo);

            if (form.$invalid) {

                $location.hash('top');
                $anchorScroll();

                vm.error = [];
                vm.detailErrors = true;

                for (var key in form.$error) {
                    for (var index = 0; index < form.$error[key].length; index++) {
                        vm.error.push(form.$error[key][index].$name);
                    }
                }

                for (var i = 0; i < vm.error.length; i++) {

                    var oo1 = new RegExp(/_([0-9]|[1-9][0-9])$/);
                    var oo2 = new RegExp(/_([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])$/);
                    var oo3 = new RegExp(/([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])$/);


                    vm.error[i] = vm.error[i].replace(oo1, '_0');
                    vm.error[i] = vm.error[i].replace(oo2, '_0_0');
                    vm.error[i] = vm.error[i].replace(oo3, '0_0_0');
                }



                var unique = {};
                vm.errors = []
                vm.alerts = []
                angular.forEach(vm.error, function (item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });

                vm.poko = {
                    'applicationDate': {
                        'key': 'applicationDate',
                        'en': 'Contract - Application Date',
                        'jp': 'e-MOSS Plus申込書 - 申込年月日'
                    },
                    'applicantNameReading': {
                        'key': 'applicantNameReading',
                        'en': 'Company Information - Name',
                        'jp': '企業情報 - 会社名'
                    },
                    'applicantName': {
                        'key': 'applicantName',
                        'en': 'Company Information - Name (Kana)',
                        'jp': '企業情報 - 会社名 (フリガナ)'
                    },
                    'applicantCompanyCode': {
                        'key': 'applicantCompanyCode',
                        'en': 'Company Information - Company Code',
                        'jp': '企業情報 - 法人コード'
                    },
                    'businessType': {
                        'key': 'businessType',
                        'en': 'Company Information - Business Type',
                        'jp': '企業情報 - 業種業務区分'
                    },
                    'applicantProductHandled': {
                        'key': 'applicantProductHandled',
                        'en': 'Company Information - Products Handled',
                        'jp': '企業情報 - 取扱商品'
                    },
                    'contractTerms': {
                        'key': 'contractTerms',
                        'en': 'e-MOSS Plus Terms & Condition',
                        'jp': '「e-MOSS Plus加盟店規約」'
                    },
                    'companyRepresentativeNameReading_0': {
                        'key': 'companyRepresentativeNameReading_0',
                        'en': 'Company Representative Information - Name (Kana)',
                        'jp': '代表者様情報 - 氏名(フリガナ)'
                    },
                    'companyRepresentativeName_0': {
                        'key': 'companyRepresentativeName_0',
                        'en': 'Company Representative Information - Name',
                        'jp': '代表者様情報 - 氏名'
                    },
                    'representativedob':{
                        'key':'representativedob',
                        'en':'Company Representative - Date of Birth',
                        'jp':'代表者様情報 - 生年月日'

                    },
                    'companyInChargePerson_0': {
                        'key': 'companyInChargePerson_0',
                        'en': 'In-Charge Person - Name',
                        'jp': '担当者情報 - 氏名'
                    },
                    'companyInChargePersonReading_0':{
                        'key':'companyInChargePersonReading_0',
                        'en':'In-Charge Person - Name (Kana)',
                        'jp':'担当者情報 - 氏名 (フリガナ)'

                    },
                    'companyUsername_0': {
                        'key': 'companyUsername_0',
                        'en': 'In-Charge Person - Email',
                        'jp': '担当者情報 - メールアドレス'
                    },
                    'MerchantOwnerType': {
                        'key': 'MerchantOwnerType',
                        'en': 'Link Device Owners - Device Purchase',
                        'jp': '端末借用元情報 - 端末購入'
                    },
                    'deviceOwner_0': {
                        'key': 'deviceOwner_0',
                        'en': 'Device Owner Organisation Name',
                        'jp': '端末借用元情報 - 端末所有者の会社名'
                    },
                    'settlementDate': {
                        'key': 'settlementDate',
                        'en': 'Settlement Conditions - Payment Date',
                        'jp': 'ご精算条件 - 支払日'
                    },
                    'closingDate': {
                        'key': 'closingDate',
                        'en': 'Settlement Conditions - Closing Date',
                        'jp': 'ご精算条件 - 決済端末締め日'
                    },
                    'paymentMethod': {
                        'key': 'paymentMethod',
                        'en': 'Settlement Conditions - Payment Method',
                        'jp': 'ご精算条件 - 諸費用 (B) (C)のお支払い方法'
                    },
                    'invoiceMethod': {
                        'key': 'invoiceMethod',
                        'en': 'Settlement Conditions - Settlement Destination',
                        'jp': 'ご精算条件 - 精算先'
                    },
                    'chargeMonthlyFeeFrom': {
                        'key': 'chargeMonthlyFeeFrom',
                        'en': 'Charge Monthly Fee From',
                        'jp': '月額費用の課金開始タイミング'
                    },
                    'builtIn_deviceType': {
                        'key': 'builtIn_deviceType',
                        'en': 'Service Fee - Built-in Modem Type - Applicable Device types',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 端末機種'
                    },
                    'external_deviceType': {
                        'key': 'external_deviceType',
                        'en': 'Service Fee - External Modem Type - Applicable Device types',
                        'jp': 'サービス費用 - 外部モデムタイプ - 端末機種'
                    },
                    'e_money_rateOrAmount_builtIn_deviceType_0': {
                        'key': 'e_money_rateOrAmount_builtIn_deviceType_0',
                        'en': 'Service Fee - Built-in Modem Type - Initial Charges - E Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 初期費用 - 電子マネー数'
                    },
                    'e_money_rangeEnd_builtIn_deviceType_0': {
                        'key': 'e_money_rangeEnd_builtIn_deviceType_0',
                        'en': 'Service Fee - Built-in Modem Type - Initial Charges - E Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 初期費用 - 電子マネー数'
                    },
                    'qr_money_rateOrAmount_builtIn_deviceType_0': {
                        'key': 'qr_money_rateOrAmount_builtIn_deviceType_0',
                        'en': 'Service Fee - Built-in Modem Type - Initial Charges - QR Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 初期費用 - QRマネー数'
                    },
                    'qr_money_rangeEnd_builtIn_deviceType_0': {
                        'key': 'qr_money_rangeEnd_builtIn_deviceType_0',
                        'en': 'Service Fee - Built-in Modem Type - Initial Charges - QR Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 初期費用 - QRマネー数'
                    },
                    'e_money_rateOrAmount_builtIn_monthly_0': {
                        'key': 'e_money_rateOrAmount_builtIn_monthly_0',
                        'en': 'Service Fee - Built-in Modem Type - Monthly Charges - E Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 月額費用 - 電子マネー数'
                    },
                    'e_money_rangeEnd_builtIn_monthly_0': {
                        'key': 'e_money_rangeEnd_builtIn_monthly_0',
                        'en': 'Service Fee - Built-in Modem Type - Monthly Charges - E Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 月額費用 - 電子マネー数'
                    },
                    'qr_money_rateOrAmount_builtIn_monthly_0': {
                        'key': 'qr_money_rateOrAmount_builtIn_monthly_0',
                        'en': 'Service Fee - Built-in Modem Type - Monthly Charges - QR Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 月額費用 - QRマネー数'
                    },
                    'qr_money_rangeEnd_builtIn_monthly_0': {
                        'key': 'qr_money_rangeEnd_builtIn_monthly_0',
                        'en': 'Service Fee - Built-in Modem Type - Monthly Charges - QR Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 月額費用 - QRマネー数'
                    },
                    'e_money_rateOrAmount_external_initial_0': {
                        'key': 'e_money_rateOrAmount_external_initial_0',
                        'en': 'Service Fee - External Modem Type - Initial Charges - E Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 初期費用 - 電子マネー数'
                    },
                    'e_money_rangeEnd_external_initial_0': {
                        'key': 'e_money_rangeEnd_external_initial_0',
                        'en': 'Service Fee - External Modem Type - Initial Charges - E Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 初期費用 - 電子マネー数'
                    },
                    'qr_money_rateOrAmount_external_initial_0': {
                        'key': 'qr_money_rateOrAmount_external_initial_0',
                        'en': 'Service Fee - External Modem Type - Initial Charges - QR Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 初期費用 - QRマネー数'
                    },
                    'qr_money_rangeEnd_external_initial_0': {
                        'key': 'qr_money_rangeEnd_external_initial_0',
                        'en': 'Service Fee - External Modem Type - Initial Charges - QR Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 初期費用 - QRマネー数'
                    },
                    'e_money_rateOrAmount_external_monthly_0': {
                        'key': 'e_money_rateOrAmount_external_monthly_0',
                        'en': 'Service Fee - External Modem Type - Monthly Charges - E Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 月額費用 - 電子マネー数'
                    },
                    'e_money_rangeEnd_external_monthly_0': {
                        'key': 'e_money_rangeEnd_external_monthly_0',
                        'en': 'Service Fee - External Modem Type - Monthly Charges - E Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 月額費用 - 電子マネー数'
                    },
                    'qr_money_rateOrAmount_external_monthly_0': {
                        'key': 'qr_money_rateOrAmount_external_monthly_0',
                        'en': 'Service Fee - External Modem Type - Monthly Charges - QR Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 月額費用 - QRマネー数'
                    },
                    'qr_money_rangeEnd_external_monthly_0': {
                        'key': 'qr_money_rangeEnd_external_monthly_0',
                        'en': 'Service Fee - External Modem Type - Monthly Charges - QR Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 月額費用 - QRマネー数'
                    },
                    'settlementBankCode_0': {
                        'key': 'settlementBankCode_0',
                        'en': 'Bank - FI Code',
                        'jp': 'お振込口座 - 金融機関コード'
                    },
                    'settlementBranchCode_0': {
                        'key': 'settlementBranchCode_0',
                        'en': 'Bank = Branch Code',
                        'jp': 'お振込口座 - 支店コード'
                    },
                    'accountNo_0': {
                        'key': 'accountNo_0',
                        'en': 'Bank - Account No',
                        'jp': 'お振込口座 - 口座番号'
                    },
                    'bankName_0': {
                        'key': 'bankName_0',
                        'en': 'Bank - Name',
                        'jp': 'お振込口座 - 金融機関名'
                    },
                    'branchName_0': {
                        'key': 'branchName_0',
                        'en': 'Bank - Branch/Office Name',
                        'jp': 'お振込口座 - 支店名'
                    },
                    'branchType_0': {
                        'key': 'branchType_0',
                        'en': 'Bank - Branch/Office Name',
                        'jp': 'お振込口座 - 支店名'
                    },
                    'bankType_0': {
                        'key': 'bankType_0',
                        'en': 'Bank - Type',
                        'jp': 'お振込口座 - 金融機関'
                    },
                    'bankAccountType_0': {
                        'key': 'bankAccountType_0',
                        'en': 'Bank - Type of Account',
                        'jp': 'お振込口座 - 普通/当座'
                    },
                    'bankAccountNameReading_0': {
                        'key': 'bankAccountNameReading_0',
                        'en': 'Bank - Account Holder Name (Kana)',
                        'jp': 'お振込口座 - 口座名義(フリガナ)'
                    },
                    'bankAccountName_0': {
                        'key': 'bankAccountName_0',
                        'en': 'Bank - Account Holder Name',
                        'jp': 'お振込口座 - 口座名義'
                    },
                    'inChargeNameReading_0_0': {
                        'key': 'inChargeNameReading_0_0',
                        'en': 'Invoice Destination - In Charge Name  (Kana)',
                        'jp': '請求書送付先 - 会社名(フリガナ)'
                    },
                    'inChargeNameReading_cr_0_0': {
                        'key': 'inChargeNameReading_cr_0_0',
                        'en': 'Credit Notification - In Charge Name  (Kana)',
                        'jp': '入金通知書送付先 - 会社名(フリガナ)'
                    },
                    'inChargeName_0_0': {
                        'key': 'inChargeName_0_0',
                        'en': 'Invoice Destination - In Charge Name',
                        'jp': '請求書送付先 - 会社名'
                    },
                    'inChargeName_cr_0_0': {
                        'key': 'inChargeName_cr_0_0',
                        'en': 'Credit Notification - In Charge Name',
                        'jp': '入金通知書送付先 - 会社名'
                    },
                    'addressPin_settlement_address_0_0': {
                        'key': 'addressPin_settlement_address_0_0',
                        'en': 'Invoice Destination - Zip Code',
                        'jp': '請求書送付先 - 〒'
                    },
                    'streetAddress_settlement_address_0_0': {
                        'key': 'streetAddress_settlement_address_0_0',
                        'en': 'Invoice Destination - Street Address',
                        'jp': '請求書送付先 - 番地'
                    },
                    'streetAddressKana_settlement_address_0_0': {
                        'key': 'streetAddressKana_settlement_address_0_0',
                        'en': 'Invoice Destination - Street Address(Kana)',
                        'jp': '請求書送付先 - 番地(フリガナ)'
                    },
                    'addressPin_settlement_address_cr_0_0': {
                        'key': 'addressPin_settlement_address_cr_0_0',
                        'en': 'Credit Notification - Zip Code',
                        'jp': '入金通知書送付先 - 〒'
                    },
                    'streetAddress_settlement_address_cr_0_0': {
                        'key': 'streetAddress_settlement_address_cr_0_0',
                        'en': 'Credit Notification - Street Address',
                        'jp': '入金通知書送付先 - 番地'
                    },
                    'streetAddressKana_settlement_address_cr_0_0': {
                        'key': 'streetAddressKana_settlement_address_cr_0_0',
                        'en': 'Credit Notification - Street Address(Kana)',
                        'jp': '入金通知書送付先 - 番地(フリガナ)'
                    },
                    'addressPin_organisation_address': {
                        'key': 'addressPin_organisation_address',
                        'en': 'Company Contact - Zip Code',
                        'jp': '企業連絡先 - 〒'
                    },
                    'streetAddress_organisation_address': {
                        'key': 'streetAddress_organisation_address',
                        'en': 'Company Contact - Street Address',
                        'jp': '企業連絡先 - 番地'
                    },
                    'streetAddressKana_organisation_address': {
                        'key': 'streetAddressKana_organisation_address',
                        'en': 'Company Contact - Street Address(Kana)',
                        'jp': '企業連絡先 - 番地(フリガナ)'
                    },
                    'contactNumber_organisation_account_contact_0_0': {
                        'key': 'contactNumber_organisation_account_contact_0_0',
                        'en': 'Company In Charge - Contact',
                        'jp': '担当者情報 - ご連絡先'
                    },
                    'contactNumber_settlement_contact0_0_0': {
                        'key': 'contactNumber_settlement_contact0_0_0',
                        'en': 'Invoice Destination - Contact',
                        'jp': '請求書送付先 - ご連絡先'
                    },
                    'contactNumber_settlement_contact_cr0_0_0': {
                        'key': 'contactNumber_settlement_contact_cr0_0_0',
                        'en': 'Credit Notification - Contact',
                        'jp': '入金通知書送付先 - ご連絡先'
                    },
                    'contactNumber_organisation_contact_0': {
                        'key': 'contactNumber_organisation_contact_0',
                        'en': 'Company\'s Contact - Contact',
                        'jp': '企業連絡先 - ご連絡先'
                    },
                    'inchargeDepartment_0': {
                        'key': 'inchargeDepartment_0',
                        'en': 'In-Charge - Department Name',
                        'jp': '担当者情報 - 担当部署名'
                    },
                    'branchName_0_0': {
                        'key': 'branchName_0_0',
                        'en': 'Invoice Destination - Branch Name',
                        'jp': '請求書送付先 - 支店営業所名'
                    },
                    'centerCode_0_0': {
                        'key': 'centerCode_0_0',
                        'en': 'Invoice Destination - Branch/Center Code',
                        'jp': '請求書送付先 - 支店営業所コード'
                    },
                    'branchName_cr_0_0': {
                        'key': 'branchName_cr_0_0',
                        'en': 'Credit Notification - Branch Name',
                        'jp': '入金通知書送付先 - 支店営業所名'
                    },
                    'centerCode_cr_0_0': {
                        'key': 'centerCode_cr_0_0',
                        'en': 'Credit Notification - Branch/Center Code',
                        'jp': '入金通知書送付先 - 支店営業所コード'
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_10_E_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_10_E_MONEY_value',
                              en:'Payment Handling Fee - ME-10 - E-Money - ' + vm.types.PaymentHandlingOption.E_MONEY.en[i],
                              jp:'決済手数料 - ME-10 - 電子マネ - ' + vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                          };
                         
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_20_1_E_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_20_1_E_MONEY_value',
                              en:'Payment Handling Fee - ME-20-1 - E-Money - ' + vm.types.PaymentHandlingOption.E_MONEY.en[i],
                              jp:'決済手数料 - ME-20-1 - 電子マネ - ' + vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                          };
                         
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_5_1_E_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_5_1_E_MONEY_value',
                              en:'Payment Handling Fee - ME-5-1 - E-Money - ' + vm.types.PaymentHandlingOption.E_MONEY.en[i],
                              jp:'決済手数料 - ME-5-1 - 電子マネ - ' + vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                          };
                         
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_20_2_E_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_20_2_E_MONEY_value',
                              en:'Payment Handling Fee - ME-20-2 - E-Money - ' + vm.types.PaymentHandlingOption.E_MONEY.en[i],
                              jp:'決済手数料 - ME-20-2 - 電子マネ - ' + vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                          };
                         
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_10_QR_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_10_QR_MONEY_value',
                              en:'Payment Handling Fee - ME-10 - QR Money - ' + vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                              jp:'決済手数料 - ME-10 - QRマネ - ' + vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_20_1_QR_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_20_1_QR_MONEY_value',
                              en:'Payment Handling Fee - ME-20-1 - QR Money - ' + vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                              jp:'決済手数料 - ME-20-1 - QRマネ - ' + vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_20_2_QR_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_20_2_QR_MONEY_value',
                              en:'Payment Handling Fee - ME-20-2 - QR Money - ' + vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                              jp:'決済手数料 - ME-20-2 - QRマネ - ' + vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_5_1_QR_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_5_1_QR_MONEY_value',
                              en:'Payment Handling Fee - ME-5-1 - QR Money - ' + vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                              jp:'決済手数料 - ME-5-1 - QRマネ - ' + vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_20_1_CREDIT_CARD_value'] = {
                              key:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_20_1_CREDIT_CARD_value',
                              en:'Payment Handling Fee - ME-20-1 - Credit Card - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.en[i],
                              jp:'決済手数料 - ME-20-1 - Creditマネ - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_20_2_CREDIT_CARD_value'] = {
                              key:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_20_2_CREDIT_CARD_value',
                              en:'Payment Handling Fee - ME-20-2 - Credit Card - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.en[i],
                              jp:'決済手数料 - ME-20-2 - QRマネ - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_5_1_CREDIT_CARD_value'] = {
                              key:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_5_1_CREDIT_CARD_value',
                              en:'Payment Handling Fee - ME-5-1 - Credit Card - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.en[i],
                              jp:'決済手数料 - ME-5-1 - Creditマネ - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i],
                          };
                    }
                }

                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })
                }

                vm.submitBtn = false;
                vm.enableButton();
                vm.errorNumbers = vm.alerts.length;
                return;
            }
            else {
                vm.detailErrors = false;
            }
            if (!angular.isNumber(contractInfo.date)) {
                contractInfo.date = contractInfo.date.getTime();
            }

            var on = contractInfo.organisationDto.accountDtos.length;
            for (var i = 1; i <= (on - 1); i++) {
                /*    list.push({
                        "contactCreateDtos": [{}]
                    })*/
                contractInfo.organisationDto.accountDtos[i].organisationBranchId = contractInfo.organisationDto.accountDtos[0].organisationBranchId;
            }
            var repDob = contractInfo.organisationDto.organisationRepresentativeDtos[0].dateOfBirth;
            if (!baUtil.isUndefinedOrNull(repDob)) {
                vm.contractInfoCopyCopy = angular.copy(contractInfo);
                var n = vm.contractInfoCopyCopy.organisationDto.organisationRepresentativeDtos.length;
                for (var i = 0; i <= (n - 1); i++) {
                    if (!angular.isNumber(vm.contractInfoCopyCopy.organisationDto.organisationRepresentativeDtos[i].dateOfBirth)) {
                        var repLongDOB = vm.contractInfoCopyCopy.organisationDto.organisationRepresentativeDtos[i].dateOfBirth.getTime();
                        vm.contractInfoCopyCopy.organisationDto.organisationRepresentativeDtos[i].dateOfBirth = repLongDOB;
                    }
                }

                contractInfo = angular.copy(vm.contractInfoCopyCopy);

            }

            var data = contractInfo;

            var paymentHandlingFeeDtos = [];
            var serviceFeeDtos = [];

            Object.keys(vm.paymentHandlingFeeDtos).forEach(function (item) {
                var obj = vm.paymentHandlingFeeDtos[item];

                Object.keys(obj).forEach(function (key) {
                    var valueList = obj[key];
                    Object.keys(valueList).forEach(function (value) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(valueList[value].rateOrAmount)) {
                            paymentHandlingFeeDtos.push(valueList[value])
                        }
                    })
                })
            })

            Object.keys(vm.serviceFeeDtos).forEach(function (item) {
                var obj = vm.serviceFeeDtos[item];
                Object.keys(obj).forEach(function (key) {
                    var valueList = obj[key];
                    valueList.forEach(function (value) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(value.rateOrAmount)) {
                            serviceFeeDtos.push(value)
                        }
                        if (value.modemType === "BUILT_IN" && value.deviceTypes !== vm.builtIn_deviceType ) {
                            value.deviceTypes = vm.builtIn_deviceType
                        }

                        if (value.modemType === "EXTERNAL" && value.deviceTypes !== vm.external_deviceType) {
                            value.deviceTypes = vm.external_deviceType
                        }
                        if (value.modemType === "BUILT_IN_20" && value.deviceTypes !== vm.builtIn20_deviceType ) {
                            value.deviceTypes = vm.builtIn20_deviceType
                        }

                        if (value.modemType === "EXTERNAL_20" && value.deviceTypes !== vm.external20_deviceType) {
                            value.deviceTypes = vm.external20_deviceType
                        }

                        if (value.modemType === "BUILT_IN_5" && value.deviceTypes !== vm.builtIn5_deviceType ) {
                            value.deviceTypes = vm.builtIn5_deviceType
                        }
                    })


                })
            })

            //this is required to get edited data
            contractInfo.deviceOwnerDtos = vm.deviceOwnerDto.map(function (item) {
                return {
                    deviceOwnerCode: item.code,
                    name: item.deviceOrgName,
                    organisationId: item.organisationId,
                }
            })

            vm.otherServiceFeeDtos.builtIn_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.otherServiceFeeDtos.builtIn_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.otherServiceFeeDtos.external_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.otherServiceFeeDtos.external_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.otherServiceFeeDtos.builtIn20_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.otherServiceFeeDtos.builtIn20_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.otherServiceFeeDtos.external20_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.otherServiceFeeDtos.external20_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.otherServiceFeeDtos.builtIn5_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];
            vm.otherServiceFeeDtos.builtIn5_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];

            vm.qrOtherServiceFeeDtos.builtIn_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.qrOtherServiceFeeDtos.external_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.qrOtherServiceFeeDtos.external_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn20_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn20_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.qrOtherServiceFeeDtos.external20_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.qrOtherServiceFeeDtos.external20_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn5_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn5_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];

            vm.baseServiceFeeDtos.builtIn_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.baseServiceFeeDtos.builtIn_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.baseServiceFeeDtos.external_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.baseServiceFeeDtos.external_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.baseServiceFeeDtos.builtIn20_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.baseServiceFeeDtos.builtIn20_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.baseServiceFeeDtos.external20_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.baseServiceFeeDtos.external20_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.baseServiceFeeDtos.builtIn5_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];
            vm.baseServiceFeeDtos.builtIn5_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];

            vm.serviceFeeDtosCreditCard.builtIn_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.serviceFeeDtosCreditCard.external_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.serviceFeeDtosCreditCard.external_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn20_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn20_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.serviceFeeDtosCreditCard.external20_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.serviceFeeDtosCreditCard.external20_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn5_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn5_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];

            serviceFeeDtos.push(vm.otherServiceFeeDtos.builtIn_initial);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.builtIn_monthly);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.external_initial);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.external_monthly);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.builtIn20_initial);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.builtIn20_monthly);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.external20_initial);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.external20_monthly);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.builtIn5_initial);
            serviceFeeDtos.push(vm.otherServiceFeeDtos.builtIn5_monthly);

            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.builtIn_initial);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.builtIn_monthly);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.external_initial);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.external_monthly);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.builtIn20_initial);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.builtIn20_monthly);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.external20_initial);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.external20_monthly);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.builtIn5_initial);
            serviceFeeDtos.push(vm.qrOtherServiceFeeDtos.builtIn5_monthly);

            serviceFeeDtos.push(vm.baseServiceFeeDtos.builtIn_initial);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.builtIn_monthly);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.external_initial);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.external_monthly);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.builtIn20_initial);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.builtIn20_monthly);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.external20_initial);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.external20_monthly);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.builtIn5_initial);
            serviceFeeDtos.push(vm.baseServiceFeeDtos.builtIn5_monthly);

            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.builtIn_initial);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.builtIn_monthly);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.external_initial);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.external_monthly);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.builtIn20_initial);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.builtIn20_monthly);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.external20_initial);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.external20_monthly);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.builtIn5_initial);
            serviceFeeDtos.push(vm.serviceFeeDtosCreditCard.builtIn5_monthly);

            data.paymentHandlingFeeDtos = paymentHandlingFeeDtos
            data.serviceFeeDtos = serviceFeeDtos;

            baUtil.showConfirm("", vm.localTranslator("merchant.number.update.confirm"), vm.localTranslator("common.components.msg.continue"))
                .then(function () {
                    vm.recordsUpdating = true;
                    ServiceContractService.saveDetail(data).then(function success(response) {
                        toastr.success(
                            vm.localTranslator("common.components.msg.success"),
                            vm.localTranslator("common.components.title.success"),
                            baUtil.toastOptions()
                        );
                        $state.reload();
                        vm.isEdit = false;
                    }, function err(err) {
                        toastr.error(
                            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                            vm.localTranslator("common.components.title.error"),
                            baUtil.toastOptions()
                        )
                        vm.submitBtn = false;
                        vm.enableButton();
                        vm.recordsUpdating = false;
                    });
            })
            .catch(function(){
                vm.submitBtn = false;
                vm.enableButton();
                return;
            });
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('JescaMaroonCtrl', JescaMaroonCtrl);

    /** @ngInject */
    function JescaMaroonCtrl(ServiceContractService, $filter, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, AuthService, $uibModal, hotUtil,  FileSaver, types) {

        if( $stateParams.maroonData == null ) {
            $state.go("main.serviceContract.list");
        }

        var vm = this;
        vm.deviceRequest = [];
        vm.getInputType = getInputType;
        vm.create = create;
        vm.applyMaroon = applyMaroon;
        vm.cancelCreate = cancelCreate;
        vm.permissions = AuthService.getPermissions();
        vm.localTranslator = $filter('translate');
        vm.isSystemUser = vm.permissions.DEVICE_REQUEST.MGMNT_READ;
        vm.getDeviceStatusFromKey = getDeviceStatusFromKey;
        vm.getInstallationStatusIndex = getInstallationStatusIndex;
        vm.isDIStateTransitionValid = isDIStateTransitionValid;
        vm.getLang = getLang;
        vm.modal = null;
        vm.errors = {};
        vm.alerts = [];
        // vm.keyMap = [];
        vm.isFormValid = isFormValid;
        vm.getErrMessage = getErrMessage;
        vm.getErrMessageOfStatus = getErrMessageOfStatus;
        vm.getErrMessageDO = getErrMessageDO;
        vm.hotTable = null;
        vm.disableActionButtons = true;
        vm.downloadDeviceRequestExcel = downloadDeviceRequestExcel;
        vm.downloadJescaCsv = downloadJescaCsv;
        vm.downloadJescaCsvResult = downloadJescaCsvResult;
        vm.jescaActivationCsvDownload = jescaActivationCsvDownload;
        vm.uploadJescaCsv = uploadJescaCsv;
        vm.isMerchantAdmin = baUtil.isMerchantAdmin();
        vm.isDeviceOwnerAdmin = baUtil.isDeviceOwnerAdmin();

        // map of {SCId: isUserDeviceOwnerOfSC} to disallow edit of device owner by another device owner
        vm.isUserDeviceOwnerOfSC = {};

        vm.canEditInStatus = vm.isSystemUser ?
                                [ "DRAFT", "REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INVENTORY" ] :
                                [ "DRAFT" ];
        vm.merchantAdminCanEditInStatus = ["REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INSTALLED", "RUNNING", "INVENTORY"];

        vm.deviceOwnerCanEditInStatus = ["REGISTERED", "ACCEPTED", "UNDER_FULFILMENT", "COMPLETED", "INSTALLED", "RUNNING", "INVENTORY"];

        vm.canPartiallyEditInStatus = vm.isSystemUser ? [ "INSTALLED", "RUNNING", "PROCESSING_SUSPENSION", "SUSPENDED" ] : [ ];
        vm.readOnlyFieldsInPartiallyEditStatus = [ "status", "branchName", "branchCode" ];
        vm.editableFieldsWhenMerchantAdmin = [ "branchDepartment", "branchDesignation", "branchPersonInCharge", "branchPersonInChargePhone",  "branchPersonInChargeEmail", "vendingMachineModel", "remarks1", "remarks2", "remarks3", "remarks4", "remarks5" ];
        vm.editableFieldsWhenDeviceOwner = [  "branchDepartment", "branchDesignation", "branchPersonInCharge", "branchPersonInChargePhone",  "branchPersonInChargeEmail","vendingMachineModel", "remarks1", "remarks2", "remarks3", "remarks4", "remarks5" ];

        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        }


        vm.abc = {
            "key":[1,2,3],
            "en":[1,2,3],
            "jp":[1,2,3]
        };

//        vm.abc = {
//            "key":["1","2","3"],
//            "en":["1","2","3"],
//            "jp":["1","2","3"]
//        };

        if (!baUtil.isUndefinedOrNullOrEmpty($stateParams.maroonData) && !baUtil.isUndefinedOrNullOrEmptyObject($stateParams.maroonData.data.data) && ($stateParams.maroonData.status >= 200 && $stateParams.maroonData.status <= 299)) {
            vm.deviceRequest = $stateParams.maroonData.data.data;
            vm.disableActionButtons = false
            }
//            .maroonDataRequests.sort(function (a, b) { return b.dateCreated - a.dateCreated });
            //vm.KeyMap = DeviceRequestUtilService.getKeys(vm.KeyMap, "2.0");
            //vm.types.deviceOwner = $stateParams.maroonData.data.data.deviceOwners;
            //vm.KeyMap.deviceOwnerId.type = "Dropdown";
            //vm.KeyMap.deviceOwnerId.readOnly = false;
//            vm.orgId = AuthService.getOrgId();
//            if (vm.orgId && vm.orgId != "" && !baUtil.isMerchant()) {
//                Object.keys(vm.types.deviceOwner).forEach(function(d){
//                    if(vm.types.deviceOwner[d].key.indexOf(vm.orgId) != -1 ) {
//                        vm.isUserDeviceOwnerOfSC[d] = true;
//                    }
//                });
//            }
//        }

        function init() {

            vm.KeyMap ={

                serviceContractId: {
                              en: "Contract ID",
                              jp: "契約先ID",
                              id: 1,
                              inUse: true,
                              isDeleted: false,
                              name: "serviceContractId",
                              order: 1,
                              readOnly: false,
                              type: "String",
                              validators: ["required"]

                         },

                transportName: {
                              en: "Trasnsport Business Name (for Memo)",
                              jp: "交通系事業者名(メモ用)",
                              id: 1,
                              inUse: true,
                              isDeleted: false,
                              name: "transportName",
                              order: 1,
                              readOnly: false,
                              type: "String",
                              validators: []

                         },

                ifVersion: {
                              en: "IF Version",
                              jp: "IFバージョン",
                              id: 1,
                              inUse: true,
                              isDeleted: false,
                              name: "ifVersion",
                              order: 1,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_5", "stringAlphanumeric"]

                         },
                         schemeType: {
                              en: "Scheme type",
                              jp: "スキーム種別",
                              id: 2,
                              inUse: true,
                              isDeleted: false,
                              name: "schemeType",
                              order: 2,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1", "stringAlphanumeric"]

                         },
                         centerContractCode: {
                              en: "Center Contract Code",
                              jp: "センタ契約者コード",
                              id: 3,
                              inUse: true,
                              isDeleted: false,
                              name: "centerContractCode",
                              order: 3,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_3", "stringAlphanumeric"]

                         },
                         allowedValuesProcessingCategory: {
                              en: "Processing Category",
                              jp: "処理区分",
                              id: 4,
                              inUse: true,
                              isDeleted: false,
                              name: "allowedValuesProcessingCategory",
                              order: 4,
                              readOnly: false,
                              type: "Dropdown",
                              validators: []

                         },
                         applicationSerialNumber : {
                              en: "Application Serial Number",
                              jp: "申込通番",
                              id: 5,
                              inUse: true,
                              isDeleted: false,
                              name: "applicationSerialNumber",
                              order: 5,
                              readOnly: false,
                              type: "String",
                              validators: []

                         },
                         uniqueId: {
                              en: "Unique ID",
                              jp: "ユニークID",
                              id: 6,
                              inUse: true,
                              isDeleted: false,
                              name: "false",
                              order: 6,
                              readOnly: true,
                              type: "String",
                              validators: []

                         },
                         reflectionDate: {
                              en: "Reflection Date",
                              jp: "反映日",
                              id: 7,
                              inUse: true,
                              isDeleted: false,
                              name: "reflectionDate",
                              order: 7,
                              readOnly: false,
                              type: "Date",
                              validators: []

                         },
                         caseCode : {
                              en: "Case code",
                              jp: "案件コード",
                              id: 8,
                              inUse: true,
                              isDeleted: false,
                              name: "caseCode",
                              order: 8,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_5", "stringAlphanumeric"]

                         },
                         merchantName : {
                              en: "Merchant Name",
                              jp: "導入先法人名",
                              id: 9,
                              inUse: true,
                              isDeleted: false,
                              name: "merchantName",
                              order: 9,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringFullWidth"]

                         },
                         storeZipCode : {
                              en: "Store Zip Code",
                              jp: "店舗郵便番号",
                              id: 10,
                              inUse: true,
                              isDeleted: false,
                              name: "storeZipCode",
                              order: 10,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_7" ,"numeric"]

                         },
                         storeAddress : {
                              en: "Store address",
                              jp: "店舗住所",
                              id: 11,
                              inUse: true,
                              isDeleted: false,
                              name: "storeAddress",
                              order: 11,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_50" ,"stringFullWidth"]

                         },
                         storeNameKana:  {
                              en: "Store name Kana",
                              jp: "店舗名カナ",
                              id: 12,
                              inUse: true,
                              isDeleted: false,
                              name: "storeNameKana",
                              order: 12,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_30" ,"stringHalfWidth"]

                         },
                         storeName : {
                              en: "Store name",
                              jp: "店舗名",
                              id: 13,
                              inUse: true,
                              isDeleted: false,
                              name: "storeName",
                              order: 13,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringFullWidth"]

                         },
                         storeContactPerson :   {
                              en: "Store Contact Person",
                              jp: "店舗担当者",
                              id: 14,
                              inUse: true,
                              isDeleted: false,
                              name: "storeContactPerson",
                              order: 14,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringFullWidth"]

                         },
                         storeContactPhoneNumber : {
                              en: "Store contact phone number",
                              jp: "店舗連絡先電話番号",
                              id: 15,
                              inUse: true,
                              isDeleted: false,
                              name: "storeContactPhoneNumber",
                              order: 15,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_11" ,"numeric"]

                         },
                         industryCode:  {
                              en: "Industry Code",
                              jp: "業種コード",
                              id: 16,
                              inUse: true,
                              isDeleted: false,
                              name: "industryCode",
                              order: 16,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericOneToFive"]

                         },
                         installationCompanyName :  {
                              en: "Installation company name",
                              jp: "設置会社名",
                              id: 17,
                              inUse: true,
                              isDeleted: false,
                              name: "installationCompanyName",
                              order: 17,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLengthFullHalf_60"]

                         },
                         mainUnitManufacturer : {
                              en: "Main unit manufacturer",
                              jp: "本体メーカー",
                              id: 18,
                              inUse: true,
                              isDeleted: false,
                              name: "mainUnitManufacturer",
                              order: 18,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_2", "stringAlphanumeric"]

                         },
                         mainUnitModelNumber : {
                              en: "Main unit model number",
                              jp: "本体型番",
                              id: 19,
                              inUse: true,
                              isDeleted: false,
                              name: "mainUnitModelNumber",
                              order: 19,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_2", "stringAlphanumeric"]

                         },
                         mainUnitTerminalNumber :  {
                              en: "Main unit terminal number",
                              jp: "本体端末番号",
                              id: 20,
                              inUse: true,
                              isDeleted: false,
                              name: "mainUnitTerminalNumber",
                              order: 20,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20", "stringAlphanumeric"]

                         },
                         posLinkage : {
                              en: "POS linkage",
                              jp: "POS連動有無",
                              id: 21,
                              inUse: true,
                              isDeleted: false,
                              name: "posLinkage",
                              order: 21,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         operationType : {
                              en: "Operation type",
                              jp: "操作タイプ",
                              id: 22,
                              inUse: true,
                              isDeleted: false,
                              name: "operationType",
                              order: 22,
                              readOnly: false,
                              type: "String",
                              validators:["stringLength_1" ,"numericZeroToOne"]

                         },
                         activateId : {
                              en: "Activate ID",
                              jp: "アクティベートID",
                              id: 23,
                              inUse: true,
                              isDeleted: false,
                              name: "activateId",
                              order: 23,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20", "stringAlphanumeric"]

                         },
                         activationPassword : {
                              en: "Activation password",
                              jp: "アクティベートパスワード",
                              id: 24,
                              inUse: true,
                              isDeleted: false,
                              name: "activationPassword",
                              order: 24,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_10", "stringAlphanumeric"]

                         },
                         enableTrafficIC :  {
                              en: "Traffic IC Yes/No",
                              jp: "交通系IC有無",
                              id: 25,
                              inUse: true,
                              isDeleted: false,
                              name: "enableTrafficIC",
                              order: 25,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         tkid :  {
                              en: "T_KID",
                              jp: "交_KID",
                              id: 26,
                              inUse: true,
                              isDeleted: false,
                              name: "tkid",
                              order: 26,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         talternateSPRWID :  {
                              en: "T_Alternate_SPRWID",
                              jp: "交_SPRWID",
                              id: 27,
                              inUse: true,
                              isDeleted: false,
                              name: "talternateSPRWID",
                              order: 27,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13", "stringAlphanumeric"]

                         },
                         ttid :  {
                              en: "T_TID",
                              jp: "交_TID",
                              id: 28,
                              inUse: true,
                              isDeleted: false,
                              name: "ttid",
                              order: 28,
                              readOnly: false,
                              type: "Number",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         tbusinessCode :  {
                              en: "T_Business Code",
                              jp: "交_事業者コード",
                              id: 29,
                              inUse: true,
                              isDeleted: false,
                              name: "tbusinessCode",
                              order: 29,
                              readOnly: false,
                              type: "String",
                              validators: ["required","stringLength_2", "stringAlphanumeric"]

                         },
                         tmerchantNumber :   {
                              en: "T_Merchant Number",
                              jp: "交_加盟店番号",
                              id: 30,
                              inUse: true,
                              isDeleted: false,
                              name: "tmerchantNumber",
                              order: 30,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         tmerchantName :    {
                              en: "T_Merchant Name",
                              jp: "交_加盟店名称",
                              id: 31,
                              inUse: true,
                              isDeleted: false,
                              name: "tmerchantName",
                              order: 31,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         tpayeeCode :   {
                              en: "T_Payee Code",
                              jp: "交_精算先コード",
                              id: 32,
                              inUse: true,
                              isDeleted: false,
                              name: "tpayeeCode",
                              order: 32,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"numeric"]

                         },
                         tdeviceDataPattern : {
                              en: "T_Terminal Data Pattern",
                              jp: "交_端末データパターン",
                              id: 33,
                              inUse: true,
                              isDeleted: false,
                              name: "tdeviceDataPattern",
                              order: 33,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         treturnDataProviderID : {
                              en: "T_Redemption data provider ID",
                              jp: "交_還元データ提供先ID",
                              id: 34,
                              inUse: true,
                              isDeleted: false,
                              name: "treturnDataProviderID",
                              order: 34,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableQUICPay :  {
                              en: "QUICPay Yes/No",
                              jp: "QUICPay有無",
                              id: 35,
                              inUse: true,
                              isDeleted: false,
                              name: "enableQUICPay",
                              order: 35,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         quicPayOptionQKID :   {
                              en: "QUICPay Option",
                              jp: "QUICPayオプション",
                              id: 36,
                              inUse: true,
                              isDeleted: false,
                              name: "quicPayOptionQKID",
                              order: 36,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericOneToTwo"]

                         },
                         qkid :    {
                              en: "Q_KID",
                              jp: "Q_KID",
                              id: 37,
                              inUse: true,
                              isDeleted: false,
                              name: "qkid",
                              order: 37,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         qtid :       {
                              en: "Q_TID",
                              jp: "Q_TID",
                              id: 38,
                              inUse: true,
                              isDeleted: false,
                              name: "qtid",
                              order: 38,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         qmerchantNumber :   {
                              en: "Q_Merchant Number",
                              jp: "Q_加盟店番号",
                              id: 39,
                              inUse: true,
                              isDeleted: false,
                              name: "qmerchantNumber",
                              order: 39,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumeric","stringHalfWidth"]

                         },
                         qmerchantName :  {
                              en: "Q_Merchant Name",
                              jp: "Q_加盟店名称",
                              id: 40,
                              inUse: true,
                              isDeleted: false,
                              name: "qmerchantName",
                              order: 40,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         qmanualCancellationInputAccepted :     {
                              en: "Q_Manual Cancellation Input Accepted",
                              jp: "Q_マニュアル取消入力可否",
                              id: 41,
                              inUse: true,
                              isDeleted: false,
                              name: "qmanualCancellationInputAccepted",
                              order: 41,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         qpartialReturnEntryPermitted :  {
                              en: "Q_Partial Return Entry Permitted",
                              jp: "Q_一部返品入力可否",
                              id: 42,
                              inUse: true,
                              isDeleted: false,
                              name: "qpartialReturnEntryPermitted",
                              order: 42,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         qdeviceDataPattern : {
                              en: "Q_Terminal data pattern",
                              jp: "Q_端末データパターン",
                              id: 43,
                              inUse: true,
                              isDeleted: false,
                              name: "qdeviceDataPattern",
                              order: 43,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         qreturnDataProviderId :  {
                              en: "Q_Return Data Provider ID",
                              jp: "Q_還元データ提供先ID",
                              id: 44,
                              inUse: true,
                              isDeleted: false,
                              name: "qreturnDataProviderId",
                              order: 44,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableId :   {
                              en: "iD Yes/No",
                              jp: "iD有無",
                              id: 45,
                              inUse: true,
                              isDeleted: false,
                              name: "enableId",
                              order: 45,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         ikid :    {
                              en: "I_KID",
                              jp: "I_KID",
                              id: 46,
                              inUse: true,
                              isDeleted: false,
                              name: "ikid",
                              order: 46,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         itid :   {
                              en: "I_TID",
                              jp: "I_TID",
                              id: 47,
                              inUse: true,
                              isDeleted: false,
                              name: "itid",
                              order: 47,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         imerchantNumber :  {
                              en: "I_Merchant Number",
                              jp: "I_加盟店番号",
                              id: 48,
                              inUse: true,
                              isDeleted: false,
                              name: "imerchantNumber",
                              order: 48,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumeric","stringHalfWidth"]

                         },
                         imerchantName :  {
                              en: "I_Merchant Name",
                              jp: "I_加盟店名称",
                              id: 49,
                              inUse: true,
                              isDeleted: false,
                              name: "imerchantName",
                              order: 49,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         iitemCodeRequired :   {
                              en: "I_ItemCodeRequired",
                              jp: "I_商品コード入力要否",
                              id: 50,
                              inUse: true,
                              isDeleted: false,
                              name: "iitemCodeRequired",
                              order: 50,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         imanualRejectRequired :  {
                              en: "I_Manual_Reject_Required",
                              jp: "I_マニュアル取消入力可否",
                              id: 51,
                              inUse: true,
                              isDeleted: false,
                              name: "imanualRejectRequired",
                              order: 51,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         itaxOrOtherInputRequired :  {
                              en: "I_Tax/other input required",
                              jp: "I_税・その他入力要否",
                              id: 52,
                              inUse: true,
                              isDeleted: false,
                              name: "itaxOrOtherInputRequired",
                              order: 52,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         ienquiryRequired :   {
                              en: "I_Enquiry_Required",
                              jp: "I_照会業務入力可否",
                              id: 53,
                              inUse: true,
                              isDeleted: false,
                              name: "ienquiryRequired",
                              order: 53,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         ideviceDataPattern :  {
                              en: "I_terminal data pattern",
                              jp: "I_端末データパターン",
                              id: 54,
                              inUse: true,
                              isDeleted: false,
                              name: "ideviceDataPattern",
                              order: 54,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         ireturnDataProviderId :  {
                              en: "I_reduction data supplier ID",
                              jp: "I_還元データ提供先ID",
                              id: 55,
                              inUse: true,
                              isDeleted: false,
                              name: "ireturnDataProviderId",
                              order: 55,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableEdy :      {
                              en: "Edy Yes/No",
                              jp: "Edy有無",
                              id: 56,
                              inUse: true,
                              isDeleted: false,
                              name: "enableEdy",
                              order: 56,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         ekid : {
                              en: "E_KID",
                              jp: "E_KID",
                              id: 57,
                              inUse: true,
                              isDeleted: false,
                              name: "ekid",
                              order: 57,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         ehigherLevelTerminalId :  {
                              en: "E_Higher level terminal ID",
                              jp: "E_上位端末ID",
                              id: 58,
                              inUse: true,
                              isDeleted: false,
                              name: "ehigherLevelTerminalId",
                              order: 58,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         eemid : {
                              en: "E_EM-ID",
                              jp: "E_EM-ID",
                              id: 59,
                              inUse: true,
                              isDeleted: false,
                              name: "eemid",
                              order: 59,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         ehwidm : {
                              en: "E_HW-idm",
                              jp: "E_HW-idm",
                              id: 60,
                              inUse: true,
                              isDeleted: false,
                              name: "ehwidm",
                              order: 60,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_16", "stringAlphanumeric"]

                         },
                         etid : {
                              en: "E_TID",
                              jp: "E_TID",
                              id: 61,
                              inUse: true,
                              isDeleted: false,
                              name: "etid",
                              order: 61,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         emerchantNumber :  {
                              en: "E_Merchant Number",
                              jp: "E_加盟店番号",
                              id: 62,
                              inUse: true,
                              isDeleted: false,
                              name: "emerchantNumber",
                              order: 62,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         emerchantName : {
                              en: "E_Merchant Name",
                              jp: "E_加盟店名称",
                              id: 63,
                              inUse: true,
                              isDeleted: false,
                              name: "emerchantName",
                              order: 63,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         eedyMerchantId : {
                              en: "E_Edy Merchant ID",
                              jp: "E_Edy加盟店ID",
                              id: 64,
                              inUse: true,
                              isDeleted: false,
                              name: "eedyMerchantId",
                              order: 64,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         e_10JPYRoundingRequired :   {
                              en: "E_10_Yen_Rounding required",
                              jp: "E_10円丸め要否",
                              id: 65,
                              inUse: true,
                              isDeleted: false,
                              name: "e_10JPYRoundingRequired",
                              order: 65,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         eterminalUseClassification :    {
                              en: "E_Terminal use classification",
                              jp: "E_端末用途区分",
                              id: 66,
                              inUse: true,
                              isDeleted: false,
                              name: "eterminalUseClassification",
                              order: 66,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericOneToThree"]

                         },
                         edeviceDataPattern :      {
                              en: "E_terminal data pattern",
                              jp: "E_端末データパターン",
                              id: 67,
                              inUse: true,
                              isDeleted: false,
                              name: "edeviceDataPattern",
                              order: 67,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         ereturnDataProviderId : {
                              en: "E_redemption data provider ID",
                              jp: "E_還元データ提供先ID",
                              id: 68,
                              inUse: true,
                              isDeleted: false,
                              name: "ereturnDataProviderId",
                              order: 68,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableWAON :   {
                              en: "WAON Yes/No",
                              jp: "WAON有無",
                              id: 69,
                              inUse: true,
                              isDeleted: false,
                              name: "enableWAON",
                              order: 69,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         wkid :  {
                              en: "W_KID",
                              jp: "W_KID",
                              id: 70,
                              inUse: true,
                              isDeleted: false,
                              name: "wkid",
                              order: 70,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         wsprwid : {
                              en: "W_SPRWID",
                              jp: "W_SPRWID",
                              id: 71,
                              inUse: true,
                              isDeleted: false,
                              name: "wsprwid",
                              order: 71,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_13", "stringAlphanumeric"]

                         },
                         wmerchantCategoryCode :     {
                              en: "W_Merchant Category Code",
                              jp: "W_加盟店区分コード",
                              id: 72,
                              inUse: true,
                              isDeleted: false,
                              name: "wmerchantCategoryCode",
                              order: 72,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_2", "stringAlphanumeric"]

                         },
                         wcompanyCode :  {
                              en: "W_Company Code",
                              jp: "W_会社コード",
                              id: 73,
                              inUse: true,
                              isDeleted: false,
                              name: "wcompanyCode",
                              order: 73,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_4", "stringAlphanumeric"]

                         },
                         wtid :   {
                              en: "W_TID",
                              jp: "W_TID",
                              id: 74,
                              inUse: true,
                              isDeleted: false,
                              name: "wtid",
                              order: 74,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         wmerchantNumber :    {
                              en: "W_Merchant Number",
                              jp: "W_加盟店番号",
                              id: 75,
                              inUse: true,
                              isDeleted: false,
                              name: "wmerchantNumber",
                              order: 75,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         wmerchantName : {
                              en: "W_Merchant Name",
                              jp: "W_加盟店名称",
                              id: 76,
                              inUse: true,
                              isDeleted: false,
                              name: "wmerchantName",
                              order: 76,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         wwhetherToCancel :   {
                              en: "W_Whether to cancel",
                              jp: "W_取消実施可否",
                              id: 77,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherToCancel",
                              order: 77,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherCashChargeIsAllowed :  {
                              en: "W_Whether cash charge is allowed",
                              jp: "W_現金チャージ実施可否",
                              id: 78,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherCashChargeIsAllowed",
                              order: 78,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherCashChargeCanBeCancelled :  {
                              en: "W_Whether cash charge can be cancelled",
                              jp: "W_現金チャージ取消実施可否",
                              id: 79,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherCashChargeCanBeCancelled",
                              order: 79,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherPointChargeIsAllowed :   {
                              en: "W_Whether point charge is allowed",
                              jp: "W_ポイントチャージ実施可否",
                              id: 80,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherPointChargeIsAllowed",
                              order: 80,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherAutoChargeIsAllowed :   {
                              en: "W_Whether auto charge is allowed",
                              jp: "W_オートチャージ可否",
                              id: 81,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherAutoChargeIsAllowed",
                              order: 81,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wwhetherToCancelAnotherTerminal : {
                              en: "W_Whether to cancel another terminal",
                              jp: "W_別端末取消可否",
                              id: 82,
                              inUse: true,
                              isDeleted: false,
                              name: "wwhetherToCancelAnotherTerminal",
                              order: 82,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wreturnPolicy :   {
                              en: "W_Return policy",
                              jp: "W_返品可否",
                              id: 83,
                              inUse: true,
                              isDeleted: false,
                              name: "wreturnPolicy",
                              order: 83,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         wpointAssignmentPattern : {
                              en: "W_Point assignment pattern",
                              jp: "W_ポイント付与パターン",
                              id: 84,
                              inUse: true,
                              isDeleted: false,
                              name: "wpointAssignmentPattern",
                              order: 84,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         wdeviceDataPattern :   {
                              en: "W_Terminal data pattern",
                              jp: "W_端末データパターン",
                              id: 85,
                              inUse: true,
                              isDeleted: false,
                              name: "wdeviceDataPattern",
                              order: 85,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         wreturnDataProviderId :    {
                              en: "W_redemption data provider ID",
                              jp: "W_還元データ提供先ID",
                              id: 86,
                              inUse: true,
                              isDeleted: false,
                              name: "wreturnDataProviderId",
                              order: 86,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enableNanaco :   {
                              en: "nanaco Yes/No",
                              jp: "nanaco有無",
                              id: 87,
                              inUse: true,
                              isDeleted: false,
                              name: "enableNanaco",
                              order: 87,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         nkid :    {
                              en: "N_KID",
                              jp: "N_KID",
                              id: 88,
                              inUse: true,
                              isDeleted: false,
                              name: "nkid",
                              order: 88,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         nhigherTerminalId9Digits : {
                              en: "N_Higher terminal ID_9 digits",
                              jp: "N_上位端末ID_9桁",
                              id: 89,
                              inUse: true,
                              isDeleted: false,
                              name: "nhigherTerminalId9Digits",
                              order: 89,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_9", "stringAlphanumeric"]

                         },
                         nhigherLevelTerminalId : {
                              en: "N_Higher level terminal ID",
                              jp: "N_上位端末ID",
                              id: 90,
                              inUse: true,
                              isDeleted: false,
                              name: "nhigherLevelTerminalId",
                              order: 90,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_20", "stringAlphanumeric"]

                         },
                         ntid :  {
                              en: "N_TID",
                              jp: "N_TID",
                              id: 91,
                              inUse: true,
                              isDeleted: false,
                              name: "ntid",
                              order: 91,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         nmerchantNumber :    {
                              en: "N_Merchant Number",
                              jp: "N_加盟店番号",
                              id: 92,
                              inUse: true,
                              isDeleted: false,
                              name: "nmerchantNumber",
                              order: 92,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         nnameOfMerchant :  {
                              en: "N_Merchant Name",
                              jp: "N_加盟店名称",
                              id: 93,
                              inUse: true,
                              isDeleted: false,
                              name: "nnameOfMerchant",
                              order: 93,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         ncashChargeAcceptance :  {
                              en: "N_Cash Charge Acceptance",
                              jp: "N_現金チャージ可否",
                              id: 94,
                              inUse: true,
                              isDeleted: false,
                              name: "ncashChargeAcceptance",
                              order: 94,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         ndeviceDataPattern :  {
                              en: "N_terminal data pattern",
                              jp: "N_端末データパターン",
                              id: 95,
                              inUse: true,
                              isDeleted: false,
                              name: "ndeviceDataPattern",
                              order: 95,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         nreturnDataProviderId :  {
                              en: "N_reduction data provider ID",
                              jp: "N_還元データ提供先ID",
                              id: 96,
                              inUse: true,
                              isDeleted: false,
                              name: "nreturnDataProviderId",
                              order: 96,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         },
                         enablePiTaPa :  {
                              en: "PiTaPa Yes/No",
                              jp: "PiTaPa有無",
                              id: 97,
                              inUse: true,
                              isDeleted: false,
                              name: "enablePiTaPa",
                              order: 97,
                              readOnly: false,
                              type: "Checkbox",
                              validators: []

                         },
                         pkid :    {
                              en: "P_KID",
                              jp: "P_KID",
                              id: 98,
                              inUse: true,
                              isDeleted: false,
                              name: "pkid",
                              order: 98,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_3" ,"numeric"]

                         },
                         ppiTaPaTID :     {
                              en: "P_PiTaPa-TID",
                              jp: "P_PiTaPa-TID",
                              id: 99,
                              inUse: true,
                              isDeleted: false,
                              name: "ppiTaPaTID",
                              order: 99,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_13", "stringAlphanumeric"]

                         },
                         ptid :   {
                              en: "P_TID",
                              jp: "P_TID",
                              id: 100,
                              inUse: true,
                              isDeleted: false,
                              name: "ptid",
                              order: 100,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_13" ,"numeric"]

                         },
                         pmerchantNumber :  {
                              en: "P_Merchant Number",
                              jp: "P_加盟店番号",
                              id: 101,
                              inUse: true,
                              isDeleted: false,
                              name: "pmerchantNumber",
                              order: 101,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_15" ,"stringAlphanumericContainsSpace","stringHalfWidth"]

                         },
                         pmerchantName : {
                              en: "P_Merchant Name",
                              jp: "P_加盟店名称",
                              id: 102,
                              inUse: true,
                              isDeleted: false,
                              name: "pmerchantName",
                              order: 102,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_25" ,"stringHalfWidth"]

                         },
                         preturnBusinessAvailability :   {
                              en: "P_Return business availability",
                              jp: "P_返品業務可否",
                              id: 103,
                              inUse: true,
                              isDeleted: false,
                              name: "preturnBusinessAvailability",
                              order: 103,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_1" ,"numericZeroToOne"]

                         },
                         pdeviceDataPattern :   {
                              en: "P_Terminal data pattern",
                              jp: "P_端末データパターン",
                              id: 104,
                              inUse: true,
                              isDeleted: false,
                              name: "pdeviceDataPattern",
                              order: 104,
                              readOnly: false,
                              type: "String",
                              validators: ["stringLength_20" ,"stringHalfWidth"]


                         },
                         preturnDataProviderId : {
                              en: "P_Return Data Provider ID",
                              jp: "P_還元データ提供先ID",
                              id: 105,
                              inUse: true,
                              isDeleted: false,
                              name: "preturnDataProviderId",
                              order: 105,
                              readOnly: false,
                              type: "String",
                              validators: [ "stringLength_8", "stringAlphanumeric"]

                         }
                        };
            var allCols = Object.keys(vm.KeyMap)
            var coloredCols=["merchantName", "installationCompanyName", "tkid" ,  "tbusinessCode" ,  "tmerchantNumber", "tmerchantName" , 
            "tpayeeCode", "qkid" , "qmerchantNumber", "qmerchantName" ,  "ikid" , "imerchantNumber" ,  
            "imerchantName", "ekid",  "emerchantNumber" ,  "emerchantName" , "eedyMerchantId" ,  "wkid" ,  
            "wmerchantCategoryCode" ,  "wcompanyCode" , "wmerchantNumber", "wmerchantName" ,  "wpointAssignmentPattern",  
            "nkid", "nhigherTerminalId9Digits", "nmerchantNumber", "nnameOfMerchant", "pkid" ,"pmerchantNumber", "pmerchantName"]
            var foundIndexes = allCols.map(function(item) { 
                return coloredCols.some(function(col) {
                    return item === col;
                })
            })

            vm.tableData = [];
            vm.tableOptions = {};
            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                fixedColumnsLeft: 0,
                afterGetColHeader: function(col, TH) {
                    var TR = TH.parentNode;
                    function applyClass(elem, className) {
                        if (!Handsontable.dom.hasClass(elem, className)) {
                          Handsontable.dom.addClass(elem, className);
                        }
                      }

                      if (foundIndexes[col]) {
                        applyClass(TH, 'yellow');
                      }
                },
                modifyColWidth: function(width, col) {
//                return 150;
//                    if(col === 3 || col === 5) {
//                        return 300;
//                    }else if (col === 1 || col === 4){
//                        return 300;
//                    } else if(width > 500) return 500;
                },
                afterValidate: function (isValid, value, row, prop, source) {
                    // custom validation for device installaiton status
                    if(prop === "status") {
                        var index = vm.types.DeviceInstallationStatus.en.indexOf(value);
                        if (index < 0) {
                            index = vm.types.DeviceInstallationStatus.jp.indexOf(value);
                        }
                        var indexValue = index === -1 ? value : vm.types.DeviceInstallationStatus.key[index];

                        if(vm.isDIStateTransitionValid(vm.deviceRequest[row]['status'], indexValue)) {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                        else {
                            vm.errors[ row + "_" + prop ] = vm.getErrMessageOfStatus(
                                row+1,
                                vm.deviceRequest[row]['applicationNumber'],
                                vm.deviceRequest[row]['status'],
                                indexValue
                            );
                            return false;
                        }
                    }



                    // custom validation for device owner
//                    if(prop === "deviceOwnerId") {
//                        if(baUtil.isUndefinedOrNullOrEmpty(value)) {
//                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId");
//                            return false;
//                        }
//                        else if( vm.types.deviceOwner[ vm.deviceRequest[row]["serviceContractId"] ][$translate.use()].indexOf(value) === -1 ) {
//                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "deviceOwnerId", true);
//                            return false;
//                        }
//                        else {
//                            delete vm.errors[ row + "_" + prop ];
//                            return true;
//                        }
//                    }

//                    if(prop === "paymentHandlingOption_TRANSPORT") {
//                        if(baUtil.isUndefinedOrNullOrEmpty(value) ||
//                         vm.types.TransportPaymentOptions[$translate.use()].indexOf(value) === -1 ) {
//                            vm.errors[ row + "_" + prop ] = vm.getErrMessageDO(row+1, "paymentHandlingOption_TRANSPORT", true);
//                            return false;
//                        }
//                        else {
//                            delete vm.errors[ row + "_" + prop ];
//                            return true;
//                        }
//                    }

                    // common use validator

                    if(!vm.KeyMap[prop]['validators']) {
                        console.log(vm.KeyMap[prop]);

                    }
                   if ( !vm.KeyMap[prop]["readOnly"] && vm.KeyMap[prop]['validators'].length ) {
                       var msg = hotUtil.aggregatedValidator(vm.KeyMap[prop]['validators'], value, row, vm.KeyMap[prop][vm.getLang()]);

                       if( msg != "" ) {
                           vm.errors[ row + "_" + prop ] = msg;
                           return false;
                       }
                       else {
                           delete vm.errors[ row + "_" + prop ];
                           return true;
                       }
                   }

                   if(isValid) {
                       delete vm.errors[ row + "_" + prop ];
                   }
                   else {
                       vm.errors[ row + "_" + prop ] = value;
                   }

                }
            };

            // disable rows if the device status is not DRAFT or REGISTERED
            //    for users which don't have permissions
            //    when status is cancelled
            //    ALSO >> customise device owners for different SC's DIs
            vm.tableSettings.cells = function (row, col, prop) {
                var cellMeta = {};
//                if(prop === "deviceSerial" || prop === "companyName" || prop === "applicationNumber" || prop === "deviceOwnerId") {
//                    cellMeta.className = 'word-break';
//                }
//                if( prop === "deviceOwnerId" ) {
//                    cellMeta.source = vm.types.deviceOwner[ vm.deviceRequest[row]["serviceContractId"] ][$translate.use()];
//                }
                if(!baUtil.isUndefinedOrNullOrEmpty(vm.tableData[row])) {
                    if( vm.tableData[row].readOnly || vm.tableData[row][ prop + "_readOnly" ] ) {
                        cellMeta.readOnly = true;
                    }
                }
                return  cellMeta;
            };
            vm.deviceRequest.forEach(function (item, index) {
                var obj = {};

                var keys = Object.keys(item).filter(function (k) { return k !== 'paymentHandlingOptions' })
                keys.forEach(function (field) {
                    var value = item[field];
                    obj[field] = value;
                    if (field === 'date' || field == 'reflectionDate') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                    }
//                    else if (field === 'deviceOwnerId') {
//                        if(baUtil.isUndefinedOrNullOrEmptyObject(value)) {
//                            obj['deviceOwnerId'] =  "";
//                        }
//                        else {
//                            var index = vm.types.deviceOwner[item.serviceContractId].key.indexOf(value);
//                            obj['deviceOwnerId'] = vm.types.deviceOwner[item.serviceContractId][$translate.use()][index];
//                        }
//                    }
//                    else if (field === 'allowedValuesProcessingCategory') {
//                        var index = vm.abc.key.indexOf(value);
//                        obj[field] = vm.abc[$translate.use()][index];
//                    }
//                    else if (field === 'type') {
//                        var index = vm.types.maroonDataType.key.indexOf(value);
//                        obj[field] = vm.types.maroonDataType[$translate.use()][index];
//                    }
//                    else if (field === 'vendingMachineModel') {
//                        item.paymentHandlingOptions.forEach(function (k, i) {
//                            obj['paymentHandlingOption_' + k] = true
//                        });
//
//                        obj['paymentHandlingOption_TRANSPORT'] = DeviceRequestUtilService.getTransportPaymentOptionTextFromKey(
//                            vm.types.TransportPaymentOptions,
//                            item['transportPaymentHandlingOption'],
//                            item['paymentHandlingOptions']
//                        );
//
//                        obj[field] = value;
//                    }
//                    else {
//                        obj[field] = value;
//                    }
//
//
                })
//
//
//                // for merchant admin - allow edit of vending maching model and remarks 1-5
//                if( vm.isMerchantAdmin && vm.merchantAdminCanEditInStatus.indexOf(item['status'] || "") !== -1) {
//                    obj.readOnly = false;
//                    vm.disableActionButtons = false;
//                    Object.keys(obj).forEach(function (field) {
//                        if(vm.editableFieldsWhenMerchantAdmin.indexOf(field)===-1) {
//                            obj[ field + "_readOnly" ] = true;
//                        }
//                    });
//                    vm.types.PaymentHandlingOption.E_MONEY.key.forEach(function (key) {
//                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
//                    });
//                    vm.types.PaymentHandlingOption.QR_MONEY.key.forEach(function (key) {
//                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
//                    });
//                }
//                else if( vm.isDeviceOwnerAdmin && vm.deviceOwnerCanEditInStatus.indexOf(item['status'] || "") !== -1) {
//                    obj.readOnly = false;
//                    vm.disableActionButtons = false;
//                    Object.keys(obj).forEach(function (field) {
//                        if(vm.editableFieldsWhenDeviceOwner.indexOf(field)===-1) {
//                            obj[ field + "_readOnly" ] = true;
//                        }
//                    });
//                    vm.types.PaymentHandlingOption.E_MONEY.key.forEach(function (key) {
//                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
//                    });
//                    vm.types.PaymentHandlingOption.QR_MONEY.key.forEach(function (key) {
//                        obj[ "paymentHandlingOption_" + key + "_readOnly" ] = true;
//                    });
//                }
//                else if (
//                    vm.canEditInStatus.indexOf(item.status) !== -1 &&
//                    vm.permissions.DEVICE_REQUEST.WRITE
//                ) {
//                    obj.readOnly = false;
//                    vm.disableActionButtons = false;
//                }
//                else if(
//                    vm.canPartiallyEditInStatus.indexOf(item.status) !== -1 &&
//                    vm.permissions.DEVICE_REQUEST.WRITE
//                ) {
//                    obj.readOnly = false;
//                    vm.disableActionButtons = false;
//                    vm.readOnlyFieldsInPartiallyEditStatus.forEach(function(key){
//                        obj[ key + "_readOnly" ] = true;
//                    });
//                }
//                else {
//                    obj.readOnly = true;
//                }
//
//                if( vm.isUserDeviceOwnerOfSC[item.serviceContractId] ) {
//                    obj["deviceOwnerId_readOnly"] = true;
//                }
//
                if(item.allowedValuesProcessingCategory == 1) {
                    obj["allowedValuesProcessingCategory_readOnly"] = true;
                }

                if( item.changeApplicable == 1 ) {
                    obj.readOnly = true;
                    vm.disableActionButtons = true;
                }
                vm.tableData.push(obj);
            });
            var keyMap = vm.KeyMap
            var optionKeys = Object.keys(keyMap).sort(function (a, b) {
                return keyMap[a].order - keyMap[b].order;
            });

            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: value.name,
                    readOnly: value.readOnly
                }

                if(field == 'status' && !vm.isSystemUser) {
                    col.readOnly = true;
                }

                if (getInputType(value.type) === 'dropdown') {
                    col.source = [1,2,3]
                }

                if (getInputType(value.type) === 'date') {
                    col.dateFormat = 'YYYY/MM/DD'
                    col.datePickerConfig = {
                        showMonthAfterYear: true,
                        yearSuffix: "年",
                        i18n: baUtil.geti18nDateForJP()
                    }
                }

//                if ( !vm.KeyMap[field]["readOnly"] && vm.KeyMap[field]['validators'].length ) {
                if ( !vm.KeyMap[field]["readOnly"] ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);

            })


            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsontable-request-detail');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }
        if(!baUtil.isUndefinedOrNullOrEmpty($stateParams.maroonData) && !baUtil.isUndefinedOrNullOrEmptyObject($stateParams.maroonData.data.data)){
            init();
        }
//
        $scope.$on('LANG_CHANGE', function (event) {
            init();
        });

        function cancelCreate() {
            $state.go('main.serviceContract.detail', { contractId: $stateParams.serviceContractId});
        }

        function getInputType(type) {
           switch (type) {
               case 'String':
                   return 'text'
               case 'Checkbox':
                   return 'checkbox'
               case 'Date':
                   return 'date'
               case 'Dropdown':
                   return 'dropdown'
               default:
                return 'text'
           }
        }


        function getSource(key) {
            switch (key) {
                case 'status':
                    return vm.types.DeviceInstallationStatus[$translate.use()]
                case 'type':
                    return vm.types.maroonDataType[$translate.use()]
                case 'deviceOwnerId':
                    return []; // setting this in cells hook
                case 'paymentHandlingOption_TRANSPORT':
                    return vm.types.TransportPaymentOptions[$translate.use()]
                case 'allowedValuesProcessingCategory':
                    return vm.abc[$translate.use()]
                default:
                    return []
            }
        }

        function getLang() {
            return $translate.use();
        }

        function getErrMessage(row, field){
            if( vm.fieldMetaData[field] ) {
                return $translate.instant(
                    vm.fieldMetaData[field]['errMsg'],
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
            else {
                /// return reqd otherwise
                return $translate.instant(
                    "err.msg.required.field",
                    { row: row, param: vm.KeyMap[field][vm.getLang()] }
                );
            }
        }

        function getErrMessageOfStatus(row, applicationNumber, from, to){
            return $translate.instant(
                "device.request.edit.err.msg.cannot.allow.state.transition",
                {
                    row: row,
                    id: applicationNumber,
                    from: vm.getDeviceStatusFromKey(from),
                    to: vm.getDeviceStatusFromKey(to)
                }
            );
        }

        function getErrMessageDO (row, field, isWrongInput) {
            return $translate.instant(
                isWrongInput ? "device.request.edit.err.msg.device.owner" : "device.request.edit.err.msg.required.field",
                { row: row, param: vm.KeyMap[field][vm.getLang()] }
            );
        }

        function getInstallationStatusIndex(status){
            var statusMap = {
                "DRAFT": 0,
                "REGISTERED": 1,
                "ACCEPTED": 2,
                "UNDER_FULFILMENT": 3,
                "COMPLETED": 4,
                "APPLICATION_CANCELLED": 5
            };
            if(Object.keys(statusMap).indexOf(status) === -1) {
                return null;
            }
            return statusMap[status]
        }

        function isDIStateTransitionValid(statusBefore, statusAfter) {

            // no change detected
            if(statusBefore == statusAfter) {
                return true;
            }

            // status shifted backwards
            else if (
                vm.getInstallationStatusIndex(statusBefore) != null &&
                vm.getInstallationStatusIndex(statusAfter) != null &&
                vm.getInstallationStatusIndex(statusBefore) > vm.getInstallationStatusIndex(statusAfter)
            ) {
                if(vm.isSystemUser) {
                    if(
                        (statusBefore == "ACCEPTED" && statusAfter == "REGISTERED") ||
                        (statusBefore == "UNDER_FULFILMENT" && statusAfter == "REGISTERED")
                    ) {
                        return true;
                    }
                }
                return false;
            }

            // status moving forward
            else {
                // for common permissions
                if(
                    (statusBefore == "DRAFT" && statusAfter == "REGISTERED") ||
                    (statusBefore == "REGISTERED" && statusAfter == "APPLICATION_CANCELLED")
                ) {
                    return true;
                }
                // for System User
                else if(vm.isSystemUser) {
                    if(
                        (statusBefore == "REGISTERED" && statusAfter == "ACCEPTED") ||
                        (
                            statusBefore == "ACCEPTED" &&
                            ["UNDER_FULFILMENT", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        ) ||
                        (
                            statusBefore == "UNDER_FULFILMENT" &&
                            ["COMPLETED", "APPLICATION_CANCELLED"].indexOf(statusAfter) !== -1
                        )
                    ) {
                        return true;
                    }
                }
                // otherwise
                return false;
            }
        }

        function getDeviceStatusFromKey(key) {
            var index = vm.types.DeviceInstallationStatus.key.indexOf(key);

            if(index === -1) return key;

            return ($translate.use() === "jp" ?
                    vm.types.DeviceInstallationStatus.jp[index] :
                    vm.types.DeviceInstallationStatus.en[index]);
        }

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function downloadDeviceRequestExcel() {
            if (
                baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest) ||
                vm.isDownloadingDIExcel == true
            ) {
                return false;
            }
            vm.isDownloadingDIExcel = true;
            var keys = vm.deviceRequest.map(function(i){
                return i.applicationNumber;
            });

            DeviceRequestService
            .downloadDeviceRequestExcel(keys)
            .then(function(resp) {
                vm.isDownloadingDIExcel = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingDIExcel = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function downloadJescaCsv() {
//            if (
//                baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest) ||
//                vm.isDownloadingDIExcel == true
//            ) {
//                return false;
//            }
            vm.isDownloadingJescaCsv = true;
            if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest)){
                var keys = vm.deviceRequest.map(function(i){
                    return i.applicationSerialNumber;
                });
            }
            else {
                var keys = [];
            }

            DeviceRequestService
            .downloadJescaCsv(keys)
            .then(function(resp) {
                vm.isDownloadingJescaCsv = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingJescaCsv = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }
        function downloadJescaCsvResult() {
//            if (
//                baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest) ||
//                vm.isDownloadingDIExcel == true
//            ) {
//                return false;
//            }
            vm.isDownloadingJescaCsvResult = true;
            if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest)){
                var keys = vm.deviceRequest.map(function(i){
                    return i.applicationSerialNumber;
                });
            }
            else {
                var keys = [];
            }

            DeviceRequestService
            .downloadJescaCsvResult(keys)
            .then(function(resp) {
                vm.isDownloadingJescaCsvResult = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            },function(err) {
                vm.isDownloadingJescaCsvResult = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }



        function jescaActivationCsvDownload() {

            vm.isDownloadingJescaActivationCsv = true;
            if(!baUtil.isUndefinedOrNullOrEmptyObject(vm.deviceRequest)){
                var keys = vm.deviceRequest.map(function(i){
                    return i.applicationSerialNumber;
                });
            }
            else {
                var keys = [];
            }

            DeviceRequestService
            .downloadJescaActivationCsv(keys)
            .then(function(resp) {
                vm.isDownloadingJescaActivationCsv = false;
                var headers = resp.headers();
                var filename = headers["content-disposition"];
                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                var serverData = new Blob([resp.data], {type: headers['content-type']});
                FileSaver.saveAs(serverData, filename); // File name set at server passed to the FileSaver function
            }, function(err) {
                vm.isDownloadingJescaActivationCsv = false;
                if ("TextDecoder" in window) {
                    try {
                        var enc = new TextDecoder("utf-8");
                        var data = enc.decode(err.data);
                        err = JSON.parse(data);
                    } catch(ignore){ }
                }
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function create(isDraft) {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            var message = vm.tableData.find(function(d){
                var index = vm.types.DeviceInstallationStatus.en.indexOf(d.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(d.status);
                }
                var indexValue = vm.types.DeviceInstallationStatus.key[index];

                return (indexValue === "INSTALLED" || indexValue === "RUNNING") && !vm.isMerchantAdmin;
            }) ? vm.localTranslator("device.request.edit.running.state.edit.message") : null;


            baUtil.showConfirm(null, message)
            .then(function() {

                var data = [];
                vm.tableData.forEach(function (row, i) {
                    var obj = {
//                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
//                        if( key === "paymentHandlingOptions" ) return;

                        if (key === 'date' || key == 'preferredDateOfInstallation') {
                            var long = row[key] && baUtil.convertJpDateToTimestamp(row[key])
                            obj[key] = long;
                        }
                        if (key === 'processingCategory') {
                            obj[key]  = row.allowedValuesProcessingCategory;
                        }
//                        else if (key.indexOf("paymentHandlingOption_") >= 0){
//                            if(row[key]) {
//                                var optionKey = key.replace('paymentHandlingOption_', '');
//                                obj.paymentHandlingOptions.push(optionKey);
//                            }
//                        }
//                        else if( key == "deviceOwnerId" ) {
//                            var index = vm.types.deviceOwner[row.serviceContractId].en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.deviceOwner[row.serviceContractId].jp.indexOf(row[key]);
//                            }
//                            obj['deviceOwnerId'] = vm.types.deviceOwner[row.serviceContractId].key[index];
//                        }
//                        else if( key == "status" ) {
//                            var index = vm.types.DeviceInstallationStatus.en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.DeviceInstallationStatus.jp.indexOf(row[key]);
//                            }
//                            var indexValue = vm.types.DeviceInstallationStatus.key[index];
//
//
//                            if(indexValue == "DRAFT" && !isDraft) {
//                                obj['status'] = "REGISTERED";
//                            }
//                            else
//                                obj['status'] = indexValue;
//
//                        }
//                        else if( key == "type" ) {
//                            var index = vm.types.maroonDataType.en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.maroonDataType.jp.indexOf(row[key]);
//                            }
//                            obj['type'] = vm.types.maroonDataType.key[index];
//                        }
                        else {
                            obj[key] = row[key]
                        }
                    })

//                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
//                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
//                    if(obj['transportPaymentHandlingOption'] !== "-") {
//                        obj.paymentHandlingOptions.push("TRANSPORT");
//                    }
//
//                    if( !(obj['version'] || "1.7").startsWith("2.") ) {
//                        obj['version'] = "2.0";
//                    }

                    var long = baUtil.convertJpDateToTimestamp(obj['reflectionDate'])
                    obj['reflectionDate'] = long;
                    data.push(obj)
                })

                data = data.filter(function(d, i){ return !vm.tableData[i].readOnly });
                if(!data.length) return;

                if(data.length > 9) {
                    vm.modal = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/modalTemplates/loadingModal.html',
                        size: "sm",
                        resolve: {
                          items: function () {
                            return $scope.items;
                        }}
                    });
                }

                if (isDraft) {
                    vm.draftInProgress = true;
                } else {
                    vm.createInProgress = true;
                }
                DeviceRequestService
                .updateJescaDeviceRequest( data )
                .then(function success(response) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.deviceRequest.list');
                }, function err(err) {

                    if(vm.modal) {
                        vm.modal.close();
                    }

                    if (isDraft) {
                        vm.draftInProgress = false;
                    } else {
                        vm.createInProgress = false;
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }
        function applyMaroon() {
            if(!vm.hotTable) return;

            if (!vm.isFormValid()) {
                return;
            }

            // update currently selected cell's value if directly clicked on submit
            // after change cell value
            vm.hotTable.selectCell(0,1,0,1);

            var message = vm.tableData.find(function(d){
                var index = vm.types.DeviceInstallationStatus.en.indexOf(d.status);
                if (index < 0) {
                    index = vm.types.DeviceInstallationStatus.jp.indexOf(d.status);
                }
                var indexValue = vm.types.DeviceInstallationStatus.key[index];

                return (indexValue === "INSTALLED" || indexValue === "RUNNING") && !vm.isMerchantAdmin;
            }) ? vm.localTranslator("device.request.edit.running.state.edit.message") : null;

            var title = vm.localTranslator("service.contract.list.maroon.application.register.title");
            var message = vm.localTranslator("service.contract.list.maroon.application.register.message");
            var btnText = vm.localTranslator("service.contract.list.maroon.application.register");


            baUtil.showConfirm(title, message, btnText)
            .then(function() {

                var data = [];
                vm.tableData.forEach(function (row, i) {
                    var obj = {
//                        paymentHandlingOptions: []
                    };
                    Object.keys(row).forEach(function (key) {
                        if (key == 'date' || key == 'reflectionDate') {
                            obj[key] = '';
                            var long = baUtil.convertJpDateToTimestamp(row[key])
                            obj['reflectionDate'] = long;
                        }
                        if (key === 'processingCategory') {
                            obj[key]  = row.allowedValuesProcessingCategory;
                        }
//                        else if (key.indexOf("paymentHandlingOption_") >= 0){
//                            if(row[key]) {
//                                var optionKey = key.replace('paymentHandlingOption_', '');
//                                obj.paymentHandlingOptions.push(optionKey);
//                            }
//                        }
//                        else if( key == "deviceOwnerId" ) {
//                            var index = vm.types.deviceOwner[row.serviceContractId].en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.deviceOwner[row.serviceContractId].jp.indexOf(row[key]);
//                            }
//                            obj['deviceOwnerId'] = vm.types.deviceOwner[row.serviceContractId].key[index];
//                        }
//                        else if( key == "status" ) {
//                            var index = vm.types.DeviceInstallationStatus.en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.DeviceInstallationStatus.jp.indexOf(row[key]);
//                            }
//                            var indexValue = vm.types.DeviceInstallationStatus.key[index];
//
//
//                            if(indexValue == "DRAFT" && !isDraft) {
//                                obj['status'] = "REGISTERED";
//                            }
//                            else
//                                obj['status'] = indexValue;
//
//                        }
//                        else if( key == "type" ) {
//                            var index = vm.types.maroonDataType.en.indexOf(row[key]);
//                            if (index < 0) {
//                                index = vm.types.maroonDataType.jp.indexOf(row[key]);
//                            }
//                            obj['type'] = vm.types.maroonDataType.key[index];
//                        }
                        else {
                            obj[key] = row[key]
                        }
                    })

//                    obj['transportPaymentHandlingOption'] = DeviceRequestUtilService.getTransportPaymentOptionKeyFromText(vm.types.TransportPaymentOptions, row['paymentHandlingOption_TRANSPORT']);
//                    obj.paymentHandlingOptions = obj.paymentHandlingOptions.filter(function (d) { return d!="TRANSPORT" });
//                    if(obj['transportPaymentHandlingOption'] !== "-") {
//                        obj.paymentHandlingOptions.push("TRANSPORT");
//                    }
//
//                    if( !(obj['version'] || "1.7").startsWith("2.") ) {
//                        obj['version'] = "2.0";
//                    }
                    var long = baUtil.convertJpDateToTimestamp(obj['reflectionDate'])
                    obj['reflectionDate'] = long;
                    data.push(obj)
                })

                data = data.filter(function(d, i){ return !vm.tableData[i].readOnly });
                if(!data.length) return;

                if(data.length > 9) {
                    vm.modal = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/modalTemplates/loadingModal.html',
                        size: "sm",
                        resolve: {
                          items: function () {
                            return $scope.items;
                        }}
                    });
                }

                vm.createInProgress = true;

                ServiceContractService
                .applyMarron( data, $stateParams.serviceContractId )
                .then(function success(response) {

                    if(vm.modal) {
                        vm.modal.close();
                    }
                    vm.createInProgress = false;
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.go('main.serviceContract.list');
                }, function err(err) {

                    if(vm.modal) {
                        vm.modal.close();
                    }
                    vm.createInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }



        function uploadJescaCsv(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 10485760;
            if(baUtil.checkForInvalidExtension(name.toLowerCase(), [".csv"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.10"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.uploadingJescaCsv = true;

                DeviceRequestService
                .uploadJescaRequest(file)
                .then(function (response) {
                    vm.newDeviceInProgress = false;
                    $state.go('main.deviceRequest.jesca', { maroonData: response });
                    }, function err(err) {
                    ev.target.value = "";
                    vm.uploadingJescaCsv = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            }
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('ListContractCtrl', ListContractCtrl)
        .run(function(Idle){
            // start watching when the app runs. also starts the Keepalive service by default.
            Idle.watch();
        });

    /** @ngInject */
    function ListContractCtrl(allTypes, baUtil, $timeout, $translate, toastr, ServiceContractService, scListPromise, $uibModal, $state, Upload, API_CONFIG, $filter, AuthService, $window, FileSaver, Blob, Idle, $scope) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.init = init;
        vm.searchSC = searchSC;
        vm.openFilterModal = openFilterModal;
        vm.uploadFile = uploadFile;
        vm.openDetail = openDetail;
        vm.downloadCSV = downloadCSV;
        vm.downloadMutlipleCSV = downloadMutlipleCSV;
        vm.query = {}
        vm.paginateCallback = paginateCallback
        vm.getOwnerIds = getOwnerIds;
        vm.getOwnerName = getOwnerName;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.localTranslator = $filter('translate');
        vm.isDownloadingExcel = false;
        vm.isDownloadingMultipleExcel = false;
        init();


        if (scListPromise.status >= 200 && scListPromise.status <= 299) {
            vm.scListResponse = scListPromise.data.data;
        } else {
            return;
        }

        function init() {
            vm.scListResponse = {
                content: []
            };
            vm.search = {
                query : ''
            }
        }

        function getOwnerIds(dtos) {
            return dtos.filter(function(x){ return !!x;}).map(function(x){ return x.deviceOwnerCode}).join(" , ");
        }


        function getOwnerName(dtos) {
            return dtos.filter(function(x){ return !!x;}).map(function(x){ return x.name}).join(" , ");
        }

        function searchSC() {
            ServiceContractService.search(vm.search.query)
            .then(function s(response) {
                vm.scListResponse = response.data.data;
            },function err(err) {
            })
        }

        function openFilterModal(page, size) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                resolve: {
                    items: function () {
                        return [];
                    }
                }
            });
        }

        function openDetail(ev, obj) {
            $state.go('main.serviceContract.detail', { contractId: obj.serviceContractId});
        }

        function downloadCSV(scId) {
            vm.isDownloadingExcel = true;
            ServiceContractService.downloadCSV(scId)
                .then(function (response) {
                    vm.isDownloadingExcel = false;
                    var headers = response.headers();
                    var filename = headers["content-disposition"];
                    filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                    if (filename.length > 150) {
                        filename = filename.substring(0, 150);
                        var currentDate = $filter('date')(new Date(), 'yyyyMMdd');
                        filename = filename + '..._' + currentDate +'.csv';
                    }
                    var serverData = new Blob([response.data], {type: headers['content-type']});
                    FileSaver.saveAs(serverData, filename);
            },function (err) {
                        vm.isDownloadingExcel = false;
                        if ("TextDecoder" in window) {
                            var enc = new TextDecoder("utf-8");
                            var data = enc.decode(err.data);
                            try {
                                 err = JSON.parse(data);
                            } catch(ignore){ }
                        }
                       toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions());
                    });
                }

        function downloadMutlipleCSV() {
            vm.isDownloadingMultipleExcel = true;
                    ServiceContractService.downloadPaymentHandingFeeCSV()
                        .then(function (response) {
                            var headers = response.headers();
                            var filename = headers["content-disposition"];
                            filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                            if (filename.length > 150) {
                                filename = filename.substring(0, 150);
                                var currentDate = $filter('date')(new Date(), 'yyyyMMdd');
                                filename = filename + '..._' + currentDate +'.csv';
                            }
                            var serverData = new Blob([response.data], {type: headers['content-type']});
                            FileSaver.saveAs(serverData, filename);
                    },function (err) {
                                vm.isDownloadingExcel = false;
                                if ("TextDecoder" in window) {
                                    var enc = new TextDecoder("utf-8");
                                    var data = enc.decode(err.data);
                                    try {
                                         err = JSON.parse(data);
                                    } catch(ignore){ }
                                }
                               toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions());
                            });

                    ServiceContractService.downloadServiceFeeCSV()
                        .then(function (response) {
                                var headers = response.headers();
                                var filename = headers["content-disposition"];
                                filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                                if (filename.length > 150) {
                                    filename = filename.substring(0, 150);
                                    var currentDate = $filter('date')(new Date(), 'yyyyMMdd');
                                    filename = filename + '..._' + currentDate +'.csv';
                                }
                                var serverData = new Blob([response.data], {type: headers['content-type']});
                                FileSaver.saveAs(serverData, filename);
                        },function (err) {
                                    vm.isDownloadingExcel = false;
                                    if ("TextDecoder" in window) {
                                        var enc = new TextDecoder("utf-8");
                                        var data = enc.decode(err.data);
                                        try {
                                             err = JSON.parse(data);
                                        } catch(ignore){ }
                                    }
                                   toastr.error(
                                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                                    vm.localTranslator("common.components.title.error"),
                                    baUtil.toastOptions());
                                });
                                
                                
                    ServiceContractService.downloadSettlementMethodCSV()
                        .then(function (response) {
                            var headers = response.headers();
                            var filename = headers["content-disposition"];
                            filename = decodeURIComponent(filename.substring(filename.indexOf("filename=") + 9));
                            if (filename.length > 150) {
                                filename = filename.substring(0, 150);
                                var currentDate = $filter('date')(new Date(), 'yyyyMMdd');
                                filename = filename + '..._' + currentDate +'.csv';
                            }
                            var serverData = new Blob([response.data], {type: headers['content-type']});
                            FileSaver.saveAs(serverData, filename);
                    },function (err) {
                                vm.isDownloadingExcel = false;
                                if ("TextDecoder" in window) {
                                    var enc = new TextDecoder("utf-8");
                                    var data = enc.decode(err.data);
                                    try {
                                         err = JSON.parse(data);
                                    } catch(ignore){ }
                                }
                               toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions());
                            });
                        vm.isDownloadingMultipleExcel = false;

        }        

        function uploadFile(file, ev) {
            var name = file.name;
            var size = file.size;
            var maxSize = 5242880;
            if(baUtil.checkForInvalidExtension(name, [".xlsx"])) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.format"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else if(size > maxSize) {
                toastr.error(
                    vm.localTranslator("common.components.msg.csv.max.size.5"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            } else {
                vm.uploadInProgress = true;
                var promise = Upload.upload({
                    url: API_CONFIG.url + '/api/v1/sc/parse',
                    data: {
                        file: file
                    },
                    headers: {
                        'X-COV-TOKEN': AuthService.getToken(),
                        'Accept-Language': $translate.use(),
                        'Pragma': 'no-cache',
                        'Cache-Control': 'no-cache'
                    }
                });
                promise.then(function (response) {
                    vm.uploadInProgress = false;
                    $state.go('main.serviceContract.create', { contractInfo: response.data});
                }, function (err) {
                    ev.target.value = "";
                    vm.uploadInProgress = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions());
                    });
                }
        }

        function paginateCallback(query) {
            ServiceContractService.search(baUtil.makeQueryString(query))
                .then(function (response) {
                    vm.scListResponse = response.data.data;
                    vm.query = query;
                });
        }

        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.types = allTypes.data.data;
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('NewContractCtrl', NewContractCtrl);

    /** @ngInject */
    function NewContractCtrl(allTypes, branchProperty,emvProperty, ServiceContractService, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, $location, $filter, $anchorScroll) {
        var vm = this;

        vm.getDeviceOwner = getDeviceOwner;
        vm.onOrgSelected = onOrgSelected;
        vm.onBankSelected = onBankSelected;
        vm.bankCodeChange = bankCodeChange;
        vm.onBankBranchSelected = onBankBranchSelected;
        vm.bankBranchCodeChange = bankBranchCodeChange;
        vm.createServiceContract = createServiceContract;
        vm.addNewRow = addNewRow;
        vm.enableButton = enableButton;
        vm.disableButton = disableButton;
        vm.btnClick = false;
        vm.bankData = {};
        vm.bankBranchData = {};
        vm.paymentHandlingFeeCreateDtos = {
            'ME_10': {
                'E_MONEY':{},
                'QR_MONEY':{},
                'CREDIT_CARD':[{
                    "paymentType": "CREDIT_CARD",
                    "paymentOption": "VISA",
                    "paymentDeductionOption": "PERCENTAGE",
                    "rateOrAmount": 0,
                    "createSettlement": false,
                    "nonTaxable": false,
                    "deviceTypes": "ME-10"
                },
                {
                    "paymentType": "CREDIT_CARD",
                    "paymentOption": "MASTERCARD",
                    "paymentDeductionOption": "PERCENTAGE",
                    "rateOrAmount": 0,
                    "createSettlement": false,
                    "nonTaxable": false,
                    "deviceTypes": "ME-10"
                },
                {
                    "paymentType": "CREDIT_CARD",
                    "paymentOption": "AMERICANEXPRESS",
                    "paymentDeductionOption": "PERCENTAGE",
                    "rateOrAmount": 0,
                    "createSettlement": false,
                    "nonTaxable": false,
                    "deviceTypes": "ME-10"
                },
                {
                    "paymentType": "CREDIT_CARD",
                    "paymentOption": "JCB",
                    "paymentDeductionOption": "PERCENTAGE",
                    "rateOrAmount": 0,
                    "createSettlement": false,
                    "nonTaxable": false,
                    "deviceTypes": "ME-10"
                },
                {
                    "paymentType": "CREDIT_CARD",
                    "paymentOption": "DISCOVER",
                    "paymentDeductionOption": "PERCENTAGE",
                    "rateOrAmount": 0,
                    "createSettlement": false,
                    "nonTaxable": false,
                    "deviceTypes": "ME-10"
                },
                {
                    "paymentType": "CREDIT_CARD",
                    "paymentOption": "DINERS",
                    "paymentDeductionOption": "PERCENTAGE",
                    "rateOrAmount": 0,
                    "createSettlement": false,
                    "nonTaxable": false,
                    "deviceTypes": "ME-10"
                }
            ]},
            'ME_20_1': {
                'E_MONEY':{},
                'QR_MONEY':{},
                'CREDIT_CARD':{}
            },
            'ME_20_2': {
                'E_MONEY':{},
                'QR_MONEY':{},
                'CREDIT_CARD':{}
            },
             'ME_5_1': {
                'E_MONEY':{},
                'QR_MONEY':{},
                'CREDIT_CARD':{},
            },
        }
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.isRepresentativeRequired = isRepresentativeRequired;
        vm.removeRow = removeRow;
        vm.localTranslator = $filter('translate');
        vm.rent = true;
        vm.detailErrors = false;
        vm.isXlUpload = false;
        vm.submitBtn = false;
        vm.byBranch = false;
        vm.showSettlement = false;
        vm.radioChange = radioChange;
        vm.paymentMethodChange = paymentMethodChange;
        vm.settlementMethodChange = settlementMethodChange;
        vm.getPartner = getPartner;
        vm.onPartnerSelected = onPartnerSelected;
        vm.handlingFeeEmoneyForME_10SelectAll = handlingFeeEmoneyForME_10SelectAll;
        vm.handlingFeeQRmoneyForME_10SelectAll = handlingFeeQRmoneyForME_10SelectAll;
        vm.handlingFeeCreditCardForME_10SelectAll = handlingFeeCreditCardForME_10SelectAll;
        vm.handlingFeeEmoneyForME_20_1SelectAll = handlingFeeEmoneyForME_20_1SelectAll;
        vm.handlingFeeQRmoneyForME_20_1SelectAll = handlingFeeQRmoneyForME_20_1SelectAll;
        vm.handlingFeeCreditCardForME_20_1SelectAll = handlingFeeCreditCardForME_20_1SelectAll;
        vm.handlingFeeEmoneyForME_20_2SelectAll = handlingFeeEmoneyForME_20_2SelectAll;
        vm.handlingFeeQRmoneyForME_20_2SelectAll = handlingFeeQRmoneyForME_20_2SelectAll;
        vm.handlingFeeCreditCardForME_20_2SelectAll = handlingFeeCreditCardForME_20_2SelectAll;
        vm.handlingFeeQRmoneyForME_5_1SelectAll = handlingFeeQRmoneyForME_5_1SelectAll;
        vm.dobOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date(1901,0,1),
            maxDate : new Date()
        }
        vm.isSystemAdmin = baUtil.isSystemAdmin();

        function radioChange(index) {
            if (index == "0") {
                vm.rent = false;
                vm.contractInfo.deviceOwnerSummaries = [{}]
            }
            else if (index == "1") {
                vm.rent = true;
            }
            else if (index == "2") {
                vm.rent = true;
            }

        }


        vm.contractInfo = {
            "organisationCreateDto": {
                "addressCreateDtos": [{
                    "contactCreateDtos": [{}]
                }],
                "accountCreateDtos": [{
                    "contactCreateDtos": [{}]
                }],
                "organisationRepresentativeCreateDtos": [{
                    "addressCreateDtos": [{
                        "contactCreateDtos": [{}]
                    }]
                }],
                "organisationBranchCreateDtos": [{
                    "accountCreateDtos": [{
                        "contactCreateDtos": [{}]
                    }],
                    "addressCreateDto": {
                        "contactCreateDtos": [{}]
                    }
                }],

            },
            "paymentHandlingFeeCreateDtos": [{}],
            "serviceFeeCreateDtos": [{}],
            "settlementMethodCreateDto": {},
            "settlementBranchCreateDtos": [{
                "settlementSendLocationCreateDtos": [{
                    "addressCreateDto": {
                        "contactCreateDtos": [{}]
                    }
                }]
            }],
            "deviceOwnerSummaries": [{}],
            "partnerSummaries": [{}],
            "ownerCanApplyForDevice": true,
            "ownerMustApproveDeviceRequest": false,
            "merchantCanApplyForDeviceRequest": false,
            "serviceContractEmvCreateDto":{}
        }

        vm.otherServiceFeeDtos =  {
            builtIn_initial : {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },       
            builtIn_monthly:  
            {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external_initial:  {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn20_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn20_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external20_initial: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external20_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn5_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn5_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 7,
                rangeEnd:7,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
        }

        vm.qrOtherServiceFeeDtos =  {
            builtIn_initial : {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },       
            builtIn_monthly:  
            {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external_initial:  {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn20_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn20_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external20_initial: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external20_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn5_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn5_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "QR_MONEY",
                rangeStart: 15,
                rangeEnd:15,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
        }

        vm.baseServiceFeeDtos =  {
            builtIn_initial : {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd: 0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },   
            builtIn_monthly:  
            {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external_initial:  {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd: 0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn20_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn20_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external20_initial: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external20_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn5_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn5_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "E_MONEY",
                rangeStart: 0,
                rangeEnd:0,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
        }

        vm.serviceFeeDtosCreditCard =  {
            builtIn_initial : {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd: 1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },   
            builtIn_monthly:  
            {
                deviceTypes: undefined,
                modemType: "BUILT_IN",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external_initial:  {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd: 1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn20_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn20_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_20",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            external20_initial: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            external20_monthly: {
                deviceTypes: undefined,
                modemType: "EXTERNAL_20",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
            builtIn5_initial: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "INITIAL"
            },
            builtIn5_monthly: {
                deviceTypes: undefined,
                modemType: "BUILT_IN_5",
                paymentDeductionOption: "FLAT",
                paymentType: "CREDIT_CARD",
                rangeStart: 1,
                rangeEnd:1,
                rateOrAmount: 0,
                serviceFeeFrequency: "MONTHLY"
            },
        }


        vm.serviceFeeCreateDtos = {
            "builtIn_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "external_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "external_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn20_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn20_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "external20_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "external20_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn5_initial": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
            "builtIn5_monthly": {
                eMoney: [],
                qrMoney: [],
                creditCard: [],
            },
        }

        vm.contractInfo.date = new Date();
        vm.contractInfo.version = '2.0';
        vm.contractInfo.settlementMethodCreateDto.settlementGroup = 'THIRD_OF_MONTH';

        vm.contractInfo.organisationCreateDto.subOrganisationType = 'ORGANISATION';
        // vm.deviceOwnerDto = [{}];
        vm.contractInfo.settlementMethodCreateDto.emailInvoice = true;
        vm.contractInfo.settlementMethodCreateDto.enableTelemetryOption = false;

        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.types = allTypes.data.data;
        }

        if (branchProperty.status >= 200 && branchProperty.status <= 299) {
            vm.branchProperty = branchProperty.data.data;
            vm.branchCodeMaxLength = vm.branchProperty.branchCodeLength;
            vm.branchNameMaxLength = vm.branchProperty.branchNameLength;
        }
        else {
            vm.branchCodeMaxLength = 6;
            vm.branchNameMaxLength = 50;
        }

        if(emvProperty.status>=200 && emvProperty.status <= 299){
            vm.emvProperty = emvProperty.data.data;
            vm.contractInfo.serviceContractEmvCreateDto.tid = vm.emvProperty.terminalIdentificationNumberMUN;
            vm.contractInfo.serviceContractEmvCreateDto.senderId = vm.emvProperty.senderIdMUN;
            vm.contractInfo.serviceContractEmvCreateDto.receipientIdMUN = vm.emvProperty.receipientIdMUN;
            vm.contractInfo.serviceContractEmvCreateDto.receipientIdJCB = vm.emvProperty.receipientIdJCB;
        }

        vm.types.createInvoice  = {
            en:['Yes','No'],
            jp:['はい','いいえ'],
            key:[true,false]
        }

        vm.types.emailInvoice  = {
            en:['Yes','No'],
            jp:['する','しない'],
            key:[true,false]
        }

        vm.contractInfo.jmupsTemplate = vm.types.JmupsTemplateMaster.default[0];
        vm.contractInfo.serviceContractEmvCreateDto.senderIdType = vm.types.SenderIdType.default[0];

        if (!baUtil.isUndefinedOrNull($stateParams.contractInfo)) {
            vm.contractInfo = $stateParams.contractInfo.data
            if (!vm.contractInfo.serviceContractEmvCreateDto) {
                vm.contractInfo.serviceContractEmvCreateDto = {};
            }
            vm.contractInfo.serviceContractEmvCreateDto.senderIdType = vm.types.SenderIdType.default[0];
            vm.contractInfo.serviceContractEmvCreateDto.tid = vm.emvProperty.terminalIdentificationNumberMUN;
            vm.contractInfo.serviceContractEmvCreateDto.senderId = vm.emvProperty.senderIdMUN;
            vm.contractInfo.serviceContractEmvCreateDto.receipientIdMUN = vm.emvProperty.receipientIdMUN;
            vm.contractInfo.serviceContractEmvCreateDto.receipientIdJCB = vm.emvProperty.receipientIdJCB;
            
            vm.merchantOwnerType = vm.contractInfo.merchantOwnerType;

            vm.isXlUpload = true;
            vm.showSettlement = true;
            vm.settlementMethodChange();
            vm.contractInfo.ownerCanApplyForDevice = true;

            if (vm.contractInfo.merchantOwnerType == "MERCHANT_OWNER_SELF_DEVICE_ONLY") {
                vm.rent = false;
            }
            else {
                vm.rent = true;
            }

             if (!baUtil.isUndefinedOrNullOrEmptyList(vm.contractInfo.paymentHandlingFeeCreateDtos)) {
                 vm.contractInfo.paymentHandlingFeeCreateDtos.forEach(function (item) {
                    if (item.deviceTypes === "ME-10") {

                        if(item.paymentType === "E_MONEY"){
                            vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.E_MONEY.key)] = item
                        }
                        
                        if (item.paymentType === "QR_MONEY") {
                            vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.QR_MONEY.key)] = item
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            vm.paymentHandlingFeeCreateDtos.ME_10.CREDIT_CARD[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.CREDIT_CARD.key)] = item
                        }

                    }
                        
                    if (item.deviceTypes === "ME-20-1") {

                        if(item.paymentType === "E_MONEY"){
                            vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.E_MONEY.key)] = item
                        }

                       if (item.paymentType === "QR_MONEY") {
                            vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.QR_MONEY.key)] = item
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.CREDIT_CARD.key)] = item
                        }
                    }

                    if(item.deviceTypes === "ME-20-2"){

                        if (item.paymentType === "E_MONEY") {
                            vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.E_MONEY.key)] = item
                        }
    
                        if (item.paymentType === "QR_MONEY") {
                            vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.QR_MONEY.key)] = item
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.CREDIT_CARD.key)] = item
                        }
                    }

                    if (item.deviceTypes === "ME-5-1") {

                        if(item.paymentType === "E_MONEY"){
                            vm.paymentHandlingFeeCreateDtos.ME_5_1.E_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.E_MONEY.key)] = item
                        }

                       if (item.paymentType === "QR_MONEY") {
                            vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.QR_MONEY.key)] = item
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            vm.paymentHandlingFeeCreateDtos.ME_5_1.CREDIT_CARD[getIndexInPaymentDeductionOption(item.paymentOption, vm.types.PaymentHandlingOption.CREDIT_CARD.key)] = item
                        }
                    }
                })
            }

            vm.handlingFeeSelectAllEmoney = true;
            angular.forEach(vm.paymentHandlingFeeCreateDtos.E_MONEY, function (key) {
                if (key.createSettlement === false) {
                    vm.handlingFeeSelectAllEmoney = false;
                }
            });

            vm.handlingFeeSelectAllQRmoney = true;
            angular.forEach(vm.paymentHandlingFeeCreateDtos.QR_MONEY, function (key) {
                if (key.createSettlement === false) {
                    vm.handlingFeeSelectAllQRmoney = false;
                }
            });

            if (!baUtil.isUndefinedOrNullOrEmptyList(vm.contractInfo.serviceFeeCreateDtos)) {
                vm.contractInfo.serviceFeeCreateDtos.forEach(function (item) {
                    if (item.modemType === "BUILT_IN" && baUtil.isUndefinedOrNull(vm.builtIn_deviceType)) {
                        vm.builtIn_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "EXTERNAL" && baUtil.isUndefinedOrNull(vm.external_deviceType)) {
                        vm.external_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "BUILT_IN_20" && baUtil.isUndefinedOrNull(vm.builtIn_deviceType)) {
                        vm.builtIn_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "EXTERNAL_20" && baUtil.isUndefinedOrNull(vm.external_deviceType)) {
                        vm.external_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "BUILT_IN_5" && baUtil.isUndefinedOrNull(vm.builtIn_deviceType)) {
                        vm.builtIn_deviceType = item.deviceTypes
                    }

                    if (item.modemType === "BUILT_IN" && item.serviceFeeFrequency === "INITIAL") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.builtIn_initial = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.builtIn_initial = item;
                            } else{
                                vm.serviceFeeCreateDtos.builtIn_initial.eMoney.push(item)
                            }
                        } 

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.builtIn_initial = item;
                            } else{
                            vm.serviceFeeCreateDtos.builtIn_initial.qrMoney.push(item)

                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.builtIn_initial = item;
                            } else{
                            vm.serviceFeeCreateDtos.builtIn_initial.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "BUILT_IN" && item.serviceFeeFrequency === "MONTHLY") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.builtIn_monthly = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.builtIn_monthly = item;
                            }
                             else{
                                vm.serviceFeeCreateDtos.builtIn_monthly.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.builtIn_monthly = item;
                            } else{
                            vm.serviceFeeCreateDtos.builtIn_monthly.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.builtIn_monthly = item;
                            } else{
                            vm.serviceFeeCreateDtos.builtIn_monthly.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "EXTERNAL" && item.serviceFeeFrequency === "INITIAL") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.external_initial = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.external_initial = item;
                            } else {
                                vm.serviceFeeCreateDtos.external_initial.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.external_initial = item;
                            } else {
                            vm.serviceFeeCreateDtos.external_initial.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.external_initial = item;
                            } else{
                            vm.serviceFeeCreateDtos.external_initial.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "EXTERNAL" && item.serviceFeeFrequency === "MONTHLY") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.external_monthly = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.external_monthly = item;
                            }
                             else {
                                vm.serviceFeeCreateDtos.external_monthly.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) && (item.rangeEnd === 15)){
                                vm.qrOtherServiceFeeDtos.external_monthly = item;
                            }else{
                            vm.serviceFeeCreateDtos.external_monthly.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.external_monthly = item;
                            } else{
                            vm.serviceFeeCreateDtos.external_monthly.creditCard.push(item)

                            }
                        }
                    }

                    // NEW IMPLEMENTATION

                    if (item.modemType === "BUILT_IN_20" && item.serviceFeeFrequency === "INITIAL") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.builtIn20_initial = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.builtIn20_initial = item;
                            } else{
                                vm.serviceFeeCreateDtos.builtIn20_initial.eMoney.push(item)
                            }
                        } 

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.builtIn20_initial = item;
                            } else{
                            vm.serviceFeeCreateDtos.builtIn20_initial.qrMoney.push(item)

                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.builtIn20_initial = item;
                            } else{
                            vm.serviceFeeCreateDtos.builtIn20_initial.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "BUILT_IN_20" && item.serviceFeeFrequency === "MONTHLY") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.builtIn20_monthly = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.builtIn20_monthly = item;
                            }
                             else{
                                vm.serviceFeeCreateDtos.builtIn20_monthly.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.builtIn20_monthly = item;
                            } else{
                            vm.serviceFeeCreateDtos.builtIn20_monthly.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.builtIn20_monthly = item;
                            } else{
                            vm.serviceFeeCreateDtos.builtIn20_monthly.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "EXTERNAL_20" && item.serviceFeeFrequency === "INITIAL") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.external20_initial = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.external20_initial = item;
                            } else {
                                vm.serviceFeeCreateDtos.external20_initial.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.external20_initial = item;
                            } else {
                            vm.serviceFeeCreateDtos.external20_initial.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.external20_initial = item;
                            } else{
                            vm.serviceFeeCreateDtos.external20_initial.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "EXTERNAL_20" && item.serviceFeeFrequency === "MONTHLY") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.external20_monthly = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.external20_monthly = item;
                            }
                             else {
                                vm.serviceFeeCreateDtos.external20_monthly.eMoney.push(item)
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) && (item.rangeEnd === 15)){
                                vm.qrOtherServiceFeeDtos.external20_monthly = item;
                            }else{
                            vm.serviceFeeCreateDtos.external20_monthly.qrMoney.push(item)
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.external20_monthly = item;
                            } else{
                            vm.serviceFeeCreateDtos.external20_monthly.creditCard.push(item)

                            }
                        }
                    }

                    if (item.modemType === "BUILT_IN_5" && item.serviceFeeFrequency === "INITIAL") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.builtIn5_initial = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.builtIn5_initial = item;
                            } else{
                                vm.serviceFeeCreateDtos.builtIn5_initial.eMoney.push(item);
                            }
                        } 

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.builtIn5_initial = item;
                            } else{
                                vm.serviceFeeCreateDtos.builtIn5_initial.qrMoney.push(item);
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.builtIn5_initial = item;
                            } else{
                                vm.serviceFeeCreateDtos.builtIn5_initial.creditCard.push(item);
                            }
                        }
                    }

                    if (item.modemType === "BUILT_IN_5" && item.serviceFeeFrequency === "MONTHLY") {
                        if (item.paymentType === "E_MONEY") {
                            if((item.rangeStart === 7) &&  (item.rangeEnd === 7)) {
                                vm.otherServiceFeeDtos.builtIn5_monthly = item;
                            }
                            else if((item.rangeStart === 0) && (item.rangeEnd === 0)){
                                vm.baseServiceFeeDtos.builtIn5_monthly = item;
                            }
                             else{
                                vm.serviceFeeCreateDtos.builtIn5_monthly.eMoney.push(item);
                            }
                        }

                        if (item.paymentType === "QR_MONEY") {
                            if((item.rangeStart === 15) &&  (item.rangeEnd === 15)) {
                                vm.qrOtherServiceFeeDtos.builtIn5_monthly = item;
                            } else{
                                vm.serviceFeeCreateDtos.builtIn5_monthly.qrMoney.push(item);
                            }
                        }

                        if (item.paymentType === "CREDIT_CARD") {
                            if((item.rangeStart === 1) &&  (item.rangeEnd === 1)) {
                                vm.serviceFeeDtosCreditCard.builtIn5_monthly = item;
                            } else{
                              vm.serviceFeeCreateDtos.builtIn5_monthly.creditCard.push(item);
                            }
                        }
                    }

                    //END

                })
            }
            if (baUtil.isUndefinedOrNullOrEmptyList(vm.contractInfo.deviceOwnerSummaries)) {
                vm.contractInfo.deviceOwnerSummaries = [{}];
            }
            else {
                vm.contractInfo.deviceOwnerSummaries = vm.contractInfo.deviceOwnerSummaries || []
            }

            if (baUtil.isUndefinedOrNullOrEmptyList(vm.contractInfo.partnerSummaries)) {
                vm.contractInfo.partnerSummaries = [{}];
            }
            else {
                vm.contractInfo.partnerSummaries = vm.contractInfo.partnerSummaries || []
            }

        }



        Object.keys(vm.serviceFeeCreateDtos).forEach(function (item) {
            var obj = vm.serviceFeeCreateDtos[item]
            Object.keys(obj).forEach(function (type) {
                var typeList = obj[type]
                if (baUtil.isUndefinedOrNullOrEmptyList(typeList)) {
                    typeList.push({ rangeStart: 1 });
                }
            })
        })


        function getIndexInPaymentDeductionOption(key, list) {
            return list.findIndex(function (item) {
                return item === key
            })
        }
        function getLang() {
            return $translate.use();
        }
        function getDeviceOwner(query) {
            return ServiceContractService.getDeviceOwner(query)
        }

        function getPartner(query) {
            return ServiceContractService.getPartner(query)
        }

        function handlingFeeEmoneyForME_10SelectAll() {
            if (vm.handlingFeeME_10SelectAllEmoney){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeQRmoneyForME_10SelectAll() {
            if (vm.handlingFeeME_10SelectAllQRmoney){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeCreditCardForME_10SelectAll() {
            if (vm.handlingFeeME_10SelectAllCreditCard){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_10.CREDIT_CARD,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_10.CREDIT_CARD,function (item){
                    item.createSettlement = false;
                })
            }
        }
        
        // ME_20_1
        function handlingFeeEmoneyForME_20_1SelectAll() {
            if (vm.handlingFeeME_20_1SelectAllEmoney){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeQRmoneyForME_20_1SelectAll() {
            if (vm.handlingFeeME_20_1SelectAllQRmoney){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeCreditCardForME_20_1SelectAll() {
            if (vm.handlingFeeME_20_1SelectAllCreditCard){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD,function (item){
                    item.createSettlement = false;
                })
            }
        }
        //End

        //ME-5 START
        function handlingFeeQRmoneyForME_5_1SelectAll() {
            if (vm.handlingFeeME_5_1SelectAllQRmoney){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        //ME-5 END

        // ME_20_2
        function handlingFeeEmoneyForME_20_2SelectAll() {
            if (vm.handlingFeeME_20_2SelectAllEmoney){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeQRmoneyForME_20_2SelectAll() {
            if (vm.handlingFeeME_20_2SelectAllQRmoney){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY,function (item){
                    item.createSettlement = false;
                })
            }
        }
        function handlingFeeCreditCardForME_20_2SelectAll() {
            if (vm.handlingFeeME_20_2SelectAllCreditCard){
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD,function (item){
                    item.createSettlement = true;
                })
            }
            else {
                angular.forEach(vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD,function (item){
                    item.createSettlement = false;
                })
            }
        }
        //End

        function onOrgSelected(data, index) {
            var filteredData = $filter('filter')(vm.contractInfo.deviceOwnerSummaries, data);
            if(filteredData.length) {
                vm.newContractForm['deviceOwner_' + index].$setViewValue("");
                toastr.error(
                    vm.localTranslator("service.contract.create.deviceOwner.warning.msg"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                return;
            }
            vm.contractInfo.deviceOwnerSummaries[index].name = data.name;
            vm.contractInfo.deviceOwnerSummaries[index].deviceOwnerCode = data.deviceOwnerCode;
            vm.contractInfo.deviceOwnerSummaries[index].organisationId = data.organisationId;
        }


    
        function onPartnerSelected(data, index) {
            var filteredData = $filter('filter')(vm.contractInfo.partnerSummaries, data);
            if(filteredData.length) {
                vm.newContractForm['partnerSummaries_' + index].$setViewValue("");
                toastr.error(
                    vm.localTranslator("partner.warning.msg"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                return;
            }
            
            vm.contractInfo.partnerSummaries[index].name = data.name;
            vm.contractInfo.partnerSummaries[index].partnerCode = data.partnerCode;
            vm.contractInfo.partnerSummaries[index].organisationId = data.organisationId;
        }

        function bankCodeChange(bankCode) {
            return ServiceContractService.getDataFromBankCode(bankCode)
        }

        function onBankSelected(data, index) {
            vm.bankData = data
            vm.contractInfo.settlementBranchCreateDtos[index].settlementBankCreateDto.bankName = data.bankName
        }

        function bankBranchCodeChange(branchCode) {
            return ServiceContractService.getDataFromBankBranchCode(vm.bankData.bankCode, branchCode)
        }

        function onBankBranchSelected(data, index) {
            vm.bankBranchData = data
            vm.contractInfo.settlementBranchCreateDtos[index].settlementBankCreateDto.branchName = data.branchName
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }


        function paymentMethodChange(index) {

            if (!vm.isXlUpload && vm.contractInfo.settlementMethodCreateDto.paymentMethod === 'OFFSETTING') {
                vm.showSettlement = true;
                vm.contractInfo.settlementBranchCreateDtos = [{

                    "settlementSendLocationCreateDtos": [{
                        "addressCreateDto": {
                            "contactCreateDtos": [{}]
                        },
                        "branchLocationType": "OFFSET_NOTIFICATION"
                    }]


                }]

                return;

            }

            if (!vm.isXlUpload && vm.contractInfo.settlementMethodCreateDto.paymentMethod === 'NON_OFFSETTING') {
                vm.showSettlement = true;
                vm.contractInfo.settlementBranchCreateDtos = [{

                    "settlementSendLocationCreateDtos": [{
                        "addressCreateDto": {
                            "contactCreateDtos": [{}]
                        },
                        "branchLocationType": "INVOICE_DESTINATION"
                    },
                    {
                        "addressCreateDto": {
                            "contactCreateDtos": [{}]
                        },
                        "branchLocationType": "CREDIT_NOTIFICATION"
                    }]

                }]

                return;

            }
        }

        function settlementMethodChange(index) {
            if (vm.contractInfo.settlementMethodCreateDto.invoiceMethod == 'BRANCH') {
                vm.byBranch = true;
            }

            else {
                vm.byBranch = false;
            }


        }


        function addNewRow(list, type) {
            if (baUtil.isUndefinedOrNull(list)) {
                return
            }
            if (type === 'ADD_SETTLEMENT' && vm.contractInfo.settlementMethodCreateDto.paymentMethod === 'OFFSETTING') {
                list.push({
                    "settlementSendLocationCreateDtos": [{
                        "addressCreateDto": {
                            "contactCreateDtos": [{}]
                        },
                        "branchLocationType": "OFFSET_NOTIFICATION"
                    }]
                })
                return
            }
            if (type === 'ADD_SETTLEMENT' && vm.contractInfo.settlementMethodCreateDto.paymentMethod === 'NON_OFFSETTING') {
                list.push({
                    "settlementSendLocationCreateDtos": [{
                        "addressCreateDto": {
                            "contactCreateDtos": [{}]
                        },
                        "branchLocationType": "INVOICE_DESTINATION"
                    },
                    {
                        "addressCreateDto": {
                            "contactCreateDtos": [{}]
                        },
                        "branchLocationType": "CREDIT_NOTIFICATION"
                    }]

                })
                return
            }
            if (type === 'CREATE_ORGANISATION') {
                list.push({
                    "contactCreateDtos": [{}]
                })
                return
            }
            if (type === 'REPRESENTATIVE') {
                list.push({
                    "addressCreateDtos": [{
                        "contactCreateDtos": [{}]
                    }]
                })
                return
            }
            if (type === 'SETTLEMENT_LOCATION') {
                list.push({
                    "addressCreateDto": {
                        "contactCreateDtos": [{}]
                    }
                })
                return
            }
            list.push({})
        }

        function removeRow(list, index) {
            list.splice(index, 1);
        }

        function isRepresentativeRequired(type) {
            return type === 'INDIVIDUAL'
        }

        function enableButton () {
            $timeout(function() {
                vm.btnClick = false;
            }, 1000);
        }

        function disableButton () {
            vm.btnClick = true;
            $timeout(function() {
                vm.btnClick = false;
            }, 2000);
        }

        function createServiceContract() {

           // vm.disableButton();
            vm.submitBtn = true;
            var form = angular.copy(vm.newContractForm);
            var contractInfo = angular.copy(vm.contractInfo);

            if (form.$invalid) {
                $location.hash('top');
                $anchorScroll();

                vm.error = [];
                vm.detailErrors = true;

                for (var key in form.$error) {
                    for (var index = 0; index < form.$error[key].length; index++) {
                        vm.error.push(form.$error[key][index].$name);
                    }
                }

                for (var i = 0; i < vm.error.length; i++) {
                    var exception = vm.types.ModemType.key.some(function(item){
                        return vm.error[i].includes(item);
                    });
                    if(exception){
                        continue;
                    }

                    var oo1 = new RegExp(/_([0-9]|[1-9][0-9])$/);
                    var oo2 = new RegExp(/_([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])$/);
                    var oo3 = new RegExp(/([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])$/);


                    vm.error[i] = vm.error[i].replace(oo1, '_0');
                    vm.error[i] = vm.error[i].replace(oo2, '_0_0');
                    vm.error[i] = vm.error[i].replace(oo3, '0_0_0');
                }

                vm.alerts = []
                vm.errors = []

                var unique = {};

                angular.forEach(vm.error, function (item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });

                vm.poko = {
                    'applicationDate': {
                        'key': 'applicationDate',
                        'en': 'Contract - Application Date',
                        'jp': 'e-MOSS Plus申込書 - 申込年月日'
                    },
                    'applicantNameReading': {
                        'key': 'applicantNameReading',
                        'en': 'Company Information - Name',
                        'jp': '企業情報 - 会社名'
                    },
                    'applicantName': {
                        'key': 'applicantName',
                        'en': 'Company Information - Name (Kana)',
                        'jp': '企業情報 - 会社名 (フリガナ)'
                    },
                    'applicantCompanyCode': {
                        'key': 'applicantCompanyCode',
                        'en': 'Company Information - Company Code',
                        'jp': '企業情報 - 法人コード'
                    },
                    'businessType': {
                        'key': 'businessType',
                        'en': 'Company Information - Business Type',
                        'jp': '企業情報 - 業種業務区分'
                    },
                    'applicantProductHandled': {
                        'key': 'applicantProductHandled',
                        'en': 'Company Information - Products Handled',
                        'jp': '企業情報 - 取扱商品'
                    },
                    'contractTerms': {
                        'key': 'contractTerms',
                        'en': 'e-MOSS Plus Terms & Condition',
                        'jp': '「e-MOSS Plus加盟店規約」'
                    },
                    'companyRepresentativeNameReading_0': {
                        'key': 'companyRepresentativeNameReading_0',
                        'en': 'Company Representative Information - Name (Kana)',
                        'jp': '代表者様情報 - 氏名(フリガナ)'
                    },
                    'companyRepresentativeName_0': {
                        'key': 'companyRepresentativeName_0',
                        'en': 'Company Representative Information - Name',
                        'jp': '代表者様情報 - 氏名'
                    },
                    'representativedob':{
                        'key':'representativedob',
                        'en':'Company Representative - Date of Birth',
                        'jp':'代表者様情報 - 生年月日'

                    },
                    'companyInChargePerson_0': {
                        'key': 'companyInChargePerson_0',
                        'en': 'In-Charge Person - Name',
                        'jp': '担当者情報 - 氏名'
                    },
                    'companyInChargePersonReading_0':{
                        'key':'companyInChargePersonReading_0',
                        'en':'In-Charge Person - Name (Kana)',
                        'jp':'担当者情報 - 氏名 (フリガナ)'

                    },
                    'companyUsername_0': {
                        'key': 'companyUsername_0',
                        'en': 'In-Charge Person - Email',
                        'jp': '担当者情報 - メールアドレス'
                    },
                    'MerchantOwnerType': {
                        'key': 'MerchantOwnerType',
                        'en': 'Link Device Owners - Device Purchase',
                        'jp': '端末借用元情報 - 端末購入'
                    },
                    'deviceOwner_0': {
                        'key': 'deviceOwner_0',
                        'en': 'Device Owner Organisation Name',
                        'jp': '端末借用元情報 - 端末所有者の会社名'
                    },
                    'settlementDate': {
                        'key': 'settlementDate',
                        'en': 'Settlement Conditions - Payment Date',
                        'jp': 'ご精算条件 - 支払日'
                    },
                    'closingDate': {
                        'key': 'closingDate',
                        'en': 'Settlement Conditions - Closing Date',
                        'jp': 'ご精算条件 - 決済端末締め日'
                    },
                    'paymentMethod': {
                        'key': 'paymentMethod',
                        'en': 'Settlement Conditions - Payment Method',
                        'jp': 'ご精算条件 - 諸費用 (B) (C)のお支払い方法'
                    },
                    'createInvoices': {
                        'key': 'createInvoices',
                        'en': 'Settlement Conditions - Create Invoice',
                        'jp': 'ご精算条件 - 請求書作成'
                    },
                    'invoiceMethod': {
                        'key': 'invoiceMethod',
                        'en': 'Settlement Conditions - Settlement Destination',
                        'jp': 'ご精算条件 - 精算先'
                    },
                    'chargeMonthlyFeeFrom': {
                        'key': 'chargeMonthlyFeeFrom',
                        'en': 'Charge Monthly Fee From',
                        'jp': '月額費用の課金開始タイミング'
                    },
                    'builtIn_deviceType': {
                        'key': 'builtIn_deviceType',
                        'en': 'Service Fee - Built-in Modem Type - Applicable Device types',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 端末機種'
                    },
                    'external_deviceType': {
                        'key': 'external_deviceType',
                        'en': 'Service Fee - External Modem Type - Applicable Device types',
                        'jp': 'サービス費用 - 外部モデムタイプ - 端末機種'
                    },
                    'e_money_rateOrAmount_builtIn_deviceType_0': {
                        'key': 'e_money_rateOrAmount_builtIn_deviceType_0',
                        'en': 'Service Fee - Built-in Modem Type - Initial Charges - E Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 初期費用 - 電子マネー数'
                    },
                    'e_money_rangeEnd_builtIn_deviceType_0': {
                        'key': 'e_money_rangeEnd_builtIn_deviceType_0',
                        'en': 'Service Fee - Built-in Modem Type - Initial Charges - E Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 初期費用 - 電子マネー数'
                    },
                    'qr_money_rateOrAmount_builtIn_deviceType_0': {
                        'key': 'qr_money_rateOrAmount_builtIn_deviceType_0',
                        'en': 'Service Fee - Built-in Modem Type - Initial Charges - QR Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 初期費用 - QRマネー数'
                    },
                    'qr_money_rangeEnd_builtIn_deviceType_0': {
                        'key': 'qr_money_rangeEnd_builtIn_deviceType_0',
                        'en': 'Service Fee - Built-in Modem Type - Initial Charges - QR Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 初期費用 - QRマネー数'
                    },
                    'e_money_rateOrAmount_builtIn_monthly_0': {
                        'key': 'e_money_rateOrAmount_builtIn_monthly_0',
                        'en': 'Service Fee - Built-in Modem Type - Monthly Charges - E Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 月額費用 - 電子マネー数'
                    },
                    'e_money_rangeEnd_builtIn_monthly_0': {
                        'key': 'e_money_rangeEnd_builtIn_monthly_0',
                        'en': 'Service Fee - Built-in Modem Type - Monthly Charges - E Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 月額費用 - 電子マネー数'
                    },
                    'qr_money_rateOrAmount_builtIn_monthly_0': {
                        'key': 'qr_money_rateOrAmount_builtIn_monthly_0',
                        'en': 'Service Fee - Built-in Modem Type - Monthly Charges - QR Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 月額費用 - QRマネー数'
                    },
                    'qr_money_rangeEnd_builtIn_monthly_0': {
                        'key': 'qr_money_rangeEnd_builtIn_monthly_0',
                        'en': 'Service Fee - Built-in Modem Type - Monthly Charges - QR Money',
                        'jp': 'サービス費用 - モデム内蔵タイプ - 月額費用 - QRマネー数'
                    },
                    'e_money_rateOrAmount_external_initial_0': {
                        'key': 'e_money_rateOrAmount_external_initial_0',
                        'en': 'Service Fee - External Modem Type - Initial Charges - E Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 初期費用 - 電子マネー数'
                    },
                    'e_money_rangeEnd_external_initial_0': {
                        'key': 'e_money_rangeEnd_external_initial_0',
                        'en': 'Service Fee - External Modem Type - Initial Charges - E Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 初期費用 - 電子マネー数'
                    },
                    'qr_money_rateOrAmount_external_initial_0': {
                        'key': 'qr_money_rateOrAmount_external_initial_0',
                        'en': 'Service Fee - External Modem Type - Initial Charges - QR Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 初期費用 - QRマネー数'
                    },
                    'qr_money_rangeEnd_external_initial_0': {
                        'key': 'qr_money_rangeEnd_external_initial_0',
                        'en': 'Service Fee - External Modem Type - Initial Charges - QR Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 初期費用 - QRマネー数'
                    },
                    'e_money_rateOrAmount_external_monthly_0': {
                        'key': 'e_money_rateOrAmount_external_monthly_0',
                        'en': 'Service Fee - External Modem Type - Monthly Charges - E Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 月額費用 - 電子マネー数'
                    },
                    'e_money_rangeEnd_external_monthly_0': {
                        'key': 'e_money_rangeEnd_external_monthly_0',
                        'en': 'Service Fee - External Modem Type - Monthly Charges - E Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 月額費用 - 電子マネー数'
                    },
                    'qr_money_rateOrAmount_external_monthly_0': {
                        'key': 'qr_money_rateOrAmount_external_monthly_0',
                        'en': 'Service Fee - External Modem Type - Monthly Charges - QR Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 月額費用 - QRマネー数'
                    },
                    'qr_money_rangeEnd_external_monthly_0': {
                        'key': 'qr_money_rangeEnd_external_monthly_0',
                        'en': 'Service Fee - External Modem Type - Monthly Charges - QR Money',
                        'jp': 'サービス費用 - 外部モデムタイプ - 月額費用 - QRマネー数'
                    },
                    'settlementBankCode_0': {
                        'key': 'settlementBankCode_0',
                        'en': 'Bank - FI Code',
                        'jp': 'お振込口座 - 金融機関コード'
                    },
                    'settlementBranchCode_0': {
                        'key': 'settlementBranchCode_0',
                        'en': 'Bank = Branch Code',
                        'jp': 'お振込口座 - 支店コード'
                    },
                    'accountNo_0': {
                        'key': 'accountNo_0',
                        'en': 'Bank - Account No',
                        'jp': 'お振込口座 - 口座番号'
                    },
                    'bankName_0': {
                        'key': 'bankName_0',
                        'en': 'Bank - Name',
                        'jp': 'お振込口座 - 金融機関名'
                    },
                    'branchName_0': {
                        'key': 'branchName_0',
                        'en': 'Bank - Branch/Office Name',
                        'jp': 'お振込口座 - 支店名'
                    },
                    'branchType_0': {
                        'key': 'branchType_0',
                        'en': 'Bank - Branch/Office Name',
                        'jp': 'お振込口座 - 支店名'
                    },
                    'bankType_0': {
                        'key': 'bankType_0',
                        'en': 'Bank - Type',
                        'jp': 'お振込口座 - 金融機関'
                    },
                    'bankAccountType_0': {
                        'key': 'bankAccountType_0',
                        'en': 'Bank - Type of Account',
                        'jp': 'お振込口座 - 普通/当座'
                    },
                    'bankAccountNameReading_0': {
                        'key': 'bankAccountNameReading_0',
                        'en': 'Bank - Account Holder Name (Kana)',
                        'jp': 'お振込口座 - 口座名義(フリガナ)'
                    },
                    'bankAccountName_0': {
                        'key': 'bankAccountName_0',
                        'en': 'Bank - Account Holder Name',
                        'jp': 'お振込口座 - 口座名義'
                    },
                    'inChargeNameReading_0_0': {
                        'key': 'inChargeNameReading_0_0',
                        'en': 'Invoice Destination - In Charge Name  (Kana)',
                        'jp': '請求書送付先 - 会社名(フリガナ)'
                    },
                    'inChargeNameReading_cr_0_0': {
                        'key': 'inChargeNameReading_cr_0_0',
                        'en': 'Credit Notification - In Charge Name  (Kana)',
                        'jp': '入金通知書送付先 - 会社名(フリガナ)'
                    },
                    'inChargeName_0_0': {
                        'key': 'inChargeName_0_0',
                        'en': 'Invoice Destination - In Charge Name',
                        'jp': '請求書送付先 - 会社名'
                    },
                    'inChargeName_cr_0_0': {
                        'key': 'inChargeName_cr_0_0',
                        'en': 'Credit Notification - In Charge Name',
                        'jp': '入金通知書送付先 - 会社名'
                    },
                    'addressPin_settlement_address_0_0': {
                        'key': 'addressPin_settlement_address_0_0',
                        'en': 'Invoice Destination - Zip Code',
                        'jp': '請求書送付先 - 〒'
                    },
                    'streetAddress_settlement_address_0_0': {
                        'key': 'streetAddress_settlement_address_0_0',
                        'en': 'Invoice Destination - Street Address',
                        'jp': '請求書送付先 - 番地'
                    },
                    'streetAddressKana_settlement_address_0_0': {
                        'key': 'streetAddressKana_settlement_address_0_0',
                        'en': 'Invoice Destination - Street Address(Kana)',
                        'jp': '請求書送付先 - 番地(フリガナ)'
                    },
                    'addressPin_settlement_address_cr_0_0': {
                        'key': 'addressPin_settlement_address_cr_0_0',
                        'en': 'Credit Notification - Zip Code',
                        'jp': '入金通知書送付先 - 〒'
                    },
                    'streetAddress_settlement_address_cr_0_0': {
                        'key': 'streetAddress_settlement_address_cr_0_0',
                        'en': 'Credit Notification - Street Address',
                        'jp': '入金通知書送付先 - 番地'
                    },
                    'streetAddressKana_settlement_address_cr_0_0': {
                        'key': 'streetAddressKana_settlement_address_cr_0_0',
                        'en': 'Credit Notification - Street Address(Kana)',
                        'jp': '入金通知書送付先 - 番地(フリガナ)'
                    },
                    'addressPin_organisation_address': {
                        'key': 'addressPin_organisation_address',
                        'en': 'Company Contact - Zip Code',
                        'jp': '企業連絡先 - 〒'
                    },
                    'streetAddress_organisation_address': {
                        'key': 'streetAddress_organisation_address',
                        'en': 'Company Contact - Street Address',
                        'jp': '企業連絡先 - 番地'
                    },
                    'streetAddressKana_organisation_address': {
                        'key': 'streetAddressKana_organisation_address',
                        'en': 'Company Contact - Street Address(Kana)',
                        'jp': '企業連絡先 - 番地(フリガナ)'
                    },
                    'contactNumber_organisation_account_contact_0_0': {
                        'key': 'contactNumber_organisation_account_contact_0_0',
                        'en': 'Company In Charge - Contact',
                        'jp': '担当者情報 - ご連絡先'
                    },
                    'contactNumber_settlement_contact0_0_0': {
                        'key': 'contactNumber_settlement_contact0_0_0',
                        'en': 'Invoice Destination - Contact',
                        'jp': '請求書送付先 - ご連絡先'
                    },
                    'contactNumber_settlement_contact_cr0_0_0': {
                        'key': 'contactNumber_settlement_contact_cr0_0_0',
                        'en': 'Credit Notification - Contact',
                        'jp': '入金通知書送付先 - ご連絡先'
                    },
                    'contactNumber_organisation_contact_0': {
                        'key': 'contactNumber_organisation_contact_0',
                        'en': 'Company\'s Contact - Contact',
                        'jp': '企業連絡先 - ご連絡先'
                    },
                    'inchargeDepartment_0': {
                        'key': 'inchargeDepartment_0',
                        'en': 'In-Charge - Department Name',
                        'jp': '担当者情報 - 担当部署名'
                    },
                    'branchName_0_0': {
                        'key': 'branchName_0_0',
                        'en': 'Invoice Destination - Branch Name',
                        'jp': '請求書送付先 - 支店営業所名'
                    },
                    'centerCode_0_0': {
                        'key': 'centerCode_0_0',
                        'en': 'Invoice Destination - Branch/Center Code',
                        'jp': '請求書送付先 - 支店営業所コード'
                    },
                    'branchName_cr_0_0': {
                        'key': 'branchName_cr_0_0',
                        'en': 'Credit Notification - Branch Name',
                        'jp': '入金通知書送付先 - 支店営業所名'
                    },
                    'centerCode_cr_0_0': {
                        'key': 'centerCode_cr_0_0',
                        'en': 'Credit Notification - Branch/Center Code',
                        'jp': '入金通知書送付先 - 支店営業所コード'
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_10_E_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_10_E_MONEY_value',
                              en:'Payment Handling Fee - ME-10 - E-Money - ' + vm.types.PaymentHandlingOption.E_MONEY.en[i],
                              jp:'決済手数料 - ME-10 - 電子マネ - ' + vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                          };
                         
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_20_1_E_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_20_1_E_MONEY_value',
                              en:'Payment Handling Fee - ME-20-1 - E-Money - ' + vm.types.PaymentHandlingOption.E_MONEY.en[i],
                              jp:'決済手数料 - ME-20-1 - 電子マネ - ' + vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                          };
                         
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_20_2_E_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_20_2_E_MONEY_value',
                              en:'Payment Handling Fee - ME-20-2 - E-Money - ' + vm.types.PaymentHandlingOption.E_MONEY.en[i],
                              jp:'決済手数料 - ME-20-2 - 電子マネ - ' + vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                          };
                         
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.E_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.E_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_5_1_E_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.E_MONEY.key[i] + '_ME_5_1_E_MONEY_value',
                              en:'Payment Handling Fee - ME-5-1 - E-Money - ' + vm.types.PaymentHandlingOption.E_MONEY.en[i],
                              jp:'決済手数料 - ME-5-1 - 電子マネ - ' + vm.types.PaymentHandlingOption.E_MONEY.jp[i],
                          };
                         
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_10_QR_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_10_QR_MONEY_value',
                              en:'Payment Handling Fee - ME-10 - QR Money - ' + vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                              jp:'決済手数料 - ME-10 - QRマネ - ' + vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_20_1_QR_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_20_1_QR_MONEY_value',
                              en:'Payment Handling Fee - ME-20-1 - QR Money - ' + vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                              jp:'決済手数料 - ME-20-1 - QRマネ - ' + vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_20_2_QR_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_20_2_QR_MONEY_value',
                              en:'Payment Handling Fee - ME-20-2 - QR Money - ' + vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                              jp:'決済手数料 - ME-20-2 - QRマネ - ' + vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.QR_MONEY.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.QR_MONEY.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_5_1_QR_MONEY_value'] = {
                              key:vm.types.PaymentHandlingOption.QR_MONEY.key[i] + '_ME_5_1_QR_MONEY_value',
                              en:'Payment Handling Fee - ME-5-1 - QR Money - ' + vm.types.PaymentHandlingOption.QR_MONEY.en[i],
                              jp:'決済手数料 - ME-5-1 - QRマネ - ' + vm.types.PaymentHandlingOption.QR_MONEY.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_20_1_CREDIT_CARD_value'] = {
                              key:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_20_1_CREDIT_CARD_value',
                              en:'Payment Handling Fee - ME-20-1 - Credit Card - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.en[i],
                              jp:'決済手数料 - ME-20-1 - Creditマネ - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_20_2_CREDIT_CARD_value'] = {
                              key:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_20_2_CREDIT_CARD_value',
                              en:'Payment Handling Fee - ME-20-2 - Credit Card - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.en[i],
                              jp:'決済手数料 - ME-20-2 - QRマネ - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i],
                          };
                    }
                }

                for (var i = 0; i < vm.types.PaymentHandlingOption.CREDIT_CARD.key.length; i++) {
                    if(vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[i]) {
                          vm.poko[vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_5_1_CREDIT_CARD_value'] = {
                              key:vm.types.PaymentHandlingOption.CREDIT_CARD.key[i] + '_ME_5_1_CREDIT_CARD_value',
                              en:'Payment Handling Fee - ME-5-1 - Credit Card - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.en[i],
                              jp:'決済手数料 - ME-5-1 - Creditマネ - ' + vm.types.PaymentHandlingOption.CREDIT_CARD.jp[i],
                          };
                    }
                }

                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.enableButton();
                vm.errorNumbers = vm.alerts.length;
                return;
            }
            else {
                vm.detailErrors = false;
            }

            if (!angular.isNumber(contractInfo.date)) {
                contractInfo.date = contractInfo.date.getTime();
            }


            var on = contractInfo.organisationCreateDto.accountCreateDtos.length;
            for (var i = 0; i <= (on - 1); i++) {
                contractInfo.organisationCreateDto.accountCreateDtos[i].serviceContractId = null;
                contractInfo.organisationCreateDto.accountCreateDtos[i].dob = null;
                contractInfo.organisationCreateDto.accountCreateDtos[i].organisationBranchId = null;
                contractInfo.organisationCreateDto.accountCreateDtos[i].organisationId = null;

            }

            contractInfo.organisationCreateDto.organisationTypes = ["MERCHANT"];
            var repDob = contractInfo.organisationCreateDto.organisationRepresentativeCreateDtos[0].dateOfBirth;
            if (!baUtil.isUndefinedOrNull(repDob)) {
                vm.contractInfoCopy = angular.copy(contractInfo);
                var n = vm.contractInfoCopy.organisationCreateDto.organisationRepresentativeCreateDtos.length;
                for (var i = 0; i <= (n - 1); i++) {
                    if (!angular.isNumber(vm.contractInfoCopy.organisationCreateDto.organisationRepresentativeCreateDtos[i].dateOfBirth)) {
                        var repLongDOB = vm.contractInfoCopy.organisationCreateDto.organisationRepresentativeCreateDtos[i].dateOfBirth.getTime();
                        vm.contractInfoCopy.organisationCreateDto.organisationRepresentativeCreateDtos[i].dateOfBirth = repLongDOB;

                    }
                }

                contractInfo = angular.copy(vm.contractInfoCopy);

            }


            contractInfo.merchantOwnerType = vm.merchantOwnerType;

            var data = contractInfo;

            if (data.settlementMethodCreateDto.invoiceMethod === 'BRANCH') {
                var missingBranch = data.settlementBranchCreateDtos.filter(function (el) {
                    return el.settlementSendLocationCreateDtos.filter(function (item) {
                        if (baUtil.isUndefinedOrNull(item.branchCode) || item.branchCode == '0' || item.branchCode == 0) {
                            return true;
                        }
                    }).length > 0;
                });
                if (missingBranch.length > 0) {
                    toastr.error('Invoice method is branch but branch data not present for atleast of the invoice location', 'Error', baUtil.toastOptions())
                    return;
                }
            }
            var organisationBranchCreateDtos = [];
            if (data.settlementMethodCreateDto.invoiceMethod === 'BRANCH') {
                data.settlementBranchCreateDtos.forEach(function (el) {
                    el.settlementSendLocationCreateDtos.filter(function (item) {
                        organisationBranchCreateDtos.push({
                            "name": item.branchCode,
                            "code": item.branchCode,
                            "organisationBranchType": "BRANCH_OFFICE"
                        });
                    });
                })
            }
            contractInfo.organisationCreateDto.organisationBranchCreateDtos = organisationBranchCreateDtos;

            var paymentHandlingFeeCreateDtos = [];
            var serviceFeeCreateDtos = [];

            Object.keys(vm.paymentHandlingFeeCreateDtos).forEach(function (item) {
                var obj = vm.paymentHandlingFeeCreateDtos[item];

                Object.keys(obj).forEach(function (key) {
                    var valueList = obj[key];
                    Object.keys(valueList).forEach(function (value) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(valueList[value].rateOrAmount)) {
                            paymentHandlingFeeCreateDtos.push(valueList[value])
                        }
                    })
                })
            })

            Object.keys(vm.serviceFeeCreateDtos).forEach(function (item) {
                var obj = vm.serviceFeeCreateDtos[item];
                
                Object.keys(obj).forEach(function (key) {
                    var valueList = obj[key];
                    valueList.forEach(function (value) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(value.rateOrAmount)) {
                            serviceFeeCreateDtos.push(value)
                        }
                    })
                })
            })

   
            vm.otherServiceFeeDtos.builtIn_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.otherServiceFeeDtos.builtIn_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.otherServiceFeeDtos.external_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.otherServiceFeeDtos.external_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.otherServiceFeeDtos.builtIn20_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.otherServiceFeeDtos.builtIn20_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.otherServiceFeeDtos.external20_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.otherServiceFeeDtos.external20_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.otherServiceFeeDtos.builtIn5_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];
            vm.otherServiceFeeDtos.builtIn5_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];

            vm.qrOtherServiceFeeDtos.builtIn_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.qrOtherServiceFeeDtos.external_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.qrOtherServiceFeeDtos.external_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn20_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn20_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.qrOtherServiceFeeDtos.external20_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.qrOtherServiceFeeDtos.external20_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn5_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];
            vm.qrOtherServiceFeeDtos.builtIn5_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];

            vm.baseServiceFeeDtos.builtIn_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.baseServiceFeeDtos.builtIn_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.baseServiceFeeDtos.external_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.baseServiceFeeDtos.external_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.baseServiceFeeDtos.builtIn20_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.baseServiceFeeDtos.builtIn20_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.baseServiceFeeDtos.external20_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.baseServiceFeeDtos.external20_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.baseServiceFeeDtos.builtIn5_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];
            vm.baseServiceFeeDtos.builtIn5_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];

            vm.serviceFeeDtosCreditCard.builtIn_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN.key[0]];
            vm.serviceFeeDtosCreditCard.external_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.serviceFeeDtosCreditCard.external_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn20_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn20_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_20.key[0]];
            vm.serviceFeeDtosCreditCard.external20_initial.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.serviceFeeDtosCreditCard.external20_monthly.deviceTypes = [vm.types.DeviceType.EXTERNAL_20.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn5_initial.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];
            vm.serviceFeeDtosCreditCard.builtIn5_monthly.deviceTypes = [vm.types.DeviceType.BUILT_IN_5.key[0]];

            data.paymentHandlingFeeCreateDtos = paymentHandlingFeeCreateDtos
            data.serviceFeeCreateDtos = serviceFeeCreateDtos;

            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.builtIn_initial);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.builtIn_monthly);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.external_initial);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.external_monthly);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.builtIn20_initial);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.builtIn20_monthly);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.external20_initial);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.external20_monthly);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.builtIn5_initial);
            serviceFeeCreateDtos.push(vm.otherServiceFeeDtos.builtIn5_monthly);

            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.builtIn_initial);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.builtIn_monthly);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.external_initial);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.external_monthly);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.builtIn20_initial);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.builtIn20_monthly);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.external20_initial);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.external20_monthly);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.builtIn5_initial);
            serviceFeeCreateDtos.push(vm.qrOtherServiceFeeDtos.builtIn5_monthly);

            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.builtIn_initial);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.builtIn_monthly);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.external_initial);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.external_monthly);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.builtIn20_initial);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.builtIn20_monthly);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.external20_initial);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.external20_monthly);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.builtIn5_initial);
            serviceFeeCreateDtos.push(vm.baseServiceFeeDtos.builtIn5_monthly);

            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.builtIn_initial);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.builtIn_monthly);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.external_initial);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.external_monthly);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.builtIn20_initial);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.builtIn20_monthly);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.external20_initial);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.external20_monthly);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.builtIn5_initial);
            serviceFeeCreateDtos.push(vm.serviceFeeDtosCreditCard.builtIn5_monthly);


            if (!vm.isXlUpload) {
                data.serviceFeeCreateDtos.forEach(function (item) {
                    if (item.modemType === "BUILT_IN" && baUtil.isUndefinedOrNull(item.deviceTypes)) {
                        item.deviceTypes = vm.builtIn_deviceType
                    }
                })
                data.serviceFeeCreateDtos.forEach(function (item) {
                    if (item.modemType === "EXTERNAL" && baUtil.isUndefinedOrNull(item.deviceTypes)) {
                        item.deviceTypes = vm.external_deviceType
                    }
                })
            }
            baUtil.showConfirm("", vm.localTranslator("service.contract.create.confirm"), vm.localTranslator("common.components.btn.confirm"))
            .then(function () {
                ServiceContractService.checkForOrganisation(data).then(function success(response) {
                    if (response.data.data.status == true) {
                        baUtil.showConfirm("", vm.localTranslator("common.components.msg.service.contract.organisation"), vm.localTranslator("common.components.msg.continue"))
                            .then(function () {
                                data.overrideConcerns = true;
                                ServiceContractService.createServiceContract(data).then(function success(response) {
                                    toastr.success(vm.localTranslator("common.components.msg.success"), vm.localTranslator("common.components.title.success"), baUtil.toastOptions())
                                    $state.go('main.serviceContract.list');
                                }, function err(err) {
                                    vm.btnClick = false;
                                    toastr.error(
                                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                                        vm.localTranslator("common.components.title.error"),
                                        baUtil.toastOptions()
                                    );
                                }
                            )})
                        .catch(function() {
                             vm.btnClick = false;
                             return;
                         });
                    } else {
                        ServiceContractService.createServiceContract(data).then(function success(response) {
                            toastr.success(vm.localTranslator("common.components.msg.success"), vm.localTranslator("common.components.title.success"), baUtil.toastOptions())
                            $state.go('main.serviceContract.list');
                        }, function err(err) {
                            toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions()
                            );
                        });
                        vm.btnClick = false;
                    }
                }, function err(err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );

                    vm.btnClick = false;
                });

            })
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .factory('ServiceContractService', ServiceContractService);

    /** @ngInject */
    function ServiceContractService(baUtil, $translate, $http, API_CONFIG, AuthService, Upload) {
        var service = {};
        service.getDataFromPinCode = getDataFromPinCode
        service.getAllTypes = getAllTypes
        service.getMaronBtnStatus = getMaronBtnStatus
        service.getBranchProperty = getBranchProperty
        service.getDataFromBankCode = getDataFromBankCode
        service.getDataFromBankBranchCode = getDataFromBankBranchCode
        service.getDeviceOwner = getDeviceOwner
        service.getPartner = getPartner
        service.createServiceContract = createServiceContract
        service.search = search
        service.getDetailFromId = getDetailFromId
        service.saveDetail = saveDetail
        service.getTypeByEntity = getTypeByEntity
        service.deleteDeviceOwner = deleteDeviceOwner
        service.checkForOrganisation = checkForOrganisation
        service.merchantNumberRegistration = merchantNumberRegistration
        service.downloadCSV = downloadCSV
        service.downloadMaronExcel = downloadMaronExcel
        service.uploadJescaMaroonRequest = uploadJescaMaroonRequest
        service.applyMarron = applyMarron
        service.downloadPaymentHandingFeeCSV = downloadPaymentHandingFeeCSV;
        service.downloadServiceFeeCSV = downloadServiceFeeCSV;
        service.downloadSettlementMethodCSV = downloadSettlementMethodCSV;
        service.getEMVProperty = getEMVProperty;

        return service;

        function getDataFromPinCode(pincode) {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/address/' + pincode  + '/like',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data.content;
            });
		}

        function getAllTypes() {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/allTypes',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getMaronBtnStatus(id) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/dji/flagForDownload?serviceContractId=' + id,
                method: 'post',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function uploadJescaMaroonRequest(file) {
            return Upload.upload({
                url: API_CONFIG.url + '/api/v1/sc/dji/parse',
                data: {
                    file: file
                },
                headers: {
                    'Accept-Language': $translate.use(),
                    'X-COV-TOKEN': AuthService.getToken(),
                    'X-TIMEZONE-OFFSET': (new Date()).getTimezoneOffset(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });
        }

        function applyMarron(data,serviceContractId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/dji/save?serviceContractId=' + serviceContractId,
                method: 'put',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getBranchProperty() {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/branch/property',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getTypeByEntity(entity) {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/types?entity=' + entity,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getDetailFromId(id) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/' + id,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function downloadCSV(scId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/merchant/download/' + scId,
                method: 'get',
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function downloadMaronExcel(scId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/dji/download?serviceContractId=' + scId,
                method: 'post',
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getDataFromBankCode(bankCode) {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/bank/' + bankCode  + '/like',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
		}

        function getDataFromBankBranchCode(bankCode, branchCode) {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/bank/' + bankCode + '/' + branchCode  + '/like',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data.content;
            });
        }

        function search(query) {
            var url = API_CONFIG.url + '/api/v1/sc';
            if (!baUtil.isUndefinedOrNullOrEmpty(query)) {
                url = url + '?' + query;
            }
            return $http({
                url: url,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function getDeviceOwner(query) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/search/deviceOwners?query=' + query,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data.content;
            });
        }

        function getPartner(query) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/search/partner?query=' + query,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function deleteDeviceOwner(serviceContractId, deviceOwnerId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/deviceOwner/delete?serviceContractId=' + serviceContractId + '&deviceOwnerId=' + deviceOwnerId,
                method: 'post',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function checkForOrganisation(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/checkForOrganisation',
                data: data,
                method: 'post',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function createServiceContract(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function merchantNumberRegistration(data,scId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/merchant/number/' + scId,
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function saveDetail(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc',
                method: 'patch',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function downloadPaymentHandingFeeCSV() {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/download/paymentHandlingFee',
                method: 'get',
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function downloadServiceFeeCSV() {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/download/serviceFee',
                method: 'get',
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function downloadSettlementMethodCSV() {
            return $http({
                url: API_CONFIG.url + '/api/v1/sc/download/settlementMethod',
                method: 'get',
                responseType: 'arraybuffer',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getEMVProperty() {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/emv/property',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('JPTC.pages.serviceManagement')
        .factory('ServiceManagementService', ServiceManagementService);

    /** @ngInject */
    function ServiceManagementService(baUtil, $http, API_CONFIG, AuthService, $translate) {
        var service = {};
        service.getDataFromPinCode = getDataFromPinCode
        service.getAllTypes = getAllTypes
        service.createUsers = createUsers
        service.createOrganisation = createOrganisation
        service.generateUserId = generateUserId
        service.search = search
        service.getOrgName = getOrgName
        service.getOrgCode = getOrgCode
        service.searchOrg = searchOrg
        service.getDetailFromId = getDetailFromId
        service.getOrgDetailFromId = getOrgDetailFromId
        service.getUserDetailFromId = getUserDetailFromId
        service.saveUserDetail = saveUserDetail
        service.saveOrgDetail = saveOrgDetail
        service.enableOrganisation = enableOrganisation
        service.disableOrganisation = disableOrganisation
        service.deleteOrganisation = deleteOrganisation
        service.enableUser = enableUser
        service.disableUser = disableUser
        service.forgotPassword = forgotPassword
        service.generatePassword = generatePassword
        service.changePassword = changePassword
        service.deleteUser = deleteUser
        service.resetPassword = resetPassword
        service.getAvailableServiceContract = getAvailableServiceContract
        service.deleteIncharge = deleteIncharge
        service.getMerchantForOffice = getMerchantForOffice
        service.getOfficeServiceSubTypeOptions = getOfficeServiceSubTypeOptions
        service.getOfficeServiceSubTypeState = getOfficeServiceSubTypeState

        // Default Service Sub Type key by Service Type API key
        var OFFICE_SERVICE_TYPE_DEFAULT_SUB_TYPE = {
            'STANDARD': 'IOSLQR',
            'TANITA_HEALTH_POINTS': 'IOSLQR',
            'TOMO_CORPORATION_SERVER': 'IOSLQR',
            'INTAPAY': 'AEON',
            'PAYGENT': 'ONLINE_CREDIT'
        };

        return service;

        function getOfficeServiceSubTypeMaster(types) {
            if (!types) {
                return null;
            }
            return types.OfficeServiceSubTypeMaster || null;
        }

        function emptyTypeOptions() {
            return { key: [], en: [], jp: [] };
        }

        function convertSubTypeArrayToOptions(subTypes) {
            var result = emptyTypeOptions();

            if (!angular.isArray(subTypes)) {
                return result;
            }

            subTypes.forEach(function (item) {
                if (!item || baUtil.isUndefinedOrNullOrEmpty(item.key)) {
                    return;
                }
                result.key.push(item.key);
                result.en.push(item.en || item.key);
                result.jp.push(item.jp || item.en || item.key);
            });

            return result;
        }

        function getOfficeServiceSubTypeOptions(types, serviceTypeKey) {
            if (!serviceTypeKey) {
                return emptyTypeOptions();
            }

            var master = getOfficeServiceSubTypeMaster(types);
            if (!master || !angular.isArray(master[serviceTypeKey])) {
                return emptyTypeOptions();
            }

            return convertSubTypeArrayToOptions(master[serviceTypeKey]);
        }

        function resolveDefaultSubTypeKey(options, preferredKey) {
            if (!options || !angular.isArray(options.key) || !options.key.length) {
                return null;
            }

            if (preferredKey && options.key.indexOf(preferredKey) >= 0) {
                return preferredKey;
            }

            return options.key[0];
        }

        function getDefaultOfficeServiceSubTypeKey(types, serviceTypeKey) {
            var options = getOfficeServiceSubTypeOptions(types, serviceTypeKey);
            var preferredKey = OFFICE_SERVICE_TYPE_DEFAULT_SUB_TYPE[serviceTypeKey];
            return resolveDefaultSubTypeKey(options, preferredKey);
        }

        function getOfficeServiceSubTypeState(types, serviceTypeKey) {
            var options = getOfficeServiceSubTypeOptions(types, serviceTypeKey);
            var defaultKey = getDefaultOfficeServiceSubTypeKey(types, serviceTypeKey);

            return {
                options: options,
                defaultKey: defaultKey
            };
        }

        function getDataFromPinCode(pincode) {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/address/' + pincode  + '/like',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data.content;
            });
		}

        function getAllTypes() {
            return $http({
                url: API_CONFIG.url + '/api/v1/master/allTypes',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function generateUserId(){
            return Math.floor(Math.random()*9000000000) + 155570000000000;
        }

        function generateUserIds(){
            return $http({
                url: API_CONFIG.url + '/api/v1/account',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });

        }

        function enableOrganisation(id){
            return $http({
                url: API_CONFIG.url + '/api/v1/org/update/enable/status',
                method: 'post',
                data: {
                    "id": id,
                    "action": "ENABLE"
                },
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });

            }

        function disableOrganisation(id) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/update/enable/status',
                method: 'post',
                data: {
                    "id": id,
                    "action": "DISABLE"
                },
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function deleteOrganisation(id){
            return $http({
                url: API_CONFIG.url + '/api/v1/org/' + id,
                method: 'DELETE',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function enableUser(id){
            return $http({
                url: API_CONFIG.url + '/api/v1/account/update/enable/status',
                method: 'post',
                data: {
                    "id": id,
                    "action": "ENABLE"
                },
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });

            }

        function disableUser(id){
            return $http({
                url: API_CONFIG.url + '/api/v1/account/update/enable/status',
                method: 'post',
                data: {
                    "id": id,
                    "action": "DISABLE"
                },
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });

        }

        function deleteUser(id){
            return $http({
                url: API_CONFIG.url + '/api/v1/account/' + id,
                method: 'DELETE',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });

        }

        function getOrgDetailFromId(id) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/' + id,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getUserDetailFromId(id) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/' + id,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function getDetailFromId(id) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/' + id,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }


        function search(query) {

            var url = API_CONFIG.url + '/api/v1/account';
            if (!baUtil.isUndefinedOrNullOrEmpty(query)) {
                url = url + '?' + query;
            }
            return $http({
                url: url,
                method: 'get',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }

        function searchOrg(query) {

            var url = API_CONFIG.url + '/api/v1/org';
            if (!baUtil.isUndefinedOrNullOrEmpty(query)) {
                url = url + '?' + query;
            }
            return $http({
                url: url,
                method: 'get',
                headers: {
                   'X-COV-TOKEN': AuthService.getToken(),
                   'Content-Type': 'application/json',
                   'Accept-Language': $translate.use(),
                   'Pragma': 'no-cache',
                   'Cache-Control': 'no-cache'
                },
            });
        }


        function getOrgName(query) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/search/by/name?query=' + query,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
        }

        function getOrgCode(query) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/search/by/code?query=' + query,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data.content;
            });
        }

        function getAvailableServiceContract(orgId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/serviceContract/' + orgId,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function deleteIncharge(serviceContractId) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/incharge/delete/' + serviceContractId,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        };

        function createUsers(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function createOrganisation(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org',
                method: 'post',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function saveUserDetail(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account',
                method: 'patch',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

        function saveOrgDetail(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org',
                method: 'patch',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

          function forgotPassword(userName, successCallback, errorCallback) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/forgot/password/initiate',
                method: 'post',
                data: {
                    "userName":userName
                },
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).
                success(function(response) {
                    successCallback(response);
                }).
                error(function(response){
                    errorCallback(response);
                });
        };


          function generatePassword(accountId, successCallback, errorCallback) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/manage/password',
                method: 'post',
                data: {
                    "accountId":accountId,
                    "action":"GENERATE_PASSWORD",
                    "oldPass": "",
                    "newPass": ""

                },
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).
                success(function(response){
                successCallback(response);
                }).
                error(function(response){
                    errorCallback(response);
                });
        };



          function changePassword(accountId, oldPass, newPass, successCallback, errorCallback) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/manage/password',
                method: 'post',
                data: {
                    "accountId":accountId,
                    "action":"CHANGE_PASSWORD",
                    "oldPass": oldPass,
                    "newPass": newPass

                },
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).
                success(function(response) {
                    successCallback(response);
                }).
                error(function(response){
                    errorCallback(response);
                });
        };


        function resetPassword(accountId, successCallback, errorCallback) {
            return $http({
                url: API_CONFIG.url + '/api/v1/account/manage/password',
                method: 'post',
                data: {
                    "accountId":accountId,
                    "action":"RESET_PASSWORD",
                    "oldPass": "",
                    "newPass": ""

                },
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).
                success(function(response) {
                    successCallback(response);
                }).
                error(function(response){
                    errorCallback(response);
                });
        };


        function getMerchantForOffice(query) {
            return $http({
                url: API_CONFIG.url + '/api/v1/org/search/merchant/ofc?query=' + query,
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data.content;
            });
        }




    }
})();

(function () {
    'use strict';

    angular.module('JPTC.pages.systemManagement')
        .controller('JmupsMappingCtrl', JmupsMappingCtrl);


    function JmupsMappingCtrl(systemManagementService, jmupsMap, API_CONFIG, AuthService, $translate, baUtil, $state, toastr, $filter) {
        var vm = this;

        vm.jmupsMap = jmupsMap;
        vm.showInUseCheck = true;
        vm.showInUse = showInUse;
        vm.saveDetail = saveDetail;
        vm.isEdit = false;
        vm.editDetail = editDetail;
        vm.cancelEdit = cancelEdit;
        vm.getLang = getLang;
        vm.localTranslator = $filter('translate');
        vm.getValueFromTypeKey = getValueFromTypeKey;


        vm.areaMap = [];
        vm.currentOperator = [];

        showInUse();

        angular.forEach(vm.jmupsMap.areaMapping, function(k,i) {
            getOperatorName(k.transportPaymentOptionsMasterName);
        })


        angular.forEach(vm.jmupsMap.areaMapping, function(value, key) {
            vm.areaMap.push({
                en:value.areaNameEn,
                jp:value.areaNameJp,
                prefecture:{
                    en:value.prefectureEn,
                    jp:value.prefectureJp,
                },
                transportPaymentOptionKey:value.transportPaymentOptionKey,
                currentOperatorValue:value.transportPaymentOptionsMasterName

            })
        })



        function getOperatorName(key) {
            vm.jmupsMap.mappingOptions.filter(function (i) { return i.name == key}).forEach(function (item) {
                vm.currentOperator.push({
                        en:item.displayEn,
                        jp:item.displayJp
                })
            })
        }

        function editDetail() {
            vm.isEdit = true;
        }

        function showInUse() {

            vm.changeOperator = {
                "en":[],
                "jp":[],
                "key":[],
                "inUse":[],
            };

            var jmupsMapOptions = vm.jmupsMap.mappingOptions;
            jmupsMapOptions = jmupsMapOptions.filter(function (key) { return key.name !== '-' && key.name !== '○' });

            if (vm.showInUseCheck) {
                jmupsMapOptions.filter(function (item) { return item.inUse == true}).forEach(function (value) {
                    vm.changeOperator.en.push(value.displayEn);
                    vm.changeOperator.jp.push(value.displayJp);
                    vm.changeOperator.key.push(value.name);
                    vm.changeOperator.inUse.push(value.inUse);
                })
            }
            else {
                jmupsMapOptions.forEach(function (value) {
                    vm.changeOperator.en.push(value.displayEn);
                    vm.changeOperator.jp.push(value.displayJp);
                    vm.changeOperator.key.push(value.name);
                    vm.changeOperator.inUse.push(value.inUse);
                })
            }

        }

        function cancelEdit() {
            vm.isEdit = false;
            $state.reload();
        }

        function saveDetail() {
            vm.changeMap = [];

            vm.areaMap[3].transportPaymentOptionsMasterName = vm.areaMap[2].transportPaymentOptionsMasterName;
            vm.areaMap[4].transportPaymentOptionsMasterName = vm.areaMap[2].transportPaymentOptionsMasterName;
            vm.areaMap[5].transportPaymentOptionsMasterName = vm.areaMap[2].transportPaymentOptionsMasterName;
            vm.areaMap[6].transportPaymentOptionsMasterName = vm.areaMap[2].transportPaymentOptionsMasterName;
            vm.areaMap[7].transportPaymentOptionsMasterName = vm.areaMap[2].transportPaymentOptionsMasterName;
            vm.areaMap[8].transportPaymentOptionsMasterName = vm.areaMap[2].transportPaymentOptionsMasterName;

            angular.forEach(vm.areaMap, function(value, key) {

                if(baUtil.isUndefinedOrNull(value.transportPaymentOptionsMasterName)) {
                    vm.changeMap.push({
                        transportPaymentOptionKey:value.transportPaymentOptionKey,
                        transportPaymentOptionsMasterName:value.currentOperatorValue,
                        prefectureEn :value.prefecture.en
                    })
                }
                else {
                    vm.changeMap.push({
                        transportPaymentOptionKey:value.transportPaymentOptionKey,
                        transportPaymentOptionsMasterName:value.transportPaymentOptionsMasterName,
                        prefectureEn :value.prefecture.en
                    })
                }
            })

            var data = vm.changeMap;


            baUtil.showConfirm("", vm.localTranslator("jmups.mapping.confirm"), vm.localTranslator("common.components.msg.continue"))
                .then(function () {
                    systemManagementService.updateJmupsMapping(data).then(function success(response) {
                            toastr.success(
                                vm.localTranslator("common.components.msg.success"),
                                vm.localTranslator("common.components.title.success"),
                                baUtil.toastOptions()
                            );
                        $state.reload();
                        vm.isEdit = false;
                    }, function err(err) {
                            toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions()
                            );
                    });

                })
                .catch(function(){
                    return;
                });

        }


        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.systemManagement')
        .factory('systemManagementService', systemManagementService);

    /** @ngInject */

    function systemManagementService(baUtil, $translate, $http, API_CONFIG, AuthService) {

        var service = {};
        service.getJmupsMapping = getJmupsMapping
        service.updateJmupsMapping = updateJmupsMapping

        return service;

        function getJmupsMapping() {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/area/acq/mapping',
                method: 'get',
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            }).then(function(response) {
                return response.data.data;
            });
		}

        function updateJmupsMapping(data) {
            return $http({
                url: API_CONFIG.url + '/api/v1/di/area/acq/mapping',
                method: 'PUT',
                data: data,
                headers: {
                    'X-COV-TOKEN': AuthService.getToken(),
                    'Content-Type': 'application/json',
                    'Accept-Language': $translate.use(),
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                },
            });
        }

    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('JPTC.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('JPTC.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baUtil, baSidebarService, AuthService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.permissions = AuthService.getPermissions();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
      if (!baUtil.isUndefinedOrNull($event.currentTarget.href) && $event.currentTarget.href.includes('%')) {
        $event.currentTarget.href = $event.currentTarget.href.split("%")[0];
      }
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('JPTC.theme.components')
    .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes, AuthService, baUtil) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        // this.getMenuItems = function() {
        //   var states = defineMenuItemStates();
        //   var menuItems = states.filter(function(item) {
        //     return item.level == 0;
        //   });

        //   menuItems.forEach(function(item) {
        //     var children = states.filter(function(child) {
        //       return child.level == 1 && child.name.indexOf(item.name) === 0;
        //     });
        //     item.subMenu = children.length ? children : null;
        //   });

        //   return menuItems.concat(staticMenuItems);
        // };
        this.getMenuItems = function () {
          var states = defineMenuItemStates();
          var children0 = states.filter(function (child0) {
              return child0.level == 0;
          });

          //Menu level 1
          children0.forEach(function (item1) {
              var children1 = states.filter(function (child1) {
                  return child1.level == 1 && child1.name.indexOf(item1.name) === 0;
              });

              //Menu level 2
              children1.forEach(function (item2) {
                  var children2 = states.filter(function (child2) {
                      return child2.level == 2 && child2.name.indexOf(item2.name) === 0;

                  });

                  //Menu level 3
                  children2.forEach(function (item3) {
                      var children3 = states.filter(function (child3) {
                          return child3.level == 3 && child3.name.indexOf(item3.name) === 0;
                      });

                      item3.subMenu = children3.length ? children3 : null;
                  });

                  item2.subMenu = children2.length ? children2 : null;
              });

              item1.subMenu = children1.length ? children1 : null;
          });

          return children0.concat(staticMenuItems);
      };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function(s) {
              return s.sidebarMeta;
            })
            .filter(function(s) {
              var meta = s.sidebarMeta;
              if (baUtil.isUndefinedOrNull(meta.permission)) {
                return false;
              }
              var permission = AuthService.getPermissions();
              var keys = Object.keys(meta.permission);
              for (var i=0;i<keys.length;i++) {
                var module = keys[i];
                var permissionList = meta.permission[module];
                if(baUtil.isUndefinedOrNullOrEmptyList(permissionList)){
                  continue;
                }
                var userPermissionsForModule = permission[module]
                if(baUtil.isUndefinedOrNull(userPermissionsForModule)){
                  continue;
                }
                var userPermissionsForModuleKeys = Object.keys(userPermissionsForModule);
                for (var j=0;j<userPermissionsForModuleKeys.length;j++) {
                  var p = userPermissionsForModuleKeys[j];
                  var pVal = userPermissionsForModule[p];
                  if (!baUtil.isUndefinedOrNull(pVal) && pVal == true && permissionList.indexOf(p) >= 0) {
                    return true;
                  }
                }
              }
              return false;
            })
            .map(function(s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                level: ((s.name.match(/\./g) || []).length - 1),
                order: meta.order,
                url:s.url,
                icon: meta.icon,
                stateRef: s.name,
              };
            })
            .sort(function(a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('JPTC.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('JPTC.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('JPTC.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          var parent = $state.$current.parent.self.title;
          $scope.activePageParentTitle = parent;
          if(parent !== undefined) {
            $scope.showArrow = true;
          }
          else {
            $scope.showArrow = false;
          }
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: PageTopCtrl,
			controllerAs: 'vm',
    };
  }

  function PageTopCtrl($scope, $state, $translate, localStorageService, AuthService, baUtil) {
    var vm = this;
    vm.changeLanguage = changeLanguage;
    vm.logout = logout;
    vm.profile = localStorageService.get('loginResponse').accountDto;
    vm.pageSize = pageSize;

    pageSize();

    function changeLanguage(lang) {
        $translate.use(lang);
        localStorageService.set('lang', lang);
        $scope.$broadcast('LANG_CHANGE');
    }

    function logout(){
      AuthService.logout();
    }

    function pageSize() {
        AuthService.getPageSize();
    }


}


})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('JPTC.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

(function() {
    'use strict';

    angular
        .module('JPTC.theme')
        .filter('capitalize', capitalize);

    function capitalize() {
        return filterFunction;
        function filterFunction(input) {
            if (input!=null && angular.isDefined(input)) {
                return input.replace(/_/g, ' ').toLowerCase().replace( /\b\w/g, function (m) {
                    return m.toUpperCase();
                });
            }
        }
    }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('EditDepartmentCtrl', EditDepartmentCtrl);

    /** @ngInject */
    function EditDepartmentCtrl($translate, $stateParams, toastr,  baUtil,$scope, $state, $filter, inOfficeServices) {
    
        if( $stateParams.departments == null ) {
            cancel();
        }

        var vm = this;
        vm.getLang = getLang;
        vm.isServerError = false;
        vm.query = {}
        vm.cancel = cancel;
        vm.submit = submit;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        

       
        vm.KeyMap;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;


        vm.operationTypes =  {
            en: ['Insert', 'Update', 'Add/Change', 'Delete', 'Reissue'],
            jp: ['追加', '更新', '追加/変更', '削除', '再発行'],
            key: ['INSERT', 'UPDATE', 'UPSERT', 'DELETE', 'REISSUE']
          }
      
     

        var departments = $stateParams.departments || [];
        createTable(departments);

        function cancel() {
            $state.go("main.iosl.department.list");
        }


        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function createTable(rowData) {
                    vm.tableRowData = [];
                    vm.tableData = [{}];
                    vm.tableOptions = {};

                    vm.deviceTableHeader = {
                        serialNo: {
                            en: '#',
                            jp: '行番号',
                            column: 'serialNo'
                        },
                        operation: {
                            en: 'Operation',
                            jp: '操作',
                            column: 'operation'
                        },
                        officeId: {
                            en: 'Office ID',
                            jp: 'オフィスID',
                            column: 'officeId'
                        },
                        departmentId: {
                            en: 'Department ID',
                            jp: '部署ID',
                            column: 'departmentId'
                        },
                        name: {
                            en: 'Department Name',
                            jp: '部署名',
                            column: 'name'
                        },
                        remarks: {
                            en: 'Department Remarks',
                            jp: '部署備考',
                            column: 'remarks'
                        }
                    }


                    rowData.forEach(function (item, index) {
                        var obj = {};
                        var keys = Object.keys(item)
                        keys.forEach(function (field) {
                            var value = item[field]
                            if (field === 'operation'){
                                obj[field] = getOperationTypes(value);
                                return
                            }
                            obj[field] = value;
                        })
                        vm.tableRowData.push(obj)
                    })

                    vm.KeyMap = vm.deviceTableHeader;
                    vm.KeyMap.serialNo.readOnly = true;
                    vm.KeyMap.serialNo.validators = ['required'];
                    vm.KeyMap.operation.readOnly = true;
                    vm.KeyMap.operation.validators = ['required'];
                    vm.KeyMap.officeId.readOnly = true;
                    vm.KeyMap.officeId.validators = ['required'];
                    vm.KeyMap.departmentId.readOnly = true;
                    vm.KeyMap.departmentId.validators = ['required'];
                    vm.KeyMap.name.readOnly = false;
                    vm.KeyMap.name.validators = ['required'];
                    vm.KeyMap.remarks.readOnly = false;
                
                    vm.tableSettings = {
                        colHeaders: [],
                        rowHeaders: true,
                        currentRowClassName: 'currentRow',
                        currentColClassName: 'currentCol',
                        invalidCellClassName: 'cell-has-error',
                        columns: [],
                        modifyColWidth: function(width, col) {
                            if(width > 500) return 500;
                        },
                      
                        afterValidate: function (isValid, value, row, prop, source) {
                            if(prop === "serialNo"  || prop === "operation" || prop === "officeId" || prop === "departmentId") {
                                if(baUtil.isUndefinedOrNullOrEmpty(value)){
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "iosl.department.err.msg.required.field",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;
                                }
                                else {
                                    delete vm.errors[ row + "_" + prop ];
                                    return true;
                                }
                            }
                            if(prop === "name") {
                                if(baUtil.isUndefinedOrNullOrEmpty(value)){
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "iosl.department.err.msg.required.field",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;
                                }
                                if(!baUtil.isValueWithoutSpecialCharacter(value)){
                                    vm.errors[ row + "_" + prop ] = $translate.instant(
                                        "iosl.department.err.msg.valid.required.field",
                                        {
                                            row: row+1,
                                            param: vm.KeyMap[prop][vm.getLang()]
                                        }
                                    );
                                    return false;
                                }
                                else {
                                    delete vm.errors[ row + "_" + prop ];
                                    return true;
                                }
                            }
                        }
                    };

                


                    var keyMap = vm.KeyMap;
                    var optionKeys = Object.keys(keyMap);
                    optionKeys.forEach(function (field) {
                        var value = keyMap[field]
                        var fieldValue = "";
                        vm.tableSettings.colHeaders.push(value[$translate.use()])
                        var col = {
                            type: getInputType(value.type),
                            data: field,
                            readOnly: value.readOnly
                        }

                        if (field == 'operation') {
                            col.type = 'dropdown',
                            col.source = getSource('operation')
                        }

                        if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length ) {
                            col.validator = function(query, callback) {
                                callback(true);
                            }
                        }

                        vm.tableSettings.columns.push(col);
                        vm.tableData[0][field] = fieldValue;

                    });

            
                    vm.disableApplyBtn = false;

                    vm.alerts = [];
                    vm.errors = {};
                    var container = document.getElementById('handsOnTable-department');
                    container.innerHTML = "";
                    var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
                    vm.hotTable = new Handsontable(container, options);
                    vm.hotTable.validateCells();
                }

      

        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function(key){
                var row = Number(key.split("_")[0])+1;
                var field = key.split("_")[1];
                if(!field) return;
                vm.alerts.push( vm.errors[key] );
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submit() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm()
                        .then(function() {
                            vm.isLoading = true;
                            var data = [];
                            vm.tableRowData.forEach(function (row) {
                                var obj = {};
                                Object.keys(row).forEach(function (key) {
                                        var value = row[key];
                                        if (key === 'operation'){
                                            obj[key] = getOperationTypesKey(value);
                                            return
                                        }
                                        obj[key] = row[key];
                                })
                                data.push(obj)
                            });

                            inOfficeServices.uploadDepartment(data)
                            .then(function success(response) {
                                vm.isLoading = false;
                                toastr.success(
                                    vm.localTranslator("common.components.msg.success"),
                                    vm.localTranslator("common.components.title.success"),
                                    baUtil.toastOptions()
                                );
                                cancel();
                            }, function err(err) {
                                vm.isLoading = false;
                                vm.alerts = err.data.data;
                                vm.isServerError = true;
                            });
                        });


        }


        function getSource(key) {
            switch (key) {
                case 'operation':
                    return vm.operationTypes[$translate.use()]
                default:
                    return []
            }
        }

        function getOperationTypes(flag) {
            var operationString;
            vm.operationTypes.key.forEach (function (value, i) {
                if (value == flag) {
                    operationString = vm.operationTypes[$translate.use()][i]
                }
            })
            return operationString;
        }

        function getOperationTypesKey(flag) {
            var operationKey;
            vm.operationTypes[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    operationKey = vm.operationTypes.key[i]
                }
            })
            return operationKey;
        }

    
        $scope.$on('LANG_CHANGE', function (event) {
            suspendOrRemoveDevice(suspendDeviceMap);
        });

        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }



   


    }
})();
(function () {
  'use strict';

  angular.module('JPTC.pages.inOfficeService')
    .controller('DepartmentListCtrl', DepartmentListCtrl);

  /** @ngInject */
  function DepartmentListCtrl(inOfficeServices, FileSaver,  $translate, toastr, baUtil, $state, $filter, AuthService) {
    var vm = this;
    vm.getLang = getLang;
    vm.query = {}
    vm.getValueFromTypeKey = getValueFromTypeKey
    vm.localTranslator = $filter('translate');
    vm.isLoading = true;
    vm.isFilterLoading = false;
    vm.isClearLoading = false;
    vm.isUploadLoading = false;
    vm.isDownloadLoading = false;
    vm.isDeleteLoading = false;
    vm.paginateCallback = paginateCallback;
    vm.selectedIds = {};
    vm.getDistinctColumnValues = getDistinctColumnValues;
    vm.getDepartmentList = getDepartmentList;
    vm.onDelete = onDelete;
    vm.onUpload = onUpload;
    vm.onUpdate = onUpdate;
    vm.onExport = onExport;
    vm.applyFilters = applyFilters;
    vm.clearFilters = clearFilters;
    vm.onSelectAll = onSelectAll;
    vm.isEditDisabled = isEditDisabled;
    vm.departmentResponse = {
      content: []
    };
    vm.permissions = AuthService.getPermissions();

    var operationTypes = {
      en: ['Insert', 'Update', 'Add/Change', 'Delete', 'Reissue'],
      jp: ['追加', '更新', '追加/変更', '削除', '再発行'],
      key: ['INSERT', 'UPDATE', 'UPSERT', 'DELETE', 'REISSUE']
    }


    init();

    function init() {
      vm.colFilter = {};
      vm.selectedIds = {};
      vm.select = false;
      vm.filter = {
        page: 0,
        size: baUtil.getDefaultPageSize('OFFICE'),
        pageSize: baUtil.getDefaultPageSize('OFFICE'),
        filterModel: {

        }
      }
    }

    getDepartments();
    getDistinctColumnValues("departmentId");
    getDistinctColumnValues("officeId");



    function getDepartments() {
      inOfficeServices.searchDepartment(vm.filter)
        .then(function success(response) {
          vm.isFilterLoading = false;
          vm.isClearLoading = false;
          vm.isLoading = false;
          vm.departmentResponse = response.data.data;
        }, function err(err) {
          vm.isLoading = false;
          vm.isFilterLoading = false;
          vm.isClearLoading = false;
          toastr.error(
            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
            vm.localTranslator("common.components.title.error"),
            baUtil.toastOptions()
          );
        })
    }


    function applyFilters() {
      vm.isFilterLoading = true;
      if(vm.colFilter.OFFICE_ID) {
        vm.filter.filterModel["officeId"] = {
          filterType:"set",
          values: vm.colFilter.OFFICE_ID
        }
      }
      if(vm.colFilter.DEPARTMENT_ID) {
        vm.filter.filterModel["departmentId"] = {
          filterType:"set",
          values: vm.colFilter.DEPARTMENT_ID
        };
      }
      getDepartments();
      
      if(!vm.colFilter.DEPARTMENT_ID || !vm.colFilter.DEPARTMENT_ID.length) {
        getDistinctColumnValues("departmentId");
      }
      if(!vm.colFilter.OFFICE_ID || !vm.colFilter.OFFICE_ID.length) {
        getDistinctColumnValues("officeId");
      }
    }


    function clearFilters() {
      vm.isClearLoading = true;
      init();
      getDepartments();
      getDistinctColumnValues("departmentId");
      getDistinctColumnValues("officeId");
    }

    function onSelectAll(ev, list) {
      list.forEach(function (item) {
        vm.selectedIds[item.id] = ev.target.checked
      })
    }


    function getLang() {
      return $translate.use();
    }


    function getValueFromTypeKey(key, type) {
      var index = type.key.findIndex(function (item) {
        return item === key
      })

      return type[vm.getLang()][index]
    }


    function getDistinctColumnValues(columnName) {
      var filter = getFilterWithoutPageOrSize();
      inOfficeServices.getDepartmentColumnValues(columnName, filter)
        .then(function (response) {
          if(columnName === "departmentId") {
            vm.deptIdList = response.data.data;
          } else {
            vm.officeIdList = response.data.data;
          }
        });
    }

    function getDepartmentList(){
      if(vm.colFilter.OFFICE_ID) {
        vm.filter.filterModel["officeId"] = {
          filterType:"set",
          values: vm.colFilter.OFFICE_ID
        }
      }
      getDistinctColumnValues("departmentId");
    }

    function isEditDisabled() {
      return Object.keys(vm.selectedIds)
        .filter(function (id) { return vm.selectedIds[id] })
        .length === 0;
    }


    function onUpdate() {
      var selectedRows = vm.departmentResponse.content.map(function (i) {
        return vm.selectedIds[i.id] ? i : null;
      }).filter(function (d) { return d; });
      var rows = [];
      selectedRows.forEach(function (item, index) {
        item.serialNo = index + 1;
        item.operation = 'UPSERT';
        rows.push(item);
      })
      $state.go('main.iosl.department.update', { departments: rows });
    }

    function onUpload(file, ev) {
      var name = file.name;
      var size = file.size;
      var maxSize = 10485760;
      if (baUtil.checkForInvalidExtension(name.toLowerCase(), [".xlsx"])) {
        toastr.error(
          vm.localTranslator("common.components.msg.csv.format"),
          vm.localTranslator("common.components.title.error"),
          baUtil.toastOptions()
        );
      } else if (size > maxSize) {
        toastr.error(
          vm.localTranslator("common.components.msg.csv.max.size.10"),
          vm.localTranslator("common.components.title.error"),
          baUtil.toastOptions()
        );
      } else {
        vm.isUploadLoading = true;

        inOfficeServices.uploadDepartmentAndEmployeePreview(file)
          .then(function (response) {
            vm.isUploadLoading = false;
            if(!response.data.data.DEPARTMENT.length && !response.data.data.EMPLOYEE.length){
              ev.target.value = "";
              toastr.error(
                vm.localTranslator("iosl.empty.excel.file.msg"),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
            } else{
              $state.go('main.iosl.department.preview', { data: response.data.data });
            }
          }, function err(err) {
            ev.target.value = "";
            vm.isUploadLoading = false;
            toastr.error(
              baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
              vm.localTranslator("common.components.title.error"),
              baUtil.toastOptions()
            );
          });
      }
    }



    function onExport() {
      var ids = vm.departmentResponse.content.map(function (i) {
        return vm.selectedIds[i.id] ? i.id : null;
      }).filter(function (d) { return d; });


      var filter  = vm.filter;
      filter.filterModel["id"] = {
        filterType:"set",
        values: ids
      }

      delete filter['page'];
      delete filter['size'];
      vm.isDownloadLoading = true;
      inOfficeServices.exportDepartment(filter)
        .then(function (resp) {
          var headers = resp.headers();
          var serverData = new Blob([resp.data], { type: headers['content-type'] });
          FileSaver.saveAs(serverData, '部署_' + moment().format("YYYYMMDD") + '.xlsx');
          vm.isDownloadLoading = false;
          init();
        }, function (err) {
          vm.isDownloadLoading = false;
          if ("TextDecoder" in window) {
            try {
              var enc = new TextDecoder("utf-8");
              var data = enc.decode(err.data);
              err = JSON.parse(data);
            } catch (ignore) { }
          }
          toastr.error(
            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
            vm.localTranslator("common.components.title.error"),
            baUtil.toastOptions()
          );
        });
    }


    function onDelete() {
      var ids = vm.departmentResponse.content.map(function (i) {
        return vm.selectedIds[i.id] ? i.id : null;
      }).filter(function (d) { return d; });

      baUtil.showConfirm(vm.localTranslator("iosl.department.delete") + ' ?', vm.localTranslator("iosl.department.delete.msg"), vm.localTranslator("common.components.btn.yes"))
        .then(function () {
          vm.isDeleteLoading = true;
          inOfficeServices.deleteDepartment(ids)
            .then(function (response) {
              getDepartments();
              vm.isDeleteLoading = false;
              vm.selectedIds = {};
              vm.select = false;
              toastr.success(
                vm.localTranslator("iosl.department.msg.delete.status"),
                vm.localTranslator("common.components.title.success"),
                baUtil.toastOptions()
              );
            }, function err(err) {
              toastr.error(
                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
              vm.isDeleteLoading = false;
            });
        });
    }


    function getFilterWithoutPageOrSize() {
      var filter  = angular.copy(vm.filter);
      delete filter['page'];
      delete filter['size'];
      return filter;
    }

    function paginateCallback(query) {
      vm.filter.size = query.pageSize;
      vm.filter.pageSize = query.pageSize;
      vm.filter.page = query.pageNumber;
      inOfficeServices.searchDepartment(vm.filter)
        .then(function (response) {
          vm.departmentResponse = response.data.data;
          vm.filter = query;
        });
    }


  }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('ListPreviewCtrl', ListPreviewCtrl);

    /** @ngInject */
    function ListPreviewCtrl($translate, $stateParams, toastr,  baUtil,$scope, $state, $filter, inOfficeServices) {
    
        if ($stateParams.data == null) {
            cancelDepartment();
        }

        var vm = this;
        vm.getLang = getLang;
        vm.query = {}
        vm.cancelDepartment = cancelDepartment;
        vm.submitDepartment = submitDepartment;
        vm.cancelEmployee = cancelEmployee;
        vm.submitEmployee = submitEmployee;
        vm.isEmployeeTableVisible = false;
        vm.isDepartmentUploaded = false;
        vm.isDepartmentEmpty = false;
        vm.isEmployeeEmpty = false;
        vm.showDepartmentTable = showDepartmentTable;
        vm.showEmployeeTable = showEmployeeTable;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.localTranslator = $filter('translate');

        vm.KeyMap;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;


        vm.enableOptions = {
            en: ['Yes', 'No'],
            jp: ['はい', 'いいえ'],
            key: ['true', 'false']
        }

        vm.operationTypes =  {
            en: ['Insert', 'Update', 'Add/Change', 'Delete', 'Reissue'],
            jp: ['追加', '更新', '追加/変更', '削除', '再発行'],
            key: ['INSERT', 'UPDATE', 'UPSERT', 'DELETE', 'REISSUE']
          }
    

        var employees = $stateParams.data.EMPLOYEE || [];
        var department = $stateParams.data.DEPARTMENT || [];

        if(!employees.length){
            vm.isEmployeeEmpty = true;
        }

        if(!department.length){
            vm.isDepartmentEmpty = true;
            vm.isDepartmentUploaded = true;
        }

        var isUpdate = $stateParams.isUpdate ? $stateParams.isUpdate : false;

        showDepartmentTable();


        function showDepartmentTable() {
            if(!vm.isDepartmentEmpty){
                vm.isEmployeeTableVisible = false;
                createDepartmentTable(department);
            } else{
                showEmployeeTable();
            }
        }

        function showEmployeeTable() {
            vm.isEmployeeTableVisible = true;
            createEmployeeTable(employees);
        }   

        function cancelDepartment() {
            $state.go("main.iosl.department.list");
        }

        function cancelEmployee() {
            if(department.length){
                showDepartmentTable();
            } else{
                cancelDepartment();
            }
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function createEmployeeTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {
                serialNo: {
                    en: '#',
                    jp: '行番号',
                    column: 'serialNo'
                },
                operation: {
                    en: 'Operation',
                    jp: '操作',
                    column: 'operation'
                },
                officeId: {
                    en: 'Office ID',
                    jp: 'オフィスID',
                    column: 'officeId'
                },
                departmentId: {
                    en: 'Department ID',
                    jp: '部署ID',
                    column: 'departmentId'
                },
                employeeId: {
                    en: 'Employee ID',
                    jp: '従業員ID',
                    column: 'employeeId'
                },
                name: {
                    en: 'Employee Name',
                    jp: '従業員名',
                    column: 'name'
                },
                isEnabled: {
                    en: 'Enabled',
                    jp: '有効済み',
                    column: 'isEnabled'
                },
                startDate: {
                    en: 'Start Date',
                    jp: '開始日',
                    column: 'startDate'
                },
                expiryDate: {
                    en: 'Expiration Date',
                    jp: '有効期限',
                    column: 'expiryDate'
                },
                remarks: {
                    en: 'Employee Remarks',
                    jp: '従業員備考',
                    column: 'remarks'
                },
                feliCaIdm: {
                    en: 'Card Number (IDM)',
                    jp: 'カード番号(IDM)',
                    column: 'feliCaIdm'
                }
            }


            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'startDate' || field === 'expiryDate') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                        return
                    } else if (field === 'operation'){
                        obj[field] = getOperationTypes(value);
                        return
                    }
                    else if (field === 'isEnabled') {
                        if (value === true) {
                            obj[field] = enabledOption(value);
                            return
                        }
                        else if (value === false) {
                            obj[field] = enabledOption(value);
                            return
                        }
                    }
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;
            vm.KeyMap.serialNo.readOnly = true;
            vm.KeyMap.serialNo.validators = ['required'];
            vm.KeyMap.operation.readOnly = true;
            vm.KeyMap.operation.validators = ['required'];
            vm.KeyMap.officeId.readOnly = isUpdate;
            vm.KeyMap.officeId.validators = ['required'];
            vm.KeyMap.departmentId.readOnly = isUpdate;
            vm.KeyMap.departmentId.validators = ['required'];
            vm.KeyMap.employeeId.readOnly = isUpdate;
            vm.KeyMap.employeeId.validators = ['required'];
            vm.KeyMap.name.readOnly = false;
            vm.KeyMap.name.validators = ['required'];
            vm.KeyMap.isEnabled.readOnly = false;
            vm.KeyMap.isEnabled.validators = ['required'];
            vm.KeyMap.startDate.readOnly = false;
            vm.KeyMap.startDate.validators = ['required'];
            vm.KeyMap.expiryDate.readOnly = false;
            vm.KeyMap.remarks.readOnly = false;

            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                modifyColWidth: function (width, col) {
                    if (width > 500) return 500;
                },

                afterValidate: function (isValid, value, row, prop, source) {
                    if (prop === "serialNo" || prop === "operation" || prop === "officeId" || prop === "departmentId" || prop === "employeeId" || prop === "name" || prop === "startDate" || prop === "isEnabled") {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "iosl.department.err.msg.required.field",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }
                    if (prop === 'expiryDate') {
                        if(!baUtil.isUndefinedOrNullOrEmpty(value) && moment(value).valueOf() < moment(vm.tableRowData[row].startDate).valueOf()) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "iosl.employee.expiration.date.msg",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        } else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                     }
                }
            };




            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field === 'startDate') {
                    col.type = 'date';
                    col.dateFormat = 'YYYY/MM/DD';
                }

                if (field === 'expiryDate') {
                    col.type = 'date';
                    col.dateFormat = 'YYYY/MM/DD';
                }

                if (field == 'operation') {
                    col.type = 'dropdown',
                    col.source = getSource('operation')
                }

                if (field == 'isEnabled') {
                    col.type = 'dropdown';
                    col.source = getSource('isEnabled');
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length) {
                    col.validator = function (query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;

            });


            vm.disableApplyBtn = false;

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-employee-department');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }

        function createDepartmentTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {
                serialNo: {
                    en: '#',
                    jp: '行番号',
                    column: 'serialNo'
                },
                operation: {
                    en: 'Operation',
                    jp: '操作',
                    column: 'operation'
                },
                officeId: {
                    en: 'Office ID',
                    jp: 'オフィスID',
                    column: 'officeId'
                },
                departmentId: {
                    en: 'Department ID',
                    jp: '部署ID',
                    column: 'departmentId'
                },
                name: {
                    en: 'Department Name',
                    jp: '部署名',
                    column: 'name'
                },
                remarks: {
                    en: 'Department Remarks',
                    jp: '部署備考',
                    column: 'remarks'
                }
            }


            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'operation'){
                        obj[field] = getOperationTypes(value);
                        return
                    }
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;
            vm.KeyMap.serialNo.readOnly = true;
            vm.KeyMap.serialNo.validators = ['required'];
            vm.KeyMap.operation.readOnly = true;
            vm.KeyMap.operation.validators = ['required'];
            vm.KeyMap.officeId.readOnly = isUpdate;
            vm.KeyMap.officeId.validators = ['required'];
            vm.KeyMap.departmentId.readOnly = isUpdate;
            vm.KeyMap.departmentId.validators = ['required'];
            vm.KeyMap.name.readOnly = false;
            vm.KeyMap.name.validators = ['required'];
            vm.KeyMap.remarks.readOnly = false;
        
            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                modifyColWidth: function(width, col) {
                    if(width > 500) return 500;
                },
              
                afterValidate: function (isValid, value, row, prop, source) {
                    if(prop === "serialNo"  || prop === "operation" || prop === "officeId" || prop === "departmentId"  || prop === "name") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value)){
                            vm.errors[ row + "_" + prop ] = $translate.instant(
                                "iosl.department.err.msg.required.field",
                                {
                                    row: row+1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }
                }
            };

        


            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field == 'operation') {
                    col.type = 'dropdown',
                    col.source = getSource('operation')
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;

            });

    
            vm.disableApplyBtn = false;

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-employee-department');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }


        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function (key) {
                var row = Number(key.split("_")[0]) + 1;
                var field = key.split("_")[1];
                if (!field) return;
                vm.alerts.push(vm.errors[key]);
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submitEmployee() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm()
                .then(function () {
                    vm.isLoading = true;
                    var data = [];
                    vm.tableRowData.forEach(function (row) {
                        var obj = {};
                        Object.keys(row).forEach(function (key) {
                            var value = row[key];
                            if (key === 'startDate' || key === 'expiryDate') {
                                var dateM = new Date(Date.parse(value))
                                var long = dateM.getTime();
                                obj[key] = long
                                return
                            }
                            else if (key === 'operation'){
                                obj[key] = getOperationTypesKey(value);
                                return
                            }
                            else if (key === 'isEnabled') {
                                obj[key] = getEnabledOptionKey(value);
                                return
                            }
                            obj[key] = row[key]
                        })
                        data.push(obj)
                    });

                    inOfficeServices.uploadEmployee(data)
                        .then(function success() {
                            vm.isLoading = false;
                            toastr.success(
                                vm.localTranslator("common.components.msg.success"),
                                vm.localTranslator("common.components.title.success"),
                                baUtil.toastOptions()
                            );
                            cancelDepartment();
                        }, function err(err) {
                            vm.isLoading = false;
                            vm.alerts = err.data.data;
                            toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions()
                            );
                        });
                });
        }


        function submitDepartment() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm()
                        .then(function() {
                            vm.isLoading = true;
                            var data = [];
                            vm.tableRowData.forEach(function (row) {
                                var obj = {};
                                Object.keys(row).forEach(function (key) {
                                        var value = row[key];
                                        if (key === 'operation'){
                                            obj[key] = getOperationTypesKey(value);
                                            return
                                        }
                                        obj[key] = row[key];
                                })
                                data.push(obj)
                            });

                            inOfficeServices.uploadDepartment(data)
                            .then(function success(response) {
                                vm.isLoading = false;
                                vm.isDepartmentUploaded = true;
                                if(employees.length){
                                    showEmployeeTable();
                                } else{
                                    cancelDepartment();
                                }
                                toastr.success(
                                    vm.localTranslator("common.components.msg.success"),
                                    vm.localTranslator("common.components.title.success"),
                                    baUtil.toastOptions()
                                );
                            }, function err(err) {
                                vm.isLoading = false;
                                vm.alerts = err.data.data;
                                toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions()
                            );
                            });
                        });


        }


        function getSource(key) {
            switch (key) {
                case 'isEnabled':
                    return vm.enableOptions[$translate.use()]
                case 'operation':
                    return vm.operationTypes[$translate.use()]
                default:
                    return []
            }
        }


        function getOperationTypes(flag) {
            var operationString;
            vm.operationTypes.key.forEach (function (value, i) {
                if (value == flag) {
                    operationString = vm.operationTypes[$translate.use()][i]
                }
            })
            return operationString;
        }

        function getOperationTypesKey(flag) {
            var operationKey;
            vm.operationTypes[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    operationKey = vm.operationTypes.key[i]
                }
            })
            return operationKey;
        }


        function enabledOption(flag) {
            if (flag) { return vm.enableOptions[$translate.use()][0] }
            if (!flag) { return vm.enableOptions[$translate.use()][1] }
        }

        function getEnabledOptionKey(flag) {
            if (flag == vm.enableOptions[$translate.use()][0]) { return true }
            if (flag == vm.enableOptions[$translate.use()][1]) { return false }
        }


        $scope.$on('LANG_CHANGE', function (event) {
            suspendOrRemoveDevice(suspendDeviceMap);
        });

        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }
   


    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('NewDepartmentCtrl', NewDepartmentCtrl);

    /** @ngInject */
    function NewDepartmentCtrl($translate, $state, $location, $anchorScroll, toastr,  baUtil, $filter, inOfficeServices) {
        var vm = this;
        vm.getLang = getLang;
        vm.query = {}
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.getOfficeName = getOfficeName;
        vm.isOfficeFieldDisabled = false;
        vm.onOfficeNameSelected = onOfficeNameSelected;
        vm.createDepartment = createDepartment;
        vm.departmentInfo = {};


        if(baUtil.isOfficeUser()) {
            vm.departmentInfo.officeId = baUtil.getAccountDto().organisation.officeCode;
            vm.departmentInfo.officeName = baUtil.getAccountDto().organisation.name;
            vm.isOfficeFieldDisabled = true;
        }


        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function onOfficeNameSelected(data) {
            vm.departmentInfo.officeId = data.officeCode;
            vm.departmentInfo.officeName = data.name;
        }

        function createDepartment() {

            if(!vm.departmentInfo.officeId) {
                vm.departmentInfo.officeName = null;
                return;
            }
            
            if (vm.departmentForm.$invalid) {
                 
                $location.hash('top');
                $anchorScroll();
                 
                vm.error = [];
                vm.detailErrors = true; 

                for (var key in vm.departmentForm.$error) {
                    for (var index = 0; index < vm.departmentForm.$error[key].length; index++) {
                        vm.error.push(vm.departmentForm.$error[key][index].$name);
                    }
                }
                 
                vm.alerts = []
                vm.errors = []
                
                var unique = {};
                 
                angular.forEach(vm.error, function(item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });
                
                                 
                vm.poko = {
                    'departmentId':{
                        'key':'departmentId',
                        'en':'Department ID',
                        'jp':'部署ID'
                    },
                    'departmentName':{
                        'key':'departmentName',
                        'en':'Department Name',
                        'jp':'部署名'
                    },
                    'officeName':{
                        'key':'officeName',
                        'en':'Office Name',
                        'jp':'オフィス名'
                    },
                    'departmentRemarks':{
                        'key':'departmentRemarks',
                        'en':'Department Remarks',
                        'jp':'部署備考'
                    }
                }
                 
                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.errorNumbers = vm.alerts.length;
                return;

            }
            else {
                vm.detailErrors = false;
            }
            var data = vm.departmentInfo;
            inOfficeServices.createDepartment(data).then(function success(response) {
                $state.go('main.iosl.department.list');
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                );
            }, function err(err) {
                vm.alerts = err.data.data;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }

        function getOfficeName(query) {
            return inOfficeServices.searchOfficeByName(query);
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('CreateDeviceLinkCtrl', CreateDeviceLinkCtrl);

    /** @ngInject */
    function CreateDeviceLinkCtrl($translate, $state, $location, $anchorScroll, toastr,  baUtil, $filter, inOfficeServices) {
        var vm = this;
        vm.getLang = getLang;
        vm.query = {}
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.createDeviceLink = createDeviceLink;
        vm.deviceLinkInfo = {
            "id": 0
        };
        vm.getOfficeName = getOfficeName;
        vm.onOfficeNameSelected = onOfficeNameSelected;

        function getOfficeName(name){
            return inOfficeServices.searchOfficeByName(name);
        }

        function onOfficeNameSelected(data){
            vm.deviceLinkInfo.officeId = data.officeCode;
            vm.enableDepartment = true;
        }

        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }


        function createDeviceLink() {

            if (vm.deviceLinkForm.$invalid) {

                $location.hash('top');
                $anchorScroll();

                vm.error = [];
                vm.detailErrors = true;

                for (var key in vm.deviceLinkForm.$error) {
                    for (var index = 0; index < vm.deviceLinkForm.$error[key].length; index++) {
                        vm.error.push(vm.deviceLinkForm.$error[key][index].$name);
                    }
                }

                vm.alerts = []
                vm.errors = []

                var unique = {};

                angular.forEach(vm.error, function(item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });


                vm.poko = {
                    'officeName':{
                        'key':'officeName',
                        'en':'Office Name',
                        'jp':'オフィス名'
                    },
                    'applicationNumber':{
                        'key':'applicationNumber',
                        'en':'Application Number',
                        'jp':'申込通番'
                    }
                }

                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.errorNumbers = vm.alerts.length;
                return;

            }
            else {
                vm.detailErrors = false;
            }
            var data = vm.deviceLinkInfo;
            inOfficeServices.createDeviceLink(data).then(function success(response) {
                $state.go('main.iosl.deviceLinkage.list');
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                );
            }, function err(error) {
                vm.errorString = error.data.data ? error.data.data[0] : error.data.errorMessage;
                if (baUtil.isUndefinedOrNullOrEmpty(vm.errorString)) {
                    vm.errorString = vm.localTranslator("common.components.msg.error.in.form");
                }
                toastr.error(
                    vm.errorString,
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }




    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('DeviceLinkListCtrl', DeviceLinkListCtrl);

    /** @ngInject */
    function DeviceLinkListCtrl($translate, FileSaver, $filter, inOfficeServices, baUtil, $state, toastr, AuthService) {
        var vm = this;
        vm.localTranslator = $filter('translate');
        vm.onUpload = onUpload;
        vm.onDownload = onDownload;
        vm.onDelete = onDelete;
        vm.getDistinctColumnValues = getDistinctColumnValues;
        vm.applyFilters = applyFilters;
        vm.clearFilters = clearFilters;
        vm.onSelectAll = onSelectAll;
        vm.paginateCallback = paginateCallback;
        vm.isEditDisabled = isEditDisabled;
        vm.selectedIds = {};
        vm.onUpdate = onUpdate;
        vm.permissions = AuthService.getPermissions();


        init();

        function init() {
          vm.colFilter = {};
          vm.search = {};
          vm.selectedIds = {};
          vm.select = false;
          vm.filter = {
            page: 0,
            size: baUtil.getDefaultPageSize('OFFICE'),
            filterModel: {

            }
          }
        }

        getDeviceLink();
        getDistinctColumnValues("officeId");
        getDistinctColumnValues('merchantName');
        getDistinctColumnValues('deviceOwner');

        function getDeviceLink() {
            inOfficeServices.searchDeviceLink(vm.filter)
            .then(function success(response) {
              vm.isFilterLoading = false;
              vm.isLoading = false;
              vm.isClearLoading = false;
              vm.deviceLink = response.data.data;
            }, function err(err) {
              vm.isLoading = false;
              vm.isFilterLoading = false;
              vm.isClearLoading = false;
              toastr.error(
                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
            })
        }


        function applyFilters() {
          vm.isFilterLoading = true;
          if(vm.colFilter.OFFICE_ID) {
            vm.filter.filterModel["officeId"] = {
              filterType:"set",
              values: vm.colFilter.OFFICE_ID
            }
          }

          if(vm.colFilter.merchantName) {
            vm.filter.filterModel["merchantName"] = {
              filterType:"set",
              values: vm.colFilter.merchantName
            };
          }

          if(vm.colFilter.deviceOwner) {
            vm.filter.filterModel["deviceOwner"] = {
              filterType:"set",
              values: vm.colFilter.deviceOwner
            };
          }

          if(!vm.search.deviceSerialNumber && vm.filter.filterModel['deviceSerialNumber']) {
            delete vm.filter.filterModel['deviceSerialNumber'];
          }

          if(vm.search.deviceSerialNumber) {
            vm.filter.filterModel["deviceSerialNumber"] = {
              filterType:"text",
              filter: vm.search.deviceSerialNumber
            };
          }

          if(!vm.search.EMPLOYEE_NAME && vm.filter.filterModel['installationStoreName']) {
            delete vm.filter.filterModel['installationStoreName'];
          }

          if(vm.search.installationLocation) {
            vm.filter.filterModel["installationStoreName"] = {
              filterType:"text",
              filter: vm.search.installationLocation
            };
          }

          getDeviceLink();

        }


        function clearFilters() {
          vm.isClearLoading = true;
          init();
          getDeviceLink();
        }

        function onSelectAll(ev, list) {
          list.forEach(function (item) {
            vm.selectedIds[item.id] = ev.target.checked
          })
        }

        function isEditDisabled() {
          return Object.keys(vm.selectedIds)
            .filter(function (id) { return vm.selectedIds[id] })
            .length === 0;
        }


        function paginateCallback(query) {
          vm.filter.size = query.pageSize;
          vm.filter.pageSize = query.pageSize;
          vm.filter.page = query.pageNumber;
          inOfficeServices.searchDeviceLink(vm.filter)
            .then(function (response) {
              vm.deviceLink = response.data.data;
              vm.query = query;
            });
        }


        function getDistinctColumnValues(columnName) {
          inOfficeServices.getDeviceColumnValues(columnName, vm.filter)
            .then(function (response) {
              if(columnName === "officeId") {
                vm.officeIdList = response.data.data;
              }
              if (columnName === 'merchantName') {
                vm.merchantList = response.data.data;
              }
              if (columnName === 'deviceOwner') {
                vm.deviceOwnerList = response.data.data;
              }
            });
        }


        function onUpdate() {
          var selectedRows = vm.deviceLink.content.map(function (i) {
            return vm.selectedIds[i.id] ? i : null;
          }).filter(function (d) { return d; });
          var rows = [];
          selectedRows.forEach(function (item, index) {
            item.serialNo = index + 1;
            item.operation = 'UPSERT';
            rows.push(item);
          })
          $state.go('main.iosl.deviceLinkage.update', { deviceLink: rows });
        }

        function onUpload(file, ev) {
          var name = file.name;
          var size = file.size;
          var maxSize = 10485760;
          if (baUtil.checkForInvalidExtension(name.toLowerCase(), [".xlsx"])) {
            toastr.error(
              vm.localTranslator("common.components.msg.csv.format"),
              vm.localTranslator("common.components.title.error"),
              baUtil.toastOptions()
            );
          } else if (size > maxSize) {
            toastr.error(
              vm.localTranslator("common.components.msg.csv.max.size.10"),
              vm.localTranslator("common.components.title.error"),
              baUtil.toastOptions()
            );
          } else {
            vm.isUploading = true;

            inOfficeServices.uploadDeviceLinkPreview(file)
              .then(function (response) {
                vm.isUploadLoading = false;
                $state.go('main.iosl.deviceLinkage.preview', { deviceLink: response.data.data });
              }, function err(err) {
                ev.target.value = "";
                vm.isUploading = false;
                toastr.error(
                  baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                  vm.localTranslator("common.components.title.error"),
                  baUtil.toastOptions()
                );
              });
          }
        }


        function onDownload() {
          var ids = vm.deviceLink.content.map(function (i) {
            return vm.selectedIds[i.id] ? i.id : null;
          }).filter(function (d) { return d; });

          var filter  = vm.filter;
          filter.filterModel["id"] = {
            filterType:"set",
            values: ids
          }
          vm.isDownloadLoading = true;
          inOfficeServices.downloadDeviceLink(vm.filter)
            .then(function (resp) {
              var headers = resp.headers();
              var serverData = new Blob([resp.data], { type: headers['content-type'] });
              FileSaver.saveAs(serverData, '端末紐付け_' + moment().format("YYYYMMDD") + '.xlsx');
              vm.isDownloadLoading = false;
              init();
            }, function (err) {
              vm.isDownloadLoading = false;
              if ("TextDecoder" in window) {
                try {
                  var enc = new TextDecoder("utf-8");
                  var data = enc.decode(err.data);
                  err = JSON.parse(data);
                } catch (ignore) { }
              }
              toastr.error(
                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
            });
        }


        function onDelete() {
          var ids = vm.deviceLink.content.map(function (i) {
            return vm.selectedIds[i.id] ? i.id : null;
          }).filter(function (d) { return d; });

          baUtil.showConfirm(vm.localTranslator("iosl.department.delete") + ' ?', vm.localTranslator("iosl.department.delete.msg"), vm.localTranslator("common.components.btn.yes"))
            .then(function () {
              vm.isDeleteLoading = true;
              inOfficeServices.deleteDeviceLink(ids)
                .then(function (response) {
                  getDeviceLink();
                  vm.isDeleteLoading = false;
                  vm.selectedIds = {};
                  toastr.success(
                    vm.localTranslator("iosl.department.msg.delete.status"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                  );
                }, function err(err) {
                  toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                  );
                  vm.isDeleteLoading = false;
                });
            });
        }




    }

})();


(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('DeviceLinkPreviewCtrl', DeviceLinkPreviewCtrl);

    /** @ngInject */
    function DeviceLinkPreviewCtrl($translate, $stateParams, toastr, baUtil, $scope, $state, $filter, inOfficeServices) {

        if ($stateParams.deviceLink == null) {
            cancel();
        }

        var vm = this;
        vm.getLang = getLang;
        vm.query = {}
        vm.cancel = cancel;
        vm.submit = submit;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');



        vm.KeyMap;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;

        vm.operationTypes = {
            en: ['Add/Change', 'Delete'],
            jp: ['追加/変更', '削除'],
            key: ['UPSERT', 'DELETE']
        }


        var deviceLink = $stateParams.deviceLink || [];
        var isUpdate = $stateParams.isUpdate ? $stateParams.isUpdate : false;
        createTable(deviceLink);

        function cancel() {
            $state.go("main.iosl.deviceLinkage.list");
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function createTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {
                serialNo: {
                    en: '#',
                    jp: '行番号',
                    column: 'serialNo'
                },
                operation: {
                    en: 'Operation',
                    jp: '操作',
                    column: 'operation'
                },
                officeId: {
                    en: 'Office ID',
                    jp: 'オフィスID',
                    column: 'officeId'
                },
                applicationNumber: {
                    en: 'Application Number',
                    jp: '申込通番',
                    column: 'applicationNumber'
                },
                customerControlNumber: {
                    en: 'Customer Control Number',
                    jp: 'お客様管理番号',
                    column: 'customerControlNumber'
                },
            }

            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'operation'){
                        obj[field] = getOperationTypes(value);
                        return
                    }
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;
            vm.KeyMap.serialNo.readOnly = true;
            vm.KeyMap.serialNo.validators = ['required'];
            vm.KeyMap.operation.readOnly = false;
            vm.KeyMap.operation.validators = ['required'];
            vm.KeyMap.officeId.readOnly = false;
            vm.KeyMap.officeId.validators = ['required'];
            vm.KeyMap.applicationNumber.readOnly = false;
            vm.KeyMap.applicationNumber.validators = ['required'];

            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                modifyColWidth: function (width, col) {
                    if (width > 500) return 500;
                },

                afterValidate: function (isValid, value, row, prop, source) {
                    if (prop === "serialNo" || prop === "officeId" || prop === "applicationNumber") {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "iosl.department.err.msg.required.field",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }
                }
            };




            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field == 'operation') {
                    col.type = 'dropdown',
                    col.source = getSource('operation')
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length) {
                    col.validator = function (query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;

            });


            vm.disableApplyBtn = false;

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-deviceLinkage');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }



        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function (key) {
                var row = Number(key.split("_")[0]) + 1;
                var field = key.split("_")[1];
                if (!field) return;
                vm.alerts.push(vm.errors[key]);
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submit() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm()
                .then(function () {
                    vm.isLoading = true;
                    var data = [];
                    vm.tableRowData.forEach(function (row) {
                        var obj = {};
                        Object.keys(row).forEach(function (key) {
                            var value = row[key];
                            if (key === 'operation'){
                                obj[key] = getOperationTypesKey(value);
                                return
                            }
                            obj[key] = row[key]
                        })
                        data.push(obj)
                    });

                    inOfficeServices.uploadDeviceLink(data)
                        .then(function success() {
                            vm.isLoading = false;
                            toastr.success(
                                vm.localTranslator("common.components.msg.success"),
                                vm.localTranslator("common.components.title.success"),
                                baUtil.toastOptions()
                            );
                            cancel();
                        }, function err(err) {
                            vm.isLoading = false;
                            vm.alerts = err.data.data;
                        });
                });
        }



        function getSource(key) {
            switch (key) {
                case 'operation':
                    return vm.operationTypes[$translate.use()]
                default:
                    return []
            }
        }


        function getOperationTypes(flag) {
            var operationString;
            vm.operationTypes.key.forEach (function (value, i) {
                if (value == flag) {
                    operationString = vm.operationTypes[$translate.use()][i]
                }
            })
            return operationString;
        }

        function getOperationTypesKey(flag) {
            var operationKey;
            vm.operationTypes[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    operationKey = vm.operationTypes.key[i]
                }
            })
            return operationKey;
        }

        $scope.$on('LANG_CHANGE', function (event) {
            suspendOrRemoveDevice(suspendDeviceMap);
        });

        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('EditEmployeeCtrl', EditEmployeeCtrl);

    /** @ngInject */
    function EditEmployeeCtrl($translate, $stateParams, toastr, baUtil, $scope, $state, $filter, inOfficeServices) {

        if ($stateParams.employees == null) {
            cancel();
        }

        var vm = this;
        vm.getLang = getLang;
        vm.isServerError = false;
        vm.query = {}
        vm.cancel = cancel;
        vm.submit = submit;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');



        vm.KeyMap;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;


        vm.enableOptions = {
            en: ['Yes', 'No'],
            jp: ['はい', 'いいえ'],
            key: ['true', 'false']
        }

        vm.operationTypes =  {
            en: ['Insert', 'Update', 'Add/Change', 'Delete', 'Reissue'],
            jp: ['追加', '更新', '追加/変更', '削除', '再発行'],
            key: ['INSERT', 'UPDATE', 'UPSERT', 'DELETE', 'REISSUE']
          }
      


        var employees = $stateParams.employees || [];
        createTable(employees);

        function cancel() {
            $state.go("main.iosl.employee.list");
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function createTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {
                serialNo: {
                    en: '#',
                    jp: '行番号',
                    column: 'serialNo'
                },
                operation: {
                    en: 'Operation',
                    jp: '操作',
                    column: 'operation'
                },
                officeId: {
                    en: 'Office ID',
                    jp: 'オフィスID',
                    column: 'officeId'
                },
                departmentId: {
                    en: 'Department ID',
                    jp: '部署ID',
                    column: 'departmentId'
                },
                employeeId: {
                    en: 'Employee ID',
                    jp: '従業員ID',
                    column: 'employeeId'
                },
                name: {
                    en: 'Employee Name',
                    jp: '従業員名',
                    column: 'name'
                },
                isEnabled: {
                    en: 'Enabled',
                    jp: '有効済み',
                    column: 'isEnabled'
                },
                startDate: {
                    en: 'Start Date',
                    jp: '開始日',
                    column: 'startDate'
                },
                expiryDate: {
                    en: 'Expiration Date',
                    jp: '有効期限',
                    column: 'expiryDate'
                },
                remarks: {
                    en: 'Employee Remarks',
                    jp: '従業員備考',
                    column: 'remarks'
                },
                feliCaIdm: {
                    en: 'Card Number (IDM)',
                    jp: 'カード番号(IDM)',
                    column: 'feliCaIdm'
                }
            }


            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'startDate' || field === 'expiryDate') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                        return
                    } else if (field === 'operation'){
                        obj[field] = getOperationTypes(value);
                        return
                    }
                    else if (field === 'isEnabled') {
                        if (value === true) {
                            obj[field] = enabledOption(value);
                            return
                        }
                        else if (value === false) {
                            obj[field] = enabledOption(value);
                            return
                        }
                    }
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;
            vm.KeyMap.serialNo.readOnly = true;
            vm.KeyMap.serialNo.validators = ['required'];
            vm.KeyMap.operation.readOnly = true;
            vm.KeyMap.operation.validators = ['required'];
            vm.KeyMap.officeId.readOnly = true;
            vm.KeyMap.officeId.validators = ['required'];
            vm.KeyMap.departmentId.readOnly = true;
            vm.KeyMap.departmentId.validators = ['required'];
            vm.KeyMap.employeeId.readOnly = true;
            vm.KeyMap.employeeId.validators = ['required'];
            vm.KeyMap.name.readOnly = false;
            vm.KeyMap.name.validators = ['required'];
            vm.KeyMap.isEnabled.readOnly = false;
            vm.KeyMap.isEnabled.validators = ['required'];
            vm.KeyMap.startDate.readOnly = false;
            vm.KeyMap.startDate.validators = ['required'];
            vm.KeyMap.expiryDate.readOnly = false;
            vm.KeyMap.remarks.readOnly = false;

            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                modifyColWidth: function (width, col) {
                    if (width > 500) return 500;
                },
                beforeChange: function(changes, source){
                    var row = changes[0][0];
                    var prop = changes[0][1];
                    if(prop === 'startDate'){
                        this.setDataAtRowProp(row, 'expiryDate', this.getDataAtRowProp(row, 'expiryDate'), 'edit');
                        return;
                    }
                },
                afterValidate: function (isValid, value, row, prop, source) {
                    if (prop === "serialNo" || prop === "operation" || prop === "officeId" || prop === "departmentId" || prop === "employeeId" || prop === "startDate" || prop === "isEnabled") {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "iosl.department.err.msg.required.field",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }
                    if (prop === 'expiryDate') {
                        if(!baUtil.isUndefinedOrNullOrEmpty(value) && moment(value).valueOf() < moment(vm.tableRowData[row].startDate).valueOf()) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "iosl.employee.expiration.date.msg",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        } else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                     }
                     if(prop === "name") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value)){
                            vm.errors[ row + "_" + prop ] = $translate.instant(
                                "iosl.department.err.msg.required.field",
                                {
                                    row: row+1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        if(!baUtil.isValueWithoutSpecialCharacter(value)){
                            vm.errors[ row + "_" + prop ] = $translate.instant(
                                "iosl.department.err.msg.valid.required.field",
                                {
                                    row: row+1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }
                }
            };




            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field === 'startDate') {
                    col.type = 'date';
                    col.dateFormat = 'YYYY/MM/DD';
                }

                if (field === 'expiryDate') {
                    col.type = 'date';
                    col.dateFormat = 'YYYY/MM/DD';
                }

                if (field == 'operation') {
                    col.type = 'dropdown',
                    col.source = getSource('operation')
                }

                if (field == 'isEnabled') {
                    col.type = 'dropdown';
                    col.source = getSource('isEnabled');
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length) {
                    col.validator = function (query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;

            });


            vm.disableApplyBtn = false;

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-employee');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }



        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function (key) {
                var row = Number(key.split("_")[0]) + 1;
                var field = key.split("_")[1];
                if (!field) return;
                vm.alerts.push(vm.errors[key]);
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submit() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm()
                .then(function () {
                    vm.isLoading = true;
                    var data = [];
                    vm.tableRowData.forEach(function (row) {
                        var obj = {};
                        Object.keys(row).forEach(function (key) {
                            var value = row[key];
                            if (key === 'startDate' || key === 'expiryDate') {
                                var dateM = new Date(Date.parse(value))
                                var long = dateM.getTime();
                                obj[key] = long
                                return
                            }
                            else if (key === 'operation'){
                                obj[key] = getOperationTypesKey(value);
                                return
                            }
                            else if (key === 'isEnabled') {
                                obj[key] = getEnabledOptionKey(value);
                                return
                            }
                            obj[key] = row[key]
                        })
                        data.push(obj)
                    });

                    inOfficeServices.uploadEmployee(data)
                        .then(function success() {
                            vm.isLoading = false;
                            toastr.success(
                                vm.localTranslator("common.components.msg.success"),
                                vm.localTranslator("common.components.title.success"),
                                baUtil.toastOptions()
                            );
                            cancel();
                        }, function err(err) {
                            vm.isLoading = false;
                            vm.alerts = err.data.data;
                            vm.isServerError = true;
                        });
                });
        }



        function getSource(key) {
            switch (key) {
                case 'isEnabled':
                    return vm.enableOptions[$translate.use()]
                case 'operation':
                    return vm.operationTypes[$translate.use()]
                default:
                    return []
            }
        }


        function getOperationTypes(flag) {
            var operationString;
            vm.operationTypes.key.forEach (function (value, i) {
                if (value == flag) {
                    operationString = vm.operationTypes[$translate.use()][i]
                }
            })
            return operationString;
        }

        function getOperationTypesKey(flag) {
            var operationKey;
            vm.operationTypes[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    operationKey = vm.operationTypes.key[i]
                }
            })
            return operationKey;
        }


        function enabledOption(flag) {
            if (flag) { return vm.enableOptions[$translate.use()][0] }
            if (!flag) { return vm.enableOptions[$translate.use()][1] }
        }

        function getEnabledOptionKey(flag) {
            if (flag == vm.enableOptions[$translate.use()][0]) { return true }
            if (flag == vm.enableOptions[$translate.use()][1]) { return false }
        }


        $scope.$on('LANG_CHANGE', function (event) {
            suspendOrRemoveDevice(suspendDeviceMap);
        });

        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('EmployeeDetailCtrl', EmployeeDetailCtrl);

    /** @ngInject */
    function EmployeeDetailCtrl($stateParams, $translate, toastr, baUtil, $state, $filter, inOfficeServices) {
        if ($stateParams.id == null) {
            cancel();
        }
        
        var vm = this;
        vm.getLang = getLang;
        vm.cancel = cancel;
        vm.isLoading = true;
        vm.localTranslator = $filter('translate');
        vm.getValueFromTypeKey = getValueFromTypeKey;

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

    
        
        vm.boolOptions = {
            en: ['Yes', 'No'],
            jp: ['はい', 'いいえ'],
            key: [true, false]
        }
        var id = $stateParams.id;
        getEmployeeQRCodeDetail(id);

        function getLang() {
            return $translate.use();
        }


        function cancel() {
            $state.go("main.inOfficeService.employee.list");
        }


        function getEmployeeDetail(qrCodeDetail) {
                vm.employeeData = qrCodeDetail.employeeSearchResponseDto;
                vm.employeeData.remainingQR = qrCodeDetail.remainingQR;
                vm.employeeData.qrCodeData = qrCodeDetail.employeeQRResponseDto.qrCodeData;
                vm.employeeData.qrCodeImage = "data:image/png;base64," + qrCodeDetail.employeeQRResponseDto.qrCodeImage;
                vm.isLoading = false;

            // var filter = {};
            // filter.page = 0;
            // filter.size = 1;
            // filter.filterModel = {
            //     employeeId: {
            //         filterType:"set",
            //         values: [qrCodeDetail.employeeId]
            //     },
            //     officeId: {
            //         filterType:"set",
            //         values: [qrCodeDetail.officeId]
            //     }
            // }
            // inOfficeServices.searchEmployees(filter)
            // .then(function success(response) {
            //     vm.isLoading = false;
            //     vm.employeeData = response.data.data.content[0];
            //     vm.employeeData.qrCodeData = qrCodeDetail.qrCodeData;
            //     vm.employeeData.qrCodeImage = "data:image/png;base64," + qrCodeDetail.qrCodeImage;
            //   }, function err(err) {
            //     vm.isLoading = false;
            //     toastr.error(
            //       baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
            //       vm.localTranslator("common.components.title.error"),
            //       baUtil.toastOptions()
            //     );
            //   })
        }


        function getEmployeeQRCodeDetail(id) {
            inOfficeServices.getEmployeeQRCodeDetail(id)
            .then(function success(response) {
                vm.isLoading = true;
                var qrCodeDetail = response.data.data;
                getEmployeeDetail(qrCodeDetail);
              }, function err(err) {
                vm.isLoading = false;
                toastr.error(
                  baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                  vm.localTranslator("common.components.title.error"),
                  baUtil.toastOptions()
                );
              })
        }
       
    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('EmployeeListPreviewCtrl', EmployeeListPreviewCtrl);

    /** @ngInject */
    function EmployeeListPreviewCtrl($translate, $stateParams, toastr, baUtil, $scope, $state, $filter, inOfficeServices) {

        if ($stateParams.data == null) {
            cancelDepartment();
        }

        var vm = this;
        vm.getLang = getLang;
        vm.query = {}
        vm.cancelDepartment = cancelDepartment;
        vm.submitDepartment = submitDepartment;
        vm.cancelEmployee = cancelEmployee;
        vm.submitEmployee = submitEmployee;
        vm.isEmployeeTableVisible = false;
        vm.isDepartmentUploaded = false;
        vm.isDepartmentEmpty = false;
        vm.isEmployeeEmpty = false;
        vm.showDepartmentTable = showDepartmentTable;
        vm.showEmployeeTable = showEmployeeTable;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.localTranslator = $filter('translate');

        vm.KeyMap;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;


        vm.enableOptions = {
            en: ['Yes', 'No'],
            jp: ['はい', 'いいえ'],
            key: ['true', 'false']
        }

        vm.operationTypes =  {
            en: ['Insert', 'Update', 'Add/Change', 'Delete', 'Reissue'],
            jp: ['追加', '更新', '追加/変更', '削除', '再発行'],
            key: ['INSERT', 'UPDATE', 'UPSERT', 'DELETE', 'REISSUE']
          }
    

        var employees = $stateParams.data.EMPLOYEE || [];
        var department = $stateParams.data.DEPARTMENT || [];

        if(!employees.length){
            vm.isEmployeeEmpty = true;
        }

        if(!department.length){
            vm.isDepartmentEmpty = true;
            vm.isDepartmentUploaded = true;
        }

        var isUpdate = $stateParams.isUpdate ? $stateParams.isUpdate : false;

        showDepartmentTable();

        function showDepartmentTable() {
            if(!vm.isDepartmentEmpty){
                vm.isEmployeeTableVisible = false;
                createDepartmentTable(department);
            } else{
                showEmployeeTable();
            }
        }


        function showEmployeeTable() {
            vm.isEmployeeTableVisible = true;
            createEmployeeTable(employees);
        }   

        function cancelDepartment() {
            $state.go("main.iosl.employee.list");
        }

        function cancelEmployee() {
            if(department.length){
                showDepartmentTable();
            } else{
                cancelDepartment();
            }
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function createEmployeeTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {
                serialNo: {
                    en: '#',
                    jp: '行番号',
                    column: 'serialNo'
                },
                operation: {
                    en: 'Operation',
                    jp: '操作',
                    column: 'operation'
                },
                officeId: {
                    en: 'Office ID',
                    jp: 'オフィスID',
                    column: 'officeId'
                },
                departmentId: {
                    en: 'Department ID',
                    jp: '部署ID',
                    column: 'departmentId'
                },
                employeeId: {
                    en: 'Employee ID',
                    jp: '従業員ID',
                    column: 'employeeId'
                },
                name: {
                    en: 'Employee Name',
                    jp: '従業員名',
                    column: 'name'
                },
                isEnabled: {
                    en: 'Enabled',
                    jp: '有効済み',
                    column: 'isEnabled'
                },
                startDate: {
                    en: 'Start Date',
                    jp: '開始日',
                    column: 'startDate'
                },
                expiryDate: {
                    en: 'Expiration Date',
                    jp: '有効期限',
                    column: 'expiryDate'
                },
                remarks: {
                    en: 'Employee Remarks',
                    jp: '従業員備考',
                    column: 'remarks'
                },
                feliCaIdm: {
                    en: 'Card Number (IDM)',
                    jp: 'カード番号(IDM)',
                    column: 'feliCaIdm'
                }
            }


            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'startDate' || field === 'expiryDate') {
                        obj[field] = $filter('date')(value, "yyyy/MM/dd");
                        return
                    } else if (field === 'operation'){
                        obj[field] = getOperationTypes(value);
                        return
                    }
                    else if (field === 'isEnabled') {
                        if (value === true) {
                            obj[field] = enabledOption(value);
                            return
                        }
                        else if (value === false) {
                            obj[field] = enabledOption(value);
                            return
                        }
                    }
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;
            vm.KeyMap.serialNo.readOnly = true;
            vm.KeyMap.serialNo.validators = ['required'];
            vm.KeyMap.operation.readOnly = true;
            vm.KeyMap.operation.validators = ['required'];
            vm.KeyMap.officeId.readOnly = isUpdate;
            vm.KeyMap.officeId.validators = ['required'];
            vm.KeyMap.departmentId.readOnly = isUpdate;
            vm.KeyMap.departmentId.validators = ['required'];
            vm.KeyMap.employeeId.readOnly = isUpdate;
            vm.KeyMap.employeeId.validators = ['required'];
            vm.KeyMap.name.readOnly = false;
            vm.KeyMap.name.validators = ['required'];
            vm.KeyMap.isEnabled.readOnly = false;
            vm.KeyMap.isEnabled.validators = ['required'];
            vm.KeyMap.startDate.readOnly = false;
            vm.KeyMap.startDate.validators = ['required'];
            vm.KeyMap.expiryDate.readOnly = false;
            vm.KeyMap.remarks.readOnly = false;

            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                modifyColWidth: function (width, col) {
                    if (width > 500) return 500;
                },

                afterValidate: function (isValid, value, row, prop, source) {
                    if (prop === "serialNo" || prop === "operation" || prop === "officeId" || prop === "departmentId" || prop === "employeeId" || prop === "name" || prop === "startDate" || prop === "isEnabled") {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "iosl.department.err.msg.required.field",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }
                    if (prop === 'expiryDate') {
                        if(!baUtil.isUndefinedOrNullOrEmpty(value) && moment(value).valueOf() < moment(vm.tableRowData[row].startDate).valueOf()) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "iosl.employee.expiration.date.msg",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        } else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                     }
                }
            };




            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field === 'startDate') {
                    col.type = 'date';
                    col.dateFormat = 'YYYY/MM/DD';
                }

                if (field === 'expiryDate') {
                    col.type = 'date';
                    col.dateFormat = 'YYYY/MM/DD';
                }

                if (field == 'operation') {
                    col.type = 'dropdown',
                    col.source = getSource('operation')
                }

                if (field == 'isEnabled') {
                    col.type = 'dropdown';
                    col.source = getSource('isEnabled');
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length) {
                    col.validator = function (query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;

            });


            vm.disableApplyBtn = false;

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-employee-department');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }

        function createDepartmentTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {
                serialNo: {
                    en: '#',
                    jp: '行番号',
                    column: 'serialNo'
                },
                operation: {
                    en: 'Operation',
                    jp: '操作',
                    column: 'operation'
                },
                officeId: {
                    en: 'Office ID',
                    jp: 'オフィスID',
                    column: 'officeId'
                },
                departmentId: {
                    en: 'Department ID',
                    jp: '部署ID',
                    column: 'departmentId'
                },
                name: {
                    en: 'Department Name',
                    jp: '部署名',
                    column: 'name'
                },
                remarks: {
                    en: 'Department Remarks',
                    jp: '部署備考',
                    column: 'remarks'
                }
            }


            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'operation'){
                        obj[field] = getOperationTypes(value);
                        return
                    }
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;
            vm.KeyMap.serialNo.readOnly = true;
            vm.KeyMap.serialNo.validators = ['required'];
            vm.KeyMap.operation.readOnly = true;
            vm.KeyMap.operation.validators = ['required'];
            vm.KeyMap.officeId.readOnly = isUpdate;
            vm.KeyMap.officeId.validators = ['required'];
            vm.KeyMap.departmentId.readOnly = isUpdate;
            vm.KeyMap.departmentId.validators = ['required'];
            vm.KeyMap.name.readOnly = false;
            vm.KeyMap.name.validators = ['required'];
            vm.KeyMap.remarks.readOnly = false;
        
            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                modifyColWidth: function(width, col) {
                    if(width > 500) return 500;
                },
              
                afterValidate: function (isValid, value, row, prop, source) {
                    if(prop === "serialNo"  || prop === "operation" || prop === "officeId" || prop === "departmentId"  || prop === "name") {
                        if(baUtil.isUndefinedOrNullOrEmpty(value)){
                            vm.errors[ row + "_" + prop ] = $translate.instant(
                                "iosl.department.err.msg.required.field",
                                {
                                    row: row+1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[ row + "_" + prop ];
                            return true;
                        }
                    }
                }
            };

        


            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field == 'operation') {
                    col.type = 'dropdown',
                    col.source = getSource('operation')
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length ) {
                    col.validator = function(query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;

            });

    
            vm.disableApplyBtn = false;

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-employee-department');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }


        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function (key) {
                var row = Number(key.split("_")[0]) + 1;
                var field = key.split("_")[1];
                if (!field) return;
                vm.alerts.push(vm.errors[key]);
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submitEmployee() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm()
                .then(function () {
                    vm.isLoading = true;
                    var data = [];
                    vm.tableRowData.forEach(function (row) {
                        var obj = {};
                        Object.keys(row).forEach(function (key) {
                            var value = row[key];
                            if (key === 'startDate' || key === 'expiryDate') {
                                var dateM = new Date(Date.parse(value))
                                var long = dateM.getTime();
                                obj[key] = long
                                return
                            }
                            else if (key === 'operation'){
                                obj[key] = getOperationTypesKey(value);
                                return
                            }
                            else if (key === 'isEnabled') {
                                obj[key] = getEnabledOptionKey(value);
                                return
                            }
                            obj[key] = row[key]
                        })
                        data.push(obj)
                    });

                    inOfficeServices.uploadEmployee(data)
                        .then(function success() {
                            vm.isLoading = false;
                            toastr.success(
                                vm.localTranslator("common.components.msg.success"),
                                vm.localTranslator("common.components.title.success"),
                                baUtil.toastOptions()
                            );
                            cancelDepartment();
                        }, function err(err) {
                            vm.isLoading = false;
                            vm.alerts = err.data.data;
                            toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions()
                            );
                        });
                });
        }


        function submitDepartment() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm()
                        .then(function() {
                            vm.isLoading = true;
                            var data = [];
                            vm.tableRowData.forEach(function (row) {
                                var obj = {};
                                Object.keys(row).forEach(function (key) {
                                        var value = row[key];
                                        if (key === 'operation'){
                                            obj[key] = getOperationTypesKey(value);
                                            return
                                        }
                                        obj[key] = row[key];
                                })
                                data.push(obj)
                            });

                            inOfficeServices.uploadDepartment(data)
                            .then(function success(response) {
                                vm.isLoading = false;
                                vm.isDepartmentUploaded = true;
                                if(employees.length){
                                    showEmployeeTable();
                                } else{
                                    cancelDepartment();
                                }
                                toastr.success(
                                    vm.localTranslator("common.components.msg.success"),
                                    vm.localTranslator("common.components.title.success"),
                                    baUtil.toastOptions()
                                );
                            }, function err(err) {
                                vm.isLoading = false;
                                vm.alerts = err.data.data;
                                toastr.error(
                                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                                vm.localTranslator("common.components.title.error"),
                                baUtil.toastOptions()
                            );
                            });
                        });


        }


        function getSource(key) {
            switch (key) {
                case 'isEnabled':
                    return vm.enableOptions[$translate.use()]
                case 'operation':
                    return vm.operationTypes[$translate.use()]
                default:
                    return []
            }
        }


        function getOperationTypes(flag) {
            var operationString;
            vm.operationTypes.key.forEach (function (value, i) {
                if (value == flag) {
                    operationString = vm.operationTypes[$translate.use()][i]
                }
            })
            return operationString;
        }

        function getOperationTypesKey(flag) {
            var operationKey;
            vm.operationTypes[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    operationKey = vm.operationTypes.key[i]
                }
            })
            return operationKey;
        }


        function enabledOption(flag) {
            if (flag) { return vm.enableOptions[$translate.use()][0] }
            if (!flag) { return vm.enableOptions[$translate.use()][1] }
        }

        function getEnabledOptionKey(flag) {
            if (flag == vm.enableOptions[$translate.use()][0]) { return true }
            if (flag == vm.enableOptions[$translate.use()][1]) { return false }
        }


        $scope.$on('LANG_CHANGE', function (event) {
            suspendOrRemoveDevice(suspendDeviceMap);
        });

        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

    }
})();
(function () {
  'use strict';

  angular.module('JPTC.pages.inOfficeService')
    .controller('EmployeeListCtrl', EmployeeListCtrl);

  /** @ngInject */
  function EmployeeListCtrl(inOfficeServices, FileSaver, $translate, toastr, baUtil, $state, $filter, AuthService) {
    var vm = this;
    vm.getLang = getLang;
    vm.query = {}
    vm.getValueFromTypeKey = getValueFromTypeKey
    vm.localTranslator = $filter('translate');
    vm.isLoading = true;
    vm.isFilterLoading = false;
    vm.isClearLoading = false;
    vm.isUploadLoading = false;
    vm.isDownloadLoading = false;
    vm.isDeleteLoading = false;
    vm.isQrDownloadLoading = false;
    vm.paginateCallback = paginateCallback;
    vm.selectedIds = {};
    vm.getDistinctColumnValues = getDistinctColumnValues;
    vm.getDepartmentList = getDepartmentList;
    vm.onDelete = onDelete;
    vm.onUpload = onUpload;
    vm.onUpdate = onUpdate;
    vm.onExport = onExport;
    vm.onQrCodeExport = onQrCodeExport;
    vm.applyFilters = applyFilters;
    vm.clearFilters = clearFilters;
    vm.onSelectAll = onSelectAll;
    vm.isEditDisabled = isEditDisabled;
    vm.gotoDetailPage = gotoDetailPage;
    vm.employeeResponse = {
      content: []
    };
    vm.permissions = AuthService.getPermissions();
    vm.isNormalSystemUser  = baUtil.isNormalSystemUser();
    vm.isNormalOfficeUser  = baUtil.isNormalOfficeUser();

    vm.boolOptions = {
      en: ['Yes', 'No'],
      jp: ['はい', 'いいえ'],
      key: [true, false]
    }

    var operationTypes = {
      en: ['Insert', 'Update', 'Add/Change', 'Delete', 'Reissue'],
      jp: ['追加', '更新', '追加/変更', '削除', '再発行'],
      key: ['INSERT', 'UPDATE', 'UPSERT', 'DELETE', 'REISSUE']
    }



    init();

    function init() {
      vm.colFilter = {};
      vm.search = {};
      vm.selectedIds = {};
      vm.select = false;
      vm.filter = {
        page: 0,
        size: baUtil.getDefaultPageSize('OFFICE'),
        filterModel: {

        }
      }
    }

    getEmployees();
    getDistinctColumnValues('departmentId');
    getDistinctColumnValues("officeId");


    function getEmployees() {
      inOfficeServices.searchEmployees(vm.filter)
        .then(function success(response) {
          vm.isFilterLoading = false;
          vm.isLoading = false;
          vm.isClearLoading = false;
          vm.employeeResponse = response.data.data;
        }, function err(err) {
          vm.isLoading = false;
          vm.isFilterLoading = false;
          vm.isClearLoading = false;
          toastr.error(
            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
            vm.localTranslator("common.components.title.error"),
            baUtil.toastOptions()
          );
        })
    }

    function gotoDetailPage(id) {
      $state.go('main.iosl.employee.detail', { id: id });
    }


    function applyFilters() {
      vm.isFilterLoading = true;
      if(vm.colFilter.OFFICE_ID) {
        vm.filter.filterModel["officeId"] = {
          filterType:"set",
          values: vm.colFilter.OFFICE_ID
        }
      }
      if(vm.colFilter.DEPARTMENT_ID) {
        vm.filter.filterModel["departmentId"] = {
          filterType:"set",
          values: vm.colFilter.DEPARTMENT_ID
        };
      }
      if(!vm.search.EMPLOYEE_ID && vm.filter.filterModel['employeeId']) {
        delete vm.filter.filterModel['employeeId'];
      }
      if(vm.search.EMPLOYEE_ID) {
        vm.filter.filterModel["employeeId"] = {
          filterType:"text",
          type:"",
          filter: vm.search.EMPLOYEE_ID
        };
      }
      if(!vm.search.EMPLOYEE_NAME && vm.filter.filterModel['name']) {
        delete vm.filter.filterModel['name'];
      }
      if(vm.search.EMPLOYEE_NAME) {
        vm.filter.filterModel["name"] = {
          filterType:"text",
          type:"",
          filter: vm.search.EMPLOYEE_NAME
        };
      }
      getEmployees();
      if(!vm.colFilter.DEPARTMENT_ID || !vm.colFilter.DEPARTMENT_ID.length) {
        getDistinctColumnValues("departmentId");
      }
      if(!vm.colFilter.OFFICE_ID || !vm.colFilter.OFFICE_ID.length) {
        getDistinctColumnValues("officeId");
      }
    }


    function clearFilters() {
      vm.isClearLoading = true;
      init();
      getEmployees();
      getDistinctColumnValues("departmentId");
      getDistinctColumnValues("officeId");
    }

    function getFilterWithoutPageOrSize() {
      var filter  = angular.copy(vm.filter);
      delete filter['page'];
      delete filter['size'];
      return filter;
    }

    function onSelectAll(ev, list) {
      list.forEach(function (item) {
        vm.selectedIds[item.id] = ev.target.checked
      })
    }


    function getLang() {
      return $translate.use();
    }


    function getValueFromTypeKey(key, type) {
      var index = type.key.findIndex(function (item) {
        return item === key
      })

      return type[vm.getLang()][index]
    }

    function isEditDisabled() {
      return Object.keys(vm.selectedIds)
        .filter(function (id) { return vm.selectedIds[id] })
        .length === 0;
    }


    function getDistinctColumnValues(columnName) {
      var filter = getFilterWithoutPageOrSize();
      inOfficeServices.getEmployeeColumnValues(columnName, filter)
        .then(function (response) {
          if(columnName === "departmentId") {
            vm.deptIdList = response.data.data;
          } else {
            vm.officeIdList = response.data.data;
          }
        });
    }

    function onUpdate() {
      var selectedRows = vm.employeeResponse.content.map(function (i) {
        return vm.selectedIds[i.id] ? i : null;
      }).filter(function (d) { return d; });
      var rows = [];
      selectedRows.forEach(function (item, index) {
        item.serialNo = index + 1;
        item.operation = 'UPSERT';
        rows.push(item);
      })
      $state.go('main.iosl.employee.update', { employees: rows });
    }

    function onUpload(file, ev) {
      var name = file.name;
      var size = file.size;
      var maxSize = 10485760;
      if (baUtil.checkForInvalidExtension(name.toLowerCase(), [".xlsx"])) {
        toastr.error(
          vm.localTranslator("common.components.msg.csv.format"),
          vm.localTranslator("common.components.title.error"),
          baUtil.toastOptions()
        );
      } else if (size > maxSize) {
        toastr.error(
          vm.localTranslator("common.components.msg.csv.max.size.10"),
          vm.localTranslator("common.components.title.error"),
          baUtil.toastOptions()
        );
      } else {
        vm.isUploadLoading = true;

        inOfficeServices.uploadDepartmentAndEmployeePreview(file)
          .then(function (response) {
            vm.isUploadLoading = false;
            if(!response.data.data.DEPARTMENT.length && !response.data.data.EMPLOYEE.length){
              ev.target.value = "";
              toastr.error(
                vm.localTranslator("iosl.empty.excel.file.msg"),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
            } else{
              $state.go('main.iosl.employee.preview', { data: response.data.data });
            }
          }, function err(err) {
            ev.target.value = "";
            vm.isUploadLoading = false;
            toastr.error(
              baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
              vm.localTranslator("common.components.title.error"),
              baUtil.toastOptions()
            );
          });
      }
    }

    function onQrCodeExport() {
      var ids = vm.employeeResponse.content.map(function (i) {
        return vm.selectedIds[i.id] ? i.id : null;
      }).filter(function (d) { return d; });
      vm.isQrDownloadLoading = true;
      inOfficeServices.exportEmployeeQrCode(ids)
        .then(function (resp) {
          var headers = resp.headers();
          var serverData = new Blob([resp.data], { type: headers['content-type'] });
          FileSaver.saveAs(serverData, '従業員QRコード_' + moment().format("YYYYMMDD") + '.zip');
          vm.isQrDownloadLoading = false;
          init();
        }, function (err) {
          vm.isQrDownloadLoading = false;
          if ("TextDecoder" in window) {
            try {
              var enc = new TextDecoder("utf-8");
              var data = enc.decode(err.data);
              err = JSON.parse(data);
            } catch (ignore) { }
          }
          toastr.error(
            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
            vm.localTranslator("common.components.title.error"),
            baUtil.toastOptions()
          );
        });
    }


    function onExport() {
      var ids = vm.employeeResponse.content.map(function (i) {
        return vm.selectedIds[i.id] ? i.id : null;
      }).filter(function (d) { return d; });

      
      var filter  = vm.filter;
      filter.filterModel["id"] = {
        filterType:"set",
        values: ids
      }

      delete filter['page'];
      delete filter['size'];
      vm.isDownloadLoading = true;
      inOfficeServices.exportEmployee(vm.filter)
        .then(function (resp) {
          var headers = resp.headers();
          var serverData = new Blob([resp.data], { type: headers['content-type'] });
          FileSaver.saveAs(serverData, '従業員_' + moment().format("YYYYMMDD") + '.xlsx');
          vm.isDownloadLoading = false;
          init();
        }, function (err) {
          vm.isDownloadLoading = false;
          if ("TextDecoder" in window) {
            try {
              var enc = new TextDecoder("utf-8");
              var data = enc.decode(err.data);
              err = JSON.parse(data);
            } catch (ignore) { }
          }
          toastr.error(
            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
            vm.localTranslator("common.components.title.error"),
            baUtil.toastOptions()
          );
        });
    }


    function onDelete() {
      var ids = vm.employeeResponse.content.map(function (i) {
        return vm.selectedIds[i.id] ? i.id : null;
      }).filter(function (d) { return d; });
      baUtil.showConfirm(vm.localTranslator("iosl.department.delete") + ' ?', vm.localTranslator("iosl.department.delete.msg"), vm.localTranslator("common.components.btn.yes"))
        .then(function () {
          vm.isDeleteLoading = true;
          inOfficeServices.deleteEmployee(ids)
          .then(function (response) {
            getEmployees();
            vm.isDeleteLoading = false;
            vm.selectedIds = {};
            vm.select = false;
              toastr.success(
                vm.localTranslator("iosl.employee.msg.delete.status"),
                vm.localTranslator("common.components.title.success"),
                baUtil.toastOptions()
              );
            }, function err(err) {
              toastr.error(
                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
              vm.isDeleteLoading = false;
            });
        });
    }

    function getDepartmentList(){
      if(vm.colFilter.OFFICE_ID) {
        vm.filter.filterModel["officeId"] = {
          filterType:"set",
          values: vm.colFilter.OFFICE_ID
        }
      }
      getDistinctColumnValues("departmentId");
    }


    function paginateCallback(query) {
      vm.filter.size = query.pageSize;
      vm.filter.pageSize = query.pageSize;
      vm.filter.page = query.pageNumber;
      inOfficeServices.searchEmployees(vm.filter)
        .then(function (response) {
          vm.employeeResponse = response.data.data;
          vm.filter = query;
        });
    }

  }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('NewEmployeeCtrl', NewEmployeeCtrl);

    /** @ngInject */
    function NewEmployeeCtrl($translate, toastr, $anchorScroll, $location, baUtil, $state, $filter, inOfficeServices) {

        var vm = this;
        vm.getLang = getLang;
        vm.query = {}
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.getDepartmentName = getDepartmentName;
        vm.isOfficeFieldDisabled = false;
        vm.onOfficeNameSelected = onOfficeNameSelected;
        vm.onDepartmentNameSelected = onDepartmentNameSelected;
        vm.createEmployee = createEmployee;
        vm.getOfficeName = getOfficeName;
        vm.employeeInfo = {};
        vm.employeeInfo.issueCount = 1;
        vm.open = open;
        vm.opened = false;

        if(baUtil.isOfficeUser()) {
            vm.employeeInfo.officeId = baUtil.getAccountDto().organisation.officeCode;
            vm.employeeInfo.officeName = baUtil.getAccountDto().organisation.name;
            vm.isOfficeFieldDisabled = true;
        }

        vm.startDateOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date()
        }

        vm.expiryDateOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
        }

        vm.boolOptions = {
            en: ['Yes', 'No'],
            jp: ['はい', 'いいえ'],
            key: [true, false]
        }

        function open() {
            vm.opened = true;
		}
		


        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function onOfficeNameSelected(data) {
            vm.employeeInfo.officeId = data.officeCode;
        }

        function onDepartmentNameSelected(data) {
            vm.employeeInfo.departmentId = data.key;
        }

        function createEmployee() {
           
            if(!vm.employeeInfo.departmentId) {
                vm.employeeInfo.departmentName = null;
                return;
            }

            if (vm.employeeForm.$invalid) {
                
                $location.hash('top');
                $anchorScroll();

                vm.error = [];
                vm.detailErrors = true;

                for (var key in vm.employeeForm.$error) {
                    for (var index = 0; index < vm.employeeForm.$error[key].length; index++) {
                        vm.error.push(vm.employeeForm.$error[key][index].$name);
                    }
                }

                vm.alerts = []
                vm.errors = []

                var unique = {};

                angular.forEach(vm.error, function (item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });

                vm.poko = {
                    'employeeId': {
                        'key': 'employeeId',
                        'en': 'Employee ID',
                        'jp': '従業員ID'
                    },
                    'employeeName': {
                        'key': 'employeeName',
                        'en': 'Employee Name',
                        'jp': '従業員名'
                    },
                    'officeName': {
                        'key': 'officeName',
                        'en': 'Office Name',
                        'jp': 'オフィス名'
                    },
                    'departmentName': {
                        'key': 'departmentName',
                        'en': 'Department Name',
                        'jp': '部署名'
                    },
                    isEnabled: {
                        'key': 'isEnabled',
                        'en': 'Enabled',
                        'jp': '有効済み',
                    },
                    startDate: {
                        'key': 'startDate',
                        'en': 'Start Date',
                        'jp': '開始日',
                    },
                    expiryDate: {
                        'key': 'expiryDate',
                        'en': 'Expiration Date',
                        'jp': '有効期限',
                    },
                    issueCount: {
                        'key': 'issueCount',
                        'en': 'Issue Count',
                        'jp': '発行回数',
                    },
                    remarks: {
                        'key': 'remarks',
                        'en': 'Employee Remarks',
                        'jp': '従業員備考',
                    }
                }

                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }

                vm.errorNumbers = vm.alerts.length;
                return;

            }
            else {
                vm.detailErrors = false;
            }

            vm.employeeInfo.startDate = typeof vm.employeeInfo.startDate === 'number' ? vm.employeeInfo.startDate : vm.employeeInfo.startDate.getTime();
            if(vm.employeeInfo.expiryDate) {
                 vm.employeeInfo.expiryDate = typeof vm.employeeInfo.expiryDate === 'number' ? vm.employeeInfo.expiryDate : vm.employeeInfo.expiryDate.getTime();
            }

            if(vm.employeeInfo.expiryDate && vm.employeeInfo.startDate > vm.employeeInfo.expiryDate) {
                toastr.error(
                    vm.localTranslator("iosl.employee.expiration.date.msg"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                return;
            }
            var data = vm.employeeInfo;
            inOfficeServices.createEmployee(data).then(function success(response) {
                $state.go('main.iosl.employee.list');
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                );
            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                vm.alerts = err.data.data;
            });
        }


        function getOfficeName(query) {
            return inOfficeServices.searchOfficeByName(query);
        }

        function getDepartmentName(query) {
            if(!vm.employeeInfo.officeId) {
                toastr.error(
                    vm.localTranslator("iosl.employee.select.office.name.msg"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                return;
            }
            return inOfficeServices.searchDepartmentByName(query,  vm.employeeInfo.officeId);
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('accountManagementCtrl', accountManagementCtrl);

    /** @ngInject */
    function accountManagementCtrl($translate, FileSaver, toastr, baUtil, $filter, inOfficeServices,$state) {
        var vm = this;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.onRegisterNew = registerNew;
        vm.deleteTerminalOpsAccount = deleteTerminalOpsAccount;
        vm.applyFilters = applyFilters;
        vm.clearFilters = clearFilters;
        vm.enableAccount = enableAccount;
        vm.disableAccount = disableAccount;
        vm.onUpdate = onUpdate;
        vm.isLoading = true;
        vm.isClearBtnDisabled = true;
        vm.date = new Date(baUtil.getStartDateOfMonth());
        vm.dateFormat = 'yyyy/MM';
        vm.paginateCallback = paginateCallback;
        vm.accountDetailsResponse = {
            content: []
          };

        vm.displayUnit = {
            en: ["Monthly", "Daily"],
            jp: ["月毎", "日毎"],
            key: ['MONTHLY', 'DAILY']
        }

        vm.monthlyDateOptions = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month',
            placeholder: 'yyyy年mm月'
        }

        vm.dailyDateOptions = {
            showWeeks: false,
            placeholder: 'yyyy年mm月dd日'
        }

        init();
        
        function init() {
            vm.colFilter = {};
            vm.search = {};
            vm.select = false;
            vm.filter = {
                page: 0,
                size: baUtil.getDefaultPageSize('OFFICE'),
                pageSize: baUtil.getDefaultPageSize('OFFICE'),
                filterModel: {
        
                }
            }
        }

        getTerminalAccountDetails();

        function getTerminalAccountDetails(){
            inOfficeServices.searchTerminalOpsAccounts(vm.filter)
            .then(function success(response) {
              vm.isFilterLoading = false;
              vm.isLoading = false;
              vm.isClearLoading = false;
              vm.accountDetailsResponse = response.data.data;
            }, function err(err) {
              vm.isLoading = false;
              vm.isFilterLoading = false;
              vm.isClearLoading = false;
              toastr.error(
                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
        })
        }

        function paginateCallback(query) {
            vm.filter.size = query.pageSize;
            vm.filter.pageSize = query.pageSize;
            vm.filter.page = query.pageNumber;
            inOfficeServices.searchTerminalOpsAccounts(vm.filter)
              .then(function (response) {
                vm.accountDetailsResponse = response.data.data;
                vm.filter = query;
              });
          }

        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            
            return type[vm.getLang()][index]
        }


        function registerNew() {
            $state.go('main.iosl.terminalOperation.register');
        }



        function applyFilters() {
            vm.isFilterLoading = true;
  
            if(vm.search.officeId) {
              vm.filter.filterModel["officeId"] = {
                filterType:"text",
                filter: vm.search.officeId
              };
            }
  
            if(vm.search.authenticationId) {
                vm.filter.filterModel["authenticationId"] = {
                  filterType:"text",
                  filter: vm.search.authenticationId
                };
              }
  
            if(vm.search.authenticationIdName) {
              vm.filter.filterModel["authenticationIdName"] = {
                filterType:"text",
                filter: vm.search.authenticationIdName
              };
            }
  
            getTerminalAccountDetails();
  
        }  

        function clearFilters() {
            vm.isClearLoading = true;
            init();
            getTerminalAccountDetails();
        }  

        function deleteTerminalOpsAccount(obj){

            baUtil.showConfirm(vm.localTranslator("iosl.account.management.delete") + ' ?',vm.localTranslator("iosl.account.management.delete.msg"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
                inOfficeServices.deleteTerminalOpsAccounts(obj.id).then(function success(response) {
                $state.reload()
                toastr.success(
                    vm.localTranslator("iosl.account.management.msg.delete.status"),                     
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions())
                }, function err(err) {
                    toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                });
             });

        }  

        function enableAccount(obj){
            baUtil.showConfirm(vm.localTranslator("iosl.account.management.enable") + ' ?',vm.localTranslator("iosl.account.management.msg.enable"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
            
                inOfficeServices.enableTerminalOpsAccount(obj).then(function success(response) {
                $state.reload()
                toastr.success(
                    vm.localTranslator("iosl.account.management.msg.enable.status"),                     
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions())
                }, function err(err) {
                    toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                });
                
            });               
        }

        function disableAccount(obj){
            baUtil.showConfirm(vm.localTranslator("iosl.account.management.disable") + ' ?',vm.localTranslator("iosl.account.management.msg.disable"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
            
                inOfficeServices.disableTerminalOpsAccount(obj).then(function success(response) {
                $state.reload()
                toastr.success(
                    vm.localTranslator("iosl.account.management.msg.disable.status"),                     
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions())
                }, function err(err) {
                    toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                });
                
            });
        }

        function onUpdate(item) {
            $state.go('main.iosl.terminalOperation.edit', { accountDetails: item });
        }

    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('editAccountNewCtrl', editAccountNewCtrl);

    /** @ngInject */
    function editAccountNewCtrl($translate, FileSaver, toastr, baUtil, $filter, inOfficeServices,$state,$stateParams) {

        if( $stateParams.accountDetails == null ) {
            $state.go("main.iosl.terminalOperation.accountManagement");
        }

        var vm = this;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.createNewAccount = createNewAccount;
        vm.isLoading = false;
        vm.isClearBtnDisabled = true;
        vm.date = new Date(baUtil.getStartDateOfMonth());
        vm.dateFormat = 'yyyy/MM';
        vm.onOfficeNameSelected = onOfficeNameSelected;
        vm.getOfficeName = getOfficeName;

        vm.displayUnit = {
            en: ["Monthly", "Daily"],
            jp: ["月毎", "日毎"],
            key: ['MONTHLY', 'DAILY']
        }

        vm.monthlyDateOptions = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month',
            placeholder: 'yyyy年mm月'
        }

        vm.dailyDateOptions = {
            showWeeks: false,
            placeholder: 'yyyy年mm月dd日'
        }

        init();
        // getUsageDetailsMinMaxDate();

        function init() {
            vm.colFilter = {};
            vm.search = {};
            vm.filter = {
                page: 0,
                size: 10,
                pageSize: 100,
                filterModel: {

                }
            }
        }

        if (!baUtil.isUndefinedOrNull($stateParams.accountDetails)) {
            vm.newAccountInfo = $stateParams.accountDetails;
        }    

        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function createNewAccount (){
            
            //Start of error validation

            if (vm.terminalOpsNewAccount.$invalid) {
                 
                $location.hash('top');
                $anchorScroll();
                
                vm.error = [];
                vm.detailErrors = true; 
                
                for (var key in vm.terminalOpsNewAccount.$error) {
                    for (var index = 0; index < vm.terminalOpsNewAccount.$error[key].length; index++) {
                        vm.error.push(vm.terminalOpsNewAccount.$error[key][index].$name);
                    }
                }
                
                vm.alerts = []
                vm.errors = []
                
                var unique = {};
                
                angular.forEach(vm.error, function(item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });
                
                                 
                vm.poko = {
                    'OfficeId':{
                        'key':'OfficeId',
                        'en':'Office Id',
                        'jp':'オフィスID'
                    },
                    'authenticationId':{
                        'key':'authenticationId',
                        'en':'Authentication Id',
                        'jp':'認証ID'
                    },
                    'authenticationIdName':{
                        'key':'authenticationIdName',
                        'en':'Authentication Id Name',
                        'jp':'認証ID名'
                    },
                    'password':{
                        'key':'password',
                        'en':'Password',
                        'jp':'パスワード'
                    }
                }
                
                vm.errorCounts = vm.errors.length;
                
                for (var i = 0; i < vm.errorCounts; i++) {
                    
                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })
                    
                }
                vm.errorNumbers = vm.alerts.length;
                return;
                
            }
            else {
                vm.detailErrors = false;
            }
            
            //end of error validation

            vm.btnClick = true;

            var data = vm.newAccountInfo;
            inOfficeServices.updateTerminalOpsAccount(data).then(function success(response) {
                vm.btnClick = false;
                $state.go('main.iosl.terminalOperation.accountManagement');
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                );
            }, function err(err) {
                vm.btnClick = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                vm.alerts = err.data.data;
            });

        }

        function getOfficeName(Id){
            return inOfficeServices.searchOfficeById(Id);
        }

        function onOfficeNameSelected(data){
            vm.newAccountInfo.officeId = data.officeCode;
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('registerNewCtrl', registerNewCtrl);

    /** @ngInject */
    function registerNewCtrl($translate, FileSaver, toastr, baUtil, $filter, inOfficeServices,$state,$anchorScroll,$location) {
        var vm = this;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.createNewAccount = createNewAccount;
        vm.isLoading = false;
        vm.isClearBtnDisabled = true;
        vm.date = new Date(baUtil.getStartDateOfMonth());
        vm.dateFormat = 'yyyy/MM';
        vm.onOfficeNameSelected = onOfficeNameSelected;
        vm.getOfficeName = getOfficeName;

        vm.displayUnit = {
            en: ["Monthly", "Daily"],
            jp: ["月毎", "日毎"],
            key: ['MONTHLY', 'DAILY']
        }

        vm.monthlyDateOptions = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month',
            placeholder: 'yyyy年mm月'
        }

        vm.dailyDateOptions = {
            showWeeks: false,
            placeholder: 'yyyy年mm月dd日'
        }

        init();
        // getUsageDetailsMinMaxDate();

        function init() {
            vm.colFilter = {};
            vm.search = {};
            vm.filter = {
                page: 0,
                size: 10,
                pageSize: 100,
                filterModel: {

                }
            }
        }

        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function createNewAccount (){

            //Start of error validation
            if (vm.terminalOpsNewAccount.$invalid) {
                 
                $location.hash('top');
                $anchorScroll();
                 
                vm.error = [];
                vm.detailErrors = true; 

                for (var key in vm.terminalOpsNewAccount.$error) {
                    for (var index = 0; index < vm.terminalOpsNewAccount.$error[key].length; index++) {
                        vm.error.push(vm.terminalOpsNewAccount.$error[key][index].$name);
                    }
                }
                 
                vm.alerts = []
                vm.errors = []
                console.log('vm.errors', vm.errors)
                var unique = {};
                 
                angular.forEach(vm.error, function(item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });
                
                                 
                vm.poko = {
                    'OfficeId':{
                        'key':'OfficeId',
                        'en':'Office Id',
                        'jp':'オフィスID'
                    },
                    'authenticationId':{
                        'key':'authenticationId',
                        'en':'Authentication Id',
                        'jp':'認証ID'
                    },
                    'authenticationIdName':{
                        'key':'authenticationIdName',
                        'en':'Authentication Id Name',
                        'jp':'認証ID名'
                    },
                    'password':{
                        'key':'password',
                        'en':'Password',
                        'jp':'パスワード'
                    }
                }
                 
                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.errorNumbers = vm.alerts.length;
                return;

            }
            else {
                vm.detailErrors = false;
            }

            //end of error validation

            vm.btnClick = true;
            var data = vm.newAccountInfo;
            inOfficeServices.termianlOpsAccountCreate(data).then(function success(response) {
                vm.btnClick = false;
                $state.go('main.iosl.terminalOperation.accountManagement');
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                );
            }, function err(err) {
                vm.btnClick = false;
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                vm.alerts = err.data.data;
            });

        }

        function getOfficeName(Id){
            return inOfficeServices.searchOfficeById(Id);
        }

        function onOfficeNameSelected(data){
            vm.newAccountInfo.officeId = data.officeCode;
        }
    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('transmissionHistoryCtrl', transmissionHistoryCtrl);

    /** @ngInject */
    function transmissionHistoryCtrl($translate, toastr,filterOptions, baUtil, $filter, inOfficeServices,$scope) {
        var vm = this;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.applyFilters = applyFilters;
        vm.clearFilters = clearFilters;
        vm.onDelete = onDelete;
        vm.isEditDisabled = isEditDisabled;
        vm.isLoading = true;
        vm.isClearBtnDisabled = true;
        vm.date = new Date(baUtil.getStartDateOfMonth());
        vm.dateFormat = 'yyyy/MM';
        vm.paginateCallback = paginateCallback;
        vm.selectedIds = {};
        vm.transmissionHistoryResponse = {
            content: []
          };
        vm.filterOptions = filterOptions.data.data;
        vm.setFiltersOptionsOfCurrentLanguage = setFiltersOptionsOfCurrentLanguage;

        vm.displayUnit = {
            en: ["Monthly", "Daily"],
            jp: ["月毎", "日毎"],
            key: ['MONTHLY', 'DAILY']
        }

        vm.monthlyDateOptions = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month',
            placeholder: 'yyyy年mm月'
        }

        vm.dailyDateOptions = {
            showWeeks: false,
            placeholder: 'yyyy年mm月dd日'
        }

        init();

        function init() {
            vm.colFilter = {};
            vm.search = {};
            vm.select = false;
            vm.filter = {
                page: 0,
                size: baUtil.getDefaultPageSize('OFFICE'),
                pageSize: baUtil.getDefaultPageSize('OFFICE'),
                filterModel: {

                }
            }
        }

        getTerminalAccountHistory();

        vm.changeFirstDateRange = changeFirstDateRange;

        function changeFirstDateRange() {
            var dates = getDatePair(vm.filterOptions.DateOptions.filter(function(op){return op.key===vm.opFirstSelect.value})[0]);
            vm.search.TRANSMISSION_RECIEVED_FROM = dates[0];
            vm.search.TRANSMISSION_RECIEVED_TO = dates[1];
        }


        function getDatePair(dateOption) {
            var isDay, isWeek, isMonth, isYear;
            isDay = (dateOption.unit == 1);
            isWeek = (dateOption.unit == 2);
            isMonth = (dateOption.unit == 3);
            isYear = (dateOption.unit == 4);

            var fromValue = dateOption.from - 1;
            var toValue = dateOption.to - 1;
            var today = new Date();
            var lastDay = new Date();
            var month = today.getMonth();
            var year = today.getFullYear();

            var fromDate, toDate;

            if (isDay) {
                var startDate = today.getDate() - fromValue;
                var endDate = lastDay.getDate() - toValue;
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(endDate);
            } else if (isWeek) {
                var weekDay = fromValue*7;
                var startDate = today.getDate() - today.getDay() - weekDay + (today.getDay() === 0 ? -6 : 0);
                fromDate = today.setDate(startDate);
                toDate = lastDay.setDate(lastDay.getDate() - lastDay.getDay() - (toValue*7) + 6);
                if (toDate > new Date().getTime()) {
                    toDate = new Date().getTime();
                }
            } else if (isMonth) {
                var fromMonth = month - fromValue;
                var toMonth = month - toValue + 1;
                fromDate = new Date(year, fromMonth, 1).getTime();
                toDate = new Date(year, toMonth, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            } else if (isYear) {
                var fromYear = year - fromValue;
                var toYear = year - toValue;
                fromDate = new Date(fromYear, 0, 1).getTime();
                toDate = new Date(toYear,12, 0).getTime();
                if (toDate > lastDay.getTime()) {
                    toDate = today.getTime();
                }
            }
            return [fromDate, toDate];
        }



        $scope.$on('LANG_CHANGE', function (event) {
            setFiltersOptionsOfCurrentLanguage();
        });

        function setFiltersOptionsOfCurrentLanguage() {

            vm.filterOptions.options = {};
            
            vm.filterOptions.options["DateOptions"] = (vm.filterOptions["DateOptions"]||[]).map(function(d,i){
                return { label: d[getLang()], value: d["key"] };
            });

        }

        setFiltersOptionsOfCurrentLanguage();

        function getTerminalAccountHistory(){
        inOfficeServices.searchTerminalOpsHistory(vm.filter)
        .then(function success(response) {
          vm.isFilterLoading = false;
          vm.isLoading = false;
          vm.isClearLoading = false;
          vm.transmissionHistoryResponse = response.data.data;
        }, function err(err) {
          vm.isLoading = false;
          vm.isFilterLoading = false;
          vm.isClearLoading = false;
          toastr.error(
            baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
            vm.localTranslator("common.components.title.error"),
            baUtil.toastOptions()
          );
        })
        }


        function applyFilters() {
            vm.isFilterLoading = true;

            if (!vm.search.OFFICE_ID && vm.filter.filterModel['officeId']) {
                delete vm.filter.filterModel['officeId'];
            }
            if (vm.search.OFFICE_ID) {
                vm.filter.filterModel["officeId"] = {
                    filterType: "text",
                    filter: vm.search.OFFICE_ID
                };
            }
            if (!vm.search.OFFICE_NAME && vm.filter.filterModel['officeName']) {
                delete vm.filter.filterModel['officeName'];
            }
            if (vm.search.OFFICE_NAME) {
                vm.filter.filterModel["officeName"] = {
                    filterType: "text",
                    filter: vm.search.OFFICE_NAME
                };
            }
            if (!vm.search.DEVICE_NUMBER && vm.filter.filterModel['deviceNumber']) {
                delete vm.filter.filterModel['deviceNumber'];
            }
            if (vm.search.DEVICE_NUMBER) {
                vm.filter.filterModel["deviceNumber"] = {
                    filterType: "text",
                    filter: vm.search.DEVICE_NUMBER
                };
            }
            if (!vm.search.PROCESSING_RESULT && vm.filter.filterModel['processingResult']) {
                delete vm.filter.filterModel['processingResult'];
            }
            if (vm.search.PROCESSING_RESULT) {
                vm.filter.filterModel["processingResult"] = {
                    filterType: "number",
                    filter: vm.search.PROCESSING_RESULT
                };
            }
            if (!vm.search.ERROR_CODE && vm.filter.filterModel['errorCode']) {
                delete vm.filter.filterModel['errorCode'];
            }
            if (vm.search.ERROR_CODE) {
                vm.filter.filterModel["errorCode"] = {
                    filterType: "text",
                    filter: vm.search.ERROR_CODE
                };
            }
            if (!vm.search.ERROR_RESULT && vm.filter.filterModel['errorResult']) {
                delete vm.filter.filterModel['errorResult'];
            }
            if (vm.search.ERROR_RESULT) {
                vm.filter.filterModel["errorResult"] = {
                    filterType: "text",
                    filter: vm.search.ERROR_RESULT
                };
            }

            if (!vm.search.TRANSMISSION_RECIEVED_FROM && vm.filter.filterModel['transmissionReceivedFrom']) {
                delete vm.filter.filterModel['transmissionReceivedFrom'];
            }

            if (!vm.search.TRANSMISSION_RECIEVED_TO && vm.filter.filterModel['transmissionReceivedTo']) {
                delete vm.filter.filterModel['transmissionReceivedTo'];
            }

            if (vm.search.TRANSMISSION_RECIEVED_TO || vm.search.TRANSMISSION_RECIEVED_FROM) {
                vm.filter.filterModel["transmissionReceivedAt"] = {
                    filterType: "number",
                    type:"inRange",
                    filter: new Date(vm.search.TRANSMISSION_RECIEVED_FROM).setHours(0,0,0,0),
                    filterTo : new Date(vm.search.TRANSMISSION_RECIEVED_TO).setHours(23,59,59,0),
                };
            }

            getTerminalAccountHistory();
        }


        function clearFilters() {
            vm.isClearLoading = true;
            init();
            delete vm.opFirstSelect;
            getTerminalAccountHistory();
        }


        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function paginateCallback(query) {
            vm.filter.size = query.pageSize;
            vm.filter.pageSize = query.pageSize;
            vm.filter.page = query.pageNumber;
            inOfficeServices.searchTerminalOpsHistory(vm.filter)
              .then(function (response) {
                vm.transmissionHistoryResponse = response.data.data;
                vm.filter = query;
              });
          }

          function isEditDisabled() {
            return Object.keys(vm.selectedIds)
              .filter(function (id) { return vm.selectedIds[id] })
              .length === 0;
          }

          function onDelete() {
            var ids = vm.transmissionHistoryResponse.content.map(function (i) {
              return vm.selectedIds[i.id] ? i.id : null;
            }).filter(function (d) { return d; });
            baUtil.showConfirm(vm.localTranslator("iosl.department.delete") + ' ?', vm.localTranslator("iosl.department.delete.msg"), vm.localTranslator("common.components.btn.yes"))
              .then(function () {
                vm.isDeleteLoading = true;
                inOfficeServices.deleteTerminalOpsHistory(ids)
                .then(function (response) {
                getTerminalAccountHistory();
                  vm.isDeleteLoading = false;
                  vm.selectedIds = {};
                  vm.select = false;
                    toastr.success(
                      vm.localTranslator("iosl.employee.msg.delete.status"),
                      vm.localTranslator("common.components.title.success"),
                      baUtil.toastOptions()
                    );
                  }, function err(err) {
                    toastr.error(
                      baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                      vm.localTranslator("common.components.title.error"),
                      baUtil.toastOptions()
                    );
                    vm.isDeleteLoading = false;
                  });
              });
          }  



    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('MonthlyUsageCtrl', MonthlyUsageCtrl);

    /** @ngInject */
    function MonthlyUsageCtrl($translate, toastr, baUtil, $filter,FileSaver, inOfficeServices) {
        var vm = this;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.applyFilters = applyFilters;
        vm.clearFilters = clearFilters;
        vm.onExport = onExport;
        vm.isLoading = false;
        vm.isDepartment = true;
        vm.isClearBtnDisabled = true;
        vm.navigate = navigate;
        vm.date = new Date(baUtil.getStartDateOfMonth());
        vm.dateFormat = 'yyyy/MM';
        vm.paginateCallback = paginateCallback;
        vm.interval = "MONTHLY";
        vm.isTableHeaderVisible = isTableHeaderVisible;
      

        vm.displayUnit = {
            en: ["Monthly", "Daily", "Specific Period"],
            jp: ["月毎", "日毎", "特定の期間"],
            key: ["MONTHLY", "DAILY", "SPECIFIC_PERIOD"]
        }

        vm.granularityOptions = {
            en: ["Office", "Department", "Employee",  "Daily"],
            jp: ["オフィス", "部署", "従業員", "日毎"],
            key: ["OFFICE", "DEPARTMENT", "EMPLOYEE", "DAILY"]
        }

        vm.monthlyDateOptions = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month',
            placeholder: 'yyyy年mm月'
        }

        vm.dailyDateOptions = {
            showWeeks: false,
            placeholder: 'yyyy年mm月dd日',
        }

        vm.fromDateOptions = {
            format: 'YYYY/MM/DD',
            date: new Date(),
            locale:'ja',
            dayViewHeaderFormat:'MMMM YYYY[年]',
            allowInputToggle: true
          }

        vm.toDateOptions = {
            format: 'YYYY/MM/DD',
            date: new Date(),
            locale:'ja',
            dayViewHeaderFormat:'MMMM YYYY[年]',
            allowInputToggle: true,
        }

        vm.onFromDateChange = function(){
            vm.toDateOptions['minDate'] = moment(vm.fromDate).toDate();
            vm.fromDateOptions["date"] = vm.fromDate ? vm.fromDate: new Date(); 
            if(moment(vm.fromDate).valueOf() < moment(vm.toDate).valueOf()){
                vm.toDateOptions["date"] = vm.toDate ? vm.toDate: new Date(); 
            }
        }

        init();
        getUsageDetailsMinMaxDate();

        function init() {
            vm.colFilter = {};
            vm.search = {};
            vm.filter = {
                filters: {
                    page: 0,
                    size: baUtil.getDefaultPageSize('OFFICE'),
                    filterModel: {

                    }
                }
            }
        }


        function applyFilters() {
            if (vm.searchForm.$invalid) {
                toastr.error($translate.instant('common.components.errorMessages.fillRequiredFields'),
                    $translate.instant('common.components.errorMessages.error'), baUtil.toastOptions())
                vm.isLoading = false;
                return;
            }
           
            switch(vm.interval){
                case "MONTHLY":
                    vm.filter.filters.filterModel = {
                        month: {
                            filter:  vm.date.getTime(),
                            filterType: "number"
                        }
                    }
                break;
                case "DAILY":
                    vm.filter.filters.filterModel = {
                        day: {
                            filter:  vm.date.getTime(),
                            filterType: "number"
                        }
                    }
                break;
                case "SPECIFIC_PERIOD":
                    vm.filter.filters.filterModel = {
                        day: {
                            filter:  moment(vm.fromDate).valueOf(),
                            filterTo: moment(vm.toDate).valueOf(),
                            filterType: "number"
                        }
                    }
                break;
                default:
                    vm.filter.filters.filterModel = {
                    }
            }


            if (!vm.search.OFFICE_ID && vm.filter.filters.filterModel['officeId']) {
                delete vm.filter.filters.filterModel['officeId'];
            }
            if (vm.search.OFFICE_ID) {
                vm.filter.filters.filterModel["officeId"] = {
                    filterType: "text",
                    filter: vm.search.OFFICE_ID
                };
            }
            if (!vm.search.DEPARTMENT_ID && vm.filter.filters.filterModel['departmentId']) {
                delete vm.filter.filters.filterModel['departmentId'];
            }
            if (vm.search.DEPARTMENT_ID) {
                vm.filter.filters.filterModel["departmentId"] = {
                    filterType: "text",
                    filter: vm.search.DEPARTMENT_ID
                };
            }
            if (!vm.search.OPERATOR && vm.filter.filters.filterModel['merchantCode']) {
                delete vm.filter.filters.filterModel['merchantCode'];
            }
            if (vm.search.OPERATOR) {
                vm.filter.filters.filterModel["merchantCode"] = {
                    filterType: "text",
                    filter: vm.search.OPERATOR
                };
            }
            if (!vm.search.EMPLOYEE_ID && vm.filter.filters.filterModel['employeeId']) {
                delete vm.filter.filters.filterModel['employeeId'];
            }
            if (vm.search.EMPLOYEE_ID) {
                vm.filter.filters.filterModel["employeeId"] = {
                    filterType: "text",
                    filter: vm.search.EMPLOYEE_ID
                };
            }
            if (!vm.search.EMPLOYEE_NAME && vm.filter.filters.filterModel['employeeName']) {
                delete vm.filter.filters.filterModel['employeeName'];
            }
            if (vm.search.EMPLOYEE_NAME) {
                vm.filter.filters.filterModel["employeeName"] = {
                    filterType: "text",
                    filter: vm.search.EMPLOYEE_NAME
                };
            }
            if (!vm.search.DEVICE_SERIAL && vm.filter.filters.filterModel['deviceSerialNumber']) {
                delete vm.filter.filters.filterModel['deviceSerialNumber'];
            }
            if (vm.search.DEVICE_SERIAL) {
                vm.filter.filters.filterModel["deviceSerialNumber"] = {
                    filterType: "text",
                    filter: vm.search.DEVICE_SERIAL
                };
            }
            if (!vm.search.INSTALLATION_STORE && vm.filter.filters.filterModel['installationStoreName']) {
                delete vm.filter.filters.filterModel['installationStoreName'];
            }
            if (vm.search.INSTALLATION_STORE) {
                vm.filter.filters.filterModel["installationStoreName"] = {
                    filterType: "text",
                    filter: vm.search.INSTALLATION_STORE
                };
            }
            if (!vm.search.REMARKS && vm.filter.filters.filterModel['remarks']) {
                delete vm.filter.filters.filterModel['remarks'];
            }
            if (vm.search.REMARKS) {
                vm.filter.filters.filterModel["remarks"] = {
                    filterType: "text",
                    filter: vm.search.REMARKS
                };
            }


            vm.filter['aggregationColumn'] = vm.granularity.entity;

            getData();
        }

        function getData() {
            vm.isLoading = true;
            inOfficeServices.getTransactions(vm.filter)
                .then(function success(response) {
                    vm.isLoading = false;
                    vm.isClearBtnDisabled = false;
                    vm.transactionResponse = response.data.data;
                }, function err(err) {
                    vm.isLoading = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                })
        }


        function isTableHeaderVisible(granularity) {
            if(vm.filter.aggregationColumn){
                return vm.filter.aggregationColumn === granularity;
            }
        }

        function getDistinctColumnValues(columnName) {
            var filter = getFilterWithoutPageOrSize();
            inOfficeServices.getDeviceUsageColumnValues(columnName, filter)
                .then(function (response) {
                    if (columnName === "departmentId") {
                        vm.deptIdList = response.data.data;
                    } else if (columnName === "officeId") {
                        vm.officeIdList = response.data.data;
                    } else {
                        vm.merchantList = response.data.data;
                    }
                });
        }


        function onExport() {
            var filter = vm.filter.filters;
            vm.isDownloadLoading = true;
            inOfficeServices.downloadTransactions(vm.filter)
                .then(function (resp) {
                    var headers = resp.headers();
                    var serverData = new Blob([resp.data], { type: headers['content-type'] });
                    FileSaver.saveAs(serverData, '利用詳細 / 月別・日別_' + moment().format("YYYYMMDD") + '.csv');
                    vm.isDownloadLoading = false;
                    vm.select = false;
                }, function (err) {
                    vm.isDownloadLoading = false;
                    if ("TextDecoder" in window) {
                        try {
                            var enc = new TextDecoder("utf-8");
                            var data = enc.decode(err.data);
                            err = JSON.parse(data);
                        } catch (ignore) { }
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function getFilterWithoutPageOrSize() {
            var filter = angular.copy(vm.filter.filters);
            delete filter['page'];
            delete filter['size'];
            return filter;
        }

        function clearFilters() {
            vm.isClearLoading = true;
            init();
            applyFilters();
            // getData();
            getDistinctColumnValues("departmentId");
            getDistinctColumnValues("officeId");
            getDistinctColumnValues("merchantCode");
        }

        function navigate(type) {
            if (vm.interval === 'DAILY') {
                switch (type) {
                    case 'NEXT':
                        vm.date = new Date(baUtil.getStartOfNextDay(vm.date));
                        break;
                    case 'PREV':
                        vm.date = new Date(baUtil.getStartOfPrevDay(vm.date));
                        break;
                    case 'FIRST':
                        vm.date = new Date(baUtil.getStartOfDay(vm.navigationDates.from));
                        break;
                    case 'LAST':
                        vm.date = new Date(baUtil.getStartOfDay(vm.navigationDates.to));
                        break;
                    default:
                        return
                }
                vm.filter.filters.filterModel = {
                    day: {
                        filter: vm.date.getTime(),
                        filterType: "number"
                    }
                }
            } else {
                switch (type) {
                    case 'NEXT':
                        vm.date = new Date(baUtil.getStartOfNextMonth(vm.date));
                        break;
                    case 'PREV':
                        vm.date = new Date(baUtil.getStartOfPrevMonth(vm.date));
                        break;
                    case 'FIRST':
                        vm.date = new Date(baUtil.getStartDateOfMonth(vm.navigationDates.from));
                        break;
                    case 'LAST':
                        vm.date = new Date(baUtil.getStartDateOfMonth(vm.navigationDates.to));
                        break;
                    default:
                        return
                }
                vm.filter.filters.filterModel = {
                    month: {
                        filter: vm.date.getTime(),
                        filterType: "number"
                    }
                }
            }
            getDistinctColumnValues("departmentId");
            getDistinctColumnValues("officeId");
            getDistinctColumnValues("merchantCode");
            applyFilters();
            getData();
        }


        function getUsageDetailsMinMaxDate() {  
            inOfficeServices.getUsageDetailsMinMaxDate()
                .then(function success(response) {
                    vm.navigationDates = response.data.data;
                });
        }



        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }


        function paginateCallback(query) {
          vm.filter.filters.size = query.pageSize;
          vm.filter.filters.page = query.pageNumber;
          vm.filter.filters.pageSize = query.pageSize;
          inOfficeServices.getTransactions(vm.filter)
            .then(function (response) {
                if(vm.granularity.entity === 'EMPLOYEE') {
                    vm.isDepartment = false;
                } else {
                    vm.isDepartment = true;
                }
                vm.transactionResponse = response.data.data;
              vm.query = query;
            });
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('OneItemUsageCtrl', OneItemUsageCtrl);

    /** @ngInject */
    function OneItemUsageCtrl($translate, FileSaver, toastr, baUtil, $filter, inOfficeServices) {
        var vm = this;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.applyFilters = applyFilters;
        vm.clearFilters = clearFilters;
        vm.onExport = onExport;
        vm.isLoading = false;
        vm.isClearBtnDisabled = true;
        vm.navigate = navigate;
        vm.date = new Date(baUtil.getStartDateOfMonth());
        vm.dateFormat = 'yyyy/MM';
        vm.interval = "MONTHLY";
        vm.paginateCallback = paginateCallback;

        vm.displayUnit = {
            en: ["Monthly", "Daily", "Specific Period"],
            jp: ["月毎", "日毎", "特定の期間"],
            key: ["MONTHLY", "DAILY", "SPECIFIC_PERIOD"]
        }

        vm.monthlyDateOptions = {
            showWeeks: false,
            datepickerMode: 'month',
            minMode: 'month',
            placeholder: 'yyyy年mm月'
        }

        vm.dailyDateOptions = {
            showWeeks: false,
            placeholder: 'yyyy年mm月dd日'
        }

        vm.fromDateOptions = {
            format: 'YYYY/MM/DD',
            date: new Date(),
            locale:'ja',
            dayViewHeaderFormat:'MMMM YYYY[年]',
            allowInputToggle: true
          }

        vm.toDateOptions = {
            format: 'YYYY/MM/DD',
            date: new Date(),
            locale:'ja',
            dayViewHeaderFormat:'MMMM YYYY[年]',
            allowInputToggle: true,
        }

        vm.onFromDateChange = function(){
            vm.toDateOptions['minDate'] = moment(vm.fromDate).toDate();
            vm.fromDateOptions["date"] = vm.fromDate ? vm.fromDate: new Date(); 
            if(moment(vm.fromDate).valueOf() < moment(vm.toDate).valueOf()){
                vm.toDateOptions["date"] = vm.toDate ? vm.toDate: new Date(); 
            }
        }

        init();
        getUsageDetailsMinMaxDate();

        function init() {
            vm.colFilter = {};
            vm.search = {};
            vm.filter = {
                page: 0,
                size: baUtil.getDefaultPageSize('OFFICE'),
                pageSize: baUtil.getDefaultPageSize('OFFICE'),
                filterModel: {

                }
            }
        }


        function applyFilters() {
            if (vm.searchForm.$invalid) {
                toastr.error($translate.instant('common.components.errorMessages.fillRequiredFields'),
                    $translate.instant('common.components.errorMessages.error'), baUtil.toastOptions())
                vm.isLoading = false;
                return;
            }

            if (vm.interval === 'MONTHLY') {
                vm.filter.filterModel = {
                    month: {
                        filter: vm.date.getTime(),
                        filterType: "number"
                    }
                }
            }
            else if(vm.interval === 'SPECIFIC_PERIOD'){
                vm.filter.filterModel = {
                    day: {
                        filter:  moment(vm.fromDate).valueOf(),
                        filterTo: moment(vm.toDate).valueOf(),
                        filterType: "number"
                    }
               }
            }
            else if(vm.interval === 'DAILY') {
                vm.filter.filterModel = {
                    day: {
                        filter: vm.date.getTime(),
                        filterType: "number"
                    }
                }
            }
            else{
                vm.filter.filterModel = {
                }
            }


            if (!vm.search.OFFICE_ID && vm.filter.filterModel['officeId']) {
                delete vm.filter.filterModel['officeId'];
            }
            if (vm.search.OFFICE_ID) {
                vm.filter.filterModel["officeId"] = {
                    filterType: "text",
                    filter: vm.search.OFFICE_ID
                };
            }
            if (!vm.search.DEPARTMENT_ID && vm.filter.filterModel['departmentId']) {
                delete vm.filter.filterModel['departmentId'];
            }
            if (vm.search.DEPARTMENT_ID) {
                vm.filter.filterModel["departmentId"] = {
                    filterType: "text",
                    filter: vm.search.DEPARTMENT_ID
                };
            }
            if (!vm.search.OPERATOR && vm.filter.filterModel['merchantCode']) {
                delete vm.filter.filterModel['merchantCode'];
            }
            if (vm.search.OPERATOR) {
                vm.filter.filterModel["merchantCode"] = {
                    filterType: "text",
                    filter: vm.search.OPERATOR
                };
            }
            if (!vm.search.EMPLOYEE_ID && vm.filter.filterModel['employeeId']) {
                delete vm.filter.filterModel['employeeId'];
            }
            if (vm.search.EMPLOYEE_ID) {
                vm.filter.filterModel["employeeId"] = {
                    filterType: "text",
                    filter: vm.search.EMPLOYEE_ID
                };
            }
            if (!vm.search.EMPLOYEE_NAME && vm.filter.filterModel['employeeName']) {
                delete vm.filter.filterModel['employeeName'];
            }
            if (vm.search.EMPLOYEE_NAME) {
                vm.filter.filterModel["employeeName"] = {
                    filterType: "text",
                    filter: vm.search.EMPLOYEE_NAME
                };
            }
            if (!vm.search.DEVICE_SERIAL && vm.filter.filterModel['deviceSerialNumber']) {
                delete vm.filter.filterModel['deviceSerialNumber'];
            }
            if (vm.search.DEVICE_SERIAL) {
                vm.filter.filterModel["deviceSerialNumber"] = {
                    filterType: "text",
                    filter: vm.search.DEVICE_SERIAL
                };
            }
            if (!vm.search.INSTALLATION_STORE && vm.filter.filterModel['installationStoreName']) {
                delete vm.filter.filterModel['installationStoreName'];
            }
            if (vm.search.INSTALLATION_STORE) {
                vm.filter.filterModel["installationStoreName"] = {
                    filterType: "text",
                    filter: vm.search.INSTALLATION_STORE
                };
            }
            if (!vm.search.REMARKS && vm.filter.filterModel['remarks']) {
                delete vm.filter.filterModel['remarks'];
            }
            if (vm.search.REMARKS) {
                vm.filter.filterModel["remarks"] = {
                    filterType: "text",
                    filter: vm.search.REMARKS
                };
            }

            getData();
        }

        function getData() {
            vm.isLoading = true;
            inOfficeServices.getOneItemDetails(vm.filter)
                .then(function success(response) {
                    vm.isLoading = false;
                    vm.transactionResponse = response.data.data;
                    vm.isClearBtnDisabled = false;
                }, function err(err) {
                    vm.isLoading = false;
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                })
        }

        function getDistinctColumnValues(columnName) {
            var filter = getFilterWithoutPageOrSize();
            inOfficeServices.getDeviceUsageColumnValues(columnName, filter)
                .then(function (response) {
                    if (columnName === "departmentId") {
                        vm.deptIdList = response.data.data;
                    } else if (columnName === "officeId") {
                        vm.officeIdList = response.data.data;
                    } else {
                        vm.merchantList = response.data.data;
                    }
                });
        }

        function onExport() {
            var filter = vm.filter;
            vm.isDownloadLoading = true;
            inOfficeServices.downloadUsageDetails(vm.filter)
                .then(function (resp) {
                    var headers = resp.headers();
                    var serverData = new Blob([resp.data], { type: headers['content-type'] });
                    FileSaver.saveAs(serverData, '一件明細_' + moment().format("YYYYMMDD") + '.csv');
                    vm.isDownloadLoading = false;
                    vm.select = false;
                }, function (err) {
                    vm.isDownloadLoading = false;
                    if ("TextDecoder" in window) {
                        try {
                            var enc = new TextDecoder("utf-8");
                            var data = enc.decode(err.data);
                            err = JSON.parse(data);
                        } catch (ignore) { }
                    }
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
        }

        function getFilterWithoutPageOrSize() {
            var filter = angular.copy(vm.filter);
            delete filter['page'];
            delete filter['size'];
            return filter;
        }

        function clearFilters() {
            vm.isClearLoading = true;
            init();
            applyFilters();
            // getData();
            getDistinctColumnValues("departmentId");
            getDistinctColumnValues("officeId");
            getDistinctColumnValues("merchantCode");
        }

        function navigate(type) {
            if (vm.interval === 'DAILY') {
                switch (type) {
                    case 'NEXT':
                        vm.date = new Date(baUtil.getStartOfNextDay(vm.date));
                        break;
                    case 'PREV':
                        vm.date = new Date(baUtil.getStartOfPrevDay(vm.date));
                        break;
                    case 'FIRST':
                        vm.date = new Date(baUtil.getStartOfDay(vm.navigationDates.from));
                        break;
                    case 'LAST':
                        vm.date = new Date(baUtil.getStartOfDay(vm.navigationDates.to));
                        break;
                    default:
                        return
                }
                vm.filter.filterModel = {
                    day: {
                        filter: vm.date.getTime(),
                        filterType: "number"
                    }
                }
            } else {

                switch (type) {
                    case 'NEXT':
                        vm.date = new Date(baUtil.getStartOfNextMonth(vm.date));
                        break;
                    case 'PREV':
                        vm.date = new Date(baUtil.getStartOfPrevMonth(vm.date));
                        break;
                    case 'FIRST':
                        vm.date = new Date(baUtil.getStartDateOfMonth(vm.navigationDates.from));
                        break;
                    case 'LAST':
                        vm.date = new Date(baUtil.getStartDateOfMonth(vm.navigationDates.to));
                        break;
                    default:
                        return
                }

                vm.filter.filterModel = {
                    month: {
                        filter: vm.date.getTime(),
                        filterType: "number"
                    }
                }
            }
            getDistinctColumnValues("departmentId");
            getDistinctColumnValues("officeId");
            getDistinctColumnValues("merchantCode");
            applyFilters();
            getData();
        }


        function getUsageDetailsMinMaxDate() {  
            inOfficeServices.getUsageDetailsMinMaxDate()
                .then(function success(response) {
                    vm.navigationDates = response.data.data;
                });
        }


        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function paginateCallback(query) {
          vm.filter.size = query.pageSize;
          vm.filter.pageSize = query.pageSize;
          vm.filter.page = query.pageNumber;
          inOfficeServices.getOneItemDetails(vm.filter)
            .then(function (response) {
              vm.transactionResponse = response.data.data;
              vm.filter = query;
            });
        }



    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('CreateRuleCtrl', CreateRuleCtrl);

    /** @ngInject */
    function CreateRuleCtrl($translate, $state, $location, $anchorScroll, toastr,  baUtil, $filter, inOfficeServices) {
        var vm = this;
        vm.getLang = getLang;
        vm.query = {}
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');
        vm.isOfficeFieldDisabled = false;
        vm.createUsageRules = createUsageRules;
        vm.usageRulesInfo = {
            "id": 0
        };
        vm.getOfficeName = getOfficeName;
        vm.onOfficeNameSelected = onOfficeNameSelected;
        vm.getDepartmentName = getDepartmentName;
        vm.onDepartmentNameSelected = onDepartmentNameSelected;
        vm.getEmployeeName = getEmployeeName;
        vm.onEmployeeNameSelected = onEmployeeNameSelected;

        vm.weekDays = {
            "key": [
                "MONDAY",
                "TUESDAY",
                "WEDNESDAY",
                "THURSDAY",
                "FRIDAY",
                "SATURDAY",
                "SUNDAY"
            ],
            "jp": [
            "月",
            "火",
            "水",
            "木",
            "金",
            "土",
            "日"
        ],
        "en": [
            "Mon",
            "Tue",
            "Wed",
            "Thur",
            "Fri",
            "Sat",
            "Sun"
        ]
    }


        if(baUtil.isOfficeUser()) {
            vm.usageRulesInfo.officeId = baUtil.getAccountDto().organisation.officeCode;
            vm.usageRulesInfo.organizationName = baUtil.getAccountDto().organisation.name;
            vm.isOfficeFieldDisabled = true;
            vm.enableDepartment = true;
        }

        function getOfficeName(name){
            return inOfficeServices.searchOfficeByName(name);
        }

        function onOfficeNameSelected(data){
            vm.usageRulesInfo.officeId = data.officeCode;
            vm.enableDepartment = true;
        }
        function getDepartmentName(name){
            return inOfficeServices.searchDepartmentByName(name,vm.usageRulesInfo.officeId);
        }

        function onDepartmentNameSelected(data){
            vm.usageRulesInfo.departmentId = data.key;
            vm.enableEmployee = true;
        }
        function getEmployeeName(name){
            return inOfficeServices.searchEmployeeByName(name,vm.usageRulesInfo.officeId);
        }

        function onEmployeeNameSelected(data){
            vm.usageRulesInfo.employeeId = data.key;
        }


        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function sortWeekDays(obj) {
            var order = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
            obj = obj.sort(function(a, b) {
                return order.indexOf(a) - order.indexOf(b);
            });
            return obj;
        }


        function createUsageRules() {
            if(!vm.usageRulesInfo.officeId) {
                vm.usageRulesInfo.organizationName = null;
                return;
            }
            if(vm.usageRulesInfo.weekDaysAllowed){
                vm.usageRulesInfo.weekDaysAllowed = sortWeekDays(vm.usageRulesInfo.weekDaysAllowed);
            }
 
            if(!vm.usageRulesInfo.oneTimeAmountAllowed && !vm.usageRulesInfo.noOfTimesPerDayAllowed && !vm.usageRulesInfo.noOfTimesPerMonthAllowed
                && !vm.usageRulesInfo.cumulativeAmountPerDayAllowed && !vm.usageRulesInfo.cumulativeAmountPerMonthAllowed && !vm.usageRulesInfo.cumulativeNoOfTimesAllowed && !vm.usageRulesInfo.cumulativeAmountAllowed && !vm.usageRulesInfo.columnCodes && !vm.usageRulesInfo.timeSlotAvailable && !vm.usageRulesInfo.weekDaysAllowed && !vm.usageRulesInfo.cumulativeNoOfTimesPerWeekAllowed && !vm.usageRulesInfo.cumulativeAmountPerWeekAllowed) {
                    toastr.error(
                        vm.localTranslator("iosl.usage.rules.not.empty.error.msg"),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                    return;
                }

            if (vm.usageRulesForm.$invalid) {

                $location.hash('top');
                $anchorScroll();

                vm.error = [];
                vm.detailErrors = true;

                for (var key in vm.usageRulesForm.$error) {
                    for (var index = 0; index < vm.usageRulesForm.$error[key].length; index++) {
                        vm.error.push(vm.usageRulesForm.$error[key][index].$name);
                    }
                }

                vm.alerts = []
                vm.errors = []

                var unique = {};

                angular.forEach(vm.error, function(item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });


                vm.poko = {
                    'officeName':{
                        'key':'officeName',
                        'en':'Office Name',
                        'jp':'オフィス名'
                    }
                }

                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.errorNumbers = vm.alerts.length;
                return;

            }
            else {
                vm.detailErrors = false;
            }
            var data = vm.usageRulesInfo;
            inOfficeServices.createUsageRules(data).then(function success(response) {
                $state.go('main.iosl.usageRules.list');
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                );
            }, function err(error) {
                vm.errorString = error.data.data ? error.data.data[0] : error.data.errorMessage;
                if (baUtil.isUndefinedOrNullOrEmpty(vm.errorString)) {
                    vm.errorString = vm.localTranslator("common.components.msg.error.in.form");
                }
                toastr.error(
                    vm.errorString,
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }




    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('UsageRulesListCtrl', UsageRulesListCtrl);

    /** @ngInject */
    function UsageRulesListCtrl($translate, FileSaver, $filter, inOfficeServices, baUtil, $state, toastr, AuthService) {
        var vm = this;
        vm.localTranslator = $filter('translate');
        vm.onUpload = onUpload;
        vm.onDownload = onDownload;
        vm.onDelete = onDelete;
        vm.getDistinctColumnValues = getDistinctColumnValues;
        vm.getDepartmentList = getDepartmentList;
        vm.applyFilters = applyFilters;
        vm.clearFilters = clearFilters;
        vm.onSelectAll = onSelectAll;
        vm.paginateCallback = paginateCallback;
        vm.isEditDisabled = isEditDisabled;
        vm.selectedIds = {};
        vm.onUpdate = onUpdate;
        vm.getWeekDays = getWeekDays;
        vm.permissions = AuthService.getPermissions();

        vm.weekDays = {
            "key": [
                "MONDAY",
                "TUESDAY",
                "WEDNESDAY",
                "THURSDAY",
                "FRIDAY",
                "SATURDAY",
                "SUNDAY"
            ],
            "jp": [
            "月",
            "火",
            "水",
            "木",
            "金",
            "土",
            "日"
          ],
          "en": [
            "Mon",
            "Tue",
            "Wed",
            "Thur",
            "Fri",
            "Sat",
            "Sun"
          ]
        }


        init();

        function init() {
          vm.colFilter = {};
          vm.search = {};
          vm.selectedIds = {};
          vm.select = false;
          vm.filter = {
            page: 0,
            size: baUtil.getDefaultPageSize('OFFICE'),
            filterModel: {

            }
          }
        }

        getUsageRules();
        getDistinctColumnValues('departmentId');
        getDistinctColumnValues("officeId");

        function getUsageRules() {
            inOfficeServices.searchUsageRules(vm.filter)
            .then(function success(response) {
              vm.isFilterLoading = false;
              vm.isLoading = false;
              vm.isClearLoading = false;
              vm.usageRules = response.data.data;
            }, function err(err) {
              vm.isLoading = false;
              vm.isFilterLoading = false;
              vm.isClearLoading = false;
              toastr.error(
                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
            })
        }


        function applyFilters() {
          vm.isFilterLoading = true;
          if(vm.colFilter.OFFICE_ID) {
            vm.filter.filterModel["officeId"] = {
              filterType:"set",
              values: vm.colFilter.OFFICE_ID
            }
          }

          if(vm.colFilter.DEPARTMENT_ID) {
            vm.filter.filterModel["departmentId"] = {
              filterType:"set",
              values: vm.colFilter.DEPARTMENT_ID
            };
          }

          if(!vm.search.EMPLOYEE_ID && vm.filter.filterModel['employeeId']) {
            delete vm.filter.filterModel['employeeId'];
          }

          if(vm.search.EMPLOYEE_ID) {
            vm.filter.filterModel["employeeId"] = {
              filterType:"text",
              filter: vm.search.EMPLOYEE_ID
            };
          }

          if(!vm.search.EMPLOYEE_NAME && vm.filter.filterModel['employeeName']) {
            delete vm.filter.filterModel['employeeName'];
          }

          if(vm.search.EMPLOYEE_NAME) {
            vm.filter.filterModel["employeeName"] = {
              filterType:"text",
              filter: vm.search.EMPLOYEE_NAME
            };
          }

          getUsageRules();

          if(!vm.colFilter.DEPARTMENT_ID) {
            getDistinctColumnValues("departmentId");
          }
          if(!vm.colFilter.OFFICE_ID) {
            getDistinctColumnValues("officeId");
          }

        }

        function getDepartmentList(){
          if(vm.colFilter.OFFICE_ID) {
            vm.filter.filterModel["officeId"] = {
              filterType:"set",
              values: vm.colFilter.OFFICE_ID
            }
          }
          getDistinctColumnValues("departmentId");
        }


        function clearFilters() {
          vm.isClearLoading = true;
          init();
          getUsageRules();
        }

        function onSelectAll(ev, list) {
          list.forEach(function (item) {
            vm.selectedIds[item.id] = ev.target.checked
          })
        }

        function getWeekDays(keys) {
          if (!keys) return '';

          var weekKeys = Array.isArray(keys)
          ? keys
            : typeof keys === 'string'
          ? keys.split(',')  
          : [];
  
          var lang = $translate.use();
          var translatedDays = weekKeys
          .map(function (key) {
          key = key.trim();
          var index = vm.weekDays.key.indexOf(key);
          return index !== -1 ? vm.weekDays[lang][index] : key;
          })
          .filter(Boolean); 

          return translatedDays.join(', ');
        }


        function isEditDisabled() {
          return Object.keys(vm.selectedIds)
            .filter(function (id) { return vm.selectedIds[id] })
            .length === 0;
        }


        function paginateCallback(query) {
          vm.filter.size = query.pageSize;
          vm.filter.pageSize = query.pageSize;
          vm.filter.page = query.pageNumber;
          inOfficeServices.searchUsageRules(vm.filter)
            .then(function (response) {
              vm.usageRules = response.data.data;
              vm.filter = query;
            });
        }


        function getDistinctColumnValues(columnName) {
          inOfficeServices.getUsageRulesColumnValues(columnName, vm.filter)
            .then(function (response) {
              if(columnName === "departmentId") {
                vm.deptIdList = response.data.data;
              } else {
                vm.officeIdList = response.data.data;
              }
            });
        }

        function onUpdate() {
          var selectedRows = vm.usageRules.content.map(function (i) {
            return vm.selectedIds[i.id] ? i : null;
          }).filter(function (d) { return d; });
          var rows = [];
          selectedRows.forEach(function (item, index) {
            item.serialNo = index + 1;
            item.operation = 'UPSERT';
            rows.push(item);
          })
          $state.go('main.iosl.usageRules.update', { usageRules: rows });
        }

        function onUpload(file, ev) {
          var name = file.name;
          var size = file.size;
          var maxSize = 10485760;
          if (baUtil.checkForInvalidExtension(name, [".xlsx"])) {
            toastr.error(
              vm.localTranslator("common.components.msg.csv.format"),
              vm.localTranslator("common.components.title.error"),
              baUtil.toastOptions()
            );
          } else if (size > maxSize) {
            toastr.error(
              vm.localTranslator("common.components.msg.csv.max.size.10"),
              vm.localTranslator("common.components.title.error"),
              baUtil.toastOptions()
            );
          } else {
            vm.isUploading = true;

            inOfficeServices.uploadUsageRulesPreview(file)
              .then(function (response) {
                vm.isUploadLoading = false;
                $state.go('main.iosl.usageRules.preview', { usageRules: response.data.data });
              }, function err(err) {
                ev.target.value = "";
                vm.isUploading = false;
                toastr.error(
                  baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                  vm.localTranslator("common.components.title.error"),
                  baUtil.toastOptions()
                );
              });
          }
        }


        function onDownload() {
          var ids = vm.usageRules.content.map(function (i) {
            return vm.selectedIds[i.id] ? i.id : null;
          }).filter(function (d) { return d; });


          var filter  = vm.filter;
          filter.filterModel["id"] = {
            filterType:"set",
            values: ids
          }

          delete filter['page'];
          delete filter['size'];
          vm.isDownloadLoading = true;
          inOfficeServices.downloadUsageRules(vm.filter)
            .then(function (resp) {
              var headers = resp.headers();
              var serverData = new Blob([resp.data], { type: headers['content-type'] });
              FileSaver.saveAs(serverData, '利用ルール_' + moment().format("YYYYMMDD") + '.xlsx');
              vm.isDownloadLoading = false;
              init();
            }, function (err) {
              vm.isDownloadLoading = false;
              if ("TextDecoder" in window) {
                try {
                  var enc = new TextDecoder("utf-8");
                  var data = enc.decode(err.data);
                  err = JSON.parse(data);
                } catch (ignore) { }
              }
              toastr.error(
                baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                vm.localTranslator("common.components.title.error"),
                baUtil.toastOptions()
              );
            });
        }


        function onDelete() {
          var ids = vm.usageRules.content.map(function (i) {
            return vm.selectedIds[i.id] ? i.id : null;
          }).filter(function (d) { return d; });

          baUtil.showConfirm(vm.localTranslator("iosl.department.delete") + ' ?', vm.localTranslator("iosl.department.delete.msg"), vm.localTranslator("common.components.btn.yes"))
            .then(function () {
              vm.isDeleteLoading = true;
              inOfficeServices.deleteUsageRules(ids)
                .then(function (response) {
                  getUsageRules();
                  vm.isDeleteLoading = false;
                  vm.selectedIds = {};
                  toastr.success(
                    vm.localTranslator("iosl.department.msg.delete.status"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                  );
                }, function err(err) {
                  toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.response")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                  );
                  vm.isDeleteLoading = false;
                });
            });
        }




    }

})();


(function () {
    'use strict';

    angular.module('JPTC.pages.inOfficeService')
        .controller('UsageRulePreviewCtrl', UsageRulePreviewCtrl);

    /** @ngInject */
    function UsageRulePreviewCtrl($translate, $stateParams, toastr, baUtil, $scope, $state, $filter, inOfficeServices) {

        if ($stateParams.usageRules == null) {
            cancel();
        }

        var vm = this;
        vm.getLang = getLang;
        vm.isServerError = false;
        vm.query = {}
        vm.cancel = cancel;
        vm.submit = submit;
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');



        vm.KeyMap;
        vm.errors = {};
        vm.alerts = [];
        vm.isFormValid = isFormValid;

        vm.operationTypes = {
            en: ['Add/Change', 'Delete'],
            jp: ['追加/変更', '削除'],
            key: ['UPSERT', 'DELETE']
        }

        vm.weekDaysAllowedPermission = {
            en: ['〇',''],
            jp:['〇',''],
            key:['〇','']
        }


        var usageRules = $stateParams.usageRules || [];
        var isUpdate = $stateParams.isUpdate ? $stateParams.isUpdate : false;
        createTable(usageRules);

        function cancel() {
            $state.go("main.iosl.usageRules.list");
        }

        function getInputType(type) {
            switch (type) {
                case 'String':
                    return 'text'
                case 'Checkbox':
                    return 'checkbox'
                case 'Date':
                    return 'date'
                case 'Dropdown':
                    return 'dropdown'
                default:
                    return 'text'
            }
        }
        function getLang() {
            return $translate.use();
        }

        function createTable(rowData) {
            vm.tableRowData = [];
            vm.tableData = [{}];
            vm.tableOptions = {};

            vm.deviceTableHeader = {
                serialNo: {
                    en: '#',
                    jp: '行番号',
                    column: 'serialNo'
                },
                operation: {
                    en: 'Operation',
                    jp: '操作',
                    column: 'operation'
                },
                officeId: {
                    en: 'Office ID',
                    jp: 'オフィスID',
                    column: 'officeId'
                },
                departmentId: {
                    en: 'Department ID',
                    jp: '部署ID',
                    column: 'departmentId'
                },
                employeeId: {
                    en: 'Employee ID',
                    jp: '従業員ID',
                    column: 'employeeId'
                },
                oneTimeAmountAllowed: {
                    en: 'One-time Amount',
                    jp: '一回金額',
                    column: 'oneTimeAmountAllowed'
                },
                noOfTimesPerDayAllowed: {
                    en: 'Total number of times/day',
                    jp: '累積回数/日',
                    column: 'noOfTimesPerDayAllowed'
                },
                noOfTimesPerMonthAllowed: {
                    en: 'Total number of times/month',
                    jp: '累積回数/月',
                    column: 'noOfTimesPerMonthAllowed'
                },
                cumulativeAmountPerDayAllowed: {
                    en: 'Cumulated amount/day',
                    jp: '累積金額/日',
                    column: 'cumulativeAmountPerDayAllowed'
                },
                cumulativeAmountPerMonthAllowed: {
                    en: 'Cumulated amount/month',
                    jp: '累積金額/月',
                    column: 'cumulativeAmountPerMonthAllowed'
                },
                cumulativeNoOfTimesAllowed: {
                    en: 'Cumulative number of times',
                    jp: '累積回数',
                    column: 'cumulativeNoOfTimesAllowed'
                },
                cumulativeAmountAllowed: {
                    en: 'Cumulative amount',
                    jp: '累積金額',
                    column: 'cumulativeAmountAllowed'
                },
                columnCodes: {
                    en: 'Column Number',
                    jp: 'コラム番号',
                    column: 'columnCodes'
                },
                timeSlotAvailable:{
                    en: 'Time range',
                    jp: '時間範囲',
                    column: 'timeSlotAvailable'
                },
                mon:{
                    en:'Mon',
                    jp:'月',
                    column:'mon'
                },
                tue:{
                    en:'Tues',
                    jp:'火',
                    column:'tue'
                },
                wed:{
                    en:'Wed',
                    jp:'水',
                    column:'wed'
                },
                thu:{
                    en:'Thur',
                    jp:'木',
                    column:'thu'
                },
                fri:{
                    en:'Fri',
                    jp:'金',
                    column:'fri'
                },
                sat:{
                    en:'Sat',
                    jp:'土',
                    column:'sat'
                },
                sun:{
                    en:'Sun',
                    jp:'日',
                    column:'sun'
                },
                cumulativeNoOfTimesPerWeekAllowed:{
                    en: 'Cumulative count/week',
                    jp: '累積回数/週',
                    column: 'cumulativeNoOfTimesPerWeekAllowed'
                },
                cumulativeAmountPerWeekAllowed:{
                    en: 'Cumulative amount/week',
                    jp: '累積金額/週',
                    column: 'cumulativeAmountPerWeekAllowed'
                }
            }

            rowData.forEach(function (item, index) {
                var obj = {};
                var keys = Object.keys(item)
                keys.forEach(function (field) {
                    var value = item[field]
                    if (field === 'operation'){
                        obj[field] = getOperationTypes(value);
                        return
                    }
                    obj[field] = value;
                })
                vm.tableRowData.push(obj)
            })

            vm.KeyMap = vm.deviceTableHeader;
            vm.KeyMap.serialNo.readOnly = true;
            vm.KeyMap.serialNo.validators = ['required'];
            vm.KeyMap.operation.readOnly = isUpdate;
            vm.KeyMap.operation.validators = ['required'];
            vm.KeyMap.officeId.readOnly = isUpdate;
            vm.KeyMap.officeId.validators = ['required'];
            vm.KeyMap.departmentId.readOnly = isUpdate;
            vm.KeyMap.employeeId.readOnly = isUpdate;
            vm.KeyMap.oneTimeAmountAllowed.readOnly = false;
            vm.KeyMap.noOfTimesPerDayAllowed.readOnly = false;
            vm.KeyMap.noOfTimesPerMonthAllowed.readOnly = false;
            vm.KeyMap.cumulativeAmountPerDayAllowed.readOnly = false;
            vm.KeyMap.cumulativeAmountPerMonthAllowed.readOnly = false;

            vm.tableSettings = {
                colHeaders: [],
                rowHeaders: true,
                currentRowClassName: 'currentRow',
                currentColClassName: 'currentCol',
                invalidCellClassName: 'cell-has-error',
                columns: [],
                modifyColWidth: function (width, col) {
                    if (width > 500) return 500;
                },

                afterValidate: function (isValid, value, row, prop, source) {
                    if (prop === "serialNo" || prop === "officeId" || prop === "departmentId" || prop === "employeeId") {
                        if (baUtil.isUndefinedOrNullOrEmpty(value)) {
                            vm.errors[row + "_" + prop] = $translate.instant(
                                "iosl.department.err.msg.required.field",
                                {
                                    row: row + 1,
                                    param: vm.KeyMap[prop][vm.getLang()]
                                }
                            );
                            return false;
                        }
                        else {
                            delete vm.errors[row + "_" + prop];
                            return true;
                        }
                    }
                }
            };




            var keyMap = vm.KeyMap;
            var optionKeys = Object.keys(keyMap);
            optionKeys.forEach(function (field) {
                var value = keyMap[field]
                var fieldValue = "";
                vm.tableSettings.colHeaders.push(value[$translate.use()])
                var col = {
                    type: getInputType(value.type),
                    data: field,
                    readOnly: value.readOnly
                }

                if (field == 'operation') {
                    col.type = 'dropdown',
                    col.source = getSource('operation')
                }

                if(field == 'mon' || field == 'tue' || field == 'wed' || field == 'thu' || field == 'fri' || field == 'sat' || field == 'sun') {
                    col.type = 'dropdown',
                    col.source = getSource('weekDaysOperation')
                }

                if (vm.KeyMap[field]['validators'] && vm.KeyMap[field]['validators'].length) {
                    col.validator = function (query, callback) {
                        callback(true);
                    }
                }

                vm.tableSettings.columns.push(col);
                vm.tableData[0][field] = fieldValue;

            });

            vm.disableApplyBtn = false;

            vm.alerts = [];
            vm.errors = {};
            var container = document.getElementById('handsOnTable-usageRules');
            container.innerHTML = "";
            var options = Object.assign({ data: vm.tableRowData }, vm.tableSettings);
            vm.hotTable = new Handsontable(container, options);
            vm.hotTable.validateCells();
        }



        function isFormValid() {
            vm.alerts = [];

            Object.keys(vm.errors).forEach(function (key) {
                var row = Number(key.split("_")[0]) + 1;
                var field = key.split("_")[1];
                if (!field) return;
                vm.alerts.push(vm.errors[key]);
            });

            vm.alerts = vm.alerts.reverse();

            return vm.alerts.length === 0;
        }

        function submit() {
            if (!vm.isFormValid()) {
                return;
            }

            baUtil.showConfirm()
                .then(function () {
                    vm.isLoading = true;
                    var data = [];
                    vm.tableRowData.forEach(function (row) {
                        var obj = {};
                        Object.keys(row).forEach(function (key) {
                            var value = row[key];
                            if (key === 'operation'){
                                obj[key] = getOperationTypesKey(value);
                                return
                            }
                            obj[key] = row[key]
                        })
                        data.push(obj)
                    });
                    inOfficeServices.uploadUsageRules(data)
                        .then(function success() {
                            vm.isLoading = false;
                            toastr.success(
                                vm.localTranslator("common.components.msg.success"),
                                vm.localTranslator("common.components.title.success"),
                                baUtil.toastOptions()
                            );
                            cancel();
                        }, function err(err) {
                            vm.isLoading = false;
                            vm.alerts = err.data.data;
                            vm.isServerError = true;
                        });
                });
        }



        function getSource(key) {
            switch (key) {
                case 'operation':
                    return vm.operationTypes[$translate.use()]
                case 'weekDaysOperation':
                    return vm.weekDaysAllowedPermission[$translate.use()]    
                default:
                    return []
            }
        }


        function getOperationTypes(flag) {
            var operationString;
            vm.operationTypes.key.forEach (function (value, i) {
                if (value == flag) {
                    operationString = vm.operationTypes[$translate.use()][i]
                }
            })
            return operationString;
        }

        function getOperationTypesKey(flag) {
            var operationKey;
            vm.operationTypes[$translate.use()].forEach (function (value, i) {
                if (value == flag) {
                    operationKey = vm.operationTypes.key[i]
                }
            })
            return operationKey;
        }

        $scope.$on('LANG_CHANGE', function (event) {
            suspendOrRemoveDevice(suspendDeviceMap);
        });

        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

    }
})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('ListOrgCtrl', ListOrgCtrl);

    /** @ngInject */
    function ListOrgCtrl($timeout,types, $translate, ServiceManagementService, toastr,  baUtil, scListPromise, $uibModal, $state, Upload, API_CONFIG, AuthService, $filter) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.init = init;
        vm.searchSC = searchSC;
        vm.openFilterModal = openFilterModal;
        vm.openDetail = openDetail;
        vm.disableOrg = disableOrg;
        vm.enableOrg = enableOrg;
        vm.deleteOrg = deleteOrg;
        vm.orgType = orgType;
        vm.getLang = getLang;
        vm.query = {}
        vm.paginateCallback = paginateCallback
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.localTranslator = $filter('translate');

        init();

        if (scListPromise.status >= 200 && scListPromise.status <= 299) {
            vm.scListResponse = scListPromise.data.data;
        } else {
            return;
        }
        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        } else {
            return;
        }

        function init() {
            vm.scListResponse = {
                content: []
            };
             vm.types = {
                content: []
            };

            vm.search = {
                query : ''
            }
        }

        function orgType(item) {
            var resultIndex = vm.types.OrganisationType.key.indexOf(item);
            return vm.types.OrganisationType[vm.getLang()][resultIndex];
        }

        function searchSC() {
            ServiceManagementService.searchOrg(vm.search.query)
            .then(function s(response) {
                vm.scListResponse = response.data.data;
            },function err(err) {
            })
        }

        function enableOrg(obj){
            
            baUtil.showConfirm(vm.localTranslator("org.list.enable") + ' ?',vm.localTranslator("org.list.msg.enable"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
            
                ServiceManagementService.enableOrganisation(obj.organisationId).then(function success(response) {
                $state.reload()
                toastr.success(
                    vm.localTranslator("org.list.msg.enable.status"),                     
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions())
                }, function err(err) {
                    toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                });
                
            });               

        }

        function disableOrg(obj){
            
             baUtil.showConfirm(vm.localTranslator("org.list.disable") + ' ?',vm.localTranslator("org.list.msg.disable"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
                ServiceManagementService.disableOrganisation(obj.organisationId).then(function success(response) {
                $state.reload()
                toastr.success(
                    vm.localTranslator("org.list.msg.disable.status"),                     
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions())
                }, function err(err) {
                    toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                });
            });

        }

        function deleteOrg(obj){
            
             baUtil.showConfirm(vm.localTranslator("org.list.delete") + ' ?',vm.localTranslator("org.list.msg.delete"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
                ServiceManagementService.deleteOrganisation(obj.organisationId).then(function success(response) {
                $state.reload()
                toastr.success(
                    vm.localTranslator("org.list.msg.delete.status"),                     
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions())
                }, function err(err) {
                    toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                )
                });
             });

        }

        function openFilterModal(page, size) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                resolve: {
                    items: function () {
                        return [];
                    }
                }
            });
        }

        function openDetail(ev, obj) {
            $state.go('main.serviceManagement.organisation.detail', { orgId: obj.organisationId});
        }

          function paginateCallback(query) {
            ServiceManagementService.searchOrg(baUtil.makeQueryString(query))
                .then(function (response) {
                    vm.scListResponse = response.data.data;
                    vm.query = query;
                });
        }

        function getLang() {
            return $translate.use();
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('NewOrganizationCtrl', NewOrganizationCtrl);

    /** @ngInject */
    function NewOrganizationCtrl(allTypes, ServiceManagementService, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, $filter, AuthService, $location, $anchorScroll) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.createOrganisation = createOrganisation;
        vm.getLang = getLang;
        vm.addNewRow = addNewRow;
        vm.removeRow = removeRow;
        vm.enableButton = enableButton;
        vm.disableButton = disableButton;
        vm.btnClick = false;
        vm.localTranslator = $filter('translate');        
        vm.detailErrors = false;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.organisationTypeSelect = organisationTypeSelect;
        vm.canLoginOrNot = canLoginOrNot;
        vm.showInchargeSection = true;
        vm.dobOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date(1901,0,1),
            maxDate : new Date()
        }

        vm.getMerchant = getMerchant;
        vm.onOfficeMerchantSelected = onOfficeMerchantSelected;
        vm.officeServiceSubTypeOptions = { key: [], en: [], jp: [] };
//        vm.showOffice = true;

        vm.orgInfo = {
            "organisationRepresentativeCreateDtos": [{
                    "addressCreateDtos": [{
                        "contactCreateDtos": [{}]
                    }]
                }],
            "addressCreateDtos": [{
                    "contactCreateDtos": [{}]
                }],
                "accountCreateDtos": [{
                    "contactCreateDtos": [{}],
                    "serviceContractId": []
                }],


            "organisationCreateDto": {
                "organisationBranchCreateDtos": {
                    "accountCreateDtos": [{
                        "contactCreateDtos": [{}]
                    }],
                    "addressCreateDto": {
                        "contactCreateDtos": [{}]
                    }
                }
            },
            "officeMerchantMinDtos": [{}],
            "organisationTypes": [],
            "officeServiceType": null,
            "officeServiceSubType": null,
            "login":false,
            "deviceRequest":false,
            "sales":false,
            "settlementInvoice":false,
            "serviceManagement":false,
        }



        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.types = allTypes.data.data;
        }


        vm.types.trueFalse  = {
            en:['Allow','Do Not Allow'],
            jp:['許可する','許可しない'],
            key:[true,false]
        }

        vm.orgInfo.validity = ''

        vm.orgInfo.subOrganisationType = 'ORGANISATION'

      //  vm.orgInfo.nameSimple = vm.orgInfo.name


        function getLang() {
            return $translate.use();
        }

        function organisationTypeSelect(value) {
            if (value === 'PARTNER' && vm.orgInfo.organisationTypes[0] === 'PARTNER') {
                vm.showPartner = true;
                vm.showInchargeSection = false;
            }
            else {
                vm.showPartner = false;
                vm.showInchargeSection = true;
            }
        }

        function canLoginOrNot(value) {
            if (!value) {
                vm.showInchargeSection = false;
                vm.orgInfo.deviceRequest = false;
                vm.orgInfo.sales = false;
                vm.orgInfo.settlementInvoice = false;
                vm.orgInfo.serviceManagement = false;
            }
            else {
                vm.showInchargeSection = true;
            }
        }

        if(!vm.orgInfo.login) {
            vm.orgInfo.deviceRequest = false;
            vm.orgInfo.sales = false;
            vm.orgInfo.settlementInvoice = false;
            vm.orgInfo.serviceManagement = false;
        }


        function getValueFromTypeKey(key, type) {
            if (baUtil.isUndefinedOrNull(key) || !type || !angular.isArray(type.key)) {
                return key;
            }
            var index = type.key.indexOf(key);
            if (index < 0) {
                return key;
            }
            var lang = vm.getLang();
            if (type[lang] && type[lang][index] != null) {
                return type[lang][index];
            }
            if (type.en && type.en[index] != null) {
                return type.en[index];
            }
            return key;
        }

        function addNewRow(list, type) {
            if (baUtil.isUndefinedOrNull(list)) {
                return
            }
            if (type === 'REPRESENTATIVE') {
                list.push({
                      "addressCreateDtos": [{
                        "contactCreateDtos": [{}]
                    }]
                })
                return
            }
            if (type === 'CREATE_INCHARGE') {
                list.push({
                    "contactCreateDtos": [{}],
                    "serviceContractId": []
                })
                return
            }

            list.push({})
        }

        function removeRow(list, index) {
            list.splice(index, 1);
        }

        function enableButton () {
            $timeout(function() {
                vm.btnClick = false;
            }, 1000);
        }

        function disableButton () {
            vm.btnClick = true;
            $timeout(function() {
                vm.btnClick = false;
            }, 2000);
        }

        function getMerchant(query) {
            return ServiceManagementService.getMerchantForOffice(query);
        }

        function refreshOfficeServiceSubType(serviceType) {
            if (!serviceType) {
                vm.officeServiceSubTypeOptions = { key: [], en: [], jp: [] };
                vm.orgInfo.officeServiceSubType = null;
                return;
            }

            var state = ServiceManagementService.getOfficeServiceSubTypeState(vm.types, serviceType);
            vm.officeServiceSubTypeOptions = state.options;
            vm.orgInfo.officeServiceSubType = state.defaultKey;
        }

        $scope.$watch(function () {
            return vm.orgInfo.officeServiceType;
        }, function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            refreshOfficeServiceSubType(newVal);
        });

        function onOfficeMerchantSelected(data, index) {
            var filteredData = $filter('filter')(vm.orgInfo.officeMerchantMinDtos, data);
            if(filteredData.length) {
                vm.newOrgForm['officeMerchantMinDtos_' + index].$setViewValue("");
                toastr.error(
                    vm.localTranslator("iosl.warning.msg"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                return;
            }

            vm.orgInfo.officeMerchantMinDtos[index].name = data.name;
            vm.orgInfo.officeMerchantMinDtos[index].merchantCode = data.merchantCode;
            vm.orgInfo.officeMerchantMinDtos[index].organisationId = data.organisationId;

        }


        function createOrganisation() {

           if(vm.orgInfo.organisationTypes[0] === 'PARTNER') {
                vm.orgInfo.code = '';
                vm.orgInfo.businessType = '';
                vm.orgInfo.productsHandled = '';
           }
           else {
                vm.orgInfo.login = '';
                vm.orgInfo.deviceRequest = '';
                vm.orgInfo.salesSettlement = '';
                vm.orgInfo.serviceManagement = '';
           }

            var orgData = vm.orgInfo;
//              vm.disableButton();
            if (vm.newOrgForm.$invalid) {
                 
                $location.hash('top');
                $anchorScroll();
                 
                vm.error = [];
                vm.detailErrors = true; 

                for (var key in vm.newOrgForm.$error) {
                    for (var index = 0; index < vm.newOrgForm.$error[key].length; index++) {
                        vm.error.push(vm.newOrgForm.$error[key][index].$name);
                    }
                }
                  
                for(var i=0; i < vm.error.length; i++) {
                   
                    var oo1 = new RegExp(/_([0-9]|[1-9][0-9])$/);
                    var oo2 = new RegExp(/_([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])$/);
                    var oo3 = new RegExp(/([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])$/);
                    
                    
                    vm.error[i] = vm.error[i].replace(oo1, '_0');
                    vm.error[i] = vm.error[i].replace(oo2, '_0_0');
                    vm.error[i] = vm.error[i].replace(oo3, '0_0_0');
                }
                 
                vm.alerts = []
                vm.errors = []
                
                var unique = {};
                 
                angular.forEach(vm.error, function(item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });
                                 
                vm.poko = {
                    
                    'orgName':{
                        'key':'orgName',
                        'en':'Common Information - Organisation Name',
                        'jp':'共通情報 - 会社名'
                        
                    },

                    'applicantCompanyCode':{
                        'key':'applicantCompanyCode',
                        'en':'Organisation Information - Company Code',
                        'jp':'企業情報 - 法人コード'
                        
                    },

                    'businessType':{
                        'key':'businessType',
                        'en':'Organisation Information - Business Type',
                        'jp':'企業情報 - 業種業務区分'
                        
                    },


                    'productsHandled':{
                        'key':'productsHandled',
                        'en':'Organisation Information - Products Handled',
                        'jp':'企業情報 - 取扱商品'
                        
                    },

                    'organisationTypes_':{
                        'key':'organisationTypes_',
                        'en':'Common Information - Organisation Type',
                        'jp':'共通情報 - 区分'
                        
                    },

                    'addressPin_organisation_address':{
                        'key':'addressPin_organisation_address',
                        'en':'Company Contact - Zip Code',
                        'jp':'企業連絡先 - 〒'
                        
                    },

                    'streetAddress_organisation_address':{
                        'key':'streetAddress_organisation_address',
                        'en':'Company Contact - Street Address',
                        'jp':'企業連絡先 - 番地'
                        
                    },

                    'streetAddressKana_organisation_address':{
                        'key':'streetAddressKana_organisation_address',
                        'en':'Company Contact - Street Address(Kana)',
                        'jp':'企業連絡先 - 番地(フリガナ)'
                        
                    },

                    'contactNumber_organisation_account_contact__0':{
                        'key':'contactNumber_organisation_account_contact__0',
                        'en':'Company Contact - Contact',
                        'jp':'企業連絡先 - ご連絡先'
                        
                    },

                    'companyRepresentativeNameReading_0':{
                        'key':'companyRepresentativeNameReading_0',
                        'en':'Company Representative - Name(Kana)',
                        'jp':'代表者様情報 - 氏名 (フリガナ)'
                        
                    },

                    'companyRepresentativeName_0':{
                        'key':'companyRepresentativeName_0',
                        'en':'Company Representative - Name',
                        'jp':'代表者様情報 - 氏名'
                        
                    },

                    'companyInChargePerson_0':{
                        'key':'companyInChargePerson_0',
                        'en':'In-Charge Person - Name',
                        'jp':'担当者情報 - 氏名'
                        
                    },

                    'companyInChargePersonReading_0':{
                        'key':'companyInChargePersonReading_0',
                        'en':'In-Charge Person - Name (Kana)',
                        'jp':'担当者情報 - 氏名 (フリガナ)'

                    },

                    'contactNumber_organisation_account_contact_0_0':{
                        'key':'contactNumber_organisation_account_contact_0_0',
                        'en':'In-Charge Person - Contact',
                        'jp':'担当者情報- ご連絡先'
                        
                    },
                    

                    'contactEmail_organisation_account_contact_0_0':{
                        'key':'contactEmail_organisation_account_contact_0_0',
                        'en':'In-Charge Person - Email',
                        'jp':'担当者情報- メールアドレス'
                        
                    },

                    'representativedob':{
                        'key':'representativedob',
                        'en':'Company Representative - Date of Birth',
                        'jp':'代表者様情報 - 生年月日'
                        
                    },
                    
                    'companyUsername_0':{
                        'key':'companyUsername_0',
                        'en':'In-Charge Person - Email',
                        'jp':'担当者情報 - メールアドレス'
                    },

                    'officeServiceType':{
                        'key':'officeServiceType',
                        'en':'Office Attribute - Service Type',
                        'jp':'オフィス属性 - サービスタイプ'
                    },

                    'officeServiceSubType':{
                        'key':'officeServiceSubType',
                        'en':'Office Attribute - Service Sub Type',
                        'jp':'オフィス属性 - サービスサブタイプ'
                    },

                    'merchantSummaries_0':{
                        'key':'merchantSummaries_0',
                        'en':'Office Attribute - Related Merchant Name',
                        'jp':'オフィス属性 - 関連加盟店'
                    }



                }
                 
                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.enableButton();
                vm.errorNumbers = vm.alerts.length;
                return;

        }
            else {
                vm.detailErrors = false;
            }

             if(orgData.organisationTypes.indexOf('ADMIN') !== -1 && orgData.organisationTypes.length > 1) {
                             toastr.error(vm.localTranslator('common.components.org.type.err.msg'),
                                  vm.localTranslator('common.components.errorMessages.error'), baUtil.toastOptions());
                                        return;
             }
            
            var repDob = orgData.organisationRepresentativeCreateDtos[0].dateOfBirth;
            if (!baUtil.isUndefinedOrNull(repDob)) {                
                vm.orgInfoCopy = angular.copy(orgData);
                var n = vm.orgInfoCopy.organisationRepresentativeCreateDtos.length;
                for(var i=0;i<=(n-1);i++) {
                    if (!angular.isNumber(vm.orgInfoCopy.organisationRepresentativeCreateDtos[i].dateOfBirth)){                        
                        var repLongDOB = vm.orgInfoCopy.organisationRepresentativeCreateDtos[i].dateOfBirth.getTime();
                        vm.orgInfoCopy.organisationRepresentativeCreateDtos[i].dateOfBirth = repLongDOB;
                        }
                }

                orgData = angular.copy(vm.orgInfoCopy);
                
            }
            
            
            orgData.nameSimple = orgData.name
                      
            var data = orgData;
            

            ServiceManagementService.createOrganisation(data).then(function success(response) {
                $state.go('main.serviceManagement.organisation.list');
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                );
            }, function err(err) {
                vm.enableButton();
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }



    }


})();

(function () {
    'use strict';

    angular.module('JPTC.pages.serviceManagement')
        .controller('DetailOrgCtrl', DetailOrgCtrl);

    /** @ngInject */
    function DetailOrgCtrl(allTypes, ServiceManagementService, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, getDetail, AuthService, $filter, $location, $anchorScroll) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.saveDetail = saveDetail;
        vm.addNewRow = addNewRow;
        vm.localTranslator = $filter('translate');
        vm.enableButton = enableButton;
        vm.disableButton = disableButton;
        vm.btnClick = false;
        vm.typeOrg = typeOrg;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.isRepresentativeRequired = isRepresentativeRequired;
        vm.removeRow = removeRow;
        vm.removeIncharge = removeIncharge;
        vm.editDetail = editDetail;
        vm.cancelEdit = cancelEdit;
        vm.canLoginOrNot = canLoginOrNot;
        vm.isEdit = false;
        vm.detailErrors = false;
        vm.orgType = '';

        vm.orgInfo = {}
        vm.dobOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date(1901,0,1),
            maxDate : new Date()
        }

        vm.getMerchant = getMerchant;
        vm.onOfficeMerchantSelected = onOfficeMerchantSelected;
        vm.officeServiceSubTypeOptions = { key: [], en: [], jp: [] };


        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.types = allTypes.data.data;
        }

        vm.types.allowOrNot  = {
            en:['Allow','Do Not Allow'],
            jp:['許可する','許可しない'],
            key:[true,false]
        }

        if (getDetail.status >= 200 && getDetail.status <= 299) {
            vm.orgDetails = getDetail.data.data;
        }

        if (!baUtil.isUndefinedOrNull(vm.orgDetails)) {
            vm.orgInfo = vm.orgDetails

        }

        updateOfficeServiceSubTypeOptions();

        if (vm.orgInfo.officeServiceType) {
            var initialSubTypeOptions = vm.officeServiceSubTypeOptions;
            if (!vm.orgInfo.officeServiceSubType || initialSubTypeOptions.key.indexOf(vm.orgInfo.officeServiceSubType) === -1) {
                refreshOfficeServiceSubType(vm.orgInfo.officeServiceType);
            }
        }

        if(vm.orgInfo.organisationTypes[0] === 'PARTNER') {
            vm.showInchargeSection = vm.orgInfo.login;
        }
        else {
            vm.showInchargeSection = true;
        }

        vm.oldLogin = vm.orgInfo.login;
        vm.oldDeviceRequest = vm.orgInfo.deviceRequest;
        vm.oldSales = vm.orgInfo.sales;
        vm.oldsettlementInvoice = vm.orgInfo.settlementInvoice;
        vm.oldServiceManagement = vm.orgInfo.serviceManagement;


        vm.orgType = vm.orgInfo.organisationTypes[0];
        if (vm.orgInfo.organisationTypes.length > 1) {
            for (var i = 1; i <= vm.orgInfo.organisationTypes.length - 1; i++) {
                vm.orgType = vm.orgType + "/" + vm.orgInfo.organisationTypes[i];
            }
        }


        function getLang() {
            return $translate.use();
        }

        function typeOrg(item) {
            var resultIndex = vm.types.OrganisationType.key.indexOf(item);
            return vm.types.OrganisationType[vm.getLang()][resultIndex];
        }

        function canLoginOrNot(value) {
            if (!value) {
                vm.orgInfo.deviceRequest = false;
                vm.orgInfo.sales = false;
                vm.orgInfo.settlementInvoice = false;
                vm.orgInfo.serviceManagement = false;
                vm.showInchargeSection = false;
            }
            else {
                vm.orgInfo.deviceRequest = vm.oldDeviceRequest;
                vm.orgInfo.sales = vm.oldSales;
                vm.orgInfo.settlementInvoice = vm.oldsettlementInvoice;
                vm.orgInfo.serviceManagement = vm.oldServiceManagement;
                vm.showInchargeSection = true;
                if (baUtil.isUndefinedOrNullOrEmptyObject(vm.orgInfo.accountDtos)) {
                    vm.orgInfo.accountDtos = [{
                        "contactDtos": [{}]
                    }];
                }
            }
        }



        function getValueFromTypeKey(key, type) {
            if (baUtil.isUndefinedOrNull(key) || !type || !angular.isArray(type.key)) {
                return key;
            }
            var index = type.key.indexOf(key);
            if (index < 0) {
                return key;
            }
            var lang = vm.getLang();
            if (type[lang] && type[lang][index] != null) {
                return type[lang][index];
            }
            if (type.en && type.en[index] != null) {
                return type.en[index];
            }
            return key;
        }

        function addNewRow(list, type) {
            if (baUtil.isUndefinedOrNull(list)) {
                return
            }
            if (type === 'REPRESENTATIVE') {
                list.push({
                    "addressDtos": [{
                        "contactDtos": [{}]
                    }]
                })
                return
            }
            if (type === 'CREATE_INCHARGE') {
                list.push({
                    "contactDtos": [{}],
                    "serviceContractId": []
                })
                return
            }

            list.push({})
        }

        function removeRow(list, index) {
            list.splice(index, 1);
        }

        function removeIncharge(list, index) {
            var orgId = vm.orgInfo.accountDtos[index].accountId;

            ServiceManagementService.deleteIncharge(orgId).then(function (response) {
                var scId = '"' + response.data.data +'"';
                if (response.data.data  == null) {
                    list.splice(index, 1);
                }

                else {
                    toastr.error(vm.localTranslator("org.view.incharge.delete.error1") + scId + vm.localTranslator("org.view.incharge.delete.error2") + scId + vm.localTranslator("org.view.incharge.delete.error3") + scId + vm.localTranslator("org.view.incharge.delete.error4"), vm.localTranslator("common.components.title.error"), baUtil.toastOptions())
                }

            });

        }

        function isRepresentativeRequired(type) {
            return type === 'INDIVIDUAL'
        }

        function enableButton() {
            $timeout(function () {
                vm.btnClick = false;
            }, 1000);
        }

        function disableButton() {
            vm.btnClick = true;
            $timeout(function () {
                vm.btnClick = false;
            }, 2000);
        }

        function editDetail() {
            vm.isEdit = true;
            vm.orgInfoCopy = angular.copy(vm.orgInfo);
            updateOfficeServiceSubTypeOptions();
        }

        function cancelEdit() {
            vm.isEdit = false;
            vm.orgInfo = vm.orgInfoCopy;
            updateOfficeServiceSubTypeOptions();
            $state.reload();

        }

        function getMerchant(query) {
            return ServiceManagementService.getMerchantForOffice(query);
        }

        function updateOfficeServiceSubTypeOptions(serviceTypeKey) {
            var selectedType = serviceTypeKey || vm.orgInfo.officeServiceType;
            vm.officeServiceSubTypeOptions = ServiceManagementService.getOfficeServiceSubTypeOptions(
                vm.types,
                selectedType
            );
        }

        function refreshOfficeServiceSubType(serviceType) {
            serviceType = serviceType || vm.orgInfo.officeServiceType;
            if (!serviceType) {
                vm.officeServiceSubTypeOptions = { key: [], en: [], jp: [] };
                vm.orgInfo.officeServiceSubType = null;
                return;
            }

            var state = ServiceManagementService.getOfficeServiceSubTypeState(vm.types, serviceType);
            vm.officeServiceSubTypeOptions = state.options;
            vm.orgInfo.officeServiceSubType = state.defaultKey;
        }

        function onOfficeMerchantSelected(data, index) {
            var ignoreComparison = false;
            for(i=0; i <= index; i++) {
                if(vm.orgDetails.officeMerchantMinDtos[index].merchantCode === data.merchantCode) {
                    var ignoreComparison = true;
                }
            }
            var filteredData = $filter('filter')(vm.orgInfo.officeMerchantMinDtos, data);
            if(filteredData.length && !ignoreComparison) {
                vm.newOrgForm['merchantSummaries_' + index].$setViewValue("");
                toastr.error(
                    vm.localTranslator("iosl.warning.msg"),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
                return;
            }

            vm.orgInfo.officeMerchantMinDtos[index].name = data.name;
            vm.orgInfo.officeMerchantMinDtos[index].merchantCode = data.merchantCode;
            vm.orgInfo.officeMerchantMinDtos[index].organisationId = data.organisationId;

        }

        function saveDetail() {
            var orgData = vm.orgInfo;
            if (vm.newOrgForm.$invalid) {

                $location.hash('top');
                $anchorScroll();

                vm.error = [];
                vm.detailErrors = true;

                for (var key in vm.newOrgForm.$error) {
                    for (var index = 0; index < vm.newOrgForm.$error[key].length; index++) {
                        vm.error.push(vm.newOrgForm.$error[key][index].$name);
                    }
                }

                for (var i = 0; i < vm.error.length; i++) {

                    var oo1 = new RegExp(/_([0-9]|[1-9][0-9])$/);
                    var oo2 = new RegExp(/_([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])$/);
                    var oo3 = new RegExp(/([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])_([0-9]|[1-9][0-9])$/);


                    vm.error[i] = vm.error[i].replace(oo1, '_0');
                    vm.error[i] = vm.error[i].replace(oo2, '_0_0');
                    vm.error[i] = vm.error[i].replace(oo3, '0_0_0');
                }

                vm.alerts = []
                vm.errors = []

                var unique = {};

                angular.forEach(vm.error, function (item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });

                vm.poko = {

                    'orgName':{
                        'key':'orgName',
                        'en':'Common Information - Organisation Name',
                        'jp':'共通情報 - 会社名'

                    },

                    'applicantCompanyCode':{
                        'key':'applicantCompanyCode',
                        'en':'Organisation Information - Company Code',
                        'jp':'企業情報 - 法人コード'

                    },

                    'businessType':{
                        'key':'businessType',
                        'en':'Organisation Information - Business Type',
                        'jp':'企業情報 - 業種業務区分'

                    },


                    'productsHandled':{
                        'key':'productsHandled',
                        'en':'Organisation Information - Products Handled',
                        'jp':'企業情報 - 取扱商品'

                    },

                    'organisationTypes_':{
                        'key':'organisationTypes_',
                        'en':'Common Information - Organisation Type',
                        'jp':'共通情報 - 区分'

                    },

                    'addressPin_organisation_address':{
                        'key':'addressPin_organisation_address',
                        'en':'Company Contact - Zip Code',
                        'jp':'企業連絡先 - 〒'

                    },

                    'streetAddress_organisation_address':{
                        'key':'streetAddress_organisation_address',
                        'en':'Company Contact - Street Address',
                        'jp':'企業連絡先 - 番地'
                        
                    },

                    'streetAddressKana_organisation_address':{
                        'key':'streetAddressKana_organisation_address',
                        'en':'Company Contact - Street Address(Kana)',
                        'jp':'企業連絡先 - 番地(フリガナ)'
                        
                    },

                    'contactNumber_organisation_account_contact__0':{
                        'key':'contactNumber_organisation_account_contact__0',
                        'en':'Company Contact - Contact',
                        'jp':'企業連絡先 - ご連絡先'

                    },

                    'companyRepresentativeNameReading_0':{
                        'key':'companyRepresentativeNameReading_0',
                        'en':'Company Representative - Name(Kana)',
                        'jp':'代表者様情報 - 氏名 (フリガナ)'

                    },

                    'companyRepresentativeName_0':{
                        'key':'companyRepresentativeName_0',
                        'en':'Company Representative - Name',
                        'jp':'代表者様情報 - 氏名'

                    },

                    'companyInChargePerson_0':{
                        'key':'companyInChargePerson_0',
                        'en':'In-Charge Person - Name',
                        'jp':'担当者情報 - 氏名'

                    },

                    'companyInChargePersonReading_0':{
                        'key':'companyInChargePersonReading_0',
                        'en':'In-Charge Person - Name (Kana)',
                        'jp':'担当者情報 - 氏名 (フリガナ)'

                    },

                    'contactNumber_organisation_account_contact_0_0':{
                        'key':'contactNumber_organisation_account_contact_0_0',
                        'en':'In-Charge Person - Contact',
                        'jp':'担当者情報- ご連絡先'

                    },


                    'contactEmail_organisation_account_contact_0_0':{
                        'key':'contactEmail_organisation_account_contact_0_0',
                        'en':'In-Charge Person - Email',
                        'jp':'担当者情報- メールアドレス'

                    },

                    'representativedob':{
                        'key':'representativedob',
                        'en':'Company Representative - Date of Birth',
                        'jp':'代表者様情報 - 生年月日'

                    },

                    'companyUsername_0':{
                        'key':'companyUsername_0',
                        'en':'In-Charge Person - Email',
                        'jp':'担当者情報 - メールアドレス'
                    },

                    'officeServiceType':{
                        'key':'officeServiceType',
                        'en':'Office Attribute - Service Type',
                        'jp':'オフィス属性 - サービスタイプ'
                    },

                    'officeServiceSubType':{
                        'key':'officeServiceSubType',
                        'en':'Office Attribute - Service Sub Type',
                        'jp':'オフィス属性 - サービスサブタイプ'
                    },

                    'merchantSummaries_0':{
                        'key':'merchantSummaries_0',
                        'en':'Office Attribute - Related Merchant Name',
                        'jp':'オフィス属性 - 関連加盟店'
                    }



                }

                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.enableButton();
                vm.errorNumbers = vm.alerts.length;
                return;

            }
            else {
                vm.detailErrors = false;
            }

            if (orgData.organisationTypes.indexOf('ADMIN') !== -1 && orgData.organisationTypes.length > 1) {
                toastr.error(vm.localTranslator('common.components.org.type.err.msg'),
                    vm.localTranslator('common.components.errorMessages.error'), baUtil.toastOptions());
                vm.enableButton();
                return;
            }

            if (vm.orgInfo.organisationTypes[0] === 'PARTNER' && !vm.orgInfo.login) {
                vm.orgInfo.accountDtos = [];
            }

            if (!baUtil.isUndefinedOrNull(orgData.organisationRepresentativeDtos[0].dateOfBirth)) {
                vm.orgInfoCopy = angular.copy(orgData);
                var n = vm.orgInfoCopy.organisationRepresentativeDtos.length;
                for (var i = 0; i <= (n - 1); i++) {
                    if (!angular.isNumber(vm.orgInfoCopy.organisationRepresentativeDtos[i].dateOfBirth)) {
                        var repLongDOB = vm.orgInfoCopy.organisationRepresentativeDtos[i].dateOfBirth.getTime();
                        vm.orgInfoCopy.organisationRepresentativeDtos[i].dateOfBirth = repLongDOB;
                    }
                }

                orgData = angular.copy(vm.orgInfoCopy);

            }

            var msgString = vm.localTranslator("partner.org.msg.changes");

            if (orgData.login !== vm.oldLogin) {
                vm.isConfirmRequired = true;
                if (orgData.login) {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.login')
                }
                else {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.no.login')
                }
            }

            if (orgData.deviceRequest !== vm.oldDeviceRequest) {
                vm.isConfirmRequired = true;
                if (orgData.deviceRequest) {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.access.grant.deviceRequest')
                }
                else {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.access.revoke.deviceRequest')
                }
            }

            if (orgData.sales !== vm.oldSales) {
                vm.isConfirmRequired = true;
                if (orgData.salesSettlement) {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.access.grant.sales')
                }
                else {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.access.revoke.sales')
                }
            }
            if (orgData.settlementInvoice !== vm.oldsettlementInvoice) {
                vm.isConfirmRequired = true;
                if (orgData.salesSettlement) {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.access.grant.settlementInvoice')
                }
                else {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.access.revoke.settlementInvoice')
                }
            }

            if (orgData.serviceManagement !== vm.oldServiceManagement) {
                vm.isConfirmRequired = true;
                if (orgData.serviceManagement) {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.access.grant.serviceManagement')
                }
                else {
                    msgString += '<br><br>' + vm.localTranslator('partner.org.msg.access.revoke.serviceManagement')
                }
            }

            if(vm.isConfirmRequired) {
                baUtil.showConfirm("", msgString, vm.localTranslator("common.components.msg.continue"))
                    .then(function () {
                        submitData(orgData);
                })
                .catch(function(){
                    return;
                });
            }
            else {
                submitData(orgData);
            }



            function submitData(orgData) {

                    var data = orgData;

                    ServiceManagementService.saveOrgDetail(data).then(function success(response) {
                        toastr.success(vm.localTranslator('common.components.msg.success'),
                            vm.localTranslator('common.components.title.success'), baUtil.toastOptions());
                        $state.reload();
                        vm.isEdit = false;
                    }, function err(err) {
                        vm.enableButton();
                        toastr.error(baUtil.getErrorMessageOrDefault(err, 'Error submitting form'),
                            vm.localTranslator('common.components.errorMessages.error'), baUtil.toastOptions())
                    });

            }



        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('DetailUserCtrl', DetailUserCtrl);

    /** @ngInject */
    function DetailUserCtrl(allTypes, ServiceManagementService, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, getDetail, $filter, AuthService , $location, $anchorScroll, localStorageService) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();
        vm.profile = localStorageService.get('loginResponse').accountDto;

        vm.onOrgNameSelected = onOrgNameSelected;
        vm.saveDetail = saveDetail;
        vm.getLang = getLang;
        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.getOrgName = getOrgName;
        vm.editDetail = editDetail;
        vm.cancelEdit = cancelEdit;
        vm.isEdit = false;
        vm.enableButton = enableButton;
        vm.disableButton = disableButton;
        vm.btnClick = false;
        vm.localTranslator = $filter('translate');
        vm.detailErrors = false;
        vm.account = baUtil.getAccountDto();
        vm.isMerchantOrDeviceOwner = baUtil.isMerchantOrDeviceOwner();
        vm.userInfo = {};
        vm.dobOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date(1901,0,1),
            maxDate : new Date()
        }
        if (vm.isMerchantOrDeviceOwner) {
            vm.userInfo.organisationId = vm.account.organisation.organisationId;
            vm.userInfo.organizationName =  vm.account.organisation.name;
            vm.userInfo.organizationCode =  vm.account.organisation.code;
        }


        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.types = allTypes.data.data;
        }

        if (getDetail.status >= 200 && getDetail.status <= 299) {
            vm.userDetails = getDetail.data.data;
        }

        if (!baUtil.isUndefinedOrNull(vm.userDetails)) {
            vm.userInfo = vm.userDetails
        }

        if (baUtil.isUndefinedOrNullOrEmptyObject(vm.userInfo.addressDtos)) {
            vm.userInfo.addressDtos[0] = {}
        }

        function getLang() {
            return $translate.use();
        }

        function getOrgName(query) {
            return ServiceManagementService.getOrgName(query)
        }

        function onOrgNameSelected(data) {
            vm.userInfo.organisationId = data.organisationId;
            vm.userInfo.organisation.code = data.code;
        }

        availableListOfSC(vm.userInfo.organisation.organisationId)

        function availableListOfSC(orgId) {
            ServiceManagementService.getAvailableServiceContract(orgId)
                .then(function(response){ // http promise block
                     vm.availableServiceContract = response.data.data;
                     if (baUtil.isUndefinedOrNullOrEmptyObject(vm.availableServiceContract)) {
                        vm.display = false;
                     }
                     else {
                        vm.display = true;
                     }
                });
        }


        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function editDetail() {
            vm.isEdit = true;
            vm.userInfoCopy = angular.copy(vm.userInfo);
        }

        function cancelEdit() {
            vm.isEdit = false;
            vm.userInfo = vm.userInfoCopy;
        }

        function enableButton () {
            $timeout(function() {
                vm.btnClick = false;
            }, 1000);
        }

        function disableButton () {
            vm.btnClick = true;
            $timeout(function() {
                vm.btnClick = false;
            }, 2000);
        }

        function saveDetail() {

            if (vm.newUserForm.$invalid) {

                $location.hash('top');
                $anchorScroll();

                vm.error = [];
                vm.detailErrors = true;

                for (var key in vm.newUserForm.$error) {
                    for (var index = 0; index < vm.newUserForm.$error[key].length; index++) {
                        vm.error.push(vm.newUserForm.$error[key][index].$name);
                    }
                }

                vm.alerts = []
                vm.errors = []

                var unique = {};

                angular.forEach(vm.error, function(item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });

                 vm.poko = {
                    'commonInfoUserEmail':{
                        'key':'commonInfoUserEmail',
                        'en':'Common Information - User Email',
                        'jp':'共通情報 - ユーザーメールアドレス'
                    },
                    'companyInChargePerson_':{
                        'key':'companyInChargePerson_',
                        'en':'Common Information - User Name',
                        'jp':'共通情報 - ユーザー名'
                    },
                    'companyInChargePersonReading_':{
                        'key':'companyInChargePersonReading_',
                        'en':'Common Information - User Name (Kana)',
                        'jp':'共通情報 - ユーザー名 (フリガナ)'
                    },
                    'commonInfoUserDescription':{
                        'key':'commonInfoUserDescription',
                        'en':'Common Information - User Description',
                        'jp':'共通情報 - ユーザー情報'
                    },
                    'organizationName':{
                        'key':'organizationName',
                        'en':'Organisation Information - Organisation Name',
                        'jp':'企業情報 - 法人名'
                    },
                    'accountTypes':{
                        'key':'accountTypes',
                        'en':'Organisation Information - User Type',
                        'jp':'企業情報 - ユーザー区分'
                    },
                    'userDob':{
                        'key':'userDob',
                        'en':'User Information - Date of Birth',
                        'jp':'ユーザー情報 - 生年月日'
                    },
                    'addressPin_organisation_address':{
                        'key':'addressPin_organisation_address',
                        'en':'User Information - Zip Code',
                        'jp':'ユーザー情報 - 〒'
                    },
                    'contactNumber_user_account_contact__0':{
                        'key':'contactNumber_user_account_contact__0',
                        'en':'User Information - Contact',
                        'jp':'ユーザー情報 - ご連絡先'
                    },

                }

                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.enableButton();
                vm.errorNumbers = vm.alerts.length;
                return;

             }
            else {
                vm.detailErrors = false;
            }

            if (vm.userInfo.accountTypes[0] !== 'ADMIN') {
                vm.userInfo.serviceContractId = [];
            }

            if (!angular.isNumber(vm.userInfo.dob)){
                vm.userInfo.dob = vm.userInfo.dob.getTime();
            }

            var data = vm.userInfo;

            ServiceManagementService.saveUserDetail(data).then(function success(response) {
                    toastr.success(
                        vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                vm.isEdit = false;
                $state.reload();
            }, function err(err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
            });
        }


    }

})();

(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('ListUsersCtrl', ListUsersCtrl);

    /** @ngInject */
    function ListUsersCtrl($timeout, types, toastr, ServiceManagementService, scListPromise, $uibModal, baUtil, $state, Upload, API_CONFIG, $filter, $translate, AuthService, localStorageService) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();
        vm.profile = localStorageService.get('loginResponse').accountDto;

        vm.init = init;
        vm.searchSC = searchSC;
        vm.openFilterModal = openFilterModal;

        vm.disableUser = disableUser;
        vm.enableUser = enableUser;
        vm.deleteUser = deleteUser;
        vm.query = {}
        vm.paginateCallback = paginateCallback
        vm.getValueFromTypeKey = getValueFromTypeKey
        vm.getLang = getLang;
        vm.localTranslator = $filter('translate');
        vm.openDetail = openDetail;
        vm.passwordManagement = passwordManagement;
        init();

        if (scListPromise.status >= 200 && scListPromise.status <= 299) {
            vm.scListResponse = scListPromise.data.data;
        } else {
            return;
        }
        if (types.status >= 200 && types.status <= 299) {
            vm.types = types.data.data;
        } else {
            return;
        }

        function init() {
            vm.scListResponse = {
                content: []
            };
            vm.search = {
                query : ''
            }
        }

        function searchSC() {
            ServiceManagementService.search(vm.search.query)
            .then(function s(response) {
                vm.scListResponse = response.data.data;
            },function err(err) {
            })
        }

        function openFilterModal(page, size) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                resolve: {
                    items: function () {
                        return [];
                    }
                }
            });
        }

        function openDetail(ev, obj) {
            $state.go('main.serviceManagement.users.detail', { userId: obj.accountId});
        }

        function passwordManagement(ev, obj) {
            $state.go('main.serviceManagement.users.passwordManagement', { userId: obj.accountId});
        }

        function enableUser(obj){
            baUtil.showConfirm(vm.localTranslator("org.list.enable") + ' ?',vm.localTranslator("user.list.msg.enable"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
                ServiceManagementService.enableUser(obj.accountId).then(function success(response) {
                    toastr.success(
                       // response.data.data.message || vm.localTranslator("user.list.msg.enable.status"),
                        vm.localTranslator("user.list.msg.enable.status"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.reload()
                }, function err(err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
            });
        }

        function disableUser(obj){
             baUtil.showConfirm(vm.localTranslator("org.list.disable") + ' ?',vm.localTranslator("user.list.msg.disable"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
                ServiceManagementService.disableUser(obj.accountId).then(function success(response) {
                    toastr.success(
                     //   response.data.data.message || vm.localTranslator("user.list.msg.disable.status"),
                        vm.localTranslator("user.list.msg.disable.status"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.reload()
                }, function err(err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
             });
        }

        function deleteUser(obj){
             baUtil.showConfirm(vm.localTranslator("org.list.delete") + ' ?',vm.localTranslator("user.list.msg.delete"),vm.localTranslator("common.components.btn.yes"))
            .then(function() {
                ServiceManagementService.deleteUser(obj.accountId).then(function success(response) {
                    toastr.success(
                     //   response.data.data.message || vm.localTranslator("user.list.msg.delete.status"),
                        vm.localTranslator("user.list.msg.delete.status"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                    $state.reload()
                }, function err(err) {
                    toastr.error(
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });
             });
        }


        function paginateCallback(query) {
            ServiceManagementService.search(baUtil.makeQueryString(query))
            .then(function (response) {
                vm.scListResponse = response.data.data;
                vm.query = query;
            });
        }

        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })
            return type[vm.getLang()][index]
        }

        function getLang() {
            return $translate.use();
        }




    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('NewUsersCtrl', NewUsersCtrl);

    /** @ngInject */
    function NewUsersCtrl(allTypes, generateUserId, ServiceManagementService, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, $filter, AuthService,  $location, $anchorScroll) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.createUser = createUser;
        vm.getLang = getLang;
        vm.enableButton = enableButton;
        vm.disableButton = disableButton;
        vm.btnClick = false;

        vm.getValueFromTypeKey = getValueFromTypeKey;
        vm.getOrgName = getOrgName;
        vm.getOrgCode = getOrgCode;
        vm.onOrgNameSelected = onOrgNameSelected;
        vm.availableListOfSC = availableListOfSC;
        vm.localTranslator = $filter('translate');
        vm.detailErrors = false;
        vm.dobOptions = {
            showWeeks: false,
            formatDayTitle:'yyyy 年 MMMM',
            formatMonthTitle:'yyyy 年',
            minDate : new Date(1901,0,1),
            maxDate : new Date()
        }

        vm.userInfo = {
            "contactCreateDtos": [{}],
            "addressCreateDtos": [{}],
            "accountTypes": []
        }

        vm.account = baUtil.getAccountDto();
        vm.isMerchantOrDeviceOwner = baUtil.isMerchantOrDeviceOwner();
        if (vm.isMerchantOrDeviceOwner) {
            vm.userInfo.organisationId = vm.account.organisation.organisationId;
            vm.userInfo.organizationName =  vm.account.organisation.name;
            vm.userInfo.organizationCode =  vm.account.organisation.code;
        }

        vm.isOfficeUser = baUtil.isOfficeUser();
        if (vm.isOfficeUser) {
            vm.userInfo.organisationId = vm.account.organisation.organisationId;
            vm.userInfo.organizationName =  vm.account.organisation.name;
            vm.userInfo.organizationCode =  vm.account.organisation.code;
        }



        vm.isPartner = baUtil.isPartnerUser();
        if (vm.isPartner) {
            vm.userInfo.organisationId = vm.account.organisation.organisationId;
            vm.userInfo.organizationName =  vm.account.organisation.name;
            vm.userInfo.organizationCode =  vm.account.organisation.code;
        }


        if (allTypes.status >= 200 && allTypes.status <= 299) {
            vm.types = allTypes.data.data;
        }


         function getOrgName(query) {
            return ServiceManagementService.getOrgName(query)
        }

         function getOrgCode(query) {
            return ServiceManagementService.getOrgCode(query)
        }


        function onOrgNameSelected(data) {
            vm.userInfo.organisationId = data.organisationId;
            if (baUtil.isUndefinedOrNullOrEmpty(data.code)) {
                vm.userInfo.organizationCode = '';
            }
            else {
                vm.userInfo.organizationCode = data.code;
            }
            availableListOfSC(vm.userInfo.organisationId);
        }

        function availableListOfSC(orgId) {
            ServiceManagementService.getAvailableServiceContract(orgId)
                .then(function(response){ // http promise block
                     vm.availableServiceContract = response.data.data;
                     if (baUtil.isUndefinedOrNullOrEmptyObject(vm.availableServiceContract)) {
                        vm.display = false;
                     }
                     else {
                        vm.display = true;
                     }

                });
        }



        function getLang() {
            return $translate.use();
        }



        function getValueFromTypeKey(key, type) {
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }

        function addNewRow(list, type) {
            if (baUtil.isUndefinedOrNull(list)) {
                return
            }
            if (type === 'ADD_SETTLEMENT') {
                list.push({
                    "settlementSendLocationCreateDtos": [{
                        "addressCreateDto": {
                            "contactCreateDtos": [{}]
                        }
                    }]
                })
                return
            }
            if (type === 'CREATE_ORGANISATION') {
                list.push({
                    "contactCreateDtos": [{}]
                })
                return
            }
            if (type === 'REPRESENTATIVE') {
                list.push({
                    "addressCreateDtos": [{
                        "contactCreateDtos": [{}]
                    }]
                })
                return
            }
            if (type === 'SETTLEMENT_LOCATION') {
                list.push({
                    "addressCreateDto": {
                        "contactCreateDtos": [{}]
                    }
                })
                return
            }
            list.push({})
        }

        function removeRow(list, index) {
            list.splice(index, 1);
        }

        function enableButton () {
            $timeout(function() {
                vm.btnClick = false;
            }, 1000);
        }

        function disableButton () {
            vm.btnClick = true;
            $timeout(function() {
                vm.btnClick = false;
            }, 2000);
        }


        function createUser() {
            
            if (vm.newUserForm.$invalid) {
                 
                $location.hash('top');
                $anchorScroll();
                 
                vm.error = [];
                vm.detailErrors = true; 

                for (var key in vm.newUserForm.$error) {
                    for (var index = 0; index < vm.newUserForm.$error[key].length; index++) {
                        vm.error.push(vm.newUserForm.$error[key][index].$name);
                    }
                }
                 
                vm.alerts = []
                vm.errors = []
                
                var unique = {};
                 
                angular.forEach(vm.error, function(item) {
                    if (!unique[item]) {
                        vm.errors.push(item);
                        unique[item] = item;
                    }
                });
                                 
                vm.poko = {
                    'commonInfoUserEmail':{
                        'key':'commonInfoUserEmail',
                        'en':'Common Information - User Email',
                        'jp':'共通情報 - ユーザーメールアドレス'
                    },
                    'companyInChargePerson_':{
                        'key':'companyInChargePerson_',
                        'en':'Common Information - User Name',
                        'jp':'共通情報 - ユーザー名'
                    },
                    'companyInChargePersonReading_':{
                        'key':'companyInChargePersonReading_',
                        'en':'Common Information - User Name (Kana)',
                        'jp':'共通情報 - ユーザー名 (フリガナ)'
                    },
                    'commonInfoUserDescription':{
                        'key':'commonInfoUserDescription',
                        'en':'Common Information - User Description',
                        'jp':'共通情報 - ユーザー情報'
                    },
                    'organizationName':{
                        'key':'organizationName',
                        'en':'Organisation Information - Organisation Name',
                        'jp':'企業情報 - 法人名'
                    },
                    'accountTypes':{
                        'key':'accountTypes',
                        'en':'Organisation Information - User Type',
                        'jp':'企業情報 - ユーザー区分'
                    },
                    'userDob':{
                        'key':'userDob',
                        'en':'User Information - Date of Birth',
                        'jp':'ユーザー情報 - 生年月日'
                    },
                    'addressPin_organisation_address':{
                        'key':'addressPin_organisation_address',
                        'en':'User Information - Zip Code',
                        'jp':'ユーザー情報 - 〒'
                    },
                    'contactNumber_user_account_contact__0':{
                        'key':'contactNumber_user_account_contact__0',
                        'en':'User Information - Contact',
                        'jp':'ユーザー情報 - ご連絡先'
                    },
                    
                }
                 
                vm.errorCounts = vm.errors.length;

                for (var i = 0; i < vm.errorCounts; i++) {

                    vm.errors.filter(function (key) { return key == vm.errors[i] }).forEach(function (item) {
                        if (!baUtil.isUndefinedOrNullOrEmpty(vm.poko[item])) {
                            vm.alerts.push(vm.poko[item][vm.getLang()])
                        }
                    })

                }
                vm.enableButton();
                vm.errorNumbers = vm.alerts.length;
                return;

            }
            else {
                vm.detailErrors = false;
            }

            if (vm.userInfo.accountTypes[0] !== 'ADMIN') {
                vm.userInfo.serviceContractId = [];
            }
            
            if(!vm.isPartner && baUtil.isUndefinedOrNull(vm.userInfo.organizationCode)) {
                toastr.error(vm.localTranslator("users.create.update.view.common.information.orgError"), vm.localTranslator("common.components.title.error"), baUtil.toastOptions());
                return;
            }

            if (!angular.isNumber(vm.userInfo.dob)){
                vm.userInfo.dob = vm.userInfo.dob.getTime();
            }

            var data = vm.userInfo;
            ServiceManagementService.createUsers(data).then(function success(response) {
                $state.go('main.serviceManagement.users.list');
                toastr.success(
                    response.data.data.message || vm.localTranslator("common.components.msg.success"),
                    vm.localTranslator("common.components.title.success"),
                    baUtil.toastOptions()
                );
            }, function err(err) {
                toastr.error(
                    baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                    vm.localTranslator("common.components.title.error"),
                    baUtil.toastOptions()
                );
            });
        }


    }

})();
(function () {
    'use strict';

    angular.module('JPTC.pages.serviceContract')
        .controller('PassManageCtrl', PassManageCtrl);

    /** @ngInject */
    function PassManageCtrl( ServiceManagementService, baUtil, $state, toastr, $stateParams, $translate, $timeout, $scope, getDetail, $filter, AuthService, allTypes) {
        var vm = this;
        vm.permissions = AuthService.getPermissions();

        vm.getLang = getLang;
        vm.isGeneratePass = false;
        vm.isResetPass = false;
        vm.isChangePass = false;
        vm.changePass = changePass;
        vm.resetPass = resetPass;
        vm.generatePass = generatePass;
        vm.localTranslator = $filter('translate');
        vm.getValueFromTypeKey = getValueFromTypeKey;
        

        vm.userInfo = {}

        if (allTypes.status >= 200 && allTypes.status <= 299) {
             vm.types = allTypes.data.data;

        }
        
        $scope.onSelected = function (selectedItem) {
            if (selectedItem == 'GENERATE_PASSWORD'){
                vm.isGeneratePass = true;
                vm.isResetPass = false;
                vm.isChangePass = false;
            }
            else if (selectedItem == 'RESET_PASSWORD'){
                vm.isGeneratePass = false;
                vm.isResetPass = true;
                vm.isChangePass = false;
            } 
            else if (selectedItem == 'CHANGE_PASSWORD'){
                vm.isGeneratePass = false;
                vm.isResetPass = false;
                vm.isChangePass = true;
            }
}
        
        vm.operationType = ["Generate Password", "Reset Password", "Change Password"]
        
        
       
        if (getDetail.status >= 200 && getDetail.status <= 299) {
            vm.userDetails = getDetail.data.data;
        }

        if (!baUtil.isUndefinedOrNull(vm.userDetails)) {
            vm.userInfo = vm.userDetails
        }

        function getLang() {
            return $translate.use();
        }

        function getValueFromTypeKey(key, type) {
            if (baUtil.isUndefinedOrNull(key)) {
                return
            }
            var index = type.key.findIndex(function (item) {
                return item === key
            })

            return type[vm.getLang()][index]
        }
       
        
        function generatePass() { 
            ServiceManagementService.generatePassword(vm.userInfo.accountId,
                  function success(response) {
                    toastr.success(
                        response.data.message || vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                  $state.go('main.serviceManagement.users.list');
                       //  $state.reload()
                }, function err(err) {
                    toastr.error(           
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });        
        }

        function resetPass() {            
              ServiceManagementService.resetPassword(vm.userInfo.accountId,
                  function success(response) {
                    toastr.success(
                        response.data.message || vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                  $state.go('main.serviceManagement.users.list');
                       //  $state.reload()
                }, function err(err) {
                    toastr.error(           
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                });            
        }
        function changePass() {

            var form = angular.copy(vm.newUserForm);

            if (form.$invalid) {
                return;
            }
            
            if (vm.userInfo.oldPass == vm.userInfo.newPass) { 
                
                 toastr.error(
                        vm.localTranslator("common.components.msg.error.same.oldPassword"),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                
                return
            }
            
            if (vm.userInfo.newPass == vm.userInfo.newPassConfirm) { 
                
                 ServiceManagementService.changePassword(vm.userInfo.accountId,vm.userInfo.oldPass , vm.userInfo.newPass,
                  function success(response) {
                    toastr.success(
                        response.data.message || vm.localTranslator("common.components.msg.success"),
                        vm.localTranslator("common.components.title.success"),
                        baUtil.toastOptions()
                    );
                  $state.go('main.serviceManagement.users.list');
                       //  $state.reload()
                }, function err(err) {
                    toastr.error(           
                        baUtil.getErrorMessageOrDefault(err, vm.localTranslator("common.components.msg.error.in.form")),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
    
                }); 
                
                }
            else { 
                
                 toastr.error(
                        vm.localTranslator("common.components.msg.error.password.noMatch"),
                        vm.localTranslator("common.components.title.error"),
                        baUtil.toastOptions()
                    );
                 
            }
            
            
            
        }


    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('JPTC.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('JPTC.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('JPTC.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/*!
 * ng-bootstrap-select v0.5.0
 * https://github.com/snapappointments/ng-bootstrap-select
 * Licensed under MIT
 */

(function () {
  'use strict';

  angular.module('JPTC.pages.form')
    .directive('selectpickernew', selectpickerDirective);

  /**
   * @ngdoc directive
   * @name selectpicker
   * @restrict A
   *
   * @param {object} selectpicker Directive attribute to configure bootstrap-select, full configurable params can be found in [bootstrap-select docs](http://silviomoreto.github.io/bootstrap-select/).
   * @param {string} ngModel Assignable angular expression to data-bind to.
   *
   * @description
   * The selectpicker directive is used to wrap bootstrap-select.
   *
   * @usage [more options from - https://developer.snapappointments.com/bootstrap-select/]
   * ```html
      <select
        class="form-control selectpicker show-tick"
        title="契約先IDで絞る"
        data-live-search="true"
        data-actions-box="true"
        data-width="16%"
        data-select-all-text="すべて選択"
        data-deselect-all-text="選択を解除"
        data-live-search-placeholder="複数選択"
        data-size="10"
        multiple
        selectpickernew="{dropupAuto:false}"
        ng-model="vm.selectModel"
        ng-change="vm.selectChangeHandler()"
        ng-options="item as item.label for item in vm.selectOptions track by item.value"
      />
   * ```
   *
   * Usage points:
   * > all options >> any change in the model will result into rerender
   * > selected options >> any change in the model will result into rerender
   * > accepts - on change handler function using `ng-change`
   * > no mechanism to trigger refresh on demand
   * > on lang change > change the label of options model and it will cause rerender.
   *
   */

  function isWindow(obj) {
    return obj && obj.window === obj;
  }

  var isArray = Array.isArray;

  function isArrayLike(obj) {

    // `null`, `undefined` and `window` are not array-like
    if (obj == null || isWindow(obj)) return false;

    // arrays, strings and jQuery/jqLite objects are array like
    // * jqLite is either the jQuery or jqLite constructor function
    // * we have to check the existance of jqLite first as this method is called
    //   via the forEach method when constructing the jqLite object in the first place
    if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

    // Support: iOS 8.2 (not reproducible in simulator)
    // "length" in obj used to prevent JIT error (gh-11508)
    var length = "length" in Object(obj) && obj.length;

    // NodeList objects (with `item` method) and
    // other objects with suitable length characteristics are array-like
    return isNumber(length) &&
      (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item == 'function');

  }

  var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                          // 1: value expression (valueFn)
                          // 2: label expression (displayFn)
                          // 3: group by expression (groupByFn)
                          // 4: disable when expression (disableWhenFn)
                          // 5: array item variable name
                          // 6: object item key variable name
                          // 7: object item value variable name
                          // 8: collection expression
                          // 9: track by expression

  /** @ngInject */
  function selectpickerDirective($parse, $timeout) {
    return {
      restrict: 'A',
      priority: 1000,
      link: function (scope, element, attrs) {
        var $async = scope.$applyAsync ? '$applyAsync' : '$evalAsync', // fall back to $evalAsync if using AngularJS v1.2.x
            selectCollection;

        if (attrs.ngOptions) {
          var multiple = attrs.multiple,
              optionsExp = attrs.ngOptions,
              optionAttrs = $parse(attrs.bsOptionAttrs)(scope),
              emptyOption,
              unknownOption,
              match = optionsExp.match(NG_OPTIONS_REGEXP);

          // The collection to watch
          selectCollection = match[8];
          // The variable name for the value of the item in the collection
          var valueName = match[5] || match[7];
          // The variable name for the key of the item in the collection
          var keyName = match[6];

          // An expression that generates the viewValue for an option if there is a label expression
          var selectAs = / as /.test(match[0]) && match[1];
          // An expression that is used to track the id of each object in the options collection
          var trackBy = match[9];
          // An expression that generates the viewValue for an option if there is no label expression
          var valueFn = $parse(match[2] ? match[1] : valueName);
          var selectAsFn = selectAs && $parse(selectAs);
          var viewValueFn = selectAsFn || valueFn;
          var trackByFn = trackBy && $parse(trackBy);

          // Get the value by which we are going to track the option
          // if we have a trackFn then use that (passing scope and locals)
          // otherwise just hash the given viewValue
          var getTrackByValueFn = trackBy ?
                                    function(value, locals) { return trackByFn(scope, locals); } :
                                    function getHashOfValue(value) { return hashKey(value); };
          var getTrackByValue = function(value, key) {
            return getTrackByValueFn(value, getLocals(value, key));
          };

          var displayFn = $parse(match[2] || match[1]);
          var groupByFn = $parse(match[3] || '');
          var disableWhenFn = $parse(match[4] || '');
          var valuesFn = $parse(selectCollection);

          var locals = {};
          var getLocals = keyName ? function(value, key) {
            locals[keyName] = key;
            locals[valueName] = value;
            return locals;
          } : function(value) {
            locals[valueName] = value;
            return locals;
          };

          scope[$async](function () {
            element.selectpicker($parse(attrs.selectpicker)());
          });
        } else {
          selectCollection = attrs.selectCollection;

          element.selectpicker($parse(attrs.selectpicker)());

          $timeout(function () { // fall back to $timeout for selects that don't use ng-options
            refresh();
          });
        }

        if (selectCollection) scope.$watch(selectCollection, refresh, true);

        function bindData(text) {
          var startIndex,
              endIndex,
              index = 0,
              expressions = [],
              parseFns = [],
              textLength = text ? text.length : 0,
              exp,
              concat = [],
              startSymbol = '{{',
              endSymbol = '}}',
              startSymbolLength = startSymbol.length,
              endSymbolLength = endSymbol.length,
              escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
              escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g'),
              expressionPositions = [];

          function escape(ch) {
            return '\\\\\\' + ch;
          }

          function unescapeText(text) {
            return text.replace(escapedStartRegexp, startSymbol).
              replace(escapedEndRegexp, endSymbol);
          }

          while (index < textLength) {
            if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
                 ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
              if (index !== startIndex) {
                concat.push(unescapeText(text.substring(index, startIndex)));
              }
              exp = text.substring(startIndex + startSymbolLength, endIndex);
              expressions.push(exp);
              index = endIndex + endSymbolLength;
              expressionPositions.push(concat.length);
              concat.push('');
            } else {
              // we did not find an interpolation, so we have to add the remainder to the separators array
              if (index !== textLength) {
                concat.push(unescapeText(text.substring(index)));
              }
              break;
            }
          }

          return function(context, locals) {
            for (var i = 0, ii = expressions.length; i < ii; i++) {
              concat[expressionPositions[i]] = $parse(expressions[i])(context, locals);
            }

            return concat.join('');
          }
        }

        function setAttributes() {
          if (typeof optionAttrs === 'object' && $.isEmptyObject(optionAttrs)) return;

          function getOptionValuesKeys(optionValues) {
            var optionValuesKeys;

            if (!keyName && isArrayLike(optionValues)) {
              optionValuesKeys = optionValues;
            } else {
              // if object, extract keys, in enumeration order, unsorted
              optionValuesKeys = [];
              for (var itemKey in optionValues) {
                if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
                  optionValuesKeys.push(itemKey);
                }
              }
            }
            return optionValuesKeys;
          }

          var optionValues = valuesFn(scope) || [],
              optionValuesKeys = getOptionValuesKeys(optionValues);

          emptyOption = [];
          unknownOption = [];

          // find empty or unknown options
          for (var i = 0, children = element.find('option'), ii = children.length; i < ii; i++) {
            var value = children[i].value,
                option = children.eq(i);

            if (value === '') {
              emptyOption.push(option);
            } else if (value === '?') {
              unknownOption.push(option);
            } else {
              break;
            }
          }

          if (emptyOption.length > 1) emptyOption[1].remove();

          element.find('option').each(function(i) {
            if (emptyOption.length) i--;
            if (unknownOption.length) i--;

            var locals = {},
                newAttrs = {},
                newData = {},
                key = (optionValues === optionValuesKeys) ? i : optionValuesKeys[i],
                value = optionValues[key];

            locals = getLocals(value, key);

            if (attrs.bsOptionAttrs && (keyName && key || !keyName && value)) {
              var customAttrs = typeof optionAttrs === 'function' ? optionAttrs(value, key) : optionAttrs;

              if ($.isEmptyObject(customAttrs)) return;

              for (var optionAttr in customAttrs) {
                var attr = customAttrs[optionAttr],
                    dataAttr = optionAttr.split('data-')[1] ? optionAttr.split('data-')[1].replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); }) : null, // convert to camelCase
                    parseAttr = bindData(attr)(scope, locals);

                if (dataAttr) {
                  newData[dataAttr] = parseAttr || attr;
                } else {
                  newAttrs[optionAttr] = parseAttr || attr;
                }
              }

              $(this).data(newData).attr(newAttrs);
            }
          });
        }

        function refresh(newVal) {
          scope[$async](function () {
            if (attrs.ngOptions && attrs.bsOptionAttrs) setAttributes();
            element.selectpicker('refresh');
          });
        }

        function render(newVal) {
          // update model if select is within child scope (e.g. inside ng-if)
          if (scope.$parent[attrs.ngModel] !== undefined && scope.$parent[attrs.ngModel] !== newVal) {
            scope.$parent[attrs.ngModel] = newVal;
          }

          if (scope.$$childHead && scope.$$childHead[attrs.ngModel]) {
            scope.$$childHead[attrs.ngModel] = newVal;
          }

          scope[$async](function () {
            element.selectpicker('render');
          });
        }

        attrs.$observe('spTheme', function (val) {
          $timeout(function () {
            element.data('selectpicker').$button.removeClass(function (i, c) {
              return (c.match(/(^|\s)?btn-\S+/g) || []).join(' ');
            });
            element.selectpicker('setStyle', val);
          });
        });

        if (attrs.ngModel) {
          scope.$watch(attrs.ngModel, function(newVal, oldVal) {
            if (newVal !== oldVal) {
              if (!oldVal) {
                return refresh(newVal);
              } else {
                return render(newVal);
              }
            }
          }, true);
        }

        if (attrs.ngDisabled) {
          scope.$watch(attrs.ngDisabled, refresh, true);
        }

        scope.$on('$destroy', function () {
          $timeout(function () {
            element.selectpicker('destroy');
          });
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          if (attrs.refreshflag) {
            scope.$watch(attrs.refreshflag, refresh);
          }

          scope.$on('LANG_CHANGE', function(){
            setTimeout(function() {
              elem.selectpicker('refresh');
            }, 500);
          });

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('JPTC.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('JPTC.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module('JPTC').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/authSignIn/authSignIn.html','<div class="login" form="vm.loginForm"><main class="auth-main"><div class="auth-block"><div class="text-right" style=""><img ng-click="vm.changeLanguage(\'jp\')" src="./assets/img/lang-flags/jp.svg" alt="JP" width="30px" style="border: 2px solid #edeff2; cursor: pointer"> <img ng-click="vm.changeLanguage(\'en\')" src="./assets/img/lang-flags/en.svg" alt="EN" width="30px" style="border: 1px solid #ffffff; cursor: pointer"></div><h1>{{\'login.title\' | translate}}</h1><form name="vm.loginForm" novalidate=""><div class="form-group" ng-class="{\'has-error\': vm.loginForm.email.$invalid && vm.loginForm.$submitted}"><label for="inputEmail3" class="control-label">{{\'login.email\' | translate}}</label><div class="form-input-group-row labelXXL"><input type="text" valid-email="" ng-model="vm.loginFormData.email" name="email" class="form-control" id="inputEmail3" placeholder="{{\'login.email\' | translate}}" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.email_error_msg\' | translate}}</span></div><div class="form-group" ng-class="{\'has-error\': vm.loginForm.pass.$invalid && vm.loginForm.$submitted}"><label for="inputPassword3" class="control-label">{{\'login.password\' | translate}}</label><div class="form-input-group-row labelXXL"><input type="password" ng-model="vm.loginFormData.password" name="pass" class="form-control" required="required" id="inputPassword3" placeholder="{{\'login.password\' | translate}}"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="form-group"><div class="m-t-40 clearfix"><a href="/#/forgotPassword" class=""><button type="button" class="btn btn-warning">{{\'login.forgotPass\' | translate}}</button></a> <button class="btn btn-info pull-right" type="submit" ng-click="vm.login()">{{\'login.title\' | translate}}</button></div></div><div class="form-group" ng-if="vm.expireSessionText"><label class="control-label" style="color:red">{{\'session.timeout.expireText\' | translate}}</label></div><div class="form-group"><div class="m-t-30 clearfix"></div></div></form></div></main><div class="text-center seal-wrapper"><div ng-if="!vm.originalSeal" class="text-center"><img src="./assets/img/app/seal/getseal.png"></div><div ng-if="vm.originalSeal" class="text-center"><a href="https://trustsealinfo.websecurity.norton.com/splash?form_file=fdf/splash.fdf&dn=emp.cpi-cgw.com&lang=ja" target="_blank"><img src="./assets/img/app/seal/getseal.png"></a></div></div></div>');
$templateCache.put('app/pages/authSignUp/authSignUp.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>Sign up to Blur Admin</h1><a ui-sref="authSignIn" class="auth-link">Already have a Blur Admin account? Sign in!</a><form class="form-horizontal"><div class="form-group"><label for="inputName3" class="col-sm-2 control-label">Name</label><div class="col-sm-10"><input type="text" class="form-control" id="inputName3" placeholder="Full Name"></div></div><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">Sign up</button></div></div></form><div class="auth-sep"><span><span>or Sign up with one click</span></span></div><div class="al-share-auth"><ul class="al-share clearfix"><li><i class="socicon socicon-facebook" title="Share on Facebook"></i></li><li><i class="socicon socicon-twitter" title="Share on Twitter"></i></li><li><i class="socicon socicon-google" title="Share on Google Plus"></i></li></ul></div></div></main></div>');
$templateCache.put('app/pages/comingSoon/comingSoon.html','<h2>{{\'common.components.coming.soon\' | translate}}</h2>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Acquisition Channels" ba-panel-class="medium-panel traffic-panel"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users by Country" ba-panel-class="medium-panel"><dashboard-map></dashboard-map></div></div><div class="row"><div class="col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12" ba-panel="" ba-panel-title="Revenue" ba-panel-class="medium-panel"><dashboard-line-chart></dashboard-line-chart></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app medium-panel"><popular-app></popular-app></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ba-panel="" ba-panel-title="Feed" ba-panel-class="large-panel with-scroll feed-panel"><blur-feed></blur-feed></div></div><div class="row shift-up"><div class="col-xlg-3 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="To Do List" ba-panel-class="xmedium-panel feed-comply-panel with-scroll todo-panel"><dashboard-todo></dashboard-todo></div><div class="col-xlg-6 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/forgotPassword/changePassword.html','<div class="login" form="vm.changePassForm"><main class="auth-main"><div class="auth-block"><div class="text-right" style=""><img ng-click="vm.changeLanguage(\'jp\')" src="https://lipis.github.io/flag-icon-css/flags/4x3/jp.svg" alt="JP" width="30px" style="border: 2px solid #edeff2; cursor: pointer"> <img ng-click="vm.changeLanguage(\'en\')" src="https://lipis.github.io/flag-icon-css/flags/4x3/um.svg" alt="EN" width="30px" style="border: 1px solid #ffffff; cursor: pointer"></div><h1>{{\'user.password.management.changePass\' | translate}}</h1><form name="vm.changePassForm" novalidate=""><div class="form-group" ng-class="{\'has-error\': vm.changePassForm.password.$invalid && vm.changePassForm.$submitted}"><label for="inputEmail3" class="control-label">{{\'user.password.management.newPassword\' | translate}}</label><div class=""><input required="" type="password" ng-model="vm.changePass" class="form-control" name="password"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="form-group" ng-class="{\'has-error\': vm.changePassForm.confirmPassword.$invalid && vm.changePassForm.$submitted}"><label for="inputPassword3" class="control-label">{{\'user.password.management.confirmPassword\' | translate}}</label><div class=""><input required="" type="password" ng-model="vm.changePassConfirm" name="confirmPassword" class="form-control"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="form-group"><div class="m-t-40 clearfix"><button class="btn btn-info pull-right" ng-click="vm.submit()">{{\'user.password.management.changePass\' | translate}}</button></div></div></form></div></main></div>');
$templateCache.put('app/pages/forgotPassword/forgotPassword.html','<div class="login" form="vm.forgotPass"><main class="auth-main"><div class="auth-block"><div class="text-right" style=""><img ng-click="vm.changeLanguage(\'jp\')" src="https://lipis.github.io/flag-icon-css/flags/4x3/jp.svg" alt="JP" width="30px" style="border: 2px solid #edeff2; cursor: pointer"> <img ng-click="vm.changeLanguage(\'en\')" src="https://lipis.github.io/flag-icon-css/flags/4x3/um.svg" alt="EN" width="30px" style="border: 1px solid #ffffff; cursor: pointer"></div><h1>{{\'login.forgotPass\' | translate}}</h1><form name="vm.forgotPass" novalidate=""><div class="form-group" ng-class="{\'has-error\': vm.forgotPass.userName.$invalid && vm.forgotPass.$submitted}"><label for="inputEmail3" class="control-label">{{\'login.email\' | translate}}</label><div class=""><input required="" type="email" ng-model="vm.userName" name="userName" class="form-control" id="inputEmail3"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="form-group"><div class="m-t-40 clearfix"><button class="btn btn-info pull-right" ng-click="vm.submit()">{{\'login.submit\' | translate}}</button></div></div></form></div></main></div>');
$templateCache.put('app/pages/homePage/homePage.html','<h2>e-MOSS Plus \u30B5\u30FC\u30D3\u30B9\u3078\u3088\u3046\u3053\u305D</h2><h4 style="padding-top:25px">\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u8AAC\u660E\u66F8\u3084\u30B5\u30DD\u30FC\u30C8\u30BB\u30F3\u30BF\u30FC\u3078\u306E\u9023\u7D61\u5148\u3001\u304A\u3088\u3073\u5404\u7A2E\u30DE\u30CB\u30E5\u30A2\u30EB\u985E\u306F\u3001<a href="https://www.conlux.co.jp/me-10/support/" target="_blank" class="bold-text">\u3053\u3061\u3089\u306E\u30DA\u30FC\u30B8</a>\u3088\u308A\u3054\u89A7\u3044\u305F\u3060\u3051\u307E\u3059\u3002</h4><session></session>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/permissionDenied/404.html','<div class="row"><div class="col-md-12"><div class="alert bg-danger"><strong><b class="error-msg">{{\'common.components.404.msg.part1\' | translate}} <a href="/#/main/dashboard">{{\'home.page.home\' | translate}}</a> {{\'common.components.404.msg.part2\' | translate}}</b></strong></div></div></div>');
$templateCache.put('app/pages/permissionDenied/500.html','<div class="row"><div class="col-md-12"><div class="alert bg-danger"><strong><b class="error-msg">{{\'common.components.500.msg.part1\' | translate}} <a href="/#/main/dashboard">{{\'home.page.home\' | translate}}</a> {{\'common.components.500.msg.part2\' | translate}}</b></strong></div></div></div>');
$templateCache.put('app/pages/permissionDenied/permissionDenied.html','<div class="row"><div class="col-md-12"><div class="alert bg-danger"><strong>{{\'common.components.permission.denied.msg\' | translate}}</strong></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="progress-info">Your profile is 70% Complete</div><div class="progress"><div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%"></div></div><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">First Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Last Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Department</label><div class="col-sm-9"><select class="form-control" selectpicker=""><option>Web Development</option><option>System Development</option><option>Sales</option><option>Human Resources</option></select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Occupation</label><div class="col-sm-9"><input type="text" class="form-control" id="inputOccupation" placeholder="" value="Front End Web Developer"></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" value="12345678"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder=""></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/application/views/info.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Application for e-M Plus" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Application Info" form="vm.applicationInfoForm"><form name="vm.applicationInfoForm" novalidate=""><h5 class="bold-text m-b-20 wizard-form-title">Applicant Information</h5><div class="row"><div class="col-md-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.applicationInfoForm.companyName.$invalid && (vm.applicationInfoForm.companyName.$dirty || vm.applicationInfoForm.$submitted)}"><label for="companyName">Company name</label> <input type="text" class="form-control" id="companyName" name="companyName" ng-model="vm.personalInfo.companyName" required=""> <span class="help-block error-block basic-block">Required</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.address.$invalid && (vm.applicationInfoForm.address.$dirty || vm.applicationInfoForm.$submitted)}"><label for="address">Address</label> <textarea class="form-control" name="address" ng-model="vm.personalInfo.address" id="address" required=""></textarea> <span class="help-block error-block basic-block">Required</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.phone.$invalid && (vm.applicationInfoForm.phone.$dirty || vm.applicationInfoForm.$submitted)}"><label for="phone">Phone</label> <input type="phone" class="form-control" id="phone" name="phone" ng-model="vm.personalInfo.phone" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.companyCode.$invalid && (vm.applicationInfoForm.companyCode.$dirty || vm.applicationInfoForm.$submitted)}"><label for="companyCode">Company Code</label> <input type="text" class="form-control" id="companyCode" name="companyCode" ng-model="vm.personalInfo.companyCode" required=""> <span class="help-block error-block basic-block">Required</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.businessType.$invalid && (vm.applicationInfoForm.businessType.$dirty || vm.applicationInfoForm.$submitted)}"><label for="businessType">Business type</label> <input type="businessType" class="form-control" id="businessType" name="businessType" ng-model="vm.personalInfo.businessType" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.productHandled.$invalid && (vm.applicationInfoForm.productHandled.$dirty || vm.applicationInfoForm.$submitted)}"><label for="productHandled">Products handled</label> <input type="text" class="form-control" id="productHandled" name="productHandled" ng-model="vm.personalInfo.productHandled" required=""> <span class="help-block error-block basic-block">Required</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.departmentSignature.$invalid && (vm.applicationInfoForm.departmentSignature.$dirty || vm.applicationInfoForm.$submitted)}"><label for="departmentSignature">Department signature</label> <input type="departmentSignature" class="form-control" id="departmentSignature" name="departmentSignature" ng-model="vm.personalInfo.departmentSignature" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.inchargeName.$invalid && (vm.applicationInfoForm.inchargeName.$dirty || vm.applicationInfoForm.$submitted)}"><label for="inchargeName">Incharge Name</label> <input type="text" class="form-control" id="inchargeName" name="inchargeName" ng-model="vm.personalInfo.inchargeName" required=""> <span class="help-block error-block basic-block">Required</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.inchargePhone.$invalid && (vm.applicationInfoForm.inchargePhone.$dirty || vm.applicationInfoForm.$submitted)}"><label for="inchargePhone">Incharge phone</label> <input type="inchargePhone" class="form-control" id="inchargePhone" name="inchargePhone" ng-model="vm.personalInfo.inchargePhone" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.mailAddress.$invalid && (vm.applicationInfoForm.mailAddress.$dirty || vm.applicationInfoForm.$submitted)}"><label for="mailAddress">Mail address</label> <input type="text" class="form-control" id="mailAddress" name="mailAddress" ng-model="vm.personalInfo.mailAddress" required=""> <span class="help-block error-block basic-block">Required</span></div></div></div><h5 class="bold-text m-t-30 m-b-20 wizard-form-title">Representative\'s Information</h5><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.fullName.$invalid && (vm.applicationInfoForm.fullName.$dirty || vm.applicationInfoForm.$submitted)}"><label for="fullName">Full name</label> <input type="text" class="form-control" id="fullName" name="fullName" ng-model="vm.personalInfo.fullName" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.dob.$invalid && (vm.applicationInfoForm.dob.$dirty || vm.applicationInfoForm.$submitted)}"><label for="dob">Date of Birth</label> <input type="text" class="form-control" id="dob" name="dob" ng-model="vm.personalInfo.dob" required=""> <span class="help-block error-block basic-block">Required</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.applicationInfoForm.homeAddress.$invalid && (vm.applicationInfoForm.homeAddress.$dirty || vm.applicationInfoForm.$submitted)}"><label for="homeAddress">Representative\'s home address</label> <textarea class="form-control" name="homeAddress" ng-model="vm.personalInfo.homeAddress" id="homeAddress" required=""></textarea> <span class="help-block error-block basic-block">Required</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.pincode.$invalid && (vm.applicationInfoForm.pincode.$dirty || vm.applicationInfoForm.$submitted)}"><label for="pincode">Pincode</label> <input type="text" class="form-control" id="pincode" name="pincode" ng-model="vm.personalInfo.pincode" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.representativePhone.$invalid && (vm.applicationInfoForm.representativePhone.$dirty || vm.applicationInfoForm.$submitted)}"><label for="representativePhone">Representative\'s phone no.</label> <input type="text" class="form-control" id="representativePhone" name="representativePhone" ng-model="vm.personalInfo.representativePhone" required=""> <span class="help-block error-block basic-block">Required</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Service Details" form="vm.serviceDetailsForm"><form name="vm.serviceDetailsForm" novalidate=""><h5 class="bold-text m-b-20 wizard-form-title">Service Conditions</h5><h5 class="m-b-20">Payment handling fee</h5><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label for="companyName">Payment handling fee per E-money</label><ui-select ng-model="vm.paymentEMoney.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.EMoneyTypes"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div><div class="col-md-6"><div class="form-group has-feedback"><label for="companyName">Payment handling fee per QR money</label><ui-select ng-model="vm.paymentQRMoney.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.QRMoneyTypes"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div></div><h5 class="m-b-10 m-t-30">Monthly Service Fee</h5><h5 class="m-b-20">1. Buit-in modem type</h5><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label for="companyName">Initial charges</label><ui-select ng-model="vm.chargesBuiltinInitial.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.chargesBuiltinInitialTypes"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div><div class="col-md-6"><div class="form-group has-feedback"><label for="companyName">Monthly charges</label><ui-select ng-model="vm.chargesBuiltinMonthly.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.chargesBuiltinMonthlyTypes"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div></div><h5 class="m-b-20 m-t-20">2. External modem type</h5><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label for="companyName">Initial charges</label><ui-select ng-model="vm.chargesExternalInitial.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.chargesExternalInitialTypes"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div><div class="col-md-6"><div class="form-group has-feedback"><label for="companyName">Monthly charges</label><ui-select ng-model="vm.chargesExternalMonthly.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.chargesExternalMonthlyTypes"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div></div><h5 class="m-b-10 m-t-30">Other charges</h5><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.applicationInfoForm.remarks.$invalid && (vm.applicationInfoForm.remarks.$dirty || vm.applicationInfoForm.$submitted)}"><label for="remarks">Remarks</label> <textarea class="form-control" name="remarks" ng-model="vm.personalInfo.remarks" id="remarks"></textarea></div></div></div></form></ba-wizard-step><ba-wizard-step title="Settlement Conditions" form="vm.settlementForm"><form name="vm.settlementForm" novalidate=""><h5 class="bold-text m-b-20 wizard-form-title">Settlement method</h5><div class="form-group has-feedback" ng-class="{\'has-error\': vm.settlementForm.paymentDate.$invalid && (vm.settlementForm.paymentDate.$dirty || vm.settlementForm.$submitted)}"><label>Payment date</label><div><span class="m-r-20"><label class="radio-inline custom-radio nowrap"><input type="radio" name="paymentDate" value="option1"> <span>Month-end</span></label></span> <span><label class="radio-inline custom-radio nowrap"><input type="radio" name="paymentDate" value="option2"> <span>20th</span></label></span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.settlementForm.closingDate.$invalid && (vm.settlementForm.closingDate.$dirty || vm.settlementForm.$submitted)}"><label>Closing date</label><div><span class="m-r-20"><label class="radio-inline custom-radio nowrap"><input type="radio" name="closingDate" value="option1"> <span>Calender day (month end 23:59:59 closing)</span></label></span> <span><label class="radio-inline custom-radio nowrap"><input type="radio" name="closingDate" value="option2"> <span>Between 2 closings at the terminal</span></label></span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.settlementForm.paymentMethod.$invalid && (vm.settlementForm.paymentMethod.$dirty || vm.settlementForm.$submitted)}"><label>Payment method of Expenses (B), (C)</label><div><span class="m-r-20"><label class="radio-inline custom-radio nowrap"><input type="radio" name="paymentMethod" value="option1"> <span>Offsetting with e-money sales amount \u2192 4, Settlement Information</span></label></span> <span><label class="radio-inline custom-radio nowrap"><input type="radio" name="paymentMethod" value="option2"> <span>Without offsetting with e-money sales amount \u2192 4, Settlement Information</span></label></span></div></div></form></ba-wizard-step><ba-wizard-step title="Settlement Info"></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/components/address/address.html','<div ng-if="!vm.isEdit"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{ "common.components.address.title" | translate }}</label><div ng-if="vm.address">{{vm.address.pin}} &nbsp; {{vm.address.prefecture}} &nbsp; {{vm.address.city}}<br><span class="kanaAddress word-break">{{vm.address.streetAddressSimple}}</span><br><span class="word-break">{{vm.address.streetAddress}}</span></div></div></div></div><div ng-if="vm.isEdit"><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.addressForm[\'addressPin_\'+vm.formKey].$invalid && vm.addressForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{ "common.components.address.zip" | translate }} <span ng-if="vm.required">{{\'common.components.required\' | translate }}</span> <span ng-if="!vm.required"></span></label> <input type="text" numbers-only="" typeahead-on-select="vm.onZipSelected($item)" ng-model="vm.address.pin" name="addressPin_{{vm.formKey}}" uib-typeahead="pincode.pin as pincode.pin for pincode in vm.onPinCodeChange($viewValue)" class="form-control" ng-required="vm.required" mask="999-9999" mask-validate="false" ng-pattern="/^\\d{3}-\\d{4}$/"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row noWrap"><label>{{\'common.components.address.prefecture\' | translate }}</label> <input type="text" class="form-control" name="prefecture" ng-model="vm.address.prefecture" disabled=""></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row noWrap"><label>{{\'common.components.address.city.town\' | translate }}</label> <input type="text" class="form-control" name="city" ng-model="vm.address.city" disabled=""></div></div></div></div><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.addressForm[\'streetAddressKana_\'+vm.formKey].$invalid || vm.addressForm[\'streetAddress_\'+vm.formKey].$invalid) && vm.addressForm.$submitted}"><div class="form-input-group-row labelXXL"><label ng-if="!vm.streetAddressRequired">{{\'common.components.address.street\' | translate }}</label> <label ng-if="vm.streetAddressRequired">{{\'common.components.address.street\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" ng-model="vm.address.streetAddressSimple" special-character-limit="" placeholder="{{\'common.components.address.street.kana\' | translate }}" maxlength="250" ng-required="vm.streetAddressRequired" name="streetAddressKana_{{vm.formKey}}"> <input type="text" class="form-control" ng-model="vm.address.streetAddress" maxlength="250" special-character-limit="" placeholder="{{\'common.components.address.street\' | translate }}" ng-required="vm.streetAddressRequired" name="streetAddress_{{vm.formKey}}"></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div>');
$templateCache.put('app/pages/components/confirm/confirm.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close" ng-if="!confirmVm.showCancelButton"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{confirmVm.title}}</h4></div><div class="modal-body"><p ng-bind-html="confirmVm.message"></p></div><div class="modal-footer"><button class="btn btn-primary" ng-click="confirmVm.cancel()" ng-if="confirmVm.showCancelButton">{{confirmVm.cancelbtnText}}</button> <button type="button" class="btn btn-primary" ng-click="confirmVm.ok()">{{confirmVm.btnText}}</button></div></div>');
$templateCache.put('app/pages/components/contact/contact.html','<div class="contactWrapper" ng-if="!vm.isEdit" ng-repeat="contact in vm.contact track by $index"><div class="labelWrap"><label>{{\'common.components.contact.title\' | translate }}</label></div><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row noWrap"><div>{{vm.contact[$index].phone}}</div></div></div></div><div class="col-md-6"><div ng-if="vm.displayEmail" class="form-group"><div class="form-detail-row noWrap"><label>{{\'common.components.contact.email\' | translate }}</label><div>{{vm.contact[$index].email}}</div></div></div></div></div></div><div class="contactWrapper addContainer" ng-if="vm.isEdit" ng-repeat="contact in vm.contact track by $index"><div class="labelWrap"><div class="addNewPlaceholder" ng-if="vm.isMultiple"><div ng-if="vm.contact.length !== 1" ng-click="vm.removeRow($index)" class="btn btn-default contactAddNew"><i class="ion-trash-a"></i></div><div ng-if="$last" ng-click="vm.addNewRow()" class="btn btn-default contactAddNew addBtn"><i class="ion-plus-round"></i></div></div><label>{{ "common.components.contact.title" | translate }} <span ng-if="vm.required">{{\'common.components.required\' | translate }}</span> <span ng-if="!vm.required"></span></label></div><div class="row" ng-init="vm.contact[$index].contactEntity=vm.contactEntity;vm.contact[$index].contactHours=vm.contactHours.key[0];vm.contact[$index].contactType=vm.contactType.key[0]"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (vm.contactForm[\'contactNumber_\'+vm.formKey+\'_\'+$index].$invalid || vm.contactForm[\'contactNumber_\'+vm.formKey+\'_\'+$index].$error.pattern) && vm.contactForm.$submitted}"><div class="form-input-group-row noWrap"><input type="text" class="form-control" mobile-number="" name="contactNumber_{{vm.formKey}}_{{$index}}" placeholder="{{\'common.components.contact.phone\' | translate}}" ng-model="vm.contact[$index].phone" ng-required="vm.required" numbers-only="" ng-pattern="/(?=^\\d{1,}-?\\d{1,}-?\\d{1,}$).{11,13}/" maxlength="13"></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.phone_error_msg\' | translate}}</span></div></div><div class="col-md-6"><div ng-if="vm.displayEmail" class="form-group" ng-class="{\'has-error\': vm.contactForm[\'contactEmail_\'+vm.formKey+\'_\'+$index].$invalid && vm.contactForm.$submitted}"><div class="form-input-group-row noWrap"><label>{{ "service.contract.create.contact.email" | translate }} <span ng-if="vm.emailRequired">{{\'common.components.required\' | translate }}</span> <span ng-if="!vm.emailRequired"></span></label> <input type="text" class="form-control" valid-email="" name="contactEmail_{{vm.formKey}}_{{$index}}" ng-model="vm.contact[$index].email" ng-required="vm.emailRequired"></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.email_error_msg\' | translate}}</span></div></div></div></div>');
$templateCache.put('app/pages/components/datepicker/datepicker.html','<div class="datePickerWrap" ng-class="{\'has-error\': vm.baUtil.isUndefinedOrNull(date) && vm.dateFrom.$submitted}"><div class="input-group m-b-0"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" datepicker-options="vm.options" ng-model="date" is-open="vm.opened" ng-required="vm.required" placeholder="{{vm.options.placeholder || \'yyyy\u5E74mm\u6708dd\u65E5\'}}" close-text="Close" show-button-bar="false"> <span ng-click="vm.open()" class="clickOverlay"></span> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div>');
$templateCache.put('app/pages/components/device-fields/device-fields.html','<div ng-if="vm.readOnly" class="readOnly"><div class="form-group" ng-if="vm.type === \'date\'">{{model | date}}</div><div class="form-group" ng-if="vm.type !== \'date\'">{{model}}</div></div><div ng-if="!vm.readOnly"><div class="form-group" ng-if="vm.type === \'date\'"><datepicker date="model"></datepicker></div><div class="form-group" ng-if="vm.type === \'dropdown\'"><ui-select ng-model="model" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.dropdownOptions track by $index"><span>{{item}}</span></ui-select-choices></ui-select></div><div class="form-group" ng-if="vm.type === \'text\'"><input type="text" class="form-control" name="applicantCompanyCode" ng-model="model"></div><div class="form-group" ng-if="vm.type === \'checkbox\'"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="model"> <span></span></label></div></div>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/msg/msg-modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{msgVm.title}}</h4></div><div class="modal-body"><p ng-bind-html="msgVm.message"></p></div></div>');
$templateCache.put('app/pages/components/pagination/pagination.html','<div ng-if="totalElements!=0 && getLang() == \'jp\'" class="paginationRow"><div class="totalCount"><span ng-if="totalPages > 0">{{pageItemsJp}}</span></div><div class="selectPageSize"><ui-select ng-model="pageable.pageSize" ng-change="updateQuery(pageable.pageSize, \'SIZE\')" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="size in pageSizeList"><span>{{size}}</span></ui-select-choices></ui-select></div><div class="selectPage"><button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(pageable.pageSize, \'FIRST\');" ng-disabled="pageable.pageNumber == 0"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(pageable.pageSize, \'PREV\');" ng-disabled="pageable.pageNumber == 0"><i class="fa fa-angle-left"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(pageable.pageSize, \'NEXT\');" ng-disabled="displayData.pageNumber == totalPages"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon pull-left m-l-5 m-r-40" ng-click="updateQuery(pageable.pageSize, \'LAST\');" ng-disabled="displayData.pageNumber == totalPages"><i class="fa fa-angle-double-right"></i></button> <span class="m-l-20 m-r-10">\u30DA\u30FC\u30B8: {{totalPages}} &nbsp;\u306E</span><div class="form-group m-l-10"><input type="text" class="form-control" name="pageNumber" numbers-only="" ng-model="displayData.pageNumber" ng-keyup="$event.keyCode == 13 && updateQuery(pageable.pageSize, \'PAGE\', displayData.pageNumber)"></div></div></div><div ng-if="totalElements!=0 && getLang() == \'en\'" class="paginationRow"><div class="totalCount"><span ng-if="totalPages > 0">{{pageItemsEn}}</span></div><div class="selectPageSize"><ui-select ng-model="pageable.pageSize" ng-change="updateQuery(pageable.pageSize, \'SIZE\')" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="size in pageSizeList"><span>{{size}}</span></ui-select-choices></ui-select></div><div class="selectPage"><button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(pageable.pageSize, \'FIRST\');" ng-disabled="pageable.pageNumber == 0"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(pageable.pageSize, \'PREV\');" ng-disabled="pageable.pageNumber == 0"><i class="fa fa-angle-left"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(pageable.pageSize, \'NEXT\');" ng-disabled="displayData.pageNumber == totalPages"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(pageable.pageSize, \'LAST\');" ng-disabled="displayData.pageNumber == totalPages"><i class="fa fa-angle-double-right"></i></button> <span class="m-l-20 m-r-10">Go to page:</span><div class="form-group"><input type="text" class="form-control" name="pageNumber" numbers-only="" ng-model="displayData.pageNumber" ng-keyup="$event.keyCode == 13 && updateQuery(pageable.pageSize, \'PAGE\', displayData.pageNumber)"></div><span class="m-l-10">of<span class="m-l-10">{{totalPages}}</span></span></div></div><div ng-if="totalElements==0" class="alignCenter paddingTop20">{{ "common.components.random.no.results.found" | translate }}</div>');
$templateCache.put('app/pages/components/pagination-v2/pagination.html','<div ng-if="totalElements!==0 && getLang() == \'jp\'" class="paginationRow"><div class="totalCount"><span ng-if="totalPages > 0">{{pageItemsJp}}</span></div><div class="selectPageSize"><ui-select ng-model="currentPageSize" ng-change="updateQuery(currentPageSize, \'SIZE\')" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="size in pageSizeList"><span>{{size}}</span></ui-select-choices></ui-select></div><div class="selectPage"><button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(currentPageSize, \'FIRST\');" ng-disabled="currentPage == 0"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(currentPageSize, \'PREV\');" ng-disabled="currentPage == 0"><i class="fa fa-angle-left"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(currentPageSize, \'NEXT\');" ng-disabled="displayData.pageNumber == totalPages"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon pull-left m-l-5 m-r-40" ng-click="updateQuery(currentPageSize, \'LAST\');" ng-disabled="displayData.pageNumber == totalPages"><i class="fa fa-angle-double-right"></i></button> <span class="m-l-20 m-r-10">\u30DA\u30FC\u30B8: {{totalPages}} &nbsp;\u306E</span><div class="form-group m-l-10"><input type="text" class="form-control" name="pageNumber" numbers-only="" ng-model="displayData.pageNumber" ng-keyup="$event.keyCode == 13 && updateQuery(currentPageSize, \'PAGE\', displayData.pageNumber)"></div></div></div><div ng-if="totalElements!=0 && getLang() == \'en\'" class="paginationRow"><div class="totalCount"><span ng-if="totalPages > 0">{{pageItemsEn}}</span></div><div class="selectPageSize"><ui-select ng-model="currentPageSize" ng-change="updateQuery(currentPageSize, \'SIZE\')" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="size in pageSizeList"><span>{{size}}</span></ui-select-choices></ui-select></div><div class="selectPage"><button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(currentPageSize, \'FIRST\');" ng-disabled="currentPage == 0"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(currentPageSize, \'PREV\');" ng-disabled="currentPage == 0"><i class="fa fa-angle-left"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(currentPageSize, \'NEXT\');" ng-disabled="displayData.pageNumber == totalPages"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon pull-left m-l-5" ng-click="updateQuery(currentPageSize, \'LAST\');" ng-disabled="displayData.pageNumber == totalPages"><i class="fa fa-angle-double-right"></i></button> <span class="m-l-20 m-r-10">Go to page:</span><div class="form-group"><input type="text" class="form-control" name="pageNumber" numbers-only="" ng-model="displayData.pageNumber" ng-keyup="$event.keyCode == 13 && updateQuery(currentPageSize, \'PAGE\', displayData.pageNumber)"></div><span class="m-l-10">of<span class="m-l-10">{{totalPages}}</span></span></div></div><div ng-if="totalElements==0" class="alignCenter paddingTop20">{{ "common.components.random.no.results.found" | translate }}</div>');
$templateCache.put('app/pages/components/service-fee/serviceFee.html','<div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{vm.title | translate }}<br>{{vm.subTitle | translate }}</div><div class="panel-body serviceFee" ng-if="!vm.isEdit"><div ng-if="vm.deviceType != \'ME_5_1\'"><div class="sectionLabel">{{\'common.components.service.fee.e.money\' | translate }}</div><div class="row"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label>{{\'service.contract.create.serviceDetails.0.emoney\' | translate }}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelL"><div>{{vm.getLabel(vm.baseFeeModel.paymentDeductionOption, vm.paymentDeductionOption)}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row"><div>{{(vm.baseFeeModel.rateOrAmount | number)}}</div><span ng-if="vm.baseFeeModel.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.baseFeeModel.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div></div><div class="row" ng-repeat="option in vm.model.eMoney track by $index"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label>{{option.rangeStart}} ~ {{option.rangeEnd}}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelL"><div>{{vm.getLabel(option.paymentDeductionOption, vm.paymentDeductionOption)}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row"><div>{{(option.rateOrAmount | number)}}</div><span ng-if="option.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="option.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label>PiTaPa*</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelL"><div>{{vm.getLabel(vm.otherFeeModel.paymentDeductionOption, vm.paymentDeductionOption)}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row"><div>{{(vm.otherFeeModel.rateOrAmount | number)}}</div><span ng-if="vm.otherFeeModel.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.otherFeeModel.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div></div></div><div ng-if="vm.deviceType == \'ME_5_1\'" class="row m-t-20 m-b-10"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label ng-if="vm.serviceFeeFrequency === \'INITIAL\'">{{\'service.contract.create.serviceDetails.emoney.registrationFee\' | translate }}</label> <label ng-if="vm.serviceFeeFrequency === \'MONTHLY\'">{{\'service.contract.create.serviceDetails.emoney.systemUsageFee\' | translate }}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelL"><div>{{vm.getLabel(vm.baseFeeModel.paymentDeductionOption, vm.paymentDeductionOption)}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row"><div>{{(vm.baseFeeModel.rateOrAmount | number)}}</div><span ng-if="vm.baseFeeModel.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.baseFeeModel.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div></div><hr ng-if="vm.deviceType != \'ME_5_1\'"><div class="sectionLabel">{{\'common.components.service.fee.qr.money\' | translate }}</div><div class="row" ng-repeat="option in vm.model.qrMoney track by $index"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label>{{option.rangeStart}} ~ {{option.rangeEnd}}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelL"><div>{{vm.getLabel(option.paymentDeductionOption, vm.paymentDeductionOption)}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row"><div>{{(option.rateOrAmount | number)}}</div><span ng-if="option.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="option.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label>{{\'service.contract.create.serviceDetails.in.office.pay\' | translate }}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelL"><div>{{vm.getLabel(vm.qrOtherFeeModel.paymentDeductionOption, vm.paymentDeductionOption)}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row"><div>{{(vm.qrOtherFeeModel.rateOrAmount | number)}}</div><span ng-if="vm.qrOtherFeeModel.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.qrOtherFeeModel.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div></div><div ng-if="!(vm.deviceType == \'ME_10_1\' || vm.deviceType == \'ME_10_2\' || vm.deviceType == \'ME_5_1\')"><hr><div class="sectionLabel">{{\'common.components.service.fee.credit.money\' | translate }}</div><div class="row"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label>\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9{{\'common.components.required\' | translate }}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelL"><div>{{vm.getLabel(vm.creditCardFeeModel.paymentDeductionOption, vm.paymentDeductionOption)}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row"><div>{{(vm.creditCardFeeModel.rateOrAmount | number)}}</div><span ng-if="vm.creditCardFeeModel.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.creditCardFeeModel.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div></div></div></div><div ng-if="vm.isEdit" class="panel-body serviceFee"><div ng-if="vm.deviceType != \'ME_5_1\'"><div class="sectionLabel">{{\'common.components.service.fee.e.money\' | translate }}{{\'common.components.required\' | translate }}</div><div class="row"><div class="col-md-3"><div class="form-group"><div class="form-input-group-row noWrap"><label>{{\'service.contract.create.serviceDetails.0.emoney\' | translate }}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-input-group-row noWrap"><label>{{vm.getLabel("FLAT", vm.paymentDeductionOption)}}</label></div></div></div><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'baseFeeModel_rateOrAmount_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" ng-model="vm.baseFeeModel.rateOrAmount" required="" name="baseFeeModel_rateOrAmount_{{vm.formKey}}_{{$index}}" service-fee-number-validation=""> <span class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row" ng-repeat="option in vm.model.eMoney track by $index"><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'e_money_rangeEnd_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row noWrap"><label>{{option.rangeStart}} ~</label><ui-select ng-model="option.rangeEnd" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" on-select="vm.appendRow($item, vm.eMoneyOptionKey, vm.model.eMoney, $index, \'eMoney\')" name="e_money_rangeEnd_{{vm.formKey}}_{{$index}}" required=""><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.eMoneyOptionKey | filter: vm.greaterThan(option.rangeStart)"><span>{{item}}</span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-5"><div class="form-group" ng-if="vm.serviceFeeEdit" ng-init="option.serviceFeeFrequency=vm.serviceFeeFrequency;option.paymentType=\'E_MONEY\';option.deviceTypes=vm.deviceType;option.modemType=vm.modemType;"><div class="form-input-group-row labelL"><ui-select ng-model="option.paymentDeductionOption" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getLabel($select.selected, vm.paymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.paymentDeductionOption.key track by $index"><span ng-bind-html="vm.paymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-if="!vm.serviceFeeEdit" ng-init="option.serviceFeeFrequency=vm.serviceFeeFrequency;option.paymentType=\'E_MONEY\';option.deviceTypes=vm.deviceType;option.modemType=vm.modemType;option.paymentDeductionOption=vm.paymentDeductionOption.key[0];"><div class="form-input-group-row labelL"><ui-select ng-model="option.paymentDeductionOption" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getLabel($select.selected, vm.paymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.paymentDeductionOption.key track by $index"><span ng-bind-html="vm.paymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'e_money_rateOrAmount_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" ng-model="option.rateOrAmount" required="" name="e_money_rateOrAmount_{{vm.formKey}}_{{$index}}" service-fee-number-validation=""> <span ng-if="option.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="option.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><div class="form-input-group-row noWrap"><label>PiTaPa*</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-input-group-row noWrap"><label>{{vm.getLabel("FLAT", vm.paymentDeductionOption)}}</label></div></div></div><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'otherFee_rateOrAmount_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" ng-model="vm.otherFeeModel.rateOrAmount" required="" name="otherFee_rateOrAmount_{{vm.formKey}}_{{$index}}" service-fee-number-validation=""> <span class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div></div><div ng-if="vm.deviceType == \'ME_5_1\'" class="row m-t-20 m-b-10"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label ng-if="vm.serviceFeeFrequency === \'INITIAL\'">{{\'service.contract.create.serviceDetails.emoney.registrationFee\' | translate }}</label> <label ng-if="vm.serviceFeeFrequency === \'MONTHLY\'">{{\'service.contract.create.serviceDetails.emoney.systemUsageFee\' | translate }}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-input-group-row noWrap"><label>{{vm.getLabel("FLAT", vm.paymentDeductionOption)}}</label></div></div></div><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'baseFeeModel_rateOrAmount_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" ng-model="vm.baseFeeModel.rateOrAmount" required="" name="baseFeeModel_rateOrAmount_{{vm.formKey}}_{{$index}}" service-fee-number-validation=""> <span class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><hr ng-if="vm.deviceType != \'ME_5_1\'"><div class="sectionLabel">{{\'common.components.service.fee.qr.money\' | translate }}{{\'common.components.required\' | translate }}</div><div class="row" ng-repeat="option in vm.model.qrMoney track by $index"><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'qr_money_rangeEnd_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row noWrap"><label>{{option.rangeStart}} ~</label><ui-select ng-model="option.rangeEnd" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" on-select="vm.appendRow($item, vm.qrMoneyOptionKey, vm.model.qrMoney, $index, \'qrMoney\')" required="" name="qr_money_rangeEnd_{{vm.formKey}}_{{$index}}"><ui-select-match><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="item in vm.qrMoneyOptionKey | filter: vm.greaterThan(option.rangeStart)"><span>{{item}}</span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-5"><div class="form-group" ng-if="vm.serviceFeeEdit" ng-init="option.serviceFeeFrequency=vm.serviceFeeFrequency;option.paymentType=\'QR_MONEY\';option.deviceTypes=vm.deviceType;option.modemType=vm.modemType;"><div class="form-input-group-row labelL"><ui-select ng-model="option.paymentDeductionOption" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getLabel($select.selected, vm.paymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.paymentDeductionOption.key track by $index"><span ng-bind-html="vm.paymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-if="!vm.serviceFeeEdit" ng-init="option.serviceFeeFrequency=vm.serviceFeeFrequency;option.paymentType=\'QR_MONEY\';option.deviceTypes=vm.deviceType;option.modemType=vm.modemType;option.paymentDeductionOption=vm.paymentDeductionOption.key[0];"><div class="form-input-group-row labelL"><ui-select ng-model="option.paymentDeductionOption" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getLabel($select.selected, vm.paymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.paymentDeductionOption.key track by $index"><span ng-bind-html="vm.paymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'qr_money_rateOrAmount_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" ng-model="option.rateOrAmount" name="qr_money_rateOrAmount_{{vm.formKey}}_{{$index}}" required="" service-fee-number-validation=""> <span ng-if="option.paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="option.paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><div class="form-input-group-row noWrap"><label>{{\'service.contract.create.serviceDetails.in.office.pay\' | translate }}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-input-group-row noWrap"><label>{{vm.getLabel("FLAT", vm.paymentDeductionOption)}}</label></div></div></div><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'qr_money_rateOrAmount_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" ng-model="vm.qrOtherFeeModel.rateOrAmount" required="" name="qr_money_rateOrAmount_{{vm.formKey}}_{{$index}}" service-fee-number-validation=""> <span class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div ng-if="!(vm.deviceType == \'ME_10_1\' || vm.deviceType == \'ME_10_2\')"><hr ng-if="vm.deviceType != \'ME_5_1\'"><div ng-if="vm.deviceType != \'ME_5_1\'"><div class="sectionLabel">{{\'common.components.service.fee.credit.money\' | translate }}{{\'common.components.required\' | translate }}</div><div class="row"><div class="col-md-3"><div class="form-group"><div class="form-detail-row noWrap"><label>\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9{{\'common.components.required\' | translate }}</label></div></div></div><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelL"><div>{{vm.getLabel(vm.creditCardFeeModel.paymentDeductionOption, vm.paymentDeductionOption)}}</div></div></div></div><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.serviceFeeForm[\'creditCardFee_rateOrAmount_\'+vm.formKey+\'_\'+$index].$invalid && vm.serviceFeeForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" ng-model="vm.creditCardFeeModel.rateOrAmount" required="" name="creditCardFee_rateOrAmount_{{vm.formKey}}_{{$index}}" service-fee-number-validation=""> <span class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/components/session/expire.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-android-danger modal-icon"></i><span>You\'ve Timed Out!</span></div><div class="modal-body text-center">You were idle too long. Normally you\'d be logged out, but in this demo just do anything and you\'ll be reset.</div></div>');
$templateCache.put('app/pages/components/session/start.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>{{\'session.timeout.caution\' | translate}}</span></div><div class="modal-body" idle-countdown="countdown" ng-init="countdown=899">{{\'session.timeout.message.pre\' | translate}} <span style="width:24px">{{countdown | getMinutes}}</span> {{\'session.timeout.message.post\' | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">{{\'session.timeout.renew\' | translate}}</button></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/contract/devicePurchase/list-filter.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30D5\u30A3\u30EB\u30BF</h4></div><div class="modal-body"><div><form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-md-3 control-label">\u6240\u6709\u8005</label><div class="col-md-9"><input type="text" class="form-control" name="CustomerName" placeholder="\u6240\u6709\u8005"></div></div><div class="form-group"><label for="inputEmail3" class="col-md-3 control-label">\u6A5F\u7A2E</label><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Model X</span></label></div><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Model Xl</span></label></div></div><div class="form-group"><label for="inputEmail3" class="col-md-3 control-label">\u5951\u7D04\u671F\u9593</label><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.contractEndDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.contractEndDate.dt" is-open="vm.datePickerData.contractEndDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="Start" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'contractEndDate\', vm.datePickerData.contractEndDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.contractEndDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.contractEndDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.contractEndDate.dt" is-open="vm.datePickerData.contractEndDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="End" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'contractEndDate\', vm.datePickerData.contractEndDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.contractEndDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><label for="inputEmail3" class="col-md-3 control-label">\u4FDD\u8A3C\u671F\u9593</label><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.contractEndDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.contractEndDate.dt" is-open="vm.datePickerData.contractEndDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="Start" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'contractEndDate\', vm.datePickerData.contractEndDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.contractEndDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.contractEndDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.contractEndDate.dt" is-open="vm.datePickerData.contractEndDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="End" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'contractEndDate\', vm.datePickerData.contractEndDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.contractEndDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></form></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">\u9069\u7528</button></div></div>');
$templateCache.put('app/pages/contract/devicePurchase/list.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Search" ba-panel-class="with-scroll"><form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" name="search" ng-model="vm.search.query" placeholder="\u6240\u6709\u8005\u3001\u6A5F\u7A2E\u3092\u691C\u7D22\u3059\u308B"></div><button type="button" ng-click="vm.searchDp()" class="btn btn-default btn-icon"><i class="ion-search"></i></button> <button data-toggle="modal" ng-click="vm.openFilterModal(\'app/pages/contract/devicePurchase/list-filter.html\', \'md\')" type="button" class="btn btn-default btn-icon"><i class="fa fa-filter"></i></button></form></div><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table"><tr><th>\u62C5\u5F53\u8005\u540D</th><th>\u6240\u6709\u8005</th><th>\u6A5F\u7A2E</th><th>\u53F0\u6570</th><th>\u5951\u7D04\u958B\u59CB</th><th>\u5951\u7D04\u7D42\u4E86</th><th>\u5951\u7D04\u958B\u59CB</th><th>\u5951\u7D04\u7D42\u4E86</th><th></th></tr><tr ng-repeat="dp in vm.dpListResponse.content"><td style="text-align: left;"><span tooltip-append-to-body="true" uib-tooltip="{{dp.ownerAccountDto.email}}">{{dp.ownerAccountDto.name}} <span></span></span></td><td style="text-align: left;">{{dp.customerCompanyName}}</td><td>{{dp.deviceModel | capitalize}}</td><td>{{dp.numberOfDevices}}</td><td>{{dp.contractStartDate | date : \'yyyy/MM/dd\'}}</td><td>{{dp.contractEndDate | date : \'yyyy/MM/dd\'}}</td><td>{{dp.warrantyStartDate | date: \'yyyy/MM/dd\'}}</td><td>{{dp.warrantyEndDate | date : \'yyyy/MM/dd\'}}</td><td><a href="" class="learn-more" ng-click="vm.openDetail($event, dp)">\u95B2\u89A7</a> | <a href="" class="learn-more" ng-click="vm.openDetail($event, dp)">\u4FEE\u6B63</a></td></tr></table></div></div></div></div></div>');
$templateCache.put('app/pages/contract/devicePurchase/new.html','<div ba-panel="" ba-panel-title="\u60C5\u5831\u5165\u529B" ba-panel-class="with-scroll"><form class="form-horizontal" name="vm.dpForm"><div class="form-group"><label for="forNewUser" class="col-sm-2 control-label">\u65B0\u6240\u6709\u8005</label><div class="col-sm-9"><ba-switcher name="forNewUser" switcher-style="primary" switcher-value="vm.forNewUser"></ba-switcher></div></div><div class="form-group" ng-if="vm.forNewUser"><label for="forNewUser" class="col-sm-2 control-label">\u62C5\u5F53\u8005\u540D</label><div class="col-sm-9"><input ng-model="vm.dpFormData.personInChargeName" type="text" class="form-control" name="personInChargeName" placeholder="\u62C5\u5F53\u8005\u540D"></div></div><div class="form-group" ng-if="!vm.forNewUser"><label for="forNewUser" class="col-sm-2 control-label">\u62C5\u5F53\u8005\u540D</label><div class="col-sm-9"><input type="text" typeahead-on-select="vm.personInCharge.onPersonInChargeSelected($item)" ng-model="vm.personInCharge.selectedValue" placeholder="\u62C5\u5F53\u8005\u540D" uib-typeahead="account.name as account.name for account in vm.personInCharge.search($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control"> <i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i><div ng-show="noResults"><i class="glyphicon glyphicon-remove"></i> No Results Found</div></div></div><div class="form-group"><label for="personInChargeEmail" class="col-sm-2 control-label">\u62C5\u5F53\u8005\u30E1\u30FC\u30EB</label><div class="col-sm-9"><input ng-model="vm.dpFormData.personInChargeEmail" type="email" class="form-control" name="personInChargeEmail" ng-disabled="!vm.forNewUser" placeholder="\u62C5\u5F53\u8005\u30E1\u30FC\u30EB"></div></div><div class="form-group"><label for="customerCompanyName" class="col-sm-2 control-label">\u6240\u6709\u8005</label><div class="col-sm-9"><input ng-model="vm.dpFormData.customerCompanyName" type="text" class="form-control" name="customerCompanyName" placeholder="\u6240\u6709\u8005" required=""> <span class="help-block error-block basic-block">* Required</span></div></div><div class="form-group"><label for="phone" class="col-sm-2 control-label">\u96FB\u8A71\u756A\u53F7</label><div class="col-sm-9"><div class="input-group" style="margin-bottom:0px!important"><span class="input-group-addon addon-left input-group-addon-info">+81</span> <input ng-model="vm.dpFormData.phone" type="text" class="form-control with-info-addon" name="phone" placeholder="\u96FB\u8A71\u756A\u53F7" required=""></div><span class="help-block error-block basic-block">* Invalid Pattern</span></div></div><div class="form-group"><label for="addressPin" class="col-sm-2 control-label">\u3012</label><div class="col-sm-9"><input ng-model="vm.dpFormData.address.addressPin" type="number" class="form-control" name="addressPin" placeholder="\u3012"></div></div><div class="form-group"><label for="addressLine1" class="col-sm-2 control-label">\u4F4F\u6240</label><div class="col-sm-9"><input ng-model="vm.dpFormData.address.addressLine1" type="text" class="form-control" name="addressLine1" placeholder="\u4F4F\u6240"></div></div><div class="form-group"><label for="deviceModel" class="col-sm-2 control-label">\u6A5F\u7A2E</label><div class="col-sm-9"><ui-select name="deviceModel" ng-model="vm.selectedDevice" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="\u6A5F\u7A2E"><span>{{$select.selected.label | capitalize}}</span></ui-select-match><ui-select-choices repeat="device in vm.devices | filter: $select.search"><span>{{device.label | capitalize}}</span></ui-select-choices></ui-select></div></div><div class="form-group"><label for="numberOfDevices" class="col-sm-2 control-label">\u53F0\u6570</label><div class="col-sm-9"><input ng-model="vm.dpFormData.numberOfDevices" type="number" class="form-control" name="numberOfDevices" placeholder="\u53F0\u6570"></div></div><div class="form-group"><label for="contractStartDate" class="col-sm-2 control-label">\u5951\u7D04\u958B\u59CB\u65E5</label><div class="col-sm-9"><p class="input-group" style="margin-bottom:0px!important"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.contractStartDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.contractStartDate.dt" is-open="vm.datePickerData.contractStartDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="\u5951\u7D04\u958B\u59CB\u65E5" name="contractStartDate" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'contractStartDate\', vm.datePickerData.contractStartDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.contractStartDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="help-block error-block basic-block">* Invalid Date</span></div></div><div class="form-group"><label for="contractEndDate" class="col-sm-2 control-label">\u5951\u7D04\u7D42\u4E86\u65E5</label><div class="col-sm-9"><p class="input-group" style="margin-bottom:0px!important"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.contractEndDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.contractEndDate.dt" is-open="vm.datePickerData.contractEndDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" name="contractEndDate" placeholder="\u5951\u7D04\u7D42\u4E86\u65E5" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'contractEndDate\', vm.datePickerData.contractEndDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.contractEndDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="help-block error-block basic-block">* Invalid Date</span></div></div><div class="form-group"><label for="warrantyStartDate" class="col-sm-2 control-label">\u5951\u7D04\u958B\u59CB\u65E5</label><div class="col-sm-9"><p class="input-group" style="margin-bottom:0px!important"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.warrantyStartDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.warrantyStartDate.dt" is-open="vm.datePickerData.warrantyStartDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="\u5951\u7D04\u958B\u59CB\u65E5" name="warrantyStartDate" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'warrantyStartDate\', vm.datePickerData.warrantyStartDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.warrantyStartDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="help-block error-block basic-block">* Invalid Date</span></div></div><div class="form-group"><label for="warrantyEndDate" class="col-sm-2 control-label">\u5951\u7D04\u7D42\u4E86\u65E5</label><div class="col-sm-9"><p class="input-group" style="margin-bottom:0px!important"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.warrantyEndDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.warrantyEndDate.dt" is-open="vm.datePickerData.warrantyEndDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" name="warrantyEndDate" placeholder="\u5951\u7D04\u7D42\u4E86\u65E5" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'warrantyEndDate\', vm.datePickerData.warrantyEndDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.warrantyEndDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="help-block error-block basic-block">* Invalid Date</span></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="button" class="btn btn-primary" ng-click="vm.submitDpForm(vm.dpForm)">\u767B\u9332</button></div></div></form></div>');
$templateCache.put('app/pages/contract/devicePurchase/new.old.html','<div ba-panel="" ba-panel-title="New Device Purchase" ba-panel-class="with-scroll"><form name="vm.dpForm"><div class="row"><div class="col-sm-1"><div class="form-group"><label for="forNewUser">New User</label><ba-switcher name="forNewUser" switcher-style="primary" switcher-value="vm.forNewUser"></ba-switcher></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group" ng-if="vm.forNewUser"><input ng-model="vm.dpFormData.personInChargeName" type="text" class="form-control" name="personInChargeName" placeholder="Person in-charge"></div><div class="form-group" ng-if="!vm.forNewUser"><input type="text" typeahead-on-select="vm.personInCharge.onPersonInChargeSelected($item)" ng-model="vm.personInCharge.selectedValue" placeholder="Search" uib-typeahead="account.name as account.name for account in vm.personInCharge.search($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control"> <i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i><div ng-show="noResults"><i class="glyphicon glyphicon-remove"></i> No Results Found</div></div></div><div class="col-sm-6"><div class="form-group"><input ng-model="vm.dpFormData.personInChargeEmail" type="email" class="form-control" name="personInChargeEmail" ng-disabled="!vm.forNewUser" placeholder="Person in-charge email"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><input ng-model="vm.dpFormData.customerCompanyName" type="text" class="form-control" name="customerCompanyName" placeholder="Customer company name" required=""> <span class="help-block error-block basic-block">* Required</span></div></div><div class="col-sm-6"><div><div class="input-group" style="margin-bottom:0px!important"><span class="input-group-addon addon-left input-group-addon-info">+81</span> <input ng-model="vm.dpFormData.phone" type="text" ng-pattern="/^\\d{10}$/" class="form-control with-info-addon" name="phone" placeholder="Phone" required=""></div><span class="help-block error-block basic-block">* Invalid Pattern</span></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><input ng-model="vm.dpFormData.address.addressPin" type="number" class="form-control" name="addressPin" placeholder="Address Pincode"></div></div><div class="col-sm-6"><div class="form-group"><input ng-model="vm.dpFormData.address.addressLine1" type="text" class="form-control" name="addressLine1" placeholder="Address Detail"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><ui-select ng-model="vm.selectedDevice" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Device Model"><span>{{$select.selected.label | capitalize}}</span></ui-select-match><ui-select-choices repeat="device in vm.devices | filter: $select.search"><span>{{device.label | capitalize}}</span></ui-select-choices></ui-select></div></div><div class="col-sm-6"><div class="form-group"><input ng-model="vm.dpFormData.numberOfDevices" type="number" class="form-control" name="numberOfDevices" placeholder="Device Count"></div></div></div><div class="row datepicker"><div class="col-sm-6"><div><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.contractStartDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.contractStartDate.dt" is-open="vm.datePickerData.contractStartDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="Contract Start Date" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'contractStartDate\', vm.datePickerData.contractStartDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.contractStartDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="help-block error-block basic-block">* Invalid Date</span></div></div><div class="col-sm-6"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.contractEndDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.contractEndDate.dt" is-open="vm.datePickerData.contractEndDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="Contract End Date" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'contractEndDate\', vm.datePickerData.contractEndDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.contractEndDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="row datepicker"><div class="col-sm-6"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.warrantyStartDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.warrantyStartDate.dt" is-open="vm.datePickerData.warrantyStartDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="Warranty Start Date" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'warrantyStartDate\', vm.datePickerData.warrantyStartDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.warrantyStartDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-6"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePickerData.warrantyEndDate.format}}" datepicker-options="options" ng-model="vm.datePickerData.warrantyEndDate.dt" is-open="vm.datePickerData.warrantyEndDate.opened" popup-placement="top-right" ng-required="true" close-text="Close" placeholder="Warranty End Date" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.dateChange(\'warrantyEndDate\', vm.datePickerData.warrantyEndDate.dt)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerData.warrantyEndDate.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><button type="button" class="btn btn-primary" ng-click="vm.submitDpForm(vm.dpForm)">Submit</button></form></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/device-linkage/views/device-linkage.html','<div class="panel panel-default bootstrap-panel p-2"><div class="row"><div class="col-md-12 p-2" ng-if="vm.alerts.length !== 0"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div><div form="vm.deviceLinkageForm" class="row" style="width:100%;margin:0 4px 0 0; display: flex; align-items: center;"><form name="vm.deviceLinkageForm" style="display: flex; width: 100%;" novalidate=""><div class="form-group" ng-class="{\'has-error\': vm.deviceLinkageForm.deviceOwnerId.$invalid && vm.deviceLinkageForm.$submitted}" style="flex: 1;"><div class="form-input-group-row labelXL" style="display: flex; align-items: center;"><label>{{\'salesSettlements.monthly.list.search.deviceOwner\' | translate}}</label><div style="width:60%;"><ui-select ng-model="vm.selectedOption" name="deviceOwnerId" ng-disabled="vm.isDeviceOwner" class="btn-group bootstrap-select form-control"><ui-select-match><span>{{$select.selected.deviceOwnerName}}({{$select.selected.deviceOwnerId}})</span></ui-select-match><ui-select-choices repeat="item in vm.deviceOwnerIds track by $index"><span ng-bind-html="(item.deviceOwnerName) + \' (\' + (item.deviceOwnerId) + \')\'"></span></ui-select-choices></ui-select></div><div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><button type="reset" class="btn btn-primary pull-left m-l-10 m-r-10" ng-click="vm.showData()" ng-disabled="vm.inProgress || vm.showMessage">{{\'salesSettlements.monthly.list.search.showData\' | translate }} <i class="inProgress m-l-10" ng-if="vm.inProgress"></i></button></div></div><div class="form-group" style="flex: 1;" ng-class="{\'has-error\': vm.deviceLinkageForm.serviceContractIds.$invalid && vm.deviceLinkageForm.$submitted}"><div class="form-input-group-row" style="display: flex; align-items: center;"><label>{{\'salesSettlements.monthly.list.search.organization\' | translate}}</label><div style="width:60%;" id="divToHide"><ui-select ng-model="vm.selectedMerchant" name="serviceContractIds" ng-disabled="vm.isMerchantAdmin || !vm.enableSelectMerchant" class="btn-group bootstrap-select form-control"><ui-select-match><span>{{$select.selected.merchantName}}({{$select.selected.merchantCode}})</span></ui-select-match><ui-select-choices repeat="item in vm.serviceContractIds track by $index"><span ng-bind-html="(item.merchantName) + \' (\' + (item.merchantCode) + \')\'"></span></ui-select-choices></ui-select></div><div class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</div></div></div><div ng-if="vm.showTable"><button class="btn btn-primary pull-right m-l-5" ng-click="vm.cancelCreate()">{{ "device.request.edit.btn.cancel" | translate }}</button> <button class="btn btn-primary pull-right m-l-5" type="submit" ng-click="vm.saveData()" ng-disabled="vm.createInProgress">{{ "device.request.change.btn.save" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button></div></form></div></div><div class="panel panel-default bootstrap-panel" style="height:20%;"><div ng-if="vm.showMessage" class="alignCenter m-l-15 m-t-15">{{ "common.components.random.no.results.found" | translate }}</div><div class="handsOnTableWrapper"><div id="handsontable-device-linkage"></div></div></div>');
$templateCache.put('app/pages/device-linkage/views/edit-device-application-change.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="handsOnTableWrapper"><div id="handsontable-edit-change-multiple-request"></div></div><div class="clearfix bottomAction" ng-if="vm.systemAdmin"><button class="btn btn-primary pull-right m-l-10" ng-click="vm.cancelCreate()">{{ "device.request.edit.btn.cancel" | translate }}</button> <button class="btn btn-primary pull-right m-l-10" ng-click="vm.reserve()" ng-disabled="(vm.isReserveBtnDisbaled || vm.createInProgress)">{{ "device.request.change.btn.reserve" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button> <button class="btn btn-primary pull-right m-l-10" ng-click="vm.save()" ng-disabled="(vm.isReserveBtnDisbaled || vm.saveInProgress)">{{ "device.request.change.btn.save" | translate }} <i class="inProgress m-l-10" ng-if="vm.saveInProgress"></i></button> <button class="btn btn-primary pull-right" ng-click="vm.download()" ng-disabled="vm.downloadInProgress">{{ "device.request.change.btn.download" | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInProgress"></i></button><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right m-r-10" ng-click="vm.cancelApplication()" ng-disabled="(vm.isReserveBtnDisbaled || vm.cancelApplicationInProgress)">{{ "device.request.change.btn.cancelApplication" | translate }} <i class="inProgress m-l-10" ng-if="vm.cancelApplicationInProgress"></i></button></div><div class="clearfix bottomAction" ng-if="(!vm.systemAdmin)"><button class="btn btn-primary pull-right m-l-10" ng-click="vm.cancelCreate()">{{ "device.request.edit.btn.cancel" | translate }}</button></div><div class="clearfix bottomAction" ng-if="(vm.merchantLogin)"><button class="btn btn-primary pull-right m-l-10" ng-click="vm.cancelCreate()">{{ "device.request.edit.btn.cancel" | translate }}</button> <button class="btn btn-primary pull-right" ng-click="vm.download()" ng-disabled="vm.downloadInProgress">{{ "device.request.change.btn.download" | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInProgress"></i></button></div></div>');
$templateCache.put('app/pages/device-linkage/views/inventory-device-management.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i"><div class="panel-body p-10-i"><form class="row form-inline"><div class="form-group col-xs-12"><button class="btn btn-primary m-t-5 m-l-5 w-btn-md-1 btn-raised btn-xs" ng-disabled="(vm.isBulkDeviceRequestEditDisabled() || vm.isBulkEditInProgress)" ng-click="vm.onBulkEdit()">{{ "device.request.list.edit.device.changes" | translate }} &nbsp;<i class="ion-compose" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isBulkEditInProgress"></i></button></div></form></div></div><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><form><div class="row" style="margin-left: -10px"><div class="col-sm-12" style="padding-right: 15.5px"><div class="form-group row select-dropdown"><div class="form-group-col col-filter"><select ng-show="vm.isSystemUser" class="form-control selectpicker with-search show-tick" title="\u30D1\u30FC\u30C8\u30CA\u30FC" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.PARTNER_ID" ng-options="item as item.label for item in vm.filterOptions.options.partner track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select class="form-control selectpicker show-tick" title="\u5951\u7D04\u5148ID\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.SERVICE_CONTRACT_ID" ng-options="item as item.label for item in vm.filterOptions.options.serviceContractId track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select ng-show="vm.isDeviceOwner || vm.isSystemUser || vm.isPartner" class="form-control selectpicker with-search show-tick minMaxSelect" title="\u52A0\u76DF\u5E97\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.MERCHANT_ID" ng-options="item as item.label for item in vm.filterOptions.options.merchant track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select ng-show="!(vm.isSystemUser || vm.isPartner || vm.isMerchantOrMerchantAndDeviceOwner)" class="form-control selectpicker with-search show-tick" title="\u8ACB\u6C42\u5148\u652F\u5E97\u540D\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.INVOICE_DESTINATION_BRANCH_ID" ng-options="item as item.label for item in vm.filterOptions.options.settlementBranch track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter m-l-3"><select ng-show="vm.isMerchantOrMerchantAndDeviceOwner || vm.isSystemUser || vm.isPartner" class="form-control selectpicker with-search show-tick minMaxSelect" title="\u7AEF\u672B\u6240\u6709\u8005\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.DEVICE_OWNER_ID" ng-options="item as item.label for item in vm.filterOptions.options.deviceOwner track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select class="form-control selectpicker with-search show-tick" title="\u72B6\u6CC1\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.STATUS" ng-options="item as item.label for item in vm.filterOptions.options.status track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter" style="width: 9%;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.search.DEVICE_APPLICATION_NUMBER" placeholder="{{\'device.request.list.device.application.number\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter" style="width: 9%;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.search.DEVICE_SERIAL" placeholder="{{\'device.management.device.serial\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter" style="width: 9%;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.search.RECEIPT_NUMBER" placeholder="{{\'device.request.change.receipt.number\' | translate }}" maxlength="200"></span></div><div class="m-r-15 text-right"><button style="width:60px;text-align: center;" class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.show.data\' | translate}} <span ng-if="vm.dataFetchInProgress" class="inProgress-custom"></span></span></button></div></div></div></div><div class="row m-t-5" style="margin-left:-10px; margin-right:-10px"><div class="col-sm-12" style="padding-right: 15.5px"><div class="form-group row"><div class="form-group-col col-filter"><input type="text" class="form-control" ng-model="vm.filters.search.installationLocation" placeholder="{{\'salesSettlements.monthly.list.search.installationLocation\' | translate }}" maxlength="200"></div><div class="form-group-col col-filter"><input type="text" class="form-control" ng-model="vm.filters.search.remarks" placeholder="{{\'salesSettlements.monthly.list.search.remarksOrVmNumber\' | translate }}" maxlength="200"></div><div class="form-group-col col-filter"><label class="label-filter same-line-label">{{\'device.request.list.reservation.date.time\' | translate}}</label><div class="form-group daterange-select select-dropdown" style="width: 45%;float: right;"><select class="form-control selectpicker show-tick op-dropdown" data-actions-box="false" data-live-search="false" data-size="10" ng-change="vm.changeFirstDateRange()" ng-model="vm.opFirstSelect" ng-options="item as item.label for item in vm.filterOptions.options.DateOptions" selectpicker="" title="\u9078\u629E"></select></div></div><div class="form-group-col no-cal-icon m-l-3 col-filter"><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.reservationDateFrom" ng-model="vm.filters.reservationDateFrom"></datepicker></div></div><span class="daterange-span" style="text-align: center;float: left;margin-top: 7px;margin-left: -5px;width: 0px;">~</span><div class="form-group-col no-cal-icon col-filter"><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.reservationDateTo" ng-model="vm.filters.reservationDateTo"></datepicker></div></div><div class="m-r-10 text-right"><button style="width:60px;text-align: center;" class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.clear\' | translate}} <span ng-if="vm.dataFetchInProgressUsingClear" class="inProgress-custom"></span></span></button></div></div></div><div class="row" style="margin-left: 2px;"><div class="col-sm-10 m-t-5"><div class="form-group row"></div></div></div></div></form></div></div><div class="panel with-scroll table-panel m-b-10-i" ng-if="!vm.isLoading"><div class="panel-body p-10-i"><div class="table-responsive m-t-0-i"><table class="table table-bordered"><thead><tr><th><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.select" ng-click="vm.selectAll($event, vm.requests.content)"> <span></span></label></th><th>{{ "device.request.change.receipt.number" | translate }}</th><th>{{ "device.request.change.serial.number" | translate }}</th><th>{{ "device.request.change.service.contractId" | translate }}</th><th>{{ "device.request.change.device.merchant" | translate }}</th><th>{{ "device.request.change.device.owner" | translate }}</th><th>{{ "device.request.change.device.application.number" | translate }}</th><th>{{ "device.request.change.device.serial" | translate }}</th><th>{{ "device.request.change.installation.store.name" | translate }}</th><th>{{ "device.request.change.reservation.date.time" | translate }}</th><th>{{ "device.request.change.status" | translate }}</th></tr></thead><tbody><tr ng-repeat="di in vm.requests.content track by $index"><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedRequests[di.id]"> <span></span></label></td><td>{{di.receiptNumber}}</td><td>{{di.serialNumber}}</td><td class="word-break">{{di.serviceContractId}}</td><td class="word-break">{{ di.companyName }}</td><td><div class="applicationNumber-cell word-break">{{di.deviceOwnerName}}</div></td><td class="deviceSerial-cell word-break">{{di.applicationNumber}}</td><td class="deviceSerial-cell word-break">{{di.deviceSerial}}</td><td>{{di.storeName}}</td><td>{{di.reservationDateTime | date: \'yyyy/MM/dd HH:mm:ss\'}}</td><td>{{vm.getStatus(di.reservationStatus)}}</td></tr></tbody></table></div><div class="m-t-20"><pagination query="vm.query" pageable="vm.requests.pageable" total-pages="vm.requests.totalPages" total-elements="vm.requests.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/device-management/views/list-deviceManagement.html','<div form="vm.listDeviceForm"><form name="vm.listDeviceForm" novalidate=""><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><div class="row" ng-if="vm.isSystemUser"><div class="col-md-4"><div style="width:30%;margin:0 10px 0 0; float:left;"><select class="form-control selectpicker show-tick minMaxSelect" title="\u30D1\u30FC\u30C8\u30CA\u30FC" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="100%" multiple="" refreshflag="vm.refreshflag" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.partnerNames" ng-options="item as item.label for item in vm.options.Partners track by item.value" ng-change="vm.changeFilter()" selectpicker=""></select></div><div class="form-group select-dropdown"><select class="form-control selectpicker with-search show-tick" title="\u54C1\u540D" data-live-search="true" data-actions-box="true" data-width="17%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="6" ng-model="vm.filters.productNames" ng-options="item as item.label for item in vm.options.ProductNames track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select><select class="form-control selectpicker show-tick minMaxSelect" title="\u52A0\u76DF\u5E97" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="20%" multiple="" refreshflag="vm.refreshflag" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.merchantNames" ng-options="item as item.label for item in vm.options.Merchants track by item.value" ng-change="vm.changeFilter()" selectpicker=""></select><select class="form-control selectpicker show-tick minMaxSelect" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="20%" multiple="" refreshflag="vm.refreshflag" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.deviceOwnerNames" ng-options="item as item.label for item in vm.options.DeviceOwners track by item.value" ng-change="vm.changeFilter()" title="\u6240\u6709\u8005" selectpicker=""></select></div></div><div class="col-md-4"><div style="width:30%;margin:0 10px 0 0; float:left;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.DEVICE_SERIAL" placeholder="{{\'device.management.device.serial\' | translate }}" maxlength="200"></span></div><div class="form-group select-dropdown"><select class="form-control selectpicker with-search show-tick f-left" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="25%" multiple="" refreshflag="vm.refreshflag" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.merchantCodeBranchNamePairs" ng-options="item as item.label for item in vm.options.Branches track by item.value" ng-change="vm.changeFilter()" title="\u652F\u5E97\u30FB\u55B6\u696D\u6240" selectpicker=""></select><select class="form-control selectpicker with-search show-tick" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="15%" multiple="" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.runningStatuses" ng-options="item as item.label for item in vm.options.Status track by item.value" selectpicker="" title="\u72B6\u6CC1"></select><select class="form-control selectpicker with-search show-tick" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="19%" multiple="" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.signalStrengths" ng-options="item as item for item in vm.options.Signal" selectpicker="" title="\u96FB\u6CE2"></select></div></div><div class="col-md-4"><div class="form-group select-dropdown"><select class="form-control selectpicker with-search show-tick" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="22%" multiple="" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.moneyTypes" ng-options="item as item.label for item in vm.options.MoneyTypes" selectpicker="" title="\u30DE\u30CD\u30FC\u7A2E"></select><select class="form-control selectpicker show-tick op-dropdown replacement" data-actions-box="false" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="false" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="20%" multiple="" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.isReplaced" ng-options="item as item.label for item in vm.options.Replacement" selectpicker="" title="\u305D\u306E\u4ED6"></select><div class="pull-right"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)" type="submit"><span>{{\'device.request.list.btn.show.data\' | translate}} <span ng-if="vm.dataFetchInProgress" class="inProgress-custom"></span></span></button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.clear\' | translate}} <span ng-if="vm.dataFetchInProgressUsingClear" class="inProgress-custom"></span></span></button> <button class="btn btn-primary m-r-5" ng-click="vm.downloadCsv()" ng-disabled="vm.csvInProgress"><span>CSV <i aria-hidden="true" class="fa fa-download"></i> <span ng-if="vm.csvInProgress" class="inProgress-custom"></span></span></button></div></div></div></div><div class="row" ng-if="!vm.isSystemUser"><div class="col-md-4"><div class="form-group select-dropdown"><select class="form-control selectpicker show-tick minMaxSelect" title="\u52A0\u76DF\u5E97" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="30%" multiple="" refreshflag="vm.refreshflag" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.merchantNames" ng-options="item as item.label for item in vm.options.Merchants track by item.value" ng-change="vm.changeFilter()" selectpicker=""></select><select class="form-control selectpicker show-tick minMaxSelect" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="30%" multiple="" refreshflag="vm.refreshflag" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.deviceOwnerNames" ng-options="item as item.label for item in vm.options.DeviceOwners track by item.value" ng-change="vm.changeFilter()" title="\u6240\u6709\u8005" selectpicker=""></select><select class="form-control selectpicker with-search show-tick" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="32%" multiple="" refreshflag="vm.refreshflag" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.merchantCodeBranchNamePairs" ng-options="item as item.label for item in vm.options.Branches track by item.value" ng-change="vm.changeFilter()" title="\u652F\u5E97\u30FB\u55B6\u696D\u6240" selectpicker=""></select></div></div><div class="col-md-4"><div class="form-group select-dropdown"><div style="width:32%;float:left;margin-right:10px;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.DEVICE_SERIAL" placeholder="{{\'device.management.device.serial\' | translate }}" maxlength="200"></span></div><select class="form-control selectpicker with-search show-tick" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="30%" multiple="" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.runningStatuses" ng-options="item as item.label for item in vm.options.Status track by item.value" selectpicker="" title="\u72B6\u6CC1"></select><select class="form-control selectpicker with-search show-tick" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="30%" multiple="" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.signalStrengths" ng-options="item as item for item in vm.options.Signal" selectpicker="" title="\u96FB\u6CE2"></select></div></div><div class="col-md-4"><div class="form-group select-dropdown"><select class="form-control selectpicker with-search show-tick" data-actions-box="true" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search="true" data-live-search-placeholder="\u8907\u6570\u9078\u629E" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-size="10" data-width="24%" multiple="" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.moneyTypes" ng-options="item as item.label for item in vm.options.MoneyTypes" selectpicker="" title="\u30DE\u30CD\u30FC\u7A2E"></select><select class="form-control selectpicker show-tick op-dropdown replacement" data-actions-box="false" data-live-search="false" data-size="10" data-width="20%" multiple="" selectpickernew="{dropupAuto:false, virtualScroll: true}" ng-model="vm.filters.isReplaced" ng-options="item as item.label for item in vm.options.Replacement" selectpicker="" title="\u305D\u306E\u4ED6"></select><button class="btn btn-primary pull-right m-l-5 m-r-5" ng-click="vm.downloadCsv()" ng-disabled="vm.csvInProgress"><span>CSV <i aria-hidden="true" class="fa fa-download"></i> <span ng-if="vm.csvInProgress" class="inProgress-custom"></span></span></button> <button class="btn btn-danger pull-right m-l-5" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.clear\' | translate}} <span ng-if="vm.dataFetchInProgressUsingClear" class="inProgress-custom"></span></span></button> <button class="btn btn-primary pull-right" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.show.data\' | translate}} <span ng-if="vm.dataFetchInProgress" class="inProgress-custom"></span></span></button></div></div></div><div class="row m-t-20"><div class="col-md-4"><label class="label-filter">{{\'device.management.operation.start.date\' | translate}}</label><div class="btn btn-default clearDates" ng-click="vm.clearDates(1)"><i class="ion-trash-a"></i></div><div class="datePickerFilterWrap"><div class="form-group daterange-select select-dropdown"><select class="form-control selectpicker show-tick op-dropdown" data-actions-box="false" data-live-search="false" data-size="10" ng-change="vm.changeFirstDateRange()" ng-model="vm.opFirstSelect" ng-options="item as item.label for item in vm.options.DateOptions" selectpicker="" title="\u9078\u629E"></select></div><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.installDateFrom" ng-model="vm.filters.installDateFrom"></datepicker></div><span class="daterange-span">~</span><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.installDateTo" ng-model="vm.filters.installDateTo"></datepicker></div></div></div><div class="col-md-4"><label class="label-filter">{{\'device.management.last.communication.date\' | translate}}</label><div class="btn btn-default clearDates" ng-click="vm.clearDates(2)"><i class="ion-trash-a"></i></div><div class="datePickerFilterWrap"><div class="form-group daterange-select select-dropdown"><select class="form-control selectpicker show-tick op-dropdown" data-actions-box="false" data-live-search="false" data-size="10" ng-change="vm.changeSecondDateRange()" ng-model="vm.opSecondSelect" ng-options="item as item.label for item in vm.options.DateOptions" selectpicker="" title="\u9078\u629E"></select></div><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.communicationDateFrom" ng-model="vm.filters.communicationDateFrom"></datepicker></div><span class="daterange-span">~</span><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.communicationDateTo" ng-model="vm.filters.communicationDateTo"></datepicker></div></div></div><div class="col-md-4"><label class="label-filter">{{\'device.management.last.sales.date\' | translate}}</label><div class="btn btn-default clearDates" ng-click="vm.clearDates(3)"><i class="ion-trash-a"></i></div><div class="datePickerFilterWrap"><div class="form-group daterange-select select-dropdown"><select class="form-control selectpicker show-tick op-dropdown" data-actions-box="false" data-live-search="false" data-size="10" ng-change="vm.changeThirdDateRange()" ng-model="vm.opThirdSelect" ng-options="item as item.label for item in vm.options.DateOptions" selectpicker="" title="\u9078\u629E"></select></div><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.salesDateFrom" placeholder="test" ng-model="vm.filters.salesDateFrom"></datepicker></div><span class="daterange-span">~</span><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.salesDateTo" ng-model="vm.filters.salesDateTo"></datepicker></div></div></div></div><div class="row m-t-20"><div class="col-md-4"><label class="label-filter">{{\'device.management.device.delivery.date\' | translate}}</label><div class="btn btn-default clearDates" ng-click="vm.clearDates(4)"><i class="ion-trash-a"></i></div><div class="datePickerFilterWrap"><div class="form-group daterange-select select-dropdown"><select class="form-control selectpicker show-tick op-dropdown" data-actions-box="false" data-live-search="false" data-size="10" ng-change="vm.changeFourthDateRange()" ng-model="vm.opFourthSelect" ng-options="item as item.label for item in vm.options.DateOptions" selectpicker="" title="\u9078\u629E"></select></div><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.deviceDeliveryDateFrom" ng-model="vm.filters.deviceDeliveryDateFrom"></datepicker></div><span class="daterange-span">~</span><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.filters.deviceDeliveryDateTo" ng-model="vm.filters.deviceDeliveryDateTo"></datepicker></div></div></div><div class="col-md-4"><div style="width:60%;margin:27px 10px 0 0; float:left;"><input type="text" class="form-control" ng-model="vm.filters.installationDestinationCode" placeholder="{{\'device.management.installation.code\' | translate }}" maxlength="200"></div><div style="width:32%;margin:27px 10px 0 0; float:left;"><input type="text" class="form-control" ng-model="vm.filters.remarks" placeholder="{{\'device.management.remarks\' | translate }}" maxlength="200"></div></div></div></div></div></form><div class="panel panel-default bootstrap-panel" ng-if="!vm.isLoading"><div class="table-responsive"><table class="table salesTable deviceManagementTable"><thead><tr><th class="serial">#</th><th class="text-center" ng-repeat="key in vm.tableHeaders track by $index"><span ng-if="key[\'column\']===\'startDate\'">{{key[vm.getLang()]}} <a class="m-no-error" title="{{\'device.management.operation.start.date.info\' | translate }}"><i class="fa fa-info-circle"></i></a></span> <span ng-if="key[\'column\']===\'moneyTypes\'">{{key[vm.getLang()]}} <a class="m-no-error" title="{{\'device.management.csv.info\' | translate }}"><i class="fa fa-info-circle"></i></a></span> <span ng-if="key[\'column\']!==\'startDate\' && key[\'column\']!==\'moneyTypes\'">{{key[vm.getLang()]}}</span></th></tr></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.deviceList.content)"><td class="nodata" colspan="{{vm.tableHeaders.length + 1}}">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate}}</td></tr><tr ng-if="!vm.baUtil.isUndefinedOrNullOrEmptyList(vm.deviceList.content)" ng-repeat="data in vm.deviceList.content track by $index"><td class="serial">{{vm.deviceList.pageable.offset + $index + 1}}</td><td ng-repeat="column in vm.columns track by $index"><div ng-compile="vm.getDeviceSerialHtml(data[column])" ng-if="column === \'deviceSerialNumber\' && data[\'isReplacedOrSuspended\']"></div><div ng-bind-html="data[column]" ng-if="column === \'deviceSerialNumber\' && !data[\'isReplacedOrSuspended\']"></div><div ng-bind-html="vm.getDeviceRunningStatusFromKey(data[column])" ng-if="column === \'runningStatus\'"></div><div ng-bind-html="data[column]" ng-if="column !== \'startDate\' && column !== \'deviceSerialNumber\' && column !== \'lastCommunicationTime\' && column !== \'lastSalesTime\' && column !== \'lastModified\' && column !== \'runningStatus\' && column !== \'moneyTypes\' && column !== \'salesCenter\'"></div><div ng-if="column === \'salesCenter\'">{{data[\'branchName\']}} ({{data[\'branchCode\']}})</div><div ng-if="column === \'startDate\'"><div ng-if="data[\'startDate\']>0">{{data[\'startDate\'] | date: \'shortDate\'}} {{data[\'startDate\'] | date: \'mediumTime\'}}</div><div ng-if="data[\'installationTime\']>0">({{data[\'installationTime\'] | date: \'shortDate\'}} {{data[\'installationTime\'] | date: \'mediumTime\'}})</div></div><div ng-bind-html="vm.getMoneyTypesFromKeys(data[column])" ng-if="column === \'moneyTypes\'"></div><div ng-if="(column === \'lastCommunicationTime\' || column === \'lastSalesTime\') && data[column]>0">{{data[column] | date: \'shortDate\'}} {{data[column] | date: \'mediumTime\'}}</div><div ng-if="column === \'lastModified\'">{{data[column] | date: \'shortDate\'}} {{data[column] | date: \'mediumTime\'}}</div></td></tr></tbody></table></div><div class="m-t-20"><pagination query="vm.query" pageable="vm.deviceList.pageable" total-pages="vm.deviceList.totalPages" total-elements="vm.deviceList.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/device-request/views/change-device-request.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i"><div class="panel-body p-10-i"><form class="row form-inline"><div class="form-group col-xs-12"><button ngf-select="vm.uploadForNewJescaRequest($file, $event, bank)" ng-show="vm.writeVisible" ng-if="vm.systemAdmin" ng-disabled="(!vm.permissions.DEVICE_REQUEST.WRITE || vm.isJescaExcelUpload)" class="btn btn-primary m-t-5 w-btn-md btn-raised btn-xs" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "device.request.change.upload.excel" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isJescaExcelUpload"></i></button> <button class="btn btn-primary m-t-5 m-l-5 w-btn-md-1 btn-raised btn-xs" ng-disabled="(vm.isBulkDeviceRequestEditDisabled() || vm.isBulkEditInProgress)" ng-click="vm.onBulkEdit()">{{ "device.request.change.edit.title" | translate }} &nbsp;<i class="ion-compose" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isBulkEditInProgress"></i></button> <button class="btn btn-info m-t-5 m-l-5 w-btn-md-1 btn-raised btn-xs" ng-show="vm.systemAdmin" ng-disabled="((!vm.showBulkEdit()) || vm.isDownloadingDITMSExcel)" ng-click="vm.downloadDRCTMSExcel()">{{ "device.request.list.download.request.tms.excel.btn" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloadingDITMSExcel"></i></button> <button class="btn btn-info m-t-5 m-l-5 w-btn-md-1 btn-raised btn-xs" style="width:262px;" ng-if="vm.systemAdmin" ng-disabled="((!vm.showBulkEdit()) || vm.isDownloadingJescaActivationCsv)" ng-click="vm.jescaActivationCsvDownload()">{{ "device.request.jesca.download.activation.csv" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp;<i class="inProgress m-l-5" ng-if="vm.isDownloadingJescaActivationCsv"></i></button></div></form></div></div><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><form><div class="row" style="margin-left: -10px"><div class="col-sm-12" style="padding-right: 15.5px"><div class="form-group row select-dropdown"><div class="form-group-col col-filter"><select ng-show="vm.isSystemUser" class="form-control selectpicker with-search show-tick" title="\u30D1\u30FC\u30C8\u30CA\u30FC" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.PARTNER_ID" ng-options="item as item.label for item in vm.filterOptions.options.partner track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select class="form-control selectpicker show-tick" title="\u5951\u7D04\u5148ID\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.SERVICE_CONTRACT_ID" ng-options="item as item.label for item in vm.filterOptions.options.serviceContractId track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select ng-show="vm.isDeviceOwner || vm.isSystemUser || vm.isPartner" class="form-control selectpicker with-search show-tick minMaxSelect" title="\u52A0\u76DF\u5E97\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.MERCHANT_ID" ng-options="item as item.label for item in vm.filterOptions.options.merchant track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select ng-show="!(vm.isSystemUser || vm.isPartner || vm.isMerchantOrMerchantAndDeviceOwner)" class="form-control selectpicker with-search show-tick" title="\u8ACB\u6C42\u5148\u652F\u5E97\u540D\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.INVOICE_DESTINATION_BRANCH_ID" ng-options="item as item.label for item in vm.filterOptions.options.settlementBranch track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter m-l-3"><select ng-show="vm.isMerchantOrMerchantAndDeviceOwner || vm.isSystemUser || vm.isPartner" class="form-control selectpicker with-search show-tick minMaxSelect" title="\u7AEF\u672B\u6240\u6709\u8005\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.DEVICE_OWNER_ID" ng-options="item as item.label for item in vm.filterOptions.options.deviceOwner track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select class="form-control selectpicker with-search show-tick" title="\u72B6\u6CC1\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.STATUS" ng-options="item as item.label for item in vm.filterOptions.options.status track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter" style="width: 9%;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.search.DEVICE_APPLICATION_NUMBER" placeholder="{{\'device.request.list.device.application.number\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter" style="width: 9%;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.search.DEVICE_SERIAL" placeholder="{{\'device.management.device.serial\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter" style="width: 9%;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.search.RECEIPT_NUMBER" placeholder="{{\'device.request.change.receipt.number\' | translate }}" maxlength="200"></span></div><div class="m-r-15 text-right"><button style="width:60px;text-align: center;" class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.show.data\' | translate}} <span ng-if="vm.dataFetchInProgress" class="inProgress-custom"></span></span></button></div></div></div></div><div class="row m-t-5" style="margin-left:-10px; margin-right:-10px"><div class="col-sm-12" style="padding-right: 15.5px"><div class="form-group row"><div class="form-group-col col-filter"><input type="text" class="form-control" ng-model="vm.filters.search.installationLocation" placeholder="{{\'salesSettlements.monthly.list.search.installationLocation\' | translate }}" maxlength="200"></div><div class="form-group-col col-filter"><input type="text" class="form-control" ng-model="vm.filters.search.remarks" placeholder="{{\'salesSettlements.monthly.list.search.remarksOrVmNumber\' | translate }}" maxlength="200"></div><div class="form-group-col col-filter"><label class="label-filter same-line-label">{{\'device.request.list.reservation.date.time\' | translate}}</label><div class="form-group daterange-select select-dropdown" style="width: 45%;float: right;"><select class="form-control selectpicker show-tick op-dropdown" data-actions-box="false" data-live-search="false" data-size="10" ng-change="vm.changeFirstDateRange()" ng-model="vm.opFirstSelect" ng-options="item as item.label for item in vm.filterOptions.options.DateOptions" selectpicker="" title="\u9078\u629E"></select></div></div><div class="form-group-col no-cal-icon m-l-3 col-filter"><div class="input-group m-b-0 daterange"><input class="form-control" type="text" datetimepicker="" options="vm.dateOptions" name="vm.filters.reservationDateFrom" ng-model="vm.filters.reservationDateFrom" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div><span class="daterange-span" style="text-align: center;float: left;margin-top: 7px;margin-left: -5px;width: 0px;">~</span><div class="form-group-col no-cal-icon col-filter"><div class="input-group m-b-0 daterange"><input class="form-control" type="text" datetimepicker="" options="vm.dateOptions" name="vm.filters.reservationDateTo" ng-model="vm.filters.reservationDateTo" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div><div class="form-group-col col-filter"><select class="form-control selectpicker op-dropdown show-tick replacement" title="\u305D\u306E\u4ED6" data-live-search="false" data-actions-box="false" data-width="100%" multiple="false" data-size="10" ng-model="vm.filters.DEVICE_REPLACEMENT" ng-options="item as item.label for item in vm.filterOptions.options.Replacement track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><select class="form-control selectpicker with-search show-tick" title="\u9805\u76EE\u540D" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.ITEM_NAME" ng-options="item as item.label for item in vm.filterOptions.options.dr_requestType track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></span></div><div class="m-r-10 text-right"><button style="width:60px;text-align: center;" class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.clear\' | translate}} <span ng-if="vm.dataFetchInProgressUsingClear" class="inProgress-custom"></span></span></button></div></div></div><div class="row" style="margin-left: 2px;"><div class="col-sm-10 m-t-5"><div class="form-group row"></div></div></div></div></form></div></div><div class="panel with-scroll table-panel m-b-10-i" ng-if="!vm.isLoading"><div class="panel-body p-10-i"><div class="table-responsive m-t-0-i"><table class="table table-bordered"><thead><tr><th><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.select" ng-click="vm.selectAll($event, vm.requests.content)"> <span></span></label></th><th>{{ "device.request.change.item.name" | translate }}</th><th>{{ "device.request.change.receipt.number" | translate }}</th><th>{{ "device.request.change.serial.number" | translate }}</th><th>{{ "device.request.change.service.contractId" | translate }}</th><th>{{ "device.request.change.device.merchant" | translate }}</th><th>{{ "device.request.change.device.owner" | translate }}</th><th>{{ "device.request.change.device.application.number" | translate }}</th><th>{{ "device.request.change.device.serial" | translate }}</th><th>{{ "device.request.change.installation.store.name" | translate }}</th><th>{{ "device.request.change.reservation.date.time" | translate }}</th><th>{{ "device.request.change.status" | translate }}</th></tr></thead><tbody><tr ng-repeat="di in vm.requests.content track by $index"><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedRequests[di.deviceInstallationId]"> <span></span></label></td><td style="text-align: left;" class="numbering">{{vm.getDrRequestTypeStatus(di.itemName)}}</td><td>{{di.receiptNumber}}</td><td>{{di.serialNumber}}</td><td class="word-break">{{di.serviceContractId}}</td><td class="word-break">{{ di.companyName }}</td><td><div class="applicationNumber-cell word-break">{{di.deviceOwnerName}}</div></td><td class="deviceSerial-cell word-break">{{di.applicationNumber}}</td><td class="deviceSerial-cell word-break">{{di.deviceSerial}}</td><td>{{di.storeName}}</td><td>{{di.reservationDateTime | date: \'yyyy/MM/dd HH:mm:ss\'}}</td><td>{{vm.getStatus(di.drchangeStatus)}}</td></tr></tbody></table></div><div class="m-t-20"><pagination query="vm.query" pageable="vm.requests.pageable" total-pages="vm.requests.totalPages" total-elements="vm.requests.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/device-request/views/change-multiple-request.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="handsOnTableWrapper"><div id="handsontable-change-multiple-request"></div></div><div class="clearfix bottomAction"><button class="btn btn-primary pull-right m-l-10" ng-click="vm.cancelCreate()">{{ "device.request.edit.btn.cancel" | translate }}</button> <button class="btn btn-primary pull-right m-l-10" ng-click="vm.reserve()" ng-disabled="vm.createInProgress">{{ "device.request.change.btn.reserve" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button> <button class="btn btn-primary pull-right" ng-click="vm.download()" ng-disabled="vm.downloadInProgress">{{ "device.request.change.btn.download" | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInProgress"></i></button><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div></div></div>');
$templateCache.put('app/pages/device-request/views/custom-status-tooltip.html','<div class="text-left"><strong>{{\'device.replacement.device.information.status.title\' | translate }}</strong><div class="text-left">{{\'device.replacement.device.information.status.removed\' | translate }}</div><div class="text-left">{{\'device.replacement.device.information.status.portalDetached\' | translate }}</div><div class="text-left">{{\'device.replacement.device.information.status.removed.settled\' | translate }}</div><div class="text-left">{{\'device.replacement.device.information.status.portalDetached.settled\' | translate }}</div><div ng-if="vm.isNewInput" class="text-left">{{\'device.replacement.device.information.status.or\' | translate }}</div><div ng-if="vm.isNewInput" class="text-left">{{\'device.replacement.device.information.status.fresh\' | translate }}</div></div>');
$templateCache.put('app/pages/device-request/views/device-detail.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="handsOnTableWrapper"><div id="handsontable-device-detail"></div></div><div class="clearfix bottomAction" ng-if="vm.permissions.DEVICE_REQUEST.MGMNT_WRITE && vm.canShowActionBtns"><button class="btn btn-primary pull-right" ng-click="vm.cancelCreate()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.create()">{{ "device.request.detail.btn_update" | translate }} <i class="inProgress m-l-10" ng-if="vm.updateInProgress"></i></button><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div></div></div>');
$templateCache.put('app/pages/device-request/views/device-history-modal.html','<div class="modal-content"><div ng-if="vm.deviceHistory.length && !vm.isLoading"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{\'device.request.history.title\' | translate}} : {{vm.deviceSerial}}</h4></div><div class="modal-body"><div class="panel panel-default bootstrap-panel"><div><table class="table table-bordered"><thead><tr><th class="text-left va-center"><span>#</span></th><th><span>{{\'device.request.history.operation.start.date\' | translate }}</span></th><th><span>{{\'device.request.history.removal.date\' | translate }}</span></th><th><span>{{\'device.request.history.replacement.date\' | translate }}</span></th><th><span>{{\'device.request.history.contract.id\' | translate }}</span></th><th><span>{{\'device.request.history.branchName\' | translate }}</span></th><th><span>{{\'device.request.history.branchCode\' | translate }}</span></th><th><span>{{\'device.request.history.charge.initial.fee\' | translate }}</span></th><th><span>{{\'device.request.history.charge.monthly.fee\' | translate }}</span></th></tr></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.deviceHistory)"><td class="nodata" colspan="9">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate}}</td></tr><tr ng-repeat="data in vm.deviceHistory track by $index"><td>{{$index + 1}}</td><td><span ng-if="data.installationDate">{{data.installationDate | date: \'medium\' }}</span> <span ng-if="!data.installationDate">{{\'device.replacement.device.information.na\' | translate}}</span></td><td><span ng-if="data.removalDate">{{data.removalDate | date: \'medium\' }}</span> <span ng-if="!data.removalDate">{{\'device.replacement.device.information.na\' | translate}}</span></td><td><span ng-if="data.dateTo">{{data.dateTo | date: \'medium\' }}</span> <span ng-if="!data.dateTo">{{\'device.replacement.device.information.na\' | translate}}</span></td><td>{{data.serviceContractId}}</td><td class="break-word">{{data.branchName}}</td><td>{{data.branchCode}}</td><td><span ng-if="data.canChargeInitialFee !== null">{{vm.getValueFromTypeKey(data.canChargeInitialFee, vm.boolOptions)}}</span> <span ng-if="data.canChargeInitialFee === null">{{\'device.replacement.device.information.na\' | translate}}</span></td><td><span ng-if="data.canChargeMonthlyFee !== null">{{vm.getValueFromTypeKey(data.canChargeMonthlyFee, vm.boolOptions)}}</span> <span ng-if="data.canChargeMonthlyFee === null">{{\'device.replacement.device.information.na\' | translate}}</span></td></tr></tbody></table></div></div></div></div><div ng-if="vm.suspensionHistory.length && !vm.isLoading"><div class="modal-header"><button ng-if="!vm.deviceHistory.length" type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{\'device.request.history.suspend.title\' | translate}} : {{vm.deviceSerial}}</h4></div><div class="modal-body"><div class="panel panel-default bootstrap-panel"><div><table class="table table-bordered"><thead><tr><th class="text-left va-center"><span>#</span></th><th><span>{{\'device.request.history.status\' | translate }}</span></th><th><span>{{\'device.request.history.fromDateTime\' | translate }}</span></th><th><span>{{\'device.request.history.toDateTime\' | translate }}</span></th><th><span>{{\'device.request.history.contract.id\' | translate }}</span></th><th><span>{{\'device.request.history.branchName\' | translate }}</span></th><th><span>{{\'device.request.history.branchCode\' | translate }}</span></th><th><span>{{\'device.request.history.charge.initial.fee\' | translate }}</span></th><th><span>{{\'device.request.history.charge.monthly.fee\' | translate }}</span></th></tr></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.suspensionHistory)"><td class="nodata" colspan="9">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate}}</td></tr><tr ng-repeat="data in vm.suspensionHistory track by $index"><td>{{$index + 1}}</td><td><span>{{vm.getValueFromTypeKey(data.nowStatus, vm.types)}}</span></td><td><span ng-if="data.dateFrom">{{data.dateFrom | date: \'medium\' }}</span> <span ng-if="!data.dateFrom">{{\'device.replacement.device.information.na\' | translate}}</span></td><td><span ng-if="data.dateTo">{{data.dateTo | date: \'medium\' }}</span> <span ng-if="!data.dateTo">{{\'device.replacement.device.information.na\' | translate}}</span></td><td>{{data.serviceContractId}}</td><td class="break-word">{{data.branchName}}</td><td>{{data.branchCode}}</td><td><span ng-if="data.canChargeInitialFee !== null">{{vm.getValueFromTypeKey(data.canChargeInitialFee, vm.boolOptions)}}</span> <span ng-if="data.canChargeInitialFee === null"></span></td><td><span ng-if="data.canChargeMonthlyFee !== null">{{vm.getValueFromTypeKey(data.canChargeMonthlyFee, vm.boolOptions)}}</span> <span ng-if="data.canChargeMonthlyFee === null"></span></td></tr></tbody></table></div></div><div>{{\'device.request.history.suspend.note\' | translate}}</div></div></div><div class="modal-footer"><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div></div></div>');
$templateCache.put('app/pages/device-request/views/device-replacement-modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{\'device.replacement.confirm.tobe.device\' | translate}}</h4></div><div class="modal-body"><div class="table-responsive"><form name="vm.deviceReplaceForm" novalidate=""><table class="table table-bordered"><thead><tr><th class="text-left">{{\'device.replacement.device.information.title\' | translate }}</th><th class="text-center">{{\'device.replacement.now.title\' | translate }}</th><th class="text-center">{{\'device.replacement.tobe.title\' | translate }}</th></tr></thead><tbody><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.device.serial\' | translate }}</span></td><td class="text-left va-center col-md-4"><span>{{vm.oldDeviceData.deviceSerial}}</span></td><td class="text-left va-center tobe-device col-md-4"><span>{{vm.newDeviceData.deviceSerial}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.application.number\' | translate }}</span></td><td class="text-left va-center break-word"><span>{{vm.oldDeviceData.applicationNumber}}</span></td><td class="text-left va-center device-replacement break-word"><span>{{vm.oldDeviceData.applicationNumber}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.status\' | translate }}</span></td><td class="text-left device-replacement va-center"><span>{{vm.getValueFromTypeKey(vm.oldDeviceData.status, vm.status)}}</span></td><td class="text-left device-replacement tobe-device va-center"><span>{{vm.getValueFromTypeKey(vm.newDeviceData.status, vm.status)}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.contract.id\' | translate }}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.serviceContractId}}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.serviceContractId}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.merchant\' | translate }}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.merchantName}} ({{vm.oldDeviceData.merchantCode}})</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.merchantName}} ({{vm.oldDeviceData.merchantCode}})</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.device.owner\' | translate }}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.deviceOwnerName}} ({{vm.oldDeviceData.deviceOwnerCode}})</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.deviceOwnerName}} ({{vm.oldDeviceData.deviceOwnerCode}})</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.branch.name\' | translate }}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.branchName}}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.branchName}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.branch.code\' | translate }}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.branchCode}}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.branchCode}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.last.communication.date.star\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData"><span ng-if="vm.oldDeviceData.lastCommunicationTime">{{vm.oldDeviceData.lastCommunicationTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.oldDeviceData.lastCommunicationTime">{{\'device.replacement.device.information.na\' | translate}}</span></span></td><td class="text-left va-center"><span ng-if="vm.newDeviceData"><span ng-if="vm.newDeviceData.lastCommunicationTime">{{vm.newDeviceData.lastCommunicationTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.newDeviceData.lastCommunicationTime">{{\'device.replacement.device.information.na\' | translate}}</span></span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.last.sales.date.star\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData"><span ng-if="vm.oldDeviceData.lastSalesTime">{{vm.oldDeviceData.lastSalesTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.oldDeviceData.lastSalesTime">{{\'device.replacement.device.information.na\' | translate}}</span></span></td><td class="text-left va-center"><span ng-if="vm.newDeviceData"><span ng-if="vm.newDeviceData.lastSalesTime">{{vm.newDeviceData.lastSalesTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.newDeviceData.lastSalesTime">{{\'device.replacement.device.information.na\' | translate}}</span></span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.removal.date\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData.removalDate">{{vm.oldDeviceData.removalDate | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.oldDeviceData.removalDate">{{\'device.replacement.device.information.na\' | translate}}</span></td><td class="text-left va-center"><span ng-if="!vm.isNewDevice"><span ng-if="vm.newDeviceData.removalDate">{{vm.newDeviceData.removalDate | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.newDeviceData.removalDate">{{\'device.replacement.device.information.na\' | translate}}</span></span> <span ng-if="vm.isNewDevice">{{\'device.replacement.device.information.na\' | translate}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.portalDetached.date\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData.operationApplicableTime">{{vm.oldDeviceData.operationApplicableTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.oldDeviceData.operationApplicableTime">{{\'device.replacement.device.information.na\' | translate}}</span></td><td class="text-left va-center"><span ng-if="!vm.isNewDevice"><span ng-if="vm.newDeviceData.operationApplicableTime">{{vm.newDeviceData.operationApplicableTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.newDeviceData.operationApplicableTime">{{\'device.replacement.device.information.na\' | translate}}</span></span> <span ng-if="vm.isNewDevice">{{\'device.replacement.device.information.na\' | translate}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.charge.initial.fee\' | translate }}</span></td><td class="text-center va-center"></td><td class="text-left va-center"><div class="form-group m-t-10" ng-class="{\'has-error\': vm.deviceReplaceForm.canChargeInitialFee.$invalid && vm.deviceReplaceForm.$submitted}"><div class="form-input-group-row labelXXL"><ui-select name="canChargeInitialFee" ng-model="vm.canChargeInitialFee" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.boolOptions)}}</span></ui-select-match><ui-select-choices repeat="item in vm.boolOptions.key track by $index"><span ng-bind-html="vm.boolOptions[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block">{{\'common.components.random.required\' | translate}}</span></div></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.charge.monthly.fee\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData.addMonthlyFee !== null">{{vm.getValueFromTypeKey(vm.oldDeviceData.addMonthlyFee, vm.boolOptions)}}</span> <span ng-if="vm.oldDeviceData.addMonthlyFee === null">{{\'device.replacement.device.information.na\' | translate}}</span></td><td class="text-left va-center"><div class="form-group m-t-10" ng-class="{\'has-error\': vm.deviceReplaceForm.canChargeMonthlyFee.$invalid && vm.deviceReplaceForm.$submitted}"><div class="form-input-group-row labelXXL"><ui-select name="canChargeMonthlyFee" ng-model="vm.canChargeMonthlyFee" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.boolOptions)}}</span></ui-select-match><ui-select-choices repeat="item in vm.boolOptions.key track by $index"><span ng-bind-html="vm.boolOptions[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.replacement.date\' | translate }}</span></td><td></td><td class="text-left va-center"><div class="form-group" ng-class="{\'has-error\': vm.deviceReplaceForm.replacementDate.$invalid && vm.deviceReplaceForm.$submitted}"><div class="input-group m-t-10"><input ng-disabled="vm.isDateGreaterThanNowTime()" class="form-control" type="text" datetimepicker="" options="vm.dateOptions" placeholder="YYYY/MM/DD HH:mm:ss" name="replacementDate" ng-model="vm.replacementDate" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.expected.delivery.date\' | translate }}</span></td><td></td><td class="text-left va-center"><div class="form-group" ng-class="{\'has-error\': vm.deviceReplaceForm.deliveryDate.$invalid && vm.deviceReplaceForm.$submitted}"><div class="input-group m-t-10"><input class="form-control" type="text" datetimepicker="" options="vm.deliveryDateOptions" placeholder="YYYY/MM/DD HH:mm:ss" name="deliveryDate" ng-model="vm.deliveryDate" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></td></tr></tbody></table><div class="m-t-50"><strong>{{ "device.replacement.device.information.notes.title" | translate }}</strong><ol class="m-t-10"><li>{{ "device.replacement.device.information.notes.1" | translate }}</li><li>{{ "device.replacement.device.information.notes.2" | translate }}</li><li>{{ "device.replacement.device.information.notes.3" | translate }}</li><li>{{ "device.replacement.device.information.notes.4" | translate }}</li></ol></div><div class="m-t-50"></div><div class="clearfix action-border"><button class="btn btn-primary pull-right m-t-10 m-r-20" ng-click="vm.applyDeviceReplacement()" ng-disabled="vm.inProgress">{{\'device.replacement.apply\' | translate }} <i class="inProgress m-l-10" ng-if="vm.inProgress"></i></button></div></form></div></div></div>');
$templateCache.put('app/pages/device-request/views/device-replacement.html','<div class="panel panel-default bootstrap-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th class="text-left va-center">{{\'device.replacement.device.information.title\' | translate }}</th><th class="text-center va-center">{{\'device.replacement.now.title\' | translate }}</th><th class="text-center va-center">{{\'device.replacement.tobe.title\' | translate }}</th></tr></thead><form name="vm.deviceReplaceForm" novalidate=""><tbody><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.device.serial\' | translate }}</span></td><td class="va-center"><div class="form-group m-t-10" ng-class="{\'has-error\': vm.deviceReplaceForm.beforeSerialNumber.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><span ng-mouseenter="vm.changeStatus(false)" class="w-100" tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip-template="\'app/pages/device-request/views/custom-status-tooltip.html\'"><input placeholder="{{\'device.replacement.device.information.before.device.serial.placeholder\' | translate }}" type="text" class="form-control" name="serial Number" ng-model="vm.oldDeviceId"></span> <button class="btn btn-primary pull-right" ng-click="vm.getOldDeviceData()">{{\'device.replacement.getData\' | translate }} <i class="inProgress m-l-10" ng-if="vm.inProgress"></i></button></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></td><td class="va-center"><div class="form-group m-t-10" ng-class="{\'has-error\': vm.deviceReplaceForm.beforeSerialNumber.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><span ng-mouseenter="vm.changeStatus(true)" class="w-100" tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip-template="\'app/pages/device-request/views/custom-status-tooltip.html\'"><input placeholder="{{\'device.replacement.device.information.before.device.serial.placeholder\' | translate }}" type="text" class="form-control" name="serial Number" ng-model="vm.newDeviceId"></span> <button class="btn btn-primary pull-right" ng-click="vm.getNewDeviceData()">{{\'device.replacement.getData\' | translate }} <i class="inProgress m-l-10" ng-if="vm.inProgress"></i></button></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.application.number\' | translate }}</span></td><td class="text-left va-center break-word"><span>{{vm.oldDeviceData.applicationNumber}}</span></td><td class="text-left va-center break-word"><span>{{vm.newDeviceData.applicationNumber}}</span></td></tr><tr class="row-height"><td class="text-left va-center row-height"><span class="m-t-10">{{\'device.replacement.device.information.status\' | translate }}</span></td><td class="text-left va-center col-md-5"><span>{{vm.getValueFromTypeKey(vm.oldDeviceData.status, vm.status)}}</span></td><td class="text-left va-center col-md-5"><span ng-if="vm.newDeviceData.status">{{vm.getValueFromTypeKey(vm.newDeviceData.status, vm.status)}}</span> <span ng-if="vm.newDeviceData.deviceSerial && !vm.newDeviceData.status">{{\'device.replacement.fresh.device.msg\' | translate }}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.contract.id\' | translate }}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.serviceContractId}}</span></td><td class="text-left va-center"><span>{{vm.newDeviceData.serviceContractId}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.merchant\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData.merchantName">{{vm.oldDeviceData.merchantName}} ({{vm.oldDeviceData.merchantCode}})</span></td><td class="text-left va-center"><span ng-if="vm.newDeviceData.merchantName">{{vm.newDeviceData.merchantName}} ({{vm.newDeviceData.merchantCode}})</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.device.owner\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData.deviceOwnerCode">{{vm.oldDeviceData.deviceOwnerName}} ({{vm.oldDeviceData.deviceOwnerCode}})</span></td><td class="text-left va-center"><span ng-if="vm.newDeviceData.deviceOwnerCode">{{vm.newDeviceData.deviceOwnerName}} ({{vm.newDeviceData.deviceOwnerCode}})</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.branch.name\' | translate }}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.branchName}}</span></td><td class="text-left va-center"><span>{{vm.newDeviceData.branchName}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.branch.code\' | translate }}</span></td><td class="text-left va-center"><span>{{vm.oldDeviceData.branchCode}}</span></td><td class="text-left va-center"><span>{{vm.newDeviceData.branchCode}}</span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.initial.fee\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData">{{vm.oldDeviceData.initialFee ? vm.oldDeviceData.initialFee: vm.translatedNA}}</span></td><td class="text-left va-center"><span ng-if="vm.newDeviceData"><span ng-if="!vm.isNewDevice">{{vm.newDeviceData.initialFee ? vm.newDeviceData.initialFee : vm.translatedNA}}</span></span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.monthly.fee\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData">{{vm.oldDeviceData.monthlyFee ? vm.oldDeviceData.monthlyFee : vm.translatedNA}}</span></td><td class="text-left va-center"><span ng-if="vm.newDeviceData"><span ng-if="!vm.isNewDevice">{{vm.newDeviceData.monthlyFee || vm.translatedNA}}</span></span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.last.communication.date\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData"><span ng-if="vm.oldDeviceData.lastCommunicationTime">{{vm.oldDeviceData.lastCommunicationTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.oldDeviceData.lastCommunicationTime">{{\'device.replacement.device.information.na\' | translate}}</span></span></td><td class="text-left va-center"><span ng-if="vm.newDeviceData"><span ng-if="vm.newDeviceData.lastCommunicationTime">{{vm.newDeviceData.lastCommunicationTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.newDeviceData.lastCommunicationTime">{{\'device.replacement.device.information.na\' | translate}}</span></span></td></tr><tr class="row-height"><td class="text-left va-center"><span class="m-t-10">{{\'device.replacement.device.information.last.sales.date\' | translate }}</span></td><td class="text-left va-center"><span ng-if="vm.oldDeviceData"><span ng-if="vm.oldDeviceData.lastSalesTime">{{vm.oldDeviceData.lastSalesTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.oldDeviceData.lastSalesTime">{{\'device.replacement.device.information.na\' | translate}}</span></span></td><td class="text-left va-center"><span ng-if="vm.newDeviceData"><span ng-if="vm.newDeviceData.lastSalesTime">{{vm.newDeviceData.lastSalesTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</span> <span ng-if="!vm.newDeviceData.lastSalesTime">{{\'device.replacement.device.information.na\' | translate}}</span></span></td></tr><div class="clearfix bottomAction"><button class="btn btn-primary pull-right m-r-20" ng-click="vm.showConfirmModal()" ng-disabled="!vm.oldDeviceData.deviceSerial || !vm.newDeviceData.deviceSerial || vm.isModalOpen" ng-dblclick="vm.disableButton()">{{\'device.replacement.next\' | translate }} <i class="inProgress m-l-10" ng-if="vmi"></i></button></div></tbody></form></table></div></div>');
$templateCache.put('app/pages/device-request/views/edit-device-request-change.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="handsOnTableWrapper"><div id="handsontable-edit-change-multiple-request"></div></div><div class="clearfix bottomAction" ng-if="vm.systemAdmin"><button class="btn btn-primary pull-right m-l-10" ng-click="vm.cancelCreate()">{{ "device.request.edit.btn.cancel" | translate }}</button> <button class="btn btn-primary pull-right m-l-10" ng-click="vm.reserve()" ng-disabled="(vm.isReserveBtnDisbaled || vm.createInProgress)">{{ "device.request.change.btn.reserve" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button> <button class="btn btn-primary pull-right" ng-click="vm.download()" ng-disabled="vm.downloadInProgress">{{ "device.request.change.btn.download" | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInProgress"></i></button><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div></div><div class="clearfix bottomAction" ng-if="(!vm.systemAdmin)"><button class="btn btn-primary pull-right m-l-10" ng-click="vm.cancelCreate()">{{ "device.request.edit.btn.cancel" | translate }}</button></div></div>');
$templateCache.put('app/pages/device-request/views/jesca-detail.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="handsOnTableWrapper"><div id="handsontable-request-detail"></div></div><div class="clearfix bottomAction" ng-if="vm.permissions.DEVICE_REQUEST.WRITE"><button class="btn btn-primary pull-right" ng-click="vm.cancelCreate()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.applyMaroon()" ng-disabled="vm.disableActionButtons">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.create(true)" ng-disabled="vm.disableActionButtons">{{ "device.request.edit.btn.save.as.draft" | translate }} <i class="inProgress m-l-10" ng-if="vm.draftInProgress"></i></button><button class="btn btn-primary pull-right m-r-15 text-transform-inherit" ng-click="vm.jescaActivationCsvDownload()" my-ng-disabled="vm.isDownloadingJescaCsvResult || vm.disableActionButtons">{{ "device.request.jesca.download.activation.csv" | translate }} <i class="inProgress m-l-10" ng-if="vm.isDownloadingJescaActivationCsv"></i></button> <button class="btn btn-primary pull-right m-r-15 text-transform-inherit" ng-click="vm.downloadJescaCsvResult()" ng-disabled="vm.isDownloadingJescaCsvResult">{{ "device.request.jesca.download.result" | translate }} <i class="inProgress m-l-10" ng-if="vm.isDownloadingJescaCsvResult"></i></button> <button class="btn btn-primary pull-right m-r-15 text-transform-inherit" ng-click="vm.downloadJescaCsv()" ng-disabled="vm.isDownloadingJescaCsv">{{ "device.request.jesca.download" | translate }} <i class="inProgress m-l-10" ng-if="vm.isDownloadingJescaCsv"></i></button> <button class="btn btn-primary pull-right m-r-15 text-transform-inherit" ngf-select="vm.uploadJescaCsv($file, $event, bank)" ng-disabled="!vm.permissions.DEVICE_REQUEST.WRITE" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "device.request.jesca.upload.csv" | translate }} <i class="inProgress m-l-10" ng-if="vm.uploadingJescaCsv"></i></button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.resetRequest()" ng-disabled="!vm.disableResetButton">{{ "device.request.jesca.reset.btn.text" | translate }}</button><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div></div><div class="clearfix bottomAction" ng-if="(!vm.permissions.DEVICE_REQUEST.WRITE && vm.permissions.DEVICE_REQUEST.READ)"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancelCreate()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-15 text-transform-inherit" ng-click="vm.downloadDeviceRequestExcel()" ng-disabled="vm.isDownloadingDIExcel">{{ "device.request.list.download.device.request.excel.btn" | translate }} <i class="inProgress m-l-10" ng-if="vm.isDownloadingDIExcel"></i></button></div></div>');
$templateCache.put('app/pages/device-request/views/multiple-request.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="handsOnTableWrapper"><div id="handsontable-multiple-request"></div></div><div class="clearfix bottomAction" ng-if="vm.permissions.DEVICE_REQUEST.WRITE"><button class="btn btn-primary pull-right m-l-10" ng-click="vm.cancelCreate()">{{ "device.request.edit.btn.cancel" | translate }}</button> <button class="btn btn-primary pull-right m-l-10" ng-click="vm.create(false)">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button> <button class="btn btn-primary pull-right" ng-click="vm.create(true)">{{ "device.request.edit.btn.save.as.draft" | translate }} <i class="inProgress m-l-10" ng-if="vm.draftInProgress"></i></button><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div></div></div>');
$templateCache.put('app/pages/device-request/views/new-request.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><div class="form-group no-margin"><div class="form-input-group-row d-inline-block"><label class="d-inline-block"><b>{{ "device.request.list.version" | translate }}:</b></label><ui-select ng-model="vm.version" name="version" class="btn-group bootstrap-select" append-to-body="false" search-enabled="false" on-select="vm.onVersionChange($item)"><ui-select-match><span>{{ $select.selected }}</span></ui-select-match><ui-select-choices repeat="item in vm.versionOptions track by $index"><span ng-bind-html="vm.versionOptions[$index]"></span></ui-select-choices></ui-select></div></div></div><div class="handsOnTableWrapper"><div id="handsontable-request-create"></div></div><div class="clearfix bottomAction" ng-if="vm.permissions.DEVICE_REQUEST.WRITE"><button class="btn btn-primary pull-right" ng-click="vm.cancelCreate()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.create(false)">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.create(true)">{{ "device.request.edit.btn.save.as.draft" | translate }} <i class="inProgress m-l-10" ng-if="vm.draftInProgress"></i></button></div></div>');
$templateCache.put('app/pages/device-request/views/remove-device.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="remove-device"><div class="handsOnTableWrapper"><div id="handsOnTable-remove-device"></div></div><div class="info"><h5>{{ "common.components.points.to.note" | translate }}</h5><ol type="1"><li ng-bind-html="vm.localTranslator(\'device.request.list.detach.terminal.point1\')"></li><li ng-bind-html="vm.localTranslator(\'device.request.list.detach.terminal.point2\')"></li><li ng-bind-html="vm.localTranslator(\'device.request.list.detach.terminal.point3\')"></li><li ng-bind-html="vm.localTranslator(\'device.request.list.detach.terminal.point4\')"></li></ol></div><div class="clearfix bottomAction"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancel()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submit()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button></div></div>');
$templateCache.put('app/pages/device-request/views/request-detail.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="handsOnTableWrapper"><div id="handsontable-request-detail"></div></div><div class="clearfix bottomAction" ng-if="vm.permissions.DEVICE_REQUEST.WRITE"><button class="btn btn-primary pull-right" ng-click="vm.cancelCreate()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.create(false)" ng-disabled="vm.disableActionButtons">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.create(true)" ng-disabled="vm.disableActionButtons">{{ "device.request.edit.btn.save.as.draft" | translate }} <i class="inProgress m-l-10" ng-if="vm.draftInProgress"></i></button> <button class="btn btn-primary pull-right m-r-15 text-transform-inherit" ng-click="vm.downloadDeviceRequestExcel()" ng-disabled="vm.isDownloadingDIExcel">{{ "device.request.list.download.device.request.excel.btn" | translate }} <i class="inProgress m-l-10" ng-if="vm.isDownloadingDIExcel"></i></button><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div></div><div class="clearfix bottomAction" ng-if="(!vm.permissions.DEVICE_REQUEST.WRITE && vm.permissions.DEVICE_REQUEST.READ)"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancelCreate()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-15 text-transform-inherit" ng-click="vm.downloadDeviceRequestExcel()" ng-disabled="vm.isDownloadingDIExcel">{{ "device.request.list.download.device.request.excel.btn" | translate }} <i class="inProgress m-l-10" ng-if="vm.isDownloadingDIExcel"></i></button></div></div>');
$templateCache.put('app/pages/device-request/views/request-list.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i"><div class="panel-body p-10-i"><form class="row form-inline"><div class="form-group col-xs-12"><button ngf-select="vm.uploadForNewDeviceRequest($file, $event, bank)" ng-show="vm.writeVisible" ng-disabled="!vm.permissions.DEVICE_REQUEST.WRITE" class="btn btn-primary w-btn-md btn-raised btn-xs" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "device.request.list.upload.device" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.newDeviceInProgress"></i></button> <button class="btn btn-info m-l-5 w-btn-md-1 btn-raised btn-xs" ng-show="vm.isSystemUser" ng-disabled="((!vm.showBulkEdit()) || vm.isDownloadingExcel)" ng-click="vm.downloadShipmentExcel()">{{ "device.request.list.download.shipment.template" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloadingExcel"></i></button> <button ngf-select="vm.uploadForDeviceDetail($file, $event, bank)" ng-show="vm.isSystemUser" ng-disabled="!vm.permissions.DEVICE_REQUEST.MGMNT_WRITE" class="btn btn-primary m-l-5 w-btn-md btn-raised btn-xs" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "device.request.list.upload.device.progress" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.inProgress"></i></button> <button class="btn btn-info m-l-5 w-btn-md-1 btn-raised btn-xs" ng-show="vm.isSystemUser" ng-disabled="((!vm.showBulkEdit()) || vm.isDownloadingDITMSExcel)" ng-click="vm.downloadDITMSExcel()">{{ "device.request.list.download.request.tms.excel.btn" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloadingDITMSExcel"></i></button> <button class="btn btn-danger pull-right w-btn-sm btn-raised btn-xs" ng-show="vm.writeVisible" ng-disabled="vm.isBulkDeleteDisabled()" ng-click="vm.deleteBulkDeviceRequest()">{{ "device.request.list.btn.delete" | translate }} &nbsp;<i class="fa fa-trash" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isBulkDeleteInProgress"></i></button> <button class="btn btn-danger pull-right w-btn-sm btn-raised btn-xs m-r-5" ng-show="vm.writeVisible" ng-disabled="vm.isBulkCancelDisabled()" ng-click="vm.cancelBulkDeviceRequest()">{{ "device.request.list.btn.cancel" | translate }} &nbsp;<i class="fa fa-times" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isBulkCancelInProgress"></i></button></div><div class="form-group col-xs-12"><button class="btn btn-primary m-t-5 w-btn-md btn-raised btn-xs" ng-disabled="vm.isBulkDeviceRequestEditDisabled()" ng-click="vm.onBulkEdit()">{{ "device.request.list.edit.device" | translate }} &nbsp;<i class="ion-compose" ng-if="!vm.isBulkEditInProgress" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isBulkEditInProgress"></i></button> <button class="btn btn-info m-t-5 m-l-5 w-btn-md-1 btn-raised btn-xs" ng-show="vm.isSystemUser" ng-disabled="((!vm.showBulkEdit()) || vm.isDownloadingJMupsExcel)" ng-click="vm.downloadDeviceJMupsExcelValidate()">{{ "device.request.list.download.jmups.excel" | translate }} &nbsp;<i class="fa fa-download" ng-if="!vm.isDownloadingJMupsExcel" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloadingJMupsExcel"></i></button> <button class="btn btn-primary m-t-5 m-l-5 w-btn-md btn-raised btn-xs" ng-show="vm.isSystemUser" ng-disabled="!vm.showBulkEdit() || !vm.permissions.DEVICE_REQUEST.MGMNT_READ" ng-click="vm.bulkDeviceEdit()">{{ "device.request.list.edit.device.progress" | translate }} &nbsp;<i class="ion-compose" ng-if="!vm.isBulkDeviceEditInProgress" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isBulkDeviceEditInProgress"></i></button> <button class="btn btn-info m-t-5 m-l-5 w-btn-md-1 btn-raised btn-xs" ng-show="vm.isSystemUser" ng-disabled="((!vm.showBulkEdit()) || vm.isDownloadingShipmentTMSExcel)" ng-click="vm.downloadShipmentTMSExcel()">{{ "device.request.list.download.shipment.tms.excel.btn" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloadingShipmentTMSExcel"></i></button><div ng-show="vm.isSystemUser" class="btn-group pull-right m-t-5" uib-dropdown=""><button id="btn-append-to-single-button" type="button" class="btn btn-danger w-btn-sm-x2 btn-xs" ng-disabled="vm.isDetachSuspendDropdownDisabled()" uib-dropdown-toggle="">{{ "device.request.list.detach.suspend.dropdown.btn" | translate }} <span class="caret" ng-if="!vm.detachTerminalLoader"></span> <span ng-if="vm.detachTerminalLoader" class="inProgress"></span></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="btn-append-to-single-button"><li role="menuitem"><button ng-click="vm.removeTerminal()" ng-disabled="vm.isBulkRemoveDisabled()" class="btn btn-danger w-btn-sm-x2 btn-xs">{{ "device.request.list.detach.terminal.btn" | translate }}</button></li><li role="menuitem"><button ng-click="vm.openSuspendScreen()" ng-disabled="vm.isSuspensionDisabled()" class="btn btn-danger w-btn-sm-x2 btn-xs">{{ "device.request.suspend.btn" | translate }}</button></li></ul></div></div><div class="form-group col-xs-12"><button ngf-select="vm.uploadForNewJescaRequest($file, $event, bank)" ng-show="vm.writeVisible" ng-disabled="!vm.permissions.DEVICE_REQUEST.WRITE" class="btn btn-primary m-t-5 w-btn-md btn-raised btn-xs" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "device.request.jesca.upload.excel" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isJescaExcelUpload"></i></button> <button class="btn btn-primary m-t-5 m-l-5 w-btn-md-1 btn-raised btn-xs" ng-if="vm.systemAdmin" ng-click="vm.onBulkJescaEdit()">{{ "device.request.jesca.edit.title" | translate }} &nbsp;<i class="ion-compose" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isBulkEditJescaInProgress"></i></button> <button class="btn btn-info m-t-5 m-l-5 w-btn-md-1 btn-raised btn-xs" style="width:262px;" ng-if="vm.systemAdmin" ng-disabled="((!vm.showBulkEdit()) || vm.isDownloadingJescaActivationCsv)" ng-click="vm.jescaActivationCsvDownload()">{{ "device.request.jesca.download.activation.csv" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp;<i class="inProgress m-l-5" ng-if="vm.isDownloadingJescaActivationCsv"></i></button></div></form></div></div><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><form><div class="row" style="margin-left: -10px"><div class="col-sm-12" style="padding-right: 15.5px"><div class="form-group row select-dropdown"><div class="form-group-col col-filter"><select ng-show="vm.isSystemUser" class="form-control selectpicker with-search show-tick" title="\u30D1\u30FC\u30C8\u30CA\u30FC" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.PARTNER_ID" ng-options="item as item.label for item in vm.filterOptions.options.partner track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select class="form-control selectpicker show-tick" title="\u5951\u7D04\u5148ID\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.SERVICE_CONTRACT_ID" ng-options="item as item.label for item in vm.filterOptions.options.serviceContractId track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select ng-show="vm.isDeviceOwner || vm.isSystemUser || vm.isPartner" class="form-control selectpicker with-search show-tick minMaxSelect" title="\u52A0\u76DF\u5E97\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.MERCHANT_ID" ng-options="item as item.label for item in vm.filterOptions.options.merchant track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select ng-show="!(vm.isSystemUser || vm.isPartner)" class="form-control selectpicker with-search show-tick" title="\u8ACB\u6C42\u5148\u652F\u5E97\u540D\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.INVOICE_DESTINATION_BRANCH_ID" ng-options="item as item.label for item in vm.filterOptions.options.settlementBranch track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter m-l-3"><select ng-show="vm.isMerchantOrMerchantAndDeviceOwner || vm.isSystemUser || vm.isPartner" class="form-control selectpicker with-search show-tick minMaxSelect" title="\u7AEF\u672B\u6240\u6709\u8005\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.DEVICE_OWNER_ID" ng-options="item as item.label for item in vm.filterOptions.options.deviceOwner track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter"><select class="form-control selectpicker with-search show-tick" title="\u72B6\u6CC1\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.filters.STATUS" ng-options="item as item.label for item in vm.filterOptions.options.status track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter" ng-if="vm.systemAdmin" style="width: 9%;"><select class="form-control selectpicker with-search show-tick" title="\u54C1\u540D" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="6" ng-model="vm.filters.PRODUCT_NAME" ng-options="item as item.label for item in vm.filterOptions.options.productName track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter" style="width: 9%;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.search.DEVICE_APPLICATION_NUMBER" placeholder="{{\'device.request.list.device.application.number\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter" style="width: 9%;"><span tooltip-append-to-body="true" tooltip-placement="top" uib-tooltip="{{\'device.request.list.device.serial.tooltip\' | translate }}"><input type="text" class="form-control" ng-model="vm.filters.search.DEVICE_SERIAL" placeholder="{{\'device.management.device.serial\' | translate }}" maxlength="200"></span></div><div class="m-r-15 text-right"><button style="width:60px;text-align: center;" class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.show.data\' | translate}} <span ng-if="vm.dataFetchInProgress" class="inProgress-custom"></span></span></button></div></div></div></div><div class="row m-t-5" style="margin-left:-10px; margin-right:-10px"><div class="col-sm-12" style="padding-right: 15.5px"><div class="form-group row"><div class="form-group-col col-filter"><input type="text" class="form-control" ng-model="vm.filters.search.installationLocation" placeholder="{{\'salesSettlements.monthly.list.search.installationLocation\' | translate }}" maxlength="200"></div><div class="form-group-col col-filter"><input type="text" class="form-control" ng-model="vm.filters.search.remarks" placeholder="{{\'salesSettlements.monthly.list.search.remarksOrVmNumber\' | translate }}" maxlength="200"></div><div class="form-group-col col-filter"><label class="label-filter same-line-label">{{\'device.request.list.expected.delivery.date\' | translate}}</label><div class="form-group daterange-select select-dropdown" style="width: 45%;float: right;"><select class="form-control selectpicker show-tick op-dropdown" data-actions-box="false" data-live-search="false" data-size="10" ng-change="vm.changeFirstDateRange()" ng-model="vm.opFirstSelect" ng-options="item as item.label for item in vm.filterOptions.options.DateOptions" selectpicker="" title="\u9078\u629E"></select></div></div><div class="form-group-col no-cal-icon m-l-3 col-filter"><div class="input-group m-b-0 daterange"><input class="form-control" type="text" datetimepicker="" options="vm.dateOptions" name="vm.filters.expectedDeliveryDateFrom" ng-model="vm.filters.expectedDeliveryDateFrom" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div><span class="daterange-span" style="text-align: center;float: left;margin-top: 7px;margin-left: -5px;width: 0px;">~</span><div class="form-group-col no-cal-icon col-filter"><div class="input-group m-b-0 daterange"><input class="form-control" type="text" datetimepicker="" options="vm.dateOptions" name="vm.filters.expectedDeliveryDateTo" ng-model="vm.filters.expectedDeliveryDateTo" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div><div class="form-group-col col-filter"><select class="form-control selectpicker op-dropdown show-tick replacement" title="\u305D\u306E\u4ED6" data-live-search="false" data-actions-box="false" data-width="100%" multiple="false" data-size="10" ng-model="vm.filters.DEVICE_REPLACEMENT" ng-options="item as item.label for item in vm.filterOptions.options.Replacement track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="form-group-col col-filter m-r-5" ng-if="vm.systemAdmin"><select class="form-control selectpicker with-search show-tick" title="JESCA\u7533\u8ACB" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="6" ng-model="vm.filters.DEVICE_JESCA_STATUS" ng-options="item as item.label for item in vm.filterOptions.options.jesca_status track by item.value" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="m-r-10 text-right"><button style="width:60px;text-align: center;" class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)"><span>{{\'device.request.list.btn.clear\' | translate}} <span ng-if="vm.dataFetchInProgressUsingClear" class="inProgress-custom"></span></span></button></div></div></div></div></form></div></div><div class="panel with-scroll table-panel m-b-10-i" ng-if="!vm.isLoading"><div class="panel-body p-10-i"><div class="table-responsive m-t-0-i"><table class="table table-bordered"><thead><tr><th><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.select" ng-click="vm.selectAll($event, vm.requests.content)"> <span></span></label></th><th>#</th><th ng-show="vm.visibilityPermission[\'partner\']" class="partnerColumn">{{ "device.request.list.partner.table.column" | translate }}</th><th ng-show="vm.visibilityPermission[\'serviceContract\']">{{ "device.request.list.service.contract.id" | translate }}</th><th ng-show="vm.visibilityPermission[\'merchant_name\']">{{ "device.request.list.merchant.name" | translate }}</th><th ng-show="vm.visibilityPermission[\'device_owner_name\']">{{ "device.request.list.device.owner" | translate }}</th><th>{{ "device.request.list.device.application.number" | translate }}</th><th>{{ "device.request.list.device.productName" | translate }}</th><th>{{ "device.request.list.device.serial" | translate }}</th><th ng-show="vm.visibilityPermission[\'desired_delivery_date\']">{{ "device.request.list.desired.delivery.date" | translate }}</th><th ng-show="vm.visibilityPermission[\'storeName\']">{{ "device.request.list.ins.store.name" | translate }}</th><th ng-show="vm.visibilityPermission[\'branchName\']">{{ "device.request.list.inv.branch.name" | translate }}</th><th>{{ "device.request.list.expected.delivery.date" | translate }}</th><th>{{ "device.request.list.status" | translate }}</th><th>{{ "device.request.list.last.modified" | translate }}</th><th ng-if="vm.systemAdmin">{{ "device.request.list.jesca.application" | translate }}</th><th ng-if="vm.systemAdmin">{{ "device.request.list.jesca.application.date" | translate }}</th><th ng-if="vm.systemAdmin">{{ "device.request.list.jesca.reflection.date" | translate }}</th><th><a title="{{\'device.request.list.supplementary.information\' | translate }}" class="m-no-error"><i class="fa fa-info-circle"></i></a></th><th colspan="2" class="text-center" ng-if="!(vm.isSystemUser || vm.isPartner)">{{\'org.list.action\' | translate}}</th></tr></thead><tbody><tr ng-repeat="di in vm.requests.content track by $index"><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedRequests[di.deviceInstallationId]"> <span></span></label></td><td style="text-align: left;" class="numbering">{{vm.requests.pageable.offset + $index + 1}}</td><td ng-show="vm.visibilityPermission[\'partner\']" class="partnerColumn">{{di.partnerIds.join(", ")}}</td><td ng-show="vm.visibilityPermission[\'serviceContract\']">{{di.serviceContractId}}</td><td ng-show="vm.visibilityPermission[\'merchant_name\']" class="word-break">{{di.companyName}}</td><td ng-show="vm.visibilityPermission[\'device_owner_name\']" class="word-break">{{ vm.isUndefinedOrNullOrEmptyObject(di.deviceOwnerName) ? "" : di.deviceOwnerName }}</td><td><div class="applicationNumber-cell word-break">{{di.applicationNumber}}</div></td><td><div class="applicationNumber-cell word-break">{{di.productName}}</div></td><td class="deviceSerial-cell word-break" ng-if="di.isReplaced || di.isSuspended"><u><a ng-click="vm.showDeviceHistoryModal(di.deviceSerial)" title="{{\'device.request.history.msg\' | translate }}" class="link m-no-error">{{di.deviceSerial}}</a></u></td><td class="deviceSerial-cell word-break" ng-if="!di.isReplaced && !di.isSuspended">{{di.deviceSerial}}</td><td ng-show="vm.visibilityPermission[\'desired_delivery_date\']">{{di.preferredDateOfInstallation | date: \'shortDate\'}}</td><td ng-show="vm.visibilityPermission[\'storeName\']" class="installationStore-cell word-break">{{di.storeName }}</td><td ng-show="vm.visibilityPermission[\'branchName\']" class="word-break">{{ di.branchName }}</td><td>{{di.expectedDateOfDelivery | date: \'shortDate\'}}</td><td>{{vm.getStatus(di.status)}}</td><td>{{vm.timeConverter(di.lastModified)}}</td><td ng-if="vm.systemAdmin && di.jescaApplicable">{{vm.getJescaStatus(di.jescaApplicationStatus)}}</td><td ng-if="vm.systemAdmin && !di.jescaApplicable">{{vm.getJescaStatus(di.jescaApplicationStatus)}}</td><td ng-if="vm.systemAdmin && di.jescaApplicable">{{di.applicationDate | date: \'shortDate\'}}</td><td ng-if="vm.systemAdmin && !di.jescaApplicable">N/A</td><td ng-if="vm.systemAdmin && di.jescaApplicable">{{di.reflectionDate | date: \'shortDate\'}}</td><td ng-if="vm.systemAdmin && !di.jescaApplicable">N/A</td><td><a title="{{ \'device.request.list.version\' | translate }}: {{di.version}} {{\'device.request.list.created.by\' | translate }} {{vm.createdByOrgTitle[$index]}}" class="m-no-error"><i class="fa fa-info-circle"></i></a></td><td ng-if="!(vm.isSystemUser || vm.isPartner)"><button class="btn btn-primary btn-xs" ng-click="vm.openDetail(di.deviceInstallationId)">{{ "device.request.list.view" | translate }}</button></td><td ng-if="!(vm.isSystemUser || vm.isPartner)"><button ng-if="vm.isDeleteButtonVisible(di.status)" ng-disabled="!vm.permissions.DEVICE_REQUEST.WRITE" class="btn btn-danger btn-xs" ng-click="vm.deleteDeviceRequest(di.deviceInstallationId)">{{ "device.request.list.btn.delete" | translate }}</button> <button ng-if="vm.isCancelButtonVisible(di.status)" ng-disabled="!vm.permissions.DEVICE_REQUEST.WRITE" class="btn btn-danger btn-xs" ng-click="vm.cancelDeviceRequest(di.deviceInstallationId)">{{ "device.request.list.btn.cancel" | translate }}</button></td></tr></tbody></table></div><div class="m-t-20"><pagination query="vm.query" pageable="vm.requests.pageable" total-pages="vm.requests.totalPages" total-elements="vm.requests.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/device-request/views/reserve-change-modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title text-center" id="myModalLabel"><span ng-if="!confirmVm.nonEmptyStartTime">{{ "device.request.reserve.modal.title" | translate}}</span> <span ng-if="confirmVm.nonEmptyStartTime">{{ "device.request.reserve.modal.title2" | translate}}</span></h4></div><div class="modal-body m-b-10" ng-class="{\'has-error\': confirmVm.settlementForm.reserveDate.$invalid && (confirmVm.settlementForm.reserveDate.$dirty || confirmVm.settlementForm.$submitted)}"><div><div class="m-b-10"><label class="radio-inline nowrap"><input type="radio" name="confirmVm.reserveChange.reservationDateTime" ng-model="confirmVm.reserveChange.reservationDateTime" value="immediate" ng-checked="confirmVm.nonEmptyStartTime"> <span>{{ "device.request.reserve.modal.immediate" | translate }}</span></label></div><div ng-hide="confirmVm.nonEmptyStartTime" class="m-b-10"><label class="radio-inline nowrap"><input type="radio" name="confirmVm.reserveChange.reservationDateTime" ng-model="confirmVm.reserveChange.reservationDateTime" value="today" ng-checked="!confirmVm.nonEmptyStartTime" ng-disabled="confirmVm.nonEmptyStartTime"> <span>{{ "device.request.reserve.modal.today" | translate }} (<span>{{confirmVm.todayDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</span>)</span></label></div><div ng-if="!confirmVm.nonEmptyStartTime" class="m-b-10"><label class="radio-inline nowrap"><input type="radio" name="confirmVm.reserveChange.reservationDateTime" ng-model="confirmVm.reserveChange.reservationDateTime" value="monthEnd" ng-disabled="confirmVm.nonEmptyStartTime"> <span>{{ "device.request.reserve.modal.month.end" | translate }} (<span>{{confirmVm.monthEndDate | date:\'yyyy-MM-dd\'}}</span> 23:59:59)</span></label></div><div ng-if="!confirmVm.nonEmptyStartTime" class="m-b-10"><label class="radio-inline nowrap"><input type="radio" name="confirmVm.reserveChange.reservationDateTime" ng-model="confirmVm.reserveChange.reservationDateTime" value="startNextMonth" ng-disabled="confirmVm.nonEmptyStartTime"> <span>{{ "device.request.reserve.modal.start.next.month" | translate }} (<span>{{confirmVm.nextMonthStartDate | date:\'yyyy-MM-dd\'}}</span> 00:00:00)</span></label></div><div ng-if="!confirmVm.nonEmptyStartTime" class="m-b-10"><label class="radio-inline"><table cellpadding="0" cellspacing="0"><th class="p-b-20"><input type="radio" name="confirmVm.reserveChange.reservationDateTime" ng-model="confirmVm.reserveChange.reservationDateTime" value="specificDate" ng-disabled="confirmVm.nonEmptyStartTime"></th><th class="p-r-5">{{ "device.request.reserve.modal.specify.date.time" | translate }}</th><th><datepicker options="confirmVm.dateOptions" date="confirmVm.date" name="confirmVm.date" ng-model="confirmVm.date"></datepicker></th><th class="p-l-5">(00:00:00)</th></table></label></div><div ng-if="confirmVm.nonEmptyStartTime" class="m-t-20 m-b-10"><span>{{ "device.request.reserve.modal.message1" | translate}}</span><ul><li ng-repeat="transaction in confirmVm.transactionArray track by $index" class="m-t-10">{{transaction.deviceSerial}}, {{transaction.startTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</li></ul><span>{{ "device.request.reserve.modal.message2" | translate}}</span></div><div class="m-t-10" ng-if="!confirmVm.cancelReservation"><label class="radio-inline nowrap"><input type="radio" name="confirmVm.reserveChange.reservationDateTime" ng-model="confirmVm.reserveChange.reservationDateTime" value="cancelReservation"> <span>{{ "device.request.reserve.modal.cancel.reservation" | translate }}</span></label></div></div></div><div class="modal-footer"><button class="btn btn-primary pull-right m-l-10" ng-click="confirmVm.cancel()">{{ "device.request.create.btn_cancel" | translate }}</button> <button type="button" class="btn btn-primary" ng-click="confirmVm.ok()">{{ "device.request.reserve.modal.btnText" | translate}}</button></div></div>');
$templateCache.put('app/pages/device-request/views/suspend-device.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="remove-device"><div class="handsOnTableWrapper"><div id="handsOnTable-suspend-device"></div></div><div class="info"><h5>{{ "common.components.points.to.note" | translate }}</h5><ol type="1"><li ng-bind-html="vm.localTranslator(\'device.request.suspend.terminal.point1\')"></li><li ng-bind-html="vm.localTranslator(\'device.request.suspend.terminal.point2\')"></li><li ng-bind-html="vm.localTranslator(\'device.request.suspend.terminal.point3\')"></li><li ng-bind-html="vm.localTranslator(\'device.request.suspend.terminal.point4\')"></li></ol></div><div class="clearfix bottomAction"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancel()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submit()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button></div></div>');
$templateCache.put('app/pages/device-request/views/upload-device-request-change-error-modal.html','<div class="modal-content"><div class="modal-header p-t-30"><span class="modal-title">{{ "device.request.upload.error.modal.message1" | translate}}</span></div><div class="modal-body m-b-10"><span>{{ "device.request.upload.error.modal.message2" | translate}}</span><ul><li ng-repeat="transaction in errorVm.transactionArray track by $index" class="m-t-10">{{transaction.deviceSerial}}, {{transaction.startTime | date : \'yyyy/MM/dd HH:mm:ss\'}}</li></ul></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="errorVm.ok()">{{ "device.request.upload.error.modal.btnText" | translate}}</button></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/in-office-service/views/list-device-linkage.html','');
$templateCache.put('app/pages/in-office-service/views/qrCodeManagement.html','');
$templateCache.put('app/pages/in-office-service/views/usageDetails-byDevice.html','');
$templateCache.put('app/pages/in-office-service/views/usageDetails-byEmployee.html','');
$templateCache.put('app/pages/other/views/other.html','<div ng-if="vm.telemetryEnabled"><h2>{{\'other.header\'| translate}}</h2><h4 style="padding-top:25px"><a ng-href="{{vm.getTelemetryUrl()}}" target="_blank" class="bold-text">{{\'other.link\'| translate}}</a></h4></div><div ng-if="!vm.telemetryEnabled"><h2>{{\'common.components.coming.soon\' | translate}}</h2></div>');
$templateCache.put('app/pages/sales-settlements/views/device-history-modal.html','<div><div class="m-b-30" ng-if="vm.deviceHistory.length && !vm.isLoading"><div class="m-b-30"><h4 class="modal-title" id="myModalLabel">{{\'device.request.history.title\' | translate}} : {{vm.deviceSerial}}</h4></div><div><div><table class="table table-bordered"><thead><tr><th class="text-left va-center"><span>#</span></th><th><span>{{\'device.request.history.operation.start.date\' | translate }}</span></th><th><span>{{\'device.request.history.removal.date\' | translate }}</span></th><th><span>{{\'device.request.history.replacement.date\' | translate }}</span></th><th><span>{{\'device.request.history.contract.id\' | translate }}</span></th><th><span>{{\'device.request.history.branchName\' | translate }}</span></th><th><span>{{\'device.request.history.branchCode\' | translate }}</span></th><th><span>{{\'device.request.history.charge.initial.fee\' | translate }}</span></th><th><span>{{\'device.request.history.charge.monthly.fee\' | translate }}</span></th></tr></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.deviceHistory)"><td class="nodata" colspan="9">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate}}</td></tr><tr ng-repeat="data in vm.deviceHistory track by $index"><td>{{$index + 1}}</td><td><span ng-if="data.installationDate">{{data.installationDate | date: \'medium\' }}</span> <span ng-if="!data.installationDate">{{\'device.replacement.device.information.na\' | translate}}</span></td><td><span ng-if="data.removalDate">{{data.removalDate | date: \'medium\' }}</span> <span ng-if="!data.removalDate">{{\'device.replacement.device.information.na\' | translate}}</span></td><td><span ng-if="data.dateTo">{{data.dateTo | date: \'medium\' }}</span> <span ng-if="!data.dateTo">{{\'device.replacement.device.information.na\' | translate}}</span></td><td>{{data.serviceContractId}}</td><td class="break-word">{{data.branchName}}</td><td>{{data.branchCode}}</td><td><span ng-if="data.canChargeInitialFee !== null">{{vm.getValueFromTypeKey(data.canChargeInitialFee, vm.boolOptions)}}</span> <span ng-if="data.canChargeInitialFee === null">{{\'device.replacement.device.information.na\' | translate}}</span></td><td><span ng-if="data.canChargeMonthlyFee !== null">{{vm.getValueFromTypeKey(data.canChargeMonthlyFee, vm.boolOptions)}}</span> <span ng-if="data.canChargeMonthlyFee === null">{{\'device.replacement.device.information.na\' | translate}}</span></td></tr></tbody></table></div></div></div><div ng-if="vm.suspensionHistory.length && !vm.isLoading"><div class="m-b-30"><h4 class="modal-title" id="myModalLabel">{{\'device.request.history.suspend.title\' | translate}} : {{vm.deviceSerial}}</h4></div><div><div><div><table class="table table-bordered"><thead><tr><th class="text-left va-center"><span>#</span></th><th><span>{{\'device.request.history.status\' | translate }}</span></th><th><span>{{\'device.request.history.fromDateTime\' | translate }}</span></th><th><span>{{\'device.request.history.toDateTime\' | translate }}</span></th><th><span>{{\'device.request.history.contract.id\' | translate }}</span></th><th><span>{{\'device.request.history.branchName\' | translate }}</span></th><th><span>{{\'device.request.history.branchCode\' | translate }}</span></th><th><span>{{\'device.request.history.charge.initial.fee\' | translate }}</span></th><th><span>{{\'device.request.history.charge.monthly.fee\' | translate }}</span></th></tr></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.suspensionHistory)"><td class="nodata" colspan="9">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate}}</td></tr><tr ng-repeat="data in vm.suspensionHistory track by $index"><td>{{$index + 1}}</td><td><span>{{vm.getValueFromTypeKey(data.nowStatus, vm.types)}}</span></td><td><span ng-if="data.dateFrom">{{data.dateFrom | date: \'medium\' }}</span> <span ng-if="!data.dateFrom">{{\'device.replacement.device.information.na\' | translate}}</span></td><td><span ng-if="data.dateTo">{{data.dateTo | date: \'medium\' }}</span> <span ng-if="!data.dateTo">{{\'device.replacement.device.information.na\' | translate}}</span></td><td>{{data.serviceContractId}}</td><td class="break-word">{{data.branchName}}</td><td>{{data.branchCode}}</td><td><span ng-if="data.canChargeInitialFee !== null">{{vm.getValueFromTypeKey(data.canChargeInitialFee, vm.boolOptions)}}</span> <span ng-if="data.canChargeInitialFee === null"></span></td><td><span ng-if="data.canChargeMonthlyFee !== null">{{vm.getValueFromTypeKey(data.canChargeMonthlyFee, vm.boolOptions)}}</span> <span ng-if="data.canChargeMonthlyFee === null"></span></td></tr></tbody></table></div></div><div class="m-t-30">{{\'device.request.history.suspend.note\' | translate}}</div></div></div><div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div></div></div>');
$templateCache.put('app/pages/sales-settlements/views/monthly-sales-list-display-data-warning-modal.html','<div class="modal-content"><div class="modal-header p-t-30 p-b-5"><span class="modal-title">{{"salesSettlements.monthly.list.warning.modal.message1" | translate}}</span></div><div class="modal-body p-b-30"><span>{{"salesSettlements.monthly.list.warning.modal.message2" | translate}}</span></div><div class="modal-footer"><button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">{{\'common.components.btn.cancel\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="warningVm.ok()" ng-disabled="warningVm.inProgress">{{\'salesSettlements.monthly.list.search.downloadExcel\' | translate }} <i class="inProgress m-l-10" ng-if="warningVm.inProgress"></i></button></div></div>');
$templateCache.put('app/pages/sales-settlements/views/monthly-sales-request.html','<div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="m-b-15 text-right"><button class="btn btn-primary m-r-15" ng-click="vm.goBack()" ng-disabled="vm.isGoBackLoading"><span">{{\'salesSettlements.monthly.list.table.back\' | translate}} <span ng-if="vm.isGoBackLoading" class="inProgress-custom"></span></span"></button> <button class="btn btn-primary" ng-click="vm.getData()" ng-disabled="vm.isLoading"><span>{{\'salesSettlements.monthly.list.table.refresh\' | translate}} <span ng-if="vm.isLoading" class="inProgress-custom"></span></span></button></div><div class="table-responsive" ng-if="!vm.isLoading"><table class="table table-bordered"><thead><tr><th>#</th><th>{{\'salesSettlements.monthly.list.table.sourcePage\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.requestDate\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.merchantId\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.branchName\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.date\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.aggregatedSalesBy\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.granularity\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.unitPrice\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.status\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.completionDate\' | translate }}</th><th>{{\'salesSettlements.monthly.list.table.downloadCSV\' | translate }}</th><th><a title="{{\'salesSettlements.monthly.list.table.supplementary.information\' | translate }}" class="m-no-error"><i class="fa fa-info-circle"></i></a></th></tr></thead><tbody><tr ng-repeat="report in vm.monthlySalesDownloadReport.content" track="" by="" $index=""><td style="text-align: left;" class="numbering">{{vm.monthlySalesDownloadReport.pageable.offset + $index + 1}}</td><td><div>{{vm.getValueFromTypeKey(report.sourcePage, vm.sourcePageEnum.SourcePage)}}</div></td><td><div>{{report.dateCreated | date: \'yyyy/MM/dd HH:mm:ss\'}}</div></td><td><div>{{report.organisationNames}}({{report.merchantCode}})</div></td><td><div>{{vm.getBranch(report.branchName, report.branchCode)}}</div></td><td><div>{{report.month | date: \'yyyy/MM\'}}</div></td><td><div>{{vm.getValueFromTypeKey(report.period, vm.aggregationPeriod)}}</div></td><td><div>{{vm.getValueFromTypeKey(report.type, vm.types.AggregationEntityType)}}</div></td><td><div>{{vm.getValueFromTypeKey(report.unitPrice, vm.aggregationByUnitPrice)}}</div></td><td><div>{{vm.getValueFromTypeKey(report.status, vm.reportStatus)}}</div></td><td><div ng-if="report.completionTime">{{report.completionTime | date: \'yyyy/MM/dd HH:mm:ss\'}}</div></td><td><button type="submit" class="btn btn-primary settSubmitBtn" ng-if="report.status === \'COMPLETED\' && report.expirationTime > vm.date" ng-click="vm.downloadMonthlySalesReport(report.id, report.userId)" ng-disabled="vm.submitMonthlyReportInProgress[report.id]">{{\'salesSettlements.monthly.list.table.downloadBtn\' | translate }} <i class="inProgress m-l-10" ng-if="vm.submitMonthlyReportInProgress[report.id]"></i></button></td><td><a ng-attr-title="{{vm.getSuppInfoTitle(report)}}" class="m-no-error"><i class="fa fa-info-circle"></i></a></td></tr></tbody></table></div></div><div class="padding-20" ng-if="!vm.isLoading"><pagination query="vm.query" pageable="vm.monthlySalesDownloadReport.pageable" total-pages="vm.monthlySalesDownloadReport.totalPages" total-elements="vm.monthlySalesDownloadReport.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/sales-settlements/views/preview-sales-detail-toggle-closing.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong ng-if="!vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong> <strong ng-if="vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'salesSettlements.monthly.list.search.msg.server.error\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class=""><div class="handsOnTableWrapper"><div id="handsOnTable-oneItemDetailToggleClosing"></div></div><div class="clearfix bottomAction"><div class="di-msg-div pull-left">{{ "salesSettlements.monthly.list.search.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancel()">{{ "salesSettlements.monthly.list.search.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submit()" ng-disabled="vm.disableApplyBtn || vm.isLoading">{{ "salesSettlements.monthly.list.search.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div></div>');
$templateCache.put('app/pages/sales-settlements/views/preview-sales-detail.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong ng-if="!vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong> <strong ng-if="vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'salesSettlements.monthly.list.search.msg.server.error\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class=""><div class="handsOnTableWrapper"><div id="handsOnTable-oneItemDetailAddClosing"></div></div><div class="clearfix bottomAction"><div class="di-msg-div pull-left">{{ "salesSettlements.monthly.list.search.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancel()">{{ "salesSettlements.monthly.list.search.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submit()" ng-disabled="vm.disableApplyBtn || vm.isLoading">{{ "salesSettlements.monthly.list.search.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div></div>');
$templateCache.put('app/pages/sales-settlements/views/sales-detail.html','<div form="vm.searchForm"><form name="vm.searchForm" novalidate=""><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'salesSettlements.monthly.list.search.oneItemTitle\' | translate }}</div><div class="panel-body filterQueryForm"><div class="form-group" ng-class="{\'has-error\': vm.searchForm.organisationName.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.organization\' | translate }}</label><ui-select ng-model="vm.selectedOrg" class="btn-group bootstrap-select form-control" name="organisationName" ng-disabled="vm.isMerchant" append-to-body="false" search-enabled="false" ng-change="vm.updateBranchOffice()" ng-required="true"><ui-select-match><span>{{$select.selected.name}} <span ng-if="$select.selected.merchantCode">({{$select.selected.merchantCode}})</span></span></ui-select-match><ui-select-choices repeat="org in vm.allMerchants track by $index"><span ng-bind-html="(org.name) + \' (\' + (org.merchantCode) + \')\'"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.salesOffice\' | translate }}</label><ui-select ng-model="vm.search.branch" class="btn-group bootstrap-select form-control" name="branchCode" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{$select.selected.value}} <span ng-if="$select.selected.key != \'Total\'">({{$select.selected.key}})</span></span></ui-select-match><ui-select-choices repeat="(key, obj) in vm.salesBranch"><span>{{obj.value}} <span ng-if="obj.key != \'Total\'">({{obj.key}})</span></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-class="{\'has-error\': vm.searchForm.interval.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.displayUnit\' | translate }}</label><div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.displayUnit.key"><input type="radio" name="interval" ng-model="vm.search.interval" value="{{option}}" required=""> <span>{{vm.displayUnit[vm.getLang()][$index]}}</span></label></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="form-group"><div class="form-input-group-row labelXXXL" ng-if="vm.search.interval !== \'DAILY\'"><label>{{\'salesSettlements.monthly.list.search.month\' | translate }}</label><datepicker date="vm.search.date" required="true" format="vm.dateFormat" form="vm.searchForm" options="vm.dateOptions"></datepicker></div><div class="form-input-group-row labelXXXL" ng-if="vm.search.interval === \'DAILY\'"><label>{{\'salesSettlements.monthly.list.search.date\' | translate }}</label><datepicker date="vm.search.date" required="true" form="vm.searchForm"></datepicker></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.productName\' | translate }}</label><ui-select multiple="" ng-model="vm.search.productNames" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($item, vm.productNameOptions)}}</span></ui-select-match><ui-select-choices repeat="item in vm.productNameOptions.key | filter:$select.search"><span ng-bind-html="vm.getValueFromTypeKey(item, vm.productNameOptions)"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-class="{\'has-error\': vm.searchForm.displayData.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.displayData\' | translate }}</label><div><div><label ng-hide="vm.updateOptionsVisibility(option)" class="radio-inline custom-radio nowrap" ng-repeat="option in vm.displayData.key"><input type="radio" name="displayData" ng-model="vm.search.displayData" value="{{option}}" required="" ng-change="vm.handleDisplayDataChange(option)" ng-init="vm.search.displayData" ng-disabled="option === \'CLOSING\' && !vm.search.deviceSerialSearchText"> <span>{{vm.displayData[vm.getLang()][$index]}}</span></label></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="form-group" ng-if="vm.interval !== \'DAILY\'" ng-class="{\'has-error\': vm.searchForm.period.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.aggregatedSalesBy\' | translate }}</label><div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.aggregationPeriod.key"><input type="radio" name="period" ng-model="vm.search.period" value="{{option}}" required="" ng-disabled="option === \'CLOSING_DATE\' && (vm.search.granularity === \'DAILY\' || vm.search.displayData === \'CLOSING\')"> <span>{{vm.aggregationPeriod[vm.getLang()][$index]}}</span></label></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.moneyType\' | translate }}</label><ui-select multiple="" ng-model="vm.search.moneyTypes" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($item, vm.moneyTypesOptions)}}</span></ui-select-match><ui-select-choices repeat="item in vm.moneyTypesOptions.key | filter:$select.search"><span ng-bind-html="vm.getValueFromTypeKey(item, vm.moneyTypesOptions)"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.unitPrice\' | translate }}</label><ui-select multiple="" ng-model="vm.search.units" class="btn-group bootstrap-select form-control" ng-disabled="vm.isUnitPriceDisabled" append-to-body="false" search-enabled="false"><ui-select-match><span>{{ $item }}</span></ui-select-match><ui-select-choices repeat="item in vm.unitPrices | filter:$select.search"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.deviceSerial\' | translate }}</label> <input type="text" class="form-control" ng-change="vm.handleDeviceSerialSearchTextChange(vm.search.displayData)" ng-model="vm.search.deviceSerialSearchText" maxlength="200"></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.applicationSerial\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.search.applicationSerialNumberText" maxlength="200"></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.installationLocation\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.search.installationLocationText" maxlength="200"></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.remarks\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.search.remarksText" maxlength="200"></div></div><div class="row"><div class="col-md-12"><button type="submit" class="btn btn-primary pull-right" ng-click="vm.listMonthlySales()" ng-disabled="vm.inProgress">{{\'salesSettlements.monthly.list.search.showData\' | translate }} <i class="inProgress m-l-10" ng-if="vm.inProgress"></i></button></div></div></div></div></form></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.showTable && !vm.isLoading"><div class="m-b-10 navigateMonths m-t-10"><button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'FIRST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'PREV\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-left"></i></button><div class="date"><span ng-if="vm.query.interval === \'MONTHLY\'">{{vm.query.date | date: \'yyyy/MM\'}}</span> <span ng-if="vm.query.interval === \'DAILY\'">{{vm.query.date | date: \'yyyy/MM/dd\'}}</span></div><button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'NEXT\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'LAST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.downloadCsv()" ng-hide="vm.inProgress || !vm.showDownload"><i class="fa fa-download"></i></button></div><div ng-if="vm.search.displayData === \'CLOSING\' && vm.showTable && !vm.isLoading" class="align-right m-t-10 m-r-10 m-b-10 m-l-10"><button class="btn btn-primary m-r-5" ng-click="vm.addClosingInformation()" ng-disabled="vm.addClosing === false">{{\'salesSettlements.monthly.list.search.addClosingInformation\' | translate }}</button> <button class="btn btn-primary" ng-click="vm.toggleClosingInformation()" ng-disabled="!vm.isOneItemCheckboxSelected() || baUtil.isUndefinedOrNullOrEmptyList(vm.tableData)">{{\'salesSettlements.monthly.list.search.toggleClosingInformation\' | translate }}</button></div><div class="table-responsive m-t-10"><table class="table salesTable"><thead><tr><th ng-if="vm.search.displayData === \'CLOSING\'" style="min-width: unset; text-align: center; justify-content: center;"><label class="custom-checkbox nowrap"><input style="border-color: black !important;" type="checkbox" ng-model="vm.selectAllOneItemCheckboxes" ng-click="vm.selectAllOneItemCheckbox($event, vm.tableData)"> <span></span></label></th><th style="min-width: unset; text-align: center; justify-content: center;" ng-if="vm.search.displayData === \'CLOSING\'">#</th><th style="min-width: unset; max-width: min-content;" class="text-center" ng-repeat="key in vm.tableHeaders[vm.getLang()]">{{key}}</th></tr></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.tableData)"><td class="nodata" colspan="{{vm.tableHeaders[vm.getLang()].length}}">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate }}</td></tr><tr ng-style="vm.getRowStyle(data)" ng-if="!vm.baUtil.isUndefinedOrNullOrEmptyList(vm.tableData)" ng-repeat="data in vm.tableData" track="" by="" $index=""><td ng-if="vm.search.displayData === \'CLOSING\'" style="min-width: unset; text-align: center; align-self: center; justify-content: center;"><label class="custom-checkbox"><input type="checkbox" style="border-color: black !important;" ng-model="vm.selectedOneItemCheckboxRequests[data.basicInfoId]" ng-click="vm.selectSingleOneItemCheckbox($event, vm.tableData)"> <span></span></label></td><td ng-if="vm.search.displayData === \'CLOSING\'" style="min-width: unset; text-align: center; justify-content: center;">{{vm.paymentDetail.closingInfoDtos.pageable.offset + $index + 1}}</td><td style="min-width: unset; max-width: min-content;" ng-repeat="column in vm.columns"><div ng-if="column !== \'date\' && column !== \'processResult\' && column !== \'processType\' && column !== \'moneyType\' && column !== \'startTime\' && column !== \'dateCreated\' && column != \'salesCenter\' && column != \'closingStatus\'" ng-bind-html="data[column]"></div><div ng-if="column === \'moneyType\'" ng-bind-html="vm.getPaymentLabelFromKey(data[column])"></div><div ng-if="column === \'processResult\'" ng-bind-html="vm.getProcessResultFromKey(data[column])"></div><div ng-if="column === \'processType\'" ng-bind-html="vm.getProcessTypeFromKey(data[column])"></div><div ng-if="column === \'date\' || column === \'startTime\' || column === \'dateCreated\'"><div>{{data[column] | date: \'yyyy/MM/dd\'}}</div><div>{{data[column] | date: \'HH:mm:ss\'}}</div></div><div ng-if="column === \'salesCenter\'" style="white-space: pre-line;">{{data[column]}}</div><div ng-if="column === \'closingStatus\'">{{data[column] === \'Valid\'? (vm.getLang() === \'en\'? \'Active\' : \'\u6709\u52B9\') : (vm.getLang() === \'en\'?\'Inactive\': \'\u7121\u52B9\')}}</div></td></tr></tbody></table></div><div class="padding-20"><pagination query="vm.query" pageable="vm.paymentDetail.pageable" total-pages="vm.paymentDetail.totalPages" total-elements="vm.paymentDetail.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div>');
$templateCache.put('app/pages/sales-settlements/views/sales-list.html','<div form="vm.searchForm"><form name="vm.searchForm" novalidate=""><div class="panel panel-default bootstrap-panel"><div class="panel-heading" ng-if="vm.interval === \'MONTHLY\'">{{\'salesSettlements.monthly.list.search.title\' | translate }}</div><div class="panel-heading" ng-if="vm.interval === \'DAILY\'">{{\'salesSettlements.daily.title\' | translate }}</div><div class="panel-body filterQueryForm"><div class="form-group" ng-class="{\'has-error\': vm.searchForm.organisationName.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.organization\' | translate }}</label><ui-select ng-model="vm.selectedOrg" class="btn-group bootstrap-select form-control" name="organisationName" ng-disabled="vm.isMerchant" append-to-body="false" search-enabled="false" ng-change="vm.updateBranchOffice()" ng-required="true"><ui-select-match><span>{{$select.selected.name}} ({{$select.selected.merchantCode}})</span></ui-select-match><ui-select-choices repeat="org in vm.allMerchants track by $index"><span ng-bind-html="(org.name) + \' (\' + (org.merchantCode) + \')\'"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.salesOffice\' | translate }}</label><ui-select ng-model="vm.search.branch" class="btn-group bootstrap-select form-control" name="branchCode" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{$select.selected.value}} <span ng-if="$select.selected.key != \'Total\'">({{$select.selected.key}})</span></span></ui-select-match><ui-select-choices repeat="(key, obj) in vm.salesBranch"><span>{{obj.value}} <span ng-if="obj.key != \'Total\'">({{obj.key}})</span></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="form-input-group-row labelXXXL" ng-if="vm.interval !== \'DAILY\'"><label>{{\'salesSettlements.monthly.list.search.month\' | translate }}</label><datepicker date="vm.search.date" required="true" format="vm.dateFormat" form="vm.searchForm" options="vm.dateOptions"></datepicker></div><div class="form-input-group-row labelXXXL" ng-if="vm.interval === \'DAILY\'"><label>{{\'salesSettlements.monthly.list.search.date\' | translate }}</label><datepicker date="vm.search.date" required="true" form="vm.searchForm"></datepicker></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.productName\' | translate }}</label><ui-select multiple="" ng-model="vm.search.productNames" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" ng-change="vm.handleProductNameChange(vm.search.productNames)"><ui-select-match><span>{{vm.getValueFromTypeKey($item, vm.productNameOptions)}}</span></ui-select-match><ui-select-choices repeat="item in vm.productNameOptions.key | filter:$select.search"><span ng-bind-html="vm.getValueFromTypeKey(item, vm.productNameOptions)"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.deviceSerial\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.search.deviceSerialSearchText" maxlength="200"></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.applicationSerial\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.search.applicationSerialNumberText" maxlength="200"></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.installationLocation\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.search.installationLocationText" maxlength="200"></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.remarks\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.search.remarksText" maxlength="200"></div></div><div class="form-group" ng-if="vm.interval !== \'DAILY\'"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.aggregatedSalesBy\' | translate }}</label><div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.aggregationPeriod.key"><input type="radio" name="period" ng-model="vm.search.period" value="{{option}}" required="" ng-disabled="option === \'CLOSING_DATE\' && vm.search.granularity === \'DAILY\'"> <span>{{vm.aggregationPeriod[vm.getLang()][$index]}}</span></label></div></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.searchForm.granularity.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.granularity\' | translate }}</label><div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.AggregationEntityType.key" ng-if="!(option === \'DAILY\' && vm.interval === \'DAILY\')"><input type="radio" name="granularity" ng-model="vm.search.granularity" value="{{option}}" required="" ng-disabled="!(option === \'DEVICE\') && vm.isProductNameSelected === true || vm.search.period === \'CLOSING_DATE\' && option ===\'DAILY\'"> <span>{{vm.types.AggregationEntityType[vm.getLang()][$index]}}</span></label></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'salesSettlements.monthly.list.search.option\' | translate }}</label><div><div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.unitPrice" name="unitPriceCheck"> <span>{{\'salesSettlements.monthly.list.search.option.unitprice\' | translate }}</span></label></div></div></div></div><div class="row"><div class="col-md-7"><label class="text10">{{\'salesSettlements.notes01\' | translate }}</label> <label class="text10" ng-if="vm.interval === \'MONTHLY\'">{{\'salesSettlements.notes02\' | translate }}</label></div><div class="col-md-5"><button type="submit" class="btn btn-primary pull-right" ng-click="vm.validateListMonthlySales()" ng-disabled="vm.inProgress">{{\'salesSettlements.monthly.list.search.showData\' | translate }} <i class="inProgress m-l-10" ng-if="vm.inProgress"></i></button> <button ng-if="vm.interval === \'MONTHLY\' && vm.isDownloadReportsEnabled" type="button" class="btn btn-primary pull-right m-r-15" ng-click="vm.navigateToDownloadReports()">{{\'salesSettlements.monthly.list.search.downloadReports\' | translate }}</button></div></div></div></div></form><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.showTable && !vm.unitPriceAggregation"><div ng-if="vm.tableHeaders[1] === vm.tableOptions.deviceSerial[vm.getLang()] && vm.salesStats && vm.salesStats.replacedDeviceCount" class="pull-left m-l-20"><div>{{\'salesSettlements.deviceSerialNumber\' | translate}}</div><div><span class="legend green"></span> {{ \'salesSettlements.after.replacement\' | translate}}</div><div><span class="legend red"></span> {{ \'salesSettlements.before.replacement\' | translate}}</div></div><div><div class="m-b-10 navigateMonths m-t-10"><button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'FIRST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'PREV\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-left"></i></button><div class="date"><span ng-if="vm.interval === \'MONTHLY\'">{{vm.query.date | date: \'yyyy/MM\'}}</span> <span ng-if="vm.interval === \'DAILY\'">{{vm.query.date | date: \'yyyy/MM/dd\'}}</span></div><button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'NEXT\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'LAST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.downloadAggCsv()" ng-hide="vm.inProgress"><i class="fa fa-download"></i></button></div><div class="table-responsive"><table class="table salesTable"><thead><tr><th class="text-center" ng-repeat="key in vm.tableHeaders track by $index"><span ng-if="vm.columns[$index] === \'endDate\'">{{key}} <a class="m-no-error" title="{{\'salesSettlements.closing.date.info\' | translate }}"><i class="fa fa-info-circle"></i></a></span> <span ng-if="vm.columns[$index] !== \'endDate\'">{{key}}</span></th></tr></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.tableData)"><td class="nodata" colspan="{{vm.tableHeaders.length}}">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate }}</td></tr><tr ng-if="!vm.baUtil.isUndefinedOrNullOrEmptyList(vm.tableData)" ng-repeat="data in vm.tableData track by $index"><td ng-repeat="column in vm.columns track by $index"><div ng-if="(column !== \'numberOfDevices\' && vm.query.type === \'BRANCH\') || vm.query.type === \'DEVICE\'"><div ng-if="column !== \'endDate\' && column !== \'startDate\'" ng-bind-html="data[column]"></div><div ng-if="column === \'endDate\' || column === \'startDate\'"><div ng-show="data[column] === \'-\'"><div>-</div></div><div ng-show="data[column] !== \'-\'"><div>{{data[column] | date: \'shortDate\'}}</div><div>{{data[column] | date: \'mediumTime\'}}</div></div></div></div><div ng-if="column === \'numberOfDevices\' && vm.query.type === \'BRANCH\'"><span ng-if="data[column] === \'Total\'" ng-bind-html="data[column]" class="p-r-10"></span> <button class="btn btn-link" ng-if="data[column] !== \'Total\'" ng-click="vm.getBranchData(data)" ng-bind-html="data[column]"></button></div><div ng-if="vm.query.type === \'DAILY\'"><span ng-bind-html="data[column]"></span></div></td></tr></tbody></table></div><div class="padding-20"><pagination query="vm.query" pageable="vm.salesList.pageable" total-pages="vm.salesList.totalPages" total-elements="vm.salesList.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div></div><div class="loader" ng-if="vm.isBranchLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.showBranchTable && !vm.unitPriceAggregation"><div ng-if="vm.salesStats && vm.salesStats.replacedDeviceCount" class="pull-left m-l-20"><div>{{\'salesSettlements.deviceSerialNumber\' | translate}}</div><div><span class="legend green"></span> {{ \'salesSettlements.after.replacement\' | translate}}</div><div><span class="legend red"></span> {{ \'salesSettlements.before.replacement\' | translate}}</div></div><div><div class="navigateMonths m-t-10"><button class="btn btn-icon m-l-5" ng-click="vm.downloadAggDetailCsv()" ng-hide="vm.inProgress" ng-if="!vm.isLoading && vm.showBranchTable"><i class="fa fa-download"></i></button></div><div class="table-responsive" ng-if="vm.showBranchTable"><table class="table salesTable"><thead><tr><th class="text-center" ng-repeat="key in vm.branchTableHeaders track by $index"><span ng-if="vm.branchColumns[$index] === \'endDate\'">{{key}} <a class="m-no-error" title="{{\'salesSettlements.closing.date.info\' | translate }}"><i class="fa fa-info-circle"></i></a></span> <span ng-if="vm.branchColumns[$index] !== \'endDate\'">{{key}}</span></th></tr></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.branchTableData)"><td class="nodata" colspan="{{vm.branchTableHeaders.length}}">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate }}</td></tr><tr ng-if="!vm.baUtil.isUndefinedOrNullOrEmptyList(vm.branchTableData)" ng-repeat="data in vm.branchTableData track by $index"><td ng-repeat="column in vm.branchColumns track by $index"><div ng-bind-html="data[column]"></div><div ng-if="data[column] === undefined || data[column] === \'\'"><a href="#/main/sales/one-item/detail/">0 \u4EF6 /0 \u5186</a></div></td></tr></tbody></table></div><div class="padding-20"><pagination query="vm.branchQuery" pageable="vm.branchData.pageable" total-pages="vm.branchData.totalPages" total-elements="vm.branchData.totalElements" paginate-callback="vm.paginateCallbackBranch"></pagination></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.showTable && vm.unitPriceAggregation"><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div><div ng-if="vm.tableHeaders[1] === vm.tableOptions.deviceSerial[vm.getLang()] && vm.salesStats && vm.salesStats.replacedDeviceCount" class="pull-left m-l-20"><div>{{\'salesSettlements.deviceSerialNumber\' | translate}}</div><div><span class="legend green"></span> {{ \'salesSettlements.after.replacement\' | translate}}</div><div><span class="legend red"></span> {{ \'salesSettlements.before.replacement\' | translate}}</div></div><div><div class="m-b-10 navigateMonths m-t-10"><button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'FIRST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'PREV\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-left"></i></button><div class="date"><span ng-if="vm.interval === \'MONTHLY\'">{{vm.query.date | date: \'yyyy/MM\'}}</span> <span ng-if="vm.interval === \'DAILY\'">{{vm.query.date | date: \'yyyy/MM/dd\'}}</span></div><button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'NEXT\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'LAST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.downloadAggCsvUnitPrice()" ng-hide="vm.inProgress"><i class="fa fa-download"></i></button></div><div class="table-responsive"><table class="table salesTable unitPriceSalesTable"><thead></thead><tbody><tr ng-repeat="row in vm.tableData[0].dataRowHeader track by $index" ng-bind-html="row"></tr><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.tableData[0].dataRow)"><td class="nodata" colspan="{{vm.tableHeaders.length}}">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate }}</td></tr><tr ng-if="!vm.baUtil.isUndefinedOrNullOrEmptyList(vm.tableData[0].dataRow)" ng-repeat="row in vm.tableData track by $index" ng-bind-html="row.dataRow"></tr></tbody></table></div><div class="padding-20"><pagination query="vm.query" pageable="vm.salesList.pageable" total-pages="vm.salesList.totalPages" total-elements="vm.salesList.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div></div><div class="loader" ng-if="vm.isUnitBranchLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.showUnitPriceBranchTable && vm.unitPriceAggregation"><div ng-if="vm.salesStats && vm.salesStats.replacedDeviceCount" class="pull-left m-l-20"><div>{{\'salesSettlements.deviceSerialNumber\' | translate}}</div><div><span class="legend green"></span> {{ \'salesSettlements.after.replacement\' | translate}}</div><div><span class="legend red"></span> {{ \'salesSettlements.before.replacement\' | translate}}</div></div><div><div class="navigateMonths m-t-10"><button class="btn btn-icon m-l-5" ng-click="vm.downloadAggDetailCsvUnitPrice()" ng-hide="vm.inProgress" ng-if="vm.showUnitPriceBranchTable"><i class="fa fa-download"></i></button></div><div class="table-responsive" ng-if="vm.showUnitPriceBranchTable"><table class="table salesTable unitPriceSalesTable"><thead></thead><tbody><tr ng-if="vm.baUtil.isUndefinedOrNullOrEmptyList(vm.branchTableData[0].dataRow)"><td class="nodata" colspan="{{vm.branchTableHeaders.length}}">{{\'salesSettlements.monthly.list.searchResult.noResults\' | translate }}</td></tr><tr ng-repeat="key in vm.branchTableData[0].dataRowHeader track by $index" ng-bind-html="key"></tr><tr ng-if="!vm.baUtil.isUndefinedOrNullOrEmptyList(vm.branchTableData[0].dataRow)" ng-repeat="data in vm.branchTableData track by $index" ng-bind-html="data.dataRow"></tr></tbody></table></div><div class="padding-20"><pagination query="vm.branchQuery" pageable="vm.branchData.pageable" total-pages="vm.branchData.totalPages" total-elements="vm.branchData.totalElements" paginate-callback="vm.paginateCallbackBranch"></pagination></div></div></div></div><script>\n\n</script>');
$templateCache.put('app/pages/sales-settlements/views/settlement-detail.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'settlementsAndInvoices.detail.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-sm-6"><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'settlementsAndInvoices.detail.form.merchantName\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.query.name" disabled=""></div></div></div><div class="col-sm-6"><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'settlementsAndInvoices.detail.form.contractId\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.query.contractId" disabled=""></div></div></div></div><div class="form-group settlementDateWrap"><div class="form-input-group-row labelXXXL"><label>{{\'settlementsAndInvoices.detail.form.date\' | translate }}</label><datepicker date="vm.date" format="vm.dateFormat" options="vm.dateOptions"></datepicker></div></div><div class="clearfix"><button type="submit" class="btn btn-primary pull-right" ng-click="vm.getData()" ng-disabled="vm.dataInProgress">{{\'settlementsAndInvoices.detail.form.showData\' | translate }} <i class="inProgress m-l-10" ng-if="vm.dataInProgress"></i></button></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="!vm.showSettlementBranchTable && !vm.showSettlementDeviceTable && !vm.showInvoiceBranchTable && !vm.showInvoiceDeviceTable && !vm.isLoading"><div ng-if="vm.query.invoiceMethod == \'HEADQUARTERS\'"><div class="clearfix panel-heading">{{\'settlementsAndInvoices.detail.card.settlement.title\' | translate }}</div><div class="panel-body settlementDetailAction"><div class="row m-b-20"><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSettlement()" ng-disabled="vm.viewSettlementInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.settlement.action.display\' | translate }} <i class="inProgress m-l-10" ng-if="vm.viewSettlementInProgress"></i></button></div><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSettlement(true)" ng-disabled="vm.downloadSettlementInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.settlement.action.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadSettlementInProgress"></i></button></div></div><div ng-if="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)"><div class="padding-20 text-center">{{\'settlementsAndInvoices.list.noData\' | translate }}</div></div><div class="row m-b-20" ng-if="vm.settlementByDeviceBtnEnable"><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.displaySettlementByDevice()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.invoice.action.displayDevice\' | translate }}</button></div><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.getSettlementByDevice(true)" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.invoice.action.downloadByDeviceCSV\' | translate }}</button></div><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-if="vm.settlementByDeviceOwnerBtnEnable" ng-click="vm.downloadByDeviceOwnerByDevice()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement) || vm.isDownloadingDetailsByDeviceOwner">{{\'settlementsAndInvoices.detail.card.settlement.action.downloadDetailsByDeviceOwnerByDevice\' | translate }} &nbsp;<i class="inProgress m-l-5" ng-if="vm.isDownloadingDetailsByDeviceOwner"></i></button></div></div><div class="row"><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.displaySettlementByBranch()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.settlement.action.displayBranch\' | translate }}</button></div><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSettlementCSV()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.settlement.action.downloadCSV\' | translate }}</button></div></div></div></div><div ng-if="vm.query.invoiceMethod == \'BRANCH\'"><div ng-if="vm.settlement"><div class="clearfix panel-heading"><span class="m-t-10 pull-left">{{\'settlementsAndInvoices.detail.card.settlement.title\' | translate }}</span><div class="m-l-20 pull-right"><button type="submit" class="btn btn-primary m-r-20" ng-click="vm.downloadSettlementBranch()" ng-disabled="!vm.isSettlementSelected() || vm.viewSettlementInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.settlement.action.display\' | translate }} <i class="inProgress m-l-10" ng-if="vm.viewSettlementInProgress"></i></button> <button type="submit" class="btn btn-primary" ng-click="vm.downloadSettlementBranch(true)" ng-disabled="!vm.isSettlementSelected() || vm.downloadSettlementInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.settlement.action.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadSettlementInProgress"></i></button></div><div class="m-l-20 pull-right" ng-if="vm.settlementByDeviceBtnEnable"><button type="submit" class="btn btn-primary" ng-click="vm.getSettlementByDevice(true)" ng-disabled="!vm.isSettlementSelected() || baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.invoice.action.downloadByDeviceCSV\' | translate }}</button></div><div class="m-l-20 pull-right" ng-if="vm.settlementByDeviceBtnEnable"><button type="submit" class="btn btn-primary" ng-click="vm.displaySettlementByDevice()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement) || !vm.isSettlementSelected()">{{\'settlementsAndInvoices.detail.card.invoice.action.displayDevice\' | translate }}</button></div><div class="m-l-20 pull-right" ng-if="vm.settlementByDeviceOwnerBtnEnable"><button type="submit" class="btn btn-primary" ng-click="vm.downloadByDeviceOwnerByDevice()" ng-disabled="!vm.isSettlementSelected() || baUtil.isUndefinedOrNullOrEmptyList(vm.settlement) || vm.isDownloadingDetailsByDeviceOwner">{{\'settlementsAndInvoices.detail.card.settlement.action.downloadDetailsByDeviceOwnerByDevice\' | translate }} &nbsp;<i class="inProgress m-l-5" ng-if="vm.isDownloadingDetailsByDeviceOwner"></i></button></div></div><div class="panel-body"><div ng-if="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)"><div class="padding-20 text-center">{{\'settlementsAndInvoices.list.noData\' | translate }}</div></div><div class="table-responsive" ng-if="!baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)"><table class="table settlementTable"><tr><th style="width: 5%"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectSettlement" ng-click="vm.selectAllSettlement($event, vm.settlement)"> <span></span></label></th><th style="width: 25%">{{\'settlementsAndInvoices.list.card.settlement.table.merchantName\' | translate }}</th><th style="width: 25%">{{\'settlementsAndInvoices.list.card.settlement.table.branchName\' | translate }}</th><th style="width: 25%">{{\'settlementsAndInvoices.list.card.settlement.table.branchCode\' | translate }}</th><th></th></tr><tr ng-repeat="settlement in vm.settlement"><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedSettlementRequests[settlement.settlementId]"> <span></span></label></td><td>{{settlement.merchantName}}</td><td>{{settlement.branchName}}</td><td>{{settlement.branchCode}}</td><td></td></tr></table></div><div class="clearfix"><div class="pull-right m-l-20"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSettlementCSV()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.settlement.action.downloadCSV\' | translate }}</button></div><div class="pull-right m-l-20"><button type="submit" class="btn btn-primary" ng-click="vm.displaySettlementByBranch()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.detail.card.settlement.action.displayBranch\' | translate }}</button></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.settlementDetail && vm.showSettlementBranchTable && !vm.isLoading"><div class="clearfix panel-heading"><span class="m-t-10 pull-left">{{\'settlementsAndInvoices.detail.card.settlement.branchDetail.title\' | translate }}</span><div ng-if="vm.statsLoading" class="m-l-20 m-t-10 pull-left">{{\'common.components.processing\' | translate}}</div><div ng-if="vm.settlementStats && vm.settlementStats.replacedDeviceCount" class="pull-left m-l-20"><div>{{\'salesSettlements.deviceSerialNumber\' | translate}}</div><div><span class="legend green"></span> {{ \'salesSettlements.after.replacement\' | translate}}</div><div><span class="legend red"></span> {{ \'salesSettlements.before.replacement\' | translate}}</div></div><div ng-if="vm.settlementStats" class="m-l-20 pull-left"><div>{{\'salesSettlements.devices.count\' | translate}}</div><div><span ng-if="vm.query.paymentMethod === \'OFFSETTING\'">{{\'salesSettlements.initial.fee\' | translate }} {{vm.settlementStats.deviceCountWithInitialFeeCharged}} ,</span> <span ng-if="vm.query.paymentMethod === \'OFFSETTING\'">{{\'salesSettlements.monthly.fee\' | translate }} {{vm.settlementStats.deviceCountWithMonthlyFeeCharged}} ,</span> <span>{{\'salesSettlements.replacement\' | translate }} {{vm.settlementStats.replacedDeviceCount}} ,</span> <span>{{\'salesSettlements.total.count\' | translate }} {{vm.settlementStats.totalDeviceCount}}</span></div></div><div class="pull-right"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSettlement(true)" ng-disabled="vm.downloadSettlementInProgress">{{\'settlementsAndInvoices.detail.card.settlement.branchDetail.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadSettlementInProgress"></i></button></div></div><div class="settlementDetails"><div class="table-responsive"><table class="table salesTable nowrap"><tr><th ng-repeat="key in vm.settlementTableHeaders[vm.getLang()] track by $index">{{key}}</th></tr><tr ng-repeat="data in vm.settlementTableData track by $index"><td ng-repeat="column in vm.settlementColumns track by $index"><div ng-compile="vm.getDeviceSerialHtml(data[column], data[\'branchCode\'], data[\'isReplacedOrSuspended\'])" ng-if="column === \'deviceSerial\'"></div><div ng-bind-html="data[column]" ng-if="column !== \'deviceSerial\'"></div><div ng-if="data[column] === undefined || data[column] === \'\'">0</div></td></tr></table></div></div><div class="padding-20"><pagination query="vm.settlementDataQuery" pageable="vm.settlementDetailInfo.pageable" total-pages="vm.settlementDetailInfo.totalPages" total-elements="vm.settlementDetailInfo.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.settlementDetail && vm.showSettlementDeviceTable && !vm.isLoading"><div class="clearfix panel-heading"><span class="m-t-10 m-r-20 pull-left">{{\'settlementsAndInvoices.detail.card.settlement.branchDetail.title\' | translate }}</span><div ng-if="vm.statsLoading" class="m-l-20 m-t-10 pull-left">{{\'common.components.processing\' | translate}}</div><div ng-if="vm.settlementStats" class="pull-left m-r-20"><div>{{\'salesSettlements.deviceSerialNumber\' | translate}}</div><div><span class="legend green"></span> {{ \'salesSettlements.after.replacement\' | translate}}</div><div><span class="legend red"></span> {{ \'salesSettlements.before.replacement\' | translate}}</div></div><div ng-if="vm.settlementStats" class="pull-left"><div>{{\'salesSettlements.devices.count\' | translate}}</div><div><span ng-if="vm.query.paymentMethod === \'OFFSETTING\'">{{\'salesSettlements.initial.fee\' | translate }} {{vm.settlementStats.deviceCountWithInitialFeeCharged}} ,</span> <span ng-if="vm.query.paymentMethod === \'OFFSETTING\'">{{\'salesSettlements.monthly.fee\' | translate }} {{vm.settlementStats.deviceCountWithMonthlyFeeCharged}} ,</span> <span>{{\'salesSettlements.replacement\' | translate }} {{vm.settlementStats.replacedDeviceCount}} ,</span> <span>{{\'salesSettlements.total.count\' | translate }} {{vm.settlementStats.totalDeviceCount}}</span></div></div><div class="pull-right"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSettlement(true)" ng-disabled="vm.downloadSettlementInProgress">{{\'settlementsAndInvoices.detail.card.settlement.branchDetail.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadSettlementInProgress"></i></button></div></div><div class="settlementDetails"><div class="table-responsive"><table class="table salesTable nowrap"><tr><th ng-repeat="key in vm.settlementTableOfDeviceHeaders[vm.getLang()] track by $index">{{key}}</th></tr><tr ng-repeat="data in vm.settlementTableOfDeviceData track by $index"><td ng-repeat="column in vm.settlementOfDeviceColumns track by $index"><div ng-compile="vm.getDeviceSerialHtml(data[column], data[\'branchCode\'], data[\'isReplacedOrSuspended\'])" ng-if="column === \'deviceSerial\'"></div><div ng-bind-html="data[column]" ng-if="column !== \'deviceSerial\'"></div><div ng-if="data[column] === undefined || data[column] === \'\'">0</div></td></tr></table></div></div><div class="padding-20"><pagination query="vm.settlementDataQuery" pageable="vm.settlementDetailInfo.pageable" total-pages="vm.settlementDetailInfo.totalPages" total-elements="vm.settlementDetailInfo.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div><div><div class="panel panel-default bootstrap-panel" ng-if="!vm.showSettlementBranchTable && !vm.showSettlementDeviceTable && !vm.showInvoiceBranchTable && !vm.showInvoiceDeviceTable && !vm.isLoading"><div ng-if="vm.query.invoiceMethod == \'HEADQUARTERS\'"><div class="clearfix panel-heading">{{\'settlementsAndInvoices.detail.card.invoice.title\' | translate }}</div><div class="panel-body settlementDetailAction"><div class="row m-b-20"><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.downloadInvoice()" ng-disabled="vm.viewInvoiceInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.display\' | translate }} <i class="inProgress m-l-10" ng-if="vm.viewInvoiceInProgress"></i></button></div><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.downloadInvoice(true)" ng-disabled="vm.downloadInvoiceInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInvoiceInProgress"></i></button></div></div><div ng-if="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)"><div class="padding-20 text-center">{{\'settlementsAndInvoices.list.noData\' | translate }}</div></div><div class="row m-b-20" ng-if="vm.afterSeptemberEnable"><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.displayInvoiceByDevice()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.displayDevice\' | translate }}</button></div><div class="col-sm-4" ng-if="vm.afterSeptemberEnable"><button type="submit" class="btn btn-primary" ng-click="vm.getInvoicebyDevice(true)" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.downloadByDeviceCSV\' | translate }}</button></div></div><div class="row"><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.displayInvoiceByBranch()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.displayBranch\' | translate }}</button></div><div class="col-sm-4"><button type="submit" class="btn btn-primary" ng-click="vm.downloadInvoiceCSV()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.downloadCSV\' | translate }}</button></div></div></div></div><div ng-if="vm.query.invoiceMethod == \'BRANCH\'"><div ng-if="vm.invoice"><div class="clearfix panel-heading"><span class="m-t-10 pull-left">{{\'settlementsAndInvoices.detail.card.invoice.title\' | translate }}</span><div class="m-l-20 pull-right"><button type="submit" class="btn btn-primary m-r-20" ng-click="vm.downloadInvoiceBranch()" ng-disabled="!vm.isInvoiceSelected() || vm.viewInvoiceInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.display\' | translate }} <i class="inProgress m-l-10" ng-if="vm.viewInvoiceInProgress"></i></button> <button type="submit" class="btn btn-primary" ng-click="vm.downloadInvoiceBranch(true)" ng-disabled="!vm.isInvoiceSelected() || vm.downloadInvoiceInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInvoiceInProgress"></i></button></div><div class="m-l-20 pull-right" ng-if="vm.afterSeptemberEnable"><button type="submit" class="btn btn-primary" ng-click="vm.getInvoicebyDevice(true)" ng-disabled="!vm.isInvoiceSelected() || baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.downloadByDeviceCSV\' | translate }}</button></div><div class="m-l-20 pull-right" ng-if="vm.afterSeptemberEnable"><button type="submit" class="btn btn-primary" ng-click="vm.displayInvoiceByDevice()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice) || !vm.isInvoiceSelected()">{{\'settlementsAndInvoices.detail.card.invoice.action.displayDevice\' | translate }}</button></div></div><div class="panel-body"><div ng-if="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)"><div class="padding-20 text-center">{{\'settlementsAndInvoices.list.noData\' | translate }}</div></div><div class="table-responsive" ng-if="!baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)"><table class="table settlementTable"><tr><th style="width: 5%"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectInvoice" ng-click="vm.selectAllInvoice($event, vm.invoice)"> <span></span></label></th><th style="width: 25%">{{\'settlementsAndInvoices.list.card.invoice.table.merchantName\' | translate }}</th><th style="width: 25%">{{\'settlementsAndInvoices.list.card.invoice.table.branchName\' | translate }}</th><th style="width: 25%">{{\'settlementsAndInvoices.list.card.invoice.table.branchCode\' | translate }}</th><th></th></tr><tr ng-repeat="invoice in vm.invoice"><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedInvoiceRequests[invoice.invoiceId]"><span></span></label></td><td>{{invoice.merchantName}}</td><td>{{invoice.branchName}}</td><td>{{invoice.branchCode}}</td><td></td></tr></table></div><div class="clearfix m-t-20"><div class="m-l-20 pull-right"><button type="submit" class="btn btn-primary" ng-click="vm.downloadInvoiceCSV()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.downloadCSV\' | translate }}</button></div><div class="m-l-20 pull-right"><button type="submit" class="btn btn-primary" ng-click="vm.displayInvoiceByBranch()" ng-disabled="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.detail.card.invoice.action.displayBranch\' | translate }}</button></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.invoiceDetail && vm.showInvoiceBranchTable && !vm.showInvoiceDeviceTable && !vm.isLoading"><div class="clearfix panel-heading"><span class="m-t-10 pull-left">{{\'settlementsAndInvoices.detail.card.invoice.branchDetail.title\' | translate }}</span><div ng-if="vm.statsLoading" class="m-l-20 m-t-10 pull-left">{{\'common.components.processing\' | translate}}</div><div ng-if="vm.settlementStats" class="m-l-20 pull-left"><div>{{\'salesSettlements.devices.count\' | translate}}</div><div><span>{{\'salesSettlements.initial.fee\' | translate }} {{vm.settlementStats.deviceCountWithInitialFeeCharged}} ,</span> <span>{{\'salesSettlements.monthly.fee\' | translate }} {{vm.settlementStats.deviceCountWithMonthlyFeeCharged}} ,</span> <span>{{\'salesSettlements.replacement\' | translate }} {{vm.settlementStats.replacedDeviceCount}} ,</span> <span>{{\'salesSettlements.total.count\' | translate }} {{vm.settlementStats.totalDeviceCount}}</span></div></div><div class="pull-right"><button type="submit" class="btn btn-primary" ng-click="vm.downloadInvoice(true)" ng-disabled="vm.downloadInvoiceInProgress">{{\'settlementsAndInvoices.detail.card.invoice.branchDetail.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInvoiceInProgress"></i></button></div></div><div class="settlementDetails"><div class="table-responsive"><table class="table salesTable nowrap"><tr><th ng-repeat="key in vm.invoiceTableHeaders[vm.getLang()] track by $index">{{key}}</th></tr><tr ng-repeat="data in vm.invoiceTableData track by $index"><td ng-repeat="column in vm.invoiceColumns track by $index"><div ng-bind-html="data[column]"></div></td></tr></table></div></div><div class="padding-20"><pagination query="vm.invoiceDataQuery" pageable="vm.invoiceDetailInfo.pageable" total-pages="vm.invoiceDetailInfo.totalPages" total-elements="vm.invoiceDetailInfo.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.invoiceDetail && vm.showInvoiceDeviceTable && !vm.showInvoiceBranchTable && !vm.isLoading"><div class="clearfix panel-heading"><span class="m-t-10 pull-left">{{\'settlementsAndInvoices.detail.card.invoice.branchDetail.title\' | translate }}</span><div ng-if="vm.statsLoading" class="m-l-20 m-t-10 pull-left">{{\'common.components.processing\' | translate}}</div><div ng-if="vm.settlementStats" class="pull-left m-l-20"><div>{{\'salesSettlements.deviceSerialNumber\' | translate}}</div><div><span class="legend green"></span> {{ \'salesSettlements.after.replacement\' | translate}}</div><div><span class="legend red"></span> {{ \'salesSettlements.before.replacement\' | translate}}</div></div><div ng-if="vm.settlementStats" class="m-l-20 pull-left"><div>{{\'salesSettlements.devices.count\' | translate}}</div><div><span>{{\'salesSettlements.initial.fee\' | translate }} {{vm.settlementStats.deviceCountWithInitialFeeCharged}} ,</span> <span>{{\'salesSettlements.monthly.fee\' | translate }} {{vm.settlementStats.deviceCountWithMonthlyFeeCharged}} ,</span> <span>{{\'salesSettlements.replacement\' | translate }} {{vm.settlementStats.replacedDeviceCount}} ,</span> <span>{{\'salesSettlements.total.count\' | translate }} {{vm.settlementStats.totalDeviceCount}}</span></div></div><div class="pull-right"><button type="submit" class="btn btn-primary" ng-click="vm.downloadInvoice(true)" ng-disabled="vm.downloadInvoiceInProgress">{{\'settlementsAndInvoices.detail.card.invoice.branchDetail.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInvoiceInProgress"></i></button></div></div><div class="settlementDetails"><div class="table-responsive"><table class="table salesTable nowrap"><tr><th ng-repeat="key in vm.invoiceTableOfDeviceHeaders[vm.getLang()] track by $index">{{key}}</th></tr><tr ng-repeat="data in vm.invoiceTableOfDeviceData track by $index"><td ng-repeat="column in vm.invoiceOfDeviceColumns track by $index"><div ng-compile="vm.getDeviceSerialHtml(data[column], data[\'branchCode\'], data[\'isReplacedOrSuspended\'])" ng-if="column === \'deviceSerial\'"></div><div ng-bind-html="data[column]" ng-if="column !== \'deviceSerial\'"></div><div ng-if="data[column] === undefined || data[column] === \'\'">0</div></td></tr></table></div></div><div class="padding-20"><pagination query="vm.invoiceDataQuery" pageable="vm.invoiceDetailInfo.pageable" total-pages="vm.invoiceDetailInfo.totalPages" total-elements="vm.invoiceDetailInfo.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div><div class="previewPdf" ng-if="vm.showPdf"><button class="btn btn-icon" ng-click="vm.hidePdf()"><i class="fa fa-times"></i></button><object ng-attr-data="{{vm.pdfUrl}}"></object></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div></div>');
$templateCache.put('app/pages/sales-settlements/views/settlement-list.html','<div class="panel panel-default bootstrap-panel" ng-if="vm.noServiceContract"><div class="panel-heading">{{\'settlementsAndInvoices.list.title\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="padding-20 text-center">{{\'settlementsAndInvoices.list.noData\' | translate }}</div></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.shoTemplate"><div class="panel-heading">{{\'settlementsAndInvoices.list.title\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="form-input-group-row noWrap settlementDateWrap"><label>{{\'settlementsAndInvoices.list.form.date\' | translate }}</label><datepicker date="vm.date" format="vm.dateFormat" options="vm.dateOptions"></datepicker></div></div><div class="clearfix"><button type="submit" class="btn btn-primary pull-right" ng-click="vm.getData()" ng-disabled="vm.dataInProgress">{{\'settlementsAndInvoices.list.form.showData\' | translate }} <i class="inProgress m-l-10" ng-if="vm.dataInProgress"></i></button></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.settlement && !vm.isLoading"><div class="clearfix panel-heading"><span class="m-t-10 pull-left">{{\'settlementsAndInvoices.list.card.settlement.title\' | translate }}</span><div class="pull-right"><button type="submit" class="btn btn-primary m-r-20" ng-click="vm.downloadSettlement()" ng-disabled="!vm.isSettlementSelected() || vm.viewSettlementInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.settlement) || vm.settlementLimitFifty">{{\'settlementsAndInvoices.list.card.settlement.action.display\' | translate }} <i class="inProgress m-l-10" ng-if="vm.viewSettlementInProgress"></i></button> <button type="submit" class="btn btn-primary" ng-click="vm.downloadSettlement(true)" ng-disabled="!vm.isSettlementSelected() || vm.downloadSettlementInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)">{{\'settlementsAndInvoices.list.card.settlement.action.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadSettlementInProgress"></i></button></div></div><div class="panel-body"><div ng-if="baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)"><div class="padding-20 text-center">{{\'settlementsAndInvoices.list.noData\' | translate }}</div></div><div class="table-responsive" ng-if="!baUtil.isUndefinedOrNullOrEmptyList(vm.settlement)"><table class="table settlementTable"><tr ng-if="vm.permissions.SALES.SUBMIT"><th style="width: 2%"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectSettlement" ng-click="vm.selectAllSettlement($event, vm.settlement)"> <span></span></label></th><th style="width: 8%">{{\'settlementsAndInvoices.list.card.settlement.table.contractId\' | translate }}</th><th style="width: 12%">{{\'settlementsAndInvoices.list.card.settlement.table.merchantName\' | translate }}</th><th style="width: 10%">{{\'settlementsAndInvoices.list.card.settlement.table.branchName\' | translate }}</th><th style="width: 6%">{{\'settlementsAndInvoices.list.card.settlement.table.expenses\' | translate }}</th><th style="width: 12%">{{\'settlementsAndInvoices.list.card.settlement.table.settlementDestination\' | translate }}</th><th style="width: 10%">{{\'settlementsAndInvoices.list.card.settlement.table.otherFee\' | translate }}</th><th style="width: 12%">{{\'settlementsAndInvoices.list.card.settlement.table.remarks\' | translate }}</th><th style="width: 14%">{{\'settlementsAndInvoices.list.card.settlement.table.otherFee2\' | translate }}</th><th style="width: 12%">{{\'settlementsAndInvoices.list.card.settlement.table.remarks2\' | translate }}</th><th style="min-width: 200px !important;">{{\'settlementsAndInvoices.list.card.settlement.table.adjustedAmount\' | translate }}</th><th style="width: 10%">{{\'settlementsAndInvoices.list.card.settlement.table.submit\' | translate }}</th><th style="width: 10%">{{\'settlementsAndInvoices.list.card.settlement.table.recalculate\' | translate }}</th></tr><tr ng-if="!vm.permissions.SALES.SUBMIT"><th><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectSettlement" ng-click="vm.selectAllSettlement($event, vm.settlement)"> <span></span></label></th><th>{{\'settlementsAndInvoices.list.card.settlement.table.contractId\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.settlement.table.merchantName\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.settlement.table.branchName\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.settlement.table.expenses\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.settlement.table.settlementDestination\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.settlement.action.display\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.settlement.action.download\' | translate }}</th></tr><tr ng-repeat="settlement in vm.settlement"><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedSettlementRequests[settlement.settlementId]" ng-click="vm.selectSingleSettlement($event, vm.settlement)"> <span></span></label></td><td>{{settlement.serviceContractId}}</td><td><a ng-href="{{::vm.getUrlForDetail(settlement, \'SETTLEMENT\')}}">{{settlement.merchantName}}</a></td><td><div ng-if="settlement.branchCode != \'Total\'">{{settlement.branchName}} <span ng-if="settlement.branchCode">({{settlement.branchCode}})</span></div><div ng-if="settlement.branchCode == \'Total\'">{{vm.getValueFromTypeKey(settlement.invoiceMethod, vm.InvoiceMethod)}}</div></td><td>{{vm.getValueFromTypeKey(settlement.paymentMethod, vm.PaymentMethod)}}</td><td>{{vm.getValueFromTypeKey(settlement.invoiceMethod, vm.InvoiceMethod)}}</td><td ng-if="vm.permissions.SALES.SUBMIT"><div ng-if="settlement.status != \'DRAFT\'">{{settlement.otherFeeTaxable}}</div><div ng-if="settlement.status == \'DRAFT\'"><input type="text" class="form-control" ng-model="settlement.otherFeeTaxable" numbers-only=""></div></td><td ng-if="vm.permissions.SALES.SUBMIT"><div ng-if="settlement.status != \'DRAFT\'" class="remarksWrap">{{settlement.otherRemarks1}}</div><div ng-if="settlement.status == \'DRAFT\'"><input type="text" class="form-control" ng-model="settlement.otherRemarks1" maxlength="100"></div></td><td ng-if="vm.permissions.SALES.SUBMIT"><div ng-if="settlement.status != \'DRAFT\'">{{settlement.otherTransferNonTaxable}}</div><div ng-if="settlement.status == \'DRAFT\'"><input type="text" class="form-control" ng-model="settlement.otherTransferNonTaxable" numbers-only=""></div></td><td ng-if="vm.permissions.SALES.SUBMIT"><div ng-if="settlement.status != \'DRAFT\'" class="remarksWrap">{{settlement.otherRemarks2}}</div><div ng-if="settlement.status == \'DRAFT\'"><input type="text" class="form-control" ng-model="settlement.otherRemarks2" maxlength="100"></div></td><td ng-if="!settlement.invoiceAdjustmentDto.enableAdjustedAmount"><div style="display: flex;"><div><input type="text" class="form-control" ng-model="settlement.invoiceAdjustmentDto.adjustedInvoiceAmountFormatted" disabled=""></div><div ng-if="settlement.invoiceAdjustmentDto.enableRevertAdjustmentBtn" class="btn btn-default m-l-10" ng-click="vm.revertAdjustedInvoice(settlement)"><i class="ion-trash-a"></i></div></div></td><td ng-if="settlement.invoiceAdjustmentDto.enableAdjustedAmount"><div><button ng-init="adjustedInvoiceDate=\'\';toogleOpen=false" type="button" class="btn btn-default" uib-datepicker-popup="{{vm.dateFormat}}" datepicker-options="vm.dateOptionsForAdjustAmount" ng-model="adjustedInvoiceDate" is-open="toogleOpen" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.adjustedInvoiceAmountChange(adjustedInvoiceDate, settlement)" ng-click="toogleOpen=!toogleOpen"><i class="glyphicon glyphicon-calendar"></i></button></div></td><td ng-if="vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary settSubmitBtn" ng-if="settlement.status == \'DRAFT\'" ng-click="vm.submitSettlementDraft(settlement)" ng-disabled="!vm.permissions.SALES.SUBMIT || vm.submitSettlementInProgress[settlement.settlementId]">{{\'settlementsAndInvoices.list.card.settlement.table.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.submitSettlementInProgress[settlement.settlementId]"></i></button> <button type="submit" class="btn btn-primary settSubmitBtn" ng-if="settlement.status == \'PUBLISHED\'" ng-click="vm.revertPublishedSettlement(settlement.settlementId)" ng-disabled="vm.submitSettlementInProgress[settlement.settlementId]">{{\'settlementsAndInvoices.list.card.settlement.table.revert\' | translate }} <i class="inProgress m-l-10" ng-if="vm.submitSettlementInProgress[settlement.settlementId]"></i></button></td><td ng-if="vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary settSubmitBtn" ng-if="settlement.status == \'DRAFT\'" ng-click="vm.recalculateDraftSettlement(settlement.settlementId)" ng-disabled="vm.recalculateSettlementInProgress[settlement.settlementId]">{{\'settlementsAndInvoices.list.card.settlement.table.recalculate\' | translate }} <i class="inProgress m-l-10" ng-if="vm.recalculateSettlementInProgress[settlement.settlementId]"></i></button></td><td ng-if="!vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSingleSettlement(false,settlement.settlementId)">{{\'settlementsAndInvoices.list.card.settlement.action.display\' | translate }}</button></td><td ng-if="!vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSingleSettlement(true,settlement.settlementId)">{{\'settlementsAndInvoices.list.card.settlement.action.download\' | translate }}</button></td></tr></table></div></div><div class="padding-20"><pagination query="vm.query" pageable="vm.settlementInfo.pageable" total-pages="vm.settlementInfo.totalPages" total-elements="vm.settlementInfo.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.invoice && !vm.isLoading"><div class="clearfix panel-heading"><span class="m-t-10 pull-left">{{\'settlementsAndInvoices.list.card.invoice.title\' | translate }}</span><div class="pull-right"><span ng-if="vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary m-r-20" ng-click="vm.emailInvoice()" ng-disabled="!vm.isInvoiceSelected() || baUtil.isUndefinedOrNullOrEmptyList(vm.invoice) || vm.invoiceLimitFifty || vm.emailInvoiceInProgress || vm.isEmailInvoiceDisabled()">{{\'settlementsAndInvoices.list.card.invoice.action.emailInvoice\' | translate }} <i class="inProgress m-l-10" ng-if="vm.emailInvoiceInProgress"></i></button></span> <button type="submit" class="btn btn-primary m-r-20" ng-click="vm.downloadInvoice()" ng-disabled="!vm.isInvoiceSelected() || vm.viewInvoiceInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.invoice) || vm.invoiceLimitFifty">{{\'settlementsAndInvoices.list.card.invoice.action.display\' | translate }} <i class="inProgress m-l-10" ng-if="vm.viewInvoiceInProgress"></i></button> <button type="submit" class="btn btn-primary" ng-click="vm.downloadInvoice(true)" ng-disabled="!vm.isInvoiceSelected() || vm.downloadInvoiceInProgress || baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)">{{\'settlementsAndInvoices.list.card.invoice.action.download\' | translate }} <i class="inProgress m-l-10" ng-if="vm.downloadInvoiceInProgress"></i></button></div></div><div class="panel-body"><div ng-if="baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)"><div class="padding-20 text-center">{{\'settlementsAndInvoices.list.noData\' | translate }}</div></div><div class="table-responsive" ng-if="!baUtil.isUndefinedOrNullOrEmptyList(vm.invoice)"><table class="table settlementTable"><tr ng-if="vm.permissions.SALES.SUBMIT"><th style="width: 2%"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectInvoice" ng-click="vm.selectAllInvoice($event, vm.invoice)"> <span></span></label></th><th>{{\'settlementsAndInvoices.list.card.invoice.table.contractId\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.table.merchantName\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.table.branchName\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.table.expenses\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.table.settlementDestination\' | translate }}</th><th ng-if="vm.permissions.SALES.SUBMIT">{{\'settlementsAndInvoices.list.card.invoice.table.otherFee\' | translate }}</th><th ng-if="vm.permissions.SALES.SUBMIT">{{\'settlementsAndInvoices.list.card.invoice.table.remarks\' | translate }}</th><th ng-if="vm.permissions.SALES.SUBMIT">{{\'settlementsAndInvoices.list.card.invoice.table.otherFee2\' | translate }}</th><th ng-if="vm.permissions.SALES.SUBMIT">{{\'settlementsAndInvoices.list.card.invoice.table.remarks2\' | translate }}</th><th ng-if="vm.permissions.SALES.SUBMIT">{{\'settlementsAndInvoices.list.card.invoice.table.submit\' | translate }}</th><th ng-if="vm.permissions.SALES.SUBMIT">{{\'settlementsAndInvoices.list.card.invoice.table.recalculate\' | translate }}</th><th ng-if="vm.permissions.SALES.SUBMIT">{{\'settlementsAndInvoices.list.card.invoice.table.sendingStatus\' | translate }}</th></tr><tr ng-if="!vm.permissions.SALES.SUBMIT"><th><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectInvoice" ng-click="vm.selectAllInvoice($event, vm.invoice)"> <span></span></label></th><th>{{\'settlementsAndInvoices.list.card.invoice.table.contractId\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.table.merchantName\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.table.branchName\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.table.expenses\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.table.settlementDestination\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.action.display\' | translate }}</th><th>{{\'settlementsAndInvoices.list.card.invoice.action.download\' | translate }}</th></tr><tr ng-repeat="invoice in vm.invoice"><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedInvoiceRequests[invoice.invoiceId]" ng-click="vm.selectSingleInvoice($event, vm.invoice)"> <span></span></label></td><td>{{invoice.serviceContractId}}</td><td><a ng-href="{{::vm.getUrlForDetail(invoice, \'INVOICE\')}}">{{invoice.merchantName}}</a></td><td><div ng-if="invoice.branchCode != \'Total\'">{{invoice.branchName}} <span ng-if="invoice.branchCode">({{invoice.branchCode}})</span></div><div ng-if="invoice.branchCode == \'Total\'">{{vm.getValueFromTypeKey(invoice.invoiceMethod, vm.InvoiceMethod)}}</div></td><td>{{vm.getValueFromTypeKey(invoice.paymentMethod, vm.PaymentMethod)}}</td><td>{{vm.getValueFromTypeKey(invoice.invoiceMethod, vm.InvoiceMethod)}}</td><td ng-if="vm.permissions.SALES.SUBMIT"><div ng-if="invoice.status != \'DRAFT\'">{{invoice.otherFeeTaxable}}</div><div ng-if="invoice.status == \'DRAFT\'"><input type="text" class="form-control" ng-model="invoice.otherFeeTaxable" numbers-only=""></div></td><td ng-if="vm.permissions.SALES.SUBMIT"><div ng-if="invoice.status != \'DRAFT\'" class="remarksWrap">{{invoice.otherRemarks1}}</div><div ng-if="invoice.status == \'DRAFT\'"><input type="text" class="form-control" ng-model="invoice.otherRemarks1" maxlength="100"></div></td><td ng-if="vm.permissions.SALES.SUBMIT"><div ng-if="invoice.status != \'DRAFT\'">{{invoice.otherTransferNonTaxable}}</div><div ng-if="invoice.status == \'DRAFT\'"><input type="text" class="form-control" ng-model="invoice.otherTransferNonTaxable" numbers-only=""></div></td><td ng-if="vm.permissions.SALES.SUBMIT"><div ng-if="invoice.status != \'DRAFT\'" class="remarksWrap">{{invoice.otherRemarks2}}</div><div ng-if="invoice.status == \'DRAFT\'"><input type="text" class="form-control" ng-model="invoice.otherRemarks2" maxlength="100"></div></td><td ng-if="vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary settSubmitBtn" ng-if="invoice.status == \'DRAFT\'" ng-click="vm.submitInvoiceDraft(invoice)" ng-disabled="!vm.permissions.SALES.SUBMIT || vm.submitInvoiceInProgress[invoice.invoiceId]">{{\'settlementsAndInvoices.list.card.invoice.table.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.submitInvoiceInProgress[invoice.invoiceId]"></i></button> <button type="submit" class="btn btn-primary settSubmitBtn" ng-if="invoice.status == \'PUBLISHED\'" ng-click="vm.revertPublishedInvoice(invoice.invoiceId)" ng-disabled="vm.submitInvoiceInProgress[invoice.invoiceId]">{{\'settlementsAndInvoices.list.card.invoice.table.revert\' | translate }} <i class="inProgress m-l-10" ng-if="vm.submitInvoiceInProgress[invoice.invoiceId]"></i></button></td><td ng-if="vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary settSubmitBtn" ng-if="invoice.status == \'DRAFT\'" ng-click="vm.recalculateDraftInvoice(invoice.invoiceId)" ng-disabled="vm.recalculateInvoiceInProgress[invoice.invoiceId]">{{\'settlementsAndInvoices.list.card.invoice.table.recalculate\' | translate }} <i class="inProgress m-l-10" ng-if="vm.recalculateInvoiceInProgress[invoice.invoiceId]"></i></button></td><td ng-if="!vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSingleInvoice(false,invoice.invoiceId)">{{\'settlementsAndInvoices.list.card.invoice.action.display\' | translate }}</button></td><td ng-if="!vm.permissions.SALES.SUBMIT"><button type="submit" class="btn btn-primary" ng-click="vm.downloadSingleInvoice(true,invoice.invoiceId)">{{\'settlementsAndInvoices.list.card.invoice.action.download\' | translate }}</button></td><td ng-if="vm.permissions.SALES.SUBMIT"><div>{{vm.getValueFromTypeKey(invoice.emailStatus, vm.allTypes.InvoiceEmailStatus)}}</div></td></tr></table></div></div><div class="padding-20"><pagination query="vm.query" pageable="vm.invoiceInfo.pageable" total-pages="vm.invoiceInfo.totalPages" total-elements="vm.invoiceInfo.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div><div class="previewPdf" ng-if="vm.showPdf"><button class="btn btn-icon" ng-click="vm.hidePdf()"><i class="fa fa-times"></i></button><object ng-attr-data="{{vm.pdfUrl}}"></object></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/service-contact/views/create-new.html','<div form="vm.newContractForm"><form name="vm.newContractForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br></div><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.applicant.information.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.service.contract.date\' | translate}}{{\'common.components.required\' | translate }}</label><datepicker date="vm.contractInfo.date" required="" form="vm.newContractForm" name="applicationDate" ng-model="vm.contractInfo.date"></datepicker></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.type\' | translate }}</label><ui-select ng-model="vm.contractInfo.organisationCreateDto.subOrganisationType" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.SubOrganisationType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.SubOrganisationType.key track by $index"><span ng-bind-html="vm.types.SubOrganisationType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-input-group-row labelXXL"><label class="versionText">{{\'service.contract.create.version\' | translate}}</label> <input type="text" class="form-control" disabled="" ng-model="vm.contractInfo.version"></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.information\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm.applicantNameReading.$invalid || vm.newContractForm.applicantName.$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.name1\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="applicantNameReading" ng-model="vm.contractInfo.organisationCreateDto.nameSimple" placeholder="{{\'service.contract.create.applicant.information.name.kana\' | translate }}" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="applicantName" ng-model="vm.contractInfo.organisationCreateDto.name" placeholder="{{\'service.contract.create.applicant.information.name\' | translate }}" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.applicantCompanyCode.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.code\' | translate }} {{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="applicantCompanyCode" ng-model="vm.contractInfo.organisationCreateDto.code" required="" maxlength="20"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.businessType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.business\' | translate}}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="businessType" ng-model="vm.contractInfo.organisationCreateDto.businessType" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.applicantProductHandled.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.products\' | translate}}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="applicantProductHandled" ng-model="vm.contractInfo.organisationCreateDto.productsHandled" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.contact\' | translate }}</div><div class="panel-body"><address label="Address*" address="vm.contractInfo.organisationCreateDto.addressCreateDtos[0]" required="true" form-key="\'organisation_address\'" form="vm.newContractForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" multiple="true" contact-entity="\'ADDRESS\'" contact="vm.contractInfo.organisationCreateDto.addressCreateDtos[0].contactCreateDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_contact\'" form="vm.newContractForm"></contact></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="representative in vm.contractInfo.organisationCreateDto.organisationRepresentativeCreateDtos track by $index"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.representative.title\' | translate }}</div><div class="panel-body"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'companyRepresentativeName_\'+$index].$invalid || vm.newContractForm[\'companyRepresentativeNameReading_\'+$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.nameRep\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyRepresentativeNameReading_{{$index}}" placeholder="{{\'service.contract.create.applicant.information.company.representative.name.kana\' | translate }}" ng-model="representative.nameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="companyRepresentativeName_{{$index}}" placeholder="{{\'service.contract.create.applicant.information.company.representative.name\' | translate }}" ng-model="representative.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.representativedob.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.representative.dateOfBirh\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="representative.dateOfBirth" options="vm.dobOptions" ng-model="representative.dateOfBirth" name="representativedob" required=""></datepicker></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="account in vm.contractInfo.organisationCreateDto.accountCreateDtos track by $index"><div class="panel-heading">{{\'service.contract.create.inCharge.title\' | translate }}<div ng-if="$last && vm.contractInfo.organisationCreateDto.accountCreateDtos.length == 1" ng-click="vm.addNewRow(vm.contractInfo.organisationCreateDto.accountCreateDtos, \'CREATE_ORGANISATION\')" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.contractInfo.organisationCreateDto.accountCreateDtos.length !== 1" ng-click="vm.addNewRow(vm.contractInfo.organisationCreateDto.accountCreateDtos, \'CREATE_ORGANISATION\')" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="vm.contractInfo.organisationCreateDto.accountCreateDtos.length !== 1" ng-click="vm.removeRow(vm.contractInfo.organisationCreateDto.accountCreateDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'inchargeDepartment_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.incharge.department\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" required="" name="inchargeDepartment_{{$index}}" ng-model="account.inchargeDepartment" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': (vm.newContractForm[\'companyInChargePerson_\'+$index].$invalid || vm.newContractForm[\'companyInChargePerson_\'+$index].$invalid ) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.nameRep\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyInChargePersonReading_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name.kana\' | translate }}" ng-model="account.nameSimple" maxlength="250" required="" special-character-limit=""> <input type="text" class="form-control" name="companyInChargePerson_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name\' | translate }}" ng-model="account.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div ng-init="account.accountTypes=[\'ADMIN\']"><contact get-label="vm.getValueFromTypeKey" label="Contact" contact-entity="\'ACCOUNT\'" contact="account.contactCreateDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newContractForm"></contact></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'companyUsername_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.contact.email\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" valid-email="" class="form-control" name="companyUsername_{{$index}}" ng-model="account.userName" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.email_error_msg\' | translate}}</span></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.deviceOwner.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.MerchantOwnerType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.deviceOwner.device.purchase\' | translate}}</label><div ng-if="vm.isXlUpload">{{vm.getValueFromTypeKey(vm.contractInfo.merchantOwnerType, vm.types.MerchantOwnerType)}}</div><div ng-if="!vm.isXlUpload"><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.MerchantOwnerType.key track by $index"><input type="radio" name="MerchantOwnerType" ng-model="vm.merchantOwnerType" ng-change="vm.radioChange($index)" value="{{option}}" required=""> <span>{{vm.types.MerchantOwnerType[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div ng-if="vm.rent" class="panel panel-default bootstrap-panel title-width" ng-repeat="deviceOwner in vm.contractInfo.deviceOwnerSummaries track by $index"><div class="panel-heading">{{\'service.contract.create.deviceOwner.subTitle\' | translate }}<div ng-if="$last && vm.contractInfo.deviceOwnerSummaries.length == 1" ng-click="vm.addNewRow(vm.contractInfo.deviceOwnerSummaries)" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.contractInfo.deviceOwnerSummaries.length !== 1" ng-click="vm.addNewRow(vm.contractInfo.deviceOwnerSummaries)" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="vm.contractInfo.deviceOwnerSummaries.length !== 1" ng-click="vm.removeRow(vm.contractInfo.deviceOwnerSummaries, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.deviceOwner_{{$index}}.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.deviceOwner.name\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" typeahead-on-select="vm.onOrgSelected($item, $index)" name="deviceOwner_{{$index}}" ng-model="deviceOwner.name" uib-typeahead="org.name as org.name for org in vm.getDeviceOwner($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.deviceOwner.code\' | translate }}</label> <input type="text" class="form-control" ng-model="deviceOwner.deviceOwnerCode" disabled=""></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'partner.link\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width" ng-repeat="partnerSummaries in vm.contractInfo.partnerSummaries track by $index"><div class="panel-heading">{{\'partner.details\' | translate }}<div ng-if="$last && vm.contractInfo.partnerSummaries.length == 1" ng-click="vm.addNewRow(vm.contractInfo.partnerSummaries)" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.contractInfo.partnerSummaries.length !== 1" ng-click="vm.addNewRow(vm.contractInfo.partnerSummaries)" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="vm.contractInfo.partnerSummaries.length !== 1" ng-click="vm.removeRow(vm.contractInfo.partnerSummaries, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'partner.name\' | translate }}</label> <input type="text" typeahead-on-select="vm.onPartnerSelected($item, $index)" name="partnerSummaries_{{$index}}" ng-model="partnerSummaries.name" uib-typeahead="partner.name as partner.name for partner in vm.getPartner($viewValue)" class="form-control"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'partner.code\' | translate }}</label> <input type="text" class="form-control" ng-model="partnerSummaries.partnerCode" disabled=""></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.acquirer.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.acquirer.jmups.select\' | translate }}</label><ui-select ng-model="vm.contractInfo.jmupsTemplate" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.JmupsTemplateMaster)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.JmupsTemplateMaster.key track by $index"><span ng-bind-html="vm.types.JmupsTemplateMaster[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.cir.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.terminalId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.tid"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.tidContract"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.senderId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.senderId"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-4"><ui-select ng-model="vm.contractInfo.serviceContractEmvCreateDto.senderIdType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.SenderIdType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.SenderIdType.key track by $index"><span ng-bind-html="vm.types.SenderIdType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.receipientId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.receipientIdMUN"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.receipientIdJCB"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.merchantId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.merchantIdMUN"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.merchantIdJCB"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.2merchantId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.secondMerchantIdMUN"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.secondMerchantIdJCB"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.merchantCategoryCode\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.merchantCategoryCodeMUN"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvCreateDto.merchantCategoryCodeJCB"></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.serviceDetails.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_10SelectAllEmoney" ng-click="vm.handlingFeeEmoneyForME_10SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].paymentType=\'E_MONEY\';vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].deviceTypes=\'ME-10\';vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_10_E_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_10_E_MONEY_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_10.E_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_10SelectAllQRmoney" ng-click="vm.handlingFeeQRmoneyForME_10SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].deviceTypes=\'ME-10\';vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}} {{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_10_QR_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_10_QR_MONEY_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-5"><div style="padding-left: 0;" class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_10.QR_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.20.1\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.20.1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_1SelectAllEmoney" ng-click="vm.handlingFeeEmoneyForME_20_1SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].paymentType=\'E_MONEY\';vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].deviceTypes=\'ME-20-1\';vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_1_E_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_1_E_MONEY_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.E_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div><div class="panel-heading m-t-20">{{\'service.contract.create.serviceDetails.subTitle.creditCard\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_1SelectAllCreditCard" ng-click="vm.handlingFeeCreditCardForME_20_1SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.CREDIT_CARD.key track by $index" ng-if="vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].paymentType=\'CREDIT_CARD\';vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].deviceTypes=\'ME-20-1\';vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_1_CREDIT_CARD_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_1_CREDIT_CARD_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.CREDIT_CARD[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_1SelectAllQRmoney" ng-click="vm.handlingFeeQRmoneyForME_20_1SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].deviceTypes=\'ME-20-1\';vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}} {{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_1_QR_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_1_QR_MONEY_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-5"><div style="padding-left: 0;" class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_1.QR_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.20.2\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.20.2\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_2SelectAllEmoney" ng-click="vm.handlingFeeEmoneyForME_20_2SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].paymentType=\'E_MONEY\';vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].deviceTypes=\'ME-20-2\';vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_2_E_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_2_E_MONEY_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.E_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div><div class="panel-heading m-t-20">{{\'service.contract.create.serviceDetails.subTitle.creditCard\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_2SelectAllCreditCard" ng-click="vm.handlingFeeCreditCardForME_20_2SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.CREDIT_CARD.key track by $index" ng-if="vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].paymentType=\'CREDIT_CARD\';vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].deviceTypes=\'ME-20-2\';vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_2_CREDIT_CARD_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_2_CREDIT_CARD_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.CREDIT_CARD[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_2SelectAllQRmoney" ng-click="vm.handlingFeeQRmoneyForME_20_2SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].deviceTypes=\'ME-20-2\';vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}} {{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_2_QR_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_2_QR_MONEY_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-5"><div style="padding-left: 0;" class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_20_2.QR_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.5.1\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.5.1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_5_1SelectAllQRmoney" ng-click="vm.handlingFeeQRmoneyForME_5_1SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption=vm.types.PaymentDeductionOption.key[1];vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].deviceTypes=\'ME-5-1\';vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}} {{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_5_1_QR_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_5_1_QR_MONEY_value" ng-model="vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-5"><div style="padding-left: 0;" class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeCreateDtos.ME_5_1.QR_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b1\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.builtIn_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><span>ME-10-1</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn_initial" model="vm.serviceFeeCreateDtos.builtIn_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN.key[0]]" modem-type="\'BUILT_IN\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form-key="\'builtIn_initial\'" form="vm.newContractForm" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn_monthly" model="vm.serviceFeeCreateDtos.builtIn_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN.key[0]]" modem-type="\'BUILT_IN\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'builtIn_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b2\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.external_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><span>ME-10-2</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external_initial" base-fee-model="vm.baseServiceFeeDtos.external_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external_initial" model="vm.serviceFeeCreateDtos.external_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL.key[0]]" modem-type="\'EXTERNAL\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'external_initial\'" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external_monthly" base-fee-model="vm.baseServiceFeeDtos.external_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external_monthly" model="vm.serviceFeeCreateDtos.external_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL.key[0]]" modem-type="\'EXTERNAL\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'external_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b3\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.builtIn_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><span>ME-20-1</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn20_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn20_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn20_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn20_initial" model="vm.serviceFeeCreateDtos.builtIn20_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_20.key[0]]" modem-type="\'BUILT_IN_20\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form-key="\'builtIn20_initial\'" form="vm.newContractForm" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn20_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn20_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn20_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn20_monthly" model="vm.serviceFeeCreateDtos.builtIn20_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_20.key[0]]" modem-type="\'BUILT_IN_20\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'builtIn20_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b4\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.external_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><span>ME-20-2</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external20_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external20_initial" base-fee-model="vm.baseServiceFeeDtos.external20_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external20_initial" model="vm.serviceFeeCreateDtos.external20_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL_20.key[0]]" modem-type="\'EXTERNAL_20\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'external20_initial\'" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external20_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external20_monthly" base-fee-model="vm.baseServiceFeeDtos.external20_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external20_monthly" model="vm.serviceFeeCreateDtos.external20_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL_20.key[0]]" modem-type="\'EXTERNAL_20\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'external20_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b5\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.builtIn_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label> <span>ME-5-1</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn5_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn5_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn5_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn5_initial" model="vm.serviceFeeCreateDtos.builtIn5_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_5.key[0]]" modem-type="\'BUILT_IN_5\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form-key="\'builtIn5_initial\'" form="vm.newContractForm" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn5_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn5_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn5_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn5_monthly" model="vm.serviceFeeCreateDtos.builtIn5_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_5.key[0]]" modem-type="\'BUILT_IN_5\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'builtIn5_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">(C) {{\'service.contract.create.other.title\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="col-md-4"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.other.cancellation.charge\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.contractInfo.cancellationCharge"> <span class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span></div></div></div></div></div><div class="form-group"><div class="form-input-group-row labelXXL alignTop"><label>{{\'service.contract.create.service.usage.remarks\' | translate }}</label> <textarea class="form-control" ng-model="vm.contractInfo.serviceUsageRemarks"></textarea></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.settlementConditions.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.method.group\' | translate }}{{\'common.components.required\' | translate }}</label></div><div class="w-btn-lg"><ui-select ng-model="vm.contractInfo.settlementMethodCreateDto.settlementGroup" name="settlementGroup" class="btn-group bootstrap-select form-control settlement-group n" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.SettlementGroup)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.SettlementGroup.key track by $index"><span ng-bind-html="vm.types.SettlementGroup[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.settlementDate.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.method.sub\' | translate }}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.SettlementDate.key track by $index"><input type="radio" name="settlementDate" ng-model="vm.contractInfo.settlementMethodCreateDto.settlementDate" value="{{option}}" required=""> <span>{{vm.types.SettlementDate[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.closingDate.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.closing.sub\' | translate }}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.ClosingDate.key track by $index"><input type="radio" ng-model="vm.contractInfo.settlementMethodCreateDto.closingDate" name="closingDate" value="{{option}}" required=""> <span>{{vm.types.ClosingDate[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.paymentMethod.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.paymentMethod.sub\' | translate}}<br>{{\'service.contract.create.settlementConditions.paymentMethod.sub1\' | translate}}</label></div><div ng-if="!vm.isXlUpload"><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.PaymentMethod.key track by $index"><input type="radio" ng-model="vm.contractInfo.settlementMethodCreateDto.paymentMethod" name="paymentMethod" value="{{option}}" required="" ng-change="vm.paymentMethodChange($index)"> <span>{{vm.types.PaymentMethod[vm.getLang()][$index]}}</span></label></div><div ng-if="vm.isXlUpload">{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodCreateDto.paymentMethod, vm.types.PaymentMethod)}}</div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.createInvoices.$invalid && vm.newContractForm.$submitted}"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.createInvoice\' | translate}}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.createInvoice.key track by $index"><input type="radio" name="createInvoices" ng-model="vm.contractInfo.settlementMethodCreateDto.createInvoice" ng-value="{{option}}" required=""> <span>{{vm.types.createInvoice[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.invoiceMethod.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.bank.transfer.sub\' | translate}}{{\'common.components.required\' | translate }}</label></div><div ng-if="!vm.isXlUpload"><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.InvoiceMethod.key track by $index"><input type="radio" ng-model="vm.contractInfo.settlementMethodCreateDto.invoiceMethod" name="invoiceMethod" value="{{option}}" required="" ng-change="vm.settlementMethodChange($index)"> <span>{{vm.types.InvoiceMethod[vm.getLang()][$index]}}</span></label></div><div ng-if="vm.isXlUpload">{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodCreateDto.invoiceMethod, vm.types.InvoiceMethod)}}</div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.chargeMonthlyFee.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.charge.monthlyFee.from\' | translate}}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.ChargeMonthlyFeeFrom.key track by $index"><input type="radio" ng-model="vm.contractInfo.settlementMethodCreateDto.chargeMonthlyFeeFrom" name="chargeMonthlyFee" value="{{option}}" required=""> <span>{{vm.types.ChargeMonthlyFeeFrom[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.detailsByDeviceOwner.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.details.by.deviceOwner\' | translate}}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.detailsByDeviceOwner.key track by $index"><input type="radio" ng-model="vm.contractInfo.settlementMethodCreateDto.detailsByDeviceOwner" name="detailsByDeviceOwner" ng-value="{{option}}" required=""> <span>{{vm.types.detailsByDeviceOwner[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.emailInvoice.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.emailInvoice\' | translate}}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.emailInvoice.key track by $index"><input type="radio" ng-model="vm.contractInfo.settlementMethodCreateDto.emailInvoice" name="emailInvoice" ng-value="{{option}}" required=""> <span>{{vm.types.emailInvoice[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.enableTelemetryOption.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.telemetryAccess\' | translate}}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.emailInvoice.key track by $index"><input type="radio" ng-model="vm.contractInfo.settlementMethodCreateDto.enableTelemetryOption" name="enableTelemetryOption" ng-value="{{option}}" required=""> <span>{{vm.types.emailInvoice[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-repeat="settlement in vm.contractInfo.settlementBranchCreateDtos track by $index" ng-if="vm.showSettlement"><div class="panel-heading"><span>{{$index + 1}}. {{\'service.contract.create.settlementInformation.title\' | translate }}</span><div ng-if="vm.byBranch"><div ng-if="$last && vm.contractInfo.settlementBranchCreateDtos.length == 1" ng-click="vm.addNewRow(vm.contractInfo.settlementBranchCreateDtos, \'ADD_SETTLEMENT\')" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.contractInfo.settlementBranchCreateDtos.length !== 1" ng-click="vm.addNewRow(vm.contractInfo.settlementBranchCreateDtos, \'ADD_SETTLEMENT\')" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="vm.contractInfo.settlementBranchCreateDtos.length !== 1" ng-click="vm.removeRow(vm.contractInfo.settlementBranchCreateDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div></div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.settlementInformation.bankAccount.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'settlementBankCode_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" name="settlementBankCode_{{$index}}" typeahead-on-select="vm.onBankSelected($item, $index)" ng-model="settlement.settlementBankCreateDto.bankCode" uib-typeahead="bank.bankCode as bank.bankCode for bank in vm.bankCodeChange($viewValue)" class="form-control" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'settlementBranchCode_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankBranchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" name="settlementBranchCode_{{$index}}" typeahead-on-select="vm.onBankBranchSelected($item, $index)" ng-model="settlement.settlementBankCreateDto.branchCode" uib-typeahead="branch.branchCode as branch.branchCode for branch in vm.bankBranchCodeChange($viewValue)" class="form-control" maxlength="10" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'bankName_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" ng-model="settlement.settlementBankCreateDto.bankName" name="bankName_{{$index}}" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (vm.newContractForm[\'branchName_\'+$index].$invalid || vm.newContractForm[\'branchType_\'+$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankBranchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" ng-model="settlement.settlementBankCreateDto.branchName" name="branchName_{{$index}}" required="" special-character-limit=""><ui-select ng-model="settlement.settlementBankCreateDto.branchType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" name="branchType_{{$index}}" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.BankBranchType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.BankBranchType.key track by $index"><span ng-bind-html="vm.types.BankBranchType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'bankType_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bank.type\' | translate }}{{\'common.components.required\' | translate }}</label><ui-select ng-model="settlement.settlementBankCreateDto.bankType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" name="bankType_{{$index}}" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.BankType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.BankType.key track by $index"><span ng-bind-html="vm.types.BankType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'accountNo_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.accountNo\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="accountNo_{{$index}}" ng-model="settlement.settlementBankCreateDto.accountNumber" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'bankAccountType_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.type.of.account\' | translate }}{{\'common.components.required\' | translate }}</label><ui-select ng-model="settlement.settlementBankCreateDto.bankAccountType" name="bankAccountType_{{$index}}" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.BankAccountType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.BankAccountType.key track by $index"><span ng-bind-html="vm.types.BankAccountType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'bankAccountName_\'+$index].$invalid || vm.newContractForm[\'bankAccountNameReading_\'+$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.account.holder\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="bankAccountNameReading_{{$index}}" placeholder="{{\'service.contract.create.settlementInformation.bankAccount.accountName.kana\' | translate }}" ng-model="settlement.settlementBankCreateDto.accountHolderNameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="bankAccountName_{{$index}}" ng-model="settlement.settlementBankCreateDto.accountHolderName" placeholder="{{\'service.contract.create.settlementInformation.bankAccount.accountName\' | translate }}" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.contractInfo.settlementMethodCreateDto.paymentMethod === \'OFFSETTING\'"><div class="panel-heading">{{vm.getValueFromTypeKey(\'OFFSET_NOTIFICATION\', vm.types.BranchLocationType)}}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'branchName_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_{{$index}}_{{$parent.$index}}" required="" maxlength="{{vm.branchNameMaxLength}}" ng-model="settlement.settlementSendLocationCreateDtos[0].branchName" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'centerCode_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_{{$index}}_{{$parent.$index}}" required="" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationCreateDtos[0].branchCode" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.half.width.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'inChargeName_\'+$index+\'_\'+$parent.$index].$invalid || vm.newContractForm[\'inChargeNameReading_\'+$index+\'_\'+$parent.$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.name\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="inChargeNameReading_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName.kana\' | translate }}" ng-model="settlement.settlementSendLocationCreateDtos[0].inChargeNameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="inChargeName_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName\' | translate }}" ng-model="settlement.settlementSendLocationCreateDtos[0].inChargeName" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><address label="Address*" address="settlement.settlementSendLocationCreateDtos[0].addressCreateDto" required="true" form-key="\'settlement_address_\'+$parent.$index+\'_\'+$index" form="vm.newContractForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="settlement.settlementSendLocationCreateDtos[0].addressCreateDto.contactCreateDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="true" email-required="false" form-key="\'settlement_contact\'+$parent.$index+\'_\'+$index" form="vm.newContractForm"></contact><div class="form-group m-b-0 m-t-20"><div class="form-input-group-row labelXXL alignTop"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.remarks\' | translate }}</label> <textarea class="form-control" ng-model="settlement.remarks"></textarea></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.contractInfo.settlementMethodCreateDto.paymentMethod === \'NON_OFFSETTING\'"><div class="panel-heading"><span>{{vm.getValueFromTypeKey(\'INVOICE_DESTINATION\', vm.types.BranchLocationType)}}</span></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'branchName_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchNameMaxLength}}" required="" ng-model="settlement.settlementSendLocationCreateDtos[0].branchName" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'centerCode_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_{{$index}}_{{$parent.$index}}" required="" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationCreateDtos[0].branchCode" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.half.width.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'inChargeName_\'+$index+\'_\'+$parent.$index].$invalid || vm.newContractForm[\'inChargeNameReading_\'+$index+\'_\'+$parent.$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.name\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="inChargeNameReading_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName.kana\' | translate }}" ng-model="settlement.settlementSendLocationCreateDtos[0].inChargeNameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="inChargeName_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName\' | translate }}" ng-model="settlement.settlementSendLocationCreateDtos[0].inChargeName" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><address label="Address*" address="settlement.settlementSendLocationCreateDtos[0].addressCreateDto" required="true" form-key="\'settlement_address_\'+$parent.$index+\'_\'+$index" form="vm.newContractForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="settlement.settlementSendLocationCreateDtos[0].addressCreateDto.contactCreateDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="true" email-required="false" form-key="\'settlement_contact\'+$parent.$index+\'_\'+$index" form="vm.newContractForm"></contact></div><div class="m-t-30"></div><div class="panel-heading"><span>{{vm.getValueFromTypeKey(\'CREDIT_NOTIFICATION\', vm.types.BranchLocationType)}}</span></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'branchName_cr_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_cr_{{$index}}_{{$parent.$index}}" required="" maxlength="{{vm.branchNameMaxLength}}" ng-model="settlement.settlementSendLocationCreateDtos[1].branchName" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'centerCode_cr_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_cr_{{$index}}_{{$parent.$index}}" required="" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationCreateDtos[1].branchCode" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.half.width.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'inChargeName_cr_\'+$index+\'_\'+$parent.$index].$invalid || vm.newContractForm[\'inChargeNameReading_cr_\'+$index+\'_\'+$parent.$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.name\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="inChargeNameReading_cr_{{$index}}_{{$parent.$index}}" ng-required="true" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName.kana\' | translate }}" ng-model="settlement.settlementSendLocationCreateDtos[1].inChargeNameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="inChargeName_cr_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName\' | translate }}" ng-model="settlement.settlementSendLocationCreateDtos[1].inChargeName" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><address label="Address*" address="settlement.settlementSendLocationCreateDtos[1].addressCreateDto" required="true" form-key="\'settlement_address_cr_\'+$parent.$index+\'_\'+$index" form="vm.newContractForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="settlement.settlementSendLocationCreateDtos[1].addressCreateDto.contactCreateDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="true" email-required="false" form-key="\'settlement_contact_cr\'+$parent.$index+\'_\'+$index" form="vm.newContractForm"></contact></div><div class="form-group m-b-0 m-t-20"><div class="form-input-group-row labelXXL alignTop"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.remarks\' | translate }}</label> <textarea class="form-control" ng-model="settlement.remarks"></textarea></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL alignTop"><label>{{\'service.contract.create.service.contract.remarks\' | translate }}</label> <textarea class="form-control" name="serviceOperatorRemarks" ng-model="vm.contractInfo.remarks"></textarea></div></div><div class="row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.ownerCanApplyForDevice" name="ownerCanApplyForDevice" checked="true"> <span>{{\'service.contract.create.bool1\' | translate }}</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.ownerMustApproveDeviceRequest" name="ownerMustApproveDeviceRequest" disabled="true"> <span>{{\'service.contract.create.bool2\' | translate }}</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.merchantCanApplyForDeviceRequest" name="merchantCanApplyForDeviceRequest"> <span>{{\'service.contract.create.bool3\' | translate }}</span></label></div></div><br><div ng-class="{\'has-error\': vm.newContractForm.contractTerms.$invalid && vm.newContractForm.$submitted}"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractTerms" name="contractTerms" required=""> <span>{{\'service.contract.create.service.contract.terms\' | translate }}</span></label></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/service-contract/list" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createServiceContract()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'service.contract.create.service.contract.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/service-contact/views/detail.html','<div ng-if="!vm.isEdit"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{"service.contract.create.service.contract.title_detail" | translate}}<div ng-if="vm.permissions.SERVICE_CONTRACT.WRITE" ng-click="vm.merchantNumberForm()" class="btn btn-primary m-r-40 pull-right" style="margin-top: -10px">{{\'merchant.number.registration\' | translate}}</div><div ng-if="vm.permissions.SERVICE_CONTRACT.WRITE" ng-click="vm.editDetail()" class="btn btn-default addNewRow">{{\'org.view.EDIT\' | translate}}</div></div><div class="panel-body"><div class="row"><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.list.service.contract.id\' | translate}}</label><div>{{vm.contractInfo.serviceContractId}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.list.merchant.id\' | translate }}</label><div>{{vm.contractInfo.organisationDto.merchantCode}}</div></div></div></div></div><div class="row"><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.service.contract.date\' | translate}}</label><div>{{vm.contractInfo.date | date: \'yyyy/MM/dd\'}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.type\' | translate }}</label><div>{{vm.getValueFromTypeKey(vm.contractInfo.organisationDto.subOrganisationType, vm.types.SubOrganisationType)}}</div></div></div></div><div class="col-md-3"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.version\' | translate }}</label><div>{{vm.contractInfo.version}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.information\' | translate}}</div><div class="panel-body"><div class="form-group kanaFromGroup"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.name1\' | translate }}</label><div class="kanaInputGroup"><div class="word-break">{{vm.contractInfo.organisationDto.nameSimple}}</div><div class="word-break">{{vm.contractInfo.organisationDto.name}}</div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.code\' | translate }}{{\'common.components.required\' | translate }}</label><div>{{vm.contractInfo.organisationDto.code}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.business\' | translate}}</label><div class="word-break">{{vm.contractInfo.organisationDto.businessType}}</div></div></div></div></div><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.products\' | translate}}</label><div class="word-break">{{vm.contractInfo.organisationDto.productsHandled}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.contact\' | translate }}</div><div class="panel-body"><address is-edit="false" address="vm.contractInfo.organisationDto.addressDtos[0]" required="true" form-key="\'organisation_address\'" form="vm.newContractForm"></address><contact is-edit="false" get-label="vm.getValueFromTypeKey" label="Contact" multiple="true" contact-entity="\'ADDRESS\'" contact="vm.contractInfo.organisationDto.addressDtos[0].contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_contact\'" form="vm.newContractForm"></contact></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="representative in vm.contractInfo.organisationDto.organisationRepresentativeDtos track by $index"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.representative.title\' | translate }}</div><div class="panel-body"><div class="form-group kanaFromGroup"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.nameRep\' | translate }}</label><div class="kanaInputGroup"><div class="word-break">{{representative.nameSimplified}}</div><div class="word-break">{{representative.name}}</div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.representative.dateOfBirh\' | translate }}</label><div>{{representative.dateOfBirth | date: \'yyyy/MM/dd\'}}</div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="account in vm.contractInfo.organisationDto.accountDtos track by $index"><div class="panel-heading">{{\'service.contract.create.inCharge.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.incharge.department\' | translate }}</label><div class="word-break">{{account.inchargeDepartment}}</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.nameRep\' | translate }}</label><div class="kanaInputGroup"><div class="word-break">{{account.nameSimple}}</div><div class="word-break">{{account.name}}</div></div></div></div></div></div><div class="row"><div class="col-md-6"><div ng-init="account.accountTypes=[\'ADMIN\']"><contact is-edit="false" get-label="vm.getValueFromTypeKey" label="Contact" contact-entity="\'ACCOUNT\'" contact="account.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newContractForm"></contact></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'companyUsername_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.contact.email\' | translate }}</label><div class="word-break">{{account.userName}}</div></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.email_error_msg\' | translate}}</span></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.deviceOwner.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.deviceOwner.device.purchase\' | translate}}</label><div>{{vm.getValueFromTypeKey(vm.contractInfo.merchantOwnerType, vm.types.MerchantOwnerType)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="deviceOwner in vm.deviceOwnerDto track by $index"><div class="panel-heading">{{\'service.contract.create.deviceOwner.subTitle\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.deviceOwner.name\' | translate }}</label><div class="word-break">{{deviceOwner.deviceOrgName}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.deviceOwner.code\' | translate }}</label><div>{{deviceOwner.code}}</div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'partner.link\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width" ng-repeat="partner in vm.contractInfo.partnerDtos track by $index"><div class="panel-heading">{{\'partner.details\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'partner.name\' | translate }}</label><div class="word-break" ng-if="vm.emptyPartnerDtos">{{\'common.components.data.not.available\' | translate}}</div><div class="word-break" ng-if="!vm.emptyPartnerDtos">{{partner.name}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'partner.code\' | translate }}</label><div class="word-break" ng-if="vm.emptyPartnerDtos">{{\'common.components.data.not.available\' | translate}}</div><div class="word-break" ng-if="!vm.emptyPartnerDtos">{{partner.partnerCode}}</div></div></div></div><div ng-attr-id="merchant" ng-if="$last" ng-class="col-md-12"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.acquirer.title\' | translate }}</div><div class="panel-body"><div class="row" ng-if="vm.permissions.SERVICE_CONTRACT.WRITE"><div class="col-md-12"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading" ng-if="!vm.merchantNumber">{{\'merchant.number.information\' | translate}}</div><div class="panel-heading" ng-if="vm.merchantNumber">{{\'merchant.number.registration\' | translate}}</div><div class="panel-body"><div class="row" ng-if="!vm.merchantNumber"><div class="form-group"><div class="form-detail-row"><table class="table table-bordered m-t-10" ng-if="vm.contractInfo.merchantNumbers.length > 0"><tr ng-repeat="option in vm.types.MerchantNumberType.key track by $index"><td class="col-md-3" style="text-align: left">{{vm.types.MerchantNumberType[vm.getLang()][$index]}}</td><td class="col-md-6 word-break">{{(vm.contractInfo.merchantNumbers[$index].number)}}</td></tr></table><table class="table table-bordered m-t-10" ng-if="vm.contractInfo.merchantNumbers.length == 0"><tr ng-repeat="option in vm.types.MerchantNumberType.key track by $index"><td class="col-md-3" style="text-align: left">{{vm.types.MerchantNumberType[vm.getLang()][$index]}}</td><td class="col-md-6">{{\'merchant.number.not.registered\' | translate}}</td></tr></table></div></div></div><div class="row"><div class="col-md-12"><div class="mn-reg"><div id="merchant-number"></div></div><div class="mn-reg"><div id="merchant-number-second"></div></div><button class="btn btn-primary m-t-50 mn-apply-all-btn" ng-click="vm.applyAllMerchantNumber()" ng-if="vm.merchantNumber">{{\'merchant.number.form.apply.all\' | translate}}</button></div><div class="col-md-8 m-t-30 mn-btn-group" ng-if="vm.merchantNumber"><button class="btn btn-default pull-right m-r-20" ng-click="vm.cancelMerchantForm()">{{\'merchant.number.form.cancel\' | translate}}</button> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.submitMerchantForm()">{{\'merchant.number.form.submit\' | translate}}</button></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.list.maroon.application\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group"><div class="form-detail-row labelXXL"><button ngf-select="vm.uploadJescaMaroonCsv($file, $event, bank)" class="btn btn-primary w-btn-md btn-raised btn-xs" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "service.contract.list.upload" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.uploadingJescaMaroonCsv"></i></button> <button class="btn btn-info m-l-5 w-btn-md-1 btn-raised btn-xs" ng-disabled="!vm.maronBtnStatus" ng-click="vm.downloadMaronExcel()">{{ "service.contract.list.download" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloadingMaronExcel"></i></button></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.acquirer.jmups\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.acquirer.jmups.select\' | translate }}</label><div class="word-break">{{vm.getValueFromTypeKey(vm.contractInfo.jmupsTemplate, vm.types.JmupsTemplateMaster)}}</div></div></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.cir.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.terminalId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><div>{{vm.contractInfo.serviceContractEmvDto.tid}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><div>{{vm.contractInfo.serviceContractEmvDto.tidContract}}</div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.senderId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><div>{{vm.contractInfo.serviceContractEmvDto.senderId}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><div>{{vm.getValueFromTypeKey(vm.contractInfo.serviceContractEmvDto.senderIdType, vm.types.SenderIdType)}}</div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.receipientId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label><div>{{vm.contractInfo.serviceContractEmvDto.receipientIdMUN}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label><div>{{vm.contractInfo.serviceContractEmvDto.receipientIdJCB}}</div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.merchantId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label><div>{{vm.contractInfo.serviceContractEmvDto.merchantIdMUN}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label><div>{{vm.contractInfo.serviceContractEmvDto.merchantIdJCB}}</div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.2merchantId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label><div>{{vm.contractInfo.serviceContractEmvDto.secondMerchantIdMUN}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label><div>{{vm.contractInfo.serviceContractEmvDto.secondMerchantIdJCB}}</div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.merchantCategoryCode\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label><div>{{vm.contractInfo.serviceContractEmvDto.merchantCategoryCodeMUN}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label><div>{{vm.contractInfo.serviceContractEmvDto.merchantCategoryCodeJCB}}</div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.serviceDetails.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL"><label>{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].rateOrAmount | number:2 )}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\'| translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\'| translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL" ng-init="vm.paymentHandlingFeeDtos.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeDtos.QR_MONEY[$index].paymentOption=option"><label>{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].rateOrAmount | number)}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.20.1\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.20.1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL"><label>{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].rateOrAmount | number:2 )}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.creditCard\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.CREDIT_CARD.key track by $index" ng-if="vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL"><label>{{vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].rateOrAmount | number:2 )}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL" ng-init="vm.paymentHandlingFeeDtos.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeDtos.QR_MONEY[$index].paymentOption=option"><label>{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].rateOrAmount | number)}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.20.2\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.20.2\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL"><label>{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].rateOrAmount | number:2 )}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.creditCard\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.CREDIT_CARD.key track by $index" ng-if="vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL"><label>{{vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].rateOrAmount | number:2 )}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL" ng-init="vm.paymentHandlingFeeDtos.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeDtos.QR_MONEY[$index].paymentOption=option"><label>{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].rateOrAmount | number)}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.5.1\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.5.1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelL" ng-init="vm.paymentHandlingFeeDtos.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeDtos.QR_MONEY[$index].paymentOption=option"><label>{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}}</label></div></div></div><div class="col-md-2"><div class="form-group"><div class="form-detail-row"><div>{{(vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].rateOrAmount | number)}}</div><span ng-if="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div></div></div><div class="col-md-6"><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].createSettlement" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div></div><div class="col-md-6 form-group"><div class="form-detail-row labelL"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].nonTaxable" disabled=""> <span class="handling-fee-checkbox-disable">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b1\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><div><span ng-repeat="type in vm.builtIn_deviceType track by $index">{{vm.getType(type)}}<span ng-if="!$last">,</span></span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn_initial" is-edit="false" model="vm.serviceFeeDtos.builtIn_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN.key[0]]" modem-type="\'BUILT_IN\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn_monthly" is-edit="false" model="vm.serviceFeeDtos.builtIn_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN.key[0]]" modem-type="\'BUILT_IN\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b2\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><div><span ng-repeat="type in vm.external_deviceType track by $index">{{vm.getType(type)}}<span ng-if="!$last">,</span></span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external_initial" base-fee-model="vm.baseServiceFeeDtos.external_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external_initial" is-edit="false" model="vm.serviceFeeDtos.external_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL.key[0]]" modem-type="\'EXTERNAL\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external_monthly" base-fee-model="vm.baseServiceFeeDtos.external_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external_monthly" is-edit="false" model="vm.serviceFeeDtos.external_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL.key[0]]" modem-type="\'EXTERNAL\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b3\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><span>ME-20-1</span></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn20_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn20_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn20_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn20_initial" is-edit="false" model="vm.serviceFeeDtos.builtIn20_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_20.key[0]]" modem-type="\'BUILT_IN_20\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn20_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn20_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn20_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn20_monthly" is-edit="false" model="vm.serviceFeeDtos.builtIn20_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_20.key[0]]" modem-type="\'BUILT_IN_20\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b4\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><span>ME-20-2</span></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external20_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external20_initial" base-fee-model="vm.baseServiceFeeDtos.external20_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external20_initial" is-edit="false" model="vm.serviceFeeDtos.external20_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL_20.key[0]]" modem-type="\'EXTERNAL_20\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external20_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external20_monthly" base-fee-model="vm.baseServiceFeeDtos.external20_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external20_monthly" is-edit="false" model="vm.serviceFeeDtos.external20_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL_20.key[0]]" modem-type="\'EXTERNAL_20\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b5\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label> <span>ME-5-1</span></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn5_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn5_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn5_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn5_initial" is-edit="false" model="vm.serviceFeeDtos.builtIn5_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_5.key[0]]" modem-type="\'BUILT_IN_5\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn5_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn5_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn5_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn5_monthly" is-edit="false" model="vm.serviceFeeDtos.builtIn5_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_5.key[0]]" modem-type="\'BUILT_IN_5\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" payment-handling-option="vm.types.PaymentHandlingOption" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">(C) {{\'service.contract.create.other.title\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.other.cancellation.charge\' | translate }}</label><div>{{vm.contractInfo.cancellationCharge | currency : \'\' }} {{\'service.contract.create.serviceDetails.yen\' | translate }}</div></div></div></div></div><div class="form-group"><div class="form-detail-row labelXXL alignTop"><label>{{\'service.contract.create.service.usage.remarks\' | translate }}</label><div class="word-break">{{vm.contractInfo.serviceUsageRemarks}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.settlementConditions.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.method.group\' | translate }}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.settlementGroup, vm.types.SettlementGroup)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.method.sub\' | translate }}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.settlementDate, vm.types.SettlementDate)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.closing.sub\' | translate }}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.closingDate, vm.types.ClosingDate)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.paymentMethod.sub\' | translate}}<br>{{\'service.contract.create.settlementConditions.paymentMethod.sub1\' | translate}}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.paymentMethod, vm.types.PaymentMethod)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.createInvoice\' | translate}}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.createInvoice, vm.types.createInvoice)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row noWrap"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.bank.transfer.sub\' | translate }}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.invoiceMethod, vm.types.InvoiceMethod)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.charge.monthlyFee.from\' | translate}}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.chargeMonthlyFeeFrom, vm.types.ChargeMonthlyFeeFrom)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.details.by.deviceOwner\' | translate}}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.detailsByDeviceOwner, vm.types.detailsByDeviceOwner)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.emailInvoice\' | translate}}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.emailInvoice, vm.types.emailInvoice)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.telemetryAccess\' | translate}}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.enableTelemetryOption, vm.types.emailInvoice)}}</div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-repeat="settlement in vm.contractInfo.settlementBranchDtos track by $index"><div class="panel-heading"><span>{{$index +1}}. {{\'service.contract.create.settlementInformation.title\' | translate }}</span></div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.settlementInformation.bankAccount.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankCode\' | translate }}</label><div>{{settlement.settlementBankDto.bankCode}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankBranchCode\' | translate }}</label><div>{{settlement.settlementBankDto.branchCode}}</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankName\' | translate }}</label><div class="word-break">{{settlement.settlementBankDto.bankName}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankBranchName\' | translate }}</label><div>{{settlement.settlementBankDto.branchName}}</div>&nbsp;{{vm.getValueFromTypeKey(settlement.settlementBankDto.branchType, vm.types.BankBranchType)}}</div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bank.type\' | translate }}</label><div>{{vm.getValueFromTypeKey(settlement.settlementBankDto.bankType, vm.types.BankType)}}</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.accountNo\' | translate }}</label><div>{{settlement.settlementBankDto.accountNumber}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.type.of.account\' | translate }}</label><div>{{vm.getValueFromTypeKey(settlement.settlementBankDto.bankAccountType, vm.types.BankAccountType)}}</div></div></div></div></div><div class="form-group kanaFromGroup"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.account.holder\' | translate }}</label><div class="kanaInputGroup"><div class="word-break">{{settlement.settlementBankDto.accountHolderNameSimplified}}</div><div class="word-break">{{settlement.settlementBankDto.accountHolderName}}</div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="location in settlement.settlementSendLocationDtos track by $index"><div class="panel-heading">{{vm.getValueFromTypeKey(location.branchLocationType, vm.types.BranchLocationType)}}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.invoiceId\' | translate }}</label><div>{{location.destinationInvoiceId}}</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}</label><div class="word-break">{{location.branchName}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}</label><div>{{location.branchCode}}</div></div></div></div></div><div class="form-group kanaFromGroup"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.name\' | translate }}</label><div class="kanaInputGroup"><div class="word-break">{{location.inChargeNameSimplified}}</div><div class="word-break">{{location.inChargeName}}</div></div></div></div><address is-edit="false" label="Address" address="location.addressDto" required="true" form-key="\'settlement_address_\'+$parent.$index+\'_\'+$index" form="vm.newContractForm"></address><contact is-edit="false" get-label="vm.getValueFromTypeKey" label="Contact" contact-entity="\'ADDRESS\'" multiple="true" contact="location.addressDto.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="true" email-required="false" form-key="\'settlement_contact\'+$parent.$index+\'_\'+$index" form="vm.newContractForm"></contact></div></div><div class="form-group m-b-0 m-t-20"><div class="form-detail-row labelXXL alignTop"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.remarks\' | translate }}</label><div class="word-break">{{settlement.remarks}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL alignTop"><label>{{\'service.contract.create.service.contract.remarks\' | translate }}</label><div class="word-break">{{vm.contractInfo.remarks}}</div></div></div><div class="row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.ownerCanApplyForDevice" name="ownerCanApplyForDevice" readonly="" ng-disabled="true"> <span>{{\'service.contract.create.bool1\' | translate }}</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.ownerMustApproveDeviceRequest" name="ownerMustApproveDeviceRequest" readonly="" ng-disabled="true"> <span>{{\'service.contract.create.bool2\' | translate }}</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.merchantCanApplyForDeviceRequest" name="merchantCanApplyForDeviceRequest" readonly="" ng-disabled="true"> <span>{{\'service.contract.create.bool3\' | translate }}</span></label></div></div></div></div></div><div form="vm.newContractForm" ng-if="vm.isEdit"><form name="vm.newContractForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{"service.contract.create.service.contract.title_edit" | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-5"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.list.service.contract.id\' | translate}}</label><div>{{vm.contractInfo.serviceContractId}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.list.merchant.id\' | translate }}</label><div>{{vm.contractInfo.organisationDto.merchantCode}}</div></div></div></div></div><div class="row"><div class="col-md-5"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.service.contract.date\' | translate}}{{\'common.components.required\' | translate }}</label><datepicker date="vm.contractInfo.date"></datepicker></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.type\' | translate }}</label><ui-select ng-model="vm.contractInfo.organisationDto.subOrganisationType" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.SubOrganisationType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.SubOrganisationType.key track by $index"><span ng-bind-html="vm.types.SubOrganisationType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group"><div class="form-input-group-row labelXXXL"><label>{{\'service.contract.create.version\' | translate }}</label> <input type="text" class="form-control m-w-50" disabled="" ng-model="vm.contractInfo.version"></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.information\' | translate}}</div><div class="panel-body"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm.applicantNameReading.$invalid || vm.newContractForm.applicantName.$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.name1\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="applicantNameReading" ng-model="vm.contractInfo.organisationDto.nameSimple" placeholder="{{\'service.contract.create.applicant.information.name.kana\' | translate }}" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="applicantName" ng-model="vm.contractInfo.organisationDto.name" placeholder="{{\'service.contract.create.applicant.information.name\' | translate }}" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.applicantCompanyCode.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.code\' | translate }} {{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="applicantCompanyCode" ng-model="vm.contractInfo.organisationDto.code" required="" maxlength="20"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.businessType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.business\' | translate}}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="businessType" ng-model="vm.contractInfo.organisationDto.businessType" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.applicantProductHandled.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.products\' | translate}}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="applicantProductHandled" ng-model="vm.contractInfo.organisationDto.productsHandled" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.contact\' | translate }}</div><div class="panel-body"><address label="Address*" address="vm.contractInfo.organisationDto.addressDtos[0]" required="true" form-key="\'organisation_address\'" form="vm.newContractForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact" multiple="true" contact-entity="\'ADDRESS\'" contact="vm.contractInfo.organisationDto.addressDtos[0].contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_contact\'" form="vm.newContractForm"></contact></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="representative in vm.contractInfo.organisationDto.organisationRepresentativeDtos track by $index"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.representative.title\' | translate }}</div><div class="panel-body"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'companyRepresentativeName_\'+$index].$invalid || vm.newContractForm[\'companyRepresentativeNameReading_\'+$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.nameRep\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyRepresentativeNameReading_{{$index}}" placeholder="{{\'service.contract.create.applicant.information.company.representative.name.kana\' | translate }}" ng-model="representative.nameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="companyRepresentativeName_{{$index}}" placeholder="{{\'service.contract.create.applicant.information.company.representative.name\' | translate }}" ng-model="representative.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.representativedob.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.representative.dateOfBirh\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="representative.dateOfBirth" options="vm.dobOptions" ng-model="representative.dateOfBirth" name="representativedob" required=""></datepicker></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="account in vm.contractInfo.organisationDto.accountDtos track by $index"><div class="panel-heading">{{\'service.contract.create.inCharge.title\' | translate }}<div ng-if="$last && vm.contractInfo.organisationDto.accountDtos.length == 1" ng-click="vm.addNewRow(vm.contractInfo.organisationDto.accountDtos, \'CREATE_ORGANISATION\')" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.contractInfo.organisationDto.accountDtos.length !== 1" ng-click="vm.addNewRow(vm.contractInfo.organisationDto.accountDtos, \'CREATE_ORGANISATION\')" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="vm.contractInfo.organisationDto.accountDtos.length !== 1" ng-click="vm.removeRow(vm.contractInfo.organisationDto.accountDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'inchargeDepartment_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.incharge.department\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" required="" name="inchargeDepartment_{{$index}}" ng-model="account.inchargeDepartment" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': (vm.newContractForm[\'companyInChargePerson_\'+$index].$invalid || vm.newContractForm[\'companyInChargePersonReading_\'+$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.nameRep\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyInChargePersonReading_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name.kana\' | translate }}" ng-model="account.nameSimple" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="companyInChargePerson_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name\' | translate }}" ng-model="account.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div ng-init="account.accountTypes=[\'ADMIN\']"><contact get-label="vm.getValueFromTypeKey" label="Contact" contact-entity="\'ACCOUNT\'" contact="account.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newContractForm"></contact></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'companyUsername_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.contact.email\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" valid-email="" class="form-control" name="companyUsername_{{$index}}" ng-model="account.userName" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.email_error_msg\' | translate}}</span></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.deviceOwner.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.deviceOwner.device.purchase\' | translate}}</label><div>{{vm.getValueFromTypeKey(vm.contractInfo.merchantOwnerType, vm.types.MerchantOwnerType)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="deviceOwner in vm.deviceOwnerDto track by $index"><div class="panel-heading">{{\'service.contract.create.deviceOwner.subTitle\' | translate }} {{vm.selfDO[$index]}}<div ng-if="!vm.selfDO[$index]"><div ng-if="$last && vm.deviceOwnerDto.length == 1" ng-click="vm.addNewRow(vm.deviceOwnerDto)" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.deviceOwnerDto.length !== 1" ng-click="vm.addNewRow(vm.deviceOwnerDto)" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div></div><div ng-if="vm.selfDO[$index] && vm.deviceOwnerDto.length >= 2"><div ng-if="$last && vm.deviceOwnerDto.length == 1" ng-click="vm.addNewRow(vm.deviceOwnerDto)" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.deviceOwnerDto.length !== 1" ng-click="vm.addNewRow(vm.deviceOwnerDto)" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div></div><div ng-if="!vm.selfDO[$index]"><div ng-if="vm.deviceOwnerDto.length !== 1" ng-click="vm.removeDeviceOwnerRow(vm.deviceOwnerDto, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.deviceOwner_{{$index}}.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL" ng-if="!vm.selfDO[$index]"><label>{{\'service.contract.create.deviceOwner.name\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" typeahead-on-select="vm.onOrgSelected($item, $index)" name="deviceOwner_{{$index}}" ng-model="deviceOwner.deviceOrgName" uib-typeahead="org.name as org.name for org in vm.getDeviceOwner($viewValue)" class="form-control" required=""></div><div class="form-input-group-row labelXXL" ng-if="vm.selfDO[$index]"><label>{{\'service.contract.create.deviceOwner.name\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" typeahead-on-select="vm.onOrgSelected($item, $index)" name="deviceOwner_{{$index}}" ng-model="deviceOwner.deviceOrgName" uib-typeahead="org.name as org.name for org in vm.getDeviceOwner($viewValue)" class="form-control" required="" disabled=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.deviceOwner.code\' | translate }}</label> <input type="text" class="form-control" ng-model="deviceOwner.code" disabled=""></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'partner.link\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width" ng-repeat="partnerSummaries in vm.contractInfo.partnerDtos track by $index"><div class="panel-heading">{{\'partner.details\' | translate }}<div ng-if="$last && vm.contractInfo.partnerSummaries.length == 1" ng-click="vm.addNewRow(vm.contractInfo.partnerDtos)" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.contractInfo.partnerSummaries.length !== 1" ng-click="vm.addNewRow(vm.contractInfo.partnerDtos)" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="vm.contractInfo.partnerSummaries.length !== 1" ng-click="vm.removePartner(vm.contractInfo.partnerDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'partner.name\' | translate }}</label> <input type="text" typeahead-on-select="vm.onPartnerSelected($item, $index)" name="partnerSummaries_{{$index}}" ng-model="partnerSummaries.name" uib-typeahead="partner.name as partner.name for partner in vm.getPartner($viewValue)" class="form-control"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'partner.code\' | translate }}</label> <input type="text" class="form-control" ng-model="partnerSummaries.partnerCode" disabled=""></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.acquirer.title\' | translate }}</div><div class="panel-body"><div class="row" ng-if="vm.permissions.SERVICE_CONTRACT.WRITE"><div class="col-md-12"><div class="panel panel-default bo otstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.acquirer.jmups\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.acquirer.jmups.select\' | translate }}</label><ui-select ng-model="vm.contractInfo.jmupsTemplate" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.JmupsTemplateMaster)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.JmupsTemplateMaster.key track by $index"><span ng-bind-html="vm.types.JmupsTemplateMaster[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.cir.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.terminalId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.tid"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.tidContract"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.senderId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.senderId"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-4"><ui-select ng-model="vm.contractInfo.serviceContractEmvDto.senderIdType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.SenderIdType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.SenderIdType.key track by $index"><span ng-bind-html="vm.types.SenderIdType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.receipientId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.receipientIdMUN"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.receipientIdJCB"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.merchantId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.merchantIdMUN"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.merchantIdJCB"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.2merchantId\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.secondMerchantIdMUN"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.secondMerchantIdJCB"></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.cir.merchantCategoryCode\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>MUN</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.merchantCategoryCodeMUN"></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelXXL"><label>JCB</label> <input type="text" class="form-control" ng-model="vm.contractInfo.serviceContractEmvDto.merchantCategoryCodeJCB"></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.serviceDetails.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_10SelectAllEmoney" ng-click="vm.handlingFeeEmoneyForME_10SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].paymentType=\'E_MONEY\';vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].deviceTypes=\'ME-10\';vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_10_E_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_10_E_MONEY_value" ng-model="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_10.E_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_10SelectAllQRmoney" ng-click="vm.handlingFeeQRmoneyForME_10SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].deviceTypes=\'ME-10\';vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}} {{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_10_QR_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_10_QR_MONEY_value" ng-model="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-5"><div style="padding-left: 0;" class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_10.QR_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.20.1\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.20.1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_1SelectAllEmoney" ng-click="vm.handlingFeeEmoneyForME_20_1SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].paymentType=\'E_MONEY\';vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].deviceTypes=\'ME-20-1\';vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_1_E_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_1_E_MONEY_value" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.E_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.creditCard\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_1SelectAllCreditCard" ng-click="vm.handlingFeeCreditCardForME_20_1SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.CREDIT_CARD.key track by $index" ng-if="vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].paymentType=\'CREDIT_CARD\';vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].deviceTypes=\'ME-20-1\';vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_1_CREDIT_CARD_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_1_CREDIT_CARD_value" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.CREDIT_CARD[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_1SelectAllQRmoney" ng-click="vm.handlingFeeQRmoneyForME_20_1SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].deviceTypes=\'ME-20-1\';vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}} {{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_1_QR_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_1_QR_MONEY_value" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-5"><div style="padding-left: 0;" class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_1.QR_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.20.2\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.20.2\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.emoney\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_2SelectAllEmoney" ng-click="vm.handlingFeeEmoneyForME_20_2SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.E_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.E_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].paymentType=\'E_MONEY\';vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].deviceTypes=\'ME-20-2\';vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.E_MONEY[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_2_E_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_2_E_MONEY_value" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.E_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.creditCard\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_2SelectAllCreditCard" ng-click="vm.handlingFeeCreditCardForME_20_2SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.CREDIT_CARD.key track by $index" ng-if="vm.types.PaymentHandlingOption.CREDIT_CARD.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].paymentType=\'CREDIT_CARD\';vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].deviceTypes=\'ME-20-2\';vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.CREDIT_CARD[vm.getLang()][$index]}}{{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_2_CREDIT_CARD_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_2_CREDIT_CARD_value" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div style="padding-left: 0;" class="col-md-5"><div class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.CREDIT_CARD[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_20_2SelectAllQRmoney" ng-click="vm.handlingFeeQRmoneyForME_20_2SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].deviceTypes=\'ME-20-2\';vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}} {{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_20_2_QR_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_20_2_QR_MONEY_value" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-5"><div style="padding-left: 0;" class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_20_2.QR_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.a.ME.5.1\' | translate }}</div><div class="panel-body"><div class="form-group">{{\'service.contract.create.serviceDetails.subTitle.a1.ME.5.1\' | translate }}</div><div class="row"><div class="col-md-6"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.qr\' | translate }}</div><div class="panel-body"><div class="row>"><div class="col-md-7"></div><div class="col-md-5"><div class="form-group" style="padding-left:2px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.handlingFeeME_5_1SelectAllQRmoney" ng-click="vm.handlingFeeQRmoneyForME_5_1SelectAll()"> <span class="handling-fee-checkbox">{{\'common.components.select.all\' | translate }}</span></label></div></div></div><div class="row" ng-repeat="option in vm.types.PaymentHandlingOption.QR_MONEY.key track by $index" ng-if="vm.types.PaymentHandlingOption.QR_MONEY.inUse[$index]"><div class="col-md-4"><div class="form-group"><div class="form-input-group-row labelL" ng-init="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].paymentType=\'QR_MONEY\';vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].deviceTypes=\'ME-5-1\';vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].paymentOption=option"><label class="custom-label-width">{{vm.types.PaymentHandlingOption.QR_MONEY[vm.getLang()][$index]}} {{\'common.components.required\' | translate }}</label><ui-select ng-model="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption" class="btn-group bootstrap-select form-control emoney-select" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.PaymentDeductionOption)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.PaymentDeductionOption.key track by $index"><span ng-bind-html="vm.types.PaymentDeductionOption[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-3"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.{{option}}_ME_5_1_QR_MONEY_value.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><input type="text" class="form-control flatBox" name="{{option}}_ME_5_1_QR_MONEY_value" ng-model="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].rateOrAmount" service-fee-number-validation="" required=""> <span ng-if="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption === \'FLAT\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.yen\' | translate }}</span> <span ng-if="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].paymentDeductionOption === \'PERCENTAGE\'" class="nowrap m-l-5">{{\'service.contract.create.serviceDetails.percent\' | translate }}</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-5"><div style="padding-left: 0;" class="col-md-8"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].createSettlement"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.includeSettlement\' | translate }}</span></label></div><div style="padding-left: 0;" class="col-md-4"><label class="checkbox-inline custom-checkbox"><input type="checkbox" ng-model="vm.paymentHandlingFeeDtos.ME_5_1.QR_MONEY[$index].nonTaxable"> <span class="handling-fee-checkbox">{{\'service.contract.create.serviceDetails.nonTaxable\' | translate }}</span></label></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b1\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.builtIn_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}{{\'common.components.required\' | translate }}</label><span>ME-10-1</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn_initial" model="vm.serviceFeeDtos.builtIn_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN.key[0]]" modem-type="\'BUILT_IN\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form-key="\'builtIn_initial\'" form="vm.newContractForm" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn_monthly" model="vm.serviceFeeDtos.builtIn_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.monthly.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN.key[0]]" modem-type="\'BUILT_IN\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'builtIn_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b2\' | translate }}</div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.external_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}{{\'common.components.required\' | translate }}</label><span>ME-10-2</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external_initial" base-fee-model="vm.baseServiceFeeDtos.external_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external_initial" model="vm.serviceFeeDtos.external_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL.key[0]]" modem-type="\'EXTERNAL\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'external_initial\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external_monthly" base-fee-model="vm.baseServiceFeeDtos.external_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external_monthly" model="vm.serviceFeeDtos.external_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL.key[0]]" modem-type="\'EXTERNAL\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'external_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b3\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.builtIn_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><span>ME-20-1</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn20_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn20_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn20_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn20_initial" model="vm.serviceFeeDtos.builtIn20_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_20.key[0]]" modem-type="\'BUILT_IN_20\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'builtIn20_initial\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn20_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn20_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn20_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn20_monthly" model="vm.serviceFeeDtos.builtIn20_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_20.key[0]]" modem-type="\'BUILT_IN_20\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'builtIn20_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b4\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.external_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label><span>ME-20-2</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external20_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external20_initial" base-fee-model="vm.baseServiceFeeDtos.external20_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external20_initial" model="vm.serviceFeeDtos.external20_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL_20.key[0]]" modem-type="\'EXTERNAL_20\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'external20_initial\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.external20_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.external20_monthly" base-fee-model="vm.baseServiceFeeDtos.external20_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.external20_monthly" model="vm.serviceFeeDtos.external20_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.EXTERNAL_20.key[0]]" modem-type="\'EXTERNAL_20\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'external20_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.serviceDetails.subTitle.b5\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.builtIn_deviceType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row"><label>{{\'service.contract.create.serviceDetails.applicable.device\' | translate }}</label> <span>ME-5-1</span></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn5_initial" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn5_initial" base-fee-model="vm.baseServiceFeeDtos.builtIn5_initial" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn5_initial" model="vm.serviceFeeDtos.builtIn5_initial" title="service.contract.create.serviceDetails.init.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_5.key[0]]" modem-type="\'BUILT_IN_5\'" service-fee-frequency="\'INITIAL\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'builtIn5_initial\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div><div class="col-md-6"><service-fee other-fee-model="vm.otherServiceFeeDtos.builtIn5_monthly" qr-other-fee-model="vm.qrOtherServiceFeeDtos.builtIn5_monthly" base-fee-model="vm.baseServiceFeeDtos.builtIn5_monthly" credit-card-fee-model="vm.serviceFeeDtosCreditCard.builtIn5_monthly" model="vm.serviceFeeDtos.builtIn5_monthly" title="service.contract.create.serviceDetails.monthly.charges.title" sub-title="service.contract.create.serviceDetails.init.charges.sub" device-type="[vm.types.DeviceType.BUILT_IN_5.key[0]]" modem-type="\'BUILT_IN_5\'" service-fee-frequency="\'MONTHLY\'" get-label="vm.getValueFromTypeKey" form="vm.newContractForm" form-key="\'builtIn5_monthly\'" payment-handling-option="vm.types.PaymentHandlingOption" service-fee-edit="true" payment-deduction-option="vm.types.PaymentDeductionOption"></service-fee></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">(C) {{\'service.contract.create.other.title\' | translate }}</div><div class="panel-body"><div class="form-group"><div class="col-md-4"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.other.cancellation.charge\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.contractInfo.cancellationCharge"> &nbsp;{{\'service.contract.create.serviceDetails.yen\' | translate }}</div></div></div></div></div><div class="form-group"><div class="form-input-group-row labelXXL alignTop"><label>{{\'service.contract.create.service.usage.remarks\' | translate }}</label> <textarea class="form-control" ng-model="vm.contractInfo.serviceUsageRemarks"></textarea></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'service.contract.create.settlementConditions.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.method.group\' | translate }}</label></div><div class="w-btn-lg"><ui-select ng-model="vm.contractInfo.settlementMethodDto.settlementGroup" name="settlementGroup" class="btn-group bootstrap-select form-control settlement-group" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.SettlementGroup)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.SettlementGroup.key track by $index"><span ng-bind-html="vm.types.SettlementGroup[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.method.sub\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.SettlementDate.key track by $index"><input type="radio" name="settlementDate" ng-model="vm.contractInfo.settlementMethodDto.settlementDate" value="{{option}}" required=""> <span>{{vm.types.SettlementDate[vm.getLang()][$index]}}</span></label></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.closing.sub\' | translate }}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.closingDate, vm.types.ClosingDate)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.paymentMethod.sub\' | translate}}<br>{{\'service.contract.create.settlementConditions.paymentMethod.sub1\' | translate}}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.paymentMethod, vm.types.PaymentMethod)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementConditions.createInvoice\' | translate}}</label></div><div ng-if="vm.contractInfo.settlementMethodDto.paymentMethod === \'OFFSETTING\'">{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.createInvoice, vm.types.createInvoice)}}</div><div ng-if="vm.contractInfo.settlementMethodDto.paymentMethod === \'NON_OFFSETTING\'"><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.createInvoice.key track by $index"><input type="radio" name="createInvoices" ng-model="vm.contractInfo.settlementMethodDto.createInvoice" ng-value="{{option}}" required=""> <span>{{vm.types.createInvoice[vm.getLang()][$index]}}</span></label></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row noWrap"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.bank.transfer.sub\' | translate }}</label></div><div>{{vm.getValueFromTypeKey(vm.contractInfo.settlementMethodDto.invoiceMethod, vm.types.InvoiceMethod)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="form-group"><div class="form-detail-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.charge.monthlyFee.from\' | translate}}</label></div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.ChargeMonthlyFeeFrom.key track by $index"><input type="radio" name="chargeMonthlyFeeFrom" ng-model="vm.contractInfo.settlementMethodDto.chargeMonthlyFeeFrom" value="{{option}}" required=""> <span>{{vm.types.ChargeMonthlyFeeFrom[vm.getLang()][$index]}}</span></label></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.details.by.deviceOwner\' | translate}}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.detailsByDeviceOwner.key track by $index"><input type="radio" name="detailsByDeviceOwner" ng-model="vm.contractInfo.settlementMethodDto.detailsByDeviceOwner" ng-value="{{option}}" required=""> <span>{{vm.types.detailsByDeviceOwner[vm.getLang()][$index]}}</span></label></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.emailInvoice\' | translate}}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.emailInvoice.key track by $index"><input type="radio" name="emailInvoice" ng-model="vm.contractInfo.settlementMethodDto.emailInvoice" ng-value="{{option}}" required=""> <span>{{vm.types.emailInvoice[vm.getLang()][$index]}}</span></label></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.isSystemAdmin"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-2"><label>{{\'service.contract.create.settlementInformation.telemetryAccess\' | translate}}{{\'common.components.required\' | translate }}</label></div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.types.emailInvoice.key track by $index"><input type="radio" name="enableTelemetryOption" ng-model="vm.contractInfo.settlementMethodDto.enableTelemetryOption" ng-value="{{option}}" required=""> <span>{{vm.types.emailInvoice[vm.getLang()][$index]}}</span></label></div></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-repeat="settlement in vm.contractInfo.settlementBranchDtos track by $index"><div class="panel-heading"><span>{{$index + 1}}. {{\'service.contract.create.settlementInformation.title\' | translate }}</span><div ng-if="vm.contractInfo.settlementMethodDto.invoiceMethod == \'BRANCH\'"><div ng-if="$last && vm.contractInfo.settlementBranchDtos.length == 1" ng-click="vm.addNewRow(vm.contractInfo.settlementBranchDtos, \'ADD_SETTLEMENT\')" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.contractInfo.settlementBranchDtos.length !== 1" ng-click="vm.addNewRow(vm.contractInfo.settlementBranchDtos, \'ADD_SETTLEMENT\')" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="!vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><div ng-if="vm.contractInfo.settlementBranchDtos.length !== 1" ng-click="vm.removeRow(vm.contractInfo.settlementBranchDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div></div></div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.settlementInformation.bankAccount.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'settlementBankCode_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" name="settlementBankCode_{{$index}}" typeahead-on-select="vm.onBankSelected($item, $index)" ng-model="settlement.settlementBankDto.bankCode" uib-typeahead="bank.bankCode as bank.bankCode for bank in vm.bankCodeChange($viewValue)" class="form-control" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'settlementBranchCode_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankBranchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" name="settlementBranchCode_{{$index}}" typeahead-on-select="vm.onBankBranchSelected($item, $index)" ng-model="settlement.settlementBankDto.branchCode" uib-typeahead="branch.branchCode as branch.branchCode for branch in vm.bankBranchCodeChange($viewValue)" class="form-control" maxlength="10" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'bankName_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" ng-model="settlement.settlementBankDto.bankName" name="bankName_{{$index}}" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (vm.newContractForm[\'branchName_\'+$index].$invalid || vm.newContractForm[\'branchType_\'+$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bankBranchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" ng-model="settlement.settlementBankDto.branchName" name="branchName_{{$index}}" required="" special-character-limit=""><ui-select ng-model="settlement.settlementBankDto.branchType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.BankBranchType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.BankBranchType.key track by $index"><span ng-bind-html="vm.types.BankBranchType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'bankType_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.bank.type\' | translate }}{{\'common.components.required\' | translate }}</label><ui-select ng-model="settlement.settlementBankDto.bankType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" name="bankType_{{$index}}" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.BankType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.BankType.key track by $index"><span ng-bind-html="vm.types.BankType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'accountNo_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.accountNo\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="accountNo_{{$index}}" ng-model="settlement.settlementBankDto.accountNumber" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'bankAccountType_\'+$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.type.of.account\' | translate }}{{\'common.components.required\' | translate }}</label><ui-select ng-model="settlement.settlementBankDto.bankAccountType" name="bankAccountType_{{$index}}" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.BankAccountType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.BankAccountType.key track by $index"><span ng-bind-html="vm.types.BankAccountType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'bankAccountName_\'+$index].$invalid || vm.newContractForm[\'bankAccountNameReading_\'+$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.account.holder\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="bankAccountNameReading_{{$index}}" placeholder="{{\'service.contract.create.settlementInformation.bankAccount.accountName.kana\' | translate }}" ng-model="settlement.settlementBankDto.accountHolderNameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="bankAccountName_{{$index}}" ng-model="settlement.settlementBankDto.accountHolderName" placeholder="{{\'service.contract.create.settlementInformation.bankAccount.accountName\' | translate }}" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.contractInfo.settlementMethodDto.paymentMethod === \'OFFSETTING\'"><div class="panel-heading">{{vm.getValueFromTypeKey(\'OFFSET_NOTIFICATION\', vm.types.BranchLocationType)}}</div><div class="panel-body"><div class="row" ng-show="vm.contractInfo.settlementBranchDtos[$index].settlementSendLocationDtos[0].destinationInvoiceId"><div class="col-md-12"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.invoiceId\' | translate }}</label><div>{{vm.contractInfo.settlementBranchDtos[$index].settlementSendLocationDtos[0].destinationInvoiceId}}</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'branchName_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL" ng-if="vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_{{$index}}_{{$parent.$index}}" ng-model="settlement.settlementSendLocationDtos[0].branchName" required="" disabled="" special-character-limit=""></div><div class="form-input-group-row labelXXL" ng-if="!vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchNameMaxLength}}" required="" ng-model="settlement.settlementSendLocationDtos[0].branchName" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'centerCode_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL" ng-if="vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationDtos[0].branchCode" required="" disabled="" special-character-limit=""></div><div class="form-input-group-row labelXXL" ng-if="!vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationDtos[0].branchCode" special-character-limit="" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.half.width.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'inChargeName_\'+$index+\'_\'+$parent.$index].$invalid || vm.newContractForm[\'inChargeNameReading_\'+$index+\'_\'+$parent.$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.name\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="inChargeNameReading_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName.kana\' | translate }}" ng-model="settlement.settlementSendLocationDtos[0].inChargeNameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="inChargeName_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName\' | translate }}" ng-model="settlement.settlementSendLocationDtos[0].inChargeName" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><address label="Address*" address="settlement.settlementSendLocationDtos[0].addressDto" required="true" form-key="\'settlement_address_\'+$parent.$index+\'_\'+$index" form="vm.newContractForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="settlement.settlementSendLocationDtos[0].addressDto.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="true" email-required="false" form-key="\'settlement_contact\'+$parent.$index+\'_\'+$index" form="vm.newContractForm"></contact><div class="form-group m-b-0 m-t-20"><div class="form-input-group-row labelXXL alignTop"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.remarks\' | translate }}</label> <textarea class="form-control" ng-model="settlement.remarks"></textarea></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-if="vm.contractInfo.settlementMethodDto.paymentMethod === \'NON_OFFSETTING\'"><div class="panel-heading"><span>{{vm.getValueFromTypeKey(\'INVOICE_DESTINATION\', vm.types.BranchLocationType)}}</span></div><div class="panel-body"><div class="row" ng-show="vm.contractInfo.settlementBranchDtos[$index].settlementSendLocationDtos[0].destinationInvoiceId"><div class="col-md-12"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.invoiceId\' | translate }}</label><div>{{vm.contractInfo.settlementBranchDtos[$index].settlementSendLocationDtos[0].destinationInvoiceId}}</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'branchName_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL" ng-if="vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchNameMaxLength}}" ng-model="settlement.settlementSendLocationDtos[0].branchName" required="" special-character-limit=""></div><div class="form-input-group-row labelXXL" ng-if="!vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchNameMaxLength}}" ng-model="settlement.settlementSendLocationDtos[0].branchName" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'centerCode_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL" ng-if="vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationDtos[0].branchCode" required="" special-character-limit=""></div><div class="form-input-group-row labelXXL" ng-if="!vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationDtos[0].branchCode" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.half.width.valid.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'inChargeName_\'+$index+\'_\'+$parent.$index].$invalid || vm.newContractForm[\'inChargeNameReading_\'+$index+\'_\'+$parent.$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.name\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="inChargeNameReading_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName.kana\' | translate }}" ng-model="settlement.settlementSendLocationDtos[0].inChargeNameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="inChargeName_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName\' | translate }}" ng-model="settlement.settlementSendLocationDtos[0].inChargeName" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><address label="Address*" address="settlement.settlementSendLocationDtos[0].addressDto" required="true" form-key="\'settlement_address_\'+$parent.$index+\'_\'+$index" form="vm.newContractForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="settlement.settlementSendLocationDtos[0].addressDto.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="true" email-required="false" form-key="\'settlement_contact\'+$parent.$index+\'_\'+$index" form="vm.newContractForm"></contact></div><div class="m-t-30"></div><div class="panel-heading"><span>{{vm.getValueFromTypeKey(\'CREDIT_NOTIFICATION\', vm.types.BranchLocationType)}}</span></div><div class="panel-body"><div class="row" ng-show="vm.contractInfo.settlementBranchDtos[$index].settlementSendLocationDtos[1].destinationInvoiceId"><div class="col-md-12"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.settlementInformation.bankAccount.invoiceId\' | translate }}</label><div>{{vm.contractInfo.settlementBranchDtos[$index].settlementSendLocationDtos[1].destinationInvoiceId}}</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'branchName_cr_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL" ng-if="vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_cr_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchNameMaxLength}}" ng-model="settlement.settlementSendLocationDtos[1].branchName" disabled="" required="" special-character-limit=""></div><div class="form-input-group-row labelXXL" ng-if="! vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchName\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="branchName_cr_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchNameMaxLength}}" ng-model="settlement.settlementSendLocationDtos[1].branchName" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm[\'centerCode_cr_\'+$index+\'_\'+$parent.$index].$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL" ng-if="vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_cr_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationDtos[1].branchCode" disabled="" required="" special-character-limit=""></div><div class="form-input-group-row labelXXL" ng-if="!vm.contractInfo.settlementBranchDtos[$index].deviceRequestAvailable"><label>{{\'service.contract.create.settlementInformation.bankAccount.branchCode\' | translate }}{{\'common.components.required\' | translate }}</label> <input type="text" class="form-control" name="centerCode_cr_{{$index}}_{{$parent.$index}}" maxlength="{{vm.branchCodeMaxLength}}" half-width-limit="" ng-model="settlement.settlementSendLocationDtos[1].branchCode" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.half.width.valid.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newContractForm[\'inChargeName_cr_\'+$index+\'_\'+$parent.$index].$invalid || vm.newContractForm[\'inChargeNameReading_cr_\'+$index+\'_\'+$parent.$index].$invalid) && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.name\' | translate }}{{\'common.components.required\' | translate }}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="inChargeNameReading_cr_{{$index}}_{{$parent.$index}}" ng-required="true" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName.kana\' | translate }}" ng-model="settlement.settlementSendLocationDtos[1].inChargeNameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="inChargeName_cr_{{$index}}_{{$parent.$index}}" placeholder="{{\'service.contract.create.settlementInformation.settlement.send.location.inChargeName\' | translate }}" ng-model="settlement.settlementSendLocationDtos[1].inChargeName" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate }}</span></div></div></div><address label="Address*" address="settlement.settlementSendLocationDtos[1].addressDto" required="true" form-key="\'settlement_address_cr_\'+$parent.$index+\'_\'+$index" form="vm.newContractForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="settlement.settlementSendLocationDtos[1].addressDto.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="true" email-required="false" form-key="\'settlement_contact_cr\'+$parent.$index+\'_\'+$index" form="vm.newContractForm"></contact></div><div class="form-group m-b-0 m-t-20"><div class="form-input-group-row labelXXL alignTop"><label>{{\'service.contract.create.settlementInformation.settlement.send.location.remarks\' | translate }}</label> <textarea class="form-control" ng-model="settlement.remarks"></textarea></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="form-group"><div class="form-input-group-row labelXXL alignTop"><label>{{\'service.contract.create.service.contract.remarks\' | translate }}</label> <textarea class="form-control" name="serviceOperatorRemarks" ng-model="vm.contractInfo.remarks"></textarea></div></div><br><div class="row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.ownerCanApplyForDevice" name="ownerCanApplyForDevice"> <span>{{\'service.contract.create.bool1\' | translate }}</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.ownerMustApproveDeviceRequest" name="ownerMustApproveDeviceRequest" ng-disabled="true"> <span>{{\'service.contract.create.bool2\' | translate }}</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.contractInfo.merchantCanApplyForDeviceRequest" name="merchantCanApplyForDeviceRequest"> <span>{{\'service.contract.create.bool3\' | translate }}</span></label></div></div><br></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a class="btn btn-primary pull-right m-r-20" ng-click="vm.cancelEdit()" ng-disabled="vm.recordsUpdating">{{\'service.contract.create.service.contract.cancel\' | translate}}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.saveDetail()" ng-disabled="vm.recordsUpdating" ng-dblclick="vm.disableButton()">{{\'service.contract.create.service.contract.save\' | translate}} <i ng-if="vm.recordsUpdating" class="inProgress m-l-10"></i></button></div></form></div>');
$templateCache.put('app/pages/service-contact/views/jesca-maroon.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="panel panel-default bootstrap-panel"><div class="handsOnTableWrapper"><div id="handsontable-request-detail"></div></div><div class="clearfix bottomAction" ng-if="vm.permissions.DEVICE_REQUEST.WRITE"><button class="btn btn-primary pull-right" ng-click="vm.cancelCreate()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.applyMaroon()" ng-disabled="vm.disableActionButtons">{{ "service.contract.list.maroon.application.register" | translate }} <i class="inProgress m-l-10" ng-if="vm.createInProgress"></i></button><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div></div><div class="clearfix bottomAction" ng-if="(!vm.permissions.DEVICE_REQUEST.WRITE && vm.permissions.DEVICE_REQUEST.READ)"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div></div></div>');
$templateCache.put('app/pages/service-contact/views/list.html','<div ba-panel="" ba-panel-class="with-scroll" ng-if="vm.permissions.SERVICE_CONTRACT.WRITE"><form class="row form-inline"><button ng-if="vm.permissions.SERVICE_CONTRACT.WRITE" ngf-select="vm.uploadFile($file, $event, bank)" class="btn btn-primary pull-right" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"><i class="fa fa-upload" aria-hidden="true"></i> &nbsp; {{ "service.contract.list.upload.excel.btn" | translate}} <i class="inProgress m-l-10" ng-if="vm.uploadInProgress"></i></button> <button class="btn btn-primary pull-right m-l-10 m-r-10" ng-if="vm.permissions.SERVICE_CONTRACT.WRITE" ng-click="vm.downloadMutlipleCSV()"><i class="fa fa-download" aria-hidden="true"></i> &nbsp; {{ "service.contract.list.download.excel.btn" | translate}} <i class="inProgress m-l-10" ng-if="vm.isDownloadingMultipleExcel"></i></button></form></div><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th>{{\'service.contract.list.contract.id\' | translate}}</th><th>{{\'service.contract.list.doc\' | translate}}</th><th>{{\'service.contract.list.merchant.id\' | translate}}</th><th>{{\'service.contract.list.merchant.name\' | translate}}</th><th>{{\'service.contract.list.owner.id\' | translate}}</th><th>{{\'service.contract.list.owner.name\' | translate}}</th><th>{{\'service.contract.list.merchant.address\' | translate}}</th><th colspan="1" class="text-center" ng-if="vm.permissions.SERVICE_CONTRACT.READ">{{\'org.list.action\' | translate}}</th><th colspan="1" class="text-center" ng-if="vm.permissions.SERVICE_CONTRACT.CSV">{{\'service.contract.list.download\' | translate}}</th></tr></thead><tbody><tr ng-repeat="sc in vm.scListResponse.content"><td style="text-align: left;">{{vm.scListResponse.pageable.offset + $index + 1}}</td><td width="90px" class="text-center">{{sc.serviceContractId}} <a title="{{\'merchant.number.isRegistered\' | translate}}" class="m-no-success" ng-if="sc.merchantNumberRegistered && vm.permissions.SERVICE_CONTRACT.WRITE"><i class="fa fa-check-circle"></i></a> <a title="{{\'merchant.number.notRegistered\' | translate}}" class="m-no-error" ng-if="!sc.merchantNumberRegistered && vm.permissions.SERVICE_CONTRACT.WRITE"><i class="fa fa-times-circle"></i></a></td><td style="text-align: left;">{{sc.date | date : \'yyyy/MM/dd\'}}</td><td>{{sc.organisationDto.merchantCode}}</td><td class="word-break">{{sc.organisationDto.name}}</td><td>{{vm.getOwnerIds(sc.deviceOwnerDtos)}}</td><td class="word-break">{{vm.getOwnerName(sc.deviceOwnerDtos)}}</td><td class="word-break">{{sc.organisationDto.addressDtos[0].streetAddress || ""}}</td><td class="text-center" ng-if="vm.permissions.SERVICE_CONTRACT.READ"><button ng-if="vm.permissions.SERVICE_CONTRACT.WRITE" class="btn btn-info btn-xs" ng-click="vm.openDetail($event, sc)">{{\'org.list.view.edit\' | translate}}</button> <button ng-if="!vm.permissions.SERVICE_CONTRACT.WRITE" class="btn btn-info btn-xs" ng-click="vm.openDetail($event, sc)">{{\'org.list.view\' | translate}}</button></td><td ng-if="vm.permissions.SERVICE_CONTRACT.CSV"><button class="btn btn-info btn-xs" ng-click="vm.downloadCSV(sc.serviceContractId)">{{\'service.contract.list.merchant.information\' | translate}} &nbsp;<i class="fa fa-download" aria-hidden="true"></i></button></td></tr></tbody></table></div><div class="m-t-20"><pagination query="vm.query" pageable="vm.scListResponse.pageable" total-pages="vm.scListResponse.totalPages" total-elements="vm.scListResponse.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div>');
$templateCache.put('app/pages/system-management/views/jmups-mapping.html','<div ng-if="!vm.isEdit"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{"jmups.mapping.title" | translate}}<div ng-click="vm.editDetail()" class="btn btn-default addNewRow">{{\'org.view.EDIT\' | translate}}</div></div><div class="panel-body table-panel"><div class="row"><div class="col-md-6"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th colspan="2">{{\'jmups.mapping.area\' | translate}}</th><th>{{\'jmups.mapping.area.specific\' | translate}}</th><th>{{\'jmups.mapping.current.operator\' | translate}}</th></tr></thead><tbody><tr><td>1.</td><td>{{vm.areaMap[0][vm.getLang()]}}</td><td>{{vm.areaMap[0].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[0][vm.getLang()]}}</td></tr><tr><td rowspan="8">2.</td><td rowspan="8">{{vm.areaMap[1][vm.getLang()]}}</td><td>{{vm.areaMap[1].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[1][vm.getLang()]}}</td></tr><tr><td rowspan="7"></td><td>{{vm.areaMap[2].prefecture[vm.getLang()]}}</td><td rowspan="7">{{vm.currentOperator[2][vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[3].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[4].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[5].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[6].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[7].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[8].prefecture[vm.getLang()]}}</td></tr><tr><td rowspan="4">3.</td><td rowspan="4">{{vm.areaMap[9][vm.getLang()]}}</td><td>{{vm.areaMap[9].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[9][vm.getLang()]}}</td></tr><tr><td rowspan="3"></td><td>{{vm.areaMap[10].prefecture[vm.getLang()]}}</td><td>{{vm.currentOperator[10][vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[11].prefecture[vm.getLang()]}}</td><td>{{vm.currentOperator[11][vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[12].prefecture[vm.getLang()]}}</></td><td>{{vm.currentOperator[12][vm.getLang()]}}</td></tr><tr><td>4.</td><td>{{vm.areaMap[13][vm.getLang()]}}</td><td>{{vm.areaMap[13].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[13][vm.getLang()]}}</td></tr><tr><td rowspan="2">5.</td><td rowspan="2">{{vm.areaMap[14][vm.getLang()]}}</td><td>{{vm.areaMap[14].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[14][vm.getLang()]}}</td></tr><tr><td></td><td>{{vm.areaMap[15].prefecture[vm.getLang()]}}</td><td>{{vm.currentOperator[15][vm.getLang()]}}</td></tr></tbody></table></div></div></div></div></div></div><div ng-if="vm.isEdit"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{"jmups.mapping.title" | translate}}</div><div class="panel-body table-panel"><div class="row"><div class="col-md-8" style="text-align:right;height:20px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.showInUseCheck" name="showInUse" checked="true" ng-change="vm.showInUse()"> <span>{{\'jmups.mapping.inuse.money.operator\' | translate }}</span></label></div><div class="col-md-8"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th colspan="2">{{\'jmups.mapping.area\' | translate}}</th><th>{{\'jmups.mapping.area.specific\' | translate}}</th><th>{{\'jmups.mapping.current.operator\' | translate}}</th><th>{{\'jmups.mapping.change.operator\' | translate}}</th></tr></thead><tbody><tr><td>1.</td><td>{{vm.areaMap[0][vm.getLang()]}}</td><td>{{vm.areaMap[0].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[0][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[0].transportPaymentOptionsMasterName" name="changeOperator_0" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td rowspan="8">2.</td><td rowspan="8">{{vm.areaMap[1][vm.getLang()]}}</td><td>{{vm.areaMap[1].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[1][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[1].transportPaymentOptionsMasterName" name="changeOperator_1" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td rowspan="7"></td><td>{{vm.areaMap[2].prefecture[vm.getLang()]}}</td><td rowspan="7">{{vm.currentOperator[2][vm.getLang()]}}</td><td rowspan="7" style="width:300px"><ui-select ng-model="vm.areaMap[2].transportPaymentOptionsMasterName" name="changeOperator_2" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td class="text-left">{{vm.areaMap[3].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[4].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[5].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[6].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[7].prefecture[vm.getLang()]}}</td></tr><tr><td class="text-left">{{vm.areaMap[8].prefecture[vm.getLang()]}}</td></tr><tr><td rowspan="4">3.</td><td rowspan="4">{{vm.areaMap[9][vm.getLang()]}}</td><td>{{vm.areaMap[9].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[9][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[9].transportPaymentOptionsMasterName" name="changeOperator_9" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td rowspan="3"></td><td>{{vm.areaMap[10].prefecture[vm.getLang()]}}</td><td>{{vm.currentOperator[10][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[10].transportPaymentOptionsMasterName" name="changeOperator_10" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td class="text-left">{{vm.areaMap[11].prefecture[vm.getLang()]}}</td><td>{{vm.currentOperator[11][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[11].transportPaymentOptionsMasterName" name="changeOperator_11" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td class="text-left">{{vm.areaMap[12].prefecture[vm.getLang()]}}</td><td>{{vm.currentOperator[12][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[12].transportPaymentOptionsMasterName" name="changeOperator_12" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td>4.</td><td>{{vm.areaMap[13][vm.getLang()]}}</td><td>{{vm.areaMap[13].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[13][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[13].transportPaymentOptionsMasterName" name="changeOperator_13" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td rowspan="2">5.</td><td rowspan="2">{{vm.areaMap[14][vm.getLang()]}}</td><td>{{vm.areaMap[14].prefecture[vm.getLang()]}}</td><td></td><td>{{vm.currentOperator[14][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[14].transportPaymentOptionsMasterName" name="changeOperator_14" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr><tr><td></td><td>{{vm.areaMap[15].prefecture[vm.getLang()]}}</td><td>{{vm.currentOperator[15][vm.getLang()]}}</td><td style="width:300px"><ui-select ng-model="vm.areaMap[15].transportPaymentOptionsMasterName" name="changeOperator_15" class="btn-group bootstrap-select form-control jmups-operator" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.changeOperator)}}</span></ui-select-match><ui-select-choices repeat="item in vm.changeOperator.key track by $index" ui-disable-choice="!vm.changeOperator.inUse[$index]"><span ng-bind-html="vm.changeOperator[vm.getLang()][$index]"></span></ui-select-choices></ui-select></td></tr></tbody></table></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a class="btn btn-primary pull-right" ng-disabled="vm.btnClick" ng-click="vm.cancelEdit()">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.saveDetail()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'jmups.mapping.save\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ item.title | translate }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ item.title | translate }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ subitem.title | translate }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ subSubitem.title | translate }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{ subSubitem.title | translate }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ subitem.title | translate }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ subitem.title | translate }}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-primary active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title"><span ng-if="activePageParentTitle!=\'\'">{{ activePageParentTitle | translate }}</span> <span ng-if="showArrow" class="navigationArrow1"><i class="fa fa-chevron-right"></i></span> {{ activePageTitle | translate }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/main/dashboard">{{ "home.page.home" | translate }}</a></li><li ng-if="activePageTitle!=\'\'">{{ activePageParentTitle | translate }} <span ng-if="showArrow" class="navigationArrow2"><i class="fa fa-chevron-right"></i></span> {{ activePageTitle | translate }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="/#/main/dashboard" class="al-logo clearfix"><span>{{\'home.page.title\' | translate}}</span>{{\'home.page.title2\' | translate}}</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="text-center" style="position: absolute;left: 50%;top: 30%;"><b>BUILD 2.21.0075 (2026/09/10)</b></div><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{::( \'Nasta\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href=""><i class="fa fa-user"></i>{{vm.profile.name}}</a></li><li><a href=""><i class="fa fa-building-o"></i>{{vm.profile.organisation.name}}</a></li><li ng-click="vm.changeLanguage(\'en\')"><a href=""><i class="fa fa-flag"></i>En</a></li><li ng-click="vm.changeLanguage(\'jp\')"><a href=""><i class="fa fa-flag"></i>Jp</a></li><li ng-click="vm.logout()"><a href=""><i class="fa fa-power-off"></i>{{\'login.sign.out\' | translate}}</a></li></ul></div></div></div><session></session>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/in-office-service/department/views/edit-department.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong ng-if="!vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong> <strong ng-if="vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'iosl.msg.server.error\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="department"><div class="handsOnTableWrapper"><div id="handsOnTable-department"></div></div><div class="clearfix bottomAction"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancel()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submit()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div></div>');
$templateCache.put('app/pages/in-office-service/department/views/list-department.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><div class="row"><div class="col-sm-12"><button ng-if="vm.permissions.OFFICE_DEPARTMENT.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onUpdate()" class="btn btn-primary btn-raised w-btn-md-3 btn-xs m-l-20">{{ "iosl.department.edit" | translate }} &nbsp;<i class="fa fa-edit" aria-hidden="true"></i>&nbsp;</button> <button ng-if="vm.permissions.OFFICE_DEPARTMENT.SUBMIT" ngf-select="vm.onUpload($file, $event, bank)" class="btn btn-primary btn-raised w-btn-md-2 btn-xs m-l-5" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "iosl.department.upload" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isUploadLoading"></i></button> <button ng-if="vm.permissions.OFFICE_DEPARTMENT.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onExport()" class="btn btn-info btn-raised btn-xs w-btn-md-3 m-l-5">{{ "iosl.department.download" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true" ng-if="!vm.isDownloadLoading"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloadLoading"></i></button> <button ng-if="vm.permissions.OFFICE_DEPARTMENT.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onDelete()" class="btn btn-danger btn-raised btn-xs w-btn-sm-x3 m-r-5 pull-right">{{ "iosl.department.delete" | translate }} &nbsp;<i class="fa fa-trash" aria-hidden="true" ng-if="!vm.isDeleteLoading"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDeleteLoading"></i></button></div><div class="col-sm-12 m-t-10"><form class="filters"><div class="w-btn-md-3 inline-block"><select class="form-control selectpicker show-tick" title="\u30AA\u30D5\u30A3\u30B9\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.OFFICE_ID" ng-change="vm.getDepartmentList()" ng-options="item for item in vm.officeIdList track by item" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="w-btn-md-2 m-l-8px inline-block"><select class="form-control selectpicker show-tick" title="\u90E8\u7F72\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.DEPARTMENT_ID" ng-options="item for item in vm.deptIdList track by item" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="inline-block pull-right m-r-5"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="vm.isFilterLoading">{{\'device.request.list.btn.show.data\' | translate}} <i class="inProgress-custom m-l-5" ng-if="vm.isFilterLoading"></i></button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="vm.isClearLoading">{{\'device.request.list.btn.clear\' | translate}} <i class="inProgress-custom m-l-5" ng-if="vm.isClearLoading"></i></button></div></form></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.select" ng-click="vm.onSelectAll($event, vm.departmentResponse.content)"> <span></span></label></th><th>#</th><th>{{\'iosl.department.office.id\' | translate}}</th><th>{{\'iosl.employee.office.name\' | translate}}</th><th>{{\'iosl.department.id\' | translate}}</th><th>{{\'iosl.department.name\' | translate}}</th><th>{{\'iosl.department.remarks\' | translate}}</th><th>{{\'iosl.last.modified\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in vm.departmentResponse.content" track="" by="" $index=""><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedIds[item.id]"> <span></span></label></td><td style="text-align: left;">{{vm.departmentResponse.offset + $index + 1}}</td><td class="word-break">{{item.officeId}}</td><td class="word-break">{{item.officeName}}</td><td class="word-break">{{item.departmentId}}</td><td class="word-break">{{item.name}}</td><td class="word-break">{{item.remarks}}</td><td class="word-break">{{item.lastModified | date: \'medium\'}}</td></tr></tbody></table></div><div class="m-t-20"><paginationv2 query="vm.filter" current-page-size="vm.departmentResponse.currentPageSize" current-page="vm.departmentResponse.currentPage" total-pages="vm.departmentResponse.totalPages" total-elements="vm.departmentResponse.totalElements" paginate-callback="vm.paginateCallback"></paginationv2></div></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/in-office-service/department/views/list-preview.html','<ul class="nav nav-tabs"><li><button ng-class="{\'active\': !vm.isEmployeeTableVisible}" class="btn btn-primary" ng-click="vm.showDepartmentTable()" ng-disabled="vm.isDepartmentEmpty">{{ "iosl.employee.department" | translate }}</button></li><li><button ng-class="{\'active\': vm.isEmployeeTableVisible}" class="btn btn-primary" ng-click="vm.showEmployeeTable()" ng-disabled="!vm.isDepartmentUploaded || vm.isEmployeeEmpty">{{ "iosl.department.employee" | translate }}</button></li></ul><div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts && vm.alerts.length > 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'iosl.msg.server.error\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="employee"><div class="handsOnTableWrapper"><div id="handsOnTable-employee-department"></div></div><div class="clearfix bottomAction" ng-if="vm.isEmployeeTableVisible"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancelEmployee()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submitEmployee()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div><div class="clearfix bottomAction" ng-if="!vm.isEmployeeTableVisible"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancelDepartment()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submitDepartment()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div></div>');
$templateCache.put('app/pages/in-office-service/department/views/new-department.html','<div form="vm.departmentForm"><form name="vm.departmentForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'iosl.department.create.update.view.on.page.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.departmentForm.officeName.$invalid && vm.departmentForm.$submitted}"><div class="form-input-group-row labelXXL organization-name"><label>{{\'iosl.department.office.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input ng-disabled="vm.isOfficeFieldDisabled" type="text" typeahead-on-select="vm.onOfficeNameSelected($item)" name="officeName" ng-model="vm.departmentInfo.officeName" uib-typeahead="office.name as office.name for office in vm.getOfficeName($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.departmentForm.departmentId.$invalid && vm.departmentForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.department.id\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" special-character-limit-v2="" class="form-control" name="departmentId" ng-model="vm.departmentInfo.departmentId" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.departmentForm.departmentName.$invalid && vm.departmentForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.department.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" special-character-limit-v2="" class="form-control" name="departmentName" ng-model="vm.departmentInfo.name" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.departmentForm.departmentRemarks.$invalid && vm.departmentForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.department.remarks\' | translate }}</label> <textarea class="form-control" special-character-limit="" name="departmentRemarks" ng-model="vm.departmentInfo.remarks" maxlength="250"></textarea></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/iosl/department/list" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createDepartment()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'iosl.department.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/in-office-service/deviceLinkage/views/create-device-link.html','<div form="vm.deviceLinkForm"><form name="vm.deviceLinkForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'iosl.device.linkage.create\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.deviceLinkForm.officeName.$invalid && vm.deviceLinkForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.department.office.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" typeahead-on-select="vm.onOfficeNameSelected($item)" name="officeName" ng-model="vm.userInfo.organizationName" uib-typeahead="org.name as org.name for org in vm.getOfficeName($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.deviceLinkForm.applicationNumber.$invalid && vm.deviceLinkForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.device.linkage.application.number\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" name="applicationNumber" ng-model="vm.deviceLinkInfo.applicationNumber" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.device.linkage.customer.control.number\' | translate }}</label> <input type="text" class="form-control" name="customerControlNumber" ng-model="vm.deviceLinkInfo.customerControlNumber"></div></div></div></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/iosl/device-linkage/list" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createDeviceLink()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'iosl.department.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/in-office-service/deviceLinkage/views/list-device-link.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><div class="row"><div class="col-sm-12"><button ng-if="vm.permissions.OFFICE_DEVICE_LINKAGE.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onUpdate()" class="btn btn-primary btn-raised w-btn-md-3 btn-xs m-l-20">{{ "iosl.device.linkage.edit" | translate }} &nbsp;<i class="fa fa-edit" aria-hidden="true"></i>&nbsp;</button> <button ng-if="vm.permissions.OFFICE_DEVICE_LINKAGE.SUBMIT" ngf-select="vm.onUpload($file, $event, bank)" class="btn btn-primary btn-raised btn-xs w-btn-md-3 m-l-5" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "iosl.device.linkage.upload" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isUploading"></i></button> <button ng-if="vm.permissions.OFFICE_DEVICE_LINKAGE.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onDownload()" class="btn btn-info btn-raised btn-xs w-btn-md-3 m-l-5">{{ "iosl.device.linkage.download" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloading"></i></button> <button ng-if="vm.permissions.OFFICE_DEVICE_LINKAGE.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onDelete()" class="btn btn-danger btn-raised btn-xs w-btn-sm-x3 m-r-5 pull-right">{{ "iosl.department.delete" | translate }} &nbsp;<i class="fa fa-trash" aria-hidden="true" ng-if="!vm.isDeleteLoading"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDeleteLoading"></i></button></div><div class="col-sm-12 m-t-10"><form class="filters"><div class="w-btn-md-3 m-l-20 inline-block"><select class="form-control selectpicker show-tick" title="\u30AA\u30D5\u30A3\u30B9\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.OFFICE_ID" ng-options="item for item in vm.officeIdList track by item" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="w-btn-md-3 m-l-8px inline-block"><div class="form-group select-dropdown"><select class="form-control selectpicker show-tick" title="\u52A0\u76DF\u5E97" data-live-search="true" data-actions-box="true" data-width="43%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.merchantName" ng-options="item for item in vm.merchantList track by item" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select><select class="form-control selectpicker show-tick" title="\u7AEF\u672B\u6240\u6709\u8005" data-live-search="true" data-actions-box="true" data-width="50%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.deviceOwner" ng-options="item for item in vm.deviceOwnerList track by item" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div></div><div class="w-btn-md-3 m-l-8px inline-block"><div class="form-group select-dropdown"><span><input type="search" class="form-control" ng-model="vm.search.deviceSerialNumber" placeholder="{{\'iosl.device.linkage.device.serial\' | translate }}" maxlength="200"></span></div></div><div class="w-btn-md-3 m-l-8px inline-block"><span><input type="search" class="form-control" ng-model="vm.search.installationLocation" placeholder="{{\'iosl.device.linkage.installation.location\' | translate }}" maxlength="200"></span></div><div class="inline-block pull-right m-r-5"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.show.data\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isFilterLoading"></i></button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.clear\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isClearLoading"></i></button></div></form></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.select" ng-click="vm.onSelectAll($event, vm.deviceLink.content)"> <span></span></label></th><th>#</th><th>{{\'iosl.department.office.id\' | translate}}</th><th>{{\'iosl.department.office.name\' | translate}}</th><th>{{\'iosl.device.linkage.merchant\' | translate}}</th><th>{{\'iosl.device.linkage.device.owner\' | translate}}</th><th>{{\'iosl.device.linkage.application.number\' | translate}}</th><th>{{\'iosl.device.linkage.device.serial\' | translate}}</th><th>{{\'iosl.device.linkage.installation.store.name\' | translate}}</th><th>{{\'iosl.device.linkage.linking.date\' | translate}}</th><th>{{\'iosl.last.modified\' | translate}}</th></tr></thead><tbody><tr ng-repeat="link in vm.deviceLink.content" track="" by="" $index=""><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedIds[link.id]"> <span></span></label></td><td style="text-align: left;">{{vm.employeeResponse.offset + $index + 1}}</td><td class="word-break">{{link.officeId}}</td><td class="word-break">{{link.officeName}}</td><td class="word-break">{{link.merchantName}}</td><td class="word-break">{{link.deviceOwner}}</td><td class="word-break">{{link.applicationNumber}}</td><td class="word-break">{{link.deviceSerialNumber}}</td><td class="word-break">{{link.installationStoreName}}</td><td class="word-break">{{link.linkingDate | date: \'medium\'}}</td><td class="word-break">{{link.lastModified | date: \'medium\'}}</td></tr></tbody></table></div><div class="m-t-20"><paginationv2 query="vm.filter" current-page-size="vm.deviceLink.currentPageSize" current-page="vm.deviceLink.currentPage" total-pages="vm.deviceLink.totalPages" total-elements="vm.deviceLink.totalElements" paginate-callback="vm.paginateCallback"></paginationv2></div></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/in-office-service/deviceLinkage/views/preview-device-link.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="department"><div class="handsOnTableWrapper"><div id="handsOnTable-deviceLinkage"></div></div><div class="clearfix bottomAction"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancel()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submit()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div></div>');
$templateCache.put('app/pages/in-office-service/employee/views/detail.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>{{\'iosl.department.office.id\' | translate}}</th><th>{{\'iosl.department.office.name\' | translate}}</th><th>{{\'iosl.department.id\' | translate}}</th><th>{{\'iosl.department.name\' | translate}}</th><th>{{\'iosl.department.remarks\' | translate}}</th><th>{{\'iosl.employee.id\' | translate}}</th><th>{{\'iosl.employee.name\' | translate}}</th><th>{{\'iosl.employee.enabled\' | translate}}</th><th>{{\'iosl.employee.expiryDate\' | translate}}</th><th>{{\'iosl.employee.startDate\' | translate}}</th><th>{{\'iosl.employee.issueCount\' | translate}}</th><th>{{\'iosl.employee.remarks\' | translate}}</th></tr></thead><tbody><tr><td class="word-break">{{vm.employeeData.officeId}}</td><td class="word-break">{{vm.employeeData.officeName}}</td><td class="word-break">{{vm.employeeData.departmentId}}</td><td class="word-break">{{vm.employeeData.departmentName}}</td><td class="word-break">{{vm.employeeData.departmentRemarks}}</td><td class="word-break">{{vm.employeeData.employeeId}}</td><td class="word-break">{{vm.employeeData.name}}</td><td class="word-break"><span ng-if="vm.employeeData.isEnabled !== null">{{vm.getValueFromTypeKey(vm.employeeData.isEnabled, vm.boolOptions)}}</span> <span ng-if="vm.employeeData.isEnabled === null">{{\'device.replacement.device.information.na\' | translate}}</span></td><td class="word-break">{{vm.employeeData.expiryDate | date: \'shortDate\'}}</td><td class="word-break">{{vm.employeeData.startDate | date: \'shortDate\'}}</td><td class="word-break">{{vm.employeeData.issueCount}}</td><td class="word-break">{{vm.employeeData.remarks}}</td></tr><tr><td colspan="12" class="word-break text-left p-t-20 p-b-20"><h4>{{\'iosl.employee.qrcode.info\' | translate}}</h4></td></tr><tr><td colspan="4" class="word-break text-left">{{\'iosl.employee.qrcode.data\' | translate}}</td><td colspan="8" class="word-break"><u><a target="_blank" href="{{vm.employeeData.qrCodeData}}" title="{{\'iosl.employee.qrcode.detail.msg\' | translate }}" class="link m-no-error">{{vm.employeeData.qrCodeData}}</a></u></td></tr><tr><td colspan="4" class="word-break text-left">{{\'iosl.employee.qrcode\' | translate}}</td><td colspan="8" class="word-break"><img ng-src="{{vm.employeeData.qrCodeImage}}" alt="Employee QRcode"></td></tr><tr><td colspan="4" class="word-break text-left">{{\'iosl.employee.feliCaIdm\' | translate}}</td><td colspan="8" class="word-break">{{vm.employeeData.feliCaIdm}}</td></tr></tbody></table></div></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div><div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>{{\'\'}}</th><th>{{\'iosl.usage.rules.one.time.amount\' | translate}}</th><th>{{\'iosl.usage.rules.total.number.per.day\' | translate}}</th><th>{{\'iosl.usage.rules.cumulated.amount.per.day\' | translate}}</th><th>{{\'iosl.usage.rules.total.number.per.month\' | translate}}</th><th>{{\'iosl.usage.rules.cumulated.amount.per.month\' | translate}}</th><th>{{\'iosl.usage.rules.cumulated.numberoftimes.allowed\' | translate}}</th><th>{{\'iosl.usage.rules.cumulated.amount\' | translate}}</th><th>{{\'iosl.usage.rules.column.code\' | translate}}</th><th>{{\'iosl.usage.rules.time.slot.available\' | translate}}</th><th>{{\'iosl.usage.rules.week.days.allowed\' | translate}}</th><th>{{\'iosl.usage.rules.cumulative.no.of.times.per.week.allowed\' | translate}}</th><th>{{\'iosl.usage.rules.cumulative.amount.per.week.allowed\' | translate}}</th></tr></thead><tbody><tr><td>{{\'iosl.employee.setting.value\' | translate}}</td><td class="word-break">{{vm.employeeData.remainingQR.oneTimeAmountAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeNumberPerDayAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeAmountPerDayAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeNumberPerMonthAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeAmountPerMonthAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeNumberAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeAmountAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.columnCodesAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.timeSlotAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.weekDaysAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeNumberPerWeekAllowed}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeAmountPerWeekAllowed}}</td></tr><tr><td>{{\'iosl.employee.remainder.from.result\' | translate}}</td><td class="word-break">{{vm.employeeData.remainingQR.oneTimeAmountRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeNumberPerDayRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeAmountPerDayRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeNumberPerMonthRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeAmountPerMonthRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeNumberRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeAmountRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.columnCodesRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.timeSlotRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.weekDaysRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeNumberPerWeekRemainder}}</td><td class="word-break">{{vm.employeeData.remainingQR.cumulativeAmountPerWeekRemainder}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/in-office-service/employee/views/edit-employee.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong ng-if="!vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong> <strong ng-if="vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'iosl.msg.server.error\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="department"><div class="handsOnTableWrapper"><div id="handsOnTable-employee"></div></div><div class="clearfix bottomAction"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancel()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submit()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div></div>');
$templateCache.put('app/pages/in-office-service/employee/views/list-employee.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><div class="row"><div class="col-sm-12"><button ng-if="vm.permissions.OFFICE_EMPLOYEE.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onUpdate()" class="btn btn-primary btn-raised w-btn-md-3 m-l-5 m-b-5 btn-xs">{{ "iosl.employee.edit" | translate }} &nbsp;<i class="fa fa-edit" aria-hidden="true"></i>&nbsp;</button> <button ng-if="vm.permissions.OFFICE_EMPLOYEE.SUBMIT" ngf-select="vm.onUpload($file, $event, bank)" class="btn btn-primary btn-raised w-btn-md-2 m-l-5 btn-xs" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "iosl.employee.upload" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true" ng-if="!vm.isUploadLoading"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isUploadLoading"></i></button> <button ng-if="vm.permissions.OFFICE_EMPLOYEE.SUBMIT || vm.isNormalSystemUser || vm.isNormalOfficeUser" ng-disabled="vm.isEditDisabled()" ng-click="vm.onExport()" class="btn btn-info btn-xs btn-raised m-b-5 w-btn-md-3 m-l-5">{{ "iosl.employee.download" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true" ng-if="!vm.isDownloadLoading"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloadLoading"></i></button> <button ng-if="vm.permissions.OFFICE_QR_CODES.READ" ng-disabled="vm.isEditDisabled()" ng-click="vm.onQrCodeExport()" class="btn btn-info btn-raised btn-xs w-btn-md-3 m-l-5 m-b-5">{{ "iosl.employee.qrcode.download" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true" ng-if="!vm.isQrDownloadLoading"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isQrDownloadLoading"></i></button> <button ng-if="vm.permissions.OFFICE_EMPLOYEE.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onDelete()" class="btn btn-danger btn-raised w-btn-sm-x3 btn-xs m-r-5 pull-right">{{ "iosl.employee.delete" | translate }} &nbsp;<i class="fa fa-trash" aria-hidden="true" ng-if="!vm.isDeleteLoading"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDeleteLoading"></i></button></div><div class="col-sm-12 m-t-10"><form class="filters"><div class="w-btn-md-3 m-l-5 inline-block"><select class="form-control selectpicker show-tick" title="\u30AA\u30D5\u30A3\u30B9\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.OFFICE_ID" ng-change="vm.getDepartmentList()" ng-options="item for item in vm.officeIdList track by item" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="w-btn-md-2 m-l-5 inline-block m-l-8px"><select class="form-control selectpicker show-tick" title="\u90E8\u7F72\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.DEPARTMENT_ID" ng-options="item for item in vm.deptIdList track by item" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="w-btn-md-3 m-l-5 inline-block m-l-8px"><span><input type="search" class="form-control" ng-model="vm.search.EMPLOYEE_ID" placeholder="{{\'iosl.employee.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-3 m-l-5 inline-block m-l-8px"><span><input type="search" class="form-control" ng-model="vm.search.EMPLOYEE_NAME" placeholder="{{\'iosl.employee.name\' | translate }}" maxlength="200"></span></div><div class="inline-block pull-right m-r-5"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.show.data\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isFilterLoading"></i></button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.clear\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isClearLoading"></i></button></div></form></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.select" ng-click="vm.onSelectAll($event, vm.employeeResponse.content)"> <span></span></label></th><th>#</th><th>{{\'iosl.department.office.id\' | translate}}</th><th>{{\'iosl.employee.office.name\' | translate}}</th><th>{{\'iosl.department.id\' | translate}}</th><th>{{\'iosl.department.name\' | translate}}</th><th>{{\'iosl.department.remarks\' | translate}}</th><th>{{\'iosl.employee.id\' | translate}}</th><th>{{\'iosl.employee.name\' | translate}}</th><th>{{\'iosl.employee.enabled\' | translate}}</th><th>{{\'iosl.employee.expiryDate\' | translate}}</th><th>{{\'iosl.employee.startDate\' | translate}}</th><th>{{\'iosl.employee.issueCount\' | translate}}</th><th>{{\'iosl.employee.remarks\' | translate}}</th><th>{{\'iosl.employee.feliCaIdm\' | translate}}</th><th>{{\'iosl.last.modified\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in vm.employeeResponse.content" track="" by="" $index=""><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedIds[item.id]"> <span></span></label></td><td style="text-align: left;">{{vm.employeeResponse.offset + $index + 1}}</td><td class="word-break">{{item.officeId}}</td><td class="word-break">{{item.officeName}}</td><td class="word-break">{{item.departmentId}}</td><td class="word-break">{{item.departmentName}}</td><td class="word-break">{{item.departmentRemarks}}</td><td class="word-break" ng-if="vm.permissions.OFFICE_QR_CODES.READ"><u><a target="_blank" href="/#/main/iosl/employee/detail/{{item.id}}" title="{{\'iosl.employee.qrcode.detail.msg\' | translate }}" class="link m-no-error">{{item.employeeId}}</a></u></td><td class="word-break" ng-if="!vm.permissions.OFFICE_QR_CODES.READ">{{item.employeeId}}</td><td class="word-break" ng-if="vm.permissions.OFFICE_QR_CODES.READ"><u><a target="_blank" href="/#/main/iosl/employee/detail/{{item.id}}" title="{{\'iosl.employee.qrcode.detail.msg\' | translate }}" class="link m-no-error">{{item.name}}</a></u></td><td class="word-break" ng-if="!vm.permissions.OFFICE_QR_CODES.READ">{{item.name}}</td><td class="word-break"><span ng-if="item.isEnabled !== null">{{vm.getValueFromTypeKey(item.isEnabled, vm.boolOptions)}}</span> <span ng-if="item.isEnabled === null">{{\'device.replacement.device.information.na\' | translate}}</span></td><td class="word-break">{{item.expiryDate | date: \'shortDate\'}}</td><td class="word-break">{{item.startDate | date: \'shortDate\'}}</td><td class="word-break">{{item.issueCount}}</td><td class="word-break">{{item.remarks}}</td><td class="word-break">{{item.feliCaIdm}}</td><td class="word-break">{{item.lastModified | date: \'medium\'}}</td></tr></tbody></table></div><div class="m-t-20"><paginationv2 query="vm.filter" current-page-size="vm.employeeResponse.currentPageSize" current-page="vm.employeeResponse.currentPage" total-pages="vm.employeeResponse.totalPages" total-elements="vm.employeeResponse.totalElements" paginate-callback="vm.paginateCallback"></paginationv2></div></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/in-office-service/employee/views/list-preview.html','<ul class="nav nav-tabs"><li><button ng-class="{\'active\': !vm.isEmployeeTableVisible}" class="btn btn-primary" ng-click="vm.showDepartmentTable()" ng-disabled="vm.isDepartmentEmpty">{{ "iosl.employee.department" | translate }}</button></li><li><button ng-class="{\'active\': vm.isEmployeeTableVisible}" class="btn btn-primary" ng-click="vm.showEmployeeTable()" ng-disabled="!vm.isDepartmentUploaded || vm.isEmployeeEmpty">{{ "iosl.department.employee" | translate }}</button></li></ul><div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts && vm.alerts.length > 0"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'iosl.msg.server.error\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="employee"><div class="handsOnTableWrapper"><div id="handsOnTable-employee-department"></div></div><div class="clearfix bottomAction" ng-if="vm.isEmployeeTableVisible"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancelEmployee()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submitEmployee()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div><div class="clearfix bottomAction" ng-if="!vm.isEmployeeTableVisible"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancelDepartment()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submitDepartment()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div></div>');
$templateCache.put('app/pages/in-office-service/employee/views/new-employee.html','<div form="vm.employeeForm"><form name="vm.employeeForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'iosl.employee.create.update.view.on.page.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.employeeForm.officeName.$invalid && vm.employeeForm.$submitted}"><div class="form-input-group-row labelXXL organization-name"><label>{{\'iosl.employee.office.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input ng-disabled="vm.isOfficeFieldDisabled" type="text" typeahead-on-select="vm.onOfficeNameSelected($item)" name="officeName" ng-model="vm.employeeInfo.officeName" uib-typeahead="office.name as office.name for office in vm.getOfficeName($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.employeeForm.departmentName.$invalid && vm.employeeForm.$submitted}"><div class="form-input-group-row labelXXL organization-name"><label>{{\'iosl.employee.department.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" typeahead-on-select="vm.onDepartmentNameSelected($item)" name="departmentName" ng-model="vm.employeeInfo.departmentName" uib-typeahead="item.value as item.value for item in vm.getDepartmentName($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.employeeForm.employeeId.$invalid && vm.employeeForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.id\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" special-character-limit="" class="form-control" name="employeeId" ng-model="vm.employeeInfo.employeeId" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.employeeForm.employeeName.$invalid && vm.employeeForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" special-character-limit="" class="form-control" name="employeeName" ng-model="vm.employeeInfo.name" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.startDate\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="vm.employeeInfo.startDate" name="startDate" options="vm.startDateOptions" ng-model="vm.employeeInfo.startDate" required="true" form="vm.employeeForm"></datepicker></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.expiryDate\' | translate }}</label><div class="datePickerWrap"><div class="input-group m-b-0"><input ng-model="vm.employeeInfo.expiryDate" form="vm.employeeForm" type="text" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="vm.expiryDateOptions" is-open="vm.opened" ng-required="false" placeholder="yyyy\u5E74mm\u6708dd\u65E5" close-text="Close" options="vm.expiryDateOptions" show-button-bar="false"> <span ng-click="vm.open()" class="clickOverlay"></span> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.employeeForm.isEnabled.$invalid && vm.employeeForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.enabled\' | translate }}{{\'common.components.required\' | translate}}</label><ui-select ng-model="vm.employeeInfo.isEnabled" class="btn-group bootstrap-select form-control" name="isEnabled" append-to-body="false" search-enabled="false" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.boolOptions)}}</span></ui-select-match><ui-select-choices repeat="item in vm.boolOptions.key track by $index"><span ng-bind-html="vm.boolOptions[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.employeeForm.issueCount.$invalid && vm.employeeForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.issueCount\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="number" disabled="true" class="form-control" name="issueCount" ng-model="vm.employeeInfo.issueCount" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.employeeForm.remarks.$invalid && vm.employeeForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.remarks\' | translate }}</label> <textarea class="form-control" special-character-limit="" name="remarks" ng-model="vm.employeeInfo.remarks" maxlength="250"></textarea></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.employeeForm.feliCaIdm.$invalid && vm.employeeForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.feliCaIdm\' | translate }}</label> <input type="text" special-character-limit="" class="form-control" name="feliCaIdm" ng-model="vm.employeeInfo.feliCaIdm"></div></div></div></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/iosl/employee/list" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createEmployee()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'iosl.department.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/in-office-service/terminalOperations/views/account-management.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><div class="row"><div class="col-sm-12"><button ng-click="vm.onRegisterNew()" class="btn btn-primary btn-raised w-btn-md-3 btn-xs m-l-20">{{\'iosl.account.management.register.new\' | translate }} &nbsp;<i class="fa fa-edit" aria-hidden="true"></i>&nbsp;</button></div><div class="col-sm-12 m-t-10"><form class="filters"><div class="w-btn-md-3 m-l-5 inline-block m-l-8px"><span><input type="search" class="form-control" ng-model="vm.search.officeId" placeholder="{{\'iosl.department.office.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-3 m-l-5 inline-block m-l-8px"><span><input type="search" class="form-control" ng-model="vm.search.authenticationId" placeholder="{{\'iosl.account.management.auth.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-3 m-l-5 inline-block m-l-8px"><span><input type="search" class="form-control" ng-model="vm.search.authenticationIdName" placeholder="{{\'iosl.account.management.auth.id.name\' | translate }}" maxlength="200"></span></div><div class="inline-block pull-right m-r-5"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.show.data\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isFilterLoading"></i></button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.clear\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isClearLoading"></i></button></div></form></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th>{{\'iosl.department.office.id\' | translate}}</th><th>{{\'iosl.account.management.auth.id\' | translate}}</th><th>{{\'iosl.account.management.auth.id.name\' | translate}}</th><th colspan="3" class="text-center">{{\'org.list.action\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in vm.accountDetailsResponse.content" track="" by="" $index=""><td>{{$index+1}}</td><td>{{item.officeId}}</td><td>{{item.authenticationId}}</td><td>{{item.authenticationIdName}}</td><td><button class="btn btn-info btn-sm" ng-click="vm.onUpdate(item)" ng-disabled="!item.isEnabled">{{\'iosl.transmission.history.update\' | translate}}</button></td><td><div ng-switch="item.isEnabled"><div ng-switch-when="false"><button class="btn btn-warning btn-sm" ng-click="vm.enableAccount(item)">{{\'org.list.enable\' | translate}}</button></div><div ng-switch-when="true"><button class="btn btn-primary btn-sm" ng-click="vm.disableAccount(item)">{{\'org.list.disable\' | translate}}</button></div></div></td><td><button class="btn btn-danger btn-sm" ng-click="vm.deleteTerminalOpsAccount(item)" ng-disabled="!item.isEnabled">{{\'org.list.delete\' | translate}}</button></td></tr></tbody></table></div><div class="m-t-20"><paginationv2 query="vm.filter" current-page-size="vm.accountDetailsResponse.currentPageSize" current-page="vm.accountDetailsResponse.currentPage" total-pages="vm.accountDetailsResponse.totalPages" total-elements="vm.accountDetailsResponse.totalElements" paginate-callback="vm.paginateCallback"></paginationv2></div></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/in-office-service/terminalOperations/views/edit-account.html','<div form="vm.terminalOpsNewAccount"><form name="vm.terminalOpsNewAccount" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'iosl.account.management.register.new\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.terminalOpsNewAccount.officeId.$invalid && vm.terminalOpsNewAccount.$submitted}"><div class="form-input-group-row labelXXL organization-name"><label>{{\'iosl.account.management.office.id\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" name="officeId" typeahead-on-select="vm.onOfficeNameSelected($item)" uib-typeahead="org.name as org.name for org in vm.getOfficeName($viewValue)" ng-model="vm.newAccountInfo.officeId" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.terminalOpsNewAccount.authenticationId.$invalid && vm.terminalOpsNewAccount.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.account.management.auth.id\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" special-character-limit-v2="" class="form-control" name="authenticationId" ng-model="vm.newAccountInfo.authenticationId" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.terminalOpsNewAccount.authenticationIdName.$invalid && vm.terminalOpsNewAccount.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.account.management.auth.id.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" special-character-limit-v2="" class="form-control" name="authenticationIdName" ng-model="vm.newAccountInfo.authenticationIdName" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.terminalOpsNewAccount.password.$invalid && vm.terminalOpsNewAccount.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.account.management.password\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="password" placeholder="************" class="form-control" name="password" ng-model="vm.newAccountInfo.password"></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/iosl/terminal-operation/account-management" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createNewAccount()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'iosl.department.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/in-office-service/terminalOperations/views/register-new-account.html','<div form="vm.terminalOpsNewAccount"><form name="vm.terminalOpsNewAccount" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'iosl.account.management.register.new\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.terminalOpsNewAccount.officeId.$invalid && vm.terminalOpsNewAccount.$submitted}"><div class="form-input-group-row labelXXL organization-name"><label>{{\'iosl.account.management.office.id\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" name="officeId" typeahead-on-select="vm.onOfficeNameSelected($item)" uib-typeahead="org.name as org.name for org in vm.getOfficeName($viewValue)" ng-model="vm.newAccountInfo.officeId" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.terminalOpsNewAccount.authenticationId.$invalid && vm.terminalOpsNewAccount.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.account.management.auth.id\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" special-character-limit-v2="" class="form-control" name="authenticationId" ng-model="vm.newAccountInfo.authenticationId" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.terminalOpsNewAccount.authenticationIdName.$invalid && vm.terminalOpsNewAccount.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.account.management.auth.id.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" special-character-limit-v2="" class="form-control" name="authenticationIdName" ng-model="vm.newAccountInfo.authenticationIdName" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.terminalOpsNewAccount.password.$invalid && vm.terminalOpsNewAccount.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.account.management.new.password\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="password" class="form-control" name="password" ng-model="vm.newAccountInfo.password" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/iosl/terminal-operation/account-management" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createNewAccount()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'iosl.department.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/in-office-service/terminalOperations/views/transmission-history.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><div class="row"><div class="col-sm-12"><form class="filters"><div class="form-group-col col-filter"><span><input type="search" class="form-control" ng-model="vm.search.OFFICE_ID" placeholder="{{\'iosl.department.office.id\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter"><span><input type="search" class="form-control" ng-model="vm.search.OFFICE_NAME" placeholder="{{\'iosl.employee.office.name\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter"><span><input type="search" class="form-control" ng-model="vm.search.DEVICE_NUMBER" placeholder="{{\'iosl.transmission.history.device.number\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter"><span><input type="search" class="form-control" ng-model="vm.search.PROCESSING_RESULT" placeholder="{{\'iosl.transmission.history.processing.result\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter"><span><input type="search" class="form-control" ng-model="vm.search.ERROR_CODE" placeholder="{{\'iosl.transmission.history.error.code\' | translate }}" maxlength="200"></span></div><div class="form-group-col col-filter"><span><input type="search" class="form-control" ng-model="vm.search.ERROR_RESULT" placeholder="{{\'iosl.transmission.history.error.result\' | translate }}" maxlength="200"></span></div><button ng-disabled="vm.isEditDisabled()" ng-click="vm.onDelete()" class="btn btn-danger btn-raised w-btn-sm-x3 btn-xs m-r-5 pull-right">{{ "iosl.employee.delete" | translate }} &nbsp;<i class="fa fa-trash" aria-hidden="true" ng-if="!vm.isDeleteLoading"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDeleteLoading"></i></button></form></div><div class="col-sm-12 m-t-10"><form class="filters"><div class="form-group-col col-filter"><label class="label-filter same-line-label" style="text-align: left;">{{\'iosl.transmission.history.duration\' | translate}}</label><div class="form-group daterange-select select-dropdown" style="width: 55%;float: right;"><select class="form-control selectpicker show-tick op-dropdown" data-actions-box="false" data-live-search="false" data-size="10" ng-change="vm.changeFirstDateRange()" ng-model="vm.opFirstSelect" ng-options="item as item.label for item in vm.filterOptions.options.DateOptions" selectpicker="" title="\u9078\u629E"></select></div></div><div class="form-group-col col-filter"><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.search.TRANSMISSION_RECIEVED_FROM" ng-model="vm.search.TRANSMISSION_RECIEVED_FROM"></datepicker></div></div><div class="form-group-col col-filter"><div class="input-group m-b-0 daterange"><datepicker options="vm.dateOptions" date="vm.search.TRANSMISSION_RECIEVED_TO" ng-model="vm.search.TRANSMISSION_RECIEVED_TO"></datepicker></div></div><div class="inline-block pull-right m-r-5"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.show.data\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isFilterLoading"></i></button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.clear\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isClearLoading"></i></button></div></form></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th>{{\'iosl.department.office.id\' | translate}}</th><th>{{\'iosl.employee.office.name\' | translate}}</th><th>{{\'iosl.transmission.history.device.number\' | translate}}</th><th>{{\'iosl.transmission.history.transmission.received.date\' | translate}}</th><th>{{\'iosl.transmission.history.sequence.number\' | translate}}</th><th>{{\'iosl.transmission.history.transmission.type\' | translate}}</th><th>{{\'iosl.transmission.history.number.of.retry\' | translate}}</th><th>{{\'iosl.transmission.history.processing.result\' | translate}}</th><th>{{\'iosl.transmission.history.error.code\' | translate}}</th><th>{{\'iosl.transmission.history.error.result\' | translate}}</th><th>{{\'iosl.transmission.history.delete\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in vm.transmissionHistoryResponse.content" track="" by="" $index=""><td style="text-align: left;">{{vm.transmissionHistoryResponse.offset + $index + 1}}</td><td class="word-break">{{item.officeId}}</td><td class="word-break">{{item.officeName}}</td><td class="word-break">{{item.deviceNumber}}</td><td class="word-break">{{item.transmissionReceivedAt | date: \'yyyy/MM/dd HH:mm:ss\'}}</td><td class="word-break">{{item.sequenceNumber}}</td><td class="word-break">{{item.transmissionType}}</td><td class="word-break">{{item.retryCount}}</td><td class="word-break">{{item.processingResult}}</td><td class="word-break">{{item.errorCode}}</td><td class="word-break">{{item.errorResult}}</td><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedIds[item.id]"> <span></span></label></td></tr></tbody></table></div><div class="m-t-20"><paginationv2 query="vm.filter" current-page-size="vm.transmissionHistoryResponse.currentPageSize" current-page="vm.transmissionHistoryResponse.currentPage" total-pages="vm.transmissionHistoryResponse.totalPages" total-elements="vm.transmissionHistoryResponse.totalElements" paginate-callback="vm.paginateCallback"></paginationv2></div></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/in-office-service/usageDetails/views/monthly-usage.html','<div form="vm.searchForm"><form name="vm.searchForm" novalidate=""><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'salesSettlements.monthly.list.search.title\' | translate }}</div><div class="panel-body filterQueryForm"><div class="form-group" ng-class="{\'has-error\': vm.searchForm.interval.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL m-b-25"><label>{{\'salesSettlements.monthly.list.search.displayUnit\' | translate }}{{\'common.components.required\' | translate}}</label><div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.displayUnit.key"><input type="radio" name="interval" ng-model="vm.interval" value="{{option}}" required=""> <span>{{vm.displayUnit[vm.getLang()][$index]}}</span></label></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.searchForm.date.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL m-b-25" ng-if="vm.interval === \'MONTHLY\'"><label>{{\'iosl.usage.details.target.month\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="vm.date" required="true" format="vm.dateFormat" form="vm.searchForm" options="vm.monthlyDateOptions" name="date"></datepicker></div><div class="form-input-group-row labelXXXL m-b-25" ng-if="vm.interval === \'DAILY\'"><label>{{\'iosl.usage.details.target.day\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker options="vm.dailyDateOptions" date="vm.date" required="true" form="vm.searchForm" name="date"></datepicker></div></div><div class="form-group" ng-class="{\'has-error\': (vm.searchForm.fromDate.$invalid || vm.searchForm.toDate.$invalid) && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL m-b-25" ng-if="vm.interval === \'SPECIFIC_PERIOD\'"><label>{{\'iosl.usage.details.time.period\' | translate }}{{\'common.components.required\' | translate}}</label><div class="input-group datePickerWrap"><input ng-change="vm.onFromDateChange()" required="" class="form-control" type="text" datetimepicker="" options="vm.fromDateOptions" placeholder="yyyy\u5E74mm\u6708dd\u65E5" name="fromDate" ng-model="vm.fromDate"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><span class="dateRange-span">~</span><div class="input-group datePickerWrap"><input class="form-control" type="text" required="" datetimepicker="" options="vm.toDateOptions" placeholder="yyyy\u5E74mm\u6708dd\u65E5" name="toDate" ng-model="vm.toDate"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate}}</span></div></div><div class="form-group" ng-class="{\'has-error\': vm.searchForm.granularity.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL m-b-25"><label>{{\'iosl.usage.details.display.granularity\' | translate }}{{\'common.components.required\' | translate}}</label><div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.granularityOptions.key"><input type="radio" name="granularity" ng-model="vm.granularity.entity" value="{{option}}" required=""> <span>{{vm.granularityOptions[vm.getLang()][$index]}}</span></label></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="w-btn-md-2 m-l-10 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.OFFICE_ID" placeholder="{{\'iosl.employee.office.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.DEPARTMENT_ID" placeholder="{{\'iosl.employee.department.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.EMPLOYEE_ID" placeholder="{{\'iosl.employee.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.EMPLOYEE_NAME" placeholder="{{\'iosl.employee.name\' | translate }}" maxlength="200"></span></div></div><div class="row m-t-10"><div class="w-btn-md-2 m-l-10 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.OPERATOR" placeholder="{{\'iosl.usage.details.operatorId\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.DEVICE_SERIAL" placeholder="{{\'iosl.usage.details.device.serial\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.INSTALLATION_STORE" placeholder="{{\'iosl.usage.details.installation.location\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.REMARKS" placeholder="{{\'iosl.usage.details.remark\' | translate }}" maxlength="200"></span></div><div class="inline-block pull-right m-r-5"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="vm.isLoading">{{\'device.request.list.btn.show.data\' | translate}}</button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="vm.isLoading || vm.isClearBtnDisabled">{{\'device.request.list.btn.clear\' | translate}}</button></div></div></div></div></form></div><div ng-if="vm.transactionResponse.content" class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="m-b-10 navigateMonths m-t-10"><button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'FIRST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'PREV\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-left"></i></button><div class="date"><span ng-if="vm.interval === \'MONTHLY\'">{{vm.date | date: \'yyyy/MM\'}}</span> <span ng-if="vm.interval === \'DAILY\'">{{vm.date | date: \'yyyy/MM/dd\'}}</span></div><button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'NEXT\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'LAST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.onExport()" ng-hide="vm.inProgress"><i class="fa fa-download"></i></button></div><div class="table-responsive"><table class="table table-bordered"><thead><tr><th class="text-left">#</th><th>{{\'iosl.usage.details.office\' | translate}}</th><th ng-if="vm.isTableHeaderVisible(vm.granularityOptions.key[1])">{{\'iosl.usage.details.department\' | translate}}</th><th ng-if="vm.isTableHeaderVisible(vm.granularityOptions.key[2])">{{\'iosl.usage.details.employee\' | translate}}</th><th ng-if="vm.isTableHeaderVisible(vm.granularityOptions.key[3])">{{\'iosl.usage.details.daily\' | translate}}</th><th>{{\'iosl.usage.details.total.usage\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in vm.transactionResponse.content" track="" by="" $index=""><td class="text-left">{{vm.transactionResponse.offset + $index + 1}}</td><td class="word-break">{{item.officeName}} <span ng-if="item.officeId">( {{item.officeId}})</span></td><td ng-if="!vm.isTableHeaderVisible(vm.granularityOptions.key[0])" class="word-break">{{item.columnDetails}}</td><td class="word-break">{{item.totalCount}} \u4EF6 /{{item.totalAmount}} \u5186</td></tr></tbody></table></div><div class="m-t-20"><paginationv2 query="vm.filter" current-page-size="vm.transactionResponse.currentPageSize" current-page="vm.transactionResponse.currentPage" total-pages="vm.transactionResponse.totalPages" total-elements="vm.transactionResponse.totalElements" paginate-callback="vm.paginateCallback"></paginationv2></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/in-office-service/usageDetails/views/one-item-usage.html','<div form="vm.searchForm"><form name="vm.searchForm" novalidate=""><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'salesSettlements.monthly.list.search.title\' | translate }}</div><div class="panel-body filterQueryForm"><div class="form-group" ng-class="{\'has-error\': vm.searchForm.interval.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL m-b-25"><label>{{\'salesSettlements.monthly.list.search.displayUnit\' | translate }}{{\'common.components.required\' | translate}}</label><div><div><label class="radio-inline custom-radio nowrap" ng-repeat="option in vm.displayUnit.key"><input type="radio" name="interval" ng-model="vm.interval" value="{{option}}" required=""> <span>{{vm.displayUnit[vm.getLang()][$index]}}</span></label></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.searchForm.date.$invalid && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL m-b-25" ng-if="vm.interval === \'MONTHLY\'"><label>{{\'iosl.usage.details.target.month\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="vm.date" required="true" format="vm.dateFormat" form="vm.searchForm" options="vm.monthlyDateOptions" name="date"></datepicker></div><div class="form-input-group-row labelXXXL m-b-25" ng-if="vm.interval === \'DAILY\'"><label>{{\'iosl.usage.details.target.day\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker options="vm.dailyDateOptions" date="vm.date" required="true" form="vm.searchForm" name="date"></datepicker></div></div><div class="form-group" ng-class="{\'has-error\': (vm.searchForm.fromDate.$invalid || vm.searchForm.toDate.$invalid) && vm.searchForm.$submitted}"><div class="form-input-group-row labelXXXL m-b-25" ng-if="vm.interval === \'SPECIFIC_PERIOD\'"><label>{{\'iosl.usage.details.time.period\' | translate }}{{\'common.components.required\' | translate}}</label><div class="input-group datePickerWrap"><input ng-change="vm.onFromDateChange()" required="" class="form-control" type="text" datetimepicker="" options="vm.fromDateOptions" placeholder="yyyy\u5E74mm\u6708dd\u65E5" name="fromDate" ng-model="vm.fromDate"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><span class="dateRange-span">~</span><div class="input-group datePickerWrap"><input class="form-control" type="text" required="" datetimepicker="" options="vm.toDateOptions" placeholder="yyyy\u5E74mm\u6708dd\u65E5" name="toDate" ng-model="vm.toDate"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate}}</span></div></div><div class="row"><div class="w-btn-md-2 m-l-10 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.OFFICE_ID" placeholder="{{\'iosl.employee.office.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.DEPARTMENT_ID" placeholder="{{\'iosl.employee.department.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.EMPLOYEE_ID" placeholder="{{\'iosl.employee.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.EMPLOYEE_NAME" placeholder="{{\'iosl.employee.name\' | translate }}" maxlength="200"></span></div></div><div class="row m-t-10"><div class="w-btn-md-2 m-l-10 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.OPERATOR" placeholder="{{\'iosl.usage.details.operatorId\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.DEVICE_SERIAL" placeholder="{{\'iosl.usage.details.device.serial\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.INSTALLATION_STORE" placeholder="{{\'iosl.usage.details.installation.location\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-2 m-l-5 inline-block"><span><input type="search" class="form-control" ng-model="vm.search.REMARKS" placeholder="{{\'iosl.usage.details.remark\' | translate }}" maxlength="200"></span></div><div class="inline-block pull-right m-r-5"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="vm.isLoading">{{\'device.request.list.btn.show.data\' | translate}}</button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="vm.isLoading || vm.isClearBtnDisabled">{{\'device.request.list.btn.clear\' | translate}}</button></div></div></div></div></form></div><div ng-if="vm.transactionResponse.content" class="row"><div class="col-lg-12 col-md-12"><div class="m-b-10 navigateMonths m-t-10"><button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'FIRST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-left"></i></button> <button class="btn btn-icon m-r-5" ng-click="vm.navigate(\'PREV\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-left"></i></button><div class="date"><span ng-if="vm.interval === \'MONTHLY\'">{{vm.date | date: \'yyyy/MM\'}}</span> <span ng-if="vm.interval === \'DAILY\'">{{vm.date | date: \'yyyy/MM/dd\'}}</span></div><button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'NEXT\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.navigate(\'LAST\')" ng-disabled="vm.inProgress"><i class="fa fa-angle-double-right"></i></button> <button class="btn btn-icon m-l-5" ng-click="vm.onExport()" ng-hide="vm.inProgress"><i class="fa fa-download"></i></button></div><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th>{{\'iosl.usage.details.operator\' | translate}}</th><th>{{\'iosl.usage.details.device.serial\' | translate}}</th><th>{{\'iosl.usage.details.installation.store.name\' | translate}}</th><th>{{\'iosl.usage.details.office\' | translate}}</th><th>{{\'iosl.usage.details.department\' | translate}}</th><th>{{\'iosl.usage.details.employee\' | translate}}</th><th>{{\'iosl.usage.details.settlement.time\' | translate}}</th><th>{{\'iosl.usage.details.settlement.amount\' | translate}}</th><th>{{\'iosl.usage.details.processing.result\' | translate}}</th><th>{{\'iosl.usage.details.error.id\' | translate}}</th><th>{{\'iosl.usage.details.column.id\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in vm.transactionResponse.content" track="" by="" $index=""><td style="text-align: left;">{{vm.transactionResponse.offset + $index + 1}}</td><td style="width: max-content">{{item.merchantName}} <span ng-if="item.merchantCode">({{item.merchantCode}})</span></td><td class="word-break">{{item.deviceSerialNumber}}</td><td class="word-break">{{item.installationStoreName}}</td><td style="width: max-content">{{item.officeName}} <span ng-if="item.officeId">( {{item.officeId}})</span></td><td class="word-break">{{item.departmentName}} <span ng-if="item.departmentId">( {{item.departmentId}} )</span></td><td class="word-break">{{item.employeeName}} <span ng-if="item.employeeId">( {{item.employeeId}} )</span></td><td class="word-break">{{item.transTime | date: \'medium\'}}</td><td class="word-break">{{item.amount}}</td><td class="word-break">{{item.processingResult}}</td><td style="width: max-content"><span ng-if="vm.getLang()===\'en\'">{{item.errorDescriptionEn}}</span><span ng-if="vm.getLang()===\'jp\'">{{item.errorDescriptionJa}}</span> <span ng-if="item.errorId">({{item.errorId}})</span></td><td class="word-break">{{item.columnCode}}</td></tr></tbody></table></div><div class="m-t-20"><paginationv2 query="vm.filter" current-page-size="vm.transactionResponse.currentPageSize" current-page="vm.transactionResponse.currentPage" total-pages="vm.transactionResponse.totalPages" total-elements="vm.transactionResponse.totalElements" paginate-callback="vm.paginateCallback"></paginationv2></div></div></div></div>');
$templateCache.put('app/pages/in-office-service/usageRules/views/create-rule.html','<div form="vm.usageRulesForm"><form name="vm.usageRulesForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'iosl.usage.rules.create\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.usageRulesForm.officeName.$invalid && vm.usageRulesForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.department.office.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input ng-disabled="vm.isOfficeFieldDisabled" type="text" typeahead-on-select="vm.onOfficeNameSelected($item)" name="officeName" ng-model="vm.usageRulesInfo.organizationName" uib-typeahead="org.name as org.name for org in vm.getOfficeName($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" n=""><div class="form-input-group-row labelXXL"><label>{{\'iosl.department.name\' | translate }}</label> <input type="text" typeahead-on-select="vm.onDepartmentNameSelected($item)" name="department" ng-model="vm.usageRulesInfo.department" uib-typeahead="department.value as department.value for department in vm.getDepartmentName($viewValue)" class="form-control" ng-disabled="!vm.enableDepartment"></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.employee.name\' | translate }}</label> <input type="text" typeahead-on-select="vm.onEmployeeNameSelected($item)" name="employee" ng-model="vm.usageRulesInfo.employee" uib-typeahead="employee.value as employee.value for employee in vm.getEmployeeName($viewValue)" class="form-control" ng-disabled="!vm.enableEmployee"></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.one.time.amount\' | translate }}</label> <input type="text" class="form-control" name="oneTimeAmountAllowed" ng-model="vm.usageRulesInfo.oneTimeAmountAllowed" positive-numbers-only=""></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.total.number.per.day\' | translate }}</label> <input type="text" class="form-control" name="noOfTimesPerDayAllowed" ng-model="vm.usageRulesInfo.noOfTimesPerDayAllowed" positive-numbers-only=""></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.total.number.per.month\' | translate }}</label> <input type="text" class="form-control" name="noOfTimesPerMonthAllowed" ng-model="vm.usageRulesInfo.noOfTimesPerMonthAllowed" positive-numbers-only=""></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.cumulated.amount.per.day\' | translate }}</label> <input type="text" class="form-control" name="cumulativeAmountPerDayAllowed" ng-model="vm.usageRulesInfo.cumulativeAmountPerDayAllowed" positive-numbers-only=""></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.cumulated.amount.per.month\' | translate }}</label> <input type="text" class="form-control" name="cumulativeAmountPerMonthAllowed" ng-model="vm.usageRulesInfo.cumulativeAmountPerMonthAllowed" positive-numbers-only=""></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.cumulated.numberoftimes.allowed\' | translate }}</label> <input type="text" class="form-control" name="cumulativeNoOfTimesAllowed" ng-model="vm.usageRulesInfo.cumulativeNoOfTimesAllowed" positive-numbers-only=""></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.cumulated.amount\' | translate }}</label> <input type="text" class="form-control" name="cumulativeAmountAllowed" ng-model="vm.usageRulesInfo.cumulativeAmountAllowed" positive-numbers-only=""></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.column.code\' | translate }}</label> <input type="text" class="form-control" name="columnCodes" ng-model="vm.usageRulesInfo.columnCodes"></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.time.slot.available\' | translate }}</label> <input type="text" class="form-control" name="timeSlotAvailable" ng-model="vm.usageRulesInfo.timeSlotAvailable" placeholder="HH:MM-HH:MM,HH:MM-HH:MM,HH:MM-HH:MM..."></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.week.days.allowed\' | translate }}</label><ui-select multiple="" ng-model="vm.usageRulesInfo.weekDaysAllowed" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($item, vm.weekDays)}}</span></ui-select-match><ui-select-choices repeat="item in vm.weekDays.key | filter:$select.search"><span ng-bind-html="vm.getValueFromTypeKey(item, vm.weekDays)"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.cumulative.no.of.times.per.week.allowed\' | translate }}</label> <input type="text" class="form-control" name="cumulativeNoOfTimesPerWeekAllowed" ng-model="vm.usageRulesInfo.cumulativeNoOfTimesPerWeekAllowed"></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.usage.rules.cumulative.amount.per.week.allowed\' | translate }}</label> <input type="text" class="form-control" name="cumulativeAmountPerWeekAllowed" ng-model="vm.usageRulesInfo.cumulativeAmountPerWeekAllowed"></div></div></div></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/iosl/usage-rules/list" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createUsageRules()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'iosl.department.submit\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/in-office-service/usageRules/views/list-usage-rules.html','<div class="widgets"><div class="panel panel-default bootstrap-panel m-b-10-i filter-panel"><div class="panel-body"><div class="row"><div class="col-sm-12"><button ng-if="vm.permissions.OFFICE_USAGE_RULES.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onUpdate()" class="btn btn-primary btn-raised w-btn-md-3 btn-xs m-l-20">{{ "iosl.usage.rules.edit" | translate }} &nbsp;<i class="fa fa-edit" aria-hidden="true"></i>&nbsp;</button> <button ng-if="vm.permissions.OFFICE_USAGE_RULES.SUBMIT" ngf-select="vm.onUpload($file, $event, bank)" class="btn btn-primary btn-raised btn-xs w-btn-md-3 m-l-5" accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">{{ "iosl.usage.rules.upload" | translate }} &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isUploading"></i></button> <button ng-if="vm.permissions.OFFICE_USAGE_RULES.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onDownload()" class="btn btn-info btn-raised btn-xs w-btn-md-3 m-l-5">{{ "iosl.usage.rules.download" | translate }} &nbsp;<i class="fa fa-download" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDownloading"></i></button> <button ng-if="vm.permissions.OFFICE_USAGE_RULES.SUBMIT" ng-disabled="vm.isEditDisabled()" ng-click="vm.onDelete()" class="btn btn-danger btn-raised btn-xs w-btn-sm-x3 m-r-5 pull-right">{{ "iosl.department.delete" | translate }} &nbsp;<i class="fa fa-trash" aria-hidden="true"></i>&nbsp; <i class="inProgress m-l-5" ng-if="vm.isDeleteLoading"></i></button></div><div class="col-sm-12 m-t-10"><form class="filters"><div class="w-btn-md-3 m-l-20 inline-block"><select class="form-control selectpicker show-tick" title="\u30AA\u30D5\u30A3\u30B9\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.OFFICE_ID" ng-options="item for item in vm.officeIdList track by item" ng-change="vm.getDepartmentList()" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="w-btn-md-3 m-l-8px inline-block"><select class="form-control selectpicker show-tick" title="\u90E8\u7F72\u3067\u7D5E\u308B" data-live-search="true" data-actions-box="true" data-width="100%" data-select-all-text="\u3059\u3079\u3066\u9078\u629E" data-deselect-all-text="\u9078\u629E\u3092\u89E3\u9664" data-live-search-placeholder="\u8907\u6570\u9078\u629E" multiple="" data-size="10" ng-model="vm.colFilter.DEPARTMENT_ID" ng-options="item for item in vm.deptIdList track by item" selectpickernew="{dropupAuto:false, virtualScroll: true}" selectpicker=""></select></div><div class="w-btn-md-3 m-l-8px inline-block"><span><input type="search" class="form-control" ng-model="vm.search.EMPLOYEE_ID" placeholder="{{\'iosl.employee.id\' | translate }}" maxlength="200"></span></div><div class="w-btn-md-3 m-l-8px inline-block"><span><input type="search" class="form-control" ng-model="vm.search.EMPLOYEE_NAME" placeholder="{{\'iosl.employee.name\' | translate }}" maxlength="200"></span></div><div class="inline-block pull-right m-r-5"><button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.show.data\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isFilterLoading"></i></button> <button class="btn btn-danger" ng-click="vm.clearFilters()" ng-disabled="(vm.dataFetchInProgressUsingClear || vm.dataFetchInProgress)">{{\'device.request.list.btn.clear\' | translate}} <i class="inProgress-custom m-l-10" ng-if="vm.isClearLoading"></i></button></div></form></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.select" ng-click="vm.onSelectAll($event, vm.usageRules.content)"> <span></span></label></th><th>#</th><th>{{\'iosl.department.office.id\' | translate}}</th><th>{{\'iosl.department.office.name\' | translate}}</th><th>{{\'iosl.department.id\' | translate}}</th><th>{{\'iosl.department.name\' | translate}}</th><th>{{\'iosl.employee.id\' | translate}}</th><th>{{\'iosl.employee.name\' | translate}}</th><th>{{\'iosl.usage.rules.one.time.amount\' | translate}}</th><th>{{\'iosl.usage.rules.total.number.per.day\' | translate}}</th><th>{{\'iosl.usage.rules.total.number.per.month\' | translate}}</th><th>{{\'iosl.usage.rules.cumulated.amount.per.day\' | translate}}</th><th>{{\'iosl.usage.rules.cumulated.amount.per.month\' | translate}}</th><th>{{\'iosl.usage.rules.cumulated.numberoftimes.allowed\' | translate}}</th><th>{{\'iosl.usage.rules.cumulated.amount\' | translate}}</th><th>{{\'iosl.usage.rules.column.code\' | translate}}</th><th>{{\'iosl.usage.rules.time.slot.available\' | translate}}</th><th>{{\'iosl.usage.rules.week.days.allowed\' | translate}}</th><th>{{\'iosl.usage.rules.cumulative.no.of.times.per.week.allowed\' | translate}}</th><th>{{\'iosl.usage.rules.cumulative.amount.per.week.allowed\' | translate}}</th><th>{{\'iosl.last.modified\' | translate}}</th></tr></thead><tbody><tr ng-repeat="rule in vm.usageRules.content" track="" by="" $index=""><td style="text-align: left;"><label class="custom-checkbox nowrap"><input type="checkbox" ng-model="vm.selectedIds[rule.id]"> <span></span></label></td><td style="text-align: left;">{{vm.employeeResponse.offset + $index + 1}}</td><td class="word-break">{{rule.officeId}}</td><td class="word-break">{{rule.officeName}}</td><td class="word-break">{{rule.departmentId}}</td><td class="word-break">{{rule.departmentName}}</td><td class="word-break">{{rule.employeeId}}</td><td class="word-break">{{rule.employeeName}}</td><td class="word-break">{{rule.oneTimeAmountAllowed}}</td><td class="word-break">{{rule.noOfTimesPerDayAllowed}}</td><td class="word-break">{{rule.noOfTimesPerMonthAllowed}}</td><td class="word-break">{{rule.cumulativeAmountPerDayAllowed}}</td><td class="word-break">{{rule.cumulativeAmountPerMonthAllowed}}</td><td class="word-break">{{rule.cumulativeNoOfTimesAllowed}}</td><td class="word-break">{{rule.cumulativeAmountAllowed}}</td><td class="word-break">{{rule.columnCodes}}</td><td class="word-break">{{rule.timeSlotAvailable}}</td><td class="word-break">{{vm.getWeekDays(rule.weekDaysAllowed)}}</td><td class="word-break">{{rule.cumulativeNoOfTimesPerWeekAllowed}}</td><td class="word-break">{{rule.cumulativeAmountPerWeekAllowed}}</td><td class="word-break">{{rule.lastModified | date: \'medium\'}}</td></tr></tbody></table></div><div class="m-t-20"><paginationv2 query="vm.filter" current-page-size="vm.usageRules.currentPageSize" current-page="vm.usageRules.currentPage" total-pages="vm.usageRules.totalPages" total-elements="vm.usageRules.totalElements" paginate-callback="vm.paginateCallback"></paginationv2></div></div></div></div></div><div class="loader" ng-if="vm.isLoading"><div class="col-md-12"><span class="loader-text">{{\'common.components.processing\' | translate}}</span></div><div class="col-md-12"><div id="loading"></div></div></div>');
$templateCache.put('app/pages/in-office-service/usageRules/views/preview-usage-rules.html','<div class="panel panel-default bootstrap-panel p-2" ng-if="vm.alerts.length !== 0"><div class="row"><div class="col-md-12"><strong ng-if="!vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong> <strong ng-if="vm.isServerError" class="error-textPanel"><span ng-bind-html="vm.alerts.length"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'iosl.msg.server.error\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-12 m-t-10 error-textPanel">{{ alert }}</li></ul></div></div></div><div class="department"><div class="handsOnTableWrapper"><div id="handsOnTable-usageRules"></div></div><div class="clearfix bottomAction"><div class="di-msg-div pull-left">{{ "device.request.edit.warning.msg.dont.refresh" | translate }}</div><button class="btn btn-primary pull-right" ng-click="vm.cancel()">{{ "device.request.create.btn_cancel" | translate }}</button> <button class="btn btn-primary pull-right m-r-10" ng-click="vm.submit()" ng-disabled="vm.disableApplyBtn">{{ "device.request.edit.btn.submit" | translate }} <i class="inProgress m-l-10" ng-if="vm.isLoading"></i></button></div></div>');
$templateCache.put('app/pages/service-management/organization/views/create-new.html','<div form="vm.newOrgForm"><form name="vm.newOrgForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'org.create.common.information\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm[\'organisationTypes_\'+$index].$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.org.type\' | translate}}{{\'common.components.required\' | translate}}</label><ui-select multiple="" ng-model="vm.orgInfo.organisationTypes" class="btn-group bootstrap-select form-control" name="organisationTypes_{{$index}}" ng-disabled="false" append-to-body="false" search-enabled="false" required="" on-select="vm.organisationTypeSelect($item)"><ui-select-match><span>{{vm.getValueFromTypeKey($item, vm.types.OrganisationType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.OrganisationType.key | filter:$select.search"><span ng-bind-html="vm.getValueFromTypeKey(item, vm.types.OrganisationType)"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.orgName.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.org.name\' | translate}}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" ng-model="vm.orgInfo.name" name="orgName" required="" maxlength="250" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div><div class="row"></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="(vm.showPartner || vm.orgInfo.organisationTypes[0] === \'PARTNER\') && vm.permissions.SERVICE_MGMT.ORG_ATTR_WRITE"><div class="panel-heading">{{\'partner.conditions\' | translate}}</div><div class="panel-body"><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.login\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.login" class="btn-group bootstrap-select form-control" on-select="vm.canLoginOrNot($select.selected)" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.trueFalse)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.trueFalse.key track by $index"><span ng-bind-html="vm.types.trueFalse[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.deviceRequest\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.deviceRequest" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.login"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.trueFalse)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.trueFalse.key track by $index"><span ng-bind-html="vm.types.trueFalse[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.sales\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.sales" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.login"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.trueFalse)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.trueFalse.key track by $index"><span ng-bind-html="vm.types.trueFalse[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.settlementInvoice\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.settlementInvoice" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.login"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.trueFalse)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.trueFalse.key track by $index"><span ng-bind-html="vm.types.trueFalse[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.serviceManagement\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.serviceManagement" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.login"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.trueFalse)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.trueFalse.key track by $index"><span ng-bind-html="vm.types.trueFalse[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="(vm.showOffice || vm.orgInfo.organisationTypes[0] === \'OFFICE\') && vm.permissions.SERVICE_MGMT.ORG_ATTR_WRITE"><div class="panel-heading">{{\'iosl.office.attributes\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.officeServiceType{{$index}}.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.service.type\' | translate }}{{\'common.components.required\' | translate}}</label><ui-select ng-model="vm.orgInfo.officeServiceType" name="officeServiceType" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.OfficeServiceType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.OfficeServiceType.key track by $index"><span ng-bind-html="vm.types.OfficeServiceType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.officeServiceSubType.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.service.sub.type\' | translate }}{{\'common.components.required\' | translate}}</label><ui-select ng-model="vm.orgInfo.officeServiceSubType" name="officeServiceSubType" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.officeServiceType" ng-required="vm.orgInfo.officeServiceType"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.officeServiceSubTypeOptions)}}</span></ui-select-match><ui-select-choices repeat="item in vm.officeServiceSubTypeOptions.key track by $index"><span ng-bind-html="vm.officeServiceSubTypeOptions[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width m-t-10" ng-repeat="merchantSummaries in vm.orgInfo.officeMerchantMinDtos track by $index"><div class="panel-heading">{{\'iosl.related.merchants\' | translate }}<div ng-if="$last && vm.orgInfo.officeMerchantMinDtos.length == 1" ng-click="vm.addNewRow(vm.orgInfo.officeMerchantMinDtos)" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.orgInfo.officeMerchantMinDtos.length !== 1" ng-click="vm.addNewRow(vm.orgInfo.officeMerchantMinDtos)" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="vm.orgInfo.officeMerchantMinDtos.length !== 1" ng-click="vm.removeRow(vm.orgInfo.officeMerchantMinDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.merchantSummaries_{{$index}}.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.merchant.name\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" typeahead-on-select="vm.onOfficeMerchantSelected($item, $index)" name="merchantSummaries_{{$index}}" ng-model="merchantSummaries.name" uib-typeahead="merchant.name as merchant.name for merchant in vm.getMerchant($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.merchant.code\' | translate }}</label> <input type="text" class="form-control" ng-model="merchantSummaries.merchantCode" disabled=""></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'org.create.organisation.information\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'org.create.url\' | translate}}</label> <input type="text" class="form-control" maxlength="250" ng-model="vm.orgInfo.url"></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.contact\' | translate }}</div><div class="panel-body"><address label="Address*" address="vm.orgInfo.addressCreateDtos[0]" required="true" form-key="\'organisation_address\'" form="vm.newOrgForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="vm.orgInfo.addressCreateDtos[0].contactCreateDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newOrgForm"></contact></div></div><div ng-if="vm.orgInfo.organisationTypes[0] !== \'PARTNER\'"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.applicantCompanyCode.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.code\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" name="applicantCompanyCode" ng-model="vm.orgInfo.code" required="" maxlength="20" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.businessType.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.business\' | translate}}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" name="businessType" ng-model="vm.orgInfo.businessType" required="" maxlength="250" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.productsHandled.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.products.handled\' | translate}}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" name="productsHandled" ng-model="vm.orgInfo.productsHandled" required="" maxlength="250" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div></div><div class="panel panel-default bootstrap-panel title-width m-t-30" ng-repeat="representative in vm.orgInfo.organisationRepresentativeCreateDtos track by $index"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.representative.title\' | translate }}</div><div class="panel-body"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newOrgForm[\'companyRepresentativeName_\'+$index].$invalid || vm.newOrgForm[\'companyRepresentativeNameReading_\'+$index].$invalid) && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.name\' | translate}}{{\'common.components.required\' | translate}}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyRepresentativeNameReading_{{$index}}" placeholder="{{\'service.contract.create.applicant.information.company.representative.name.kana\' | translate }}" ng-model="representative.nameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="companyRepresentativeName_{{$index}}" placeholder="{{\'service.contract.create.applicant.information.company.representative.name\' | translate }}" ng-model="representative.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.representativedob.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.representative.dateOfBirh\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="representative.dateOfBirth" name="representativedob" options="vm.dobOptions" ng-model="representative.dateOfBirth" required=""></datepicker></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="account in vm.orgInfo.accountCreateDtos track by $index" ng-if="vm.showInchargeSection"><div class="panel-heading">{{\'service.contract.create.inCharge.title\' | translate }}<div ng-if="$last && vm.orgInfo.accountCreateDtos.length == 1" ng-click="vm.addNewRow(vm.orgInfo.accountCreateDtos, \'CREATE_INCHARGE\')" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate}}</div><div ng-if="$last && vm.orgInfo.accountCreateDtos.length !== 1" ng-click="vm.addNewRow(vm.orgInfo.accountCreateDtos, \'CREATE_INCHARGE\')" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate}}</div><div ng-if="vm.orgInfo.accountCreateDtos.length !== 1" ng-click="vm.removeRow(vm.orgInfo.accountCreateDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newOrgForm[\'companyInChargePerson_\'+$index].$invalid || vm.newOrgForm[\'companyInChargePersonReading_\'+$index].$invalid) && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.name\' | translate}}{{\'common.components.required\' | translate}}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyInChargePersonReading_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name.kana\' | translate }}" ng-model="account.nameSimple" maxlength="250" required="" special-character-limit=""> <input type="text" class="form-control" name="companyInChargePerson_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name\' | translate }}" ng-model="account.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><div ng-init="account.accountTypes=[\'ADMIN\']"><contact get-label="vm.getValueFromTypeKey" label="Contact" contact-entity="\'ACCOUNT\'" contact="account.contactCreateDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newOrgForm"></contact></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm[\'companyUsername_\'+$index].$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.contact.email\' | translate }} {{\'common.components.required\' | translate}}</label> <input type="text" valid-email="" class="form-control" name="companyUsername_{{$index}}" ng-model="account.userName" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.email_error_msg\' | translate}}</span></div></div></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/service-management/organisation/list" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createOrganisation()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'org.create.submit.data\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/service-management/organization/views/link.html','<div form="vm.newContractForm"><form name="vm.newContractForm" novalidate=""><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Create New Link</div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Recievers Organisation</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.deviceOwner.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>Organisation Code</label> <input type="text" typeahead-on-select="vm.onOrgSelected($item, $index)" name="deviceOwner" ng-model="deviceOwner.deviceOrgName" uib-typeahead="org.name as org.name for org in vm.getDeviceOwner($viewValue)" class="form-control" required="" placeholder="Search by Organisation Code"></div><span class="help-block error-block basic-block align-right">Required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.deviceOwner.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>Organisation Name</label> <input type="text" typeahead-on-select="vm.onOrgSelected($item, $index)" name="deviceOwner" ng-model="deviceOwner.deviceOrgName" uib-typeahead="org.name as org.name for org in vm.getDeviceOwner($viewValue)" class="form-control" required="" placeholder="Search by Organisation Name"></div><span class="help-block error-block basic-block align-right">Required</span></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Association</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.businessType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>Type of Link</label><ui-select ng-model="vm.contractInfo.organisationCreateDto.businessType" name="businessType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" required=""><ui-select-match><span></span></ui-select-match><ui-select-choices repeat="item in vm.types.OrgType.key track by $index"><span ng-bind-html="vm.types.OrgType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">Required</span></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.businessType.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>Type of Association</label><ui-select ng-model="vm.contractInfo.organisationCreateDto.businessType" name="businessType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" required=""><ui-select-match><span></span></ui-select-match><ui-select-choices repeat="item in vm.types.OrgType.key track by $index"><span ng-bind-html="vm.types.OrgType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">Required</span></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Provider Organisation</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.deviceOwner.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>Organisation Code</label> <input type="text" typeahead-on-select="vm.onOrgSelected($item, $index)" name="deviceOwner" ng-model="deviceOwner.deviceOrgName" uib-typeahead="org.name as org.name for org in vm.getDeviceOwner($viewValue)" class="form-control" required="" placeholder="Search by Organisation Code"></div><span class="help-block error-block basic-block align-right">Required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newContractForm.deviceOwner.$invalid && vm.newContractForm.$submitted}"><div class="form-input-group-row labelXXL"><label>Organisation Name</label> <input type="text" typeahead-on-select="vm.onOrgSelected($item, $index)" name="deviceOwner" ng-model="deviceOwner.deviceOrgName" uib-typeahead="org.name as org.name for org in vm.getDeviceOwner($viewValue)" class="form-control" required="" placeholder="Search by Organisation Name"></div><span class="help-block error-block basic-block align-right">Required</span></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md-12 text-right"><button type="button" class="btn btn-danger">CANCEL</button> <button type="button" class="btn btn-success">SUBMIT</button></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Existing Connections</div><div class="panel-body"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th colspan="2" class="text-center">Reciever Organisation</th><th colspan="3" class="text-center">Association</th><th colspan="2" class="text-center">Provider Organisation</th></tr><tr><th>Organisation Code</th><th>Organisation Name</th><th>Type of Link</th><th>Association Attribute</th><th>Type ofAssociation</th><th>Organisation Code</th><th>Organisation Name</th></tr></thead><tbody><tr><td>demo</td><td>demo</td><td>demo</td><td>demo</td><td>demo</td><td>demo</td><td>demo</td></tr></tbody></table></div></div></div></div></div></div></form></div>');
$templateCache.put('app/pages/service-management/organization/views/list-Org.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th>{{\'org.list.org.id\' | translate}} <a title="{{\'org.list.org.id.info\' | translate }}" class="m-no-error"><i class="fa fa-info-circle"></i></a></th><th>{{\'org.list.org.type\' | translate}}</th><th>{{\'org.list.org.name\' | translate}}</th><th>{{\'org.list.org.address\' | translate}}</th><th>{{\'org.list.org.representative\' | translate}}</th><th colspan="3" class="text-center">{{\'org.list.action\' | translate}}</th></tr></thead><tbody><tr ng-repeat="sc in vm.scListResponse.content" track="" by="" $index=""><td style="text-align: left;">{{vm.scListResponse.pageable.offset + $index + 1}}</td><td>{{ sc.organisationTypes[0] == "MERCHANT" && sc.organisationTypes[1] == "DEVICE_OWNER" ? sc.merchantCode + "/" + sc.deviceOwnerCode : sc.organisationTypes[0] == "DEVICE_OWNER" ? sc.deviceOwnerCode : sc.organisationTypes[0] == "MERCHANT" ? sc.merchantCode : sc.organisationTypes[0] == "MERCHANT_AND_DEVICE_OWNER" ? sc.deviceOwnerCode + "/" + sc.merchantCode : sc.organisationTypes[0] == "PARTNER" ? sc.partnerCode : sc.organisationTypes[0] == "OFFICE" ? sc.officeCode : "" }}</td><td><span ng-bind-html="vm.orgType(sc.organisationTypes[0])"></span> <span ng-if="sc.organisationTypes.length === 2">/</span> <span ng-if="sc.organisationTypes.length === 2" ng-bind-html="vm.orgType(sc.organisationTypes[1])"></span></td><td class="word-break">{{sc.name}}</td><td class="word-break">{{sc.addressDtos[0].streetAddress}}</td><td class="word-break">{{sc.organisationRepresentativeDtos[0].name}}</td><td><button class="btn btn-info btn-xs" ng-if="vm.permissions.SERVICE_MGMT.ORG_WRITE" ng-click="vm.openDetail($event, sc)">{{\'org.list.view.edit\' | translate}}</button> <button class="btn btn-info btn-xs" ng-if="!vm.permissions.SERVICE_MGMT.ORG_WRITE" ng-click="vm.openDetail($event, sc)">{{\'org.list.view\' | translate}}</button></td><td><div ng-switch="sc.enabled"><div ng-switch-when="false"><button class="btn btn-warning btn-xs" ng-disabled="!vm.permissions.SERVICE_MGMT.ORG_WRITE" ng-click="vm.enableOrg(sc)">{{\'org.list.enable\' | translate}}</button></div><div ng-switch-when="true"><button class="btn btn-primary btn-xs" ng-disabled="!vm.permissions.SERVICE_MGMT.ORG_WRITE" ng-click="vm.disableOrg(sc)">{{\'org.list.disable\' | translate}}</button></div></div></td><td><button class="btn btn-danger btn-xs" ng-disabled="!vm.permissions.SERVICE_MGMT.ORG_WRITE" ng-click="vm.deleteOrg(sc)">{{\'org.list.delete\' | translate}}</button></td></tr></tbody></table></div><div class="m-t-20"><pagination query="vm.query" pageable="vm.scListResponse.pageable" total-pages="vm.scListResponse.totalPages" total-elements="vm.scListResponse.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div></div></div></div>');
$templateCache.put('app/pages/service-management/organization/views/org-detail.html','<div ng-if="!vm.isEdit"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'org.view.title_view\' | translate}} <button class="btn addNewRow" ng-click="vm.editDetail()" ng-if="vm.permissions.SERVICE_MGMT.ORG_WRITE" ng-disabled="!(vm.permissions.SERVICE_MGMT.ORG_WRITE || vm.permissions.SERVICE_MGMT.SELF_ORG)">{{\'org.view.EDIT\' | translate}}</button></div><div class="panel-body"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'org.create.common.information\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.organisationTypes.$invalid && vm.newOrgForm.$submitted}"><div class="form-detail-row labelXXL"><label>{{\'org.create.org.type\' | translate}}</label><div><span ng-bind-html="vm.typeOrg(vm.orgInfo.organisationTypes[0])"></span> <span ng-if="vm.orgInfo.organisationTypes.length === 2">/</span> <span ng-if="vm.orgInfo.organisationTypes.length === 2" ng-bind-html="vm.typeOrg(vm.orgInfo.organisationTypes[1])"></span></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row" ng-show="!vm.orgInfo.organisationTypes[0] == \'ADMIN\'"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'user.list.merchant.id\' | translate}}/{{\'user.list.owner.id\' | translate}}</label><div>{{ vm.orgInfo.organisationTypes[0] == "MERCHANT" && vm.orgInfo.organisationTypes[1] == "DEVICE_OWNER" ? vm.orgInfo.merchantCode + "/" + vm.orgInfo.deviceOwnerCode : vm.orgInfo.organisationTypes[0] == "DEVICE_OWNER" ? vm.orgInfo.deviceOwnerCode : vm.orgInfo.organisationTypes[0] == "MERCHANT" ? vm.orgInfo.merchantCode : vm.orgInfo.organisationTypes[0] == "MERCHANT_AND_DEVICE_OWNER" ? vm.orgInfo.deviceOwnerCode + "/" + vm.orgInfo.merchantCode : "" }}</div></div></div></div></div><div class="row" ng-if="vm.orgInfo.organisationTypes[0] === \'PARTNER\'"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'partner.code\' | translate}}</label><div>{{vm.orgInfo.partnerCode}}</div></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.orgName.$invalid && vm.newOrgForm.$submitted}"><div class="form-detail-row labelXXL"><label>{{\'org.create.org.name\' | translate}}</label><div class="word-break">{{vm.orgInfo.name}}</div></div></div></div></div><div class="row"></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.orgInfo.organisationTypes[0] === \'PARTNER\' && vm.permissions.SERVICE_MGMT.ORG_ATTR_WRITE" "=""><div class="panel-heading">{{\'partner.conditions\' | translate}}</div><div class="panel-body"><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.login\' | translate }}</label></div><div class="col-md-3">{{vm.getValueFromTypeKey(vm.orgInfo.login, vm.types.allowOrNot)}}</div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.deviceRequest\' | translate }}</label></div><div class="col-md-3">{{vm.getValueFromTypeKey(vm.orgInfo.deviceRequest, vm.types.allowOrNot)}}</div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.sales\' | translate }}</label></div><div class="col-md-3">{{vm.getValueFromTypeKey(vm.orgInfo.sales, vm.types.allowOrNot)}}</div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.settlementInvoice\' | translate }}</label></div><div class="col-md-3">{{vm.getValueFromTypeKey(vm.orgInfo.settlementInvoice, vm.types.allowOrNot)}}</div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.serviceManagement\' | translate }}</label></div><div class="col-md-3">{{vm.getValueFromTypeKey(vm.orgInfo.serviceManagement, vm.types.allowOrNot)}}</div></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.orgInfo.organisationTypes[0] === \'OFFICE\' && vm.permissions.SERVICE_MGMT.ORG_ATTR_WRITE"><div class="panel-heading">{{\'iosl.office.attributes\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'iosl.service.type\' | translate }}</label><div class="word-break">{{vm.getValueFromTypeKey(vm.orgInfo.officeServiceType, vm.types.OfficeServiceType)}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'iosl.service.sub.type\' | translate }}</label><div class="word-break">{{vm.getValueFromTypeKey(vm.orgInfo.officeServiceSubType, vm.officeServiceSubTypeOptions)}}</div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width m-t-10" ng-repeat="merchantSummaries in vm.orgInfo.officeMerchantMinDtos track by $index"><div class="panel-heading">{{\'iosl.related.merchants\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'iosl.merchant.name\' | translate }}</label><div class="word-break">{{merchantSummaries.name}}</div></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'iosl.merchant.code\' | translate }}</label><div class="word-break">{{merchantSummaries.merchantCode}}</div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'org.create.organisation.information\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'org.create.url\' | translate}}</label><div class="word-break">{{vm.orgInfo.url}}</div></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.contact\' | translate }}</div><div class="panel-body"><address is-edit="false" label="Address*" address="vm.orgInfo.addressDtos[0]" required="false" form-key="\'organisation_address\'" form="vm.newOrgForm"></address><contact is-edit="false" get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="vm.orgInfo.addressDtos[0].contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newOrgForm"></contact></div></div><div ng-if="vm.orgInfo.organisationTypes[0] !== \'PARTNER\'"><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.code\' | translate }}</label><div>{{vm.orgInfo.code}}</div></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.businessType.$invalid && vm.newOrgForm.$submitted}"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.business\' | translate}}</label><div class="word-break">{{vm.orgInfo.businessType}}</div></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'org.create.products.handled\' | translate}}</label><div class="word-break">{{vm.orgInfo.productsHandled}}</div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="representative in vm.orgInfo.organisationRepresentativeDtos track by $index"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.representative.title\' | translate }}</div><div class="panel-body"><div class="form-group kanaFromGroup"><div class="form-detail-row labelXXL"><label>{{\'org.create.name\' | translate}}</label><div class="kanaInputGroup"><div class="word-break">{{representative.nameSimplified}}</div><div class="word-break">{{representative.name}}</div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.representative.dateOfBirh\' | translate }}</label><div>{{representative.dateOfBirth | date: \'yyyy/MM/dd\' }}</div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="account in vm.orgInfo.accountDtos track by $index"><div class="panel-heading">{{\'service.contract.create.inCharge.title\' | translate }}</div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm[\'companyInChargePerson_\'+$index].$invalid && vm.newOrgForm.$submitted}"><div class="form-detail-row labelXXL"><label>{{\'org.create.name\' | translate}}</label><div class="kanaInputGroup"><div class="word-break">{{account.nameSimple}}</div><div class="word-break">{{account.name}}</div></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="row"><div class="col-md-6"><div ng-init="account.accountTypes=[\'ADMIN\']"><contact is-edit="false" get-label="vm.getValueFromTypeKey" label="Contact" contact-entity="\'ACCOUNT\'" contact="account.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" fform="" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newOrgForm"></contact></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.contact.email\' | translate }} {{\'common.components.required\' | translate}}</label><div class="word-break">{{account.userName}}</div></div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.isEdit"><div class="panel-heading">{{\'org.view.title_update\' | translate}}</div><div class="panel-body"><div form="vm.newOrgForm"><form name="vm.newOrgForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'org.create.common.information\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.organisationTypes.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.org.type\' | translate}}{{\'common.components.required\' | translate}}</label><div><span ng-bind-html="vm.typeOrg(vm.orgInfo.organisationTypes[0])"></span> <span ng-if="vm.orgInfo.organisationTypes.length === 2">/</span> <span ng-if="vm.orgInfo.organisationTypes.length === 2" ng-bind-html="vm.typeOrg(vm.orgInfo.organisationTypes[1])"></span></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div></div><div class="row" ng-show="!vm.orgInfo.organisationTypes[0] == \'ADMIN\'"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'user.list.merchant.id\' | translate}}/{{\'user.list.owner.id\' | translate}}</label><div>{{ vm.orgInfo.organisationTypes[0] == "MERCHANT" && vm.orgInfo.organisationTypes[1] == "DEVICE_OWNER" ? vm.orgInfo.merchantCode + "/" + vm.orgInfo.deviceOwnerCode : vm.orgInfo.organisationTypes[0] == "DEVICE_OWNER" ? vm.orgInfo.deviceOwnerCode : vm.orgInfo.organisationTypes[0] == "MERCHANT" ? vm.orgInfo.merchantCode : vm.orgInfo.organisationTypes[0] == "MERCHANT_AND_DEVICE_OWNER" ? vm.orgInfo.deviceOwnerCode + "/" + vm.orgInfo.merchantCode : "" }}</div></div></div></div></div><div class="row" ng-if="vm.orgInfo.organisationTypes[0] === \'PARTNER\'"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'partner.code\' | translate}}</label><div>{{vm.orgInfo.partnerCode}}</div></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.orgName.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.org.name\' | translate}}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" ng-model="vm.orgInfo.name" name="orgName" required="" maxlength="250" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.orgInfo.organisationTypes[0] === \'PARTNER\' && vm.permissions.SERVICE_MGMT.ORG_ATTR_WRITE"><div class="panel-heading">{{\'partner.conditions\' | translate}}</div><div class="panel-body"><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.login\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.login" class="btn-group bootstrap-select form-control" on-select="vm.canLoginOrNot($select.selected)" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.allowOrNot)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.allowOrNot.key track by $index"><span ng-bind-html="vm.types.allowOrNot[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.deviceRequest\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.deviceRequest" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.login"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.allowOrNot)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.allowOrNot.key track by $index"><span ng-bind-html="vm.types.allowOrNot[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.sales\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.sales" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.login"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.allowOrNot)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.allowOrNot.key track by $index"><span ng-bind-html="vm.types.allowOrNot[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.settlementInvoice\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.settlementInvoice" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.login"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.allowOrNot)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.allowOrNot.key track by $index"><span ng-bind-html="vm.types.allowOrNot[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="form-input-group-row labelXXL"><div class="col-md-4"><label>{{\'partner.allow.serviceManagement\' | translate }}</label></div><div class="col-md-3"><ui-select ng-model="vm.orgInfo.serviceManagement" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.login"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.allowOrNot)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.allowOrNot.key track by $index"><span ng-bind-html="vm.types.allowOrNot[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel" ng-if="vm.orgInfo.organisationTypes[0] === \'OFFICE\' && vm.permissions.SERVICE_MGMT.ORG_ATTR_WRITE"><div class="panel-heading">{{\'iosl.office.attributes\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'iosl.service.type\' | translate }}</label><div class="word-break">{{vm.getValueFromTypeKey(vm.orgInfo.officeServiceType, vm.types.OfficeServiceType)}}</div></div></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.officeServiceSubType.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.service.sub.type\' | translate }}{{\'common.components.required\' | translate}}</label><ui-select ng-model="vm.orgInfo.officeServiceSubType" name="officeServiceSubType" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false" ng-disabled="!vm.orgInfo.officeServiceType" ng-required="vm.orgInfo.officeServiceType"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.officeServiceSubTypeOptions)}}</span></ui-select-match><ui-select-choices repeat="item in vm.officeServiceSubTypeOptions.key track by $index"><span ng-bind-html="vm.officeServiceSubTypeOptions[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="panel panel-default bootstrap-panel title-width m-t-10" ng-repeat="merchantSummaries in vm.orgInfo.officeMerchantMinDtos track by $index"><div class="panel-heading">{{\'iosl.related.merchants\' | translate }}<div ng-if="$last && vm.orgInfo.officeMerchantMinDtos.length == 1" ng-click="vm.addNewRow(vm.orgInfo.officeMerchantMinDtos)" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="$last && vm.orgInfo.officeMerchantMinDtos.length !== 1" ng-click="vm.addNewRow(vm.orgInfo.officeMerchantMinDtos)" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate }}</div><div ng-if="vm.orgInfo.officeMerchantMinDtos.length !== 1" ng-click="vm.removeRow(vm.orgInfo.officeMerchantMinDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.merchantSummaries_{{$index}}.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'iosl.merchant.name\' | translate }}</label> <input type="text" typeahead-on-select="vm.onOfficeMerchantSelected($item, $index)" name="merchantSummaries_{{$index}}" ng-model="merchantSummaries.name" uib-typeahead="merchant.name as merchant.name for merchant in vm.getMerchant($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate }}</span></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'iosl.merchant.code\' | translate }}</label> <input type="text" class="form-control" ng-model="merchantSummaries.merchantCode" disabled=""></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'org.create.organisation.information\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'org.create.url\' | translate}}</label> <input type="text" class="form-control" maxlength="250" ng-model="vm.orgInfo.url"></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.contact\' | translate }}</div><div class="panel-body"><address label="Address*" address="vm.orgInfo.addressDtos[0]" required="true" form-key="\'organisation_address\'" form="vm.newOrgForm" street-address-required="true"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ADDRESS\'" contact="vm.orgInfo.addressDtos[0].contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="fakse" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newOrgForm"></contact></div></div><div ng-if="vm.orgInfo.organisationTypes[0] !== \'PARTNER\'"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.applicantCompanyCode.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.code\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" name="applicantCompanyCode" ng-model="vm.orgInfo.code" required="" maxlength="20" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.businessType.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.business\' | translate}}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" name="businessType" ng-model="vm.orgInfo.businessType" maxlength="250" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.productsHandled.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.products.handled\' | translate}}{{\'common.components.required\' | translate}}</label> <input type="text" class="form-control" name="productsHandled" ng-model="vm.orgInfo.productsHandled" maxlength="250" required="" special-character-limit=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="representative in vm.orgInfo.organisationRepresentativeDtos track by $index"><div class="panel-heading">{{\'service.contract.create.applicant.information.company.representative.title\' | translate }}</div><div class="panel-body"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newOrgForm[\'companyRepresentativeName_\'+$index].$invalid || vm.newOrgForm[\'companyRepresentativeNameReading_\'+$index].$invalid) && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.name\' | translate}}{{\'common.components.required\' | translate}}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyRepresentativeNameReading_{{$index}}" placeholder="{{\'service.contract.create.applicant.information.company.representative.name.kana\' | translate }}" ng-model="representative.nameSimplified" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="companyRepresentativeName_{{$index}}" placeholder="{{\'service.contract.create.applicant.information.company.representative.name\' | translate }}" ng-model="representative.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm.representativedob.$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.applicant.information.company.representative.dateOfBirh\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="representative.dateOfBirth" name="representativedob" ng-model="representative.dateOfBirth" required="" options="vm.dobOptions"></datepicker></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width" ng-repeat="account in vm.orgInfo.accountDtos track by $index" ng-if="vm.showInchargeSection"><div class="panel-heading">{{\'service.contract.create.inCharge.title\' | translate }}<div ng-if="$last && vm.orgInfo.accountDtos.length == 1" ng-click="vm.addNewRow(vm.orgInfo.accountDtos, \'CREATE_INCHARGE\')" class="btn btn-default addNewRow"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate}}</div><div ng-if="$last && vm.orgInfo.accountDtos.length !== 1" ng-click="vm.addNewRow(vm.orgInfo.accountDtos, \'CREATE_INCHARGE\')" class="btn btn-default addNewRow m-r-30"><i class="ion-plus-round"></i> {{\'common.components.random.add.new\' | translate}}</div><div ng-if="vm.orgInfo.accountDtos.length !== 1" ng-click="vm.removeIncharge(vm.orgInfo.accountDtos, $index)" class="btn btn-default addNewRow"><i class="ion-trash-a"></i></div></div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newOrgForm[\'companyInChargePerson_\'+$index].$invalid || vm.newOrgForm[\'companyInChargePersonReading_\'+$index].$invalid) && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'org.create.name\' | translate}}{{\'common.components.required\' | translate}}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyInChargePersonReading_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name.kana\' | translate }}" ng-model="account.nameSimple" required="" maxlength="250" special-character-limit=""> <input type="text" class="form-control" name="companyInChargePerson_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name\' | translate }}" ng-model="account.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div></div><div class="row"><div class="col-md-6"><div ng-init="account.accountTypes=[\'ADMIN\']"><contact get-label="vm.getValueFromTypeKey" label="Contact" contact-entity="\'ACCOUNT\'" contact="account.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newOrgForm"></contact></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.newOrgForm[\'companyUsername_\'+$index].$invalid && vm.newOrgForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'service.contract.create.contact.email\' | translate }} {{\'common.components.required\' | translate}}</label> <input type="text" valid-email="" class="form-control" name="companyUsername_{{$index}}" ng-model="account.userName" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.email_error_msg\' | translate}}</span></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a class="btn btn-primary pull-right m-r-20" ng-click="vm.cancelEdit()" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate}}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.saveDetail()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'org.view.save\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div></div></div>');
$templateCache.put('app/pages/service-management/users/views/create-user.html','<div form="vm.newUserForm"><form name="vm.newUserForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'users.create.update.view.on.page.details.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.common.information.title\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.commonInfoUserEmail.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userEmail\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" valid-email="" class="form-control" name="commonInfoUserEmail" ng-model="vm.userInfo.userName" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.contact.email_error_msg\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newUserForm[\'companyInChargePerson_\'+$index].$invalid || vm.newUserForm[\'companyInChargePersonReading_\'+$index].$invalid) && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userName\' | translate }}{{\'common.components.required\' | translate}}</label><div class="kanaInputGroup"><input type="text" special-character-limit="" class="form-control" name="companyInChargePersonReading_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name.kana\' | translate }}" ng-model="vm.userInfo.nameSimple" maxlength="250" required=""> <input type="text" special-character-limit="" class="form-control" name="companyInChargePerson_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name\' | translate }}" ng-model="vm.userInfo.name" required="" maxlength="250"></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.commonInfoUserDescription.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userDescription\' | translate }}{{\'common.components.required\' | translate}}</label> <textarea class="form-control" special-character-limit="" name="commonInfoUserDescription" ng-model="vm.userInfo.userDescription" required="" maxlength="250"></textarea></div><span class="help-block error-block basic-block align-right">{{\'user.list.msg.user.description\' | translate}}</span></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.organization.information.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.organizationName.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL organization-name"><label>{{\'users.create.update.view.organization.information.organizationName\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" typeahead-on-select="vm.onOrgNameSelected($item)" name="organizationName" ng-disabled="vm.isMerchantOrDeviceOwner || vm.isPartner || vm.isOfficeUser" ng-model="vm.userInfo.organizationName" uib-typeahead="org.name as org.name for org in vm.getOrgName($viewValue)" class="form-control" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-5"><div class="form-group"><label class="m-t-10">{{\'users.create.update.view.info.msg\' | translate }}</label></div></div><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{sc.accountId}} {{\'users.create.update.view.organization.information.organizationCode\' | translate }}</label><div ng-if="vm.userInfo.organizationCode === \'\'">{{\'common.components.data.not.available\' | translate}}</div><div ng-if="vm.userInfo.organizationCode !== \'\'">{{vm.userInfo.organizationCode}}</div></div></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.accountTypes.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.organization.information.userType\' | translate }}{{\'common.components.required\' | translate}}</label><ui-select ng-model="vm.userInfo.accountTypes[0]" class="btn-group bootstrap-select form-control" name="accountTypes" append-to-body="false" search-enabled="false" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.AccountType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.AccountType.key track by $index"><span ng-bind-html="vm.types.AccountType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7" ng-if="vm.display && vm.userInfo.accountTypes[0] == \'ADMIN\'"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'user.service.contract.in-charge\' | translate}}</label><ui-select multiple="" ng-model="vm.userInfo.serviceContractId" class="btn-group bootstrap-select form-control" name="availableSC" append-to-body="false" search-enabled="false"><ui-select-match placeholder="{{\'user.list.placeholder.for.sc.id\' | translate}}"><span>{{$item}}</span></ui-select-match><ui-select-choices repeat="item in vm.availableServiceContract"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.user.information.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.user.information.dob\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="vm.userInfo.dob" name="userDob" options="vm.dobOptions" ng-model="vm.userInfo.dob" required="" form="vm.newUserForm"></datepicker></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row"><label>{{\'users.create.update.view.user.information.gender\' | translate }}</label><ui-select ng-model="vm.userInfo.gender" name="commonInfoGender" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.Gender)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.Gender.key track by $index"><span ng-bind-html="vm.types.Gender[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><address label="Address*" address="vm.userInfo.addressCreateDtos[0]" required="true" form-key="\'organisation_address\'" form="vm.newUserForm"></address><contact get-label="vm.getValueFromTypeKey" label="Contact" multiple="true" contact-entity="\'ACCOUNT\'" contact="vm.userInfo.contactCreateDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'user_account_contact_\'+$index" form="vm.newUserForm"></contact></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a href="/#/main/service-management/users/list" class="btn btn-primary pull-right" ng-disabled="vm.btnClick">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.createUser()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'user.view.submit.data\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/service-management/users/views/detail-user.html','<div ng-if="!vm.isEdit"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'users.create.update.view.on.page.details.title\' | translate }} <button ng-click="vm.editDetail()" ng-if="vm.permissions.SERVICE_MGMT.USER_WRITE" ng-disabled="!(vm.permissions.SERVICE_MGMT.USER_WRITE || vm.userInfo.userName===vm.profile.userName)" class="btn addNewRow">{{\'org.view.EDIT\' | translate}}</button></div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.common.information.title\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.common.information.userEmail\' | translate }}</label><div class="word-break">{{vm.userInfo.userName}}</div></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.common.information.userName\' | translate }}</label><div class="kanaInputGroup"><div class="word-break">{{vm.userInfo.nameSimple}}</div><div class="word-break">{{vm.userInfo.name}}</div></div></div></div></div><div><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.common.information.userDescription\' | translate }}</label><div class="userDescription">{{vm.userInfo.userDescription}}</div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.organization.information.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.organization.information.organizationName\' | translate }}</label><div class="word-break">{{vm.userInfo.organisation.name}}</div></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.organization.information.organizationCode\' | translate }}</label><div ng-if="vm.userInfo.organisation.code === \'\' || vm.userInfo.organisation.code === null">{{\'common.components.data.not.available\' | translate}}</div><div ng-if="vm.userInfo.organisation.code !== \'\' || vm.userInfo.organisation.code !== null">{{vm.userInfo.organisation.code}}</div></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.organization.information.userType\' | translate }}</label><div>{{vm.getValueFromTypeKey(vm.userInfo.accountTypes[0], vm.types.AccountType)}}</div></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'user.service.contract\' | translate }}</label><div><span ng-repeat="sc in vm.userInfo.serviceContractId track by $index">{{sc}} <span ng-if="!$last">,</span></span> <span ng-if="vm.userInfo.serviceContractId.length == 0">{{\'user.none\' | translate}}</span></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.user.information.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.user.information.dob\' | translate }}</label><div>{{vm.userInfo.dob | date: \'yyyy/MM/dd\'}}</div></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.user.information.gender\' | translate }}</label><div>{{vm.getValueFromTypeKey(vm.userInfo.gender, vm.types.Gender)}}</div></div></div></div></div><address is-edit="false" label="Address*" address="vm.userInfo.addressDtos[0]" required="true" form-key="\'organisation_address\'" form="vm.newUserForm"></address><div ng-init="account.accountTypes=[\'ADMIN\']"><contact is-edit="false" get-label="vm.getValueFromTypeKey" label="Contact" contact-entity="\'ACCOUNT\'" contact="vm.userInfo.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'organisation_account_contact_\'+$index" form="vm.newUserForm"></contact></div></div></div></div></div></div><div form="vm.newUserForm" ng-if="vm.isEdit"><form name="vm.newUserForm" novalidate=""><div class="panel panel-default bootstrap-panel" ng-if="vm.detailErrors"><div class="panel-body"><div class="row"><div class="col-md-12"><strong class="error-textPanel"><span ng-bind-html="vm.errorNumbers"></span> {{\'common.components.title.error.withCount\' | translate}} {{\'common.components.msg.error.in.form.withCount\' | translate}}</strong><br><br><ul><li ng-repeat="alert in vm.alerts track by $index" class="col-md-4 error-textPanel"><strong>{{alert | translate}}</strong></li></ul></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'users.create.update.view.on.page.details.title\' | translate }}</div><div class="panel-body"><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.common.information.title\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.commonInfoUserEmail.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userEmail\' | translate }}{{\'common.components.required\' | translate}}</label> <input type="text" valid-email="" class="form-control" name="commonInfoUserEmail" ng-model="vm.userInfo.userName" required=""></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group kanaFromGroup" ng-class="{\'has-error\': (vm.newUserForm[\'companyInChargePerson_\'+$index].$invalid || vm.newUserForm[\'companyInChargePersonReading_\'+$index].$invalid) && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userName\' | translate }}{{\'common.components.required\' | translate}}</label><div class="kanaInputGroup"><input type="text" class="form-control" name="companyInChargePersonReading_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name.kana\' | translate }}" ng-model="vm.userInfo.nameSimple" maxlength="250" required="" special-character-limit=""> <input type="text" class="form-control" name="companyInChargePerson_{{$index}}" placeholder="{{\'service.contract.create.inCharge.name\' | translate }}" ng-model="vm.userInfo.name" required="" maxlength="250" special-character-limit=""></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.valid.required\' | translate}}</span></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.commonInfoUserDescription.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userDescription\' | translate }}{{\'common.components.required\' | translate}}</label> <textarea class="form-control" name="commonInfoUserDescription" ng-model="vm.userInfo.userDescription" required="" ng-maxlength="250" special-character-limit=""></textarea></div><span class="help-block error-block basic-block align-right">{{\'user.list.msg.user.description\' | translate}}</span></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.organization.information.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.organization.information.organizationName\' | translate }}</label><div>{{vm.userInfo.organisation.name}}</div></div></div></div><div class="col-md-7"><div class="form-group"><div class="form-detail-row labelXXL"><label>{{\'users.create.update.view.organization.information.organizationCode\' | translate }}</label><div ng-if="vm.userInfo.organisation.code === \'\' || vm.userInfo.organisation.code === null">{{\'common.components.data.not.available\' | translate}}</div><div ng-if="vm.userInfo.organisation.code !== \'\' || vm.userInfo.organisation.code !== null">{{vm.userInfo.organisation.code}}</div></div></div></div><div class="col-md-7"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.accountTypes.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.organization.information.userType\' | translate }}{{\'common.components.required\' | translate}}</label><ui-select ng-disabled="!vm.permissions.SERVICE_MGMT.USER_WRITE" ng-model="vm.userInfo.accountTypes[0]" class="btn-group bootstrap-select form-control" name="accountTypes" append-to-body="false" search-enabled="false" required=""><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.AccountType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.AccountType.key track by $index"><span ng-bind-html="vm.types.AccountType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div><span class="help-block error-block basic-block align-right">{{\'common.components.random.required\' | translate}}</span></div><div class="col-md-7" ng-if="vm.display && vm.userInfo.accountTypes[0] == \'ADMIN\'"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'user.service.contract.in-charge\' | translate}}</label> <input type="text" disabled="" class="form-control" placeholder="{{\'user.text.placeholder.for.sc.id\' | translate}}" ng-if="vm.userInfo.accountTypes[0] !== \'ADMIN\'"><ui-select multiple="" ng-model="vm.userInfo.serviceContractId" class="btn-group bootstrap-select form-control" name="availableSC" append-to-body="false" search-enabled="false" ng-if="vm.userInfo.accountTypes[0] === \'ADMIN\'"><ui-select-match placeholder="{{\'user.list.placeholder.for.sc.id\' | translate}}"><span>{{$item}}</span></ui-select-match><ui-select-choices repeat="item in vm.availableServiceContract"><span ng-bind-html="item"></span></ui-select-choices></ui-select></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel title-width"><div class="panel-heading">{{\'users.create.update.view.user.information.title\' | translate }}</div><div class="panel-body"><div class="row"><div class="col-md-6"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.user.information.dob\' | translate }}{{\'common.components.required\' | translate}}</label><datepicker date="vm.userInfo.dob" ng-model="vm.userInfo.dob" options="vm.dobOptions" required="" form="vm.newUserForm" name="userDob"></datepicker></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-input-group-row"><label>{{\'users.create.update.view.user.information.gender\' | translate }}</label><ui-select ng-model="vm.userInfo.gender" name="commonInfoGender" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.Gender)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.Gender.key track by $index"><span ng-bind-html="vm.types.Gender[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><address label="Address*" address="vm.userInfo.addressDtos[0]" required="true" form-key="\'organisation_address\'" form="vm.newUserForm"></address><contact get-label="vm.getValueFromTypeKey" label="Contact*" multiple="true" contact-entity="\'ACCOUNT\'" contact="vm.userInfo.contactDtos" contact-hours="vm.types.ContactHours" contact-type="vm.types.ContactType" required="true" display-email="false" email-required="false" form-key="\'user_account_contact_\'+$index" form="vm.newUserForm"></contact></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction"><a class="btn btn-primary pull-right" ng-disabled="vm.btnClick" ng-click="vm.cancelEdit()">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-primary pull-right m-r-20" ng-click="vm.saveDetail()" ng-disabled="vm.btnClick" ng-dblclick="vm.disableButton()">{{\'user.view.save\' | translate }} <i class="inProgress m-l-10" ng-if="vm.btnClick"></i></button></div></form></div>');
$templateCache.put('app/pages/service-management/users/views/list.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll table-panel"><div class="table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th>{{\'users.create.update.view.organization.information.userType\' | translate}}</th><th>{{\'users.create.update.view.common.information.userName\' | translate}}</th><th>{{\'users.create.update.view.common.information.userEmail\' | translate}}</th><th>{{\'users.create.update.view.common.information.contactNumber\' | translate}}</th><th>{{\'org.list.org.id\' | translate}} <a title="{{\'org.list.org.id.info\' | translate }}" class="m-no-error"><i class="fa fa-info-circle"></i></a></th><th>{{\'org.list.org.name\' | translate}}</th><th colspan="4" class="text-center">{{\'org.list.action\' | translate}}</th></tr></thead><tbody><tr ng-repeat="sc in vm.scListResponse.content"><td style="text-align: left;">{{vm.scListResponse.pageable.offset + $index + 1}}</td><td>{{vm.getValueFromTypeKey(sc.accountTypes[0], vm.types.AccountType)}}{{}}</td><td class="word-break">{{sc.name}}</td><td class="word-break">{{sc.userName}}</td><td>{{sc.contactDtos[0].phone}}</td><td>{{ sc.organisation.organisationTypes[0] == "MERCHANT" && sc.organisation.organisationTypes[1] == "DEVICE_OWNER" ? sc.organisation.merchantCode + "/" + sc.organisation.deviceOwnerCode : sc.organisation.organisationTypes[0] == "DEVICE_OWNER" ? sc.organisation.deviceOwnerCode : sc.organisation.organisationTypes[0] == "MERCHANT" ? sc.organisation.merchantCode : sc.organisation.organisationTypes[0] == "MERCHANT_AND_DEVICE_OWNER" ? sc.organisation.merchantCode + "/" + sc.organisation.deviceOwnerCode : sc.organisation.organisationTypes[0] == "PARTNER" ? sc.organisation.partnerCode : sc.organisation.organisationTypes[0] == "OFFICE" ? sc.organisation.officeCode : "" }}</td><td class="word-break">{{sc.organisation.name}}</td><td><button class="btn btn-warning btn-xs" ng-click="vm.passwordManagement($event, sc)" ng-disabled="!(vm.permissions.SERVICE_MGMT.USER_WRITE || sc.userName===vm.profile.userName)">{{\'org.list.pass\' | translate}}</button></td><td><button class="btn btn-info btn-xs" ng-if="vm.permissions.SERVICE_MGMT.USER_WRITE" ng-click="vm.openDetail($event, sc)">{{\'org.list.view.edit\' | translate}}</button> <button class="btn btn-info btn-xs" ng-if="!vm.permissions.SERVICE_MGMT.USER_WRITE" ng-click="vm.openDetail($event, sc)">{{\'org.list.view\' | translate}}</button></td><td><div ng-switch="sc.enabled"><div ng-switch-when="false"><button class="btn btn-warning btn-xs" ng-click="vm.enableUser(sc)" ng-disabled="!vm.permissions.SERVICE_MGMT.USER_WRITE">{{\'org.list.enable\' | translate}}</button></div><div ng-switch-when="true"><button class="btn btn-primary btn-xs" ng-click="vm.disableUser(sc)" ng-disabled="!vm.permissions.SERVICE_MGMT.USER_WRITE">{{\'org.list.disable\' | translate}}</button></div></div></td><td><button class="btn btn-danger btn-xs" ng-click="vm.deleteUser(sc)" ng-disabled="!vm.permissions.SERVICE_MGMT.USER_WRITE">{{\'org.list.delete\' | translate}}</button></td></tr></tbody></table></div><div class="m-t-20"><pagination query="vm.query" pageable="vm.scListResponse.pageable" total-pages="vm.scListResponse.totalPages" total-elements="vm.scListResponse.totalElements" paginate-callback="vm.paginateCallback"></pagination></div></div></div></div></div>');
$templateCache.put('app/pages/service-management/users/views/passwordManagement.html','<div form="vm.newUserForm"><form name="vm.newUserForm" novalidate=""><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{\'left.nav.ChildSubMenu.item8\' | translate}}</div><div class="panel-body"><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.organization.information.userType\' | translate }}</label> <input disabled="" type="text" class="form-control" name="commonInfoType" ng-model="vm.userInfo.accountTypes"></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userId\' | translate }}</label> <input disabled="" type="text" class="form-control" name="commonInfoId" ng-model="vm.userInfo.accountId"></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userEmail\' | translate }}</label> <input disabled="" type="text" class="form-control" name="commonInfoEmail" ng-model="vm.userInfo.userName"></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.common.information.userName\' | translate }}</label> <input disabled="" type="text" class="form-control" name="commonInfoName" ng-model="vm.userInfo.name"></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.organization.information.organizationCode\' | translate }}</label> <input disabled="" type="text" class="form-control" name="organizationCode" placeholder="{{\'common.components.data.not.available\' | translate}}" ng-model="vm.userInfo.organisation.code"></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'users.create.update.view.organization.information.organizationName\' | translate }}</label> <input disabled="" type="text" class="form-control" name="organizationName" ng-model="vm.userInfo.organisation.name"></div></div></div></div><div class="row"><div class="col-md-7"><div class="form-group"><div class="form-input-group-row labelXXL"><label>{{\'user.password.management.operation\' | translate}}</label><ui-select ng-model="vm.userInfo.operationType" on-select="onSelected($item)" name="operationType" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false"><ui-select-match><span>{{vm.getValueFromTypeKey($select.selected, vm.types.OperationType)}}</span></ui-select-match><ui-select-choices repeat="item in vm.types.OperationType.key track by $index"><span ng-bind-html="vm.types.OperationType[vm.getLang()][$index]"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-7" ng-if="vm.isChangePass"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.userOldPassword.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'user.password.management.oldPassword\' | translate }}</label> <input type="password" class="form-control" name="userOldPassword" ng-model="vm.userInfo.oldPass" required=""></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-7" ng-if="vm.isChangePass"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.userNewPassword.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'user.password.management.newPassword\' | translate }}</label> <input type="password" class="form-control" name="userNewPassword" ng-model="vm.userInfo.newPass" required=""></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div><div class="row"><div class="col-md-7" ng-if="vm.isChangePass"><div class="form-group" ng-class="{\'has-error\': vm.newUserForm.userConfirmPassword.$invalid && vm.newUserForm.$submitted}"><div class="form-input-group-row labelXXL"><label>{{\'user.password.management.confirmPassword\' | translate }}</label> <input type="password" class="form-control" name="userConfirmPassword" ng-model="vm.userInfo.newPassConfirm" required=""></div><span class="help-block error-block basic-block align-left">{{\'common.components.random.required\' | translate }}</span></div></div></div></div></div><div class="m-t-50"></div><div class="clearfix bottomAction" ng-if="!vm.isGeneratePass || !vm.isResetPass || !vm.isChangePass"><a href="/#/main/service-management/users/list" class="btn btn-primary pull-right">{{\'service.contract.create.service.contract.cancel\' | translate }}</a></div><div class="clearfix bottomAction" ng-if="vm.isGeneratePass"><a href="/#/main/service-management/users/list" class="btn btn-primary pull-right">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-success pull-right m-r-20" ng-click="vm.generatePass()">{{\'user.password.management.generatePass\' | translate }}</button></div><div class="clearfix bottomAction" ng-if="vm.isResetPass"><a href="/#/main/service-management/users/list" class="btn btn-primary pull-right">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-success pull-right m-r-20" ng-click="vm.resetPass()">{{\'user.password.management.resetPass\' | translate }}</button></div><div class="clearfix bottomAction" ng-if="vm.isChangePass"><a href="/#/main/service-management/users/list" class="btn btn-primary pull-right">{{\'service.contract.create.service.contract.cancel\' | translate }}</a> <button class="btn btn-success pull-right m-r-20" ng-click="vm.changePass()">{{\'user.password.management.changePass\' | translate }}</button></div></form></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/loadingModal.html','<div class="modal-content"><div class="modal-body">Loading <i class="inProgress progress-black m-l-10"></i></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');}]);